(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 4444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ calculateBackoffMillis; },
/* harmony export */   "BH": function() { return /* binding */ Deferred; },
/* harmony export */   "L": function() { return /* binding */ base64urlEncodeWithoutPadding; },
/* harmony export */   "LL": function() { return /* binding */ ErrorFactory; },
/* harmony export */   "Pz": function() { return /* binding */ getExperimentalSetting; },
/* harmony export */   "ZR": function() { return /* binding */ FirebaseError; },
/* harmony export */   "aH": function() { return /* binding */ getDefaultAppConfig; },
/* harmony export */   "b$": function() { return /* binding */ isReactNative; },
/* harmony export */   "eu": function() { return /* binding */ validateIndexedDBOpenable; },
/* harmony export */   "hl": function() { return /* binding */ isIndexedDBAvailable; },
/* harmony export */   "m9": function() { return /* binding */ getModularInstance; },
/* harmony export */   "ne": function() { return /* binding */ createSubscribe; },
/* harmony export */   "pd": function() { return /* binding */ extractQuerystring; },
/* harmony export */   "q4": function() { return /* binding */ getDefaultEmulatorHost; },
/* harmony export */   "ru": function() { return /* binding */ isBrowserExtension; },
/* harmony export */   "tV": function() { return /* binding */ base64Decode; },
/* harmony export */   "uI": function() { return /* binding */ isMobileCordova; },
/* harmony export */   "vZ": function() { return /* binding */ deepEqual; },
/* harmony export */   "w1": function() { return /* binding */ isIE; },
/* harmony export */   "xO": function() { return /* binding */ querystring; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; },
/* harmony export */   "z$": function() { return /* binding */ getUA; },
/* harmony export */   "zI": function() { return /* binding */ areCookiesEnabled; },
/* harmony export */   "zd": function() { return /* binding */ querystringDecode; }
/* harmony export */ });
/* unused harmony exports CONSTANTS, DecodeBase64StringError, MAX_VALUE_MILLIS, RANDOM_FACTOR, Sha1, assert, assertionError, async, base64, base64Encode, contains, createMockUserToken, decode, deepCopy, deepExtend, errorPrefix, getDefaultEmulatorHostnameAndPort, getDefaults, getGlobal, isAdmin, isBrowser, isElectron, isNode, isNodeSdk, isSafari, isUWP, isValidFormat, isValidTimestamp, issuedAtTime, jsonEval, map, ordinal, promiseWithTimeout, safeGet, stringLength, stringToByteArray, stringify, uuidv4, validateArgCount, validateCallback, validateContextObject, validateNamespace */
/* provided dependency */ var process = __webpack_require__(3454);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || typeof process.env === 'undefined') {
        return;
    }
    const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 2899:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomThemedResource = void 0;
var react_1 = __importDefault(__webpack_require__(7294));
var cdn_1 = __webpack_require__(3218);
var CustomThemedResource = function (props) {
    var className = props.className, source = props.source, alt = props.alt, format = props.format;
    var extension = format !== null && format !== void 0 ? format : "webp";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { "data-hide-on-theme": "dark", src: (0, cdn_1.assetUrl)(source + "-light." + extension + "?aaa"), className: className, alt: alt }),
        react_1.default.createElement("img", { "data-hide-on-theme": "light", src: (0, cdn_1.assetUrl)(source + "-dark." + extension + "?aaa"), className: className, alt: alt })));
};
exports.CustomThemedResource = CustomThemedResource;
//# sourceMappingURL=image.js.map

/***/ }),

/***/ 9930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PopupContainer = void 0;
var react_1 = __importDefault(__webpack_require__(7294));
var clsx_1 = __importDefault(__webpack_require__(8024));
var react_2 = __webpack_require__(7294);
var shortcut_1 = __webpack_require__(9399);
var image_1 = __webpack_require__(2899);
function PopupContainer(props) {
    var children = props.children, open = props.open, close = props.close;
    var popupBackground = (0, react_2.useRef)(null);
    (0, shortcut_1.useShortCut)({
        shortCut: "Escape",
        handler: function () {
            if (popupBackground.current) {
                close && close();
                popupBackground.current.style.display = "none";
            }
        },
    });
    return (react_1.default.createElement("div", { ref: popupBackground, className: (0, clsx_1.default)("fixed left-0 top-0 z-[105] h-screen w-screen bg-color-popup", "flex desktop:items-center desktop:justify-center"), style: {
            display: open ? "flex" : "none",
        }, onClick: function (e) {
            if (e.currentTarget) {
                if (e.currentTarget === popupBackground.current) {
                    if (popupBackground.current) {
                        popupBackground.current.style.display = "none";
                        close && close();
                    }
                }
            }
        } },
        react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "flex desktop:relative" },
            children,
            react_1.default.createElement("button", { onClick: function () {
                    if (popupBackground.current) {
                        popupBackground.current.style.display = "none";
                        close && close();
                    }
                }, className: (0, clsx_1.default)("absolute right-[-40px] top-0 hidden bg-color-surface desktop:flex", "h-[32px] w-[32px] items-center justify-center rounded-full", "border border-color-separator") },
                react_1.default.createElement(image_1.CustomThemedResource, { format: "svg", source: "/general/close" })))));
}
exports.PopupContainer = PopupContainer;
//# sourceMappingURL=popup.js.map

/***/ }),

/***/ 8976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.Xg = exports.kZ = void 0;
var popup_1 = __webpack_require__(9930);
Object.defineProperty(exports, "kZ", ({ enumerable: true, get: function () { return popup_1.PopupContainer; } }));
var shortcut_1 = __webpack_require__(9399);
Object.defineProperty(exports, "Xg", ({ enumerable: true, get: function () { return shortcut_1.useShortCut; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3218:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assetUrl = void 0;
var assetUrl = function (source) {
    var cdnUrl = "https://filesw.zoomerang.info/Web" || 0;
    return cdnUrl + source;
};
exports.assetUrl = assetUrl;
//# sourceMappingURL=cdn.js.map

/***/ }),

/***/ 9399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShortCut = void 0;
var react_1 = __webpack_require__(7294);
function useShortCut(props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, shortCut = props.shortCut, handler = props.handler;
    (0, react_1.useEffect)(function () {
        if (disabled) {
            return;
        }
        var handleKeyDown = function (event) {
            if ((event.key && event.key.toLowerCase() === shortCut.toLowerCase()) ||
                (shortCut === "BracketLeft" && event.key === "[") ||
                (shortCut === "BracketRight" && event.key === "]")) {
                event.preventDefault();
                handler();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handler, shortCut, disabled]);
}
exports.useShortCut = useShortCut;
//# sourceMappingURL=shortcut.js.map

/***/ }),

/***/ 8024:
/***/ (function(module) {

function r(e){var o,t,f="";if("string"==typeof e||"number"==typeof e)f+=e;else if("object"==typeof e)if(Array.isArray(e)){var n=e.length;for(o=0;o<n;o++)e[o]&&(t=r(e[o]))&&(f&&(f+=" "),f+=t)}else for(t in e)e[t]&&(f&&(f+=" "),f+=t);return f}function e(){for(var e,o,t=0,f="",n=arguments.length;t<n;t++)(e=arguments[t])&&(o=r(e))&&(f&&(f+=" "),f+=o);return f}module.exports=e,module.exports.clsx=e;

/***/ }),

/***/ 8363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;

exports.Z = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 6010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 6489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 4470:
/***/ (function(module) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 8139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function (style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 5733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(1876)["Buffer"];
/* provided dependency */ var process = __webpack_require__(3454);
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if(true)module.exports=e();else {}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t=undefined;if(!e&&t)return require(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l=undefined,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});

/***/ }),

/***/ 2213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (typeof_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof_typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = createConfig_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function createConfig_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createConfig_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createConfig_arrayLikeToArray(o, minLen); }

function createConfig_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = _objectWithoutProperties(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = _objectWithoutProperties(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = _slicedToArray(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = _slicedToArray(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if (typeof_typeof(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(9611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (typeof_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (typeof_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (typeof_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (typeof_typeof(args[2]) === 'object' || typeof_typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (typeof_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

_defineProperty(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 2010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ y; },
/* harmony export */   "f": function() { return /* binding */ $; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
const c=["light","dark"],i="(prefers-color-scheme: dark)",d="undefined"==typeof window,u=/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0),h={setTheme:e=>{},themes:[]},y=()=>{var e;return null!==(e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(u))&&void 0!==e?e:h},$=r=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(u)?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,r.children):/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(f,r),v=["light","dark"],f=({forcedTheme:t,disableTransitionOnChange:n=!1,enableSystem:l=!0,enableColorScheme:m=!0,storageKey:d="theme",themes:h=v,defaultTheme:y=(l?"system":"light"),attribute:$="data-theme",value:f,children:w,nonce:T})=>{const[E,k]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>S(d,y)),[C,L]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>S(d)),x=f?Object.values(f):h,I=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{let t=e;if(!t)return;"system"===e&&l&&(t=p());const r=f?f[t]:t,o=n?b():null,a=document.documentElement;if("class"===$?(a.classList.remove(...x),r&&a.classList.add(r)):r?a.setAttribute($,r):a.removeAttribute($),m){const e=c.includes(y)?y:null,n=c.includes(t)?t:e;a.style.colorScheme=n}null==o||o()},[]),O=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{k(e);try{localStorage.setItem(d,e)}catch(e){}},[t]),M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e=>{const n=p(e);L(n),"system"===E&&l&&!t&&I("system")},[E,t]);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=window.matchMedia(i);return e.addListener(M),M(e),()=>e.removeListener(M)},[M]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{const e=e=>{e.key===d&&O(e.newValue||y)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)},[O]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{I(null!=t?t:E)},[t,E]);const A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({theme:E,setTheme:O,forcedTheme:t,resolvedTheme:"system"===E?C:E,themes:l?[...h,"system"]:h,systemTheme:l?C:void 0}),[E,O,t,C,l,h]);/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(u.Provider,{value:A},/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(g,{forcedTheme:t,disableTransitionOnChange:n,enableSystem:l,enableColorScheme:m,storageKey:d,themes:h,defaultTheme:y,attribute:$,value:f,children:w,attrs:x,nonce:T}),w)},g=/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(({forcedTheme:t,storageKey:n,attribute:r,enableSystem:o,enableColorScheme:a,defaultTheme:s,value:l,attrs:m,nonce:d})=>{const u="system"===s,h="class"===r?`var d=document.documentElement,c=d.classList;c.remove(${m.map(e=>`'${e}'`).join(",")});`:`var d=document.documentElement,n='${r}',s='setAttribute';`,y=a?c.includes(s)&&s?`if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${s}'`:"if(e==='light'||e==='dark')d.style.colorScheme=e":"",$=(e,t=!1,n=!0)=>{const o=l?l[e]:e,s=t?e+"|| ''":`'${o}'`;let m="";return a&&n&&!t&&c.includes(e)&&(m+=`d.style.colorScheme = '${e}';`),"class"===r?m+=t||o?`c.add(${s})`:"null":o&&(m+=`d[s](n,${s})`),m},v=t?`!function(){${h}${$(t)}}()`:o?`!function(){try{${h}var e=localStorage.getItem('${n}');if('system'===e||(!e&&${u})){var t='${i}',m=window.matchMedia(t);if(m.media!==t||m.matches){${$("dark")}}else{${$("light")}}}else if(e){${l?`var x=${JSON.stringify(l)};`:""}${$(l?"x[e]":"e",!0)}}${u?"":"else{"+$(s,!1,!1)+"}"}${y}}catch(e){}}()`:`!function(){try{${h}var e=localStorage.getItem('${n}');if(e){${l?`var x=${JSON.stringify(l)};`:""}${$(l?"x[e]":"e",!0)}}else{${$(s,!1,!1)};}${y}}catch(t){}}();`;/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script",{nonce:d,dangerouslySetInnerHTML:{__html:v}})},()=>!0),S=(e,t)=>{if(d)return;let n;try{n=localStorage.getItem(e)||void 0}catch(e){}return n||t},b=()=>{const e=document.createElement("style");return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(e),()=>{window.getComputedStyle(document.body),setTimeout(()=>{document.head.removeChild(e)},1)}},p=e=>(e||(e=window.matchMedia(i)),e.matches?"dark":"light");


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(2673);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U$": function() { return /* binding */ LockIconContainer; },
/* harmony export */   "eg": function() { return /* binding */ FollowButton; },
/* harmony export */   "mB": function() { return /* binding */ LockIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_home_templates_preview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6468);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9612);
/* harmony import */ var _comps_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9980);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1816);
/* harmony import */ var _utils_discover__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3300);
/* harmony import */ var _utils_infinite__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(275);
/* harmony import */ var _utils_last_viewed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8178);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7592);
/* harmony import */ var _utils_millions__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(323);
/* harmony import */ var _utils_queryfy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(669);
/* harmony import */ var _utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2715);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(6010);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6489);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2213);
/* harmony import */ var pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2142);
/* harmony import */ var pages_template_slug___WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3174);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8767);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2337);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6106);
/* harmony import */ var sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(7276);
/* harmony import */ var sections_history_report_popup__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(1059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(9521);
/* harmony import */ var _ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1455);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(5896);
/* harmony import */ var _dropdown__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(3153);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: var(--w-screen);\n  padding: 0 16px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    width: 728px;\n  }\n\n  @media ",
        " {\n    width: 1175px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  ",
        ";\n\n  @media ",
        " {\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n    flex: 1;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 16px;\n\n  @media ",
        " {\n    padding-bottom: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 100%;\n\n  width: 70px;\n  height: 70px;\n  border: 2px solid var(--color-separator);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  gap: 16px;\n\n  @media ",
        " {\n    visibility: hidden;\n    width: 116px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 32px;\n\n  @media ",
        " {\n    line-height: 21px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n\n  color: var(--color-blue-700);\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    display: block;\n  }\n\n  margin-top: 16px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n\n  gap: 4px;\n\n  @media ",
        " {\n    gap: 10px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid var(--color-separator);\n  border-radius: 8px;\n\n  width: 32px;\n  height: 32px;\n  padding: 5px 0;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 20px;\n  margin: 0 auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid var(--color-separator);\n  border-radius: 8px;\n\n  width: 32px;\n  height: 32px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.5px;\n\n  color: var(--color-primary-500);\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n\n  transition: opacity 200ms ease-in-out;\n\n  display: flex;\n  gap: 4px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 24px;\n\n  display: flex;\n  gap: 2px;\n\n  align-items: center;\n\n  padding: 4px 8px;\n\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 17px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-radius: 26px;\n        "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-radius: 26px 0 0 26px;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(154, 84, 244, 0.13);\n  color: #a566f5;\n\n  ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-radius: 26px;\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-radius: 0 26px 26px 0;\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 24px;\n\n  background-color: rgba(243, 84, 74, 0.13);\n  color: #f3544a;\n\n  ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 12px;\n  height: 12px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 6px;\n\n  width: 100%;\n\n  padding: 8px 0;\n\n  @media ",
        " {\n    display: inline-flex;\n    width: unset;\n    gap: 0;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n\n  gap: 4px;\n\n  height: 60px;\n\n  border-radius: 6px;\n  background-color: var(--color-background-cell);\n\n  @media ",
        " {\n    flex-direction: row;\n    align-items: baseline;\n    border-radius: 0;\n    height: 21px;\n    padding-right: 10px;\n\n    & + & {\n      border-left: 1px solid var(--color-separator);\n      padding-left: 10px;\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n\n  color: var(--color-blue-400);\n\n  text-transform: capitalize;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 18px;\n\n  color: var(--color-blue-800);\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  display: grid;\n  grid-template-columns: 1fr;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 0;\n      transform: translateY(50px);\n      transition-delay: 0ms;\n      pointer-events: none;\n\n      // TODO: use calc for different sizes\n      height: 350px;\n      overflow: hidden;\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(var(--w-screen));\n  ",
        ";\n\n  transition: all 300ms;\n\n  opacity: 1;\n  transform: translateY(0);\n  transition-delay: 200ms;\n\n  ",
        ";\n\n  grid-row-start: 1;\n  grid-column-start: 1;\n\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  align-content: flex-start;\n\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  padding: 0 16px 16px;\n  gap: 16px;\n\n  @media ",
        " {\n    gap: 14px;\n    padding: 0 0 16px 0;\n  }\n\n  @media ",
        " {\n    padding-bottom: 25px;\n    gap: 25px;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  gap: 20px;\n\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 19px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 128px;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  path {\n    stroke: var(--color-blue-400);\n  }\n\n  @media ",
        " {\n    path {\n      stroke: var(--color-blue-700);\n    }\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  width: var(--w-screen);\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: var(--w-screen);\n\n  ",
        ";\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n  padding: 50px 0;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  z-index: 10;\n\n  width: ",
        "px;\n  height: ",
        "px;\n\n  border-radius: 5px;\n\n  top: ",
        "px;\n  left: ",
        "px;\n\n  transition: left 200ms ease-in-out;\n\n  background-color: var(--color-background-cell);\n\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: var(--color-blue-900);\n        "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: var(--color-blue-400);\n        "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      cursor: unset;\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  z-index: 15;\n\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n\n  flex: 1;\n\n  height: 50px;\n\n  @media ",
        " {\n    flex: unset;\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 20px;\n\n  cursor: pointer;\n\n  ",
        ";\n\n  @media ",
        " {\n    color: var(--color-blue-700);\n  }\n\n  ",
        ";\n\n  transition: color 200ms ease-in-out;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n\n  @media ",
        " {\n    display: inline-flex;\n    background-color: var(--color-background);\n\n    padding: ",
        "px;\n    border-radius: 8px;\n\n    margin: 20px 0;\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n\n  gap: 16px;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: -40px;\n\n  width: 100px;\n  object-fit: cover;\n  aspect-ratio: 1;\n\n  border-radius: 100%;\n  border: 2px solid var(--color-separator);\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}































var Container = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-1"
})(_templateObject1(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.desktop */ .Hb.desktop);
var TopWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(Wrapper).withConfig({
    componentId: "sc-30b63c0e-2"
})(_templateObject2(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .wrapped */ .tz, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var Maximize = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-3"
})(_templateObject3(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var TopContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(Container).withConfig({
    componentId: "sc-30b63c0e-4"
})(_templateObject4(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var BottomContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(Container).withConfig({
    componentId: "sc-30b63c0e-5"
})(_templateObject5());
var ProfilePicture = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-30b63c0e-6"
})(_templateObject6());
var PictureAligner = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-7"
})(_templateObject7(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var NamePositionContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-8"
})(_templateObject8());
var NameText = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-30b63c0e-9"
})(_templateObject9(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var BioText = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-30b63c0e-10"
})(_templateObject10(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var BioTextDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(BioText).withConfig({
    componentId: "sc-30b63c0e-11"
})(_templateObject11(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var SocialsContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-12"
})(_templateObject12(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var SocialAnchor = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-30b63c0e-13"
})(_templateObject13());
var SocialIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK).withConfig({
    componentId: "sc-30b63c0e-14"
})(_templateObject14());
var SocialPlusContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-15"
})(_templateObject15());
var SocialPlus = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-30b63c0e-16"
})(_templateObject16());
var socialLinks = {
    tiktok: "https://tiktok.com/@",
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    youtube: "https://youtube.com/channel/",
    snapchat: "https://snapchat.com/add/",
    discord: "https://discord.gg/",
    behance: "https://behance.net/",
    dribbble: "https://dribbble.com/",
    vimeo: "https://vimeo.com/",
    art_station: "https://artstation.com/"
};
var Socials = function(props) {
    var list = props.list;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .Desktop */ .Hi, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialsContainer, {
                    children: list.map(function(param, index) {
                        var provider = param.provider, account = param.account;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialAnchor, {
                            href: socialLinks[provider] + account,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialIcon, {
                                source: "/social/colorful/" + provider
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .TabletOrMobile */ .Vi, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SocialsContainer, {
                    children: [
                        list.filter(function(_, i) {
                            return i < 2;
                        }).map(function(param, index) {
                            var provider = param.provider, account = param.account;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialAnchor, {
                                href: socialLinks[provider] + account,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialIcon, {
                                    source: "/social/colorful/" + provider
                                })
                            }, index);
                        }),
                        list.length > 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SocialPlusContainer, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SocialPlus, {
                                children: [
                                    "+",
                                    list.length - 2
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var LeaderboardContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-17"
})(_templateObject17(), function(props) {
    return props.show ? "opacity: 1" : "opacity: 0";
});
var LeadIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-18"
})(_templateObject18());
var FireContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(LeadIconContainer).withConfig({
    componentId: "sc-30b63c0e-19"
})(_templateObject21(), function(props) {
    return props.full ? (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject19()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject20());
});
var StarContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(LeadIconContainer).withConfig({
    componentId: "sc-30b63c0e-20"
})(_templateObject24(), function(props) {
    return props.full ? (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject22()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject23());
});
var LeaderboardIcon = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-30b63c0e-21"
})(_templateObject25());
var getLeaderboard = function(uid, token) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_28__.__generator)(this, function(_state) {
            return [
                2,
                axios__WEBPACK_IMPORTED_MODULE_29__/* ["default"].get */ .Z.get("/api/user-pos-in-lead" + (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)({
                    uid: uid
                }), {
                    headers: {
                        Authorization: "Bearer " + token,
                        "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_30__/* .HEADER_WEB_VERSION */ .F
                    }
                }).then(function(res) {
                    return res.data;
                })
            ];
        });
    });
};
var Leaderboard = function(props) {
    var ref, ref1;
    var uid = props.uid;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)().userInfo;
    var leaderboard = (0,react_query__WEBPACK_IMPORTED_MODULE_18__.useQuery)("lead/" + uid, getLeaderboard(uid, userInfo.accessToken));
    var ref2;
    var fire = (ref2 = (ref = leaderboard.data) === null || ref === void 0 ? void 0 : ref.trending) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3;
    var star = (ref3 = (ref1 = leaderboard.data) === null || ref1 === void 0 ? void 0 : ref1.top) !== null && ref3 !== void 0 ? ref3 : null;
    var show = leaderboard.data !== undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LeaderboardContainer, {
        show: show,
        children: [
            fire && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FireContainer, {
                full: star === null,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LeaderboardIcon, {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_30__/* .assetUrl */ .p)("/general/fire.png"),
                        alt: "fire image"
                    }),
                    fire
                ]
            }),
            star && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StarContainer, {
                full: fire === null,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LeaderboardIcon, {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_30__/* .assetUrl */ .p)("/general/star.png"),
                        alt: "star image"
                    }),
                    star
                ]
            })
        ]
    });
};
var StatsContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-22"
})(_templateObject26(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var StatsSingle = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-23"
})(_templateObject27(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var StatsUnit = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-30b63c0e-24"
})(_templateObject28());
var StatsValue = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-30b63c0e-25"
})(_templateObject29());
var AllStats = function(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var followers = props.followers, following = props.following, shoots = props.shoots;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StatsContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StatsSingle, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsValue, {
                        children: (0,_utils_millions__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(following)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsUnit, {
                        children: t("lbl_following")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StatsSingle, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsValue, {
                        children: (0,_utils_millions__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(followers)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsUnit, {
                        children: t("lbl_followers")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StatsSingle, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsValue, {
                        children: (0,_utils_millions__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(shoots)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatsUnit, {
                        children: t("lbl_shoots")
                    })
                ]
            })
        ]
    });
};
var UserTemplatesContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-26"
})(_templateObject30());
var CustomSwipePage = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-27"
})(_templateObject32(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .wrapped */ .tz, function(props) {
    return !props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject31());
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.desktop */ .Hb.desktop);
var LockIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-28"
})(_templateObject33());
var LockIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .ZP)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK).withConfig({
    componentId: "sc-30b63c0e-29"
})(_templateObject34());
var SmallLockIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-30b63c0e-30"
})(_templateObject35(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var SmallLockIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SmallLockIconContainer, {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M13.6863 7.24821V5.45904C13.6863 3.36487 11.9879 1.66654 9.89378 1.66654C7.79962 1.65737 6.09462 3.34737 6.08545 5.44237V5.45904V7.24821",
                stroke: "#919191",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M9.8859 11.8354V13.6863",
                stroke: "#919191",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M3.5498 9.95638C3.5498 8.80579 4.48255 7.87305 5.63314 7.87305H14.3668C15.5174 7.87305 16.4502 8.80579 16.4502 9.95638V15.6245C16.4502 16.7751 15.5174 17.7079 14.3668 17.7079H5.63314C4.48255 17.7079 3.5498 16.7751 3.5498 15.6245V9.95638Z",
                stroke: "#919191",
                strokeWidth: "2"
            })
        ]
    });
};
var TemplatesSectionContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-31"
})(_templateObject36());
var TemplatesSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-32"
})(_templateObject37(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .wrapped */ .tz);
var LoaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-33"
})(_templateObject38());
var indicatorWidth = 120;
var indicatorHeight = 38;
var indicatorPadding = 4;
var Indicator = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-34"
})(_templateObject39(), indicatorWidth, indicatorHeight, indicatorPadding, function(props) {
    return props.active * indicatorWidth + indicatorPadding;
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet);
var SingleTab = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-35"
})(_templateObject43(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, indicatorWidth, indicatorHeight, function(props) {
    return props.available && props.active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject40()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject41());
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, function(props) {
    return !props.available && (0,styled_components__WEBPACK_IMPORTED_MODULE_26__/* .css */ .iv)(_templateObject42());
});
var TabsContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-36"
})(_templateObject44(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .devices.tablet */ .Hb.tablet, indicatorPadding);
var ProfilePictureContainer = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-37"
})(_templateObject45());
var BioColumn = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30b63c0e-38"
})(_templateObject46());
var ProfilePictureUnbound = styled_components__WEBPACK_IMPORTED_MODULE_26__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-30b63c0e-39"
})(_templateObject47());
var SinglePage = function(props) {
    var query = props.query, index = props.index, active = props.active, available = props.available, uid = props.uid;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)("common").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_17__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)(""), templateIndex = ref1[0], setTemplateIndex = ref1[1];
    var enabled = active === index && available;
    (0,_utils_infinite__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(query, ref, 1000, enabled);
    var flat = (0,react__WEBPACK_IMPORTED_MODULE_17__.useMemo)(function() {
        var ref;
        return (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .flattenAndFilter */ .Ah)(((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) || []);
    }, [
        query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_17__.useEffect)(function() {
        var ref;
        var cookieValue = {
            location: active === 0 ? "created" : "likes",
            userId: uid,
            offset: (ref = flat.findIndex(function(template) {
                return template.id === templateIndex;
            })) !== null && ref !== void 0 ? ref : 0
        };
        document.cookie = (0,cookie__WEBPACK_IMPORTED_MODULE_13__/* .serialize */ .q)(pages_template_slug___WEBPACK_IMPORTED_MODULE_16__.TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY, JSON.stringify(cookieValue), {
            sameSite: "lax"
        });
    }, [
        active,
        templateIndex,
        flat,
        uid
    ]);
    var showTemplates = available && query.isSuccess;
    var noTemplates = query.isSuccess && !query.isFetching && flat.length === 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CustomSwipePage, {
        ref: ref,
        active: active === index,
        children: [
            !available && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LockIconContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LockIcon, {
                        source: "/general/private"
                    }),
                    t("txt_is_private")
                ]
            }),
            showTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: flat.map(function(template) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_home_templates_preview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        setTemplateIndex: setTemplateIndex,
                        template: template
                    }, template.id);
                })
            }),
            noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LockIconContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LockIcon, {
                        source: "/general/empty"
                    }),
                    t("txt_is_empty")
                ]
            }),
            query.isFetchingNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoaderContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            })
        ]
    });
};
var GalleryPage = function(props) {
    var query = props.query, index = props.index, active = props.active, available = props.available, username = props.username, setGalleryPopupState = props.setGalleryPopupState, setFilterDialogOpen = props.setFilterDialogOpen;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)("common").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_17__.useRef)(null);
    var enabled = active === index && available;
    (0,_utils_infinite__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(query, ref, 1000, enabled);
    var flat = (0,react__WEBPACK_IMPORTED_MODULE_17__.useMemo)(function() {
        var ref;
        return (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .flattenAndFilterGallery */ .KP)(((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) || []);
    }, [
        query
    ]);
    var showTemplates = available && query.isSuccess;
    var noTemplates = query.isSuccess && !query.isFetching && flat.length === 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        ref: ref,
        style: {
            gridColumnStart: 1,
            gridRowStart: 1
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex w-full flex-col content-start items-start justify-start transition-all tablet:w-[728px] desktop:w-[1175px]", active !== index ? "pointer-events-none h-[350px] translate-y-12 overflow-hidden opacity-0 delay-0" : "translate-y-0 opacity-100 delay-200"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-full flex-col", !noTemplates && "pb-24"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex w-full flex-row justify-between px-4 tablet:h-10 desktop:h-11 desktop:px-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MediaTypeGallery, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "hidden h-full flex-row items-center justify-center gap-4 tablet:flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SortByGallery, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AvailableFilters, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return setFilterDialogOpen(true);
                                },
                                className: "flex h-full w-10 items-center justify-center rounded-[8px] bg-color-background [--icon-color:var(--color-placeholder)] tablet:hidden desktop:w-11",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .FilterIcon */ .k1, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_19__/* .ResponsiveMasonry */ .G, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("mx-auto w-full gap-3 p-4 tablet:w-[768px] tablet:gap-4 desktop:w-[1175px] desktop:gap-[15px] desktop:px-0 desktop:pt-4", noTemplates && "hidden", !showTemplates && "hidden"),
                        columnsCountBreakPoints: {
                            1: 2,
                            760: 4,
                            1280: 5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            gutter: "15px",
                            children: flat.map(function(single) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .SingleGenerated */ .W2, {
                                    entity: single,
                                    setGalleryPopupState: setGalleryPopupState,
                                    closeLink: "/".concat(username),
                                    notShallow: true
                                }, single.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        ref: ref
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "flex w-full justify-center p-8",
                        children: query.isFetchingNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LockIconContainer, {
                className: "pb-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LockIcon, {
                        source: "/general/empty-gallery"
                    }),
                    t("txt_no_result_yet")
                ]
            })
        ]
    });
};
function AvailableFilters() {
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)(), dispatch = ref.dispatch, state = ref.state;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var availableFilters = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)().availableFilters;
    var styles = availableFilters.styles;
    var uniqueFilters = styles.filter(function(style) {
        return state.selectedTools.includes(style.tool);
    }).map(function(style) {
        return style.name;
    });
    var filteredStyles = Array.from(new Set(uniqueFilters));
    var uniqueTools = Array.from(new Set(styles.map(function(style) {
        return style.tool;
    })));
    var commonTools = pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__.galleryProducts.filter(function(tool) {
        return uniqueTools.some(function(product) {
            return product === tool.tool;
        });
    });
    var setStyle = function(name) {
        if (state.selectedStyles.find(function(style) {
            return style.name === name;
        })) {
            dispatch({
                type: "remove_style",
                name: name
            });
            return;
        }
        dispatch({
            type: "select_style",
            name: name,
            tools: commonTools.map(function(tool) {
                return tool.tool;
            })
        });
    };
    var setTool = function(tool) {
        if (state.selectedTools.find(function(selected) {
            return selected === tool;
        })) {
            dispatch({
                type: "remove_tool",
                tool: tool
            });
            return;
        }
        dispatch({
            type: "select_tool",
            tool: tool
        });
    };
    var selectCustom = function(custom) {
        dispatch({
            type: "set_include_custom",
            state: custom
        });
    };
    var clearStyle = function() {
        dispatch({
            type: "clear_style"
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
    };
    var apply = function() {
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    var clearTools = function() {
        dispatch({
            type: "clear_tools"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_25__/* .DropDown */ .vb, {
        closeOnClick: true,
        className: "group bg-color-background tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]",
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex flex-row items-center justify-center [--icon-color:var(--color-blue-600)]", "tablet:h-10 tablet:w-10 tablet:rounded-[6px]", "hover:bg-blue-100 desktop:h-11 desktop:w-11 desktop:rounded-[10px]"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .FilterIcon */ .k1, {})
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "absolute z-50 -translate-x-[calc(100%-44px)] pt-2 tablet:w-[349px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex w-full flex-col gap-[18px] rounded-[13px] bg-color-popup-cell px-4 py-3 [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_ai_tools")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            clearTools();
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "flex w-full flex-wrap gap-[10px]",
                                children: pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__.galleryProducts.map(function(tool, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setTool(tool.tool);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 [--icon-color:var(--color-blue-600)]", state.selectedTools.some(function(selected) {
                                            return selected === tool.tool;
                                        }) ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            tool.icon,
                                            t(tool.label)
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "h-[1px] w-full border-b border-color-separator"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_style")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        onClick: function() {
                                            return clearStyle();
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "no-scrollbar flex max-h-[142px] w-full flex-wrap gap-[10px] overflow-y-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            selectCustom(!state.includeCustoms);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.includeCustoms ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: t("txt_custom")
                                    }),
                                    filteredStyles.map(function(name, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                setStyle(name);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.selectedStyles.some(function(style) {
                                                return style.name === name;
                                            }) ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                            children: t(name)
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex h-11 w-full flex-row gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    clearAll();
                                },
                                className: "h-full cursor-pointer px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                children: t("txt_clear_all")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_button__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .ZP, {
                                onClick: apply,
                                text: t("lbl_apply"),
                                className: "h-full flex-1"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function SortByGallery() {
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)(), state = ref.state, dispatch = ref.dispatch;
    var sortBy = state.sortBy;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var currentLabel = sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .sortLabels */ .OI[sortBy];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_25__/* .DropDown */ .vb, {
        hover: true,
        className: "group h-full rounded-[8px] bg-color-background",
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-4", "tablet:h-10 tablet:w-[140px] tablet:rounded-[6px]", "desktop:h-11 desktop:w-[175px] desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    className: "text-[14px] font-500 text-blue-700",
                    children: t(currentLabel)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .ButtonArrowIcon */ .hd, {})
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "absolute z-10 w-[110px] pt-2 tablet:w-[112px] desktop:w-[175px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "w-full rounded-[10px] bg-color-popup-cell px-[10px] py-[14px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "flex w-full flex-col gap-1",
                    children: sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .sortOptions.map */ .Fo.map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            onClick: function() {
                                return setSortBy(option);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center rounded-[8px] py-3 pl-4 text-[14px] font-500 text-blue-800 transition-all", sortBy === option ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                            children: t(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .sortLabels */ .OI[option])
                        }, option);
                    })
                })
            })
        })
    });
}
function MediaTypeGallery() {
    var setMediaType = function setMediaType(mediaType) {
        dispatch({
            type: "set_media_type",
            mediaType: mediaType
        });
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)(), dispatch = ref.dispatch, state = ref.state;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var mediaType = state.mediaType;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_25__/* .DropDown */ .vb, {
        hover: true,
        className: "group h-full rounded-[8px] bg-color-background",
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex h-10 w-[94px] flex-row items-center justify-between gap-[6px] px-[12px] desktop:h-11"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    className: "flex-1 text-center text-[15px] font-500 text-blue-600",
                    children: t("lbl_".concat(mediaType))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("mr-1 flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .ButtonArrowIcon */ .hd, {})
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "absolute z-10 w-[94px] pt-3",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex flex-col items-center gap-1 rounded-[12px] bg-color-popup-cell", "px-[10px] py-[14px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        onClick: function() {
                            return setMediaType("all");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", mediaType === "all" ? "bg-blue-300 hover:bg-blue-300" : "hover:bg-blue-100"),
                        children: t("lbl_all")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        onClick: function() {
                            return setMediaType("image");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", mediaType === "image" ? "bg-blue-300 hover:bg-blue-300" : "hover:bg-blue-100"),
                        children: t("lbl_image")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        onClick: function() {
                            return setMediaType("video");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", mediaType === "video" ? "bg-blue-300 hover:bg-blue-300" : "hover:bg-blue-100"),
                        children: t("lbl_video")
                    })
                ]
            })
        })
    });
}
function FilterDialogMobile(props) {
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
    };
    var filterDialogOpen = props.filterDialogOpen, setFilterDialogOpen = props.setFilterDialogOpen;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)(), dispatch = ref.dispatch, state = ref.state;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var availableFilters = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)().availableFilters;
    var sortBy = state.sortBy;
    var styles = availableFilters.styles;
    var uniqueFilters = styles.filter(function(style) {
        return state.selectedTools.includes(style.tool);
    }).map(function(style) {
        return style.name;
    });
    var filteredStyles = Array.from(new Set(uniqueFilters));
    var uniqueTools = Array.from(new Set(styles.map(function(style) {
        return style.tool;
    })));
    var commonTools = pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__.galleryProducts.filter(function(tool) {
        return uniqueTools.some(function(product) {
            return product === tool.tool;
        });
    });
    var setStyle = function(name) {
        if (state.selectedStyles.find(function(style) {
            return style.name === name;
        })) {
            dispatch({
                type: "remove_style",
                name: name
            });
            return;
        }
        dispatch({
            type: "select_style",
            name: name,
            tools: commonTools.map(function(tool) {
                return tool.tool;
            })
        });
    };
    var setTool = function(tool) {
        if (state.selectedTools.find(function(selected) {
            return selected === tool;
        })) {
            dispatch({
                type: "remove_tool",
                tool: tool
            });
            return;
        }
        dispatch({
            type: "select_tool",
            tool: tool
        });
    };
    var selectCustom = function(custom) {
        dispatch({
            type: "set_include_custom",
            state: custom
        });
    };
    var clearStyle = function() {
        dispatch({
            type: "clear_style"
        });
    };
    var clearTools = function() {
        dispatch({
            type: "clear_tools"
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
    };
    var apply = function() {
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:hidden", !filterDialogOpen && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
            id: "filter-popup",
            onClick: function(event) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)(event.target, Element)) {
                    if (event.target.id === event.currentTarget.id) {
                        setFilterDialogOpen(false);
                    }
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("relative h-[60vh] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", filterDialogOpen ? "translate-y-0" : "translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "no-scrollbar flex h-[calc(60vh-74px)] w-full flex-col gap-[18px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-4 py-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_sort_by")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy("newest");
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "flex w-full flex-wrap gap-[10px]",
                                        children: sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .sortOptions.map */ .Fo.map(function(option) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy(option);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", sortBy === option ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", sortBy === option ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", sortBy === option ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .sortLabels */ .OI[option])
                                                ]
                                            }, option);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_ai_tools")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    clearTools();
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "flex w-full flex-wrap gap-[10px]",
                                        children: pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__.galleryProducts.map(function(tool, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setTool(tool.tool);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all", state.selectedTools.some(function(selected) {
                                                    return selected === tool.tool;
                                                }) ? "border-blue-100 bg-blue-100 text-blue-800 [--icon-color:var(--color-blue-700)]" : "border-color-separator text-blue-700 [--icon-color:var(--color-blue-600)]"),
                                                children: [
                                                    tool.icon,
                                                    t(tool.label)
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_style")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                onClick: function() {
                                                    return clearStyle();
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "no-scrollbar flex max-h-[184px] w-full flex-wrap gap-[10px] overflow-y-auto pb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    selectCustom(!state.includeCustoms);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.includeCustoms ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: t("txt_custom")
                                            }),
                                            filteredStyles.map(function(name, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        setStyle(name);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.selectedStyles.some(function(style) {
                                                        return style.name === name;
                                                    }) ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                    children: t(name)
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "fixed bottom-0 left-0 w-full border-t border-color-separator bg-color-cell px-4 py-[14px] dark:bg-[#2C2C34]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex h-11 w-full flex-row gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    onClick: function(e) {
                                        e.preventDefault();
                                        clearAll();
                                    },
                                    className: "h-full px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                    children: t("txt_clear_all")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_button__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .ZP, {
                                    onClick: function() {
                                        apply();
                                        setFilterDialogOpen(false);
                                    },
                                    text: t("lbl_apply"),
                                    className: "h-full flex-1"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var TemplatesSection = function(props) {
    var templates = props.templates, uid = props.uid, privateLikes = props.privateLikes, privateAccount = props.privateAccount, creator = props.creator, setGalleryPopupState = props.setGalleryPopupState, setFilterDialogOpen = props.setFilterDialogOpen, activeTab = props.activeTab, username = props.username;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)(activeTab), active = ref[0], setActive = ref[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)().userInfo;
    var isSelf = userInfo.userId === uid;
    var likesAvailable = isSelf || !(privateAccount || privateLikes);
    var templatesAvailable = isSelf || !privateAccount;
    var createdReady = templatesAvailable;
    var createdResult = createdReady ? {
        data: new _utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .CreatedScrollContext */ .z3(uid, templates, creator),
        ready: true
    } : {
        ready: false,
        data: undefined
    };
    var likedReady = likesAvailable;
    var likedResult = likedReady ? {
        data: new _utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .LikedScrollContext */ .zA(uid, [], creator),
        ready: true
    } : {
        data: undefined,
        ready: false
    };
    var ref1 = (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .useScrollContext */ .K3)(createdResult), created = ref1.query, createdTemplates = ref1.templates;
    var ref2 = (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .useScrollContext */ .K3)(likedResult), liked = ref2.query, likedTemplates = ref2.templates;
    var ref3 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useGalleryViewContext */ .$e)(), gallery = ref3.query;
    (0,react__WEBPACK_IMPORTED_MODULE_17__.useEffect)(function() {
        var context = active === 0 ? new _utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .CreatedScrollContext */ .z3(uid, createdTemplates, creator) : new _utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .LikedScrollContext */ .zA(uid, likedTemplates, creator);
        (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_12__/* .setScrollContext */ .X5)(context);
    }, [
        active,
        created,
        createdTemplates,
        creator,
        likedTemplates,
        uid, 
    ]);
    var tabs = (0,react__WEBPACK_IMPORTED_MODULE_17__.useMemo)(function() {
        return [
            {
                label: "common:lbl_templates",
                query: created,
                available: templatesAvailable,
                type: "template"
            },
            {
                label: "common:lbl_liked",
                query: liked,
                available: likesAvailable,
                type: "template"
            },
            {
                label: "common:txt_ai_arts",
                query: gallery,
                available: templatesAvailable,
                type: "gallery"
            }, 
        ];
    }, [
        created,
        templatesAvailable,
        liked,
        likesAvailable,
        gallery, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TemplatesSectionContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TemplatesSectionWrapper, {
            children: [
                templatesAvailable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TabsContainer, {
                    children: [
                        tabs.map(function(param, index) {
                            var available = param.available, label = param.label;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SingleTab, {
                                active: active === index,
                                available: available,
                                onClick: function() {
                                    available && setActive(index);
                                    var newUrl = "/".concat(username, "?active=").concat(index);
                                    window.history.pushState({
                                        path: newUrl
                                    }, "", newUrl);
                                },
                                children: [
                                    !available && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SmallLockIcon, {}),
                                    t(label)
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Indicator, {
                            active: active
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserTemplatesContainer, {
                    children: tabs.map(function(tab, index) {
                        switch(tab.type){
                            case "template":
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SinglePage, {
                                    active: active,
                                    index: index,
                                    query: tab.query,
                                    available: tab.available,
                                    uid: uid
                                }, index);
                            case "gallery":
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GalleryPage, {
                                    active: active,
                                    index: index,
                                    query: tab.query,
                                    available: tab.available,
                                    username: creator.username,
                                    setGalleryPopupState: setGalleryPopupState,
                                    setFilterDialogOpen: setFilterDialogOpen
                                }, index);
                        }
                    })
                })
            ]
        })
    });
};
var AdvancedProfile = function(props) {
    var _user = props.user, name = _user.name, bio = _user.bio, picture = _user.picture, socials = _user.socials, followers = _user.followers, following = _user.following, shoots = _user.shoots, uid = _user.uid, username = _user.username;
    var _gallery = props.gallery, initial = _gallery.initial, availableFilters = _gallery.availableFilters, jobs = _gallery.jobs;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)().userInfo;
    var isSelf = userInfo.userId === uid;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)(null), galleryPopupState = ref[0], setGalleryPopupState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)(false), reportPopup = ref1[0], setReportPopup = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)(false), filterDialogOpen = ref2[0], setFilterDialogOpen = ref2[1];
    var _followStatus;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)((_followStatus = props.user.followStatus) !== null && _followStatus !== void 0 ? _followStatus : "not_following"), followStatus = ref3[0], setFollowStatus = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_17__.useState)({
        to_uid: uid,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref4[0], setPayload = ref4[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_17__.useEffect)(function() {
        if (filterDialogOpen || galleryPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        filterDialogOpen,
        galleryPopupState
    ]);
    var creator = (0,react__WEBPACK_IMPORTED_MODULE_17__.useMemo)(function() {
        return {
            username: username,
            followers: followers,
            picture: picture,
            uid: uid,
            followStatus: followStatus
        };
    }, [
        username,
        followers,
        picture,
        uid,
        followStatus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TopContainer, {
                className: "bg-color-background",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TopWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PictureAligner, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProfilePicture, {
                                    src: picture !== null && picture !== void 0 ? picture : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_30__/* .assetUrl */ .p)("/general/avatar.svg"),
                                    alt: "avatar image"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "flex w-full items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Socials, {
                                            list: socials
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(isSelf && "hidden", "flex items-center gap-[11px] tablet:hidden"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-[96px] items-center justify-center", "h-[32px] overflow-hidden rounded-[10px]"),
                                                    children: followStatus !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FollowButton, {
                                                        followStatus: followStatus,
                                                        uid: uid,
                                                        setFollowStatus: setFollowStatus,
                                                        userPage: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("h-[32px] w-[32px] [--icon-color:var(--color-blue-900)] hover:bg-blue-100", "flex items-center justify-center rounded-[10px]"),
                                                            children: (0,_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .moreIcon */ .Jf)()
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                            onClick: function() {
                                                                setReportPopup(true);
                                                            },
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("absolute hidden w-[123px] rounded-[12px] px-[10px]", "bg-color-popup-cell py-[8px] group-hover:flex", "items-center gap-[8px] shadow-xl hover:bg-blue-100", "-right-[70px] top-[50px] -translate-x-1/2"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                                                    source: "/general/report",
                                                                    format: "svg"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "text-[16px] font-500 text-blue-800",
                                                                    children: t("txt_report")
                                                                })
                                                            ]
                                                        }),
                                                        reportPopup && setReportPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_history_report_popup__WEBPACK_IMPORTED_MODULE_22__/* .ReportPopup */ .j, {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("fixed bottom-0 left-0 right-0 z-[100]"),
                                                            payload: payload,
                                                            payloadLocation: "user",
                                                            setPayload: setPayload,
                                                            endpoint: "user-report",
                                                            setReportPopup: setReportPopup,
                                                            galleryOrTemplate: "template"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NamePositionContainer, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NameText, {
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Leaderboard, {
                                    uid: uid
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Maximize, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .DesktopOrTablet */ .lS, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Socials, {
                                list: socials
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BioText, {
                            children: bio
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .Mobile */ .ij, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AllStats, {
                                followers: followers,
                                following: following,
                                shoots: shoots
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BottomContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .DesktopOrTablet */ .lS, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProfilePictureContainer, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProfilePictureUnbound, {
                                    src: picture !== null && picture !== void 0 ? picture : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_30__/* .assetUrl */ .p)("/general/avatar.svg"),
                                    alt: "avatar"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BioColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BioTextDesktop, {
                                            children: bio
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "flex w-full items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AllStats, {
                                                    followers: followers,
                                                    following: following,
                                                    shoots: shoots
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(isSelf && "hidden", "flex items-center gap-[11px]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex w-[150px] items-center justify-center", "h-[44px] overflow-hidden rounded-[6px]"),
                                                            children: followStatus !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FollowButton, {
                                                                followStatus: followStatus,
                                                                uid: uid,
                                                                setFollowStatus: setFollowStatus,
                                                                userPage: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("h-[44px] w-[44px] [--icon-color:var(--color-blue-900)] hover:bg-blue-100", "flex items-center justify-center rounded-[10px]", "border-2 border-color-separator"),
                                                                    children: (0,_ai_tools_icons__WEBPACK_IMPORTED_MODULE_23__/* .moreIcon */ .Jf)()
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                                    onClick: function() {
                                                                        setReportPopup(true);
                                                                    },
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("absolute hidden w-[123px] rounded-[12px] px-[10px]", "bg-color-popup-cell py-[8px] group-hover:flex", "items-center gap-[8px] shadow-xl hover:bg-blue-100", "left-1/2 top-[50px] -translate-x-1/2"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                                                            source: "/general/report",
                                                                            format: "svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                            className: "text-[16px] font-500 text-blue-800",
                                                                            children: t("txt_report")
                                                                        })
                                                                    ]
                                                                }),
                                                                reportPopup && setReportPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_history_report_popup__WEBPACK_IMPORTED_MODULE_22__/* .ReportPopup */ .j, {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("absolute left-1/2 top-[50px] z-[100] -translate-x-2/3"),
                                                                    payloadLocation: "user",
                                                                    payload: payload,
                                                                    setPayload: setPayload,
                                                                    endpoint: "user-report",
                                                                    setReportPopup: setReportPopup,
                                                                    galleryOrTemplate: "template"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_last_viewed__WEBPACK_IMPORTED_MODULE_9__/* .LastViewedProvider */ .h, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .GalleryViewProvider */ .tp, {
                    availableFilters: availableFilters,
                    initialFilters: initial !== null && initial !== void 0 ? initial : pages_ai_gallery__WEBPACK_IMPORTED_MODULE_15__.indexFiltersGallery,
                    initialData: jobs !== null && jobs !== void 0 ? jobs : undefined,
                    pageNumber: 1,
                    page: "ai-gallery",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TemplatesSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, props.user), {
                            creator: creator,
                            activeTab: props.activeTab,
                            setGalleryPopupState: setGalleryPopupState,
                            setFilterDialogOpen: setFilterDialogOpen
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FilterDialogMobile, {
                            filterDialogOpen: filterDialogOpen,
                            setFilterDialogOpen: setFilterDialogOpen
                        })
                    ]
                })
            }),
            galleryPopupState !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_21__/* .GalleryPopup */ .wY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, galleryPopupState))
        ]
    });
};
function FollowButton(props) {
    var followStatus = props.followStatus, userPage = props.userPage, uid = props.uid, setFollowStatus = props.setFollowStatus, className = props.className;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_14__/* .useTranslation */ .$G)().t;
    var auth = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
    function handleFollow(follow) {
        return _handleFollow.apply(this, arguments);
    }
    function _handleFollow() {
        _handleFollow = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(function(follow) {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_28__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!follow) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_29__/* ["default"].post */ .Z.post("/api/user-follow", {
                                uid_to: uid
                            })
                        ];
                    case 1:
                        _state.sent();
                        setFollowStatus("following");
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_29__/* ["default"].post */ .Z.post("/api/user-unfollow", {
                                uid_to: uid
                            })
                        ];
                    case 3:
                        _state.sent();
                        setFollowStatus("not_following");
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFollow.apply(this, arguments);
    }
    switch(followStatus){
        case "not_following":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_button__WEBPACK_IMPORTED_MODULE_24__/* .NewButton */ .R9, {
                text: t("lbl_".concat(followStatus)),
                variant: "secondary",
                className: className,
                onClick: function() {
                    if (auth.userInfo && auth.userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_10__/* .redirectToLogin */ .r)();
                        return;
                    }
                    handleFollow(true);
                }
            });
        case "follow_back":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_button__WEBPACK_IMPORTED_MODULE_24__/* .NewButton */ .R9, {
                text: t("lbl_".concat(followStatus)),
                variant: "secondary",
                className: className,
                onClick: function() {
                    if (auth.userInfo && auth.userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_10__/* .redirectToLogin */ .r)();
                        return;
                    }
                    handleFollow(true);
                }
            });
        case "following":
            return userPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex h-[44px] w-full items-center justify-center rounded-[6px] bg-blue-300", className),
                onClick: function() {
                    if (auth.userInfo && auth.userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_10__/* .redirectToLogin */ .r)();
                        return;
                    }
                    handleFollow(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "text-[16px] font-600 text-blue-800",
                    children: t("lbl_".concat(followStatus))
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
        case "requested":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)("flex h-[44px] w-full items-center justify-center rounded-[6px] bg-blue-300", className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "text-[16px] font-600 text-blue-800",
                    children: t("lbl_".concat(followStatus))
                })
            });
    }
}
/* harmony default export */ __webpack_exports__["ZP"] = (AdvancedProfile);


/***/ }),

/***/ 9264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ RestyleConfigurator; },
/* harmony export */   "Eh": function() { return /* binding */ SliderConfiguratorDashboard; },
/* harmony export */   "FD": function() { return /* binding */ useVideoClipper; },
/* harmony export */   "N4": function() { return /* binding */ ClipVideoSector; },
/* harmony export */   "QI": function() { return /* binding */ MAX_FREE_MILLIS; },
/* harmony export */   "dS": function() { return /* binding */ ParamtersTrigger; },
/* harmony export */   "vU": function() { return /* binding */ createPromptStateFrom; }
/* harmony export */ });
/* unused harmony exports useKeyFrames, ConfigSwitcher, SliderWithValues, ConfigCheckbox, GroupSection */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9612);
/* harmony import */ var _comps_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7092);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(177);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6961);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1501);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5896);
/* harmony import */ var _editors_deform__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8641);
/* harmony import */ var _editors_restyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9868);



















function createPromptStateFrom(params) {
    if (!params) return null;
    return params.reduce(function(acc, param) {
        switch(param.type){
            case "switcher":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "slider":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "cameras":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, ""));
            case "checkbox":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, Boolean(param.defaultValue)));
            case "select":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "dynamic":
                return acc;
        }
    }, {});
}
function useKeyFrames(video, count) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), frames = ref[0], setFrames = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (frames !== null) {
            return;
        }
        (0,_utils_video__WEBPACK_IMPORTED_MODULE_3__/* .extractFramesFromVideo */ .oE)(video, count).then(function(param) {
            var keyframes = param.keyframes;
            return setFrames(keyframes);
        });
    }, [
        count,
        frames,
        video
    ]);
    return frames;
}
var INITIAL_CROPPED_MILLIS = 1000;
var PICKER_FRAME_COUNT = 10;
function useVideoClipper(config) {
    var file = config.file, start = config.start;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), duration = ref[0], setDuration = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        width: 0,
        height: 0
    }), dimensions = ref1[0], setDimensions = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        function loadState() {
            return _loadState.apply(this, arguments);
        }
        function _loadState() {
            _loadState = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
                var ref, extractedDimensions, extractedDuration, initialStartTime, initialDuration;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (file === null) return [
                                2
                            ];
                            return [
                                4,
                                Promise.all([
                                    (0,_utils_video__WEBPACK_IMPORTED_MODULE_3__/* .getVideoDimensions */ .jC)(file),
                                    (0,_utils_video__WEBPACK_IMPORTED_MODULE_3__/* .getVideoDurationMillis */ .nr)(file)
                                ])
                            ];
                        case 1:
                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), extractedDimensions = ref[0], extractedDuration = ref[1];
                            initialStartTime = Math.min(start !== null && start !== void 0 ? start : 0, extractedDuration - INITIAL_CROPPED_MILLIS);
                            initialDuration = Math.min(INITIAL_CROPPED_MILLIS, extractedDuration - initialStartTime);
                            setStartTime(initialStartTime);
                            setSelectedDuration(initialDuration);
                            setDimensions(extractedDimensions);
                            setDuration(extractedDuration);
                            return [
                                2
                            ];
                    }
                });
            });
            return _loadState.apply(this, arguments);
        }
        loadState().catch(console.error);
    }, [
        file,
        start
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), startTime = ref2[0], setStartTime = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(INITIAL_CROPPED_MILLIS), selectedDuration = ref3[0], setSelectedDuration = ref3[1];
    if (duration === null) {
        return null;
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, dimensions), {
        startTime: startTime,
        selectedDuration: selectedDuration,
        setStartTime: setStartTime,
        setSelectedDuration: setSelectedDuration,
        duration: duration
    });
}
function clampNumber(x, min, max) {
    return Math.max(Math.min(max, x), min);
}
var MAX_FREE_MILLIS = 1000;
var MIN_ALLOWED_MILLIS = 300;
var MAX_ALLOWED_MILLIS = 30000;
function ClipVideoSector(props) {
    var className = props.className, controller = props.controller, file = props.file;
    var startTime = controller.startTime, selectedDuration = controller.selectedDuration, setStartTime = controller.setStartTime, setSelectedDuration = controller.setSelectedDuration, duration = controller.duration;
    var keyframes = useKeyFrames(file, PICKER_FRAME_COUNT);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), position = ref[0], setPosition = ref[1];
    var now = ((0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(video_provider__WEBPACK_IMPORTED_MODULE_6__/* .VideoContext */ .l) || {}).now;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), initialMouse = ref1[0], setInitialMouse = ref1[1];
    var leftWidth = startTime / duration * 100;
    var endTime = startTime + selectedDuration;
    var rightWidth = (duration - endTime) / duration * 100;
    var frameWidth = 100 / PICKER_FRAME_COUNT;
    var costsCoins = (0,_editors_restyle__WEBPACK_IMPORTED_MODULE_9__.calculateDurationPrice)(selectedDuration) > 0;
    var durationSeconds = duration / 1000;
    var startPercent = startTime / duration * 100;
    var endPercent = endTime / duration * 100;
    var currentPercent = (now !== null && now !== void 0 ? now : 0) / durationSeconds * 100;
    var progressPercent = Math.max(startPercent, Math.min(endPercent, currentPercent));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("relative flex w-full", position === "middle" ? "cursor-grab" : "cursor-ew-resize", className),
        onPointerLeave: function(_) {
            setPosition(null);
            setInitialMouse(null);
        },
        onPointerUp: function(_) {
            setPosition(null);
            setInitialMouse(null);
        },
        onPointerMove: function onPointerMove(event) {
            if (!position) {
                return;
            }
            var ref = event.currentTarget.getBoundingClientRect(), x = ref.x, width = ref.width;
            var percentUnclamped = (event.clientX - x) / width;
            var percent = clampNumber(percentUnclamped, 0, 1);
            var unclampedTime = percent * duration;
            switch(position){
                case "left":
                    var currentEnd = startTime + selectedDuration;
                    var clampedStartDuration = Math.max(MIN_ALLOWED_MILLIS, Math.min(MAX_ALLOWED_MILLIS, currentEnd - unclampedTime));
                    setSelectedDuration(Math.round(clampedStartDuration));
                    var clampedStart = Math.max(0, currentEnd - clampedStartDuration);
                    setStartTime(Math.round(clampedStart));
                    break;
                case "right":
                    var clampedDuration = Math.max(MIN_ALLOWED_MILLIS, Math.min(MAX_ALLOWED_MILLIS, unclampedTime - startTime));
                    setSelectedDuration(Math.round(clampedDuration));
                    break;
                case "middle":
                    if (initialMouse === null) {
                        setInitialMouse({
                            time: unclampedTime,
                            startTime: startTime
                        });
                        break;
                    }
                    var delta = unclampedTime - initialMouse.time;
                    var newStartTime = clampNumber(initialMouse.startTime + delta, 0, duration - selectedDuration);
                    setStartTime(Math.round(newStartTime));
                    break;
            }
        },
        children: [
            keyframes ? keyframes.map(function(keyframe, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: keyframe.source,
                    alt: "keyframe image",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("pointer-events-none aspect-[9/16] object-cover", index === 0 && "rounded-l-[8px]", index === keyframes.length - 1 && "rounded-r-[8px]"),
                    style: {
                        width: "".concat(frameWidth, "%")
                    }
                }, keyframe.source);
            }) : new Array(PICKER_FRAME_COUNT).fill(null).map(function(_, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("pointer-events-none aspect-[9/16] object-cover", index === 0 && "rounded-l-[8px]", index === PICKER_FRAME_COUNT - 1 && "rounded-r-[8px]"),
                    style: {
                        width: "".concat(frameWidth, "%")
                    }
                }, index);
            }),
            now !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute top-0 h-full w-1 -translate-x-1/2 bg-color-white transition-all duration-75",
                style: {
                    left: "".concat(progressPercent, "%")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute inset-0 flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("rounded-l-[8px] bg-color-black/60", position === null && "cursor-grab"),
                        style: {
                            width: "".concat(leftWidth, "%")
                        },
                        onPointerDown: function(_) {
                            return setPosition("middle");
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("flex flex-1 justify-between inner-border-[3px]", costsCoins ? "inner-border-[#FABF2A]" : "inner-border-color-success", "transition-colors"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("flex h-full w-3 items-center justify-center", "-translate-x-[5px] cursor-ew-resize rounded-l-[3px]", costsCoins ? "bg-[#FABF2A]" : "bg-color-success", "transition-colors"),
                                onPointerDown: function(_) {
                                    return setPosition("left");
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-1/2 w-[3px] rounded-full bg-color-white"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("-mx-2 flex-1", position === null && "cursor-grab"),
                                onPointerDown: function(_) {
                                    return setPosition("middle");
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("flex h-full w-3 items-center justify-center", "translate-x-[5px] cursor-ew-resize rounded-r-[3px]", costsCoins ? "bg-[#FABF2A]" : "bg-color-success", "transition-colors"),
                                onPointerDown: function(_) {
                                    return setPosition("right");
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-1/2 w-[3px] rounded-full bg-color-white"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("rounded-r-[8px] bg-color-black/60", position === null && "cursor-grab"),
                        style: {
                            width: "".concat(rightWidth, "%")
                        },
                        onPointerDown: function(_) {
                            return setPosition("middle");
                        }
                    })
                ]
            })
        ]
    });
}
function ParamtersTrigger(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), open = ref[0], setOpen = ref[1];
    var actionLoading = props.actionLoading, className = props.className;
    var params = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_editors_deform__WEBPACK_IMPORTED_MODULE_8__.ParamsContext);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    if (!params) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "Cannot use params trigger here"
        });
    }
    if (!params.params) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var countVisible = 0;
    for(var i = 0; i < params.params.length; i++){
        var param = params.params[i];
        var type = param.type;
        if (type === "slider" && !param.invisible) {
            countVisible++;
        }
        if (type === "checkbox" || type === "cameras" || type === "select" || type === "switcher") {
            countVisible++;
        }
    }
    var invisible = countVisible === 0;
    if (invisible) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: function() {
                    if (actionLoading) return;
                    setOpen(true);
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("group flex items-center gap-2 rounded-[15px] bg-color-cell px-4 py-6 transition-all hover:bg-blue-200", actionLoading && "opacity-30", className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 22 22",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.2498 3.66602H12.8331",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.16654 3.66602H2.74988",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.25 11H11",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.33333 11H2.75",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M19.2498 18.332H14.6665",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M11 18.332H2.75",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.833 1.83203V5.4987",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.33313 9.16602V12.8327",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14.6665 16.5V20.1667",
                                stroke: "var(--color-blue-500)",
                                strokeWidth: "1.83333",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[16px] font-600 text-blue-600 transition-colors group-hover:text-blue-800",
                        children: t("lbl_parameters")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M9 6L15 12L9 18",
                            stroke: "#9195AB",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RestyleConfigurator, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props), {
                open: open,
                setOpen: setOpen,
                params: params.params
            }))
        ]
    });
}
function ConfigSwitcher(props) {
    var id = props.id, name = props.name, value = props.value, setState = props.setState;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-2 rounded-[6px] bg-color-background px-3 py-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-700 uppercase text-blue-600",
                    children: t(name)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_toggle__WEBPACK_IMPORTED_MODULE_2__/* .Switch */ .rs, {
                    enabled: value === 1,
                    onChange: function(status) {
                        return setState(status ? 0 : 1);
                    }
                })
            ]
        })
    }, id);
}
function ConfigCameras(props) {
    var id = props.id, value = props.value, styles = props.styles, setState = props.setState;
    var cameraRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex w-full justify-start gap-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-0 top-0 h-full w-12 bg-gradient-to-l from-color-cell to-color-white/0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "no-scrollbar flex gap-2 overflow-x-scroll px-4",
                ref: cameraRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("font-500 transition-all", value === "" ? "text-primary-500" : "text-blue-600"),
                        onClick: function(_) {
                            return setState("");
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                "aria-checked": value === "",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("border-2 border-[transparent] aria-checked:border-primary-500", "transition-all", "h-[84px] w-[84px] shrink-0 overflow-hidden rounded-[12px]"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_1__/* .CustomThemedResource */ .aK, {
                                    source: "/tools/none-image",
                                    className: "h-full w-full object-cover"
                                })
                            }),
                            t("lbl_none")
                        ]
                    }),
                    styles.map(function(style) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "font-500 text-blue-600",
                            onClick: function(_) {
                                return setState(style.id);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    "aria-checked": value === style.id,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("border-2 border-[transparent] aria-checked:border-primary-500", "transition-all", "h-[84px] w-[84px] shrink-0 overflow-hidden rounded-[12px]"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: style.image,
                                        alt: "style image",
                                        className: "h-full w-full object-cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("w-[84px] truncate font-500 transition-all", value === style.id ? "text-primary-500" : "text-blue-600"),
                                    children: style.name
                                })
                            ]
                        }, style.id);
                    })
                ]
            })
        ]
    }, id);
}
var SCROLL_SPEED = 0.8;
function RestyleConfigurator(props) {
    var promptState = props.promptState, params = props.params, setPromptState = props.setPromptState, open = props.open, setOpen = props.setOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(promptState), currentPromptState = ref[0], setCurrentPromptState = ref[1];
    var cameraRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), showHints = ref1[0], setShowHints = ref1[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        var handleWheel = function handleWheel(event) {
            if (!element) {
                return;
            }
            event.preventDefault();
            element.scrollLeft += event.deltaY * SCROLL_SPEED + event.deltaX;
        };
        var element = cameraRef.current;
        if (!element) {
            return;
        }
        element.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return function() {
            return element.removeEventListener("wheel", handleWheel);
        };
    }, [
        cameraRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setCurrentPromptState(promptState);
    }, [
        promptState
    ]);
    if (!params) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var countSlider = 0;
    for(var i = 0; i < params.length; i = i + 1){
        var param = params[i];
        if (param.type === "slider" && param.invisible) {
            countSlider = countSlider + 1;
        }
    }
    var invisible = params.length === countSlider;
    if (invisible) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:items-center tablet:justify-center", !open && "pointer-events-none opacity-0", "z-[120] transition-opacity"),
        id: "ai-config-popup",
        onClick: function(event) {
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(event.target, Element)) {
                if (event.target.id === event.currentTarget.id) {
                    setOpen(false);
                    if (currentPromptState !== promptState) {
                        setCurrentPromptState(promptState);
                    }
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("relative w-full rounded-2xl bg-color-cell pb-9 pt-5 transition-all tablet:w-[575px] tablet:py-4", open ? "translate-y-0" : "translate-y-full tablet:translate-y-0"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        setOpen(false);
                        if (currentPromptState !== promptState) {
                            setCurrentPromptState(promptState);
                        }
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("absolute -right-10 top-0 hidden h-8 w-8 items-center justify-center rounded-full desktop:flex", "bg-color-cell transition-colors hover:bg-blue-100"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_1__/* .CustomThemedResource */ .aK, {
                        format: "svg",
                        source: "/general/close"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "block w-full pb-1 text-center text-[20px] font-600 text-blue-600",
                    children: t("lbl_parameters")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        return setShowHints(!showHints);
                    },
                    className: "absolute right-4 top-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "transition-all",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#clip0_8639_9982)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "9.99935",
                                        cy: "10.0001",
                                        r: "8.33333",
                                        fill: !showHints ? "var(--color-background-cell)" : "var(--color-blue-500)",
                                        stroke: "var(--color-blue-500)",
                                        strokeWidth: "1.66667",
                                        className: "transition-all"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M10.0007 11.25V11.0167C10.0007 10.2612 10.4224 9.86114 10.8441 9.53891C11.2557 9.2278 11.6673 8.82782 11.6673 8.09448C11.6673 7.07226 10.9244 6.25 10.0007 6.25C9.07694 6.25 8.33398 7.07226 8.33398 8.09448",
                                        stroke: !showHints ? "var(--color-blue-500)" : "var(--color-background-cell)",
                                        strokeWidth: "1.66667",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        className: "transition-all"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M9.9969 13.7499H10.0044",
                                        stroke: !showHints ? "var(--color-blue-500)" : "var(--color-background-cell)",
                                        strokeWidth: "1.66667",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        className: "transition-all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                                    id: "clip0_8639_9982",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        width: "20",
                                        height: "20",
                                        fill: "var(--color-background-cell)"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-1 flex flex-col gap-3",
                    children: params.map(function(param) {
                        switch(param.type){
                            case "switcher":
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfigSwitcher, {
                                    id: param.id,
                                    name: param.name,
                                    value: currentPromptState[param.id],
                                    setState: function(value) {
                                        return setCurrentPromptState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, currentPromptState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, value)));
                                    }
                                }, param.id);
                            case "cameras":
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfigCameras, {
                                    id: param.id,
                                    styles: param.styles,
                                    value: currentPromptState[param.id],
                                    setState: function(value) {
                                        return setCurrentPromptState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, currentPromptState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, value)));
                                    }
                                }, param.id);
                            case "slider":
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderConfigurator, {
                                    value: currentPromptState[param.id],
                                    id: param.id,
                                    name: param.name,
                                    kind: param.kind,
                                    hint: param.hint,
                                    suffix: param.suffix,
                                    values: param.values,
                                    maxFreeValue: param.maxFreeValue,
                                    showHints: showHints,
                                    current: currentPromptState[param.id],
                                    invisible: param.invisible,
                                    updateValue: function(value) {
                                        return setCurrentPromptState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, currentPromptState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, param.id, value)));
                                    }
                                }, param.id);
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-4 flex flex-row gap-3 px-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .ConditionalButton */ .Di, {
                            style: "empty",
                            className: "!w-[97px] !min-w-[97px] tablet:!w-[200px] tablet:!min-w-[200px]",
                            onClick: function() {
                                return setPromptState(createPromptStateFrom(params));
                            },
                            children: t("lbl_reset")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .ConditionalButton */ .Di, {
                            className: "flex-1",
                            onClick: function() {
                                setPromptState(currentPromptState);
                                setOpen(false);
                            },
                            children: t("lbl_done")
                        })
                    ]
                })
            ]
        })
    });
}
function SliderConfiguratorDashboard(props) {
    var name = props.name, value = props.value, id = props.id, suffix = props.suffix, kind = props.kind, values = props.values, current = props.current, updateValue = props.updateValue, maxFreeValue = props.maxFreeValue, invisible = props.invisible;
    var selected = typeof value === "number" ? value : 0;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var isFree = typeof value === "string" || typeof value === "boolean" || value <= maxFreeValue;
    if (invisible) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-600 text-blue-800",
                                children: t(name)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_18__/* .assetUrl */ .p)("/general/coin.svg"),
                                alt: "coin icon",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(isFree ? "opacity-0" : "opacity-100", "transition-opacity")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "flex w-[44px] items-center justify-center rounded-[4px] bg-blue-200 text-[14px] text-blue-600",
                        children: [
                            current,
                            suffix
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderWithValues, {
                suffix: suffix,
                kind: kind,
                values: values,
                selected: selected,
                maxFreeValue: maxFreeValue,
                onResolve: updateValue
            })
        ]
    }, id);
}
function SliderConfigurator(props) {
    var showHints = props.showHints, name = props.name, value = props.value, id = props.id, hint = props.hint, suffix = props.suffix, kind = props.kind, values = props.values, current = props.current, updateValue = props.updateValue, maxFreeValue = props.maxFreeValue, invisible = props.invisible;
    var selected = typeof value === "number" ? value : 0;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var isFree = typeof value === "string" || typeof value === "boolean" || value <= maxFreeValue;
    if (invisible) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col rounded-[6px] bg-color-background px-4 py-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-grey-600 font-700 uppercase",
                            children: t(name)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_18__/* .assetUrl */ .p)("/general/coin.svg"),
                            alt: "coin icon",
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(isFree ? "opacity-0" : "opacity-100", "transition-opacity")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-grey-600 flex w-[44px] items-center justify-center rounded-[4px] bg-blue-200 text-[14px]",
                            children: [
                                current,
                                suffix
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("text-grey-600 text-[12px]", showHints ? "max-h-[36px]" : "max-h-0", "overflow-hidden transition-all duration-300"),
                    children: t(hint)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderWithValues, {
                    suffix: suffix,
                    kind: kind,
                    values: values,
                    selected: selected,
                    maxFreeValue: maxFreeValue,
                    onResolve: updateValue
                })
            ]
        }, id)
    });
}
function SliderWithValues(props) {
    var values = props.values, maxFreeValue = props.maxFreeValue, selected = props.selected, onResolve = props.onResolve, kind = props.kind, suffix = props.suffix;
    var defaultIndex = values.indexOf(maxFreeValue);
    var _values = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(values, 1), minNormal = _values[0];
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(values.slice(-1), 1), maxNormal = ref[0];
    var min = kind === "normal" ? minNormal : 0;
    var max = kind === "normal" ? maxNormal : values.length - 1;
    var range = max - min;
    var initialPercent = (maxFreeValue - min) / range * 100;
    var initialPart = defaultIndex / (values.length - 1) * 100;
    var selectedIndex = values.indexOf(selected);
    var selectedPercent = (selected - min) / range * 100;
    var selectedPart = selectedIndex / (values.length - 1) * 100;
    var defaultWidth = kind === "normal" ? initialPercent : initialPart;
    var selectedPosition = kind === "normal" ? selectedPercent : selectedPart;
    var selectedLeft = selectedPosition;
    var greenWidth = Math.min(defaultWidth, selectedPosition);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "range",
                        min: min,
                        max: max,
                        step: 1,
                        value: kind === "normal" ? selected : selectedIndex,
                        className: "relative z-[100] w-full cursor-grab opacity-0 active:cursor-grabbing",
                        onChange: function(e) {
                            var newSelected = parseInt(e.currentTarget.value);
                            var realValue = kind === "normal" ? newSelected : values[newSelected];
                            onResolve(realValue);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 top-1/2 z-10 h-1 w-full -translate-y-1/2 bg-blue-200"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 top-1/2 z-20 h-1 -translate-y-1/2 bg-[#FABF2A]",
                                style: {
                                    width: "".concat(selectedLeft, "%")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 top-1/2 z-30 h-1 -translate-y-1/2 bg-primary-500",
                                style: {
                                    width: "".concat(greenWidth, "%")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("absolute top-1/2 z-50 h-[16px] w-[16px] -translate-x-1/2 -translate-y-1/2", "rounded-full border-2 border-primary-500 bg-color-cell"),
                                style: {
                                    left: "".concat(selectedLeft, "%")
                                }
                            }),
                            values.map(function(value, index) {
                                var percent = (value - min) / range;
                                var part = index / (values.length - 1);
                                var position = kind === "normal" ? percent : part;
                                var activePoint = value <= selected;
                                var greenPoint = maxFreeValue >= value;
                                var greenIndicator = greenPoint && activePoint;
                                var yellowIndicator = !greenPoint && activePoint;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("absolute top-1/2  h-[7px] w-[7px] -translate-y-1/2", "rounded-full", greenIndicator && "z-40 bg-primary-500", yellowIndicator && "z-20 bg-[#FABF2A]", !activePoint && "z-10 bg-blue-200"),
                                    style: {
                                        left: "".concat(position * 100, "%")
                                    }
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative h-4",
                children: values.map(function(value, index) {
                    var percent = (value - min) / range;
                    var part = index / (values.length - 1);
                    var position = kind === "normal" ? percent : part;
                    var firstPoint = index === 0;
                    var lastPoint = index === values.length - 1;
                    var middlePoint = !firstPoint && !lastPoint;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("absolute bottom-0 text-[11px] font-500 text-blue-600", middlePoint && "-translate-x-1/2", lastPoint && "-translate-x-full"),
                        style: {
                            left: "".concat(position * 100, "%")
                        },
                        children: [
                            value,
                            suffix
                        ]
                    }, value);
                })
            })
        ]
    });
}
function ConfigCheckbox(props) {
    var id = props.id, icon_light = props.icon_light, icon_dark = props.icon_dark, name = props.name, default_value = props.default_value, promptState = props.promptState, setPromptState = props.setPromptState;
    var ref = useState(Boolean(default_value)), checked = ref[0], setChecked = ref[1];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-row items-center justify-between",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-row items-center gap-3 text-[18px] font-500 text-blue-600",
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: icon_light,
                            alt: "ter icon light",
                            className: "h-[20px] w-[20px] dark:hidden"
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: icon_dark,
                            alt: "ter icon dark",
                            className: "hidden h-[20px] w-[20px] dark:block"
                        }),
                        name
                    ]
                }),
                /*#__PURE__*/ _jsx(SquareSwitch, {
                    enabled: checked,
                    onChange: function(value) {
                        setChecked(!checked);
                        setPromptState(_object_spread_props(_object_spread({}, promptState), _define_property({}, id, value)));
                    }
                })
            ]
        })
    });
}
function GroupSection(props) {
    var components = props.components, promptState = props.promptState, setPromptState = props.setPromptState;
    var cameraRef = useRef(null);
    useEffect(function() {
        var handleWheel = function handleWheel(event) {
            if (!element) {
                return;
            }
            event.preventDefault();
            element.scrollLeft += event.deltaY * SCROLL_SPEED + event.deltaX;
        };
        var element = cameraRef.current;
        if (!element) {
            return;
        }
        element.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return function() {
            return element.removeEventListener("wheel", handleWheel);
        };
    }, [
        cameraRef
    ]);
    if (!promptState) return /*#__PURE__*/ _jsx(_Fragment, {});
    var countSlider = 0;
    for(var i = 0; i < components.length; i = i + 1){
        var param = components[i];
        if (param.type === "slider" && param.invisible) {
            countSlider = countSlider + 1;
        }
    }
    var invisible = components.length === countSlider;
    if (invisible) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex flex-col gap-[22px] rounded-[14px] bg-color-cell py-[22px] pl-[12px] pr-[22px]",
            children: components.map(function(param) {
                switch(param.type){
                    case "switcher":
                        return /*#__PURE__*/ _jsx(ConfigSwitcher, {
                            id: param.id,
                            name: param.name,
                            value: promptState[param.id],
                            setState: function(value) {
                                return setPromptState(_object_spread_props(_object_spread({}, promptState), _define_property({}, param.id, value)));
                            }
                        }, param.id);
                    case "cameras":
                        return /*#__PURE__*/ _jsx(ConfigCameras, {
                            id: param.id,
                            styles: param.styles,
                            value: promptState[param.id],
                            setState: function(value) {
                                return setPromptState(_object_spread_props(_object_spread({}, promptState), _define_property({}, param.id, value)));
                            }
                        }, param.id);
                    case "slider":
                        return /*#__PURE__*/ _jsx(SliderConfigurator, {
                            value: promptState[param.id],
                            id: param.id,
                            name: param.name,
                            kind: param.kind,
                            hint: param.hint,
                            showHints: false,
                            suffix: param.suffix,
                            values: param.values,
                            maxFreeValue: param.maxFreeValue,
                            current: promptState[param.id],
                            invisible: param.invisible,
                            updateValue: function(value) {
                                return setPromptState(_object_spread_props(_object_spread({}, promptState), _define_property({}, param.id, value)));
                            }
                        }, param.id);
                    case "checkbox":
                        return /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(ConfigCheckbox, {
                                    id: param.id,
                                    icon_light: param.icon_light,
                                    icon_dark: param.icon_dark,
                                    name: param.name_en,
                                    default_value: param.defaultValue,
                                    promptState: promptState,
                                    setPromptState: setPromptState
                                }, param.id),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex-1 border-b border-blue-200 last:hidden"
                                })
                            ]
                        });
                    case "select":
                        return /*#__PURE__*/ _jsx(_Fragment, {
                            children: "Aystex karox e linel dzer govazdy"
                        });
                }
            })
        })
    });
}


/***/ }),

/***/ 1455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ textToVideoSmallIcon; },
/* harmony export */   "Ay": function() { return /* binding */ deforumSmallIcon; },
/* harmony export */   "Cz": function() { return /* binding */ textToVideoIcon; },
/* harmony export */   "DS": function() { return /* binding */ newCloseIcon; },
/* harmony export */   "Jf": function() { return /* binding */ moreIcon; },
/* harmony export */   "Lt": function() { return /* binding */ restyleIcon; },
/* harmony export */   "PD": function() { return /* binding */ CheckboxIcon; },
/* harmony export */   "Rk": function() { return /* binding */ ClearIcon; },
/* harmony export */   "SB": function() { return /* binding */ aiAdsGenratorIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "Uq": function() { return /* binding */ galleryIcon; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "Wn": function() { return /* binding */ textToImageSmallIcon; },
/* harmony export */   "X9": function() { return /* binding */ allIcon; },
/* harmony export */   "XB": function() { return /* binding */ ImageIcon; },
/* harmony export */   "XH": function() { return /* binding */ TrashIcon; },
/* harmony export */   "YH": function() { return /* binding */ lookAiIcon; },
/* harmony export */   "bv": function() { return /* binding */ videoBGRemoverIcon; },
/* harmony export */   "ce": function() { return /* binding */ productUrlToAdsIcon; },
/* harmony export */   "f7": function() { return /* binding */ textToImageIcon; },
/* harmony export */   "hM": function() { return /* binding */ generativeFillIcon; },
/* harmony export */   "hd": function() { return /* binding */ ButtonArrowIcon; },
/* harmony export */   "k1": function() { return /* binding */ FilterIcon; },
/* harmony export */   "kf": function() { return /* binding */ photoAiSmallIcon; },
/* harmony export */   "m5": function() { return /* binding */ restyleSmallIcon; },
/* harmony export */   "rL": function() { return /* binding */ musicGeneratorIcon; },
/* harmony export */   "re": function() { return /* binding */ generateIcon; },
/* harmony export */   "s8": function() { return /* binding */ globusIcon; },
/* harmony export */   "sz": function() { return /* binding */ InfoIcon; },
/* harmony export */   "uv": function() { return /* binding */ deforumIcon; },
/* harmony export */   "wQ": function() { return /* binding */ AIPhotoshoot; },
/* harmony export */   "wv": function() { return /* binding */ templatesIcon; },
/* harmony export */   "x$": function() { return /* binding */ photoAiIcon; },
/* harmony export */   "y$": function() { return /* binding */ scriptToAdsGenerator; },
/* harmony export */   "zB": function() { return /* binding */ aiScriptGenerator; },
/* harmony export */   "zl": function() { return /* binding */ videoGptIcon; }
/* harmony export */ });
/* unused harmony exports ParametersFilterIcon, AiModelIcon, closeIcon, enhanceIcon, DownArrowsIcon, DownArrowsDesktopIcon, PlusIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TrashIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.00031 4.5H18.0003",
                    stroke: "#FD2E2E",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.00031 1.5H14.0003",
                    stroke: "#FD2E2E",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.50031 4.49609H16.5003V15.3333C16.5003 16.8061 15.3064 18 13.8336 18H6.16697C4.69421 18 3.50031 16.8061 3.50031 15.3333V4.49609Z",
                    stroke: "#FD2E2E",
                    strokeWidth: "1.5"
                })
            ]
        })
    });
};
var CloseIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "16",
                    height: "16",
                    rx: "8",
                    fill: "#FD2E2E"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.1661 5.03351C5.85368 4.72109 5.34715 4.72109 5.03473 5.03351C4.72231 5.34593 4.72231 5.85246 5.03473 6.16488L6.86904 7.99919L5.03473 9.83351C4.72231 10.1459 4.72231 10.6525 5.03473 10.9649C5.34715 11.2773 5.85368 11.2773 6.1661 10.9649L8.00042 9.13057L9.83473 10.9649C10.1471 11.2773 10.6537 11.2773 10.9661 10.9649C11.2785 10.6525 11.2785 10.1459 10.9661 9.83351L9.13179 7.99919L10.9661 6.16488C11.2785 5.85246 11.2785 5.34593 10.9661 5.03351C10.6537 4.72109 10.1471 4.72109 9.83473 5.03351L8.00042 6.86782L6.1661 5.03351Z",
                    fill: "white"
                })
            ]
        })
    });
};
var CheckboxIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "16",
                    height: "16",
                    rx: "8",
                    fill: "#09C185"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11.4169 5.54272L6.2214 10.4574L4.53638 8.49153",
                    stroke: "white",
                    strokeWidth: "1.44",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var ImageIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "22",
            height: "23",
            viewBox: "0 0 22 23",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.24992 20.6663H13.7499C18.3333 20.6663 20.1666 18.833 20.1666 14.2497V8.74967C20.1666 4.16634 18.3333 2.33301 13.7499 2.33301H8.24992C3.66659 2.33301 1.83325 4.16634 1.83325 8.74967V14.2497C1.83325 18.833 3.66659 20.6663 8.24992 20.6663Z",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.65",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.25008 9.66642C9.2626 9.66642 10.0834 8.84561 10.0834 7.83309C10.0834 6.82057 9.2626 5.99976 8.25008 5.99976C7.23756 5.99976 6.41675 6.82057 6.41675 7.83309C6.41675 8.84561 7.23756 9.66642 8.25008 9.66642Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.75 17.9164L7.19202 14.8615C7.90382 14.3724 8.93098 14.4277 9.5707 14.9907L9.86804 15.2584C10.5708 15.8767 11.7061 15.8767 12.4089 15.2584L16.1571 11.9635C16.8599 11.3452 17.9952 11.3452 18.698 11.9635L20.1667 13.2556",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.65",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var InfoIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9 2.06262C12.8318 2.06262 15.9375 5.16912 15.9375 9.00012C15.9375 12.8311 12.8318 15.9376 9 15.9376C5.169 15.9376 2.0625 12.8311 2.0625 9.00012C2.0625 5.16912 5.169 2.06262 9 2.06262Z",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.99634 5.25V9.46748",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.99625 12.375H9.00375",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var ButtonArrowIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "6",
            height: "8",
            viewBox: "0 0 6 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.55118 7.15783L1.38892 3.99994L4.55118 0.842041",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var SearchIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "9.38937",
                    cy: "9.38937",
                    r: "6.88937",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.6577 14.6572L17.8998 17.8993",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var FilterIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var ParametersFilterIcon = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M9.2741 16.4884H2.64282",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.3581 16.4877C19.3581 17.9457 18.1762 19.1277 16.7181 19.1277C15.2601 19.1277 14.0781 17.9457 14.0781 16.4877C14.0781 15.0285 15.2601 13.8477 16.7181 13.8477C18.1762 13.8477 19.3581 15.0285 19.3581 16.4877Z",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M12.7258 5.74039H19.3582",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.64233 5.74059C2.64233 7.1997 3.82429 8.38059 5.28233 8.38059C6.74037 8.38059 7.92233 7.1997 7.92233 5.74059C7.92233 4.28255 6.74037 3.10059 5.28233 3.10059C3.82429 3.10059 2.64233 4.28255 2.64233 5.74059Z",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var AIPhotoshoot = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.75162 1.16887C9.13124 0.950115 9.56168 0.834961 9.99984 0.834961C10.438 0.834961 10.8685 0.950124 11.2481 1.16889L11.2498 1.1699L17.08 4.50138L17.0832 4.50322C17.4628 4.72243 17.7782 5.03762 17.9976 5.41718C18.217 5.79674 18.3327 6.22732 18.3332 6.66573V6.66658V13.3333V13.3341C18.3327 13.7725 18.217 14.2031 17.9976 14.5827C17.7782 14.9622 17.4628 15.2774 17.0832 15.4966L17.08 15.4985L11.2498 18.8299L11.2483 18.8308C10.8876 19.0387 10.481 19.1531 10.0655 19.164C10.0439 19.1657 10.0219 19.1666 9.99984 19.1666C9.97773 19.1666 9.95582 19.1657 9.93415 19.164C9.51865 19.1531 9.11206 19.0387 8.75138 18.8308L8.74984 18.8299L2.91972 15.4985L2.9165 15.4966C2.53683 15.2774 2.22148 14.9622 2.00208 14.5827C1.78268 14.2031 1.66695 13.7725 1.6665 13.3341V13.3333V6.66658V6.66573C1.66695 6.22732 1.78268 5.79674 2.00208 5.41718C2.22148 5.03762 2.53683 4.72243 2.9165 4.50323L2.91972 4.50138L2.91972 4.50138L8.75162 1.16887ZM10.8332 17.1485L16.2498 14.0532L16.2512 14.0525C16.3771 13.9794 16.4818 13.8747 16.5546 13.7486C16.6278 13.6221 16.6664 13.4785 16.6665 13.3324V7.12966L10.8332 10.4821V17.1485ZM9.1665 10.4821V17.1485L3.74984 14.0532L3.74852 14.0525C3.62255 13.9794 3.51791 13.8747 3.44503 13.7486C3.37196 13.6222 3.33338 13.4788 3.33317 13.3328V7.12961L9.1665 10.4821ZM9.99984 2.50163C9.85356 2.50163 9.70985 2.54013 9.58317 2.61327L9.57996 2.61513L9.57995 2.61512L4.18594 5.6974L9.99988 9.03874L15.8138 5.69743L10.4197 2.61512L10.4165 2.61328L10.4165 2.61327C10.2898 2.54013 10.1461 2.50163 9.99984 2.50163Z",
            fill: "var(--icon-color)"
        })
    });
};
var AiModelIcon = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "25",
            height: "24",
            viewBox: "0 0 25 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M11.3299 10.3132L10.7955 11.5132C10.6725 11.7891 10.6295 12.0742 10.6633 12.3441C10.6971 12.6141 10.8082 12.8699 10.9928 13.0862L11.7957 14.0287C11.8325 14.0731 11.8502 14.131 11.8447 14.1902C11.8393 14.2494 11.8112 14.3051 11.7665 14.3452C11.7349 14.3741 11.6962 14.3936 11.6549 14.4016C11.6136 14.4095 11.5715 14.4055 11.5333 14.39L10.3885 13.9184C10.1361 13.8123 9.85579 13.7833 9.5809 13.8349C9.30371 13.8903 9.04412 14.0231 8.8317 14.2179L7.85612 15.0975C7.83439 15.1177 7.8091 15.1335 7.78172 15.1439C7.75435 15.1543 7.72543 15.1592 7.69666 15.1583C7.66788 15.1573 7.63983 15.1505 7.61414 15.1384C7.58845 15.1262 7.56563 15.1088 7.54701 15.0873C7.52043 15.0559 7.50354 15.017 7.4983 14.9753C7.49307 14.9336 7.49972 14.8907 7.51746 14.8516L8.05185 13.6517C8.17152 13.3894 8.21735 13.1014 8.18409 12.8207C8.14816 12.5434 8.03408 12.2858 7.85536 12.0785L7.05206 11.1356C7.01509 11.0912 6.99745 11.0331 7.00296 10.9738C7.00848 10.9145 7.03669 10.8588 7.08152 10.8187C7.11319 10.7898 7.1519 10.7702 7.19318 10.7623C7.23445 10.7544 7.2766 10.7584 7.31474 10.7738L8.45996 11.2458C8.71238 11.3519 8.99272 11.3809 9.26761 11.3293C9.5343 11.2776 9.79255 11.1488 10.0168 10.9463L10.9924 10.0667C11.0141 10.0465 11.0394 10.0307 11.0668 10.0203C11.0942 10.0099 11.1231 10.005 11.1519 10.0059C11.1806 10.0069 11.2087 10.0137 11.2344 10.0259C11.2601 10.038 11.2829 10.0554 11.3015 10.0769C11.3281 10.1084 11.345 10.1472 11.3502 10.1889C11.3554 10.2306 11.3488 10.2735 11.331 10.3126L11.3299 10.3132ZM14.7335 7.76721L14.4866 8.322C14.4402 8.42433 14.4229 8.53661 14.4364 8.6459C14.4522 8.75025 14.4936 8.84347 14.562 8.92291L14.9336 9.35869C14.9705 9.40301 14.9881 9.46099 14.9827 9.52018C14.9772 9.57936 14.9492 9.635 14.9045 9.67514C14.8728 9.70404 14.8341 9.7236 14.7928 9.73154C14.7516 9.73948 14.7094 9.73548 14.6713 9.72L14.1419 9.50157C14.041 9.46027 13.9348 9.44978 13.8333 9.46905C13.7319 9.48831 13.6327 9.53901 13.5471 9.61585L13.096 10.0224C13.0743 10.0426 13.049 10.0583 13.0216 10.0688C12.9943 10.0792 12.9653 10.0841 12.9366 10.0831C12.9078 10.0822 12.8797 10.0754 12.8541 10.0632C12.8284 10.051 12.8055 10.0337 12.7869 10.0121C12.7603 9.98071 12.7434 9.94187 12.7382 9.90015C12.733 9.85843 12.7396 9.81555 12.7574 9.7765L13.0043 9.22171C13.05 9.12147 13.0677 9.01145 13.0553 8.90411C13.041 8.79825 12.9972 8.69999 12.9288 8.6208L12.5572 8.18502C12.5203 8.14071 12.5027 8.08272 12.5082 8.02354C12.5136 7.96436 12.5417 7.90871 12.5863 7.86857C12.618 7.83967 12.6567 7.82012 12.698 7.81218C12.7393 7.80424 12.7814 7.80824 12.8195 7.82371L13.349 8.04214C13.4474 8.08324 13.5567 8.09387 13.6636 8.07274C13.7671 8.05061 13.8638 8.00039 13.9433 7.92754L14.3944 7.521C14.4161 7.50081 14.4414 7.48505 14.4688 7.47462C14.4961 7.4642 14.5251 7.45932 14.5538 7.46028C14.5826 7.46123 14.6106 7.468 14.6363 7.48018C14.662 7.49237 14.6849 7.50972 14.7035 7.53125C14.7301 7.56268 14.7469 7.60152 14.7522 7.64324C14.7574 7.68497 14.7512 7.72817 14.7335 7.76721ZM10.4526 5.86117L10.0761 6.70555C9.9973 6.87862 9.96718 7.0686 9.98917 7.2538L9.9902 7.26731C10.0148 7.43978 10.0875 7.60389 10.206 7.74314L10.7712 8.40606C10.8081 8.45037 10.8257 8.50836 10.8203 8.56754C10.8148 8.62672 10.7868 8.68237 10.7421 8.72251C10.7105 8.75141 10.6717 8.77096 10.6305 8.7789C10.5892 8.78684 10.547 8.78284 10.5089 8.76737L9.70321 8.43558C9.52944 8.36402 9.34621 8.34658 9.17068 8.38014C8.99516 8.41369 8.82478 8.49992 8.6764 8.63332L7.99007 9.25276C7.96834 9.27295 7.94305 9.28871 7.91567 9.29914C7.88829 9.30956 7.85937 9.31444 7.8306 9.31349C7.80183 9.31253 7.77378 9.30577 7.74809 9.29358C7.7224 9.2814 7.69957 9.26404 7.68095 9.24252C7.65437 9.21108 7.63748 9.17224 7.63225 9.13052C7.62702 9.0888 7.63366 9.04591 7.65141 9.00687L8.02748 8.16216C8.10634 7.98923 8.13662 7.79937 8.11486 7.61424C8.09136 7.43136 8.01609 7.26148 7.89805 7.1249L7.33268 6.46119C7.2958 6.41688 7.27819 6.35889 7.28364 6.29971C7.28909 6.24053 7.31715 6.18488 7.3618 6.14474C7.39347 6.11584 7.43218 6.09629 7.47346 6.08835C7.51473 6.08041 7.55688 6.08441 7.59502 6.09988L8.40037 6.43214C8.5737 6.50337 8.75693 6.52081 8.93279 6.48679L8.94652 6.4847C9.11737 6.44917 9.28317 6.36459 9.42719 6.23439L10.114 5.61527C10.1357 5.59509 10.161 5.57933 10.1884 5.5689C10.2157 5.55848 10.2447 5.5536 10.2734 5.55455C10.3022 5.55551 10.3302 5.56227 10.3559 5.57446C10.3816 5.58664 10.4045 5.604 10.4231 5.62552C10.4497 5.65696 10.4665 5.6958 10.4718 5.73752C10.477 5.77924 10.4704 5.82212 10.4526 5.86117Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.7568 18.9303V12.6909C21.7149 11.5175 20.199 11.5167 20.1568 12.6909V18.9303C20.1986 20.1036 21.7145 20.1045 21.7568 18.9303ZM17.234 13.2614C16.9579 12.3765 16.2082 11.8069 15.3259 11.8106C14.4424 11.8141 13.6973 12.3901 13.4277 13.2781C13.4218 13.2978 12.1791 18.7346 12.1791 18.7346C12.071 19.2079 12.3659 19.6794 12.8379 19.7878C13.3102 19.8962 13.7801 19.6004 13.8882 19.1271L14.1238 18.0958H16.5809L16.8273 19.1343C16.9374 19.6102 17.4244 19.8993 17.8831 19.7861C18.3541 19.6737 18.6451 19.1998 18.5331 18.7275C18.5331 18.7275 17.2401 13.281 17.234 13.2614ZM14.5569 16.6106L15.1304 13.6401C15.174 13.4922 15.2498 13.411 15.3455 13.4106H15.3464C15.4423 13.4106 15.5161 13.4885 15.5606 13.6362L16.1569 16.6106H14.5569Z",
                    fill: "var(--icon-color)"
                })
            ]
        })
    });
};
var ClearIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "9",
            height: "9",
            viewBox: "0 0 9 9",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.49512 7.50455L4.50032 4.49934M4.50032 4.49934L7.50553 1.49414M4.50032 4.49934L1.49512 1.49414M4.50032 4.49934L7.50552 7.50455",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        })
    });
};
var lookAiIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.267 10.9331C11.0003 9.93311 9.53364 9.93311 9.26697 10.9331L8.66697 13.7998C8.46697 14.3998 9.46697 14.5998 9.60031 13.9998L9.73364 13.4664H10.9336C11.067 13.7998 11.067 14.5331 11.667 14.3998C11.9336 14.3331 12.067 14.1331 12.0003 13.8664L11.267 10.9331ZM9.86697 12.7331L10.1336 11.1998C10.1336 11.1331 10.2003 11.0664 10.267 11.0664C10.3336 11.0664 10.3336 11.1331 10.4003 11.1998L10.667 12.7331H9.86697Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.7998 10.5996V13.9329C12.7998 14.5329 13.6665 14.5329 13.6665 13.9329V10.5996C13.6665 9.93294 12.7998 9.93294 12.7998 10.5996Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.0669 6.19987L13.4669 3.19987C13.0002 2.19987 11.9336 1.86654 10.9336 1.5332C10.5336 3.86654 5.46689 3.86654 5.06689 1.5332C4.06689 1.86654 3.00022 2.19987 2.53355 3.19987L0.933554 6.19987C0.80022 6.39987 0.933554 6.66654 1.13355 6.7332L3.46689 7.66654C3.53355 7.7332 3.60022 7.79987 3.60022 7.86654L3.20022 14.0665C3.20022 14.2665 3.40022 14.4665 3.60022 14.4665H8.20022C7.93355 14.1332 7.86689 13.6665 7.93355 13.3332L8.53355 10.6665C8.86689 9.19987 10.9336 8.7332 11.8669 9.9332C12.0002 9.7332 12.1336 9.46654 12.4002 9.3332L12.3336 7.79987C12.3336 7.7332 12.4002 7.59987 12.4669 7.59987L14.8002 6.66654C15.0669 6.66654 15.1336 6.3332 15.0669 6.19987ZM12.0669 6.59987C11.4002 6.86654 11.1336 7.59987 11.2669 8.19987C9.66689 7.7332 7.93355 8.7332 7.53355 10.3999V10.4665L6.93355 13.0665C6.93355 13.1332 6.86689 13.2665 6.86689 13.3332H4.46689L4.80022 7.9332C4.86689 7.3332 4.46689 6.79987 3.93355 6.59987L2.33355 5.9332L3.53355 3.66654C3.73355 3.26654 4.06689 2.99987 4.46689 2.86654C5.86689 4.86654 10.0669 4.79987 11.4669 2.86654C11.8669 2.99987 12.2002 3.26654 12.4002 3.66654L13.6002 5.9332L12.0669 6.59987Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var videoBGRemoverIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_18567_138196)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.52711 0.332031C3.97855 0.332031 4.19415 0.887068 3.86107 1.1918L2.49187 2.44447C2.17608 2.73338 1.66748 2.50935 1.66748 2.08134C1.66748 1.94369 1.72512 1.81233 1.82642 1.71914L3.19214 0.462678C3.28346 0.378662 3.40302 0.332031 3.52711 0.332031Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8.00406 0.332031C8.47714 0.332031 8.70399 0.912867 8.35614 1.2335L2.53125 6.60253C2.20137 6.90659 1.66748 6.67261 1.66748 6.22397C1.66748 6.08036 1.72746 5.94328 1.83294 5.84582L7.65153 0.469957C7.74751 0.381279 7.87338 0.332031 8.00406 0.332031Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.71476 7.484C5.78752 7.67482 5.75692 7.89736 5.60428 8.03305L2.49758 10.7946C2.17594 11.0805 1.66748 10.8521 1.66748 10.4218C1.66748 10.2801 1.72777 10.145 1.83329 10.0504L4.95877 7.24828C5.20815 7.02469 5.59543 7.17104 5.71476 7.484Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.2499 12.9806C3.44674 12.8042 3.74719 12.8123 3.93415 12.9992C4.209 13.274 3.93416 13.666 3.86748 13.7326L2.49133 14.9836C2.17494 15.2712 1.66748 15.0468 1.66748 14.6192C1.66748 14.4792 1.72703 14.3458 1.83124 14.2524L3.2499 12.9806Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.66631 3.19531C7.93298 3.19531 6.46631 4.59531 6.46631 6.39531C6.46631 6.46198 6.46631 6.46198 6.46631 6.52865C6.46631 6.79531 6.53298 7.12865 6.59964 7.39531C6.79964 8.06198 7.26631 8.66198 7.86631 9.06198C8.19964 9.26198 8.53298 9.39531 8.86631 9.52865C9.13298 9.59531 9.39964 9.66198 9.66631 9.66198C11.3996 9.66198 12.8663 8.26198 12.8663 6.46198C12.8663 4.66198 11.3996 3.19531 9.66631 3.19531ZM9.66631 8.52865C8.46631 8.52865 7.53298 7.52865 7.53298 6.39531C7.53298 5.19531 8.53298 4.26198 9.66631 4.26198C10.7996 4.26198 11.7996 5.26198 11.7996 6.39531C11.7996 7.52865 10.8663 8.52865 9.66631 8.52865Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M5.0641 14.8668C4.73076 14.8668 4.53076 14.6001 4.53076 14.3335C4.53076 12.8668 5.13076 10.4668 9.2641 10.4668C9.34326 10.4668 9.42149 10.4677 9.49877 10.4696C9.57606 10.4677 9.65429 10.4668 9.73345 10.4668C13.8668 10.4668 14.4668 12.8668 14.4668 14.3335C14.4668 14.6001 14.2668 14.8668 13.9335 14.8668C13.9207 14.8668 13.9082 14.8665 13.8959 14.8659C13.8857 14.8665 13.8751 14.8668 13.8641 14.8668C13.5308 14.8668 13.3308 14.6001 13.3308 14.3335C13.3308 13.0711 12.8673 11.5439 9.49877 11.5335C6.13027 11.5439 5.66679 13.0711 5.66679 14.3335C5.66679 14.6001 5.46678 14.8668 5.13345 14.8668C5.12241 14.8668 5.11181 14.8665 5.10163 14.8659C5.08931 14.8665 5.0768 14.8668 5.0641 14.8668Z",
                        fill: "var(--icon-color)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_18567_138196",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var musicGeneratorIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.87023 9.72266C3.79634 9.72266 2.92578 10.5932 2.92578 11.6671C2.92578 12.741 3.79634 13.6115 4.87023 13.6115C5.94411 13.6115 6.81467 12.741 6.81467 11.6671C6.81467 10.5932 5.94411 9.72266 4.87023 9.72266ZM1.92578 11.6671C1.92578 10.0409 3.24405 8.72266 4.87023 8.72266C6.4964 8.72266 7.81467 10.0409 7.81467 11.6671C7.81467 13.2933 6.4964 14.6115 4.87023 14.6115C3.24405 14.6115 1.92578 13.2933 1.92578 11.6671Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.31543 2.61072C7.59157 2.61072 7.81543 2.83458 7.81543 3.11072V11.6663C7.81543 11.9424 7.59157 12.1663 7.31543 12.1663C7.03929 12.1663 6.81543 11.9424 6.81543 11.6663V3.11072C6.81543 2.83458 7.03929 2.61072 7.31543 2.61072Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.0815 2.47929C7.9425 2.57936 7.81816 2.77766 7.82034 3.10834L7.82036 3.11163L7.82035 3.83274C7.82035 4.05295 7.90885 4.31008 8.07601 4.54104C8.24296 4.7717 8.46049 4.93766 8.67076 5.00861C8.67099 5.00869 8.67123 5.00877 8.67146 5.00885L11.3703 5.90641C11.3704 5.90644 11.3701 5.90637 11.3703 5.90641C11.6892 6.01189 11.918 5.9556 12.0564 5.85572C12.1947 5.75588 12.3204 5.55677 12.3204 5.21996V4.50496C12.3204 4.28475 12.2318 4.02762 12.0647 3.79667C11.8977 3.56602 11.6802 3.40006 11.47 3.32911C11.4697 3.32903 11.4695 3.32894 11.4692 3.32886L8.76978 2.43108L8.7675 2.43032C8.45007 2.32305 8.22065 2.37912 8.0815 2.47929ZM9.08644 1.48254C8.51815 1.29085 7.9414 1.34798 7.49725 1.66772C7.05307 1.98748 6.81689 2.51568 6.82035 3.11317V3.83274C6.82035 4.30309 7.00074 4.76096 7.26594 5.12736C7.53117 5.49381 7.90917 5.80746 8.35258 5.95664L8.35423 5.95719L11.056 6.85574C11.623 7.04344 12.198 6.98679 12.6417 6.66657C13.0854 6.34627 13.3204 5.81816 13.3204 5.21996V4.50496C13.3204 4.03462 13.14 3.57675 12.8748 3.21034C12.6095 2.8439 12.2315 2.53025 11.7881 2.38107L9.08644 1.48254Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0013 12.1514V8.8243C14.979 8.19861 14.1707 8.19814 14.1481 8.8243V12.1514C14.1705 12.7771 14.9788 12.7776 15.0013 12.1514ZM12.5893 9.12852C12.442 8.65663 12.0423 8.3529 11.5718 8.35487C11.1007 8.35674 10.7034 8.66392 10.5596 9.13743C10.5564 9.14793 9.89374 12.0471 9.89374 12.0471C9.8361 12.2995 9.99339 12.5509 10.245 12.6087C10.4969 12.6665 10.7475 12.5088 10.8051 12.2564L10.9308 11.7064H12.241L12.3724 12.2602C12.4311 12.514 12.6908 12.6682 12.9354 12.6078C13.1865 12.5479 13.3418 12.2951 13.282 12.0433C13.282 12.0433 12.5925 9.13895 12.5893 9.12852ZM11.1618 10.9145L11.4676 9.33042C11.4909 9.25157 11.5313 9.20829 11.5823 9.20805H11.5828C11.6339 9.20805 11.6733 9.24957 11.697 9.32836L12.015 10.9145H11.1618Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var generativeFillIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.75036 6.44783C9.74966 6.44816 9.74895 6.4485 9.74826 6.44883C9.73627 6.45461 9.72464 6.46114 9.71342 6.46839C9.67772 6.49148 9.64697 6.52144 9.62297 6.55653C9.59897 6.59162 9.5822 6.63114 9.57363 6.67278L9.16546 8.51161C9.07183 8.93457 8.87226 9.30086 8.59467 9.58502C8.307 9.87588 7.94184 10.078 7.54262 10.1673L5.73992 10.5837C5.68011 10.5978 5.62552 10.6286 5.5825 10.6725C5.53947 10.7164 5.50977 10.7716 5.49683 10.8317C5.4778 10.9158 5.49263 11.0041 5.53811 11.0774C5.58359 11.1507 5.65608 11.2032 5.73992 11.2235L7.54262 11.6398C7.94157 11.7297 8.3064 11.9321 8.59385 12.223C8.88111 12.5201 9.07892 12.8921 9.16463 13.2964L9.57281 15.1352C9.58566 15.1953 9.61533 15.2506 9.65837 15.2945C9.70141 15.3384 9.75604 15.3692 9.8159 15.3832C9.85739 15.3925 9.90032 15.3934 9.94216 15.3859C9.98401 15.3784 10.0239 15.3627 10.0596 15.3396C10.0953 15.3165 10.1261 15.2865 10.1501 15.2514C10.1741 15.2163 10.1909 15.1768 10.1994 15.1352L10.6076 13.2964C10.6936 12.8922 10.8913 12.5202 11.1784 12.223C11.4661 11.9321 11.8312 11.73 12.2304 11.6407L14.0323 11.2243C14.0921 11.2101 14.1467 11.1793 14.1897 11.1354C14.2328 11.0915 14.2625 11.0363 14.2754 10.9763C14.2942 10.8922 14.2793 10.8042 14.2338 10.7311C14.1883 10.658 14.116 10.6056 14.0323 10.5853L12.2304 10.1689C11.8165 10.0737 11.4568 9.87082 11.1784 9.58666C10.9 9.3025 10.7012 8.93621 10.6076 8.51326L10.1994 6.67442L10.2003 6.67278C10.1874 6.61265 10.1577 6.55741 10.1147 6.5135C10.0717 6.46959 10.017 6.43881 9.95716 6.42476C9.91567 6.41549 9.87275 6.41458 9.8309 6.42207C9.80297 6.42707 9.77589 6.43575 9.75036 6.44783ZM5.60543 6.6611C5.67496 6.50586 5.76868 6.36766 5.88282 6.25147C6.00582 6.12626 6.15327 6.02477 6.31969 5.95245C6.40107 5.91709 6.48699 5.8887 6.5768 5.86793L7.84485 5.57474C7.90466 5.5606 7.95925 5.52979 8.00227 5.48589C8.0453 5.44199 8.075 5.3868 8.08794 5.32671C8.10673 5.2427 8.09178 5.15466 8.04632 5.08155C8.00086 5.00844 7.92851 4.9561 7.84485 4.93579L6.5768 4.64342C6.48711 4.62265 6.40124 4.59424 6.31986 4.55883C6.15981 4.4892 6.01711 4.39253 5.89679 4.27384L5.88365 4.25906C5.76768 4.13917 5.67376 4.00081 5.60532 3.85039C5.60352 3.84643 5.60174 3.84247 5.59997 3.83849C5.59965 3.83776 5.59932 3.83702 5.599 3.83629C5.55866 3.74508 5.52764 3.64955 5.50668 3.55112L5.22006 2.25679C5.20721 2.19666 5.17753 2.14142 5.13449 2.09751C5.09145 2.0536 5.03682 2.02282 4.97696 2.00877C4.93547 1.9995 4.89255 1.99859 4.8507 2.00608C4.80885 2.01357 4.76891 2.02932 4.73321 2.05241C4.69752 2.07549 4.66677 2.10545 4.64277 2.14054C4.61877 2.17564 4.60199 2.21515 4.59342 2.25679L4.30598 3.55112C4.2848 3.64713 4.25533 3.73884 4.21832 3.82545C4.21659 3.82951 4.21484 3.83355 4.21307 3.83759C4.21117 3.84193 4.20925 3.84626 4.20731 3.85057C4.1406 3.99903 4.05144 4.13192 3.9438 4.2451L3.92901 4.25906C3.80613 4.3847 3.65885 4.4863 3.49287 4.55867C3.41147 4.59415 3.32558 4.62261 3.23586 4.64342L1.96781 4.93579C1.908 4.94993 1.85341 4.98074 1.81039 5.02464C1.76736 5.06853 1.73766 5.12372 1.72472 5.18381C1.70593 5.26783 1.72087 5.35587 1.76634 5.42898C1.8118 5.50209 1.88415 5.55443 1.96781 5.57474L3.23668 5.86793C3.32534 5.88778 3.41144 5.91608 3.49388 5.95224C3.65616 6.0234 3.80427 6.12497 3.92983 6.25229C4.0455 6.37215 4.13916 6.5104 4.20742 6.66065C4.20896 6.66404 4.21049 6.66743 4.212 6.67083C4.21245 6.67183 4.21289 6.67282 4.21333 6.67382C4.25385 6.76541 4.28499 6.86136 4.30598 6.96023L4.59342 8.25456C4.60627 8.31469 4.63595 8.36993 4.67899 8.41384C4.72203 8.45775 4.77666 8.48853 4.83652 8.50258C4.87801 8.51185 4.92093 8.51276 4.96278 8.50527C5.00463 8.49778 5.04457 8.48203 5.08027 8.45894C5.11596 8.43586 5.14671 8.40589 5.17071 8.3708C5.19471 8.33571 5.21149 8.2962 5.22006 8.25456L5.50668 6.96023C5.52807 6.86454 5.55746 6.77311 5.59423 6.68673C5.59621 6.68207 5.59822 6.67743 5.60025 6.6728C5.60196 6.66889 5.60369 6.66499 5.60543 6.6611ZM4.81743 5.25539C4.83831 5.27527 4.8589 5.2955 4.87919 5.31607L4.88426 5.32122L4.88929 5.32642C4.89483 5.33217 4.90035 5.33794 4.90585 5.34373C4.91439 5.3348 4.92299 5.32591 4.93167 5.31708C4.95215 5.29623 4.97294 5.27575 4.99403 5.25563C4.98275 5.24488 4.97155 5.23403 4.96044 5.22307L4.92931 5.19236L4.90691 5.16716L4.88529 5.18989L4.86048 5.21333C4.84627 5.22753 4.83192 5.24155 4.81743 5.25539ZM11.4568 4.85284C11.4697 4.91297 11.4993 4.96821 11.5424 5.01212C11.5854 5.05603 11.64 5.08681 11.6999 5.10086C11.7414 5.11013 11.7843 5.11104 11.8262 5.10355C11.868 5.09606 11.908 5.08031 11.9436 5.05723C11.9793 5.03414 12.0101 5.00418 12.0341 4.96909C12.0581 4.934 12.0749 4.89448 12.0834 4.85284L12.2723 4.00282C12.2786 3.97489 12.2861 3.94752 12.2947 3.92081C12.3116 3.86832 12.3328 3.81834 12.3582 3.77149C12.3604 3.7673 12.3627 3.76314 12.3651 3.75901C12.3947 3.70633 12.4296 3.65778 12.4691 3.61427C12.4759 3.60676 12.4829 3.59939 12.49 3.59218C12.5025 3.57951 12.5154 3.56725 12.5287 3.55544C12.5607 3.52718 12.595 3.50142 12.6316 3.47839C12.6337 3.47709 12.6357 3.47579 12.6378 3.4745C12.6881 3.44343 12.7425 3.41749 12.8003 3.39722C12.8301 3.38675 12.8608 3.3778 12.8924 3.37044L13.726 3.17826C13.7858 3.16412 13.8404 3.13331 13.8834 3.08942C13.9264 3.04552 13.9561 2.99033 13.9691 2.93024C13.9879 2.84622 13.9729 2.75818 13.9275 2.68507C13.882 2.61196 13.8097 2.55962 13.726 2.53931L12.8924 2.34713C12.8609 2.34001 12.8302 2.33125 12.8004 2.32087C12.7406 2.30001 12.6843 2.27265 12.6316 2.23908C12.6304 2.23834 12.6292 2.23759 12.6281 2.23684C12.5932 2.21434 12.5598 2.18909 12.5281 2.16118C12.5174 2.15174 12.5069 2.142 12.4965 2.13196C12.4874 2.12263 12.4785 2.1131 12.4699 2.10339C12.4301 2.05884 12.3953 2.0104 12.3659 1.95893C12.3637 1.95509 12.3615 1.95124 12.3594 1.94737C12.3328 1.89925 12.311 1.84859 12.2941 1.79606C12.2855 1.76941 12.2783 1.74228 12.2723 1.71475L12.0834 0.864735C12.0706 0.804605 12.0401 0.749364 11.9971 0.705452C11.954 0.661539 11.8994 0.630763 11.8395 0.61671C11.798 0.607443 11.7551 0.60653 11.7133 0.614022C11.6714 0.621514 11.6315 0.637262 11.5958 0.660348C11.5601 0.683433 11.5293 0.713395 11.5053 0.748486C11.4813 0.783577 11.4646 0.823094 11.456 0.864735L11.2671 1.71475C11.2612 1.7426 11.2538 1.77006 11.2452 1.79702C11.2281 1.8503 11.2058 1.90165 11.1786 1.95035C11.1771 1.9532 11.1755 1.95603 11.1738 1.95886C11.1444 2.01021 11.1096 2.05853 11.0698 2.10294C11.0653 2.10801 11.0607 2.11303 11.056 2.118C11.0416 2.13284 11.0267 2.1471 11.0113 2.16076C10.9791 2.18924 10.9449 2.21509 10.9089 2.2381C10.9063 2.23975 10.9037 2.24139 10.9011 2.24301C10.8505 2.27457 10.7965 2.30058 10.7401 2.32051C10.71 2.33114 10.6792 2.34004 10.6479 2.34713L9.81426 2.53931C9.75444 2.55346 9.69986 2.58426 9.65683 2.62816C9.61381 2.67206 9.58411 2.72725 9.57116 2.78734C9.55238 2.87136 9.56732 2.95939 9.61279 3.0325C9.65825 3.10561 9.7306 3.15795 9.81426 3.17826L10.6479 3.37044C10.6791 3.37746 10.7098 3.38626 10.7398 3.39678C10.797 3.41684 10.8518 3.44314 10.9031 3.47514C10.905 3.47631 10.9069 3.47748 10.9087 3.47867C10.945 3.50168 10.9795 3.52755 11.0119 3.55609C11.025 3.56769 11.0378 3.57972 11.0503 3.59218C11.0572 3.59943 11.0641 3.6068 11.0708 3.61428C11.1099 3.65804 11.1443 3.7056 11.1734 3.75612C11.1739 3.75707 11.1745 3.75802 11.175 3.75898C11.2043 3.81024 11.2282 3.86453 11.2462 3.92098C11.2548 3.9478 11.262 3.97512 11.2679 4.00282L11.4568 4.85284ZM9.88577 10.114C9.98828 10.2574 10.1019 10.3931 10.226 10.5198C10.365 10.6616 10.5155 10.7904 10.6759 10.9052C10.5176 11.0187 10.3685 11.1457 10.2304 11.2854L10.2248 11.291L10.2192 11.2968C10.0981 11.4222 9.98687 11.556 9.88622 11.6968C9.78535 11.5557 9.67386 11.4218 9.55242 11.2962L9.54735 11.2909L9.54223 11.2857C9.40368 11.1455 9.25406 11.018 9.0952 10.9042C9.25422 10.7904 9.40399 10.6628 9.54268 10.5226L9.54844 10.5167C9.67124 10.391 9.78388 10.2564 9.88577 10.114Z",
            fill: "var(--icon-color)"
        })
    });
};
function deforumIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.59543 1.02473C10.3515 0.892457 12.1067 1.293 13.6316 2.17401C15.1565 3.05502 16.3801 4.37552 17.1426 5.96296C17.9052 7.5504 18.1711 9.33094 17.9057 11.0719C17.8378 11.5176 17.4214 11.8238 16.9757 11.7559C16.53 11.6879 16.2238 11.2716 16.2917 10.8259C16.5076 9.40964 16.2913 7.96122 15.671 6.66988C15.0507 5.37854 14.0553 4.30435 12.8148 3.58767C11.5744 2.871 10.1466 2.54517 8.71805 2.65277C7.28951 2.76037 5.92664 3.29639 4.80755 4.19079C3.68846 5.08519 2.86518 6.29636 2.44532 7.66604C2.02545 9.03573 2.02852 10.5002 2.45412 11.8681C2.87972 13.236 3.70805 14.4438 4.83088 15.3335C5.95371 16.2232 7.31881 16.7535 8.74779 16.8551C9.1975 16.8871 9.53614 17.2775 9.50416 17.7273C9.47218 18.177 9.08169 18.5156 8.63198 18.4836C6.87534 18.3587 5.19722 17.7068 3.81693 16.6131C2.43664 15.5194 1.41836 14.0347 0.895176 12.3532C0.371988 10.6716 0.368218 8.87129 0.88436 7.18754C1.4005 5.50379 2.41255 4.0149 3.78825 2.91541C5.16395 1.81593 6.83932 1.157 8.59543 1.02473Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.27126 8.0076C8.25274 8.0183 8.08413 8.13336 8.08413 8.63071V10.8557C8.08413 11.353 8.25274 11.4681 8.27126 11.4788C8.28942 11.4893 8.47237 11.578 8.90204 11.3298C8.90213 11.3298 8.90196 11.3299 8.90204 11.3298L10.8218 10.2177C11.2514 9.9695 11.2679 9.76545 11.2679 9.74319C11.2679 9.72092 11.2523 9.51739 10.8226 9.26916L8.9023 8.15669C8.90216 8.15661 8.90243 8.15676 8.9023 8.15669C8.47273 7.90862 8.28942 7.9971 8.27126 8.0076ZM7.37248 6.45276C8.13901 6.00966 9.03867 6.16134 9.80075 6.60166L11.7211 7.71414C11.7212 7.71421 11.721 7.71406 11.7211 7.71414C12.4832 8.1546 13.0638 8.8584 13.0638 9.74319C13.0638 10.6279 12.4836 11.3315 11.7216 11.772C11.7214 11.7721 11.7217 11.7719 11.7216 11.772L9.80165 12.8842C9.03956 13.3245 8.13901 13.4767 7.37248 13.0336C6.6063 12.5907 6.28821 11.7357 6.28821 10.8557V8.63071C6.28821 7.75071 6.6063 6.89566 7.37248 6.45276Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.5681 19.5453V14.7862C19.5361 13.8913 18.3799 13.8906 18.3477 14.7862V19.5453C18.3796 20.4402 19.5359 20.4409 19.5681 19.5453ZM16.1182 15.2215C15.9075 14.5465 15.3357 14.112 14.6628 14.1149C13.9889 14.1175 13.4206 14.5569 13.215 15.2342C13.2104 15.2492 12.2626 19.3962 12.2626 19.3962C12.1801 19.7571 12.4051 20.1167 12.7651 20.1994C13.1254 20.2821 13.4837 20.0565 13.5662 19.6955L13.7459 18.9089H15.62L15.8079 19.701C15.8919 20.064 16.2634 20.2845 16.6132 20.1981C16.9725 20.1125 17.1945 19.7509 17.109 19.3907C17.109 19.3907 16.1228 15.2364 16.1182 15.2215ZM14.0761 17.7759L14.5135 15.5102C14.5468 15.3974 14.6046 15.3355 14.6776 15.3351H14.6782C14.7514 15.3351 14.8077 15.3945 14.8416 15.5072L15.2965 17.7759H14.0761Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function videoGptIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width !== null && width !== void 0 ? width : "20",
        height: height !== null && height !== void 0 ? height : "20",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5 11.452C13.1 12.052 13 13.052 12.2 13.452L6.6 16.752C5.1 17.652 3.3 17.052 2 14.952C2.4 17.752 5.5 19.552 8.3 17.952L13.1 15.152C15.3 13.952 15.2 10.752 13 9.552L7.5 6.452C7.7 5.652 8.6 5.252 9.4 5.652L15 8.952C16.5 9.852 17 11.652 15.9 13.652C17.9 12.452 18.5 8.752 15.4 6.952L10.4 4.052C8.2 2.752 5.6 4.252 5.7 6.752V13.352C4.9 13.652 4 13.052 4 12.152V5.652C4 3.952 5 2.352 7.7 2.352C5.1 1.152 2 3.152 2.1 6.352V12.152C2.1 14.652 4.8 16.152 6.9 14.852L12.5 11.452ZM10.6 10.352L7.5 8.652V12.152L10.6 10.352Z",
            fill: "var(--icon-color)"
        })
    });
}
function scriptToAdsGenerator(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "20",
        height: height !== null && height !== void 0 ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.9169 17.8331V14.288C17.8914 13.6214 16.9703 13.6209 16.9447 14.288V17.8331C16.9701 18.4998 17.8912 18.5003 17.9169 17.8331ZM15.1686 14.6122C15.0008 14.1094 14.5453 13.7858 14.0092 13.7879C13.4723 13.7899 13.0196 14.1172 12.8558 14.6217C12.8522 14.6329 12.0971 17.722 12.0971 17.722C12.0314 17.9909 12.2106 18.2588 12.4974 18.3204C12.7844 18.382 13.0699 18.2139 13.1356 17.945L13.2787 17.359H14.7717L14.9214 17.9491C14.9884 18.2195 15.2843 18.3838 15.563 18.3194C15.8492 18.2556 16.026 17.9863 15.9579 17.718C15.9579 17.718 15.1723 14.6233 15.1686 14.6122ZM13.5413 16.5151L13.8898 14.8272C13.9163 14.7432 13.9624 14.6971 14.0205 14.6969H14.021C14.0793 14.6969 14.1242 14.7411 14.1512 14.8251L14.5135 16.5151H13.5413Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.3335 4.16675C3.3335 2.78604 4.45278 1.66675 5.8335 1.66675H14.1668C15.5475 1.66675 16.6668 2.78604 16.6668 4.16675V11.8751C16.6668 12.3353 16.2937 12.7084 15.8335 12.7084C15.3733 12.7084 15.0002 12.3353 15.0002 11.8751V4.16675C15.0002 3.70651 14.6271 3.33341 14.1668 3.33341H5.8335C5.37326 3.33341 5.00016 3.70651 5.00016 4.16675V15.8334C5.00016 16.2937 5.37326 16.6667 5.8335 16.6667H10.0002C10.4604 16.6667 10.8335 17.0398 10.8335 17.5001C10.8335 17.9603 10.4604 18.3334 10.0002 18.3334H5.8335C4.45278 18.3334 3.3335 17.2141 3.3335 15.8334V4.16675Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.66699 6.66659C6.66699 6.20635 7.04009 5.83325 7.50033 5.83325H12.5003C12.9606 5.83325 13.3337 6.20635 13.3337 6.66659C13.3337 7.12682 12.9606 7.49992 12.5003 7.49992H7.50033C7.04009 7.49992 6.66699 7.12682 6.66699 6.66659Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.50033 5.83325C7.04009 5.83325 6.66699 6.20635 6.66699 6.66659C6.66699 7.12682 7.04009 7.49992 7.50033 7.49992H12.5003C12.9606 7.49992 13.3337 7.12682 13.3337 6.66659C13.3337 6.20635 12.9606 5.83325 12.5003 5.83325H7.50033Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.66699 9.99992C6.66699 9.53968 7.04009 9.16659 7.50033 9.16659H12.5003C12.9606 9.16659 13.3337 9.53968 13.3337 9.99992C13.3337 10.4602 12.9606 10.8333 12.5003 10.8333H7.50033C7.04009 10.8333 6.66699 10.4602 6.66699 9.99992Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.50033 9.16659C7.04009 9.16659 6.66699 9.53968 6.66699 9.99992C6.66699 10.4602 7.04009 10.8333 7.50033 10.8333H12.5003C12.9606 10.8333 13.3337 10.4602 13.3337 9.99992C13.3337 9.53968 12.9606 9.16659 12.5003 9.16659H7.50033Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.74268 13.3333C6.74268 12.873 7.11577 12.4999 7.57601 12.4999H10.076C10.5362 12.4999 10.9093 12.873 10.9093 13.3333C10.9093 13.7935 10.5362 14.1666 10.076 14.1666H7.57601C7.11577 14.1666 6.74268 13.7935 6.74268 13.3333Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.57601 12.4999C7.11577 12.4999 6.74268 12.873 6.74268 13.3333C6.74268 13.7935 7.11577 14.1666 7.57601 14.1666H10.076C10.5362 14.1666 10.9093 13.7935 10.9093 13.3333C10.9093 12.873 10.5362 12.4999 10.076 12.4999H7.57601Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function aiScriptGenerator(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "20",
        height: height !== null && height !== void 0 ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.3335 15.8333C3.3335 17.214 4.45278 18.3333 5.8335 18.3333H14.1668C15.5475 18.3333 16.6668 17.214 16.6668 15.8333V8.12492C16.6668 7.66468 16.2937 7.29159 15.8335 7.29159C15.3733 7.29159 15.0002 7.66468 15.0002 8.12492V15.8333C15.0002 16.2935 14.6271 16.6666 14.1668 16.6666H5.8335C5.37326 16.6666 5.00016 16.2935 5.00016 15.8333V4.16659C5.00016 3.70635 5.37326 3.33325 5.8335 3.33325H10.0002C10.4604 3.33325 10.8335 2.96016 10.8335 2.49992C10.8335 2.03968 10.4604 1.66659 10.0002 1.66659H5.8335C4.45278 1.66659 3.3335 2.78588 3.3335 4.16659V15.8333Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.66699 13.3334C6.66699 13.7937 7.04009 14.1667 7.50033 14.1667H12.5003C12.9606 14.1667 13.3337 13.7937 13.3337 13.3334C13.3337 12.8732 12.9606 12.5001 12.5003 12.5001H7.50033C7.04009 12.5001 6.66699 12.8732 6.66699 13.3334Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.50033 14.1667C7.04009 14.1667 6.66699 13.7937 6.66699 13.3334C6.66699 12.8732 7.04009 12.5001 7.50033 12.5001H12.5003C12.9606 12.5001 13.3337 12.8732 13.3337 13.3334C13.3337 13.7937 12.9606 14.1667 12.5003 14.1667H7.50033Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.66699 10.0001C6.66699 10.4603 7.04009 10.8334 7.50033 10.8334H12.5003C12.9606 10.8334 13.3337 10.4603 13.3337 10.0001C13.3337 9.53984 12.9606 9.16675 12.5003 9.16675H7.50033C7.04009 9.16675 6.66699 9.53984 6.66699 10.0001Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.50033 10.8334C7.04009 10.8334 6.66699 10.4603 6.66699 10.0001C6.66699 9.53984 7.04009 9.16675 7.50033 9.16675H12.5003C12.9606 9.16675 13.3337 9.53984 13.3337 10.0001C13.3337 10.4603 12.9606 10.8334 12.5003 10.8334H7.50033Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.74268 6.66675C6.74268 7.12699 7.11577 7.50008 7.57601 7.50008H10.076C10.5362 7.50008 10.9093 7.12699 10.9093 6.66675C10.9093 6.20651 10.5362 5.83342 10.076 5.83342H7.57601C7.11577 5.83342 6.74268 6.20651 6.74268 6.66675Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.57601 7.50008C7.11577 7.50008 6.74268 7.12699 6.74268 6.66675C6.74268 6.20651 7.11577 5.83342 7.57601 5.83342H10.076C10.5362 5.83342 10.9093 6.20651 10.9093 6.66675C10.9093 7.12699 10.5362 7.50008 10.076 7.50008H7.57601Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.8041 2.28321L12.3655 1.86736C12.2989 1.84758 12.2281 1.84713 12.1612 1.86606C12.0944 1.88499 12.0343 1.92252 11.988 1.97429C11.9564 2.01042 11.9323 2.05249 11.9171 2.09805C11.9018 2.1436 11.8959 2.19173 11.8994 2.23962C11.903 2.28751 11.9161 2.3342 11.9379 2.37699C11.9598 2.41977 11.9899 2.45778 12.0265 2.4888L13.1547 3.47397C13.3918 3.68046 13.5588 3.93427 13.647 4.20852L13.6528 4.23073C13.7395 4.51364 13.7439 4.82143 13.6591 5.12604L13.2632 6.54173C13.2448 6.6087 13.2459 6.6795 13.2661 6.74591C13.2864 6.81232 13.325 6.87163 13.3776 6.91697C13.4508 6.98105 13.5462 7.01384 13.6433 7.0083C13.7404 7.00276 13.8314 6.95932 13.8968 6.88734L14.8739 5.78757C15.0747 5.55845 15.3372 5.39198 15.63 5.30805C15.9268 5.22645 16.2406 5.22988 16.5355 5.31794L17.9746 5.73297C18.0412 5.75275 18.112 5.75321 18.1789 5.73427C18.2457 5.71534 18.3058 5.67781 18.3521 5.62605C18.3837 5.58991 18.4078 5.54784 18.423 5.50229C18.4382 5.45673 18.4442 5.40861 18.4406 5.36072C18.4371 5.31282 18.424 5.26613 18.4022 5.22335C18.3803 5.18056 18.3502 5.14255 18.3136 5.11153L17.185 4.12718C16.9418 3.91425 16.7714 3.65325 16.6856 3.37079C16.5997 3.08832 16.5954 2.78053 16.6806 2.47511L17.0757 1.05897C17.094 0.991999 17.093 0.921204 17.0727 0.854791C17.0525 0.788379 17.0138 0.729068 16.9612 0.683732C16.888 0.619655 16.7926 0.586858 16.6956 0.5924C16.5985 0.597942 16.5074 0.641379 16.442 0.713364L15.4662 1.81277C15.2612 2.04334 15.0076 2.20409 14.7319 2.28725L14.7101 2.29228C14.4132 2.37428 14.0993 2.37113 13.8041 2.28321Z",
                fill: "#85889E"
            })
        ]
    });
}
function productUrlToAdsIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "20",
        height: height !== null && height !== void 0 ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.90325 10.1077C8.16863 10.4797 8.5203 10.7777 8.93442 10.9815C9.34853 11.1853 9.8154 11.2901 10.3034 11.2888C10.7913 11.2876 11.2889 11.1803 11.7625 10.9742C12.236 10.7682 12.6744 10.4681 13.0479 10.0945L15.2585 7.88402C15.9312 7.19081 16.3412 6.29879 16.4 5.40008C16.4589 4.50138 16.162 3.66789 15.5732 3.07913C14.9845 2.49038 14.151 2.19346 13.2523 2.25234C12.3536 2.31122 11.4616 2.72118 10.7684 3.39393L9.50151 4.65443",
                stroke: "var(--icon-color)",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.749 8.53223C10.4837 8.16024 10.132 7.86225 9.71787 7.65845C9.30376 7.45466 8.83689 7.34983 8.34893 7.35108C7.86097 7.35233 7.36335 7.45962 6.8898 7.66569C6.41625 7.87176 5.97785 8.17177 5.60435 8.54539L3.39384 10.7559C2.7211 11.4491 2.31114 12.3411 2.25226 13.2398C2.19338 14.1385 2.49029 14.972 3.07904 15.5608C3.6678 16.1495 4.50129 16.4465 5.4 16.3876C6.2987 16.3287 7.19072 15.9187 7.88393 15.246L9.14392 13.986",
                stroke: "var(--icon-color)",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.4275 13.0985C15.2502 12.5302 14.7687 12.1644 14.2022 12.1668C13.6348 12.169 13.1563 12.5389 12.9832 13.1092C12.9794 13.1218 12.1813 16.6132 12.1813 16.6132C12.1119 16.9171 12.3013 17.2199 12.6044 17.2895C12.9077 17.3591 13.2095 17.1692 13.2789 16.8653L13.4302 16.203H15.008L15.1663 16.8699C15.237 17.1755 15.5498 17.3611 15.8443 17.2884C16.1468 17.2163 16.3337 16.9119 16.2617 16.6086C16.2617 16.6086 15.4314 13.111 15.4275 13.0985ZM13.7082 15.2492L14.0765 13.3416C14.1045 13.2466 14.1532 13.1945 14.2146 13.1942H14.2152C14.2768 13.1942 14.3241 13.2442 14.3527 13.3391L14.7357 15.2492H13.7082ZM18.3321 16.7389V12.7321C18.3052 11.9786 17.3317 11.9781 17.3046 12.7321V16.7389C17.3315 17.4924 18.3049 17.493 18.3321 16.7389Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function aiAdsGenratorIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "20",
        height: height !== null && height !== void 0 ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.9887 2.40454L13.55 1.9887C13.4835 1.96892 13.4126 1.96846 13.3458 1.9874C13.279 2.00633 13.2189 2.04386 13.1726 2.09562C13.1409 2.13176 13.1168 2.17383 13.1016 2.21938C13.0864 2.26494 13.0804 2.31306 13.084 2.36095C13.0876 2.40884 13.1007 2.45554 13.1225 2.49832C13.1443 2.54111 13.1744 2.57912 13.2111 2.61014L14.3392 3.5953C14.5764 3.8018 14.7434 4.05561 14.8316 4.32985L14.8374 4.35207C14.924 4.63498 14.9284 4.94277 14.8437 5.24738L14.4477 6.66307C14.4294 6.73004 14.4304 6.80084 14.4507 6.86725C14.4709 6.93366 14.5096 6.99297 14.5622 7.03831C14.6354 7.10238 14.7308 7.13518 14.8279 7.12964C14.9249 7.1241 15.016 7.08066 15.0814 7.00867L16.0585 5.9089C16.2592 5.67978 16.5217 5.51331 16.8146 5.42939C17.1114 5.34779 17.4251 5.35122 17.7201 5.43928L19.1592 5.85431C19.2258 5.87409 19.2966 5.87454 19.3634 5.85561C19.4303 5.83668 19.4903 5.79915 19.5367 5.74738C19.5683 5.71125 19.5924 5.66918 19.6076 5.62362C19.6228 5.57807 19.6288 5.52994 19.6252 5.48205C19.6216 5.43416 19.6085 5.38747 19.5867 5.34468C19.5649 5.3019 19.5348 5.26389 19.4981 5.23287L18.3696 4.24852C18.1264 4.03558 17.9559 3.77459 17.8701 3.49213C17.7843 3.20966 17.7799 2.90187 17.8651 2.59644L18.2603 1.18031C18.2786 1.11334 18.2776 1.04254 18.2573 0.976129C18.237 0.909716 18.1984 0.850406 18.1458 0.80507C18.0726 0.740993 17.9772 0.708196 17.8801 0.713738C17.783 0.71928 17.692 0.762717 17.6266 0.834702L16.6508 1.9341C16.4457 2.16468 16.1922 2.32543 15.9164 2.40859L15.8947 2.41362C15.5978 2.49562 15.2839 2.49247 14.9887 2.40454Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.33464 4.40527C2.93534 4.40527 2.41797 4.82792 2.41797 5.6078V15.3704C2.41797 16.1503 2.93534 16.573 3.33464 16.573H16.668C17.0673 16.573 17.5846 16.1503 17.5846 15.3704L17.5846 9.23563C17.5846 8.82142 17.9204 8.48563 18.3346 8.48563C18.7488 8.48563 19.0846 8.82142 19.0846 9.23563L19.0846 15.3704C19.0846 16.7473 18.1096 18.073 16.668 18.073H3.33464C1.89298 18.073 0.917969 16.7473 0.917969 15.3704V5.6078C0.917969 4.23098 1.89298 2.90527 3.33464 2.90527H10.8267C11.2409 2.90527 11.5767 3.24106 11.5767 3.65527C11.5767 4.06949 11.2409 4.40527 10.8267 4.40527H3.33464Z",
                fill: "var(--icon-color)",
                stroke: "var(--icon-color)",
                strokeWidth: "0.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.1934 13.6812C10.7402 13.6812 10.4746 13.4077 10.4746 12.9312V8.79443C10.4746 8.31787 10.7402 8.04443 11.1934 8.04443H12.7637C14.4668 8.04443 15.4668 9.03271 15.4668 10.8296C15.4668 12.6304 14.4629 13.6812 12.7637 13.6812H11.1934ZM11.9082 12.5249H12.5762C13.5098 12.5249 14.0098 11.9585 14.0098 10.8335C14.0098 9.7749 13.4824 9.20068 12.5762 9.20068H11.9082V12.5249Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.26367 13.7671C4.81055 13.7671 4.5332 13.5093 4.5332 13.0835C4.5332 12.9624 4.57227 12.7866 4.63477 12.6147L6.02539 8.79443C6.23242 8.22021 6.58008 7.9585 7.13867 7.9585C7.72852 7.9585 8.07227 8.2085 8.28711 8.79443L9.68945 12.6147C9.75586 12.7983 9.7832 12.9312 9.7832 13.0796C9.7832 13.4819 9.48242 13.7671 9.06445 13.7671C8.65039 13.7671 8.43555 13.5796 8.31055 13.1187L8.11914 12.4937H6.18945L5.99805 13.0952C5.86133 13.5718 5.64648 13.7671 5.26367 13.7671ZM6.47461 11.4116H7.80664L7.14648 9.23975H7.11523L6.47461 11.4116Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function galleryIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.1871 7.29292C17.455 7.56075 17.5485 7.95692 17.4287 8.31625L15.3087 14.6763C15.2092 14.9749 14.9749 15.2092 14.6763 15.3087L8.31625 17.4287C7.95692 17.5485 7.56075 17.455 7.29292 17.1871C7.02509 16.9193 6.93157 16.5231 7.05134 16.1638L9.17134 9.8038C9.27088 9.50519 9.50519 9.27088 9.8038 9.17134L16.1638 7.05134C16.5231 6.93157 16.9193 7.02509 17.1871 7.29292ZM10.9106 10.9106L9.58117 14.8989L13.5695 13.5695L14.8989 9.58117L10.9106 10.9106Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.9505 1H12.0495C13.8768 0.999992 15.3162 0.999985 16.4701 1.10456C17.6481 1.21133 18.6263 1.43338 19.5 1.93782C20.5641 2.5522 21.4478 3.43587 22.0622 4.5C22.5666 5.37372 22.7887 6.35191 22.8954 7.52993C23 8.6838 23 10.1232 23 11.9505V12.0495C23 13.8768 23 15.3162 22.8954 16.4701C22.7887 17.6481 22.5666 18.6263 22.0622 19.5C21.4478 20.5641 20.5641 21.4478 19.5 22.0622C18.6263 22.5666 17.6481 22.7887 16.4701 22.8954C15.3162 23 13.8768 23 12.0495 23H11.9505C10.1232 23 8.6838 23 7.52993 22.8954C6.35191 22.7887 5.37372 22.5666 4.5 22.0622C3.43587 21.4478 2.5522 20.5641 1.93782 19.5C1.43338 18.6263 1.21133 17.6481 1.10456 16.4701C0.999985 15.3162 0.999992 13.8768 1 12.0495V11.9505C0.999992 10.1232 0.999985 8.68379 1.10456 7.52993C1.21133 6.35191 1.43338 5.37372 1.93782 4.5C2.5522 3.43587 3.43587 2.5522 4.5 1.93782C5.37372 1.43338 6.35191 1.21133 7.52993 1.10456C8.68379 0.999985 10.1232 0.999992 11.9505 1ZM7.71045 3.0964C6.67116 3.19059 6.01859 3.37047 5.5 3.66987C4.7399 4.10872 4.10872 4.7399 3.66987 5.5C3.37047 6.01859 3.19059 6.67116 3.0964 7.71045C3.00096 8.7635 3 10.1124 3 12C3 13.8876 3.00096 15.2365 3.0964 16.2895C3.19059 17.3288 3.37047 17.9814 3.66987 18.5C4.10872 19.2601 4.7399 19.8913 5.5 20.3301C6.01859 20.6295 6.67116 20.8094 7.71045 20.9036C8.7635 20.999 10.1124 21 12 21C13.8876 21 15.2365 20.999 16.2895 20.9036C17.3288 20.8094 17.9814 20.6295 18.5 20.3301C19.2601 19.8913 19.8913 19.2601 20.3301 18.5C20.6295 17.9814 20.8094 17.3288 20.9036 16.2895C20.999 15.2365 21 13.8876 21 12C21 10.1124 20.999 8.7635 20.9036 7.71045C20.8094 6.67116 20.6295 6.01859 20.3301 5.5C19.8913 4.7399 19.2601 4.10872 18.5 3.66987C17.9814 3.37047 17.3288 3.19059 16.2895 3.0964C15.2365 3.00096 13.8876 3 12 3C10.1124 3 8.7635 3.00096 7.71045 3.0964Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function templatesIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_20309_11780)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.60317 6.60015C2.38001 6.47413 2.14874 6.36061 1.91031 6.26054C1.81619 6.22105 1.72095 6.18364 1.62466 6.14839C1.40832 6.06919 1.40832 5.55945 1.62466 5.48025C1.72095 5.445 1.81619 5.4076 1.91031 5.3681C2.14874 5.26803 2.38001 5.15451 2.60317 5.02849C2.63692 5.00943 2.67049 4.99008 2.70387 4.97045C3.67686 4.39823 4.48953 3.58555 5.06176 2.61256C5.08139 2.57918 5.10073 2.54562 5.1198 2.51186C5.24582 2.2887 5.35934 2.05744 5.4594 1.819C5.4989 1.72488 5.5363 1.62965 5.57156 1.53335C5.65075 1.31701 6.1605 1.31701 6.2397 1.53335C6.27495 1.62965 6.31235 1.72488 6.35185 1.819C6.45192 2.05743 6.56543 2.2887 6.69146 2.51186C6.71052 2.54562 6.72987 2.57918 6.7495 2.61256C7.32172 3.58555 8.1344 4.39823 9.10738 4.97045C9.14076 4.99008 9.17433 5.00943 9.20808 5.02849C9.43124 5.15451 9.66251 5.26803 9.90094 5.3681C9.99506 5.4076 10.0903 5.445 10.1866 5.48025C10.4029 5.55945 10.4029 6.06919 10.1866 6.14839C10.0903 6.18364 9.99506 6.22105 9.90094 6.26054C9.66251 6.36061 9.43124 6.47413 9.20808 6.60015C9.17433 6.61921 9.14076 6.63856 9.10738 6.65819C8.1344 7.23041 7.32172 8.04309 6.7495 9.01608C6.72987 9.04946 6.71052 9.08302 6.69146 9.11678C6.56543 9.33994 6.45192 9.57121 6.35185 9.80964C6.31235 9.90376 6.27495 9.99899 6.2397 10.0953C6.1605 10.3116 5.65075 10.3116 5.57156 10.0953C5.5363 9.99899 5.4989 9.90376 5.4594 9.80964C5.35934 9.57121 5.24582 9.33994 5.1198 9.11678C5.10073 9.08302 5.08139 9.04946 5.06176 9.01608C4.48953 8.04309 3.67686 7.23041 2.70387 6.65819C2.67049 6.63856 2.63692 6.61921 2.60317 6.60015ZM4.36447 5.6493C4.25812 5.73282 4.25812 5.89582 4.36447 5.97934C4.87642 6.38137 5.33858 6.84353 5.74061 7.35548C5.82413 7.46183 5.98712 7.46183 6.07064 7.35548C6.47267 6.84353 6.93483 6.38137 7.44678 5.97934C7.55314 5.89582 7.55314 5.73282 7.44678 5.6493C6.93483 5.24728 6.47267 4.78511 6.07064 4.27316C5.98712 4.16681 5.82413 4.16681 5.74061 4.27316C5.33858 4.78511 4.87642 5.24728 4.36447 5.6493ZM12.5809 9.85799C12.2853 10.0535 11.9698 10.2216 11.6379 10.3585C11.4249 10.4464 11.4249 10.9912 11.6379 11.079C11.9698 11.216 12.2853 11.384 12.5809 11.5795C13.2033 11.9913 13.7371 12.5251 14.1489 13.1476C14.3445 13.4431 14.5125 13.7587 14.6494 14.0906C14.7373 14.3036 15.2821 14.3036 15.37 14.0906C15.5069 13.7587 15.6749 13.4431 15.8705 13.1476C16.2823 12.5252 16.8161 11.9913 17.4385 11.5795C17.7341 11.384 18.0496 11.216 18.3815 11.079C18.5945 10.9912 18.5945 10.4464 18.3815 10.3585C18.0496 10.2216 17.7341 10.0535 17.4385 9.85799C16.8161 9.44618 16.2823 8.91236 15.8705 8.28992C15.6749 7.99438 15.5069 7.67885 15.37 7.34692C15.2821 7.13395 14.7373 7.13395 14.6494 7.34693C14.5125 7.67885 14.3445 7.99438 14.1489 8.28992C13.7371 8.91236 13.2033 9.44619 12.5809 9.85799ZM14.1327 10.5597C14.0362 10.6432 14.0362 10.7943 14.1327 10.8778C14.3889 11.0996 14.6288 11.3396 14.8506 11.5958C14.9341 11.6923 15.0853 11.6923 15.1688 11.5958C15.3906 11.3396 15.6305 11.0996 15.8867 10.8778C15.9832 10.7943 15.9832 10.6432 15.8867 10.5597C15.6305 10.3379 15.3906 10.0979 15.1688 9.84172C15.0853 9.74526 14.9341 9.74526 14.8506 9.84172C14.6288 10.0979 14.3889 10.3379 14.1327 10.5597ZM7.47416 17.6745C7.4254 17.6133 7.37505 17.5533 7.32317 17.4948C7.20514 17.3616 7.07917 17.2356 6.94599 17.1176C6.88744 17.0657 6.8275 17.0154 6.76623 16.9666C6.41771 16.6893 6.02605 16.4636 5.60255 16.3008C5.55269 16.2816 5.50238 16.2633 5.45165 16.2459C5.3209 16.2011 5.3209 15.9058 5.45165 15.861C5.50238 15.8436 5.55269 15.8253 5.60255 15.8061C6.02605 15.6433 6.41771 15.4176 6.76623 15.1403C6.82751 15.0915 6.88745 15.0412 6.94599 14.9893C7.07917 14.8713 7.20514 14.7453 7.32317 14.6121C7.37506 14.5536 7.42541 14.4936 7.47416 14.4324C7.75148 14.0838 7.97718 13.6922 8.13998 13.2687C8.15915 13.2188 8.17745 13.1685 8.19485 13.1178C8.23971 12.987 8.53492 12.987 8.57979 13.1178C8.59719 13.1685 8.61549 13.2188 8.63466 13.2687C8.79746 13.6922 9.02316 14.0838 9.30048 14.4324C9.34923 14.4936 9.39958 14.5536 9.45147 14.6121C9.5695 14.7453 9.69547 14.8713 9.82865 14.9893C9.88719 15.0412 9.94713 15.0915 10.0084 15.1403C10.3569 15.4176 10.7486 15.6433 11.1721 15.8061C11.222 15.8253 11.2723 15.8436 11.323 15.861C11.4537 15.9058 11.4537 16.2011 11.323 16.2459C11.2723 16.2633 11.222 16.2816 11.1721 16.3008C10.7486 16.4636 10.3569 16.6893 10.0084 16.9666C9.94713 17.0154 9.88719 17.0657 9.82865 17.1176C9.69547 17.2356 9.5695 17.3616 9.45147 17.4948C9.39958 17.5533 9.34923 17.6133 9.30048 17.6745C9.02316 18.0231 8.79746 18.4147 8.63466 18.8382C8.61549 18.8881 8.59719 18.9384 8.57979 18.9891C8.53492 19.1199 8.23971 19.1199 8.19485 18.9891C8.17745 18.9384 8.15915 18.8881 8.13998 18.8382C7.97718 18.4147 7.75148 18.0231 7.47416 17.6745Z",
                    fill: "var(--icon-color)"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_20309_11780",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
function closeIcon() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                filter: "url(#filter0_d_14526_87645)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.06511 6.17059C7.54209 5.64756 6.6941 5.64756 6.17108 6.17059C5.64805 6.69361 5.64805 7.5416 6.17108 8.06462L13.1061 14.9996L6.17108 21.9346C5.64805 22.4576 5.64805 23.3056 6.17108 23.8287C6.6941 24.3517 7.54209 24.3517 8.06511 23.8287L15.0001 16.8937L21.9351 23.8287C22.4581 24.3517 23.3061 24.3517 23.8291 23.8287C24.3522 23.3056 24.3522 22.4576 23.8291 21.9346L16.8941 14.9996L23.8291 8.06462C24.3522 7.5416 24.3522 6.69361 23.8291 6.17059C23.3061 5.64756 22.4581 5.64756 21.9351 6.17059L15.0001 13.1056L8.06511 6.17059Z",
                    fill: "var(--icon-color)"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    id: "filter0_d_14526_87645",
                    x: "-3",
                    y: "-3",
                    width: "36",
                    height: "36",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {}),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_14526_87645"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_14526_87645",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
}
function newCloseIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width ? width : "24",
        height: height ? height : "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.07107 19.2117L19.2132 5.06956M5.07107 5.06956L19.2132 19.2117",
            stroke: "var(--icon-color)",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}
function moreIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0555 20.8056C12.0555 21.875 12.9305 22.75 14 22.75C15.0694 22.75 15.9444 21.875 15.9444 20.8056C15.9444 19.7361 15.0694 18.8611 14 18.8611C12.9305 18.8611 12.0555 19.7361 12.0555 20.8056Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0555 7.19447C12.0555 8.26392 12.9305 9.13892 14 9.13892C15.0694 9.13892 15.9444 8.26392 15.9444 7.19447C15.9444 6.12503 15.0694 5.25003 14 5.25003C12.9305 5.25003 12.0555 6.12503 12.0555 7.19447Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0555 14C12.0555 15.0695 12.9305 15.9445 14 15.9445C15.0694 15.9445 15.9444 15.0695 15.9444 14C15.9444 12.9306 15.0694 12.0556 14 12.0556C12.9305 12.0556 12.0555 12.9306 12.0555 14Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function globusIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9.75",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.9055 12C15.9055 14.8199 15.3972 17.3368 14.6063 19.1206C14.2105 20.0135 13.7585 20.6895 13.2945 21.1322C12.8344 21.5711 12.3982 21.75 12.0001 21.75C11.602 21.75 11.1659 21.5711 10.7057 21.1322C10.2417 20.6895 9.78977 20.0135 9.39389 19.1206C8.60299 17.3368 8.09473 14.8199 8.09473 12C8.09473 9.18009 8.60299 6.6632 9.39389 4.87936C9.78977 3.98647 10.2417 3.31043 10.7057 2.86781C11.1659 2.42885 11.602 2.25 12.0001 2.25C12.3982 2.25 12.8344 2.42885 13.2945 2.86781C13.7585 3.31043 14.2105 3.98647 14.6063 4.87936C15.3972 6.6632 15.9055 9.18009 15.9055 12Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.60742 12H21.3933",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            })
        ]
    });
}
function restyleIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.98969 18.1324V13.5897C6.9592 12.7354 5.85553 12.7348 5.82478 13.5897V18.1324C5.85527 18.9867 6.95894 18.9874 6.98969 18.1324ZM3.69661 14.0052C3.49555 13.3609 2.94974 12.9462 2.30739 12.9488C1.66411 12.9514 1.12165 13.3708 0.925378 14.0173C0.921038 14.0317 0.0162514 17.9901 0.0162514 17.9901C-0.0624506 18.3346 0.152305 18.6779 0.4959 18.7568C0.839814 18.8358 1.18191 18.6204 1.26061 18.2759L1.43215 17.525H3.22105L3.40044 18.2811C3.48064 18.6276 3.83522 18.838 4.16914 18.7556C4.51207 18.6738 4.72398 18.3287 4.64237 17.9849C4.64237 17.9849 3.70105 14.0194 3.69661 14.0052ZM1.74733 16.4435L2.16487 14.2807C2.19666 14.1731 2.25183 14.114 2.32149 14.1136H2.32212C2.39197 14.1136 2.44567 14.1703 2.47809 14.2779L2.91224 16.4435H1.74733Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.09102 5.97377C2.09102 4.84207 2.32319 4.38133 2.61526 4.13847C2.95927 3.85241 3.64315 3.63991 5.08224 3.63991H10.9399C12.3789 3.63991 13.0628 3.85241 13.4068 4.13847C13.6989 4.38133 13.9311 4.84207 13.9311 5.97377V12.463C13.9311 13.5926 13.6976 14.0542 13.404 14.2978C13.0584 14.5847 12.3735 14.7969 10.9399 14.7969H8.19999V16.6184H10.9399C12.4258 16.6184 13.6919 16.426 14.5674 15.6995C15.4949 14.9296 15.7526 13.7689 15.7526 12.463V5.97377C15.7526 4.67007 15.4982 3.50848 14.5715 2.73788C13.6967 2.01047 12.4296 1.81836 10.9399 1.81836H5.08224C3.59251 1.81836 2.32539 2.01047 1.45062 2.73788C0.523893 3.50848 0.26947 4.67007 0.26947 5.97377V11.8238C0.704339 11.2711 1.34905 10.9101 2.09102 10.8648V5.97377Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.2383 5.97209C17.2381 5.97224 17.2385 5.97193 17.2383 5.97209L15.6856 7.21768V11.213L17.2395 12.4596L17.2413 12.461C17.4653 12.6419 17.5852 12.6583 17.6261 12.6567C17.6524 12.6212 17.7279 12.49 17.7279 12.1274V6.31093C17.7279 5.9443 17.6507 5.81364 17.6247 5.7794C17.5848 5.77707 17.4644 5.79161 17.2383 5.97209ZM17.64 5.78192C17.64 5.782 17.639 5.78177 17.6371 5.78099ZM17.6425 12.6542C17.6425 12.6543 17.6415 12.6547 17.6393 12.6552ZM18.3252 4.35507C18.9698 4.7401 19.1963 5.54266 19.1963 6.31093V12.1274C19.1963 12.8949 18.9702 13.6992 18.3237 14.0832C17.6636 14.4754 16.9333 14.2156 16.3734 13.764C16.3731 13.7637 16.3737 13.7642 16.3734 13.764L14.5188 12.2762C14.3293 12.1241 14.2172 11.8816 14.2172 11.6236V6.80709C14.2172 6.54908 14.3293 6.3066 14.5188 6.15456L16.3742 4.6661C16.9354 4.21779 17.6668 3.96186 18.3252 4.35507Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function photoAiIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.9019 7.15768C6.77009 7.15768 7.4739 6.45387 7.4739 5.58568C7.4739 4.71748 6.77009 4.01367 5.9019 4.01367C5.03371 4.01367 4.3299 4.71748 4.3299 5.58568C4.3299 6.45387 5.03371 7.15768 5.9019 7.15768Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.3537 18.7797V13.7827C19.3202 12.843 18.1061 12.8423 18.0723 13.7827V18.7797C18.1058 19.7194 19.3199 19.7201 19.3537 18.7797ZM15.7313 14.2397C15.5101 13.531 14.9098 13.0748 14.2032 13.0778C13.4956 13.0806 12.8989 13.5419 12.683 14.2531C12.6782 14.2689 11.6829 18.6231 11.6829 18.6231C11.5963 19.0021 11.8326 19.3797 12.2105 19.4665C12.5888 19.5534 12.9651 19.3165 13.0517 18.9375L13.2404 18.1115H15.2082L15.4055 18.9432C15.4937 19.3244 15.8838 19.5559 16.2511 19.4652C16.6283 19.3752 16.8614 18.9956 16.7717 18.6174C16.7717 18.6174 15.7362 14.2554 15.7313 14.2397ZM13.5871 16.9219L14.0464 14.5428C14.0814 14.4244 14.1421 14.3594 14.2187 14.359H14.2194C14.2962 14.359 14.3553 14.4214 14.3909 14.5397L14.8685 16.9219H13.5871Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.26483 2.13373C3.45154 0.947031 5.20653 0.515137 7.39247 0.515137H12.4341C14.6201 0.515137 16.3751 0.947031 17.5618 2.13373C18.7485 3.32043 19.1804 5.07543 19.1804 7.26137V9.81863V9.8219V11.8049C19.0841 11.7889 18.9855 11.7807 18.8852 11.7806C18.3049 11.7805 17.7815 12.0558 17.4503 12.5123C17.4513 12.4436 17.4518 12.3738 17.4518 12.303V10.2107L16.3989 9.2844L16.3989 9.28438C16.0811 9.00476 15.5294 9.00476 15.2116 9.28438L15.2113 9.28464L11.7757 12.3047L11.7754 12.3049C10.8047 13.1587 9.2753 13.1586 8.30474 12.3047L8.29739 12.2982L8.29743 12.2982L8.02919 12.0567C7.74572 11.81 7.24426 11.7763 6.9124 12.0041L6.91214 12.0043L2.84055 14.8045C2.79801 14.8337 2.75378 14.8586 2.70838 14.8793C2.89654 15.4498 3.1599 15.8812 3.48712 16.2084C4.19104 16.9123 5.37702 17.3207 7.39247 17.3207H10.65L10.3807 18.498C10.3383 18.6833 10.3252 18.8687 10.3382 19.0493H7.39247C5.20653 19.0493 3.45154 18.6174 2.26483 17.4307C1.07813 16.244 0.64624 14.489 0.64624 12.303V7.26137C0.64624 5.07543 1.07813 3.32043 2.26483 2.13373ZM17.4518 7.26137V7.912C16.4788 7.13343 15.0116 7.15822 14.0701 7.98636L14.0697 7.98663L10.6342 11.0067L10.6339 11.0069C10.3171 11.2857 9.76782 11.2865 9.44956 11.0095L9.18134 10.7681L9.18137 10.768L9.17409 10.7616C8.28428 9.97855 6.90511 9.91176 5.93314 10.5797L5.93289 10.5799L2.39337 13.0141C2.38107 12.7893 2.37481 12.5525 2.37481 12.303V7.26137C2.37481 5.24592 2.78319 4.05994 3.48712 3.35602C4.19104 2.65209 5.37702 2.24371 7.39247 2.24371H12.4341C14.4496 2.24371 15.6356 2.65209 16.3395 3.35602C17.0434 4.05994 17.4518 5.24592 17.4518 7.26137Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function textToImageIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.77701 15.6575C5.26551 15.7092 5.63622 16.1212 5.63622 16.6124V17.9263C5.63622 18.4515 6.2208 18.7649 6.65777 18.4738L6.65827 18.4735L10.6039 15.8489C10.7615 15.7441 10.9465 15.6882 11.1358 15.6882H14.6296C15.9584 15.6882 17.0446 15.2464 17.7981 14.4929C18.5515 13.7395 18.9934 12.6532 18.9934 11.3245V5.7689C18.9934 4.44014 18.5515 3.35385 17.7981 2.60042C17.0446 1.84698 15.9584 1.40514 14.6296 1.40514H5.37034C4.04158 1.40514 2.9553 1.84698 2.20186 2.60042C1.44843 3.35385 1.00659 4.44014 1.00659 5.7689V11.3245C1.00659 12.6532 1.44843 13.7395 2.20186 14.4929C2.84198 15.1331 3.71811 15.5454 4.77701 15.6575Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.92063",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.2591 7.68555L14.9384 10.8849C13.5176 11.937 11.6316 12.1177 10.0369 11.3545V11.3545C8.50731 10.6225 6.70427 10.7568 5.30007 11.7073L1.6665 14.167",
                stroke: "var(--icon-color)",
                strokeWidth: "1.92063",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.101 7.49099C13.059 7.49099 13.8357 6.71432 13.8357 5.75624C13.8357 4.79816 13.059 4.02148 12.101 4.02148C11.1429 4.02148 10.3662 4.79816 10.3662 5.75624C10.3662 6.71432 11.1429 7.49099 12.101 7.49099Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function generateIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.7488 8.343L11.259 10.6415C11.3761 11.1702 11.6245 11.6281 11.9725 11.9833C12.3205 12.3385 12.7702 12.5921 13.2876 12.7111L15.5399 13.2316C15.6445 13.257 15.7349 13.3224 15.7918 13.4138C15.8486 13.5052 15.8673 13.6153 15.8438 13.7203C15.8276 13.7954 15.7905 13.8644 15.7367 13.9193C15.6829 13.9741 15.6147 14.0126 15.5399 14.0303L13.2876 14.5508C12.7885 14.6624 12.3321 14.9151 11.9725 15.2787C11.6137 15.6503 11.3665 16.1152 11.259 16.6204L10.7488 18.9189C10.7381 18.971 10.7171 19.0204 10.6871 19.0643C10.6571 19.1081 10.6187 19.1456 10.5741 19.1744C10.5294 19.2033 10.4795 19.223 10.4272 19.2323C10.3749 19.2417 10.3213 19.2406 10.2694 19.229C10.1946 19.2114 10.1263 19.1729 10.0725 19.1181C10.0187 19.0632 9.98158 18.9941 9.96552 18.9189L9.4553 16.6204C9.34816 16.115 9.1009 15.6501 8.74182 15.2787C8.38251 14.9151 7.92648 14.6621 7.42778 14.5498L5.17441 14.0293C5.06961 14.0039 4.979 13.9383 4.92215 13.8467C4.86529 13.7551 4.84676 13.6448 4.87054 13.5396C4.88672 13.4645 4.92385 13.3955 4.97763 13.3406C5.03141 13.2858 5.09964 13.2473 5.17441 13.2296L7.42778 12.7091C7.92681 12.5975 8.38327 12.3448 8.74285 11.9812C9.08984 11.626 9.3393 11.1682 9.45633 10.6395L9.96655 8.34095C9.97726 8.2889 9.99823 8.2395 10.0282 8.19564C10.0582 8.15177 10.0967 8.11432 10.1413 8.08546C10.1859 8.0566 10.2358 8.03692 10.2881 8.02755C10.3404 8.01819 10.3941 8.01933 10.446 8.03092C10.5208 8.04848 10.5891 8.08695 10.6429 8.14184C10.6967 8.19673 10.7338 8.26578 10.7498 8.34095L10.7488 8.343ZM13.1038 1.08089L13.3399 2.14341C13.3823 2.34019 13.4795 2.52098 13.6202 2.66492C13.7588 2.7994 13.9241 2.89077 14.115 2.93389L15.157 3.17411C15.2616 3.1995 15.352 3.26492 15.4088 3.35631C15.4657 3.4477 15.4843 3.55774 15.4609 3.66277C15.4447 3.73788 15.4076 3.80687 15.3538 3.86174C15.3 3.91661 15.2318 3.95512 15.157 3.9728L14.115 4.21302C13.9169 4.25922 13.7444 4.35572 13.612 4.4902C13.4795 4.62468 13.3851 4.80228 13.3399 5.0035L13.1038 6.06602C13.0931 6.11807 13.0721 6.16747 13.0421 6.21133C13.0121 6.25519 12.9737 6.29264 12.9291 6.3215C12.8844 6.35036 12.8345 6.37004 12.7822 6.37941C12.7299 6.38877 12.6763 6.38763 12.6244 6.37605C12.5496 6.35848 12.4813 6.32001 12.4275 6.26512C12.3737 6.21023 12.3366 6.14118 12.3205 6.06602L12.0844 5.0035C12.0434 4.81035 11.9492 4.63254 11.8124 4.4902C11.6744 4.35197 11.4999 4.25583 11.3093 4.21302L10.2673 3.9728C10.1628 3.94741 10.0723 3.88198 10.0155 3.7906C9.95866 3.69921 9.93998 3.58916 9.96347 3.48414C9.97964 3.40903 10.0168 3.34004 10.0706 3.28517C10.1243 3.2303 10.1926 3.19179 10.2673 3.17411L11.3093 2.93389C11.5036 2.88993 11.6809 2.79041 11.8195 2.64747C11.9519 2.50671 12.0431 2.33238 12.0834 2.14341L12.3195 1.08089C12.3302 1.02884 12.3512 0.97944 12.3812 0.935577C12.4112 0.891714 12.4496 0.854261 12.4942 0.825404C12.5389 0.796547 12.5888 0.776862 12.6411 0.767497C12.6934 0.758132 12.747 0.759274 12.7989 0.770857C12.8737 0.788424 12.942 0.826894 12.9958 0.881784C13.0496 0.936675 13.0877 1.00573 13.1038 1.08089ZM4.52458 2.82096L4.88286 4.43887C4.95384 4.7722 5.11712 5.07884 5.35407 5.32379L5.37049 5.34227C5.59737 5.56607 5.8879 5.72724 6.22051 5.80424L7.80557 6.1697C7.91015 6.19509 8.00058 6.26052 8.05741 6.35191C8.11424 6.44329 8.13292 6.55334 8.10944 6.65836C8.09326 6.73347 8.05613 6.80246 8.00235 6.85733C7.94857 6.91221 7.88034 6.95071 7.80557 6.96839L6.22051 7.33489C5.87866 7.41393 5.58197 7.58127 5.35304 7.8143C5.12411 8.04734 4.96088 8.35121 4.88286 8.70025L4.52458 10.3182C4.51387 10.3702 4.4929 10.4196 4.4629 10.4635C4.4329 10.5073 4.39447 10.5448 4.34984 10.5736C4.30522 10.6025 4.2553 10.6222 4.20299 10.6316C4.15068 10.6409 4.09703 10.6398 4.04516 10.6282C3.97034 10.6106 3.90205 10.5722 3.84825 10.5173C3.79445 10.4624 3.75735 10.3933 3.74129 10.3182L3.38198 8.70025C3.31125 8.36706 3.14833 8.06044 2.9118 7.81533C2.67511 7.57532 2.37431 7.40852 2.04536 7.33489L0.459277 6.96839C0.354698 6.94301 0.264263 6.87758 0.207434 6.78619C0.150604 6.6948 0.131922 6.58476 0.155406 6.47974C0.171582 6.40462 0.208713 6.33564 0.262494 6.28076C0.316276 6.22589 0.384506 6.18738 0.459277 6.1697L2.04434 5.80424C2.38516 5.72519 2.68185 5.55786 2.91078 5.32379L2.92926 5.30634C3.14895 5.07536 3.30704 4.77867 3.38198 4.43887L3.74129 2.82096C3.752 2.76891 3.77297 2.71951 3.80297 2.67565C3.83297 2.63179 3.87141 2.59433 3.91603 2.56548C3.96065 2.53662 4.01058 2.51693 4.06289 2.50757C4.1152 2.4982 4.16885 2.49935 4.22071 2.51093C4.29554 2.5285 4.36383 2.56697 4.41763 2.62186C4.47143 2.67675 4.50852 2.7458 4.52458 2.82096Z",
            fill: "var(--icon-color)"
        })
    });
}
function textToVideoIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.21823 19.1844L11.1244 16.5861H14.5833C16.1145 16.5861 17.444 16.0727 18.3924 15.1243C19.3407 14.176 19.8541 12.8465 19.8541 11.3153V5.81527C19.8541 4.28403 19.3407 2.95458 18.3924 2.00621C17.444 1.05785 16.1145 0.544434 14.5833 0.544434H5.41665C3.88541 0.544434 2.55596 1.05785 1.60759 2.00621C0.659224 2.95458 0.145813 4.28403 0.145813 5.81527V11.3153C0.145813 12.8465 0.659224 14.176 1.60759 15.1243C2.41098 15.9277 3.48782 16.419 4.72915 16.5504V17.8511C4.72915 19.1369 6.1594 19.8896 7.21823 19.1844ZM4.91115 14.8314C5.79044 14.9245 6.45772 15.6662 6.45772 16.5504V17.6142L10.1671 15.1468C10.4507 14.9582 10.7838 14.8575 11.1244 14.8575H14.5833C15.7222 14.8575 16.5898 14.4823 17.1701 13.902C17.7503 13.3218 18.1256 12.4542 18.1256 11.3153V5.81527C18.1256 4.67633 17.7503 3.80874 17.1701 3.2285C16.5898 2.64826 15.7222 2.27301 14.5833 2.27301H5.41665C4.27771 2.27301 3.41012 2.64826 2.82988 3.2285C2.24964 3.80874 1.87438 4.67633 1.87438 5.81527V11.3153C1.87438 12.4542 2.24964 13.3218 2.82988 13.902C3.32479 14.3969 4.02076 14.7371 4.91115 14.8314Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.13065 6.95363C9.11297 6.96385 8.95202 7.07368 8.95202 7.54842V9.67224C8.95202 10.147 9.11297 10.2568 9.13065 10.267C9.14798 10.277 9.32262 10.3618 9.73276 10.1249C9.73284 10.1248 9.73268 10.1249 9.73276 10.1249L11.5652 9.0633C11.9753 8.82635 11.991 8.63158 11.991 8.61033C11.991 8.58908 11.9762 8.3948 11.5661 8.15785L9.733 7.09594C9.73287 7.09587 9.73313 7.09602 9.733 7.09594C9.32296 6.85915 9.14797 6.94361 9.13065 6.95363ZM8.27271 5.46947C9.00441 5.04651 9.86317 5.1913 10.5906 5.6116L12.4237 6.67351C12.4238 6.67358 12.4235 6.67344 12.4237 6.67351C13.1511 7.09395 13.7053 7.76576 13.7053 8.61033C13.7053 9.45487 13.1516 10.1264 12.4241 10.5469C12.424 10.547 12.4243 10.5468 12.4241 10.5469L10.5915 11.6086C9.86402 12.0289 9.00441 12.1741 8.27271 11.7512C7.54137 11.3284 7.23773 10.5122 7.23773 9.67224V7.54842C7.23773 6.70842 7.54137 5.89223 8.27271 5.46947Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function deforumSmallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.59543 1.02473C10.3515 0.892457 12.1067 1.293 13.6316 2.17401C15.1565 3.05502 16.3801 4.37552 17.1426 5.96296C17.9052 7.5504 18.1711 9.33094 17.9057 11.0719C17.8378 11.5176 17.4214 11.8238 16.9757 11.7559C16.53 11.6879 16.2238 11.2716 16.2917 10.8259C16.5076 9.40964 16.2913 7.96122 15.671 6.66988C15.0507 5.37854 14.0553 4.30435 12.8148 3.58767C11.5744 2.871 10.1466 2.54517 8.71805 2.65277C7.28951 2.76037 5.92664 3.29639 4.80755 4.19079C3.68846 5.08519 2.86518 6.29636 2.44532 7.66604C2.02545 9.03573 2.02852 10.5002 2.45412 11.8681C2.87972 13.236 3.70805 14.4438 4.83088 15.3335C5.95371 16.2232 7.31881 16.7535 8.74779 16.8551C9.1975 16.8871 9.53614 17.2775 9.50416 17.7273C9.47218 18.177 9.08169 18.5156 8.63198 18.4836C6.87534 18.3587 5.19722 17.7068 3.81693 16.6131C2.43664 15.5194 1.41836 14.0347 0.895176 12.3532C0.371988 10.6716 0.368218 8.87129 0.88436 7.18754C1.4005 5.50379 2.41255 4.0149 3.78825 2.91541C5.16395 1.81593 6.83932 1.157 8.59543 1.02473Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.27126 8.0076C8.25274 8.0183 8.08413 8.13336 8.08413 8.63071V10.8557C8.08413 11.353 8.25274 11.4681 8.27126 11.4788C8.28942 11.4893 8.47237 11.578 8.90204 11.3298C8.90213 11.3298 8.90196 11.3299 8.90204 11.3298L10.8218 10.2177C11.2514 9.9695 11.2679 9.76545 11.2679 9.74319C11.2679 9.72092 11.2523 9.51739 10.8226 9.26916L8.9023 8.15669C8.90216 8.15661 8.90243 8.15676 8.9023 8.15669C8.47273 7.90862 8.28942 7.9971 8.27126 8.0076ZM7.37248 6.45276C8.13901 6.00966 9.03867 6.16134 9.80075 6.60166L11.7211 7.71414C11.7212 7.71421 11.721 7.71406 11.7211 7.71414C12.4832 8.1546 13.0638 8.8584 13.0638 9.74319C13.0638 10.6279 12.4836 11.3315 11.7216 11.772C11.7214 11.7721 11.7217 11.7719 11.7216 11.772L9.80165 12.8842C9.03956 13.3245 8.13901 13.4767 7.37248 13.0336C6.6063 12.5907 6.28821 11.7357 6.28821 10.8557V8.63071C6.28821 7.75071 6.6063 6.89566 7.37248 6.45276Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.5681 19.5453V14.7862C19.5361 13.8913 18.3799 13.8906 18.3477 14.7862V19.5453C18.3796 20.4402 19.5359 20.4409 19.5681 19.5453ZM16.1182 15.2215C15.9075 14.5465 15.3357 14.112 14.6628 14.1149C13.9889 14.1175 13.4206 14.5569 13.215 15.2342C13.2104 15.2492 12.2626 19.3962 12.2626 19.3962C12.1801 19.7571 12.4051 20.1167 12.7651 20.1994C13.1254 20.2821 13.4837 20.0565 13.5662 19.6955L13.7459 18.9089H15.62L15.8079 19.701C15.8919 20.064 16.2634 20.2845 16.6132 20.1981C16.9725 20.1125 17.1945 19.7509 17.109 19.3907C17.109 19.3907 16.1228 15.2364 16.1182 15.2215ZM14.0761 17.7759L14.5135 15.5102C14.5468 15.3974 14.6046 15.3355 14.6776 15.3351H14.6782C14.7514 15.3351 14.8077 15.3945 14.8416 15.5072L15.2965 17.7759H14.0761Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function restyleSmallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.98969 18.1324V13.5897C6.9592 12.7354 5.85553 12.7348 5.82478 13.5897V18.1324C5.85527 18.9867 6.95894 18.9874 6.98969 18.1324ZM3.69661 14.0052C3.49555 13.3609 2.94974 12.9462 2.30739 12.9488C1.66411 12.9514 1.12165 13.3708 0.925378 14.0173C0.921038 14.0317 0.0162514 17.9901 0.0162514 17.9901C-0.0624506 18.3346 0.152305 18.6779 0.4959 18.7568C0.839814 18.8358 1.18191 18.6204 1.26061 18.2759L1.43215 17.525H3.22105L3.40044 18.2811C3.48064 18.6276 3.83522 18.838 4.16914 18.7556C4.51207 18.6738 4.72398 18.3287 4.64237 17.9849C4.64237 17.9849 3.70105 14.0194 3.69661 14.0052ZM1.74733 16.4435L2.16487 14.2807C2.19666 14.1731 2.25183 14.114 2.32149 14.1136H2.32212C2.39197 14.1136 2.44567 14.1703 2.47809 14.2779L2.91224 16.4435H1.74733Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.09102 5.97377C2.09102 4.84207 2.32319 4.38133 2.61526 4.13847C2.95927 3.85241 3.64315 3.63991 5.08224 3.63991H10.9399C12.3789 3.63991 13.0628 3.85241 13.4068 4.13847C13.6989 4.38133 13.9311 4.84207 13.9311 5.97377V12.463C13.9311 13.5926 13.6976 14.0542 13.404 14.2978C13.0584 14.5847 12.3735 14.7969 10.9399 14.7969H8.19999V16.6184H10.9399C12.4258 16.6184 13.6919 16.426 14.5674 15.6995C15.4949 14.9296 15.7526 13.7689 15.7526 12.463V5.97377C15.7526 4.67007 15.4982 3.50848 14.5715 2.73788C13.6967 2.01047 12.4296 1.81836 10.9399 1.81836H5.08224C3.59251 1.81836 2.32539 2.01047 1.45062 2.73788C0.523893 3.50848 0.26947 4.67007 0.26947 5.97377V11.8238C0.704339 11.2711 1.34905 10.9101 2.09102 10.8648V5.97377Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.2383 5.97209C17.2381 5.97224 17.2385 5.97193 17.2383 5.97209L15.6856 7.21768V11.213L17.2395 12.4596L17.2413 12.461C17.4653 12.6419 17.5852 12.6583 17.6261 12.6567C17.6524 12.6212 17.7279 12.49 17.7279 12.1274V6.31093C17.7279 5.9443 17.6507 5.81364 17.6247 5.7794C17.5848 5.77707 17.4644 5.79161 17.2383 5.97209ZM17.64 5.78192C17.64 5.782 17.639 5.78177 17.6371 5.78099ZM17.6425 12.6542C17.6425 12.6543 17.6415 12.6547 17.6393 12.6552ZM18.3252 4.35507C18.9698 4.7401 19.1963 5.54266 19.1963 6.31093V12.1274C19.1963 12.8949 18.9702 13.6992 18.3237 14.0832C17.6636 14.4754 16.9333 14.2156 16.3734 13.764C16.3731 13.7637 16.3737 13.7642 16.3734 13.764L14.5188 12.2762C14.3293 12.1241 14.2172 11.8816 14.2172 11.6236V6.80709C14.2172 6.54908 14.3293 6.3066 14.5188 6.15456L16.3742 4.6661C16.9354 4.21779 17.6668 3.96186 18.3252 4.35507Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function photoAiSmallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.9019 7.15768C6.77009 7.15768 7.4739 6.45387 7.4739 5.58568C7.4739 4.71748 6.77009 4.01367 5.9019 4.01367C5.03371 4.01367 4.3299 4.71748 4.3299 5.58568C4.3299 6.45387 5.03371 7.15768 5.9019 7.15768Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.3537 18.7797V13.7827C19.3202 12.843 18.1061 12.8423 18.0723 13.7827V18.7797C18.1058 19.7194 19.3199 19.7201 19.3537 18.7797ZM15.7313 14.2397C15.5101 13.531 14.9098 13.0748 14.2032 13.0778C13.4956 13.0806 12.8989 13.5419 12.683 14.2531C12.6782 14.2689 11.6829 18.6231 11.6829 18.6231C11.5963 19.0021 11.8326 19.3797 12.2105 19.4665C12.5888 19.5534 12.9651 19.3165 13.0517 18.9375L13.2404 18.1115H15.2082L15.4055 18.9432C15.4937 19.3244 15.8838 19.5559 16.2511 19.4652C16.6283 19.3752 16.8614 18.9956 16.7717 18.6174C16.7717 18.6174 15.7362 14.2554 15.7313 14.2397ZM13.5871 16.9219L14.0464 14.5428C14.0814 14.4244 14.1421 14.3594 14.2187 14.359H14.2194C14.2962 14.359 14.3553 14.4214 14.3909 14.5397L14.8685 16.9219H13.5871Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.26483 2.13373C3.45154 0.947031 5.20653 0.515137 7.39247 0.515137H12.4341C14.6201 0.515137 16.3751 0.947031 17.5618 2.13373C18.7485 3.32043 19.1804 5.07543 19.1804 7.26137V9.81863V9.8219V11.8049C19.0841 11.7889 18.9855 11.7807 18.8852 11.7806C18.3049 11.7805 17.7815 12.0558 17.4503 12.5123C17.4513 12.4436 17.4518 12.3738 17.4518 12.303V10.2107L16.3989 9.2844L16.3989 9.28438C16.0811 9.00476 15.5294 9.00476 15.2116 9.28438L15.2113 9.28464L11.7757 12.3047L11.7754 12.3049C10.8047 13.1587 9.2753 13.1586 8.30474 12.3047L8.29739 12.2982L8.29743 12.2982L8.02919 12.0567C7.74572 11.81 7.24426 11.7763 6.9124 12.0041L6.91214 12.0043L2.84055 14.8045C2.79801 14.8337 2.75378 14.8586 2.70838 14.8793C2.89654 15.4498 3.1599 15.8812 3.48712 16.2084C4.19104 16.9123 5.37702 17.3207 7.39247 17.3207H10.65L10.3807 18.498C10.3383 18.6833 10.3252 18.8687 10.3382 19.0493H7.39247C5.20653 19.0493 3.45154 18.6174 2.26483 17.4307C1.07813 16.244 0.64624 14.489 0.64624 12.303V7.26137C0.64624 5.07543 1.07813 3.32043 2.26483 2.13373ZM17.4518 7.26137V7.912C16.4788 7.13343 15.0116 7.15822 14.0701 7.98636L14.0697 7.98663L10.6342 11.0067L10.6339 11.0069C10.3171 11.2857 9.76782 11.2865 9.44956 11.0095L9.18134 10.7681L9.18137 10.768L9.17409 10.7616C8.28428 9.97855 6.90511 9.91176 5.93314 10.5797L5.93289 10.5799L2.39337 13.0141C2.38107 12.7893 2.37481 12.5525 2.37481 12.303V7.26137C2.37481 5.24592 2.78319 4.05994 3.48712 3.35602C4.19104 2.65209 5.37702 2.24371 7.39247 2.24371H12.4341C14.4496 2.24371 15.6356 2.65209 16.3395 3.35602C17.0434 4.05994 17.4518 5.24592 17.4518 7.26137Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function textToImageSmallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.77701 15.6575C5.26551 15.7092 5.63622 16.1212 5.63622 16.6124V17.9263C5.63622 18.4515 6.2208 18.7649 6.65777 18.4738L6.65827 18.4735L10.6039 15.8489C10.7615 15.7441 10.9465 15.6882 11.1358 15.6882H14.6296C15.9584 15.6882 17.0446 15.2464 17.7981 14.4929C18.5515 13.7395 18.9934 12.6532 18.9934 11.3245V5.7689C18.9934 4.44014 18.5515 3.35385 17.7981 2.60042C17.0446 1.84698 15.9584 1.40514 14.6296 1.40514H5.37034C4.04158 1.40514 2.9553 1.84698 2.20186 2.60042C1.44843 3.35385 1.00659 4.44014 1.00659 5.7689V11.3245C1.00659 12.6532 1.44843 13.7395 2.20186 14.4929C2.84198 15.1331 3.71811 15.5454 4.77701 15.6575Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.92063",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.2591 7.68555L14.9384 10.8849C13.5176 11.937 11.6316 12.1177 10.0369 11.3545V11.3545C8.50731 10.6225 6.70427 10.7568 5.30007 11.7073L1.6665 14.167",
                stroke: "var(--icon-color)",
                strokeWidth: "1.92063",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.101 7.49099C13.059 7.49099 13.8357 6.71432 13.8357 5.75624C13.8357 4.79816 13.059 4.02148 12.101 4.02148C11.1429 4.02148 10.3662 4.79816 10.3662 5.75624C10.3662 6.71432 11.1429 7.49099 12.101 7.49099Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function textToVideoSmallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.21823 19.1844L11.1244 16.5861H14.5833C16.1145 16.5861 17.444 16.0727 18.3924 15.1243C19.3407 14.176 19.8541 12.8465 19.8541 11.3153V5.81527C19.8541 4.28403 19.3407 2.95458 18.3924 2.00621C17.444 1.05785 16.1145 0.544434 14.5833 0.544434H5.41665C3.88541 0.544434 2.55596 1.05785 1.60759 2.00621C0.659224 2.95458 0.145813 4.28403 0.145813 5.81527V11.3153C0.145813 12.8465 0.659224 14.176 1.60759 15.1243C2.41098 15.9277 3.48782 16.419 4.72915 16.5504V17.8511C4.72915 19.1369 6.1594 19.8896 7.21823 19.1844ZM4.91115 14.8314C5.79044 14.9245 6.45772 15.6662 6.45772 16.5504V17.6142L10.1671 15.1468C10.4507 14.9582 10.7838 14.8575 11.1244 14.8575H14.5833C15.7222 14.8575 16.5898 14.4823 17.1701 13.902C17.7503 13.3218 18.1256 12.4542 18.1256 11.3153V5.81527C18.1256 4.67633 17.7503 3.80874 17.1701 3.2285C16.5898 2.64826 15.7222 2.27301 14.5833 2.27301H5.41665C4.27771 2.27301 3.41012 2.64826 2.82988 3.2285C2.24964 3.80874 1.87438 4.67633 1.87438 5.81527V11.3153C1.87438 12.4542 2.24964 13.3218 2.82988 13.902C3.32479 14.3969 4.02076 14.7371 4.91115 14.8314Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.13065 6.95363C9.11297 6.96385 8.95202 7.07368 8.95202 7.54842V9.67224C8.95202 10.147 9.11297 10.2568 9.13065 10.267C9.14798 10.277 9.32262 10.3618 9.73276 10.1249C9.73284 10.1248 9.73268 10.1249 9.73276 10.1249L11.5652 9.0633C11.9753 8.82635 11.991 8.63158 11.991 8.61033C11.991 8.58908 11.9762 8.3948 11.5661 8.15785L9.733 7.09594C9.73287 7.09587 9.73313 7.09602 9.733 7.09594C9.32296 6.85915 9.14797 6.94361 9.13065 6.95363ZM8.27271 5.46947C9.00441 5.04651 9.86317 5.1913 10.5906 5.6116L12.4237 6.67351C12.4238 6.67358 12.4235 6.67344 12.4237 6.67351C13.1511 7.09395 13.7053 7.76576 13.7053 8.61033C13.7053 9.45487 13.1516 10.1264 12.4241 10.5469C12.424 10.547 12.4243 10.5468 12.4241 10.5469L10.5915 11.6086C9.86402 12.0289 9.00441 12.1741 8.27271 11.7512C7.54137 11.3284 7.23773 10.5122 7.23773 9.67224V7.54842C7.23773 6.70842 7.54137 5.89223 8.27271 5.46947Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function enhanceIcon() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.6723 5.71724C16.2525 5.13703 16.6673 4.42758 16.9774 3.57836C17.2875 4.42758 17.7022 5.13703 18.2824 5.71724C18.8626 6.29745 19.5721 6.71217 20.4213 7.02228C19.5721 7.33239 18.8626 7.74711 18.2824 8.32732C17.7022 8.90753 17.2875 9.61698 16.9774 10.4662C16.6672 9.61698 16.2525 8.90753 15.6723 8.32732C15.0921 7.74711 14.3827 7.33238 13.5334 7.02228C14.3827 6.71217 15.0921 6.29745 15.6723 5.71724Z",
                fill: "var(--icon-color)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.4983 14.145C19.666 13.9773 19.809 13.7932 19.9319 13.5938C20.0547 13.7932 20.1977 13.9773 20.3654 14.145C20.5332 14.3128 20.7172 14.4558 20.9166 14.5786C20.7172 14.7015 20.5332 14.8445 20.3654 15.0122C20.1977 15.1799 20.0547 15.364 19.9319 15.5634C19.809 15.364 19.666 15.1799 19.4983 15.0122C19.3305 14.8445 19.1465 14.7015 18.9471 14.5786C19.1465 14.4558 19.3305 14.3128 19.4983 14.145Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.87844 4.37355C8.04616 4.20582 8.18916 4.02175 8.31201 3.82234C8.43486 4.02175 8.57786 4.20582 8.74559 4.37355C8.91332 4.54128 9.09739 4.68428 9.2968 4.80713C9.09739 4.92998 8.91332 5.07297 8.74559 5.2407C8.57786 5.40843 8.43486 5.5925 8.31201 5.79192C8.18916 5.5925 8.04617 5.40843 7.87844 5.2407C7.71071 5.07298 7.52664 4.92998 7.32723 4.80713C7.52664 4.68428 7.71071 4.54128 7.87844 4.37355Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.6386 9.50391C13.618 9.97904 14.2847 10.6459 14.7597 11.6254L4.96808 21.417C4.57755 21.8076 3.94439 21.8076 3.55386 21.417L2.84676 20.7099C2.45623 20.3194 2.45623 19.6862 2.84676 19.2957L12.6386 9.50391Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function allIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "22",
        height: "23",
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Default/Grid",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Group_1000002576",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Rectangle_602",
                        x: "3.07617",
                        y: "3.53711",
                        width: "6.41488",
                        height: "6.41488",
                        rx: "3.20744",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Rectangle_604",
                        x: "3.07617",
                        y: "13.0488",
                        width: "6.415",
                        height: "6.415",
                        rx: "3.2075",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Rectangle_603",
                        x: "12.5088",
                        y: "3.53711",
                        width: "6.41488",
                        height: "6.41488",
                        rx: "3.20744",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Rectangle_605",
                        x: "12.5088",
                        y: "13.0488",
                        width: "6.415",
                        height: "6.415",
                        rx: "3.2075",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.5"
                    })
                ]
            })
        })
    });
}
var DownArrowsIcon = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M5.83366 5L10.0003 9.16667L14.167 5",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.66667",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M5.83366 10.832L10.0003 14.9987L14.167 10.832",
                    stroke: "var(--icon-color)",
                    strokeWidth: "1.66667",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var DownArrowsDesktopIcon = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M6 17L11 12L6 7",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M13 17L18 12L13 7",
                    stroke: "var(--icon-color)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 1C6.30683 1 6.55556 1.24873 6.55556 1.55556V5.44444H10.4444C10.7513 5.44444 11 5.69318 11 6C11 6.30683 10.7513 6.55556 10.4444 6.55556H6.55556V10.4444C6.55556 10.7513 6.30683 11 6 11C5.69318 11 5.44444 10.7513 5.44444 10.4444V6.55556H1.55556C1.24873 6.55556 1 6.30683 1 6C1 5.69318 1.24873 5.44444 1.55556 5.44444H5.44444V1.55556C5.44444 1.24873 5.69318 1 6 1Z",
                fill: "var(--icon-color)"
            })
        })
    });
};


/***/ }),

/***/ 437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Od": function() { return /* binding */ allProducts; }
/* harmony export */ });
/* unused harmony exports OtherProductsSectionOld, OtherProductsSection */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1156);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pages_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9274);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9612);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1455);








var allProducts = [
    {
        tool: "ai_restyle",
        label: "txt_restyle_ai",
        location: "restyle",
        color: "#a42ef3",
        url: "/tools/ai-animation-generator",
        icon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .restyleIcon */ .Lt)(),
        smallIcon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .restyleSmallIcon */ .m5)()
    },
    {
        tool: "deform",
        label: "txt_deforum_ai",
        location: "deforum",
        color: "#d94f91",
        url: "/tools/ai-video-transformation",
        icon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .deforumIcon */ .uv)(),
        smallIcon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .deforumSmallIcon */ .Ay)()
    },
    {
        tool: "ai_photo",
        label: "txt_photo_ai",
        location: "photo-ai",
        color: "#227df5",
        url: "/tools/ai-photo-editor",
        icon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .photoAiIcon */ .x$)(),
        smallIcon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .photoAiSmallIcon */ .kf)()
    },
    {
        tool: "text_to_image",
        label: "txt_text_to_image",
        location: "text-to-image",
        color: "#227df5",
        url: "/tools/text-to-image",
        icon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .textToImageIcon */ .f7)(),
        smallIcon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .textToImageSmallIcon */ .Wn)()
    },
    {
        tool: "text_to_video",
        label: "txt_text_to_video",
        location: "text-to-video",
        color: "#227df5",
        url: "/tools/text-to-video",
        icon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .textToVideoIcon */ .Cz)(),
        smallIcon: (0,_icons__WEBPACK_IMPORTED_MODULE_6__/* .textToVideoSmallIcon */ .AP)()
    }, 
];
function OtherProductsSectionOld(props) {
    var products = props.products;
    var selectedProducts = products !== null && products !== void 0 ? products : allProducts;
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsxs("section", {
        className: "relative flex w-full flex-col items-center gap-12 pb-28 pt-20 tablet:gap-16 tablet:pb-44 tablet:pt-11 desktop:pb-24 desktop:pt-20",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-h2 text-center",
                children: t("txt_try_other")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: clsx("z-20 flex flex-row gap-3 tablet:gap-4 desktop:items-center desktop:gap-6", "no-scrollbar w-full overflow-x-scroll px-4 tablet:w-[731px] desktop:w-[867px] desktop:px-0"),
                children: selectedProducts.map(function(product) {
                    return /*#__PURE__*/ _jsxs("a", {
                        href: product.url,
                        className: clsx("relative z-20 flex flex-col gap-1 rounded-[14px] tablet:gap-4 tablet:rounded-[22px] desktop:gap-8", "flex-1 bg-color-cell text-[12px] font-700 tablet:text-[20px] desktop:text-[28px]", "group h-[103px] items-center justify-center tablet:h-[182px] desktop:h-[242px]", "transition-all duration-300 desktop:hover:gap-6"),
                        style: {
                            "--icon-color": product.color
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: clsx("tablet:scale-[2] tablet:group-hover:scale-[2.5] desktop:scale-[2.5]", "transition-transform desktop:group-hover:scale-[3]", "duration-300"),
                                children: product.icon
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-center",
                                children: t(product.label)
                            })
                        ]
                    }, product.label);
                })
            }),
            /*#__PURE__*/ _jsx(ResponsiveImage, {
                src: "/tools/other",
                className: "pointer-events-none absolute left-1/2 top-0 z-10 h-full -translate-x-1/2 object-cover"
            })
        ]
    });
}
function OtherProductsSection(props) {
    var products = props.products;
    var selectedProducts = products !== null && products !== void 0 ? products : allProducts;
    var t = useTranslation().t;
    var router = useRouter();
    var device = useDeviceSize();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "relative flex w-full flex-col items-center gap-6 py-[35px] tablet:gap-8 tablet:py-[40px] desktop:py-[55px]",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "text-h2 z-10 text-center",
                    children: t("txt_try_other")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx("no-scrollbar z-10 flex w-full flex-col gap-3 overflow-x-scroll px-4", "tablet:grid tablet:w-auto tablet:grid-cols-3 tablet:gap-4 tablet:overflow-auto", "desktop:grid-cols-4 desktop:gap-6 desktop:px-0"),
                    children: selectedProducts.filter(function(product) {
                        return !router.pathname.startsWith(product.url);
                    }).map(function(product) {
                        return /*#__PURE__*/ _jsx(SingleProduct, {
                            product: product,
                            isMobile: device === Device.Mobile
                        }, product.url);
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pointer-events-none absolute left-0 top-0 flex h-full w-full items-center justify-center overflow-x-clip desktop:translate-y-1/4",
                    children: /*#__PURE__*/ _jsx(ResponsiveImage, {
                        src: "/tools/other",
                        className: "h-full w-full scale-x-150 scale-y-125 object-cover tablet:scale-150 desktop:w-[1728px] desktop:scale-100"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 5794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2708);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4382);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9870);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





var AppearBottom = function(props) {
    var children = props.children, onView = props.onView, playNow = props.playNow, delay = props.delay, short = props.short, opaque = props.opaque, long = props.long;
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)(), inView = ref.inView, ref1 = ref.ref;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(playNow || false), play = ref2[0], setPlay = ref2[1];
    if (!play && // if it uses `playNow`, already initialized correctly
    (onView === undefined && playNow || // render only when user sees, and is already `inView`
    onView && inView || // no trigger specified, render immediately
    onView === undefined && playNow === undefined)) setPlay(true);
    var getAnimateClass = function() {
        if (short && opaque) return (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["appear-bottom-short-opaque"]);
        if (short) return (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["appear-bottom-short"]);
        if (opaque) return (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["appear-bottom-opaque"]);
        if (long) return (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["appear-bottom-long"]);
        return (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["appear-bottom"]);
    };
    var getDelayMaybe = function(delayInSeconds) {
        return delayInSeconds === undefined ? undefined : delayInSeconds + "s";
    };
    var animateIf = function(playIfTrue) {
        return playIfTrue ? getAnimateClass() : "invisible";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        ref: ref1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
            className: animateIf(play),
            style: {
                animationDelay: getDelayMaybe(delay)
            },
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppearBottom);


/***/ }),

/***/ 9505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9870);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_1__);


var AppearInPlace = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_1___default()["appear-in-place"]),
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppearInPlace);


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBoop; }
/* harmony export */ });
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9926);

var useBoop = function(props) {
    var scale = props.scale, trigger = props.trigger, close = props.close;
    return (0,react_spring__WEBPACK_IMPORTED_MODULE_0__/* .useSpring */ .q_)({
        display: "inline-block",
        transform: trigger ? "scale(".concat(scale, ")") : "scale(1)",
        opacity: trigger ? 1 : 0,
        onRest: close,
        config: react_spring__WEBPACK_IMPORTED_MODULE_0__/* .config.gentle */ .vc.gentle
    });
};



/***/ }),

/***/ 3850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ switch_on_change; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/floating/index.tsx
var floating = __webpack_require__(501);
;// CONCATENATED MODULE: ./comps/phony/index.tsx

var Phony = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            visibility: "hidden"
        },
        children: props.children
    });
};
/* harmony default export */ var phony = (Phony);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
// EXTERNAL MODULE: ./comps/animate/appear-bottom.tsx
var appear_bottom = __webpack_require__(5794);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(2708);
// EXTERNAL MODULE: ./comps/animate/styles.module.css
var styles_module = __webpack_require__(9870);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./comps/animate/disappear-top.tsx





var DisappearTop = function(props) {
    var children = props.children, onView = props.onView, playNow = props.playNow, delay = props.delay, short = props.short, opaque = props.opaque;
    var ref = (0,react_intersection_observer/* useInView */.YD)(), inView = ref.inView, ref1 = ref.ref;
    var ref2 = (0,react.useState)(playNow || false), play = ref2[0], setPlay = ref2[1];
    if (!play && (// if it uses `playNow`, already initialized correctly
    onView === undefined && playNow || // render only when user sees, and is already `inView`
    onView && inView || // no trigger specified, render immediately
    onView === undefined && playNow === undefined)) setPlay(true);
    var getAnimateClass = function() {
        if (short && opaque) return (styles_module_default())["disappear-top-short-opaque"];
        if (short) return (styles_module_default())["disappear-top-short"];
        if (opaque) return (styles_module_default())["disappear-top-opaque"];
        return (styles_module_default())["disappear-top"];
    };
    var getDelayMaybe = function(delayInSeconds) {
        return delayInSeconds === undefined ? undefined : delayInSeconds + "s";
    };
    var animateIf = function(playIfTrue) {
        return playIfTrue ? getAnimateClass() : "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
            className: animateIf(play),
            style: {
                animationDelay: getDelayMaybe(delay)
            },
            children: children
        })
    });
};
/* harmony default export */ var disappear_top = (DisappearTop);

;// CONCATENATED MODULE: ./comps/animate/switch-on-change.tsx







var SwitchOnChange = function(props) {
    var children = props.children, index = props.index, short = props.short, solid = props.solid, opaque = props.opaque;
    var previous = (index + children.length - 1) % children.length;
    return solid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
        children: children[index]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(floating/* Relative */.I, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(phony, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                    children: children[index]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                position: {
                    top: 0,
                    right: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disappear_top, {
                    short: short,
                    opaque: opaque,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                        children: children[previous]
                    })
                }, previous)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                position: {
                    top: 0,
                    left: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(appear_bottom/* default */.Z, {
                    short: short,
                    opaque: opaque,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                        children: children[index]
                    })
                }, index)
            })
        ]
    });
};
/* harmony default export */ var switch_on_change = (SwitchOnChange);


/***/ }),

/***/ 8007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ BlogSocialsHorizontal; },
/* harmony export */   "ZP": function() { return /* binding */ BlogSocials; }
/* harmony export */ });
/* unused harmony export BlogStickySocials */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);









function SocialButton(props) {
    var onClick = props.onClick, url = props.url, slug = props.slug, desktop = props.desktop, className = props.className;
    var imageClasses = "hover:bg-color-background transition-colors p-2 desktop:w-full h-full " + className;
    var anchorClasses = "flex overflow-hidden rounded-full pointer-events-auto flex-1";
    var desktopUrl = onClick ? undefined : desktop ? desktop(slug) : url && url(slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                href: desktopUrl,
                onClick: function() {
                    return onClick && onClick(slug);
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("hidden desktop:block", onClick && "cursor-pointer", anchorClasses),
                children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: props.icon,
                    alt: "props icon",
                    className: imageClasses
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.dark,
                            "data-hide-on-theme": "light",
                            alt: "social dark",
                            className: imageClasses
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.light,
                            "data-hide-on-theme": "dark",
                            alt: "social light",
                            className: imageClasses
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("desktop:hidden", anchorClasses, onClick && "cursor-pointer"),
                href: url && url(slug),
                children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: props.icon,
                    alt: "social icon",
                    className: imageClasses
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.dark,
                            "data-hide-on-theme": "light",
                            alt: "social dark",
                            className: imageClasses
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.light,
                            alt: "social light",
                            "data-hide-on-theme": "dark",
                            className: imageClasses
                        })
                    ]
                })
            })
        ]
    });
}
var socials = [
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/facebook-colorful.svg"),
        url: function(link) {
            return "https://www.facebook.com/sharer/sharer.php?u=".concat(link);
        }
    },
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/messenger-colorful.svg"),
        url: function(link) {
            return "fb-messenger://share?link=".concat(link, "&app_id=").concat("215609162521480", "}");
        },
        desktop: function(link) {
            return "https://www.facebook.com/dialog/send?link=".concat(link, "&app_id=").concat("215609162521480", "&redirect_uri=").concat(encodeURIComponent("https://zoomerang.app"));
        }
    },
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/whatsapp-colorful.svg"),
        url: function(link) {
            return "https://wa.me/?text=".concat(link);
        }
    },
    {
        light: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/viber-colorful-light.svg"),
        dark: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/viber-colorful-dark.svg"),
        url: function(link) {
            return "viber://forward?text=".concat(link);
        }
    },
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/pinterest-colorful.svg"),
        url: function(link) {
            return "https://pinterest.com/pin/create/button/?url=".concat(link);
        }
    },
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/email-colorful.svg"),
        url: function(link) {
            return "mailto:?body=".concat(link);
        }
    },
    {
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/comps/url-colorful.svg"),
        onClick: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(link) {
                var e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                navigator.clipboard.writeText(link)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(link) {
                return _ref.apply(this, arguments);
            };
        }()
    }, 
];
function BlogSocials(props) {
    var isSmall = props.isSmall;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), link = ref[0], setLink = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLink(location.href);
    }, []);
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(isSmall || [
            "left-1/2 top-[262px] z-50 desktop:fixed",
            "mb-12 flex w-full justify-center desktop:block",
            "pointer-events-none", 
        ]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("px-3 py-4 desktop:h-auto desktop:w-[75px] desktop:flex-col", "rounded-[10px] tablet:rounded-[18px]", "bg-color-cell dark:bg-[#363636]", "inline-flex h-[75px] gap-2", "desktop:[transform:translateX(-580px)]", "shadow-[0px_0px_40px_rgba(0,0,0,0.08)]"),
            children: socials.map(function(props) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(SocialButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                    slug: link,
                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                }));
            })
        })
    });
}
function BlogStickySocials() {
    var ref = useState(""), link = ref[0], setLink = ref[1];
    useEffect(function() {
        setLink(location.href);
    }, []);
    var _icon;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("hidden desktop:sticky desktop:block desktop:max-h-[460px]", "top-[80px]", "bottom-0"),
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx("related z-20", "px-3 py-4 desktop:h-auto desktop:w-[75px] desktop:flex-col", "rounded-[18px] bg-color-cell", "inline-flex h-[75px] gap-2", "desktop:shadow-[0px_0px_40px_rgba(0,0,0,0.08)]"),
            children: socials.map(function(props) {
                return /*#__PURE__*/ _createElement(SocialButton, _object_spread_props(_object_spread({}, props), {
                    slug: link,
                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                }));
            })
        })
    });
}
function BlogSocialsHorizontal() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), link = ref[0], setLink = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLink(location.href);
    }, []);
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex w-full flex-row justify-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("no-scrollbar w-full overflow-x-scroll desktop:h-auto desktop:flex-row", "inline-flex h-[75px] gap-2", "shadow-[0px_0px_40px_rgba(0,0,0,0.08)]"),
            children: socials.map(function(props) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(SocialButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                    slug: link,
                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light,
                    className: "h-[46px] w-[46px] bg-color-background"
                }));
            })
        })
    });
}


/***/ }),

/***/ 3607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dp": function() { return /* binding */ BorderInput; },
/* harmony export */   "NW": function() { return /* binding */ BorderTextareaResizable; }
/* harmony export */ });
/* unused harmony export BorderTextarea */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);






function BorderInput(props) {
    var className = props.className, hasErrors = props.hasErrors, hasIcon = props.hasIcon, disabled = props.disabled, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "hasErrors",
        "hasIcon",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, otherProps), {
        disabled: disabled,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("border-[1.5px]", "bg-color-cell outline-none", "rounded-[8px]", "py-3 placeholder-color-placeholder", "no-autofill transition-all duration-200", hasErrors ? "border-color-error" : "border-color-separator focus:border-blue-400", hasIcon ? "pl-10 pr-5" : "px-5", disabled && "pointer-events-none cursor-crosshair opacity-30", className)
    }));
}
function BorderTextarea(props) {
    var className = props.className, hasErrors = props.hasErrors, hasIcon = props.hasIcon, disabled = props.disabled, otherProps = _object_without_properties(props, [
        "className",
        "hasErrors",
        "hasIcon",
        "disabled"
    ]);
    return /*#__PURE__*/ _jsx("textarea", _object_spread_props(_object_spread({}, otherProps), {
        disabled: disabled,
        className: clsx("border-[1.5px] border-color-separator", "focus:border-blue-500", "bg-color-cell outline-none", "rounded-[8px]", "py-3 placeholder-color-placeholder", "no-autofill transition-all duration-200", hasErrors && "border-color-error", hasIcon ? "pl-10 pr-5" : "px-5", disabled && "pointer-events-none cursor-crosshair opacity-30", className)
    }));
}
function BorderTextareaResizable(props) {
    var className = props.className, hasErrors = props.hasErrors, hasIcon = props.hasIcon, placeholder = props.placeholder, disabled = props.disabled, setValue = props.setValue, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "hasErrors",
        "hasIcon",
        "placeholder",
        "disabled",
        "setValue"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, otherProps), {
        ref: ref,
        contentEditable: !disabled,
        "data-placeholder": placeholder,
        onInput: function onInput() {
            var ref1;
            var ref2;
            setValue((ref2 = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.innerText) !== null && ref2 !== void 0 ? ref2 : "");
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("border-[1.5px] border-color-separator", "focus:border-blue-500", "bg-color-cell outline-none", "break-all rounded-[8px]", "py-3 placeholder-color-placeholder", "no-autofill transition-all duration-200", hasErrors && "border-color-error", hasIcon ? "pl-10 pr-5" : "px-5", disabled && "pointer-events-none cursor-crosshair opacity-30", "inline-placeholder cursor-text", className)
    }));
}


/***/ }),

/***/ 5232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UI": function() { return /* binding */ RawBubble; },
/* harmony export */   "jm": function() { return /* binding */ NewBubble; },
/* harmony export */   "t1": function() { return /* binding */ GradientText; }
/* harmony export */ });
/* unused harmony export StaticBubble */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2213);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #1f7b8f;\n	"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #7d4fde;\n	"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #ce32b9;\n	"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: var(--color-primary-500);\n	"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: var(--color-primary-500);\n	"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			#d13cf6 0%,\n			#a64dfe 100%\n		);\n	"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #d33af9;\n	"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #eff1fb;\n	"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			#d13cf6 0%,\n			#a64dfe 100%\n		);\n	"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: rgba(31, 123, 143, 0.2);\n	"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: rgba(125, 79, 222, 0.2);\n	"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: rgba(206, 50, 185, 0.2);\n	"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			rgba(209, 60, 246, 0.15) 0%,\n			rgba(166, 77, 254, 0.15) 100%\n		);\n	"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: rgba(255, 49, 102, 0.15);\n	"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			rgba(209, 60, 246, 0.15) 0%,\n			rgba(166, 77, 254, 0.15) 100%\n		);\n	"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: #d13cf614;\n	"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			rgba(209, 60, 246, 1) 0%,\n			rgba(166, 77, 254, 1) 100%\n		);\n	"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		background: linear-gradient(\n			90deg,\n			rgba(209, 60, 246, 0.15) 0%,\n			rgba(166, 77, 254, 0.15) 100%\n		);\n		&:hover {\n			background: linear-gradient(\n				90deg,\n				rgba(209, 60, 246, 0.22) 0%,\n				rgba(166, 77, 254, 0.22) 100%\n			);\n		}\n	"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			align-self: start;\n		"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					background: rgba(255, 255, 255, 0.2);\n			  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					background: rgba(255, 255, 255, 0.2);\n					&:hover {\n						background: rgba(255, 255, 255, 0.4);\n					}\n			  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: rgba(0, 0, 0, 0.8);\n					background: var(--color-white);\n			  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-size: 12px;\n	line-height: 14px;\n	letter-spacing: 0.15em;\n\n	@media ",
        " {\n		font-size: 14px;\n		line-height: 17px;\n	}\n\n	font-weight: 700;\n	flex-shrink: 0;\n\n	text-transform: uppercase;\n	user-select: none;\n\n	border-radius: 38px;\n	padding: 7px 15px;\n\n	",
        ";\n\n	",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					background: var(--color-white);\n			  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	",
        "\n\n	-webkit-background-clip: text;\n	-webkit-text-fill-color: transparent;\n	background-clip: text;\n	color: transparent;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--color-white);\n	background-color: ",
        ";\n	display: inline;\n	font-weight: 600;\n	letter-spacing: 0.15em;\n	text-transform: uppercase;\n\n	font-size: 12px;\n	padding: 5px 10px;\n\n	@media ",
        " {\n		font-size: 16px;\n		padding: 7px 30px;\n	}\n\n	@media ",
        " {\n		padding: 5px 30px;\n	}\n\n	border-radius: 30px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			box-shadow: 0px 7px 23px 0px rgba(74, 13, 67, 0.11);\n		"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background: linear-gradient(\n		60deg,\n		rgba(134, 54, 248, 0.5),\n		rgba(240, 32, 179, 0.5),\n		rgba(248, 71, 94, 0.5),\n		rgba(255, 148, 33, 0.5)\n	);\n	padding: 1px;\n	border-radius: 9999px;\n\n	",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background: linear-gradient(\n		60deg,\n		rgba(134, 54, 248, 1),\n		rgba(240, 32, 179, 1),\n		rgba(248, 71, 94, 1),\n		rgba(255, 148, 33, 1)\n	);\n\n	-webkit-background-clip: text;\n	-webkit-text-fill-color: transparent;\n	background-clip: text;\n	color: transparent;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}





var textColors = {
    tan: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    purple: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1()),
    pink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2()),
    pinkPurple: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3()),
    primaryPink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4()),
    purplePink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject5()),
    pinkPurpleLight: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6()),
    purplePinkSelected: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject7()),
    purplePinkWithHover: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject8())
};
var backgroundColors = {
    tan: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject9()),
    purple: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject10()),
    pink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject11()),
    pinkPurple: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject12()),
    primaryPink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject13()),
    purplePink: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject14()),
    pinkPurpleLight: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject15()),
    purplePinkSelected: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject16()),
    purplePinkWithHover: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject17())
};
var StyledBubble = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-87b9fc04-0"
})(_templateObject22(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop, function(props) {
    return !props.control && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject18());
}, function(props) {
    return props.light ? backgroundColors[props.color] : props.color !== "purplePinkWithHover" && props.color !== "purplePinkSelected" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject19()) : props.color === "purplePinkWithHover" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject20()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject21());
});
// noinspection CssInvalidPropertyValue
var StyledBubbleInside = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-87b9fc04-1"
})(_templateObject24(), function(props) {
    return props.light ? textColors[props.color] : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject23());
});
var Bubble = function(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RawBubble, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        text: t(props.text)
    }));
};
var RawBubble = function(props) {
    var text = props.text, color = props.color, className = props.className, control = props.control;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBubble, {
                className: className,
                light: true,
                control: control,
                color: color,
                "data-hide-on-theme": "dark",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBubbleInside, {
                    light: true,
                    color: color,
                    "data-hide-on-theme": "dark",
                    children: text
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBubble, {
                control: control,
                className: className,
                color: color,
                "data-hide-on-theme": "light",
                children: text
            })
        ]
    });
};
var StyledStaticBubble = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-87b9fc04-2"
})(_templateObject25(), function(props) {
    return props.color;
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop);
var StaticBubble = function(props) {
    var text = props.text, color = props.color;
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx(StyledStaticBubble, {
        color: color,
        children: t(text)
    });
};
var StyledNewBubble = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-87b9fc04-3"
})(_templateObject27(), function(props) {
    return props.shaddow && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject26());
});
var NewBubble = function(props) {
    var uppercase = props.uppercase, text = props.text, wideLetter = props.wideLetter, shaddow = props.shaddow, className = props.className;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNewBubble, {
        shaddow: shaddow,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
            style: {
                letterSpacing: wideLetter ? "2.1px" : "0em"
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("rounded-full bg-color-cell px-5 py-[6px]", "text-[13px] font-600 text-primary-800 tablet:text-[14px]", uppercase && "uppercase", className),
            children: t(text)
        })
    });
};
// noinspection CssInvalidPropertyValue
var StyledGradientText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-87b9fc04-4"
})(_templateObject28());
var GradientText = function(props) {
    var text = props.text, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGradientText, {
        className: className,
        children: text
    });
};

/* harmony default export */ __webpack_exports__["ZP"] = (Bubble);


/***/ }),

/***/ 5896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Di": function() { return /* binding */ ConditionalButton; },
/* harmony export */   "R9": function() { return /* binding */ NewButton; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "hq": function() { return /* binding */ ConditionalAnchor; },
/* harmony export */   "sH": function() { return /* binding */ GradientGrayscaleButton; },
/* harmony export */   "wL": function() { return /* binding */ RawButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var _utils_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7232);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7851);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2213);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					padding: 6px 16px;\n					border-radius: 6px;\n\n					font-size: 15px;\n					line-height: 20px;\n					letter-spacing: ",
        ";\n			  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					min-width: 200px;\n\n					padding: 14px 34px;\n					border-radius: 6px;\n\n					font-size: 16px;\n					line-height: 19px;\n					letter-spacing: 0.03em;\n			  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			max-width: 400px;\n			width: calc(var(--w-screen) - 32px);\n\n			@media ",
        " {\n				width: unset;\n			}\n		"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					background-color: var(\n						--color-primary-100\n					) !important;\n					cursor: not-allowed;\n					color: var(--color-inactive-text) !important;\n\n					&:hover {\n						background-color: var(\n							--color-primary-100\n						) !important;\n					}\n			  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-white);\n					cursor: not-allowed;\n			  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					cursor: pointer;\n			  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-primary-50);\n					background-color: var(--color-primary-800);\n\n					&:hover {\n						background-color: var(--color-primary-700);\n					}\n			  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-primary-700);\n					border-width: 1px;\n					border-color: var(--color-primary-400);\n\n					&:hover {\n						background-color: var(--color-primary-50);\n					}\n			  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-blue-50);\n					background-color: var(--color-green-600);\n\n					&:hover {\n						background-color: var(--color-green-700);\n					}\n			  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-green-600);\n					border-width: 1px;\n					border-color: var(--color-green-400);\n\n					&:hover {\n						background-color: var(--color-green-50);\n					}\n			  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					background: linear-gradient(\n						90deg,\n						rgba(174, 54, 248, 1),\n						rgba(240, 32, 179, 1),\n						rgba(248, 71, 94, 1)\n					);\n\n					color: var(--color-white);\n\n					// &:hover {\n					// 	background: linear-gradient(\n					// 			0deg,\n					// 			rgba(0, 0, 0, 0.3) 0%,\n					// 			rgba(0, 0, 0, 0.3) 100%\n					// 		),\n					// 		linear-gradient(\n					// 			90deg,\n					// 			rgba(174, 54, 248, 1),\n					// 			rgba(240, 32, 179, 1),\n					// 			rgba(248, 71, 94, 1)\n					// 		);\n					// }\n			  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-primary-800);\n					background-color: var(--color-blue-200);\n\n					&:hover {\n						background-color: var(--color-blue-300);\n					}\n			  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					color: var(--color-primary-800);\n					background-color: var(--color-primary-100);\n\n					&:hover {\n						background-color: var(--color-primary-200);\n					}\n			  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	",
        "\n\n	",
        "\n\n  user-select: none;\n	flex-shrink: 0;\n	font-weight: 700;\n	transition: color 300ms, background-color 300ms;\n	transition-timing-function: ease-in-out;\n	position: relative;\n	z-index: 6;\n	text-align: center;\n\n	",
        "\n\n	",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	right: 0;\n	top: 0;\n	height: 100%;\n	width: 100%;\n\n	display: flex;\n	flex-direction: row;\n	justify-content: flex-end;\n	align-items: center;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			display: none;\n		"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 20px;\n	height: 20px;\n	margin: 0 12px;\n	animation: ",
        " 800ms infinite linear;\n\n	",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					cursor: not-allowed;\n\n					background-color: var(--color-blue-200);\n			  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					cursor: pointer;\n					background: linear-gradient(\n						60deg,\n						rgba(134, 54, 248, 1),\n						rgba(240, 32, 179, 1),\n						rgba(248, 71, 94, 1),\n						rgba(255, 148, 33, 1)\n					);\n			  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	transition-property: all;\n	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n	transition-duration: 150ms;\n\n	padding: 2px;\n	border-radius: 8px;\n\n	",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}








var Styled = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7d72032-0"
})(_templateObject13(), function(props) {
    return props.small ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_spacing__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("16")) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return props.full && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet);
}, function(props) {
    return props.disabled && !props.gradient ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3()) : props.disabled && props.gradient ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject5());
}, function(props) {
    return props.primary ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6()) : props.outline ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject7()) : props.secondary ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject8()) : props.outlineSecondary ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject9()) : props.gradient ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject10()) : props.grayscale ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject11()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject12());
});
var Loading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7d72032-1"
})(_templateObject14());
var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .keyframes */ .F4)(_templateObject15());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-7d72032-2"
})(_templateObject17(), rotate, function(props) {
    return !props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject16());
});
function RawButton(props) {
    var text = props.text, small = props.small, primary = props.primary, full = props.full, grayscale = props.grayscale, href = props.href, onClick = props.onClick, className = props.className, gradient = props.gradient, disabled = props.disabled, loading = props.loading, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "text",
        "small",
        "primary",
        "full",
        "grayscale",
        "href",
        "onClick",
        "className",
        "gradient",
        "disabled",
        "loading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Styled, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, other), {
        as: href ? "a" : "button",
        href: href,
        disabled: disabled,
        primary: primary,
        gradient: gradient,
        grayscale: grayscale,
        small: small,
        full: full,
        onClick: onClick,
        className: className,
        children: [
            text,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loading, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loader, {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/comps/button-loader.webp"),
                    alt: "loader icon",
                    show: loading !== null && loading !== void 0 ? loading : false
                })
            })
        ]
    }));
}
function Button(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RawButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        text: t(props.text)
    }));
}
var StyledGradientContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7d72032-3"
})(_templateObject20(), function(props) {
    return props.disabled ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject18()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject19());
});
function GradientGrayscaleButton(props) {
    var disabled = props.disabled, text = props.text, onClick = props.onClick, className = props.className;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGradientContainer, {
        disabled: disabled,
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("h-full w-full rounded-[6px]", "flex items-center justify-center text-[16px] font-600", disabled ? "bg-blue-200 text-blue-400" : "bg-blue-50 text-primary-800"),
            children: t(text)
        })
    });
}
var allButtonStyles = {
    primary: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-primary-500 text-color-white disabled:opacity-40 disabled:pointer-events-none", "hover:bg-primary-600 select-none", "transition-colors"),
    empty: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-color-cell text-blue-700 hover:text-blue-900", "transition-colors")
};
var allButtonSizes = {
    regular: "text-base font-600 min-w-[232px] py-3 rounded-[10px] text-center"
};
var defaultButtonSize = "regular";
var defaultButtonStyle = "primary";
function ConditionalAnchor(props) {
    var disabled = props.disabled, onClick = props.onClick, className = props.className, children = props.children, style = props.style, size = props.size, href = props.href, download = props.download;
    var value = disabled && disabled();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_11__/* .twMerge */ .m)(allButtonSizes[size !== null && size !== void 0 ? size : defaultButtonSize], allButtonStyles[style !== null && style !== void 0 ? style : defaultButtonStyle], value === null && "pointer-events-none", className),
        onClick: function() {
            if (value) {
                onClick === null || onClick === void 0 ? void 0 : onClick(value);
                return;
            }
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        },
        download: download,
        href: href,
        children: children
    });
}
function ConditionalButton(props) {
    var disabled = props.disabled, onClick = props.onClick, className = props.className, children = props.children, style = props.style, size = props.size;
    var value = disabled && disabled();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_11__/* .twMerge */ .m)(allButtonSizes[size !== null && size !== void 0 ? size : defaultButtonSize], allButtonStyles[style !== null && style !== void 0 ? style : defaultButtonStyle], className),
        disabled: value === null,
        onClick: function() {
            if (value) {
                onClick === null || onClick === void 0 ? void 0 : onClick(value);
                return;
            }
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        },
        children: children
    });
}
var variantsMap = {
    default: "",
    secondary: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-primary-100 text-primary-800 disabled:opacity-70", "hover:bg-primary-200 select-none transition-colors disabled:text-primary-800"),
    secondaryBlue: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-green-600 text-color-white disabled:opacity-70", "hover:bg-green-700 select-none transition-colors disabled:text-color-white", "hover:text-color-white"),
    primary: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-primary-500 text-color-white disabled:opacity-40", "hover:bg-primary-600 select-none transition-colors"),
    outline: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("bg-color-cell text-blue-600 disabled:opacity-40 border", "hover:bg-blue-100 select-none transition-colors border-color-separator", "flex-row-reverse")
};
function NewButton(props) {
    var children = props.children, text = props.text, className = props.className, disabled = props.disabled, variant = props.variant, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        onClick: onClick,
        disabled: disabled,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("h-[44px] w-full rounded-[6px] text-[16px] font-600 disabled:pointer-events-none", "flex items-center justify-center gap-[8px]", variantsMap[variant !== null && variant !== void 0 ? variant : "default"], className),
        children: [
            children,
            " ",
            text
        ]
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 3708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


function Checkbox(props) {
    var checked = props.checked, onClick = props.onClick, className = props.className, id = props.id;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative h-6 w-6 cursor-pointer rounded-[6px] bg-[transparent] inner-border-[1.8px] inner-border-color-separator",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "checkbox",
                    id: id,
                    checked: checked,
                    onChange: onClick,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(className, "peer h-full w-full cursor-pointer", "opacity-0")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("absolute inset-0 h-full w-full cursor-pointer transition-opacity", "pointer-events-none opacity-0 peer-checked:opacity-100"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Checked, {})
                })
            ]
        })
    });
}
var Checked = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "24",
                    height: "24",
                    rx: "6",
                    fill: "var(--color-primary-500)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.6676 7.95154L9.10782 16.0487L6.33167 12.8098",
                    stroke: "white",
                    strokeWidth: "2.16",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};


/***/ }),

/***/ 1579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9612);
/* harmony import */ var _utils_maxcookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6489);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5896);









var disabledPages = [
    "/vidcon",
    "/webview",
    "/landing-preview",
    "/forms", 
];
var rightPages = [
    "/chat",
    "/discover",
    "/home",
    "/video-gpt", 
];
var Cookies = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true), allowed = ref[0], setAllowed = ref[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var allowCookie = function() {
        setAllowed(true);
        (0,_utils_maxcookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("cookies", "true");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var cookies = (0,cookie__WEBPACK_IMPORTED_MODULE_3__/* .parse */ .Q)(document.cookie).cookies;
        if (cookies) allowCookie();
        else setAllowed(false);
    }, []);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isDisabled = Boolean(disabledPages.find(function(page) {
        return router.pathname.startsWith(page);
    }));
    if (isDisabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    var showRight = Boolean(rightPages.find(function(page) {
        return router.asPath.startsWith(page);
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("fixed z-[200] flex items-center gap-4 p-3 min-[500px]:h-[150px] min-[500px]:px-6 min-[500px]:py-4", "left-[10px] w-[calc(100%-20px)] rounded-[8px] transition-all duration-700 ease-in-out", "min-[500px]:w-[450px] min-[500px]:rounded-xl", "border border-solid  border-color-separator bg-color-surface-cell backdrop-blur-md", allowed ? "opacity-0" : "opacity-100", allowed ? "bottom-[-150px]" : "bottom-[10px] min-[500px]:bottom-4", showRight ? "tablet:left-auto tablet:right-4" : "min-[500px]:left-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_1__/* .CustomThemedResource */ .aK, {
                alt: "Cookie icon",
                source: "/general/cookie-new",
                format: "svg",
                className: "hidden min-[500px]:block"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-1 flex-row items-center gap-3 min-[500px]:flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "max-w-[300px] text-base text-blue-800",
                        children: t("common:txt_cookies")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        text: "txt_its_okay",
                        onClick: allowCookie,
                        className: "!h-[44px] !w-[98px] !min-w-0 !p-0 min-[500px]:!w-full min-[500px]:!max-w-[300px]"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cookies);


/***/ }),

/***/ 9889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ CrispChatButton; },
  "Z": function() { return /* binding */ crisp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/listener.ts
var listener = __webpack_require__(3943);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./node_modules/crisp-sdk-web/dist/crisp.esm.js
var CrispMessage = /** @class */ (function () {
    function CrispMessage(crisp) {
        this.parent = crisp;
    }
    CrispMessage.prototype.send = function (type, content) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:send", [type, content]]);
    };
    CrispMessage.prototype.sendText = function (content) {
        this.send("text", content);
    };
    CrispMessage.prototype.sendFile = function (content) {
        this.send("file", content);
    };
    CrispMessage.prototype.sendAnimation = function (content) {
        this.send("animation", content);
    };
    CrispMessage.prototype.sendAudio = function (content) {
        this.send("audio", content);
    };
    CrispMessage.prototype.show = function (type, content) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:show", [type, content]]);
    };
    CrispMessage.prototype.showText = function (content) {
        this.show("text", content);
    };
    CrispMessage.prototype.showFile = function (content) {
        this.show("file", content);
    };
    CrispMessage.prototype.showAnimation = function (content) {
        this.show("animation", content);
    };
    CrispMessage.prototype.showAudio = function (content) {
        this.show("audio", content);
    };
    CrispMessage.prototype.showPicker = function (content) {
        this.show("picker", content);
    };
    CrispMessage.prototype.showField = function (content) {
        this.show("field", content);
    };
    CrispMessage.prototype.showCarousel = function (content) {
        this.show("carousel", content);
    };
    CrispMessage.prototype.markAsRead = function () {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:read"]);
    };
    CrispMessage.prototype.startThread = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:thread:start", [name]]);
    };
    CrispMessage.prototype.endThread = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:thread:end", [name]]);
    };
    CrispMessage.prototype.onMessageSent = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:sent"]);
        window.$crisp.push(["on", "message:sent", callback]);
    };
    CrispMessage.prototype.onMessageReceived = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:received"]);
        window.$crisp.push(["on", "message:received", callback]);
    };
    CrispMessage.prototype.onMessageComposeSent = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:compose:sent"]);
        window.$crisp.push(["on", "message:compose:sent", callback]);
    };
    CrispMessage.prototype.onMessageComposeReceived = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:compose:received"]);
        window.$crisp.push(["on", "message:compose:received", callback]);
    };
    return CrispMessage;
}());

var CrispUser = /** @class */ (function () {
    function CrispUser(crisp) {
        this.parent = crisp;
    }
    CrispUser.prototype.setNickname = function (nickname) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:nickname", [nickname]]);
    };
    CrispUser.prototype.setEmail = function (email, hmac) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:email", [email, hmac]]);
    };
    CrispUser.prototype.setPhone = function (phone) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:phone", [phone]]);
    };
    CrispUser.prototype.setAvatar = function (avatar) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:avatar", [avatar]]);
    };
    CrispUser.prototype.setCompany = function (name, data) {
        var _payload = {};
        if (data && data.url) {
            _payload.url = data.url;
        }
        if (data && data.description) {
            _payload.description = data.description;
        }
        if (data && data.employment) {
            _payload.employment = [
                data.employment.title
            ];
            if (data.employment.role) {
                _payload.employment.push(data.employment.role);
            }
        }
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:company", [name, _payload]]);
    };
    CrispUser.prototype.getEmail = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:email");
    };
    CrispUser.prototype.getPhone = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:phone");
    };
    CrispUser.prototype.getNickname = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:nickname");
    };
    CrispUser.prototype.getAvatar = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:avatar");
    };
    CrispUser.prototype.getCompany = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:company");
    };
    CrispUser.prototype.onEmailChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:email:changed"]);
            window.$crisp.push(["on", "user:email:changed", callback]);
        }
    };
    CrispUser.prototype.onPhoneChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:phone:changed"]);
            window.$crisp.push(["on", "user:phone:changed", callback]);
        }
    };
    CrispUser.prototype.onNicknameChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:nickname:changed"]);
            window.$crisp.push(["on", "user:nickname:changed", callback]);
        }
    };
    CrispUser.prototype.onAvatarChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:avatar:changed"]);
            window.$crisp.push(["on", "user:avatar:changed", callback]);
        }
    };
    return CrispUser;
}());

var CrispTrigger = /** @class */ (function () {
    function CrispTrigger(crisp) {
        this.parent = crisp;
    }
    CrispTrigger.prototype.run = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "trigger:run", [name]]);
    };
    return CrispTrigger;
}());

var EventsColors;
(function (EventsColors) {
    EventsColors["Red"] = "red";
    EventsColors["Orange"] = "orange";
    EventsColors["Yellow"] = "yellow";
    EventsColors["Green"] = "green";
    EventsColors["Blue"] = "blue";
    EventsColors["Purple"] = "purple";
    EventsColors["Pink"] = "pink";
    EventsColors["Brown"] = "brown";
    EventsColors["Grey"] = "grey";
    EventsColors["Black"] = "black";
})(EventsColors || (EventsColors = {}));
var CrispSession = /** @class */ (function () {
    function CrispSession(crisp) {
        this.parent = crisp;
    }
    CrispSession.prototype.reset = function (reload) {
        if (reload === void 0) { reload = false; }
        if (this.parent.isCrispInjected()) {
            window.$crisp.do("session:reset", [reload]);
        }
    };
    CrispSession.prototype.setSegments = function (segments, overwrite) {
        this.parent.createSingletonIfNecessary();
        $crisp.push(["set", "session:segments", [segments, overwrite]]);
    };
    CrispSession.prototype.setData = function (data) {
        var _this = this;
        var _payload = [];
        Object.entries(data).forEach(function (item) {
            if (_this.isValidDataValue(item[0])) {
                _payload.push([item[0], item[1]]);
            }
        });
        this.parent.createSingletonIfNecessary();
        $crisp.push(["set", "session:data", [_payload]]);
    };
    CrispSession.prototype.pushEvent = function (name, data, color) {
        if (data === void 0) { data = {}; }
        if (color === void 0) { color = EventsColors.Blue; }
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["set", "session:event", [[[name, data, color]]]]);
        }
    };
    CrispSession.prototype.getData = function (key) {
        if (!this.parent.isCrispInjected()) {
            return undefined;
        }
        return window.$crisp.get("session:data", key);
    };
    CrispSession.prototype.getIdentifier = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("session:identifier");
    };
    CrispSession.prototype.onLoaded = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "session:loaded"]);
        window.$crisp.push(["on", "session:loaded", callback]);
    };
    CrispSession.prototype.isValidDataValue = function (value) {
        return (typeof value === "string" ||
            typeof value === "number" ||
            typeof value === "boolean");
    };
    return CrispSession;
}());

var CrispChat = /** @class */ (function () {
    function CrispChat(crisp) {
        this.parent = crisp;
    }
    CrispChat.prototype.show = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:show"]);
    };
    CrispChat.prototype.hide = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:hide"]);
    };
    CrispChat.prototype.open = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:open"]);
    };
    CrispChat.prototype.close = function () {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["do", "chat:close"]);
        }
    };
    CrispChat.prototype.setHelpdeskView = function () {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:search"]);
    };
    CrispChat.prototype.openHelpdeskArticle = function (locale, slug, title, category) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:article:open", [locale, slug, title, category]]);
    };
    CrispChat.prototype.queryHelpdesk = function (query) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:query", [query]]);
    };
    CrispChat.prototype.unreadCount = function () {
        if (!this.parent.isCrispInjected()) {
            return 0;
        }
        return window.$crisp.get("chat:unread:count");
    };
    CrispChat.prototype.isChatOpened = function () {
        if (!this.parent.isCrispInjected()) {
            return false;
        }
        return window.$crisp.is("chat:opened");
    };
    CrispChat.prototype.isVisible = function () {
        if (!this.parent.isCrispInjected()) {
            return false;
        }
        return window.$crisp.is("chat:visible");
    };
    CrispChat.prototype.onChatInitiated = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:initiated"]);
        window.$crisp.push(["on", "chat:initiated", callback]);
    };
    CrispChat.prototype.onChatOpened = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:opened"]);
        window.$crisp.push(["on", "chat:opened", callback]);
    };
    CrispChat.prototype.onChatClosed = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:closed"]);
        window.$crisp.push(["on", "chat:closed", callback]);
    };
    CrispChat.prototype.onHelpdeskQueried = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "helpdesk:queried"]);
        window.$crisp.push(["on", "helpdesk:queried", callback]);
    };
    return CrispChat;
}());

var ChatboxColors;
(function (ChatboxColors) {
    ChatboxColors["Default"] = "default";
    ChatboxColors["Amber"] = "amber";
    ChatboxColors["Black"] = "black";
    ChatboxColors["Blue"] = "blue";
    ChatboxColors["BlueGrey"] = "blue_grey";
    ChatboxColors["LightBlue"] = "light_blue";
    ChatboxColors["Brown"] = "brown";
    ChatboxColors["Cyan"] = "cyan";
    ChatboxColors["Green"] = "green";
    ChatboxColors["LightGreen"] = "light_green";
    ChatboxColors["Grey"] = "grey";
    ChatboxColors["Indigo"] = "indigo";
    ChatboxColors["Orange"] = "orange";
    ChatboxColors["DeepOrange"] = "deep_orange";
    ChatboxColors["Pink"] = "pink";
    ChatboxColors["Purple"] = "purple";
    ChatboxColors["DeepPurple"] = "deep_purple";
    ChatboxColors["Red"] = "red";
    ChatboxColors["Teal"] = "teal";
})(ChatboxColors || (ChatboxColors = {}));
var ChatboxPosition;
(function (ChatboxPosition) {
    ChatboxPosition["Left"] = "left";
    ChatboxPosition["Right"] = "right";
})(ChatboxPosition || (ChatboxPosition = {}));
var Crisp = /** @class */ (function () {
    function Crisp() {
        // Options
        this.clientUrl = "https://client.crisp.chat/l.js";
        this.websiteId = "";
        this.autoload = true;
        // States
        this.injected = false;
        this.chat = new CrispChat(this);
        this.session = new CrispSession(this);
        this.user = new CrispUser(this);
        this.message = new CrispMessage(this);
        this.trigger = new CrispTrigger(this);
    }
    Crisp.prototype.configure = function (websiteId, options) {
        if (options === void 0) { options = {}; }
        this.websiteId = websiteId;
        this.tokenId = options.tokenId;
        this.locale = options.locale;
        this.sessionMerge = options.sessionMerge;
        this.cookieDomain = options.cookieDomain;
        this.cookieExpire = options.cookieExpire;
        this.lockFullview = options.lockFullview;
        this.lockMaximized = options.lockMaximized;
        this.safeMode = options.safeMode;
        if (options.clientUrl !== undefined) {
            this.clientUrl = options.clientUrl;
        }
        if (options.autoload !== undefined) {
            this.autoload = options.autoload;
        }
        // Autoload Crisp if option is enabled
        if (this.autoload) {
            this.load();
        }
    };
    Crisp.prototype.load = function () {
        var _head = document.getElementsByTagName("head");
        this.createSingletonIfNecessary();
        // Prevents from loading Crisp twice
        if (this.isCrispInjected() === true) {
            return;
        }
        if (!this.websiteId) {
            throw new Error("websiteId must be set before loading Crisp");
        }
        window.CRISP_WEBSITE_ID = this.websiteId;
        window.CRISP_RUNTIME_CONFIG = {};
        if (this.tokenId) {
            window.CRISP_TOKEN_ID = this.tokenId;
        }
        if (this.sessionMerge) {
            window.CRISP_RUNTIME_CONFIG.session_merge = true;
        }
        if (this.locale) {
            window.CRISP_RUNTIME_CONFIG.locale = this.locale;
        }
        if (this.lockFullview) {
            window.CRISP_RUNTIME_CONFIG.lock_full_view = true;
        }
        if (this.lockMaximized) {
            window.CRISP_RUNTIME_CONFIG.lock_maximized = true;
        }
        if (this.cookieDomain) {
            window.CRISP_COOKIE_DOMAIN = this.cookieDomain;
        }
        if (this.cookieExpire) {
            window.CRISP_COOKIE_EXPIRE = this.cookieExpire;
        }
        if (!_head || !_head[0]) {
            return this.deferredLoading();
        }
        if (this.safeMode === true) {
            this.setSafeMode(true);
        }
        var _script = document.createElement("script");
        _script.src = this.clientUrl;
        _script.async = true;
        _head[0].appendChild(_script);
        this.injected = true;
    };
    Crisp.prototype.setTokenId = function (tokenId) {
        this.tokenId = tokenId;
        // Refresh injected token?
        if (this.isCrispInjected() === true) {
            if (tokenId) {
                window.CRISP_TOKEN_ID = tokenId;
            }
            else {
                delete window.CRISP_TOKEN_ID;
            }
        }
    };
    Crisp.prototype.setZIndex = function (zIndex) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "container:index", [zIndex]]);
    };
    Crisp.prototype.setColorTheme = function (color) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "color:theme", [color]]);
    };
    Crisp.prototype.setHideOnAway = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:on:away", [enabled]]);
    };
    Crisp.prototype.setHideOnMobile = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:on:mobile", [enabled]]);
    };
    Crisp.prototype.setPosition = function (position) {
        this.createSingletonIfNecessary();
        $crisp.push(["config", "position:reverse", [position === ChatboxPosition.Left]]);
    };
    Crisp.prototype.setAvailabilityTooltip = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "availability:tooltip", [enabled]]);
    };
    Crisp.prototype.setVacationMode = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:vacation", [enabled]]);
    };
    Crisp.prototype.setSafeMode = function (safe) {
        if (safe === void 0) { safe = true; }
        this.createSingletonIfNecessary();
        window.$crisp.push(["safe", safe]);
    };
    Crisp.prototype.muteSound = function (mute) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "sound:mute", [mute]]);
    };
    Crisp.prototype.toggleOperatorCount = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "show:operator:count", [enabled]]);
    };
    Crisp.prototype.onWebsiteAvailabilityChanged = function (callback) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["off", "website:availability:changed"]);
        window.$crisp.push(["on", "website:availability:changed", callback]);
    };
    Crisp.prototype.createSingletonIfNecessary = function () {
        // Assigns $crisp singleton
        if (window.$crisp === undefined) {
            window.$crisp = [];
        }
    };
    Crisp.prototype.autoInjectIfNecessary = function () {
        if (!this.isCrispInjected()) {
            this.load();
        }
    };
    Crisp.prototype.isCrispInjected = function () {
        // Check if Crisp was injected (either from the Web SDK, or from another \
        //   source)
        if (this.injected === true || (window.$crisp && window.$crisp.is)) {
            return true;
        }
        return false;
    };
    Crisp.prototype.deferredLoading = function () {
        var _this = this;
        document.addEventListener("DOMContentLoaded", function () {
            _this.load();
        });
    };
    return Crisp;
}());
var singleton = new Crisp();


//# sourceMappingURL=crisp.esm.js.map

// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./comps/crisp.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          opacity: 0;\n          pointer-events: none;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  position: fixed;\n  z-index: 79;\n  bottom: 24px;\n\n  width: 52px;\n  height: 52px;\n\n  cursor: pointer;\n\n  border-radius: 52px;\n\n  background-color: var(--color-primary-500);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  transition: background-color 300ms ease-in-out,\n    200ms ease-in-out;\n\n  right: 24px;\n\n  :hover {\n    background-color: var(--color-primary-600);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 30px;\n  height: 30px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	#crisp-chatbox > div > a {\n		display: none !important;\n	}\n\n	#crisp-chatbox > div > :first-child {\n		right: 24px !important;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	#crisp-chatbox > div > a {\n		display: none !important;\n	}\n\n	#crisp-chatbox > div > :first-child {\n		right: 12px !important;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f5083819-0"
})(_templateObject1(), function(props) {
    return props.show ? "opacity:1;" : (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var CrispIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-f5083819-1"
})(_templateObject2());
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject3());
var GlobalChatStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject4());
var CrispButton = function(props) {
    var percent = props.percent, page = props.page;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var ref = (0,react.useState)(false), ready = ref[0], setReady = ref[1];
    var ref1 = (0,react.useState)(false), opened = ref1[0], setOpened = ref1[1];
    var ref2 = (0,react.useState)(false), threshold = ref2[0], setThreshold = ref2[1];
    (0,react.useEffect)(function() {
        singleton.configure("a15734e6-8a12-44d3-ab3c-1c0eb544d961" || 0);
        singleton.session.onLoaded(function() {
            setReady(true);
            var isOpen = singleton.chat.isChatOpened();
            setOpened(isOpen);
            singleton.chat.onChatOpened(function() {
                return setOpened(true);
            });
            singleton.chat.onChatClosed(function() {
                return setOpened(false);
            });
        });
    }, []);
    var scrollHandler = (0,react.useCallback)(function() {
        if (percent === undefined) {
            return;
        }
        var body = document.body, html = document.documentElement;
        var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        var full = height - window.innerHeight;
        var now = window.scrollY;
        var shouldHide = now / full < percent / 100;
        setThreshold(shouldHide);
    }, [
        percent
    ]);
    (0,listener/* default */.Z)(scrollHandler);
    var isActive = opened;
    var showEvenInactive = ready && !threshold;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                show: isActive || showEvenInactive,
                onClick: function() {
                    $crisp.push([
                        "do",
                        "chat:toggle"
                    ]);
                    (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_crisp_toggle", {
                        page: page,
                        uid: userInfo.userId
                    });
                    logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("contact");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrispIcon, {
                    src: opened ? (0,cdn/* assetUrl */.p)("/comps/crisp-close.svg") : (0,cdn/* assetUrl */.p)("/comps/crisp.svg"),
                    alt: "crisp icon"
                })
            })
        ]
    });
};
var CrispChatButton = function() {
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), ready = ref[0], setReady = ref[1];
    var ref1 = (0,react.useState)(false), opened = ref1[0], setOpened = ref1[1];
    (0,react.useEffect)(function() {
        singleton.configure("a15734e6-8a12-44d3-ab3c-1c0eb544d961" || 0);
        singleton.session.onLoaded(function() {
            setReady(true);
            var isOpen = singleton.chat.isChatOpened();
            setOpened(isOpen);
            singleton.chat.onChatOpened(function() {
                return setOpened(true);
            });
            singleton.chat.onChatClosed(function() {
                return setOpened(false);
            });
        });
    }, []);
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalChatStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                disabled: !ready,
                className: (0,clsx_m/* default */.Z)("flex h-[44px] items-center justify-center tablet:w-[400px]", "cursor-pointer rounded-[8px] bg-color-chat hover:opacity-80", "max-w-[350px] gap-[8px] disabled:cursor-default disabled:opacity-80", "transition-colors duration-300"),
                onClick: function() {
                    $crisp.push([
                        "do",
                        "chat:toggle"
                    ]);
                    (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_crisp_toggle", {
                        page: "chat",
                        uid: userInfo.userId
                    });
                    logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("contact");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/contact-support.png"),
                        alt: "contact support icon",
                        className: "h-[18px] w-[18px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[16px] font-500 text-color-white",
                        children: t("txt_contact_support")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var crisp = (CrispButton);


/***/ }),

/***/ 3153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vb": function() { return /* binding */ DropDown; },
  "rV": function() { return /* binding */ DropDownAlternative; },
  "Ar": function() { return /* binding */ DropDownWithState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/outside-click.tsx

function useOutsideClick(param) {
    var ref = param.ref, handler = param.handler;
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        handler
    ]);
}

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./comps/dropdown.tsx





function DropDown(props) {
    var trigger = props.trigger, children = props.children, className = props.className, contentClassName = props.contentClassName, onFocus = props.onFocus, hover = props.hover, closeOnClick = props.closeOnClick, isOpen = props.isOpen, zIndex = props.zIndex, triggerClassName = props.triggerClassName, closeInSelect = props.closeInSelect, mobileBackground = props.mobileBackground;
    var buttonRef = (0,react.useRef)(null);
    var handleClick = function(e) {
        var // Thanks Safari
        ref;
        e.stopPropagation();
        onFocus && onFocus();
        (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(zIndex ? zIndex : "z-[66px]", className, "relative"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: buttonRef,
                    type: "button",
                    onClick: handleClick,
                    className: (0,clsx_m/* default */.Z)("peer focus:border-none focus:outline-none", triggerClassName),
                    children: trigger
                }),
                mobileBackground && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0", "fixed z-10 h-screen w-screen bg-color-popup tablet:hidden", "left-0 top-[58px] opacity-0 peer-focus:opacity-100")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(!closeOnClick && "focus-within:pointer-events-auto focus-within:opacity-100", "hover:pointer-events-auto", !closeInSelect && "hover:opacity-100", hover ? "peer-hover:pointer-events-auto peer-hover:opacity-100" : "peer-focus:pointer-events-auto peer-focus:opacity-100", "z-[66] transition-all", isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0", contentClassName),
                    children: children
                })
            ]
        })
    });
}
function DropDownAlternative(props) {
    var trigger = props.trigger, children = props.children, className = props.className, contentClassName = props.contentClassName, onFocus = props.onFocus, hover = props.hover, closeOnClick = props.closeOnClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("relative", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function(event) {
                        onFocus && onFocus();
                        // thanks Safari
                        (0,_instanceof/* default */.Z)(event.target, HTMLElement) && event.target.focus();
                    },
                    className: "peer z-[66]",
                    children: trigger
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(!closeOnClick && "focus-within:pointer-events-auto focus-within:opacity-100", "hover:pointer-events-auto hover:opacity-100", hover ? "peer-hover:pointer-events-auto peer-hover:opacity-100" : "peer-focus:pointer-events-auto peer-focus:opacity-100", "pointer-events-none opacity-0", "z-[66] transition-all", contentClassName),
                    children: children
                })
            ]
        })
    });
}
function DropDownWithState(props) {
    var trigger = props.trigger, children = props.children, className = props.className, contentClassName = props.contentClassName, isOpen = props.isOpen, triggerClassName = props.triggerClassName, setIsOpen = props.setIsOpen;
    var buttonRef = (0,react.useRef)(null);
    var handleClick = function(e) {
        var // Thanks Safari
        ref;
        e.stopPropagation();
        setIsOpen(!isOpen);
        (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    var dropdownRef = (0,react.useRef)(null);
    useOutsideClick({
        ref: dropdownRef,
        handler: function() {
            return setIsOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: dropdownRef,
            className: (0,clsx_m/* default */.Z)("z-[66px]", className, "relative"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    ref: buttonRef,
                    type: "button",
                    onClick: handleClick,
                    className: (0,clsx_m/* default */.Z)("focus:border-none focus:outline-none", triggerClassName),
                    children: trigger
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("z-[66] transition-all", isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0", contentClassName),
                    children: children
                })
            ]
        })
    });
}


/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AiMusicGeneratorStorageSchema": function() { return /* binding */ AiMusicGeneratorStorageSchema; },
/* harmony export */   "ParamtersTriggerSmall": function() { return /* binding */ ParamtersTriggerSmall; },
/* harmony export */   "default": function() { return /* binding */ AiMusicGeneratorEditor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9483);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8767);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5091);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1604);
/* harmony import */ var _ai_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9264);
/* harmony import */ var _header_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1817);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9612);
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9034);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9460);
























var DEFORUM_STORAGE_KEY = "last";
var AiMusicGeneratorStorageSchema = zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_15__.z.literal("ai_music_generator").default("ai_music_generator"),
    id: zod__WEBPACK_IMPORTED_MODULE_15__.z.literal(DEFORUM_STORAGE_KEY),
    pat: zod__WEBPACK_IMPORTED_MODULE_15__.z.string()
});
var mubertResponseSchema = zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
    data: zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
        tasks: zod__WEBPACK_IMPORTED_MODULE_15__.z.array(zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
            task_id: zod__WEBPACK_IMPORTED_MODULE_15__.z.string(),
            task_status_code: zod__WEBPACK_IMPORTED_MODULE_15__.z.union([
                zod__WEBPACK_IMPORTED_MODULE_15__.z.literal(1),
                zod__WEBPACK_IMPORTED_MODULE_15__.z.literal(2), 
            ]),
            download_link: zod__WEBPACK_IMPORTED_MODULE_15__.z.string()
        }))
    })
});
function getPromptParamsOfChannels() {
    return [
        {
            id: "duration",
            type: "slider",
            kind: "normal",
            hint: "Track duration in seconds",
            defaultValue: 60,
            maxFreeValue: 300,
            name: "Duration",
            values: [
                10,
                60,
                120,
                180,
                240
            ],
            suffix: "s",
            invisible: false
        },
        {
            id: "intensity",
            type: "slider",
            kind: "step",
            hint: "The complexity of the arrangement, fewer or more instruments are playing simultaneously",
            defaultValue: 50,
            maxFreeValue: 100,
            name: "Intensity",
            values: [
                10,
                50,
                100
            ],
            suffix: "%",
            invisible: false
        }, 
    ];
}
var intensityMap = {
    10: "low",
    50: "medium",
    100: "high"
};
function fetchStatus(pat, taskId) {
    return function() {
        var _fetcher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var ref, data, response, parsed, status_code, canPlay, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        data = {
                            method: "TrackStatus",
                            params: {
                                pat: pat
                            }
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].post */ .Z.post("https://api-b2b.mubert.com/v2/TrackStatus", data).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        parsed = mubertResponseSchema.parse(response);
                        status_code = (ref = parsed.data.tasks.find(function(task) {
                            return task.task_id === taskId;
                        })) === null || ref === void 0 ? void 0 : ref.task_status_code;
                        canPlay = status_code === 2 ? true : false;
                        return [
                            2,
                            canPlay
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            false
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        function fetcher() {
            return _fetcher.apply(this, arguments);
        }
        return fetcher;
    }();
}
function AiMusicGeneratorEditor(props) {
    if (props.content.tool !== "ai_music_generator") {
        throw new Error("You are not in ai music generator editor.");
    }
    var channels = props.channels, content = props.content;
    if (channels === null) {
        throw new Error("Parameters for filters are null.");
    }
    var pat = content.pat;
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__/* .useEditorParamsContext */ .mK)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).notify;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(channels.categories[0].category_id), categoryId = ref[0], setCategoryId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), taskId = ref1[0], setTaskId = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), music = ref2[0], setMusic = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), title = ref3[0], setTitle = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), name = ref4[0], setName = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), playlist = ref5[0], setPlaylist = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)((0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/audio-visuals/default.webp")), image = ref6[0], setImage = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({}), generatingMusic = ref7[0], setGeneratingMusic = ref7[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), subscriptionPopupOpen = ref8[0], setSubscriptionPopupOpen = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), actionLoading = ref9[0], setActionLoading = ref9[1];
    var params = getPromptParamsOfChannels();
    var config = (0,_ai_config__WEBPACK_IMPORTED_MODULE_10__/* .createPromptStateFrom */ .vU)(params);
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(config), promptState = ref10[0], setPromptState = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true), fetchEnabled = ref11[0], setFetchEnabled = ref11[1];
    (0,react_query__WEBPACK_IMPORTED_MODULE_8__.useQuery)({
        queryKey: [
            "music-status",
            "task-".concat(taskId),
            "playlist-".concat(playlist), 
        ],
        queryFn: fetchStatus(pat, taskId),
        enabled: fetchEnabled && taskId !== null && playlist !== null,
        onSuccess: function(res) {
            setGeneratingMusic(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, playlist !== null && playlist !== void 0 ? playlist : "null", !res));
            });
            if (res) {
                setFetchEnabled(false);
            }
        },
        refetchInterval: 2000
    });
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_2__/* .useIndexedDB */ .i)("ai_art", "ai_music_generator", AiMusicGeneratorStorageSchema);
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var payload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "ai_music_generator",
                            id: DEFORUM_STORAGE_KEY,
                            pat: pat
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    function submitData(playlist) {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(playlist) {
            var submitData, response, result, error, notifier;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionLoading) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setActionLoading(true);
                        setGeneratingMusic(function(prev) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, playlist, true));
                        });
                        submitData = {
                            method: "RecordTrack",
                            params: {
                                pat: pat,
                                playlist: playlist,
                                duration: promptState ? promptState["duration"] : "60",
                                format: "mp3",
                                intensity: promptState ? intensityMap[Number(promptState["intensity"])] : "medium",
                                bitrate: "320"
                            }
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].post */ .Z.post("https://api-b2b.mubert.com/v2/RecordTrack", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        result = mubertResponseSchema.parse(response);
                        setTaskId(result.data.tasks[0].task_id);
                        setMusic(result.data.tasks[0].download_link);
                        setFetchEnabled(true);
                        setActionLoading(false);
                        setPlaylist(playlist);
                        window.removeEventListener("beforeunload", handleLeave);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        notifier = (0,_utils_trigger__WEBPACK_IMPORTED_MODULE_4__/* .withNotify */ .nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_13__/* .ErrorMessage */ .Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    var canPlay = music !== null && music.trim().length !== 0 && !Object.values(generatingMusic).some(function(value) {
        return value === true;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full justify-center overflow-y-scroll",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative mx-auto mb-[70px] mt-4 flex w-full flex-col gap-4 tablet:mb-[100px] tablet:mt-4 tablet:w-[727px] tablet:gap-8 desktop:my-[100px] desktop:w-[975px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                window.removeEventListener("beforeunload", handleLeave);
                                if (router.asPath === "/editor/ai-music-generator") {
                                    router.back();
                                }
                                editor.closePage();
                                return [
                                    2
                                ];
                            });
                        }),
                        className: "group absolute left-[0] hidden flex-row items-center gap-3 desktop:top-[-70px] desktop:flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex h-9 w-9 items-center justify-center rounded-full bg-color-cell inner-border inner-border-[transparent] group-hover:inner-border-color-separator",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_12__/* .CustomThemedResource */ .aK, {
                                    format: "svg",
                                    source: "/general/arrow",
                                    className: "rotate-180"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-lg font-500 text-blue-700 group-hover:text-blue-900",
                                children: t("lbl_back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-row items-center justify-between pr-4 tablet:p-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "no-scrollbar flex flex-1 flex-row overflow-x-scroll pl-4 tablet:overflow-auto tablet:p-0 desktop:gap-1",
                                children: channels.categories.map(function(cat) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return setCategoryId(cat.category_id);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-9 rounded-[9px] border px-[18px] text-[16px] font-500 transition-all desktop:h-11 desktop:rounded-[14px] desktop:border-[2px]", categoryId === cat.category_id ? " border-primary-500 bg-color-cell text-primary-500" : " border-[transparent] text-blue-700"),
                                        children: cat.name
                                    }, cat.category_id);
                                })
                            }),
                            promptState && config && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParamtersTriggerSmall, {
                                params: params,
                                actionLoading: actionLoading,
                                promptState: promptState,
                                setPromptState: setPromptState,
                                showFiltered: JSON.stringify(promptState) !== JSON.stringify(config),
                                className: "!py-[18px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid w-full grid-cols-1 px-4 tablet:px-0",
                        children: channels.categories.map(function(cat) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    gridColumnStart: 1,
                                    gridRowStart: 1
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("flex w-full flex-col gap-4 transition-all tablet:grid tablet:grid-cols-3", categoryId !== cat.category_id ? "pointer-events-none h-[400px] translate-y-12 overflow-hidden opacity-0 delay-0 tablet:h-[200px]" : "translate-y-0 opacity-100 delay-200"),
                                children: cat.groups.map(function(group) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative flex h-[70px] w-full shrink-0 overflow-hidden rounded-[12px] tablet:h-[196px] tablet:rounded-[10px] desktop:h-[193px] desktop:rounded-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/audio-visuals/".concat(group.name.toLowerCase().replace(/\s/g, ""), ".webp")),
                                                alt: group.name,
                                                onErrorCapture: function(e) {
                                                    return e.currentTarget.src = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/audio-visuals/default.webp");
                                                },
                                                className: "h-full w-full object-cover"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pointer-events-none absolute left-0 top-0 z-0 h-full w-[130px] bg-gradient-to-r from-color-black/50 via-color-black/20 to-[transparent] tablet:hidden"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "absolute bottom-0 left-0 z-[1] flex h-full w-full flex-row items-center justify-between pl-5 pr-4 tablet:h-[66px] tablet:bg-[#00000020] tablet:px-[14px] tablet:py-[14px] tablet:backdrop-blur-[22px] desktop:px-[10px]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-[19px] font-500 text-color-white tablet:text-[14px] tablet:font-600 tablet:text-[#ECEDEF] desktop:text-[16px]",
                                                        children: group.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        disabled: Object.values(generatingMusic).some(function(value) {
                                                            return value === true;
                                                        }),
                                                        onClick: function() {
                                                            if (isPro) {
                                                                setImage((0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/audio-visuals/".concat(group.name.toLowerCase().replace(/\s/g, ""), ".webp")));
                                                                setTitle(cat.name);
                                                                setName(group.name);
                                                                submitData(group.playlist);
                                                            } else {
                                                                setSubscriptionPopupOpen(true);
                                                            }
                                                        },
                                                        className: "flex h-[38px] flex-row items-center gap-[6px] rounded-[8px] bg-[#00000038] px-5 text-[16px] font-500 text-color-white backdrop-blur-[16px] [--icon-color:var(--color-white)] disabled:cursor-not-allowed tablet:px-3 tablet:text-[14px] tablet:backdrop-blur-0 desktop:text-[16px]",
                                                        children: [
                                                            generatingMusic[group.playlist] === undefined ? (0,_header_icon__WEBPACK_IMPORTED_MODULE_11__/* .musicGeneratorIcon */ .rL)() : generatingMusic[group.playlist] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/loading-small.webp"),
                                                                alt: "loading small",
                                                                className: " h-4 animate-[spin_1s_infinite_linear]"
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/regenerate.webp"),
                                                                alt: "regenerate icon",
                                                                className: " h-4"
                                                            }),
                                                            generatingMusic[group.playlist] === undefined || generatingMusic[group.playlist] ? t("lbl_generate") : t("txt_regenerate")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, group.playlist);
                                })
                            }, cat.category_id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[150px] w-full shrink-0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AudioPlayer, {
                music: music,
                canPlay: canPlay,
                title: title,
                name: name,
                image: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_subscription_popup__WEBPACK_IMPORTED_MODULE_14__/* .SubscriptionPopup */ .yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: "/editor/ai-music-generator",
                addToStorage: addToStorage
            })
        ]
    });
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function formatTime(time) {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time % 60);
    return "".concat(minutes.toString().padStart(2, "0"), ":").concat(seconds.toString().padStart(2, "0"));
}
function AudioPlayer(props) {
    var ref, ref1, ref2, ref3;
    var music = props.music, canPlay = props.canPlay, title = props.title, name = props.name, image = props.image;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true), isPlaying = ref4[0], setIsPlaying = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("00:00"), currentTime = ref5[0], setCurrentTime = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(0), currentNumber = ref6[0], setCurrentNumber = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), isDragging = ref7[0], setIsDragging = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(100), volumePercentage = ref8[0], setVolumePercentage = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), isVolumeDragging = ref9[0], setIsVolumeDragging = ref9[1];
    var volumeBarRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var audioRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var progressBarRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (canPlay && music) {
            navigator.mediaSession.metadata = new window.MediaMetadata({
                title: title,
                artist: name,
                artwork: [
                    {
                        src: image,
                        sizes: "312x312",
                        type: "image/webp"
                    }, 
                ]
            });
        } else {
            navigator.mediaSession.metadata = null;
        }
        return function() {
            navigator.mediaSession.metadata = null;
        };
    }, [
        canPlay,
        image,
        music,
        name,
        title
    ]);
    var handleProgressBarClick = function(event) {
        if (!progressBarRef.current || !audioRef.current) return;
        var progressBarWidth = progressBarRef.current.clientWidth;
        var clickPositionX = event.clientX - progressBarRef.current.getBoundingClientRect().left;
        var newPositionInSeconds = clickPositionX / progressBarWidth * audioRef.current.duration;
        audioRef.current.currentTime = newPositionInSeconds;
    };
    var handlePointerDown = function(event) {
        event.preventDefault();
        setIsDragging(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var progressBar = progressBarRef.current;
        var audio = audioRef.current;
        if (!progressBar || !audio) return;
        progressBar.focus();
        var handlePointerUp = function() {
            window.removeEventListener("pointerup", handlePointerUp);
            window.removeEventListener("pointermove", handlePointerMove);
            setIsDragging(false);
        };
        var handlePointerMove = function(event) {
            if (!progressBar || !audio || !isDragging || !event.clientX) {
                return;
            }
            var progressBarWidth = progressBar.clientWidth;
            var clickPositionX = event.clientX - progressBar.getBoundingClientRect().left;
            var newPositionInSeconds = clickPositionX / progressBarWidth * audio.duration;
            setCurrentNumber(Math.min(newPositionInSeconds, audio.duration));
            audio.currentTime = newPositionInSeconds;
        };
        progressBar.addEventListener("pointerdown", function(event) {
            event.preventDefault();
            setIsDragging(true);
        });
        window.addEventListener("pointermove", handlePointerMove);
        window.addEventListener("pointerup", handlePointerUp);
        return function() {
            window.removeEventListener("pointermove", handlePointerMove);
            window.removeEventListener("pointerup", handlePointerUp);
        };
    }, [
        progressBarRef,
        audioRef,
        isDragging
    ]);
    var handleVolumeBarClick = function(event) {
        if (!volumeBarRef.current || !audioRef.current) return;
        var volumeBarWidth = volumeBarRef.current.clientWidth;
        var clickPositionX = event.clientX - volumeBarRef.current.getBoundingClientRect().left;
        var newVolumePercentage = clickPositionX / volumeBarWidth * 100;
        setVolumePercentage(newVolumePercentage);
        var newVolume = newVolumePercentage / 100;
        audioRef.current.volume = newVolume;
    };
    var handleVolumeBarMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function(event) {
        event.preventDefault();
        setIsVolumeDragging(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var volumeBar = volumeBarRef.current;
        var audio = audioRef.current;
        if (!volumeBar || !audio) return;
        volumeBar.focus();
        var handleMouseUp = function() {
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("mousemove", handleVolumeBarDrag);
            setIsVolumeDragging(false);
        };
        var handleVolumeBarDrag = function(event) {
            if (!volumeBar || !audio || !isVolumeDragging || !event.clientX) return;
            var volumeBarWidth = volumeBar.clientWidth;
            var newVolumePercentage = (event.clientX - volumeBar.getBoundingClientRect().left) / volumeBarWidth * 100;
            newVolumePercentage = Math.max(0, Math.min(100, newVolumePercentage));
            setVolumePercentage(newVolumePercentage);
            var newVolume = newVolumePercentage / 100;
            audio.volume = newVolume;
        };
        volumeBar === null || volumeBar === void 0 ? void 0 : volumeBar.addEventListener("mousedown", function(event) {
            event.preventDefault();
            setIsVolumeDragging(true);
        });
        window.addEventListener("mousemove", handleVolumeBarDrag);
        window.addEventListener("mouseup", handleMouseUp);
        return function() {
            window.removeEventListener("mousemove", handleVolumeBarDrag);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        volumeBarRef,
        audioRef,
        isVolumeDragging,
        handleVolumeBarMouseDown, 
    ]);
    var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function(event) {
        event.preventDefault();
        if (!audioRef.current) return;
        if (event.key === "ArrowUp") {
            var newVolumePercentage = Math.min(volumePercentage + 10, 100);
            setVolumePercentage(newVolumePercentage);
            audioRef.current.volume = newVolumePercentage / 100;
        } else if (event.key === "ArrowDown") {
            var newVolumePercentage1 = Math.max(volumePercentage - 10, 0);
            setVolumePercentage(newVolumePercentage1);
            audioRef.current.volume = newVolumePercentage1 / 100;
        }
    }, [
        volumePercentage
    ]);
    var handleAudioKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function(event) {
        event.preventDefault();
        var progressBar = progressBarRef.current;
        var audio = audioRef.current;
        if (!progressBar || !audio) return;
        if (event.key === "ArrowLeft") {
            audio.currentTime -= 10;
        } else if (event.key === "ArrowRight") {
            audio.currentTime += 10;
        }
    }, []);
    if (music === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    var ref10, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("fixed bottom-6 flex w-full items-center justify-center overscroll-none px-4 transition-all tablet:px-0 desktop:bottom-10", canPlay ? "translate-y-0" : "pointer-events-none translate-y-[100px] opacity-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative flex h-[60px] w-full flex-row justify-between overflow-hidden rounded-[10px] bg-color-cell p-[10px] tablet:h-[114px] tablet:w-[745px] tablet:gap-4 tablet:rounded-[20px] tablet:p-5 desktop:w-[975px] desktop:gap-7",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none absolute left-0 top-0 h-full w-[60%] blur-[30px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: image,
                            alt: title + " - " + name,
                            className: "h-full w-full opacity-70 blur-[30px] tablet:opacity-50"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pointer-events-none z-[2] flex flex-row items-center gap-2 tablet:gap-[15px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: image,
                                alt: title + " - " + name,
                                className: "aspect-1 h-full rounded-[10px] object-cover"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[16px] font-500 leading-5 text-blue-800 tablet:leading-normal",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[13px] font-400 leading-4 text-blue-700 tablet:leading-normal",
                                        children: name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "z-[1] flex flex-row items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                className: "relative hidden h-6 w-6 overflow-hidden tablet:block",
                                onClick: function() {
                                    var ref;
                                    if ((ref = audioRef.current) === null || ref === void 0 ? void 0 : ref.paused) {
                                        setIsPlaying(true);
                                        audioRef.current.play();
                                    } else {
                                        var ref1;
                                        setIsPlaying(false);
                                        (ref1 = audioRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute left-0 top-0 flex items-center transition-opacity [--icon-color:var(--color-blue-700)]", !isPlaying && "opacity-0"),
                                        children: pauseIcon()
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute left-0 top-0 flex items-center transition-opacity [--icon-color:var(--color-blue-700)]", isPlaying && "opacity-0"),
                                        children: playIcon()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "hidden w-[35px] text-[12px] font-500 text-blue-700 tablet:block",
                                children: currentTime
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                ref: progressBarRef,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("group absolute left-0 top-0 h-full w-full cursor-pointer focus:outline-none", "tablet:relative tablet:h-1 tablet:w-[257px] tablet:rounded-md tablet:bg-blue-200 desktop:w-[284px]"),
                                onClick: function(event) {
                                    return handleProgressBarClick(event);
                                },
                                onPointerDown: handlePointerDown,
                                onKeyDown: handleAudioKeyDown,
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            width: "".concat(currentNumber / ((ref10 = (ref = audioRef.current) === null || ref === void 0 ? void 0 : ref.duration) !== null && ref10 !== void 0 ? ref10 : 1) * 100, "%")
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute hidden h-full rounded-md transition-colors tablet:block", isDragging ? "bg-blue-800" : "bg-blue-700")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute top-0 hidden h-[10px] w-[10px] -translate-x-[5px] -translate-y-[3px]", "transform rounded-full bg-blue-800 transition-opacity inner-border-[1px] inner-border-blue-400 tablet:block", isDragging ? "opacity-100" : "opacity-0 hover:opacity-100 group-hover:opacity-100"),
                                        style: {
                                            left: "".concat(currentNumber / ((ref11 = (ref1 = audioRef.current) === null || ref1 === void 0 ? void 0 : ref1.duration) !== null && ref11 !== void 0 ? ref11 : 1) * 100, "%")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            left: "".concat(currentNumber / ((ref12 = (ref2 = audioRef.current) === null || ref2 === void 0 ? void 0 : ref2.duration) !== null && ref12 !== void 0 ? ref12 : 1) * 100, "%")
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute top-0 h-full w-[144px] -translate-x-full bg-gradient-to-l to-[transparent] transition-colors tablet:hidden", isDragging ? "from-[#ff316470]" : "from-[#ff31643c]")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "hidden w-[35px] text-[12px] font-500 text-blue-700 tablet:block",
                                children: formatTime((ref13 = (ref3 = audioRef.current) === null || ref3 === void 0 ? void 0 : ref3.duration) !== null && ref13 !== void 0 ? ref13 : 0)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "hidden flex-row items-center gap-2 desktop:flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    if (!audioRef.current || !volumeBarRef.current) return;
                                    volumeBarRef.current.focus();
                                    if (volumePercentage > 0) {
                                        audioRef.current.volume = 0;
                                        setVolumePercentage(0);
                                    } else {
                                        audioRef.current.volume = 0.7;
                                        setVolumePercentage(70);
                                    }
                                },
                                className: "h-6 w-6 [--icon-color:var(--color-blue-700)]",
                                children: volumePercentage > 50 ? volumeFullIcon() : volumePercentage !== 0 ? volumeHalfIcon() : volumeMuteIcon()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                ref: volumeBarRef,
                                className: "group relative h-1 w-[70px] cursor-pointer rounded-md bg-blue-200 focus:outline-none",
                                onClick: function(event) {
                                    return handleVolumeBarClick(event);
                                },
                                onMouseDown: handleVolumeBarMouseDown,
                                onKeyDown: handleKeyDown,
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            width: "".concat(volumePercentage, "%")
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute h-full rounded-md transition-colors", isVolumeDragging ? "bg-blue-800" : "bg-blue-700")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute top-0 h-[10px] w-[10px] -translate-x-[5px] -translate-y-[3px] transform rounded-full bg-blue-800 transition-opacity inner-border-[1px] inner-border-blue-400", isVolumeDragging ? "opacity-100" : "opacity-0 hover:opacity-100 group-hover:opacity-100"),
                                        style: {
                                            left: "".concat(volumePercentage, "%")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "z-[1] flex flex-row items-center gap-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                className: "relative h-6 w-6 overflow-hidden tablet:pointer-events-none tablet:hidden",
                                onClick: function() {
                                    var ref;
                                    if ((ref = audioRef.current) === null || ref === void 0 ? void 0 : ref.paused) {
                                        setIsPlaying(true);
                                        audioRef.current.play();
                                    } else {
                                        var ref1;
                                        setIsPlaying(false);
                                        (ref1 = audioRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute left-0 top-0 flex items-center transition-opacity [--icon-color:var(--color-blue-700)]", !isPlaying && "opacity-0"),
                                        children: pauseIcon()
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute left-0 top-0 flex items-center transition-opacity [--icon-color:var(--color-blue-700)]", isPlaying && "opacity-0"),
                                        children: playIcon()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/api/download-music?link=".concat(encodeURIComponent(music)),
                                target: "_blank",
                                rel: "noreferrer noopener",
                                download: title + " - " + name,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-10 w-10 rounded-full bg-primary-500", "transition-colors tablet:pointer-events-none tablet:hidden", "flex flex-row items-center justify-center"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-4 w-4"),
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/download.webp"),
                                    alt: "download"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: "/api/download-music?link=".concat(encodeURIComponent(music)),
                                target: "_blank",
                                rel: "noreferrer noopener",
                                download: title + " - " + name,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-11 rounded-[8px] font-500 tablet:w-[129px] desktop:w-[171px]", "text-[16px] text-color-white", "hover:bg-primary-600 bg-primary-500", "hidden transition-colors", "flex-row items-center justify-center gap-1 tablet:flex"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-4 w-4"),
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/ai-music-generator/download.webp"),
                                            alt: "download"
                                        })
                                    }),
                                    t("lbl_download")
                                ]
                            })
                        ]
                    })
                ]
            }),
            canPlay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("audio", {
                ref: audioRef,
                playsInline: true,
                autoPlay: true,
                loop: true,
                title: title + " - " + name,
                onTimeUpdate: function(e) {
                    setCurrentTime(formatTime(e.currentTarget.currentTime));
                    setCurrentNumber(e.currentTarget.currentTime);
                },
                className: "h-0 w-0 opacity-0",
                src: music
            })
        ]
    });
}
function ParamtersTriggerSmall(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), open = ref[0], setOpen = ref[1];
    var actionLoading = props.actionLoading, className = props.className, params = props.params, showFiltered = props.showFiltered;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: function() {
                    if (actionLoading) return;
                    setOpen(true);
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("group relative flex h-11 w-11 items-center justify-center gap-2 rounded-[11px] border border-blue-200 bg-color-cell transition-all desktop:w-[77px] desktop:rounded-[15px] desktop:border-none desktop:px-4 desktop:py-6 desktop:hover:bg-blue-200", className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        width: "21",
                        height: "20",
                        viewBox: "0 0 21 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M17.9998 3.33203H12.1665",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M8.83309 3.33203H2.99976",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M18 10H10.5",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.16667 10H3",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M17.9997 16.6641H13.833",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M10.5 16.6641H3",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M12.1663 1.66406V4.9974",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.1665 8.33203V11.6654",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M13.833 15V18.3333",
                                stroke: "#888CA0",
                                strokeWidth: "1.66667",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute right-[-2px] top-[-2px] h-2 w-2 rounded-full bg-primary-500 transition-opacity desktop:right-[0px] desktop:top-[1px]", showFiltered ? "opacity-100" : "opacity-0")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_10__/* .RestyleConfigurator */ .BQ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, props), {
                open: open,
                setOpen: setOpen,
                params: params
            }))
        ]
    });
}
var playIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.1198 13.68C20.3378 12.8919 20.3378 11.1098 19.1198 10.3217L7.80134 2.99798C6.47062 2.13692 4.71484 3.09211 4.71484 4.67712V19.3245C4.71484 20.9095 6.47062 21.8647 7.80135 21.0037L19.1198 13.68Z",
            fill: "var(--icon-color)"
        })
    });
};
var pauseIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "4.65039",
                y: "2.84961",
                width: "5.1",
                height: "18.3",
                rx: "2.55",
                fill: "var(--icon-color)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "14.25",
                y: "2.84961",
                width: "5.1",
                height: "18.3",
                rx: "2.55",
                fill: "var(--icon-color)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            })
        ]
    });
};
var volumeFullIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2 9.99979V13.9998C2 15.9998 3 16.9998 5 16.9998H6.43C6.8 16.9998 7.17 17.1098 7.49 17.2998L10.41 19.1298C12.93 20.7098 15 19.5598 15 16.5898V7.40979C15 4.42979 12.93 3.28979 10.41 4.86979L7.49 6.69979C7.17 6.88979 6.8 6.99979 6.43 6.99979H5C3 6.99979 2 7.99979 2 9.99979Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 8C19.78 10.37 19.78 13.63 18 16",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.8301 5.5C22.7201 9.35 22.7201 14.65 19.8301 18.5",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var volumeHalfIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2 9.99979V13.9998C2 15.9998 3 16.9998 5 16.9998H6.43C6.8 16.9998 7.17 17.1098 7.49 17.2998L10.41 19.1298C12.93 20.7098 15 19.5598 15 16.5898V7.40979C15 4.42979 12.93 3.28979 10.41 4.86979L7.49 6.69979C7.17 6.88979 6.8 6.99979 6.43 6.99979H5C3 6.99979 2 7.99979 2 9.99979Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18 8C19.78 10.37 19.78 13.63 18 16",
                stroke: "var(--icon-color)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var volumeMuteIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2 9.99979V13.9998C2 15.9998 3 16.9998 5 16.9998H6.43C6.8 16.9998 7.17 17.1098 7.49 17.2998L10.41 19.1298C12.93 20.7098 15 19.5598 15 16.5898V7.40979C15 4.42979 12.93 3.28979 10.41 4.86979L7.49 6.69979C7.17 6.88979 6.8 6.99979 6.43 6.99979H5C3 6.99979 2 7.99979 2 9.99979Z",
            stroke: "var(--icon-color)",
            strokeWidth: "1.5"
        })
    });
};


/***/ }),

/***/ 8641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFORUM_STORAGE_KEY": function() { return /* binding */ DEFORUM_STORAGE_KEY; },
/* harmony export */   "MIN_INPUT_CHARACTERS": function() { return /* binding */ MIN_INPUT_CHARACTERS; },
/* harmony export */   "MIN_RESOLUTION": function() { return /* binding */ MIN_RESOLUTION; },
/* harmony export */   "ParamsContext": function() { return /* binding */ ParamsContext; },
/* harmony export */   "createInputs": function() { return /* binding */ createInputs; },
/* harmony export */   "default": function() { return /* binding */ DeformEditor; },
/* harmony export */   "deforumStorageSchema": function() { return /* binding */ deforumStorageSchema; },
/* harmony export */   "getAcceptedMimes": function() { return /* binding */ getAcceptedMimes; },
/* harmony export */   "promptSchema": function() { return /* binding */ promptSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(788);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4371);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9483);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6961);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8767);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5091);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1604);
/* harmony import */ var _ai_config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9264);
/* harmony import */ var _border_input__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3607);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9612);
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9034);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9460);


























var DEFORUM_STORAGE_KEY = "last";
var ParamsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_9__.createContext)(null);
function getAcceptedMimes() {
    return [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/quicktime", 
    ].join(",");
}
var remoteStorageSchema = zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal("remote"),
    url: zod__WEBPACK_IMPORTED_MODULE_17__.z.string()
});
var localStorageSchema = zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal("local"),
    blob: zod__WEBPACK_IMPORTED_MODULE_17__.z.unknown()
});
var deforumStorageSchema = zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal("deform").default("deform"),
    id: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_17__.z.string(),
    inputs: zod__WEBPACK_IMPORTED_MODULE_17__.z.array(zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
        id: zod__WEBPACK_IMPORTED_MODULE_17__.z.string(),
        text: zod__WEBPACK_IMPORTED_MODULE_17__.z.string()
    }))
}).and(zod__WEBPACK_IMPORTED_MODULE_17__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var MAX_INPUTS = 4;
var promptSchema = zod__WEBPACK_IMPORTED_MODULE_17__.z.union([
    zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
        type: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal("custom"),
        content: zod__WEBPACK_IMPORTED_MODULE_17__.z.array(zod__WEBPACK_IMPORTED_MODULE_17__.z.string())
    }),
    zod__WEBPACK_IMPORTED_MODULE_17__.z.object({
        type: zod__WEBPACK_IMPORTED_MODULE_17__.z.literal("predefined"),
        id: zod__WEBPACK_IMPORTED_MODULE_17__.z.string()
    }), 
]);
function uuid() {
    return Math.random().toString();
}
function createInput() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        text: text,
        id: uuid()
    };
}
function createInputs(initial) {
    if (initial.type === "predefined") {
        return [
            createInput()
        ];
    }
    return initial.content.map(createInput);
}
function updateInput(input, text) {
    return {
        id: input.id,
        text: text
    };
}
var MIN_INPUT_CHARACTERS = 3;
var MIN_RESOLUTION = 450;
function DeformEditor(props) {
    var ref;
    if (props.content.tool !== "deform") {
        throw new Error("You are not in deform editor.");
    }
    if (props.blob === null) {
        throw new Error("No file uploaded.");
    }
    var content = props.content, parameters = props.params, file = props.blob;
    if (parameters === null) {
        throw new Error("Parameters for filters are null.");
    }
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(), uploadedUrl = ref1[0], setUploadedUrl = ref1[1];
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_11__/* .useEditorParamsContext */ .mK)();
    var styles = parameters.styles, params = parameters.params;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(content.inputs), inputs = ref2[0], setInputs = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(content.promptType), promptType = ref3[0], setPromptType = ref3[1];
    var fileType = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(function() {
        return getFileType(file);
    }, [
        file
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(null), getData = ref4[0], setDataGetter = ref4[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_4__/* .NotificationContext */ .u).notify;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().userInfo;
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var initialConfig = (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .createPromptStateFrom */ .vU)(params.params);
    var sectionsConfig = params.sections ? params.sections.map(function(section) {
        return (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .createPromptStateFrom */ .vU)(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, acc, section) : acc;
    }, initialConfig || {}) : initialConfig || {};
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(config), promptState = ref5[0], setPromptState = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), subscriptionPopupOpen = ref6[0], setSubscriptionPopupOpen = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), actionLoading = ref7[0], setActionLoading = ref7[1];
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_1__/* .useAdjustLogger */ .eW)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_10__.useQueryClient)();
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_3__/* .useIndexedDB */ .i)("ai_art", "deform", deforumStorageSchema);
    function submitData() {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var image, prompts, res, resolution, dimensions, changedDimensions, url, ref, upload, download, contentType, submitData, error, notifier;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionLoading) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            9,
                            ,
                            10
                        ]);
                        if (!getData) {
                            throw new Error("Should have set getData");
                        }
                        setActionLoading(true);
                        return [
                            4,
                            getData.getter()
                        ];
                    case 2:
                        image = _state.sent();
                        prompts = promptType === "custom" ? {
                            type: "custom",
                            content: inputs.map(function(input) {
                                return input.text;
                            })
                        } : {
                            type: "predefined",
                            id: promptType
                        };
                        res = null;
                        if (promptState && promptState["resolution"]) res = Number(promptState["resolution"]);
                        resolution = res !== null && res !== void 0 ? res : MIN_RESOLUTION;
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_6__/* .getImageDimensions */ .pz)(image)
                        ];
                    case 3:
                        dimensions = _state.sent();
                        changedDimensions = resizeDimensions(dimensions, resolution);
                        url = uploadedUrl;
                        if (!!url) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: image.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 4:
                        ref = _state.sent(), upload = ref.upload, download = ref.download, contentType = ref.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].put */ .Z.put(upload, image, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 5:
                        _state.sent();
                        url = download;
                        setUploadedUrl(url);
                        _state.label = 6;
                    case 6:
                        submitData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                            url: url,
                            prompts: prompts,
                            tool: "deform",
                            params: promptState !== null && promptState !== void 0 ? promptState : {
                                resolution: 720
                            }
                        }, changedDimensions);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 7:
                        _state.sent();
                        if (promptType === "custom") {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_prompt_writing");
                        } else {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_select_style");
                        }
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_generate");
                        window.removeEventListener("beforeunload", handleLeave);
                        queryClient.invalidateQueries("coins");
                        return [
                            4,
                            router.push("/profile/generations/all")
                        ];
                    case 8:
                        _state.sent();
                        editor.closePage();
                        setActionLoading(false);
                        return [
                            3,
                            10
                        ];
                    case 9:
                        error = _state.sent();
                        notifier = (0,_utils_trigger__WEBPACK_IMPORTED_MODULE_5__/* .withNotify */ .nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_15__/* .ErrorMessage */ .Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var payload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "deform",
                            id: DEFORUM_STORAGE_KEY,
                            inputs: inputs,
                            promptType: promptType,
                            location: "local",
                            blob: file
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    var canEditPrompts = promptType === "custom";
    var _length;
    var firstInputLength = (_length = (ref = inputs.at(0)) === null || ref === void 0 ? void 0 : ref.text.length) !== null && _length !== void 0 ? _length : 0;
    var isFirstInputCorrect = firstInputLength >= MIN_INPUT_CHARACTERS;
    var canSubmit = promptType !== "custom" || isFirstInputCorrect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParamsContext.Provider, {
        value: params,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full justify-center overflow-y-scroll",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mx-auto my-[24px] flex w-[1175] gap-[25px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-[calc(70vh/16*9)] min-w-[300px] max-w-[575px]",
                            id: "media-preview",
                            children: [
                                fileType === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImagePreview, {
                                    file: file,
                                    setDataGetter: setDataGetter,
                                    closePage: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                                            window.removeEventListener("beforeunload", handleLeave);
                                            if (router.asPath === "/editor/deform") {
                                                router.back();
                                            }
                                            editor.closePage();
                                            return [
                                                2
                                            ];
                                        });
                                    })
                                }),
                                fileType === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoPreviewWithFrames, {
                                    file: file,
                                    setDataGetter: setDataGetter,
                                    closePage: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                                            window.removeEventListener("beforeunload", handleLeave);
                                            editor.closePage();
                                            return [
                                                2
                                            ];
                                        });
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-[575px] flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("flex flex-col items-stretch gap-[22px] rounded-[15px] bg-color-cell px-6 pb-[22px] pt-[16px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-[16px] font-700 text-blue-600",
                                                    children: t("lbl_styles")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute bottom-0 right-0 z-10 h-3 w-full bg-gradient-to-t from-color-cell to-color-white/0"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "no-scrollbar grid max-h-[340px] grid-cols-3 gap-2 overflow-y-scroll pb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === "custom" ? "border-primary-500 bg-[#FF31661F]" : "bg-blue-100", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors", "flex flex-col items-center justify-center gap-1"),
                                                            onClick: function() {
                                                                return setPromptType("custom");
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_14__/* .CustomThemedResource */ .aK, {
                                                                    format: "svg",
                                                                    source: "/general/custom-prompt",
                                                                    alt: "custom prompt"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-600 text-blue-800",
                                                                    children: t("lbl_custom")
                                                                })
                                                            ]
                                                        }),
                                                        styles.map(function(param) {
                                                            var name = param.name, id = param.id, image = param.image;
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === id && "border-primary-500", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors"),
                                                                onClick: function() {
                                                                    return setPromptType(id);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: image,
                                                                        alt: "cover of ".concat(name, " style"),
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("pointer-events-none h-full w-full object-cover")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "absolute bottom-0 left-0 h-8 w-full bg-gradient-to-t from-color-black/60 to-[transparent]"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "absolute bottom-1 left-2 text-[13px] font-600 text-color-white",
                                                                        children: name
                                                                    })
                                                                ]
                                                            }, id);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        canEditPrompts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-[16px] font-700 text-blue-600 transition-opacity",
                                                    children: t("lbl_prompts")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("no-scrollbar flex max-h-[312px] shrink-0 flex-col items-stretch gap-3 overflow-y-scroll", "transition-opacity", actionLoading && "opacity-30"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex flex-col items-stretch gap-3",
                                                        children: inputs.map(function(input, index) {
                                                            var isLast = index === inputs.length - 1;
                                                            var isNotFull = inputs.length < MAX_INPUTS;
                                                            var canAddPrompts = canEditPrompts && isLast && isNotFull;
                                                            var canDeletePrompts = canEditPrompts && inputs.length > 1;
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("relative"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_border_input__WEBPACK_IMPORTED_MODULE_13__/* .BorderTextareaResizable */ .NW, {
                                                                        placeholder: t("txt_prompt_placeholder"),
                                                                        setValue: function(content) {
                                                                            var newInput = createInput();
                                                                            if (canAddPrompts) {
                                                                                setInputs(function(oldInputs) {
                                                                                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(oldInputs.map(function(old, i) {
                                                                                        return i === index ? updateInput(old, content) : old;
                                                                                    })).concat([
                                                                                        newInput, 
                                                                                    ]);
                                                                                });
                                                                            } else if (canDeletePrompts && content === "") {
                                                                                setInputs(function(oldInputs) {
                                                                                    return oldInputs.filter(function(_, i) {
                                                                                        return i !== index;
                                                                                    });
                                                                                });
                                                                            } else {
                                                                                setInputs(function(oldInputs) {
                                                                                    return oldInputs.map(function(old, i) {
                                                                                        return i === index ? updateInput(old, content) : old;
                                                                                    });
                                                                                });
                                                                            }
                                                                        },
                                                                        disabled: !canEditPrompts,
                                                                        className: "group inline-block w-full resize-none !pr-10",
                                                                        autoCorrect: "off"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        disabled: !canDeletePrompts,
                                                                        onClick: function() {
                                                                            var newInputs = inputs.filter(function(_, i) {
                                                                                return i !== index;
                                                                            });
                                                                            setInputs(newInputs);
                                                                        },
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute right-2 top-[9px] h-8 w-8 rounded-full bg-color-cell transition-opacity", "flex flex-col items-center justify-center outline-none focus:bg-[#ff316630]", canDeletePrompts ? "opacity-100 disabled:opacity-50" : "pointer-events-none opacity-0"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/trash-icon.svg"),
                                                                            alt: "remove this prompt"
                                                                        })
                                                                    })
                                                                ]
                                                            }, input.id);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                promptState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .ParamtersTrigger */ .dS, {
                                    actionLoading: actionLoading,
                                    promptState: promptState,
                                    setPromptState: setPromptState
                                }),
                                isPro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    disabled: fileType === "unrecognized" || !canSubmit,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "hover:bg-primary-600 bg-primary-500", "relative py-3 transition-colors", "flex items-center justify-center gap-4", actionLoading && "pointer-events-none"),
                                    onClick: function() {
                                        if (actionLoading) return;
                                        submitData();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("h-6 w-6 animate-[spin_1s_infinite_linear]", actionLoading ? "opacity-100" : "opacity-0"),
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/loading-dark.webp"),
                                                alt: "loading"
                                            })
                                        }),
                                        t("lbl_generate"),
                                        promptState && params.params && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostsCoins, {
                                            coins: getPromptPrice(promptState, params.params, params.price)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: fileType === "unrecognized" || actionLoading,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "bg-[#2F91FD] hover:bg-[#0264CF]", "py-3 transition-colors"),
                                    onClick: function() {
                                        setSubscriptionPopupOpen(true);
                                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_subscribe_to_continue");
                                    },
                                    children: t("txt_subscribe_to_continue")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[70px] w-full shrink-0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_subscription_popup__WEBPACK_IMPORTED_MODULE_16__/* .SubscriptionPopup */ .yj, {
                    isOpen: subscriptionPopupOpen,
                    close: function() {
                        return setSubscriptionPopupOpen(false);
                    },
                    location: "/editor/deform",
                    addToStorage: addToStorage
                })
            ]
        })
    });
}
function getFileType(file) {
    try {
        if (file.type.startsWith("video")) {
            return "video";
        }
        if (file.type.startsWith("image")) {
            return "image";
        }
    } catch (e) {}
    return "unrecognized";
}
function resizeDimensions(dimensions, max) {
    if (Math.max(dimensions.width, dimensions.height) < max) {
        return dimensions;
    }
    if (dimensions.width > dimensions.height) {
        return {
            width: Math.floor(max / dimensions.height * dimensions.width),
            height: max
        };
    }
    return {
        width: max,
        height: Math.floor(max / dimensions.width * dimensions.height)
    };
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function ImagePreview(props) {
    var file = props.file, setDataGetter = props.setDataGetter, closePage = props.closePage;
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        setDataGetter({
            getter: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                    return [
                        2,
                        file
                    ];
                });
            })
        });
    }, [
        file,
        setDataGetter
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "group absolute left-2 top-2 z-50 flex h-5 w-5 items-center justify-center rounded-full bg-blue-300 hover:bg-blue-400",
                onClick: closePage,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "group-hover:hidden",
                        alt: "close icon",
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle.svg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "hidden group-hover:block dark:hidden dark:group-hover:hidden",
                        alt: "close icon",
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle-hover.svg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "hidden dark:hidden dark:group-hover:block",
                        alt: "close icon",
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle-hover-dark.svg")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: URL.createObjectURL(props.file),
                alt: "image",
                className: "w-full rounded-[16px]"
            })
        ]
    });
}
function canvasToBlob(canvas) {
    return _canvasToBlob.apply(this, arguments);
}
function _canvasToBlob() {
    _canvasToBlob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(canvas) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    canvas.toBlob(function(blob) {
                        if (!blob) {
                            reject(new Error("Cannot get blob"));
                            return;
                        }
                        resolve(blob);
                    });
                })
            ];
        });
    });
    return _canvasToBlob.apply(this, arguments);
}
function videoToBlob(ref) {
    return _videoToBlob.apply(this, arguments);
}
function _videoToBlob() {
    _videoToBlob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(ref) {
        var canvas, context, _current, videoWidth, videoHeight, image;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    canvas = document.createElement("canvas");
                    context = canvas.getContext("2d");
                    if (!context) throw new Error("Cannot get 2d context");
                    if (!ref.current) throw new Error("Cannot get video element");
                    _current = ref.current, videoWidth = _current.videoWidth, videoHeight = _current.videoHeight;
                    canvas.width = videoWidth;
                    canvas.height = videoHeight;
                    context.drawImage(ref.current, 0, 0, videoWidth, videoHeight);
                    return [
                        4,
                        canvasToBlob(canvas)
                    ];
                case 1:
                    image = _state.sent();
                    return [
                        2,
                        image
                    ];
            }
        });
    });
    return _videoToBlob.apply(this, arguments);
}
function mapRanges(startIn, endIn, startOut, endOut, value) {
    var rangeIn = endIn - startIn;
    var rangeOut = endOut - startOut;
    var percent = (value - startIn) / rangeIn;
    var result = percent * rangeOut + startOut;
    return result;
}
function calculateFramePosition(x, constants) {
    var start = x - constants.PREVIEW_SINGLE_WIDTH;
    var max = constants.PREVIEW_SLIDER_WIDTH - 2 * constants.PREVIEW_SINGLE_WIDTH;
    var percent = mapRanges(0, max, 0, 1, start);
    var clampedDown = Math.max(0, percent);
    var clampedUp = Math.min(1, clampedDown);
    return clampedUp;
}
function VideoPreviewWithFrames(props) {
    var handleMouseMove = function handleMouseMove(event, overrideHolding) {
        if (!progress) {
            return;
        }
        if (!holding && !overrideHolding) {
            return;
        }
        var element = video.current;
        if (!element) {
            return;
        }
        var rect = event.currentTarget.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var percent = calculateFramePosition(x, constants);
        setProgress(function(progress) {
            var ref;
            var duration = (ref = progress === null || progress === void 0 ? void 0 : progress.duration) !== null && ref !== void 0 ? ref : 0;
            var time = duration * percent;
            element.currentTime = time;
            return {
                duration: duration,
                time: time
            };
        });
    };
    var file = props.file, setDataGetter = props.setDataGetter, closePage = props.closePage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]), frames = ref[0], setFrames = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(null), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), holding = ref2[0], setHolding = ref2[1];
    var video = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)({
        PREVIEW_SLIDER_WIDTH: 1,
        PREVIEW_FRAMES_COUNT: 1,
        PREVIEW_SINGLE_WIDTH: 1,
        PREVIEW_SINGLE_HEIGHT: 1,
        PREVIEW_FRAME_BORDER: 0
    }), constants = ref3[0], setConstants = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        var updateSizes = function updateSizes() {
            var ref;
            var ref1;
            var PREVIEW_SLIDER_WIDTH = (ref1 = (ref = document.getElementById("media-preview")) === null || ref === void 0 ? void 0 : ref.clientWidth) !== null && ref1 !== void 0 ? ref1 : 575;
            var PREVIEW_FRAMES_COUNT = 18;
            var PREVIEW_SINGLE_WIDTH = PREVIEW_SLIDER_WIDTH / PREVIEW_FRAMES_COUNT;
            var PREVIEW_SINGLE_HEIGHT = PREVIEW_SINGLE_WIDTH / 9 * 16;
            var PREVIEW_FRAME_BORDER = 2;
            setConstants({
                PREVIEW_SLIDER_WIDTH: PREVIEW_SLIDER_WIDTH,
                PREVIEW_FRAMES_COUNT: PREVIEW_FRAMES_COUNT,
                PREVIEW_SINGLE_WIDTH: PREVIEW_SINGLE_WIDTH,
                PREVIEW_SINGLE_HEIGHT: PREVIEW_SINGLE_HEIGHT,
                PREVIEW_FRAME_BORDER: PREVIEW_FRAME_BORDER
            });
        };
        updateSizes();
        window.addEventListener("resize", updateSizes);
        return function() {
            return window.removeEventListener("resize", updateSizes);
        };
    }, []);
    var previewFrames = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(function() {
        return (0,_utils_video__WEBPACK_IMPORTED_MODULE_6__/* .extractUniformFrames */ .Ge)(frames, constants.PREVIEW_FRAMES_COUNT);
    }, [
        frames,
        constants
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        setDataGetter({
            getter: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                videoToBlob(video)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            })
        });
    }, [
        setDataGetter
    ]);
    var videoUrl = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(function() {
        return URL.createObjectURL(file);
    }, [
        file
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (constants.PREVIEW_FRAMES_COUNT === 1) return;
        (0,_utils_video__WEBPACK_IMPORTED_MODULE_6__/* .extractFramesFromVideo */ .oE)(file, constants.PREVIEW_FRAMES_COUNT).then(function(param) {
            var keyframes = param.keyframes;
            return setFrames(keyframes);
        });
        (0,_utils_video__WEBPACK_IMPORTED_MODULE_6__/* .getVideoDurationMillis */ .nr)(file).then(function(durationMillis) {
            return setProgress({
                time: 0,
                duration: durationMillis / 1000
            });
        });
    }, [
        file,
        constants
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        var handleMouseDown = function handleMouseDown() {
            setHolding(true);
        };
        var handleMouseUp = function handleMouseUp() {
            setHolding(false);
        };
        window.addEventListener("mousedown", handleMouseDown);
        window.addEventListener("mouseup", handleMouseUp);
        return function() {
            window.removeEventListener("mousedown", handleMouseDown);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var preview = progress && frames.length ? frames[Math.floor(progress.time / progress.duration * (frames.length - 1))].source : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full overflow-hidden rounded-[16px] bg-blue-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        className: "group absolute left-2 top-2 z-50 flex h-5 w-5 items-center justify-center rounded-full bg-blue-300 hover:bg-blue-400",
                        onClick: closePage,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "group-hover:hidden",
                                alt: "circle",
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle.svg")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "hidden group-hover:block dark:hidden dark:group-hover:hidden",
                                alt: "circle",
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle-hover.svg")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "hidden dark:hidden dark:group-hover:block",
                                alt: "circle",
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/close-in-circle-hover-dark.svg")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        src: videoUrl,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("w-full object-cover", "opacity-0 transition-opacity", progress && "opacity-100"),
                        ref: video
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative flex",
                style: {
                    height: constants.PREVIEW_SINGLE_HEIGHT
                },
                onMouseMove: handleMouseMove,
                onClick: function(event) {
                    return handleMouseMove(event, true);
                },
                children: [
                    previewFrames.map(function(param, index) {
                        var source = param.source, time = param.time;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: source,
                            alt: "Frame of time ".concat(time),
                            style: {
                                width: constants.PREVIEW_SINGLE_WIDTH,
                                height: constants.PREVIEW_SINGLE_HEIGHT
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("pointer-events-none aspect-[9/16] object-cover first:rounded-l-[12px]", "brightness-[0.3]", index === previewFrames.length - 1 && "rounded-r-[12px]")
                        }, time);
                    }),
                    progress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute top-0 aspect-[9/16] border-primary-500", holding ? "hover:cursor-grabbing hover:border-[#FFDB20]" : "cursor-grab", "transition-colors duration-150", "group box-border rounded-sm", "overflow-visible"),
                        style: {
                            borderWidth: constants.PREVIEW_FRAME_BORDER,
                            left: calculateBorderPosition(progress.time, progress.duration, constants),
                            width: constants.PREVIEW_SINGLE_WIDTH + constants.PREVIEW_FRAME_BORDER * 2,
                            height: constants.PREVIEW_SINGLE_HEIGHT
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative h-full w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute -top-14 left-1/2 -translate-x-1/2 px-4 py-2", "pointer-events-none select-none opacity-0", holding && "group-hover:opacity-100", "rounded-lg bg-color-cell transition-opacity duration-150"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("relative", "w-[120px] text-center", "font-500 text-blue-600"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("absolute h-3 w-3 rotate-45 rounded-[3px] bg-color-cell", "-bottom-3 left-1/2 -translate-x-1/2")
                                            }),
                                            t("txt_make_keyframe")
                                        ]
                                    })
                                }),
                                preview ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: preview,
                                    alt: "current frame",
                                    className: "pointer-events-none h-full w-full object-cover"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pointer-events-none h-full w-full object-cover"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function calculateBorderPosition(time, duration, constants) {
    var progress = time / duration;
    var max = constants.PREVIEW_SLIDER_WIDTH - constants.PREVIEW_SINGLE_WIDTH;
    var maxWithoutBorders = max - constants.PREVIEW_FRAME_BORDER;
    var pixels = progress * maxWithoutBorders;
    var style = "".concat(pixels, "px");
    return style;
}
function CostsCoins(props) {
    var coins = props.coins;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().userInfo;
    var isCoinFree = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isCoinFree;
    if (isCoinFree || !coins) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-1 rounded-full bg-[#C6113F] px-1 text-[14px] font-700 text-color-white",
        children: [
            "+",
            coins,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_22__/* .assetUrl */ .p)("/general/coin.svg"),
                alt: "coins"
            })
        ]
    });
}
function getPromptPrice(prompt, params, non_free_price) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            var promptID = prompt[param.id];
            if (typeof promptID !== "number") {
                continue;
            }
            if (param.type !== "slider") {
                continue;
            }
            if (promptID > param.maxFreeValue) {
                return non_free_price;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0;
}


/***/ }),

/***/ 187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CostsCoins": function() { return /* binding */ CostsCoins; },
/* harmony export */   "DEFORUM_STORAGE_KEY": function() { return /* binding */ DEFORUM_STORAGE_KEY; },
/* harmony export */   "FaceIcon": function() { return /* binding */ FaceIcon; },
/* harmony export */   "MIN_INPUT_CHARACTERS": function() { return /* binding */ MIN_INPUT_CHARACTERS; },
/* harmony export */   "MIN_RESOLUTION": function() { return /* binding */ MIN_RESOLUTION; },
/* harmony export */   "default": function() { return /* binding */ PhotoAiEditor; },
/* harmony export */   "getAcceptedMimes": function() { return /* binding */ getAcceptedMimes; },
/* harmony export */   "getPromptPrice": function() { return /* binding */ getPromptPrice; },
/* harmony export */   "photoAiStorageSchema": function() { return /* binding */ photoAiStorageSchema; },
/* harmony export */   "resizeDimensions": function() { return /* binding */ resizeDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9483);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6961);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8767);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5091);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1604);
/* harmony import */ var _ai_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9264);
/* harmony import */ var _border_input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3607);
/* harmony import */ var _checkbox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3708);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9612);
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9034);
/* harmony import */ var _simple_drop_area__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(356);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9460);
/* harmony import */ var _deform__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8641);




























var remoteStorageSchema = zod__WEBPACK_IMPORTED_MODULE_19__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_19__.z.literal("remote"),
    url: zod__WEBPACK_IMPORTED_MODULE_19__.z.string()
});
var localStorageSchema = zod__WEBPACK_IMPORTED_MODULE_19__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_19__.z.literal("local"),
    blob: zod__WEBPACK_IMPORTED_MODULE_19__.z.unknown()
});
var DEFORUM_STORAGE_KEY = "last";
var photoAiStorageSchema = zod__WEBPACK_IMPORTED_MODULE_19__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_19__.z.literal("ai_photo").default("ai_photo"),
    id: zod__WEBPACK_IMPORTED_MODULE_19__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_19__.z.string().nullable(),
    input: zod__WEBPACK_IMPORTED_MODULE_19__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_19__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var MIN_RESOLUTION = 450;
var MIN_INPUT_CHARACTERS = 3;
function PhotoAiEditor(props) {
    var ref;
    if (props.content.tool !== "ai_photo") {
        throw new Error("You are not in deform editor.");
    }
    if (props.blob === null) {
        throw new Error("No file uploaded.");
    }
    var content = props.content, parameters = props.params, file = props.blob;
    if (parameters === null) {
        throw new Error("Parameters for filters are null.");
    }
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(), uploadedUrl = ref1[0], setUploadedUrl = ref1[1];
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_10__/* .useEditorParamsContext */ .mK)();
    var styles = parameters.styles, params = parameters.params;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(content.input), input = ref2[0], setInput = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(content.promptType), promptType = ref3[0], setPromptType = ref3[1];
    var fileType = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return getFileType(file);
    }, [
        file
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).notify;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true), keepFace = ref4[0], setKeepFace = ref4[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useQueryClient)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), subscriptionPopupOpen = ref5[0], setSubscriptionPopupOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), actionLoading = ref6[0], setActionLoading = ref6[1];
    var initialConfig = (0,_ai_config__WEBPACK_IMPORTED_MODULE_11__/* .createPromptStateFrom */ .vU)(params.params);
    var sectionsConfig = params.sections ? params.sections.map(function(section) {
        return (0,_ai_config__WEBPACK_IMPORTED_MODULE_11__/* .createPromptStateFrom */ .vU)(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, acc, section) : acc;
    }, initialConfig || {}) : initialConfig || {};
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(config), promptState = ref7[0], setPromptState = ref7[1];
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_2__/* .useIndexedDB */ .i)("ai_art", "ai_photo", photoAiStorageSchema);
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
            var payload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "ai_photo",
                            id: DEFORUM_STORAGE_KEY,
                            input: input,
                            promptType: promptType,
                            location: "local",
                            blob: file
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    function submitData() {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
            var url, ref, upload, download, contentType, res, resolution, dimensions, changedDimensions, face, submitData, error, notifier;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionLoading) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        setActionLoading(true);
                        url = uploadedUrl;
                        if (!!url) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_23__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: file.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), upload = ref.upload, download = ref.download, contentType = ref.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_23__/* ["default"].put */ .Z.put(upload, file, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        url = download;
                        setUploadedUrl(download);
                        _state.label = 4;
                    case 4:
                        res = null;
                        if (promptState && promptState["resolution"]) res = Number(promptState["resolution"]);
                        resolution = res !== null && res !== void 0 ? res : MIN_RESOLUTION;
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_5__/* .getImageDimensions */ .pz)(file)
                        ];
                    case 5:
                        dimensions = _state.sent();
                        changedDimensions = resizeDimensions(dimensions, resolution);
                        face = null;
                        if (!isKeepFaceNotAllowed && keepFace) face = url;
                        submitData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                            url: url,
                            style: promptType,
                            additional: input,
                            tool: "ai_photo",
                            params: promptState !== null && promptState !== void 0 ? promptState : {
                                resolution: 720
                            },
                            face_object_url: face
                        }, changedDimensions);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_23__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 6:
                        _state.sent();
                        setActionLoading(false);
                        window.removeEventListener("beforeunload", handleLeave);
                        queryClient.invalidateQueries("coins");
                        return [
                            4,
                            router.push("/profile/generations/all")
                        ];
                    case 7:
                        _state.sent();
                        editor.closePage();
                        return [
                            3,
                            9
                        ];
                    case 8:
                        error = _state.sent();
                        notifier = (0,_utils_trigger__WEBPACK_IMPORTED_MODULE_4__/* .withNotify */ .nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_15__/* .ErrorMessage */ .Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    var isKeepFaceNotAllowed = (ref = styles.find(function(style) {
        return style.id === promptType;
    })) === null || ref === void 0 ? void 0 : ref.ignoreFace;
    var isFirstInputCorrect = input.length >= MIN_INPUT_CHARACTERS;
    var canSubmit = promptType !== null || isFirstInputCorrect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deform__WEBPACK_IMPORTED_MODULE_18__.ParamsContext.Provider, {
        value: params,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full justify-center overflow-y-scroll",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mx-auto my-[24px] flex w-[1175] gap-[25px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-[calc(70vh/16*9)] min-w-[300px] max-w-[575px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PhotoPreview, {
                                file: file,
                                closePage: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                                        window.removeEventListener("beforeunload", handleLeave);
                                        if (router.asPath === "/editor/photo-ai") {
                                            router.back();
                                        }
                                        editor.closePage();
                                        return [
                                            2
                                        ];
                                    });
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-[575px] flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex flex-col items-stretch gap-[22px] rounded-[15px] bg-color-cell px-6 pb-[22px] pt-[16px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-[16px] font-700 text-blue-600",
                                                    children: t("lbl_styles")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute bottom-0 right-0 z-10 h-3 w-full bg-gradient-to-t from-color-cell to-color-white/0"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "no-scrollbar grid max-h-[340px] grid-cols-3 gap-2 overflow-y-scroll pb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === null ? "border-primary-500 bg-[#FF31661F]" : "bg-blue-100", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors", "flex flex-col items-center justify-center gap-1"),
                                                            onClick: function() {
                                                                return setPromptType(null);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_14__/* .CustomThemedResource */ .aK, {
                                                                    format: "svg",
                                                                    source: "/general/custom-prompt",
                                                                    alt: "custom prompt"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-600 text-blue-800",
                                                                    children: t("lbl_custom")
                                                                })
                                                            ]
                                                        }),
                                                        styles.map(function(param) {
                                                            var name = param.name, id = param.id, image = param.image;
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === id && "border-primary-500", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors"),
                                                                onClick: function() {
                                                                    return setPromptType(id);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: image,
                                                                        alt: "cover of ".concat(name, " style"),
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("pointer-events-none h-full w-full object-cover")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "absolute bottom-0 left-0 h-8 w-full bg-gradient-to-t from-color-black/60 to-[transparent]"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "absolute bottom-1 left-2 text-[13px] font-600 text-color-white",
                                                                        children: name
                                                                    })
                                                                ]
                                                            }, id);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-[16px] font-700 text-blue-600",
                                                    children: t("lbl_prompts")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("no-scrollbar flex max-h-[312px] shrink-0 flex-col items-stretch gap-3 overflow-y-scroll transition-all", actionLoading && "pointer-events-none opacity-30"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex flex-col items-stretch gap-3",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_border_input__WEBPACK_IMPORTED_MODULE_12__/* .BorderTextareaResizable */ .NW, {
                                                                placeholder: t("txt_prompt_placeholder_additional"),
                                                                setValue: setInput,
                                                                defaultValue: input,
                                                                className: "group inline-block w-full resize-none !pr-10",
                                                                autoCorrect: "off"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex flex-row items-center justify-between rounded-[14px] bg-color-cell py-[22px] pl-3 pr-[22px] transition-opacity", isKeepFaceNotAllowed && "pointer-events-none opacity-30", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            htmlFor: "keep_face_check",
                                            className: "flex cursor-pointer select-none flex-row items-center gap-3 [--icon-color:var(--color-blue-500)]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaceIcon, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-[18px] font-500 text-blue-600",
                                                    children: t("txt_keep_face")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_checkbox__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            id: "keep_face_check",
                                            checked: keepFace,
                                            onClick: function() {
                                                setKeepFace(!keepFace);
                                            }
                                        })
                                    ]
                                }),
                                promptState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_11__/* .ParamtersTrigger */ .dS, {
                                    actionLoading: actionLoading,
                                    promptState: promptState,
                                    setPromptState: setPromptState
                                }),
                                isPro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    disabled: fileType === "unrecognized" || !canSubmit,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-primary-500 hover:bg-primary-600", "relative py-3 transition-colors", "flex items-center justify-center gap-4", actionLoading && "pointer-events-none"),
                                    onClick: function() {
                                        if (actionLoading) return;
                                        submitData();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("h-6 w-6 animate-[spin_1s_infinite_linear]", actionLoading ? "opacity-100" : "opacity-0"),
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .assetUrl */ .p)("/general/loading-dark.webp"),
                                                alt: "loading"
                                            })
                                        }),
                                        t("lbl_generate"),
                                        promptState && params.params && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostsCoins, {
                                            coins: getPromptPrice(promptState, params.params, params.price)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: fileType === "unrecognized",
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-[#2F91FD] hover:bg-[#0264CF]", "py-3 transition-colors"),
                                    onClick: function() {
                                        return setSubscriptionPopupOpen(true);
                                    },
                                    children: t("txt_subscribe_to_continue")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[70px] w-full shrink-0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_subscription_popup__WEBPACK_IMPORTED_MODULE_17__/* .SubscriptionPopup */ .yj, {
                    isOpen: subscriptionPopupOpen,
                    close: function() {
                        return setSubscriptionPopupOpen(false);
                    },
                    location: "/editor/photo-ai",
                    addToStorage: addToStorage
                })
            ]
        })
    });
}
function getFileType(file) {
    if (file.type.startsWith("video")) {
        return "video";
    }
    if (file.type.startsWith("image")) {
        return "image";
    }
    return "unrecognized";
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function PhotoPreview(props) {
    var file = props.file, closePage = props.closePage;
    var imageUrl = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return URL.createObjectURL(file);
    }, [
        file
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col gap-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full overflow-hidden rounded-[16px] bg-blue-100",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    className: "group absolute left-2 top-2 z-50 flex h-5 w-5 items-center justify-center rounded-full bg-blue-300 hover:bg-blue-400",
                    onClick: closePage,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "group-hover:hidden",
                            alt: "close circle icon",
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .assetUrl */ .p)("/general/close-in-circle.svg")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "hidden group-hover:block dark:hidden dark:group-hover:hidden",
                            alt: "circle hover icon",
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .assetUrl */ .p)("/general/close-in-circle-hover.svg")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "hidden dark:hidden dark:group-hover:block",
                            alt: "circle dark",
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .assetUrl */ .p)("/general/close-in-circle-hover-dark.svg")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: imageUrl,
                    alt: "image",
                    className: "h-full w-full object-cover"
                })
            ]
        })
    });
}
var FaceIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "18",
            height: "20",
            viewBox: "0 0 18 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7505 13.7358L14.5704 12.9307C14.2943 12.9925 14.0692 13.1913 13.9738 13.4577L14.7505 13.7358ZM3.61789 13.7002L4.39591 13.4258C4.30985 13.1818 4.1143 12.9923 3.86771 12.9139L3.61789 13.7002ZM2.56909 7.59516L2.89406 8.35346C3.17536 8.23291 3.36682 7.96653 3.39142 7.66147L2.56909 7.59516ZM15.931 7.59519L15.1087 7.6615C15.1333 7.96655 15.3247 8.23292 15.606 8.35348L15.931 7.59519ZM13.9738 13.4577C13.0167 16.1301 11.6576 17.975 9.25005 17.975V19.625C12.8076 19.625 14.5379 16.7762 15.5272 14.014L13.9738 13.4577ZM9.25005 17.975C6.83783 17.975 5.33321 16.0831 4.39591 13.4258L2.83987 13.9746C3.83017 16.7822 5.71936 19.625 9.25005 19.625V17.975ZM2.24413 6.83685C1.41813 7.19083 0.951739 7.88621 0.744793 8.63443C0.542481 9.36589 0.572475 10.1829 0.73605 10.9378C0.900726 11.6979 1.21332 12.4544 1.63844 13.0786C2.05538 13.6908 2.63546 14.2537 3.36807 14.4865L3.86771 12.9139C3.61896 12.8349 3.30555 12.5952 3.0022 12.1498C2.70703 11.7164 2.47253 11.1603 2.34863 10.5884C2.22364 10.0115 2.22359 9.4774 2.33509 9.07428C2.44195 8.68792 2.63321 8.46524 2.89406 8.35346L2.24413 6.83685ZM3.39142 7.66147C3.64833 4.47578 6.20038 2.02501 9.25005 2.02501V0.375012C5.27721 0.375012 2.06758 3.5507 1.74676 7.52884L3.39142 7.66147ZM9.25005 2.02501C12.2997 2.02501 14.8518 4.4758 15.1087 7.6615L16.7533 7.52888C16.4325 3.55072 13.2229 0.375012 9.25005 0.375012V2.02501ZM15.606 8.35348C15.8717 8.46736 16.0668 8.69749 16.172 9.10065C16.2815 9.52023 16.2726 10.0737 16.1344 10.6637C15.9974 11.249 15.747 11.8094 15.4392 12.2331C15.1221 12.6696 14.8078 12.8776 14.5704 12.9307L14.9306 14.5409C15.7115 14.3662 16.3317 13.8118 16.7741 13.203C17.2257 12.5814 17.5598 11.8137 17.741 11.0399C17.9211 10.2707 17.9643 9.43389 17.7686 8.68401C17.5686 7.91771 17.1012 7.19914 16.256 6.8369L15.606 8.35348Z",
                fill: "var(--icon-color)"
            })
        })
    });
};
function getPromptPrice(prompt, params, non_free_price) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            var promptID = prompt[param.id];
            if (typeof promptID !== "number") {
                continue;
            }
            if (param.type !== "slider") {
                continue;
            }
            if (promptID > param.maxFreeValue) {
                return non_free_price;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0;
}
function CostsCoins(props) {
    var coins = props.coins;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isCoinFree = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isCoinFree;
    if (isCoinFree || !coins) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-1 rounded-full bg-[#C6113F] px-1 text-[14px] font-700 text-color-white",
        children: [
            "+",
            coins,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_24__/* .assetUrl */ .p)("/general/coin.svg"),
                alt: "coins"
            })
        ]
    });
}
function resizeDimensions(dimensions, max) {
    if (Math.max(dimensions.width, dimensions.height) < max) {
        return dimensions;
    }
    if (dimensions.width > dimensions.height) {
        return {
            width: Math.floor(max / dimensions.height * dimensions.width),
            height: max
        };
    }
    return {
        width: max,
        height: Math.floor(max / dimensions.width * dimensions.height)
    };
}
var actionMimes = {
    deform: [
        "images",
        "videos"
    ],
    restyle: [
        "videos"
    ],
    photo_ai: [
        "images"
    ]
};
function getAcceptedMimes() {
    var mimes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(actionMimes["photo_ai"]);
    var empty = [];
    var allMimes = mimes.reduce(function(all, single) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(all).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(_simple_drop_area__WEBPACK_IMPORTED_MODULE_16__/* .mimeTypes */ .aN[single]));
    }, empty);
    return allMimes.join(", ");
}


/***/ }),

/***/ 9868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CostsCoins": function() { return /* binding */ CostsCoins; },
/* harmony export */   "MIN_INPUT_CHARACTERS": function() { return /* binding */ MIN_INPUT_CHARACTERS; },
/* harmony export */   "MIN_RESOLUTION": function() { return /* binding */ MIN_RESOLUTION; },
/* harmony export */   "calculateDurationPrice": function() { return /* binding */ calculateDurationPrice; },
/* harmony export */   "default": function() { return /* binding */ RestyleEditor; },
/* harmony export */   "getAcceptedMimes": function() { return /* binding */ getAcceptedMimes; },
/* harmony export */   "getPromptPrice": function() { return /* binding */ getPromptPrice; },
/* harmony export */   "resizeDimensions": function() { return /* binding */ resizeDimensions; },
/* harmony export */   "restyleStorageSchema": function() { return /* binding */ restyleStorageSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9483);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6961);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8767);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5091);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1501);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(1604);
/* harmony import */ var _ai_config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9264);
/* harmony import */ var _border_input__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3607);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9612);
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9034);
/* harmony import */ var _player__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1993);
/* harmony import */ var _simple_drop_area__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(356);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9460);
/* harmony import */ var _deform__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8641);





























var actionMimes = {
    deform: [
        "images",
        "videos"
    ],
    restyle: [
        "videos"
    ],
    photo_ai: [
        "images"
    ]
};
function getAcceptedMimes() {
    var mimes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(actionMimes["restyle"]);
    var empty = [];
    var allMimes = mimes.reduce(function(all, single) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(all).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_simple_drop_area__WEBPACK_IMPORTED_MODULE_17__/* .mimeTypes */ .aN[single]));
    }, empty);
    return allMimes.join(", ");
}
var ControllerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_8__.createContext)(null);
var DurationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_8__.createContext)(null);
var remoteStorageSchema = zod__WEBPACK_IMPORTED_MODULE_21__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_21__.z.literal("remote"),
    url: zod__WEBPACK_IMPORTED_MODULE_21__.z.string()
});
var localStorageSchema = zod__WEBPACK_IMPORTED_MODULE_21__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_21__.z.literal("local"),
    blob: zod__WEBPACK_IMPORTED_MODULE_21__.z.unknown()
});
var DEFORUM_STORAGE_KEY = "last";
var restyleStorageSchema = zod__WEBPACK_IMPORTED_MODULE_21__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_21__.z.literal("ai_restyle").default("ai_restyle"),
    id: zod__WEBPACK_IMPORTED_MODULE_21__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_21__.z.string().nullable(),
    input: zod__WEBPACK_IMPORTED_MODULE_21__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_21__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var MIN_INPUT_CHARACTERS = 3;
var MIN_RESOLUTION = 450;
function RestyleEditor(props) {
    if (props.content.tool !== "ai_restyle") {
        throw new Error("You are not in restyle editor.");
    }
    if (props.blob === null) {
        throw new Error("No file uploaded.");
    }
    var content = props.content, parameters = props.params, file = props.blob;
    if (parameters === null) {
        throw new Error("Parameters for filters are null");
    }
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(), uploadedUrl = ref[0], setUploadedUrl = ref[1];
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_10__/* .useEditorParamsContext */ .mK)();
    var styles = parameters.styles, params = parameters.params;
    var controller = (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .useVideoClipper */ .FD)({
        file: file
    });
    var fileType = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return getFileType(file);
    }, [
        file
    ]);
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_2__/* .useIndexedDB */ .i)("ai_art", "ai_restyle", restyleStorageSchema);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(content.input), input = ref1[0], setInput = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(content.promptType), promptType = ref2[0], setPromptType = ref2[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).notify;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useQueryClient)();
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var isFirstInputCorrect = input.length >= MIN_INPUT_CHARACTERS;
    var canSubmit = promptType !== null || isFirstInputCorrect;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(null), duration = ref3[0], setDuration = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (duration !== null) {
            return;
        }
        (0,_utils_video__WEBPACK_IMPORTED_MODULE_5__/* .getVideoDurationMillis */ .nr)(file).then(setDuration);
    }, [
        duration,
        file
    ]);
    var initialConfig = (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .createPromptStateFrom */ .vU)(params.params);
    var sectionsConfig = params.sections ? params.sections.map(function(section) {
        return (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .createPromptStateFrom */ .vU)(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, acc, section) : acc;
    }, initialConfig || {}) : initialConfig || {};
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(config), promptState = ref4[0], setPromptState = ref4[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), subscriptionPopupOpen = ref5[0], setSubscriptionPopupOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), actionLoading = ref6[0], setActionLoading = ref6[1];
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var payload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "ai_restyle",
                            id: DEFORUM_STORAGE_KEY,
                            input: input,
                            promptType: promptType,
                            location: "local",
                            blob: file
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    function submitData() {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var url, ref, upload, download, contentType, res, resolution, changedDimensions, submitData, error, notifier;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (actionLoading) {
                            throw new Error("Action is loading");
                        }
                        if (!controller) {
                            throw new Error("Controller is not ready");
                        }
                        if (!params) {
                            throw new Error("Params are not ready");
                        }
                        setActionLoading(true);
                        url = uploadedUrl;
                        if (!!url) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-video-url", {
                                content: file.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        ref = _state.sent(), upload = ref.upload, download = ref.download, contentType = ref.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].put */ .Z.put(upload, file, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        url = download;
                        setUploadedUrl(download);
                        _state.label = 3;
                    case 3:
                        res = null;
                        if (promptState && promptState["resolution"]) res = Number(promptState["resolution"]);
                        resolution = res !== null && res !== void 0 ? res : MIN_RESOLUTION;
                        changedDimensions = resizeDimensions({
                            width: controller.width,
                            height: controller.height
                        }, resolution);
                        submitData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
                            url: url,
                            additional: input,
                            style: promptType,
                            tool: "ai_restyle",
                            start: controller.startTime,
                            duration: controller.selectedDuration,
                            params: promptState !== null && promptState !== void 0 ? promptState : {
                                resolution: 720
                            },
                            price: calculateDurationPrice(controller.selectedDuration)
                        }, changedDimensions);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 4:
                        _state.sent();
                        setActionLoading(false);
                        window.removeEventListener("beforeunload", handleLeave);
                        queryClient.invalidateQueries("coins");
                        return [
                            4,
                            router.push("/profile/generations/all")
                        ];
                    case 5:
                        _state.sent();
                        editor.closePage();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        notifier = (0,_utils_trigger__WEBPACK_IMPORTED_MODULE_4__/* .withNotify */ .nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_15__/* .ErrorMessage */ .Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deform__WEBPACK_IMPORTED_MODULE_19__.ParamsContext.Provider, {
        value: params,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DurationContext.Provider, {
            value: duration,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ControllerContext.Provider, {
                value: controller,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: " flex w-full justify-center overflow-y-scroll",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto my-[24px] flex w-[1175] gap-[25px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[calc(70vh/16*9)] min-w-[300px] max-w-[575px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoPreviewWithFrames, {
                                        file: file,
                                        closePage: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                                                window.removeEventListener("beforeunload", handleLeave);
                                                if (router.asPath === "/editor/restyle") {
                                                    router.back();
                                                }
                                                editor.closePage();
                                                return [
                                                    2
                                                ];
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[575px] flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("flex flex-col items-stretch gap-[22px] rounded-[15px] bg-color-cell px-6 pb-[22px] pt-[16px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative flex flex-col gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-[16px] font-700 text-blue-600",
                                                            children: t("lbl_styles")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute bottom-0 right-0 z-10 h-3 w-full bg-gradient-to-t from-color-cell to-color-white/0"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "no-scrollbar grid max-h-[340px] grid-cols-3 gap-2 overflow-y-scroll pb-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === null ? "border-primary-500 bg-[#FF31661F]" : "bg-blue-100", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors", "flex flex-col items-center justify-center gap-1"),
                                                                    onClick: function() {
                                                                        return setPromptType(null);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_14__/* .CustomThemedResource */ .aK, {
                                                                            format: "svg",
                                                                            source: "/general/custom-prompt",
                                                                            alt: "custom prompt"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "font-600 text-blue-800",
                                                                            children: t("lbl_custom")
                                                                        })
                                                                    ]
                                                                }),
                                                                styles.map(function(param) {
                                                                    var name = param.name, id = param.id, image = param.image;
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative h-[122px] overflow-hidden rounded-[8px]", promptType === id && "border-primary-500", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors"),
                                                                        onClick: function() {
                                                                            return setPromptType(id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                src: image,
                                                                                alt: "cover of ".concat(name, " style"),
                                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("pointer-events-none h-full w-full object-cover")
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "absolute bottom-0 left-0 h-8 w-full bg-gradient-to-t from-color-black/60 to-[transparent]"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "absolute bottom-1 left-2 text-[13px] font-600 text-color-white",
                                                                                children: name
                                                                            })
                                                                        ]
                                                                    }, id);
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-[16px] font-700 text-blue-600",
                                                            children: t("lbl_prompts")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("no-scrollbar flex max-h-[312px] shrink-0 flex-col items-stretch gap-3 overflow-y-scroll transition-all", actionLoading && "pointer-events-none opacity-30"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex flex-col items-stretch gap-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_border_input__WEBPACK_IMPORTED_MODULE_13__/* .BorderTextareaResizable */ .NW, {
                                                                        placeholder: t("txt_prompt_placeholder_additional"),
                                                                        setValue: setInput,
                                                                        defaultValue: input,
                                                                        className: "group inline-block w-full resize-none !pr-10",
                                                                        autoCorrect: "off"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        promptState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .ParamtersTrigger */ .dS, {
                                            actionLoading: actionLoading,
                                            promptState: promptState,
                                            setPromptState: setPromptState
                                        }),
                                        isPro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            disabled: fileType === "unrecognized" || !canSubmit,
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-primary-500 hover:bg-primary-600", "relative py-3 transition-colors", "flex items-center justify-center gap-4", actionLoading && "pointer-events-none"),
                                            onClick: function() {
                                                if (actionLoading) return;
                                                submitData();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("h-6 w-6 animate-[spin_1s_infinite_linear]", actionLoading ? "opacity-100" : "opacity-0"),
                                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/loading-dark.webp"),
                                                        alt: "loading"
                                                    })
                                                }),
                                                t("lbl_generate"),
                                                promptState && params.params && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostsCoins, {
                                                    coins: getPromptPrice(promptState, params.params, params.price) + calculateDurationPrice(controller === null || controller === void 0 ? void 0 : controller.selectedDuration)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            disabled: fileType === "unrecognized",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-[#2F91FD] hover:bg-[#0264CF]", "py-3 transition-colors"),
                                            onClick: function() {
                                                return setSubscriptionPopupOpen(true);
                                            },
                                            children: t("txt_subscribe_to_continue")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[70px] w-full shrink-0"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_subscription_popup__WEBPACK_IMPORTED_MODULE_18__/* .SubscriptionPopup */ .yj, {
                            isOpen: subscriptionPopupOpen,
                            close: function() {
                                return setSubscriptionPopupOpen(false);
                            },
                            location: "/editor/restyle",
                            addToStorage: addToStorage
                        })
                    ]
                })
            })
        })
    });
}
function getFileType(file) {
    try {
        if (file.type.startsWith("video")) {
            return "video";
        }
        if (file.type.startsWith("image")) {
            return "image";
        }
    } catch (e) {}
    return "unrecognized";
}
function resizeDimensions(dimensions, max) {
    if (Math.max(dimensions.width, dimensions.height) < max) {
        return dimensions;
    }
    if (dimensions.width > dimensions.height) {
        return {
            width: Math.floor(max / dimensions.height * dimensions.width),
            height: max
        };
    }
    return {
        width: max,
        height: Math.floor(max / dimensions.width * dimensions.height)
    };
}
var COINS_PER_SECOND = 50;
function calculateDurationPrice(duration) {
    if (!duration) {
        return 0;
    }
    if (duration <= _ai_config__WEBPACK_IMPORTED_MODULE_12__/* .MAX_FREE_MILLIS */ .QI) {
        return 0;
    }
    var additionalDuration = duration - _ai_config__WEBPACK_IMPORTED_MODULE_12__/* .MAX_FREE_MILLIS */ .QI;
    return Math.floor(additionalDuration * COINS_PER_SECOND / 1000);
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function VideoPreviewWithFrames(props) {
    var file = props.file, closePage = props.closePage;
    var controller = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(ControllerContext);
    (0,_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .useVideoClipper */ .FD)({
        file: file
    });
    var video = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        var elem = video.current;
        if (!elem) {
            return;
        }
        if (!controller) {
            return;
        }
        var handleProgress = function() {
            var startSeconds = controller.startTime / 1000;
            var endSeconds = (controller.startTime + controller.selectedDuration) / 1000;
            if (elem.currentTime < startSeconds) {
                elem.currentTime = startSeconds;
            } else if (elem.currentTime > endSeconds) {
                elem.currentTime = startSeconds;
            }
        };
        elem.addEventListener("timeupdate", handleProgress);
        return function() {
            return elem.removeEventListener("timeupdate", handleProgress);
        };
    }, [
        controller
    ]);
    var videoUrl = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return URL.createObjectURL(file);
    }, [
        file
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(video_provider__WEBPACK_IMPORTED_MODULE_11__/* .VideoProvider */ .G, {
        element: video,
        remember: [],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative w-full overflow-hidden rounded-[16px] bg-blue-100",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "group absolute left-2 top-2 z-50 flex h-5 w-5 items-center justify-center rounded-full bg-blue-300 hover:bg-blue-400",
                            onClick: closePage,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "group-hover:hidden",
                                    alt: "close-in-circle",
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/close-in-circle.svg")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "hidden group-hover:block dark:hidden dark:group-hover:hidden",
                                    alt: "close-in-circle",
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/close-in-circle-hover.svg")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "hidden dark:hidden dark:group-hover:block",
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/close-in-circle-hover-dark.svg"),
                                    alt: "close-in-circle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_player__WEBPACK_IMPORTED_MODULE_16__/* .PlayWithProvider */ .uX, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            loop: true,
                            src: videoUrl,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("w-full object-cover", "transition-opacity", controller ? "opacity-100" : "opacity-0"),
                            ref: video
                        })
                    ]
                }),
                controller ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center gap-[6px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-600 uppercase text-blue-600",
                                    children: t("label_duration")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/coin.svg"),
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(calculateDurationPrice(controller.selectedDuration) > 0 ? "opacity-100" : "opacity-0", "transition-opacity"),
                                    alt: "coin icon"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex-1"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "rounded-[4px] bg-blue-200 p-1 text-[13px] font-500 text-blue-400",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-blue-700",
                                            children: [
                                                (controller.selectedDuration / 1000).toFixed(1),
                                                " / "
                                            ]
                                        }),
                                        (controller.duration / 1000).toFixed(1),
                                        "s"
                                    ]
                                })
                            ]
                        }),
                        controller && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_12__/* .ClipVideoSector */ .N4, {
                            className: "h-[70px]",
                            controller: controller,
                            file: file
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-[91px] w-3"
                })
            ]
        })
    });
}
function CostsCoins(props) {
    var coins = props.coins;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isCoinFree = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isCoinFree;
    if (isCoinFree || !coins) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-1 rounded-full bg-[#C6113F] px-1 text-[14px] font-700 text-color-white",
        children: [
            "+",
            coins,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/coin.svg"),
                alt: "coins"
            })
        ]
    });
}
function getPromptPrice(prompt, params, non_free_price) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            var promptID = prompt[param.id];
            if (typeof promptID !== "number") {
                continue;
            }
            if (param.type !== "slider") {
                continue;
            }
            if (promptID > param.maxFreeValue) {
                return non_free_price;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0;
}


/***/ }),

/***/ 3569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFORUM_STORAGE_KEY": function() { return /* binding */ DEFORUM_STORAGE_KEY; },
  "MIN_RESOLUTION": function() { return /* binding */ MIN_RESOLUTION; },
  "calculateDimensions": function() { return /* binding */ calculateDimensions; },
  "default": function() { return /* binding */ TextToImageEditor; },
  "handleLeave": function() { return /* binding */ handleLeave; },
  "textToImageStorageSchema": function() { return /* binding */ textToImageStorageSchema; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/indexed.tsx
var utils_indexed = __webpack_require__(788);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./utils/trigger.tsx
var trigger = __webpack_require__(9483);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(2512);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(8767);
// EXTERNAL MODULE: ./sections/editor/editor.tsx
var editor_editor = __webpack_require__(5091);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./comps/ai-config.tsx
var ai_config = __webpack_require__(9264);
// EXTERNAL MODULE: ./comps/ai-tools/icons.tsx
var icons = __webpack_require__(1455);
// EXTERNAL MODULE: ./comps/dropdown.tsx + 1 modules
var dropdown = __webpack_require__(3153);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/simple-drop-area.tsx
var simple_drop_area = __webpack_require__(356);
// EXTERNAL MODULE: ./comps/subscription-popup.tsx + 1 modules
var subscription_popup = __webpack_require__(9460);
// EXTERNAL MODULE: ./comps/editors/deform.tsx
var deform = __webpack_require__(8641);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./comps/editors/model-composition.tsx








var FabricCanvas = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1735).then(__webpack_require__.bind(__webpack_require__, 1735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1735)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    },
    ssr: false
});
function ModelComposition(props) {
    var aspectRatio = props.aspectRatio, compInfo = props.compInfo, selectedComposition = props.selectedComposition, setSelectedComposition = props.setSelectedComposition, imagePosition = props.imagePosition, setImagePosition = props.setImagePosition, setRotation = props.setRotation, setCenterX = props.setCenterX, setCenterY = props.setCenterY;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var visited = null;
    if (true) {
        visited = localStorage.getItem("visited-composition-id-".concat(userInfo.userId));
    }
    var showNew = !visited;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col items-start rounded-[14px] bg-color-cell px-[14px] py-[17px]", "gap-[17px]", open ? "animate-appear" : "max-h-[60px] min-h-[60px] overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/composition-icon.svg"),
                                alt: "composition icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[16px] font-600 text-blue-800",
                                children: t("lbl_composition")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(!showNew && "hidden", "rounded-[4px] bg-primary-100 px-[4px] py-[2px]"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "txt-[12px] font-700 text-primary-500",
                                    children: t("lbl_new")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)(open ? "group relative" : "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/info.svg"),
                                        alt: "info icon",
                                        className: (0,clsx_m/* default */.Z)("-mb-[20px] cursor-pointer pb-[20px]")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("absolute hidden rounded-[8px] bg-blue-800 px-[5px] py-[9px]", "left-1/2 top-[32px] z-[100] w-[330px] -translate-x-1/2 group-hover:flex"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative -top-[15px] left-1/2 h-[15px] w-[15px] -translate-x-1/2 rotate-45 rounded-none rounded-tl-[4px] bg-blue-800"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[14px] font-400 text-color-cell",
                                                children: t("txt_composition_presentation")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)("flex w-full justify-end"),
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            alt: "arrow icon",
                            className: (0,clsx_m/* default */.Z)(open ? "rotate-90" : "rotate-0")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(open ? "flex" : "hidden", "w-full justify-center"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FabricCanvas, {
                    aspectRatio: aspectRatio,
                    width: 331,
                    height: 331,
                    imageUrl: selectedComposition !== null && selectedComposition !== void 0 ? selectedComposition : "",
                    imagePosition: imagePosition,
                    setImagePosition: setImagePosition,
                    setRotation: setRotation,
                    setCenterX: setCenterX,
                    setCenterY: setCenterY
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[561px] overflow-hidden",
                children: compInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "no-scrollbar flex h-[64px] items-center gap-[5px] overflow-hidden overflow-x-scroll",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                setSelectedComposition(null);
                            },
                            className: (0,clsx_m/* default */.Z)(selectedComposition === null ? "border-primary-500 bg-primary-100" : "border-color-cell bg-blue-100 hover:bg-blue-300", "flex h-[64px] w-[64px] min-w-[64px] items-center justify-center rounded-[6px] border-2"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/none.svg"),
                                alt: "composition style thumb",
                                className: "h-[24px] !w-[24px]"
                            })
                        }),
                        compInfo === null || compInfo === void 0 ? void 0 : compInfo.map(function(elem) {
                            var _thumb, ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    var _preview;
                                    setSelectedComposition((_preview = elem.preview) !== null && _preview !== void 0 ? _preview : elem.image);
                                },
                                className: (0,clsx_m/* default */.Z)(selectedComposition === elem.preview || selectedComposition === elem.image ? "border-primary-500 bg-primary-100" : "border-color-cell bg-blue-100 hover:bg-blue-300", "h-[64px] w-[64px] min-w-[64px] rounded-[6px] border-2"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (ref = (_thumb = elem.thumb) !== null && _thumb !== void 0 ? _thumb : elem.preview) !== null && ref !== void 0 ? ref : elem.image,
                                    alt: "composition style thumb",
                                    className: "h-[64px] !w-[64px]"
                                })
                            }, elem.image);
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./comps/editors/text-to-image.tsx































function calculateDimensions(resolutionWidth, aspectRatio) {
    var height = resolutionWidth / aspectRatio;
    return {
        width: resolutionWidth,
        height: Math.ceil(height)
    };
}
function getModelsInfo(uid) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("/api/training-list-short?id=".concat(uid)).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
var remoteStorageSchema = lib.z.object({
    location: lib.z.literal("remote"),
    url: lib.z.string().nullable()
});
var localStorageSchema = lib.z.object({
    location: lib.z.literal("local"),
    blob: lib.z.unknown()
});
var DEFORUM_STORAGE_KEY = "last";
var textToImageStorageSchema = lib.z.object({
    tool: lib.z.literal("text_to_image").default("text_to_image"),
    id: lib.z.literal(DEFORUM_STORAGE_KEY),
    promptType: lib.z.string().nullable(),
    text: lib.z.string()
}).and(lib.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var MIN_RESOLUTION = 450;
function TextToImageEditor(props) {
    var getSelectionIndex = function getSelectionIndex() {
        var area = inputRef.current;
        if (!area) {
            throw new Error("You forgot the ref");
        }
        var selection = window.getSelection();
        if (!selection) {
            throw new Error("Call this function inside onInput");
        }
        var index = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = area.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.nodeType !== Node.TEXT_NODE) {
                    node = node.childNodes[0];
                }
                if (node === selection.focusNode) {
                    return index + selection.focusOffset;
                }
                if (node) {
                    var ref;
                    var ref1;
                    index += (ref1 = (ref = node.textContent) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
    var setSelectionIndex = function setSelectionIndex(index) {
        var area = inputRef.current;
        if (!area) {
            return;
        }
        var scanned = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = area.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                scanned += node.textContent.length;
                if (scanned >= index) {
                    var beforeNode = scanned - node.textContent.length;
                    var delta = index - beforeNode;
                    if (node.nodeType !== Node.TEXT_NODE) {
                        node = node.childNodes[0];
                    }
                    return {
                        node: node,
                        index: delta
                    };
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var ref, ref1;
    if (props.content.tool !== "text_to_image") {
        throw new Error("You are not in text to image editor.");
    }
    var content = props.content, parameters = props.params, blob = props.blob;
    if (parameters === null) {
        throw new Error("Parameters for filters are null.");
    }
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    var styles = parameters.styles, params = parameters.params;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(blob), file = ref2[0], setFile = ref2[1];
    var _promptType;
    var ref3 = (0,react.useState)((_promptType = content.promptType) !== null && _promptType !== void 0 ? _promptType : styles[0].id), promptType = ref3[0], setPromptType = ref3[1];
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var ref4 = (0,react.useState)(content.text.length), textLength = ref4[0], setTextLength = ref4[1];
    var ref5 = (0,react.useState)(0.75), aspectRatio = ref5[0], setAspectRation = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(""), fileName = ref7[0], setFileName = ref7[1];
    var ref8 = (0,react.useState)(0), offset = ref8[0], setOffset = ref8[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var isPro = (0,client_auth/* getUserEntitlements */.xx)(userInfo.entitlements).isPro;
    var _isModelUse;
    var ref9 = (0,react.useState)((_isModelUse = content.isModelUse) !== null && _isModelUse !== void 0 ? _isModelUse : null), selectedModel = ref9[0], setSelectedModel = ref9[1];
    var ref10 = (0,react.useState)(null), selectedComposition = ref10[0], setSelectedComposition = ref10[1];
    var ref11 = (0,react.useState)(null), imagePosition = ref11[0], setImagePosition = ref11[1];
    var ref12 = (0,react.useState)(0), rotation = ref12[0], setRotation = ref12[1];
    var ref13 = (0,react.useState)(0), centerX = ref13[0], setCenterX = ref13[1];
    var ref14 = (0,react.useState)(0), centerY = ref14[0], setCenterY = ref14[1];
    var ref15 = (0,react.useState)(true), firstRender = ref15[0], setFirstRender = ref15[1];
    var ref16 = (0,react.useState)(false), isWriteModel = ref16[0], setIsWriteModel = ref16[1];
    var inputRef = (0,react.useRef)(null);
    var queryModel = (0,react_query_es.useQuery)({
        queryKey: [
            "models-info"
        ],
        queryFn: getModelsInfo(userInfo.userId)
    });
    var result = (queryModel.data || {}).result;
    var queryClient = (0,react_query_es.useQueryClient)();
    var router = (0,next_router.useRouter)();
    var ref17 = (0,react.useState)(false), subscriptionPopupOpen = ref17[0], setSubscriptionPopupOpen = ref17[1];
    var ref18 = (0,react.useState)(false), actionLoading = ref18[0], setActionLoading = ref18[1];
    var indexed = (0,utils_indexed/* useIndexedDB */.i)("ai_art", "text_to_image", textToImageStorageSchema);
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_async_to_generator/* default */.Z)(function() {
            var _textContent, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        if (!inputRef.current) {
                            console.error("No container attached");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "text_to_image",
                            id: DEFORUM_STORAGE_KEY,
                            promptType: promptType,
                            text: (_textContent = inputRef.current.textContent) !== null && _textContent !== void 0 ? _textContent : "",
                            location: "local",
                            blob: file
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    var openExplorer = (0,react.useCallback)(function() {
        var fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = getAcceptedMimes();
        fileInput.onchange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_) {
                var _files, file, isOk;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!fileInput.files) return [
                                3,
                                2
                            ];
                            _files = (0,_sliced_to_array/* default */.Z)(fileInput.files, 1), file = _files[0];
                            return [
                                4,
                                (0,editor_editor/* isImageOrVideo */.c2)(file)
                            ];
                        case 1:
                            isOk = _state.sent();
                            if (!isOk) {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                                    children: t("txt_wrong_file_uploaded")
                                }));
                            } else {
                                setFile(file);
                                setFileName(file.name);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        fileInput.click();
    }, [
        notify,
        t,
        setFile
    ]);
    function onDrop(files) {
        return _onDrop.apply(this, arguments);
    }
    function _onDrop() {
        _onDrop = (0,_async_to_generator/* default */.Z)(function(files) {
            var _files, file, isOk;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _files = (0,_sliced_to_array/* default */.Z)(files, 1), file = _files[0];
                        if (!file) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,editor_editor/* isImageOrVideo */.c2)(file)
                        ];
                    case 1:
                        isOk = _state.sent();
                        if (!isOk) {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                                children: t("txt_wrong_file_uploaded")
                            }));
                        } else {
                            setFile(file);
                            setFileName(file.name);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _onDrop.apply(this, arguments);
    }
    var dropzoneState = (0,es/* useDropzone */.uI)({
        accept: (0,simple_drop_area/* getFormatsFromMimeTypes */.lz)((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.images */.aN.images)),
        onDrop: onDrop,
        maxFiles: 1,
        maxSize: 10000000,
        noClick: true
    });
    var initialConfig = (0,ai_config/* createPromptStateFrom */.vU)(params.params);
    var sectionsConfig = params.sections ? params.sections.map(function(section) {
        return (0,ai_config/* createPromptStateFrom */.vU)(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_object_spread/* default */.Z)({}, acc, section) : acc;
    }, initialConfig || {}) : initialConfig || {};
    var ref19 = (0,react.useState)(config), promptState = ref19[0], setPromptState = ref19[1];
    function submitData() {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_async_to_generator/* default */.Z)(function() {
            var ref, url, ref1, upload, download, contentType, res, resolution, calculatedDimensions, ref2, submitData, error, notifier;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionLoading) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        setActionLoading(true);
                        url = null;
                        if (!file) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/deforum-image-url", {
                                content: file.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref1 = _state.sent(), upload = ref1.upload, download = ref1.download, contentType = ref1.contentType;
                        return [
                            4,
                            axios/* default.put */.Z.put(upload, file, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": cdn/* HEADER_WEB_VERSION */.F
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        url = download;
                        _state.label = 4;
                    case 4:
                        res = null;
                        if (promptState && promptState["resolution"]) res = Number(promptState["resolution"]);
                        resolution = res !== null && res !== void 0 ? res : MIN_RESOLUTION;
                        calculatedDimensions = calculateDimensions(resolution, aspectRatio);
                        submitData = (0,_object_spread/* default */.Z)({
                            prompt: (ref2 = (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.textContent) !== null && ref2 !== void 0 ? ref2 : "",
                            style: promptType,
                            tool: "text_to_image",
                            params: promptState !== null && promptState !== void 0 ? promptState : {
                                resolution: 720
                            },
                            face_object_url: url,
                            compositions: selectedModel && imagePosition && selectedComposition ? [
                                {
                                    url: selectedComposition,
                                    rotation: rotation,
                                    bg_aspect: aspectRatio,
                                    c_x: centerX,
                                    c_y: centerY,
                                    width_ratio: imagePosition === null || imagePosition === void 0 ? void 0 : imagePosition.widthRatio
                                }
                            ] : undefined,
                            prompt_model_tags: selectedModel ? [
                                {
                                    id: selectedModel.id,
                                    tag: selectedModel.name
                                }
                            ] : undefined
                        }, calculatedDimensions);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 5:
                        _state.sent();
                        setActionLoading(false);
                        window.removeEventListener("beforeunload", handleLeave);
                        queryClient.invalidateQueries("coins");
                        return [
                            4,
                            router.push("/profile/generations/all")
                        ];
                    case 6:
                        _state.sent();
                        editor.closePage();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        notifier = (0,trigger/* withNotify */.nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    function getMagic() {
        return _getMagic.apply(this, arguments);
    }
    function _getMagic() {
        _getMagic = (0,_async_to_generator/* default */.Z)(function() {
            var magicText, _length, additionalLenght, foundRange, range, selection, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/deforum-magic-prompt", {
                                tool: "text_to_image",
                                style_id: promptType,
                                model_ids: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.id
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        magicText = _state.sent();
                        setLoading(false);
                        handleDivInput(selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name, magicText);
                        additionalLenght = (_length = magicText.length) !== null && _length !== void 0 ? _length : 0;
                        foundRange = setSelectionIndex(additionalLenght);
                        if (foundRange) {
                            range = document.createRange();
                            range.setStart(foundRange.node, foundRange.index);
                            range.setEnd(foundRange.node, foundRange.index);
                            selection = window.getSelection();
                            selection.removeAllRanges();
                            selection.addRange(range);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setLoading(false);
                        console.error(error);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("txt_could_not_get_magic")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getMagic.apply(this, arguments);
    }
    var scrollToImage = (0,react.useCallback)(function(index) {
        var nextImage = document.getElementsByClassName("style-".concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, []);
    (0,react.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage
    ]);
    var handleDivInput = (0,react.useCallback)(function(modelName, content) {
        var ref;
        var selected = modelName !== null && modelName !== void 0 ? modelName : selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name;
        var area = inputRef.current;
        if (!area) {
            return;
        }
        if (content !== undefined) {
            area.textContent = content;
        }
        var ref1;
        setTextLength((ref1 = (ref = area.textContent) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0);
        if (textLength === 0) {
            setSelectedModel(null);
        }
        if (!selected) {
            if (content !== undefined) {
                area.textContent = content;
            }
            return;
        }
        var foundIndex = getSelectionIndex();
        if (content) {
            area.textContent = content;
        }
        area.innerHTML = area.textContent.replace("@" + selected, '<span style="color: #2F91FD;">@'.concat(selected, "</span>"));
        var foundRange = setSelectionIndex(foundIndex);
        if (foundRange) {
            var range = document.createRange();
            range.setStart(foundRange.node, foundRange.index);
            range.setEnd(foundRange.node, foundRange.index);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }, [
        selectedModel,
        textLength
    ]);
    var canSubmit = promptType !== null;
    (0,react.useEffect)(function() {
        var area = inputRef.current;
        if (!area) {
            return;
        }
        if (firstRender) {
            if (selectedModel) {
                handleDivInput(selectedModel.name, content.text);
                var _length;
                var additionalLenght = (_length = selectedModel.name.length) !== null && _length !== void 0 ? _length : 0;
                var foundRange = setSelectionIndex(additionalLenght + 1);
                if (foundRange) {
                    var range = document.createRange();
                    range.setStart(foundRange.node, foundRange.index);
                    range.setEnd(foundRange.node, foundRange.index);
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            } else {
                handleDivInput(undefined, content.text);
            }
            setFirstRender(false);
        }
    }, [
        firstRender,
        selectedModel,
        handleDivInput,
        content.text, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(deform.ParamsContext.Provider, {
        value: params,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "no-scrollbar flex w-full justify-center overflow-y-scroll",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mx-auto my-[32px] flex w-[1175] gap-[25px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    window.removeEventListener("beforeunload", handleLeave);
                                    if (router.asPath === "/editor/text-to-image") {
                                        router.back();
                                    }
                                    editor.closePage();
                                    return [
                                        2
                                    ];
                                });
                            }),
                            className: "group absolute -left-[200px] hidden flex-row items-center gap-3 desktop:top-0 desktop:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("flex h-9 w-9 items-center justify-center rounded-full bg-color-cell inner-border", "inner-border-[transparent] group-hover:inner-border-color-separator"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                        format: "svg",
                                        source: "/general/arrow",
                                        className: "rotate-180"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-lg font-500 text-blue-700 group-hover:text-blue-900",
                                    children: t("lbl_back")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-[575px] flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("relative h-[145px] w-full shrink-0 rounded-[14px] border border-color-separator bg-color-cell transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            contentEditable: true,
                                            ref: inputRef,
                                            "data-placeholder": t("txt_describe_imagination"),
                                            className: (0,clsx_m/* default */.Z)("text-body-5 no-scrollbar h-[98px] w-full resize-none rounded-[14px] bg-color-cell py-2 pl-3 pr-8", "overflow-hidden overflow-y-scroll placeholder:text-color-placeholder focus-visible:outline-none", loading ? "text-color-placeholder" : "text-blue-800"),
                                            onInput: function(e) {
                                                var ref;
                                                handleDivInput();
                                                var text = (ref = e.currentTarget.textContent) === null || ref === void 0 ? void 0 : ref.split(" ");
                                                var includesModelName = text === null || text === void 0 ? void 0 : text.includes("@".concat(selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name));
                                                if ((text === null || text === void 0 ? void 0 : text.includes("@")) && !includesModelName) {
                                                    setIsWriteModel(true);
                                                } else {
                                                    setIsWriteModel(false);
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "absolute bottom-[6px] left-[12px] z-10 flex items-start gap-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    disabled: loading,
                                                    onClick: function() {
                                                        return getMagic();
                                                    },
                                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-1 disabled:pointer-events-none", "px-[13px] py-[3px] hover:rounded-[40px] hover:bg-primary-100"),
                                                    children: [
                                                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "loading",
                                                            src: (0,cdn/* assetUrl */.p)("/ai-tools/text-to-image/loading.webp"),
                                                            className: (0,clsx_m/* default */.Z)("pointer-events-none h-3 w-3 animate-spin [animation-timing-function:linear]")
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,cdn/* assetUrl */.p)("/ai-tools/text-to-image/magic.svg"),
                                                            alt: "magic"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-body-5 font-500 text-primary-500",
                                                            children: t("lbl_surprise_me")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropDown */.vb, {
                                                    hover: true,
                                                    isOpen: isWriteModel,
                                                    className: (0,clsx_m/* default */.Z)(selectedModel && !isWriteModel && textLength !== 0 && "pointer-events-none opacity-50", ((result === null || result === void 0 ? void 0 : result.length) === 0 || result === undefined) && "pointer-events-none opacity-50", "relative"),
                                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("-mb-[30px] pb-[30px]"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex gap-[4px] px-[13px] py-[3px] hover:rounded-[40px] hover:bg-[#2F91FD]/30",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: (0,cdn/* assetUrl */.p)("/general/model-blue-icon.svg"),
                                                                    alt: "model icon"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-body-5 font-500 text-primary-500",
                                                                    children: t("lbl_model")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("no-scrollbar absolute -left-[144px] top-[45px] max-h-[236px] w-[343px]", "overflow-y-scroll rounded-[10px] bg-color-cell px-[8px]", "py-[5px] shadow-xl"),
                                                        children: result === null || result === void 0 ? void 0 : result.map(function(model) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: "flex w-full gap-[10px] rounded-[7px] p-[10px] hover:bg-blue-100",
                                                                onClick: function() {
                                                                    var ref;
                                                                    var area = inputRef.current;
                                                                    if (area && selectedModel && ((ref = area.textContent) === null || ref === void 0 ? void 0 : ref.includes("@" + selectedModel.name))) {
                                                                        area.innerHTML = area.textContent.replace("@" + selectedModel.name, "@" + model.name);
                                                                        handleDivInput(model.name);
                                                                    } else if (area) {
                                                                        var foundIndex = getSelectionIndex();
                                                                        var _textContent;
                                                                        var content = (_textContent = area.textContent) !== null && _textContent !== void 0 ? _textContent : "";
                                                                        var newText = isWriteModel ? content.slice(0, foundIndex) + model.name + content.slice(foundIndex) : content.slice(0, foundIndex) + "@" + model.name + content.slice(foundIndex);
                                                                        area.innerHTML = newText;
                                                                        handleDivInput(model.name);
                                                                        setIsWriteModel(false);
                                                                        var _length;
                                                                        var additionalLenght = (_length = model.name.length) !== null && _length !== void 0 ? _length : 0;
                                                                        var foundRange = setSelectionIndex(additionalLenght + 1);
                                                                        if (foundRange) {
                                                                            var range = document.createRange();
                                                                            range.setStart(foundRange.node, foundRange.index);
                                                                            range.setEnd(foundRange.node, foundRange.index);
                                                                            var selection = window.getSelection();
                                                                            selection.removeAllRanges();
                                                                            selection.addRange(range);
                                                                        }
                                                                    }
                                                                    setSelectedModel({
                                                                        name: model.name,
                                                                        id: model.id
                                                                    });
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: model.thumb_url,
                                                                        alt: "model image",
                                                                        className: "h-[32px] w-[32px] rounded-[6px] object-cover"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[16px] font-500 text-blue-700",
                                                                        children: model.name
                                                                    })
                                                                ]
                                                            }, model.id);
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                handleDivInput(undefined, "");
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute right-3 top-2 flex h-[17px] w-[17px] items-center justify-center rounded-full", "bg-blue-200 transition-colors [--icon-color:var(--color-blue-700)] hover:bg-blue-400"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClearIcon */.Rk, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute bottom-2 right-3 flex flex-row items-center gap-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[14px] font-500 text-color-placeholder",
                                                children: textLength + "/1000"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("flex w-full flex-row items-center justify-between rounded-[14px] bg-color-cell px-5 py-[10px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: aspects.map(function(aspect, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            onClick: function() {
                                                setAspectRation(aspect.aspectWidth / aspect.aspectHeight);
                                            },
                                            className: "flex cursor-pointer flex-col items-center justify-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: aspect.width,
                                                        height: aspect.height
                                                    },
                                                    className: (0,clsx_m/* default */.Z)("rounded-[2px] transition-colors", aspect.aspectWidth / aspect.aspectHeight === aspectRatio ? "bg-primary-500" : "bg-blue-300 hover:bg-blue-400 dark:bg-[#34353D]")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (0,clsx_m/* default */.Z)("text-[14px] font-500 transition-colors", aspect.aspectWidth / aspect.aspectHeight === aspectRatio ? "text-primary-500" : "text-color-placeholder"),
                                                    children: aspect.aspectWidth + ":" + aspect.aspectHeight
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("flex flex-col items-stretch gap-2 rounded-[15px] bg-color-cell px-4 py-[10px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-start justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[16px] font-700 text-blue-600",
                                                    children: t("lbl_styles")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("flex flex-row items-start gap-[6px]", styles.length <= 4 && "pointer-events-none opacity-0"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            disabled: offset === 0,
                                                            onClick: function() {
                                                                return scrollToImage(offset - 1);
                                                            },
                                                            style: {
                                                                filter: "drop-shadow(0px 2.5px 15px rgba(123, 128, 158, 0.15))"
                                                            },
                                                            className: (0,clsx_m/* default */.Z)("flex h-5 w-5 items-center justify-center rounded-full", "bg-color-cell transition-all inner-border inner-border-color-separator", "[--icon-color:var(--color-blue-700)] hover:inner-border-blue-500", "disabled:hover:inner-border-color-separator"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ButtonArrowIcon */.hd, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            disabled: offset === styles.length - 4,
                                                            onClick: function() {
                                                                return scrollToImage(offset + 1);
                                                            },
                                                            style: {
                                                                filter: "drop-shadow(0px 2.5px 15px rgba(123, 128, 158, 0.15))"
                                                            },
                                                            className: (0,clsx_m/* default */.Z)("flex h-5 w-5 items-center justify-center rounded-full", "bg-color-cell transition-all inner-border inner-border-color-separator", "hover:inner-border-blue-500 disabled:hover:inner-border-color-separator"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: " rotate-180 [--icon-color:var(--color-blue-700)]",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ButtonArrowIcon */.hd, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onScroll: function(event) {
                                                var container = event.target;
                                                if ((0,_instanceof/* default */.Z)(container, HTMLElement)) {
                                                    var snapIndex = Math.floor(container.scrollLeft / (container.offsetWidth - 424));
                                                    setOffset(snapIndex);
                                                }
                                            },
                                            className: "no-scrollbar flex snap-x snap-mandatory flex-row items-center gap-2 overflow-x-scroll",
                                            children: styles.map(function(param, index) {
                                                var name = param.name, id = param.id, image = param.image;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("relative h-[126px] w-[126px] shrink-0 snap-start overflow-hidden rounded-[8px]", promptType === id && "border-primary-500", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors", "style-".concat(index)),
                                                    onClick: function() {
                                                        if (promptType !== id) {
                                                            var style = styles.find(function(style) {
                                                                return style.id === id;
                                                            });
                                                            if (style && style.ignoreFace && file) {
                                                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* WarningMessage */.jB, {
                                                                    children: t("txt_not_supported_face")
                                                                }));
                                                            }
                                                            setPromptType(id);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: image,
                                                            alt: "cover of ".concat(name, " style"),
                                                            className: (0,clsx_m/* default */.Z)("pointer-events-none aspect-1 h-full object-cover")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute bottom-0 left-0 h-8 w-full bg-gradient-to-t from-color-black/60 to-[transparent]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "absolute bottom-1 left-2 text-[13px] font-600 text-color-white",
                                                            children: name
                                                        })
                                                    ]
                                                }, id);
                                            })
                                        })
                                    ]
                                }),
                                selectedModel !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelComposition, {
                                    aspectRatio: aspectRatio,
                                    compInfo: (ref = result === null || result === void 0 ? void 0 : result.find(function(elem) {
                                        return elem.name === selectedModel.name;
                                    })) === null || ref === void 0 ? void 0 : ref.comp_info,
                                    selectedComposition: selectedComposition,
                                    setSelectedComposition: setSelectedComposition,
                                    imagePosition: imagePosition,
                                    setImagePosition: setImagePosition,
                                    setRotation: setRotation,
                                    setCenterX: setCenterX,
                                    setCenterY: setCenterY
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col items-start rounded-[14px] bg-color-cell px-[14px] py-[10px]", ((ref1 = styles.find(function(style) {
                                        return style.id === promptType;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.ignoreFace) && "pointer-events-none opacity-30", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropDown */.vb, {
                                            hover: true,
                                            className: "!absolute right-3 top-3 h-[18px]",
                                            zIndex: "z-10",
                                            contentClassName: "-translate-y-3",
                                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " z-10 [--icon-color:var(--color-blue-600)]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfoIcon */.sz, {})
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute z-50 w-[575px] -translate-x-1/2 pt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.13)"
                                                    },
                                                    className: "w-full rounded-[16px] bg-color-cell px-[14px] py-[16px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex w-full flex-col gap-[10px]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-[18px] font-500 leading-normal text-blue-700",
                                                                children: t("txt_face_replace_guide_title")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex w-full flex-row gap-3 rounded-[15px] border border-blue-300 p-2",
                                                                children: [
                                                                    goodPhotos.map(function(photo) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "relative h-[86px] w-[86px] rounded-lg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: (0,cdn/* assetUrl */.p)(photo),
                                                                                    alt: "good photo",
                                                                                    className: "pointer-events-none h-full w-full select-none rounded-lg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "absolute left-1 top-1",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckboxIcon */.PD, {})
                                                                                })
                                                                            ]
                                                                        }, photo);
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex flex-1 flex-col justify-start gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-[16px] font-600 leading-normal text-blue-800",
                                                                                children: t("txt_good_photos")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                                                                children: t("txt_make_sure_visible")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex w-full flex-row gap-3 rounded-[15px] border border-blue-300 p-2",
                                                                children: [
                                                                    badPhotos.map(function(photo) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "relative h-[86px] w-[86px] rounded-lg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: (0,cdn/* assetUrl */.p)(photo),
                                                                                    alt: "bad photo",
                                                                                    className: "pointer-events-none h-full w-full select-none rounded-lg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "absolute left-1 top-1",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                                                                                })
                                                                            ]
                                                                        }, photo);
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex flex-1 flex-col justify-start gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-[16px] font-600 leading-normal text-blue-800",
                                                                                children: t("txt_bad_photos")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                                                                children: t("txt_group_pics")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center gap-[10px] [--icon-color:var(--color-blue-600)]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIcon */.XB, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col items-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-start gap-[5px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: " text-[16px] font-600 leading-normal text-blue-800",
                                                                    children: t("common:txt_reference_face")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "bg-primary-500/10 rounded px-1 py-[2px] text-[12px] font-700 text-primary-500",
                                                                    children: t("common:lbl_new")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[14px] font-400 leading-normal text-blue-600",
                                                            children: t("common:txt_change_face_into_photo")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        file ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex w-full flex-row items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: URL.createObjectURL(file),
                                                            alt: "uploaded file",
                                                            className: "aspect-1 w-[82px] rounded-lg object-cover"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[16px] font-500 text-color-placeholder",
                                                            children: fileName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return setFile(null);
                                                    },
                                                    className: "flex h-12 w-12 items-center justify-center rounded-full bg-[#FD2E2E]/10 transition-colors hover:bg-[#FD2E2E]/20",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {})
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 w-[547px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaSmall */.Kg, {
                                                border: true,
                                                borderImage: "/general/border-dropzone-2",
                                                className: "h-[93px] w-full bg-[#E7EAF7] dark:bg-[#313649]",
                                                state: dropzoneState,
                                                formats: [
                                                    "image/png",
                                                    "image/jpeg"
                                                ],
                                                openExplorer: openExplorer
                                            })
                                        })
                                    ]
                                }),
                                promptState && /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_config/* ParamtersTrigger */.dS, {
                                    actionLoading: actionLoading,
                                    promptState: promptState,
                                    setPromptState: setPromptState,
                                    className: "!py-[18px]"
                                }),
                                isPro ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    disabled: textLength === 0 || !canSubmit,
                                    className: (0,clsx_m/* default */.Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-primary-500 hover:bg-primary-600", "relative py-3 transition-colors", "flex items-center justify-center gap-4", actionLoading && "pointer-events-none"),
                                    onClick: function() {
                                        if (actionLoading) return;
                                        submitData();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (0,clsx_m/* default */.Z)("h-6 w-6 animate-[spin_1s_infinite_linear]", actionLoading ? "opacity-100" : "opacity-0"),
                                                src: (0,cdn/* assetUrl */.p)("/general/loading-dark.webp"),
                                                alt: "loading"
                                            })
                                        }),
                                        t("lbl_generate"),
                                        promptState && params.params && /*#__PURE__*/ (0,jsx_runtime.jsx)(CostsCoins, {
                                            coins: getPromptPrice(promptState, params.params, params.price)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    disabled: textLength === 0,
                                    className: (0,clsx_m/* default */.Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-[#2F91FD] hover:bg-[#0264CF]", "py-3 transition-colors"),
                                    onClick: function() {
                                        return setSubscriptionPopupOpen(true);
                                    },
                                    children: t("txt_subscribe_to_continue")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[70px] w-full shrink-0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                    isOpen: subscriptionPopupOpen,
                    close: function() {
                        return setSubscriptionPopupOpen(false);
                    },
                    location: "/editor/text-to-image",
                    addToStorage: addToStorage
                })
            ]
        })
    });
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function getPromptPrice(prompt, params, non_free_price) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            var promptID = prompt[param.id];
            if (typeof promptID !== "number") {
                continue;
            }
            if (param.type !== "slider") {
                continue;
            }
            if (promptID > param.maxFreeValue) {
                return non_free_price;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0;
}
function CostsCoins(props) {
    var coins = props.coins;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var isCoinFree = (0,client_auth/* getUserEntitlements */.xx)(userInfo.entitlements).isCoinFree;
    if (isCoinFree || !coins) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-1 rounded-full bg-[#C6113F] px-1 text-[14px] font-700 text-color-white",
        children: [
            "+",
            coins,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)("/general/coin.svg"),
                alt: "coins"
            })
        ]
    });
}
var actionMimes = {
    deform: [
        "images",
        "videos"
    ],
    restyle: [
        "videos"
    ],
    photo_ai: [
        "images"
    ]
};
function getAcceptedMimes() {
    var mimes = (0,_to_consumable_array/* default */.Z)(actionMimes["photo_ai"]);
    var empty = [];
    var allMimes = mimes.reduce(function(all, single) {
        return (0,_to_consumable_array/* default */.Z)(all).concat((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes */.aN[single]));
    }, empty);
    return allMimes.join(", ");
}
var aspects = [
    {
        width: 23,
        height: 29,
        aspectWidth: 3,
        aspectHeight: 4
    },
    {
        width: 27,
        height: 27,
        aspectWidth: 1,
        aspectHeight: 1
    },
    {
        width: 24,
        height: 38,
        aspectWidth: 9,
        aspectHeight: 16
    },
    {
        width: 37,
        height: 24,
        aspectWidth: 16,
        aspectHeight: 9
    },
    {
        width: 29,
        height: 22,
        aspectWidth: 4,
        aspectHeight: 3
    },
    {
        width: 24,
        height: 26,
        aspectWidth: 4,
        aspectHeight: 5
    },
    {
        width: 26,
        height: 24,
        aspectWidth: 5,
        aspectHeight: 4
    }, 
];
var goodPhotos = [
    "/ai-tools/text-to-image/good-photo-1.webp",
    "/ai-tools/text-to-image/good-photo-2.webp",
    "/ai-tools/text-to-image/good-photo-3.webp", 
];
var badPhotos = [
    "/ai-tools/text-to-image/bad-photo-1.webp",
    "/ai-tools/text-to-image/bad-photo-2.webp",
    "/ai-tools/text-to-image/bad-photo-3.webp", 
];


/***/ }),

/***/ 5042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFORUM_STORAGE_KEY": function() { return /* binding */ DEFORUM_STORAGE_KEY; },
/* harmony export */   "MIN_RESOLUTION": function() { return /* binding */ MIN_RESOLUTION; },
/* harmony export */   "calculateDimensions": function() { return /* binding */ calculateDimensions; },
/* harmony export */   "default": function() { return /* binding */ TextToVideoEditor; },
/* harmony export */   "textToVideoStorageSchema": function() { return /* binding */ textToVideoStorageSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9483);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2512);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8767);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5091);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1604);
/* harmony import */ var _ai_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9264);
/* harmony import */ var _ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1455);
/* harmony import */ var _dropdown__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3153);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9612);
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9034);
/* harmony import */ var _simple_drop_area__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(356);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9460);
/* harmony import */ var _deform__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8641);






























function calculateDimensions(resolutionWidth, aspectRatio) {
    var height = resolutionWidth / aspectRatio;
    return {
        width: resolutionWidth,
        height: Math.ceil(height)
    };
}
var remoteStorageSchema = zod__WEBPACK_IMPORTED_MODULE_18__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_18__.z.literal("remote"),
    url: zod__WEBPACK_IMPORTED_MODULE_18__.z.string().nullable()
});
var localStorageSchema = zod__WEBPACK_IMPORTED_MODULE_18__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_18__.z.literal("local"),
    blob: zod__WEBPACK_IMPORTED_MODULE_18__.z.unknown()
});
var DEFORUM_STORAGE_KEY = "last";
var textToVideoStorageSchema = zod__WEBPACK_IMPORTED_MODULE_18__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_18__.z.literal("text_to_video").default("text_to_video"),
    id: zod__WEBPACK_IMPORTED_MODULE_18__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_18__.z.string().nullable(),
    text: zod__WEBPACK_IMPORTED_MODULE_18__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_18__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var MIN_RESOLUTION = 450;
function TextToVideoEditor(props) {
    var updateInput = function updateInput(newValue) {
        inputHistory.push(text);
        if (inputHistory.length >= maxHistoryLength) {
            inputHistory.shift();
        }
        setText(newValue);
    };
    var ref;
    if (props.content.tool !== "text_to_video") {
        throw new Error("You are not in text to image editor.");
    }
    var content = props.content, parameters = props.params, blob = props.blob;
    if (parameters === null) {
        throw new Error("Parameters for filters are null.");
    }
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__/* .useEditorParamsContext */ .mK)();
    var styles = parameters.styles, params = parameters.params;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(blob), file = ref1[0], setFile = ref1[1];
    var _promptType;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)((_promptType = content.promptType) !== null && _promptType !== void 0 ? _promptType : styles[0].id), promptType = ref2[0], setPromptType = ref2[1];
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).notify;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(content.text), text = ref3[0], setText = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), fileName = ref5[0], setFileName = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(0), offset = ref6[0], setOffset = ref6[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_8__.useQueryClient)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), subscriptionPopupOpen = ref7[0], setSubscriptionPopupOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), actionLoading = ref8[0], setActionLoading = ref8[1];
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_2__/* .useIndexedDB */ .i)("ai_art", "text_to_video", textToVideoStorageSchema);
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var payload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready") {
                            console.error("Indexed is not ready");
                            return [
                                2
                            ];
                        }
                        payload = {
                            tool: "text_to_video",
                            id: DEFORUM_STORAGE_KEY,
                            promptType: promptType,
                            text: text,
                            location: "local",
                            blob: file
                        };
                        return [
                            4,
                            indexed.setData(payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    var openExplorer = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function() {
        var fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = getAcceptedMimes();
        fileInput.onchange = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(_) {
                var _files, file, isOk;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!fileInput.files) return [
                                3,
                                2
                            ];
                            _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(fileInput.files, 1), file = _files[0];
                            return [
                                4,
                                (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__/* .isImageOrVideo */ .c2)(file)
                            ];
                        case 1:
                            isOk = _state.sent();
                            if (!isOk) {
                                notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_14__/* .ErrorMessage */ .Bc, {
                                    children: t("txt_wrong_file_uploaded")
                                }));
                            } else {
                                setFile(file);
                                setFileName(file.name);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        fileInput.click();
    }, [
        notify,
        t,
        setFile
    ]);
    function onDrop(files) {
        return _onDrop.apply(this, arguments);
    }
    function _onDrop() {
        _onDrop = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(files) {
            var _files, file, isOk;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(files, 1), file = _files[0];
                        if (!file) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_9__/* .isImageOrVideo */ .c2)(file)
                        ];
                    case 1:
                        isOk = _state.sent();
                        if (!isOk) {
                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_14__/* .ErrorMessage */ .Bc, {
                                children: t("txt_wrong_file_uploaded")
                            }));
                        } else {
                            setFile(file);
                            setFileName(file.name);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _onDrop.apply(this, arguments);
    }
    var dropzoneState = (0,react_dropzone__WEBPACK_IMPORTED_MODULE_22__/* .useDropzone */ .uI)({
        accept: (0,_simple_drop_area__WEBPACK_IMPORTED_MODULE_15__/* .getFormatsFromMimeTypes */ .lz)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_simple_drop_area__WEBPACK_IMPORTED_MODULE_15__/* .mimeTypes.images */ .aN.images)),
        onDrop: onDrop,
        maxFiles: 1,
        maxSize: 10000000,
        noClick: true
    });
    var initialConfig = (0,_ai_config__WEBPACK_IMPORTED_MODULE_10__/* .createPromptStateFrom */ .vU)(params.params);
    var sectionsConfig = params.sections ? params.sections.map(function(section) {
        return (0,_ai_config__WEBPACK_IMPORTED_MODULE_10__/* .createPromptStateFrom */ .vU)(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, acc, section) : acc;
    }, initialConfig || {}) : initialConfig || {};
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(config), promptState = ref9[0], setPromptState = ref9[1];
    function submitData() {
        return _submitData.apply(this, arguments);
    }
    function _submitData() {
        _submitData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var url, ref, upload, download, contentType, submitData, error, notifier;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (actionLoading) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        setActionLoading(true);
                        url = null;
                        if (!file) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: file.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), upload = ref.upload, download = ref.download, contentType = ref.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].put */ .Z.put(upload, file, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        url = download;
                        _state.label = 4;
                    case 4:
                        submitData = {
                            prompt: text,
                            style: promptType,
                            tool: "text_to_video",
                            params: promptState !== null && promptState !== void 0 ? promptState : {
                                resolution: MIN_RESOLUTION
                            },
                            face_object_url: url
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 5:
                        _state.sent();
                        setActionLoading(false);
                        window.removeEventListener("beforeunload", handleLeave);
                        queryClient.invalidateQueries("coins");
                        return [
                            4,
                            router.push("/home")
                        ];
                    case 6:
                        _state.sent();
                        editor.closePage();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        notifier = (0,_utils_trigger__WEBPACK_IMPORTED_MODULE_4__/* .withNotify */ .nX)(function(t) {
                            return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_14__/* .ErrorMessage */ .Bc, {
                                children: t
                            }));
                        });
                        notifier(error);
                        console.error(error);
                        setSubscriptionPopupOpen(false);
                        setActionLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return _submitData.apply(this, arguments);
    }
    function getMagic() {
        return _getMagic.apply(this, arguments);
    }
    function _getMagic() {
        _getMagic = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
            var magicText, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-magic-prompt", {
                                tool: "text_to_video"
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        magicText = _state.sent();
                        setLoading(false);
                        updateInput(magicText);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setLoading(false);
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_14__/* .ErrorMessage */ .Bc, {
                            children: t("txt_could_not_get_magic")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getMagic.apply(this, arguments);
    }
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), inputHistory = ref10[0], _ = ref10[1];
    var maxHistoryLength = 50;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var handleUndo = function(e) {
            if (e.ctrlKey && e.key === "z" || e.metaKey && e.key === "z") {
                if (inputHistory.length > 0) {
                    var ref;
                    setText((ref = inputHistory.pop()) !== null && ref !== void 0 ? ref : "");
                }
            }
        };
        window.addEventListener("keydown", handleUndo);
        return function() {
            window.removeEventListener("keydown", handleUndo);
        };
    }, [
        inputHistory,
        setText
    ]);
    var scrollToImage = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function(index) {
        var nextImage = document.getElementsByClassName("style-".concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage
    ]);
    var canSubmit = promptType !== null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deform__WEBPACK_IMPORTED_MODULE_17__.ParamsContext.Provider, {
        value: params,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex w-full justify-center overflow-y-scroll",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mx-auto my-[32px] flex w-[1175] gap-[25px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                                    window.removeEventListener("beforeunload", handleLeave);
                                    if (router.asPath === "/editor/text-to-video") {
                                        router.back();
                                    }
                                    editor.closePage();
                                    return [
                                        2
                                    ];
                                });
                            }),
                            className: "group absolute -left-[200px] hidden flex-row items-center gap-3 desktop:top-0 desktop:flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex h-9 w-9 items-center justify-center rounded-full bg-color-cell inner-border inner-border-[transparent] group-hover:inner-border-color-separator",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_13__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/general/arrow",
                                        className: "rotate-180"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: " text-lg font-500 text-blue-700 group-hover:text-blue-900",
                                    children: t("lbl_back")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-[575px] flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative h-[145px] w-full shrink-0 rounded-[14px] border border-color-separator bg-color-cell transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                            disabled: loading,
                                            placeholder: t("txt_describe_imagination"),
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("text-body-5 no-scrollbar h-[110px] w-full resize-none rounded-[14px] bg-color-cell py-2 pl-3 pr-8 placeholder:text-color-placeholder focus-visible:outline-none", loading ? "text-color-placeholder" : "text-grey-800"),
                                            value: text,
                                            onChange: function(e) {
                                                var inputValue = e.currentTarget.value;
                                                if (inputValue.length <= 1000) {
                                                    setText(inputValue);
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            disabled: loading,
                                            onClick: function() {
                                                return getMagic();
                                            },
                                            className: "absolute bottom-2 left-3 flex flex-row items-center gap-1 disabled:pointer-events-none",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/ai-tools/text-to-image/magic.svg"),
                                                    alt: "magic"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-body-5 font-500 text-primary-500",
                                                    children: t("lbl_surprise_me")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "loading",
                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/ai-tools/text-to-image/loading.webp"),
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("pointer-events-none h-3 w-3 animate-spin [animation-timing-function:linear]", loading ? "opacity-100" : "opacity-0")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function() {
                                                setText("");
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("absolute right-3 top-2 flex h-[17px] w-[17px] items-center justify-center rounded-full", "bg-blue-200 transition-colors [--icon-color:var(--color-blue-700)] hover:bg-blue-400"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .ClearIcon */ .Rk, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute bottom-2 right-3 flex flex-row items-center gap-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-500 text-color-placeholder",
                                                children: text.length + "/1000"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("flex flex-col items-stretch gap-2 rounded-[15px] bg-color-cell px-4 py-[10px] transition-all", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-row items-start justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-grey-600 text-[16px] font-700",
                                                    children: t("lbl_styles")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("flex flex-row items-start gap-[6px]", styles.length <= 4 && "pointer-events-none opacity-0"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            disabled: offset === 0,
                                                            onClick: function() {
                                                                return scrollToImage(offset - 1);
                                                            },
                                                            style: {
                                                                filter: "drop-shadow(0px 2.5px 15px rgba(123, 128, 158, 0.15))"
                                                            },
                                                            className: "flex h-5 w-5 items-center justify-center rounded-full bg-color-cell transition-all inner-border inner-border-color-separator [--icon-color:var(--color-blue-700)] hover:inner-border-blue-500 disabled:hover:inner-border-color-separator",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .ButtonArrowIcon */ .hd, {})
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            disabled: offset === styles.length - 4,
                                                            onClick: function() {
                                                                return scrollToImage(offset + 1);
                                                            },
                                                            style: {
                                                                filter: "drop-shadow(0px 2.5px 15px rgba(123, 128, 158, 0.15))"
                                                            },
                                                            className: "flex h-5 w-5 items-center justify-center rounded-full bg-color-cell transition-all inner-border inner-border-color-separator hover:inner-border-blue-500 disabled:hover:inner-border-color-separator",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: " rotate-180 [--icon-color:var(--color-blue-700)]",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .ButtonArrowIcon */ .hd, {})
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            onScroll: function(event) {
                                                var container = event.target;
                                                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(container, HTMLElement)) {
                                                    var snapIndex = Math.floor(container.scrollLeft / (container.offsetWidth - 424));
                                                    setOffset(snapIndex);
                                                }
                                            },
                                            className: "no-scrollbar flex snap-x snap-mandatory flex-row items-center gap-2 overflow-x-scroll",
                                            children: styles.map(function(param, index) {
                                                var name = param.name, id = param.id, image = param.image;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative h-[126px] w-[126px] shrink-0 snap-start overflow-hidden rounded-[8px]", promptType === id && "border-primary-1", "select-none border-2 border-[transparent]", "cursor-pointer transition-colors", "style-".concat(index)),
                                                    onClick: function() {
                                                        if (promptType !== id) {
                                                            var style = styles.find(function(style) {
                                                                return style.id === id;
                                                            });
                                                            if (style && style.ignoreFace && file) {
                                                                notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_message__WEBPACK_IMPORTED_MODULE_14__/* .WarningMessage */ .jB, {
                                                                    children: t("txt_not_supported_face")
                                                                }));
                                                            }
                                                            setPromptType(id);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: image,
                                                            alt: "cover of ".concat(name, " style"),
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("pointer-events-none aspect-1 h-full object-cover")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute bottom-0 left-0 h-8 w-full bg-gradient-to-t from-color-black/60 to-[transparent]"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "absolute bottom-1 left-2 text-[13px] font-600 text-color-white",
                                                            children: name
                                                        })
                                                    ]
                                                }, id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("relative flex w-full flex-col items-start rounded-[14px] bg-color-cell px-[14px] py-[10px]", ((ref = styles.find(function(style) {
                                        return style.id === promptType;
                                    })) === null || ref === void 0 ? void 0 : ref.ignoreFace) && "pointer-events-none opacity-30", actionLoading && "pointer-events-none opacity-30"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_12__/* .DropDown */ .vb, {
                                            hover: true,
                                            className: "!absolute right-3 top-3 h-[18px]",
                                            zIndex: "z-10",
                                            contentClassName: "-translate-y-3",
                                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " [--icon-color:var(--color-blue-600)]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .InfoIcon */ .sz, {})
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute z-50 w-[575px] -translate-x-1/2 pt-3",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.13)"
                                                    },
                                                    className: "w-full rounded-[16px] bg-color-popup-cell px-[14px] py-[16px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex w-full flex-col gap-[10px]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[18px] font-500 leading-normal text-blue-700",
                                                                children: t("txt_face_replace_guide_title")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "flex w-full flex-row gap-3 rounded-[15px] border border-blue-300 p-2",
                                                                children: [
                                                                    goodPhotos.map(function(photo) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "relative h-[86px] w-[86px] rounded-lg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)(photo),
                                                                                    alt: "good photo",
                                                                                    className: "pointer-events-none h-full w-full select-none rounded-lg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "absolute left-1 top-1",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .CheckboxIcon */ .PD, {})
                                                                                })
                                                                            ]
                                                                        }, photo);
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "flex flex-1 flex-col justify-start gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "text-[16px] font-600 leading-normal text-blue-800",
                                                                                children: t("txt_good_photos")
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                                                                children: t("txt_make_sure_visible")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "flex w-full flex-row gap-3 rounded-[15px] border border-blue-300 p-2",
                                                                children: [
                                                                    badPhotos.map(function(photo) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "relative h-[86px] w-[86px] rounded-lg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)(photo),
                                                                                    alt: "bad photo",
                                                                                    className: "pointer-events-none h-full w-full select-none rounded-lg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "absolute left-1 top-1",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .CloseIcon */ .Tw, {})
                                                                                })
                                                                            ]
                                                                        }, photo);
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "flex flex-1 flex-col justify-start gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "text-[16px] font-600 leading-normal text-blue-800",
                                                                                children: t("txt_bad_photos")
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                                                                children: t("txt_group_pics")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-row items-center gap-[10px] [--icon-color:var(--color-blue-600)]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .ImageIcon */ .XB, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col items-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-start gap-[5px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: " text-[16px] font-600 leading-normal text-blue-800",
                                                                    children: t("common:txt_reference_face")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "bg-primary-100 text-primary-500 rounded px-1 py-[2px] text-[12px] font-700",
                                                                    children: t("common:lbl_new")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-[14px] font-400 leading-normal text-blue-600",
                                                            children: t("common:txt_change_face_into_photo")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        file ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mt-4 flex w-full flex-row items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-row items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: URL.createObjectURL(file),
                                                            alt: "uploaded file",
                                                            className: "aspect-1 w-[82px] rounded-lg object-cover"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-[16px] font-500 text-color-placeholder",
                                                            children: fileName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    onClick: function() {
                                                        return setFile(null);
                                                    },
                                                    className: "flex h-12 w-12 items-center justify-center rounded-full bg-[#FD2E2E]/10 transition-colors hover:bg-[#FD2E2E]/20",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_tools_icons__WEBPACK_IMPORTED_MODULE_11__/* .TrashIcon */ .XH, {})
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-4 w-[547px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_simple_drop_area__WEBPACK_IMPORTED_MODULE_15__/* .DropAreaSmall */ .Kg, {
                                                border: true,
                                                borderImage: "/general/border-dropzone-2",
                                                className: "h-[93px] w-full bg-[#E7EAF7] dark:bg-[#313649]",
                                                state: dropzoneState,
                                                formats: [
                                                    "image/png",
                                                    "image/jpeg"
                                                ],
                                                openExplorer: openExplorer
                                            })
                                        })
                                    ]
                                }),
                                promptState && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ai_config__WEBPACK_IMPORTED_MODULE_10__/* .ParamtersTrigger */ .dS, {
                                    actionLoading: actionLoading,
                                    promptState: promptState,
                                    setPromptState: setPromptState,
                                    className: "!py-[18px]"
                                }),
                                isPro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    disabled: text.trim().length === 0 || !canSubmit,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-primary-500 hover:bg-primary-600", "relative py-3 transition-colors", "flex items-center justify-center gap-4", actionLoading && "pointer-events-none"),
                                    onClick: function() {
                                        if (actionLoading) return;
                                        submitData();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("h-6 w-6 animate-[spin_1s_infinite_linear]", actionLoading ? "opacity-100" : "opacity-0"),
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/loading-dark.webp"),
                                                alt: "loading"
                                            })
                                        }),
                                        t("lbl_generate"),
                                        promptState && params.params && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostsCoins, {
                                            coins: getPromptPrice(promptState, params.params, params.price)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: text.trim().length === 0,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("mt-[15px] rounded-[10px] font-500", "text-[16px] text-color-white disabled:opacity-50", "disabled:pointer-events-none", "bg-[#2F91FD] hover:bg-[#0264CF]", "py-3 transition-colors"),
                                    onClick: function() {
                                        return setSubscriptionPopupOpen(true);
                                    },
                                    children: t("txt_subscribe_to_continue")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[70px] w-full shrink-0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_subscription_popup__WEBPACK_IMPORTED_MODULE_16__/* .SubscriptionPopup */ .yj, {
                    isOpen: subscriptionPopupOpen,
                    close: function() {
                        return setSubscriptionPopupOpen(false);
                    },
                    location: "/editor/text-to-video",
                    addToStorage: addToStorage
                })
            ]
        })
    });
}
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
function getPromptPrice(prompt, params, non_free_price) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            var promptID = prompt[param.id];
            if (typeof promptID !== "number") {
                continue;
            }
            if (param.type !== "slider") {
                continue;
            }
            if (promptID > param.maxFreeValue) {
                return non_free_price;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 0;
}
function CostsCoins(props) {
    var coins = props.coins;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().userInfo;
    var isCoinFree = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_1__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isCoinFree;
    if (isCoinFree || !coins) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-1 rounded-full bg-primary-300 px-1 text-[14px] font-700 text-color-white",
        children: [
            "+",
            coins,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/general/coin.svg"),
                alt: "coins"
            })
        ]
    });
}
var actionMimes = {
    deform: [
        "images",
        "videos"
    ],
    restyle: [
        "videos"
    ],
    photo_ai: [
        "images"
    ]
};
function getAcceptedMimes() {
    var mimes = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(actionMimes["photo_ai"]);
    var empty = [];
    var allMimes = mimes.reduce(function(all, single) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(all).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(_simple_drop_area__WEBPACK_IMPORTED_MODULE_15__/* .mimeTypes */ .aN[single]));
    }, empty);
    return allMimes.join(", ");
}
var goodPhotos = [
    "/ai-tools/text-to-image/good-photo-1.webp",
    "/ai-tools/text-to-image/good-photo-2.webp",
    "/ai-tools/text-to-image/good-photo-3.webp", 
];
var badPhotos = [
    "/ai-tools/text-to-image/bad-photo-1.webp",
    "/ai-tools/text-to-image/bad-photo-2.webp",
    "/ai-tools/text-to-image/bad-photo-3.webp", 
];


/***/ }),

/***/ 7953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(177);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




var Favicon = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), dark = ref[0], setDark = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setDark(window.matchMedia("(prefers-color-scheme: dark)").matches);
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", function(media) {
            return setDark(media.matches);
        });
    }, [
        setDark
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#121212"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ecedef"
            }),
            dark ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/icons/favicon-dark.svg"),
                rel: "icon"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/icons/favicon-light.svg"),
                rel: "icon"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Favicon);


/***/ }),

/***/ 501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Relative; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);


var Floating = function(props) {
    var position = props.position, className = props.className, children = props.children, z = props.z, none = props.none;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            position: "absolute",
            width: "100%",
            zIndex: z,
            display: none ? "none" : "block"
        }, position),
        className: className,
        children: children
    });
};
var Relative = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "relative",
            overflow: "visible"
        },
        children: props.children
    });
};

/* harmony default export */ __webpack_exports__["Z"] = (Floating);


/***/ }),

/***/ 8109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ WrappedFooter; },
  "Z": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
;// CONCATENATED MODULE: ./comps/footer/socials.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  height: 42px;\n\n  margin-bottom: 10px;\n\n  @media ",
        " {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  cursor: pointer;\n\n  * path {\n    transition: fill 200ms ease-in-out;\n  }\n\n  :hover {\n    * path[fill="var(--color-blue-600)"] {\n      fill: var(--color-blue-900);\n    }\n  }\n\n  height: 42px;\n\n  @media ',
        " {\n    height: 33px;\n  }\n\n  @media ",
        " {\n    height: 42px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var SocialsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-601f083e-0"
})(_templateObject(), breakpoints/* devices.tablet */.Hb.tablet);
var SocialImage = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-601f083e-1"
})(_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var socials_Socials = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialsContainer, {
        children: [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.723 20.9993C18.723 19.4653 19.9662 18.2213 21.5003 18.2213C23.0344 18.2213 24.2783 19.4653 24.2783 20.9993C24.2783 22.5334 23.0344 23.7773 21.5003 23.7773C19.9662 23.7773 18.723 22.5334 18.723 20.9993ZM17.2213 20.9993C17.2213 23.3627 19.137 25.2784 21.5003 25.2784C23.8636 25.2784 25.7794 23.3627 25.7794 20.9993C25.7794 18.636 23.8636 16.7203 21.5003 16.7203C19.137 16.7203 17.2213 18.636 17.2213 20.9993ZM24.9488 16.5506C24.9487 16.7484 25.0073 16.9418 25.1171 17.1063C25.2269 17.2707 25.383 17.399 25.5657 17.4747C25.7484 17.5505 25.9495 17.5704 26.1435 17.5319C26.3375 17.4934 26.5157 17.3982 26.6556 17.2584C26.7955 17.1186 26.8908 16.9405 26.9295 16.7465C26.9681 16.5525 26.9484 16.3515 26.8728 16.1687C26.7972 15.9859 26.6691 15.8297 26.5047 15.7198C26.3403 15.6098 26.1469 15.5511 25.9492 15.551H25.9488C25.6837 15.5511 25.4294 15.6565 25.2419 15.8439C25.0544 16.0313 24.949 16.2855 24.9488 16.5506ZM18.1336 27.7825C17.3212 27.7455 16.8796 27.6101 16.5861 27.4958C16.1971 27.3443 15.9195 27.1639 15.6276 26.8725C15.3357 26.581 15.1551 26.3037 15.0043 25.9146C14.8899 25.6213 14.7545 25.1795 14.7176 24.3671C14.6772 23.4887 14.6691 23.2248 14.6691 20.9994C14.6691 18.774 14.6779 18.5109 14.7176 17.6317C14.7546 16.8193 14.8909 16.3784 15.0043 16.0842C15.1557 15.6951 15.3361 15.4175 15.6276 15.1257C15.9191 14.8338 16.1964 14.6531 16.5861 14.5023C16.8795 14.3879 17.3212 14.2526 18.1336 14.2157C19.012 14.1753 19.2759 14.1672 21.5003 14.1672C23.7247 14.1672 23.9888 14.1759 24.868 14.2157C25.6804 14.2527 26.1213 14.389 26.4155 14.5023C26.8046 14.6531 27.0822 14.8342 27.374 15.1257C27.6659 15.4171 27.8459 15.6951 27.9974 16.0842C28.1118 16.3775 28.2471 16.8193 28.284 17.6317C28.3244 18.5109 28.3325 18.774 28.3325 20.9994C28.3325 23.2248 28.3244 23.4879 28.284 24.3671C28.247 25.1795 28.111 25.6211 27.9974 25.9146C27.8459 26.3037 27.6655 26.5813 27.374 26.8725C27.0826 27.1637 26.8046 27.3443 26.4155 27.4958C26.1222 27.6102 25.6804 27.7455 24.868 27.7825C23.9896 27.8229 23.7257 27.8309 21.5003 27.8309C19.2749 27.8309 19.0118 27.8229 18.1336 27.7825ZM18.0646 12.7165C17.1775 12.7569 16.5713 12.8975 16.0419 13.1035C15.4937 13.3163 15.0295 13.6017 14.5657 14.0647C14.1019 14.5278 13.8173 14.9927 13.6045 15.5409C13.3985 16.0707 13.2579 16.6765 13.2175 17.5637C13.1764 18.4522 13.167 18.7363 13.167 20.9993C13.167 23.2624 13.1764 23.5465 13.2175 24.435C13.2579 25.3222 13.3985 25.928 13.6045 26.4577C13.8173 27.0057 14.102 27.4711 14.5657 27.9339C15.0295 28.3968 15.4937 28.6818 16.0419 28.8951C16.5723 29.1011 17.1775 29.2418 18.0646 29.2822C18.9536 29.3226 19.2372 29.3327 21.5003 29.3327C23.7634 29.3327 24.0474 29.3233 24.936 29.2822C25.8232 29.2418 26.429 29.1011 26.9587 28.8951C27.5066 28.6818 27.9711 28.397 28.4349 27.9339C28.8987 27.4709 29.1828 27.0057 29.3961 26.4577C29.6021 25.928 29.7434 25.3221 29.7832 24.435C29.8236 23.5458 29.833 23.2624 29.833 20.9993C29.833 18.7363 29.8236 18.4522 29.7832 17.5637C29.7428 16.6765 29.6021 16.0703 29.3961 15.5409C29.1828 14.993 28.898 14.5285 28.4349 14.0647C27.9718 13.6009 27.5066 13.3163 26.9594 13.1035C26.429 12.8975 25.8231 12.7562 24.9366 12.7165C24.0481 12.6761 23.764 12.666 21.501 12.666C19.2379 12.666 18.9536 12.6754 18.0646 12.7165Z",
                        fill: "var(--color-blue-600)"
                    })
                }),
                link: branch/* instagramLink */.WW
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M19.8848 19.1921V18.5465C19.6647 18.511 19.4424 18.4915 19.2197 18.4883C17.0628 18.4836 15.1533 19.9071 14.5055 22.0024C13.8578 24.0977 14.6224 26.3786 16.3928 27.6332C15.7436 26.9256 15.3093 26.0417 15.1425 25.0882C14.9756 24.1348 15.0833 23.1526 15.4525 22.2601C15.8217 21.3676 16.4367 20.603 17.2231 20.0586C18.0096 19.5143 18.934 19.2133 19.8846 19.1922L19.8848 19.1921Z",
                            fill: "var(--color-blue-600)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20.0044 26.5051C21.2103 26.5034 22.2016 25.5359 22.2544 24.3089V13.3593H24.2184C24.1784 13.1305 24.1592 12.8984 24.1613 12.666L21.4749 12.666V23.605C21.4302 24.8382 20.4366 25.8151 19.2249 25.8171C18.8628 25.814 18.5066 25.7233 18.1857 25.5525C18.3937 25.846 18.6669 26.0853 18.9829 26.2508C19.299 26.4164 19.649 26.5035 20.0044 26.5051ZM27.887 17.0744V16.4658C27.1641 16.4661 26.4573 16.2488 25.8553 15.8413C26.383 16.4662 27.0962 16.899 27.887 17.0744Z",
                            fill: "var(--color-blue-600)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M24.1611 23.5198V17.9577C25.2485 18.7522 26.5537 19.1975 27.892 19.1944V17.0581C27.1014 16.888 26.3865 16.4608 25.8551 15.8409C25.4307 15.5613 25.0666 15.1965 24.7852 14.7689C24.5038 14.3412 24.3109 13.8596 24.2182 13.3535H22.2542V24.3085C22.2351 24.7854 22.0686 25.2317 21.7816 25.6089C21.4946 25.9862 21.127 26.2596 20.6784 26.3975C20.2298 26.5354 19.7634 26.5386 19.3193 26.3861C18.8753 26.2336 18.4678 25.9445 18.1928 25.558C17.7477 25.3194 17.38 24.9269 17.1783 24.471C16.9717 24.0039 16.9154 23.4825 17.0349 22.9849C17.1543 22.4872 17.4337 22.0445 17.8286 21.7272C18.2235 21.4099 18.7113 21.2361 19.2143 21.2336C19.4399 21.2356 19.664 21.2713 19.8794 21.3395L19.8881 19.1886C18.9324 19.2051 17.9952 19.4849 17.2036 20.0307C16.412 20.5764 15.7914 21.3985 15.4212 22.2961C15.051 23.1937 14.9453 24.1817 15.1169 25.1394C15.2885 26.0972 15.73 26.9834 16.3875 27.6901C17.2228 28.2646 18.2119 28.5622 19.2195 28.5421C21.9446 28.5421 24.1554 26.2952 24.1611 23.5198Z",
                            fill: "var(--color-blue-600)"
                        })
                    ]
                }),
                link: branch/* tiktokLink */.Pn
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            clipPath: "url(#clip0_17543_35429)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M28.1705 15.0021C30.3363 18.1473 31.4059 21.6951 31.006 25.7793C31.0044 25.7966 30.9953 25.8124 30.9809 25.8229C29.3408 27.0124 27.7517 27.7343 26.185 28.213C26.1728 28.2167 26.1597 28.2165 26.1477 28.2125C26.1356 28.2084 26.1251 28.2008 26.1176 28.1905C25.7557 27.6931 25.4268 27.1686 25.1386 26.6179C25.1221 26.5855 25.1372 26.5464 25.1713 26.5336C25.6936 26.3393 26.1903 26.1063 26.668 25.8304C26.7056 25.8087 26.708 25.7554 26.6733 25.7298C26.5719 25.6555 26.4714 25.5773 26.3753 25.4992C26.3573 25.4848 26.3331 25.4819 26.3128 25.4916C23.2111 26.9063 19.8135 26.9063 16.6752 25.4916C16.6548 25.4826 16.6306 25.4857 16.6131 25.4999C16.5172 25.578 16.4165 25.6555 16.3161 25.7298C16.2814 25.7554 16.2842 25.8087 16.3221 25.8304C16.7998 26.1011 17.2965 26.3393 17.8181 26.5346C17.8519 26.5474 17.868 26.5855 17.8512 26.6179C17.5693 27.1694 17.2404 27.6938 16.8718 28.1912C16.8557 28.2114 16.8293 28.2206 16.8044 28.213C15.2451 27.7343 13.656 27.0124 12.0159 25.8229C12.0023 25.8124 11.9925 25.7959 11.991 25.7786C11.6569 22.2458 12.3379 18.6687 14.8239 15.0014C14.8299 14.9917 14.839 14.9841 14.8496 14.9796C16.0728 14.4251 17.3833 14.0172 18.753 13.7842C18.7779 13.7804 18.8029 13.7918 18.8158 13.8136C18.985 14.1095 19.1785 14.4891 19.3094 14.7992C20.7531 14.5814 22.2195 14.5814 23.6934 14.7992C23.8243 14.4957 24.0111 14.1095 24.1796 13.8136C24.1856 13.8028 24.1949 13.7941 24.2062 13.7888C24.2174 13.7836 24.2301 13.7819 24.2424 13.7842C25.6128 14.0179 26.9233 14.4258 28.1456 14.9796C28.1564 14.9841 28.1652 14.9917 28.1705 15.0021ZM20.0434 21.7192C20.0585 20.6748 19.2876 19.8106 18.3198 19.8106C17.36 19.8106 16.5966 20.6673 16.5966 21.7192C16.5966 22.7709 17.3752 23.6276 18.3198 23.6276C19.2799 23.6276 20.0434 22.7709 20.0434 21.7192ZM26.4153 21.7192C26.4304 20.6748 25.6595 19.8106 24.6921 19.8106C23.732 19.8106 22.9686 20.6673 22.9686 21.7192C22.9686 22.7709 23.7471 23.6276 24.6921 23.6276C25.6595 23.6276 26.4153 22.7709 26.4153 21.7192Z",
                                fill: "var(--color-blue-600)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                id: "clip0_17543_35429",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "42",
                                    height: "42",
                                    fill: "white",
                                    transform: "translate(11.5 11)"
                                })
                            })
                        })
                    ]
                }),
                link: branch/* discordLink */.T4
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21.9027 27.0868L18.1736 27.0206C16.9662 26.9975 15.7558 27.0436 14.5721 26.8046C12.7714 26.4475 12.6438 24.6967 12.5104 23.2281C12.3264 21.1635 12.3976 19.0614 12.7447 17.014C12.9407 15.8651 13.7118 15.1796 14.9044 15.105C18.9301 14.8343 22.9826 14.8664 26.9994 14.9927C27.4236 15.0043 27.8507 15.0676 28.269 15.1396C30.3339 15.4909 30.3842 17.475 30.5181 19.1452C30.6516 20.8326 30.5952 22.5287 30.3401 24.2046C30.1354 25.5922 29.7437 26.7559 28.091 26.8682C26.0202 27.0151 23.997 27.1334 21.9204 27.0957C21.9205 27.0868 21.9086 27.0868 21.9027 27.0868ZM19.7103 23.5737C21.2708 22.704 22.8016 21.8488 24.3531 20.985C22.7897 20.1153 21.2619 19.2601 19.7103 18.3962V23.5737Z",
                        fill: "var(--color-blue-600)"
                    })
                }),
                link: branch/* youtubeLink */.Ke
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.5001 12.3965C16.7488 12.3965 12.8965 16.2483 12.8965 20.9998C12.8965 24.5226 15.0149 27.5489 18.0463 28.8796C18.0221 28.2788 18.042 27.5577 18.1961 26.904C18.3614 26.2056 19.3031 22.2161 19.3031 22.2161C19.3031 22.2161 19.0282 21.6669 19.0282 20.8549C19.0282 19.58 19.7672 18.6278 20.6874 18.6278C21.47 18.6278 21.8481 19.2156 21.8481 19.9194C21.8481 20.7061 21.3463 21.8828 21.0883 22.9726C20.8727 23.8852 21.5459 24.6296 22.4462 24.6296C24.0763 24.6296 25.1742 22.536 25.1742 20.0555C25.1742 18.1699 23.9041 16.7586 21.5942 16.7586C18.9845 16.7586 17.3586 18.7048 17.3586 20.8787C17.3586 21.6282 17.5796 22.1568 17.9258 22.5661C18.0849 22.7541 18.1071 22.8297 18.0494 23.0456C18.0082 23.2039 17.9134 23.585 17.8742 23.736C17.8168 23.9539 17.6403 24.0318 17.4434 23.9513C16.2414 23.4606 15.6815 22.1443 15.6815 20.6645C15.6815 18.2207 17.7427 15.2902 21.8303 15.2902C25.1151 15.2902 27.277 17.6671 27.277 20.2185C27.277 23.5934 25.4007 26.1148 22.6349 26.1148C21.706 26.1148 20.8322 25.6127 20.533 25.0424C20.533 25.0424 20.0335 27.0246 19.9277 27.4074C19.7453 28.0707 19.3883 28.7336 19.0618 29.2504C19.8356 29.4788 20.6529 29.6032 21.5001 29.6032C26.2511 29.6032 30.1032 25.7513 30.1032 20.9998C30.1032 16.2483 26.2511 12.3965 21.5001 12.3965Z",
                        fill: "var(--color-blue-600)"
                    })
                }),
                link: branch/* pinterestLink */.RJ
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.9984 13.1426C15.1451 13.1426 13.6428 14.6449 13.6428 16.4981V26.0728C13.6428 27.926 15.1451 29.4283 16.9984 29.4283H20.2111V23.4516H18.7532V21.2011H20.1674C20.1674 20.9746 20.1681 20.7566 20.1687 20.5433C20.17 20.13 20.1713 19.7341 20.1674 19.3269C20.1674 17.5549 21.5271 17.0407 22.7495 17.0407H24.8095H24.8105V19.2638C24.6925 19.2645 24.3417 19.2642 24.0205 19.264C23.8705 19.2639 23.7269 19.2638 23.6165 19.2638C23.615 19.2638 23.6127 19.2637 23.6096 19.2636C23.5231 19.2619 22.8441 19.2479 22.8441 19.9239C22.8485 20.2099 22.8441 21.1948 22.8441 21.1948H24.8185L24.6585 23.4088H22.8902V29.4283H26.573C28.4262 29.4283 29.9285 27.926 29.9285 26.0728V16.4981C29.9285 14.6449 28.4262 13.1426 26.573 13.1426H16.9984Z",
                        fill: "var(--color-blue-600)"
                    })
                }),
                link: branch/* facebookLink */.yK
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "42",
                    height: "42",
                    viewBox: "0 0 42 42",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21.4331 28.6817C22.9463 28.6817 24.0786 27.5674 24.0786 27.5674C24.178 27.4842 24.2912 27.4046 24.2912 27.4046C25.1971 26.8096 26.6657 27.2385 26.6657 27.2385C27.1993 27.3649 27.2147 26.9618 27.2147 26.9618L27.2559 26.505C27.2949 26.0571 27.9832 26.0619 27.9832 26.0619C28.8897 26.0264 29.2713 25.6552 29.4285 25.3933C29.5973 25.1422 29.2784 25.0712 29.2784 25.0712C27.091 24.4605 26.0297 22.3843 26.0297 22.3843C25.5355 21.5169 26.2127 21.1661 26.2127 21.1661C26.3958 21.0369 27.2924 20.7416 27.2924 20.7416C28.0323 20.4449 27.7865 19.9296 27.7865 19.9296C27.512 19.3757 26.8715 19.745 26.8715 19.745C26.5687 19.9057 26.3408 19.8925 26.3408 19.8925C25.835 19.9022 25.7742 19.7938 25.7742 19.7938L25.7915 17.3917C25.7915 15.1949 23.8539 13.4141 21.4638 13.4141H21.4223C19.0321 13.4141 17.0946 15.1949 17.0946 17.3917L17.112 19.7938C17.112 19.7938 17.0512 19.9022 16.5453 19.8925C16.5453 19.8925 16.3174 19.9057 16.0146 19.745C16.0146 19.745 15.3742 19.3758 15.0997 19.9296C15.0997 19.9296 14.8536 20.4449 15.5938 20.7416C15.5938 20.7416 16.4905 21.0369 16.6734 21.1661C16.6734 21.1661 17.3506 21.5168 16.8565 22.3843C16.8565 22.3843 15.7954 24.4605 13.6078 25.0712C13.6078 25.0712 13.2889 25.1421 13.4578 25.3933C13.615 25.6552 13.9968 26.0264 14.9029 26.0619C14.9029 26.0619 15.5914 26.0571 15.6304 26.505L15.6716 26.9618C15.6716 26.9618 15.687 27.3649 16.2206 27.2385C16.2206 27.2385 17.6891 26.8096 18.595 27.4046C18.595 27.4046 18.7082 27.4842 18.8078 27.5674C18.8078 27.5674 19.9401 28.6817 21.4533 28.6817H21.4331Z",
                        fill: "var(--color-blue-600)"
                    })
                }),
                link: branch/* snapchatLink */.Co
            }, 
        ].map(function(param) {
            var icon = param.icon, link = param.link;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialImage, {
                href: link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: icon
            }, link);
        })
    });
};
/* harmony default export */ var socials = (socials_Socials);

;// CONCATENATED MODULE: ./comps/footer/copyright.tsx

function copyright_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0px 20px 0px;\n\n  width: 100%;\n\n  @media ",
        " {\n    width: 728px;\n    flex-direction: row;\n  }\n\n  @media ",
        " {\n    width: 1175px;\n  }\n"
    ]);
    copyright_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function copyright_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--color-blue-800);\n\n  @media ",
        " {\n    font-size: 14px;\n  }\n\n  @media ",
        " {\n    font-size: 16px;\n    width: unset;\n  }\n"
    ]);
    copyright_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var CopyrightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cfdbec9-0"
})(copyright_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var CopyrightText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1cfdbec9-1"
})(copyright_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var CopyrightOld = function() {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsxs(CopyrightContainer, {
        children: [
            /*#__PURE__*/ _jsx(CopyrightText, {
                children: t("fs_copyright", {
                    year: new Date().getFullYear()
                })
            }),
            /*#__PURE__*/ _jsx(Tablet, {
                children: /*#__PURE__*/ _jsx(Socials, {})
            }),
            /*#__PURE__*/ _jsx(CopyrightText, {
                children: t("txt_rights_reserved")
            }),
            /*#__PURE__*/ _jsx(Mobile, {
                children: /*#__PURE__*/ _jsx(Socials, {})
            })
        ]
    });
};
var copyright_Copyright = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightText, {
                children: t("fs_copyright_rights", {
                    year: new Date().getFullYear()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* DesktopOrTablet */.lS, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(socials, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(socials, {})
            })
        ]
    });
};
/* harmony default export */ var copyright = (copyright_Copyright);

;// CONCATENATED MODULE: ./comps/footer/line.tsx

function line_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 1px;\n	align-self: stretch;\n\n	background-color: var(--color-blue-300);\n"
    ]);
    line_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var line_Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7032da2e-0"
})(line_templateObject());
/* harmony default export */ var line = (line_Line);

// EXTERNAL MODULE: ./comps/text/index.tsx
var comps_text = __webpack_require__(64);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./comps/footer/links.tsx

function links_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	flex: 2;\n\n	margin-bottom: 20px;\n\n	flex-wrap: wrap;\n	row-gap: 10px;\n\n	@media ",
        " {\n		flex-wrap: nowrap;\n		justify-content: space-between;\n		margin-bottom: 24px;\n		width: 90%;\n	}\n\n	@media ",
        " {\n		margin-bottom: 33px;\n		width: 1170px;\n	}\n"
    ]);
    links_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function links_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	flex-shrink: 0;\n	width: 171px;\n\n	@media screen and (min-width: 1225px) {\n		flex: 1;\n		padding: 0;\n	}\n"
    ]);
    links_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 14px;\n	font-weight: 400;\n	color: var(--color-blue-800);\n	text-transform: capitalize;\n	text-align: left;\n	flex: 1;\n\n	cursor: pointer;\n\n	transition: color 200ms ease-in-out;\n\n	:hover {\n		color: var(--color-blue-600);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var LinkColumns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b34e6c84-0"
})(links_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var aiItems = [
    {
        label: "txt_text_to_reel",
        url: "/chat"
    },
    {
        label: "txt_ai_photoshoot",
        url: "/tools/ai-photoshoot-generator"
    },
    {
        label: "txt_deforum_ai",
        url: "/tools/ai-video-transformation"
    },
    {
        label: "txt_restyle_ai",
        url: "/tools/ai-animation-generator"
    },
    {
        label: "txt_photo_ai",
        url: "/tools/ai-photo-editor"
    },
    {
        label: "txt_text_to_image",
        url: "/tools/text-to-image"
    },
    {
        label: "txt_text_to_video",
        url: "/tools/text-to-video"
    },
    {
        label: "txt_look_ai",
        url: "/tools/ai-portrait-generator"
    },
    {
        label: "txt_generative_fill",
        url: "/tools/ai-image-replacer"
    },
    {
        label: "txt_ai_music_generator",
        url: "/tools/royalty-free-music"
    },
    {
        label: "txt_video_bg_remover",
        url: "/tools/video-background-remover"
    },
    {
        label: "lbl_ai_gallery",
        url: "/ai-gallery"
    }, 
];
var productItems = [
    {
        label: "Zoomerang App",
        raw: true,
        url: branch/* appStoreConstant */.HY
    },
    {
        label: "lbl_pricing",
        url: "/pricing"
    },
    {
        label: "lbl_templates",
        url: "/video-templates"
    },
    {
        label: "lbl_creators",
        url: "/creators"
    }, 
];
var companyItems = [
    {
        label: "lbl_contact_us",
        url: "/contact"
    },
    {
        label: "lbl_careers",
        url: "/careers"
    },
    {
        label: "lbl_reviews",
        url: "/#reviews"
    }, 
];
var otherItems = [
    {
        label: "lbl_blog",
        url: "/blog"
    },
    {
        label: "txt_help_center",
        url: "https://help.zoomerang.app/en/",
        newTab: true
    },
    {
        label: "txt_terms_and_privacy",
        url: "/privacy-policy"
    }, 
];
var links_Links = function() {
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), section = ref[0], setSection = ref[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var setOpen = function(item) {
        if (section === item) {
            setSection(null);
        } else {
            setSection(item);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkColumns, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: aiItems.slice(0, 6),
                            children: "lbl_ai_studio"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: aiItems.slice(6)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: productItems,
                            children: "lbl_product"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: companyItems,
                            children: "lbl_company"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: otherItems,
                            children: "lbl_other"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Tablet */.YD, {
                className: "flex w-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkColumns, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: aiItems,
                            children: "lbl_ai_studio"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                            column: true,
                            gap: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                    items: companyItems,
                                    children: "lbl_company"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                                    items: otherItems,
                                    children: "lbl_other"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSection, {
                            items: productItems,
                            children: "lbl_product"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(breakpoints/* Mobile */.ij, {
                className: "mb-2 mt-[10px] w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function() {
                                    return setOpen("ai_studio");
                                },
                                className: "flex w-full flex-row items-center justify-between py-[14px] text-[16px] font-500 text-blue-600",
                                children: [
                                    t("lbl_ai_studio"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(section === "ai_studio" && "rotate-90", "before-line absolute bg-blue-600 transition-transform duration-[250ms] ease-out")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)("bg-blue-600", "after-line absolute transition-transform duration-[250ms] ease-out")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === "ai_studio" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-col gap-5 pb-5",
                                children: aiItems.map(function(item, key) {
                                    if (item.url !== undefined) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                                onClick: function() {
                                                    return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                        page: router.route.slice(1) || "home",
                                                        link: item.url,
                                                        uid: userInfo.userId
                                                    });
                                                },
                                                target: item.newTab ? "_blank" : undefined,
                                                rel: "noopener noreferrer",
                                                children: item.raw ? item.label : t(item.label)
                                            })
                                        }, key);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                        onClick: function() {
                                            item.action && item.action();
                                            (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                page: router.route.slice(1) || "home",
                                                link: item.url,
                                                uid: userInfo.userId
                                            });
                                        },
                                        children: item.raw ? item.label : t(item.label)
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-px w-full shrink-0 bg-blue-300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function() {
                                    return setOpen("product");
                                },
                                className: "flex w-full flex-row items-center justify-between py-[14px] text-[16px] font-500 text-blue-600",
                                children: [
                                    t("lbl_product"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(section === "product" && "rotate-90", "before-line absolute bg-blue-600 transition-transform duration-[250ms] ease-out")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)("bg-blue-600", "after-line absolute transition-transform duration-[250ms] ease-out")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === "product" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-col gap-5 pb-5",
                                children: productItems.map(function(item, key) {
                                    if (item.url !== undefined) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                                onClick: function() {
                                                    return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                        page: router.route.slice(1) || "home",
                                                        link: item.url,
                                                        uid: userInfo.userId
                                                    });
                                                },
                                                target: item.newTab ? "_blank" : undefined,
                                                rel: "noopener noreferrer",
                                                children: item.raw ? item.label : t(item.label)
                                            })
                                        }, key);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                        onClick: function() {
                                            item.action && item.action();
                                            (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                page: router.route.slice(1) || "home",
                                                link: item.url,
                                                uid: userInfo.userId
                                            });
                                        },
                                        children: item.raw ? item.label : t(item.label)
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-px w-full shrink-0 bg-blue-300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function() {
                                    return setOpen("company");
                                },
                                className: "flex w-full flex-row items-center justify-between py-[14px] text-[16px] font-500 text-blue-600",
                                children: [
                                    t("lbl_company"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(section === "company" && "rotate-90", "before-line absolute bg-blue-600 transition-transform duration-[250ms] ease-out")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)("bg-blue-600", "after-line absolute transition-transform duration-[250ms] ease-out")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === "company" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-col gap-5 pb-5",
                                children: companyItems.map(function(item, key) {
                                    if (item.url !== undefined) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                                onClick: function() {
                                                    return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                        page: router.route.slice(1) || "home",
                                                        link: item.url,
                                                        uid: userInfo.userId
                                                    });
                                                },
                                                target: item.newTab ? "_blank" : undefined,
                                                rel: "noopener noreferrer",
                                                children: item.raw ? item.label : t(item.label)
                                            })
                                        }, key);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                        onClick: function() {
                                            item.action && item.action();
                                            (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                page: router.route.slice(1) || "home",
                                                link: item.url,
                                                uid: userInfo.userId
                                            });
                                        },
                                        children: item.raw ? item.label : t(item.label)
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-px w-full shrink-0 bg-blue-300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function() {
                                    return setOpen("other");
                                },
                                className: "flex w-full flex-row items-center justify-between py-[14px] text-[16px] font-500 text-blue-600",
                                children: [
                                    t("lbl_other"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(section === "other" && "rotate-90", "before-line absolute bg-blue-600 transition-transform duration-[250ms] ease-out")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)("bg-blue-600", "after-line absolute transition-transform duration-[250ms] ease-out")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === "other" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-col gap-5 pb-5",
                                children: otherItems.map(function(item, key) {
                                    if (item.url !== undefined) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: item.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                                onClick: function() {
                                                    return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                        page: router.route.slice(1) || "home",
                                                        link: item.url,
                                                        uid: userInfo.userId
                                                    });
                                                },
                                                target: item.newTab ? "_blank" : undefined,
                                                rel: "noopener noreferrer",
                                                children: item.raw ? item.label : t(item.label)
                                            })
                                        }, key);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex-1 shrink-0 text-[16px] font-400 text-blue-800",
                                        onClick: function() {
                                            item.action && item.action();
                                            (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                                page: router.route.slice(1) || "home",
                                                link: item.url,
                                                uid: userInfo.userId
                                            });
                                        },
                                        children: item.raw ? item.label : t(item.label)
                                    }, key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b34e6c84-1"
})(links_templateObject1());
var sectionText = (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
var SectionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b34e6c84-2"
})(_templateObject3(), sectionText);
var SectionAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b34e6c84-3"
})(_templateObject4(), sectionText);
var FooterSection = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
        children: [
            props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                padding: "33px 0px 20px 0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* default */.Z, {
                    content: props.children,
                    size: "16",
                    weight: "500",
                    color: "600",
                    capitalization: "uppercase",
                    letterSpacing: "1.28"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                className: (0,clsx_m/* default */.Z)(!props.children && "pt-[77px]"),
                column: true,
                gap: 12,
                children: props.items.map(function(item, key) {
                    if (item.url !== undefined) return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionAnchor, {
                            onClick: function() {
                                return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                    page: router.route.slice(1) || "home",
                                    link: item.url,
                                    uid: userInfo.userId
                                });
                            },
                            target: item.newTab ? "_blank" : undefined,
                            rel: "noopener noreferrer",
                            children: item.raw ? item.label : t(item.label)
                        })
                    }, key);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionButton, {
                        onClick: function() {
                            item.action && item.action();
                            (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_footer", {
                                page: router.route.slice(1) || "home",
                                link: item.url,
                                uid: userInfo.userId
                            });
                        },
                        children: item.raw ? item.label : t(item.label)
                    }, key);
                })
            })
        ]
    });
};
/* harmony default export */ var links = (links_Links);

;// CONCATENATED MODULE: ./comps/footer/index.tsx

function footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 77;\n  margin-top: 32px;\n  position: relative;\n\n  @media ",
        " {\n    margin-top: 60px;\n  }\n\n  @media ",
        " {\n    margin-top: 100px;\n  }\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n\n  width: var(--w-screen);\n  background-color: var(--color-blue-200);\n"
    ]);
    footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  margin: 0 16px;\n\n  @media ",
        " {\n    width: 728px;\n    align-self: unset;\n  }\n\n  @media ",
        " {\n    width: 1170px;\n  }\n"
    ]);
    footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function footer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n"
    ]);
    footer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69c47df8-0"
})(footer_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var TopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69c47df8-1"
})(footer_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var FooterOld = function(props) {
    return /*#__PURE__*/ _jsx(FooterContainer, {
        className: props.className,
        children: /*#__PURE__*/ _jsxs(TopContainer, {
            children: [
                /*#__PURE__*/ _jsx(Links, {}),
                /*#__PURE__*/ _jsx(Line, {}),
                /*#__PURE__*/ _jsx(Copyright, {})
            ]
        })
    });
};
var Footer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(links, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* DesktopOrTablet */.lS, {
                        className: "tablet:w-[728px] desktop:w-[1170px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copyright, {})
            })
        ]
    });
};
var WrappedFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(FooterContainer).withConfig({
    componentId: "sc-69c47df8-2"
})(footer_templateObject2());
var WrappedFooter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrappedFooterContainer, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(links, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* DesktopOrTablet */.lS, {
                        className: "tablet:w-[728px] desktop:w-[1170px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copyright, {})
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);


/***/ }),

/***/ 5007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ AvatarWithMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1816);
/* harmony import */ var _utils_coins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(279);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7592);
/* harmony import */ var _utils_scrollto__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1634);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8767);
/* harmony import */ var _dropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3153);
/* harmony import */ var _subscription_popup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9460);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4773);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1817);


















var PROFILE_SHORT_CACHE_HOURS = 5;
function AvatarWithMenu(props) {
    var showSection = function showSection() {
        if (userInfo === null || userInfo.isAnonymous) {
            return "sign_in";
        }
        return "user";
    };
    var ref, ref1;
    var onFocus = props.onFocus, setSubscriptionPopupOpen = props.setSubscriptionPopupOpen, changeSelectedPage = props.changeSelectedPage;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* .useClientAuth */ .K6)().userInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_1__/* .useAdjustLogger */ .eW)();
    var ref2;
    var userId = (ref2 = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) !== null && ref2 !== void 0 ? ref2 : null;
    function getModelStatus() {
        return _getModelStatus.apply(this, arguments);
    }
    function _getModelStatus() {
        _getModelStatus = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userId) {
                            return [
                                2,
                                undefined
                            ];
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/training-short-status?id=".concat(userId)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _getModelStatus.apply(this, arguments);
    }
    var queryModel = (0,react_query__WEBPACK_IMPORTED_MODULE_7__.useQuery)({
        queryKey: [
            "model-status"
        ],
        queryFn: getModelStatus,
        cacheTime: PROFILE_SHORT_CACHE_HOURS * 60 * 60 * 1000,
        staleTime: PROFILE_SHORT_CACHE_HOURS * 60 * 60 * 1000,
        enabled: userInfo !== null && !userInfo.isAnonymous
    });
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var logOut = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* .useAuthUpdater */ .Sf)().logOut;
    var show = showSection();
    var wallet = (0,_utils_coins__WEBPACK_IMPORTED_MODULE_3__/* .useCoins */ .YO)();
    var openPopup = (0,_utils_coins__WEBPACK_IMPORTED_MODULE_3__/* .useCoinsPopup */ .$c)();
    var currentPlan = userInfo ? (0,_subscription_popup__WEBPACK_IMPORTED_MODULE_9__/* .getCurrentPlan */ .MX)(userInfo.entitlements) : "FREE";
    var _profilePic, _profilePic1, ref3, ref4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            show === "user" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_8__/* .DropDown */ .vb, {
                hover: true,
                onFocus: onFocus,
                contentClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("top-0 left-0 w-screen", "translate-y-[48px]", "tablet:translate-y-full", "tablet:-translate-x-[calc(100%-40px)]", "tablet:bottom-4 tablet:w-auto", "tablet:drop-shadow-[0px_0px_30px_rgba(0,0,0,0.13)]", "fixed tablet:absolute shrink-0"),
                className: "flex items-center",
                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex shrink-0 items-center tablet:h-[90px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (_profilePic = userInfo === null || userInfo === void 0 ? void 0 : userInfo.details.profilePic) !== null && _profilePic !== void 0 ? _profilePic : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/avatar.svg"),
                        alt: "avatar",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-8 w-8 rounded-full border border-color-separator", "pointer-events-none animate-appear")
                    })
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("bg-color-popup-cell tablet:w-[312px] tablet:rounded-[10px]", "w-full border-b-color-separator", "border-b-2 tablet:border-none", "flex flex-col", "gap-1 px-[10px] pb-[10px] text-[14px] font-500"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "/".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.details.username),
                            className: "flex flex-col items-center gap-3 px-3 py-3 tablet:flex-row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (_profilePic1 = userInfo === null || userInfo === void 0 ? void 0 : userInfo.details.profilePic) !== null && _profilePic1 !== void 0 ? _profilePic1 : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/avatar.svg"),
                                    alt: "avatar",
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-16 w-16 rounded-full border border-color-separator tablet:h-8 tablet:w-8", "pointer-events-none animate-appear")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-center tablet:items-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "font-600",
                                            children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.details.fullName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "truncate text-blue-600",
                                            children: [
                                                "@",
                                                userInfo === null || userInfo === void 0 ? void 0 : userInfo.details.username
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        userInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-px w-full bg-color-separator"
                        }),
                        wallet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: function() {
                                return setSubscriptionPopupOpen(true);
                            },
                            className: "flex h-[43px] w-full flex-row items-center justify-between rounded-[6px] px-2 transition-colors hover:bg-blue-100",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: " text-[14px] font-500 text-blue-600",
                                            children: t("lbl_tokens_remaining")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tooltip__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                            showAlways: true,
                                            className: " whitespace-pre-line",
                                            title: wallet.renewInfo ? t("fs_tokens_renew", {
                                                tokens: wallet.permanentTokens + wallet.temporaryTokens,
                                                renew: wallet.renewInfo.tokens
                                            }) : wallet.permanentTokens + wallet.temporaryTokens > 0 ? t("fs_tokens_available", {
                                                tokens: wallet.permanentTokens + wallet.temporaryTokens
                                            }) : t("txt_dont_have_tokens"),
                                            margin: 5,
                                            width: 200,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-1 flex h-[14px] w-[14px] items-center justify-center rounded-full border border-blue-500 text-[10px] font-700 text-blue-500",
                                                children: "!"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-[6px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/token.svg"),
                                            alt: "coin-icon-new"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("text-[18px] font-600 uppercase", "text-blue-700"),
                                            children: (wallet.temporaryTokens + wallet.permanentTokens).toLocaleString()
                                        })
                                    ]
                                })
                            ]
                        }),
                        userInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: function() {
                                return setSubscriptionPopupOpen(true);
                            },
                            className: "flex h-[43px] w-full flex-row items-center justify-between rounded-[6px] px-2 transition-colors hover:bg-blue-100",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: " text-[14px] font-500 text-blue-600",
                                    children: t("lbl_subscription")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("text-[16px] font-600 uppercase", currentPlan === "FREE" ? "text-color-success" : "text-blue-700"),
                                    children: currentPlan
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-px w-full bg-color-separator"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-[43px] w-full flex-row items-center justify-between px-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: " text-[14px] font-500 text-blue-600",
                                    children: t("txt_coins")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-[6px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/coin-new.svg"),
                                            alt: "coin-icon-new"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-[16px] font-600 text-blue-700",
                                            children: (ref3 = wallet === null || wallet === void 0 ? void 0 : wallet.coins.toLocaleString()) !== null && ref3 !== void 0 ? ref3 : 0
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            onClick: function() {
                                                return openPopup();
                                            },
                                            className: "relative h-[24px] w-[24px] rounded-[6px] bg-blue-100 transition-colors hover:bg-blue-200",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " absolute left-1/2 top-1/2 h-[1.5px] w-[7.5px] -translate-x-1/2 -translate-y-1/2 bg-blue-500"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " absolute left-1/2 top-1/2 h-[1.5px] w-[7.5px] -translate-x-1/2 -translate-y-1/2 rotate-90 bg-blue-500"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/home",
                            onClick: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(e) {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!changeSelectedPage) return [
                                                    3,
                                                    2
                                                ];
                                                e.preventDefault();
                                                return [
                                                    4,
                                                    changeSelectedPage("home")
                                                ];
                                            case 1:
                                                _state.sent();
                                                (0,_utils_scrollto__WEBPACK_IMPORTED_MODULE_17__/* .scrollToSection */ .Q)("history", 70)();
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            className: "flex h-[43px] w-full flex-row items-center justify-between rounded-[6px] px-2 transition-colors hover:bg-blue-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-[14px] font-500 text-blue-600",
                                children: t("lbl_history")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "/models",
                            className: "flex h-[43px] w-full flex-row items-center justify-between rounded-[6px] px-2 transition-colors hover:bg-blue-100",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-[14px] font-500 text-blue-600",
                                            children: t("lbl_my_models")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-[14px] font-500 text-blue-600",
                                            children: [
                                                "(",
                                                (ref4 = (ref = queryModel.data) === null || ref === void 0 ? void 0 : ref.model_count) !== null && ref4 !== void 0 ? ref4 : "-",
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                ((ref1 = queryModel.data) === null || ref1 === void 0 ? void 0 : ref1.is_training) === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "rounded-[12px] bg-[#2F91FD] px-[11px] text-[11px] font-600 text-color-white",
                                    children: t("txt_training")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-[43px] w-full flex-row items-center justify-between px-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[14px] font-500 text-blue-600",
                                    children: t("lbl_theme")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .ThemeSwitch */ .R5, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-px w-full bg-color-separator"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("w_did_log_out");
                                            return [
                                                4,
                                                logOut()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            className: "flex h-[43px] w-full flex-row items-center justify-between rounded-[6px] px-2 transition-colors hover:bg-blue-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-[14px] font-500 text-blue-600",
                                children: t("lbl_log_out")
                            })
                        })
                    ]
                })
            }),
            show === "sign_in" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row items-center gap-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        id: "signin-button",
                        onClick: function(e) {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_do_sign_in", {
                                from: router.asPath,
                                type: "header"
                            });
                            if (!router.asPath.startsWith("/pricing")) {
                                e.preventDefault();
                                (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_4__/* .redirectToLogin */ .r)();
                            }
                        },
                        href: "/login",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("bg-primary-800 px-4 py-[6px] text-[16px] font-600 text-primary-50 hover:bg-primary-700 desktop:bg-blue-100", "rounded-[6px] desktop:text-blue-800 desktop:hover:bg-blue-200", "animate-appear transition-colors"),
                        children: t("lbl_signin")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        id: "signup-button",
                        onClick: function(e) {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_do_sign_in", {
                                from: router.asPath,
                                type: "header"
                            });
                            if (!router.asPath.startsWith("/pricing")) {
                                e.preventDefault();
                                (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_4__/* .redirectToLogin */ .r)("signup");
                            }
                        },
                        href: "/login?type=signup",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("hidden bg-primary-800 px-6 py-[6px] text-[16px] font-600 desktop:block", "rounded-[6px] text-primary-50 hover:bg-primary-700", "animate-appear transition-colors"),
                        children: t("lbl_signup")
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ aiPhotoshootIcon; },
/* harmony export */   "CI": function() { return /* binding */ HamburgerAnimated; },
/* harmony export */   "Cz": function() { return /* binding */ textToVideoIcon; },
/* harmony export */   "R5": function() { return /* binding */ ThemeSwitch; },
/* harmony export */   "Ss": function() { return /* binding */ textToReelIcon; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "Tl": function() { return /* binding */ ThemeToggle; },
/* harmony export */   "Uq": function() { return /* binding */ galleryIcon; },
/* harmony export */   "YH": function() { return /* binding */ lookAiIcon; },
/* harmony export */   "ZX": function() { return /* binding */ restlyeIcon; },
/* harmony export */   "bJ": function() { return /* binding */ adExamplesIconMobile; },
/* harmony export */   "bv": function() { return /* binding */ videoBGRemoverIcon; },
/* harmony export */   "e0": function() { return /* binding */ ArrowIcon; },
/* harmony export */   "f7": function() { return /* binding */ textToImageIcon; },
/* harmony export */   "hM": function() { return /* binding */ generativeFillIcon; },
/* harmony export */   "rL": function() { return /* binding */ musicGeneratorIcon; },
/* harmony export */   "uv": function() { return /* binding */ deforumIcon; },
/* harmony export */   "wg": function() { return /* binding */ LogoSmallScaled; },
/* harmony export */   "wv": function() { return /* binding */ templatesIcon; },
/* harmony export */   "x$": function() { return /* binding */ photoAiIcon; }
/* harmony export */ });
/* unused harmony exports LogoZ, LogoSmall */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_animate_appear_in_place__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9505);
/* harmony import */ var _comps_animate_switch_on_change__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3850);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9612);
/* harmony import */ var _comps_toggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7092);
/* harmony import */ var _comps_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4773);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1156);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2213);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7294);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4382);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9521);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(177);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_12__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			display: none;\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-shrink: 0;\n\n	padding: 8px;\n	border-radius: 10px;\n\n	transition: background-color 200ms;\n	transition-timing-function: ease-in-out;\n	cursor: pointer;\n	user-select: none;\n\n	margin: 25px 0;\n	pointer-events: unset;\n\n	:hover {\n		background-color: var(--color-blue-100);\n	}\n\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			display: none;\n		"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n		display: flex;\n		flex-shrink: 0;\n\n		position: relative;\n	"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	",
        ";\n\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	left: 5px;\n\n	height: 2px;\n	width: 20px;\n\n	border-radius: 4px;\n\n	background: var(--color-blue-900);\n	transform: rotate(0deg);\n\n	transition: opacity 300ms, transform 300ms;\n	transition-timing-function: ease-in-out;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	top: 7px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	top: 15px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	top: 15px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	top: 23px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				opacity: 0;\n			"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				opacity: 0;\n			"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				transform: rotate(-45deg);\n			"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				transform: rotate(45deg);\n			"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 32px;\n	height: 32px;\n	position: relative;\n\n	",
        " {\n		",
        "\n	}\n\n	",
        " {\n		",
        "\n	}\n\n	",
        " {\n		",
        "\n	}\n\n	",
        " {\n		",
        "\n	}\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}














var ThemeContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4e9814d-0"
})(_templateObject1(), function(props) {
    return props.forced && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject());
});
var ThemeToggle = function() {
    var ref = (0,next_themes__WEBPACK_IMPORTED_MODULE_9__/* .useTheme */ .F)(), resolvedTheme = ref.resolvedTheme, forcedTheme = ref.forcedTheme, setTheme = ref.setTheme;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(true), solid = ref1[0], setSolid = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), isDark = ref2[0], setIsDark = ref2[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)().t;
    var toggleAction = function() {
        var name = resolvedTheme === "dark" ? "light" : "dark";
        setTheme(name);
        if (solid) setSolid(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        if (!resolvedTheme) {
            return;
        }
        setIsDark(resolvedTheme === "dark");
    }, [
        resolvedTheme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .DesktopOrTablet */ .lS, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    title: t("common:txt_change_theme"),
                    disabled: true,
                    margin: -20,
                    width: 100,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ThemeContainer, {
                        onClick: toggleAction,
                        forced: forcedTheme !== undefined,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_11__/* .FlexBox */ .hs, {
                            column: true,
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_11__/* .FlexBox */ .hs, {
                                center: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_animate_appear_in_place__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_comps_animate_switch_on_change__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        index: isDark ? 1 : 0,
                                        short: true,
                                        solid: solid,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_14__/* .assetUrl */ .p)("/comps/toggle-light.webp"),
                                                alt: "Theme toggle icon light",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_14__/* .assetUrl */ .p)("/comps/toggle-dark.svg"),
                                                className: "h-6 w-6",
                                                alt: "toggle icon"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .Mobile */ .ij, {
                children: forcedTheme === undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_toggle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Co, {
                    onChange: toggleAction,
                    theme: isDark
                })
            })
        ]
    });
};
var ThemeSwitch = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,next_themes__WEBPACK_IMPORTED_MODULE_9__/* .useTheme */ .F)(), theme = ref1.theme, setTheme = ref1.setTheme;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "relative flex h-[30px] w-[136px] flex-row items-center rounded-[6px] bg-blue-100 p-[2px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    left: theme === "system" ? "2px" : theme === "dark" ? "46px" : "90px"
                },
                className: "absolute top-[2px] z-[1] h-[26px] w-11 rounded-[5px] bg-color-popup-cell transition-all duration-200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                title: t("txt_system"),
                showAlways: true,
                className: "cursor-pointer",
                margin: 5,
                width: 60,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: function(e) {
                        e.preventDefault();
                        setTheme("system");
                    },
                    className: "z-[2] flex h-full w-11 items-center justify-center [--icon-color:var(--color-blue-700)]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SystemIcon, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                title: t("txt_dark"),
                showAlways: true,
                className: "cursor-pointer",
                margin: 5,
                width: 60,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: function(e) {
                        e.preventDefault();
                        setTheme("dark");
                    },
                    className: "z-[2] flex h-full w-11 items-center justify-center [--icon-color:var(--color-blue-700)]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DarkIcon, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                title: t("txt_light"),
                showAlways: true,
                className: "cursor-pointer",
                margin: 5,
                width: 60,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: function(e) {
                        e.preventDefault();
                        setTheme("light");
                    },
                    className: "z-[2] flex h-full w-11 items-center justify-center [--icon-color:var(--color-blue-700)]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LightIcon, {})
                })
            })
        ]
    });
};
var BigLogo = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4e9814d-1"
})(_templateObject4(), function(props) {
    return !props.showOnMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject2());
}, (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .onTablet */ .pX)((0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject3())));
var galleryIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4579 4.8613C11.6365 5.03985 11.6988 5.30396 11.619 5.54352L10.2056 9.78352C10.1393 9.98259 9.98308 10.1388 9.78401 10.2052L5.54401 11.6185C5.30445 11.6983 5.04034 11.636 4.86178 11.4574C4.68323 11.2789 4.62088 11.0148 4.70073 10.7752L6.11407 6.53522C6.18042 6.33615 6.33663 6.17993 6.5357 6.11358L10.7757 4.70024C11.0153 4.62039 11.2794 4.68274 11.4579 4.8613ZM7.27357 7.27308L6.38728 9.93194L9.04614 9.04565L9.93243 6.38679L7.27357 7.27308Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.96683 0.666016H8.03285C9.25104 0.66601 10.2106 0.666006 10.9799 0.735725C11.7652 0.806903 12.4174 0.954936 12.9998 1.29123C13.7093 1.70082 14.2984 2.28993 14.708 2.99935C15.0443 3.58183 15.1923 4.23396 15.2635 5.0193C15.3332 5.78855 15.3332 6.74816 15.3332 7.96636V8.03234C15.3332 9.25054 15.3332 10.2102 15.2635 10.9794C15.1923 11.7647 15.0443 12.4169 14.708 12.9993C14.2984 13.7088 13.7093 14.2979 12.9998 14.7075C12.4174 15.0438 11.7652 15.1918 10.9799 15.263C10.2106 15.3327 9.25103 15.3327 8.03283 15.3327H7.96685C6.74864 15.3327 5.78903 15.3327 5.01979 15.263C4.23445 15.1918 3.58232 15.0438 2.99984 14.7075C2.29041 14.2979 1.7013 13.7088 1.29172 12.9993C0.955424 12.4169 0.807391 11.7647 0.736213 10.9794C0.666494 10.2102 0.666498 9.25055 0.666504 8.03236V7.96634C0.666498 6.74815 0.666494 5.78854 0.736213 5.0193C0.807391 4.23396 0.955424 3.58183 1.29172 2.99935C1.7013 2.28993 2.29041 1.70082 2.99984 1.29123C3.58232 0.954936 4.23445 0.806903 5.01979 0.735725C5.78903 0.666006 6.74863 0.66601 7.96683 0.666016ZM5.14014 2.06362C4.44728 2.12641 4.01223 2.24633 3.6665 2.44593C3.15977 2.73849 2.73898 3.15929 2.44642 3.66602C2.24682 4.01174 2.1269 4.44679 2.0641 5.13965C2.00048 5.84168 1.99984 6.74093 1.99984 7.99935C1.99984 9.25777 2.00048 10.157 2.0641 10.859C2.1269 11.5519 2.24682 11.987 2.44642 12.3327C2.73898 12.8394 3.15977 13.2602 3.6665 13.5528C4.01223 13.7524 4.44728 13.8723 5.14014 13.9351C5.84217 13.9987 6.74141 13.9993 7.99984 13.9993C9.25826 13.9993 10.1575 13.9987 10.8595 13.9351C11.5524 13.8723 11.9874 13.7524 12.3332 13.5528C12.8399 13.2602 13.2607 12.8394 13.5533 12.3327C13.7529 11.987 13.8728 11.5519 13.9356 10.859C13.9992 10.157 13.9998 9.25777 13.9998 7.99935C13.9998 6.74093 13.9992 5.84168 13.9356 5.13965C13.8728 4.44679 13.7529 4.01174 13.5533 3.66602C13.2607 3.15929 12.8399 2.73849 12.3332 2.44593C11.9874 2.24633 11.5524 2.12641 10.8595 2.06362C10.1575 1.99999 9.25826 1.99935 7.99984 1.99935C6.74141 1.99935 5.84217 1.99999 5.14014 2.06362Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var templatesIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.82289 5.14187C1.64788 5.05549 1.46736 4.97843 1.28196 4.91132C1.23117 4.89294 1.18002 4.87531 1.12851 4.85843C0.982554 4.81061 0.982554 4.49074 1.12851 4.44292C1.18002 4.42605 1.23117 4.40841 1.28196 4.39003C1.46736 4.32293 1.64788 4.24587 1.82289 4.15948C1.86363 4.13937 1.90407 4.11876 1.94421 4.09764C2.89409 3.59799 3.67221 2.81988 4.17186 1.86999C4.19297 1.82986 4.21359 1.78941 4.2337 1.74867C4.32008 1.57366 4.39714 1.39314 4.46425 1.20774C4.48263 1.15695 4.50026 1.1058 4.51714 1.05429C4.56495 0.908335 4.88483 0.908335 4.93265 1.05429C4.94952 1.1058 4.96716 1.15695 4.98554 1.20774C5.05264 1.39314 5.1297 1.57366 5.21609 1.74867C5.2362 1.78941 5.25681 1.82986 5.27792 1.86999C5.77758 2.81988 6.5557 3.59799 7.50558 4.09764C7.54571 4.11876 7.58615 4.13937 7.6269 4.15948C7.80191 4.24587 7.98243 4.32293 8.16782 4.39003C8.21861 4.40841 8.26977 4.42605 8.32127 4.44292C8.46723 4.49074 8.46723 4.81061 8.32127 4.85843C8.26977 4.87531 8.21861 4.89294 8.16782 4.91132C7.98243 4.97842 7.80191 5.05549 7.6269 5.14187C7.58615 5.16198 7.54571 5.1826 7.50558 5.20371C6.5557 5.70336 5.77758 6.48148 5.27793 7.43136C5.25681 7.4715 5.2362 7.51194 5.21609 7.55268C5.1297 7.72769 5.05264 7.90822 4.98554 8.09361C4.96716 8.1444 4.94952 8.19555 4.93265 8.24706C4.88483 8.39302 4.56495 8.39302 4.51714 8.24706C4.50026 8.19555 4.48263 8.1444 4.46425 8.09361C4.39715 7.90822 4.32008 7.72769 4.2337 7.55268C4.21359 7.51194 4.19297 7.4715 4.17186 7.43136C3.67221 6.48148 2.89409 5.70336 1.94421 5.20371C1.90407 5.1826 1.86363 5.16198 1.82289 5.14187ZM3.13368 4.53707C3.05615 4.59233 3.05615 4.70903 3.13368 4.76428C3.70464 5.17125 4.20432 5.67093 4.61129 6.24189C4.66654 6.31942 4.78324 6.31942 4.8385 6.24189C5.24547 5.67093 5.74515 5.17125 6.31611 4.76428C6.39363 4.70903 6.39363 4.59233 6.31611 4.53707C5.74515 4.1301 5.24547 3.63042 4.8385 3.05946C4.78324 2.98194 4.66654 2.98194 4.61129 3.05946C4.20432 3.63042 3.70464 4.1301 3.13368 4.53707ZM9.86275 8.0118C9.63465 8.14566 9.39342 8.25977 9.14135 8.35184C8.99708 8.40454 8.99708 8.74391 9.14135 8.79661C9.39342 8.88868 9.63465 9.0028 9.86275 9.13666C10.5164 9.52026 11.0621 10.066 11.4457 10.7196C11.5796 10.9477 11.6937 11.189 11.7858 11.441C11.8385 11.5853 12.1778 11.5853 12.2305 11.441C12.3226 11.189 12.4367 10.9477 12.5706 10.7196C12.9542 10.066 13.4999 9.52026 14.1536 9.13666C14.3816 9.0028 14.6229 8.88868 14.875 8.79661C15.0192 8.74392 15.0192 8.40454 14.875 8.35184C14.6229 8.25977 14.3816 8.14565 14.1536 8.0118C13.4999 7.6282 12.9542 7.08247 12.5706 6.42882C12.4367 6.20073 12.3226 5.9595 12.2305 5.70742C12.1778 5.56316 11.8385 5.56316 11.7858 5.70742C11.6937 5.9595 11.5796 6.20073 11.4457 6.42882C11.0621 7.08247 10.5164 7.6282 9.86275 8.0118ZM10.9712 8.46415C10.9002 8.51982 10.9002 8.62863 10.9712 8.6843C11.3163 8.95479 11.6276 9.26611 11.8981 9.61115C11.9537 9.68217 12.0626 9.68217 12.1182 9.61115C12.3887 9.26611 12.7 8.95479 13.0451 8.6843C13.1161 8.62863 13.1161 8.51982 13.0451 8.46415C12.7 8.19366 12.3887 7.88235 12.1182 7.5373C12.0626 7.46628 11.9537 7.46628 11.8981 7.5373C11.6276 7.88235 11.3163 8.19366 10.9712 8.46415ZM4.34051 12.9888C4.80417 13.1446 5.22426 13.3932 5.57896 13.7128C5.60952 13.7403 5.6396 13.7684 5.66919 13.7969C5.69837 13.8251 5.72708 13.8539 5.75528 13.883C5.78386 13.9126 5.81193 13.9427 5.83947 13.9733C6.15907 14.328 6.40767 14.748 6.56347 15.2117C6.57266 15.2391 6.58152 15.2665 6.59006 15.2942C6.61726 15.3822 6.80324 15.3822 6.83043 15.2942C6.83897 15.2665 6.84783 15.2391 6.85702 15.2117C7.01283 14.748 7.26143 14.328 7.58102 13.9733C7.60857 13.9427 7.63663 13.9126 7.66521 13.883C7.69342 13.8539 7.72212 13.8251 7.75131 13.7969C7.78089 13.7684 7.81097 13.7403 7.84154 13.7128C8.19624 13.3932 8.61632 13.1446 9.07999 12.9888C9.10733 12.9796 9.13482 12.9707 9.16245 12.9622C9.2505 12.935 9.2505 12.749 9.16245 12.7218C9.13482 12.7133 9.10733 12.7044 9.07999 12.6952C8.61632 12.5394 8.19624 12.2908 7.84154 11.9712C7.81097 11.9437 7.78089 11.9156 7.75131 11.887C7.72212 11.8588 7.69342 11.8301 7.66521 11.8009C7.63663 11.7713 7.60857 11.7413 7.58102 11.7107C7.26143 11.356 7.01283 10.9359 6.85702 10.4722C6.84783 10.4449 6.83897 10.4174 6.83043 10.3898C6.80324 10.3017 6.61726 10.3017 6.59006 10.3898C6.58152 10.4174 6.57266 10.4449 6.56347 10.4722C6.40767 10.9359 6.15907 11.356 5.83947 11.7107C5.81193 11.7413 5.78386 11.7713 5.75528 11.8009C5.72708 11.8301 5.69838 11.8588 5.66919 11.887C5.63961 11.9156 5.60952 11.9437 5.57896 11.9712C5.22426 12.2908 4.80418 12.5394 4.34051 12.6952C4.31317 12.7044 4.28568 12.7133 4.25804 12.7218C4.17 12.749 4.17 12.935 4.25804 12.9622C4.28568 12.9707 4.31317 12.9796 4.34051 12.9888Z",
            fill: "var(--icon-color)"
        })
    });
};
function adExamplesIconMobile(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M14.9887 2.40454L13.55 1.9887C13.4835 1.96892 13.4126 1.96846 13.3458 1.9874C13.279 2.00633 13.2189 2.04386 13.1726 2.09562C13.1409 2.13176 13.1168 2.17383 13.1016 2.21938C13.0864 2.26494 13.0804 2.31306 13.084 2.36095C13.0876 2.40884 13.1007 2.45554 13.1225 2.49832C13.1443 2.54111 13.1744 2.57912 13.2111 2.61014L14.3392 3.5953C14.5764 3.8018 14.7434 4.05561 14.8316 4.32985L14.8374 4.35207C14.924 4.63498 14.9284 4.94277 14.8437 5.24738L14.4477 6.66307C14.4294 6.73004 14.4304 6.80084 14.4507 6.86725C14.4709 6.93366 14.5096 6.99297 14.5622 7.03831C14.6354 7.10238 14.7308 7.13518 14.8279 7.12964C14.9249 7.1241 15.016 7.08066 15.0814 7.00867L16.0585 5.9089C16.2592 5.67978 16.5217 5.51331 16.8146 5.42939C17.1114 5.34779 17.4251 5.35122 17.7201 5.43928L19.1592 5.85431C19.2258 5.87409 19.2966 5.87454 19.3634 5.85561C19.4303 5.83668 19.4903 5.79915 19.5367 5.74738C19.5683 5.71125 19.5924 5.66918 19.6076 5.62362C19.6228 5.57807 19.6288 5.52994 19.6252 5.48205C19.6216 5.43416 19.6085 5.38747 19.5867 5.34468C19.5649 5.3019 19.5348 5.26389 19.4981 5.23287L18.3696 4.24852C18.1264 4.03558 17.9559 3.77459 17.8701 3.49213C17.7843 3.20966 17.7799 2.90187 17.8651 2.59644L18.2603 1.18031C18.2786 1.11334 18.2776 1.04254 18.2573 0.976129C18.237 0.909716 18.1984 0.850406 18.1458 0.80507C18.0726 0.740993 17.9772 0.708196 17.8801 0.713738C17.783 0.71928 17.692 0.762717 17.6266 0.834702L16.6508 1.9341C16.4457 2.16468 16.1922 2.32543 15.9164 2.40859L15.8947 2.41362C15.5978 2.49562 15.2839 2.49247 14.9887 2.40454Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.33464 4.40527C2.93534 4.40527 2.41797 4.82792 2.41797 5.6078V15.3704C2.41797 16.1503 2.93534 16.573 3.33464 16.573H16.668C17.0673 16.573 17.5846 16.1503 17.5846 15.3704L17.5846 9.23563C17.5846 8.82142 17.9204 8.48563 18.3346 8.48563C18.7488 8.48563 19.0846 8.82142 19.0846 9.23563L19.0846 15.3704C19.0846 16.7473 18.1096 18.073 16.668 18.073H3.33464C1.89298 18.073 0.917969 16.7473 0.917969 15.3704V5.6078C0.917969 4.23098 1.89298 2.90527 3.33464 2.90527H10.8267C11.2409 2.90527 11.5767 3.24106 11.5767 3.65527C11.5767 4.06949 11.2409 4.40527 10.8267 4.40527H3.33464Z",
                fill: "var(--icon-color)",
                stroke: "var(--icon-color)",
                strokeWidth: "0.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M11.1934 13.6812C10.7402 13.6812 10.4746 13.4077 10.4746 12.9312V8.79443C10.4746 8.31787 10.7402 8.04443 11.1934 8.04443H12.7637C14.4668 8.04443 15.4668 9.03271 15.4668 10.8296C15.4668 12.6304 14.4629 13.6812 12.7637 13.6812H11.1934ZM11.9082 12.5249H12.5762C13.5098 12.5249 14.0098 11.9585 14.0098 10.8335C14.0098 9.7749 13.4824 9.20068 12.5762 9.20068H11.9082V12.5249Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M5.26367 13.7671C4.81055 13.7671 4.5332 13.5093 4.5332 13.0835C4.5332 12.9624 4.57227 12.7866 4.63477 12.6147L6.02539 8.79443C6.23242 8.22021 6.58008 7.9585 7.13867 7.9585C7.72852 7.9585 8.07227 8.2085 8.28711 8.79443L9.68945 12.6147C9.75586 12.7983 9.7832 12.9312 9.7832 13.0796C9.7832 13.4819 9.48242 13.7671 9.06445 13.7671C8.65039 13.7671 8.43555 13.5796 8.31055 13.1187L8.11914 12.4937H6.18945L5.99805 13.0952C5.86133 13.5718 5.64648 13.7671 5.26367 13.7671ZM6.47461 11.4116H7.80664L7.14648 9.23975H7.11523L6.47461 11.4116Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
var textToReelIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.69785 8.90874C10.1605 9.37271 10.0834 10.146 9.46653 10.4553L5.14851 13.0072C3.9919 13.7031 2.60396 13.2392 1.60156 11.6152C1.90999 13.7805 4.30033 15.1724 6.45934 13.9351L10.1605 11.7699C11.8569 10.842 11.7798 8.36744 10.0834 7.43949L5.84248 5.04229C5.99669 4.42366 6.69066 4.11435 7.30752 4.42366L11.6255 6.97551C12.7822 7.67147 13.1677 9.0634 12.3195 10.61C13.8617 9.68203 14.3243 6.82086 11.934 5.42894L8.07859 3.1864C6.38223 2.18112 4.37743 3.34106 4.45454 5.27428V10.378C3.83768 10.61 3.14371 10.146 3.14371 9.45004V4.42366C3.14371 3.10907 3.91479 1.87181 5.99669 1.87181C3.9919 0.94386 1.60156 2.49044 1.67867 4.96496V9.45004C1.67867 11.3833 3.76057 12.5432 5.37983 11.5379L9.69785 8.90874ZM8.23281 8.05812L5.84248 6.74353V9.45004L8.23281 8.05812Z",
            fill: "var(--icon-color)"
        })
    });
};
var deforumIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M14.5892 9.00338C14.7914 7.67735 14.5888 6.32119 14.008 5.1121C13.4272 3.90302 12.4952 2.89725 11.3338 2.22622C10.1724 1.55519 8.83553 1.25012 7.49798 1.35086C6.16042 1.45161 4.88436 1.95349 3.83655 2.79092C2.78874 3.62835 2.0179 4.76238 1.62478 6.04482C1.23166 7.32726 1.23453 8.69847 1.63302 9.97925C2.03151 11.26 2.80709 12.3908 3.8584 13.2239C4.90971 14.0569 6.18786 14.5534 7.52582 14.6486",
                stroke: "var(--icon-color)",
                strokeWidth: "1.37143",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M6.09912 7.99544V7.15097C6.09912 6.09917 6.84246 5.66935 7.75267 6.19525L8.48589 6.62001L9.21911 7.04477C10.1293 7.57067 10.1293 8.43031 9.21911 8.95621L8.48589 9.38098L7.75267 9.80574C6.84246 10.3316 6.09912 9.90182 6.09912 8.85002V7.99544Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.37143",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1492 14.7447V11.1104C15.1249 10.427 14.2419 10.4265 14.2173 11.1104V14.7447C14.2417 15.4281 15.1246 15.4286 15.1492 14.7447ZM12.515 11.4427C12.3541 10.9273 11.9175 10.5955 11.4036 10.5977C10.8889 10.5997 10.455 10.9352 10.2979 11.4525C10.2945 11.4639 9.57062 14.6307 9.57062 14.6307C9.50766 14.9064 9.67946 15.181 9.95435 15.2441C10.2295 15.3073 10.5032 15.135 10.5661 14.8593L10.7034 14.2586H12.1345L12.278 14.8635C12.3422 15.1407 12.6259 15.3091 12.893 15.2432C13.1674 15.1777 13.3369 14.9016 13.2716 14.6266C13.2716 14.6266 12.5185 11.4541 12.515 11.4427ZM10.9551 13.3932L11.2891 11.663C11.3146 11.5768 11.3587 11.5296 11.4144 11.5293H11.4149C11.4708 11.5293 11.5138 11.5747 11.5397 11.6607L11.887 13.3932H10.9551Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var restlyeIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
                clipPath: "url(#clip0_18567_138177)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.90706 14.4009V10.7667C5.88266 10.0832 4.9997 10.0827 4.9751 10.7667V14.4009C4.99949 15.0844 5.88245 15.0849 5.90706 14.4009ZM3.2728 11.099C3.11195 10.5835 2.67529 10.2518 2.16139 10.2539C1.64676 10.256 1.21278 10.5915 1.05575 11.1087C1.05228 11.1202 0.328431 14.287 0.328431 14.287C0.265468 14.5626 0.437277 14.8373 0.712161 14.9004C0.987301 14.9635 1.26099 14.7912 1.32395 14.5156L1.46119 13.9149H2.89234L3.03586 14.5198C3.10002 14.797 3.38369 14.9654 3.65084 14.8994C3.92519 14.834 4.09472 14.5579 4.02944 14.2828C4.02944 14.2828 3.27635 11.1104 3.2728 11.099ZM1.71338 13.0495L2.04742 11.3192C2.07286 11.2331 2.11699 11.1858 2.17273 11.1855H2.17322C2.22911 11.1855 2.27207 11.2309 2.298 11.317L2.64534 13.0495H1.71338Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.98849 5.40636C1.98849 4.501 2.17422 4.13241 2.40788 3.93812C2.68309 3.70927 3.2302 3.53927 4.38146 3.53927H9.06756C10.2188 3.53927 10.7659 3.70927 11.0411 3.93812C11.2748 4.13241 11.4605 4.501 11.4605 5.40636V10.5978C11.4605 11.5014 11.2737 11.8707 11.0389 12.0656C10.7624 12.2951 10.2145 12.4649 9.06756 12.4649H6.87511V13.9221H9.06756C10.2563 13.9221 11.2692 13.7682 11.9696 13.1869C12.7116 12.571 12.9178 11.6424 12.9178 10.5978V5.40636C12.9178 4.3634 12.7142 3.43413 11.9729 2.81765C11.273 2.23572 10.2593 2.08203 9.06756 2.08203H4.38146C3.18968 2.08203 2.17599 2.23572 1.47617 2.81765C0.734788 3.43413 0.53125 4.3634 0.53125 5.40636V10.0829C0.879247 9.641 1.39499 9.35245 1.98849 9.31634V5.40636Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M2.40788 3.93812L2.33481 3.85025L2.40788 3.93812ZM11.0411 3.93812L10.9681 4.02599V4.02599L11.0411 3.93812ZM11.0389 12.0656L10.9659 11.9776L11.0389 12.0656ZM6.87511 12.4649V12.3506C6.81199 12.3506 6.76082 12.4017 6.76082 12.4649H6.87511ZM6.87511 13.9221H6.76082C6.76082 13.9852 6.81199 14.0364 6.87511 14.0364V13.9221ZM11.9696 13.1869L12.0425 13.2749L11.9696 13.1869ZM11.9729 2.81765L11.8998 2.90552L11.9729 2.81765ZM1.47617 2.81765L1.54924 2.90552L1.47617 2.81765ZM0.53125 10.0829H0.416964C0.416964 10.1315 0.44782 10.1749 0.493831 10.1908C0.539843 10.2068 0.590903 10.1918 0.621033 10.1536L0.53125 10.0829ZM1.98849 9.31634L1.99543 9.43041C2.05574 9.42674 2.10277 9.37676 2.10277 9.31634H1.98849ZM2.33481 3.85025C2.0615 4.07751 1.8742 4.48983 1.8742 5.40636H2.10277C2.10277 4.51216 2.28694 4.18732 2.48095 4.02599L2.33481 3.85025ZM4.38146 3.42498C3.22717 3.42498 2.64338 3.59366 2.33481 3.85025L2.48095 4.02599C2.7228 3.82488 3.23322 3.65356 4.38146 3.65356V3.42498ZM9.06756 3.42498H4.38146V3.65356H9.06756V3.42498ZM11.1142 3.85025C10.8056 3.59366 10.2219 3.42498 9.06756 3.42498V3.65356C10.2158 3.65356 10.7262 3.82488 10.9681 4.02599L11.1142 3.85025ZM11.5748 5.40636C11.5748 4.48983 11.3875 4.07751 11.1142 3.85025L10.9681 4.02599C11.1621 4.18732 11.3463 4.51216 11.3463 5.40636H11.5748ZM11.5748 10.5978V5.40636H11.3463V10.5978H11.5748ZM11.1119 12.1535C11.3863 11.9257 11.5748 11.5129 11.5748 10.5978H11.3463C11.3463 11.49 11.1611 11.8156 10.9659 11.9776L11.1119 12.1535ZM9.06756 12.5791C10.2176 12.5791 10.8021 12.4107 11.1119 12.1535L10.9659 11.9776C10.7227 12.1795 10.2113 12.3506 9.06756 12.3506V12.5791ZM6.87511 12.5791H9.06756V12.3506H6.87511V12.5791ZM6.76082 12.4649V13.9221H6.98939V12.4649H6.76082ZM9.06756 13.8078H6.87511V14.0364H9.06756V13.8078ZM11.8966 13.099C11.2294 13.6527 10.2529 13.8078 9.06756 13.8078V14.0364C10.2597 14.0364 11.309 13.8837 12.0425 13.2749L11.8966 13.099ZM12.8035 10.5978C12.8035 11.6316 12.5988 12.5162 11.8966 13.099L12.0425 13.2749C12.8245 12.6259 13.0321 11.6533 13.0321 10.5978H12.8035ZM12.8035 5.40636V10.5978H13.0321V5.40636H12.8035ZM11.8998 2.90552C12.6013 3.48882 12.8035 4.37399 12.8035 5.40636H13.0321C13.0321 4.3528 12.8272 3.37944 12.0459 2.72977L11.8998 2.90552ZM9.06756 2.19632C10.2561 2.19632 11.2332 2.35126 11.8998 2.90552L12.0459 2.72977C11.3128 2.12019 10.2626 1.96775 9.06756 1.96775V2.19632ZM4.38146 2.19632H9.06756V1.96775H4.38146V2.19632ZM1.54924 2.90552C2.2158 2.35126 3.19296 2.19632 4.38146 2.19632V1.96775C3.1864 1.96775 2.13618 2.12019 1.4031 2.72977L1.54924 2.90552ZM0.645536 5.40636C0.645536 4.37399 0.847765 3.48882 1.54924 2.90552L1.4031 2.72977C0.621811 3.37944 0.416964 4.3528 0.416964 5.40636H0.645536ZM0.645536 10.0829V5.40636H0.416964V10.0829H0.645536ZM0.621033 10.1536C0.949787 9.73615 1.43593 9.46445 1.99543 9.43041L1.98155 9.20226C1.35406 9.24044 0.808708 9.54586 0.441467 10.0121L0.621033 10.1536ZM1.8742 5.40636V9.31634H2.10277V5.40636H1.8742Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.2767 5.40384C14.2765 5.40396 14.2769 5.40372 14.2767 5.40384L12.9104 6.40032V9.5966L14.2777 10.5938L14.2793 10.595C14.4765 10.7397 14.582 10.7528 14.618 10.7515C14.6411 10.7231 14.7075 10.6181 14.7075 10.3281V5.67492C14.7075 5.38161 14.6396 5.27708 14.6167 5.2497C14.5817 5.24783 14.4757 5.25946 14.2767 5.40384ZM14.6302 5.25171C14.6302 5.25177 14.6293 5.25159 14.6276 5.25097L14.6302 5.25171ZM14.6324 10.7496C14.6324 10.7496 14.6315 10.75 14.6296 10.7503L14.6324 10.7496ZM15.2332 4.11023C15.8005 4.41825 15.9997 5.0603 15.9997 5.67492V10.3281C15.9997 10.9421 15.8007 11.5855 15.2319 11.8927C14.651 12.2065 14.0083 11.9986 13.5156 11.6373C13.5153 11.6371 13.5159 11.6375 13.5156 11.6373L11.8836 10.4471C11.7168 10.3255 11.6182 10.1315 11.6182 9.92507V6.07184C11.6182 5.86543 11.7168 5.67145 11.8836 5.54982L13.5163 4.35905C14.0102 4.0004 14.6538 3.79566 15.2332 4.11023Z",
                        fill: "var(--icon-color)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "clip0_18567_138177",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var textToVideoIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M4.23543 12.1142C4.56608 12.1492 4.81699 12.4281 4.81699 12.7606V13.7065C4.81699 14.118 5.275 14.3629 5.61691 14.1352L5.61724 14.135L8.4581 12.2453C8.56476 12.1744 8.69 12.1365 8.8181 12.1365H11.3337C12.2998 12.1365 13.093 11.8151 13.6443 11.2638C14.1956 10.7125 14.517 9.91931 14.517 8.95321V4.95321C14.517 3.9871 14.1956 3.1939 13.6443 2.64261C13.093 2.09131 12.2998 1.76987 11.3337 1.76987H4.66699C3.70089 1.76987 2.90769 2.09131 2.35639 2.64261C1.8051 3.1939 1.48366 3.9871 1.48366 4.95321V8.95321C1.48366 9.91931 1.8051 10.7125 2.35639 11.2638C2.82467 11.7321 3.46461 12.0326 4.23543 12.1142Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.3",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.92839 5.88978C6.91425 5.89796 6.78549 5.98582 6.78549 6.36562V8.06467C6.78549 8.44446 6.91425 8.53233 6.92839 8.5405C6.94226 8.54851 7.08192 8.61626 7.40989 8.42687C7.40977 8.42695 7.41002 8.4268 7.40989 8.42687L8.87672 7.57713C9.2048 7.38757 9.21671 7.23214 9.21671 7.21514C9.21671 7.19814 9.2048 7.04272 8.87672 6.85316L7.41027 6.00363C7.41018 6.00358 7.41037 6.00369 7.41027 6.00363C7.08224 5.81419 6.94226 5.88177 6.92839 5.88978ZM6.24205 4.70246C6.8274 4.36409 7.51441 4.47992 8.09637 4.81616L8.09705 4.81655L9.56282 5.66569C9.5627 5.66562 9.56293 5.66575 9.56282 5.66569C10.1448 6.00204 10.5881 6.53951 10.5881 7.21514C10.5881 7.89073 10.1452 8.42797 9.56328 8.76433C9.56312 8.76442 9.56343 8.76424 9.56328 8.76433L8.09637 9.61413C7.51441 9.95037 6.8274 10.0662 6.24205 9.72783C5.65697 9.38962 5.41406 8.73667 5.41406 8.06467V6.36562C5.41406 5.69361 5.65697 5.04067 6.24205 4.70246Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var videoBGRemoverIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
                clipPath: "url(#clip0_18567_138196)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M3.52711 0.332031C3.97855 0.332031 4.19415 0.887068 3.86107 1.1918L2.49187 2.44447C2.17608 2.73338 1.66748 2.50935 1.66748 2.08134C1.66748 1.94369 1.72512 1.81233 1.82642 1.71914L3.19214 0.462678C3.28346 0.378662 3.40302 0.332031 3.52711 0.332031Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M8.00406 0.332031C8.47714 0.332031 8.70399 0.912867 8.35614 1.2335L2.53125 6.60253C2.20137 6.90659 1.66748 6.67261 1.66748 6.22397C1.66748 6.08036 1.72746 5.94328 1.83294 5.84582L7.65153 0.469957C7.74751 0.381279 7.87338 0.332031 8.00406 0.332031Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M5.71476 7.484C5.78752 7.67482 5.75692 7.89736 5.60428 8.03305L2.49758 10.7946C2.17594 11.0805 1.66748 10.8521 1.66748 10.4218C1.66748 10.2801 1.72777 10.145 1.83329 10.0504L4.95877 7.24828C5.20815 7.02469 5.59543 7.17104 5.71476 7.484Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M3.2499 12.9806C3.44674 12.8042 3.74719 12.8123 3.93415 12.9992C4.209 13.274 3.93416 13.666 3.86748 13.7326L2.49133 14.9836C2.17494 15.2712 1.66748 15.0468 1.66748 14.6192C1.66748 14.4792 1.72703 14.3458 1.83124 14.2524L3.2499 12.9806Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M9.66631 3.19531C7.93298 3.19531 6.46631 4.59531 6.46631 6.39531C6.46631 6.46198 6.46631 6.46198 6.46631 6.52865C6.46631 6.79531 6.53298 7.12865 6.59964 7.39531C6.79964 8.06198 7.26631 8.66198 7.86631 9.06198C8.19964 9.26198 8.53298 9.39531 8.86631 9.52865C9.13298 9.59531 9.39964 9.66198 9.66631 9.66198C11.3996 9.66198 12.8663 8.26198 12.8663 6.46198C12.8663 4.66198 11.3996 3.19531 9.66631 3.19531ZM9.66631 8.52865C8.46631 8.52865 7.53298 7.52865 7.53298 6.39531C7.53298 5.19531 8.53298 4.26198 9.66631 4.26198C10.7996 4.26198 11.7996 5.26198 11.7996 6.39531C11.7996 7.52865 10.8663 8.52865 9.66631 8.52865Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M5.0641 14.8668C4.73076 14.8668 4.53076 14.6001 4.53076 14.3335C4.53076 12.8668 5.13076 10.4668 9.2641 10.4668C9.34326 10.4668 9.42149 10.4677 9.49877 10.4696C9.57606 10.4677 9.65429 10.4668 9.73345 10.4668C13.8668 10.4668 14.4668 12.8668 14.4668 14.3335C14.4668 14.6001 14.2668 14.8668 13.9335 14.8668C13.9207 14.8668 13.9082 14.8665 13.8959 14.8659C13.8857 14.8665 13.8751 14.8668 13.8641 14.8668C13.5308 14.8668 13.3308 14.6001 13.3308 14.3335C13.3308 13.0711 12.8673 11.5439 9.49877 11.5335C6.13027 11.5439 5.66679 13.0711 5.66679 14.3335C5.66679 14.6001 5.46678 14.8668 5.13345 14.8668C5.12241 14.8668 5.11181 14.8665 5.10163 14.8659C5.08931 14.8665 5.0768 14.8668 5.0641 14.8668Z",
                        fill: "var(--icon-color)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "clip0_18567_138196",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var musicGeneratorIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.87023 9.72266C3.79634 9.72266 2.92578 10.5932 2.92578 11.6671C2.92578 12.741 3.79634 13.6115 4.87023 13.6115C5.94411 13.6115 6.81467 12.741 6.81467 11.6671C6.81467 10.5932 5.94411 9.72266 4.87023 9.72266ZM1.92578 11.6671C1.92578 10.0409 3.24405 8.72266 4.87023 8.72266C6.4964 8.72266 7.81467 10.0409 7.81467 11.6671C7.81467 13.2933 6.4964 14.6115 4.87023 14.6115C3.24405 14.6115 1.92578 13.2933 1.92578 11.6671Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.31543 2.61072C7.59157 2.61072 7.81543 2.83458 7.81543 3.11072V11.6663C7.81543 11.9424 7.59157 12.1663 7.31543 12.1663C7.03929 12.1663 6.81543 11.9424 6.81543 11.6663V3.11072C6.81543 2.83458 7.03929 2.61072 7.31543 2.61072Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.0815 2.47929C7.9425 2.57936 7.81816 2.77766 7.82034 3.10834L7.82036 3.11163L7.82035 3.83274C7.82035 4.05295 7.90885 4.31008 8.07601 4.54104C8.24296 4.7717 8.46049 4.93766 8.67076 5.00861C8.67099 5.00869 8.67123 5.00877 8.67146 5.00885L11.3703 5.90641C11.3704 5.90644 11.3701 5.90637 11.3703 5.90641C11.6892 6.01189 11.918 5.9556 12.0564 5.85572C12.1947 5.75588 12.3204 5.55677 12.3204 5.21996V4.50496C12.3204 4.28475 12.2318 4.02762 12.0647 3.79667C11.8977 3.56602 11.6802 3.40006 11.47 3.32911C11.4697 3.32903 11.4695 3.32894 11.4692 3.32886L8.76978 2.43108L8.7675 2.43032C8.45007 2.32305 8.22065 2.37912 8.0815 2.47929ZM9.08644 1.48254C8.51815 1.29085 7.9414 1.34798 7.49725 1.66772C7.05307 1.98748 6.81689 2.51568 6.82035 3.11317V3.83274C6.82035 4.30309 7.00074 4.76096 7.26594 5.12736C7.53117 5.49381 7.90917 5.80746 8.35258 5.95664L8.35423 5.95719L11.056 6.85574C11.623 7.04344 12.198 6.98679 12.6417 6.66657C13.0854 6.34627 13.3204 5.81816 13.3204 5.21996V4.50496C13.3204 4.03462 13.14 3.57675 12.8748 3.21034C12.6095 2.8439 12.2315 2.53025 11.7881 2.38107L9.08644 1.48254Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0013 12.1514V8.8243C14.979 8.19861 14.1707 8.19814 14.1481 8.8243V12.1514C14.1705 12.7771 14.9788 12.7776 15.0013 12.1514ZM12.5893 9.12852C12.442 8.65663 12.0423 8.3529 11.5718 8.35487C11.1007 8.35674 10.7034 8.66392 10.5596 9.13743C10.5564 9.14793 9.89374 12.0471 9.89374 12.0471C9.8361 12.2995 9.99339 12.5509 10.245 12.6087C10.4969 12.6665 10.7475 12.5088 10.8051 12.2564L10.9308 11.7064H12.241L12.3724 12.2602C12.4311 12.514 12.6908 12.6682 12.9354 12.6078C13.1865 12.5479 13.3418 12.2951 13.282 12.0433C13.282 12.0433 12.5925 9.13895 12.5893 9.12852ZM11.1618 10.9145L11.4676 9.33042C11.4909 9.25157 11.5313 9.20829 11.5823 9.20805H11.5828C11.6339 9.20805 11.6733 9.24957 11.697 9.32836L12.015 10.9145H11.1618Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var photoAiIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M5.59354 6.70661C6.2881 6.70661 6.85114 6.14356 6.85114 5.44901C6.85114 4.75445 6.2881 4.19141 5.59354 4.19141C4.89899 4.19141 4.33594 4.75445 4.33594 5.44901C4.33594 6.14356 4.89899 6.70661 5.59354 6.70661Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.867 14.5416V10.9073C14.8426 10.2239 13.9597 10.2233 13.9351 10.9073V14.5416C13.9595 15.225 14.8424 15.2255 14.867 14.5416ZM12.2318 11.2396C12.0709 10.7242 11.6343 10.3924 11.1204 10.3945C10.6057 10.3966 10.1718 10.7321 10.0147 11.2493C10.0113 11.2608 9.28742 14.4276 9.28742 14.4276C9.22445 14.7033 9.39626 14.9779 9.67115 15.041C9.94629 15.1042 10.22 14.9319 10.2829 14.6562L10.4202 14.0555H11.8513L11.9948 14.6604C12.059 14.9376 12.3427 15.106 12.6098 15.04C12.8842 14.9746 13.0537 14.6985 12.9884 14.4234C12.9884 14.4234 12.2353 11.251 12.2318 11.2396ZM10.6724 13.1901L11.0064 11.4598C11.0318 11.3737 11.076 11.3264 11.1317 11.3262H11.1322C11.1881 11.3262 11.2311 11.3715 11.257 11.4576L11.6043 13.1901H10.6724Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.43522 2.43937C3.29827 1.57631 4.57463 1.26221 6.16441 1.26221H9.83107C11.4208 1.26221 12.6972 1.57631 13.5603 2.43937C14.4233 3.30242 14.7374 4.57878 14.7374 6.16856V7.99841C14.7384 8.01838 14.7384 8.03839 14.7374 8.05838V9.47269C14.6679 9.46119 14.5966 9.45525 14.5241 9.45523C14.1013 9.45511 13.72 9.65613 13.4792 9.98924C13.4799 9.93865 13.4803 9.88732 13.4803 9.83522V8.31174L12.7153 7.63868L12.7152 7.63867C12.4841 7.43531 12.0829 7.43531 11.8518 7.63867L11.8515 7.63886L9.35293 9.83524L9.35271 9.83543C8.64677 10.4564 7.53445 10.4563 6.82859 9.83524L6.82324 9.83053L6.82327 9.8305L6.6282 9.65491C6.42199 9.47546 6.05715 9.45093 5.81579 9.6168L2.85463 11.6533C2.8234 11.6747 2.79091 11.693 2.75755 11.7082C2.89441 12.1234 3.08603 12.4374 3.32415 12.6755C3.8361 13.1874 4.69862 13.4844 6.16441 13.4844H8.53487L8.33899 14.3406C8.30819 14.4754 8.29862 14.6103 8.30811 14.7416H6.16441C4.57463 14.7416 3.29827 14.4275 2.43522 13.5644C1.57216 12.7014 1.25806 11.425 1.25806 9.83522V6.16856C1.25806 4.57878 1.57216 3.30242 2.43522 2.43937ZM13.4803 6.16856V6.64C12.7726 6.07436 11.7061 6.09257 11.0215 6.69466L11.0215 6.69471L11.0213 6.69485L8.52272 8.89123L8.5225 8.89142C8.29209 9.09414 7.89264 9.09478 7.66118 8.89331L7.46611 8.71772L7.46614 8.71769L7.46084 8.71303C6.8137 8.14352 5.81067 8.09494 5.10379 8.58071L5.1036 8.58084L2.52866 10.3517C2.51974 10.1884 2.5152 10.0164 2.5152 9.83522V6.16856C2.5152 4.70277 2.81221 3.84025 3.32415 3.3283C3.8361 2.81636 4.69862 2.51935 6.16441 2.51935H9.83107C11.2969 2.51935 12.1594 2.81636 12.6713 3.3283C13.1833 3.84025 13.4803 4.70277 13.4803 6.16856Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var textToImageIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M4.23269 12.1357C4.55243 12.1696 4.79508 12.4393 4.79508 12.7608V13.7068C4.79508 14.1355 5.27228 14.3904 5.6283 14.1533L5.62862 14.1531L8.46948 12.2634C8.57262 12.1948 8.69373 12.1582 8.81761 12.1582H11.3332C12.3041 12.1582 13.1031 11.8351 13.6589 11.2792C14.2148 10.7233 14.5379 9.92442 14.5379 8.95345V4.95345C14.5379 3.98248 14.2148 3.18356 13.6589 2.6277C13.1031 2.07184 12.3041 1.74869 11.3332 1.74869H4.6665C3.69553 1.74869 2.89661 2.07184 2.34075 2.6277C1.78489 3.18356 1.46174 3.98248 1.46174 4.95345V8.95345C1.46174 9.92442 1.78489 10.7233 2.34075 11.2792C2.81286 11.7513 3.45752 12.0537 4.23269 12.1357Z",
                stroke: "var(--icon-color)",
                strokeWidth: "1.25714",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M14.6665 6.33301L11.5556 8.63654C10.5326 9.39405 9.17471 9.52413 8.02649 8.97463V8.97463C6.92522 8.44759 5.62703 8.5443 4.61601 9.2287L1.99984 10.9997",
                stroke: "var(--icon-color)",
                strokeWidth: "1.25714",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M9.5127 6.19336C10.2025 6.19336 10.7617 5.63415 10.7617 4.94434C10.7617 4.25452 10.2025 3.69531 9.5127 3.69531C8.82288 3.69531 8.26367 4.25452 8.26367 4.94434C8.26367 5.63415 8.82288 6.19336 9.5127 6.19336Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var generativeFillIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.75036 6.44783C9.74966 6.44816 9.74895 6.4485 9.74826 6.44883C9.73627 6.45461 9.72464 6.46114 9.71342 6.46839C9.67772 6.49148 9.64697 6.52144 9.62297 6.55653C9.59897 6.59162 9.5822 6.63114 9.57363 6.67278L9.16546 8.51161C9.07183 8.93457 8.87226 9.30086 8.59467 9.58502C8.307 9.87588 7.94184 10.078 7.54262 10.1673L5.73992 10.5837C5.68011 10.5978 5.62552 10.6286 5.5825 10.6725C5.53947 10.7164 5.50977 10.7716 5.49683 10.8317C5.4778 10.9158 5.49263 11.0041 5.53811 11.0774C5.58359 11.1507 5.65608 11.2032 5.73992 11.2235L7.54262 11.6398C7.94157 11.7297 8.3064 11.9321 8.59385 12.223C8.88111 12.5201 9.07892 12.8921 9.16463 13.2964L9.57281 15.1352C9.58566 15.1953 9.61533 15.2506 9.65837 15.2945C9.70141 15.3384 9.75604 15.3692 9.8159 15.3832C9.85739 15.3925 9.90032 15.3934 9.94216 15.3859C9.98401 15.3784 10.0239 15.3627 10.0596 15.3396C10.0953 15.3165 10.1261 15.2865 10.1501 15.2514C10.1741 15.2163 10.1909 15.1768 10.1994 15.1352L10.6076 13.2964C10.6936 12.8922 10.8913 12.5202 11.1784 12.223C11.4661 11.9321 11.8312 11.73 12.2304 11.6407L14.0323 11.2243C14.0921 11.2101 14.1467 11.1793 14.1897 11.1354C14.2328 11.0915 14.2625 11.0363 14.2754 10.9763C14.2942 10.8922 14.2793 10.8042 14.2338 10.7311C14.1883 10.658 14.116 10.6056 14.0323 10.5853L12.2304 10.1689C11.8165 10.0737 11.4568 9.87082 11.1784 9.58666C10.9 9.3025 10.7012 8.93621 10.6076 8.51326L10.1994 6.67442L10.2003 6.67278C10.1874 6.61265 10.1577 6.55741 10.1147 6.5135C10.0717 6.46959 10.017 6.43881 9.95716 6.42476C9.91567 6.41549 9.87275 6.41458 9.8309 6.42207C9.80297 6.42707 9.77589 6.43575 9.75036 6.44783ZM5.60543 6.6611C5.67496 6.50586 5.76868 6.36766 5.88282 6.25147C6.00582 6.12626 6.15327 6.02477 6.31969 5.95245C6.40107 5.91709 6.48699 5.8887 6.5768 5.86793L7.84485 5.57474C7.90466 5.5606 7.95925 5.52979 8.00227 5.48589C8.0453 5.44199 8.075 5.3868 8.08794 5.32671C8.10673 5.2427 8.09178 5.15466 8.04632 5.08155C8.00086 5.00844 7.92851 4.9561 7.84485 4.93579L6.5768 4.64342C6.48711 4.62265 6.40124 4.59424 6.31986 4.55883C6.15981 4.4892 6.01711 4.39253 5.89679 4.27384L5.88365 4.25906C5.76768 4.13917 5.67376 4.00081 5.60532 3.85039C5.60352 3.84643 5.60174 3.84247 5.59997 3.83849C5.59965 3.83776 5.59932 3.83702 5.599 3.83629C5.55866 3.74508 5.52764 3.64955 5.50668 3.55112L5.22006 2.25679C5.20721 2.19666 5.17753 2.14142 5.13449 2.09751C5.09145 2.0536 5.03682 2.02282 4.97696 2.00877C4.93547 1.9995 4.89255 1.99859 4.8507 2.00608C4.80885 2.01357 4.76891 2.02932 4.73321 2.05241C4.69752 2.07549 4.66677 2.10545 4.64277 2.14054C4.61877 2.17564 4.60199 2.21515 4.59342 2.25679L4.30598 3.55112C4.2848 3.64713 4.25533 3.73884 4.21832 3.82545C4.21659 3.82951 4.21484 3.83355 4.21307 3.83759C4.21117 3.84193 4.20925 3.84626 4.20731 3.85057C4.1406 3.99903 4.05144 4.13192 3.9438 4.2451L3.92901 4.25906C3.80613 4.3847 3.65885 4.4863 3.49287 4.55867C3.41147 4.59415 3.32558 4.62261 3.23586 4.64342L1.96781 4.93579C1.908 4.94993 1.85341 4.98074 1.81039 5.02464C1.76736 5.06853 1.73766 5.12372 1.72472 5.18381C1.70593 5.26783 1.72087 5.35587 1.76634 5.42898C1.8118 5.50209 1.88415 5.55443 1.96781 5.57474L3.23668 5.86793C3.32534 5.88778 3.41144 5.91608 3.49388 5.95224C3.65616 6.0234 3.80427 6.12497 3.92983 6.25229C4.0455 6.37215 4.13916 6.5104 4.20742 6.66065C4.20896 6.66404 4.21049 6.66743 4.212 6.67083C4.21245 6.67183 4.21289 6.67282 4.21333 6.67382C4.25385 6.76541 4.28499 6.86136 4.30598 6.96023L4.59342 8.25456C4.60627 8.31469 4.63595 8.36993 4.67899 8.41384C4.72203 8.45775 4.77666 8.48853 4.83652 8.50258C4.87801 8.51185 4.92093 8.51276 4.96278 8.50527C5.00463 8.49778 5.04457 8.48203 5.08027 8.45894C5.11596 8.43586 5.14671 8.40589 5.17071 8.3708C5.19471 8.33571 5.21149 8.2962 5.22006 8.25456L5.50668 6.96023C5.52807 6.86454 5.55746 6.77311 5.59423 6.68673C5.59621 6.68207 5.59822 6.67743 5.60025 6.6728C5.60196 6.66889 5.60369 6.66499 5.60543 6.6611ZM4.81743 5.25539C4.83831 5.27527 4.8589 5.2955 4.87919 5.31607L4.88426 5.32122L4.88929 5.32642C4.89483 5.33217 4.90035 5.33794 4.90585 5.34373C4.91439 5.3348 4.92299 5.32591 4.93167 5.31708C4.95215 5.29623 4.97294 5.27575 4.99403 5.25563C4.98275 5.24488 4.97155 5.23403 4.96044 5.22307L4.92931 5.19236L4.90691 5.16716L4.88529 5.18989L4.86048 5.21333C4.84627 5.22753 4.83192 5.24155 4.81743 5.25539ZM11.4568 4.85284C11.4697 4.91297 11.4993 4.96821 11.5424 5.01212C11.5854 5.05603 11.64 5.08681 11.6999 5.10086C11.7414 5.11013 11.7843 5.11104 11.8262 5.10355C11.868 5.09606 11.908 5.08031 11.9436 5.05723C11.9793 5.03414 12.0101 5.00418 12.0341 4.96909C12.0581 4.934 12.0749 4.89448 12.0834 4.85284L12.2723 4.00282C12.2786 3.97489 12.2861 3.94752 12.2947 3.92081C12.3116 3.86832 12.3328 3.81834 12.3582 3.77149C12.3604 3.7673 12.3627 3.76314 12.3651 3.75901C12.3947 3.70633 12.4296 3.65778 12.4691 3.61427C12.4759 3.60676 12.4829 3.59939 12.49 3.59218C12.5025 3.57951 12.5154 3.56725 12.5287 3.55544C12.5607 3.52718 12.595 3.50142 12.6316 3.47839C12.6337 3.47709 12.6357 3.47579 12.6378 3.4745C12.6881 3.44343 12.7425 3.41749 12.8003 3.39722C12.8301 3.38675 12.8608 3.3778 12.8924 3.37044L13.726 3.17826C13.7858 3.16412 13.8404 3.13331 13.8834 3.08942C13.9264 3.04552 13.9561 2.99033 13.9691 2.93024C13.9879 2.84622 13.9729 2.75818 13.9275 2.68507C13.882 2.61196 13.8097 2.55962 13.726 2.53931L12.8924 2.34713C12.8609 2.34001 12.8302 2.33125 12.8004 2.32087C12.7406 2.30001 12.6843 2.27265 12.6316 2.23908C12.6304 2.23834 12.6292 2.23759 12.6281 2.23684C12.5932 2.21434 12.5598 2.18909 12.5281 2.16118C12.5174 2.15174 12.5069 2.142 12.4965 2.13196C12.4874 2.12263 12.4785 2.1131 12.4699 2.10339C12.4301 2.05884 12.3953 2.0104 12.3659 1.95893C12.3637 1.95509 12.3615 1.95124 12.3594 1.94737C12.3328 1.89925 12.311 1.84859 12.2941 1.79606C12.2855 1.76941 12.2783 1.74228 12.2723 1.71475L12.0834 0.864735C12.0706 0.804605 12.0401 0.749364 11.9971 0.705452C11.954 0.661539 11.8994 0.630763 11.8395 0.61671C11.798 0.607443 11.7551 0.60653 11.7133 0.614022C11.6714 0.621514 11.6315 0.637262 11.5958 0.660348C11.5601 0.683433 11.5293 0.713395 11.5053 0.748486C11.4813 0.783577 11.4646 0.823094 11.456 0.864735L11.2671 1.71475C11.2612 1.7426 11.2538 1.77006 11.2452 1.79702C11.2281 1.8503 11.2058 1.90165 11.1786 1.95035C11.1771 1.9532 11.1755 1.95603 11.1738 1.95886C11.1444 2.01021 11.1096 2.05853 11.0698 2.10294C11.0653 2.10801 11.0607 2.11303 11.056 2.118C11.0416 2.13284 11.0267 2.1471 11.0113 2.16076C10.9791 2.18924 10.9449 2.21509 10.9089 2.2381C10.9063 2.23975 10.9037 2.24139 10.9011 2.24301C10.8505 2.27457 10.7965 2.30058 10.7401 2.32051C10.71 2.33114 10.6792 2.34004 10.6479 2.34713L9.81426 2.53931C9.75444 2.55346 9.69986 2.58426 9.65683 2.62816C9.61381 2.67206 9.58411 2.72725 9.57116 2.78734C9.55238 2.87136 9.56732 2.95939 9.61279 3.0325C9.65825 3.10561 9.7306 3.15795 9.81426 3.17826L10.6479 3.37044C10.6791 3.37746 10.7098 3.38626 10.7398 3.39678C10.797 3.41684 10.8518 3.44314 10.9031 3.47514C10.905 3.47631 10.9069 3.47748 10.9087 3.47867C10.945 3.50168 10.9795 3.52755 11.0119 3.55609C11.025 3.56769 11.0378 3.57972 11.0503 3.59218C11.0572 3.59943 11.0641 3.6068 11.0708 3.61428C11.1099 3.65804 11.1443 3.7056 11.1734 3.75612C11.1739 3.75707 11.1745 3.75802 11.175 3.75898C11.2043 3.81024 11.2282 3.86453 11.2462 3.92098C11.2548 3.9478 11.262 3.97512 11.2679 4.00282L11.4568 4.85284ZM9.88577 10.114C9.98828 10.2574 10.1019 10.3931 10.226 10.5198C10.365 10.6616 10.5155 10.7904 10.6759 10.9052C10.5176 11.0187 10.3685 11.1457 10.2304 11.2854L10.2248 11.291L10.2192 11.2968C10.0981 11.4222 9.98687 11.556 9.88622 11.6968C9.78535 11.5557 9.67386 11.4218 9.55242 11.2962L9.54735 11.2909L9.54223 11.2857C9.40368 11.1455 9.25406 11.018 9.0952 10.9042C9.25422 10.7904 9.40399 10.6628 9.54268 10.5226L9.54844 10.5167C9.67124 10.391 9.78388 10.2564 9.88577 10.114Z",
            fill: "var(--icon-color)"
        })
    });
};
var lookAiIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M11.267 10.9331C11.0003 9.93311 9.53364 9.93311 9.26697 10.9331L8.66697 13.7998C8.46697 14.3998 9.46697 14.5998 9.60031 13.9998L9.73364 13.4664H10.9336C11.067 13.7998 11.067 14.5331 11.667 14.3998C11.9336 14.3331 12.067 14.1331 12.0003 13.8664L11.267 10.9331ZM9.86697 12.7331L10.1336 11.1998C10.1336 11.1331 10.2003 11.0664 10.267 11.0664C10.3336 11.0664 10.3336 11.1331 10.4003 11.1998L10.667 12.7331H9.86697Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M12.7998 10.5996V13.9329C12.7998 14.5329 13.6665 14.5329 13.6665 13.9329V10.5996C13.6665 9.93294 12.7998 9.93294 12.7998 10.5996Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M15.0669 6.19987L13.4669 3.19987C13.0002 2.19987 11.9336 1.86654 10.9336 1.5332C10.5336 3.86654 5.46689 3.86654 5.06689 1.5332C4.06689 1.86654 3.00022 2.19987 2.53355 3.19987L0.933554 6.19987C0.80022 6.39987 0.933554 6.66654 1.13355 6.7332L3.46689 7.66654C3.53355 7.7332 3.60022 7.79987 3.60022 7.86654L3.20022 14.0665C3.20022 14.2665 3.40022 14.4665 3.60022 14.4665H8.20022C7.93355 14.1332 7.86689 13.6665 7.93355 13.3332L8.53355 10.6665C8.86689 9.19987 10.9336 8.7332 11.8669 9.9332C12.0002 9.7332 12.1336 9.46654 12.4002 9.3332L12.3336 7.79987C12.3336 7.7332 12.4002 7.59987 12.4669 7.59987L14.8002 6.66654C15.0669 6.66654 15.1336 6.3332 15.0669 6.19987ZM12.0669 6.59987C11.4002 6.86654 11.1336 7.59987 11.2669 8.19987C9.66689 7.7332 7.93355 8.7332 7.53355 10.3999V10.4665L6.93355 13.0665C6.93355 13.1332 6.86689 13.2665 6.86689 13.3332H4.46689L4.80022 7.9332C4.86689 7.3332 4.46689 6.79987 3.93355 6.59987L2.33355 5.9332L3.53355 3.66654C3.73355 3.26654 4.06689 2.99987 4.46689 2.86654C5.86689 4.86654 10.0669 4.79987 11.4669 2.86654C11.8669 2.99987 12.2002 3.26654 12.4002 3.66654L13.6002 5.9332L12.0669 6.59987Z",
                fill: "var(--icon-color)"
            })
        ]
    });
};
var aiPhotoshootIcon = function(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: width !== null && width !== void 0 ? width : "16",
        height: height !== null && height !== void 0 ? height : "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.75162 1.16887C9.13124 0.950115 9.56168 0.834961 9.99984 0.834961C10.438 0.834961 10.8685 0.950124 11.2481 1.16889L11.2498 1.1699L17.08 4.50138L17.0832 4.50322C17.4628 4.72243 17.7782 5.03762 17.9976 5.41718C18.217 5.79674 18.3327 6.22732 18.3332 6.66573V6.66658V13.3333V13.3341C18.3327 13.7725 18.217 14.2031 17.9976 14.5827C17.7782 14.9622 17.4628 15.2774 17.0832 15.4966L17.08 15.4985L11.2498 18.8299L11.2483 18.8308C10.8876 19.0387 10.481 19.1531 10.0655 19.164C10.0439 19.1657 10.0219 19.1666 9.99984 19.1666C9.97773 19.1666 9.95582 19.1657 9.93415 19.164C9.51865 19.1531 9.11206 19.0387 8.75138 18.8308L8.74984 18.8299L2.91972 15.4985L2.9165 15.4966C2.53683 15.2774 2.22148 14.9622 2.00208 14.5827C1.78268 14.2031 1.66695 13.7725 1.6665 13.3341V13.3333V6.66658V6.66573C1.66695 6.22732 1.78268 5.79674 2.00208 5.41718C2.22148 5.03762 2.53683 4.72243 2.9165 4.50323L2.91972 4.50138L2.91972 4.50138L8.75162 1.16887ZM10.8332 17.1485L16.2498 14.0532L16.2512 14.0525C16.3771 13.9794 16.4818 13.8747 16.5546 13.7486C16.6278 13.6221 16.6664 13.4785 16.6665 13.3324V7.12966L10.8332 10.4821V17.1485ZM9.1665 10.4821V17.1485L3.74984 14.0532L3.74852 14.0525C3.62255 13.9794 3.51791 13.8747 3.44503 13.7486C3.37196 13.6222 3.33338 13.4788 3.33317 13.3328V7.12961L9.1665 10.4821ZM9.99984 2.50163C9.85356 2.50163 9.70985 2.54013 9.58317 2.61327L9.57996 2.61513L9.57995 2.61512L4.18594 5.6974L9.99988 9.03874L15.8138 5.69743L10.4197 2.61512L10.4165 2.61328L10.4165 2.61327C10.2898 2.54013 10.1461 2.50163 9.99984 2.50163Z",
            fill: "var(--icon-color)"
        })
    });
};
var ArrowIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.67 8.02876C13.795 8.15378 13.8652 8.32335 13.8652 8.50016C13.8652 8.67697 13.795 8.84654 13.67 8.97157L10.4779 12.1636C10.2176 12.424 9.79545 12.424 9.53511 12.1636C9.27476 11.9033 9.27476 11.4812 9.53511 11.2208L11.5891 9.16683H2.80162C2.43343 9.16683 2.13495 8.86835 2.13495 8.50016C2.13495 8.13197 2.43343 7.8335 2.80162 7.8335L11.5891 7.8335L9.53511 5.77951C9.27476 5.51916 9.27476 5.09705 9.53511 4.8367C9.79545 4.57635 10.2176 4.57635 10.4779 4.8367L13.67 8.02876Z",
            fill: "var(--icon-color)"
        })
    });
};
var SystemIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M13.333 11.1663V5.16634C13.333 4.81272 13.1925 4.47358 12.9425 4.22353C12.6924 3.97348 12.3533 3.83301 11.9997 3.83301H3.99969C3.64607 3.83301 3.30693 3.97348 3.05688 4.22353C2.80683 4.47358 2.66636 4.81272 2.66636 5.16634V11.1663M13.333 11.1663H2.66636M13.333 11.1663L14.1864 12.8663C14.2378 12.9683 14.2621 13.0818 14.257 13.1959C14.252 13.31 14.2177 13.4209 14.1574 13.5179C14.0972 13.615 14.0131 13.6949 13.9131 13.7501C13.8131 13.8052 13.7006 13.8338 13.5864 13.833H2.41302C2.29881 13.8338 2.18632 13.8052 2.08632 13.7501C1.98632 13.6949 1.90217 13.615 1.84194 13.5179C1.78171 13.4209 1.74742 13.31 1.74235 13.1959C1.73729 13.0818 1.76162 12.9683 1.81302 12.8663L2.66636 11.1663",
            stroke: "var(--icon-color)",
            strokeWidth: "1.09091",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var DarkIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4755 10.5806C12.6764 10.9095 11.7985 11.0908 10.8795 11.0908C7.25459 11.0908 4.24243 8.25443 4.24243 4.66657C4.24243 4.18148 4.29817 3.70832 4.40381 3.25312C3.18806 4.33627 2.42425 5.91267 2.42425 7.66657C2.42425 10.9301 5.06984 13.5757 8.33334 13.5757C10.5361 13.5757 12.4592 12.3699 13.4755 10.5806ZM13.8178 9.1908C14.3697 8.85866 15.1877 9.23439 14.9872 9.84653C14.0709 12.6451 11.4382 14.6666 8.33334 14.6666C4.46735 14.6666 1.33334 11.5326 1.33334 7.66657C1.33334 5.04927 2.76977 2.76747 4.89729 1.5665C5.48131 1.23683 5.99847 2.04539 5.73786 2.66333C5.47701 3.28183 5.33334 3.95807 5.33334 4.66657C5.33334 7.61209 7.81645 9.99991 10.8795 9.99991C11.9587 9.99991 12.9658 9.70353 13.8178 9.1908Z",
            fill: "var(--icon-color)"
        })
    });
};
var LightIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
                clipPath: "url(#clip0_24733_53351)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                        cx: "8.00016",
                        cy: "8.49967",
                        r: "2.66667",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M13.001 8.5H14.3343",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M1.66748 8.5H3.00081",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M8 13.499L8 14.8324",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M8 2.16602L8 3.49935",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M11.5332 12.0352L12.476 12.978",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M3.52002 4.02148L4.46283 4.96429",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M4.46289 12.0352L3.52008 12.978",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M12.4761 4.02148L11.5333 4.96429",
                        stroke: "var(--icon-color)",
                        strokeWidth: "1.33333",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "clip0_24733_53351",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var _showOnMobile;
var Logo = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BigLogo, {
        showOnMobile: (_showOnMobile = props.showOnMobile) !== null && _showOnMobile !== void 0 ? _showOnMobile : false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_12___default()), {
            href: "/",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                className: "mb-3 mr-5",
                children: props.dark ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_14__/* .assetUrl */ .p)("/comps/logo-dark.svg"),
                    alt: "Zoomerang logo dark theme",
                    className: "h-[19px] w-[40px]"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                    source: "/comps/logo",
                    format: "svg",
                    alt: "Zoomerang main logo"
                })
            })
        })
    });
};
var LogoSmall = function() {
    return /*#__PURE__*/ _jsx("a", {
        href: "/",
        children: /*#__PURE__*/ _jsx(CustomThemedResource, {
            className: "h-8",
            source: "/comps/logo",
            alt: "Zoomerang small logo",
            format: "svg"
        })
    });
};
function LogoZ() {
    return /*#__PURE__*/ _jsx("a", {
        href: "/",
        children: /*#__PURE__*/ _jsx(CustomThemedResource, {
            className: "h-[28px] w-[28px]",
            source: "/comps/logo-small",
            alt: "Zoomerang small logo icon",
            format: "png"
        })
    });
}
function LogoSmallScaled() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_12___default()), {
        href: "/",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                className: "h-10",
                source: "/comps/logo",
                alt: "Zoomerang small logo icon",
                format: "svg"
            })
        })
    });
}
var GeneralLine = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4e9814d-2"
})(_templateObject5());
var FirstLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(GeneralLine).withConfig({
    componentId: "sc-4e9814d-3"
})(_templateObject6());
var SecondLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(GeneralLine).withConfig({
    componentId: "sc-4e9814d-4"
})(_templateObject7());
var HiddenLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(GeneralLine).withConfig({
    componentId: "sc-4e9814d-5"
})(_templateObject8());
var ThirdLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(GeneralLine).withConfig({
    componentId: "sc-4e9814d-6"
})(_templateObject9());
var HamburgerContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4e9814d-7"
})(_templateObject14(), FirstLine, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject10());
}, ThirdLine, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject11());
}, SecondLine, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject12());
}, HiddenLine, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .css */ .iv)(_templateObject13());
});
var HamburgerAnimated = function(props) {
    var onClick = props.onClick, show = props.show;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HamburgerContainer, {
        onClick: onClick,
        show: show,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstLine, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondLine, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HiddenLine, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ThirdLine, {})
        ]
    });
};



/***/ }),

/***/ 1083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yz": function() { return /* binding */ UpgradeButton; },
  "ZP": function() { return /* binding */ header; }
});

// UNUSED EXPORTS: New

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/floating/index.tsx
var floating = __webpack_require__(501);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/coins.tsx
var coins = __webpack_require__(279);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./comps/ai-tools/icons.tsx
var icons = __webpack_require__(1455);
// EXTERNAL MODULE: ./comps/dropdown.tsx + 1 modules
var dropdown = __webpack_require__(3153);
// EXTERNAL MODULE: ./comps/subscription-popup.tsx + 1 modules
var subscription_popup = __webpack_require__(9460);
// EXTERNAL MODULE: ./comps/header/avatar-with-menu.tsx
var avatar_with_menu = __webpack_require__(5007);
// EXTERNAL MODULE: ./comps/header/icon.tsx
var icon = __webpack_require__(1817);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
;// CONCATENATED MODULE: ./comps/header/menu.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	flex-shrink: 0;\n\n	font-size: 18px;\n	font-weight: 600;\n\n	width: var(--w-screen);\n	height: 52px;\n\n	padding-left: 20px;\n\n	display: flex;\n	align-items: center;\n	justify-content: flex-start;\n\n	background-color: var(--color-background-cell);\n\n	border-top: 1px solid var(--color-separator);\n\n	&:hover {\n		background-color: var(--color-blue-100);\n	}\n\n	&:focus {\n		background-color: var(--color-blue-100);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n\n	border-bottom: 1px solid var(--color-separator);\n\n	justify-content: space-between;\n	padding-right: 20px;\n\n	&:hover,\n	&:focus {\n		background-color: unset !important;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	.light && {\n		",
        "\n	}\n\n	.dark && {\n		",
        "\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	justify-content: center;\n	gap: 12px;\n\n	height: 104px;\n	width: var(--w-screen);\n	padding: 32px 0;\n\n	background-color: var(--color-background-cell);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 40px;\n	height: 40px;\n\n	border-radius: 24px;\n	background-color: var(--color-blue-400);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					top: 57px;\n					width: 100%;\n			  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					top: 48px;\n			  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					height: 100vh;\n					padding-bottom: 100px;\n\n					body {\n						overflow: hidden;\n					}\n			  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					height: 0;\n			  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	overflow-y: scroll;\n\n	@media ",
        " {\n		display: none;\n	}\n\n	",
        "\n\n	",
        "\n\n  position: fixed;\n	left: 0;\n\n	background-color: var(--color-background-cell);\n	border-bottom: 1px solid var(--color-separator);\n\n	z-index: 99;\n\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n\n	transition: 300ms;\n	transition-timing-function: ease-in-out;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1;\n\n	height: 100%;\n	align-self: stretch;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}












var menuStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject());
var MenuGroupSingle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ba180806-0"
})(_templateObject1(), menuStyle);
function MenuGroup(props) {
    var text = props.text, items = props.items;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var toggleShow = function() {
        return setShow(!show);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuGroupSingle, {
                onClick: toggleShow,
                className: (0,clsx_m/* default */.Z)("flex !justify-between pr-5 transition-colors", show && "!bg-color-background"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row items-center gap-1",
                        children: t(text)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(show && "rotate-90", "before-line absolute bg-blue-600 transition-transform duration-[250ms] ease-out")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("bg-blue-600", "after-line absolute transition-transform duration-[250ms] ease-out")
                            })
                        ]
                    })
                ]
            }),
            show && items.map(function(item) {
                if (item.link) {
                    var _onClick;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            onClick: (_onClick = item.onClick) !== null && _onClick !== void 0 ? _onClick : toggleShow,
                            className: "flex h-[50px] w-full shrink-0 flex-row items-center gap-2 bg-color-background px-6 text-[16px] font-400 text-blue-700",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "[--icon-color:var(--color-blue-600)]",
                                    children: item.icon
                                }),
                                t(item.text)
                            ]
                        })
                    }, item.text);
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-[31px] w-full shrink-0 flex-row items-center gap-2 bg-blue-200 px-6 text-[15px] font-500 tracking-[0.6px] text-blue-600",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "[--icon-color:var(--color-blue-500)]",
                                children: item.icon
                            }),
                            t(item.text).toUpperCase()
                        ]
                    }, item.text);
                }
            // <MenuItem
            //   className="!bg-color-background !pl-12 !text-blue-700 ![--icon-color:var(--color-blue-800)]"
            //   key={item.text}
            //   text={item.text}
            //   link={item.link}
            //   icon={item.icon}
            //   onClick={item.onClick ?? toggleShow}
            // />
            })
        ]
    });
}
var MenuItemSingle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ba180806-1"
})(_templateObject2(), menuStyle);
var MenuItem = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    // let visited = null
    // if (typeof window !== "undefined" && userInfo) {
    // 	visited = localStorage.getItem(
    // 		`visited-train-model-id-${userInfo.userId}`,
    // 	)
    // }
    // const showNew = !visited
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemSingle, {
        className: (0,clsx_m/* default */.Z)(props.className, "text-blue-900 [--icon-color:var(--color-blue-900)]"),
        href: props.link,
        rel: "noopener noreferrer",
        target: props.newTab ? "_blank" : undefined,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("flex flex-row items-center gap-2", props.link === "/tools" && "text-primary-500"),
            children: [
                props.icon,
                t(props.text)
            ]
        })
    });
};
var MenuItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba180806-2"
})(_templateObject3(), menuStyle);
var ThemeText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba180806-3"
})(_templateObject4(), function(props) {
    return props.dark && "display: none;";
}, function(props) {
    return props.light && "display: none;";
});
var Socials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba180806-4"
})(_templateObject5());
var SocialAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ba180806-5"
})(_templateObject6());
var SocialIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ba180806-6"
})(_templateObject7());
var MenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba180806-7"
})(_templateObject12(), breakpoints/* devices.tablet */.Hb.tablet, function(props) {
    return props.dashboard ? (0,styled_components_browser_esm/* css */.iv)(_templateObject8()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
}, function(props) {
    return props.show ? (0,styled_components_browser_esm/* css */.iv)(_templateObject10()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject11());
});
var ArtificialCloser = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba180806-8"
})(_templateObject13());
var Menu = function(props) {
    var show = props.show, hide = props.hide;
    (0,react.useEffect)(function() {
        var shouldShow = show ? "false" : "true";
        document.documentElement.setAttribute("data-scroll", shouldShow);
    }, [
        show
    ]);
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* useClientAuth */.K6)().userInfo;
    var handleNewClick = function() {
        localStorage.setItem("visited-train-model-id-".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId), "true");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuContainer, {
        show: show,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuGroup, {
                text: "txt_video_gpt",
                items: [
                    {
                        icon: (0,icons/* aiAdsGenratorIcon */.SB)("22", "22"),
                        text: "txt_ai_ads_generator",
                        link: "/tools/ai-ad-generator"
                    },
                    {
                        icon: (0,icons/* productUrlToAdsIcon */.ce)("22", "22"),
                        text: "txt_product_url_to_ads",
                        link: "/tools/url-to-video-maker"
                    },
                    {
                        icon: (0,icons/* videoGptIcon */.zl)("22", "22"),
                        text: "txt_video_gpt",
                        link: "/tools/video-gpt"
                    },
                    {
                        icon: (0,icons/* aiScriptGenerator */.zB)("22", "22"),
                        text: "txt_script_generator",
                        link: "/tools/ai-script-generator"
                    },
                    {
                        icon: (0,icons/* scriptToAdsGenerator */.y$)("22", "22"),
                        text: "txt_script_to_ads_generator",
                        link: "/tools/ai-script-to-video-generator"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuGroup, {
                text: "lbl_ai_studio",
                items: [
                    {
                        text: "lbl_video"
                    },
                    {
                        link: "/tools/video-gpt",
                        text: "txt_text_to_reel",
                        icon: (0,icon/* textToReelIcon */.Ss)("22", "22")
                    },
                    {
                        text: "txt_deforum_ai",
                        link: "/tools/ai-video-transformation",
                        icon: (0,icon/* deforumIcon */.uv)("22", "22")
                    },
                    {
                        text: "txt_restyle_ai",
                        link: "/tools/ai-animation-generator",
                        icon: (0,icon/* restlyeIcon */.ZX)("22", "22")
                    },
                    {
                        text: "txt_text_to_video",
                        link: "/tools/text-to-video",
                        icon: (0,icon/* textToVideoIcon */.Cz)("22", "22")
                    },
                    {
                        text: "txt_video_bg_remover",
                        link: "/tools/video-background-remover",
                        icon: (0,icon/* videoBGRemoverIcon */.bv)("22", "22")
                    },
                    {
                        text: "txt_ai_music_generator",
                        link: "/tools/royalty-free-music",
                        icon: (0,icon/* musicGeneratorIcon */.rL)("22", "22")
                    },
                    {
                        text: "lbl_image"
                    },
                    {
                        text: "txt_ai_photoshoot",
                        link: "/tools/ai-photoshoot-generator",
                        icon: (0,icon/* aiPhotoshootIcon */.Bw)("22", "22"),
                        onClick: handleNewClick
                    },
                    {
                        text: "txt_photo_ai",
                        link: "/tools/ai-photo-editor",
                        icon: (0,icon/* photoAiIcon */.x$)("22", "22")
                    },
                    {
                        text: "txt_text_to_image",
                        link: "/tools/text-to-image",
                        icon: (0,icon/* textToImageIcon */.f7)("22", "22")
                    },
                    {
                        text: "txt_generative_fill",
                        link: "/tools/ai-image-replacer",
                        icon: (0,icon/* generativeFillIcon */.hM)("22", "22")
                    },
                    {
                        text: "txt_look_ai",
                        link: "/tools/ai-portrait-generator",
                        icon: (0,icon/* lookAiIcon */.YH)("22", "22")
                    },
                    {
                        text: "txt_all_tools",
                        link: "/tools"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuGroup, {
                text: "lbl_discover",
                items: [
                    {
                        text: "lbl_ai_gallery",
                        link: "/ai-gallery",
                        icon: (0,icon/* galleryIcon */.Uq)("22", "22")
                    },
                    {
                        text: "lbl_templates",
                        link: "/video-templates",
                        icon: (0,icon/* templatesIcon */.wv)("22", "22")
                    },
                    {
                        text: "lbl_ad_examples",
                        link: "/ad-examples",
                        icon: (0,icon/* adExamplesIconMobile */.bJ)("22", "22")
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                link: branch/* appStoreConstant */.HY,
                newTab: true,
                text: "lbl_mobile_app"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                link: "/pricing",
                text: "lbl_pricing",
                onClick: hide
            }),
            userInfo !== null && userInfo.isAnonymous && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItemContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeText, {
                        children: t("txt_dark_mode")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ThemeToggle */.Tl, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Socials, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* instagramLink */.WW,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/instagram.svg"),
                            alt: "Instagram Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* tiktokLink */.Pn,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/tiktok.svg"),
                            alt: "Tiktok Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* youtubeLink */.Ke,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/youtube.svg"),
                            alt: "Youtube Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* discordLink */.T4,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/discord.svg"),
                            alt: "Discord Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* pinterestLink */.RJ,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/pinterest.svg"),
                            alt: "Pinterest Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* facebookLink */.yK,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/facebook.svg"),
                            alt: "Facebook Logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAnchor, {
                        href: branch/* snapchatLink */.Co,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                            src: (0,cdn/* assetUrl */.p)("/comps/snapchat.svg"),
                            alt: "Snapchat Logo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtificialCloser, {
                onClick: hide
            })
        ]
    });
};
/* harmony default export */ var menu = (Menu);

// EXTERNAL MODULE: ./utils/scrollto.ts
var scrollto = __webpack_require__(1634);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
;// CONCATENATED MODULE: ./comps/header/tab.tsx

function tab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n\n  flex-shrink: 0;\n\n  cursor: pointer;\n  padding: 0px 12px;\n  border-radius: 10px;\n\n  transition: color 300ms ease-in-out;\n  color: ",
        ";\n\n  &:hover {\n    color: var(--color-primary-500);\n  }\n\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n  align-items: center;\n"
    ]);
    tab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var TabContainer = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8b9fb2fa-0"
})(tab_templateObject(), function(props) {
    return props.active ? "var(--color-primary-500)" : "var(--color-blue-700)";
});
var HeaderTab = function(props) {
    var name = props.name, link = props.link, newTab = props.newTab, active = props.active, section = props.section, className = props.className, showNew = props.showNew;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var userInfo = (0,client_auth/* useClientAuth */.K6)().userInfo;
    return section ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContainer, {
        className: className,
        active: active,
        onClick: function(e) {
            e.preventDefault();
            var scroller = (0,scrollto/* scrollToSection */.Q)(section);
            scroller();
        },
        children: t(name)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContainer, {
        className: className,
        href: link,
        active: active,
        rel: "noopener noreferrer",
        target: newTab ? "_blank" : undefined,
        onClick: function() {
            if (link === "/pricing") {
                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("pricing_page_view");
            }
            if (link === branch/* appStoreFallback */.xI) {
                (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_redirect", {
                    page: router.asPath,
                    section: "header",
                    destination: "app",
                    uid: userInfo ? userInfo.userId : null
                });
            }
        },
        children: [
            t(name),
            showNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-primary-500/20 flex h-[18px] w-[41px] items-center justify-center rounded-[4px] text-[12px] font-700 text-primary-500",
                children: t("lbl_new")
            })
        ]
    });
};
/* harmony default export */ var tab = (HeaderTab);

;// CONCATENATED MODULE: ./comps/header/index.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 70px;\n	background-color: #ecedef00;\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n						background-color: rgba(253, 253, 254, 1);\n				  "
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n						background-color: rgba(255, 255, 255, 0.8);\n				  "
    ]);
    header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n						background-color: rgba(28, 28, 28, 1);\n				  "
    ]);
    header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n						background-color: rgba(18, 18, 18, 0.7);\n				  "
    ]);
    header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: transparent !important;\n			  "
    ]);
    header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					backdrop-filter: blur(10px);\n					border-bottom: 1px solid var(--color-separator);\n			  "
    ]);
    header_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	.light && {\n		",
        ";\n	}\n\n	.dark && {\n		",
        ";\n	}\n\n	",
        "\n\n	width: var(--w-screen);\n	height: 70px;\n\n	display: flex;\n	align-items: center;\n	justify-content: center;\n\n	overflow: visible;\n\n	position: fixed;\n	top: ",
        "px;\n	left: 0;\n	z-index: 99;\n\n	transition: top 300ms;\n	transition-timing-function: ease-in-out;\n"
    ]);
    header_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		justify-content: flex-start;\n		align-items: center;\n		padding: 0 16px;\n	"
    ]);
    header_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		width: 1392px;\n		padding: 0 24px;\n	"
    ]);
    header_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function header_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 70px;\n\n	display: flex;\n\n	",
        "\n\n	",
        "\n"
    ]);
    header_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function header_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: none;\n\n	@media ",
        " {\n		flex: 1;\n		display: inline;\n	}\n"
    ]);
    header_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function header_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		display: none;\n	"
    ]);
    header_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function header_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	z-index: 99;\n	top: 0;\n	left: 0;\n	",
        "\n"
    ]);
    header_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	z-index: 49;\n	bottom: -24px;\n	left: 50%;\n	right: 50%;\n\n	height: 2px;\n	border-radius: 2px;\n	background-color: var(--color-primary-500);\n\n	transition: left 300ms ease-in-out,\n		right 300ms ease-in-out;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n\n	&&:hover ",
        " {\n		left: 12px;\n		right: 12px;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






















var HeaderPhony = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-0"
})(header_templateObject());
var HeaderBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-1"
})(header_templateObject7(), function(props) {
    return props.solid ? (0,styled_components_browser_esm/* css */.iv)(header_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(header_templateObject2());
}, function(props) {
    return props.solid ? (0,styled_components_browser_esm/* css */.iv)(header_templateObject3()) : (0,styled_components_browser_esm/* css */.iv)(header_templateObject4());
}, function(props) {
    return props.transparent ? (0,styled_components_browser_esm/* css */.iv)(header_templateObject5()) : (0,styled_components_browser_esm/* css */.iv)(header_templateObject6());
}, function(props) {
    return props.outside ? -90 : 0;
});
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-2"
})(header_templateObject10(), (0,breakpoints/* onTablet */.pX)((0,styled_components_browser_esm/* css */.iv)(header_templateObject8())), (0,breakpoints/* onDesktop */.X$)((0,styled_components_browser_esm/* css */.iv)(header_templateObject9())));
var Stretchable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-3"
})(header_templateObject11(), breakpoints/* devices.desktop */.Hb.desktop);
var MobileHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-4"
})(header_templateObject13(), (0,breakpoints/* onTablet */.pX)((0,styled_components_browser_esm/* css */.iv)(header_templateObject12())));
var TabUnderline = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-5"
})(_templateObject14());
var HeaderTabWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f1816f-6"
})(_templateObject15(), TabUnderline);
var videoGptContent = [
    {
        icon: (0,icons/* aiAdsGenratorIcon */.SB)(),
        name: "txt_ai_ads_generator",
        desc: "txt_ai_ads_generator_desc",
        href: "/tools/ai-ad-generator"
    },
    {
        icon: (0,icons/* productUrlToAdsIcon */.ce)(),
        name: "txt_product_url_to_ads",
        desc: "txt_product_url_to_ads_desc",
        href: "/tools/url-to-video-maker"
    },
    {
        icon: (0,icons/* videoGptIcon */.zl)(),
        name: "txt_video_gpt",
        desc: "txt_video_gpt_desc",
        href: "/tools/video-gpt"
    },
    {
        icon: (0,icons/* aiScriptGenerator */.zB)(),
        name: "txt_script_generator",
        desc: "txt_script_generator_desc",
        href: "/tools/ai-script-generator"
    },
    {
        icon: (0,icons/* scriptToAdsGenerator */.y$)(),
        name: "txt_script_to_ads_generator",
        desc: "txt_script_to_ads_generator_desc",
        href: "/tools/ai-script-to-video-generator"
    }, 
];
var aiStudioContent = [
    {
        groupName: "lbl_video",
        groupElements: [
            {
                href: "/tools/video-gpt",
                name: "txt_text_to_reel",
                icon: (0,icon/* textToReelIcon */.Ss)()
            },
            {
                href: "/tools/ai-video-transformation",
                name: "txt_deforum_ai",
                icon: (0,icon/* deforumIcon */.uv)()
            },
            {
                href: "/tools/ai-animation-generator",
                name: "txt_restyle_ai",
                icon: (0,icon/* restlyeIcon */.ZX)()
            },
            {
                href: "/tools/text-to-video",
                name: "txt_text_to_video",
                icon: (0,icon/* textToVideoIcon */.Cz)()
            },
            {
                href: "/tools/video-background-remover",
                name: "txt_video_bg_remover",
                icon: (0,icon/* videoBGRemoverIcon */.bv)()
            },
            {
                href: "/tools/royalty-free-music",
                name: "txt_ai_music_generator",
                icon: (0,icon/* musicGeneratorIcon */.rL)()
            }, 
        ]
    },
    {
        groupName: "lbl_image",
        groupElements: [
            {
                href: "/tools/ai-photoshoot-generator",
                name: "txt_ai_photoshoot",
                icon: (0,icon/* aiPhotoshootIcon */.Bw)()
            },
            {
                href: "/tools/ai-photo-editor",
                name: "txt_photo_ai",
                icon: (0,icon/* photoAiIcon */.x$)()
            },
            {
                href: "/tools/text-to-image",
                name: "txt_text_to_image",
                icon: (0,icon/* textToImageIcon */.f7)()
            },
            {
                href: "/tools/ai-image-replacer",
                name: "txt_generative_fill",
                icon: (0,icon/* generativeFillIcon */.hM)()
            },
            {
                href: "/tools/ai-portrait-generator",
                name: "txt_look_ai",
                icon: (0,icon/* lookAiIcon */.YH)()
            }, 
        ]
    }, 
];
var Header = function(props) {
    var isStatic = props.isStatic, isSolid = props.isSolid, isTransparent = props.isTransparent, hideHiring = props.hideHiring;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)(0), scroll = ref1[0], setScroll = ref1[1];
    var ref2 = (0,react.useState)(false), outside = ref2[0], setOutside = ref2[1];
    // const [showNew, setShowNew] = useState(false)
    var ref3 = (0,react.useState)(false), subscriptionPopupOpen = ref3[0], setSubscriptionPopupOpen = ref3[1];
    var userInfo = (0,client_auth/* useClientAuth */.K6)().userInfo;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var ref4 = (0,react.useState)(""), active = ref4[0], setActive = ref4[1];
    var startHiding = 200;
    var handleScroll = (0,react.useCallback)(function() {
        var current = window.scrollY;
        if (current < startHiding) {
            if (outside) setOutside(false);
            return;
        }
        if (scroll >= current) {
            setOutside(false);
        } else {
            setOutside(true);
        }
        setScroll(window.scrollY);
    }, [
        scroll,
        outside
    ]);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setActive(router.route);
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", handleScroll);
        return function() {
            return document.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    var t = (0,esm/* useTranslation */.$G)().t;
    // useEffect(() => {
    // 	if (typeof window !== "undefined" && userInfo) {
    // 		const visited =
    // 			localStorage.getItem(
    // 				`visited-video-gpt-${userInfo.userId}`,
    // 			) !== null
    // 		setShowNew(!visited)
    // 	}
    // }, [userInfo])
    // const handleClick = () => {
    // 	if (userInfo) {
    // 		localStorage.setItem(
    // 			`visited-video-gpt-${userInfo.userId}`,
    // 			"true",
    // 		)
    // 		setShowNew(false)
    // 	}
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(breakpoints/* DesktopOrTablet */.lS, {
                children: [
                    !isTransparent && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPhony, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBackground, {
                        outside: !isStatic && outside,
                        solid: isSolid,
                        transparent: isTransparent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Logo */.TR, {
                                    hideHiring: hideHiring
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hidden flex-row items-center gap-[18px] tablet:flex desktop:gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTabWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropDown */.vb, {
                                                hover: true,
                                                className: "group",
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-1 pl-2 font-500 text-blue-700 transition-colors duration-300 ease-in-out group-hover:text-primary-500"),
                                                    children: [
                                                        t("txt_text_to_reel"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,clsx_m/* default */.Z)("transition-all [--icon-color:var(--color-blue-700)]", "group-hover:-rotate-180 group-hover:[--icon-color:var(--color-primary-500)]"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "14",
                                                                height: "14",
                                                                viewBox: "0 0 16 16",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 6L8 10L4 6",
                                                                    stroke: "var(--icon-color)",
                                                                    strokeWidth: "1.33333",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute z-50 pt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("rounded-[10px] bg-color-popup-cell p-[10px]", "[box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]", "flex w-[395px] flex-col font-500"),
                                                        children: videoGptContent.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: item.href,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: (0,clsx_m/* default */.Z)("flex items-start gap-3 self-stretch rounded-[8px]", "px-[10px] py-[15px] transition-colors [--icon-color:var(--color-blue-600)]", "hover:bg-color-surface"),
                                                                    children: [
                                                                        item.icon,
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col items-start gap-[1px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("text-[16px] font-500 leading-[19px] text-blue-800"),
                                                                                    children: t(item.name)
                                                                                }),
                                                                                item.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("w-[239px] text-[13px] font-400 leading-[19px] text-blue-600"),
                                                                                    children: t(item.desc)
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTabWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropDown */.vb, {
                                                hover: true,
                                                className: "group",
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-1 pl-2 font-500 text-blue-700 transition-colors", "duration-300 ease-in-out group-hover:text-primary-500"),
                                                    children: [
                                                        t("lbl_ai_studio"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,clsx_m/* default */.Z)("transition-all [--icon-color:var(--color-blue-700)]", "group-hover:-rotate-180 group-hover:[--icon-color:var(--color-primary-500)]"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "14",
                                                                height: "14",
                                                                viewBox: "0 0 16 16",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 6L8 10L4 6",
                                                                    stroke: "var(--icon-color)",
                                                                    strokeWidth: "1.33333",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute z-50 pt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("rounded-[10px] bg-color-popup-cell px-[10px] pb-[10px] pt-4 text-blue-700", "[box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]", "flex flex-row gap-10"),
                                                        children: aiStudioContent.map(function(group) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex w-[235px] flex-col gap-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "px-[10px] text-[15px] font-500 text-blue-600",
                                                                        children: t(group.groupName)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex flex-col",
                                                                        children: [
                                                                            group.groupElements.map(function(item, index) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: item.href,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                        // onClick={() =>
                                                                                        // 	handleClick()
                                                                                        // }
                                                                                        className: (0,clsx_m/* default */.Z)("flex h-[36px] flex-row items-center", "gap-2 rounded-[8px] px-[10px] text-[16px]", "font-400 text-blue-700 transition-colors", "hover:bg-color-surface"),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "[--icon-color:var(--color-blue-700)]",
                                                                                                children: item.icon
                                                                                            }),
                                                                                            t(item.name)
                                                                                        ]
                                                                                    })
                                                                                }, index);
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex h-[33px] flex-row items-center rounded-[8px] px-[10px]",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/tools",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            className: "peer text-[14px] font-400 text-blue-600",
                                                                                            children: t("txt_all_tools")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (0,clsx_m/* default */.Z)("opacity-0 transition-all [--icon-color:var(--color-blue-600)]", "peer-hover:translate-x-2 peer-hover:opacity-100"),
                                                                                        children: (0,icon/* ArrowIcon */.e0)()
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, group.groupName);
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTabWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropDown */.vb, {
                                                hover: true,
                                                className: "group",
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-1 pl-2 font-500 text-blue-700 transition-colors duration-300 ease-in-out group-hover:text-primary-500"),
                                                    children: [
                                                        t("lbl_discover"),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "transition-all [--icon-color:var(--color-blue-700)] group-hover:-rotate-180 group-hover:[--icon-color:var(--color-primary-500)]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "14",
                                                                height: "14",
                                                                viewBox: "0 0 16 16",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 6L8 10L4 6",
                                                                    stroke: "var(--icon-color)",
                                                                    strokeWidth: "1.33333",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute z-50 w-[395px] pt-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)("rounded-[10px] bg-color-popup-cell px-[10px] py-[10px]", "[box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]", "flex flex-col", "font-500"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/ai-gallery",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: (0,clsx_m/* default */.Z)("flex flex-row items-start gap-3 self-stretch rounded-[8px] px-[10px] py-[15px] transition-colors [--icon-color:var(--color-blue-600)] hover:bg-color-surface"),
                                                                    children: [
                                                                        (0,icons/* galleryIcon */.Uq)(),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col items-start gap-[1px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("text-[16px] font-500 leading-[19px] text-blue-800"),
                                                                                    children: t("lbl_ai_gallery")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("w-[239px] text-[13px] font-400 leading-[19px] text-blue-600"),
                                                                                    children: t("txt_explore_ai_art_videos")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/video-templates",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: (0,clsx_m/* default */.Z)("flex flex-row items-start gap-3 self-stretch rounded-[8px] px-[10px] py-[15px] transition-colors [--icon-color:var(--color-blue-600)] hover:bg-color-surface"),
                                                                    children: [
                                                                        (0,icons/* templatesIcon */.wv)(),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col items-start gap-[1px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("text-[16px] font-500 leading-[19px] text-blue-800"),
                                                                                    children: t("lbl_templates")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("w-[245px] text-[13px] font-400 leading-[19px] text-blue-600"),
                                                                                    children: t("txt_discover_industry_leading_template")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/ad-examples",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: (0,clsx_m/* default */.Z)("flex flex-row items-start gap-3 self-stretch rounded-[8px] px-[10px] py-[15px] transition-colors [--icon-color:var(--color-blue-600)] hover:bg-color-surface"),
                                                                    children: [
                                                                        (0,icons/* aiAdsGenratorIcon */.SB)(),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col items-start gap-[1px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("text-[16px] font-500 leading-[19px] text-blue-800"),
                                                                                    children: t("lbl_ad_examples")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    className: (0,clsx_m/* default */.Z)("w-[245px] text-[13px] font-400 leading-[19px] text-blue-600"),
                                                                                    children: t("txt_ad_examples_description")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTabWrapper, {
                                            className: "hidden desktop:block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tab, {
                                                    link: branch/* appStoreConstant */.HY,
                                                    newTab: true,
                                                    name: "lbl_mobile_app"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabUnderline, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTabWrapper, {
                                            className: "hidden desktop:block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tab, {
                                                    link: "/pricing",
                                                    name: "lbl_pricing",
                                                    active: "/pricing" === active
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabUnderline, {})
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stretchable, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex min-w-[200px] justify-end gap-4",
                                    children: [
                                        (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isAnonymous) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_with_menu/* AvatarWithMenu */.e, {
                                            setSubscriptionPopupOpen: setSubscriptionPopupOpen
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/home",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: function() {
                                                    return logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_dashboard", {
                                                        from: router.asPath
                                                    });
                                                },
                                                className: (0,clsx_m/* default */.Z)("bg-primary-500 px-4 py-[6px] text-[16px] font-600 hover:bg-primary-600", "rounded-[6px] text-color-white", "animate-appear transition-colors"),
                                                children: t("lbl_dashboard")
                                            })
                                        }),
                                        userInfo !== null && userInfo.isAnonymous && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ThemeToggle */.Tl, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(breakpoints/* Mobile */.ij, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* Box */.xu, {
                        height: 48
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileHeader, {
                        className: "bg-[#ecedef] dark:bg-[#121212]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                                center: true,
                                justifyContent: "space-between",
                                width: "var(--w-screen)",
                                padding: "4px 14px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LogoSmallScaled */.wg, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            (userInfo === null || userInfo === void 0 ? void 0 : userInfo.isAnonymous) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_with_menu/* AvatarWithMenu */.e, {
                                                setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                                                onFocus: function() {
                                                    return setShow(false);
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/home",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_dashboard", {
                                                            from: router.asPath
                                                        });
                                                    },
                                                    className: (0,clsx_m/* default */.Z)("bg-primary-500 px-4 py-[6px] text-[16px] font-600 hover:bg-primary-600", "rounded-[6px] text-color-white", "animate-appear transition-colors"),
                                                    children: t("lbl_dashboard")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* HamburgerAnimated */.CI, {
                                                onClick: function() {
                                                    return setShow(!show);
                                                },
                                                show: show
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                                position: {
                                    top: 8,
                                    left: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                                    center: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
                        show: show,
                        hide: function() {
                            return setShow(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: router.asPath
            })
        ]
    });
};
function UpgradeButton(props) {
    var setSubscriptionPopupOpen = props.setSubscriptionPopupOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* useClientAuth */.K6)().userInfo;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var router = (0,next_router.useRouter)();
    var isFreeUser = userInfo !== null && !userInfo.isAnonymous && (0,subscription_popup/* getCurrentPackId */.V2)(userInfo.entitlements).packId === "free";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(isFreeUser ? "flex" : "hidden", "items-center"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_upgrade", {
                    from: router.asPath
                });
                setSubscriptionPopupOpen(true);
            },
            className: (0,clsx_m/* default */.Z)("flex h-8 w-[92px] items-center justify-center rounded-[8px]", "bg-green-100 text-[16px] font-600 text-green-800", "transition-colors duration-300 hover:bg-green-200", "tablet:h-9 tablet:w-[103px]"),
            children: t("txt_upgrade")
        })
    });
}
function formatCoins(coins) {
    if (coins < 100000) {
        return coins.toLocaleString();
    }
    if (coins < 1000000) {
        return Math.floor(coins / 1000) + "K";
    }
    return Math.floor(coins / 1000000) + "M";
}
function CoinsButton(props) {
    var className = props.className;
    var coins = useCoins();
    var openPopup = useCoinsPopup();
    var coinsFormatted = coins ? formatCoins(coins.coins) : coins;
    return /*#__PURE__*/ _jsxs("button", {
        onClick: function() {
            return openPopup();
        },
        className: clsx("group flex h-[34px] w-[135px] items-center gap-2 rounded-[10px] px-3", "border border-blue-100 bg-color-background", coins === null && "pointer-events-none hidden opacity-0", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-1 gap-1",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/general/coin.svg"),
                        alt: "coin icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "flex-1 text-left font-600 text-blue-800",
                        children: coinsFormatted
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-full w-[2px] bg-blue-200"
            }),
            /*#__PURE__*/ _jsx("img", {
                src: assetUrl("/general/green-plus.svg"),
                alt: "add coins",
                className: "aspect-square w-5 transition-all group-hover:brightness-95"
            })
        ]
    });
}
function New() {
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsx("div", {
        className: "ml-1 flex h-5 w-[37px] items-center justify-center rounded bg-primary-100 text-center text-[10px] font-700 text-primary-500",
        children: t("lbl_new")
    });
}
/* harmony default export */ var header = (Header);


/***/ }),

/***/ 6468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ preview; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/floating/index.tsx
var floating = __webpack_require__(501);
// EXTERNAL MODULE: ./comps/progressive.tsx
var progressive = __webpack_require__(4903);
// EXTERNAL MODULE: ./comps/skeleton.tsx
var skeleton = __webpack_require__(4165);
// EXTERNAL MODULE: ./comps/text/index.tsx
var comps_text = __webpack_require__(64);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/last-viewed.tsx
var last_viewed = __webpack_require__(8178);
// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./types/endpoints/tutorial.ts
var TemplateReviewStatus;
(function(TemplateReviewStatus) {
    TemplateReviewStatus[TemplateReviewStatus["None"] = 0] = "None";
    TemplateReviewStatus[TemplateReviewStatus["UnderReview"] = 1] = "UnderReview";
    TemplateReviewStatus[TemplateReviewStatus["PassedAutomatically"] = 2] = "PassedAutomatically";
    TemplateReviewStatus[TemplateReviewStatus["PassedManually"] = 3] = "PassedManually";
    TemplateReviewStatus[TemplateReviewStatus["DidNotPass"] = -1] = "DidNotPass";
})(TemplateReviewStatus || (TemplateReviewStatus = {}));

;// CONCATENATED MODULE: ./comps/home/templates/preview.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 14px;\n  height: 14px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 233px;\n    aspect-ratio: 275 / 342;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 275px;\n    aspect-ratio: 275 / 342;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(50vw - 24px);\n  aspect-ratio: 275 / 342;\n\n  ",
        "\n\n  ",
        "\n\n	border-radius: 12px;\n\n  overflow: hidden;\n  object-fit: cover;\n\n  & img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 233px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 275px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  align-items: stretch;\n\n  width: calc(50vw - 24px);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  top: 0;\n  left: 0;\n\n  border-radius: 0 0 12px 12px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 10px;\n    font-size: 16px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 30px;\n\n  margin: 8px 10px 0 0;\n  font-weight: 700;\n  font-size: 14px;\n\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  border-radius: 30px;\n  background-color: var(--color-skeleton);\n\n  margin: 12px 64px 0 0;\n  width: 100px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n\n  width: 100% !important;\n\n  height: auto;\n  aspect-ratio: 189 / 235;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(0, 0, 0, 0.3);\n  padding: 2px 6px;\n\n  display: flex;\n  align-items: center;\n  gap: 2px;\n\n  border-radius: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}















var PreviewInfoIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-65244609-0"
})(_templateObject());
var PreviewImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65244609-1"
})(_templateObject3(), (0,breakpoints/* onTablet */.pX)((0,styled_components_browser_esm/* css */.iv)(_templateObject1())), (0,breakpoints/* onDesktop */.X$)((0,styled_components_browser_esm/* css */.iv)(_templateObject2())));
var Container = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-65244609-2"
})(_templateObject6(), (0,breakpoints/* onTablet */.pX)((0,styled_components_browser_esm/* css */.iv)(_templateObject4())), (0,breakpoints/* onDesktop */.X$)((0,styled_components_browser_esm/* css */.iv)(_templateObject5())));
var GradientBottom = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-65244609-3"
})(_templateObject7());
var PreviewName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65244609-4"
})(_templateObject9(), (0,breakpoints/* onTablet */.pX)((0,styled_components_browser_esm/* css */.iv)(_templateObject8())));
var NameSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65244609-5"
})(_templateObject10());
var ImageSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.ZP).withConfig({
    componentId: "sc-65244609-6"
})(_templateObject11());
var CoinContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65244609-7"
})(_templateObject12());
var Loading = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: props.href,
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NameSkeleton, {})
        ]
    });
};
var Preview = function(props) {
    var _template = props.template, id = _template.id, name = _template.name, preview = _template.preview, views = _template.views, setups = _template.setups, price = _template.price, pricing = _template.pricing, isFeatured = _template.isFeatured, reviewStatus = _template.reviewStatus, privacy = _template.privacy;
    var className = props.className, hideFeatured = props.hideFeatured, setTemplateIndex = props.setTemplateIndex;
    var priceTag = (0,react.useMemo)(function() {
        return pricing === "coins" ? (0,millions/* default */.Z)(price !== null && price !== void 0 ? price : 0) : "";
    }, [
        price,
        pricing
    ]);
    var ref, ref1;
    var image = (ref1 = (ref = preview === null || preview === void 0 ? void 0 : preview.webp) !== null && ref !== void 0 ? ref : preview === null || preview === void 0 ? void 0 : preview.gif) !== null && ref1 !== void 0 ? ref1 : preview === null || preview === void 0 ? void 0 : preview.jpg;
    var ready = (0,progressive/* useProgressive */.k)(image);
    var url = "/template/" + id;
    var last = (0,react.useContext)(last_viewed/* LastViewedContext */.P) === id;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    if (!ready) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
        className: className,
        href: url
    });
    var underReview = reviewStatus == TemplateReviewStatus.UnderReview;
    var showForeground = last || underReview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: url,
        className: className,
        onClick: function() {
            return setTemplateIndex === null || setTemplateIndex === void 0 ? void 0 : setTemplateIndex(id);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(floating/* Relative */.I, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: image,
                            alt: name
                        })
                    }),
                    showForeground && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute inset-0 flex flex-col items-center justify-center gap-1", "rounded-[12px] bg-color-black/80 text-sm font-600 text-color-white"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "w-[20px]",
                                src: (0,cdn/* assetUrl */.p)(underReview ? "/player/warning.webp" : "/player/play-preview.webp"),
                                alt: "play icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "max-w-[100px] text-center",
                                children: underReview ? t("txt_under_review") : t("txt_last_viewed")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                        position: {
                            bottom: 0,
                            left: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientBottom, {
                            src: (0,cdn/* assetUrl */.p)("/icons/home/templates/gradient-single.webp"),
                            alt: "gradient image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-[6px] right-[10px]",
                        children: [
                            privacy === "private" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/private-icon.svg"),
                                alt: "private-icon",
                                className: "aspect-square w-[22px]"
                            }),
                            privacy === "friends" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/friends-icon.svg"),
                                alt: "friends-icon",
                                className: "aspect-square w-[22px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                        position: {
                            top: 6,
                            left: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                            center: true,
                            justifyContent: "flex-start",
                            gap: 2,
                            children: pricing === "coins" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoinContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* RawText */.l, {
                                        content: priceTag,
                                        weight: "700",
                                        size: "16",
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/comps/coin.svg"),
                                        alt: "coin icon",
                                        className: "h-[20px]"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                        position: {
                            top: 15,
                            left: 10
                        },
                        children: pricing === "pro" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/icons/prime-icon.svg"),
                            alt: "coin icon",
                            className: "h-[20px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                        position: {
                            bottom: 6,
                            left: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                isFeatured && !hideFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "self-start rounded-md bg-[linear-gradient(90deg,#4F6BFE_0%,#00A1FB_100%)] px-2 py-[2px] text-xs font-600 uppercase text-color-white",
                                    children: t("lbl_featured")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexItem */.B5, {
                                    box: true,
                                    alignContent: "flex-start",
                                    gap: 12,
                                    shrink: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                                            center: true,
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewInfoIcon, {
                                                    src: (0,cdn/* assetUrl */.p)("/player/play-preview.webp"),
                                                    alt: "play icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* RawText */.l, {
                                                    content: (0,millions/* default */.Z)(views),
                                                    size: "14",
                                                    weight: "600",
                                                    color: "white"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                                            center: true,
                                            gap: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewInfoIcon, {
                                                    src: (0,cdn/* assetUrl */.p)("/player/setup-preview.webp"),
                                                    alt: "setup icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* RawText */.l, {
                                                    content: (0,millions/* default */.Z)(setups),
                                                    size: "14",
                                                    weight: "600",
                                                    color: "white"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewName, {
                children: name
            })
        ]
    });
};
/* harmony default export */ var preview = (Preview);


/***/ }),

/***/ 9612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aK": function() { return /* binding */ CustomThemedResource; },
  "t3": function() { return /* binding */ ResponsiveImage; },
  "RJ": function() { return /* binding */ ThemedImage; },
  "ZP": function() { return /* binding */ comps_image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
;// CONCATENATED MODULE: ./utils/resize.ts


var resize = function(image) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
        width: image.width / 3,
        height: image.height / 3
    });
};
/* harmony default export */ var utils_resize = (resize);

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 10 modules
var tw_merge = __webpack_require__(7851);
;// CONCATENATED MODULE: ./comps/image.tsx







var StaticImage = function(props) {
    var src = props.src, width = props.width, height = props.height, isIcon = props.isIcon, theme = props.theme, className = props.className, alt = props.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-hide-on-theme": theme
    }, isIcon ? {
        src: src,
        width: width,
        height: height
    } : utils_resize({
        src: src,
        width: width,
        height: height
    })), {
        className: className,
        alt: "".concat(alt, " icon")
    }));
};
var ThemedImage = function(props) {
    var light = props.light, dark = props.dark, className = props.className, alt = props.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                "data-hide-on-theme": "dark",
                src: light,
                className: className,
                alt: "".concat(alt, " icon")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                "data-hide-on-theme": "light",
                src: dark,
                className: className,
                alt: "".concat(alt, " icon")
            })
        ]
    });
};
var CustomThemedResource = function(props) {
    var className = props.className, source = props.source, alt = props.alt, format = props.format;
    var extension = format !== null && format !== void 0 ? format : "webp";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                "data-hide-on-theme": "dark",
                src: (0,cdn/* assetUrl */.p)(source + "-light." + extension + "?aaa"),
                className: className,
                alt: "".concat(alt, " light icon")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                "data-hide-on-theme": "light",
                src: (0,cdn/* assetUrl */.p)(source + "-dark." + extension + "?aaa"),
                className: className,
                alt: "".concat(alt, " dark icon")
            })
        ]
    });
};
function ResponsiveImage(props) {
    var src = props.src, className = props.className, otherProps = (0,_object_without_properties/* default */.Z)(props, [
        "src",
        "className"
    ]);
    var alt = otherProps.alt;
    var mobile = "".concat(src, "-mobile.webp");
    var tablet = "".concat(src, "-tablet.webp");
    var desktop = "".concat(src, "-desktop.webp");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)(mobile),
                className: (0,tw_merge/* twMerge */.m)("tablet:hidden", className),
                alt: "".concat(alt, " image")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)(tablet),
                className: (0,tw_merge/* twMerge */.m)("hidden tablet:block desktop:hidden", className),
                alt: "".concat(alt, " image")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)(desktop),
                className: (0,tw_merge/* twMerge */.m)("hidden desktop:block", className),
                alt: "".concat(alt, " image")
            })
        ]
    });
}
/* harmony default export */ var comps_image = (StaticImage);


/***/ }),

/***/ 8014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fC": function() { return /* reexport */ blog_socials/* default */.ZP; },
  "$_": function() { return /* reexport */ footer/* default */.Z; },
  "h4": function() { return /* reexport */ header/* default */.ZP; },
  "h_": function() { return /* reexport */ meta/* default */.Z; },
  "JD": function() { return /* reexport */ SuccessCover; },
  "qJ": function() { return /* reexport */ SuccessLayout; },
  "EW": function() { return /* reexport */ SuccessQuote; },
  "vA": function() { return /* reexport */ BlogRate; },
  "$": function() { return /* reexport */ SuccessSupport; }
});

// UNUSED EXPORTS: Content, RawBubble

// EXTERNAL MODULE: ./comps/blog-socials.tsx
var blog_socials = __webpack_require__(8007);
// EXTERNAL MODULE: ./comps/bubble.tsx
var bubble = __webpack_require__(5232);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./comps/content.tsx

function Content(props) {
    return /*#__PURE__*/ _jsx("div", {
        className: "wrapped",
        children: props.children
    });
}

// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/primary-button.tsx
var primary_button = __webpack_require__(3363);
;// CONCATENATED MODULE: ./comps/success/cover.tsx








function UserCover(props) {
    var username = props.username, nickname = props.nickname, source = props.source, desktop = props.desktop;
    var balls = [
        {
            colors: "bg-[#C5C5FF] dark:bg-[#3B3B99]",
            left: -100,
            top: -130,
            size: 18
        },
        {
            colors: "bg-[#BCF5C5] dark:bg-[#509B5C]",
            left: 90,
            top: 30,
            size: 16
        },
        {
            colors: "bg-[#FFD4AC] dark:bg-[#996638]",
            left: -110,
            top: 20,
            size: 20
        }, 
    ];
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            router.push("/".concat(username));
        },
        className: (0,clsx_m/* default */.Z)(desktop && "hidden desktop:flex", "desktop:pointer-events-none", "relative flex flex-row bg-color-background px-5 py-4 tablet:flex-col", "overflow-hidden pr-0 tablet:pr-[unset]", "items-center gap-[40px] tablet:justify-center tablet:gap-5", "rounded-[12px] tablet:rounded-[22px] desktop:rounded-[18px]", "w-full tablet:h-[356px] tablet:w-[356px] desktop:h-[422px] desktop:w-[475px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 right-0 h-full w-5 bg-gradient-to-r from-[transparent] to-color-background"
            }),
            balls.map(function(param) {
                var colors = param.colors, left = param.left, top = param.top, size = param.size;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(colors, "hidden rounded-full tablet:block"),
                    style: {
                        position: "absolute",
                        left: "calc(50% + ".concat(left, "px)"),
                        top: "calc(50% + ".concat(top, "px)"),
                        width: size,
                        height: size
                    }
                }, colors);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "aspect-square w-[91px] rounded-full tablet:w-[139px] desktop:w-[162px]",
                src: (0,cdn/* assetUrl */.p)("/success/".concat(source, "-avatar.webp")),
                alt: "Profile picture of ".concat(nickname)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("desktop:text-h6 tablet:text-h5 text-[18px] flex flex-col gap-1 tablet:gap-2 tablet:text-center", "overflow-hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "break-words",
                        children: nickname
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (0,clsx_m/* default */.Z)("pointer-events-auto border-b-2 border-[transparent] transition-all hover:border-blue-700", "mr-4 font-700 text-blue-700"),
                        href: "/".concat(username),
                        children: [
                            "@",
                            username
                        ]
                    })
                ]
            })
        ]
    });
}
function SuccessCover(props) {
    var username = props.username, short = props.short, source = props.source, title = props.title, paragraphs = props.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-color-cell",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-h1 py-[50px] text-center",
                children: [
                    "Success Story of ",
                    short
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "wrapped",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("pb-[30px] tablet:pb-[36px] desktop:pb-[42px]", "flex flex-col desktop:flex-row desktop:items-stretch", "items-center gap-[15px] desktop:gap-[25px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex max-w-[620px] flex-col items-center gap-9 desktop:w-[475px] desktop:items-start desktop:self-stretch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col items-center gap-4 desktop:items-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "text-h5 tablet:text-h6 text-center desktop:text-left",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden max-h-[700px] w-full max-w-[500px] flex-1 overflow-hidden rounded-[18px] desktop:block desktop:max-h-[1000px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                        alt: "Templates of ".concat(short),
                                        className: "h-full w-full object-cover",
                                        source: "/success/".concat(source, "-cover")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col items-center gap-[15px] tablet:flex-row desktop:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCover, (0,_object_spread/* default */.Z)({}, props)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[356px] w-full overflow-hidden rounded-[18px] tablet:w-[356px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                        className: "h-full w-full object-cover",
                                        source: "/success/".concat(source, "-cover"),
                                        alt: "Templates of ".concat(short)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex max-w-[604px] flex-col gap-9 desktop:w-[475px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCover, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                    desktop: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-4 text-base font-500",
                                    children: paragraphs.map(function(paragraph, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: paragraph
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primary_button/* default */.Z, {
                                    href: "/".concat(username),
                                    children: "Check My Templates"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/mdx.tsx + 2 modules
var mdx = __webpack_require__(7961);
// EXTERNAL MODULE: ./node_modules/@mdx-js/react/lib/index.js
var lib = __webpack_require__(1151);
// EXTERNAL MODULE: ./comps/crisp.tsx + 1 modules
var crisp = __webpack_require__(9889);
;// CONCATENATED MODULE: ./comps/success/layout.tsx






function SuccessLayout(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* MDXProvider */.Zo, {
        components: mdx/* components */.wx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {}),
            props.children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* WrappedFooter */.M, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(crisp/* default */.Z, {
                page: "success"
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
;// CONCATENATED MODULE: ./comps/success/quote.tsx





function SuccessQuote(props) {
    var name = props.name, source = props.source, role = props.role, quote = props.quote;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-color-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "wrapped flex flex-col items-center py-6 desktop:pb-[83px] desktop:pt-7",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (0,clsx_m/* default */.Z)("relative z-10 box-content border-4 border-color-background tablet:border-8", "aspect-square mb-[-20px] w-[100px] rounded-full tablet:mb-[-60px] tablet:w-[126px]"),
                    src: (0,cdn/* assetUrl */.p)("/success/".concat(source, "-avatar.webp")),
                    alt: "Avatar of ".concat(name)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("mb-6 flex flex-col items-center gap-2", "rounded-[18px] bg-[#D2EFEB] pt-[20px] dark:bg-[#18443E] tablet:w-[604px] tablet:pt-[70px] desktop:w-full"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-h5",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-base tablet:text-[18px]",
                            children: role
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (0,clsx_m/* default */.Z)("mb-[70px] mt-8", "text-[18px] font-600 text-blue-700 tablet:text-[20px] desktop:text-[24px]", "relative max-w-[80%] text-center tablet:max-w-[479px] desktop:max-w-[822px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteIcon, {
                                    top: true
                                }),
                                quote,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteIcon, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primary_button/* default */.Z, {
                    href: branch/* appStoreConstant */.HY,
                    className: "w-full max-w-[500px] tablet:w-auto",
                    children: "Become a Creator"
                })
            ]
        })
    });
}
function QuoteIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (0,clsx_m/* default */.Z)("absolute desktop:scale-150", props.top ? "-right-6 top-0 tablet:-top-4 tablet:right-0 desktop:-top-6" : "-left-6 bottom-0 rotate-180 tablet:-bottom-4 tablet:left-0"),
        width: "23",
        height: "16",
        viewBox: "0 0 23 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.3164 0.199219H4.85744L0.950195 15.7992H9.61525L11.3164 0.199219ZM22.4002 0.199219H15.9413L12.034 15.7992H20.6991L22.4002 0.199219Z",
            className: (0,clsx_m/* default */.Z)("[fill:#afceca] dark:[fill:#9AD0C8]")
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./comps/success/rate.tsx






function BlogRate(props) {
    var used = props.used, shoots = props.shoots, engagement = props.engagement, coins = props.coins, followers = props.followers, revenue = props.revenue, title = props.title, advice = props.advice;
    var moneyValue = coins || revenue;
    var moneyText = coins ? "Earned Coins" : "Revenue Earned";
    var activityValue = engagement || shoots || used;
    var activityText = engagement ? "Engagement Rate" : shoots ? "Video Shoots" : "Templates Used";
    var benefits = [
        {
            label: activityText,
            value: activityValue,
            colors: "bg-[#C5C5FF] dark:bg-[#3B3B99]",
            left: -10,
            top: 110,
            size: 18
        },
        {
            label: "Followers Gained",
            value: followers,
            colors: "bg-[#BCF5C5] dark:bg-[#3B3B99]",
            left: -5,
            top: -15,
            size: 16
        },
        {
            label: moneyText,
            value: moneyValue,
            colors: "bg-[#FFD4AC] dark:bg-[#996638]",
            left: 50,
            top: 120,
            size: 20
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden py-[26px] tablet:py-[36px] desktop:py-[41px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute inset-0 h-full w-full scale-[3] object-cover",
                        src: (0,cdn/* assetUrl */.p)("/tools/other-products.webp"),
                        alt: "background image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapped flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* RawBubble */.UI, {
                                control: true,
                                text: "Success Metric",
                                color: "purple"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("my-[30px] tablet:mt-[41px] tablet:mb-[78px] desktop:mt-[38px] desktop:mb-[45px]", "flex w-full flex-col gap-[10px] tablet:flex-row tablet:gap-[12px] desktop:gap-[14px]"),
                                children: benefits.map(function(_param) /*#__PURE__*/ {
                                    var label = _param.label, value = _param.value, ball = (0,_object_without_properties/* default */.Z)(_param, [
                                        "label",
                                        "value"
                                    ]);
                                    return (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("relative flex flex-row items-center justify-between py-5 px-5", "tablet:flex-col-reverse tablet:justify-center tablet:gap-1", "tablet:h-[139px] tablet:w-[232px] desktop:h-[130px] desktop:w-[315px]", "rounded-[12px] bg-[#ffffffa0] dark:bg-[#1c1c1ca0] tablet:rounded-[18px] desktop:rounded-[22px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-base font-700 uppercase tablet:text-[18px] tablet:font-500 desktop:text-[20px]",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[28px] font-800 tablet:text-[26px] desktop:text-[36px]",
                                                children: value
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBall, (0,_object_spread/* default */.Z)({}, ball))
                                        ]
                                    }, label);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mt-3 flex w-full flex-col items-center gap-3 bg-color-background px-4 pt-5 pb-7 tablet:gap-4 desktop:gap-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* RawBubble */.UI, {
                        control: true,
                        className: "self-center",
                        text: "Goal",
                        color: "purple"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("relative bg-color-cell p-3 desktop:gap-2 desktop:p-8", "flex w-full flex-col items-center gap-3", "rounded-[12px] tablet:rounded-[18px] desktop:rounded-[22px]", "max-w-[725px] desktop:max-w-[975px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "text-h5 text-center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-[604px] text-center text-base desktop:text-[18px]",
                                children: advice
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function FloatingBall(props) {
    var size = props.size, left = props.left, top = props.top, colors = props.colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("absolute hidden rounded-full tablet:block", colors),
        style: {
            left: left + "%",
            top: top + "%",
            width: size + "px",
            height: size + "px"
        }
    });
}

// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
;// CONCATENATED MODULE: ./comps/success/support.tsx








function SuccessSupport(props) {
    var support = props.support, success = props.success, used = props.used, followers = props.followers, revenue = props.revenue, coins = props.coins, engagement = props.engagement, shoots = props.shoots;
    var moneyValue = coins || revenue || "";
    var moneyText = coins ? "earned coins through selling video templates" : "earned revenue through selling video templates.";
    var activityValue = engagement || shoots || used || "";
    var activityText = engagement ? "increase in engagement rates across all my social media platforms." : shoots ? "video shoots using my created templates" : "times used the created template";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("py-4 tablet:py-8 desktop:py-[50px]", "bg-color-cell"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "wrapped mx-auto flex flex-col items-center gap-4 desktop:items-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportCard, {
                    support: support
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "text-h4",
                    children: "Their Success"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tablet:w-[604px] desktop:w-[850px]",
                    children: success
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-4 tablet:w-[604px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPoint, {
                            value: activityValue,
                            text: activityText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPoint, {
                            value: followers,
                            text: "followers gained with high engagement rate"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPoint, {
                            value: moneyValue,
                            text: moneyText
                        })
                    ]
                })
            ]
        })
    });
}
function SupportCard(props) {
    var support = props.support;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("bg-[linear-gradient(309.95deg,#8EC5FC_-9.92%,rgba(252,195,222,0.67)_108.56%)]", "dark:bg-[linear-gradient(309.95deg,#1F4770_-9.92%,#652A46_108.56%)]", "relative flex flex-col gap-4 rounded-[18px]", "tablet:w-[481px] desktop:mb-[20px] desktop:w-[869px]", "mb-[170px] tablet:mb-0 tablet:mr-[123px] desktop:mr-[106px]", "p-[24px_16px_170px_16px] tablet:p-[42px_107px_42px_26px] desktop:p-[55px_200px_55px_34px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* RawBubble */.UI, {
                color: "pink",
                text: "Dedicated support",
                control: true,
                className: "gap-4 self-center tablet:self-start"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-h4 text-center tablet:text-left",
                children: "Received Support"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-base",
                children: support
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* RawButton */.wL, {
                text: "Get your guide",
                primary: true,
                onClick: function() {
                    $crisp.push([
                        "do",
                        "chat:toggle"
                    ]);
                    (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_crisp_support", {
                        page: "success_story",
                        uid: userInfo.userId
                    });
                },
                className: "absolute -bottom-[330px] left-1/2 w-full -translate-x-1/2 tablet:bottom-0 tablet:left-0 tablet:block tablet:w-[212px] tablet:translate-x-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                source: "/success/support-card",
                className: (0,clsx_m/* default */.Z)("absolute bottom-[50px] right-1/2 aspect-[486/365] max-h-[365px] tablet:bottom-1/2 tablet:right-0", "[transform:translate(70%,50%)]")
            })
        ]
    });
}
function SuccessPoint(props) {
    var value = props.value, text = props.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-start gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "mt-[3px] h-[22px] w-[22px]",
                src: (0,cdn/* assetUrl */.p)("/success/tick.webp"),
                alt: "Tick"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-[18px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-700",
                        children: value
                    }),
                    " ",
                    text
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./comps/index.tsx














/***/ }),

/***/ 5792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gx": function() { return /* binding */ Textarea; },
/* harmony export */   "ny": function() { return /* binding */ useValidator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  position: relative;\n  display: block;\n  width: 100%;\n\n  &&:before {\n    content: "";\n    height: 1px;\n    width: 0;\n    bottom: 0;\n    position: absolute;\n    background: var(--color-blue-900);\n    transition: width 300ms ease-in-out;\n    left: 0;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin: 12px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--color-placeholder);\n  font-size: 16px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 5px;\n  top: 10px;\n\n  letter-spacing: 0.07em;\n  transition: font-size 300ms, top 300ms, color 300ms;\n  transition-timing-function: ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -20px;\n  right: 4px;\n\n  font-size: 12px;\n  letter-spacing: 0.07em;\n\n  color: var(--color-error);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  color: var(--color-blue-900);\n  font-size: 18px;\n  padding: 10px 10px 10px 5px;\n  display: block;\n  width: 100%;\n  border: none;\n  border-radius: 0;\n  line-height: 1.2em;\n\n  &&:focus ~ ",
        ":before {\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid\n    ",
        ";\n\n  &&:focus {\n    outline: none;\n    color: var(--color-blue-900);\n  }\n\n  &&:focus ~ ",
        ', &&:not([value=""]) ~ ',
        " {\n    top: -10px;\n    font-size: 12px;\n    color: var(--color-blue-900);\n  }\n\n  :-webkit-autofill,\n  :-webkit-autofill:focus,\n  :autofill {\n    color: var(--color-blue-900) !important;\n    background-color: var(\n      --color-background-cell\n    ) !important;\n\n    background-clip: content-box !important;\n    -webkit-text-fill-color: var(--color-blue-900);\n    -webkit-box-shadow: 0 0 0 60px\n      var(--color-background-cell) inset !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n\n  border-bottom: 1px solid\n    ",
        ";\n\n  resize: none;\n\n  &&:focus {\n    outline: none;\n    color: var(--color-blue-900);\n  }\n\n  &&:focus ~ ",
        ", &&:not(:empty) ~ ",
        " {\n    top: -10px;\n    font-size: 12px;\n    color: var(--color-blue-900);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Line = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9fb5d297-0"
})(_templateObject());
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9fb5d297-1"
})(_templateObject1());
var Label = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-9fb5d297-2"
})(_templateObject2());
var Invalid = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9fb5d297-3"
})(_templateObject3());
var inputStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), Line);
// noinspection CssInvalidPseudoSelector
var MainInput = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-9fb5d297-4"
})(_templateObject5(), inputStyle, function(props) {
    return !props.errors ? "var(--color-separator)" : "var(--color-error)";
}, Label, Label);
var MainTextarea = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].textarea.withConfig */ .ZP.textarea.withConfig({
    componentId: "sc-9fb5d297-5"
})(_templateObject6(), inputStyle, function(props) {
    return !props.errors ? "var(--color-separator)" : "var(--color-error)";
}, Label, Label);
var useValidator = function(value, validators) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), errors = ref[0], setErrors = ref[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var validate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        if (validators) {
            var anyError = validators.find(function(validator) {
                var result = validator(value, t);
                if (result) {
                    setErrors(result);
                    return true;
                }
                return false;
            });
            if (!anyError) setErrors("");
        }
    }, [
        t,
        validators,
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (errors) {
            validate();
        }
    }, [
        value,
        errors,
        validate
    ]);
    return {
        validate: validate,
        errors: errors
    };
};
var Input = function(props) {
    var value = props.value, setValue = props.setValue, label = props.label, className = props.className, onChange = props.onChange, type = props.type, mode = props.mode, validate = props.validate, errors = props.errors, name = props.name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainInput, {
                onBlur: validate,
                onChange: function(e) {
                    setValue(e.target.value);
                    onChange && onChange(e);
                },
                name: name,
                inputMode: mode,
                type: type,
                value: value,
                errors: Boolean(errors)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Line, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Invalid, {
                children: errors !== null && errors !== void 0 ? errors : ""
            })
        ]
    });
};
var Textarea = function(props) {
    var label = props.label, className = props.className, value = props.value, setValue = props.setValue, rows = props.rows, validate = props.validate, errors = props.errors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainTextarea, {
                onBlur: validate,
                onChange: function(e) {
                    return setValue(e.target.value);
                },
                value: value,
                rows: rows,
                errors: Boolean(errors)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Line, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Invalid, {
                children: errors !== null && errors !== void 0 ? errors : ""
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Input);


/***/ }),

/***/ 9980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Loader */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0% {\n		transform: rotate(180deg);\n	}\n	50% {\n		transform: rotate(540deg);\n	}\n	100% {\n		transform: rotate(540deg);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0% {\n		height: 70px;\n	}\n\n	50% {\n		height: 70px;\n	}\n	\n	51% {\n		height: 0;\n	}\n\n	100% {\n		height: 70px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0% {\n		stop-opacity: 1;\n	}\n	\n	51% {\n		stop-opacity: 0;\n	}\n	\n	52% {\n		stop-opacity: 1;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	--color-fill: var(--color-blue-100);\n	\n	aspect-ratio: 1;\n	\n	animation-name: ",
        ";\n	animation-duration: 2000ms;\n	animation-direction: normal;\n	animation-iteration-count: infinite;\n	animation-timing-function: ease-in-out;\n	animation-fill-mode: forwards;\n\n	#clip-animated {\n		animation-name: ",
        ";\n		animation-duration: 2000ms;\n		animation-direction: normal;\n		animation-iteration-count: infinite;\n		animation-timing-function: ease-in-out;\n		animation-fill-mode: forwards;\n	}\n\n	#gradient-animated {\n		stop {\n			animation-name: ",
        ";\n			animation-duration: 2000ms;\n			animation-direction: normal;\n			animation-iteration-count: infinite;\n			animation-timing-function: ease-in-out;\n			animation-fill-mode: forwards;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var rotateAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var fillAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject1());
var disappearAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject2());
var StyledSvg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-73d38305-0"
})(_templateObject3(), rotateAnimation, fillAnimation, disappearAnimation);
var Loader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSvg, {
        width: "70",
        height: "70",
        viewBox: "0 0 70 70",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
                clipPath: "url(#clip0_4091_172398)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
                        clipPath: "url(#clip1_4091_172398)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M53.7645 20.3923C53.5484 25.0029 47.6114 28.9815 41.871 32.8336C40.7908 33.5514 39.4945 34.4255 38.1766 35.3768C36.4029 36.6622 34.5989 38.0656 33.2983 39.4218C31.0319 41.7785 28.8217 44.463 28.8217 49.0329C28.8217 53.7464 30.9822 57.0779 35.2492 61.9478C36.2451 63.0811 37.1677 64.0902 37.9779 64.9644C39.8834 67.034 41.6831 68.9922 41.3093 69.5428C41.3026 69.5556 41.2939 69.5672 41.2834 69.5771C41.1646 69.6178 40.067 69.8578 35.2686 67.0404C32.3066 65.3029 29.1609 63.1368 27.2748 61.8406L26.6267 61.4121L26.0109 60.9836C22.6168 58.6719 16.3288 54.0613 16.3288 49.6699C16.3288 45.2785 20.2705 42.3527 25.7819 38.5091C26.5208 37.9949 27.2943 37.4635 28.0656 36.9043L28.4977 36.5937C29.7529 35.6981 31.0902 34.7554 32.3865 33.7506C36.9387 30.2455 41.1862 25.9884 41.1862 20.4051C41.1862 14.0977 35.5387 8.23371 31.4186 3.9509C30.7705 3.2803 30.1612 2.64399 29.6146 2.05266C29.3073 1.73242 29.0383 1.37798 28.8131 0.99642C28.6338 0.694331 28.5668 0.409381 28.6986 0.218701C28.7374 0.191487 28.783 0.175201 28.8304 0.171566C28.9152 0.156544 29.0013 0.149371 29.0875 0.150141C31.8831 0.150141 40.7541 6.26477 43.7204 8.31512L43.8997 8.43939C48.7867 11.8095 53.9784 15.7881 53.7645 20.3923Z",
                            fill: "var(--color-fill)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
                        clipPath: "url(#clip2_4091_172398)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M53.7645 20.3923C53.5484 25.0029 47.6114 28.9815 41.871 32.8336C40.7908 33.5514 39.4945 34.4255 38.1766 35.3768C36.4029 36.6622 34.5989 38.0656 33.2983 39.4218C31.0319 41.7785 28.8217 44.463 28.8217 49.0329C28.8217 53.7464 30.9822 57.0779 35.2492 61.9478C36.2451 63.0811 37.1677 64.0902 37.9779 64.9644C39.8834 67.034 41.6831 68.9922 41.3093 69.5428C41.3026 69.5556 41.2939 69.5672 41.2834 69.5771C41.1646 69.6178 40.067 69.8578 35.2686 67.0404C32.3066 65.3029 29.1609 63.1368 27.2748 61.8406L26.6267 61.4121L26.0109 60.9836C22.6168 58.6719 16.3288 54.0613 16.3288 49.6699C16.3288 45.2785 20.2705 42.3527 25.7819 38.5091C26.5208 37.9949 27.2943 37.4635 28.0656 36.9043L28.4977 36.5937C29.7529 35.6981 31.0902 34.7554 32.3865 33.7506C36.9387 30.2455 41.1862 25.9884 41.1862 20.4051C41.1862 14.0977 35.5387 8.23371 31.4186 3.9509C30.7705 3.2803 30.1612 2.64399 29.6146 2.05266C29.3073 1.73242 29.0383 1.37798 28.8131 0.99642C28.6338 0.694331 28.5668 0.409381 28.6986 0.218701C28.7374 0.191487 28.783 0.175201 28.8304 0.171566C28.9152 0.156544 29.0013 0.149371 29.0875 0.150141C31.8831 0.150141 40.7541 6.26477 43.7204 8.31512L43.8997 8.43939C48.7867 11.8095 53.9784 15.7881 53.7645 20.3923Z",
                            fill: "url(#gradient-animated)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M35.062 1.00806C37.7768 1.91369 41.3755 3.56922 46.4868 6.30373C46.7768 6.45887 47.0462 6.59429 47.2958 6.71088C47.7608 6.96439 48.1963 7.20561 48.5987 7.43253C52.2545 9.48395 58.9442 13.8074 58.5598 18.7025C58.2705 22.3578 55.289 25.1448 50.5427 28.2733C53.0281 25.9521 55.0898 23.495 55.2215 20.6684C55.57 15.1412 49.8835 10.7474 44.5521 7.07064L44.3707 6.94644C41.1 4.69223 37.8601 2.57587 35.062 1.00806Z",
                        fill: "#FF3166"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M19.4573 41.2601C14.7111 44.3886 11.7295 47.1756 11.4402 50.8309C11.0558 55.726 17.7455 60.0495 21.4013 62.1009C24.2646 63.7155 28.8036 66.0538 33.7096 68.3965C34.9269 68.9887 36.1905 69.4284 37.478 69.8499C34.213 68.2996 29.948 65.5635 25.6293 62.587L25.4479 62.4628C20.1165 58.7861 14.43 54.3922 14.7785 48.865C14.9102 46.0384 16.9719 43.5813 19.4573 41.2601Z",
                        fill: "#FF3166"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("linearGradient", {
                        id: "gradient-animated",
                        x1: "35.0499",
                        y1: "0.150085",
                        x2: "35.0499",
                        y2: "69.5996",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", {
                                stopColor: "#F81579"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#06D3FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                        id: "clip0_4091_172398",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                            width: "70",
                            height: "70",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                        id: "clip1_4091_172398",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                            width: "37.442",
                            height: "69.4495",
                            fill: "white",
                            transform: "translate(16.3289 0.150085)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                        id: "clip2_4091_172398",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                            id: "clip-animated",
                            width: "38",
                            height: "70",
                            fill: "white",
                            transform: "translate(16 -6.10352e-05)"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ markdown_Markdown; }
});

// NAMESPACE OBJECT: ./node_modules/property-information/lib/util/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "boolean": function() { return types_boolean; },
  "booleanish": function() { return booleanish; },
  "commaOrSpaceSeparated": function() { return commaOrSpaceSeparated; },
  "commaSeparated": function() { return commaSeparated; },
  "number": function() { return number; },
  "overloadedBoolean": function() { return overloadedBoolean; },
  "spaceSeparated": function() { return spaceSeparated; }
});

// NAMESPACE OBJECT: ./node_modules/micromark/lib/constructs.js
var constructs_namespaceObject = {};
__webpack_require__.r(constructs_namespaceObject);
__webpack_require__.d(constructs_namespaceObject, {
  "attentionMarkers": function() { return attentionMarkers; },
  "contentInitial": function() { return contentInitial; },
  "disable": function() { return disable; },
  "document": function() { return constructs_document; },
  "flow": function() { return constructs_flow; },
  "flowInitial": function() { return flowInitial; },
  "insideSpan": function() { return insideSpan; },
  "string": function() { return constructs_string; },
  "text": function() { return constructs_text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/devlop/lib/default.js
function deprecate(fn) {
  return fn
}

function equal() {}

function ok() {}

function unreachable() {}

;// CONCATENATED MODULE: ./node_modules/comma-separated-tokens/index.js
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function parse(value) {
  /** @type {Array<string>} */
  const tokens = []
  const input = String(value || '')
  let index = input.indexOf(',')
  let start = 0
  /** @type {boolean} */
  let end = false

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    const token = input.slice(start, index).trim()

    if (token || !end) {
      tokens.push(token)
    }

    start = index + 1
    index = input.indexOf(',', start)
  }

  return tokens
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function stringify(values, options) {
  const settings = options || {}

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

;// CONCATENATED MODULE: ./node_modules/hast-util-to-jsx-runtime/node_modules/estree-util-is-identifier-name/lib/index.js
/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */

const startRe = /[$_\p{ID_Start}]/u
const contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u
const contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u
const nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u

/** @type {Options} */
const emptyOptions = {}

/**
 * Checks if the given code point can start an identifier.
 *
 * @param {number | undefined} code
 *   Code point to check.
 * @returns {boolean}
 *   Whether `code` can start an identifier.
 */
// Note: `undefined` is supported so you can pass the result from `''.codePointAt`.
function start(code) {
  return code ? startRe.test(String.fromCodePoint(code)) : false
}

/**
 * Checks if the given code point can continue an identifier.
 *
 * @param {number | undefined} code
 *   Code point to check.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {boolean}
 *   Whether `code` can continue an identifier.
 */
// Note: `undefined` is supported so you can pass the result from `''.codePointAt`.
function cont(code, options) {
  const settings = options || emptyOptions
  const re = settings.jsx ? contReJsx : contRe
  return code ? re.test(String.fromCodePoint(code)) : false
}

/**
 * Checks if the given value is a valid identifier name.
 *
 * @param {string} name
 *   Identifier to check.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {boolean}
 *   Whether `name` can be an identifier.
 */
function lib_name(name, options) {
  const settings = options || emptyOptions
  const re = settings.jsx ? nameReJsx : nameRe
  return re.test(name)
}

;// CONCATENATED MODULE: ./node_modules/hast-util-whitespace/lib/index.js
/**
 * @typedef {import('hast').Nodes} Nodes
 */

// HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const re = /[ \t\n\f\r]/g

/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {Nodes | string} thing
 *   Thing to check (`Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`); if a node is passed it must be a `Text` node,
 *   whose `value` field is checked.
 */
function whitespace(thing) {
  return typeof thing === 'object'
    ? thing.type === 'text'
      ? empty(thing.value)
      : false
    : empty(thing)
}

/**
 * @param {string} value
 * @returns {boolean}
 */
function empty(value) {
  return value.replace(re, '') === ''
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {}
/** @type {Normal} */
Schema.prototype.normal = {}
/** @type {string|null} */
Schema.prototype.space = null

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new Schema(property, normal, space)
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/info.js
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
Info.prototype.space = null
Info.prototype.boolean = false
Info.prototype.booleanish = false
Info.prototype.overloadedBoolean = false
Info.prototype.number = false
Info.prototype.commaSeparated = false
Info.prototype.spaceSeparated = false
Info.prototype.commaOrSpaceSeparated = false
Info.prototype.mustUseProperty = false
Info.prototype.defined = false

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/types.js
let powers = 0

const types_boolean = increment()
const booleanish = increment()
const overloadedBoolean = increment()
const number = increment()
const spaceSeparated = increment()
const commaSeparated = increment()
const commaOrSpaceSeparated = increment()

function increment() {
  return 2 ** ++powers
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types_namespaceObject)

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index]
        mark(this, checks[index], (mask & types_namespaceObject[check]) === types_namespaceObject[check])
      }
    }
  }
}

DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[normalize(prop)] = prop
      normal[normalize(info.attribute)] = prop
    }
  }

  return new Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/xlink.js


const xlink = create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ./node_modules/property-information/lib/xml.js


const xml = create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/xmlns.js



const xmlns = create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ./node_modules/property-information/lib/aria.js



const aria = create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ./node_modules/property-information/lib/html.js




const html = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: types_boolean,
    allowPaymentRequest: types_boolean,
    allowUserMedia: types_boolean,
    alt: null,
    as: null,
    async: types_boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: types_boolean,
    autoPlay: types_boolean,
    blocking: spaceSeparated,
    capture: types_boolean,
    charSet: null,
    checked: types_boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: types_boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: types_boolean,
    defer: types_boolean,
    dir: null,
    dirName: null,
    disabled: types_boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: types_boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: types_boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: types_boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: types_boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: types_boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: types_boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: types_boolean,
    muted: types_boolean,
    name: null,
    nonce: null,
    noModule: types_boolean,
    noValidate: types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: types_boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: types_boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: types_boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: types_boolean,
    reversed: types_boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: types_boolean,
    seamless: types_boolean,
    selected: types_boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: types_boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: types_boolean, // `<frame>`
    noHref: types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: types_boolean,
    disableRemotePlayback: types_boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ./node_modules/property-information/lib/svg.js




const svg = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ./node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const property_information_html = merge([xml, xlink, xmlns, aria, html], 'html')
const property_information_svg = merge([xml, xlink, xmlns, aria, svg], 'svg')

;// CONCATENATED MODULE: ./node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const valid = /^data[-\w.:]+$/i
const dash = /-[a-z]/g
const cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize(value)
  let prop = value
  let Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ./node_modules/property-information/lib/hast-to-react.js
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
}

;// CONCATENATED MODULE: ./node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function space_separated_tokens_stringify(values) {
  return values.join(' ').trim()
}

// EXTERNAL MODULE: ./node_modules/style-to-object/cjs/index.js
var cjs = __webpack_require__(5174);
;// CONCATENATED MODULE: ./node_modules/style-to-object/esm/index.mjs


// ensure compatibility with rollup umd build
/* harmony default export */ var esm = (cjs["default"] || cjs);

;// CONCATENATED MODULE: ./node_modules/hast-util-to-jsx-runtime/node_modules/unist-util-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointEnd = point('end')

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointStart = point('start')

/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */
function point(type) {
  return point

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    if (
      typeof point.line === 'number' &&
      point.line > 0 &&
      typeof point.column === 'number' &&
      point.column > 0
    ) {
      return {
        line: point.line,
        column: point.column,
        offset:
          typeof point.offset === 'number' && point.offset > -1
            ? point.offset
            : undefined
      }
    }
  }
}

/**
 * Get the positional info of `node`.
 *
 * @param {Node | NodeLike | null | undefined} [node]
 *   Node.
 * @returns {Position | undefined}
 *   Position.
 */
function position(node) {
  const start = pointStart(node)
  const end = pointEnd(node)

  if (start && end) {
    return {start, end}
  }
}

;// CONCATENATED MODULE: ./node_modules/hast-util-to-jsx-runtime/node_modules/unist-util-stringify-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return lib_position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return lib_position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return lib_point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function lib_point(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function lib_position(pos) {
  return lib_point(pos && pos.start) + '-' + lib_point(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ./node_modules/hast-util-to-jsx-runtime/node_modules/vfile-message/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */



/**
 * Message.
 */
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super()

    if (typeof optionsOrParentOrPlace === 'string') {
      origin = optionsOrParentOrPlace
      optionsOrParentOrPlace = undefined
    }

    /** @type {string} */
    let reason = ''
    /** @type {Options} */
    let options = {}
    let legacyCause = false

    if (optionsOrParentOrPlace) {
      // Point.
      if (
        'line' in optionsOrParentOrPlace &&
        'column' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace}
      }
      // Position.
      else if (
        'start' in optionsOrParentOrPlace &&
        'end' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace}
      }
      // Node.
      else if ('type' in optionsOrParentOrPlace) {
        options = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        }
      }
      // Options.
      else {
        options = {...optionsOrParentOrPlace}
      }
    }

    if (typeof causeOrReason === 'string') {
      reason = causeOrReason
    }
    // Error.
    else if (!options.cause && causeOrReason) {
      legacyCause = true
      reason = causeOrReason.message
      options.cause = causeOrReason
    }

    if (!options.ruleId && !options.source && typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        options.ruleId = origin
      } else {
        options.source = origin.slice(0, index)
        options.ruleId = origin.slice(index + 1)
      }
    }

    if (!options.place && options.ancestors && options.ancestors) {
      const parent = options.ancestors[options.ancestors.length - 1]

      if (parent) {
        options.place = parent.position
      }
    }

    const start =
      options.place && 'start' in options.place
        ? options.place.start
        : options.place

    /* eslint-disable no-unused-expressions */
    /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */
    this.ancestors = options.ancestors || undefined

    /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */
    this.cause = options.cause || undefined

    /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */
    this.column = start ? start.column : undefined

    /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */
    this.fatal = undefined

    /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */
    this.file

    // Field from `Error`.
    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.message = reason

    /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */
    this.line = start ? start.line : undefined

    // Field from `Error`.
    /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */
    this.name = stringifyPosition(options.place) || '1:1'

    /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */
    this.place = options.place || undefined

    /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */
    this.reason = this.message

    /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */
    this.ruleId = options.ruleId || undefined

    /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */
    this.source = options.source || undefined

    // Field from `Error`.
    /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */
    this.stack =
      legacyCause && options.cause && typeof options.cause.stack === 'string'
        ? options.cause.stack
        : ''

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */
    this.actual

    /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */
    this.expected

    /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */
    this.note

    /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */
    this.url
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = ''
VFileMessage.prototype.name = ''
VFileMessage.prototype.reason = ''
VFileMessage.prototype.message = ''
VFileMessage.prototype.stack = ''
VFileMessage.prototype.column = undefined
VFileMessage.prototype.line = undefined
VFileMessage.prototype.ancestors = undefined
VFileMessage.prototype.cause = undefined
VFileMessage.prototype.fatal = undefined
VFileMessage.prototype.place = undefined
VFileMessage.prototype.ruleId = undefined
VFileMessage.prototype.source = undefined

;// CONCATENATED MODULE: ./node_modules/hast-util-to-jsx-runtime/lib/index.js
// Register MDX nodes in mdast:
/// <reference types="mdast-util-mdx-expression" />
/// <reference types="mdast-util-mdx-jsx" />
/// <reference types="mdast-util-mdxjs-esm" />

/**
 * @typedef {import('estree').Identifier} Identifier
 * @typedef {import('estree').Literal} Literal
 * @typedef {import('estree').MemberExpression} MemberExpression
 * @typedef {import('estree').Expression} Expression
 * @typedef {import('estree').Program} Program
 *
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('mdast-util-mdx-expression').MdxFlowExpressionHast} MdxFlowExpression
 * @typedef {import('mdast-util-mdx-expression').MdxTextExpressionHast} MdxTextExpression
 *
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxFlowElementHast} MdxJsxFlowElement
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxTextElementHast} MdxJsxTextElement
 *
 * @typedef {import('mdast-util-mdxjs-esm').MdxjsEsmHast} MdxjsEsm
 *
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {import('unist').Position} Position
 *
 * @typedef {import('./components.js').Components} Components
 */

/**
 * @typedef {JSX.Element | string | null | undefined} Child
 *   Child.
 *
 * @callback Create
 *   Create something in development or production.
 * @param {Nodes} node
 *   hast node.
 * @param {unknown} type
 *   Fragment symbol or tag name.
 * @param {Props} props
 *   Properties and children.
 * @param {string | undefined} key
 *   Key.
 * @returns {JSX.Element}
 *   Result.
 *
 * @callback CreateEvaluater
 *   Create an evaluator that turns ESTree ASTs from embedded MDX into values.
 * @returns {Evaluater}
 *   Evaluater.
 *
 * @typedef {'html' | 'react'} ElementAttributeNameCase
 *   Casing to use for attribute names.
 *
 *   HTML casing is for example `class`, `stroke-linecap`, `xml:lang`.
 *   React casing is for example `className`, `strokeLinecap`, `xmlLang`.
 *
 * @callback EvaluateExpression
 *   Turn an MDX expression into a value.
 * @param {Expression} expression
 *   ESTree expression.
 * @returns {unknown}
 *   Result of expression.
 *
 * @callback EvaluateProgram
 *   Turn an MDX program (export/import statements) into a value.
 * @param {Program} expression
 *   ESTree program.
 * @returns {unknown}
 *   Result of program;
 *   should likely be `undefined` as ESM changes the scope but doesn’t yield
 *   something.
 *
 * @typedef Evaluater
 *   Evaluator that turns ESTree ASTs from embedded MDX into values.
 * @property {EvaluateExpression} evaluateExpression
 *   Evaluate an expression.
 * @property {EvaluateProgram} evaluateProgram
 *   Evaluate a program.
 *
 * @typedef {[string, Value]} Field
 *   Property field.
 *
 * @typedef {unknown} Fragment
 *   Represent the children, typically a symbol.
 *
 * @callback Jsx
 *   Create a production element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} [key]
 *   Dynamicly generated key to use.
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @callback JsxDev
 *   Create a development element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} key
 *   Dynamicly generated key to use.
 * @param {boolean} isStaticChildren
 *   Whether two or more children are passed (in an array), which is whether
 *   `jsxs` or `jsx` would be used.
 * @param {Source} source
 *   Info about source.
 * @param {undefined} self
 *   Nothing (this is used by frameworks that have components, we don’t).
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @typedef {{children?: Array<Child> | Child, node?: Element | MdxJsxFlowElement | MdxJsxTextElement | undefined, [prop: string]: Array<Child> | Child | Element | MdxJsxFlowElement | MdxJsxTextElement | Value | undefined}} Props
 *   Properties and children.
 *
 * @typedef RegularFields
 *   Configuration.
 * @property {Partial<Components> | null | undefined} [components]
 *   Components to use (optional).
 * @property {CreateEvaluater | null | undefined} [createEvaluater]
 *   Create an evaluator that turns ESTree ASTs into values (optional).
 * @property {ElementAttributeNameCase | null | undefined} [elementAttributeNameCase='react']
 *   Specify casing to use for attribute names (default: `'react'`).
 * @property {string | null | undefined} [filePath]
 *   File path to the original source file (optional).
 *
 *   Passed in source info to `jsxDEV` when using the automatic runtime with
 *   `development: true`.
 * @property {boolean | null | undefined} [ignoreInvalidStyle=false]
 *   Ignore invalid CSS in `style` props (default: `false`);
 *   the default behavior is to throw an error.
 * @property {boolean | null | undefined} [passKeys=true]
 *   Generate keys to optimize frameworks that support them (default: `true`).
 *
 *   > 👉 **Note**: Solid currently fails if keys are passed.
 * @property {boolean | null | undefined} [passNode=false]
 *   Pass the hast element node to components (default: `false`).
 * @property {Space | null | undefined} [space='html']
 *   Whether `tree` is in the `'html'` or `'svg'` space (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {StylePropertyNameCase | null | undefined} [stylePropertyNameCase='dom']
 *   Specify casing to use for property names in `style` objects (default:
 *   `'dom'`).
 * @property {boolean | null | undefined} [tableCellAlignToStyle=true]
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props
 *   (default: `true`).
 *
 * @typedef RuntimeDevelopment
 *   Runtime fields when development is on.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {true} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev} jsxDEV
 *   Development JSX.
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef RuntimeProduction
 *   Runtime fields when development is off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {false | null | undefined} [development]
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off) (optional).
 * @property {Jsx} jsx
 *   Dynamic JSX.
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx} jsxs
 *   Static JSX.
 *
 * @typedef RuntimeUnknown
 *   Runtime fields when development might be on or off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {boolean} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef Source
 *   Info about source.
 * @property {number | undefined} columnNumber
 *   Column where thing starts (0-indexed).
 * @property {string | undefined} fileName
 *   Name of source file.
 * @property {number | undefined} lineNumber
 *   Line where thing starts (1-indexed).
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use `xast` if you need to support SVG as XML.
 *
 * @typedef State
 *   Info passed around.
 * @property {unknown} Fragment
 *   Fragment symbol.
 * @property {Array<Parents>} ancestors
 *   Stack of parents.
 * @property {Partial<Components>} components
 *   Components to swap.
 * @property {Create} create
 *   Create something in development or production.
 * @property {ElementAttributeNameCase} elementAttributeNameCase
 *   Casing to use for attribute names.
 * @property {Evaluater | undefined} evaluater
 *   Evaluator that turns ESTree ASTs into values.
 * @property {string | undefined} filePath
 *   File path.
 * @property {boolean} ignoreInvalidStyle
 *   Ignore invalid CSS in `style` props.
 * @property {boolean} passKeys
 *   Generate keys to optimize frameworks that support them.
 * @property {boolean} passNode
 *   Pass `node` to components.
 * @property {Schema} schema
 *   Current schema.
 * @property {StylePropertyNameCase} stylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 * @property {boolean} tableCellAlignToStyle
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props.
 *
 * @typedef {Record<string, string>} Style
 *   Style map.
 *
 * @typedef {'css' | 'dom'} StylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 *
 *   CSS casing is for example `background-color` and `-webkit-line-clamp`.
 *   DOM casing is for example `backgroundColor` and `WebkitLineClamp`.
 *
 * @typedef {Style | boolean | number | string} Value
 *   Primitive property value and `Style` map.
 */

/**
 * @typedef {RuntimeDevelopment & RegularFields} Development
 *   Configuration (development).
 * @typedef {Development | Production | Unknown} Options
 *   Configuration.
 * @typedef {RegularFields & RuntimeProduction} Production
 *   Configuration (production).
 * @typedef {RegularFields & RuntimeUnknown} Unknown
 *   Configuration (production or development).
 */











const lib_own = {}.hasOwnProperty

/** @type {Map<string, number>} */
const emptyMap = new Map()

const lib_cap = /[A-Z]/g
const dashSomething = /-([a-z])/g

// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.

// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const tableElements = new Set(['table', 'tbody', 'thead', 'tfoot', 'tr'])

const tableCellElement = new Set(['td', 'th'])

const docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime'

/**
 * Transform a hast tree to preact, react, solid, svelte, vue, etc.,
 * with an automatic JSX runtime.
 *
 * @param {Nodes} tree
 *   Tree to transform.
 * @param {Options} options
 *   Configuration (required).
 * @returns {JSX.Element}
 *   JSX element.
 */

function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === undefined) {
    throw new TypeError('Expected `Fragment` in options')
  }

  const filePath = options.filePath || undefined
  /** @type {Create} */
  let create

  if (options.development) {
    if (typeof options.jsxDEV !== 'function') {
      throw new TypeError(
        'Expected `jsxDEV` in options when `development: true`'
      )
    }

    create = developmentCreate(filePath, options.jsxDEV)
  } else {
    if (typeof options.jsx !== 'function') {
      throw new TypeError('Expected `jsx` in production options')
    }

    if (typeof options.jsxs !== 'function') {
      throw new TypeError('Expected `jsxs` in production options')
    }

    create = productionCreate(filePath, options.jsx, options.jsxs)
  }

  /** @type {State} */
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create,
    elementAttributeNameCase: options.elementAttributeNameCase || 'react',
    evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || false,
    passKeys: options.passKeys !== false,
    passNode: options.passNode || false,
    schema: options.space === 'svg' ? property_information_svg : property_information_html,
    stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
    tableCellAlignToStyle: options.tableCellAlignToStyle !== false
  }

  const result = one(state, tree, undefined)

  // JSX element.
  if (result && typeof result !== 'string') {
    return result
  }

  // Text node or something that turned into nothing.
  return state.create(
    tree,
    state.Fragment,
    {children: result || undefined},
    undefined
  )
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function one(state, node, key) {
  if (node.type === 'element') {
    return lib_element(state, node, key)
  }

  if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') {
    return mdxExpression(state, node)
  }

  if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') {
    return mdxJsxElement(state, node, key)
  }

  if (node.type === 'mdxjsEsm') {
    return mdxEsm(state, node)
  }

  if (node.type === 'root') {
    return root(state, node, key)
  }

  if (node.type === 'text') {
    return lib_text(state, node)
  }
}

/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function lib_element(state, node, key) {
  const parentSchema = state.schema
  let schema = parentSchema

  if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
    schema = property_information_svg
    state.schema = schema
  }

  state.ancestors.push(node)

  const type = findComponentFromName(state, node.tagName, false)
  const props = createElementProps(state, node)
  let children = createChildren(state, node)

  if (tableElements.has(node.tagName)) {
    children = children.filter(function (child) {
      return typeof child === 'string' ? !whitespace(child) : true
    })
  }

  addNode(state, props, type, node)
  addChildren(props, children)

  // Restore.
  state.ancestors.pop()
  state.schema = parentSchema

  return state.create(node, type, props, key)
}

/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpression | MdxTextExpression} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxExpression(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    const program = node.data.estree
    const expression = program.body[0]
    ok(expression.type === 'ExpressionStatement')

    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateExpression(expression.expression)
    )
  }

  crashEstree(state, node.position)
}

/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsm} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxEsm(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateProgram(node.data.estree)
    )
  }

  crashEstree(state, node.position)
}

/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxJsxElement(state, node, key) {
  const parentSchema = state.schema
  let schema = parentSchema

  if (node.name === 'svg' && parentSchema.space === 'html') {
    schema = property_information_svg
    state.schema = schema
  }

  state.ancestors.push(node)

  const type =
    node.name === null
      ? state.Fragment
      : findComponentFromName(state, node.name, true)
  const props = createJsxElementProps(state, node)
  const children = createChildren(state, node)

  addNode(state, props, type, node)
  addChildren(props, children)

  // Restore.
  state.ancestors.pop()
  state.schema = parentSchema

  return state.create(node, type, props, key)
}

/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function root(state, node, key) {
  /** @type {Props} */
  const props = {}

  addChildren(props, createChildren(state, node))

  return state.create(node, state.Fragment, props, key)
}

/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function lib_text(_, node) {
  return node.value
}

/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElement | MdxJsxTextElement} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */
function addNode(state, props, type, node) {
  // If this is swapped out for a component:
  if (typeof type !== 'string' && type !== state.Fragment && state.passNode) {
    props.node = node
  }
}

/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0]

    if (value) {
      props.children = value
    }
  }
}

/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */
function productionCreate(_, jsx, jsxs) {
  return create
  /** @type {Create} */
  function create(_, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children)
    const fn = isStaticChildren ? jsxs : jsx
    return key ? fn(type, props, key) : fn(type, props)
  }
}

/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */
function developmentCreate(filePath, jsxDEV) {
  return create
  /** @type {Create} */
  function create(node, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children)
    const point = pointStart(node)
    return jsxDEV(
      type,
      props,
      key,
      isStaticChildren,
      {
        columnNumber: point ? point.column - 1 : undefined,
        fileName: filePath,
        lineNumber: point ? point.line : undefined
      },
      undefined
    )
  }
}

/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */
function createElementProps(state, node) {
  /** @type {Props} */
  const props = {}
  /** @type {string | undefined} */
  let alignValue
  /** @type {string} */
  let prop

  for (prop in node.properties) {
    if (prop !== 'children' && lib_own.call(node.properties, prop)) {
      const result = createProperty(state, prop, node.properties[prop])

      if (result) {
        const [key, value] = result

        if (
          state.tableCellAlignToStyle &&
          key === 'align' &&
          typeof value === 'string' &&
          tableCellElement.has(node.tagName)
        ) {
          alignValue = value
        } else {
          props[key] = value
        }
      }
    }
  }

  if (alignValue) {
    // Assume style is an object.
    const style = /** @type {Style} */ (props.style || (props.style = {}))
    style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] =
      alignValue
  }

  return props
}

/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */
function createJsxElementProps(state, node) {
  /** @type {Props} */
  const props = {}

  for (const attribute of node.attributes) {
    if (attribute.type === 'mdxJsxExpressionAttribute') {
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const program = attribute.data.estree
        const expression = program.body[0]
        ok(expression.type === 'ExpressionStatement')
        const objectExpression = expression.expression
        ok(objectExpression.type === 'ObjectExpression')
        const property = objectExpression.properties[0]
        ok(property.type === 'SpreadElement')

        Object.assign(
          props,
          state.evaluater.evaluateExpression(property.argument)
        )
      } else {
        crashEstree(state, node.position)
      }
    } else {
      // For JSX, the author is responsible of passing in the correct values.
      const name = attribute.name
      /** @type {unknown} */
      let value

      if (attribute.value && typeof attribute.value === 'object') {
        if (
          attribute.value.data &&
          attribute.value.data.estree &&
          state.evaluater
        ) {
          const program = attribute.value.data.estree
          const expression = program.body[0]
          ok(expression.type === 'ExpressionStatement')
          value = state.evaluater.evaluateExpression(expression.expression)
        } else {
          crashEstree(state, node.position)
        }
      } else {
        value = attribute.value === null ? true : attribute.value
      }

      // Assume a prop.
      props[name] = /** @type {Props[keyof Props]} */ (value)
    }
  }

  return props
}

/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */
function createChildren(state, node) {
  /** @type {Array<Child>} */
  const children = []
  let index = -1
  /** @type {Map<string, number>} */
  // Note: test this when Solid doesn’t want to merge my upcoming PR.
  /* c8 ignore next */
  const countsByName = state.passKeys ? new Map() : emptyMap

  while (++index < node.children.length) {
    const child = node.children[index]
    /** @type {string | undefined} */
    let key

    if (state.passKeys) {
      const name =
        child.type === 'element'
          ? child.tagName
          : child.type === 'mdxJsxFlowElement' ||
              child.type === 'mdxJsxTextElement'
            ? child.name
            : undefined

      if (name) {
        const count = countsByName.get(name) || 0
        key = name + '-' + count
        countsByName.set(name, count + 1)
      }
    }

    const result = one(state, child, key)
    if (result !== undefined) children.push(result)
  }

  return children
}

/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */
function createProperty(state, prop, value) {
  const info = find(state.schema, prop)

  // Ignore nullish and `NaN` values.
  if (
    value === null ||
    value === undefined ||
    (typeof value === 'number' && Number.isNaN(value))
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? stringify(value) : space_separated_tokens_stringify(value)
  }

  // React only accepts `style` as object.
  if (info.property === 'style') {
    let styleObject =
      typeof value === 'object' ? value : parseStyle(state, String(value))

    if (state.stylePropertyNameCase === 'css') {
      styleObject = transformStylesToCssCasing(styleObject)
    }

    return ['style', styleObject]
  }

  return [
    state.elementAttributeNameCase === 'react' && info.space
      ? hastToReact[info.property] || info.property
      : info.attribute,
    value
  ]
}

/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */
function parseStyle(state, value) {
  /** @type {Style} */
  const result = {}

  try {
    // @ts-expect-error: `style-to-object` types are broken.
    esm(value, replacer)
  } catch (error) {
    if (!state.ignoreInvalidStyle) {
      const cause = /** @type {Error} */ (error)
      const message = new VFileMessage('Cannot parse `style` attribute', {
        ancestors: state.ancestors,
        cause,
        ruleId: 'style',
        source: 'hast-util-to-jsx-runtime'
      })
      message.file = state.filePath || undefined
      message.url = docs + '#cannot-parse-style-attribute'

      throw message
    }
  }

  return result

  /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */
  function replacer(name, value) {
    let key = name

    if (key.slice(0, 2) !== '--') {
      if (key.slice(0, 4) === '-ms-') key = 'ms-' + key.slice(4)
      key = key.replace(dashSomething, toCamel)
    }

    result[key] = value
  }
}

/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */
function findComponentFromName(state, name, allowExpression) {
  /** @type {Identifier | Literal | MemberExpression} */
  let result

  if (!allowExpression) {
    result = {type: 'Literal', value: name}
  } else if (name.includes('.')) {
    const identifiers = name.split('.')
    let index = -1
    /** @type {Identifier | Literal | MemberExpression | undefined} */
    let node

    while (++index < identifiers.length) {
      /** @type {Identifier | Literal} */
      const prop = lib_name(identifiers[index])
        ? {type: 'Identifier', name: identifiers[index]}
        : {type: 'Literal', value: identifiers[index]}
      node = node
        ? {
            type: 'MemberExpression',
            object: node,
            property: prop,
            computed: Boolean(index && prop.type === 'Literal'),
            optional: false
          }
        : prop
    }

    ok(node, 'always a result')
    result = node
  } else {
    result =
      lib_name(name) && !/^[a-z]/.test(name)
        ? {type: 'Identifier', name}
        : {type: 'Literal', value: name}
  }

  // Only literals can be passed in `components` currently.
  // No identifiers / member expressions.
  if (result.type === 'Literal') {
    const name = /** @type {keyof JSX.IntrinsicElements} */ (result.value)

    return lib_own.call(state.components, name) ? state.components[name] : name
  }

  // Assume component.
  if (state.evaluater) {
    return state.evaluater.evaluateExpression(result)
  }

  crashEstree(state)
}

/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */
function crashEstree(state, place) {
  const message = new VFileMessage(
    'Cannot handle MDX estrees without `createEvaluater`',
    {
      ancestors: state.ancestors,
      place,
      ruleId: 'mdx-estree',
      source: 'hast-util-to-jsx-runtime'
    }
  )
  message.file = state.filePath || undefined
  message.url = docs + '#cannot-handle-mdx-estrees-without-createevaluater'

  throw message
}

/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */
function transformStylesToCssCasing(domCasing) {
  /** @type {Style} */
  const cssCasing = {}
  /** @type {string} */
  let from

  for (from in domCasing) {
    if (lib_own.call(domCasing, from)) {
      cssCasing[transformStyleToCssCasing(from)] = domCasing[from]
    }
  }

  return cssCasing
}

/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */
function transformStyleToCssCasing(from) {
  let to = from.replace(lib_cap, toDash)
  // Handle `ms-xxx` -> `-ms-xxx`.
  if (to.slice(0, 3) === 'ms-') to = '-' + to
  return to
}

/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */
function toCamel(_, $1) {
  return $1.toUpperCase()
}

/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */
function toDash($0) {
  return '-' + $0.toLowerCase()
}

;// CONCATENATED MODULE: ./node_modules/html-url-attributes/lib/index.js
/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */
const urlAttributes = {
  action: ['form'],
  cite: ['blockquote', 'del', 'ins', 'q'],
  data: ['object'],
  formAction: ['button', 'input'],
  href: ['a', 'area', 'base', 'link'],
  icon: ['menuitem'],
  itemId: null,
  manifest: ['html'],
  ping: ['a', 'area'],
  poster: ['video'],
  src: [
    'audio',
    'embed',
    'iframe',
    'img',
    'input',
    'script',
    'source',
    'track',
    'video'
  ]
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-from-markdown/node_modules/mdast-util-to-string/lib/index.js
/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */

/** @type {Options} */
const lib_emptyOptions = {}

/**
 * Get the text content of a node or list of nodes.
 *
 * Prefers the node’s plain-text fields, otherwise serializes its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} [value]
 *   Thing to serialize, typically `Node`.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {string}
 *   Serialized `value`.
 */
function lib_toString(value, options) {
  const settings = options || lib_emptyOptions
  const includeImageAlt =
    typeof settings.includeImageAlt === 'boolean'
      ? settings.includeImageAlt
      : true
  const includeHtml =
    typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true

  return lib_one(value, includeImageAlt, includeHtml)
}

/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */
function lib_one(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ('value' in value) {
      return value.type === 'html' && !includeHtml ? '' : value.value
    }

    if (includeImageAlt && 'alt' in value && value.alt) {
      return value.alt
    }

    if ('children' in value) {
      return lib_all(value.children, includeImageAlt, includeHtml)
    }
  }

  if (Array.isArray(value)) {
    return lib_all(value, includeImageAlt, includeHtml)
  }

  return ''
}

/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */
function lib_all(values, includeImageAlt, includeHtml) {
  /** @type {Array<string>} */
  const result = []
  let index = -1

  while (++index < values.length) {
    result[index] = lib_one(values[index], includeImageAlt, includeHtml)
  }

  return result.join('')
}

/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */
function node(value) {
  return Boolean(value && typeof value === 'object')
}

;// CONCATENATED MODULE: ./node_modules/micromark-util-chunked/index.js
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */
function splice(list, start, remove, items) {
  const end = list.length
  let chunkStart = 0
  /** @type {Array<unknown>} */
  let parameters

  // Make start between zero and `end` (included).
  if (start < 0) {
    start = -start > end ? 0 : end + start
  } else {
    start = start > end ? end : start
  }
  remove = remove > 0 ? remove : 0

  // No need to chunk the items if there’s only a couple (10k) items.
  if (items.length < 10000) {
    parameters = Array.from(items)
    parameters.unshift(start, remove)
    // @ts-expect-error Hush, it’s fine.
    list.splice(...parameters)
  } else {
    // Delete `remove` items starting from `start`
    if (remove) list.splice(start, remove)

    // Insert the items in chunks to not cause stack overflows.
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000)
      parameters.unshift(start, 0)
      // @ts-expect-error Hush, it’s fine.
      list.splice(...parameters)
      chunkStart += 10000
      start += 10000
    }
  }
}

/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {Array<T>} items
 *   Items to add to `list`.
 * @returns {Array<T>}
 *   Either `list` or `items`.
 */
function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items)
    return list
  }
  return items
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-util-subtokenize/index.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */


/**
 * Tokenize subcontent.
 *
 * @param {Array<Event>} events
 *   List of events.
 * @returns {boolean}
 *   Whether subtokens were found.
 */ // eslint-disable-next-line complexity
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {}
  let index = -1
  /** @type {Event} */
  let event
  /** @type {number | undefined} */
  let lineIndex
  /** @type {number} */
  let otherIndex
  /** @type {Event} */
  let otherEvent
  /** @type {Array<Event>} */
  let parameters
  /** @type {Array<Event>} */
  let subevents
  /** @type {boolean | undefined} */
  let more
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index]
    }
    event = events[index]

    // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.
    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events
      otherIndex = 0
      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2
      }
      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }
          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true
            otherIndex++
          }
        }
      }
    }

    // Enter.
    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index))
        index = jumps[index]
        more = true
      }
    }
    // Exit.
    else if (event[1]._container) {
      otherIndex = index
      lineIndex = undefined
      while (otherIndex--) {
        otherEvent = events[otherIndex]
        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank'
            }
            otherEvent[1].type = 'lineEnding'
            lineIndex = otherIndex
          }
        } else {
          break
        }
      }
      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start)

        // Switch container exit w/ line endings.
        parameters = events.slice(lineIndex, index)
        parameters.unshift(event)
        splice(events, lineIndex, index - lineIndex + 1, parameters)
      }
    }
  }
  return !more
}

/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */
function subcontent(events, eventIndex) {
  const token = events[eventIndex][1]
  const context = events[eventIndex][2]
  let startPosition = eventIndex - 1
  /** @type {Array<number>} */
  const startPositions = []
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start)
  const childEvents = tokenizer.events
  /** @type {Array<[number, number]>} */
  const jumps = []
  /** @type {Record<string, number>} */
  const gaps = {}
  /** @type {Array<Chunk>} */
  let stream
  /** @type {Token | undefined} */
  let previous
  let index = -1
  /** @type {Token | undefined} */
  let current = token
  let adjust = 0
  let start = 0
  const breaks = [start]

  // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.
  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }
    startPositions.push(startPosition)
    if (!current._tokenizer) {
      stream = context.sliceStream(current)
      if (!current.next) {
        stream.push(null)
      }
      if (previous) {
        tokenizer.defineSkip(current.start)
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true
      }
      tokenizer.write(stream)
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined
      }
    }

    // Unravel the next token.
    previous = current
    current = current.next
  }

  // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.
  current = token
  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1
      breaks.push(start)
      // Help GC.
      current._tokenizer = undefined
      current.previous = undefined
      current = current.next
    }
  }

  // Help GC.
  tokenizer.events = []

  // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.
  if (current) {
    // Help GC.
    current._tokenizer = undefined
    current.previous = undefined
  } else {
    breaks.pop()
  }

  // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.
  index = breaks.length
  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1])
    const start = startPositions.pop()
    jumps.unshift([start, start + slice.length - 1])
    splice(events, start, 2, slice)
  }
  index = -1
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1]
    adjust += jumps[index][1] - jumps[index][0] - 1
  }
  return gaps
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/postprocess.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */



/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */
function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }
  return events
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */



const micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine multiple syntax extensions into one.
 *
 * @param {Array<Extension>} extensions
 *   List of syntax extensions.
 * @returns {NormalizedExtension}
 *   A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */
function syntaxExtension(all, extension) {
  /** @type {keyof Extension} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    /** @type {Record<string, unknown>} */
    const left = maybe || (all[hook] = {})
    /** @type {Record<string, unknown> | undefined} */
    const right = extension[hook]
    /** @type {string} */
    let code

    if (right) {
      for (code in right) {
        if (!micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
        const value = right[code]
        constructs(
          // @ts-expect-error Looks like a list.
          left[code],
          Array.isArray(value) ? value : value ? [value] : []
        )
      }
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */
function constructs(existing, list) {
  let index = -1
  /** @type {Array<unknown>} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine multiple HTML extensions into one.
 *
 * @param {Array<HtmlExtension>} htmlExtensions
 *   List of HTML extensions.
 * @returns {HtmlExtension}
 *   A single combined HTML extension.
 */
function micromark_util_combine_extensions_combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */
function htmlExtension(all, extension) {
  /** @type {keyof HtmlExtension} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {keyof Handles} */
    let type

    if (right) {
      for (type in right) {
        // @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-util-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlpha = regexCheck(/[A-Za-z]/);

/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);

/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);

/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  );
}

/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiDigit = regexCheck(/\d/);

/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);

/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);

/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEnding(code) {
  return code !== null && code < -2;
}

/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32);
}

/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32;
}

// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodePunctuation = regexCheck(/\p{P}|\p{S}/u);

/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodeWhitespace = regexCheck(/\s/);

/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */
function regexCheck(regex) {
  return check;

  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */
  function check(code) {
    return code !== null && code > -1 && regex.test(String.fromCharCode(code));
  }
}
;// CONCATENATED MODULE: ./node_modules/micromark-factory-space/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */



// To do: implement `spaceOrTab`, `spaceOrTabMinMax`, `spaceOrTabWithOptions`.

/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   spaces in markdown are often optional, in which case this factory can be
 *     used and `ok` will be switched to whether spaces were found or not
 * *   one line ending or space can be detected with `markdownSpace(code)` right
 *     before using `factorySpace`
 *
 * ###### Examples
 *
 * Where `␉` represents a tab (plus how much it expands) and `␠` represents a
 * single space.
 *
 * ```markdown
 * ␉
 * ␠␠␠␠
 * ␉␠
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {TokenType} type
 *   Type (`' \t'`).
 * @param {number | undefined} [max=Infinity]
 *   Max (exclusive).
 * @returns {State}
 *   Start state.
 */
function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY
  let size = 0
  return start

  /** @type {State} */
  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type)
      return prefix(code)
    }
    return ok(code)
  }

  /** @type {State} */
  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code)
      return prefix
    }
    effects.exit(type)
    return ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/initialize/content.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */



/** @type {InitialConstruct} */
const content = {
  tokenize: initializeContent
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  )
  /** @type {Token} */
  let previous
  return contentStart

  /** @type {State} */
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, contentStart, 'linePrefix')
  }

  /** @type {State} */
  function paragraphInitial(code) {
    effects.enter('paragraph')
    return lineStart(code)
  }

  /** @type {State} */
  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })
    if (previous) {
      previous.next = token
    }
    previous = token
    return data(code)
  }

  /** @type {State} */
  function data(code) {
    if (code === null) {
      effects.exit('chunkText')
      effects.exit('paragraph')
      effects.consume(code)
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    }

    // Data.
    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/initialize/document.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * @typedef {[Construct, ContainerState]} StackItem
 */




/** @type {InitialConstruct} */
const document_document = {
  tokenize: initializeDocument
}

/** @type {Construct} */
const containerConstruct = {
  tokenize: tokenizeContainer
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeDocument(effects) {
  const self = this
  /** @type {Array<StackItem>} */
  const stack = []
  let continued = 0
  /** @type {TokenizeContext | undefined} */
  let childFlow
  /** @type {Token | undefined} */
  let childToken
  /** @type {number} */
  let lineStartOffset
  return start

  /** @type {State} */
  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued]
      self.containerState = item[1]
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    }

    // Done.
    return checkNewContainers(code)
  }

  /** @type {State} */
  function documentContinue(code) {
    continued++

    // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.
    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined
      if (childFlow) {
        closeFlow()
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.
      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {Point | undefined} */
      let point

      // Find the flow chunk.
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end
          break
        }
      }
      exitContainers(continued)

      // Fix positions.
      let index = indexBeforeExits
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      )

      // Discard the duplicate exits.
      self.events.length = index
      return checkNewContainers(code)
    }
    return start(code)
  }

  /** @type {State} */
  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      }

      // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      }

      // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.
      // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
      // needed in micromark-extension-gfm-table@1.0.6).
      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      )
    }

    // Check if there is a new container.
    self.containerState = {}
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }

  /** @type {State} */
  function thereIsANewContainer(code) {
    if (childFlow) closeFlow()
    exitContainers(continued)
    return documentContinued(code)
  }

  /** @type {State} */
  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length
    lineStartOffset = self.now().offset
    return flowStart(code)
  }

  /** @type {State} */
  function documentContinued(code) {
    // Try new containers.
    self.containerState = {}
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }

  /** @type {State} */
  function containerContinue(code) {
    continued++
    stack.push([self.currentConstruct, self.containerState])
    // Try another.
    return documentContinued(code)
  }

  /** @type {State} */
  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow()
      exitContainers(0)
      effects.consume(code)
      return
    }
    childFlow = childFlow || self.parser.flow(self.now())
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    })
    return flowContinue(code)
  }

  /** @type {State} */
  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true)
      exitContainers(0)
      effects.consume(code)
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code)
      writeToChild(effects.exit('chunkFlow'))
      // Get ready for the next line.
      continued = 0
      self.interrupt = undefined
      return start
    }
    effects.consume(code)
    return flowContinue
  }

  /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */
  function writeToChild(token, eof) {
    const stream = self.sliceStream(token)
    if (eof) stream.push(null)
    token.previous = childToken
    if (childToken) childToken.next = token
    childToken = token
    childFlow.defineSkip(token.start)
    childFlow.write(stream)

    // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.
    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length
      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset &&
          // …and either is not ended yet…
          (!childFlow.events[index][1].end ||
            // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.
      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {boolean | undefined} */
      let seen
      /** @type {Point | undefined} */
      let point

      // Find the previous chunk (the one before the lazy line).
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end
            break
          }
          seen = true
        }
      }
      exitContainers(continued)

      // Fix positions.
      index = indexBeforeExits
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      )

      // Discard the duplicate exits.
      self.events.length = index
    }
  }

  /**
   * @param {number} size
   * @returns {undefined}
   */
  function exitContainers(size) {
    let index = stack.length

    // Exit open containers.
    while (index-- > size) {
      const entry = stack[index]
      self.containerState = entry[1]
      entry[0].exit.call(self, effects)
    }
    stack.length = size
  }
  function closeFlow() {
    childFlow.write([null])
    childToken = undefined
    childFlow = undefined
    self.containerState._closeFlow = undefined
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContainer(effects, ok, nok) {
  // Always populated by defaults.

  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLine(effects, ok, nok) {
  return start

  /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    return markdownSpace(code)
      ? factorySpace(effects, after, 'linePrefix')(code)
      : after(code)
  }

  /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/content.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content_content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}

/** @type {Construct} */
const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}

/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */
function resolveContent(events) {
  subtokenize(events)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContent(effects, ok) {
  /** @type {Token | undefined} */
  let previous
  return chunkStart

  /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */
  function chunkStart(code) {
    effects.enter('content')
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    })
    return chunkInside(code)
  }

  /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */
  function chunkInside(code) {
    if (code === null) {
      return contentEnd(code)
    }

    // To do: in `markdown-rs`, each line is parsed on its own, and everything
    // is stitched together resolving.
    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    }

    // Data.
    effects.consume(code)
    return chunkInside
  }

  /**
   *
   *
   * @type {State}
   */
  function contentEnd(code) {
    effects.exit('chunkContent')
    effects.exit('content')
    return ok(code)
  }

  /**
   *
   *
   * @type {State}
   */
  function contentContinue(code) {
    effects.consume(code)
    effects.exit('chunkContent')
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    })
    previous = previous.next
    return chunkInside
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContinuation(effects, ok, nok) {
  const self = this
  return startLookahead

  /**
   *
   *
   * @type {State}
   */
  function startLookahead(code) {
    effects.exit('chunkContent')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, prefixed, 'linePrefix')
  }

  /**
   *
   *
   * @type {State}
   */
  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    // Always populated by defaults.

    const tail = self.events[self.events.length - 1]
    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }
    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/initialize/flow.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */




/** @type {InitialConstruct} */
const flow = {
  tokenize: initializeFlow
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeFlow(effects) {
  const self = this
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content_content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  )
  return initial

  /** @type {State} */
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    self.currentConstruct = undefined
    return initial
  }

  /** @type {State} */
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    self.currentConstruct = undefined
    return initial
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/initialize/text.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

const resolver = {
  resolveAll: createResolver()
}
const string = initializeFactory('string')
const text_text = initializeFactory('text')

/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }

  /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */
  function initializeText(effects) {
    const self = this
    const constructs = this.parser.constructs[field]
    const text = effects.attempt(constructs, start, notText)
    return start

    /** @type {State} */
    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }

    /** @type {State} */
    function notText(code) {
      if (code === null) {
        effects.consume(code)
        return
      }
      effects.enter('data')
      effects.consume(code)
      return data
    }

    /** @type {State} */
    function data(code) {
      if (atBreak(code)) {
        effects.exit('data')
        return text(code)
      }

      // Data.
      effects.consume(code)
      return data
    }

    /**
     * @param {Code} code
     * @returns {boolean}
     */
    function atBreak(code) {
      if (code === null) {
        return true
      }
      const list = constructs[code]
      let index = -1
      if (list) {
        // Always populated by defaults.

        while (++index < list.length) {
          const item = list[index]
          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }
      return false
    }
  }
}

/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */
function createResolver(extraResolver) {
  return resolveAllText

  /** @type {Resolver} */
  function resolveAllText(events, context) {
    let index = -1
    /** @type {number | undefined} */
    let enter

    // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.
    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index
          index++
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end
          events.splice(enter + 2, index - enter - 2)
          index = enter + 2
        }
        enter = undefined
      }
    }
    return extraResolver ? extraResolver(events, context) : events
  }
}

/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0 // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1]
      const chunks = context.sliceStream(data)
      let index = chunks.length
      let bufferIndex = -1
      let size = 0
      /** @type {boolean | undefined} */
      let tabs
      while (index--) {
        const chunk = chunks[index]
        if (typeof chunk === 'string') {
          bufferIndex = chunk.length
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++
            bufferIndex--
          }
          if (bufferIndex) break
          bufferIndex = -1
        }
        // Number
        else if (chunk === -2) {
          tabs = true
          size++
        } else if (chunk === -1) {
          // Empty
        } else {
          // Replacement character, exit.
          index++
          break
        }
      }
      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        }
        data.end = Object.assign({}, token.start)
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token)
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          )
          eventIndex += 2
        }
      }
      eventIndex++
    }
  }
  return events
}

;// CONCATENATED MODULE: ./node_modules/micromark-util-resolve-all/index.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */
function resolveAll(constructs, events, context) {
  /** @type {Array<Resolver>} */
  const called = []
  let index = -1

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/create-tokenizer.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * @callback Restore
 * @returns {undefined}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {undefined}
 */




/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_bufferIndex' | '_index'> | undefined} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  )
  /** @type {Record<string, number>} */
  const columnStart = {}
  /** @type {Array<Construct>} */
  const resolveAllConstructs = []
  /** @type {Array<Chunk>} */
  let chunks = []
  /** @type {Array<Token>} */
  let stack = []
  /** @type {boolean | undefined} */
  let consumed = true

  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */
  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  }

  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */
  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  }

  /**
   * The state function.
   *
   * @type {State | undefined}
   */
  let state = initialize.tokenize.call(context, effects)

  /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */
  let expectedCode
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize)
  }
  return context

  /** @type {TokenizeContext['write']} */
  function write(slice) {
    chunks = push(chunks, slice)
    main()

    // Exit if we’re not done, resolve might change stuff.
    if (chunks[chunks.length - 1] !== null) {
      return []
    }
    addResult(initialize, 0)

    // Otherwise, resolve, and exit.
    context.events = resolveAll(resolveAllConstructs, context.events, context)
    return context.events
  }

  //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }

  /** @type {TokenizeContext['sliceStream']} */
  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }

  /** @type {TokenizeContext['now']} */
  function now() {
    // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
    const {line, column, offset, _index, _bufferIndex} = point
    return {
      line,
      column,
      offset,
      _index,
      _bufferIndex
    }
  }

  /** @type {TokenizeContext['defineSkip']} */
  function defineSkip(value) {
    columnStart[value.line] = value.column
    accountForPotentialSkip()
  }

  //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */
  function main() {
    /** @type {number} */
    let chunkIndex
    while (point._index < chunks.length) {
      const chunk = chunks[point._index]

      // If we’re in a buffer chunk, loop through it.
      if (typeof chunk === 'string') {
        chunkIndex = point._index
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0
        }
        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex))
        }
      } else {
        go(chunk)
      }
    }
  }

  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */
  function go(code) {
    consumed = undefined
    expectedCode = code
    state = state(code)
  }

  /** @type {Effects['consume']} */
  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++
      point.column = 1
      point.offset += code === -3 ? 2 : 1
      accountForPotentialSkip()
    } else if (code !== -1) {
      point.column++
      point.offset++
    }

    // Not in a string chunk.
    if (point._bufferIndex < 0) {
      point._index++
    } else {
      point._bufferIndex++

      // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.
      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1
        point._index++
      }
    }

    // Expose the previous character.
    context.previous = code

    // Mark as consumed.
    consumed = true
  }

  /** @type {Effects['enter']} */
  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {}
    token.type = type
    token.start = now()
    context.events.push(['enter', token, context])
    stack.push(token)
    return token
  }

  /** @type {Effects['exit']} */
  function exit(type) {
    const token = stack.pop()
    token.end = now()
    context.events.push(['exit', token, context])
    return token
  }

  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from)
  }

  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulcheck(_, info) {
    info.restore()
  }

  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */
  function constructFactory(onreturn, fields) {
    return hook

    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */
    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs
      /** @type {number} */
      let constructIndex
      /** @type {Construct} */
      let currentConstruct
      /** @type {Info} */
      let info
      return Array.isArray(constructs) /* c8 ignore next 1 */
        ? handleListOfConstructs(constructs)
        : 'tokenize' in constructs
        ? // @ts-expect-error Looks like a construct.
          handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)

      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */
      function handleMapOfConstructs(map) {
        return start

        /** @type {State} */
        function start(code) {
          const def = code !== null && map[code]
          const all = code !== null && map.null
          const list = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ]
          return handleListOfConstructs(list)(code)
        }
      }

      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */
      function handleListOfConstructs(list) {
        listOfConstructs = list
        constructIndex = 0
        if (list.length === 0) {
          return bogusState
        }
        return handleConstruct(list[constructIndex])
      }

      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */
      function handleConstruct(construct) {
        return start

        /** @type {State} */
        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store()
          currentConstruct = construct
          if (!construct.partial) {
            context.currentConstruct = construct
          }

          // Always populated by defaults.

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok(code)
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }

      /** @type {State} */
      function ok(code) {
        consumed = true
        onreturn(currentConstruct, info)
        return returnState
      }

      /** @type {State} */
      function nok(code) {
        consumed = true
        info.restore()
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }
        return bogusState
      }
    }
  }

  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */
  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct)
    }
    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      )
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context)
    }
  }

  /**
   * Store state.
   *
   * @returns {Info}
   */
  function store() {
    const startPoint = now()
    const startPrevious = context.previous
    const startCurrentConstruct = context.currentConstruct
    const startEventsIndex = context.events.length
    const startStack = Array.from(stack)
    return {
      restore,
      from: startEventsIndex
    }

    /**
     * Restore state.
     *
     * @returns {undefined}
     */
    function restore() {
      point = startPoint
      context.previous = startPrevious
      context.currentConstruct = startCurrentConstruct
      context.events.length = startEventsIndex
      stack = startStack
      accountForPotentialSkip()
    }
  }

  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line]
      point.offset += columnStart[point.line] - 1
    }
  }
}

/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */
function sliceChunks(chunks, token) {
  const startIndex = token.start._index
  const startBufferIndex = token.start._bufferIndex
  const endIndex = token.end._index
  const endBufferIndex = token.end._bufferIndex
  /** @type {Array<Chunk>} */
  let view
  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)]
  } else {
    view = chunks.slice(startIndex, endIndex)
    if (startBufferIndex > -1) {
      const head = view[0]
      if (typeof head === 'string') {
        view[0] = head.slice(startBufferIndex)
      } else {
        view.shift()
      }
    }
    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex))
    }
  }
  return view
}

/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */
function serializeChunks(chunks, expandTabs) {
  let index = -1
  /** @type {Array<string>} */
  const result = []
  /** @type {boolean | undefined} */
  let atTab
  while (++index < chunks.length) {
    const chunk = chunks[index]
    /** @type {string} */
    let value
    if (typeof chunk === 'string') {
      value = chunk
    } else
      switch (chunk) {
        case -5: {
          value = '\r'
          break
        }
        case -4: {
          value = '\n'
          break
        }
        case -3: {
          value = '\r' + '\n'
          break
        }
        case -2: {
          value = expandTabs ? ' ' : '\t'
          break
        }
        case -1: {
          if (!expandTabs && atTab) continue
          value = ' '
          break
        }
        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk)
        }
      }
    atTab = chunk === -2
    result.push(value)
  }
  return result.join('')
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/thematic-break.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const thematicBreak = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('thematicBreak')
    // To do: parse indent like `markdown-rs`.
    return before(code)
  }

  /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    marker = code
    return atBreak(code)
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence')
      return sequence(code)
    }
    if (size >= 3 && (code === null || markdownLineEnding(code))) {
      effects.exit('thematicBreak')
      return ok(code)
    }
    return nok(code)
  }

  /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      size++
      return sequence
    }
    effects.exit('thematicBreakSequence')
    return markdownSpace(code)
      ? factorySpace(effects, atBreak, 'whitespace')(code)
      : atBreak(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/list.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */






/** @type {Construct} */
const list = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}

/** @type {Construct} */
const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
}

/** @type {Construct} */
const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
}

// To do: `markdown-rs` parses list items on their own and later stitches them
// together.

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListStart(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let size = 0
  return start

  /** @type {State} */
  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered')
    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind
        effects.enter(kind, {
          _container: true
        })
      }
      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix')
        return code === 42 || code === 45
          ? effects.check(thematicBreak, nok, atMarker)(code)
          : atMarker(code)
      }
      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix')
        effects.enter('listItemValue')
        return inside(code)
      }
    }
    return nok(code)
  }

  /** @type {State} */
  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code)
      return inside
    }
    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue')
      return atMarker(code)
    }
    return nok(code)
  }

  /**
   * @type {State}
   **/
  function atMarker(code) {
    effects.enter('listItemMarker')
    effects.consume(code)
    effects.exit('listItemMarker')
    self.containerState.marker = self.containerState.marker || code
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }

  /** @type {State} */
  function onBlank(code) {
    self.containerState.initialBlankLine = true
    initialSize++
    return endOfPrefix(code)
  }

  /** @type {State} */
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace')
      effects.consume(code)
      effects.exit('listItemPrefixWhitespace')
      return endOfPrefix
    }
    return nok(code)
  }

  /** @type {State} */
  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length
    return ok(code)
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListContinuation(effects, ok, nok) {
  const self = this
  self.containerState._closeFlow = undefined
  return effects.check(blankLine, onBlank, notBlank)

  /** @type {State} */
  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine

    // We have a blank line.
    // Still, try to consume at most the items size.
    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }

  /** @type {State} */
  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined
      self.containerState.initialBlankLine = undefined
      return notInCurrentItem(code)
    }
    self.containerState.furtherBlankLines = undefined
    self.containerState.initialBlankLine = undefined
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }

  /** @type {State} */
  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true
    // As we’re closing flow, we’re no longer interrupting.
    self.interrupt = undefined
    // Always populated by defaults.

    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}

/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type)
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this

  // Always populated by defaults.

  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/block-quote.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 62) {
      const state = self.containerState
      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        })
        state.open = true
      }
      effects.enter('blockQuotePrefix')
      effects.enter('blockQuoteMarker')
      effects.consume(code)
      effects.exit('blockQuoteMarker')
      return after
    }
    return nok(code)
  }

  /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace')
      effects.consume(code)
      effects.exit('blockQuotePrefixWhitespace')
      effects.exit('blockQuotePrefix')
      return ok
    }
    effects.exit('blockQuotePrefix')
    return ok(code)
  }
}

/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self = this
  return contStart

  /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contStart(code) {
    if (markdownSpace(code)) {
      // Always populated by defaults.

      return factorySpace(
        effects,
        contBefore,
        'linePrefix',
        self.parser.constructs.disable.null.includes('codeIndented')
          ? undefined
          : 4
      )(code)
    }
    return contBefore(code)
  }

  /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contBefore(code) {
    return effects.attempt(blockQuote, ok, nok)(code)
  }
}

/** @type {Exiter} */
function exit(effects) {
  effects.exit('blockQuote')
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-factory-destination/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */


/**
 * Parse destinations.
 *
 * ###### Examples
 *
 * ```markdown
 * <a>
 * <a\>b>
 * <a b>
 * <a)>
 * a
 * a\)b
 * a(b)c
 * a(b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type for whole (`<a>` or `b`).
 * @param {TokenType} literalType
 *   Type when enclosed (`<a>`).
 * @param {TokenType} literalMarkerType
 *   Type for enclosing (`<` and `>`).
 * @param {TokenType} rawType
 *   Type when not enclosed (`b`).
 * @param {TokenType} stringType
 *   Type for the value (`a` or `b`).
 * @param {number | undefined} [max=Infinity]
 *   Depth of nested parens (inclusive).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY
  let balance = 0
  return start

  /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 60) {
      effects.enter(type)
      effects.enter(literalType)
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      return enclosedBefore
    }

    // ASCII control, space, closing paren.
    if (code === null || code === 32 || code === 41 || asciiControl(code)) {
      return nok(code)
    }
    effects.enter(type)
    effects.enter(rawType)
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return raw(code)
  }

  /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      effects.exit(literalType)
      effects.exit(type)
      return ok
    }
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return enclosed(code)
  }

  /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosed(code) {
    if (code === 62) {
      effects.exit('chunkString')
      effects.exit(stringType)
      return enclosedBefore(code)
    }
    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }
    effects.consume(code)
    return code === 92 ? enclosedEscape : enclosed
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */
  function enclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code)
      return enclosed
    }
    return enclosed(code)
  }

  /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function raw(code) {
    if (
      !balance &&
      (code === null || code === 41 || markdownLineEndingOrSpace(code))
    ) {
      effects.exit('chunkString')
      effects.exit(stringType)
      effects.exit(rawType)
      effects.exit(type)
      return ok(code)
    }
    if (balance < limit && code === 40) {
      effects.consume(code)
      balance++
      return raw
    }
    if (code === 41) {
      effects.consume(code)
      balance--
      return raw
    }

    // ASCII control (but *not* `\0`) and space and `(`.
    // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
    // doesn’t.
    if (code === null || code === 32 || code === 40 || asciiControl(code)) {
      return nok(code)
    }
    effects.consume(code)
    return code === 92 ? rawEscape : raw
  }

  /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */
  function rawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code)
      return raw
    }
    return raw(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-factory-label/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */


/**
 * Parse labels.
 *
 * > 👉 **Note**: labels in markdown are capped at 999 characters in the string.
 *
 * ###### Examples
 *
 * ```markdown
 * [a]
 * [a
 * b]
 * [a\]b]
 * ```
 *
 * @this {TokenizeContext}
 *   Tokenize context.
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole label (`[a]`).
 * @param {TokenType} markerType
 *   Type for the markers (`[` and `]`).
 * @param {TokenType} stringType
 *   Type for the identifier (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this
  let size = 0
  /** @type {boolean} */
  let seen
  return start

  /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.enter(stringType)
    return atBreak
  }

  /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (
      size > 999 ||
      code === null ||
      code === 91 ||
      (code === 93 && !seen) ||
      // To do: remove in the future once we’ve switched from
      // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
      // which doesn’t need this.
      // Hidden footnotes hook.
      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit(stringType)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    // To do: indent? Link chunks and EOLs together?
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return atBreak
    }
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return labelInside(code)
  }

  /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }
    effects.consume(code)
    if (!seen) seen = !markdownSpace(code)
    return code === 92 ? labelEscape : labelInside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return labelInside
    }
    return labelInside(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-factory-title/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */



/**
 * Parse titles.
 *
 * ###### Examples
 *
 * ```markdown
 * "a"
 * 'b'
 * (c)
 * "a
 * b"
 * 'a
 *     b'
 * (a\)b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole title (`"a"`, `'b'`, `(c)`).
 * @param {TokenType} markerType
 *   Type for the markers (`"`, `'`, `(`, and `)`).
 * @param {TokenType} stringType
 *   Type for the value (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 34 || code === 39 || code === 40) {
      effects.enter(type)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      marker = code === 40 ? 41 : code
      return begin
    }
    return nok(code)
  }

  /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function begin(code) {
    if (code === marker) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }
    effects.enter(stringType)
    return atBreak(code)
  }

  /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.exit(stringType)
      return begin(marker)
    }
    if (code === null) {
      return nok(code)
    }

    // Note: blank lines can’t exist in content.
    if (markdownLineEnding(code)) {
      // To do: use `space_or_tab_eol_with_options`, connect.
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, atBreak, 'linePrefix')
    }
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return inside(code)
  }

  /**
   *
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      return atBreak(code)
    }
    effects.consume(code)
    return code === 92 ? escape : inside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */
  function escape(code) {
    if (code === marker || code === 92) {
      effects.consume(code)
      return inside
    }
    return inside(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-factory-whitespace/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */



/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   line endings or spaces in markdown are often optional, in which case this
 *     factory can be used and `ok` will be switched to whether spaces were found
 *     or not
 * *   one line ending or space can be detected with
 *     `markdownLineEndingOrSpace(code)` right before using `factoryWhitespace`
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @returns {State}
 *   Start state.
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen
  return start

  /** @type {State} */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      seen = true
      return start
    }
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }
    return ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-util-normalize-identifier/index.js
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */
function normalizeIdentifier(value) {
  return (
    value
      // Collapse markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ')
      // Trim.
      .replace(/^ | $/g, '')
      // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/definition.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */








/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
}

/** @type {Construct} */
const titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinition(effects, ok, nok) {
  const self = this
  /** @type {string} */
  let identifier
  return start

  /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Do not interrupt paragraphs (but do follow definitions).
    // To do: do `interrupt` the way `markdown-rs` does.
    // To do: parse whitespace the way `markdown-rs` does.
    effects.enter('definition')
    return before(code)
  }

  /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    // To do: parse whitespace the way `markdown-rs` does.

    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }

  /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    )
    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker')
      return markerAfter
    }
    return nok(code)
  }

  /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */
  function markerAfter(code) {
    // Note: whitespace is optional.
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, destinationBefore)(code)
      : destinationBefore(code)
  }

  /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */
  function destinationBefore(code) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      'definitionDestination',
      'definitionDestinationLiteral',
      'definitionDestinationLiteralMarker',
      'definitionDestinationRaw',
      'definitionDestinationString'
    )(code)
  }

  /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function destinationAfter(code) {
    return effects.attempt(titleBefore, after, after)(code)
  }

  /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return markdownSpace(code)
      ? factorySpace(effects, afterWhitespace, 'whitespace')(code)
      : afterWhitespace(code)
  }

  /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function afterWhitespace(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition')

      // Note: we don’t care about uniqueness.
      // It’s likely that that doesn’t happen very frequently.
      // It is more likely that it wastes precious time.
      self.parser.defined.push(identifier)

      // To do: `markdown-rs` interrupt.
      // // You’d be interrupting.
      // tokenizer.interrupt = true
      return ok(code)
    }
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore

  /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function titleBefore(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, beforeMarker)(code)
      : nok(code)
  }

  /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function beforeMarker(code) {
    return factoryTitle(
      effects,
      titleAfter,
      nok,
      'definitionTitle',
      'definitionTitleMarker',
      'definitionTitleString'
    )(code)
  }

  /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfter(code) {
    return markdownSpace(code)
      ? factorySpace(effects, titleAfterOptionalWhitespace, 'whitespace')(code)
      : titleAfterOptionalWhitespace(code)
  }

  /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfterOptionalWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/code-indented.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
}

/** @type {Construct} */
const furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeIndented(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: manually check if interrupting like `markdown-rs`.

    effects.enter('codeIndented')
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? atBreak(code)
      : nok(code)
  }

  /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === null) {
      return after(code)
    }
    if (markdownLineEnding(code)) {
      return effects.attempt(furtherStart, atBreak, after)(code)
    }
    effects.enter('codeFlowValue')
    return inside(code)
  }

  /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return atBreak(code)
    }
    effects.consume(code)
    return inside
  }

  /** @type {State} */
  function after(code) {
    effects.exit('codeIndented')
    // To do: allow interrupting like `markdown-rs`.
    // Feel free to interrupt.
    // tokenizer.interrupt = false
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeFurtherStart(effects, ok, nok) {
  const self = this
  return furtherStart

  /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */
  function furtherStart(code) {
    // To do: improve `lazy` / `pierce` handling.
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return furtherStart
    }

    // To do: the code here in `micromark-js` is a bit different from
    // `markdown-rs` because there it can attempt spaces.
    // We can’t yet.
    //
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? furtherStart(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/heading-atx.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
}

/** @type {Resolver} */
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2
  let contentStart = 3
  /** @type {Token} */
  let content
  /** @type {Token} */
  let text

  // Prefix whitespace, part of the opening.
  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2
  }

  // Suffix whitespace, part of the closing.
  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2
  }
  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4
  }
  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    }
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: 'text'
    }
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ])
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHeadingAtx(effects, ok, nok) {
  let size = 0
  return start

  /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    effects.enter('atxHeading')
    return before(code)
  }

  /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('atxHeadingSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code)
      return sequenceOpen
    }

    // Always at least one `#`.
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence')
      return atBreak(code)
    }
    return nok(code)
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence')
      return sequenceFurther(code)
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading')
      // To do: interrupt like `markdown-rs`.
      // // Feel free to interrupt.
      // tokenizer.interrupt = false
      return ok(code)
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    // To do: generate `data` tokens, add the `text` token later.
    // Needs edit map, see: `markdown.rs`.
    effects.enter('atxHeadingText')
    return data(code)
  }

  /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */
  function sequenceFurther(code) {
    if (code === 35) {
      effects.consume(code)
      return sequenceFurther
    }
    effects.exit('atxHeadingSequence')
    return atBreak(code)
  }

  /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText')
      return atBreak(code)
    }
    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/setext-underline.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
}

/** @type {Resolver} */
function resolveToSetextUnderline(events, context) {
  // To do: resolve like `markdown-rs`.
  let index = events.length
  /** @type {number | undefined} */
  let content
  /** @type {number | undefined} */
  let text
  /** @type {number | undefined} */
  let definition

  // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.
  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index
        break
      }
      if (events[index][1].type === 'paragraph') {
        text = index
      }
    }
    // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1)
      }
      if (!definition && events[index][1].type === 'definition') {
        definition = index
      }
    }
  }
  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }

  // Change the paragraph to setext heading text.
  events[text][1].type = 'setextHeadingText'

  // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.
  if (definition) {
    events.splice(text, 0, ['enter', heading, context])
    events.splice(definition + 1, 0, ['exit', events[content][1], context])
    events[content][1].end = Object.assign({}, events[definition][1].end)
  } else {
    events[content][1] = heading
  }

  // Add the heading exit at the end.
  events.push(['exit', heading, context])
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    let index = self.events.length
    /** @type {boolean | undefined} */
    let paragraph
    // Find an opening.
    while (index--) {
      // Skip enter/exit of line ending, line prefix, and content.
      // We can now either have a definition or a paragraph.
      if (
        self.events[index][1].type !== 'lineEnding' &&
        self.events[index][1].type !== 'linePrefix' &&
        self.events[index][1].type !== 'content'
      ) {
        paragraph = self.events[index][1].type === 'paragraph'
        break
      }
    }

    // To do: handle lazy/pierce like `markdown-rs`.
    // To do: parse indent like `markdown-rs`.
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine')
      marker = code
      return before(code)
    }
    return nok(code)
  }

  /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('setextHeadingLineSequence')
    return inside(code)
  }

  /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code)
      return inside
    }
    effects.exit('setextHeadingLineSequence')
    return markdownSpace(code)
      ? factorySpace(effects, after, 'lineSuffix')(code)
      : after(code)
  }

  /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine')
      return ok(code)
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-util-html-tag-name/index.js
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'search',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]

/**
 * List of lowercase HTML “raw” tag names.
 *
 * The list, when parsing HTML (flow), results in HTML that can include lines
 * without exiting, until a closing tag also in this list is found (condition
 * 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea']

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/html-flow.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */





/** @type {Construct} */
const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
}

/** @type {Construct} */
const blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: true
}
const nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: true
}

/** @type {Resolver} */
function resolveToHtmlFlow(events) {
  let index = events.length
  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }
  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start
    // Add the prefix start to the HTML line token.
    events[index + 1][1].start = events[index - 2][1].start
    // Remove the line prefix.
    events.splice(index - 2, 2)
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this
  /** @type {number} */
  let marker
  /** @type {boolean} */
  let closingTag
  /** @type {string} */
  let buffer
  /** @type {number} */
  let index
  /** @type {Code} */
  let markerB
  return start

  /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    return before(code)
  }

  /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('htmlFlow')
    effects.enter('htmlFlowData')
    effects.consume(code)
    return open
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }
    if (code === 47) {
      effects.consume(code)
      closingTag = true
      return tagCloseStart
    }
    if (code === 63) {
      effects.consume(code)
      marker = 3
      // To do:
      // tokenizer.concrete = true
      // To do: use `markdown-rs` style interrupt.
      // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.
      return self.interrupt ? ok : continuationDeclarationInside
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      marker = 2
      return commentOpenInside
    }
    if (code === 91) {
      effects.consume(code)
      marker = 5
      index = 0
      return cdataOpenInside
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      marker = 4
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside
    }
    return nok(code)
  }

  /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside
    }
    return nok(code)
  }

  /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = 'CDATA['
    if (code === value.charCodeAt(index++)) {
      effects.consume(code)
      if (index === value.length) {
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok : continuation
      }
      return cdataOpenInside
    }
    return nok(code)
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */
  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      const slash = code === 47
      const name = buffer.toLowerCase()
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code)
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6
        if (slash) {
          effects.consume(code)
          return basicSelfClosing
        }

        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code)
      }
      marker = 7
      // Do not support complete HTML when interrupting.
      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : closingTag
        ? completeClosingTagAfter(code)
        : completeAttributeNameBefore(code)
    }

    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code)
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuation
    }
    return nok(code)
  }

  /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeClosingTagAfter
    }
    return completeEnd(code)
  }

  /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code)
      return completeEnd
    }

    // ASCII alphanumerical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return completeAttributeName
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameBefore
    }
    return completeEnd(code)
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeName(code) {
    // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return completeAttributeName
    }
    return completeAttributeNameAfter(code)
  }

  /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return completeAttributeValueBefore
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameAfter
    }
    return completeAttributeNameBefore(code)
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 34 || code === 39) {
      effects.consume(code)
      markerB = code
      return completeAttributeValueQuoted
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeValueBefore
    }
    return completeAttributeValueUnquoted(code)
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuoted(code) {
    if (code === markerB) {
      effects.consume(code)
      markerB = null
      return completeAttributeValueQuotedAfter
    }
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }
    effects.consume(code)
    return completeAttributeValueQuoted
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 47 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }
    effects.consume(code)
    return completeAttributeValueUnquoted
  }

  /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }
    return nok(code)
  }

  /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code)
      return completeAfter
    }
    return nok(code)
  }

  /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      // // Do not form containers.
      // tokenizer.concrete = true
      return continuation(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAfter
    }
    return nok(code)
  }

  /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */
  function continuation(code) {
    if (code === 45 && marker === 2) {
      effects.consume(code)
      return continuationCommentInside
    }
    if (code === 60 && marker === 1) {
      effects.consume(code)
      return continuationRawTagOpen
    }
    if (code === 62 && marker === 4) {
      effects.consume(code)
      return continuationClose
    }
    if (code === 63 && marker === 3) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    if (code === 93 && marker === 5) {
      effects.consume(code)
      return continuationCdataInside
    }
    if (markdownLineEnding(code) && (marker === 6 || marker === 7)) {
      effects.exit('htmlFlowData')
      return effects.check(
        blankLineBefore,
        continuationAfter,
        continuationStart
      )(code)
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return continuationStart(code)
    }
    effects.consume(code)
    return continuation
  }

  /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStart(code) {
    return effects.check(
      nonLazyContinuationStart,
      continuationStartNonLazy,
      continuationAfter
    )(code)
  }

  /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStartNonLazy(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return continuationBefore
  }

  /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */
  function continuationBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuationStart(code)
    }
    effects.enter('htmlFlowData')
    return continuation(code)
  }

  /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code)
      buffer = ''
      return continuationRawEndTag
    }
    return continuation(code)
  }

  /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */
  function continuationRawEndTag(code) {
    if (code === 62) {
      const name = buffer.toLowerCase()
      if (htmlRawNames.includes(name)) {
        effects.consume(code)
        return continuationClose
      }
      return continuation(code)
    }
    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer += String.fromCharCode(code)
      return continuationRawEndTag
    }
    return continuation(code)
  }

  /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */
  function continuationCdataInside(code) {
    if (code === 93) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code)
      return continuationClose
    }

    // More dashes.
    if (code === 45 && marker === 2) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return continuationAfter(code)
    }
    effects.consume(code)
    return continuationClose
  }

  /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationAfter(code) {
    effects.exit('htmlFlow')
    // // Feel free to interrupt.
    // tokenizer.interrupt = false
    // // No longer concrete.
    // tokenizer.concrete = false
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self = this
  return start

  /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return after
    }
    return nok(code)
  }

  /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start

  /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return effects.attempt(blankLine, ok, nok)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/code-fenced.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: true
}

/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeFenced(effects, ok, nok) {
  const self = this
  /** @type {Construct} */
  const closeStart = {
    tokenize: tokenizeCloseStart,
    partial: true
  }
  let initialPrefix = 0
  let sizeOpen = 0
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse whitespace like `markdown-rs`.
    return beforeSequenceOpen(code)
  }

  /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeSequenceOpen(code) {
    const tail = self.events[self.events.length - 1]
    initialPrefix =
      tail && tail[1].type === 'linePrefix'
        ? tail[2].sliceSerialize(tail[1], true).length
        : 0
    marker = code
    effects.enter('codeFenced')
    effects.enter('codeFencedFence')
    effects.enter('codeFencedFenceSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === marker) {
      sizeOpen++
      effects.consume(code)
      return sequenceOpen
    }
    if (sizeOpen < 3) {
      return nok(code)
    }
    effects.exit('codeFencedFenceSequence')
    return markdownSpace(code)
      ? factorySpace(effects, infoBefore, 'whitespace')(code)
      : infoBefore(code)
  }

  /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function infoBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFencedFence')
      return self.interrupt
        ? ok(code)
        : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code)
    }
    effects.enter('codeFencedFenceInfo')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return info(code)
  }

  /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function info(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return infoBefore(code)
    }
    if (markdownSpace(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return factorySpace(effects, metaBefore, 'whitespace')(code)
    }
    if (code === 96 && code === marker) {
      return nok(code)
    }
    effects.consume(code)
    return info
  }

  /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function metaBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return infoBefore(code)
    }
    effects.enter('codeFencedFenceMeta')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return meta(code)
  }

  /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceMeta')
      return infoBefore(code)
    }
    if (code === 96 && code === marker) {
      return nok(code)
    }
    effects.consume(code)
    return meta
  }

  /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function atNonLazyBreak(code) {
    return effects.attempt(closeStart, after, contentBefore)(code)
  }

  /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentBefore(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return contentStart
  }

  /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentStart(code) {
    return initialPrefix > 0 && markdownSpace(code)
      ? factorySpace(
          effects,
          beforeContentChunk,
          'linePrefix',
          initialPrefix + 1
        )(code)
      : beforeContentChunk(code)
  }

  /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeContentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code)
    }
    effects.enter('codeFlowValue')
    return contentChunk(code)
  }

  /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return beforeContentChunk(code)
    }
    effects.consume(code)
    return contentChunk
  }

  /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    effects.exit('codeFenced')
    return ok(code)
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeCloseStart(effects, ok, nok) {
    let size = 0
    return startBefore

    /**
     *
     *
     * @type {State}
     */
    function startBefore(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return start
    }

    /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function start(code) {
      // Always populated by defaults.

      // To do: `enter` here or in next state?
      effects.enter('codeFencedFence')
      return markdownSpace(code)
        ? factorySpace(
            effects,
            beforeSequenceClose,
            'linePrefix',
            self.parser.constructs.disable.null.includes('codeIndented')
              ? undefined
              : 4
          )(code)
        : beforeSequenceClose(code)
    }

    /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function beforeSequenceClose(code) {
      if (code === marker) {
        effects.enter('codeFencedFenceSequence')
        return sequenceClose(code)
      }
      return nok(code)
    }

    /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function sequenceClose(code) {
      if (code === marker) {
        size++
        effects.consume(code)
        return sequenceClose
      }
      if (size >= sizeOpen) {
        effects.exit('codeFencedFenceSequence')
        return markdownSpace(code)
          ? factorySpace(effects, sequenceCloseAfter, 'whitespace')(code)
          : sequenceCloseAfter(code)
      }
      return nok(code)
    }

    /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */
    function sequenceCloseAfter(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence')
        return ok(code)
      }
      return nok(code)
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self = this
  return start

  /**
   *
   *
   * @type {State}
   */
  function start(code) {
    if (code === null) {
      return nok(code)
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return lineStart
  }

  /**
   *
   *
   * @type {State}
   */
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/decode-named-character-reference/index.dom.js
/// <reference lib="dom" />

/* eslint-env browser */

const index_dom_element = document.createElement('i')

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';'
  index_dom_element.innerHTML = characterReference
  const char = index_dom_element.textContent

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/character-reference.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterReference(effects, ok, nok) {
  const self = this
  let size = 0
  /** @type {number} */
  let max
  /** @type {(code: Code) => boolean} */
  let test
  return start

  /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('characterReference')
    effects.enter('characterReferenceMarker')
    effects.consume(code)
    effects.exit('characterReferenceMarker')
    return open
  }

  /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric')
      effects.consume(code)
      effects.exit('characterReferenceMarkerNumeric')
      return numeric
    }
    effects.enter('characterReferenceValue')
    max = 31
    test = asciiAlphanumeric
    return value(code)
  }

  /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */
  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal')
      effects.consume(code)
      effects.exit('characterReferenceMarkerHexadecimal')
      effects.enter('characterReferenceValue')
      max = 6
      test = asciiHexDigit
      return value
    }
    effects.enter('characterReferenceValue')
    max = 7
    test = asciiDigit
    return value(code)
  }

  /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */
  function value(code) {
    if (code === 59 && size) {
      const token = effects.exit('characterReferenceValue')
      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      // To do: `markdown-rs` uses a different name:
      // `CharacterReferenceMarkerSemi`.
      effects.enter('characterReferenceMarker')
      effects.consume(code)
      effects.exit('characterReferenceMarker')
      effects.exit('characterReference')
      return ok
    }
    if (test(code) && size++ < max) {
      effects.consume(code)
      return value
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/character-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterEscape(effects, ok, nok) {
  return start

  /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('characterEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    effects.exit('escapeMarker')
    return inside
  }

  /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // ASCII punctuation.
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue')
      effects.consume(code)
      effects.exit('characterEscapeValue')
      effects.exit('characterEscape')
      return ok
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/line-ending.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLineEnding(effects, ok) {
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/label-end.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */









/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}

/** @type {Construct} */
const resourceConstruct = {
  tokenize: tokenizeResource
}
/** @type {Construct} */
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}
/** @type {Construct} */
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
}

/** @type {Resolver} */
function resolveAllLabelEnd(events) {
  let index = -1
  while (++index < events.length) {
    const token = events[index][1]
    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2)
      token.type = 'data'
      index++
    }
  }
  return events
}

/** @type {Resolver} */
function resolveToLabelEnd(events, context) {
  let index = events.length
  let offset = 0
  /** @type {Token} */
  let token
  /** @type {number | undefined} */
  let open
  /** @type {number | undefined} */
  let close
  /** @type {Array<Event>} */
  let media

  // Find an opening.
  while (index--) {
    token = events[index][1]
    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      }

      // Mark other link openings as inactive, as we can’t have links in
      // links.
      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index
        if (token.type !== 'labelLink') {
          offset = 2
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index
    }
  }
  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  }
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  }
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ]

  // Opening marker.
  media = push(media, events.slice(open + 1, open + offset + 3))

  // Text open.
  media = push(media, [['enter', text, context]])

  // Always populated by defaults.

  // Between.
  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  )

  // Text close, marker close, label close.
  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ])

  // Reference, resource, or so.
  media = push(media, events.slice(close + 1))

  // Media close.
  media = push(media, [['exit', group, context]])
  splice(events, open, events.length, media)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelEnd(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Token} */
  let labelStart
  /** @type {boolean} */
  let defined

  // Find an opening.
  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1]
      break
    }
  }
  return start

  /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // If there is not an okay opening.
    if (!labelStart) {
      return nok(code)
    }

    // If the corresponding label (link) start is marked as inactive,
    // it means we’d be wrapping a link, like this:
    //
    // ```markdown
    // > | a [b [c](d) e](f) g.
    //                  ^
    // ```
    //
    // We can’t have that, so it’s just balanced brackets.
    if (labelStart._inactive) {
      return labelEndNok(code)
    }
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    )
    effects.enter('labelEnd')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelEnd')
    return after
  }

  /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
    // an extension.

    // Resource (`[asd](fgh)`)?
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        labelEndOk,
        defined ? labelEndOk : labelEndNok
      )(code)
    }

    // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
    if (code === 91) {
      return effects.attempt(
        referenceFullConstruct,
        labelEndOk,
        defined ? referenceNotFull : labelEndNok
      )(code)
    }

    // Shortcut (`[asd]`) reference?
    return defined ? labelEndOk(code) : labelEndNok(code)
  }

  /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceNotFull(code) {
    return effects.attempt(
      referenceCollapsedConstruct,
      labelEndOk,
      labelEndNok
    )(code)
  }

  /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndOk(code) {
    // Note: `markdown-rs` does a bunch of stuff here.
    return ok(code)
  }

  /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndNok(code) {
    labelStart._balanced = true
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeResource(effects, ok, nok) {
  return resourceStart

  /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */
  function resourceStart(code) {
    effects.enter('resource')
    effects.enter('resourceMarker')
    effects.consume(code)
    effects.exit('resourceMarker')
    return resourceBefore
  }

  /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceBefore(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceOpen)(code)
      : resourceOpen(code)
  }

  /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceOpen(code) {
    if (code === 41) {
      return resourceEnd(code)
    }
    return factoryDestination(
      effects,
      resourceDestinationAfter,
      resourceDestinationMissing,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }

  /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceBetween)(code)
      : resourceEnd(code)
  }

  /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationMissing(code) {
    return nok(code)
  }

  /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */
  function resourceBetween(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        resourceTitleAfter,
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }
    return resourceEnd(code)
  }

  /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */
  function resourceTitleAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceEnd)(code)
      : resourceEnd(code)
  }

  /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceEnd(code) {
    if (code === 41) {
      effects.enter('resourceMarker')
      effects.consume(code)
      effects.exit('resourceMarker')
      effects.exit('resource')
      return ok
    }
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceFull(effects, ok, nok) {
  const self = this
  return referenceFull

  /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFull(code) {
    return factoryLabel.call(
      self,
      effects,
      referenceFullAfter,
      referenceFullMissing,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }

  /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */
  function referenceFullAfter(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }

  /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFullMissing(code) {
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart

  /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceCollapsedStart(code) {
    // We only attempt a collapsed label if there’s a `[`.

    effects.enter('reference')
    effects.enter('referenceMarker')
    effects.consume(code)
    effects.exit('referenceMarker')
    return referenceCollapsedOpen
  }

  /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */
  function referenceCollapsedOpen(code) {
    if (code === 93) {
      effects.enter('referenceMarker')
      effects.consume(code)
      effects.exit('referenceMarker')
      effects.exit('reference')
      return ok
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/label-start-image.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('labelImage')
    effects.enter('labelImageMarker')
    effects.consume(code)
    effects.exit('labelImageMarker')
    return open
  }

  /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker')
      effects.consume(code)
      effects.exit('labelMarker')
      effects.exit('labelImage')
      return after
    }
    return nok(code)
  }

  /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // To do: use a new field to do this, this is still needed for
    // `micromark-extension-gfm-footnote`, but the `label-start-link`
    // behavior isn’t.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-util-classify-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */


/**
 * Classify whether a code represents whitespace, punctuation, or something
 * else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * > 👉 **Note**: eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 *   Code.
 * @returns {typeof constants.characterGroupWhitespace | typeof constants.characterGroupPunctuation | undefined}
 *   Group.
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }
  if (unicodePunctuation(code)) {
    return 2
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/attention.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
}

/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */
// eslint-disable-next-line complexity
function resolveAllAttention(events, context) {
  let index = -1
  /** @type {number} */
  let open
  /** @type {Token} */
  let group
  /** @type {Token} */
  let text
  /** @type {Token} */
  let openingSequence
  /** @type {Token} */
  let closingSequence
  /** @type {number} */
  let use
  /** @type {Array<Event>} */
  let nextEvents
  /** @type {number} */
  let offset

  // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.
  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index

      // Now walk back to find an opener.
      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open &&
          // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          }

          // Number of markers to use from the sequence.
          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1
          const start = Object.assign({}, events[open][1].end)
          const end = Object.assign({}, events[index][1].start)
          movePoint(start, -use)
          movePoint(end, use)
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          }
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          }
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          }
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          }
          events[open][1].end = Object.assign({}, openingSequence.start)
          events[index][1].start = Object.assign({}, closingSequence.end)
          nextEvents = []

          // If there are more markers in the opening, add them before.
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ])
          }

          // Opening.
          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ])

          // Always populated by defaults.

          // Between.
          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          )

          // Closing.
          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ])

          // If there are more markers in the closing, add them after.
          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ])
          } else {
            offset = 0
          }
          splice(events, open - 1, index - open + 3, nextEvents)
          index = open + nextEvents.length - offset - 2
          break
        }
      }
    }
  }

  // Remove remaining sequences.
  index = -1
  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data'
    }
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null
  const previous = this.previous
  const before = classifyCharacter(previous)

  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    marker = code
    effects.enter('attentionSequence')
    return inside(code)
  }

  /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code)
      return inside
    }
    const token = effects.exit('attentionSequence')

    // To do: next major: move this to resolver, just like `markdown-rs`.
    const after = classifyCharacter(code)

    // Always populated by defaults.

    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code)
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous)
    token._open = Boolean(marker === 42 ? open : open && (before || !close))
    token._close = Boolean(marker === 42 ? close : close && (after || !open))
    return ok(code)
  }
}

/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */
function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/autolink.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAutolink(effects, ok, nok) {
  let size = 0
  return start

  /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('autolink')
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.enter('autolinkProtocol')
    return open
  }

  /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return schemeOrEmailAtext
    }
    return emailAtext(code)
  }

  /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeOrEmailAtext(code) {
    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) {
      // Count the previous alphabetical from `open` too.
      size = 1
      return schemeInsideOrEmailAtext(code)
    }
    return emailAtext(code)
  }

  /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code)
      size = 0
      return urlInside
    }

    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code)
      return schemeInsideOrEmailAtext
    }
    size = 0
    return emailAtext(code)
  }

  /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */
  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol')
      effects.enter('autolinkMarker')
      effects.consume(code)
      effects.exit('autolinkMarker')
      effects.exit('autolink')
      return ok
    }

    // ASCII control, space, or `<`.
    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }
    effects.consume(code)
    return urlInside
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code)
      return emailAtSignOrDot
    }
    if (asciiAtext(code)) {
      effects.consume(code)
      return emailAtext
    }
    return nok(code)
  }

  /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }

  /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }
    if (code === 62) {
      // Exit, then change the token type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail'
      effects.enter('autolinkMarker')
      effects.consume(code)
      effects.exit('autolinkMarker')
      effects.exit('autolink')
      return ok
    }
    return emailValue(code)
  }

  /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function emailValue(code) {
    // ASCII alphanumeric or `-`.
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      const next = code === 45 ? emailValue : emailLabel
      effects.consume(code)
      return next
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/html-text.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlText(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code> | undefined} */
  let marker
  /** @type {number} */
  let index
  /** @type {State} */
  let returnState
  return start

  /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('htmlText')
    effects.enter('htmlTextData')
    effects.consume(code)
    return open
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }
    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }
    if (code === 63) {
      effects.consume(code)
      return instruction
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagOpen
    }
    return nok(code)
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentOpenInside
    }
    if (code === 91) {
      effects.consume(code)
      index = 0
      return cdataOpenInside
    }
    if (asciiAlpha(code)) {
      effects.consume(code)
      return declaration
    }
    return nok(code)
  }

  /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      return commentEnd
    }
    return nok(code)
  }

  /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function comment(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 45) {
      effects.consume(code)
      return commentClose
    }
    if (markdownLineEnding(code)) {
      returnState = comment
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return comment
  }

  /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code)
      return commentEnd
    }
    return comment(code)
  }

  /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */
  function commentEnd(code) {
    return code === 62
      ? end(code)
      : code === 45
      ? commentClose(code)
      : comment(code)
  }

  /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = 'CDATA['
    if (code === value.charCodeAt(index++)) {
      effects.consume(code)
      return index === value.length ? cdata : cdataOpenInside
    }
    return nok(code)
  }

  /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */
  function cdata(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 93) {
      effects.consume(code)
      return cdataClose
    }
    if (markdownLineEnding(code)) {
      returnState = cdata
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return cdata
  }

  /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }
    return cdata(code)
  }

  /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */
  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }
    return cdata(code)
  }

  /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }
    if (markdownLineEnding(code)) {
      returnState = declaration
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return declaration
  }

  /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function instruction(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 63) {
      effects.consume(code)
      return instructionClose
    }
    if (markdownLineEnding(code)) {
      returnState = instruction
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return instruction
  }

  /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagClose
    }
    return nok(code)
  }

  /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagClose(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagClose
    }
    return tagCloseBetween(code)
  }

  /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagCloseBetween
    }
    return end(code)
  }

  /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpen(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagOpen
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    return nok(code)
  }

  /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code)
      return end
    }

    // ASCII alphabetical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return tagOpenAttributeName
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenBetween
    }
    return end(code)
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeName(code) {
    // ASCII alphabetical and `-`, `.`, `:`, and `_`.
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return tagOpenAttributeName
    }
    return tagOpenAttributeNameAfter(code)
  }

  /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeNameAfter
    }
    return tagOpenBetween(code)
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return tagOpenAttributeValueQuoted
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }
    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code)
      marker = undefined
      return tagOpenAttributeValueQuotedAfter
    }
    if (code === null) {
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return tagOpenAttributeValueQuoted
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  }

  /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    return nok(code)
  }

  /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function end(code) {
    if (code === 62) {
      effects.consume(code)
      effects.exit('htmlTextData')
      effects.exit('htmlText')
      return ok
    }
    return nok(code)
  }

  /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */
  function lineEndingBefore(code) {
    effects.exit('htmlTextData')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return lineEndingAfter
  }

  /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfter(code) {
    // Always populated by defaults.

    return markdownSpace(code)
      ? factorySpace(
          effects,
          lineEndingAfterPrefix,
          'linePrefix',
          self.parser.constructs.disable.null.includes('codeIndented')
            ? undefined
            : 4
        )(code)
      : lineEndingAfterPrefix(code)
  }

  /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfterPrefix(code) {
    effects.enter('htmlTextData')
    return returnState(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/label-start-link.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('labelLink')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelLink')
    return after
  }

  /** @type {State} */
  function after(code) {
    // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
    // remove.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/hard-break-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start

  /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('hardBreakEscape')
    effects.consume(code)
    return after
  }

  /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */
  function after(code) {
    if (markdownLineEnding(code)) {
      effects.exit('hardBreakEscape')
      return ok(code)
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/node_modules/micromark-core-commonmark/lib/code-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
}

// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4
  let headEnterIndex = 3
  /** @type {number} */
  let index
  /** @type {number | undefined} */
  let enter

  // If we start and end with an EOL or a space.
  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex

    // And we have data.
    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding'
        events[tailExitIndex][1].type = 'codeTextPadding'
        headEnterIndex += 2
        tailExitIndex -= 2
        break
      }
    }
  }

  // Merge adjacent spaces and data.
  index = headEnterIndex - 1
  tailExitIndex++
  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData'
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end
        events.splice(enter + 2, index - enter - 2)
        tailExitIndex -= index - enter - 2
        index = enter + 2
      }
      enter = undefined
    }
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeText(effects, ok, nok) {
  const self = this
  let sizeOpen = 0
  /** @type {number} */
  let size
  /** @type {Token} */
  let token
  return start

  /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('codeText')
    effects.enter('codeTextSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 96) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }
    effects.exit('codeTextSequence')
    return between(code)
  }

  /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */
  function between(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    }

    // To do: next major: don’t do spaces in resolve, but when compiling,
    // like `markdown-rs`.
    // Tabs don’t work, and virtual spaces don’t make sense.
    if (code === 32) {
      effects.enter('space')
      effects.consume(code)
      effects.exit('space')
      return between
    }

    // Closing fence? Could also be data.
    if (code === 96) {
      token = effects.enter('codeTextSequence')
      size = 0
      return sequenceClose(code)
    }
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return between
    }

    // Data.
    effects.enter('codeTextData')
    return data(code)
  }

  /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData')
      return between(code)
    }
    effects.consume(code)
    return data
  }

  /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */
  function sequenceClose(code) {
    // More.
    if (code === 96) {
      effects.consume(code)
      size++
      return sequenceClose
    }

    // Done!
    if (size === sizeOpen) {
      effects.exit('codeTextSequence')
      effects.exit('codeText')
      return ok(code)
    }

    // More or less accents: mark as data.
    token.type = 'codeTextData'
    return data(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/constructs.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */




/** @satisfies {Extension['document']} */
const constructs_document = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
}

/** @satisfies {Extension['contentInitial']} */
const contentInitial = {
  [91]: definition
}

/** @satisfies {Extension['flowInitial']} */
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
}

/** @satisfies {Extension['flow']} */
const constructs_flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
}

/** @satisfies {Extension['string']} */
const constructs_string = {
  [38]: characterReference,
  [92]: characterEscape
}

/** @satisfies {Extension['text']} */
const constructs_text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
}

/** @satisfies {Extension['insideSpan']} */
const insideSpan = {
  null: [attention, resolver]
}

/** @satisfies {Extension['attentionMarkers']} */
const attentionMarkers = {
  null: [42, 95]
}

/** @satisfies {Extension['disable']} */
const disable = {
  null: []
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/parse.js
/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */









/**
 * @param {ParseOptions | null | undefined} [options]
 * @returns {ParseContext}
 */
function parse_parse(options) {
  const settings = options || {}
  const constructs =
    /** @type {FullNormalizedExtension} */
    combineExtensions([constructs_namespaceObject, ...(settings.extensions || [])])

  /** @type {ParseContext} */
  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content),
    document: create(document_document),
    flow: create(flow),
    string: create(string),
    text: create(text_text)
  }
  return parser

  /**
   * @param {InitialConstruct} initial
   */
  function create(initial) {
    return creator
    /** @type {Create} */
    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark/lib/preprocess.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */

const search = /[\0\t\n\r]/g

/**
 * @returns {Preprocessor}
 */
function preprocess() {
  let column = 1
  let buffer = ''
  /** @type {boolean | undefined} */
  let start = true
  /** @type {boolean | undefined} */
  let atCarriageReturn
  return preprocessor

  /** @type {Preprocessor} */
  // eslint-disable-next-line complexity
  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = []
    /** @type {RegExpMatchArray | null} */
    let match
    /** @type {number} */
    let next
    /** @type {number} */
    let startPosition
    /** @type {number} */
    let endPosition
    /** @type {Code} */
    let code
    value =
      buffer +
      (typeof value === 'string'
        ? value.toString()
        : new TextDecoder(encoding || undefined).decode(value))
    startPosition = 0
    buffer = ''
    if (start) {
      // To do: `markdown-rs` actually parses BOMs (byte order mark).
      if (value.charCodeAt(0) === 65279) {
        startPosition++
      }
      start = undefined
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition
      match = search.exec(value)
      endPosition =
        match && match.index !== undefined ? match.index : value.length
      code = value.charCodeAt(endPosition)
      if (!match) {
        buffer = value.slice(startPosition)
        break
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3)
        atCarriageReturn = undefined
      } else {
        if (atCarriageReturn) {
          chunks.push(-5)
          atCarriageReturn = undefined
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition))
          column += endPosition - startPosition
        }
        switch (code) {
          case 0: {
            chunks.push(65533)
            column++
            break
          }
          case 9: {
            next = Math.ceil(column / 4) * 4
            chunks.push(-2)
            while (column++ < next) chunks.push(-1)
            break
          }
          case 10: {
            chunks.push(-4)
            column = 1
            break
          }
          default: {
            atCarriageReturn = true
            column = 1
          }
        }
      }
      startPosition = endPosition + 1
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5)
      if (buffer) chunks.push(buffer)
      chunks.push(null)
    }
    return chunks
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-from-markdown/node_modules/micromark-util-decode-numeric-character-reference/index.js
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base);
  if (
  // C0 except for HT, LF, FF, CR, space.
  code < 9 || code === 11 || code > 13 && code < 32 ||
  // Control character (DEL) of C0, and C1 controls.
  code > 126 && code < 160 ||
  // Lone high surrogates and low surrogates.
  code > 55_295 && code < 57_344 ||
  // Noncharacters.
  code > 64_975 && code < 65_008 || /* eslint-disable no-bitwise */
  (code & 65_535) === 65_535 || (code & 65_535) === 65_534 || /* eslint-enable no-bitwise */
  // Out of range
  code > 1_114_111) {
    return "\uFFFD";
  }
  return String.fromCodePoint(code);
}
;// CONCATENATED MODULE: ./node_modules/mdast-util-from-markdown/node_modules/micromark-util-decode-string/index.js


const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi

/**
 * Decode markdown strings (which occur in places such as fenced code info
 * strings, destinations, labels, and titles).
 *
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 *   Value to decode.
 * @returns {string}
 *   Decoded value.
 */
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */
function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  }

  // Reference.
  const head = $2.charCodeAt(0)
  if (head === 35) {
    const head = $2.charCodeAt(1)
    const hex = head === 120 || head === 88
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }
  return decodeNamedCharacterReference($2) || $0
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-from-markdown/node_modules/unist-util-stringify-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function lib_stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return unist_util_stringify_position_lib_position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return unist_util_stringify_position_lib_position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return unist_util_stringify_position_lib_point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function unist_util_stringify_position_lib_point(point) {
  return lib_index(point && point.line) + ':' + lib_index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function unist_util_stringify_position_lib_position(pos) {
  return unist_util_stringify_position_lib_point(pos && pos.start) + '-' + unist_util_stringify_position_lib_point(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function lib_index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-from-markdown/lib/index.js
/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */

/**
 * @typedef {Omit<Parent, 'children' | 'type'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */

/**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | null | undefined | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {undefined | void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */

/**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Fragment | Nodes>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {(this: CompileContext) => undefined} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {(this: CompileContext, node: Nodes, token: Token, onError?: OnEnterError) => undefined} enter
 *   Enter a node.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => undefined} exit
 *   Exit a node.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 * @property {CompileData} data
 *   Info passed around; key/value store.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */








const mdast_util_from_markdown_lib_own = {}.hasOwnProperty

/**
 * Turn markdown into a syntax tree.
 *
 * @overload
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @overload
 * @param {Value} value
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @param {Value} value
 *   Markdown to parse.
 * @param {Encoding | Options | null | undefined} [encoding]
 *   Character encoding for when `value` is `Buffer`.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {Root}
 *   mdast tree.
 */
function fromMarkdown(value, encoding, options) {
  if (typeof encoding !== 'string') {
    options = encoding
    encoding = undefined
  }
  return compiler(options)(
    postprocess(
      parse_parse(options).document().write(preprocess()(value, encoding, true))
    )
  )
}

/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */
function compiler(options) {
  /** @type {Config} */
  const config = {
    transforms: [],
    canContainEols: ['emphasis', 'fragment', 'heading', 'paragraph', 'strong'],
    enter: {
      autolink: opener(link),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading),
      blockQuote: opener(blockQuote),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis),
      hardBreakEscape: opener(hardBreak),
      hardBreakTrailing: opener(hardBreak),
      htmlFlow: opener(html, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html, buffer),
      htmlTextData: onenterdata,
      image: opener(image),
      label: buffer,
      link: opener(link),
      listItem: opener(listItem),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list, onenterlistordered),
      listUnordered: opener(list),
      paragraph: opener(paragraph),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading),
      strong: opener(strong),
      thematicBreak: opener(thematicBreak)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  }
  configure(config, (options || {}).mdastExtensions || [])

  /** @type {CompileData} */
  const data = {}
  return compile

  /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */
  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    }
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */
    const context = {
      stack: [tree],
      tokenStack: [],
      config,
      enter,
      exit,
      buffer,
      resume,
      data
    }
    /** @type {Array<number>} */
    const listStack = []
    let index = -1
    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index)
        } else {
          const tail = listStack.pop()
          index = prepareList(events, tail, index)
        }
      }
    }
    index = -1
    while (++index < events.length) {
      const handler = config[events[index][0]]
      if (mdast_util_from_markdown_lib_own.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        )
      }
    }

    // Handle tokens still being open.
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1]
      const handler = tail[1] || defaultOnError
      handler.call(context, undefined, tail[0])
    }

    // Figure out `root` position.
    tree.position = {
      start: mdast_util_from_markdown_lib_point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: mdast_util_from_markdown_lib_point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    }

    // Call transforms.
    index = -1
    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree
    }
    return tree
  }

  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */
  function prepareList(events, start, length) {
    let index = start - 1
    let containerBalance = -1
    let listSpread = false
    /** @type {Token | undefined} */
    let listItem
    /** @type {number | undefined} */
    let lineIndex
    /** @type {number | undefined} */
    let firstBlankLineIndex
    /** @type {boolean | undefined} */
    let atMarker
    while (++index <= length) {
      const event = events[index]
      switch (event[1].type) {
        case 'listUnordered':
        case 'listOrdered':
        case 'blockQuote': {
          if (event[0] === 'enter') {
            containerBalance++
          } else {
            containerBalance--
          }
          atMarker = undefined
          break
        }
        case 'lineEndingBlank': {
          if (event[0] === 'enter') {
            if (
              listItem &&
              !atMarker &&
              !containerBalance &&
              !firstBlankLineIndex
            ) {
              firstBlankLineIndex = index
            }
            atMarker = undefined
          }
          break
        }
        case 'linePrefix':
        case 'listItemValue':
        case 'listItemMarker':
        case 'listItemPrefix':
        case 'listItemPrefixWhitespace': {
          // Empty.

          break
        }
        default: {
          atMarker = undefined
        }
      }
      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index
          lineIndex = undefined
          while (tailIndex--) {
            const tailEvent = events[tailIndex]
            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue
              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank'
                listSpread = true
              }
              tailEvent[1].type = 'lineEnding'
              lineIndex = tailIndex
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) {
              // Empty
            } else {
              break
            }
          }
          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            listItem._spread = true
          }

          // Fix position.
          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          )
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]])
          index++
          length++
        }

        // Create a new list item.
        if (event[1].type === 'listItemPrefix') {
          /** @type {Token} */
          const item = {
            type: 'listItem',
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: undefined
          }
          listItem = item
          events.splice(index, 0, ['enter', item, event[2]])
          index++
          length++
          firstBlankLineIndex = undefined
          atMarker = true
        }
      }
    }
    events[start][1]._spread = listSpread
    return length
  }

  /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function opener(create, and) {
    return open

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function open(token) {
      enter.call(this, create(token), token)
      if (and) and.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   * @returns {undefined}
   */
  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    })
  }

  /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */
  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1]
    /** @type {Array<Nodes>} */
    const siblings = parent.children
    siblings.push(node)
    this.stack.push(node)
    this.tokenStack.push([token, errorHandler])
    node.position = {
      start: mdast_util_from_markdown_lib_point(token.start),
      // @ts-expect-error: `end` will be patched later.
      end: undefined
    }
  }

  /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function closer(and) {
    return close

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function close(token) {
      if (and) and.call(this, token)
      exit.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */
  function exit(token, onExitError) {
    const node = this.stack.pop()
    const open = this.tokenStack.pop()
    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          lib_stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0])
      } else {
        const handler = open[1] || defaultOnError
        handler.call(this, token, open[0])
      }
    }
    node.position.end = mdast_util_from_markdown_lib_point(token.end)
  }

  /**
   * @this {CompileContext}
   * @returns {string}
   */
  function resume() {
    return lib_toString(this.stack.pop())
  }

  //
  // Handlers.
  //

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistordered() {
    this.data.expectingFirstListItemValue = true
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistitemvalue(token) {
    if (this.data.expectingFirstListItemValue) {
      const ancestor = this.stack[this.stack.length - 2]
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10)
      this.data.expectingFirstListItemValue = undefined
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfenceinfo() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.lang = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfencemeta() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.meta = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (this.data.flowCodeInside) return
    this.buffer()
    this.data.flowCodeInside = true
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefenced() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '')
    this.data.flowCodeInside = undefined
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodeindented() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data.replace(/(\r?\n|\r)$/g, '')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitionlabelstring(token) {
    const label = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiontitlestring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.title = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiondestinationstring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.url = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitatxheadingsequence(token) {
    const node = this.stack[this.stack.length - 1]
    if (!node.depth) {
      const depth = this.sliceSerialize(token).length
      node.depth = depth
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadingtext() {
    this.data.setextHeadingSlurpLineEnding = true
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadinglinesequence(token) {
    const node = this.stack[this.stack.length - 1]
    node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheading() {
    this.data.setextHeadingSlurpLineEnding = undefined
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterdata(token) {
    const node = this.stack[this.stack.length - 1]
    /** @type {Array<Nodes>} */
    const siblings = node.children
    let tail = siblings[siblings.length - 1]
    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text()
      tail.position = {
        start: mdast_util_from_markdown_lib_point(token.start),
        // @ts-expect-error: we’ll add `end` later.
        end: undefined
      }
      siblings.push(tail)
    }
    this.stack.push(tail)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitdata(token) {
    const tail = this.stack.pop()
    tail.value += this.sliceSerialize(token)
    tail.position.end = mdast_util_from_markdown_lib_point(token.end)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1]
    // If we’re at a hard break, include the line ending in there.
    if (this.data.atHardBreak) {
      const tail = context.children[context.children.length - 1]
      tail.position.end = mdast_util_from_markdown_lib_point(token.end)
      this.data.atHardBreak = undefined
      return
    }
    if (
      !this.data.setextHeadingSlurpLineEnding &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token)
      onexitdata.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithardbreak() {
    this.data.atHardBreak = true
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmlflow() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmltext() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcodetext() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlink() {
    const node = this.stack[this.stack.length - 1]
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.
    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut'
      node.type += 'Reference'
      // @ts-expect-error: mutate.
      node.referenceType = referenceType
      // @ts-expect-error: mutate.
      delete node.url
      delete node.title
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier
      // @ts-expect-error: mutate.
      delete node.label
    }
    this.data.referenceType = undefined
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitimage() {
    const node = this.stack[this.stack.length - 1]
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.
    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut'
      node.type += 'Reference'
      // @ts-expect-error: mutate.
      node.referenceType = referenceType
      // @ts-expect-error: mutate.
      delete node.url
      delete node.title
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier
      // @ts-expect-error: mutate.
      delete node.label
    }
    this.data.referenceType = undefined
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabeltext(token) {
    const string = this.sliceSerialize(token)
    const ancestor = this.stack[this.stack.length - 2]
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    ancestor.label = decodeString(string)
    // @ts-expect-error: same as above.
    ancestor.identifier = normalizeIdentifier(string).toLowerCase()
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1]
    const value = this.resume()
    const node = this.stack[this.stack.length - 1]
    // Assume a reference.
    this.data.inReference = true
    if (node.type === 'link') {
      /** @type {Array<PhrasingContent>} */
      const children = fragment.children
      node.children = children
    } else {
      node.alt = value
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcedestinationstring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.url = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcetitlestring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.title = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresource() {
    this.data.inReference = undefined
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterreference() {
    this.data.referenceType = 'collapsed'
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitreferencestring(token) {
    const label = this.resume()
    const node = this.stack[this.stack.length - 1]
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    node.label = label
    // @ts-expect-error: same as above.
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
    this.data.referenceType = 'full'
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcharacterreferencemarker(token) {
    this.data.characterReferenceType = token.type
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token)
    const type = this.data.characterReferenceType
    /** @type {string} */
    let value
    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      )
      this.data.characterReferenceType = undefined
    } else {
      const result = decodeNamedCharacterReference(data)
      value = result
    }
    const tail = this.stack.pop()
    tail.value += value
    tail.position.end = mdast_util_from_markdown_lib_point(token.end)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token)
    const node = this.stack[this.stack.length - 1]
    node.url = this.sliceSerialize(token)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkemail(token) {
    onexitdata.call(this, token)
    const node = this.stack[this.stack.length - 1]
    node.url = 'mailto:' + this.sliceSerialize(token)
  }

  //
  // Creaters.
  //

  /** @returns {Blockquote} */
  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }

  /** @returns {Code} */
  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }

  /** @returns {InlineCode} */
  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }

  /** @returns {Definition} */
  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }

  /** @returns {Emphasis} */
  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }

  /** @returns {Heading} */
  function heading() {
    return {
      type: 'heading',
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    }
  }

  /** @returns {Break} */
  function hardBreak() {
    return {
      type: 'break'
    }
  }

  /** @returns {Html} */
  function html() {
    return {
      type: 'html',
      value: ''
    }
  }

  /** @returns {Image} */
  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }

  /** @returns {Link} */
  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }

  /**
   * @param {Token} token
   * @returns {List}
   */
  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      spread: token._spread,
      children: []
    }
  }

  /**
   * @param {Token} token
   * @returns {ListItem}
   */
  function listItem(token) {
    return {
      type: 'listItem',
      spread: token._spread,
      checked: null,
      children: []
    }
  }

  /** @returns {Paragraph} */
  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }

  /** @returns {Strong} */
  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }

  /** @returns {Text} */
  function text() {
    return {
      type: 'text',
      value: ''
    }
  }

  /** @returns {ThematicBreak} */
  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}

/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */
function mdast_util_from_markdown_lib_point(d) {
  return {
    line: d.line,
    column: d.column,
    offset: d.offset
  }
}

/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */
function configure(combined, extensions) {
  let index = -1
  while (++index < extensions.length) {
    const value = extensions[index]
    if (Array.isArray(value)) {
      configure(combined, value)
    } else {
      extension(combined, value)
    }
  }
}

/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */
function extension(combined, extension) {
  /** @type {keyof Extension} */
  let key
  for (key in extension) {
    if (mdast_util_from_markdown_lib_own.call(extension, key)) {
      switch (key) {
        case 'canContainEols': {
          const right = extension[key]
          if (right) {
            combined[key].push(...right)
          }
          break
        }
        case 'transforms': {
          const right = extension[key]
          if (right) {
            combined[key].push(...right)
          }
          break
        }
        case 'enter':
        case 'exit': {
          const right = extension[key]
          if (right) {
            Object.assign(combined[key], right)
          }
          break
        }
        // No default
      }
    }
  }
}

/** @type {OnEnterError} */
function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        lib_stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        lib_stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        lib_stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/remark-parse/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */

/**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */



/**
 * Aadd support for parsing from markdown.
 *
 * @param {Readonly<Options> | null | undefined} [options]
 *   Configuration (optional).
 * @returns {undefined}
 *   Nothing.
 */
function remarkParse(options) {
  /** @type {Processor} */
  // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
  const self = this

  self.parser = parser

  /**
   * @type {Parser}
   */
  function parser(doc) {
    return fromMarkdown(doc, {
      ...self.data('settings'),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self.data('micromarkExtensions') || [],
      mdastExtensions: self.data('fromMarkdownExtensions') || []
    })
  }
}

;// CONCATENATED MODULE: ./node_modules/@ungap/structured-clone/esm/types.js
const VOID       = -1;
const PRIMITIVE  = 0;
const ARRAY      = 1;
const OBJECT     = 2;
const DATE       = 3;
const REGEXP     = 4;
const MAP        = 5;
const SET        = 6;
const ERROR      = 7;
const BIGINT     = 8;
// export const SYMBOL = 9;

;// CONCATENATED MODULE: ./node_modules/@ungap/structured-clone/esm/deserialize.js


const env = typeof self === 'object' ? self : globalThis;

const deserializer = ($, _) => {
  const as = (out, index) => {
    $.set(index, out);
    return out;
  };

  const unpair = index => {
    if ($.has(index))
      return $.get(index);

    const [type, value] = _[index];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY: {
        const arr = as([], index);
        for (const index of value)
          arr.push(unpair(index));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index);
        for (const [key, index] of value)
          object[unpair(key)] = unpair(index);
        return object;
      }
      case DATE:
        return as(new Date(value), index);
      case REGEXP: {
        const {source, flags} = value;
        return as(new RegExp(source, flags), index);
      }
      case MAP: {
        const map = as(new Map, index);
        for (const [key, index] of value)
          map.set(unpair(key), unpair(index));
        return map;
      }
      case SET: {
        const set = as(new Set, index);
        for (const index of value)
          set.add(unpair(index));
        return set;
      }
      case ERROR: {
        const {name, message} = value;
        return as(new env[name](message), index);
      }
      case BIGINT:
        return as(BigInt(value), index);
      case 'BigInt':
        return as(Object(BigInt(value)), index);
    }
    return as(new env[type](value), index);
  };

  return unpair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns a deserialized value from a serialized array of Records.
 * @param {Record[]} serialized a previously serialized value.
 * @returns {any}
 */
const deserialize = serialized => deserializer(new Map, serialized)(0);

;// CONCATENATED MODULE: ./node_modules/@ungap/structured-clone/esm/serialize.js


const EMPTY = '';

const {toString: serialize_toString} = {};
const {keys} = Object;

const typeOf = value => {
  const type = typeof value;
  if (type !== 'object' || !value)
    return [PRIMITIVE, type];

  const asString = serialize_toString.call(value).slice(8, -1);
  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];
    case 'Object':
      return [OBJECT, EMPTY];
    case 'Date':
      return [DATE, EMPTY];
    case 'RegExp':
      return [REGEXP, EMPTY];
    case 'Map':
      return [MAP, EMPTY];
    case 'Set':
      return [SET, EMPTY];
  }

  if (asString.includes('Array'))
    return [ARRAY, asString];

  if (asString.includes('Error'))
    return [ERROR, asString];

  return [OBJECT, asString];
};

const shouldSkip = ([TYPE, type]) => (
  TYPE === PRIMITIVE &&
  (type === 'function' || type === 'symbol')
);

const serializer = (strict, json, $, _) => {

  const as = (out, value) => {
    const index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };

  const pair = value => {
    if ($.has(value))
      return $.get(value);

    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case 'bigint':
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case 'function':
          case 'symbol':
            if (strict)
              throw new TypeError('unable to serialize ' + type);
            entry = null;
            break;
          case 'undefined':
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type)
          return as([type, [...value]], value);
  
        const arr = [];
        const index = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case 'BigInt':
              return as([type, value.toString()], value);
            case 'Boolean':
            case 'Number':
            case 'String':
              return as([type, value.valueOf()], value);
          }
        }

        if (json && ('toJSON' in value))
          return pair(value.toJSON());

        const entries = [];
        const index = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const {source, flags} = value;
        return as([TYPE, {source, flags}], value);
      }
      case MAP: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index;
      }
      case SET: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index;
      }
    }

    const {message} = value;
    return as([TYPE, {name: type, message}], value);
  };

  return pair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} value a serializable value.
 * @param {{json?: boolean, lossy?: boolean}?} options an object with a `lossy` or `json` property that,
 *  if `true`, will not throw errors on incompatible types, and behave more
 *  like JSON stringify would behave. Symbol and Function will be discarded.
 * @returns {Record[]}
 */
 const serialize = (value, {json, lossy} = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, new Map, _)(value), _;
};

;// CONCATENATED MODULE: ./node_modules/@ungap/structured-clone/esm/index.js



/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */
/* harmony default export */ var structured_clone_esm = (typeof structuredClone === "function" ?
  /* c8 ignore start */
  (any, options) => (
    options && ('json' in options || 'lossy' in options) ?
      deserialize(serialize(any, options)) : structuredClone(any)
  ) :
  (any, options) => deserialize(serialize(any, options)));
  /* c8 ignore stop */



;// CONCATENATED MODULE: ./node_modules/micromark-util-sanitize-uri/index.js


/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri`).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * A regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`, or
 * `/^https?$/i` for `img[src]` (this is what `github.com` allows).
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string | null | undefined} url
 *   URI to sanitize.
 * @param {RegExp | null | undefined} [protocol]
 *   Allowed protocols.
 * @returns {string}
 *   Sanitized URI.
 */
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ''))
  if (!protocol) {
    return value
  }
  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')
  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }
  return ''
}

/**
 * Normalize a URL.
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 *   URI to normalize.
 * @returns {string}
 *   Normalized URI.
 */
function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0
  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */
    let replace = ''

    // A correct percent encoded value.
    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    }
    // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    }
    // Astral.
    else if (code > 55_295 && code < 57_344) {
      const next = value.charCodeAt(index + 1)

      // A correct surrogate pair.
      if (code < 56_320 && next > 56_319 && next < 57_344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      }
      // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    }
    // Unicode.
    else {
      replace = String.fromCharCode(code)
    }
    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }
    if (skip) {
      index += skip
      skip = 0
    }
  }
  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/footer.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */

/**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */




/**
 * Generate the default content that GitHub uses on backreferences.
 *
 * @param {number} _
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent>}
 *   Content.
 */
function defaultFootnoteBackContent(_, rereferenceIndex) {
  /** @type {Array<ElementContent>} */
  const result = [{type: 'text', value: '↩'}]

  if (rereferenceIndex > 1) {
    result.push({
      type: 'element',
      tagName: 'sup',
      properties: {},
      children: [{type: 'text', value: String(rereferenceIndex)}]
    })
  }

  return result
}

/**
 * Generate the default label that GitHub uses on backreferences.
 *
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Label.
 */
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return (
    'Back to reference ' +
    (referenceIndex + 1) +
    (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
  )
}

/**
 * Generate a hast footer for called footnote definitions.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Element | undefined}
 *   `section` element or `undefined`.
 */
// eslint-disable-next-line complexity
function footer(state) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-'
  const footnoteBackContent =
    state.options.footnoteBackContent || defaultFootnoteBackContent
  const footnoteBackLabel =
    state.options.footnoteBackLabel || defaultFootnoteBackLabel
  const footnoteLabel = state.options.footnoteLabel || 'Footnotes'
  const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2'
  const footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ['sr-only']
  }
  /** @type {Array<ElementContent>} */
  const listItems = []
  let referenceIndex = -1

  while (++referenceIndex < state.footnoteOrder.length) {
    const def = state.footnoteById.get(state.footnoteOrder[referenceIndex])

    if (!def) {
      continue
    }

    const content = state.all(def)
    const id = String(def.identifier).toUpperCase()
    const safeId = normalizeUri(id.toLowerCase())
    let rereferenceIndex = 0
    /** @type {Array<ElementContent>} */
    const backReferences = []
    const counts = state.footnoteCounts.get(id)

    // eslint-disable-next-line no-unmodified-loop-condition
    while (counts !== undefined && ++rereferenceIndex <= counts) {
      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '})
      }

      let children =
        typeof footnoteBackContent === 'string'
          ? footnoteBackContent
          : footnoteBackContent(referenceIndex, rereferenceIndex)

      if (typeof children === 'string') {
        children = {type: 'text', value: children}
      }

      backReferences.push({
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            clobberPrefix +
            'fnref-' +
            safeId +
            (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
          dataFootnoteBackref: '',
          ariaLabel:
            typeof footnoteBackLabel === 'string'
              ? footnoteBackLabel
              : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ['data-footnote-backref']
        },
        children: Array.isArray(children) ? children : [children]
      })
    }

    const tail = content[content.length - 1]

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1]
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' '
      } else {
        tail.children.push({type: 'text', value: ' '})
      }

      tail.children.push(...backReferences)
    } else {
      content.push(...backReferences)
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: clobberPrefix + 'fn-' + safeId},
      children: state.wrap(content, true)
    }

    state.patch(def, listItem)

    listItems.push(listItem)
  }

  if (listItems.length === 0) {
    return
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: footnoteLabelTagName,
        properties: {
          ...structured_clone_esm(footnoteLabelProperties),
          id: 'footnote-label'
        },
        children: [{type: 'text', value: footnoteLabel}]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: state.wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

;// CONCATENATED MODULE: ./node_modules/unist-util-is/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */

/**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */

/**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */

/**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */
const is =
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */
    // eslint-disable-next-line max-params
    function (node, test, index, parent, context) {
      const check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      return looksLikeANode(node)
        ? check.call(context, node, index, parent)
        : false
    }
  )

/**
 * Generate an assertion from a test.
 *
 * Useful if you’re going to test many nodes, for example when creating a
 * utility where something else passes a compatible test.
 *
 * The created function is a bit faster because it expects valid input only:
 * a `node`, `index`, and `parent`.
 *
 * @param {Test} test
 *   *   when nullish, checks if `node` is a `Node`.
 *   *   when `string`, works like passing `(node) => node.type === test`.
 *   *   when `function` checks if function passed the node is true.
 *   *   when `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
 *   *   when `array`, checks if any one of the subtests pass.
 * @returns {Check}
 *   An assertion.
 */
const convert =
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  (
    /**
     * @param {Test} [test]
     * @returns {Check}
     */
    function (test) {
      if (test === null || test === undefined) {
        return lib_ok
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )

/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */
function anyFactory(tests) {
  /** @type {Array<Check>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @type {TestFunction}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].apply(this, parameters)) return true
    }

    return false
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */
function propsFactory(check) {
  const checkAsRecord = /** @type {Record<string, unknown>} */ (check)

  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    const nodeAsRecord = /** @type {Record<string, unknown>} */ (
      /** @type {unknown} */ (node)
    )

    /** @type {string} */
    let key

    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false
    }

    return true
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */
function castFactory(testFunction) {
  return check

  /**
   * @this {unknown}
   * @type {Check}
   */
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode(value) &&
        testFunction.call(
          this,
          value,
          typeof index === 'number' ? index : undefined,
          parent || undefined
        )
    )
  }
}

function lib_ok() {
  return true
}

/**
 * @param {unknown} value
 * @returns {value is Node}
 */
function looksLikeANode(value) {
  return value !== null && typeof value === 'object' && 'type' in value
}

;// CONCATENATED MODULE: ./node_modules/unist-util-visit-parents/lib/color.js
/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

;// CONCATENATED MODULE: ./node_modules/unist-util-visit-parents/lib/index.js
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */

/**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */

/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */

/**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */

/**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */

/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */

/**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */

/**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */

/**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */

/**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */




/** @type {Readonly<ActionTuple>} */
const lib_empty = []

/**
 * Continue traversing as normal.
 */
const CONTINUE = true

/**
 * Stop traversing immediately.
 */
const EXIT = false

/**
 * Do not traverse this node’s children.
 */
const SKIP = 'skip'

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} test
 *   `unist-util-is`-compatible test
 * @param {Visitor | boolean | null | undefined} [visitor]
 *   Handle each node.
 * @param {boolean | null | undefined} [reverse]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visitParents(tree, test, visitor, reverse) {
  /** @type {Test} */
  let check

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    // @ts-expect-error no visitor given, so `visitor` is test.
    visitor = test
  } else {
    // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test
  }

  const is = convert(check)
  const step = reverse ? -1 : 1

  factory(tree, undefined, [])()

  /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */
  function factory(node, index, parents) {
    const value = /** @type {Record<string, unknown>} */ (
      node && typeof node === 'object' ? node : {}
    )

    if (typeof value.type === 'string') {
      const name =
        // `hast`
        typeof value.tagName === 'string'
          ? value.tagName
          : // `xast`
          typeof value.name === 'string'
          ? value.name
          : undefined

      Object.defineProperty(visit, 'name', {
        value:
          'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
      })
    }

    return visit

    function visit() {
      /** @type {Readonly<ActionTuple>} */
      let result = lib_empty
      /** @type {Readonly<ActionTuple>} */
      let subresult
      /** @type {number} */
      let offset
      /** @type {Array<UnistParent>} */
      let grandparents

      if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
        // @ts-expect-error: `visitor` is now a visitor.
        result = toResult(visitor(node, parents))

        if (result[0] === EXIT) {
          return result
        }
      }

      if ('children' in node && node.children) {
        const nodeAsParent = /** @type {UnistParent} */ (node)

        if (nodeAsParent.children && result[0] !== SKIP) {
          offset = (reverse ? nodeAsParent.children.length : -1) + step
          grandparents = parents.concat(nodeAsParent)

          while (offset > -1 && offset < nodeAsParent.children.length) {
            const child = nodeAsParent.children[offset]

            subresult = factory(child, offset, grandparents)()

            if (subresult[0] === EXIT) {
              return subresult
            }

            offset =
              typeof subresult[1] === 'number' ? subresult[1] : offset + step
          }
        }
      }

      return result
    }
  }
}

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return value === null || value === undefined ? lib_empty : [value]
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/node_modules/unist-util-visit/lib/index.js
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */

// To do: use types from `unist-util-visit-parents` when it’s released.

/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */

/**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */

/**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */

/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */

/**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */

/**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */

/**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */





/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  let reverse
  /** @type {Test} */
  let test
  /** @type {Visitor} */
  let visitor

  if (
    typeof testOrVisitor === 'function' &&
    typeof visitorOrReverse !== 'function'
  ) {
    test = undefined
    visitor = testOrVisitor
    reverse = visitorOrReverse
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse
    reverse = maybeReverse
  }

  visitParents(tree, test, overload, reverse)

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    const parent = parents[parents.length - 1]
    const index = parent ? parent.children.indexOf(node) : undefined
    return visitor(node, index, parent)
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/node_modules/unist-util-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const lib_pointEnd = unist_util_position_lib_point('end')

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const lib_pointStart = unist_util_position_lib_point('start')

/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */
function unist_util_position_lib_point(type) {
  return point

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    if (
      typeof point.line === 'number' &&
      point.line > 0 &&
      typeof point.column === 'number' &&
      point.column > 0
    ) {
      return {
        line: point.line,
        column: point.column,
        offset:
          typeof point.offset === 'number' && point.offset > -1
            ? point.offset
            : undefined
      }
    }
  }
}

/**
 * Get the positional info of `node`.
 *
 * @param {Node | NodeLike | null | undefined} [node]
 *   Node.
 * @returns {Position | undefined}
 *   Position.
 */
function unist_util_position_lib_position(node) {
  const start = lib_pointStart(node)
  const end = lib_pointEnd(node)

  if (start && end) {
    return {start, end}
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function blockquote(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'blockquote',
    properties: {},
    children: state.wrap(state.all(node), true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */
function hardBreak(state, node) {
  /** @type {Element} */
  const result = {type: 'element', tagName: 'br', properties: {}, children: []}
  state.patch(node, result)
  return [state.applyData(node, result), {type: 'text', value: '\n'}]
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function code(state, node) {
  const value = node.value ? node.value + '\n' : ''
  /** @type {Properties} */
  const properties = {}

  if (node.lang) {
    properties.className = ['language-' + node.lang]
  }

  // Create `<code>`.
  /** @type {Element} */
  let result = {
    type: 'element',
    tagName: 'code',
    properties,
    children: [{type: 'text', value}]
  }

  if (node.meta) {
    result.data = {meta: node.meta}
  }

  state.patch(node, result)
  result = state.applyData(node, result)

  // Create `<pre>`.
  result = {type: 'element', tagName: 'pre', properties: {}, children: [result]}
  state.patch(node, result)
  return result
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/delete.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strikethrough(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'del',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function emphasis(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'em',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `footnoteReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {FootnoteReference} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnoteReference(state, node) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-'
  const id = String(node.identifier).toUpperCase()
  const safeId = normalizeUri(id.toLowerCase())
  const index = state.footnoteOrder.indexOf(id)
  /** @type {number} */
  let counter

  let reuseCounter = state.footnoteCounts.get(id)

  if (reuseCounter === undefined) {
    reuseCounter = 0
    state.footnoteOrder.push(id)
    counter = state.footnoteOrder.length
  } else {
    counter = index + 1
  }

  reuseCounter += 1
  state.footnoteCounts.set(id, reuseCounter)

  /** @type {Element} */
  const link = {
    type: 'element',
    tagName: 'a',
    properties: {
      href: '#' + clobberPrefix + 'fn-' + safeId,
      id:
        clobberPrefix +
        'fnref-' +
        safeId +
        (reuseCounter > 1 ? '-' + reuseCounter : ''),
      dataFootnoteRef: true,
      ariaDescribedBy: ['footnote-label']
    },
    children: [{type: 'text', value: String(counter)}]
  }
  state.patch(node, link)

  /** @type {Element} */
  const sup = {
    type: 'element',
    tagName: 'sup',
    properties: {},
    children: [link]
  }
  state.patch(node, sup)
  return state.applyData(node, sup)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/heading.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function heading(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'h' + node.depth,
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/html.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */
function html_html(state, node) {
  if (state.options.allowDangerousHtml) {
    /** @type {Raw} */
    const result = {type: 'raw', value: node.value}
    state.patch(node, result)
    return state.applyData(node, result)
  }

  return undefined
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/revert.js
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */
function revert(state, node) {
  const subtype = node.referenceType
  let suffix = ']'

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return [{type: 'text', value: '![' + node.alt + suffix}]
  }

  const contents = state.all(node)
  const head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift({type: 'text', value: '['})
  }

  const tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push({type: 'text', value: suffix})
  }

  return contents
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `imageReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ImageReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function imageReference(state, node) {
  const id = String(node.identifier).toUpperCase()
  const def = state.definitionById.get(id)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {src: normalizeUri(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/image.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `image` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Image} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function image_image(state, node) {
  /** @type {Properties} */
  const properties = {src: normalizeUri(node.url)}

  if (node.alt !== null && node.alt !== undefined) {
    properties.alt = node.alt
  }

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function inlineCode(state, node) {
  /** @type {Text} */
  const text = {type: 'text', value: node.value.replace(/\r?\n|\r/g, ' ')}
  state.patch(node, text)

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'code',
    properties: {},
    children: [text]
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `linkReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {LinkReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function linkReference(state, node) {
  const id = String(node.identifier).toUpperCase()
  const def = state.definitionById.get(id)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {href: normalizeUri(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/link.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `link` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Link} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function link_link(state, node) {
  /** @type {Properties} */
  const properties = {href: normalizeUri(node.url)}

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/list-item.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function listItem(state, node, parent) {
  const results = state.all(node)
  const loose = parent ? listLoose(parent) : listItemLoose(node)
  /** @type {Properties} */
  const properties = {}
  /** @type {Array<ElementContent>} */
  const children = []

  if (typeof node.checked === 'boolean') {
    const head = results[0]
    /** @type {Element} */
    let paragraph

    if (head && head.type === 'element' && head.tagName === 'p') {
      paragraph = head
    } else {
      paragraph = {type: 'element', tagName: 'p', properties: {}, children: []}
      results.unshift(paragraph)
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift({type: 'text', value: ' '})
    }

    paragraph.children.unshift({
      type: 'element',
      tagName: 'input',
      properties: {type: 'checkbox', checked: node.checked, disabled: true},
      children: []
    })

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    properties.className = ['task-list-item']
  }

  let index = -1

  while (++index < results.length) {
    const child = results[index]

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      children.push({type: 'text', value: '\n'})
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      children.push(...child.children)
    } else {
      children.push(child)
    }
  }

  const tail = results[results.length - 1]

  // Add a final eol.
  if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) {
    children.push({type: 'text', value: '\n'})
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'li', properties, children}
  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * @param {Parents} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = false
  if (node.type === 'list') {
    loose = node.spread || false
    const children = node.children
    let index = -1

    while (!loose && ++index < children.length) {
      loose = listItemLoose(children[index])
    }
  }

  return loose
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread

  return spread === null || spread === undefined
    ? node.children.length > 1
    : spread
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/list.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function list_list(state, node) {
  /** @type {Properties} */
  const properties = {}
  const results = state.all(node)
  let index = -1

  if (typeof node.start === 'number' && node.start !== 1) {
    properties.start = node.start
  }

  // Like GitHub, add a class for custom styling.
  while (++index < results.length) {
    const child = results[index]

    if (
      child.type === 'element' &&
      child.tagName === 'li' &&
      child.properties &&
      Array.isArray(child.properties.className) &&
      child.properties.className.includes('task-list-item')
    ) {
      properties.className = ['contains-task-list']
      break
    }
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: node.ordered ? 'ol' : 'ul',
    properties,
    children: state.wrap(results, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function paragraph(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'p',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/root.js
/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */
function root_root(state, node) {
  /** @type {HastRoot} */
  const result = {type: 'root', children: state.wrap(state.all(node))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/strong.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strong(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'strong',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/table.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `table` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Table} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function table(state, node) {
  const rows = state.all(node)
  const firstRow = rows.shift()
  /** @type {Array<Element>} */
  const tableContent = []

  if (firstRow) {
    /** @type {Element} */
    const head = {
      type: 'element',
      tagName: 'thead',
      properties: {},
      children: state.wrap([firstRow], true)
    }
    state.patch(node.children[0], head)
    tableContent.push(head)
  }

  if (rows.length > 0) {
    /** @type {Element} */
    const body = {
      type: 'element',
      tagName: 'tbody',
      properties: {},
      children: state.wrap(rows, true)
    }

    const start = lib_pointStart(node.children[1])
    const end = lib_pointEnd(node.children[node.children.length - 1])
    if (start && end) body.position = {start, end}
    tableContent.push(body)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'table',
    properties: {},
    children: state.wrap(tableContent, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/table-row.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : undefined
  // Generate a body row when without parent.
  const rowIndex = siblings ? siblings.indexOf(node) : 1
  const tagName = rowIndex === 0 ? 'th' : 'td'
  // To do: option to use `style`?
  const align = parent && parent.type === 'table' ? parent.align : undefined
  const length = align ? align.length : node.children.length
  let cellIndex = -1
  /** @type {Array<ElementContent>} */
  const cells = []

  while (++cellIndex < length) {
    // Note: can also be undefined.
    const cell = node.children[cellIndex]
    /** @type {Properties} */
    const properties = {}
    const alignValue = align ? align[cellIndex] : undefined

    if (alignValue) {
      properties.align = alignValue
    }

    /** @type {Element} */
    let result = {type: 'element', tagName, properties, children: []}

    if (cell) {
      result.children = state.all(cell)
      state.patch(cell, result)
      result = state.applyData(cell, result)
    }

    cells.push(result)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'tr',
    properties: {},
    children: state.wrap(cells, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function tableCell(state, node) {
  // Note: this function is normally not called: see `table-row` for how rows
  // and their cells are compiled.
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'td', // Assume body cell.
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/trim-lines/index.js
const tab = 9 /* `\t` */
const space = 32 /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value)
  const search = /\r?\n|\r/g
  let match = search.exec(source)
  let last = 0
  /** @type {Array<string>} */
  const lines = []

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    )

    last = match.index + match[0].length
    match = search.exec(source)
  }

  lines.push(trimLine(source.slice(last), last > 0, false))

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0
  let endIndex = value.length

  if (start) {
    let code = value.codePointAt(startIndex)

    while (code === tab || code === space) {
      startIndex++
      code = value.codePointAt(startIndex)
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1)

    while (code === tab || code === space) {
      endIndex--
      code = value.codePointAt(endIndex - 1)
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/text.js
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `text` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastText} node
 *   mdast node.
 * @returns {HastElement | HastText}
 *   hast node.
 */
function handlers_text_text(state, node) {
  /** @type {HastText} */
  const result = {type: 'text', value: trimLines(String(node.value))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */

// Make VS Code show references to the above types.
''

/**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function thematic_break_thematicBreak(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'hr',
    properties: {},
    children: []
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/handlers/index.js
























/**
 * Default handlers for nodes.
 *
 * @satisfies {import('../state.js').Handlers}
 */
const handlers_handlers = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  delete: strikethrough,
  emphasis: emphasis,
  footnoteReference: footnoteReference,
  heading: heading,
  html: html_html,
  imageReference: imageReference,
  image: image_image,
  inlineCode: inlineCode,
  linkReference: linkReference,
  link: link_link,
  listItem: listItem,
  list: list_list,
  paragraph: paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root: root_root,
  strong: strong,
  table: table,
  tableCell: tableCell,
  tableRow: tableRow,
  text: handlers_text_text,
  thematicBreak: thematic_break_thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  return undefined
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/state.js
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */

/**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > 👉 **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */






const state_own = {}.hasOwnProperty

/** @type {Options} */
const state_emptyOptions = {}

/**
 * Create `state` from an mdast tree.
 *
 * @param {MdastNodes} tree
 *   mdast node to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {State}
 *   `state` function.
 */
function createState(tree, options) {
  const settings = options || state_emptyOptions
  /** @type {Map<string, MdastDefinition>} */
  const definitionById = new Map()
  /** @type {Map<string, MdastFootnoteDefinition>} */
  const footnoteById = new Map()
  /** @type {Map<string, number>} */
  const footnoteCounts = new Map()
  /** @type {Handlers} */
  // @ts-expect-error: the root handler returns a root.
  // Hard to type.
  const handlers = {...handlers_handlers, ...settings.handlers}

  /** @type {State} */
  const state = {
    all,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers,
    one,
    options: settings,
    patch,
    wrap
  }

  visit(tree, function (node) {
    if (node.type === 'definition' || node.type === 'footnoteDefinition') {
      const map = node.type === 'definition' ? definitionById : footnoteById
      const id = String(node.identifier).toUpperCase()

      // Mimick CM behavior of link definitions.
      // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
      if (!map.has(id)) {
        // @ts-expect-error: node type matches map.
        map.set(id, node)
      }
    }
  })

  return state

  /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */
  function one(node, parent) {
    const type = node.type
    const handle = state.handlers[type]

    if (state_own.call(state.handlers, type) && handle) {
      return handle(state, node, parent)
    }

    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ('children' in node) {
        const {children, ...shallow} = node
        const result = structured_clone_esm(shallow)
        // @ts-expect-error: TS doesn’t understand…
        result.children = state.all(node)
        // @ts-expect-error: TS doesn’t understand…
        return result
      }

      // @ts-expect-error: it’s custom.
      return structured_clone_esm(node)
    }

    const unknown = state.options.unknownHandler || defaultUnknownHandler

    return unknown(state, node, parent)
  }

  /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */
  function all(parent) {
    /** @type {Array<HastElementContent>} */
    const values = []

    if ('children' in parent) {
      const nodes = parent.children
      let index = -1
      while (++index < nodes.length) {
        const result = state.one(nodes[index], parent)

        // To do: see if we van clean this? Can we merge texts?
        if (result) {
          if (index && nodes[index - 1].type === 'break') {
            if (!Array.isArray(result) && result.type === 'text') {
              result.value = trimMarkdownSpaceStart(result.value)
            }

            if (!Array.isArray(result) && result.type === 'element') {
              const head = result.children[0]

              if (head && head.type === 'text') {
                head.value = trimMarkdownSpaceStart(head.value)
              }
            }
          }

          if (Array.isArray(result)) {
            values.push(...result)
          } else {
            values.push(result)
          }
        }
      }
    }

    return values
  }
}

/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */
function patch(from, to) {
  if (from.position) to.position = unist_util_position_lib_position(from)
}

/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */
function applyData(from, to) {
  /** @type {HastElement | Type} */
  let result = to

  // Handle `data.hName`, `data.hProperties, `data.hChildren`.
  if (from && from.data) {
    const hName = from.data.hName
    const hChildren = from.data.hChildren
    const hProperties = from.data.hProperties

    if (typeof hName === 'string') {
      // Transforming the node resulted in an element with a different name
      // than wanted:
      if (result.type === 'element') {
        result.tagName = hName
      }
      // Transforming the node resulted in a non-element, which happens for
      // raw, text, and root nodes (unless custom handlers are passed).
      // The intent of `hName` is to create an element, but likely also to keep
      // the content around (otherwise: pass `hChildren`).
      else {
        /** @type {Array<HastElementContent>} */
        // @ts-expect-error: assume no doctypes in `root`.
        const children = 'children' in result ? result.children : [result]
        result = {type: 'element', tagName: hName, properties: {}, children}
      }
    }

    if (result.type === 'element' && hProperties) {
      Object.assign(result.properties, structured_clone_esm(hProperties))
    }

    if (
      'children' in result &&
      result.children &&
      hChildren !== null &&
      hChildren !== undefined
    ) {
      result.children = hChildren
    }
  }

  return result
}

/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */
function defaultUnknownHandler(state, node) {
  const data = node.data || {}
  /** @type {HastElement | HastText} */
  const result =
    'value' in node &&
    !(state_own.call(data, 'hProperties') || state_own.call(data, 'hChildren'))
      ? {type: 'text', value: node.value}
      : {
          type: 'element',
          tagName: 'div',
          properties: {},
          children: state.all(node)
        }

  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * Wrap `nodes` with line endings between each node.
 *
 * @template {HastRootContent} Type
 *   Node type.
 * @param {Array<Type>} nodes
 *   List of nodes to wrap.
 * @param {boolean | undefined} [loose=false]
 *   Whether to add line endings at start and end (default: `false`).
 * @returns {Array<HastText | Type>}
 *   Wrapped nodes.
 */
function wrap(nodes, loose) {
  /** @type {Array<HastText | Type>} */
  const result = []
  let index = -1

  if (loose) {
    result.push({type: 'text', value: '\n'})
  }

  while (++index < nodes.length) {
    if (index) result.push({type: 'text', value: '\n'})
    result.push(nodes[index])
  }

  if (loose && nodes.length > 0) {
    result.push({type: 'text', value: '\n'})
  }

  return result
}

/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */
function trimMarkdownSpaceStart(value) {
  let index = 0
  let code = value.charCodeAt(index)

  while (code === 9 || code === 32) {
    index++
    code = value.charCodeAt(index)
  }

  return value.slice(index)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-hast/lib/index.js
/**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */





/**
 * Transform mdast to hast.
 *
 * ##### Notes
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most utilities ignore `raw` nodes but two notable ones don’t:
 *
 * *   `hast-util-to-html` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful
 *     if you completely trust authors
 * *   `hast-util-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only
 *     way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `mdast-util-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * Example: headings (DOM clobbering) in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @param {MdastNodes} tree
 *   mdast tree.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {HastNodes}
 *   hast tree.
 */
function toHast(tree, options) {
  const state = createState(tree, options)
  const node = state.one(tree, undefined)
  const foot = footer(state)
  /** @type {HastNodes} */
  const result = Array.isArray(node)
    ? {type: 'root', children: node}
    : node || {type: 'root', children: []}

  if (foot) {
    // If there’s a footer, there were definitions, meaning block
    // content.
    // So `result` is a parent node.
    ok('children' in result)
    result.children.push({type: 'text', value: '\n'}, foot)
  }

  return result
}

;// CONCATENATED MODULE: ./node_modules/remark-rehype/lib/index.js
// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />

/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} ToHastOptions
 * @typedef {import('unified').Processor} Processor
 * @typedef {import('vfile').VFile} VFile
 */

/**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */



/**
 * Turn markdown into HTML.
 *
 * ##### Notes
 *
 * ###### Signature
 *
 * *   if a processor is given, runs the (rehype) plugins used on it with a
 *     hast tree, then discards the result (*bridge mode*)
 * *   otherwise, returns a hast tree, the plugins used after `remarkRehype`
 *     are rehype plugins (*mutate mode*)
 *
 * > 👉 **Note**: It’s highly unlikely that you want to pass a `processor`.
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most plugins ignore `raw` nodes but two notable ones don’t:
 *
 * *   `rehype-stringify` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful if
 *     you completely trust authors
 * *   `rehype-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only way
 *     to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `remark-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * *Example: headings (DOM clobbering)* in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @overload
 * @param {Processor} processor
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformBridge}
 *
 * @overload
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformMutate}
 *
 * @param {Readonly<Options> | Processor | null | undefined} [destination]
 *   Processor or configuration (optional).
 * @param {Readonly<Options> | null | undefined} [options]
 *   When a processor was given, configuration (optional).
 * @returns {TransformBridge | TransformMutate}
 *   Transform.
 */
function remarkRehype(destination, options) {
  if (destination && 'run' in destination) {
    /**
     * @type {TransformBridge}
     */
    return async function (tree, file) {
      // Cast because root in -> root out.
      const hastTree = /** @type {HastRoot} */ (
        toHast(tree, {file, ...options})
      )
      await destination.run(hastTree, file)
    }
  }

  /**
   * @type {TransformMutate}
   */
  return function (tree, file) {
    // Cast because root in -> root out.
    return /** @type {HastRoot} */ (
      toHast(tree, {file, ...(options || destination)})
    )
  }
}

;// CONCATENATED MODULE: ./node_modules/bail/index.js
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

// EXTERNAL MODULE: ./node_modules/extend/index.js
var extend = __webpack_require__(4470);
;// CONCATENATED MODULE: ./node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ./node_modules/trough/index.js
/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = []
  /** @type {Pipeline} */
  const pipeline = {run, use}

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1
    /** @type {Callback} */
    const callback = values.pop()

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values)

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex]
      let index = -1

      if (error) {
        callback(error)
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index]
        }
      }

      // Save the newly created `output` for the next call.
      values = output

      // Next or done.
      if (fn) {
        trough_wrap(fn, next)(...output)
      } else {
        callback(null, ...output)
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware)
    return pipeline
  }
}

/**
 * Wrap `middleware`.
 * Can be sync or async; return a promise, receive a callback, or return new
 * values and errors.
 *
 * @param {Middleware} middleware
 * @param {Callback} callback
 */
function trough_wrap(middleware, callback) {
  /** @type {boolean} */
  let called

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length
    /** @type {any} */
    let result

    if (fnExpectsCallback) {
      parameters.push(done)
    }

    try {
      result = middleware.apply(this, parameters)
    } catch (error) {
      const exception = /** @type {Error} */ (error)

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  /**
   * Call `callback`, only once.
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true
      callback(error, ...output)
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value)
  }
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/unist-util-stringify-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function unist_util_stringify_position_lib_stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return node_modules_unist_util_stringify_position_lib_position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return node_modules_unist_util_stringify_position_lib_position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return node_modules_unist_util_stringify_position_lib_point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function node_modules_unist_util_stringify_position_lib_point(point) {
  return unist_util_stringify_position_lib_index(point && point.line) + ':' + unist_util_stringify_position_lib_index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function node_modules_unist_util_stringify_position_lib_position(pos) {
  return node_modules_unist_util_stringify_position_lib_point(pos && pos.start) + '-' + node_modules_unist_util_stringify_position_lib_point(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function unist_util_stringify_position_lib_index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile-message/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */



/**
 * Message.
 */
class lib_VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super()

    if (typeof optionsOrParentOrPlace === 'string') {
      origin = optionsOrParentOrPlace
      optionsOrParentOrPlace = undefined
    }

    /** @type {string} */
    let reason = ''
    /** @type {Options} */
    let options = {}
    let legacyCause = false

    if (optionsOrParentOrPlace) {
      // Point.
      if (
        'line' in optionsOrParentOrPlace &&
        'column' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace}
      }
      // Position.
      else if (
        'start' in optionsOrParentOrPlace &&
        'end' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace}
      }
      // Node.
      else if ('type' in optionsOrParentOrPlace) {
        options = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        }
      }
      // Options.
      else {
        options = {...optionsOrParentOrPlace}
      }
    }

    if (typeof causeOrReason === 'string') {
      reason = causeOrReason
    }
    // Error.
    else if (!options.cause && causeOrReason) {
      legacyCause = true
      reason = causeOrReason.message
      options.cause = causeOrReason
    }

    if (!options.ruleId && !options.source && typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        options.ruleId = origin
      } else {
        options.source = origin.slice(0, index)
        options.ruleId = origin.slice(index + 1)
      }
    }

    if (!options.place && options.ancestors && options.ancestors) {
      const parent = options.ancestors[options.ancestors.length - 1]

      if (parent) {
        options.place = parent.position
      }
    }

    const start =
      options.place && 'start' in options.place
        ? options.place.start
        : options.place

    /* eslint-disable no-unused-expressions */
    /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */
    this.ancestors = options.ancestors || undefined

    /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */
    this.cause = options.cause || undefined

    /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */
    this.column = start ? start.column : undefined

    /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */
    this.fatal = undefined

    /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */
    this.file

    // Field from `Error`.
    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.message = reason

    /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */
    this.line = start ? start.line : undefined

    // Field from `Error`.
    /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */
    this.name = unist_util_stringify_position_lib_stringifyPosition(options.place) || '1:1'

    /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */
    this.place = options.place || undefined

    /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */
    this.reason = this.message

    /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */
    this.ruleId = options.ruleId || undefined

    /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */
    this.source = options.source || undefined

    // Field from `Error`.
    /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */
    this.stack =
      legacyCause && options.cause && typeof options.cause.stack === 'string'
        ? options.cause.stack
        : ''

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */
    this.actual

    /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */
    this.expected

    /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */
    this.note

    /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */
    this.url
    /* eslint-enable no-unused-expressions */
  }
}

lib_VFileMessage.prototype.file = ''
lib_VFileMessage.prototype.name = ''
lib_VFileMessage.prototype.reason = ''
lib_VFileMessage.prototype.message = ''
lib_VFileMessage.prototype.stack = ''
lib_VFileMessage.prototype.column = undefined
lib_VFileMessage.prototype.line = undefined
lib_VFileMessage.prototype.ancestors = undefined
lib_VFileMessage.prototype.cause = undefined
lib_VFileMessage.prototype.fatal = undefined
lib_VFileMessage.prototype.place = undefined
lib_VFileMessage.prototype.ruleId = undefined
lib_VFileMessage.prototype.source = undefined

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const path = {basename, dirname, extname, join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */
function basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean | undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.codePointAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.codePointAt(index) === ext.codePointAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
function dirname(path) {
  assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean | undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.codePointAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.codePointAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */
function extname(path) {
  assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean | undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.codePointAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */
function join(...segments) {
  let index = -1
  /** @type {string | undefined} */
  let joined

  while (++index < segments.length) {
    assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : minpath_browser_normalize(joined)
}

/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function minpath_browser_normalize(path) {
  assertPath(path)

  const absolute = path.codePointAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */
function normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number | undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.codePointAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.codePointAt(result.length - 1) !== 46 /* `.` */ ||
          result.codePointAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const proc = {cwd}

function cwd() {
  return '/'
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile/lib/minurl.shared.js
/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */
// From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null &&
      typeof fileUrlOrPath === 'object' &&
      'href' in fileUrlOrPath &&
      fileUrlOrPath.href &&
      'protocol' in fileUrlOrPath &&
      fileUrlOrPath.protocol &&
      // @ts-expect-error: indexing is fine.
      fileUrlOrPath.auth === undefined
  )
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile/lib/minurl.browser.js




// See: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js>

/**
 * @param {URL | string} path
 *   File URL.
 * @returns {string}
 *   File URL.
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.codePointAt(index) === 37 /* `%` */ &&
      pathname.codePointAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.codePointAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 * @typedef {import('vfile-message').Options} MessageOptions
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */

/**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {Options | URL | VFile | Value} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {string | null | undefined} [basename]
 *   Set `basename` (name).
 * @property {string | null | undefined} [cwd]
 *   Set `cwd` (working directory).
 * @property {Data | null | undefined} [data]
 *   Set `data` (associated info).
 * @property {string | null | undefined} [dirname]
 *   Set `dirname` (path w/o basename).
 * @property {string | null | undefined} [extname]
 *   Set `extname` (extension with dot).
 * @property {Array<string> | null | undefined} [history]
 *   Set `history` (paths the file moved between).
 * @property {URL | string | null | undefined} [path]
 *   Set `path` (current path).
 * @property {string | null | undefined} [stem]
 *   Set `stem` (name without extension).
 * @property {Value | null | undefined} [value]
 *   Set `value` (the contents of the file).
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/60adcb0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {Record<string, unknown> & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */

/**
 * @template [Settings=ReporterSettings]
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */






/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */
const order = /** @type {const} */ ([
  'history',
  'path',
  'basename',
  'stem',
  'extname',
  'dirname'
])

class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    /** @type {Options | VFile} */
    let options

    if (!value) {
      options = {}
    } else if (isUrl(value)) {
      options = {path: value}
    } else if (typeof value === 'string' || isUint8Array(value)) {
      options = {value}
    } else {
      options = value
    }

    /* eslint-disable no-unused-expressions */

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */
    this.cwd = proc.cwd()

    /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */
    this.data = {}

    /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */
    this.history = []

    /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * Raw value.
     *
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.
    /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */
    this.map

    /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */
    this.result

    /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */
    this.stored
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < order.length) {
      const prop = order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (
        prop in options &&
        options[prop] !== undefined &&
        options[prop] !== null
      ) {
        // @ts-expect-error: TS doesn’t understand basic reality.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) {
        // @ts-expect-error: fine to set other things.
        this[prop] = options[prop]
      }
    }
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename')
    assertPart(basename, 'basename')
    this.path = path.join(this.dirname || '', basename)
  }

  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname) {
    lib_assertPath(this.basename, 'dirname')
    this.path = path.join(dirname || '', this.basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname) {
    assertPart(extname, 'extname')
    lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.codePointAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path)
    }

    assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === 'string'
      ? path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem')
    assertPart(stem, 'stem')
    this.path = path.join(this.dirname || '', stem + (this.extname || ''))
  }

  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin)

    message.fatal = true

    throw message
  }

  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin)

    message.fatal = undefined

    return message
  }

  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new lib_VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    )

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === undefined) {
      return ''
    }

    if (typeof this.value === 'string') {
      return this.value
    }

    const decoder = new TextDecoder(encoding || undefined)
    return decoder.decode(this.value)
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */
function lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function isUint8Array(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/unified/lib/callable-instance.js
const CallableInstance =
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  (
    /** @type {unknown} */
    (
      /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */
      function (property) {
        const self = this
        const constr = self.constructor
        const proto = /** @type {Record<string | symbol, Function>} */ (
          // Prototypes do exist.
          // type-coverage:ignore-next-line
          constr.prototype
        )
        const func = proto[property]
        /** @type {(...parameters: Array<unknown>) => unknown} */
        const apply = function () {
          return func.apply(apply, arguments)
        }

        Object.setPrototypeOf(apply, proto)

        const names = Object.getOwnPropertyNames(func)

        for (const p of names) {
          const descriptor = Object.getOwnPropertyDescriptor(func, p)
          if (descriptor) Object.defineProperty(apply, p, descriptor)
        }

        return apply
      }
    )
  )

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/unified/lib/index.js
/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */

/**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@link CompileResultMap `CompileResultMap`}.
 */

/**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@link Node `Node`}
 *   and {@link VFile `VFile`} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > 👉 **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@link CompileResultMap `CompileResultMap`}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */

/**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@link VFile `VFile`} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@link Node `Node`}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */

/**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */

/**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */

// Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > 👉 **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */

/**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */

/**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */

/**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */

/**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */

/**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */

/**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > 👉 **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */

/**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */

/**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@link VFile `VFile`} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@link VFile `VFile`}.
 */









// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.

// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.

const unified_lib_own = {}.hasOwnProperty

/**
 * @template {Node | undefined} [ParseTree=undefined]
 *   Output of `parse` (optional).
 * @template {Node | undefined} [HeadTree=undefined]
 *   Input for `run` (optional).
 * @template {Node | undefined} [TailTree=undefined]
 *   Output for `run` (optional).
 * @template {Node | undefined} [CompileTree=undefined]
 *   Input of `stringify` (optional).
 * @template {CompileResults | undefined} [CompileResult=undefined]
 *   Output of `stringify` (optional).
 * @extends {CallableInstance<[], Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>>}
 */
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    // If `Processor()` is called (w/o new), `copy` is called instead.
    super('copy')

    /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.Compiler = undefined

    /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.Parser = undefined

    // Note: the following fields are considered private.
    // However, they are needed for tests, and TSC generates an untyped
    // `private freezeIndex` field for, which trips `type-coverage` up.
    // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
    /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */
    this.attachers = []

    /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.compiler = undefined

    /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */
    this.freezeIndex = -1

    /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */
    this.frozen = undefined

    /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */
    this.namespace = {}

    /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.parser = undefined

    /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */
    this.transformers = trough()
  }

  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    // Cast as the type parameters will be the same after attaching.
    const destination =
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ (
        new Processor()
      )
    let index = -1

    while (++index < this.attachers.length) {
      const attacher = this.attachers[index]
      destination.use(...attacher)
    }

    destination.data(extend(true, {}, this.namespace))

    return destination
  }

  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', this.frozen)
        this.namespace[key] = value
        return this
      }

      // Get `key`.
      return (unified_lib_own.call(this.namespace, key) && this.namespace[key]) || undefined
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', this.frozen)
      this.namespace = key
      return this
    }

    // Get space.
    return this.namespace
  }

  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this
    }

    // Cast so that we can type plugins easier.
    // Plugins are supposed to be usable on different processors, not just on
    // this exact processor.
    const self = /** @type {Processor} */ (/** @type {unknown} */ (this))

    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options] = this.attachers[this.freezeIndex]

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined
      }

      const transformer = attacher.call(self, ...options)

      if (typeof transformer === 'function') {
        this.transformers.use(transformer)
      }
    }

    this.frozen = true
    this.freezeIndex = Number.POSITIVE_INFINITY

    return this
  }

  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze()
    const realFile = vfile(file)
    const parser = this.parser || this.Parser
    assertParser('parse', parser)
    return parser(String(realFile), realFile)
  }

  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self = this

    this.freeze()
    assertParser('process', this.parser || this.Parser)
    assertCompiler('process', this.compiler || this.Compiler)

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      const realFile = vfile(file)
      // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
      // input of the first transform).
      const parseTree =
        /** @type {HeadTree extends undefined ? Node : HeadTree} */ (
          /** @type {unknown} */ (self.parse(realFile))
        )

      self.run(parseTree, realFile, function (error, tree, file) {
        if (error || !tree || !file) {
          return realDone(error)
        }

        // Assume `TailTree` (the output of the last transform) matches
        // `CompileTree` (the input of the compiler).
        const compileTree =
          /** @type {CompileTree extends undefined ? Node : CompileTree} */ (
            /** @type {unknown} */ (tree)
          )

        const compileResult = self.stringify(compileTree, file)

        if (looksLikeAValue(compileResult)) {
          file.value = compileResult
        } else {
          file.result = compileResult
        }

        realDone(error, /** @type {VFileWithOutput<CompileResult>} */ (file))
      })

      /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */
      function realDone(error, file) {
        if (error || !file) {
          reject(error)
        } else if (resolve) {
          resolve(file)
        } else {
          ok(done, '`done` is defined if `resolve` is not')
          done(undefined, file)
        }
      }
    }
  }

  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    /** @type {boolean} */
    let complete = false
    /** @type {VFileWithOutput<CompileResult> | undefined} */
    let result

    this.freeze()
    assertParser('processSync', this.parser || this.Parser)
    assertCompiler('processSync', this.compiler || this.Compiler)

    this.process(file, realDone)
    assertDone('processSync', 'process', complete)
    ok(result, 'we either bailed on an error or have a tree')

    return result

    /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */
    function realDone(error, file) {
      complete = true
      bail(error)
      result = file
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree)
    this.freeze()

    const transformers = this.transformers

    if (!done && typeof file === 'function') {
      done = file
      file = undefined
    }

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      ok(
        typeof file !== 'function',
        '`file` can’t be a `done` anymore, we checked'
      )
      const realFile = vfile(file)
      transformers.run(tree, realFile, realDone)

      /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */
      function realDone(error, outputTree, file) {
        const resultingTree =
          /** @type {TailTree extends undefined ? Node : TailTree} */ (
            outputTree || tree
          )

        if (error) {
          reject(error)
        } else if (resolve) {
          resolve(resultingTree)
        } else {
          ok(done, '`done` is defined if `resolve` is not')
          done(undefined, resultingTree, file)
        }
      }
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    /** @type {boolean} */
    let complete = false
    /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */
    let result

    this.run(tree, file, realDone)

    assertDone('runSync', 'run', complete)
    ok(result, 'we either bailed on an error or have a tree')
    return result

    /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */
    function realDone(error, tree) {
      bail(error)
      result = tree
      complete = true
    }
  }

  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze()
    const realFile = vfile(file)
    const compiler = this.compiler || this.Compiler
    assertCompiler('stringify', compiler)
    assertNode(tree)

    return compiler(tree, realFile)
  }

  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers
    const namespace = this.namespace

    assertUnfrozen('use', this.frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin(value, parameters)
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    return this

    /**
     * @param {Pluggable} value
     * @returns {undefined}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value, [])
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...parameters] =
            /** @type {PluginTuple<Array<unknown>>} */ (value)
          addPlugin(plugin, parameters)
        } else {
          addPreset(value)
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {undefined}
     */
    function addPreset(result) {
      if (!('plugins' in result) && !('settings' in result)) {
        throw new Error(
          'Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither'
        )
      }

      addList(result.plugins)

      if (result.settings) {
        namespace.settings = extend(true, namespace.settings, result.settings)
      }
    }

    /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */
    function addList(plugins) {
      let index = -1

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index]
          add(thing)
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */
    function addPlugin(plugin, parameters) {
      let index = -1
      let entryIndex = -1

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entryIndex = index
          break
        }
      }

      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters])
      }
      // Only set if there was at least a `primary` value, otherwise we’d change
      // `arguments.length`.
      else if (parameters.length > 0) {
        let [primary, ...rest] = parameters
        const currentPrimary = attachers[entryIndex][1]
        if (isPlainObject(currentPrimary) && isPlainObject(primary)) {
          primary = extend(true, currentPrimary, primary)
        }

        attachers[entryIndex] = [plugin, primary, ...rest]
      }
    }
  }
}

// Note: this returns a *callable* instance.
// That’s why it’s documented as a function.
/**
 * Create a new processor.
 *
 * @example
 *   This example shows how a new processor can be created (from `remark`) and linked
 *   to **stdin**(4) and **stdout**(4).
 *
 *   ```js
 *   import process from 'node:process'
 *   import concatStream from 'concat-stream'
 *   import {remark} from 'remark'
 *
 *   process.stdin.pipe(
 *     concatStream(function (buf) {
 *       process.stdout.write(String(remark().processSync(buf)))
 *     })
 *   )
 *   ```
 *
 * @returns
 *   New *unfrozen* processor (`processor`).
 *
 *   This processor is configured to work the same as its ancestor.
 *   When the descendant processor is configured in the future it does not
 *   affect the ancestral processor.
 */
const unified = new Processor().freeze()

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */
function looksLikeAValue(value) {
  return typeof value === 'string' || lib_isUint8Array(value)
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function lib_isUint8Array(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/node_modules/unist-util-visit/lib/index.js
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */

// To do: use types from `unist-util-visit-parents` when it’s released.

/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */

/**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */

/**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */

/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */

/**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */

/**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */

/**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */





/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function lib_visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  let reverse
  /** @type {Test} */
  let test
  /** @type {Visitor} */
  let visitor

  if (
    typeof testOrVisitor === 'function' &&
    typeof visitorOrReverse !== 'function'
  ) {
    test = undefined
    visitor = testOrVisitor
    reverse = visitorOrReverse
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse
    reverse = maybeReverse
  }

  visitParents(tree, test, overload, reverse)

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    const parent = parents[parents.length - 1]
    const index = parent ? parent.children.indexOf(node) : undefined
    return visitor(node, index, parent)
  }
}

;// CONCATENATED MODULE: ./node_modules/react-markdown/lib/index.js
// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-to-jsx-runtime').Components} JsxRuntimeComponents
 * @typedef {import('remark-rehype').Options} RemarkRehypeOptions
 * @typedef {import('unist-util-visit').BuildVisitor<Root>} Visitor
 * @typedef {import('unified').PluggableList} PluggableList
 */

/**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 *
 * @typedef {Partial<JsxRuntimeComponents>} Components
 *   Map tag names to components.
 *
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 *
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 *
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */




// @ts-expect-error: untyped.







const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md'

/** @type {PluggableList} */
const emptyPlugins = []
/** @type {Readonly<RemarkRehypeOptions>} */
const emptyRemarkRehypeOptions = {allowDangerousHtml: true}
const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i

// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */
const deprecations = [
  {from: 'astPlugins', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'allowDangerousHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {
    from: 'allowNode',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowElement'
  },
  {
    from: 'allowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowedElements'
  },
  {
    from: 'disallowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'disallowedElements'
  },
  {from: 'escapeHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'includeElementIndex', id: '#remove-includeelementindex'},
  {
    from: 'includeNodeIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  },
  {from: 'linkTarget', id: 'remove-linktarget'},
  {from: 'plugins', id: 'change-plugins-to-remarkplugins', to: 'remarkPlugins'},
  {from: 'rawSourcePos', id: '#remove-rawsourcepos'},
  {from: 'renderers', id: 'change-renderers-to-components', to: 'components'},
  {from: 'source', id: 'change-source-to-children', to: 'children'},
  {from: 'sourcePos', id: '#remove-sourcepos'},
  {from: 'transformImageUri', id: '#add-urltransform', to: 'urlTransform'},
  {from: 'transformLinkUri', id: '#add-urltransform', to: 'urlTransform'}
]

/**
 * Component to render markdown.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {JSX.Element}
 *   React element.
 */
function Markdown(options) {
  const allowedElements = options.allowedElements
  const allowElement = options.allowElement
  const children = options.children || ''
  const className = options.className
  const components = options.components
  const disallowedElements = options.disallowedElements
  const rehypePlugins = options.rehypePlugins || emptyPlugins
  const remarkPlugins = options.remarkPlugins || emptyPlugins
  const remarkRehypeOptions = options.remarkRehypeOptions
    ? {...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions}
    : emptyRemarkRehypeOptions
  const skipHtml = options.skipHtml
  const unwrapDisallowed = options.unwrapDisallowed
  const urlTransform = options.urlTransform || defaultUrlTransform

  const processor = unified()
    .use(remarkParse)
    .use(remarkPlugins)
    .use(remarkRehype, remarkRehypeOptions)
    .use(rehypePlugins)

  const file = new VFile()

  if (typeof children === 'string') {
    file.value = children
  } else {
    unreachable(
      'Unexpected value `' +
        children +
        '` for `children` prop, expected `string`'
    )
  }

  if (allowedElements && disallowedElements) {
    unreachable(
      'Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other'
    )
  }

  for (const deprecation of deprecations) {
    if (Object.hasOwn(options, deprecation.from)) {
      unreachable(
        'Unexpected `' +
          deprecation.from +
          '` prop, ' +
          (deprecation.to
            ? 'use `' + deprecation.to + '` instead'
            : 'remove it') +
          ' (see <' +
          changelog +
          '#' +
          deprecation.id +
          '> for more info)'
      )
    }
  }

  const mdastTree = processor.parse(file)
  /** @type {Nodes} */
  let hastTree = processor.runSync(mdastTree, file)

  // Wrap in `div` if there’s a class name.
  if (className) {
    hastTree = {
      type: 'element',
      tagName: 'div',
      properties: {className},
      // Assume no doctypes.
      children: /** @type {Array<ElementContent>} */ (
        hastTree.type === 'root' ? hastTree.children : [hastTree]
      )
    }
  }

  lib_visit(hastTree, transform)

  return toJsxRuntime(hastTree, {
    Fragment: jsx_runtime.Fragment,
    components,
    ignoreInvalidStyle: true,
    jsx: jsx_runtime.jsx,
    jsxs: jsx_runtime.jsxs,
    passKeys: true,
    passNode: true
  })

  /** @type {Visitor} */
  function transform(node, index, parent) {
    if (node.type === 'raw' && parent && typeof index === 'number') {
      if (skipHtml) {
        parent.children.splice(index, 1)
      } else {
        parent.children[index] = {type: 'text', value: node.value}
      }

      return index
    }

    if (node.type === 'element') {
      /** @type {string} */
      let key

      for (key in urlAttributes) {
        if (
          Object.hasOwn(urlAttributes, key) &&
          Object.hasOwn(node.properties, key)
        ) {
          const value = node.properties[key]
          const test = urlAttributes[key]
          if (test === null || test.includes(node.tagName)) {
            node.properties[key] = urlTransform(String(value || ''), key, node)
          }
        }
      }
    }

    if (node.type === 'element') {
      let remove = allowedElements
        ? !allowedElements.includes(node.tagName)
        : disallowedElements
        ? disallowedElements.includes(node.tagName)
        : false

      if (!remove && allowElement && typeof index === 'number') {
        remove = !allowElement(node, index, parent)
      }

      if (remove && parent && typeof index === 'number') {
        if (unwrapDisallowed && node.children) {
          parent.children.splice(index, 1, ...node.children)
        } else {
          parent.children.splice(index, 1)
        }

        return index
      }
    }
  }
}

/**
 * Make a URL safe.
 *
 * @satisfies {UrlTransform}
 * @param {string} value
 *   URL.
 * @returns {string}
 *   Safe URL.
 */
function defaultUrlTransform(value) {
  // Same as:
  // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
  // But without the `encode` part.
  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')

  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}

;// CONCATENATED MODULE: ./node_modules/ccount/index.js
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value)

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0
  let index = source.indexOf(character)

  while (index !== -1) {
    count++
    index = source.indexOf(character, index + character.length)
  }

  return count
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-find-and-replace/node_modules/escape-string-regexp/index.js
function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-find-and-replace/lib/index.js
/**
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */





/**
 * Find patterns in a tree and replace them.
 *
 * The algorithm searches the tree in *preorder* for complete values in `Text`
 * nodes.
 * Partial matches are not supported.
 *
 * @param {Nodes} tree
 *   Tree to change.
 * @param {FindAndReplaceList | FindAndReplaceTuple} list
 *   Patterns to find.
 * @param {Options | null | undefined} [options]
 *   Configuration (when `find` is not `Find`).
 * @returns {undefined}
 *   Nothing.
 */
function findAndReplace(tree, list, options) {
  const settings = options || {}
  const ignored = convert(settings.ignore || [])
  const pairs = toPairs(list)
  let pairIndex = -1

  while (++pairIndex < pairs.length) {
    visitParents(tree, 'text', visitor)
  }

  /** @type {import('unist-util-visit-parents').BuildVisitor<Root, 'text'>} */
  function visitor(node, parents) {
    let index = -1
    /** @type {Parents | undefined} */
    let grandparent

    while (++index < parents.length) {
      const parent = parents[index]
      /** @type {Array<Nodes> | undefined} */
      const siblings = grandparent ? grandparent.children : undefined

      if (
        ignored(
          parent,
          siblings ? siblings.indexOf(parent) : undefined,
          grandparent
        )
      ) {
        return
      }

      grandparent = parent
    }

    if (grandparent) {
      return handler(node, parents)
    }
  }

  /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */
  function handler(node, parents) {
    const parent = parents[parents.length - 1]
    const find = pairs[pairIndex][0]
    const replace = pairs[pairIndex][1]
    let start = 0
    /** @type {Array<Nodes>} */
    const siblings = parent.children
    const index = siblings.indexOf(node)
    let change = false
    /** @type {Array<PhrasingContent>} */
    let nodes = []

    find.lastIndex = 0

    let match = find.exec(node.value)

    while (match) {
      const position = match.index
      /** @type {RegExpMatchObject} */
      const matchObject = {
        index: match.index,
        input: match.input,
        stack: [...parents, node]
      }
      let value = replace(...match, matchObject)

      if (typeof value === 'string') {
        value = value.length > 0 ? {type: 'text', value} : undefined
      }

      // It wasn’t a match after all.
      if (value === false) {
        // False acts as if there was no match.
        // So we need to reset `lastIndex`, which currently being at the end of
        // the current match, to the beginning.
        find.lastIndex = position + 1
      } else {
        if (start !== position) {
          nodes.push({
            type: 'text',
            value: node.value.slice(start, position)
          })
        }

        if (Array.isArray(value)) {
          nodes.push(...value)
        } else if (value) {
          nodes.push(value)
        }

        start = position + match[0].length
        change = true
      }

      if (!find.global) {
        break
      }

      match = find.exec(node.value)
    }

    if (change) {
      if (start < node.value.length) {
        nodes.push({type: 'text', value: node.value.slice(start)})
      }

      parent.children.splice(index, 1, ...nodes)
    } else {
      nodes = [node]
    }

    return index + nodes.length
  }
}

/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */
function toPairs(tupleOrList) {
  /** @type {Pairs} */
  const result = []

  if (!Array.isArray(tupleOrList)) {
    throw new TypeError('Expected find and replace tuple or list of tuples')
  }

  /** @type {FindAndReplaceList} */
  // @ts-expect-error: correct.
  const list =
    !tupleOrList[0] || Array.isArray(tupleOrList[0])
      ? tupleOrList
      : [tupleOrList]

  let index = -1

  while (++index < list.length) {
    const tuple = list[index]
    result.push([toExpression(tuple[0]), toFunction(tuple[1])])
  }

  return result
}

/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escapeStringRegexp(find), 'g') : find
}

/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */
function toFunction(replace) {
  return typeof replace === 'function'
    ? replace
    : function () {
        return replace
      }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm-autolink-literal/lib/index.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 */






/** @type {ConstructName} */
const inConstruct = 'phrasing'
/** @type {Array<ConstructName>} */
const notInConstruct = ['autolink', 'link', 'image', 'label']

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM autolink
 * literals in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 */
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM autolink
 * literals in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 */
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: '@',
        before: '[+\\-.\\w]',
        after: '[\\-.\\w]',
        inConstruct,
        notInConstruct
      },
      {
        character: '.',
        before: '[Ww]',
        after: '[\\-.\\w]',
        inConstruct,
        notInConstruct
      },
      {
        character: ':',
        before: '[ps]',
        after: '\\/',
        inConstruct,
        notInConstruct
      }
    ]
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token)
  const node = this.stack[this.stack.length - 1]
  ok(node.type === 'link')
  node.url = 'http://' + this.sliceSerialize(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolink(token) {
  this.exit(token)
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  )
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = ''

  // Not an expected previous character.
  if (!lib_previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain
    protocol = ''
    prefix = 'http://'
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path)

  if (!parts[0]) return false

  /** @type {Link} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  }

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !lib_previous(match, true) ||
    // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.')

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url)

  if (!trailExec) {
    return [url, undefined]
  }

  url = url.slice(0, trailExec.index)

  let trail = trailExec[0]
  let closingParenIndex = trail.indexOf(')')
  const openingParens = ccount(url, '(')
  let closingParens = ccount(url, ')')

  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail.slice(0, closingParenIndex + 1)
    trail = trail.slice(closingParenIndex + 1)
    closingParenIndex = trail.indexOf(')')
    closingParens++
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */
function lib_previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1)

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    (!email || code !== 47)
  )
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm-footnote/lib/index.js
/**
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */




lib_footnoteReference.peek = footnoteReferencePeek

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown`.
 */
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown`.
 */
function gfmFootnoteToMarkdown() {
  return {
    // This is on by default already.
    unsafe: [{character: '[', inConstruct: ['phrasing', 'label', 'reference']}],
    handlers: {footnoteDefinition, footnoteReference: lib_footnoteReference}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinition(token) {
  this.enter(
    {type: 'footnoteDefinition', identifier: '', label: '', children: []},
    token
  )
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinitionLabelString() {
  this.buffer()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinitionLabelString(token) {
  const label = this.resume()
  const node = this.stack[this.stack.length - 1]
  ok(node.type === 'footnoteDefinition')
  node.label = label
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinition(token) {
  this.exit(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCall(token) {
  this.enter({type: 'footnoteReference', identifier: '', label: ''}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCallString() {
  this.buffer()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCallString(token) {
  const label = this.resume()
  const node = this.stack[this.stack.length - 1]
  ok(node.type === 'footnoteReference')
  node.label = label
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCall(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */
function lib_footnoteReference(node, _, state, info) {
  const tracker = state.createTracker(info)
  let value = tracker.move('[^')
  const exit = state.enter('footnoteReference')
  const subexit = state.enter('reference')
  value += tracker.move(
    state.safe(state.associationId(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  )
  subexit()
  exit()
  value += tracker.move(']')
  return value
}

/** @type {ToMarkdownHandle} */
function footnoteReferencePeek() {
  return '['
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */
function footnoteDefinition(node, _, state, info) {
  const tracker = state.createTracker(info)
  let value = tracker.move('[^')
  const exit = state.enter('footnoteDefinition')
  const subexit = state.enter('label')
  value += tracker.move(
    state.safe(state.associationId(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  )
  subexit()
  value += tracker.move(
    ']:' + (node.children && node.children.length > 0 ? ' ' : '')
  )
  tracker.shift(4)
  value += tracker.move(
    state.indentLines(state.containerFlow(node, tracker.current()), map)
  )
  exit()

  return value
}

/** @type {Map} */
function map(line, index, blank) {
  if (index === 0) {
    return line
  }

  return (blank ? '' : '    ') + line
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm-strikethrough/lib/index.js
/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */

/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */
const constructsWithoutStrikethrough = [
  'autolink',
  'destinationLiteral',
  'destinationRaw',
  'reference',
  'titleQuote',
  'titleApostrophe'
]

handleDelete.peek = peekDelete

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM
 * strikethrough in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM strikethrough.
 */
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ['delete'],
    enter: {strikethrough: enterStrikethrough},
    exit: {strikethrough: exitStrikethrough}
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM
 * strikethrough in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM strikethrough.
 */
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: '~',
        inConstruct: 'phrasing',
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: {delete: handleDelete}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitStrikethrough(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, state, info) {
  const tracker = state.createTracker(info)
  const exit = state.enter('strikethrough')
  let value = tracker.move('~~')
  value += state.containerPhrasing(node, {
    ...tracker.current(),
    before: value,
    after: '~'
  })
  value += tracker.move('~~')
  exit()
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

;// CONCATENATED MODULE: ./node_modules/markdown-table/index.js
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat()
  const stringLength = options.stringLength || defaultStringLength
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = []
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = []
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = []
  /** @type {Array<number>} */
  const longestCellByColumn = []
  let mostCellsPerRow = 0
  let rowIndex = -1

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = []
    /** @type {Array<number>} */
    const sizes = []
    let columnIndex = -1

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = markdown_table_serialize(table[rowIndex][columnIndex])

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell)
        sizes[columnIndex] = size

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size
        }
      }

      row.push(cell)
    }

    cellMatrix[rowIndex] = row
    sizeMatrix[rowIndex] = sizes
  }

  // Figure out which alignments to use.
  let columnIndex = -1

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex])
    }
  } else {
    const code = toAlignment(align)

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code
    }
  }

  // Inject the alignment row.
  columnIndex = -1
  /** @type {Array<string>} */
  const row = []
  /** @type {Array<number>} */
  const sizes = []

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex]
    let before = ''
    let after = ''

    if (code === 99 /* `c` */) {
      before = ':'
      after = ':'
    } else if (code === 108 /* `l` */) {
      before = ':'
    } else if (code === 114 /* `r` */) {
      after = ':'
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          )

    const cell = before + '-'.repeat(size) + after

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size
      }

      sizes[columnIndex] = size
    }

    row[columnIndex] = cell
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row)
  sizeMatrix.splice(1, 0, sizes)

  rowIndex = -1
  /** @type {Array<string>} */
  const lines = []

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex]
    const sizes = sizeMatrix[rowIndex]
    columnIndex = -1
    /** @type {Array<string>} */
    const line = []

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || ''
      let before = ''
      let after = ''

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0)
        const code = alignments[columnIndex]

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size)
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5)
            after = ' '.repeat(size / 2 - 0.5)
          } else {
            before = ' '.repeat(size / 2)
            after = before
          }
        } else {
          after = ' '.repeat(size)
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|')
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ')
      }

      if (options.alignDelimiters !== false) {
        line.push(before)
      }

      line.push(cell)

      if (options.alignDelimiters !== false) {
        line.push(after)
      }

      if (options.padding !== false) {
        line.push(' ')
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|')
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    )
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function markdown_table_serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/blockquote.js
/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function blockquote_blockquote(node, _, state, info) {
  const exit = state.enter('blockquote')
  const tracker = state.createTracker(info)
  tracker.move('> ')
  tracker.shift(2)
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    blockquote_map
  )
  exit()
  return value
}

/** @type {Map} */
function blockquote_map(line, _, blank) {
  return '>' + (blank ? '' : ' ') + line
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/pattern-in-scope.js
/**
 * @typedef {import('../types.js').ConstructName} ConstructName
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */
function patternInScope(stack, pattern) {
  return (
    listInScope(stack, pattern.inConstruct, true) &&
    !listInScope(stack, pattern.notInConstruct, false)
  )
}

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */
function listInScope(stack, list, none) {
  if (typeof list === 'string') {
    list = [list]
  }

  if (!list || list.length === 0) {
    return none
  }

  let index = -1

  while (++index < list.length) {
    if (stack.includes(list[index])) {
      return true
    }
  }

  return false
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/break.js
/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {Break} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function break_hardBreak(_, _1, state, info) {
  let index = -1

  while (++index < state.unsafe.length) {
    // If we can’t put eols in this construct (setext headings, tables), use a
    // space instead.
    if (
      state.unsafe[index].character === '\n' &&
      patternInScope(state.stack, state.unsafe[index])
    ) {
      return /[ \t]/.test(info.before) ? '' : ' '
    }
  }

  return '\\\n'
}

;// CONCATENATED MODULE: ./node_modules/longest-streak/index.js
/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */
function longestStreak(value, substring) {
  const source = String(value)
  let index = source.indexOf(substring)
  let expected = index
  let count = 0
  let max = 0

  if (typeof substring !== 'string') {
    throw new TypeError('Expected substring')
  }

  while (index !== -1) {
    if (index === expected) {
      if (++count > max) {
        max = count
      }
    } else {
      count = 1
    }

    expected = index + substring.length
    index = source.indexOf(substring, expected)
  }

  return max
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/format-code-as-indented.js
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */
function formatCodeAsIndented(node, state) {
  return Boolean(
    state.options.fences === false &&
      node.value &&
      // If there’s no info…
      !node.lang &&
      // And there’s a non-whitespace character…
      /[^ \r\n]/.test(node.value) &&
      // And the value doesn’t start or end in a blank…
      !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value)
  )
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-fence.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */
function checkFence(state) {
  const marker = state.options.fence || '`'

  if (marker !== '`' && marker !== '~') {
    throw new Error(
      'Cannot serialize code with `' +
        marker +
        '` for `options.fence`, expected `` ` `` or `~`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/code.js
/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */





/**
 * @param {Code} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function code_code(node, _, state, info) {
  const marker = checkFence(state)
  const raw = node.value || ''
  const suffix = marker === '`' ? 'GraveAccent' : 'Tilde'

  if (formatCodeAsIndented(node, state)) {
    const exit = state.enter('codeIndented')
    const value = state.indentLines(raw, code_map)
    exit()
    return value
  }

  const tracker = state.createTracker(info)
  const sequence = marker.repeat(Math.max(longestStreak(raw, marker) + 1, 3))
  const exit = state.enter('codeFenced')
  let value = tracker.move(sequence)

  if (node.lang) {
    const subexit = state.enter(`codeFencedLang${suffix}`)
    value += tracker.move(
      state.safe(node.lang, {
        before: value,
        after: ' ',
        encode: ['`'],
        ...tracker.current()
      })
    )
    subexit()
  }

  if (node.lang && node.meta) {
    const subexit = state.enter(`codeFencedMeta${suffix}`)
    value += tracker.move(' ')
    value += tracker.move(
      state.safe(node.meta, {
        before: value,
        after: '\n',
        encode: ['`'],
        ...tracker.current()
      })
    )
    subexit()
  }

  value += tracker.move('\n')

  if (raw) {
    value += tracker.move(raw + '\n')
  }

  value += tracker.move(sequence)
  exit()
  return value
}

/** @type {Map} */
function code_map(line, _, blank) {
  return (blank ? '' : '    ') + line
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-quote.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */
function checkQuote(state) {
  const marker = state.options.quote || '"'

  if (marker !== '"' && marker !== "'") {
    throw new Error(
      'Cannot serialize title with `' +
        marker +
        '` for `options.quote`, expected `"`, or `\'`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/definition.js
/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {Definition} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function definition_definition(node, _, state, info) {
  const quote = checkQuote(state)
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe'
  const exit = state.enter('definition')
  let subexit = state.enter('label')
  const tracker = state.createTracker(info)
  let value = tracker.move('[')
  value += tracker.move(
    state.safe(state.associationId(node), {
      before: value,
      after: ']',
      ...tracker.current()
    })
  )
  value += tracker.move(']: ')

  subexit()

  if (
    // If there’s no url, or…
    !node.url ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral')
    value += tracker.move('<')
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    )
    value += tracker.move('>')
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw')
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : '\n',
        ...tracker.current()
      })
    )
  }

  subexit()

  if (node.title) {
    subexit = state.enter(`title${suffix}`)
    value += tracker.move(' ' + quote)
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    )
    value += tracker.move(quote)
    subexit()
  }

  exit()

  return value
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-emphasis.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */
function checkEmphasis(state) {
  const marker = state.options.emphasis || '*'

  if (marker !== '*' && marker !== '_') {
    throw new Error(
      'Cannot serialize emphasis with `' +
        marker +
        '` for `options.emphasis`, expected `*`, or `_`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/emphasis.js
/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



emphasis_emphasis.peek = emphasisPeek

// To do: there are cases where emphasis cannot “form” depending on the
// previous or next character of sequences.
// There’s no way around that though, except for injecting zero-width stuff.
// Do we need to safeguard against that?
/**
 * @param {Emphasis} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function emphasis_emphasis(node, _, state, info) {
  const marker = checkEmphasis(state)
  const exit = state.enter('emphasis')
  const tracker = state.createTracker(info)
  let value = tracker.move(marker)
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  )
  value += tracker.move(marker)
  exit()
  return value
}

/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function emphasisPeek(_, _1, state) {
  return state.options.emphasis || '*'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/node_modules/unist-util-visit/lib/index.js
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */

// To do: use types from `unist-util-visit-parents` when it’s released.

/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */

/**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */

/**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */

/**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */

/**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */

/**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */

/**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */

/**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */

/**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */

/**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */





/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function unist_util_visit_lib_visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  let reverse
  /** @type {Test} */
  let test
  /** @type {Visitor} */
  let visitor

  if (
    typeof testOrVisitor === 'function' &&
    typeof visitorOrReverse !== 'function'
  ) {
    test = undefined
    visitor = testOrVisitor
    reverse = visitorOrReverse
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse
    reverse = maybeReverse
  }

  visitParents(tree, test, overload, reverse)

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    const parent = parents[parents.length - 1]
    const index = parent ? parent.children.indexOf(node) : undefined
    return visitor(node, index, parent)
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/node_modules/mdast-util-to-string/lib/index.js
/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */

/** @type {Options} */
const mdast_util_to_string_lib_emptyOptions = {}

/**
 * Get the text content of a node or list of nodes.
 *
 * Prefers the node’s plain-text fields, otherwise serializes its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} [value]
 *   Thing to serialize, typically `Node`.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {string}
 *   Serialized `value`.
 */
function mdast_util_to_string_lib_toString(value, options) {
  const settings = options || mdast_util_to_string_lib_emptyOptions
  const includeImageAlt =
    typeof settings.includeImageAlt === 'boolean'
      ? settings.includeImageAlt
      : true
  const includeHtml =
    typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true

  return mdast_util_to_string_lib_one(value, includeImageAlt, includeHtml)
}

/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */
function mdast_util_to_string_lib_one(value, includeImageAlt, includeHtml) {
  if (lib_node(value)) {
    if ('value' in value) {
      return value.type === 'html' && !includeHtml ? '' : value.value
    }

    if (includeImageAlt && 'alt' in value && value.alt) {
      return value.alt
    }

    if ('children' in value) {
      return mdast_util_to_string_lib_all(value.children, includeImageAlt, includeHtml)
    }
  }

  if (Array.isArray(value)) {
    return mdast_util_to_string_lib_all(value, includeImageAlt, includeHtml)
  }

  return ''
}

/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */
function mdast_util_to_string_lib_all(values, includeImageAlt, includeHtml) {
  /** @type {Array<string>} */
  const result = []
  let index = -1

  while (++index < values.length) {
    result[index] = mdast_util_to_string_lib_one(values[index], includeImageAlt, includeHtml)
  }

  return result.join('')
}

/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */
function lib_node(value) {
  return Boolean(value && typeof value === 'object')
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/format-heading-as-setext.js
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').State} State
 */




/**
 * @param {Heading} node
 * @param {State} state
 * @returns {boolean}
 */
function formatHeadingAsSetext(node, state) {
  let literalWithBreak = false

  // Look for literals with a line break.
  // Note that this also
  unist_util_visit_lib_visit(node, function (node) {
    if (
      ('value' in node && /\r?\n|\r/.test(node.value)) ||
      node.type === 'break'
    ) {
      literalWithBreak = true
      return EXIT
    }
  })

  return Boolean(
    (!node.depth || node.depth < 3) &&
      mdast_util_to_string_lib_toString(node) &&
      (state.options.setext || literalWithBreak)
  )
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/heading.js
/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {Heading} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function heading_heading(node, _, state, info) {
  const rank = Math.max(Math.min(6, node.depth || 1), 1)
  const tracker = state.createTracker(info)

  if (formatHeadingAsSetext(node, state)) {
    const exit = state.enter('headingSetext')
    const subexit = state.enter('phrasing')
    const value = state.containerPhrasing(node, {
      ...tracker.current(),
      before: '\n',
      after: '\n'
    })
    subexit()
    exit()

    return (
      value +
      '\n' +
      (rank === 1 ? '=' : '-').repeat(
        // The whole size…
        value.length -
          // Minus the position of the character after the last EOL (or
          // 0 if there is none)…
          (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1)
      )
    )
  }

  const sequence = '#'.repeat(rank)
  const exit = state.enter('headingAtx')
  const subexit = state.enter('phrasing')

  // Note: for proper tracking, we should reset the output positions when there
  // is no content returned, because then the space is not output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  tracker.move(sequence + ' ')

  let value = state.containerPhrasing(node, {
    before: '# ',
    after: '\n',
    ...tracker.current()
  })

  if (/^[\t ]/.test(value)) {
    // To do: what effect has the character reference on tracking?
    value =
      '&#x' +
      value.charCodeAt(0).toString(16).toUpperCase() +
      ';' +
      value.slice(1)
  }

  value = value ? sequence + ' ' + value : sequence

  if (state.options.closeAtx) {
    value += ' ' + sequence
  }

  subexit()
  exit()

  return value
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/html.js
/**
 * @typedef {import('mdast').Html} Html
 */

handle_html_html.peek = htmlPeek

/**
 * @param {Html} node
 * @returns {string}
 */
function handle_html_html(node) {
  return node.value || ''
}

/**
 * @returns {string}
 */
function htmlPeek() {
  return '<'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/image.js
/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



handle_image_image.peek = imagePeek

/**
 * @param {Image} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function handle_image_image(node, _, state, info) {
  const quote = checkQuote(state)
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe'
  const exit = state.enter('image')
  let subexit = state.enter('label')
  const tracker = state.createTracker(info)
  let value = tracker.move('![')
  value += tracker.move(
    state.safe(node.alt, {before: value, after: ']', ...tracker.current()})
  )
  value += tracker.move('](')

  subexit()

  if (
    // If there’s no url but there is a title…
    (!node.url && node.title) ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral')
    value += tracker.move('<')
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    )
    value += tracker.move('>')
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw')
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : ')',
        ...tracker.current()
      })
    )
  }

  subexit()

  if (node.title) {
    subexit = state.enter(`title${suffix}`)
    value += tracker.move(' ' + quote)
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    )
    value += tracker.move(quote)
    subexit()
  }

  value += tracker.move(')')
  exit()

  return value
}

/**
 * @returns {string}
 */
function imagePeek() {
  return '!'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/image-reference.js
/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

image_reference_imageReference.peek = imageReferencePeek

/**
 * @param {ImageReference} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function image_reference_imageReference(node, _, state, info) {
  const type = node.referenceType
  const exit = state.enter('imageReference')
  let subexit = state.enter('label')
  const tracker = state.createTracker(info)
  let value = tracker.move('![')
  const alt = state.safe(node.alt, {
    before: value,
    after: ']',
    ...tracker.current()
  })
  value += tracker.move(alt + '][')

  subexit()
  // Hide the fact that we’re in phrasing, because escapes don’t work.
  const stack = state.stack
  state.stack = []
  subexit = state.enter('reference')
  // Note: for proper tracking, we should reset the output positions when we end
  // up making a `shortcut` reference, because then there is no brace output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  const reference = state.safe(state.associationId(node), {
    before: value,
    after: ']',
    ...tracker.current()
  })
  subexit()
  state.stack = stack
  exit()

  if (type === 'full' || !alt || alt !== reference) {
    value += tracker.move(reference + ']')
  } else if (type === 'shortcut') {
    // Remove the unwanted `[`.
    value = value.slice(0, -1)
  } else {
    value += tracker.move(']')
  }

  return value
}

/**
 * @returns {string}
 */
function imageReferencePeek() {
  return '!'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').State} State
 */

inline_code_inlineCode.peek = inlineCodePeek

/**
 * @param {InlineCode} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */
function inline_code_inlineCode(node, _, state) {
  let value = node.value || ''
  let sequence = '`'
  let index = -1

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`'
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' '
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index]
    const expression = state.compilePattern(pattern)
    /** @type {RegExpExecArray | null} */
    let match

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1)
    }
  }

  return sequence + value + sequence
}

/**
 * @returns {string}
 */
function inlineCodePeek() {
  return '`'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/format-link-as-autolink.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {Link} node
 * @param {State} state
 * @returns {boolean}
 */
function formatLinkAsAutolink(node, state) {
  const raw = mdast_util_to_string_lib_toString(node)

  return Boolean(
    !state.options.resourceLink &&
      // If there’s a url…
      node.url &&
      // And there’s a no title…
      !node.title &&
      // And the content of `node` is a single text node…
      node.children &&
      node.children.length === 1 &&
      node.children[0].type === 'text' &&
      // And if the url is the same as the content…
      (raw === node.url || 'mailto:' + raw === node.url) &&
      // And that starts w/ a protocol…
      /^[a-z][a-z+.-]+:/i.test(node.url) &&
      // And that doesn’t contain ASCII control codes (character escapes and
      // references don’t work), space, or angle brackets…
      !/[\0- <>\u007F]/.test(node.url)
  )
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/link.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Exit} Exit
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */




handle_link_link.peek = linkPeek

/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function handle_link_link(node, _, state, info) {
  const quote = checkQuote(state)
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe'
  const tracker = state.createTracker(info)
  /** @type {Exit} */
  let exit
  /** @type {Exit} */
  let subexit

  if (formatLinkAsAutolink(node, state)) {
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack
    state.stack = []
    exit = state.enter('autolink')
    let value = tracker.move('<')
    value += tracker.move(
      state.containerPhrasing(node, {
        before: value,
        after: '>',
        ...tracker.current()
      })
    )
    value += tracker.move('>')
    exit()
    state.stack = stack
    return value
  }

  exit = state.enter('link')
  subexit = state.enter('label')
  let value = tracker.move('[')
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: '](',
      ...tracker.current()
    })
  )
  value += tracker.move('](')
  subexit()

  if (
    // If there’s no url but there is a title…
    (!node.url && node.title) ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral')
    value += tracker.move('<')
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    )
    value += tracker.move('>')
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw')
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : ')',
        ...tracker.current()
      })
    )
  }

  subexit()

  if (node.title) {
    subexit = state.enter(`title${suffix}`)
    value += tracker.move(' ' + quote)
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    )
    value += tracker.move(quote)
    subexit()
  }

  value += tracker.move(')')

  exit()
  return value
}

/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */
function linkPeek(node, _, state) {
  return formatLinkAsAutolink(node, state) ? '<' : '['
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/link-reference.js
/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

link_reference_linkReference.peek = linkReferencePeek

/**
 * @param {LinkReference} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function link_reference_linkReference(node, _, state, info) {
  const type = node.referenceType
  const exit = state.enter('linkReference')
  let subexit = state.enter('label')
  const tracker = state.createTracker(info)
  let value = tracker.move('[')
  const text = state.containerPhrasing(node, {
    before: value,
    after: ']',
    ...tracker.current()
  })
  value += tracker.move(text + '][')

  subexit()
  // Hide the fact that we’re in phrasing, because escapes don’t work.
  const stack = state.stack
  state.stack = []
  subexit = state.enter('reference')
  // Note: for proper tracking, we should reset the output positions when we end
  // up making a `shortcut` reference, because then there is no brace output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  const reference = state.safe(state.associationId(node), {
    before: value,
    after: ']',
    ...tracker.current()
  })
  subexit()
  state.stack = stack
  exit()

  if (type === 'full' || !text || text !== reference) {
    value += tracker.move(reference + ']')
  } else if (type === 'shortcut') {
    // Remove the unwanted `[`.
    value = value.slice(0, -1)
  } else {
    value += tracker.move(']')
  }

  return value
}

/**
 * @returns {string}
 */
function linkReferencePeek() {
  return '['
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-bullet.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBullet(state) {
  const marker = state.options.bullet || '*'

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-bullet-other.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBulletOther(state) {
  const bullet = checkBullet(state)
  const bulletOther = state.options.bulletOther

  if (!bulletOther) {
    return bullet === '*' ? '-' : '*'
  }

  if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        bulletOther +
        '` for `options.bulletOther`, expected `*`, `+`, or `-`'
    )
  }

  if (bulletOther === bullet) {
    throw new Error(
      'Expected `bullet` (`' +
        bullet +
        '`) and `bulletOther` (`' +
        bulletOther +
        '`) to be different'
    )
  }

  return bulletOther
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-bullet-ordered.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */
function checkBulletOrdered(state) {
  const marker = state.options.bulletOrdered || '.'

  if (marker !== '.' && marker !== ')') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bulletOrdered`, expected `.` or `)`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-rule.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */
function checkRule(state) {
  const marker = state.options.rule || '*'

  if (marker !== '*' && marker !== '-' && marker !== '_') {
    throw new Error(
      'Cannot serialize rules with `' +
        marker +
        '` for `options.rule`, expected `*`, `-`, or `_`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/list.js
/**
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */






/**
 * @param {List} node
 * @param {Parents | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function handle_list_list(node, parent, state, info) {
  const exit = state.enter('list')
  const bulletCurrent = state.bulletCurrent
  /** @type {string} */
  let bullet = node.ordered ? checkBulletOrdered(state) : checkBullet(state)
  /** @type {string} */
  const bulletOther = node.ordered
    ? bullet === '.'
      ? ')'
      : '.'
    : checkBulletOther(state)
  let useDifferentMarker =
    parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false

  if (!node.ordered) {
    const firstListItem = node.children ? node.children[0] : undefined

    // If there’s an empty first list item directly in two list items,
    // we have to use a different bullet:
    //
    // ```markdown
    // * - *
    // ```
    //
    // …because otherwise it would become one big thematic break.
    if (
      // Bullet could be used as a thematic break marker:
      (bullet === '*' || bullet === '-') &&
      // Empty first list item:
      firstListItem &&
      (!firstListItem.children || !firstListItem.children[0]) &&
      // Directly in two other list items:
      state.stack[state.stack.length - 1] === 'list' &&
      state.stack[state.stack.length - 2] === 'listItem' &&
      state.stack[state.stack.length - 3] === 'list' &&
      state.stack[state.stack.length - 4] === 'listItem' &&
      // That are each the first child.
      state.indexStack[state.indexStack.length - 1] === 0 &&
      state.indexStack[state.indexStack.length - 2] === 0 &&
      state.indexStack[state.indexStack.length - 3] === 0
    ) {
      useDifferentMarker = true
    }

    // If there’s a thematic break at the start of the first list item,
    // we have to use a different bullet:
    //
    // ```markdown
    // * ---
    // ```
    //
    // …because otherwise it would become one big thematic break.
    if (checkRule(state) === bullet && firstListItem) {
      let index = -1

      while (++index < node.children.length) {
        const item = node.children[index]

        if (
          item &&
          item.type === 'listItem' &&
          item.children &&
          item.children[0] &&
          item.children[0].type === 'thematicBreak'
        ) {
          useDifferentMarker = true
          break
        }
      }
    }
  }

  if (useDifferentMarker) {
    bullet = bulletOther
  }

  state.bulletCurrent = bullet
  const value = state.containerFlow(node, info)
  state.bulletLastUsed = bullet
  state.bulletCurrent = bulletCurrent
  exit()
  return value
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-list-item-indent.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */
function checkListItemIndent(state) {
  const style = state.options.listItemIndent || 'one'

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */




/**
 * @param {ListItem} node
 * @param {Parents | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function list_item_listItem(node, parent, state, info) {
  const listItemIndent = checkListItemIndent(state)
  let bullet = state.bulletCurrent || checkBullet(state)

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (state.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet
  }

  let size = bullet.length + 1

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4
  }

  const tracker = state.createTracker(info)
  tracker.move(bullet + ' '.repeat(size - bullet.length))
  tracker.shift(size)
  const exit = state.enter('listItem')
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    map
  )
  exit()

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/paragraph.js
/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function paragraph_paragraph(node, _, state, info) {
  const exit = state.enter('paragraph')
  const subexit = state.enter('phrasing')
  const value = state.containerPhrasing(node, info)
  subexit()
  exit()
  return value
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-phrasing/lib/index.js
/**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */



/**
 * Check if the given value is *phrasing content*.
 *
 * > 👉 **Note**: Excludes `html`, which can be both phrasing or flow.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @returns
 *   Whether `value` is phrasing content.
 */

const phrasing =
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  (
    convert([
      'break',
      'delete',
      'emphasis',
      // To do: next major: removed since footnotes were added to GFM.
      'footnote',
      'footnoteReference',
      'image',
      'imageReference',
      'inlineCode',
      // Enabled by `mdast-util-math`:
      'inlineMath',
      'link',
      'linkReference',
      // Enabled by `mdast-util-mdx`:
      'mdxJsxTextElement',
      // Enabled by `mdast-util-mdx`:
      'mdxTextExpression',
      'strong',
      'text',
      // Enabled by `mdast-util-directive`:
      'textDirective'
    ])
  )

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/root.js
/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



/**
 * @param {Root} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function handle_root_root(node, _, state, info) {
  // Note: `html` nodes are ambiguous.
  const hasPhrasing = node.children.some(function (d) {
    return phrasing(d)
  })
  const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow
  return fn.call(state, node, info)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-strong.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */
function checkStrong(state) {
  const marker = state.options.strong || '*'

  if (marker !== '*' && marker !== '_') {
    throw new Error(
      'Cannot serialize strong with `' +
        marker +
        '` for `options.strong`, expected `*`, or `_`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/strong.js
/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */



strong_strong.peek = strongPeek

// To do: there are cases where emphasis cannot “form” depending on the
// previous or next character of sequences.
// There’s no way around that though, except for injecting zero-width stuff.
// Do we need to safeguard against that?
/**
 * @param {Strong} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function strong_strong(node, _, state, info) {
  const marker = checkStrong(state)
  const exit = state.enter('strong')
  const tracker = state.createTracker(info)
  let value = tracker.move(marker + marker)
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  )
  value += tracker.move(marker + marker)
  exit()
  return value
}

/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function strongPeek(_, _1, state) {
  return state.options.strong || '*'
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/text.js
/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function handle_text_text(node, _, state, info) {
  return state.safe(node.value, info)
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/util/check-rule-repetition.js
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */
function checkRuleRepetition(state) {
  const repetition = state.options.ruleRepetition || 3

  if (repetition < 3) {
    throw new Error(
      'Cannot serialize rules with repetition `' +
        repetition +
        '` for `options.ruleRepetition`, expected `3` or more'
    )
  }

  return repetition
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/thematic-break.js
/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../types.js').State} State
 */




/**
 * @param {ThematicBreak} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function handle_thematic_break_thematicBreak(_, _1, state) {
  const value = (
    checkRule(state) + (state.options.ruleSpaces ? ' ' : '')
  ).repeat(checkRuleRepetition(state))

  return state.options.ruleSpaces ? value.slice(0, -1) : value
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-to-markdown/lib/handle/index.js




















/**
 * Default (CommonMark) handlers.
 */
const handle = {
  blockquote: blockquote_blockquote,
  break: break_hardBreak,
  code: code_code,
  definition: definition_definition,
  emphasis: emphasis_emphasis,
  hardBreak: break_hardBreak,
  heading: heading_heading,
  html: handle_html_html,
  image: handle_image_image,
  imageReference: image_reference_imageReference,
  inlineCode: inline_code_inlineCode,
  link: handle_link_link,
  linkReference: link_reference_linkReference,
  list: handle_list_list,
  listItem: list_item_listItem,
  paragraph: paragraph_paragraph,
  root: handle_root_root,
  strong: strong_strong,
  text: handle_text_text,
  thematicBreak: handle_thematic_break_thematicBreak
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm-table/lib/index.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */

/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */





/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM tables in
 * markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM tables.
 */
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: lib_exit,
      tableHeader: lib_exit,
      tableRow: lib_exit
    }
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterTable(token) {
  const align = token._align
  ok(align, 'expected `_align` on table')
  this.enter(
    {
      type: 'table',
      align: align.map(function (d) {
        return d === 'none' ? null : d
      }),
      children: []
    },
    token
  )
  this.data.inTable = true
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitTable(token) {
  this.exit(token)
  this.data.inTable = undefined
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function lib_exit(token) {
  this.exit(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token)
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCodeText(token) {
  let value = this.resume()

  if (this.data.inTable) {
    value = value.replace(/\\([\\|])/g, replace)
  }

  const node = this.stack[this.stack.length - 1]
  ok(node.type === 'inlineCode')
  node.value = value
  this.exit(token)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM tables in
 * markdown.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM tables.
 */
function gfmTableToMarkdown(options) {
  const settings = options || {}
  const padding = settings.tableCellPadding
  const alignDelimiters = settings.tablePipeAlign
  const stringLength = settings.stringLength
  const around = padding ? ' ' : '|'

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      inlineCode: inlineCodeWithTable,
      table: handleTable,
      tableCell: handleTableCell,
      tableRow: handleTableRow
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, state, info) {
    return serializeData(handleTableAsData(node, state, info), node.align)
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, state, info) {
    const row = handleTableRowAsData(node, state, info)
    const value = serializeData([row])
    // `markdown-table` will always add an align row
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, state, info) {
    const exit = state.enter('tableCell')
    const subexit = state.enter('phrasing')
    const value = state.containerPhrasing(node, {
      ...info,
      before: around,
      after: around
    })
    subexit()
    exit()
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */
  function handleTableAsData(node, state, info) {
    const children = node.children
    let index = -1
    /** @type {Array<Array<string>>} */
    const result = []
    const subexit = state.enter('table')

    while (++index < children.length) {
      result[index] = handleTableRowAsData(children[index], state, info)
    }

    subexit()

    return result
  }

  /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */
  function handleTableRowAsData(node, state, info) {
    const children = node.children
    let index = -1
    /** @type {Array<string>} */
    const result = []
    const subexit = state.enter('tableRow')

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(children[index], node, state, info)
    }

    subexit()

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, state) {
    let value = handle.inlineCode(node, parent, state)

    if (state.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&')
    }

    return value
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm-task-list-item/lib/index.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */




/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM task
 * list items in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM task list items.
 */
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM task list
 * items in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM task list items.
 */
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
    handlers: {listItem: listItemWithTaskListItem}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCheck(token) {
  // We’re always in a paragraph, in a list item.
  const node = this.stack[this.stack.length - 2]
  ok(node.type === 'listItem')
  node.checked = token.type === 'taskListCheckValueChecked'
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitParagraphWithTaskListItem(token) {
  const parent = this.stack[this.stack.length - 2]

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean'
  ) {
    const node = this.stack[this.stack.length - 1]
    ok(node.type === 'paragraph')
    const head = node.children[0]

    if (head && head.type === 'text') {
      const siblings = parent.children
      let index = -1
      /** @type {Paragraph | undefined} */
      let firstParaghraph

      while (++index < siblings.length) {
        const sibling = siblings[index]
        if (sibling.type === 'paragraph') {
          firstParaghraph = sibling
          break
        }
      }

      if (firstParaghraph === node) {
        // Must start with a space or a tab.
        head.value = head.value.slice(1)

        if (head.value.length === 0) {
          node.children.shift()
        } else if (
          node.position &&
          head.position &&
          typeof head.position.start.offset === 'number'
        ) {
          head.position.start.column++
          head.position.start.offset++
          node.position.start = Object.assign({}, head.position.start)
        }
      }
    }
  }

  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, state, info) {
  const head = node.children[0]
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph'
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] '
  const tracker = state.createTracker(info)

  if (checkable) {
    tracker.move(checkbox)
  }

  let value = handle.listItem(node, parent, state, {
    ...info,
    ...tracker.current()
  })

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check)
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

;// CONCATENATED MODULE: ./node_modules/mdast-util-gfm/lib/index.js
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */

/**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */







/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @returns {Array<FromMarkdownExtension>}
 *   Extension for `mdast-util-from-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ]
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown()
    ]
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm/node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */



const node_modules_micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine multiple syntax extensions into one.
 *
 * @param {Array<Extension>} extensions
 *   List of syntax extensions.
 * @returns {NormalizedExtension}
 *   A single combined extension.
 */
function micromark_util_combine_extensions_combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    micromark_util_combine_extensions_syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */
function micromark_util_combine_extensions_syntaxExtension(all, extension) {
  /** @type {keyof Extension} */
  let hook

  for (hook in extension) {
    const maybe = node_modules_micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    /** @type {Record<string, unknown>} */
    const left = maybe || (all[hook] = {})
    /** @type {Record<string, unknown> | undefined} */
    const right = extension[hook]
    /** @type {string} */
    let code

    if (right) {
      for (code in right) {
        if (!node_modules_micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
        const value = right[code]
        micromark_util_combine_extensions_constructs(
          // @ts-expect-error Looks like a list.
          left[code],
          Array.isArray(value) ? value : value ? [value] : []
        )
      }
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */
function micromark_util_combine_extensions_constructs(existing, list) {
  let index = -1
  /** @type {Array<unknown>} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine multiple HTML extensions into one.
 *
 * @param {Array<HtmlExtension>} htmlExtensions
 *   List of HTML extensions.
 * @returns {HtmlExtension}
 *   A single combined HTML extension.
 */
function node_modules_micromark_util_combine_extensions_combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    micromark_util_combine_extensions_htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */
function micromark_util_combine_extensions_htmlExtension(all, extension) {
  /** @type {keyof HtmlExtension} */
  let hook

  for (hook in extension) {
    const maybe = node_modules_micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {keyof Handles} */
    let type

    if (right) {
      for (type in right) {
        // @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
}
const domain = {
  tokenize: tokenizeDomain,
  partial: true
}
const syntax_path = {
  tokenize: tokenizePath,
  partial: true
}
const trail = {
  tokenize: tokenizeTrail,
  partial: true
}
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
}
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}
const protocolAutolink = {
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}

/** @type {ConstructRecord} */
const syntax_text = {}

/**
 * Create an extension for `micromark` to support GitHub autolink literal
 * syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   autolink literal syntax.
 */
function gfmAutolinkLiteral() {
  return {
    text: syntax_text
  }
}

/** @type {Code} */
let syntax_code = 48

// Add alphanumerics.
while (syntax_code < 123) {
  syntax_text[syntax_code] = emailAutolink
  syntax_code++
  if (syntax_code === 58) syntax_code = 65
  else if (syntax_code === 91) syntax_code = 97
}
syntax_text[43] = emailAutolink
syntax_text[45] = emailAutolink
syntax_text[46] = emailAutolink
syntax_text[95] = emailAutolink
syntax_text[72] = [emailAutolink, protocolAutolink]
syntax_text[104] = [emailAutolink, protocolAutolink]
syntax_text[87] = [emailAutolink, wwwAutolink]
syntax_text[119] = [emailAutolink, wwwAutolink]

// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.

/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this
  /** @type {boolean | undefined} */
  let dot
  /** @type {boolean} */
  let data
  return start

  /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (
      !gfmAtext(code) ||
      !previousEmail.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkEmail')
    return atext(code)
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code)
      return atext
    }
    if (code === 64) {
      effects.consume(code)
      return emailDomain
    }
    return nok(code)
  }

  /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */
  function emailDomain(code) {
    // Dot followed by alphanumerical (not `-` or `_`).
    if (code === 46) {
      return effects.check(
        emailDomainDotTrail,
        emailDomainAfter,
        emailDomainDot
      )(code)
    }

    // Alphanumerical, `-`, and `_`.
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      data = true
      effects.consume(code)
      return emailDomain
    }

    // To do: `/` if xmpp.

    // Note: normally we’d truncate trailing punctuation from the link.
    // However, email autolink literals cannot contain any of those markers,
    // except for `.`, but that can only occur if it isn’t trailing.
    // So we can ignore truncating!
    return emailDomainAfter(code)
  }

  /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */
  function emailDomainDot(code) {
    effects.consume(code)
    dot = true
    return emailDomain
  }

  /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function emailDomainAfter(code) {
    // Domain must not be empty, must include a dot, and must end in alphabetical.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
    if (data && dot && asciiAlpha(self.previous)) {
      effects.exit('literalAutolinkEmail')
      effects.exit('literalAutolink')
      return ok(code)
    }
    return nok(code)
  }
}

/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this
  return wwwStart

  /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function wwwStart(code) {
    if (
      (code !== 87 && code !== 119) ||
      !previousWww.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkWww')
    // Note: we *check*, so we can discard the `www.` we parsed.
    // If it worked, we consider it as a part of the domain.
    return effects.check(
      wwwPrefix,
      effects.attempt(domain, effects.attempt(syntax_path, wwwAfter), nok),
      nok
    )(code)
  }

  /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */
  function wwwAfter(code) {
    effects.exit('literalAutolinkWww')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeProtocolAutolink(effects, ok, nok) {
  const self = this
  let buffer = ''
  let seen = false
  return protocolStart

  /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function protocolStart(code) {
    if (
      (code === 72 || code === 104) &&
      previousProtocol.call(self, self.previous) &&
      !previousUnbalanced(self.events)
    ) {
      effects.enter('literalAutolink')
      effects.enter('literalAutolinkHttp')
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    return nok(code)
  }

  /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */
  function protocolPrefixInside(code) {
    // `5` is size of `https`
    if (asciiAlpha(code) && buffer.length < 5) {
      // @ts-expect-error: definitely number.
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    if (code === 58) {
      const protocol = buffer.toLowerCase()
      if (protocol === 'http' || protocol === 'https') {
        effects.consume(code)
        return protocolSlashesInside
      }
    }
    return nok(code)
  }

  /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */
  function protocolSlashesInside(code) {
    if (code === 47) {
      effects.consume(code)
      if (seen) {
        return afterProtocol
      }
      seen = true
      return protocolSlashesInside
    }
    return nok(code)
  }

  /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */
  function afterProtocol(code) {
    // To do: this is different from `markdown-rs`:
    // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
    return code === null ||
      asciiControl(code) ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)
      ? nok(code)
      : effects.attempt(domain, effects.attempt(syntax_path, protocolAfter), nok)(code)
  }

  /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */
  function protocolAfter(code) {
    effects.exit('literalAutolinkHttp')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwPrefix(effects, ok, nok) {
  let size = 0
  return wwwPrefixInside

  /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixInside(code) {
    if ((code === 87 || code === 119) && size < 3) {
      size++
      effects.consume(code)
      return wwwPrefixInside
    }
    if (code === 46 && size === 3) {
      effects.consume(code)
      return wwwPrefixAfter
    }
    return nok(code)
  }

  /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixAfter(code) {
    // If there is *anything*, we can link.
    return code === null ? nok(code) : ok(code)
  }
}

/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean | undefined} */
  let underscoreInLastSegment
  /** @type {boolean | undefined} */
  let underscoreInLastLastSegment
  /** @type {boolean | undefined} */
  let seen
  return domainInside

  /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */
  function domainInside(code) {
    // Check whether this marker, which is a trailing punctuation
    // marker, optionally followed by more trailing markers, and then
    // followed by an end.
    if (code === 46 || code === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code)
    }

    // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      (code !== 45 && unicodePunctuation(code))
    ) {
      return domainAfter(code)
    }
    seen = true
    effects.consume(code)
    return domainInside
  }

  /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */
  function domainAtPunctuation(code) {
    // There is an underscore in the last segment of the domain
    if (code === 95) {
      underscoreInLastSegment = true
    }
    // Otherwise, it’s a `.`: save the last segment underscore in the
    // penultimate segment slot.
    else {
      underscoreInLastLastSegment = underscoreInLastSegment
      underscoreInLastSegment = undefined
    }
    effects.consume(code)
    return domainInside
  }

  /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */
  function domainAfter(code) {
    // Note: that’s GH says a dot is needed, but it’s not true:
    // <https://github.com/github/cmark-gfm/issues/279>
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code)
    }
    return ok(code)
  }
}

/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePath(effects, ok) {
  let sizeOpen = 0
  let sizeClose = 0
  return pathInside

  /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */
  function pathInside(code) {
    if (code === 40) {
      sizeOpen++
      effects.consume(code)
      return pathInside
    }

    // To do: `markdown-rs` also needs this.
    // If this is a paren, and there are less closings than openings,
    // we don’t check for a trail.
    if (code === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code)
    }

    // Check whether this trailing punctuation marker is optionally
    // followed by more trailing markers, and then followed
    // by an end.
    if (
      code === 33 ||
      code === 34 ||
      code === 38 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 60 ||
      code === 63 ||
      code === 93 ||
      code === 95 ||
      code === 126
    ) {
      return effects.check(trail, ok, pathAtPunctuation)(code)
    }
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    effects.consume(code)
    return pathInside
  }

  /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function pathAtPunctuation(code) {
    // Count closing parens.
    if (code === 41) {
      sizeClose++
    }
    effects.consume(code)
    return pathInside
  }
}

/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTrail(effects, ok, nok) {
  return trail

  /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */
  function trail(code) {
    // Regular trailing punctuation.
    if (
      code === 33 ||
      code === 34 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 63 ||
      code === 95 ||
      code === 126
    ) {
      effects.consume(code)
      return trail
    }

    // `&` followed by one or more alphabeticals and then a `;`, is
    // as a whole considered as trailing punctuation.
    // In all other cases, it is considered as continuation of the URL.
    if (code === 38) {
      effects.consume(code)
      return trailCharRefStart
    }

    // Needed because we allow literals after `[`, as we fix:
    // <https://github.com/github/cmark-gfm/issues/278>.
    // Check that it is not followed by `(` or `[`.
    if (code === 93) {
      effects.consume(code)
      return trailBracketAfter
    }
    if (
      // `<` is an end.
      code === 60 ||
      // So is whitespace.
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return nok(code)
  }

  /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailBracketAfter(code) {
    // Whitespace or something that could start a resource or reference is the end.
    // Switch back to trail otherwise.
    if (
      code === null ||
      code === 40 ||
      code === 91 ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return trail(code)
  }

  /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefStart(code) {
    // When non-alpha, it’s not a trail.
    return asciiAlpha(code) ? trailCharRefInside(code) : nok(code)
  }

  /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefInside(code) {
    // Switch back to trail if this is well-formed.
    if (code === 59) {
      effects.consume(code)
      return trail
    }
    if (asciiAlpha(code)) {
      effects.consume(code)
      return trailCharRefInside
    }

    // It’s not a trail.
    return nok(code)
  }
}

/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailDomainDotTrail(effects, ok, nok) {
  return start

  /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Must be dot.
    effects.consume(code)
    return after
  }

  /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Not a trail if alphanumeric.
    return asciiAlphanumeric(code) ? nok(code) : ok(code)
  }
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */
function previousWww(code) {
  return (
    code === null ||
    code === 40 ||
    code === 42 ||
    code === 95 ||
    code === 91 ||
    code === 93 ||
    code === 126 ||
    markdownLineEndingOrSpace(code)
  )
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */
function previousProtocol(code) {
  return !asciiAlpha(code)
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previousEmail(code) {
  // Do not allow a slash “inside” atext.
  // The reference code is a bit weird, but that’s what it results in.
  // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
  // Other than slash, every preceding character is allowed.
  return !(code === 47 || gfmAtext(code))
}

/**
 * @param {Code} code
 * @returns {boolean}
 */
function gfmAtext(code) {
  return (
    code === 43 ||
    code === 45 ||
    code === 46 ||
    code === 95 ||
    asciiAlphanumeric(code)
  )
}

/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */
function previousUnbalanced(events) {
  let index = events.length
  let result = false
  while (index--) {
    const token = events[index][1]
    if (
      (token.type === 'labelLink' || token.type === 'labelImage') &&
      !token._balanced
    ) {
      result = true
      break
    }

    // If we’ve seen this token, and it was marked as not having any unbalanced
    // bracket before it, we can exit.
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false
      break
    }
  }
  if (events.length > 0 && !result) {
    // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true
  }
  return result
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-footnote/node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const blank_line_blankLine = {
  tokenize: blank_line_tokenizeBlankLine,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function blank_line_tokenizeBlankLine(effects, ok, nok) {
  return start

  /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    return markdownSpace(code)
      ? factorySpace(effects, after, 'linePrefix')(code)
      : after(code)
  }

  /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-footnote/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */





const indent = {
  tokenize: syntax_tokenizeIndent,
  partial: true
}

// To do: micromark should support a `_hiddenGfmFootnoteSupport`, which only
// affects label start (image).
// That will let us drop `tokenizePotentialGfmFootnote*`.
// It currently has a `_hiddenFootnoteSupport`, which affects that and more.
// That can be removed when `micromark-extension-footnote` is archived.

/**
 * Create an extension for `micromark` to enable GFM footnote syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to
 *   enable GFM footnote syntax.
 */
function gfmFootnote() {
  /** @type {Extension} */
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: 'after',
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  }
}

// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self = this
  let index = self.events.length
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {Token} */
  let labelStart

  // Find an opening.
  while (index--) {
    const token = self.events[index][1]
    if (token.type === 'labelImage') {
      labelStart = token
      break
    }

    // Exit if we’ve walked far enough.
    if (
      token.type === 'gfmFootnoteCall' ||
      token.type === 'labelLink' ||
      token.type === 'label' ||
      token.type === 'image' ||
      token.type === 'link'
    ) {
      break
    }
  }
  return start

  /**
   * @type {State}
   */
  function start(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code)
    }
    const id = normalizeIdentifier(
      self.sliceSerialize({
        start: labelStart.end,
        end: self.now()
      })
    )
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code)
    }
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return ok(code)
  }
}

// To do: remove after micromark update.
/** @type {Resolver} */
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length
  /** @type {Token | undefined} */
  let labelStart

  // Find an opening.
  while (index--) {
    if (
      events[index][1].type === 'labelImage' &&
      events[index][0] === 'enter'
    ) {
      labelStart = events[index][1]
      break
    }
  }
  // Change the `labelImageMarker` to a `data`.
  events[index + 1][1].type = 'data'
  events[index + 3][1].type = 'gfmFootnoteCallLabelMarker'

  // The whole (without `!`):
  /** @type {Token} */
  const call = {
    type: 'gfmFootnoteCall',
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  // The `^` marker
  /** @type {Token} */
  const marker = {
    type: 'gfmFootnoteCallMarker',
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  }
  // Increment the end 1 character.
  marker.end.column++
  marker.end.offset++
  marker.end._bufferIndex++
  /** @type {Token} */
  const string = {
    type: 'gfmFootnoteCallString',
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  }
  /** @type {Token} */
  const chunk = {
    type: 'chunkString',
    contentType: 'string',
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  }

  /** @type {Array<Event>} */
  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index + 1],
    events[index + 2],
    ['enter', call, context],
    // The `[`
    events[index + 3],
    events[index + 4],
    // The `^`.
    ['enter', marker, context],
    ['exit', marker, context],
    // Everything in between.
    ['enter', string, context],
    ['enter', chunk, context],
    ['exit', chunk, context],
    ['exit', string, context],
    // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ['exit', call, context]
  ]
  events.splice(index, events.length - index + 1, ...replacement)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self = this
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  let size = 0
  /** @type {boolean} */
  let data

  // Note: the implementation of `markdown-rs` is different, because it houses
  // core *and* extensions in one project.
  // Therefore, it can include footnote logic inside `label-end`.
  // We can’t do that, but luckily, we can parse footnotes in a simpler way than
  // needed for labels.
  return start

  /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteCall')
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return callStart
  }

  /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function callStart(code) {
    if (code !== 94) return nok(code)
    effects.enter('gfmFootnoteCallMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallMarker')
    effects.enter('gfmFootnoteCallString')
    effects.enter('chunkString').contentType = 'string'
    return callData
  }

  /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */
  function callData(code) {
    if (
      // Too long.
      size > 999 ||
      // Closing brace with nothing.
      (code === 93 && !data) ||
      // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null ||
      code === 91 ||
      markdownLineEndingOrSpace(code)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit('chunkString')
      const token = effects.exit('gfmFootnoteCallString')
      if (!defined.includes(normalizeIdentifier(self.sliceSerialize(token)))) {
        return nok(code)
      }
      effects.enter('gfmFootnoteCallLabelMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteCallLabelMarker')
      effects.exit('gfmFootnoteCall')
      return ok
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }
    size++
    effects.consume(code)
    return code === 92 ? callEscape : callData
  }

  /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */
  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return callData
    }
    return callData(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionStart(effects, ok, nok) {
  const self = this
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {string} */
  let identifier
  let size = 0
  /** @type {boolean | undefined} */
  let data
  return start

  /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteDefinition')._container = true
    effects.enter('gfmFootnoteDefinitionLabel')
    effects.enter('gfmFootnoteDefinitionLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteDefinitionLabelMarker')
    return labelAtMarker
  }

  /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelAtMarker(code) {
    if (code === 94) {
      effects.enter('gfmFootnoteDefinitionMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionMarker')
      effects.enter('gfmFootnoteDefinitionLabelString')
      effects.enter('chunkString').contentType = 'string'
      return labelInside
    }
    return nok(code)
  }

  /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
      // Too long.
      size > 999 ||
      // Closing brace with nothing.
      (code === 93 && !data) ||
      // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null ||
      code === 91 ||
      markdownLineEndingOrSpace(code)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit('chunkString')
      const token = effects.exit('gfmFootnoteDefinitionLabelString')
      identifier = normalizeIdentifier(self.sliceSerialize(token))
      effects.enter('gfmFootnoteDefinitionLabelMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionLabelMarker')
      effects.exit('gfmFootnoteDefinitionLabel')
      return labelAfter
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }
    size++
    effects.consume(code)
    return code === 92 ? labelEscape : labelInside
  }

  /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return labelInside
    }
    return labelInside(code)
  }

  /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker')
      if (!defined.includes(identifier)) {
        defined.push(identifier)
      }

      // Any whitespace after the marker is eaten, forming indented code
      // is not possible.
      // No space is also fine, just like a block quote marker.
      return factorySpace(
        effects,
        whitespaceAfter,
        'gfmFootnoteDefinitionWhitespace'
      )
    }
    return nok(code)
  }

  /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */
  function whitespaceAfter(code) {
    // `markdown-rs` has a wrapping token for the prefix that is closed here.
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionContinuation(effects, ok, nok) {
  /// Start of footnote definition continuation.
  ///
  /// ```markdown
  ///   | [^a]: b
  /// > |     c
  ///     ^
  /// ```
  //
  // Either a blank line, which is okay, or an indented thing.
  return effects.check(blank_line_blankLine, ok, effects.attempt(indent, ok, nok))
}

/** @type {Exiter} */
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit('gfmFootnoteDefinition')
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function syntax_tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'gfmFootnoteDefinitionIndent',
    4 + 1
  )

  /**
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'gfmFootnoteDefinitionIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === 4
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-strikethrough/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde (default: `true`).
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */




/**
 * Create an extension for `micromark` to enable GFM strikethrough syntax.
 *
 * @param {Options | null | undefined} [options={}]
 *   Configuration.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions`, to
 *   enable GFM strikethrough syntax.
 */
function gfmStrikethrough(options) {
  const options_ = options || {}
  let single = options_.singleTilde
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  }
  if (single === null || single === undefined) {
    single = true
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  }

  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */
  function resolveAllStrikethrough(events, context) {
    let index = -1

    // Walk through all events.
    while (++index < events.length) {
      // Find a token that can close.
      if (
        events[index][0] === 'enter' &&
        events[index][1].type === 'strikethroughSequenceTemporary' &&
        events[index][1]._close
      ) {
        let open = index

        // Now walk back to find an opener.
        while (open--) {
          // Find a token that can open the closer.
          if (
            events[open][0] === 'exit' &&
            events[open][1].type === 'strikethroughSequenceTemporary' &&
            events[open][1]._open &&
            // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset ===
              events[open][1].end.offset - events[open][1].start.offset
          ) {
            events[index][1].type = 'strikethroughSequence'
            events[open][1].type = 'strikethroughSequence'

            /** @type {Token} */
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            }

            /** @type {Token} */
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            }

            // Opening.
            /** @type {Array<Event>} */
            const nextEvents = [
              ['enter', strikethrough, context],
              ['enter', events[open][1], context],
              ['exit', events[open][1], context],
              ['enter', text, context]
            ]
            const insideSpan = context.parser.constructs.insideSpan.null
            if (insideSpan) {
              // Between.
              splice(
                nextEvents,
                nextEvents.length,
                0,
                resolveAll(insideSpan, events.slice(open + 1, index), context)
              )
            }

            // Closing.
            splice(nextEvents, nextEvents.length, 0, [
              ['exit', text, context],
              ['enter', events[index][1], context],
              ['exit', events[index][1], context],
              ['exit', strikethrough, context]
            ])
            splice(events, open - 1, index - open + 3, nextEvents)
            index = open + nextEvents.length - 2
            break
          }
        }
      }
    }
    index = -1
    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data'
      }
    }
    return events
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous
    const events = this.events
    let size = 0
    return start

    /** @type {State} */
    function start(code) {
      if (
        previous === 126 &&
        events[events.length - 1][1].type !== 'characterEscape'
      ) {
        return nok(code)
      }
      effects.enter('strikethroughSequenceTemporary')
      return more(code)
    }

    /** @type {State} */
    function more(code) {
      const before = classifyCharacter(previous)
      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code)
        effects.consume(code)
        size++
        return more
      }
      if (size < 2 && !single) return nok(code)
      const token = effects.exit('strikethroughSequenceTemporary')
      const after = classifyCharacter(code)
      token._open = !after || (after === 2 && Boolean(before))
      token._close = !before || (before === 2 && Boolean(after))
      return ok(code)
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-table/lib/edit-map.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

// Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.

// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.

/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */

/**
 * Tracks a bunch of edits.
 */
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */
    this.map = []
  }

  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(index, remove, add) {
    addImpl(this, index, remove, add)
  }

  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }

  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(events) {
    this.map.sort(function (a, b) {
      return a[0] - b[0]
    })

    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
    if (this.map.length === 0) {
      return
    }

    // To do: if links are added in events, like they are in `markdown-rs`,
    // this is needed.
    // // Calculate jumps: where items in the current list move to.
    // /** @type {Array<Jump>} */
    // const jumps = []
    // let index = 0
    // let addAcc = 0
    // let removeAcc = 0
    // while (index < this.map.length) {
    //   const [at, remove, add] = this.map[index]
    //   removeAcc += remove
    //   addAcc += add.length
    //   jumps.push([at, removeAcc, addAcc])
    //   index += 1
    // }
    //
    // . shiftLinks(events, jumps)

    let index = this.map.length
    /** @type {Array<Array<Event>>} */
    const vecs = []
    while (index > 0) {
      index -= 1
      vecs.push(
        events.slice(this.map[index][0] + this.map[index][1]),
        this.map[index][2]
      )

      // Truncate rest.
      events.length = this.map[index][0]
    }
    vecs.push([...events])
    events.length = 0
    let slice = vecs.pop()
    while (slice) {
      events.push(...slice)
      slice = vecs.pop()
    }

    // Truncate everything.
    this.map.length = 0
  }
}

/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */
function addImpl(editMap, at, remove, add) {
  let index = 0

  /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
  if (remove === 0 && add.length === 0) {
    return
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove

      // To do: before not used by tables, use when moving to micromark.
      // if (before) {
      //   add.push(...editMap.map[index][2])
      //   editMap.map[index][2] = add
      // } else {
      editMap.map[index][2].push(...add)
      // }

      return
    }
    index += 1
  }
  editMap.map.push([at, remove, add])
}

// /**
//  * Shift `previous` and `next` links according to `jumps`.
//  *
//  * This fixes links in case there are events removed or added between them.
//  *
//  * @param {Array<Event>} events
//  * @param {Array<Jump>} jumps
//  */
// function shiftLinks(events, jumps) {
//   let jumpIndex = 0
//   let index = 0
//   let add = 0
//   let rm = 0

//   while (index < events.length) {
//     const rmCurr = rm

//     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
//       add = jumps[jumpIndex][2]
//       rm = jumps[jumpIndex][1]
//       jumpIndex += 1
//     }

//     // Ignore items that will be removed.
//     if (rm > rmCurr) {
//       index += rm - rmCurr
//     } else {
//       // ?
//       // if let Some(link) = &events[index].link {
//       //     if let Some(next) = link.next {
//       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
//       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
//       //             add = jumps[jumpIndex].2;
//       //             rm = jumps[jumpIndex].1;
//       //             jumpIndex += 1;
//       //         }
//       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
//       //         index = next;
//       //         continue;
//       //     }
//       // }
//       index += 1
//     }
//   }
// }

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-table/lib/infer.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */

/**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */
function gfmTableAlign(events, index) {
  let inDelimiterRow = false
  /** @type {Array<Align>} */
  const align = []
  while (index < events.length) {
    const event = events[index]
    if (inDelimiterRow) {
      if (event[0] === 'enter') {
        // Start of alignment value: set a new column.
        // To do: `markdown-rs` uses `tableDelimiterCellValue`.
        if (event[1].type === 'tableContent') {
          align.push(
            events[index + 1][1].type === 'tableDelimiterMarker'
              ? 'left'
              : 'none'
          )
        }
      }
      // Exits:
      // End of alignment value: change the column.
      // To do: `markdown-rs` uses `tableDelimiterCellValue`.
      else if (event[1].type === 'tableContent') {
        if (events[index - 1][1].type === 'tableDelimiterMarker') {
          const alignIndex = align.length - 1
          align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right'
        }
      }
      // Done!
      else if (event[1].type === 'tableDelimiterRow') {
        break
      }
    } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') {
      inDelimiterRow = true
    }
    index += 1
  }
  return align
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-table/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */






/**
 * Create an HTML extension for `micromark` to support GitHub tables syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   table syntax.
 */
function gfmTable() {
  return {
    flow: {
      null: {
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTable(effects, ok, nok) {
  const self = this
  let size = 0
  let sizeB = 0
  /** @type {boolean | undefined} */
  let seen
  return start

  /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */
  function start(code) {
    let index = self.events.length - 1
    while (index > -1) {
      const type = self.events[index][1].type
      if (
        type === 'lineEnding' ||
        // Note: markdown-rs uses `whitespace` instead of `linePrefix`
        type === 'linePrefix'
      )
        index--
      else break
    }
    const tail = index > -1 ? self.events[index][1].type : null
    const next =
      tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore

    // Don’t allow lazy body rows.
    if (next === bodyRowStart && self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    return next(code)
  }

  /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBefore(code) {
    effects.enter('tableHead')
    effects.enter('tableRow')
    return headRowStart(code)
  }

  /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowStart(code) {
    if (code === 124) {
      return headRowBreak(code)
    }

    // To do: micromark-js should let us parse our own whitespace in extensions,
    // like `markdown-rs`:
    //
    // ```js
    // // 4+ spaces.
    // if (markdownSpace(code)) {
    //   return nok(code)
    // }
    // ```

    seen = true
    // Count the first character, that isn’t a pipe, double.
    sizeB += 1
    return headRowBreak(code)
  }

  /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBreak(code) {
    if (code === null) {
      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
      if (sizeB > 1) {
        sizeB = 0
        // To do: check if this works.
        // Feel free to interrupt:
        self.interrupt = true
        effects.exit('tableRow')
        effects.enter('lineEnding')
        effects.consume(code)
        effects.exit('lineEnding')
        return headDelimiterStart
      }

      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownSpace(code)) {
      // To do: check if this is fine.
      // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
      // State::Retry(space_or_tab(tokenizer))
      return factorySpace(effects, headRowBreak, 'whitespace')(code)
    }
    sizeB += 1
    if (seen) {
      seen = false
      // Header cell count.
      size += 1
    }
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      // Whether a delimiter was seen.
      seen = true
      return headRowBreak
    }

    // Anything else is cell data.
    effects.enter('data')
    return headRowData(code)
  }

  /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return headRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? headRowEscape : headRowData
  }

  /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */
  function headRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return headRowData
    }
    return headRowData(code)
  }

  /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterStart(code) {
    // Reset `interrupt`.
    self.interrupt = false

    // Note: in `markdown-rs`, we need to handle piercing here too.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    effects.enter('tableDelimiterRow')
    // Track if we’ve seen a `:` or `|`.
    seen = false
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        headDelimiterBefore,
        'linePrefix',
        self.parser.constructs.disable.null.includes('codeIndented')
          ? undefined
          : 4
      )(code)
    }
    return headDelimiterBefore(code)
  }

  /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterBefore(code) {
    if (code === 45 || code === 58) {
      return headDelimiterValueBefore(code)
    }
    if (code === 124) {
      seen = true
      // If we start with a pipe, we open a cell marker.
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return headDelimiterCellBefore
    }

    // More whitespace / empty row not allowed at start.
    return headDelimiterNok(code)
  }

  /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellBefore(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterValueBefore, 'whitespace')(code)
    }
    return headDelimiterValueBefore(code)
  }

  /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterValueBefore(code) {
    // Align: left.
    if (code === 58) {
      sizeB += 1
      seen = true
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterLeftAlignmentAfter
    }

    // Align: none.
    if (code === 45) {
      sizeB += 1
      // To do: seems weird that this *isn’t* left aligned, but that state is used?
      return headDelimiterLeftAlignmentAfter(code)
    }
    if (code === null || markdownLineEnding(code)) {
      return headDelimiterCellAfter(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterLeftAlignmentAfter(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller')
      return headDelimiterFiller(code)
    }

    // Anything else is not ok after the left-align colon.
    return headDelimiterNok(code)
  }

  /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterFiller(code) {
    if (code === 45) {
      effects.consume(code)
      return headDelimiterFiller
    }

    // Align is `center` if it was `left`, `right` otherwise.
    if (code === 58) {
      seen = true
      effects.exit('tableDelimiterFiller')
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterRightAlignmentAfter
    }
    effects.exit('tableDelimiterFiller')
    return headDelimiterRightAlignmentAfter(code)
  }

  /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterRightAlignmentAfter(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterCellAfter, 'whitespace')(code)
    }
    return headDelimiterCellAfter(code)
  }

  /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellAfter(code) {
    if (code === 124) {
      return headDelimiterBefore(code)
    }
    if (code === null || markdownLineEnding(code)) {
      // Exit when:
      // * there was no `:` or `|` at all (it’s a thematic break or setext
      //   underline instead)
      // * the header cell count is not the delimiter cell count
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code)
      }

      // Note: in markdown-rs`, a reset is needed here.
      effects.exit('tableDelimiterRow')
      effects.exit('tableHead')
      // To do: in `markdown-rs`, resolvers need to be registered manually.
      // effects.register_resolver(ResolveName::GfmTable)
      return ok(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterNok(code) {
    // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
    return nok(code)
  }

  /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */
  function bodyRowStart(code) {
    // Note: in `markdown-rs` we need to manually take care of a prefix,
    // but in `micromark-js` that is done for us, so if we’re here, we’re
    // never at whitespace.
    effects.enter('tableRow')
    return bodyRowBreak(code)
  }

  /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowBreak(code) {
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return bodyRowBreak
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('tableRow')
      return ok(code)
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, bodyRowBreak, 'whitespace')(code)
    }

    // Anything else is cell content.
    effects.enter('data')
    return bodyRowData(code)
  }

  /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */
  function bodyRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return bodyRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? bodyRowEscape : bodyRowData
  }

  /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return bodyRowData
    }
    return bodyRowData(code)
  }
}

/** @type {Resolver} */

function resolveTable(events, context) {
  let index = -1
  let inFirstCellAwaitingPipe = true
  /** @type {RowKind} */
  let rowKind = 0
  /** @type {Range} */
  let lastCell = [0, 0, 0, 0]
  /** @type {Range} */
  let cell = [0, 0, 0, 0]
  let afterHeadAwaitingFirstBodyRow = false
  let lastTableEnd = 0
  /** @type {Token | undefined} */
  let currentTable
  /** @type {Token | undefined} */
  let currentBody
  /** @type {Token | undefined} */
  let currentCell
  const map = new EditMap()
  while (++index < events.length) {
    const event = events[index]
    const token = event[1]
    if (event[0] === 'enter') {
      // Start of head.
      if (token.type === 'tableHead') {
        afterHeadAwaitingFirstBodyRow = false

        // Inject previous (body end and) table end.
        if (lastTableEnd !== 0) {
          flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
          currentBody = undefined
          lastTableEnd = 0
        }

        // Inject table start.
        currentTable = {
          type: 'table',
          start: Object.assign({}, token.start),
          // Note: correct end is set later.
          end: Object.assign({}, token.end)
        }
        map.add(index, 0, [['enter', currentTable, context]])
      } else if (
        token.type === 'tableRow' ||
        token.type === 'tableDelimiterRow'
      ) {
        inFirstCellAwaitingPipe = true
        currentCell = undefined
        lastCell = [0, 0, 0, 0]
        cell = [0, index + 1, 0, 0]

        // Inject table body start.
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false
          currentBody = {
            type: 'tableBody',
            start: Object.assign({}, token.start),
            // Note: correct end is set later.
            end: Object.assign({}, token.end)
          }
          map.add(index, 0, [['enter', currentBody, context]])
        }
        rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1
      }
      // Cell data.
      else if (
        rowKind &&
        (token.type === 'data' ||
          token.type === 'tableDelimiterMarker' ||
          token.type === 'tableDelimiterFiller')
      ) {
        inFirstCellAwaitingPipe = false

        // First value in cell.
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
            lastCell = [0, 0, 0, 0]
          }
          cell[2] = index
        }
      } else if (token.type === 'tableCellDivider') {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
          }
          lastCell = cell
          cell = [lastCell[1], index, 0, 0]
        }
      }
    }
    // Exit events.
    else if (token.type === 'tableHead') {
      afterHeadAwaitingFirstBodyRow = true
      lastTableEnd = index
    } else if (
      token.type === 'tableRow' ||
      token.type === 'tableDelimiterRow'
    ) {
      lastTableEnd = index
      if (lastCell[1] !== 0) {
        cell[0] = cell[1]
        currentCell = flushCell(
          map,
          context,
          lastCell,
          rowKind,
          index,
          currentCell
        )
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map, context, cell, rowKind, index, currentCell)
      }
      rowKind = 0
    } else if (
      rowKind &&
      (token.type === 'data' ||
        token.type === 'tableDelimiterMarker' ||
        token.type === 'tableDelimiterFiller')
    ) {
      cell[3] = index
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
  }
  map.consume(context.events)

  // To do: move this into `html`, when events are exposed there.
  // That’s what `markdown-rs` does.
  // That needs updates to `mdast-util-gfm-table`.
  index = -1
  while (++index < context.events.length) {
    const event = context.events[index]
    if (event[0] === 'enter' && event[1].type === 'table') {
      event[1]._align = gfmTableAlign(context.events, index)
    }
  }
  return events
}

/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */
// eslint-disable-next-line max-params
function flushCell(map, context, range, rowKind, rowEnd, previousCell) {
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
  const groupName =
    rowKind === 1
      ? 'tableHeader'
      : rowKind === 2
      ? 'tableDelimiter'
      : 'tableData'
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
  const valueName = 'tableContent'

  // Insert an exit for the previous cell, if there is one.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //          ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]))
    map.add(range[0], 0, [['exit', previousCell, context]])
  }

  // Insert enter of this cell.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //           ^-- enter
  //           ^^^^-- this cell
  // ```
  const now = getPoint(context.events, range[1])
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    // Note: correct end is set later.
    end: Object.assign({}, now)
  }
  map.add(range[1], 0, [['enter', previousCell, context]])

  // Insert text start at first data start and end at last data end, and
  // remove events between.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //            ^-- enter
  //             ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2])
    const relatedEnd = getPoint(context.events, range[3])
    /** @type {Token} */
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    }
    map.add(range[2], 0, [['enter', valueToken, context]])
    if (rowKind !== 2) {
      // Fix positional info on remaining events
      const start = context.events[range[2]]
      const end = context.events[range[3]]
      start[1].end = Object.assign({}, end[1].end)
      start[1].type = 'chunkText'
      start[1].contentType = 'text'

      // Remove if needed.
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1
        const b = range[3] - range[2] - 1
        map.add(a, b, [])
      }
    }
    map.add(range[3] + 1, 0, [['exit', valueToken, context]])
  }

  // Insert an exit for the last cell, if at the row end.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //                    ^-- exit
  //               ^^^^^^-- this cell (the last one contains two “between” parts)
  // ```
  if (rowEnd !== undefined) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd))
    map.add(rowEnd, 0, [['exit', previousCell, context]])
    previousCell = undefined
  }
  return previousCell
}

/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */
// eslint-disable-next-line max-params
function flushTableEnd(map, context, index, table, tableBody) {
  /** @type {Array<Event>} */
  const exits = []
  const related = getPoint(context.events, index)
  if (tableBody) {
    tableBody.end = Object.assign({}, related)
    exits.push(['exit', tableBody, context])
  }
  table.end = Object.assign({}, related)
  exits.push(['exit', table, context])
  map.add(index + 1, 0, exits)
}

/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */
function getPoint(events, index) {
  const event = events[index]
  const side = event[0] === 'enter' ? 'start' : 'end'
  return event[1][side]
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm-task-list-item/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
}

/**
 * Create an HTML extension for `micromark` to support GFM task list items
 * syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */
function gfmTaskListItem() {
  return {
    text: {
      [91]: tasklistCheck
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this
  return open

  /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null ||
      // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code)
    }
    effects.enter('taskListCheck')
    effects.enter('taskListCheckMarker')
    effects.consume(code)
    effects.exit('taskListCheckMarker')
    return inside
  }

  /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // Currently we match how GH works in files.
    // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
    // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked')
      effects.consume(code)
      effects.exit('taskListCheckValueUnchecked')
      return close
    }
    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked')
      effects.consume(code)
      effects.exit('taskListCheckValueChecked')
      return close
    }
    return nok(code)
  }

  /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */
  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker')
      effects.consume(code)
      effects.exit('taskListCheckMarker')
      effects.exit('taskListCheck')
      return after
    }
    return nok(code)
  }

  /**
   * @type {State}
   */
  function after(code) {
    // EOL in paragraph means there must be something else after it.
    if (markdownLineEnding(code)) {
      return ok(code)
    }

    // Space or tab?
    // Check what comes after.
    if (markdownSpace(code)) {
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )(code)
    }

    // EOF, or non-whitespace, both wrong.
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function spaceThenNonSpace(effects, ok, nok) {
  return factorySpace(effects, after, 'whitespace')

  /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // EOF means there was nothing, so bad.
    // EOL means there’s content after it, so good.
    // Impossible to have more spaces.
    // Anything else is good.
    return code === null ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ./node_modules/micromark-extension-gfm/index.js
/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */









/**
 * Create an extension for `micromark` to enable GFM syntax.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 *
 *   Passed to `micromark-extens-gfm-strikethrough`.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   syntax.
 */
function gfm(options) {
  return micromark_util_combine_extensions_combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable(),
    gfmTaskListItem()
  ])
}

/**
 * Create an extension for `micromark` to support GFM when serializing to HTML.
 *
 * @param {HtmlOptions | null | undefined} [options]
 *   Configuration (optional).
 *
 *   Passed to `micromark-extens-gfm-footnote`.
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM when serializing to HTML.
 */
function gfmHtml(options) {
  return combineHtmlExtensions([
    gfmAutolinkLiteralHtml(),
    gfmFootnoteHtml(options),
    gfmStrikethroughHtml(),
    gfmTableHtml(),
    gfmTagfilterHtml(),
    gfmTaskListItemHtml()
  ])
}

;// CONCATENATED MODULE: ./node_modules/remark-gfm/lib/index.js
/// <reference types="remark-parse" />
/// <reference types="remark-stringify" />

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-gfm').Options} MdastOptions
 * @typedef {import('micromark-extension-gfm').Options} MicromarkOptions
 * @typedef {import('unified').Processor<Root>} Processor
 */

/**
 * @typedef {MicromarkOptions & MdastOptions} Options
 *   Configuration.
 */




/** @type {Options} */
const remark_gfm_lib_emptyOptions = {}

/**
 * Add support GFM (autolink literals, footnotes, strikethrough, tables,
 * tasklists).
 *
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {undefined}
 *   Nothing.
 */
function remarkGfm(options) {
  // @ts-expect-error: TS is wrong about `this`.
  // eslint-disable-next-line unicorn/no-this-assignment
  const self = /** @type {Processor} */ (this)
  const settings = options || remark_gfm_lib_emptyOptions
  const data = self.data()

  const micromarkExtensions =
    data.micromarkExtensions || (data.micromarkExtensions = [])
  const fromMarkdownExtensions =
    data.fromMarkdownExtensions || (data.fromMarkdownExtensions = [])
  const toMarkdownExtensions =
    data.toMarkdownExtensions || (data.toMarkdownExtensions = [])

  micromarkExtensions.push(gfm(settings))
  fromMarkdownExtensions.push(gfmFromMarkdown())
  toMarkdownExtensions.push(gfmToMarkdown(settings))
}

;// CONCATENATED MODULE: ./comps/markdown.tsx




function markdown_Markdown(props) {
    var markdown = props.markdown;
    (0,react.useEffect)(function() {
        var markdownElements = document.getElementsByClassName("markdown-wizard");
        var links = [];
        for(var j = 0; j < markdownElements.length; j++){
            var anchorElements = markdownElements[j].getElementsByTagName("a");
            for(var k = 0; k < anchorElements.length; k++){
                links.push(anchorElements[k]);
            }
        }
        links.forEach(function(link) {
            link.setAttribute("target", "_blank");
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown, {
        remarkPlugins: [
            remarkGfm
        ],
        className: "markdown-wizard",
        children: markdown
    });
}


/***/ }),

/***/ 9034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "jB": function() { return /* binding */ WarningMessage; },
/* harmony export */   "kk": function() { return /* binding */ SuccessMessage; }
/* harmony export */ });
/* unused harmony export MessageContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		margin-top: -67px;\n		opacity: 0;\n	}\n	to {\n		margin-top: 0;\n		opacity: 1;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  word-wrap: break-word;\n  width: 360px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		margin-top: -67px;\n		opacity: 0;\n	}\n	to {\n		margin-top: 0;\n		opacity: 1;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		margin-left: 412px;\n	}\n	to {\n		margin-left: 0;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 1;\n	}\n	to {\n		opacity: 0;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n\n  align-items: center;\n\n  padding: 21px 16px;\n\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 25px;\n\n  box-shadow: 0 8px 29px rgba(41, 91, 48, 0.14);\n\n  animation-name: ",
        ",\n    ",
        ";\n  animation-delay: 0ms,\n    ",
        "ms;\n  animation-direction: normal;\n  animation-fill-mode: forwards;\n  animation-duration: 300ms, ",
        "ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear;\n\n  @media ",
        " {\n    animation-name: ",
        ",\n      ",
        ";\n    animation-timing-function: ease-in-out;\n  }\n\n  @media ",
        " {\n    animation-name: ",
        ",\n      ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		width: 0;\n	}\n	to {\n		width: 100%;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n\n  height: 2px;\n  border-radius: 2px;\n\n  z-index: 2;\n\n  animation-name: ",
        ";\n  animation-delay: 0ms;\n  animation-direction: normal;\n  animation-fill-mode: forwards;\n  animation-duration: ",
        "ms;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in-out;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n\n  z-index: 1;\n\n  height: 2px;\n  width: 100%;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .light & {\n    background: #edf7ef;\n  }\n\n  .dark & {\n    background: #112c23;\n  }\n\n  & ",
        " {\n    background-color: var(--color-success);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg * {\n    fill: var(--color-success);\n    stroke: var(--color-success);\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .light & {\n    background: #e7eff9;\n  }\n\n  .dark & {\n    background: #1b2134;\n  }\n\n  & ",
        " {\n    background-color: var(--color-warning);\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  svg *[fill="#4D76F6"] {\n    fill: var(--color-warning);\n  }\n'
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .light & {\n    background: #f8edea;\n  }\n\n  .dark & {\n    background: #351616;\n  }\n\n  & ",
        " {\n    background-color: var(--color-error);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg * {\n    fill: var(--color-error);\n    stroke: var(--color-error);\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}






var messageAppearMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject());
var MessageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-0"
})(_templateObject1());
var messageAppearTablet = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject2());
var messageAppearDesktop = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject3());
var messageDisappear = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject4());
var disappearDuration = 300;
var MessageContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-1"
})(_templateObject5(), messageAppearMobile, messageDisappear, function(_) {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).timeout - disappearDuration;
}, disappearDuration, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, messageAppearTablet, messageDisappear, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop, messageAppearDesktop, messageDisappear);
var progressAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject6());
var Progressbar = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-2"
})(_templateObject7(), progressAnimation, function(_) {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).timeout;
});
var ProgressbarBackground = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-3"
})(_templateObject8());
var SuccessMessageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(MessageContainer).withConfig({
    componentId: "sc-658701b4-4"
})(_templateObject9(), Progressbar);
var SuccessIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-5"
})(_templateObject10());
var SuccessIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SuccessIconContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M7.71426 18L6.955 18.6508C7.13313 18.8586 7.38867 18.9843 7.66201 18.9986C7.93535 19.0129 8.20261 18.9146 8.40146 18.7265L7.71426 18ZM21.0872 6.72647C21.4884 6.34694 21.506 5.71402 21.1264 5.3128C20.7469 4.91158 20.114 4.894 19.7128 5.27353L21.0872 6.72647ZM4.35923 12.5492C3.99981 12.1299 3.36851 12.0813 2.94918 12.4407C2.52986 12.8002 2.4813 13.4315 2.84072 13.8508L4.35923 12.5492ZM8.40146 18.7265L21.0872 6.72647L19.7128 5.27353L7.02706 17.2735L8.40146 18.7265ZM8.47352 17.3492L4.35923 12.5492L2.84072 13.8508L6.955 18.6508L8.47352 17.3492Z",
                fill: "#09C185"
            })
        })
    });
};
var SuccessMessage = function(props) {
    var title = props.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SuccessMessageContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SuccessIcon, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(title && "flex flex-col", "w-[360px] break-words"),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "text-[17px] font-600 text-blue-700",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: props.children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Progressbar, {
                duration: 4000
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressbarBackground, {})
        ]
    });
};
var WarningMessageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(MessageContainer).withConfig({
    componentId: "sc-658701b4-6"
})(_templateObject11(), Progressbar);
var WarningIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-7"
})(_templateObject12());
var WarningIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WarningIconContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                    cx: "12",
                    cy: "17.5393",
                    r: "0.923077",
                    fill: "#4D76F6"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                    x1: "12",
                    y1: "6.46214",
                    x2: "12",
                    y2: "13.8468",
                    stroke: "#4D76F6",
                    strokeWidth: "1.84615",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                    cx: "12",
                    cy: "11.9998",
                    r: "10.1538",
                    stroke: "#4D76F6",
                    strokeWidth: "1.84615"
                })
            ]
        })
    });
};
var WarningMessage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WarningMessageContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WarningIcon, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MessageWrapper, {
                children: props.children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Progressbar, {
                duration: 4000
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressbarBackground, {})
        ]
    });
};
var ErrorMessageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(MessageContainer).withConfig({
    componentId: "sc-658701b4-8"
})(_templateObject13(), Progressbar);
var ErrorIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-658701b4-9"
})(_templateObject14());
var ErrorIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorIconContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289Z",
                fill: "#FC4040"
            })
        })
    });
};
var ErrorMessage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ErrorMessageContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorIcon, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MessageWrapper, {
                children: props.children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Progressbar, {
                duration: 4000
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressbarBackground, {})
        ]
    });
};


/***/ }),

/***/ 624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export JsonLd */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(177);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);





function JsonLd(json) {
    return /*#__PURE__*/ _jsx("script", {
        type: "application/ld+json",
        children: JSON.stringify(json)
    });
}
var defaultCover = "default-cover";
var Meta = function(props) {
    var title = props.title, description = props.description, cover = props.cover, alt = props.alt, _width = props.width, width = _width === void 0 ? "1200" : _width, _height = props.height, height = _height === void 0 ? "630" : _height, tags = props.tags, _prevAndNextLinks = props.prevAndNextLinks, prevAndNextLinks = _prevAndNextLinks === void 0 ? {
        next: null,
        prev: null
    } : _prevAndNextLinks, _currentPage = props.currentPage, currentPage = _currentPage === void 0 ? null : _currentPage, _jsonLdData = props.jsonLdData, jsonLdData = _jsonLdData === void 0 ? [] : _jsonLdData;
    var next = prevAndNextLinks.next, prev = prevAndNextLinks.prev;
    var coverUrl = cover !== null && cover !== void 0 ? cover : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_3__/* .assetUrl */ .p)("/covers/" + defaultCover + ".jpg");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(router.asPath.split("?"), 1), canonical = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "https://zoomerang.app" + (currentPage !== null && currentPage !== void 0 ? currentPage : canonical)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width, viewport-fit=cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-itunes-app",
                content: "app-id=1361030006, app-argument=https://link.zoomerang.app/QnOr3F3HXvb"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "app-argument",
                href: "https://link.zoomerang.app/QnOr3F3HXvb"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "black"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "https://zoomerang.app" + (currentPage !== null && currentPage !== void 0 ? currentPage : canonical)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: coverUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: coverUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure",
                content: coverUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/jpeg"
            }),
            width && height && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: width
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: height
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: alt !== null && alt !== void 0 ? alt : "Zoomerang app cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Zoomerang"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: coverUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: alt !== null && alt !== void 0 ? alt : "Zoomerang app cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "video maker, video editor, video creator, Video editing, video editor app, best video editing app, iphone video editor, the best video editing software, video maker app, best video maker app, video collage maker, youtube video maker, video creator app, video editing app for android, best video editor for iphone, instagram video editor, tiktok editing app, instagram video maker, insta video editor, slideshow maker, video template app, best mobile apps, video templates, video editing apps, best video editing app for android, best video editing app for ios, best video templates for TikTok, video editing templates, canva video template, best video templates 2022, editable video templates, high-quality video templates, popular video templates, creative video templates, video preset templates, best premiere pro templates" + (tags ? ", " + tags : "")
            }),
            next && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: "https://zoomerang.app" + next
            }),
            prev && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: "https://zoomerang.app" + prev
            }),
            jsonLdData.map(function(data, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(data)
                    }
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6377747033822089",
                crossOrigin: "anonymous"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Meta);


/***/ }),

/***/ 1993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ MarkupTaggedSlice; },
  "uX": function() { return /* binding */ PlayWithProvider; },
  "TY": function() { return /* binding */ Timeline; },
  "ZP": function() { return /* binding */ player; }
});

// UNUSED EXPORTS: NewTimeline, Progress, Progressbar, playerMargin, prettyTime

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/animate/display-trigger.tsx
var display_trigger = __webpack_require__(5467);
// EXTERNAL MODULE: ./comps/template/panel.tsx + 1 modules
var panel = __webpack_require__(4343);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/react-spring.modern.mjs + 4 modules
var react_spring_modern = __webpack_require__(9926);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./utils/hover.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			display: none;\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n	\n	width: 0;\n	height: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Optional = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff6a9666-0"
})(_templateObject1(), function(props) {
    return props.hidden && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var HoverPopup = function(props) {
    var sibling = props.sibling, children = props.children, floating = props.floating, base = props.base, setBase = props.setBase;
    var ref = (0,react.useState)(true), hidden = ref[0], setHidden = ref[1];
    if (hidden && (base || floating)) setHidden(false);
    var device = (0,breakpoints/* useDeviceSize */.BV)();
    (0,react.useEffect)(function() {
        var desktop = device === breakpoints/* Device.Desktop */.AS.Desktop;
        var onMouseEnter = function() {
            return desktop && setBase(true);
        };
        var onMouseLeave = function() {
            return setBase(false);
        };
        var elem = sibling.current;
        if (elem === null) return;
        elem.addEventListener("mouseenter", onMouseEnter);
        elem.addEventListener("mouseleave", onMouseLeave);
        return function() {
            elem.removeEventListener("mouseenter", onMouseEnter);
            elem.removeEventListener("mouseleave", onMouseLeave);
        };
    }, [
        sibling,
        device,
        setBase
    ]);
    var trigger = base || floating;
    var style = (0,react_spring_modern/* useSpring */.q_)({
        display: "inline-block",
        transform: trigger ? "scale(1)" : "scale(0.8)",
        opacity: trigger ? 1 : 0,
        onRest: function() {
            return setHidden(true);
        },
        config: react_spring_modern/* config.gentle */.vc.gentle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Optional, {
        hidden: hidden,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_modern/* animated.div */.q.div, {
            style: style,
            children: children
        })
    });
};
/* harmony default export */ var hover = (HoverPopup);

// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
// EXTERNAL MODULE: ./utils/popups.tsx
var popups = __webpack_require__(2763);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var lib_esm = __webpack_require__(4059);
// EXTERNAL MODULE: ./node_modules/video-provider/dist/esm/index.js
var dist_esm = __webpack_require__(1501);
// EXTERNAL MODULE: ./comps/template/comments.tsx
var template_comments = __webpack_require__(6412);
;// CONCATENATED MODULE: ./comps/player.tsx




function player_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 15;\n\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  user-select: none;\n  -webkit-touch-callout: none;\n"
    ]);
    player_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function player_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0 !important;\n    "
    ]);
    player_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 44px;\n  height: 44px;\n\n  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.5));\n\n  transition: opacity 300ms ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: pointer;\n      &:hover {\n        background: rgba(0, 0, 0, 0.2);\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px;\n  background: rgba(0, 0, 0, 0);\n\n  ",
        ";\n\n  border-radius: 100%;\n  transition: background 200ms ease-in-out;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: ",
        ";\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-radius: 0 0 20px 20px;\n          "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 2px;\n\n  background: rgba(0, 0, 0, 0.4);\n\n  @media ",
        " {\n    height: 44px;\n\n    ",
        "\n\n    display: flex;\n    flex-direction: row;\n\n    gap: 16px;\n\n    align-items: center;\n\n    padding: 0 16px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n\n  cursor: pointer;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 2px;\n\n  background: rgba(255, 255, 255, 0.2);\n\n  overflow: hidden;\n\n  @media ",
        " {\n    height: 4px;\n    border-radius: 8px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 9;\n  top: 0;\n  left: 0;\n\n  height: 4px;\n\n  border-radius: 4px;\n\n  background: var(--color-white);\n  opacity: 0.2;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n\n  height: 2px;\n\n  transition: width ",
        "ms linear;\n\n  background: #ecedef;\n\n  @media ",
        " {\n    border-radius: 4px;\n    height: 4px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n\n  text-align: right;\n  width: 80px;\n\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n\n  position: absolute;\n  z-index: 70;\n  top: 10px;\n  left: 10px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n\n  transition: opacity 100ms ease-in-out;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -190px;\n  right: -54px;\n\n  padding: 22px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  background-color: var(--color-primary-500);\n  border-radius: 4px;\n\n  width: 4px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 4px;\n  width: 4px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 8px;\n  height: 8px;\n\n  margin: -4px -2px;\n  background-color: #ecedef;\n  border-radius: 100%;\n\n  z-index: 100;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n\n  cursor: pointer;\n\n  padding: 12px 0;\n\n  width: 28px;\n  height: 102px;\n  background: rgba(0, 0, 0, 0.8);\n  border-radius: 4px;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &:hover ",
        " {\n    width: 6px;\n  }\n\n  &:hover ",
        " {\n    width: 10px;\n    height: 10px;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 20px;\n\n  cursor: pointer;\n\n  flex-shrink: 0;\n\n  width: 40px;\n  height: 40px;\n\n  display: none;\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 12px;\n\n  text-align: center;\n\n  text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n\n  ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n      height: 100%;\n      border-radius: 100%;\n      border: 1px solid var(--color-separator);\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 28px;\n  height: 28px;\n\n  ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n\n  width: calc(100% - 32px);\n  max-width: 400px;\n\n  margin: 0 16px;\n\n  @media ",
        " {\n    display: none;\n  }\n\n  padding: 16px 0;\n  text-align: center;\n  border-radius: 10px;\n\n  align-self: center;\n  justify-self: center;\n\n  background-color: var(--color-primary-500);\n\n  transition: background-color 300ms ease-in-out;\n\n  &:hover {\n    background-color: #e4164b;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  padding: 4px;\n  background-color: #ffffff;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n\n  color: var(--color-blue-700) !important;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 60px;\n\n  flex: 1;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: 0.02em;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n\n  letter-spacing: 0.02em;\n\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  letter-spacing: 0.02em;\n\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}



















var playerMargin = 90;
var PlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-0"
})(player_templateObject());
var PlayButton = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1dd5ade5-1"
})(_templateObject2(), function(props) {
    return !props.show && (0,styled_components_browser_esm/* css */.iv)(player_templateObject1());
});
var PlayHover = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-2"
})(_templateObject4(), function(props) {
    return props.enabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var PlayWithProvider = function() {
    var player = (0,react.useContext)(dist_esm/* VideoContext */.l);
    if (player === null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var paused = player.paused, play = player.play, pause = player.pause;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayContainer, {
        onClick: paused ? play : pause,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayHover, {
            enabled: paused,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayButton, {
                src: (0,cdn/* assetUrl */.p)("/icons/player/play.png"),
                alt: "play icon",
                show: paused
            })
        })
    });
};
var TimelineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-3"
})(_templateObject7(), breakpoints/* devices.desktop */.Hb.desktop, function(props) {
    return props.radius ? (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), props.radius) : (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var NewTimeline = function() {
    var player = useContext(VideoContext);
    if (player === null) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("absolute bottom-0 left-0 w-full"),
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx("h-[2px] w-full bg-color-popup desktop:h-[44px]", "flex items-center gap-[16px] py-[16px]")
        })
    });
};
var Timeline = function(props) {
    var player = (0,react.useContext)(dist_esm/* VideoContext */.l);
    if (player === null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineContainer, {
        radius: props.radius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timestamp, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Volume, {})
        ]
    });
};
var ProgressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-4"
})(_templateObject8(), breakpoints/* devices.desktop */.Hb.desktop);
var ProgressContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-5"
})(_templateObject9(), breakpoints/* devices.desktop */.Hb.desktop);
var updateInterval = 300;
var Hoverbar = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        style: {
            width: props.progress + "%"
        }
    };
}).withConfig({
    componentId: "sc-1dd5ade5-6"
})(_templateObject10());
var Progressbar = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        style: {
            width: props.progress + "%"
        }
    };
}).withConfig({
    componentId: "sc-1dd5ade5-7"
})(_templateObject11(), updateInterval, breakpoints/* devices.desktop */.Hb.desktop);
var Progress = function() {
    var ref = (0,react.useState)(0), hoverProgress = ref[0], setHoverProgress = ref[1];
    var player = (0,react.useContext)(dist_esm/* VideoContext */.l);
    var ref1 = (0,react.useRef)(null);
    var calculateProgress = function(mouse) {
        var ref;
        var rect = (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        if (!rect) return 0;
        var x = rect.left;
        var w = rect.width;
        return (mouse - x) / w;
    };
    var handleMoveCallback = function(e) {
        var progress = calculateProgress(e.clientX);
        if (progress > 0) {
            setHoverProgress(progress * 100);
        }
        return progress;
    };
    var handleMove = (0,react.useCallback)(handleMoveCallback, []);
    var handleClick = (0,react.useCallback)(function(e) {
        if (player === null) return;
        var newProgress = handleMove(e);
        player.seek(newProgress * player.duration);
        setHoverProgress(0);
    }, [
        player,
        handleMove
    ]);
    if (player === null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var now = player.now, duration = player.duration;
    var progress = now / duration * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressWrapper, {
        onClick: handleClick,
        onPointerMove: handleMove,
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProgressContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Progressbar, {
                    progress: progress
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hoverbar, {
                    progress: hoverProgress
                })
            ]
        })
    });
};
var TimestampText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-8"
})(_templateObject12(), breakpoints/* devices.desktop */.Hb.desktop);
var prettyTime = function(seconds) {
    var roundedSeconds = Math.floor(seconds);
    var remainder = roundedSeconds % 60;
    var minutes = Math.floor(roundedSeconds / 60);
    return minutes.toFixed(0).padStart(2, "0") + ":" + remainder.toFixed(0).padStart(2, "0");
};
var Timestamp = function() {
    var player = (0,react.useContext)(dist_esm/* VideoContext */.l);
    if (player === null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var now = player.now, duration = player.duration;
    if (!duration) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var time = prettyTime(now) + " / " + prettyTime(duration);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimestampText, {
        children: time
    });
};
var VolumeIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1dd5ade5-9"
})(_templateObject13());
var VolumeStepIcon = (0,styled_components_browser_esm/* default */.ZP)(VolumeIcon).withConfig({
    componentId: "sc-1dd5ade5-10"
})(_templateObject14(), function(props) {
    return props.opacity;
});
var VolumeControlWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-11"
})(_templateObject15());
var VolumeBarForeground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-12"
})(_templateObject16(), function(props) {
    return props.volume * 78;
});
var VolumeBarBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-13"
})(_templateObject17());
var VolumeBarBall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-14"
})(_templateObject18());
var VolumeControlContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-15"
})(_templateObject19(), VolumeBarForeground, VolumeBarBall);
var VolumeButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-16"
})(_templateObject20(), breakpoints/* devices.desktop */.Hb.desktop);
var Volume = function() {
    var ref = (0,react.useState)(false), holding = ref[0], setHolding = ref[1];
    var ref1 = (0,react.useState)(false), base = ref1[0], setBase = ref1[1];
    var ref2 = (0,react.useState)(false), floating = ref2[0], setFloating = ref2[1];
    var player = (0,react.useContext)(dist_esm/* VideoContext */.l);
    var ref3 = (0,react.useRef)(null);
    var volumeRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleMouseUp = function() {
            if (holding) {
                setHolding(false);
            }
        };
        addEventListener("mouseup", handleMouseUp);
        return function() {
            return removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        holding,
        setHolding
    ]);
    var handleMove = (0,react.useCallback)(function(e) {
        if (player === null) return;
        if (holding) {
            player.muted && player.mute(false);
            player.setVolume(calculateVolume(e.clientY));
        }
    }, [
        player,
        holding
    ]);
    if (player === null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var muted = player.muted, mute = player.mute, volume = player.volume, setVolume = player.setVolume;
    var calculateVolume = function(mouse) {
        var ref;
        var rect = (ref = volumeRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        if (!rect) return 0;
        var y = rect.top;
        var h = rect.height;
        var result = 2 - (h - y + mouse) / h;
        if (result > 1) return 1;
        if (result < 0.05) return 0;
        return result;
    };
    var noSound = volume < 0.05 || muted;
    var highOpacity = volume < 0.5 ? 0 : (volume - 0.5) * 2;
    var mediumOpacity = volume > 0.5 ? 1 : volume * 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeButton, {
                onClick: function() {
                    return mute(!muted);
                },
                ref: ref3,
                children: noSound ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeIcon, {
                    src: (0,cdn/* assetUrl */.p)("/icons/player/volume-slash.svg"),
                    alt: "volume icon"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeIcon, {
                            src: (0,cdn/* assetUrl */.p)("/icons/player/speaker.svg"),
                            alt: "volume icon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeStepIcon, {
                            opacity: highOpacity,
                            alt: "volume icon",
                            src: (0,cdn/* assetUrl */.p)("/icons/player/volume-high.svg")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeStepIcon, {
                            opacity: mediumOpacity,
                            alt: "volume icon",
                            src: (0,cdn/* assetUrl */.p)("/icons/player/volume-medium.svg")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hover, {
                sibling: ref3,
                base: base,
                setBase: setBase,
                floating: floating,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeControlWrapper, {
                    onMouseEnter: function() {
                        return base && setFloating(true);
                    },
                    onMouseLeave: function() {
                        return setFloating(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeControlContainer, {
                        onPointerDown: function(e) {
                            setHolding(true);
                            muted && mute(false);
                            setVolume(calculateVolume(e.clientY));
                        },
                        onPointerMove: handleMove,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VolumeBarBackground, {
                            ref: volumeRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeBarBall, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeBarForeground, {
                                    volume: volume
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var ActionsNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-17"
})(_templateObject22(), function(props) {
    return props.hide && (0,styled_components_browser_esm/* css */.iv)(_templateObject21());
});
var ActionIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1dd5ade5-18"
})(_templateObject24(), function(props) {
    return props.big && (0,styled_components_browser_esm/* css */.iv)(_templateObject23());
});
var Actions = function(param) {
    var mobile = param.mobile;
    var template = (0,react.useContext)(TemplateContext);
    var popup = (0,react.useContext)(popups/* PopupContext */.tH);
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isFollowed = ref[0], setIsFollowed = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var ref;
            (ref = document.getElementById("hide-after-see")) === null || ref === void 0 ? void 0 : ref.classList.add("opacity-0");
        }, 5000);
    }, [
        isFollowed
    ]);
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    if (!template) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var comments = template.comments, id = template.id, creator = template.creator, share = template.share, name = template.name, allowComments = template.allowComments;
    var isSelf = userInfo.userId === creator.uid;
    var _picture;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex shrink-0 flex-col justify-end gap-[16px] pb-[40px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("relative flex flex-col gap-[7px] desktop:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex h-[44px] w-[44px] items-center justify-center rounded-full",
                        href: "/" + creator.username,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon, {
                            big: true,
                            onError: function(e) {
                                return e.currentTarget.setAttribute("src", (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg"));
                            },
                            src: (_picture = creator.picture) !== null && _picture !== void 0 ? _picture : (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg"),
                            alt: "action icon"
                        })
                    }),
                    isFollowed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/check-other-primary.svg"),
                        alt: "check icon",
                        id: "hide-after-see",
                        className: (0,clsx_m/* default */.Z)("h-[20px] w-[20px] animate-appear", "absolute -bottom-[7px] left-1/2 -translate-x-1/2")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)(isSelf && "hidden", "absolute -bottom-[7px] left-1/2 -translate-x-1/2"),
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setIsFollowed(!isFollowed);
                                        return [
                                            4,
                                            axios/* default.post */.Z.post("/api/user-follow", {
                                                uid_to: creator.uid
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/plus-other-primary.svg"),
                            alt: "pluse icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex flex-col gap-[7px] desktop:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-[44px] w-[44px] items-center justify-center rounded-full",
                        onClick: function() {
                            mobile && (0,popups/* default */.ZP)(popup, function(close) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_comments/* default */.Z, {
                                    allowed: allowComments,
                                    close: close,
                                    template: id,
                                    count: comments,
                                    username: creator.username
                                });
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon, {
                            src: (0,cdn/* assetUrl */.p)("/icons/player/comments.svg"),
                            alt: "comment icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsNumber, {
                        children: allowComments ? (0,millions/* default */.Z)(comments) : 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex flex-col gap-[7px] desktop:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-[44px] w-[44px] items-center justify-center rounded-full",
                        onClick: function() {
                            mobile && (0,popups/* default */.ZP)(popup, function(_) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* ShareRow */.ji, {
                                    share: share !== null && share !== void 0 ? share : branch/* appStoreConstant */.HY,
                                    name: name
                                });
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon, {
                            src: (0,cdn/* assetUrl */.p)("/player/share.webp"),
                            alt: "share icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsNumber, {
                        children: t("lbl_share")
                    })
                ]
            })
        ]
    });
};
var UseTemplateButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-1dd5ade5-19"
})(_templateObject25(), breakpoints/* devices.desktop */.Hb.desktop);
var QrContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-20"
})(_templateObject26());
var ScanText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-21"
})(_templateObject27());
var NameDescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dd5ade5-22"
})(_templateObject28(), breakpoints/* devices.desktop */.Hb.desktop);
var NameText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-23"
})(_templateObject29());
var DescriptionText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-24"
})(_templateObject30());
var CategoryText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dd5ade5-25"
})(_templateObject31());
var MarkupTaggedSlice = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.tags.map(function(tag, index) {
            switch(tag.format){
                case "username":
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(panel/* Username */.Ru, {
                        href: "/user/" + tag.uid,
                        children: [
                            "@",
                            tag.label
                        ]
                    }, index);
                case "hashtag":
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(panel/* Hashtag */.AQ, {
                        children: [
                            "#",
                            tag.content,
                            " "
                        ]
                    }, index);
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(panel/* Word */.Bl, {
                        children: tag.content
                    }, index);
            }
        })
    });
};
var NameDescription = function() {
    var ref;
    var ref1 = (ref = (0,react.useContext)(TemplateContext)) !== null && ref !== void 0 ? ref : {}, name = ref1.name, description = ref1.description, category = ref1.category, isFeatured = ref1.isFeatured;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameDescriptionContainer, {
        children: [
            isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)("self-start rounded-md bg-[linear-gradient(90deg,#4F6BFE_0%,#00A1FB_100%)]", "px-2 py-[2px] text-xs font-600 uppercase"),
                children: t("lbl_featured")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NameText, {
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkupTaggedSlice, {
                    tags: description || []
                })
            }),
            category && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/player/category.svg"),
                        alt: "category icon"
                    }),
                    category
                ]
            })
        ]
    });
};
var TemplateContext = /*#__PURE__*/ (0,react.createContext)(null);
var Player = function(props) {
    var active = props.active, template = props.template;
    var preview = template.preview, creator = template.creator, video = template.video, share = template.share, name = template.name, id = template.id;
    var ref = (0,react.useState)(false), buttonSelected = ref[0], setButtonSelected = ref[1];
    var ref1 = (0,react.useState)(false), qrSelected = ref1[0], setQrSelected = ref1[1];
    var ref2 = (0,react.useState)(true), hidden = ref2[0], setHidden = ref2[1];
    var ref3 = (0,react.useRef)(null);
    var t = (0,esm/* useTranslation */.$G)().t;
    if (hidden && (buttonSelected || qrSelected)) setHidden(false);
    var style = (0,display_trigger/* useBoop */.k)({
        scale: 1.3,
        trigger: buttonSelected || qrSelected,
        close: function() {
            setHidden(true);
        }
    });
    var handleVisibilityChange = (0,react.useCallback)(function() {
        if (document.hidden) {
            var ref;
            (ref = ref3.current) === null || ref === void 0 ? void 0 : ref.pause();
        }
    }, [
        ref3
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (active) {
            var ref1;
            (ref1 = ref3.current) === null || ref1 === void 0 ? void 0 : ref1.play().catch(console.error);
            var artwork = creator.picture ? [
                {
                    src: creator.picture,
                    sizes: "512x512",
                    type: "image/jpeg"
                }, 
            ] : [
                {
                    src: (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg"),
                    sizes: "68x68",
                    type: "image/svg+xml"
                }, 
            ];
            if (navigator.mediaSession) navigator.mediaSession.metadata = new MediaMetadata({
                title: name,
                artist: creator.username,
                album: "Zoomerang",
                artwork: artwork
            });
        } else (ref = ref3.current) === null || ref === void 0 ? void 0 : ref.pause();
    }, [
        active,
        creator.picture,
        creator.username,
        name,
        ref3
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return function() {
            return document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [
        handleVisibilityChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(!active && "opacity-20", "flex snap-start scroll-mt-0 flex-col justify-center text-[#ffffff]", "desktop:transition-opacity desktop:duration-100 desktop:ease-in-out", "desktop:scroll-mt-[0px] desktop:last-of-type:mb-[170px]", "h-full items-center "),
        "data-index": id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("relative flex select-none flex-col items-center justify-center", "tablet:rounded-[20px]"),
                style: (0,_object_spread/* default */.Z)({}, {
                    WebkitMediaControls: {
                        display: "none !important"
                    }
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        ref: ref3,
                        preload: "none",
                        src: video + "#t=0.001",
                        loop: true,
                        playsInline: true,
                        autoPlay: active,
                        poster: preview.jpg,
                        className: (0,clsx_m/* default */.Z)("cursor-pointer tablet:max-w-[447px] tablet:object-contain desktop:max-w-none", "adesktop:max-w-[406px] aspect-[9/16]", "adesktop:w-auto tablet:rounded-[20px]", "h-[100svh] tablet:h-full desktop:h-[calc(100svh-110px)]")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* VideoProvider */.G, {
                        element: ref3,
                        remember: [
                            "volume",
                            "mute"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateContext.Provider, {
                            value: template,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("absolute bottom-0 left-0 z-50 w-full", "flex flex-col items-stretch justify-end gap-[16px]", "tablet:rounded-b-[20px]", "bg-gradient-to-t from-[#191919] via-[#19191966] to-[#1919191A]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("flex items-center px-[16px] py-0", "justify-between gap-[16px] desktop:hidden"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NameDescription, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute bottom-[60px] right-[16px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                                                        mobile: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UseTemplateButton, {
                                            href: share !== null && share !== void 0 ? share : "/",
                                            children: t("txt_use_template")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute -right-[60px] bottom-[60px] hidden desktop:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayWithProvider, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden w-full desktop:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)("h-[48px] rounded-[10px] text-[16px] font-700 leading-[19px]", "m-[16px] mt-[20px] w-full bg-primary-500 transition-colors duration-300 ease-in-out", "hover:bg-primary-600 desktop:m-0 desktop:mt-[20px]"),
                        onMouseEnter: function() {
                            return setButtonSelected(true);
                        },
                        onMouseLeave: function() {
                            return setButtonSelected(false);
                        },
                        children: t("txt_use_template")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(hidden && "hidden", "absolute bottom-[50px] left-0 right-0 z-[60]", "flex items-center justify-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_modern/* animated.div */.q.div, {
                            style: style,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer px-[10px] pb-[80px] pt-[10px]",
                                onMouseEnter: function() {
                                    return buttonSelected && setQrSelected(true);
                                },
                                onMouseLeave: function() {
                                    return setQrSelected(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("rounded-[12px] px-[8px] pb-[16px] pt-[8px]", "flex flex-col items-center gap-[8px] bg-color-cell"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QrContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* QRCodeCanvas */.Qd, {
                                                value: share !== null && share !== void 0 ? share : branch/* appStoreConstant */.HY,
                                                size: 150,
                                                fgColor: "#000000",
                                                bgColor: "#ffffff"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanText, {
                                            children: t("txt_scan_to_shoot")
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var player = (Player);


/***/ }),

/***/ 3363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


function PrimaryButton(props) {
    var href = props.href, onClick = props.onClick, children = props.children, inactive = props.inactive, center = props.center, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(className, inactive ? "border-1 border-color-separator text-blue-300" : "bg-primary-500 text-color-white", center && "self-center", "px-24px box-border min-w-[232px] py-3 font-600", "rounded-[10px] text-center hover:bg-primary-600", "text-color-white transition-colors", "cursor-pointer select-none"),
        onClick: function(event) {
            if (!href) {
                event.preventDefault();
                if (onClick) onClick();
            }
        },
        children: children
    });
}


/***/ }),

/***/ 4903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useProgressive; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var useProgressive = function(image) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), ready = ref[0], setReady = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (image === undefined) return;
        var loader = new Image();
        loader.src = image;
        loader.onload = function() {
            return setReady(image);
        };
    }, [
        image
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (ready === image) {
            return;
        }
        if (ready === null) {
            return;
        }
        setReady(null);
    }, [
        image,
        ready
    ]);
    return ready !== null;
};
var Progressive = function(props) {
    var source = props.source, placeholder = props.placeholder;
    var ready = useProgressive(source);
    if (ready) return /*#__PURE__*/ _jsx("img", {
        src: source,
        alt: "progressive"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: placeholder
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Progressive)));


/***/ }),

/***/ 356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ SimpleDropArea; },
/* harmony export */   "Kg": function() { return /* binding */ DropAreaSmall; },
/* harmony export */   "Oh": function() { return /* binding */ DropAreaForModel; },
/* harmony export */   "aN": function() { return /* binding */ mimeTypes; },
/* harmony export */   "lz": function() { return /* binding */ getFormatsFromMimeTypes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9612);









var mimeTypes = {
    images: [
        "image/jpeg",
        "image/png",
        "image/webp"
    ],
    videos: [
        "video/mp4",
        "video/quicktime"
    ]
};
function getFormatsFromMimeTypes(mimeTypes) {
    return mimeTypes.reduce(function(acc, format) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, format, []));
    }, {});
}
function SimpleDropArea(props) {
    var className = props.className, state = props.state, formats = props.formats, openExplorer = props.openExplorer, disabled = props.disabled, loading = props.loading;
    var getRootProps = state.getRootProps, getInputProps = state.getInputProps, isDragActive = state.isDragActive;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common").t;
    var supportedFormats = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formats.map(function(format) {
            return format.split("/")[1].includes("quicktime") ? "MOV" : format.split("/")[1].toUpperCase();
        }).join(", ");
    }, [
        formats
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getRootProps({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            className,
            disabled === true && !loading && "opacity-30 pointer-events-none",
            "relative rounded-[12px] cursor-pointer",
            "select-none flex flex-col items-center justify-center border-dashed border hover:border-primary-500 border-primary-200",
            isDragActive ? "bg-blue-100" : "bg-blue-50 hover:bg-blue-100",
            "transition-colors duration-200",
            loading && "pointer-events-none", 
        ])
    })), {
        onClick: openExplorer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 h-full w-full rounded-[22px] border border-primary-100 bg-blue-100 transition-opacity", "flex items-center justify-center", loading ? "opacity-100" : "opacity-0"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-16 w-16 items-center justify-center rounded-full bg-color-cell",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/general/loader.webp"),
                        alt: "loading image",
                        className: "animate-[spin_1s_infinite_linear]"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 h-full w-full rounded-[12px] border-2 border-primary-100 bg-blue-200 transition-opacity", "flex items-center justify-center", "text-[28px] font-700 text-blue-800", isDragActive ? "opacity-100" : "opacity-0"),
                children: t("txt_drop_here")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 64 64",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "32",
                            cy: "32",
                            r: "32",
                            fill: "var(--color-primary-100)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M28.999 24.5L31.999 21.5L34.999 24.5",
                            stroke: "var(--color-primary-700)",
                            strokeWidth: "2",
                            strokeMiterlimit: "10",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M31.999 33.5V21.5",
                            stroke: "var(--color-primary-700)",
                            strokeWidth: "2",
                            strokeMiterlimit: "10",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M20.5684 32.543V37.5932C20.5684 40.0031 22.522 41.9568 24.932 41.9568H39.0669C41.4769 41.9568 43.4305 40.0031 43.4305 37.5932V32.543",
                            stroke: "var(--color-primary-700)",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "text-[16px] font-500",
                children: [
                    t("txt_drag_and_drop"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-primary-500",
                        children: t("lbl_upload")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getInputProps())),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[13px] font-400",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("txt_supported_files")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-1",
                        children: supportedFormats
                    })
                ]
            })
        ]
    }));
}
function DropAreaSmall(props) {
    var className = props.className, state = props.state, openExplorer = props.openExplorer, border = props.border, disabled = props.disabled, borderImage = props.borderImage;
    var getRootProps = state.getRootProps, getInputProps = state.getInputProps, isDragActive = state.isDragActive;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getRootProps({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            className,
            disabled === true && "opacity-30 pointer-events-none",
            "relative rounded-[12px] cursor-pointer",
            "select-none flex flex-col items-center justify-center border-dashed border hover:border-primary-500 border-primary-200",
            isDragActive ? "bg-blue-100" : "bg-blue-50 hover:bg-blue-100",
            "transition-colors duration-200", 
        ])
    })), {
        onClick: openExplorer,
        children: [
            border && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                source: borderImage !== null && borderImage !== void 0 ? borderImage : "/general/border-dropzone",
                format: "svg",
                className: "pointer-events-none absolute left-0 top-0 h-full w-full"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: "16",
                        cy: "16",
                        r: "16",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.5002 12.25L16.0002 10.75L17.5002 12.25",
                        stroke: "#6498EE",
                        strokeWidth: "1.5",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.0002 16.75V10.75",
                        stroke: "#6498EE",
                        strokeWidth: "1.5",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.2849 16.2715V16.6148C10.2849 19.0247 12.2386 20.9784 14.6485 20.9784H17.3524C19.7623 20.9784 21.716 19.0247 21.716 16.6148V16.2715",
                        stroke: "#6498EE",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[13px] font-500 text-blue-700",
                children: t("txt_upload_or_drag_and_drop")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getInputProps()))
        ]
    }));
}
function DropAreaForModel(props) {
    var className = props.className, state = props.state, formats = props.formats, openExplorer = props.openExplorer, disabled = props.disabled, noText = props.noText, small = props.small, button = props.button;
    var getRootProps = state.getRootProps, getInputProps = state.getInputProps, isDragActive = state.isDragActive;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common").t;
    var supportedFormats = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return formats.map(function(format) {
            return format.split("/")[1].toUpperCase();
        }).join(", ");
    }, [
        formats
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getRootProps({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(className, disabled && "pointer-events-none opacity-30", small ? "gap-[4px] py-[16px]" : "gap-[14px]", isDragActive && "!bg-primary-50", button ? "bg-blue-200 rounded-[6px] h-[44px] w-full hover:bg-blue-300" : "bg-blue-50 hover:bg-primary-50", "transition-colors duration-200 relative cursor-pointer", "flex select-none flex-col items-center justify-center", "border-dashed border hover:border-primary-500 border-primary-200")
    })), {
        onClick: openExplorer,
        children: button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "!flex w-full items-center justify-center gap-[6px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "21",
                    height: "20",
                    viewBox: "0 0 21 20",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M7.915 5.42236C8.77038 4.15183 10.1712 3.33398 11.7409 3.33398C14.1733 3.33398 16.2196 5.31013 16.4209 7.88916C17.8019 8.34416 18.8327 9.7074 18.8327 11.3636C18.8327 13.406 17.2677 15.0007 15.4073 15.0007L15.4033 15.0006L15.3779 15.0005L15.3741 15.0005L13.2502 15.0001C12.8097 15.0001 12.4541 14.6085 12.4542 14.1276C12.4542 13.6467 12.8099 13.2552 13.2504 13.2553L15.382 13.2556L15.4073 13.2558L15.4091 13.2558C16.4517 13.2548 17.2404 12.3747 17.2404 11.3636C17.2404 10.4037 16.5315 9.5638 15.5666 9.47846C15.129 9.43977 14.8037 9.02087 14.8367 8.54295C14.8421 8.46525 14.8448 8.38664 14.8448 8.30722C14.8448 6.74427 13.7607 5.39733 12.285 5.12782C12.1088 5.09564 11.9271 5.07882 11.7409 5.07882C10.4886 5.07882 9.4247 5.84727 8.93254 6.93053C8.83064 7.15483 8.64552 7.32053 8.4241 7.38493C8.20266 7.44934 7.96671 7.40608 7.77652 7.26638C7.56198 7.10879 7.29814 7.01404 7.00829 7.01404C6.2742 7.01404 5.72413 7.61175 5.68838 8.29421C5.66974 8.65017 5.45515 8.95848 5.14573 9.07171C4.31927 9.37415 3.75832 10.1856 3.75832 11.1025C3.75832 12.3047 4.52772 13.2225 5.61626 13.2558H7.94728C8.3878 13.2558 8.74343 13.6473 8.74343 14.1282C8.74343 14.6092 8.3878 15.0007 7.94728 15.0007H5.60602L5.58749 15.0004C3.56947 14.9475 2.16602 13.1876 2.16602 11.1025C2.16602 9.56797 2.99641 8.26282 4.17814 7.62531C4.49432 6.25229 5.66218 5.2692 7.00829 5.2692C7.32382 5.2692 7.6288 5.32279 7.915 5.42236Z",
                            fill: "var(--color-blue-800)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M9.77456 9.54692C9.91791 9.32021 10.1888 9.16732 10.4993 9.16732C10.8099 9.16732 11.0808 9.32021 11.2241 9.54693L12.7553 11.0781C13.0807 11.4035 13.0807 11.9311 12.7553 12.2566C12.4298 12.582 11.9022 12.582 11.5768 12.2566L11.3327 12.0125V15.9173C11.3327 16.3315 10.9596 16.6673 10.4993 16.6673C10.0391 16.6673 9.66602 16.3315 9.66602 15.9173V12.0125L9.42194 12.2566C9.0965 12.582 8.56886 12.582 8.24343 12.2566C7.91799 11.9311 7.91799 11.4035 8.24343 11.0781L9.77456 9.54692Z",
                            fill: "var(--color-blue-800)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-[15px] font-500 leading-[19px] text-blue-800",
                    children: t("txt_upload_media")
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(small ? "h-[24px] w-[24px]" : "h-[54px] w-[54px]", "flex items-center justify-center rounded-full bg-primary-100"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: small ? "11" : "20",
                        height: small ? "11" : "16",
                        viewBox: "0 0 20 16",
                        fill: "none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7.84375 3.23181L10 1.07556L12.1563 3.23181",
                                stroke: "var(--color-primary-700)",
                                strokeWidth: "1.7037",
                                strokeMiterlimit: "10",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M10.0005 9.70056V1.07556",
                                stroke: "var(--color-primary-700)",
                                strokeWidth: "1.7037",
                                strokeMiterlimit: "10",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M1.78345 8.39026V12.0201C1.78345 13.7523 3.18764 15.1565 4.91981 15.1565H15.0793C16.8114 15.1565 18.2156 13.7523 18.2156 12.0201V8.39026",
                                stroke: "var(--color-primary-700)",
                                strokeWidth: "1.7037",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(noText ? "hidden" : "flex", "flex-col items-center gap-[4px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("text-[16px] font-500 text-blue-600"),
                            children: [
                                t("txt_drag_and_drop"),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[18px] font-500 text-primary-500",
                                    children: t("lbl_upload")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, getInputProps())),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[12px] font-400 text-blue-500",
                                    children: t("txt_supported_files")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "ml-1 text-[12px] font-500 text-blue-600 ",
                                    children: supportedFormats
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}


/***/ }),

/***/ 4165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yj": function() { return /* binding */ SkeletonVideo; },
/* harmony export */   "tv": function() { return /* binding */ CustomSkeleton; },
/* harmony export */   "xB": function() { return /* binding */ SizedSkeleton; },
/* harmony export */   "z3": function() { return /* binding */ SmallLoading; }
/* harmony export */ });
/* unused harmony exports MasonrySkeleton, SkeletonRectangle, SkeletonVideoWith */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9612);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		margin-left: -",
        "px;\n		margin-right: ",
        "px;\n	}\n\n	to {\n		margin-left: ",
        "px;\n		margin-right: -",
        "px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		margin-left: -100%;\n		margin-right: 100%;\n	}\n\n	to {\n		margin-left: 100%;\n		margin-right: -100%;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  z-index: 20;\n\n  opacity: 1;\n  animation-name: ",
        ";\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  animation-timing-function: ease-in-out;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  z-index: 20;\n\n  opacity: 1;\n  animation-name: ",
        ";\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  animation-timing-function: ease-in-out;\n  animation-duration: 2s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n\n  opacity: 1;\n  animation-name: ",
        ";\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  @media ",
        " {\n    animation-name: ",
        ";\n  }\n\n  animation-timing-function: ease-in-out;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n\n  img {\n    height: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 233px;\n    height: 289px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 275px;\n    height: 342px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 164px;\n  height: 203px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n\n  background-color: var(--color-skeleton);\n  border-radius: 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 233px;\n    height: 289px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 275px;\n    height: 342px;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 164px;\n  height: 203px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		transform: rotate(0deg);\n	}\n\n	to {\n		transform: rotate(360deg);\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation-name: ",
        ";\n  animation-duration: 1000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n\n  width: 20px;\n  height: 20px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}






var loadingAnimation = function(width) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject(), width, width, width, width);
};
var loadingAnimationPercent = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject1());
var CustomAnimatedImageSlow = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-395a1cc-0"
})(_templateObject2(), loadingAnimationPercent, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, loadingAnimationPercent, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop, loadingAnimationPercent);
var CustomAnimatedImageMasonry = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-395a1cc-1"
})(_templateObject3(), loadingAnimationPercent, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, loadingAnimationPercent, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop, loadingAnimationPercent);
var CustomAnimatedImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-395a1cc-2"
})(_templateObject4(), function() {
    return loadingAnimation(164);
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, function() {
    return loadingAnimation(233);
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop, function() {
    return loadingAnimation(275);
});
var SkeletonRectAnimatedImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(CustomAnimatedImage).withConfig({
    componentId: "sc-395a1cc-3"
})(_templateObject5());
var AnimatedImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(CustomAnimatedImage).withConfig({
    componentId: "sc-395a1cc-4"
})(_templateObject8(), (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .onTablet */ .pX)((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6())), (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .onDesktop */ .X$)((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject7())));
var CustomSkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-395a1cc-5"
})(_templateObject9());
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(CustomSkeletonContainer).withConfig({
    componentId: "sc-395a1cc-6"
})(_templateObject12(), (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .onTablet */ .pX)((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject10())), (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .onDesktop */ .X$)((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject11())));
var Skeleton = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AnimatedImage, {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                source: "/general/skeleton",
                format: "webp"
            })
        })
    });
};
function SizedSkeleton(props) {
    var className = props.className, style = props.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: style,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 overflow-hidden", "bg-color-skeleton", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomAnimatedImageSlow, {
            className: "h-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                source: "/general/skeleton",
                className: "aspect-[1/2] h-full"
            })
        })
    });
}
function MasonrySkeleton(props) {
    var className = props.className;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("relative z-20 overflow-hidden", "bg-color-skeleton", className),
        children: /*#__PURE__*/ _jsx(CustomAnimatedImageMasonry, {
            className: "h-full",
            children: /*#__PURE__*/ _jsx(CustomThemedResource, {
                source: "/general/skeleton",
                className: "h-full w-[300px] object-cover"
            })
        })
    });
}
var SkeletonRectangle = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SkeletonRectAnimatedImage, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                source: "/general/skeleton",
                format: "webp"
            })
        })
    }));
};
var SkeletonVideoWith = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function(props, ref) {
    var srcset = props.srcset, children = props.children, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "srcset",
        "children"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), sources = _$ref[0], setSources = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var load = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(src) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch(src)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                src
                            ];
                    }
                });
            });
            return function load(src) {
                return _ref.apply(this, arguments);
            };
        }();
        Promise.all(srcset.map(function(source) {
            return load(source);
        })).then(function(sources) {
            return setSources(sources);
        }).catch(console.error);
    }, [
        srcset
    ]);
    if (sources.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, others), {
        ref: ref,
        children: sources.map(function(source) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                src: source
            }, source);
        })
    }));
});
SkeletonVideoWith.displayName = "SkeletonVideoWith";
var SkeletonVideo = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function(props, ref) {
    var src = props.src, className = props.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "src",
        "className"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined), url = _$ref[0], setUrl = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var load = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch(src)
                            ];
                        case 1:
                            _state.sent();
                            setUrl(src);
                            return [
                                2
                            ];
                    }
                });
            });
            return function load() {
                return _ref.apply(this, arguments);
            };
        }();
        load().catch();
    }, [
        src
    ]);
    if (url === undefined) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SkeletonRectangle, {
        className: className
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        className: className,
        src: url,
        ref: ref
    }));
});
SkeletonVideo.displayName = "SkeletonVideo";
var spin = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject13());
var SmallLoadingContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK).withConfig({
    componentId: "sc-395a1cc-7"
})(_templateObject14(), spin);
var SmallLoading = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SmallLoadingContainer, {
        source: "/general/loading"
    });
};
var CustomSkeleton = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props.className, "relative", "bg-color-skeleton", "overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                src: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_4__/* .CustomThemedResource */ .aK, {
                source: "/general/skeleton",
                className: "aspect-square absolute left-0 top-0 h-full animate-slide object-cover"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Skeleton);


/***/ }),

/***/ 9460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yj": function() { return /* binding */ SubscriptionPopup; },
  "uK": function() { return /* binding */ fetchOfferingPrices; },
  "YF": function() { return /* binding */ getAdId; },
  "JH": function() { return /* binding */ getAdvancedButtonText; },
  "hv": function() { return /* binding */ getBasicButtonText; },
  "V2": function() { return /* binding */ getCurrentPackId; },
  "MX": function() { return /* binding */ getCurrentPlan; },
  "MJ": function() { return /* binding */ plansSchema; },
  "R3": function() { return /* binding */ pricesSchema; }
});

// UNUSED EXPORTS: TOKENS_TO_VIDEOS_DIVISOR

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/login-redirect.tsx
var login_redirect = __webpack_require__(7592);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/@kartyom/shared-components/dist/index.js
var dist = __webpack_require__(8976);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./node_modules/idb-keyval/dist/index.js
function promisifyRequest(request) {
    return new Promise((resolve, reject) => {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = () => resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = () => reject(request.error);
    });
}
function createStore(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    const dbp = promisifyRequest(request);
    return (txMode, callback) => dbp.then((db) => callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
    if (!defaultGetStoreFunc) {
        defaultGetStoreFunc = createStore('keyval-store', 'keyval');
    }
    return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function get(key, customStore = defaultGetStore()) {
    return customStore('readonly', (store) => promisifyRequest(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function set(key, value, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.put(value, key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function setMany(entries, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        entries.forEach((entry) => store.put(entry[1], entry[0]));
        return promisifyRequest(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function getMany(keys, customStore = defaultGetStore()) {
    return customStore('readonly', (store) => Promise.all(keys.map((key) => promisifyRequest(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function update(key, updater, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => 
    // Need to create the promise manually.
    // If I try to chain promises, the transaction closes in browsers
    // that use a promise polyfill (IE10/11).
    new Promise((resolve, reject) => {
        store.get(key).onsuccess = function () {
            try {
                store.put(updater(this.result), key);
                resolve(promisifyRequest(store.transaction));
            }
            catch (err) {
                reject(err);
            }
        };
    }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function del(key, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.delete(key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function delMany(keys, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        keys.forEach((key) => store.delete(key));
        return promisifyRequest(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function clear(customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.clear();
        return promisifyRequest(store.transaction);
    });
}
function eachCursor(store, callback) {
    store.openCursor().onsuccess = function () {
        if (!this.result)
            return;
        callback(this.result);
        this.result.continue();
    };
    return promisifyRequest(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function keys(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        if (store.getAllKeys) {
            return promisifyRequest(store.getAllKeys());
        }
        const items = [];
        return eachCursor(store, (cursor) => items.push(cursor.key)).then(() => items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function values(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        if (store.getAll) {
            return promisifyRequest(store.getAll());
        }
        const items = [];
        return eachCursor(store, (cursor) => items.push(cursor.value)).then(() => items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function entries(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) {
            return Promise.all([
                promisifyRequest(store.getAllKeys()),
                promisifyRequest(store.getAll()),
            ]).then(([keys, values]) => keys.map((key, i) => [key, values[i]]));
        }
        const items = [];
        return customStore('readonly', (store) => eachCursor(store, (cursor) => items.push([cursor.key, cursor.value])).then(() => items));
    });
}



// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./statics/offering-prices.json
var offering_prices = __webpack_require__(8753);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/toggle.tsx
var toggle = __webpack_require__(7092);
;// CONCATENATED MODULE: ./comps/subscription-popup.tsx

























var TOKENS_TO_VIDEOS_DIVISOR = 2.5;
var PackageSchema = lib.z.object({
    id: lib.z.string(),
    title: lib.z.string(),
    best_for_ai: lib.z.boolean().default(false)
});
var FeatureSchema = lib.z.object({
    title: lib.z.string(),
    package_info: lib.z.object({
        free: lib.z.string().default("x"),
        basic: lib.z.string().default("x"),
        advanced: lib.z.string().default("x"),
        enterprise: lib.z.string().default("x")
    }),
    tooltip: lib.z.string().optional()
});
var SectionSchema = lib.z.object({
    title: lib.z.string(),
    features: lib.z.array(FeatureSchema)
});
var PackageCompareSchema = lib.z.object({
    packages: lib.z.array(PackageSchema),
    sections: lib.z.array(SectionSchema)
});
var AvailablePlansSchema = lib.z.array(lib.z.object({
    id: lib.z.string(),
    title: lib.z.string(),
    weight: lib.z.number()
}));
var plansSchema = lib.z.object({
    packages: lib.z.array(PackageSchema),
    package_compare: PackageCompareSchema,
    available_plans: AvailablePlansSchema
});
// Prices Schema
var variantSchema = lib.z.object({
    pack_id: lib.z.string(),
    monthly_price: lib.z.number(),
    yearly_price: lib.z.number(),
    monthly_tokens: lib.z.number(),
    yearly_tokens: lib.z.number(),
    monthly_entitlement: lib.z.string(),
    yearly_entitlement: lib.z.string()
});
var planSchema = lib.z.object({
    free: lib.z.object({
        id: lib.z.string(),
        points: lib.z.array(lib.z.string())
    }),
    basic: lib.z.object({
        id: lib.z.string(),
        points: lib.z.array(lib.z.string()),
        variants: lib.z.array(variantSchema).optional()
    }),
    advanced: lib.z.object({
        id: lib.z.string(),
        points: lib.z.array(lib.z.string()),
        variants: lib.z.array(variantSchema).optional()
    })
});
var pricesSchema = lib.z.object({
    save_percent: lib.z.number(),
    plans: planSchema,
    faq: lib.z.array(lib.z.object({
        q: lib.z.string(),
        a: lib.z.string()
    })),
    reviews: lib.z.object({
        image: lib.z.string(),
        name: lib.z.string(),
        stars: lib.z.number(),
        text: lib.z.string()
    }).array()
});
var prices = pricesSchema.parse(offering_prices);
function fetchOfferingPrices() {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("/api/pricing-packs").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
var BASIC_ENTITLEMENT = "plan_basic_5";
var ADVANCED_ENTITLEMENT = "plan_advanced_10";
var getCurrentPlan = function(userEntitlements) {
    var plan = "FREE";
    userEntitlements.forEach(function(a) {
        var isBasicUser = a === BASIC_ENTITLEMENT;
        var isAdvancedUser = a === ADVANCED_ENTITLEMENT;
        if (isAdvancedUser) {
            plan = "ADVANCED";
            return;
        }
        if (isBasicUser) {
            plan = "PRO";
            return;
        }
    });
    return plan;
};
var getCurrentPackId = function(userEntitlements) {
    var packId = "free";
    var basicPackId = "basic_pro_tire_1";
    var advancedPackId = "pro_tire_1";
    userEntitlements.forEach(function(a) {
        var isBasicUser = a === BASIC_ENTITLEMENT;
        var isAdvancedUser = a === ADVANCED_ENTITLEMENT;
        if (isAdvancedUser) {
            packId = advancedPackId;
            return;
        }
        if (isBasicUser) {
            packId = basicPackId;
            return;
        }
    });
    return {
        packId: packId
    };
};
function getBasicButtonText(currentPackId) {
    if (currentPackId === "basic_pro_tire_1") {
        return "txt_current_plan";
    } else if (currentPackId === "pro_tire_1") {
        return "txt_downgrade";
    } else {
        return "txt_upgrade";
    }
}
function getAdvancedButtonText(currentPackId) {
    if (currentPackId === "basic_pro_tire_1") {
        return "txt_upgrade";
    } else if (currentPackId === "pro_tire_1") {
        return "txt_current_plan";
    } else {
        return "txt_upgrade";
    }
}
function SubscriptionPopup(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var isOpen = props.isOpen, close = props.close, location = props.location, addToStorage = props.addToStorage;
    var userInfo = (0,client_auth/* useClientAuth */.K6)().userInfo;
    var ref13 = userInfo ? getCurrentPackId(userInfo.entitlements) : {
        packId: "free"
    }, currentPackId = ref13.packId;
    var ref14 = (0,react.useState)(true), isYearly = ref14[0], setIsYearly = ref14[1];
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var router = (0,next_router.useRouter)();
    var plans = (0,es.useQuery)({
        queryKey: [
            "offering-prices"
        ],
        queryFn: fetchOfferingPrices(),
        staleTime: Infinity,
        cacheTime: Infinity
    });
    function handlePurchaseClick(packId) {
        return _handlePurchaseClick.apply(this, arguments);
    }
    function _handlePurchaseClick() {
        _handlePurchaseClick = (0,_async_to_generator/* default */.Z)(function(packId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (userInfo && !userInfo.isAnonymous) {
                    fetchPaymentLink(packId);
                } else {
                    (0,login_redirect/* redirectToLogin */.r)();
                }
                return [
                    2
                ];
            });
        });
        return _handlePurchaseClick.apply(this, arguments);
    }
    function fetchPaymentLink(packId) {
        return _fetchPaymentLink.apply(this, arguments);
    }
    function _fetchPaymentLink() {
        _fetchPaymentLink = (0,_async_to_generator/* default */.Z)(function(packId) {
            var sessionId, path, search, payload, _tmp, ref, url, currency, value, _tmp1, paymentData, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        sessionId = (0,v4/* default */.Z)();
                        path = window.location.pathname;
                        search = window.location.search;
                        _tmp = {
                            location: location === undefined ? path + search : location,
                            period: isYearly ? "yearly" : "monthly"
                        };
                        return [
                            4,
                            getAdId()
                        ];
                    case 1:
                        payload = (_tmp.adId = _state.sent(), _tmp.sessionId = sessionId, _tmp.offering = packId, _tmp);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/payment-stripe-url", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), url = ref.url, currency = ref.currency, value = ref.value;
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("initiate_checkout");
                        _tmp1 = addToStorage;
                        if (!_tmp1) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            addToStorage()
                        ];
                    case 3:
                        _tmp1 = _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp1;
                        paymentData = {
                            currency: currency,
                            value: value,
                            session: sessionId
                        };
                        localStorage.setItem(adjust/* PAYMENT_DATA_KEY */.kV, JSON.stringify(paymentData));
                        router.push(url);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("txt_could_not_purchase_now")
                        }));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        window.blur();
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchPaymentLink.apply(this, arguments);
    }
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    (0,react.useEffect)(function() {
        if (!logAdjust) return;
        if (!isOpen) return;
        logAdjust.logEvent("pricing_page_view");
    }, [
        isOpen,
        logAdjust
    ]);
    var yearlyPricePro = ((ref1 = (ref = plans.data) === null || ref === void 0 ? void 0 : ref.plans.basic.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref1 === void 0 ? void 0 : ref1.price) || 0;
    var yearlyPriceDividedPro = yearlyPricePro / 12;
    var yearlyPriceFormattedPro = Math.floor(yearlyPriceDividedPro);
    var yearlyPriceAdvanced = ((ref3 = (ref2 = plans.data) === null || ref2 === void 0 ? void 0 : ref2.plans.advanced.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
    var yearlyPriceDividedAdvanced = yearlyPriceAdvanced / 12;
    var yearlyPriceFormattedAdvanced = Math.floor(yearlyPriceDividedAdvanced);
    (0,react.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isOpen
    ]);
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Escape",
        handler: function() {
            close();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: function(event) {
            if (event.target === event.currentTarget) {
                close();
            }
        },
        className: (0,clsx_m/* default */.Z)(isOpen ? "block" : "hidden", "fixed left-0 top-0 h-full w-full", "flex items-center justify-center", "z-[999] bg-color-popup"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("relative h-[100svh] w-full overflow-y-scroll bg-color-background tablet:h-auto tablet:w-[658px] tablet:overflow-visible tablet:py-4 desktop:w-[703px]", "flex flex-col items-center gap-4 tablet:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (0,clsx_m/* default */.Z)("absolute -right-12 top-0", "h-[34px] w-[34px] rounded-full", "hidden items-center justify-center tablet:flex", "bg-color-cell hover:bg-blue-100", "transition-colors"),
                    onClick: close,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/close.svg"),
                        alt: "close popup"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex w-full flex-col items-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-4 flex w-full flex-row justify-between px-4 tablet:mt-0 tablet:justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[20px] font-700 text-blue-900 tablet:text-[24px]",
                                    children: t("txt_pricing_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (0,clsx_m/* default */.Z)("h-[34px] w-[34px] rounded-full", "flex items-center justify-center", "bg-color-cell hover:bg-blue-100", "transition-colors tablet:hidden"),
                                    onClick: close,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/close.svg"),
                                        alt: "close popup"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-2 flex w-full justify-start gap-[10px] px-4 tablet:justify-center tablet:px-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-500" : "text-blue-900", "text-[18px] font-500 transition-colors"),
                                    children: t("txt_monthly")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle/* SquareSwitch */.ZP, {
                                    onChange: setIsYearly,
                                    enabled: isYearly,
                                    activeColor: "var(--color-green-600)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-900" : "text-blue-500", "text-[18px] font-500 transition-colors"),
                                    children: t("txt_yearly")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx_m/* default */.Z)("text-[18px] font-500 transition-colors", isYearly ? "text-blue-900" : "text-blue-500"),
                                    children: t("fs_save_percent", {
                                        percent: String((ref4 = plans.data) === null || ref4 === void 0 ? void 0 : ref4.save_percent)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-4 mt-4 flex w-full flex-col items-center justify-center gap-6 px-4 tablet:mb-0 tablet:px-5 desktop:flex-row desktop:gap-[27px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("flex w-full flex-col overflow-hidden rounded-[8px] border-2 border-color-separator", "tablet:flex-row desktop:h-[468px] desktop:w-[310px] desktop:flex-col"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full flex-1 flex-col justify-between bg-color-surface-cell p-[18px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[24px] font-600 text-blue-900",
                                                            children: "Pro + AI"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-300 text-[14px] text-blue-600",
                                                            children: "For pro video creation"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative mt-3 h-[50px] w-full overflow-hidden",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-16", "transition-all duration-500"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[38px]"),
                                                                            children: [
                                                                                "$",
                                                                                String((ref6 = (ref5 = plans.data) === null || ref5 === void 0 ? void 0 : ref5.plans.basic.variants[0].periods.find(function(a) {
                                                                                    return a.period === "monthly";
                                                                                })) === null || ref6 === void 0 ? void 0 : ref6.price).slice(0, -2),
                                                                                ".",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: String((ref8 = (ref7 = plans.data) === null || ref7 === void 0 ? void 0 : ref7.plans.basic.variants[0].periods.find(function(a) {
                                                                                        return a.period === "monthly";
                                                                                    })) === null || ref8 === void 0 ? void 0 : ref8.price).slice(-2)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                            children: [
                                                                                "/",
                                                                                t("txt_month")
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-16", "transition-all duration-500"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[38px]"),
                                                                            children: [
                                                                                "$",
                                                                                String(yearlyPriceFormattedPro).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedPro).slice(0, -2) : 0,
                                                                                ".",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: String(yearlyPriceFormattedPro).slice(-2)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                            children: [
                                                                                "/",
                                                                                t("txt_month"),
                                                                                "*"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex w-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* GradientGrayscaleButton */.sH, {
                                                        grayscale: true,
                                                        disabled: getBasicButtonText(currentPackId) === "txt_current_plan",
                                                        onClick: function() {
                                                            var ref;
                                                            return handlePurchaseClick(((ref = plans.data) === null || ref === void 0 ? void 0 : ref.plans.basic.variants[0].pack_id) || "");
                                                        },
                                                        className: "flex h-[52px] w-full items-center justify-center !font-500 disabled:!text-color-inactive-text",
                                                        text: getBasicButtonText(currentPackId)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px] desktop:h-[1px] desktop:w-full"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col gap-2 bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 desktop:h-[160px] desktop:w-full desktop:gap-1",
                                            children: prices.plans.basic.points.map(function(point) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-[10px] ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                            format: "svg",
                                                            source: "/pricing/check"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-[14px] font-400 text-blue-800",
                                                            children: point
                                                        })
                                                    ]
                                                }, point);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col rounded-[8px]", "tablet:flex-row desktop:h-[468px] desktop:w-[310px] desktop:flex-col"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                background: "linear-gradient(120deg, rgba(134, 54, 248, 1), rgba(240, 32, 179, 1), rgba(248, 71, 94, 1), rgba(255, 148, 33, 1) )"
                                            },
                                            className: "absolute left-[-2px] top-[-2px] h-[calc(100%+4px)] w-[calc(100%+4px)] rounded-[10px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "z-10 flex w-full flex-1 flex-col justify-between rounded-t-[8px] bg-color-surface-cell p-[18px] tablet:rounded-l-[8px] tablet:rounded-r-[0px] desktop:rounded-b-[0px] desktop:rounded-t-[8px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[24px] font-600 text-blue-900",
                                                            children: "Advanced + AI"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-300 text-[14px] text-blue-600",
                                                            children: t("txt_pro_subtitle")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative mt-3 h-[50px] w-full overflow-hidden",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", isYearly && "-top-16", "transition-all duration-500"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[38px]"),
                                                                            children: [
                                                                                "$",
                                                                                String((ref10 = (ref9 = plans.data) === null || ref9 === void 0 ? void 0 : ref9.plans.advanced.variants[0].periods.find(function(a) {
                                                                                    return a.period === "monthly";
                                                                                })) === null || ref10 === void 0 ? void 0 : ref10.price).slice(0, -2),
                                                                                ".",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: String((ref12 = (ref11 = plans.data) === null || ref11 === void 0 ? void 0 : ref11.plans.advanced.variants[0].periods.find(function(a) {
                                                                                        return a.period === "monthly";
                                                                                    })) === null || ref12 === void 0 ? void 0 : ref12.price).slice(-2)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                            children: [
                                                                                "/",
                                                                                t("txt_month")
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[50px] w-full flex-row items-end justify-start gap-[2px]", !isYearly && "top-16", "transition-all duration-500"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[38px]"),
                                                                            children: [
                                                                                "$",
                                                                                String(yearlyPriceFormattedAdvanced).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedAdvanced).slice(0, -2) : 0,
                                                                                ".",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: String(yearlyPriceFormattedAdvanced).slice(-2)
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "font-300 mb-[10px] text-[14px] lowercase text-blue-600",
                                                                            children: [
                                                                                "/",
                                                                                t("txt_month"),
                                                                                "*"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-8 flex w-full tablet:mt-12 desktop:mt-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                                        gradient: true,
                                                        disabled: getAdvancedButtonText(currentPackId) === "txt_current_plan",
                                                        onClick: function() {
                                                            var ref;
                                                            return handlePurchaseClick(((ref = plans.data) === null || ref === void 0 ? void 0 : ref.plans.advanced.variants[0].pack_id) || "");
                                                        },
                                                        className: "flex h-[52px] w-full items-center justify-center !font-500",
                                                        text: getAdvancedButtonText(currentPackId)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "z-10 h-[1px] w-full bg-blue-100 tablet:h-full tablet:w-[1px] desktop:h-[1px] desktop:w-full"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "z-10 flex flex-col gap-2 rounded-b-[8px] bg-blue-50 p-4 tablet:w-[310px] tablet:gap-4 tablet:rounded-l-none tablet:rounded-r-[8px] desktop:h-[160px] desktop:w-full desktop:gap-1 desktop:rounded-b-[8px] desktop:rounded-t-[0px]",
                                            children: prices.plans.advanced.points.map(function(point) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-[10px] ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                            format: "svg",
                                                            source: "/pricing/check"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-[14px] font-400 text-blue-800",
                                                            children: point
                                                        })
                                                    ]
                                                }, point);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full items-center justify-between px-4 tablet:px-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (0,clsx_m/* default */.Z)("text-[16px] font-400 text-blue-500 transition-opacity", isYearly ? "opacity-100" : "opacity-0"),
                            children: [
                                "*",
                                t("txt_billed_yearly")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/pricing",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-[17px] font-400 text-blue-700 transition-all hover:underline",
                                children: "Compare plans"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var adjustStoreSchema = lib.z.object({
    at: lib.z.object({
        a: lib.z.string()
    })
});
function getAdId() {
    return _getAdId.apply(this, arguments);
}
function _getAdId() {
    _getAdId = (0,_async_to_generator/* default */.Z)(function() {
        var adjustStore, ref, storeValue, localStorageValue, parsedLocalStorageValue, localParsed, parsedStoreValue;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    adjustStore = createStore("adjust-sdk", "as");
                    return [
                        4,
                        values(adjustStore)
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), storeValue = ref[0];
                    if (!storeValue) {
                        localStorageValue = localStorage.getItem("adjust-sdk.as");
                        if (!localStorageValue) {
                            return [
                                2,
                                null
                            ];
                        }
                        try {
                            parsedLocalStorageValue = JSON.parse(localStorageValue);
                            if (Array.isArray(parsedLocalStorageValue) && parsedLocalStorageValue.length > 0) {
                                localParsed = adjustStoreSchema.parse(parsedLocalStorageValue[0]);
                                return [
                                    2,
                                    localParsed.at.a
                                ];
                            } else {
                                return [
                                    2,
                                    null
                                ];
                            }
                        } catch (e) {
                            console.error("Error parsing local storage value", e);
                            return [
                                2,
                                null
                            ];
                        }
                    }
                    try {
                        parsedStoreValue = adjustStoreSchema.parse(storeValue);
                        return [
                            2,
                            parsedStoreValue.at.a
                        ];
                    } catch (e1) {
                        console.error("Error parsing store value", e1);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getAdId.apply(this, arguments);
}


/***/ }),

/***/ 6412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1816);
/* harmony import */ var _utils_millions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(323);
/* harmony import */ var _utils_queryfy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(669);
/* harmony import */ var _utils_scroll_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2715);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8767);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9521);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9612);
/* harmony import */ var _player__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1993);
/* harmony import */ var _skeleton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4165);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n\n	gap: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	gap: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 12px;\n\n	font-weight: 700;\n	font-size: 16px;\n	line-height: 19px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 40px;\n	height: 40px;\n	border-radius: 100%;\n	border: 1px solid var(--color-separator);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	line-height: 0;\n	font-size: 0;\n	flex-shrink: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: #009bbd;\n	padding: 5px 8px;\n	text-transform: uppercase;\n	border-radius: 3px;\n\n	color: var(--color-background-cell);\n	font-weight: 700;\n	font-size: 12px;\n	line-height: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	gap: 12px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-weight: 500;\n	font-size: 14px;\n	line-height: 17px;\n\n	color: var(--color-blue-700);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 16px;\n	padding-left: 56px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	height: 500px;\n	max-height: 100svh;\n	flex-shrink: 0;\n\n	display: flex;\n	flex-direction: column;\n	gap: 16px;\n\n	background-color: var(--color-background-cell);\n	border-radius: 12px 12px 0px 0px;\n\n	padding: 16px;\n\n	overflow-y: scroll;\n	overflow-x: hidden;\n\n	@media ",
        " {\n		border-top: 1px solid var(--color-separator);\n\n		padding: 16px 0 0 0;\n		overflow: hidden;\n		width: unset;\n		height: unset;\n		max-height: unset;\n		border-radius: unset;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	width: 100%;\n	gap: 16px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	font-weight: 600;\n	font-size: 15px;\n	line-height: 16px;\n\n	align-self: flex-start;\n	padding: 4px 8px;\n\n	",
        ";\n\n	border-radius: 4px;\n	color: var(--color-blue-600);\n\n	transition: background-color 200ms ease-in-out;\n	:hover {\n		background-color: var(--color-025);\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	align-self: stretch;\n	text-align: center;\n	font-weight: 600;\n	font-size: 16px;\n	line-height: 20px;\n\n	color: var(--color-blue-700);\n\n	position: relative;\n	text-transform: uppercase;\n\n	@media ",
        " {\n		display: none;\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

















var commentsOnEachRequest = 10;
var getCommentFetcher = function(template, token) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(param) {
            var pageParam;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/tutorial-comments" + (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
                                offset: pageParam !== null && pageParam !== void 0 ? pageParam : 0,
                                limit: commentsOnEachRequest,
                                id: template
                            }), {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .HEADER_WEB_VERSION */ .F
                                }
                            }).then(function(res) {
                                return {
                                    data: res.data.comments,
                                    next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_5__/* .getGeneralNextPage */ .L9)(res.data.comments.length, pageParam)
                                };
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getReplyFetcher = function(template, comment, token) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(param) {
            var pageParam;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/tutorial-comments-replies" + (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
                                offset: pageParam !== null && pageParam !== void 0 ? pageParam : 0,
                                limit: commentsOnEachRequest,
                                tutorial: template,
                                comment: comment
                            }), {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .HEADER_WEB_VERSION */ .F
                                }
                            }).then(function(res) {
                                return {
                                    data: res.data.replies,
                                    next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_5__/* .getGeneralNextPage */ .L9)(res.data.replies.length, pageParam)
                                };
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var CommentContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-0"
})(_templateObject());
var InfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-1"
})(_templateObject1());
var NameContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-afc8b089-2"
})(_templateObject2());
var ProfilePicture = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-afc8b089-3"
})(_templateObject3());
var ProfilePictureAnchor = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-afc8b089-4"
})(_templateObject4());
var CreatorIndicator = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-afc8b089-5"
})(_templateObject5());
var CommentText = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-afc8b089-6"
})(_templateObject6());
var InfoRow = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-7"
})(_templateObject7());
var InfoText = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-afc8b089-8"
})(_templateObject8());
var CommentReplies = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-9"
})(_templateObject9());
var AllCommentsContainer = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-10"
})(_templateObject10(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop);
var AllComments = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-afc8b089-11"
})(_templateObject11());
var LoadMoreButton = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-afc8b089-12"
})(_templateObject12(), function(props) {
    return props.align && "margin-left: -8px;";
});
var CommentCount = styled_components__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-afc8b089-13"
})(_templateObject13(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop);
var SingleComment = function(props) {
    var reply = props.reply, comment = props.comment, creator = props.creator, template = props.template;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().userInfo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), opened = ref[0], setOpened = ref[1];
    var enabled = !reply && comment.replies > 0 && opened;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_8__.useInfiniteQuery)({
        queryFn: getReplyFetcher(template, comment.id, userInfo.accessToken),
        queryKey: "replies/" + template + comment.id,
        getNextPageParam: function(page) {
            return page.next;
        },
        enabled: enabled
    });
    var ref1;
    var replies = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        var ref;
        return (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_5__/* .flattenAndFilterGeneralComments */ .EJ)((ref1 = (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) !== null && ref1 !== void 0 ? ref1 : []);
    }, [
        query
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common").t;
    var isCreator = comment.user.username === creator;
    var time = (0,_utils_millions__WEBPACK_IMPORTED_MODULE_17__/* .contextAwareTime */ .s)(comment.time);
    var repliesToLoad = !reply && comment.replies - replies.length;
    var showReplies = !reply && comment.replies > 0;
    var showLoading = query.isFetchingNextPage;
    var existsMore = query.hasNextPage !== false && (typeof repliesToLoad === "number" ? repliesToLoad > 0 : repliesToLoad);
    var canOpen = !opened && !reply && comment.replies > 0;
    var showLoadMore = canOpen || existsMore;
    var _picture;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CommentContainer, {
                reply: reply,
                "data-id": comment.id,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProfilePictureAnchor, {
                        href: "/" + comment.user.username,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProfilePicture, {
                            onError: function(e) {
                                return e.currentTarget.setAttribute("src", (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .assetUrl */ .p)("/icons/avatar-default.svg"));
                            },
                            alt: "profile icon",
                            src: (_picture = comment.user.picture) !== null && _picture !== void 0 ? _picture : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .assetUrl */ .p)("/icons/avatar-default.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NameContainer, {
                                href: "/" + comment.user.username,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: comment.user.username
                                    }),
                                    isCreator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CreatorIndicator, {
                                        children: t("lbl_creator")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CommentText, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_player__WEBPACK_IMPORTED_MODULE_10__/* .MarkupTaggedSlice */ .iv, {
                                    tags: comment.text
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InfoRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoText, {
                                        children: time.locale !== null ? t(time.locale, {
                                            count: time.text
                                        }) : t(time.text)
                                    }),
                                    comment.likes > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoText, {
                                        children: t("fs_likes", {
                                            count: comment.likes
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showReplies && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CommentReplies, {
                children: [
                    replies.map(function(reply) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SingleComment, {
                            comment: reply,
                            reply: true,
                            creator: creator,
                            template: template
                        }, reply.id);
                    }),
                    showLoadMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex flex-shrink-0 items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadMoreButton, {
                                align: true,
                                onClick: function() {
                                    query.fetchNextPage().then(function() {
                                        return !opened && setOpened(true);
                                    }).catch(console.error);
                                },
                                children: opened ? t("txt_view_more") : t("txt_view_replies")
                            }),
                            showLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SmallLoading */ .z3, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var CommentsSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "flex flex-col items-start justify-start gap-[30px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative flex w-full flex-shrink-0 flex-grow-0 items-start justify-start gap-[15px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                        className: "h-10 w-10 flex-shrink-0 flex-grow-0 rounded-[30px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex w-full flex-shrink-0 flex-grow-0 items-center justify-start gap-[23px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "relative flex w-full flex-shrink-0 flex-grow-0 flex-col items-start justify-start gap-[7px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[30%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[204px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[70%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[327px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[50%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[247px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                className: "h-5 w-5 flex-shrink-0 flex-grow-0 rounded-[30px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative flex w-full flex-shrink-0 flex-grow-0 items-start justify-start gap-[15px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                        className: "h-10 w-10 flex-shrink-0 flex-grow-0 rounded-[30px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex w-full flex-shrink-0 flex-grow-0 items-center justify-start gap-[23px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "relative flex w-full flex-shrink-0 flex-grow-0 flex-col items-start justify-start gap-[7px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[30%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[204px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[70%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[327px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[50%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[247px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                className: "h-5 w-5 flex-shrink-0 flex-grow-0 rounded-[30px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative flex w-full flex-shrink-0 flex-grow-0 items-start justify-start gap-[15px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                        className: "h-10 w-10 flex-shrink-0 flex-grow-0 rounded-[30px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex w-full flex-shrink-0 flex-grow-0 items-center justify-start gap-[23px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "relative flex w-full flex-shrink-0 flex-grow-0 flex-col items-start justify-start gap-[7px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[30%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[204px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[70%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[327px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                        className: "h-5 w-[50%] flex-shrink-0 flex-grow-0 rounded-[30px] desktop:w-[247px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .CustomSkeleton */ .tv, {
                                className: "h-5 w-5 flex-shrink-0 flex-grow-0 rounded-[30px]"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Comments = function(props) {
    var template = props.template, count = props.count, username = props.username, close = props.close, allowed = props.allowed;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().userInfo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), clicked = ref[0], setClicked = ref[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common").t;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_8__.useInfiniteQuery)({
        queryFn: getCommentFetcher(template, userInfo.accessToken),
        queryKey: "comments/" + template,
        getNextPageParam: function(param) {
            var next = param.next;
            return next;
        },
        enabled: count > 0 && allowed
    });
    var comments = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        var ref;
        return (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_5__/* .flattenAndFilterComments */ .fC)(((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) || []);
    }, [
        query.data
    ]);
    var commentsToLoad = count - comments.length;
    var empty = count === 0 || query.hasNextPage === false && comments.length === 0;
    var showComments = comments.length > 0;
    var showSkeleton = !showComments && !query.isError;
    var showLoading = query.isFetching;
    var showViewMore = showComments && query.hasNextPage && commentsToLoad > 0;
    if (!allowed || empty) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AllCommentsContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "align-self-center relative hidden text-base font-700 uppercase text-blue-700 desktop:block",
                    children: t("lbl_comments")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "flex h-full min-h-[300px] w-full flex-col items-center justify-center gap-2 font-600 text-blue-800",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_image__WEBPACK_IMPORTED_MODULE_9__/* .CustomThemedResource */ .aK, {
                            source: "/player/comments-off",
                            alt: "comments are turned off",
                            className: "h-[120px] w-[120px]"
                        }),
                        allowed ? t("txt_comments_none") : t("txt_comments_off")
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AllCommentsContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CommentCount, {
                children: [
                    t("fs_comments", {
                        count: count
                    }),
                    close !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .assetUrl */ .p)("/player/close.svg"),
                        alt: "close comments",
                        onClick: function() {
                            clicked && close();
                            setClicked(true);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("absolute right-0 top-0 h-[20px] w-[20px] p-[4px]", "cursor-pointer rounded-full bg-color-black/40 transition-colors hover:bg-color-black/70")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "align-self-center relative hidden text-base font-700 uppercase text-blue-700 desktop:block",
                children: t("lbl_comments")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AllComments, {
                children: [
                    showComments && comments.map(function(comment, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SingleComment, {
                                template: template,
                                creator: username,
                                comment: comment,
                                reply: false
                            })
                        }, comment.id);
                    }),
                    showViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("flex items-center gap-2"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadMoreButton, {
                                align: false,
                                onClick: function() {
                                    query.fetchNextPage().catch(console.error);
                                },
                                children: t("txt_view_more")
                            }),
                            showLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SmallLoading */ .z3, {})
                        ]
                    }, comments.length),
                    showSkeleton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CommentsSkeleton, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Comments);


/***/ }),

/***/ 4343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AQ": function() { return /* binding */ Hashtag; },
  "ji": function() { return /* binding */ ShareRow; },
  "Ru": function() { return /* binding */ Username; },
  "Bl": function() { return /* binding */ Word; },
  "ZP": function() { return /* binding */ panel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
;// CONCATENATED MODULE: ./comps/template/icons.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	to {\n		transform: translateY(0);\n		opacity: 1;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      cursor: unset;\n\n      &:hover {\n        background-color: var(--color-background);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: none;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 52px;\n  height: 52px;\n\n  padding: 11px;\n  border-radius: 40px;\n\n  flex-shrink: 0;\n\n  transition: background-color 300ms ease-in-out,\n    opacity 200ms ease-in-out;\n\n  background-color: var(--color-background);\n\n  cursor: pointer;\n\n  &:hover {\n    background-color: var(--color-blue-300);\n  }\n\n  ",
        ";\n\n  opacity: 0;\n  transform: translateY(50px);\n\n  animation: ",
        " ",
        "ms forwards\n    ",
        "ms\n    ease-out;\n\n  ",
        ";\n  @media ",
        " {\n    display: unset;\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px;\n  width: 24px;\n  height: 24px;\n\n  path {\n    fill: var(--color-blue-500);\n  }\n\n  transform: rotate(\n    ",
        "deg\n  );\n\n  transition: transform 200ms ease-in-out,\n    background-color 300ms ease-in-out;\n\n  cursor: pointer;\n  border-radius: 20px;\n\n  :hover {\n    background-color: var(--color-background);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var appearBottom = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var eachAppearDelay = 50;
var eachDuration = 150;
var initialWait = 400;
var IconContainer = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-44889b51-0"
})(_templateObject4(), function(props) {
    return props.disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, appearBottom, eachDuration, function(props) {
    return props.index * eachAppearDelay + initialWait;
}, function(props) {
    return props.hideMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, breakpoints/* devices.desktop */.Hb.desktop, function(props) {
    return props.hideDesktop && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var Facebook = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://www.facebook.com/sharer/sharer.php?u=" + props.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,cdn/* assetUrl */.p)("/comps/facebook-colorful.svg"),
            alt: "facebook icon",
            className: "h-[30px] w-[30px]"
        })
    });
};
var Messenger = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                index: props.index,
                hideDesktop: true,
                href: "fb-messenger://share?link=".concat(props.url, "&app_id=").concat("215609162521480", "}"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,cdn/* assetUrl */.p)("/comps/messenger-colorful.svg"),
                    alt: "facebook icon",
                    className: "h-[30px] w-[30px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                index: props.index,
                hideMobile: true,
                target: "_blank",
                rel: "noopener noreferrer",
                href: "https://www.facebook.com/dialog/send?link=".concat(props.url, "&app_id=").concat("215609162521480", "&redirect_uri=").concat(encodeURIComponent("https://zoomerang.app")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,cdn/* assetUrl */.p)("/comps/messenger-colorful.svg"),
                    alt: "facebook icon",
                    className: "h-[30px] w-[30px]"
                })
            })
        ]
    });
};
var WhatsApp = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://wa.me/?text=".concat(props.url),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,cdn/* assetUrl */.p)("/comps/whatsapp-colorful.svg"),
            alt: "facebook icon",
            className: "h-[30px] w-[30px]"
        })
    });
};
var Email = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "mailto:?body=".concat(props.url),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,cdn/* assetUrl */.p)("/comps/email-colorful.svg"),
            alt: "facebook icon",
            className: "h-[30px] w-[30px]"
        })
    });
};
var Viber = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "viber://forward?text=".concat(props.url),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
            className: "h-[30px] w-[30px]",
            source: "/comps/viber-colorful",
            format: "svg"
        })
    });
};
var Pinterest = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://pinterest.com/pin/create/button/?url=".concat(props.url),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,cdn/* assetUrl */.p)("/comps/pinterest-colorful.svg"),
            alt: "facebook icon",
            className: "h-[30px] w-[30px]"
        })
    });
};
var URLIcon = function(props) {
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), disabled = ref[0], setDisabled = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        index: props.index,
        disabled: disabled,
        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (disabled) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setDisabled(true);
                        return [
                            4,
                            navigator.clipboard.writeText(props.url)
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                            children: t("txt_clipboard_success")
                        }));
                        setTimeout(function() {
                            return setDisabled(false);
                        }, 3500);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _ = _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("txt_clipboard_failure")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: (0,cdn/* assetUrl */.p)("/comps/url-colorful.svg"),
            alt: "facebook icon",
            className: "h-[30px] w-[30px]"
        })
    });
};
var ArrowIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44889b51-1"
})(_templateObject5(), function(props) {
    return props.show ? 0 : 180;
});
var ArrowIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIconContainer, {
        show: props.show,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 6L7.46967 5.46967C7.61032 5.32902 7.80109 5.25 8 5.25C8.19891 5.25 8.38968 5.32902 8.53033 5.46967L8 6ZM12.5303 9.46967C12.8232 9.76256 12.8232 10.2374 12.5303 10.5303C12.2374 10.8232 11.7626 10.8232 11.4697 10.5303L12.5303 9.46967ZM4.53033 10.5303C4.23744 10.8232 3.76256 10.8232 3.46967 10.5303C3.17678 10.2374 3.17678 9.76256 3.46967 9.46967L4.53033 10.5303ZM8.53033 5.46967L12.5303 9.46967L11.4697 10.5303L7.46967 6.53033L8.53033 5.46967ZM8.53033 6.53033L4.53033 10.5303L3.46967 9.46967L7.46967 5.46967L8.53033 6.53033Z",
                fill: "#A8A8A8"
            })
        })
    });
};

// EXTERNAL MODULE: ./utils/dates.ts
var dates = __webpack_require__(4455);
// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var lib_esm = __webpack_require__(4059);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./sections/history/report-popup.tsx
var report_popup = __webpack_require__(1059);
// EXTERNAL MODULE: ./comps/advanced-profile.tsx
var advanced_profile = __webpack_require__(8673);
// EXTERNAL MODULE: ./comps/ai-tools/icons.tsx
var icons = __webpack_require__(1455);
// EXTERNAL MODULE: ./comps/template/comments.tsx
var comments = __webpack_require__(6412);
;// CONCATENATED MODULE: ./comps/template/panel.tsx

function panel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 700;\n	font-size: 24px;\n	line-height: 29px;\n"
    ]);
    panel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function panel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 400;\n	font-size: 16px;\n	line-height: 18px;\n\n	color: var(--color-blue-700);\n\n	display: flex;\n	flex-wrap: wrap;\n"
    ]);
    panel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function panel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 600;\n	font-size: 16px;\n	line-height: 18px;\n	padding-right: 4px;\n"
    ]);
    panel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function panel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 600;\n	font-size: 16px;\n	line-height: 18px;\n	padding-right: 4px;\n\n	cursor: pointer;\n\n	border-bottom: 1px solid transparent;\n\n	transition: border-bottom-color 200ms ease-in-out;\n\n	&:hover {\n		border-bottom: 1px solid var(--color-blue-900);\n	}\n"
    ]);
    panel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function panel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 400;\n	font-size: 16px;\n	line-height: 18px;\n	white-space: pre-wrap;\n"
    ]);
    panel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function panel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 500;\n	font-size: 12px;\n	line-height: 14px;\n\n	color: var(--color-blue-600);\n"
    ]);
    panel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: none;\n\n	@media ",
        " {\n		display: flex;\n		flex-direction: column;\n		align-items: center;\n\n		gap: 16px;\n\n		padding: 16px 0;\n		margin-bottom: 16px;\n\n		border-top: 1px solid var(--color-separator);\n		border-bottom: 1px solid var(--color-separator);\n\n		overflow: hidden;\n\n		max-height: ",
        ";\n		transition: max-height 200ms ease-in-out;\n	}\n\n	svg {\n		flex-shrink: 0;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	gap: 16px;\n\n	align-self: stretch;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	justify-content: space-between;\n	align-items: center;\n\n	align-self: stretch;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 700;\n	font-size: 16px;\n	line-height: 19px;\n\n	text-transform: uppercase;\n\n	color: var(--color-blue-700);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	max-width: 329px;\n\n	@media ",
        " {\n		max-width: 270px;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 400;\n	font-size: 15px;\n	line-height: 26px;\n\n	color: var(--color-blue-800);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n\n	& path {\n		stroke: var(--color-blue-800);\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 700;\n	font-size: 16px;\n	line-height: 19px;\n\n	text-transform: uppercase;\n	color: var(--color-blue-700);\n\n	display: none;\n	@media ",
        " {\n		display: block;\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 18px;\n	line-height: 21px;\n\n	align-self: center;\n	margin-top: 16px;\n\n	font-weight: 600;\n	color: var(--color-blue-400);\n\n	b {\n		font-weight: 700;\n		color: var(--color-blue-800);\n	}\n\n	@media ",
        " {\n		display: none;\n	}\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 1px;\n	width: 100%;\n	max-width: 646px;\n	background-color: var(--color-separator);\n\n	@media ",
        " {\n		display: none;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	gap: 10px;\n	flex-shrink: 0;\n\n	overflow-x: scroll;\n\n	max-width: var(--w-screen);\n\n	-ms-overflow-style: none;\n	scrollbar-width: none;\n\n	&::-webkit-scrollbar {\n		display: none;\n	}\n\n	padding: 0 16px 16px 16px;\n\n	@media ",
        " {\n		margin: 0 -16px;\n	}\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	gap: 12px;\n\n	padding: 12px 0;\n\n	overflow-y: scroll;\n	overflow-x: hidden;\n\n	-ms-overflow-style: none;\n	scrollbar-width: none;\n\n	&::-webkit-scrollbar {\n		display: none;\n	}\n\n	height: calc(100vh - 82px);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	align-items: center;\n	justify-content: flex-start;\n\n	gap: 6px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-radius: 100%;\n	border-color: var(--color-separator);\n	border-width: 1px;\n	width: 40px;\n	height: 40px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 4px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 700;\n	font-size: 13px;\n	line-height: 16px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 500;\n	font-size: 12px;\n	line-height: 14px;\n\n	color: var(--color-blue-600);\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}

















var TemplateName = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-e058c95f-0"
})(panel_templateObject());
var DescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-1"
})(panel_templateObject1());
var Hashtag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-2"
})(panel_templateObject2());
var Username = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e058c95f-3"
})(panel_templateObject3());
var Word = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-4"
})(panel_templateObject4());
var TemplateDescription = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionContainer, {
        children: props.description.map(function(tag, index) {
            switch(tag.format){
                case "username":
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Username, {
                        href: "/user/" + tag.uid,
                        children: [
                            "@",
                            tag.label
                        ]
                    }, index);
                case "hashtag":
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hashtag, {
                        children: [
                            "#",
                            tag.content,
                            " "
                        ]
                    }, index);
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Word, {
                        children: tag.content
                    }, index);
            }
        })
    });
};
var TemplateDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-5"
})(panel_templateObject5());
var UseTemplateContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-6"
})(_templateObject6(), breakpoints/* devices.tablet */.Hb.tablet, function(props) {
    return props.show ? "200px" : "58px";
});
var QrContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-7"
})(_templateObject7());
var UseTemplateRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-8"
})(_templateObject8());
var UseTemplateLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-9"
})(_templateObject9());
var StepsContainer = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-e058c95f-10"
})(_templateObject10(), breakpoints/* devices.desktop */.Hb.desktop);
var Step = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e058c95f-11"
})(_templateObject11());
var ScanIconContainer = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-e058c95f-12"
})(_templateObject12());
var ScanIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScanIconContainer, {
        width: "23",
        height: "22",
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.0195 11H3.51953",
                stroke: "#292929",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.436 3.66602H16.1027C17.7596 3.66602 19.1027 5.00916 19.1027 6.66602V7.33268",
                stroke: "#292929",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.10303 18.334L7.43636 18.334C5.77951 18.334 4.43636 16.9908 4.43636 15.334L4.43636 14.6673",
                stroke: "#292929",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.1027 14.666V15.3327C19.1027 16.9895 17.7596 18.3327 16.1027 18.3327H15.436",
                stroke: "#292929",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.43636 7.33398L4.43636 6.66732C4.43636 5.01046 5.77951 3.66732 7.43636 3.66732L8.10303 3.66732",
                stroke: "#292929",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var ShareTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-13"
})(_templateObject13(), breakpoints/* devices.desktop */.Hb.desktop);
var ShareMobile = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-14"
})(_templateObject14(), breakpoints/* devices.desktop */.Hb.desktop);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-15"
})(_templateObject15(), breakpoints/* devices.desktop */.Hb.desktop);
var SocialRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-16"
})(_templateObject16(), breakpoints/* devices.desktop */.Hb.desktop);
var PanelScrollable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-17"
})(_templateObject17());
var ShareRow = function(param) {
    var share = param.share, name = param.name;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[16px] rounded-t-[14px] bg-color-cell",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTitle, {
                children: t("txt_share_on")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareMobile, {
                children: [
                    t("lbl_share"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(URLIcon, {
                        url: share,
                        index: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook, {
                        url: encodeURIComponent(share),
                        index: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Messenger, {
                        url: encodeURIComponent(share),
                        index: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsApp, {
                        url: encodeURIComponent(share),
                        index: 3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Viber, {
                        url: encodeURIComponent(share),
                        index: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pinterest, {
                        url: encodeURIComponent(share),
                        index: 5
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Email, {
                        url: encodeURIComponent(share),
                        index: 6
                    })
                ]
            })
        ]
    });
};
var CategoryIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.33337 3.83398H2.35226",
                stroke: "var(--color-blue-900)",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6516 13.168L5.60556 13.168M5.60581 8.5013L13.6516 8.5013M5.60556 3.83464L13.6516 3.83464",
                stroke: "var(--color-blue-900)",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.33337 8.5H2.35226",
                stroke: "var(--color-blue-900)",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.33337 13.168H2.35226",
                stroke: "var(--color-blue-900)",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var AuthorContainer = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e058c95f-18"
})(_templateObject18());
var AuthorPicture = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e058c95f-19"
})(_templateObject19());
var AuthorInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-20"
})(_templateObject20());
var AuthorName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-21"
})(_templateObject21());
var AuthorFollowers = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e058c95f-22"
})(_templateObject22());
var ShareContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e058c95f-23"
})(_templateObject23());
var SidePanel = function(props) {
    var _template = props.template, name = _template.name, description = _template.description, created = _template.created, share = _template.share, creator = _template.creator, category = _template.category, id = _template.id, categoryId = _template.categoryId;
    var closeFn = props.closeFn;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var uid = creator.uid, follow_status = creator.follow_status;
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var isSelf = userInfo.userId === creator.uid;
    var date = (0,dates/* getFormattedDate */.L0)(created);
    var ref1 = (0,react.useState)(false), reportPopup = ref1[0], setReportPopup = ref1[1];
    var ref2 = (0,react.useState)(follow_status !== null && follow_status !== void 0 ? follow_status : null), followStatus = ref2[0], setFollowStatus = ref2[1];
    var ref3 = (0,react.useState)({
        tid: id,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref3[0], setPayload = ref3[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var _picture;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("hidden bg-color-cell text-blue-900 desktop:flex", "absolute right-0 h-[100svh] flex-col items-center overflow-hidden", "self-stretch justify-self-end p-[8px]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "m-[16px] flex flex-col tablet:w-[478px] desktop:w-[425px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full items-center justify-between border-b border-color-separator pb-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorContainer, {
                            href: "/" + creator.username,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorPicture, {
                                    onError: function(e) {
                                        return e.currentTarget.setAttribute("src", (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg"));
                                    },
                                    alt: "author picture",
                                    src: (_picture = creator.picture) !== null && _picture !== void 0 ? _picture : (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorInfo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorName, {
                                            children: creator.username
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorFollowers, {
                                            children: [
                                                (0,millions/* default */.Z)(creator.followers),
                                                " ",
                                                t("common:lbl_followers")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(isSelf && "hidden", "flex items-center gap-[11px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(isSelf && "hidden", "flex h-[44px] items-center justify-center tablet:w-[183px]", "w-[132px] overflow-hidden rounded-[6px]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(advanced_profile/* FollowButton */.eg, {
                                        followStatus: followStatus !== null && followStatus !== void 0 ? followStatus : "not_following",
                                        uid: uid,
                                        setFollowStatus: setFollowStatus,
                                        userPage: false
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("h-[44px] w-[44px] [--icon-color:var(--color-blue-900)] hover:bg-blue-100", "flex items-center justify-center rounded-md"),
                                            children: (0,icons/* moreIcon */.Jf)()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: function() {
                                                setReportPopup(true);
                                            },
                                            className: (0,clsx_m/* default */.Z)("fixed hidden w-[123px] rounded-[12px] px-[10px] py-[8px] group-hover:flex", "z-[200] items-center gap-[8px] shadow-xl hover:bg-blue-100", "right-[20px] top-[740px] bg-color-popup-cell desktop:top-[80px]"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                    source: "/general/report",
                                                    format: "svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[16px] font-500 text-blue-800",
                                                    children: t("txt_report")
                                                })
                                            ]
                                        }),
                                        reportPopup && setReportPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(report_popup/* ReportPopup */.j, {
                                            closeFn: closeFn,
                                            payload: payload,
                                            setReportPopup: setReportPopup,
                                            payloadLocation: "tutorial",
                                            setPayload: setPayload,
                                            endpoint: "tutorial-report",
                                            galleryOrTemplate: "template",
                                            className: "absolute -right-1 top-[55px] z-[201]"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PanelScrollable, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateName, {
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateDescription, {
                            description: description
                        }),
                        category !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "/video-templates?categoryId=".concat(categoryId),
                            className: "flex items-center gap-1 text-base text-blue-900",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIcon, {}),
                                category
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateDate, {
                            children: date
                        }),
                        share && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UseTemplateContainer, {
                                show: show,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UseTemplateRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseTemplateLabel, {
                                                children: t("txt_use_template")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                                                show: show,
                                                onClick: function() {
                                                    return setShow(!show);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QrContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.ZP, {
                                                size: 100,
                                                bgColor: "#ecedef00",
                                                fgColor: "#ff3166",
                                                value: share,
                                                renderAs: "canvas"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                                        children: [
                                                            "1. ",
                                                            t("txt_open_zoomerang_app")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Step, {
                                                        children: [
                                                            "2. ",
                                                            t("txt_on_profile_tap"),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanIcon, {}),
                                                            " " /* required */ ,
                                                            t("txt_and_scan_qr")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        share && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareRow, {
                            share: share
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comments/* default */.Z, {
                            username: props.template.creator.username,
                            template: props.template.id,
                            count: props.template.comments,
                            allowed: props.template.allowComments
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var panel = (SidePanel);


/***/ }),

/***/ 64:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ RawText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7232);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2213);





var RawText = function(props) {
    var content = props.content, line = props.line, size = props.size, weight = props.weight, color = props.color, capitalization = props.capitalization, center = props.center, letterSpacing = props.letterSpacing;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "inline",
            color: color ? "var(--color-".concat(color, ")") : undefined,
            fontWeight: Number.parseInt(weight),
            fontSize: size + "px",
            lineHeight: line ? line + "px" : undefined,
            letterSpacing: letterSpacing ? letterSpacing + "px" : (0,_utils_spacing__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(size),
            textTransform: capitalization,
            textAlign: center ? "center" : undefined
        },
        children: content
    });
};
var Text = function(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RawText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        content: t(props.content)
    }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 7092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ SquareSwitch; },
/* harmony export */   "rs": function() { return /* binding */ Switch; }
/* harmony export */ });
/* unused harmony export ControlledSwitch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			opacity: 0.5;\n			pointer-events: none;\n			cursor: not-allowed;\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 28px;\n	width: 52px;\n\n	padding: 3px;\n\n	border-radius: 28px;\n\n	transition: all 200ms ease-in-out;\n	cursor: pointer;\n\n	background-color: ",
        ";\n\n	",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 22px;\n	height: 22px;\n\n	background-color: var(--color-background-cell);\n	border-radius: 22px;\n\n	margin-left: ",
        ";\n\n	transition: margin-left 300ms ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			opacity: 0.5;\n			pointer-events: none;\n			cursor: not-allowed;\n		"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 24px;\n	width: 46px;\n\n	padding: 2px;\n\n	border-radius: 6px;\n\n	transition: all 200ms ease-in-out;\n	cursor: pointer;\n\n	background-color: ",
        ";\n\n	",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 20px;\n	height: 20px;\n\n	background-color: var(--color-white);\n	border-radius: 4px;\n\n	margin-left: ",
        ";\n\n	transition: margin-left 300ms ease-in-out;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var _activeColor, _inactiveColor;
var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-22e094b4-0"
})(_templateObject1(), function(props) {
    return props.active ? (_activeColor = props.activeColor) !== null && _activeColor !== void 0 ? _activeColor : "var(--color-primary-500)" : (_inactiveColor = props.inactiveColor) !== null && _inactiveColor !== void 0 ? _inactiveColor : "var(--color-blue-300)";
}, function(props) {
    return props.available === false && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
});
var Circle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-22e094b4-1"
})(_templateObject2(), function(props) {
    return props.active ? "24px" : "0";
});
var _activeColor1, _inactiveColor1;
var ContainerRectangle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-22e094b4-2"
})(_templateObject4(), function(props) {
    return props.active ? (_activeColor1 = props.activeColor) !== null && _activeColor1 !== void 0 ? _activeColor1 : "var(--color-primary-800)" : (_inactiveColor1 = props.inactiveColor) !== null && _inactiveColor1 !== void 0 ? _inactiveColor1 : "var(--color-blue-200)";
}, function(props) {
    return props.available === false && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
});
var Square = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-22e094b4-3"
})(_templateObject5(), function(props) {
    return props.active ? "22px" : "0";
});
var Toggle = function(props) {
    var className = props.className, theme = props.theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Switch, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        enabled: theme,
        className: className
    }));
};
function Switch(props) {
    var onChange = props.onChange, className = props.className, enabled = props.enabled, activeColor = props.activeColor, inactiveColor = props.inactiveColor, available = props.available;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        available: available,
        className: className,
        activeColor: activeColor,
        inactiveColor: inactiveColor,
        active: enabled,
        onClick: function() {
            onChange(!enabled);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Circle, {
            active: enabled
        })
    });
}
function ControlledSwitch(props) {
    var onChange = props.onChange, className = props.className, enabled = props.enabled, activeColor = props.activeColor, inactiveColor = props.inactiveColor, available = props.available;
    return /*#__PURE__*/ _jsx(Container, {
        available: available,
        className: className,
        activeColor: activeColor,
        inactiveColor: inactiveColor,
        active: enabled,
        onClick: function() {
            onChange(!enabled);
        },
        children: /*#__PURE__*/ _jsx(Circle, {
            active: enabled
        })
    });
}
function SquareSwitch(props) {
    var onChange = props.onChange, className = props.className, enabled = props.enabled, activeColor = props.activeColor, inactiveColor = props.inactiveColor, available = props.available;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContainerRectangle, {
        available: available,
        className: className,
        activeColor: activeColor,
        inactiveColor: inactiveColor,
        active: enabled,
        onClick: function(e) {
            e.preventDefault();
            onChange(!enabled);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Square, {
            active: enabled
        })
    });
}
/* harmony default export */ __webpack_exports__["Co"] = (Toggle);


/***/ }),

/***/ 4773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JI": function() { return /* binding */ TextTooltip; }
/* harmony export */ });
/* unused harmony export NewTooltip */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        pointer-events: none;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  align-self: stretch;\n  align-items: stretch;\n  flex-direction: column;\n\n  display: flex;\n\n  & * {\n    ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      transition: opacity 300ms ease-in-out 300ms;\n      opacity: 1;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: calc(100% + 4px + ",
        "px);\n  z-index: 229;\n\n  width: 100%;\n  max-width: 350px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  pointer-events: none;\n\n  opacity: 0;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: ",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--color-blue-100);\n  background-color: var(--color-tooltip);\n  text-wrap: normal;\n\n  padding: 8px;\n  border-radius: 8px;\n\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n\n  text-align: center;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: var(--color-tooltip);\n\n  margin-bottom: -7px;\n\n  width: 12px;\n  height: 12px;\n  transform: rotate(45deg);\n  border-radius: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var TooltipContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd52e842-0"
})(_templateObject1(), function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
});
var _margin;
var TooltipPopupContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd52e842-1"
})(_templateObject3(), function(props) {
    return (_margin = props.margin) !== null && _margin !== void 0 ? _margin : 0;
}, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
});
var TooltipPopup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd52e842-2"
})(_templateObject5(), function(props) {
    return props.width !== undefined && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), props.width);
});
var TooltipTail = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fd52e842-3"
})(_templateObject6());
var Tooltip = function(props) {
    var children = props.children, className = props.className, title = props.title, disabled = props.disabled, margin = props.margin, width = props.width, showAlways = props.showAlways;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), active = ref[0], setActive = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TooltipContainer, {
        className: className,
        disabled: disabled,
        onMouseOver: function() {
            if (showAlways) setActive(true);
            else if (disabled) setActive(true);
        },
        onMouseLeave: function() {
            return setActive(false);
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TooltipPopupContainer, {
                active: active,
                margin: margin,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TooltipTail, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TooltipPopup, {
                        width: width,
                        children: title
                    })
                ]
            })
        ]
    });
};
function NewTooltip(props) {
    var children = props.children, className = props.className, title = props.title;
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx(className !== null && className !== void 0 ? className : "relative flex"),
        children: [
            children,
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("absolute left-1/2 -translate-x-1/2 peer-hover:opacity-100", "translate-y-[calc(100%+5px)] transition-opacity", "z-[999] opacity-0 duration-300"),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: clsx("-mb-[7px] h-[12px] w-[12px] rotate-45 rounded-[3px] bg-color-tooltip", "absolute -top-[5px] left-1/2 -translate-x-1/2")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: clsx("bg-color-tooltip p-[8px] text-blue-100", "rounded-[8px] text-[12px] font-500 leading-[14px]"),
                        children: title
                    })
                ]
            })
        ]
    });
}
function TextTooltip(props) {
    var title = props.title, className = props.className, tooltipClassName = props.tooltipClassName, children = props.children, disabled = props.disabled, showAlways = props.showAlways;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), active = ref[0], setActive = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative", className),
        onMouseOver: function() {
            if (showAlways) setActive(true);
            else if (disabled) setActive(true);
        },
        onMouseLeave: function() {
            return setActive(false);
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("absolute left-1/2 top-full -translate-x-1/2 rotate-45", "h-5 w-5 translate-y-1 rounded-[4px]", "opacity-0", "bg-color-tooltip transition-all delay-150 duration-200", active ? "opacity-100" : "")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("pointer-events-none absolute w-full max-w-[350px] rounded-[8px] opacity-0", "z-[9999] px-3 py-1", "left-1/2 top-full -translate-x-1/2 translate-y-2", "bg-color-tooltip text-xs font-500 text-blue-100 transition-all delay-150 duration-200", active ? "opacity-100" : "", tooltipClassName),
                children: title
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (Tooltip);


/***/ }),

/***/ 17:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ aspects; },
/* harmony export */   "LF": function() { return /* binding */ DEFORUM_STORAGE_KEY; },
/* harmony export */   "Qf": function() { return /* binding */ useEditorsController; },
/* harmony export */   "c2": function() { return /* binding */ isImageOrVideo; },
/* harmony export */   "cF": function() { return /* binding */ getStorage; },
/* harmony export */   "oQ": function() { return /* binding */ calculateDurationPrice; }
/* harmony export */ });
/* unused harmony exports MIN_RESOLUTION, promptSchema, isVideoFile, getAcceptedMimes */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7582);
/* harmony import */ var _comps_ai_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9264);
/* harmony import */ var _comps_editors_ai_music_generator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2490);
/* harmony import */ var _comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(356);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(177);
/* harmony import */ var _utils_mime_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3867);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6961);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8767);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1604);



















var MIN_RESOLUTION = 450;
var DEFORUM_STORAGE_KEY = "last";
var channelsSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    available_bitrates: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        bitrate: zod__WEBPACK_IMPORTED_MODULE_7__.z.number()
    })),
    available_intensities: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        intensity: zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
            zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("low"),
            zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("medium"),
            zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("high"), 
        ])
    })),
    categories: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        category_id: zod__WEBPACK_IMPORTED_MODULE_7__.z.number(),
        name: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
        groups: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
            name: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
            playlist: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
        }))
    }))
});
var promptSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        type: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("custom"),
        content: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.string())
    }),
    zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        type: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("predefined"),
        id: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
    }), 
]);
var channelsResponseSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    data: channelsSchema
});
var remoteStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("remote"),
    url: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
});
var localStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    location: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("local"),
    blob: zod__WEBPACK_IMPORTED_MODULE_7__.z.unknown()
});
var deforumStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("deform").default("deform"),
    id: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    inputs: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        id: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
        text: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
    }))
}).and(zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var restyleStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("ai_restyle").default("ai_restyle"),
    id: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().nullable(),
    input: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var photoAiStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("ai_photo").default("ai_photo"),
    id: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().nullable(),
    input: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var textToImageStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("text_to_image").default("text_to_image"),
    id: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().nullable(),
    text: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
var textToVideoStorageSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    tool: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("text_to_video").default("text_to_video"),
    id: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(DEFORUM_STORAGE_KEY),
    promptType: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().nullable(),
    text: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
}).and(zod__WEBPACK_IMPORTED_MODULE_7__.z.union([
    remoteStorageSchema,
    localStorageSchema
]));
function createPromptStateFrom(params) {
    if (!params) return null;
    return params.reduce(function(acc, param) {
        switch(param.type){
            case "switcher":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "slider":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "cameras":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, param.id, ""));
            case "checkbox":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, param.id, Boolean(param.defaultValue)));
            case "select":
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, param.id, param.defaultValue));
            case "dynamic":
                return acc;
        }
    }, {});
}
function getStateForTool(state, action) {
    switch(action.tool){
        case "deform":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                tool: action.tool,
                promptType: action.promptType
            });
        case "ai_photo":
        case "ai_restyle":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                tool: action.tool,
                promptType: action.promptType
            });
        case "text_to_image":
        case "text_to_video":
            var _promptType;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                tool: action.tool,
                userPrompt: action.text,
                promptType: (_promptType = action.promptType) !== null && _promptType !== void 0 ? _promptType : "photoreal_tti"
            });
        default:
            return state;
    }
}
var dashboardReducer = function(state, action) {
    switch(action.name){
        case "initial_state":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state);
        case "change_selected_tool":
            return getStateForTool(state, action.content);
        case "set_filters_and_channels":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                styles: action.styles,
                params: action.params,
                channels: action.channels,
                blob: action.blob,
                promptState: action.params.params ? action.params.params.reduce(function(acc, a) {
                    if (a.type !== "cameras" && a.type !== "dynamic") {
                        acc[a.id] = a.defaultValue;
                    } else {
                        acc[a.id] = "";
                    }
                    return acc;
                }, {}) : null
            });
        case "add_user_uploaded_file":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                blob: action.blob
            });
        case "set_data_getter":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                getData: action.data
            });
        case "change_propmp_type":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                promptType: action.type
            });
        case "change_camera_style":
            var ref;
            var ref1;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                promptState: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.promptState), {
                    cameras: (ref1 = (ref = action.style) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : ""
                }),
                cameraStyle: action.style
            });
        case "change_current_prompt_state":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                promptState: action.newState
            });
        case "set_user_prompt":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                userPrompt: action.prompt
            });
        case "set_selected_model":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                selectedModel: action.model
            });
        case "set_user_custom_style":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                userCustomStyle: action.prompt
            });
        case "select_aspect":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                selectedAspect: action.aspect
            });
        case "change_keep_face_value":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state), {
                keepFace: !state.keepFace
            });
        case "reset_tool_filters":
            if (state.styles === null || state.params === null) {
                return state;
            }
            return {
                tool: state.tool,
                blob: state.blob,
                channels: state.channels,
                prompts: state.prompts,
                styles: state.styles,
                params: state.params,
                getData: null,
                promptType: "custom",
                cameraStyle: null,
                promptState: createPromptStateFrom(state.params.params),
                selectedModel: null,
                userPrompt: "",
                userCustomStyle: "",
                selectedAspect: aspects[0],
                keepFace: false
            };
    }
};
function useEditorsController(initialData) {
    var changeKeepFaceValue = function changeKeepFaceValue() {
        dispatch({
            name: "change_keep_face_value"
        });
    };
    var selectAspect = function selectAspect(aspect) {
        dispatch({
            name: "select_aspect",
            aspect: aspect
        });
    };
    var resetToolFilters = function resetToolFilters() {
        dispatch({
            name: "reset_tool_filters"
        });
    };
    var setUserCustomStyle = function setUserCustomStyle(v) {
        dispatch({
            name: "set_user_custom_style",
            prompt: v
        });
    };
    var setUserPrompt = function setUserPrompt(v) {
        dispatch({
            name: "set_user_prompt",
            prompt: v
        });
    };
    var setSelectedModel = function setSelectedModel(v) {
        dispatch({
            name: "set_selected_model",
            model: v
        });
    };
    var setCurrentPromptState = function setCurrentPromptState(v) {
        dispatch({
            name: "change_current_prompt_state",
            newState: v
        });
    };
    var selectCameraStyle = function selectCameraStyle(v) {
        dispatch({
            name: "change_camera_style",
            style: v
        });
    };
    var changePromptType = function changePromptType(type) {
        dispatch({
            name: "change_propmp_type",
            type: type
        });
    };
    var changeSelectedTool = function changeSelectedTool(content) {
        dispatch({
            name: "change_selected_tool",
            content: content
        });
    };
    var createInput = function createInput() {
        var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return {
            text: text,
            id: Math.random().toString()
        };
    };
    var createInputs = function createInputs(initial) {
        if (initial.type === "predefined") {
            return [
                createInput()
            ];
        }
        return initial.content.map(createInput);
    };
    var getPayloadFromTool = function getPayloadFromTool() {
        switch(state.tool){
            case "deform":
                var _promptType;
                var inputs = state.promptType === "custom" ? createInputs({
                    type: "custom",
                    content: [
                        ""
                    ]
                }) : createInputs({
                    type: "predefined",
                    id: (_promptType = state.promptType) !== null && _promptType !== void 0 ? _promptType : ""
                });
                var _promptType1;
                return {
                    tool: "deform",
                    id: DEFORUM_STORAGE_KEY,
                    inputs: inputs,
                    promptType: (_promptType1 = state.promptType) !== null && _promptType1 !== void 0 ? _promptType1 : "custom",
                    location: "local",
                    blob: state.blob
                };
            case "ai_photo":
            case "ai_restyle":
                var _promptType2;
                return {
                    tool: state.tool,
                    id: DEFORUM_STORAGE_KEY,
                    input: "",
                    promptType: (_promptType2 = state.promptType) !== null && _promptType2 !== void 0 ? _promptType2 : "custom",
                    location: "local",
                    blob: state.blob
                };
            case "text_to_video":
            case "text_to_image":
                return {
                    tool: state.tool,
                    id: DEFORUM_STORAGE_KEY,
                    promptType: state.promptType,
                    text: state.userPrompt,
                    location: "local",
                    blob: state.blob
                };
            default:
                var _promptType3;
                var prompts = state.promptType === "custom" ? createInputs({
                    type: "custom",
                    content: [
                        ""
                    ]
                }) : createInputs({
                    type: "predefined",
                    id: (_promptType3 = state.promptType) !== null && _promptType3 !== void 0 ? _promptType3 : ""
                });
                var _promptType4;
                return {
                    tool: "deform",
                    id: DEFORUM_STORAGE_KEY,
                    inputs: prompts,
                    promptType: (_promptType4 = state.promptType) !== null && _promptType4 !== void 0 ? _promptType4 : "custom",
                    location: "local",
                    blob: state.blob
                };
        }
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useReducer)(dashboardReducer, {
        tool: initialData.tool,
        styles: null,
        params: null,
        channels: null,
        blob: null,
        getData: null,
        promptType: initialData.tool === "text_to_image" ? null : "custom",
        prompts: null,
        cameraStyle: null,
        promptState: null,
        selectedModel: null,
        userPrompt: "",
        userCustomStyle: "",
        selectedAspect: aspects[0],
        keepFace: false
    }), state = ref4[0], dispatch = ref4[1];
    var controller = (0,_comps_ai_config__WEBPACK_IMPORTED_MODULE_0__/* .useVideoClipper */ .FD)({
        file: state.blob
    });
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_3__/* .useAdjustLogger */ .eW)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQueryClient)();
    var isKeepFaceNotAllowed = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (state.styles) {
            var ref;
            var ref1;
            isKeepFaceNotAllowed.current = (ref1 = (ref = state.styles.find(function(style) {
                return style.id === state.promptType;
            })) === null || ref === void 0 ? void 0 : ref.ignoreFace) !== null && ref1 !== void 0 ? ref1 : false;
        }
    }, [
        state.promptType,
        state.styles
    ]);
    var ref5;
    var initialConfig = createPromptStateFrom((ref5 = (ref = state.params) === null || ref === void 0 ? void 0 : ref.params) !== null && ref5 !== void 0 ? ref5 : null);
    var sectionsConfig = ((ref1 = state.params) === null || ref1 === void 0 ? void 0 : ref1.sections) ? (ref2 = state.params) === null || ref2 === void 0 ? void 0 : ref2.sections.map(function(section) {
        return createPromptStateFrom(section.components);
    }) : null;
    var config = sectionsConfig ? sectionsConfig.reduce(function(acc, section) {
        return section ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc, section) : acc;
    }, initialConfig || null) : initialConfig || null;
    var setDataGetter = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(data) {
        dispatch({
            name: "set_data_getter",
            data: data
        });
    }, []);
    var setFile = function(file) {
        dispatch({
            name: "add_user_uploaded_file",
            blob: file
        });
    };
    function loadToolFilters(props) {
        return _loadToolFilters.apply(this, arguments);
    }
    function _loadToolFilters() {
        _loadToolFilters = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(props) {
            var pat, ref, params, channels, blob;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pat = props.tool === "ai_music_generator" ? props.pat : null;
                        return [
                            4,
                            Promise.all([
                                getOtherParams(props.tool),
                                getChannels(props.tool, true, pat)
                            ])
                        ];
                    case 1:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), params = ref[0], channels = ref[1];
                        if (!(props.tool !== "ai_music_generator")) return [
                            3,
                            5
                        ];
                        if (!(props.location === "remote" && props.url)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .loadUrlToBlob */ .fj)(props.url)
                        ];
                    case 2:
                        blob = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (props.location === "local" && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(props.blob, Blob)) {
                            blob = props.blob;
                        } else {
                            blob = null;
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        blob = null;
                        _state.label = 6;
                    case 6:
                        if (params) {
                            dispatch({
                                name: "set_filters_and_channels",
                                styles: params === null || params === void 0 ? void 0 : params.styles,
                                params: {
                                    sections: params.params.sections,
                                    price: params.params.price,
                                    params: params.params.params
                                },
                                channels: channels,
                                blob: blob
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _loadToolFilters.apply(this, arguments);
    }
    function getOtherParams(tool) {
        return _getOtherParams.apply(this, arguments);
    }
    function _getOtherParams() {
        _getOtherParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(tool) {
            var result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(tool !== "ai_music_generator")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-params", {
                                tool: tool
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            2,
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, result), {
                                channels: null
                            })
                        ];
                    case 2:
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getOtherParams.apply(this, arguments);
    }
    function getChannels(tool, isPro, pat) {
        return _getChannels.apply(this, arguments);
    }
    function _getChannels() {
        _getChannels = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(tool, isPro, pat) {
            var submitData, response, result, _data, available_bitrates, available_intensities, categories, e, result1, _data1, available_bitrates1, available_intensities1, categories1, result2, _data2, available_bitrates2, available_intensities2, categories2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(tool === "ai_music_generator" && isPro && pat)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        submitData = {
                            method: "GetPlayMusic",
                            params: {
                                pat: pat
                            }
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("https://api-b2b.mubert.com/v2/GetPlayMusic", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        result = channelsResponseSchema.parse(response);
                        _data = result.data, available_bitrates = _data.available_bitrates, available_intensities = _data.available_intensities, categories = _data.categories;
                        return [
                            2,
                            {
                                available_bitrates: available_bitrates,
                                available_intensities: available_intensities,
                                categories: categories
                            }
                        ];
                    case 3:
                        e = _state.sent();
                        result1 = channelsResponseSchema.parse(defaultChannelsList);
                        _data1 = result1.data, available_bitrates1 = _data1.available_bitrates, available_intensities1 = _data1.available_intensities, categories1 = _data1.categories;
                        return [
                            2,
                            {
                                available_bitrates: available_bitrates1,
                                available_intensities: available_intensities1,
                                categories: categories1
                            }
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        result2 = channelsResponseSchema.parse(defaultChannelsList);
                        _data2 = result2.data, available_bitrates2 = _data2.available_bitrates, available_intensities2 = _data2.available_intensities, categories2 = _data2.categories;
                        return [
                            2,
                            {
                                available_bitrates: available_bitrates2,
                                available_intensities: available_intensities2,
                                categories: categories2
                            }
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _getChannels.apply(this, arguments);
    }
    function generateResult() {
        return _generateResult.apply(this, arguments);
    }
    function _generateResult() {
        _generateResult = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            var _, file, res, resolution, ref, upload, download, contentType, dimensions, changedDimensions, face, _promptState, submitData, error, file1, res1, resolution1, ref1, upload1, download1, contentType1, dimensions1, changedDimensions1, _promptState1, submitData1, error1, ref2, file2, res2, resolution2, ref3, upload2, download2, contentType2, dimensions2, changedDimensions2, _promptType, prompts, _promptState2, submitData2, error2, ref4, ref5, file3, res3, resolution3, ref6, upload3, download3, contentType3, _tmp, _tmp1, aspect, calculatedDimensions, _promptState3, submitData3, error3;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = state.tool;
                        switch(_){
                            case "ai_photo":
                                return [
                                    3,
                                    1
                                ];
                            case "ai_restyle":
                                return [
                                    3,
                                    9
                                ];
                            case "deform":
                                return [
                                    3,
                                    17
                                ];
                            case "text_to_image":
                                return [
                                    3,
                                    25
                                ];
                        }
                        return [
                            3,
                            34
                        ];
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        if (!state.getData) {
                            throw new Error("Should have set getData");
                        }
                        return [
                            4,
                            state.getData.getter()
                        ];
                    case 2:
                        file = _state.sent();
                        res = null;
                        if (config && config["resolution"]) {
                            res = Number(config["resolution"]);
                        }
                        resolution = res !== null && res !== void 0 ? res : MIN_RESOLUTION;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: file.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 3:
                        ref = _state.sent(), upload = ref.upload, download = ref.download, contentType = ref.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].put */ .Z.put(upload, file, {
                                headers: {
                                    "Content-Type": contentType,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .getImageDimensions */ .pz)(file)
                        ];
                    case 5:
                        dimensions = _state.sent();
                        changedDimensions = (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .resizeDimensions */ .bY)(dimensions, resolution);
                        face = null;
                        if (!isKeepFaceNotAllowed && state.keepFace) face = download;
                        submitData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            url: download,
                            style: state.promptType === "custom" ? null : state.promptType,
                            additional: state.userCustomStyle,
                            tool: "ai_photo",
                            params: (_promptState = state.promptState) !== null && _promptState !== void 0 ? _promptState : {
                                resolution: 720
                            },
                            face_object_url: face
                        }, changedDimensions);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            3,
                            34
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            15,
                            ,
                            16
                        ]);
                        if (!state.getData) {
                            throw new Error("Should have set getData");
                        }
                        return [
                            4,
                            state.getData.getter()
                        ];
                    case 10:
                        file1 = _state.sent();
                        res1 = null;
                        if (config && config["resolution"]) {
                            res1 = Number(config["resolution"]);
                        }
                        resolution1 = res1 !== null && res1 !== void 0 ? res1 : MIN_RESOLUTION;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-video-url", {
                                content: file1.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 11:
                        ref1 = _state.sent(), upload1 = ref1.upload, download1 = ref1.download, contentType1 = ref1.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].put */ .Z.put(upload1, file1, {
                                headers: {
                                    "Content-Type": contentType1,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 12:
                        _state.sent();
                        if (!controller) {
                            throw new Error("Controller is not ready");
                        }
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .getVideoDimensions */ .jC)(file1)
                        ];
                    case 13:
                        dimensions1 = _state.sent();
                        changedDimensions1 = (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .resizeDimensions */ .bY)(dimensions1, resolution1);
                        submitData1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            url: download1,
                            additional: state.userCustomStyle,
                            style: state.promptType,
                            tool: "ai_restyle",
                            start: controller.startTime,
                            duration: controller.selectedDuration,
                            params: (_promptState1 = state.promptState) !== null && _promptState1 !== void 0 ? _promptState1 : {
                                resolution: 720
                            },
                            price: calculateDurationPrice(controller.selectedDuration)
                        }, changedDimensions1);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData1).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 14:
                        _state.sent();
                        return [
                            3,
                            16
                        ];
                    case 15:
                        error1 = _state.sent();
                        console.error(error1);
                        return [
                            3,
                            16
                        ];
                    case 16:
                        return [
                            3,
                            34
                        ];
                    case 17:
                        _state.trys.push([
                            17,
                            23,
                            ,
                            24
                        ]);
                        if (!state.getData) {
                            throw new Error("Should have set getData");
                        }
                        return [
                            4,
                            state.getData.getter()
                        ];
                    case 18:
                        file2 = _state.sent();
                        res2 = null;
                        if (config && config["resolution"]) {
                            res2 = Number(config["resolution"]);
                        }
                        resolution2 = res2 !== null && res2 !== void 0 ? res2 : MIN_RESOLUTION;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: file2.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 19:
                        ref3 = _state.sent(), upload2 = ref3.upload, download2 = ref3.download, contentType2 = ref3.contentType;
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].put */ .Z.put(upload2, file2, {
                                headers: {
                                    "Content-Type": contentType2,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 20:
                        _state.sent();
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .getImageDimensions */ .pz)(file2)
                        ];
                    case 21:
                        dimensions2 = _state.sent();
                        changedDimensions2 = (0,_utils_video__WEBPACK_IMPORTED_MODULE_4__/* .resizeDimensions */ .bY)(dimensions2, resolution2);
                        prompts = ((ref2 = state.prompts) === null || ref2 === void 0 ? void 0 : ref2.type) === "custom" ? {
                            type: "custom",
                            content: state.prompts.content.map(function(input) {
                                return input;
                            })
                        } : {
                            type: "predefined",
                            id: (_promptType = state.promptType) !== null && _promptType !== void 0 ? _promptType : ""
                        };
                        submitData2 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            url: download2,
                            prompts: prompts,
                            tool: "deform",
                            params: (_promptState2 = state.promptState) !== null && _promptState2 !== void 0 ? _promptState2 : {
                                resolution: 720
                            }
                        }, changedDimensions2);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData2).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 22:
                        _state.sent();
                        if (state.promptType === "custom") {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_prompt_writing");
                        } else {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_select_style");
                        }
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_generate");
                        return [
                            3,
                            24
                        ];
                    case 23:
                        error2 = _state.sent();
                        console.error(error2);
                        return [
                            3,
                            24
                        ];
                    case 24:
                        return [
                            3,
                            34
                        ];
                    case 25:
                        _state.trys.push([
                            25,
                            32,
                            ,
                            33
                        ]);
                        file3 = state.blob;
                        res3 = null;
                        if (config && config["resolution"]) {
                            res3 = Number(config["resolution"]);
                        }
                        resolution3 = res3 !== null && res3 !== void 0 ? res3 : MIN_RESOLUTION;
                        if (!file3) return [
                            3,
                            27
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-image-url", {
                                content: file3.type
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 26:
                        _tmp = _state.sent();
                        return [
                            3,
                            28
                        ];
                    case 27:
                        _tmp = {
                            upload: null,
                            download: null,
                            contentType: null
                        };
                        _state.label = 28;
                    case 28:
                        ref6 = _tmp, upload3 = ref6.upload, download3 = ref6.download, contentType3 = ref6.contentType;
                        _tmp1 = upload3;
                        if (!_tmp1) return [
                            3,
                            30
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].put */ .Z.put(upload3, file3, {
                                headers: {
                                    "Content-Type": contentType3,
                                    "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .HEADER_WEB_VERSION */ .F
                                }
                            })
                        ];
                    case 29:
                        _tmp1 = _state.sent();
                        _state.label = 30;
                    case 30:
                        _tmp1;
                        aspect = state.selectedAspect ? ((ref4 = state.selectedAspect) === null || ref4 === void 0 ? void 0 : ref4.aspectWidth) / ((ref5 = state.selectedAspect) === null || ref5 === void 0 ? void 0 : ref5.aspectHeight) : 1;
                        calculatedDimensions = calculateDimensions(resolution3, aspect);
                        submitData3 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            prompt: state.userPrompt,
                            style: state.promptType,
                            tool: "text_to_image",
                            params: (_promptState3 = state.promptState) !== null && _promptState3 !== void 0 ? _promptState3 : {
                                resolution: 720
                            },
                            face_object_url: download3,
                            // compositions:
                            // 	state.selectedModel &&
                            // 		imagePosition &&
                            // 		selectedComposition
                            // 		? [
                            // 			{
                            // 				url: selectedComposition,
                            // 				rotation: rotation,
                            // 				bg_aspect: aspect,
                            // 				c_x: centerX,
                            // 				c_y: centerY,
                            // 				width_ratio:
                            // 					imagePosition?.widthRatio,
                            // 			},
                            // 		]
                            // 		: undefined,
                            prompt_model_tags: state.selectedModel ? [
                                {
                                    id: state.selectedModel.id,
                                    tag: state.selectedModel.name
                                }
                            ] : undefined
                        }, calculatedDimensions);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/api/deforum-submit", submitData3).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 31:
                        _state.sent();
                        return [
                            3,
                            33
                        ];
                    case 32:
                        error3 = _state.sent();
                        console.error(error3);
                        return [
                            3,
                            33
                        ];
                    case 33:
                        return [
                            3,
                            34
                        ];
                    case 34:
                        queryClient.invalidateQueries("deforum-last");
                        return [
                            2
                        ];
                }
            });
        });
        return _generateResult.apply(this, arguments);
    }
    var _id;
    return {
        setDataGetter: setDataGetter,
        changeSelectedTool: changeSelectedTool,
        styles: state.styles,
        params: state.params,
        channels: state.channels,
        promptType: state.promptType === null ? (_id = (ref3 = state.styles) === null || ref3 === void 0 ? void 0 : ref3[0].id) !== null && _id !== void 0 ? _id : "photoreal_tti" : state.promptType,
        loadToolFilters: loadToolFilters,
        uploadedFile: state.blob,
        hasNotSelectedTool: state.tool === null,
        generateResult: generateResult,
        changePromptType: changePromptType,
        promptState: config,
        cameraStyle: state.cameraStyle,
        selectCameraStyle: selectCameraStyle,
        setCurrentPromptState: setCurrentPromptState,
        selectedModel: state.selectedModel,
        setUserPrompt: setUserPrompt,
        setSelectedModel: setSelectedModel,
        userPrompt: state.userPrompt,
        setFile: setFile,
        userCustomStyle: state.userCustomStyle,
        setUserCustomStyle: setUserCustomStyle,
        resetToolFilters: resetToolFilters,
        selectAspect: selectAspect,
        isKeepFaceNotAllowed: isKeepFaceNotAllowed.current,
        changeKeepFaceValue: changeKeepFaceValue,
        getPayloadFromTool: getPayloadFromTool
    };
}
function isImageFile(file) {
    return _isImageFile.apply(this, arguments);
}
function _isImageFile() {
    _isImageFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(file) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (!file.type.startsWith("image/")) {
                        resolve(false);
                        return;
                    }
                    var reader = new FileReader();
                    reader.onload = function() {
                        if (!reader.result) {
                            resolve(false);
                            return;
                        }
                        var blob = new Blob([
                            reader.result
                        ]);
                        createImageBitmap(blob).then(function(_ok) {
                            return resolve(true);
                        }, function(_err) {
                            return resolve(false);
                        });
                    };
                    reader.onerror = function() {
                        resolve(false);
                    };
                    reader.readAsArrayBuffer(file);
                })
            ];
        });
    });
    return _isImageFile.apply(this, arguments);
}
function isVideoFile(file) {
    return _isVideoFile.apply(this, arguments);
}
function _isVideoFile() {
    _isVideoFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(file) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (file.type === "video/mp4") {
                        file = (0,_utils_mime_types__WEBPACK_IMPORTED_MODULE_17__/* .changeMimeType */ .p)(file, "video/mp4");
                    }
                    if (!file.type.startsWith("video/")) {
                        resolve(false);
                        return;
                    }
                    var element = document.createElement("video");
                    element.preload = "metadata";
                    element.muted = true;
                    element.onloadedmetadata = function() {
                        return resolve(true);
                    };
                    element.onerror = function() {
                        resolve(false);
                    };
                    var url = URL.createObjectURL(file);
                    element.src = url;
                })
            ];
        });
    });
    return _isVideoFile.apply(this, arguments);
}
function isImageOrVideo(file) {
    return _isImageOrVideo.apply(this, arguments);
}
function _isImageOrVideo() {
    _isImageOrVideo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(file) {
        var isImage, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        isImageFile(file)
                    ];
                case 1:
                    isImage = _state.sent();
                    _tmp = isImage;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        isVideoFile(file)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return _isImageOrVideo.apply(this, arguments);
}
function calculateDimensions(resolutionWidth, aspectRatio) {
    var height = resolutionWidth / aspectRatio;
    return {
        width: resolutionWidth,
        height: Math.ceil(height)
    };
}
var MAX_FREE_MILLIS = 1000;
var COINS_PER_SECOND = 50;
function calculateDurationPrice(duration) {
    if (!duration) {
        return 0;
    }
    if (duration <= MAX_FREE_MILLIS) {
        return 0;
    }
    var additionalDuration = duration - MAX_FREE_MILLIS;
    return Math.floor(additionalDuration * COINS_PER_SECOND / 1000);
}
var actionMimes = {
    deform: [
        "images",
        "videos"
    ],
    restyle: [
        "videos"
    ],
    photo_ai: [
        "images"
    ]
};
function getAcceptedMimes() {
    var mimes = _to_consumable_array(actionMimes["photo_ai"]);
    var empty = [];
    var allMimes = mimes.reduce(function(all, single) {
        return _to_consumable_array(all).concat(_to_consumable_array(mimeTypes[single]));
    }, empty);
    return allMimes.join(", ");
}
function getStorage(tool) {
    switch(tool){
        case "ai_photo":
            return {
                tool: tool,
                storage: photoAiStorageSchema
            };
        case "ai_restyle":
            return {
                tool: tool,
                storage: restyleStorageSchema
            };
        case "deform":
            return {
                tool: tool,
                storage: deforumStorageSchema
            };
        case "text_to_image":
            return {
                tool: tool,
                storage: textToImageStorageSchema
            };
        case "ai_music_generator":
            return {
                tool: tool,
                storage: _comps_editors_ai_music_generator__WEBPACK_IMPORTED_MODULE_1__.AiMusicGeneratorStorageSchema
            };
        case "text_to_video":
            return {
                tool: tool,
                storage: textToVideoStorageSchema
            };
        default:
            return {
                tool: "deform",
                storage: deforumStorageSchema
            };
    }
}
var defaultChannelsList = {
    data: {
        available_bitrates: [
            {
                bitrate: 32
            },
            {
                bitrate: 96
            },
            {
                bitrate: 128
            },
            {
                bitrate: 192
            },
            {
                bitrate: 256
            },
            {
                bitrate: 320
            }, 
        ],
        available_intensities: [
            {
                intensity: "low"
            },
            {
                intensity: "medium"
            },
            {
                intensity: "high"
            }, 
        ],
        categories: [
            {
                category_id: 0,
                name: "Moods",
                groups: [
                    {
                        group_id: 0,
                        name: "Calm",
                        playlist: "0.0"
                    },
                    {
                        group_id: 1,
                        name: "Energizing",
                        playlist: "0.1"
                    },
                    {
                        group_id: 2,
                        name: "Joyful",
                        playlist: "0.2"
                    },
                    {
                        group_id: 3,
                        name: "Sad",
                        playlist: "0.3"
                    },
                    {
                        group_id: 4,
                        name: "Tense",
                        playlist: "0.4"
                    },
                    {
                        group_id: 5,
                        name: "Beautiful",
                        playlist: "0.5"
                    },
                    {
                        group_id: 6,
                        name: "Erotic",
                        playlist: "0.6"
                    },
                    {
                        group_id: 7,
                        name: "Dreamy",
                        playlist: "0.7"
                    },
                    {
                        group_id: 8,
                        name: "Heroic",
                        playlist: "0.8"
                    },
                    {
                        group_id: 10,
                        name: "Scary",
                        playlist: "0.10"
                    }, 
                ]
            },
            {
                category_id: 1,
                name: "Focus",
                groups: [
                    {
                        group_id: 0,
                        name: "Minimal",
                        playlist: "1.0"
                    }, 
                ]
            },
            {
                category_id: 2,
                name: "Sleep",
                groups: [
                    {
                        group_id: 0,
                        name: "Ambient",
                        playlist: "2.0"
                    },
                    {
                        group_id: 1,
                        name: "Classical",
                        playlist: "2.1"
                    },
                    {
                        group_id: 2,
                        name: "Lullaby",
                        playlist: "2.2"
                    },
                    {
                        group_id: 3,
                        name: "Noise",
                        playlist: "2.3"
                    },
                    {
                        group_id: 4,
                        name: "Sounds",
                        playlist: "2.4"
                    }, 
                ]
            },
            {
                category_id: 3,
                name: "Calm",
                groups: [
                    {
                        group_id: 0,
                        name: "Ambient",
                        playlist: "3.0"
                    },
                    {
                        group_id: 1,
                        name: "Chill",
                        playlist: "3.1"
                    }, 
                ]
            },
            {
                category_id: 4,
                name: "Chill",
                groups: [
                    {
                        group_id: 0,
                        name: "Chillout",
                        playlist: "4.0"
                    },
                    {
                        group_id: 1,
                        name: "Ethnic",
                        playlist: "4.1"
                    },
                    {
                        group_id: 2,
                        name: "Summer",
                        playlist: "4.2"
                    },
                    {
                        group_id: 3,
                        name: "Travel",
                        playlist: "4.3"
                    }, 
                ]
            },
            {
                category_id: 5,
                name: "Sport",
                groups: [
                    {
                        group_id: 0,
                        name: "Fitness",
                        playlist: "5.0"
                    },
                    {
                        group_id: 1,
                        name: "Cardio",
                        playlist: "5.1"
                    },
                    {
                        group_id: 2,
                        name: "Running",
                        playlist: "5.2"
                    },
                    {
                        group_id: 3,
                        name: "Yoga",
                        playlist: "5.3"
                    }, 
                ]
            },
            {
                category_id: 6,
                name: "Genres",
                groups: [
                    {
                        group_id: 0,
                        name: "EDM",
                        playlist: "6.0"
                    },
                    {
                        group_id: 1,
                        name: "House",
                        playlist: "6.1"
                    },
                    {
                        group_id: 2,
                        name: "Techno",
                        playlist: "6.2"
                    },
                    {
                        group_id: 3,
                        name: "Chill",
                        playlist: "6.3"
                    },
                    {
                        group_id: 4,
                        name: "Hiphop",
                        playlist: "6.4"
                    },
                    {
                        group_id: 5,
                        name: "Ambient",
                        playlist: "6.5"
                    },
                    {
                        group_id: 6,
                        name: "Electronica",
                        playlist: "6.6"
                    },
                    {
                        group_id: 7,
                        name: "Trance",
                        playlist: "6.7"
                    },
                    {
                        group_id: 8,
                        name: "Drumnbass",
                        playlist: "6.8"
                    },
                    {
                        group_id: 9,
                        name: "Dub",
                        playlist: "6.9"
                    },
                    {
                        group_id: 10,
                        name: "Bass",
                        playlist: "6.10"
                    },
                    {
                        group_id: 11,
                        name: "Breakbeat",
                        playlist: "6.11"
                    },
                    {
                        group_id: 12,
                        name: "Jazz & Funk",
                        playlist: "6.12"
                    },
                    {
                        group_id: 13,
                        name: "Disco",
                        playlist: "6.13"
                    },
                    {
                        group_id: 15,
                        name: "Pop",
                        playlist: "6.15"
                    },
                    {
                        group_id: 16,
                        name: "Rock & Metal",
                        playlist: "6.16"
                    },
                    {
                        group_id: 17,
                        name: "Classical",
                        playlist: "6.17"
                    },
                    {
                        group_id: 18,
                        name: "Folk",
                        playlist: "6.18"
                    }, 
                ]
            },
            {
                category_id: 10,
                name: "Countries",
                groups: [
                    {
                        group_id: 0,
                        name: "India",
                        playlist: "10.0"
                    }, 
                ]
            }, 
        ]
    }
};
var aspects = [
    {
        width: 27,
        height: 27,
        aspectWidth: 1,
        aspectHeight: 1,
        name: "Square"
    },
    {
        width: 24,
        height: 38,
        aspectWidth: 9,
        aspectHeight: 16,
        name: "Portrait"
    },
    {
        width: 37,
        height: 24,
        aspectWidth: 16,
        aspectHeight: 9,
        name: "Landscape"
    },
    {
        width: 23,
        height: 29,
        aspectWidth: 3,
        aspectHeight: 4
    },
    {
        width: 29,
        height: 22,
        aspectWidth: 4,
        aspectHeight: 3
    },
    {
        width: 24,
        height: 26,
        aspectWidth: 4,
        aspectHeight: 5
    },
    {
        width: 26,
        height: 24,
        aspectWidth: 5,
        aspectHeight: 4
    }, 
];


/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(8875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(8748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 8418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(5753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _router = __webpack_require__(6273);
var _addLocale = __webpack_require__(2725);
var _routerContext = __webpack_require__(3462);
var _appRouterContext = __webpack_require__(1018);
var _useIntersection = __webpack_require__(7190);
var _getDomainLocale = __webpack_require__(1210);
var _addBasePath = __webpack_require__(8684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 8875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(4317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( true ? __webpack_require__(7294) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "queryClient": function() { return /* binding */ queryClient; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/cookies.tsx
var cookies = __webpack_require__(1579);
// EXTERNAL MODULE: ./comps/favicon.tsx
var favicon = __webpack_require__(7953);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(906);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-microsoft-clarity/index.js
var react_microsoft_clarity = __webpack_require__(5399);
;// CONCATENATED MODULE: ./utils/clarity.ts


var useClarity = function(userId) {
    (0,react.useEffect)(function() {
        try {
            var _NEXT_PUBLIC_CLARITY_KEY;
            react_microsoft_clarity.clarity.init((_NEXT_PUBLIC_CLARITY_KEY = "fv5tingd14") !== null && _NEXT_PUBLIC_CLARITY_KEY !== void 0 ? _NEXT_PUBLIC_CLARITY_KEY : "");
            if (userId) {
                react_microsoft_clarity.clarity.identify(userId, {});
            }
        } catch (e) {
            console.error("Clarity counld not be loaded", e);
        }
    }, [
        userId
    ]);
};
/* harmony default export */ var clarity = (useClarity);

// EXTERNAL MODULE: ./utils/coins.tsx
var coins = __webpack_require__(279);
// EXTERNAL MODULE: ./utils/googleapi.tsx
var googleapi = __webpack_require__(9872);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
;// CONCATENATED MODULE: ./utils/unflash.tsx

var useUnflash = function() {
    (0,react.useEffect)(function() {
        document.documentElement.style.visibility = "visible";
    }, []);
    (0,react.useEffect)(function() {
        var handleResize = function handleResize() {
            try {
                var ref;
                var outer = document.createElement("div");
                outer.style.visibility = "hidden";
                outer.style.overflow = "scroll";
                document.body.appendChild(outer);
                var inner = document.createElement("div");
                outer.appendChild(inner);
                var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
                (ref = outer.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(outer);
                document.documentElement.style.setProperty("--scrollbar-width", "".concat(scrollbarWidth, "px"));
            } catch (e) {
                console.error(e);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
};
/* harmony default export */ var unflash = (useUnflash);

// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/intl-pluralrules/polyfill.js
var polyfill = __webpack_require__(3033);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(2010);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./sections/editor/editor.tsx
var editor = __webpack_require__(5091);
;// CONCATENATED MODULE: ./pages/_app.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	.grecaptcha-badge {\n		display: none;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var queryClient = new es.QueryClient();
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject());
var MyApp = function(props) {
    var Component = props.Component, pageProps = props.pageProps;
    unflash();
    var theme = Component.theme, Layout = Component.Layout;
    var userInfo = pageProps.userInfo;
    clarity(userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId);
    var Providers = Layout !== null && Layout !== void 0 ? Layout : AppProviders;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Providers, {
        theme: theme,
        userInfo: userInfo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
    });
};
function AppProviders(props) {
    var children = props.children, theme = props.theme, userInfo = props.userInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* ThemeProvider */.f, {
        attribute: "class",
        forcedTheme: theme,
        defaultTheme: "system",
        enableSystem: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
                client: queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_auth/* SSRAuthProvider */.oO, {
                    userInfo: userInfo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notification/* NotificationProvider */.J, {
                        timeout: 3000,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                            scriptProps: {
                                async: true
                            },
                            reCaptchaKey: "6LelseIjAAAAAEmIkD3assuAQxcbF9vd0zbE-jMG",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(coins/* CoinsProvider */._k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(adjust/* AdjustProvider */.xF, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(favicon/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cookies/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(editor/* EditorParamsProviders */.i9, {
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adjust/* UsePageViewEvent */.rs, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(googleapi/* GoogleOneTap */.K, {})
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp));


/***/ }),

/***/ 8605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "adExampleEntrySchema": function() { return /* binding */ adExampleEntrySchema; },
/* harmony export */   "default": function() { return /* binding */ Templates; },
/* harmony export */   "homeResponseSchema": function() { return /* binding */ homeResponseSchema; },
/* harmony export */   "indexFiltersAdExamples": function() { return /* binding */ indexFiltersAdExamples; },
/* harmony export */   "searchResponseSchema": function() { return /* binding */ searchResponseSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6106);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1604);





var __N_SSP = true;
var adExampleEntrySchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    id: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    title: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    description: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    script: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullable(),
    aspect: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
    share_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullable(),
    preview_thumbnail_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    preview_video_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    created_at: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    owner: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        username: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
        profile_pic: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
            original: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullish()
        }).nullish(),
        followers: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
        uid: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
        follow_status: zod__WEBPACK_IMPORTED_MODULE_2__.z.number().optional()
    }).nullable()
});
var homeResponseSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    sections: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        title: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
        query: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
        results: adExampleEntrySchema.array()
    }).array()
});
var searchResponseSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    results: adExampleEntrySchema.array(),
    total: zod__WEBPACK_IMPORTED_MODULE_2__.z.number().nullable().default(null)
});
var indexFiltersWithoutApplied = {
    searchQuery: null,
    aspect: null
};
var indexFiltersAdExamples = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, indexFiltersWithoutApplied), {
    applyFilters: indexFiltersWithoutApplied
});
function Templates(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        galleryJobs: null,
        templatesJobs: null,
        adExamplesJobs: props.jobs,
        initialFiltersTemplates: null,
        initialFiltersGallery: null,
        availableFiltersTemplates: props.availableFiltersTemplates,
        availableFiltersGallery: props.availableFiltersGallery,
        initialFiltersAdExamples: props.initial,
        pageTitle: props.pageTitle,
        metaLinks: props.metaLinks,
        pageNumber: props.pageNumber,
        initialPage: "ad-examples"
    });
}


/***/ }),

/***/ 2142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ AllGallery; },
/* harmony export */   "galleryProducts": function() { return /* binding */ galleryProducts; },
/* harmony export */   "indexFiltersGallery": function() { return /* binding */ indexFiltersGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_header_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1817);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6106);



var __N_SSP = true;
var indexFiltersGallery = {
    ownedBy: null,
    searchQuery: null,
    selectedCategories: [],
    selectedStyles: [],
    mediaType: "all",
    includeCustoms: false,
    sortBy: "best",
    selectedTools: [],
    applyFilters: null
};
var galleryProducts = [
    {
        tool: "ai_restyle",
        label: "txt_restyle_ai",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .restlyeIcon */ .ZX)()
    },
    {
        tool: "deform",
        label: "txt_deforum_ai",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .deforumIcon */ .uv)()
    },
    {
        tool: "ai_photo",
        label: "txt_photo_ai",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .photoAiIcon */ .x$)()
    },
    {
        tool: "text_to_image",
        label: "txt_text_to_image",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .textToImageIcon */ .f7)()
    },
    {
        tool: "text_to_video",
        label: "txt_text_to_video",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .textToVideoIcon */ .Cz)()
    },
    {
        tool: "ai_suggest",
        label: "txt_ai_photoshoot",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .aiPhotoshootIcon */ .Bw)()
    },
    {
        tool: "ai_look",
        label: "txt_look_ai",
        icon: (0,_comps_header_icon__WEBPACK_IMPORTED_MODULE_1__/* .lookAiIcon */ .YH)()
    }, 
];
function AllGallery(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        galleryJobs: props.jobs,
        templatesJobs: null,
        adExamplesJobs: null,
        initialFiltersGallery: props.initial,
        initialFiltersTemplates: null,
        availableFiltersGallery: props.availableFiltersGallery,
        availableFiltersTemplates: props.availableFiltersTemplates,
        pageTitle: props.page,
        initialFiltersAdExamples: null,
        metaLinks: props.metaLinks,
        pageNumber: props.pageNumber,
        initialPage: "ai-gallery"
    });
}


/***/ }),

/***/ 3826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SingleGeneratedPage; },
/* harmony export */   "getFirstFiveWords": function() { return /* binding */ getFirstFiveWords; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sections_gallery_single_gallery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6622);


var __N_SSP = true;
function SingleGeneratedPage(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_single_gallery__WEBPACK_IMPORTED_MODULE_1__/* .GallerySingle */ .uF, {
        job: props.job
    });
}
function getFirstFiveWords(inputString) {
    var words = inputString.split(/\s+/);
    if (words && words.length >= 5) {
        var firstFiveWords = words.slice(0, 5).join(" ");
        return firstFiveWords;
    } else {
        return inputString;
    }
}


/***/ }),

/***/ 2259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ TrainModelCreate; },
  "getRandomID": function() { return /* binding */ getRandomID; },
  "trainModelDraftSchema": function() { return /* binding */ trainModelDraftSchema; },
  "useWindowSize": function() { return /* binding */ useWindowSize; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/border-input.tsx
var border_input = __webpack_require__(3607);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/coins.tsx
var utils_coins = __webpack_require__(279);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9204);
;// CONCATENATED MODULE: ./utils/error-extractor.ts


function errorExtractor(error) {
    if ((0,_instanceof/* default */.Z)(error, axios/* AxiosError */.d7)) {
        var ref;
        var data = (ref = error.response) === null || ref === void 0 ? void 0 : ref.data;
        switch(data.code){
            case "custom":
                return {
                    type: "special",
                    message: data.message,
                    explanation: data.explanation
                };
            default:
                return {
                    type: "common",
                    message: data.message
                };
        }
    }
    return {
        type: "common",
        message: "Something went wrong"
    };
}

// EXTERNAL MODULE: ./utils/indexed.tsx
var indexed = __webpack_require__(788);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var lib_axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/jszip/dist/jszip.min.js
var jszip_min = __webpack_require__(5733);
var jszip_min_default = /*#__PURE__*/__webpack_require__.n(jszip_min);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./sections/train-model/model-mobile-card.tsx
var model_mobile_card = __webpack_require__(4418);
// EXTERNAL MODULE: ./comps/simple-drop-area.tsx
var simple_drop_area = __webpack_require__(356);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(2010);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var dist_es = __webpack_require__(2512);
;// CONCATENATED MODULE: ./sections/train-model/render-model-content.tsx










function RenderModelContent(props) {
    var title = props.title, subtitle = props.subtitle, minCount = props.minCount, maxCount = props.maxCount, iframeUrl = props.iframeUrl, onDrop = props.onDrop, haveFiles = props.haveFiles, uploadedFiles = props.uploadedFiles, directoryName = props.directoryName, removeFile = props.removeFile;
    var t = (0,esm/* useTranslation */.$G)().t;
    var iframeRef = (0,react.useRef)(null);
    var selectedTheme = (0,index_module/* useTheme */.F)();
    var dropzoneState = (0,dist_es/* useDropzone */.uI)({
        accept: (0,simple_drop_area/* getFormatsFromMimeTypes */.lz)((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.images */.aN.images)),
        onDrop: onDrop,
        maxFiles: 100,
        multiple: true,
        maxSize: 10000000,
        noClick: false
    });
    var _theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[14px] pt-[34px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-[557px] flex-col gap-[10px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-[6px]",
                                children: [
                                    uploadedFiles.length >= minCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/check-success.svg"),
                                        alt: "check icon green"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/check.svg"),
                                        alt: "check icon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[18px] font-600 text-blue-800",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)(iframeUrl === null ? "pointer-events-none opacity-40" : "group peer relative"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/general/info.svg"),
                                                alt: "info icon",
                                                className: (0,clsx_m/* default */.Z)(iframeUrl ? "cursor-pointer" : "pointer-events-none cursor-default")
                                            }),
                                            iframeUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("absolute z-50 hidden", "-top-[200px] left-[30px] -ml-[30px] pl-[30px] group-hover:flex"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                    src: iframeUrl + "?platform=ios&theme=".concat((_theme = selectedTheme.theme) !== null && _theme !== void 0 ? _theme : "light"),
                                                    ref: iframeRef,
                                                    className: "z-50 h-[468px] w-[470px] rounded-[8px]"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fixed inset-0 z-30 hidden h-full w-full animate-appear bg-color-popup peer-hover:block"
                                    })
                                ]
                            }),
                            minCount === maxCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[15px] font-500 leading-[16px] tracking-[0.3px] text-blue-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: uploadedFiles.length
                                    }),
                                    " / ",
                                    minCount,
                                    " ",
                                    t("txt_photos")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-[15px] font-500 leading-[16px] tracking-[0.3px] text-blue-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: uploadedFiles.length
                                    }),
                                    " / ",
                                    maxCount,
                                    " ",
                                    t("txt_photos")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "w-[320px] text-[14px] font-400 leading-[18px] tracking-[0.28px] text-color-placeholder",
                        children: subtitle
                    })
                ]
            }),
            haveFiles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-[545px] animate-scale flex-wrap gap-[11px]",
                children: [
                    uploadedFiles.map(function(file) {
                        if (file.directory === directoryName) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("group relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: file.url,
                                        alt: "user uploaded file",
                                        className: "h-[128px] w-[128px] overflow-hidden rounded-[8px] object-cover"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return removeFile(file);
                                        },
                                        className: (0,clsx_m/* default */.Z)("absolute -right-[6px] -top-[6px] h-[28px] w-[28px] rounded-full bg-color-cell hover:bg-blue-300", "cursor-pointer items-center justify-center border border-color-background", "hidden group-hover:flex"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                            source: "/general/minus-gray",
                                            format: "svg",
                                            alt: "minus icon"
                                        })
                                    })
                                ]
                            }, file.url);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                        state: dropzoneState,
                        openExplorer: dropzoneState.open,
                        formats: [
                            "image/jpeg",
                            "image/png"
                        ],
                        border: true,
                        className: (0,clsx_m/* default */.Z)(uploadedFiles.length >= maxCount && "hidden", "h-[128px] w-[128px] rounded-[8px]"),
                        noText: true,
                        backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%236498EEFF' stroke-width='5' stroke-dasharray='6%2c 14' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e\")"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                state: dropzoneState,
                openExplorer: dropzoneState.open,
                formats: [
                    "image/jpeg",
                    "image/png"
                ],
                border: true,
                className: "h-[148px] w-[557px] animate-fadeInUp rounded-[14px]",
                backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%236498EE80' stroke-width='5' stroke-dasharray='6%2c 14' stroke-dashoffset='8' stroke-linecap='round'/%3e%3c/svg%3e\")"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./sections/train-model/render-models.tsx



function RenderModels(props) {
    var models = props.models, selectedModel = props.selectedModel, setSelectedModel = props.setSelectedModel;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-[14px] pt-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[15px] font-600 leading-[22px] tracking-[0.3px] text-blue-700",
                children: t("txt_model_type")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-[14px]",
                children: models.map(function(model) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (0,clsx_m/* default */.Z)(selectedModel === model.id && "border-2 border-primary-500", "relative overflow-hidden rounded-[8px] border-2 border-color-background"),
                        onClick: function() {
                            return setSelectedModel(model.id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: model.thumb_url,
                                alt: "model image",
                                className: " h-[152px] w-[138px] object-cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-0 h-[27px] w-full bg-color-black/20 [backdrop-filter:blur(8px)]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[13px] font-600 text-color-white",
                                    children: model.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-[6px] top-[6px] overflow-hidden rounded-full pb-[1.5px] pr-[1px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(selectedModel === model.id ? "flex items-center justify-center border-2 border-primary-500" : " border-2 border-[#E8E6F0] shadow-color-black/20 drop-shadow-md", "h-[20px] w-[20px] rounded-full transition-colors", "bg-color-white "),
                                    children: selectedModel === model.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-[10px] w-[10px] rounded-full bg-primary-500 transition-colors"
                                    })
                                })
                            })
                        ]
                    }, model.id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./pages/models/create.tsx
/* provided dependency */ var process = __webpack_require__(3454);





























var __N_SSP = true;
var useWindowSize = function() {
    var ref = (0,react.useState)(), isDesktop = ref[0], setIsDesktop = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            var width = window.innerWidth;
            if (width > 1223) {
                setIsDesktop("desktop");
            } else if (width < 1223 && width > 768) {
                setIsDesktop("tablet");
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return isDesktop;
};
function handleLeave(event) {
    event.preventDefault();
    event.returnValue = " ";
}
var trainModelDraftSchema = lib.z.object({
    id: lib.z.string(),
    modelName: lib.z.string(),
    date: lib.z.string(),
    modelType: lib.z["enum"]([
        "model_male",
        "model_female",
        "model_perfume",
        "model_shoes",
        "model_sunglasses", 
    ]),
    uploadedFiles: lib.z.object({
        directory: lib.z.string(),
        file: lib.z["instanceof"](File)
    }).array()
});
function getModelPrice() {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        lib_axios/* default.get */.Z.get("/api/training-usage-info").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function TrainModelCreate(props) {
    var result = props.result, draftId = props.draftId;
    var ref = (0,react.useState)(null), draft = ref[0], setDraft = ref[1];
    var db = (0,indexed/* useIndexedDB */.i)("ai_art", "model_drafts", trainModelDraftSchema);
    (0,react.useEffect)(function() {
        if (db.status !== "ready") {
            return;
        }
        if (draftId === null) {
            return;
        }
        db.getData(draftId).then(function(result) {
            if (result === null) {
                console.error("Draft not found");
            }
            setDraft(result);
        });
    }, [
        db,
        draftId
    ]);
    if (draftId === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainModelEdit, {
            result: result,
            draft: null
        });
    }
    if (draft === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainModelEdit, {
        result: result,
        draft: draft
    });
}
function TrainModelEdit(props) {
    var appendFileCreator = function appendFileCreator(directory, maxCount) {
        return function(files) {
            if (process.env.NEXT_PUBLIC_DEBUG !== "true") {
                window.addEventListener("beforeunload", handleLeave);
            }
            var uploadedForDirLength = uploadedFiles.filter(function(file) {
                return file.directory === directory;
            }).length;
            var newFiles = [];
            if (files.length > maxCount - uploadedForDirLength) {
                for(var i = 0; i < maxCount - uploadedForDirLength; i++){
                    newFiles[i] = files[files.length - 1 - i];
                }
            } else {
                newFiles = files;
            }
            setUploadedFiles(function(oldFiles) {
                return (0,_to_consumable_array/* default */.Z)(oldFiles).concat((0,_to_consumable_array/* default */.Z)(newFiles.map(function(file) {
                    return {
                        file: file,
                        directory: directory,
                        url: URL.createObjectURL(file)
                    };
                })));
            });
        };
    };
    var addFilesToZip = function addFilesToZip() {
        var zip = new (jszip_min_default())();
        var initialFolders = {};
        uploadedFiles.filter(function(file) {
            return modelContent.upload.sections.find(function(section) {
                return section.dir_name === file.directory;
            });
        }).reduce(function(acc, uploaded) {
            var folder = acc[uploaded.directory];
            if (!folder) {
                var ref;
                folder = (ref = zip.folder(uploaded.directory)) !== null && ref !== void 0 ? ref : undefined;
                acc[uploaded.directory] = folder;
            }
            folder === null || folder === void 0 ? void 0 : folder.file(Math.random() + uploaded.file.name, uploaded.file);
            return acc;
        }, initialFolders);
        return zip;
    };
    var removeFile = function removeFile(removedFile) {
        var newList = uploadedFiles.filter(function(param) {
            var url = param.url;
            return url !== removedFile.url;
        });
        setUploadedFiles(newList);
    };
    var ref, ref1, ref2;
    var result = props.result;
    var draft = (0,react.useMemo)(function() {
        if (props.draft === null) {
            return null;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.draft), {
            uploadedFiles: props.draft.uploadedFiles.map(function(uploaded) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, uploaded), {
                    url: URL.createObjectURL(uploaded.file)
                });
            })
        });
    }, [
        props.draft
    ]);
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref3;
    var ref4 = (0,react.useState)((ref3 = draft === null || draft === void 0 ? void 0 : draft.modelName) !== null && ref3 !== void 0 ? ref3 : ""), modelName = ref4[0], setModelName = ref4[1];
    var ref5;
    var ref6 = (0,react.useState)((ref5 = draft === null || draft === void 0 ? void 0 : draft.modelType) !== null && ref5 !== void 0 ? ref5 : "model_male"), selectedModel = ref6[0], setSelectedModel = ref6[1];
    var ref7 = (0,react.useState)(result[0].instructions), modelContent = ref7[0], setModelContent = ref7[1];
    var ref8;
    var ref9 = (0,react.useState)((ref8 = draft === null || draft === void 0 ? void 0 : draft.uploadedFiles) !== null && ref8 !== void 0 ? ref8 : []), uploadedFiles = ref9[0], setUploadedFiles = ref9[1];
    var ref10 = (0,react.useState)({
        type: "idle"
    }), submitStatus = ref10[0], setSubmitStatus = ref10[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var index = result.findIndex(function(model) {
            return model.id === selectedModel;
        });
        setModelContent(result[index].instructions);
    }, [
        result,
        selectedModel
    ]);
    var query = (0,es.useQuery)({
        queryKey: [
            "model-price"
        ],
        queryFn: getModelPrice()
    });
    var canUseQuery = (0,es.useQuery)({
        queryKey: [
            "can-use",
            modelName
        ],
        queryFn: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var signal;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                lib_axios/* default.post */.Z.post("/api/training-check-name", {
                                    name: modelName
                                }, {
                                    signal: signal
                                }).then(function(res) {
                                    return res.data;
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var canUse = ((ref = canUseQuery.data) === null || ref === void 0 ? void 0 : ref.can_use) !== false;
    function getThumbnailUrl(file) {
        return _getThumbnailUrl.apply(this, arguments);
    }
    function _getThumbnailUrl() {
        _getThumbnailUrl = (0,_async_to_generator/* default */.Z)(function(file) {
            var ref, uploadUrl, objectUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            lib_axios/* default.get */.Z.get("/api/training-upload-object?contentType=".concat(file.type)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        ref = _state.sent(), uploadUrl = ref.uploadUrl, objectUrl = ref.objectUrl;
                        return [
                            4,
                            lib_axios/* default.put */.Z.put(uploadUrl, file)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            objectUrl
                        ];
                }
            });
        });
        return _getThumbnailUrl.apply(this, arguments);
    }
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var openCoinsPopup = (0,utils_coins/* useCoinsPopup */.$c)();
    var coins = (0,utils_coins/* useCoins */.YO)();
    function handleZipCreation() {
        return _handleZipCreation.apply(this, arguments);
    }
    function _handleZipCreation() {
        _handleZipCreation = (0,_async_to_generator/* default */.Z)(function() {
            var ref, thumbnailUrl, zip, ref1, zipFile, ref2, uploadUrl, objectUrl, payload, _tmp, notifySuccess, error, ref3, ref4, userCoins, ref5, price, neededCoins;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!uploadedFiles) {
                            return [
                                2
                            ];
                        }
                        thumbnailUrl = getThumbnailUrl(uploadedFiles[0].file);
                        zip = addFilesToZip();
                        setSubmitStatus({
                            type: "zipping"
                        });
                        return [
                            4,
                            Promise.all([
                                zip.generateAsync({
                                    type: "blob"
                                }),
                                lib_axios/* default.get */.Z.get("/api/training-upload-object?contentType=application/zip").then(function(res) {
                                    return res.data;
                                })
                            ])
                        ];
                    case 1:
                        ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), zipFile = ref1[0], ref2 = ref1[1], uploadUrl = ref2.uploadUrl, objectUrl = ref2.objectUrl;
                        setSubmitStatus({
                            type: "uploading",
                            progress: 0
                        });
                        return [
                            4,
                            lib_axios/* default.put */.Z.put(uploadUrl, zipFile, {
                                onUploadProgress: function(param) {
                                    var progress = param.progress;
                                    return setSubmitStatus({
                                        type: "uploading",
                                        progress: progress !== null && progress !== void 0 ? progress : 0
                                    });
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        _tmp = {
                            zip_url: objectUrl,
                            name: modelName
                        };
                        return [
                            4,
                            thumbnailUrl
                        ];
                    case 3:
                        payload = (_tmp.thumb_url = _state.sent(), _tmp.model_type = selectedModel, _tmp.should_buy = Boolean((ref = query.data) === null || ref === void 0 ? void 0 : ref.price), _tmp);
                        notifySuccess = function() {
                            if (result.findIndex(function(model) {
                                return model.id === selectedModel;
                            })) {
                                db.status === "ready" && db.clearData(selectedModel);
                            }
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                                children: t("fs_successfully_submited", {
                                    model: modelName
                                })
                            }));
                        };
                        return [
                            4,
                            lib_axios/* default.post */.Z.post("/api/training-submit", payload).then(notifySuccess).catch(errorExtractor)
                        ];
                    case 4:
                        error = _state.sent();
                        if (!!error) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            router.push("/models?page=training")
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (error.type === "special" && error.explanation === "insufficient_funds") {
                            ;
                            userCoins = coins ? coins.coins : 0;
                            ;
                            price = (ref5 = (ref3 = query.data) === null || ref3 === void 0 ? void 0 : ref3.price) !== null && ref5 !== void 0 ? ref5 : 0;
                            ;
                            if (((ref4 = query.data) === null || ref4 === void 0 ? void 0 : ref4.price) !== undefined) {
                                neededCoins = price - userCoins;
                            }
                            openCoinsPopup(neededCoins);
                            return [
                                2
                            ];
                        }
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: error.message
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleZipCreation.apply(this, arguments);
    }
    var db = (0,indexed/* useIndexedDB */.i)("ai_art", "model_drafts", trainModelDraftSchema);
    var enableButton = hasRequiredData(uploadedFiles, modelContent.upload.sections) && query.data !== undefined && modelName !== "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("txt_model_title"),
                description: t("txt_home_description"),
                cover: (0,cdn/* assetUrl */.p)("/covers/model.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("hidden flex-col items-start pl-[300px] pt-[44px] desktop:flex", "pb-[66px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[20px] font-700 tracking-[0.4px] text-blue-800",
                        children: t("lbl_train_model")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[11px] pt-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "model-name",
                                className: "text-[15px] font-600 leading-[22px] tracking-[0.3px] text-blue-700",
                                children: t("txt_model_name")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(border_input/* BorderInput */.Dp, {
                                hasErrors: !canUse,
                                id: "model-name",
                                value: modelName,
                                onChange: function(e) {
                                    var name = e.currentTarget.value;
                                    setModelName(name);
                                },
                                className: "w-[300px]",
                                placeholder: t("txt_enter_model_name")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderModels, {
                        models: result,
                        selectedModel: selectedModel,
                        setSelectedModel: setSelectedModel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-[24px]",
                        children: modelContent.upload.sections.map(function(section, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderModelContent, {
                                onDrop: appendFileCreator(section.dir_name, section.max_media),
                                title: section.title,
                                haveFiles: uploadedFiles.length !== 0 && include(uploadedFiles, section.dir_name),
                                subtitle: section.subtitle,
                                maxCount: section.max_media,
                                minCount: section.min_media,
                                iframeUrl: section.tip_url,
                                uploadedFiles: uploadedFiles.filter(function(file) {
                                    return file.directory === section.dir_name;
                                }),
                                directoryName: section.dir_name,
                                removeFile: removeFile
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-[557px] gap-[12px] pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                disabled: db.status !== "ready" || uploadedFiles.length === 0,
                                onClick: function() {
                                    router.push("/models?page=drafts");
                                    if (db.status !== "ready") {
                                        console.error("Cannot save");
                                        return;
                                    }
                                    var indexedId = getRandomID();
                                    if (draft !== null) {
                                        indexedId = draft.id;
                                    }
                                    db.setData({
                                        id: indexedId,
                                        modelName: modelName,
                                        uploadedFiles: uploadedFiles,
                                        modelType: selectedModel,
                                        date: String(new Date())
                                    });
                                },
                                className: (0,clsx_m/* default */.Z)("rounded-[10px] bg-blue-200 py-[12px] text-blue-800", "w-[141px] text-[16px] font-600 leading-[20px] disabled:text-blue-400"),
                                children: t("txt_draft")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    handleZipCreation()
                                                ];
                                            case 1:
                                                _state.sent();
                                                setSubmitStatus((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, submitStatus), {
                                                    type: "idle"
                                                }));
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                disabled: !enableButton,
                                className: (0,clsx_m/* default */.Z)("rounded-[10px] disabled:bg-blue-200 disabled:text-blue-400", "flex-1 bg-primary-500 text-[16px] font-600 leading-[20px] transition-all", "text-color-white transition-colors duration-300 hover:bg-primary-600", "flex items-center justify-center gap-[8px]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("txt_submit")
                                    }),
                                    enableButton && ((ref1 = query.data) === null || ref1 === void 0 ? void 0 : ref1.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[2px] rounded-[48px] bg-color-black/20 px-[7px] py-[5px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "min-w-[30px] text-[13px] font-600 text-color-white",
                                                children: (ref2 = query.data) === null || ref2 === void 0 ? void 0 : ref2.price
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/general/coin.svg"),
                                                alt: "coin icon"
                                            })
                                        ]
                                    }),
                                    submitStatus.type !== "idle" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "animate-spin",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                            format: "webp",
                                            source: "/general/loading",
                                            className: "h-[18px] w-[18px]"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(model_mobile_card/* default */.Z, {})
        ]
    });
}
function include(files, dirName) {
    for(var i = 0; i < files.length; i++){
        if (files[i].directory === dirName) {
            return true;
        }
    }
    return false;
}
function hasRequiredData(uploadedFiles, requiredData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var data = _step.value;
            var uploadedFolder = uploadedFiles.filter(function(folder) {
                return folder.directory === data.dir_name;
            });
            if (uploadedFolder.length < data.min_media) {
                return {
                    v: false
                };
            }
        };
        for(var _iterator = requiredData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function getRandomID() {
    var first = Math.floor(Math.random() * 10000);
    var second = Math.floor(Math.random() * 10000);
    return "".concat(first, "-").concat(second);
}


/***/ }),

/***/ 1087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DeletePopup": function() { return /* binding */ DeletePopup; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "backgroundGradient": function() { return /* binding */ backgroundGradient; },
  "default": function() { return /* binding */ TrainModel; },
  "getModelType": function() { return /* binding */ getModelType; },
  "getMonthDayFromDate": function() { return /* binding */ getMonthDayFromDate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/indexed.tsx
var indexed = __webpack_require__(788);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
;// CONCATENATED MODULE: ./sections/train-model/filter-content.tsx









function FilterContent(props) {
    var state = props.state, jobs = props.jobs, drafts = props.drafts, trainings = props.trainings, deleteDraft = props.deleteDraft, setSelectPopupState = props.setSelectPopupState;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    switch(state){
        case "models":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-5 gap-[16px] pb-[100px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (0,clsx_m/* default */.Z)("flex w-[200px] animate-scale flex-col rounded-[10px] bg-color-cell"),
                        onClick: function() {
                            return router.push("/models/create");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[200px] w-full rounded-t-[10px] p-[16px] hover:bg-blue-200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex h-[168px] w-[168px] items-center justify-center rounded-[9px]",
                                    style: {
                                        backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='%23C6C9DCFF' stroke-width='4' stroke-dasharray='6%2c10' stroke-dashoffset='20' stroke-linecap='round'/%3e%3c/svg%3e\")"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                        source: "/general/plus-gray",
                                        format: "svg"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-[64px] w-full items-center justify-center gap-[10px] border-t border-color-separator",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/model-plus.svg"),
                                        alt: "model icon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[16px] font-600 text-blue-800",
                                        children: t("txt_add_new")
                                    })
                                ]
                            })
                        ]
                    }),
                    jobs.map(function(job) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelCard, {
                            samples: job.samples,
                            setSelectPopupState: setSelectPopupState,
                            modelType: job.model_type,
                            image: job.thumb_url,
                            name: job.name,
                            date: job.created_at,
                            status: job.status,
                            id: job.id,
                            functionAfterDelete: function() {
                                return queryClient.invalidateQueries("all-models");
                            }
                        }, job.id);
                    })
                ]
            });
        case "drafts":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid w-[1063px] grid-cols-4 gap-[13px]",
                children: drafts === null || drafts.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-[1063px] flex-col items-center justify-center gap-[13px] pt-[100px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/empty-model.svg"),
                            alt: "ilustration for empty draft state"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[16px] font-400 text-color-placeholder",
                            children: t("txt_empty_prompt_draft")
                        })
                    ]
                }) : drafts.map(function(draft) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftCard, {
                        id: draft.id,
                        date: draft.date,
                        modelName: draft.modelName,
                        modelType: draft.modelType,
                        image: draft.uploadedFiles[0].file,
                        functionAfterDelete: function() {
                            return;
                        },
                        deleteDraft: deleteDraft
                    }, draft.id);
                })
            });
        case "training":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid w-[1063px] grid-cols-4 gap-[13px]",
                children: trainings === null || trainings.models.filter(function(m) {
                    return m.status !== "failed";
                }).length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-[1063px] flex-col items-center justify-center gap-[13px] pt-[100px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/empty-model.svg"),
                            alt: "ilustration for empty draft state"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[16px] font-400 text-color-placeholder",
                            children: t("txt_empty_prompt_training")
                        })
                    ]
                }) : trainings.models.map(function(model) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainingCard, {
                        status: model.status,
                        image: model.thumb_url,
                        modelName: model.name
                    }, model.id);
                })
            });
    }
}
function ModelCard(props) {
    var image = props.image, name = props.name, date = props.date, modelType = props.modelType, id = props.id, functionAfterDelete = props.functionAfterDelete, setSelectPopupState = props.setSelectPopupState, samples = props.samples;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), deletePopup = ref[0], setDeletePopup = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("group relative"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (0,clsx_m/* default */.Z)("flex w-[200px] animate-scale flex-col rounded-[10px] bg-color-cell"),
                        onClick: function() {
                            if (!samples) {
                                router.push("/models/single?id=".concat(id));
                            } else {
                                setSelectPopupState({
                                    samples: samples,
                                    id: id
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[200px] w-full overflow-hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: "model single image",
                                    className: "rounded-t-[10px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-[64px] w-full flex-col pl-[10px] pt-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/general/model-icon.svg"),
                                                alt: "model icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "truncate text-[16px] font-600 text-blue-800",
                                                children: name
                                            }),
                                            samples && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[6px] w-[6px] rounded-full bg-primary-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[8px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[14px] font-400 text-color-placeholder",
                                                children: modelType
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[5px] w-[5px] rounded-full bg-color-placeholder"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[14px] font-400 text-color-placeholder",
                                                children: getMonthDayFromDate(date)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "peer absolute right-2 top-2 hidden group-hover:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[10px] flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-[4px] bg-color-black/20 hover:bg-color-black/50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/ai-tools/history/more.svg"),
                                alt: "more icon"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute z-50 hidden w-[180px] flex-col gap-[2px] rounded-[10px] bg-color-cell hover:flex peer-hover:flex", "left-[15px] top-[40px] cursor-pointer px-[5px] py-[4px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "flex items-center gap-[12px] rounded-[10px] py-[12px] pl-[16px] hover:bg-color-background",
                            onClick: function() {
                                return setDeletePopup(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,cdn/* assetUrl */.p)("/ai-tools/history/trash.svg"),
                                    alt: "trash icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " text-[15px] font-500 text-color-error",
                                    children: t("txt_remove")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeletePopup, {
                modelName: name,
                setDeletePopup: setDeletePopup,
                deletePopup: deletePopup,
                id: id,
                functionAfterDelete: functionAfterDelete
            })
        ]
    });
}
function DraftCard(props) {
    var id = props.id, modelType = props.modelType, modelName = props.modelName, date = props.date, functionAfterDelete = props.functionAfterDelete, deleteDraft = props.deleteDraft;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), deletePopup = ref[0], setDeletePopup = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var image = (0,react.useMemo)(function() {
        return URL.createObjectURL(props.image);
    }, [
        props.image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("relative animate-scale"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return router.push("/models/create?draftId=".concat(id));
                        },
                        className: (0,clsx_m/* default */.Z)("flex h-[80px] items-center justify-between rounded-[10px] bg-color-cell p-[5px] pr-[12px]", "relative w-full hover:bg-blue-200"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: "draft first image",
                                    className: "h-[70px] w-[70px] rounded-[6px] object-cover"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/draft-icon.svg"),
                                            alt: "draft icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "max-w-[120px] truncate text-[16px] font-600 text-blue-800",
                                            children: modelName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-[6px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[14px] font-400 text-color-placeholder",
                                                    children: getModelType(modelType)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-[5px] w-[5px] rounded-full bg-color-placeholder"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[14px] font-400 text-color-placeholder",
                                                    children: getMonthDayFromDate(date)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "peer absolute right-2 top-[25px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("mb-[10px] flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded-[4px]", "hover:bg-color-black/10"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/more-gray.svg"),
                                alt: "more icon"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute z-50 hidden w-[180px] flex-col gap-[2px] rounded-[10px] bg-color-cell hover:flex peer-hover:flex", "right-0 top-[60px] cursor-pointer px-[5px] py-[4px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "flex items-center gap-[12px] rounded-[10px] py-[12px] pl-[16px] hover:bg-color-background",
                            onClick: function() {
                                return setDeletePopup(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,cdn/* assetUrl */.p)("/ai-tools/history/trash.svg"),
                                    alt: "trash icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " text-[15px] font-500 text-color-error",
                                    children: t("txt_remove")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeletePopup, {
                modelName: modelName,
                setDeletePopup: setDeletePopup,
                deletePopup: deletePopup,
                id: Number(id),
                functionAfterDelete: functionAfterDelete,
                deleteDraft: function() {
                    return deleteDraft(id);
                }
            })
        ]
    });
}
function TrainingCard(props) {
    var modelName = props.modelName, image = props.image, status = props.status;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(status === "failed" && "hidden", "h-[80px] animate-scale rounded-[10px] bg-color-cell p-[5px] pr-[12px]", "flex items-center gap-[10px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image,
                alt: "draft first image",
                className: "h-[70px] w-[70px] rounded-[6px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/draft-icon.svg"),
                        alt: "draft icon",
                        className: "h-[20px] w-[20px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "max-w-[120px] truncate text-[16px] font-600 text-blue-800",
                        children: modelName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[12px] font-500 text-[#2F91FD]",
                        children: t("txt_training")
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./sections/train-model/model-mobile-card.tsx
var model_mobile_card = __webpack_require__(4418);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
;// CONCATENATED MODULE: ./sections/train-model/select-model-popup.tsx












function SelectModelPopup(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var samples = props.samples, id = props.id;
    var ref = (0,react.useState)(0), selected = ref[0], setSelected = ref[1];
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    if (samples === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-[95px] hidden h-full w-full bg-color-background desktop:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-[13px] pt-[10px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[24px] font-500 text-blue-800",
                            children: t("txt_select_model")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[14px] font-400 text-color-placeholder",
                            children: t("txt_select_model_desc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[14px] pt-[5px]",
                            children: samples.map(function(sample, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectGroupCard, {
                                    images: sample.thumbs,
                                    epoch: sample.epoch,
                                    index: index,
                                    selected: selected,
                                    setSelected: setSelected
                                }, sample.epoch);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-[20px] pt-[68px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    text: t("lbl_continue"),
                                    disabled: selected === 0,
                                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        axios/* default.post */.Z.post("/api/training-select", {
                                                            model_id: id,
                                                            epoch: selected
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    router.push("/models/single?id=".concat(id));
                                                    queryClient.invalidateQueries("all-models");
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    className: "w-[376px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "w-[290px] text-center text-[14px] font-400 text-color-placeholder",
                                    children: t("txt_select_desc")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(model_mobile_card/* default */.Z, {})
        ]
    });
}
function SelectGroupCard(props) {
    var epoch = props.epoch, images = props.images, index = props.index, selected = props.selected, setSelected = props.setSelected;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: "rounded-[14px] border border-color-separator p-[8px] pb-[32px]",
        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setSelected(epoch);
                return [
                    2
                ];
            });
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[4px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: images[0],
                        alt: "first image",
                        className: "h-[270px] w-[270px] rounded-t-[14px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[4px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images[1],
                                alt: "first image",
                                className: "h-[131px] w-[133px] rounded-bl-[14px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images[2],
                                alt: "first image",
                                className: "h-[131px] w-[133px] rounded-br-[14px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-[13px] pt-[21px]",
                children: [
                    selected === epoch ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/check-primary.svg"),
                        alt: "check primary",
                        className: "h-[32px] w-[32px]"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[32px] w-[32px] rounded-full border border-color-separator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (0,clsx_m/* default */.Z)(selected === epoch ? "text-primary-500" : "text-color-placeholder", "text-[15px] font-500"),
                        children: [
                            t("lbl_checkpoint"),
                            " ",
                            index + 1
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./pages/models/create.tsx + 3 modules
var create = __webpack_require__(2259);
;// CONCATENATED MODULE: ./pages/models/index.tsx





















var __N_SSP = true;
var backgroundGradient = (0,clsx_m/* default */.Z)("tablet:[background:radial-gradient(circle_at_left,_#dae3fc,_#e7ddf5,_#f5ece5)]", "dark:tablet:[background:radial-gradient(circle_at_left,_#37415a,_#341e34,_#362d22)]", "[background:linear-gradient(to_right,_#d4dffc,_#e3eafc)] dark:[background:linear-gradient(to_right,_#3b4560,_#2a3142)]");
function getAllModels(uid) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("/api/training-list?id=".concat(uid)).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function getTrainings(uid) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("/api/tools-models-status?id=".concat(uid)).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function TrainModel(props) {
    var ref, ref1;
    var page = props.page;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(page), filter = ref2[0], setFilter = ref2[1];
    var ref3 = (0,react.useState)(null), drafts = ref3[0], setDrafts = ref3[1];
    var ref4 = (0,react.useState)(null), trainings = ref4[0], setTrainings = ref4[1];
    var ref5 = (0,react.useState)(null), selectPopupState = ref5[0], setSelectPopupState = ref5[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var uid = userInfo.userId;
    var router = (0,next_router.useRouter)();
    var query = (0,es.useQuery)({
        queryKey: [
            "all-models",
            uid
        ],
        queryFn: getAllModels(uid)
    });
    var queryTrainings = (0,es.useQuery)({
        queryKey: [
            "trainings"
        ],
        queryFn: getTrainings(uid)
    });
    (0,react.useEffect)(function() {
        if (!queryTrainings.data) {
            setTrainings(null);
            return;
        }
        setTrainings(queryTrainings.data);
    }, [
        queryTrainings.data
    ]);
    var db = (0,indexed/* useIndexedDB */.i)("ai_art", "model_drafts", create.trainModelDraftSchema);
    (0,react.useEffect)(function() {
        if (db.status !== "ready") {
            return;
        }
        db.getAll().then(function(result) {
            if (result === null) {
                console.error("Draft not found");
            }
            setDrafts(result);
        });
    }, [
        db
    ]);
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("txt_model_title"),
                description: t("txt_home_description"),
                cover: (0,cdn/* assetUrl */.p)("/covers/model.jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden h-full w-full flex-col items-center pb-[50px] desktop:flex",
                id: "background",
                onClick: function(e) {
                    var target = e.target;
                    if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                        if (target.id === "background") {
                            var popup = document.getElementById("popup");
                            if (popup) {
                                popup.style.overflow = "hidden";
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(backgroundGradient, "flex h-[95px] w-full justify-center pt-[32px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[24px] font-700 text-blue-800",
                            children: t("txt_models")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-start gap-[14px] pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-[1063px] items-center gap-[76px] border-b-2 border-color-separator pl-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: (0,clsx_m/* default */.Z)(filter === "models" ? "text-blue-800" : "text-blue-500", "relative py-[10px] text-[17px] font-600 hover:text-blue-800"),
                                        onClick: function() {
                                            setFilter("models");
                                            router.push(router.asPath, {
                                                query: {
                                                    page: "models"
                                                }
                                            }, {
                                                shallow: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("txt_models")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                        className: "pl-[6px]",
                                                        children: [
                                                            "(",
                                                            query.data ? (ref = query.data) === null || ref === void 0 ? void 0 : ref.jobs.length : "-",
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            filter === "models" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("absolute -bottom-[2px] left-1/2 h-[3px] w-[49px] rounded-t-[2px] bg-blue-800", "-translate-x-1/2 animate-appear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: (0,clsx_m/* default */.Z)(filter === "drafts" ? "text-blue-800" : "text-blue-500", "relative py-[10px] text-[17px] font-600 hover:text-blue-800"),
                                        onClick: function() {
                                            setFilter("drafts");
                                            router.push(router.asPath, {
                                                query: {
                                                    page: "drafts"
                                                }
                                            }, {
                                                shallow: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("txt_drafts"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                        className: "pl-[6px]",
                                                        children: "(".concat(drafts && (drafts === null || drafts === void 0 ? void 0 : drafts.length) !== 0 ? drafts === null || drafts === void 0 ? void 0 : drafts.length : "-", ")")
                                                    })
                                                ]
                                            }),
                                            filter === "drafts" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("absolute -bottom-[2px] left-1/2 h-[3px] w-[49px] rounded-t-[2px] bg-blue-800", "-translate-x-1/2 animate-appear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: (0,clsx_m/* default */.Z)(filter === "training" ? "text-blue-800" : "text-blue-500", "relative py-[10px] text-[17px] font-600 hover:text-blue-800"),
                                        onClick: function() {
                                            setFilter("training");
                                            router.push(router.asPath, {
                                                query: {
                                                    page: "training"
                                                }
                                            }, {
                                                shallow: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("txt_training"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                        className: "pl-[6px]",
                                                        children: "(".concat(trainings && trainings.models.filter(function(m) {
                                                            return m.status !== "failed";
                                                        }).length !== 0 ? trainings.models.filter(function(model) {
                                                            return model.status !== "failed";
                                                        }).length : "-", ")")
                                                    })
                                                ]
                                            }),
                                            filter === "training" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("absolute -bottom-[2px] left-1/2 h-[3px] w-[49px] rounded-t-[2px] bg-blue-800", "-translate-x-1/2 animate-appear")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            ((ref1 = query.data) === null || ref1 === void 0 ? void 0 : ref1.jobs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContent, {
                                setSelectPopupState: setSelectPopupState,
                                state: filter,
                                jobs: query.data.jobs,
                                drafts: drafts,
                                trainings: trainings,
                                deleteDraft: function(id) {
                                    if (db.status === "ready") {
                                        db.clearData(id);
                                        db.getAll().then(function(result) {
                                            if (result === null) {
                                                console.error("Draft not found");
                                            }
                                            setDrafts(result);
                                        });
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectModelPopup, {
                        id: (ref6 = selectPopupState === null || selectPopupState === void 0 ? void 0 : selectPopupState.id) !== null && ref6 !== void 0 ? ref6 : 0,
                        samples: (ref7 = selectPopupState === null || selectPopupState === void 0 ? void 0 : selectPopupState.samples) !== null && ref7 !== void 0 ? ref7 : null
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(model_mobile_card/* default */.Z, {})
        ]
    });
}
function DeletePopup(props) {
    var deletePopup = props.deletePopup, setDeletePopup = props.setDeletePopup, id = props.id, modelName = props.modelName, functionAfterDelete = props.functionAfterDelete, deleteDraft = props.deleteDraft;
    var t = (0,esm/* useTranslation */.$G)().t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(deletePopup ? "flex" : "hidden", "absolute left-1/2 top-[250px] w-[389px] -translate-x-1/2 p-[24px]", " z-50 animate-appear flex-col gap-[14px] rounded-[12px] bg-color-popup-cell shadow-2xl"),
        onClick: function(e) {
            var target = e.target;
            if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                if (target.id === "background") {
                    setDeletePopup(false);
                }
            }
        },
        id: "popup",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "texxt-blue-700 text-[24px] font-500",
                children: t("fs_are_you_sure", {
                    model: modelName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "texxt-[18px] font-400 text-blue-600",
                children: t("txt_delete_warning")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full items-center justify-between pt-[15px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setDeletePopup(false);
                        },
                        className: "h-[44px] w-[164px] rounded-[10px] border border-color-separator text-[16px] font-600 text-blue-600 hover:bg-blue-200",
                        children: t("lbl_cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "h-[44px] w-[164px] rounded-[10px] bg-color-error text-[16px] font-600 text-color-white hover:bg-[#DE0202]",
                        onClick: deleteDraft === undefined ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            axios/* default.post */.Z.post("/api/training-delete", {
                                                id: id
                                            }).then(function() {
                                                return notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                                                    children: t("fs_successfully_submited", {
                                                        model: modelName
                                                    })
                                                }));
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        setDeletePopup(false);
                                        functionAfterDelete();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }) : function() {
                            deleteDraft();
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                                children: t("fs_successfully_submited", {
                                    model: modelName
                                })
                            }));
                            setDeletePopup(false);
                        },
                        children: t("lbl_delete")
                    })
                ]
            })
        ]
    });
}
function getModelType(model) {
    switch(model){
        case "model_male":
            return "Male";
        case "model_female":
            return "Female";
        case "model_perfume":
            return "Perfume";
        case "model_shoes":
            return "Shoes";
        case "model_sunglasses":
            return "Sunglasses";
    }
}
function getMonthDayFromDate(dateString) {
    var date = new Date(dateString);
    var monthIndex = date.getMonth();
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec", 
    ];
    var month = monthNames[monthIndex];
    var day = date.getDate();
    return "".concat(month, " ").concat(day);
}


/***/ }),

/***/ 3174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY": function() { return /* binding */ TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Templates; },
/* harmony export */   "setTemplateFetchingContext": function() { return /* binding */ setTemplateFetchingContext; },
/* harmony export */   "templateFetchingContextSchema": function() { return /* binding */ templateFetchingContextSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(624);
/* harmony import */ var _comps_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1993);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6489);
/* harmony import */ var _comps_template_panel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4343);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9612);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(177);
/* harmony import */ var _utils_popups__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2763);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7294);
/* harmony import */ var sections_history_report_popup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9521);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1604);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	html, body {\n		height: var(--vh);\n\n		overscroll-behavior: none;\n		background: var(--color-background);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n\n	justify-content: flex-start;\n	align-items: center;\n\n	@media ",
        " {\n		width: calc(100% - 473px);\n		gap: 80px;\n	}\n\n	width: 100%;\n\n	scroll-snap-type: y mandatory;\n	overflow-y: scroll;\n\n	-ms-overflow-style: none;\n	scrollbar-width: none;\n\n	&::-webkit-scrollbar {\n		display: none;\n	}\n\n	overscroll-behavior: none;\n	flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var flattenDescription = function(description) {
    return description.reduce(function(acc, tag) {
        switch(tag.format){
            case "text":
                return acc + tag.content;
            case "hashtag":
                return acc + " #" + tag.content;
            case "username":
                return acc + tag.label;
        }
    }, "");
};
var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_13__/* .createGlobalStyle */ .vJ)(_templateObject());
var __N_SSP = true;
var templateFetchingContextSchema = zod__WEBPACK_IMPORTED_MODULE_14__.z.union([
    zod__WEBPACK_IMPORTED_MODULE_14__.z.object({
        location: zod__WEBPACK_IMPORTED_MODULE_14__.z.literal("single")
    }),
    zod__WEBPACK_IMPORTED_MODULE_14__.z.object({
        location: zod__WEBPACK_IMPORTED_MODULE_14__.z["enum"]([
            "likes",
            "created"
        ]),
        userId: zod__WEBPACK_IMPORTED_MODULE_14__.z.string(),
        offset: zod__WEBPACK_IMPORTED_MODULE_14__.z.number()
    }), 
]).catch({
    location: "single"
});
var TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY = "_template_fetching";
function setTemplateFetchingContext(context) {
    var cookieValue = JSON.stringify(context);
    document.cookie = (0,cookie__WEBPACK_IMPORTED_MODULE_4__/* .serialize */ .q)(TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY, cookieValue, {
        sameSite: "lax"
    });
}
var ScrollableContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b2501bad-0"
})(_templateObject1(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .devices.desktop */ .Hb.desktop);
function getJsonLdData(id, username, name, description, preview, uploadDate, video, views) {
    return [
        {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: name,
            description: description,
            thumbnailUrl: [
                preview
            ],
            license: "https://zoomerang.app/privacy-policy",
            acquireLicensePage: "https://zoomerang.app/template/" + id,
            copyrightNotice: "Zoomerang",
            uploadDate: uploadDate,
            author: {
                "@type": "Person",
                name: username
            },
            creator: {
                "@type": "Person",
                name: username
            },
            contentUrl: video,
            interactionStatistic: {
                "@type": "InteractionCounter",
                interactionType: {
                    "@type": "WatchAction"
                },
                userInteractionCount: views
            }
        }, 
    ];
}
var EPSILON_SCROLL_NUMBER = 100;
function Templates(props) {
    var getOffsetNumber = function getOffsetNumber() {
        var index = templates.findIndex(function(template) {
            return template.id === initialTemplate.id;
        });
        if (index === -1) {
            return 0;
        }
        return index;
    };
    var closeFn = function closeFn() {
        if (templates.length > 1) {
            handleButtonClick("down");
        } else {
            router.back();
        }
    };
    var templates = props.templates, initialTemplate = props.initialTemplate, context = props.context;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(initialTemplate), currentTemplate = ref[0], setCurrentTemplate = ref[1];
    var scroller = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var startIndex = context.location !== "single" && getOffsetNumber();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        sessionStorage.setItem("last", currentTemplate.id);
    }, [
        currentTemplate
    ]);
    var scrollToTemplate = function(templateIndex) {
        var container = scroller.current;
        if (!container || "object" === undefined) {
            return;
        }
        container.style.scrollSnapType = "y mandatory";
        container.scrollTo({
            top: templateIndex * (window.innerHeight + EPSILON_SCROLL_NUMBER),
            behavior: "smooth"
        });
    };
    var handleButtonClick = function(direction) {
        var currentTemplateIndex = templates.findIndex(function(template) {
            return template.id === currentTemplate.id;
        });
        if (direction === "up") {
            if (currentTemplateIndex !== 0) {
                setCurrentTemplate(templates[currentTemplateIndex - 1]);
                scrollToTemplate(currentTemplateIndex - 1);
            }
        } else {
            if (currentTemplateIndex !== templates.length - 1) {
                setCurrentTemplate(templates[currentTemplateIndex + 1]);
                scrollToTemplate(currentTemplateIndex + 1);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        var container = scroller.current;
        if (!container) {
            return;
        }
        if (startIndex !== false) {
            container.scrollTop = startIndex * (window.innerHeight + EPSILON_SCROLL_NUMBER);
        }
        var handleScroll = function() {
            if (container) {
                var containerRect = container.getBoundingClientRect();
                var templateElements = container.querySelectorAll(".template-element");
                var firstVisibleTemplateIndex = -1;
                templateElements.forEach(function(templateElement, index) {
                    var templateRect = templateElement.getBoundingClientRect();
                    if (templateRect.top >= containerRect.top && templateRect.bottom <= containerRect.bottom) {
                        firstVisibleTemplateIndex = index;
                    }
                });
                if (firstVisibleTemplateIndex !== -1) {
                    setCurrentTemplate(templates[firstVisibleTemplateIndex]);
                }
            }
        };
        container.addEventListener("scroll", handleScroll);
        handleScroll();
        return function() {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [
        templates,
        startIndex
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utils_popups__WEBPACK_IMPORTED_MODULE_8__/* .PopupProvider */ .lG, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("flex h-[100svh] w-full flex-col bg-color-black desktop:flex-row", "overflow-hidden"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GlobalStyle, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    title: t("fs_template_title", {
                        title: currentTemplate.name,
                        creator: currentTemplate.creator.username
                    }),
                    description: t("fs_template_description", {
                        creator: currentTemplate.creator.username,
                        description: flattenDescription(currentTemplate.description)
                    }),
                    cover: currentTemplate.preview.jpg,
                    width: "540",
                    height: "960",
                    jsonLdData: getJsonLdData(currentTemplate.id, currentTemplate.creator.username, t("fs_template_title", {
                        title: currentTemplate.name,
                        creator: currentTemplate.creator.username
                    }), t("fs_template_description", {
                        creator: currentTemplate.creator.username,
                        description: flattenDescription(currentTemplate.description)
                    }), currentTemplate.preview.jpg, new Date(currentTemplate.created).toISOString(), currentTemplate.video, currentTemplate.views)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: currentTemplate.preview.jpg,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("fixed left-0 top-0 h-full w-full bg-center bg-no-repeat", "opacity-50 blur-[90px]"),
                    alt: "template"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableContainer, {
                    id: "scrollable-container",
                    ref: scroller,
                    children: templates.map(function(template) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("template-element", "min-h-screen"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                template: template,
                                active: startIndex ? currentTemplate.id === template.id : template.id === currentTemplate.id
                            })
                        }, template.id);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseButton, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MoreButton, {
                    id: currentTemplate.id,
                    closeFn: closeFn
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(context.location === "single" ? "desktop:hidden" : "desktop:flex", "absolute right-[500px] top-1/2 z-10 hidden flex-col gap-[20px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: "rounded-full bg-color-white/20 p-[15px] hover:bg-color-white/40",
                            onClick: function() {
                                return handleButtonClick("up");
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/arrow-white.svg"),
                                alt: "arrow icon"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: "rounded-full bg-color-white/20 p-[15px] hover:bg-color-white/40",
                            onClick: function() {
                                return handleButtonClick("down");
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/arrow-white.svg"),
                                alt: "arrow icon",
                                className: "rotate-180"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_template_panel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    template: currentTemplate,
                    closeFn: closeFn
                })
            ]
        })
    });
}
function MoreButton(props) {
    var id = props.id, closeFn = props.closeFn;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), reportPopup = ref[0], setReportPopup = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)({
        tid: id,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref1[0], setPayload = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("absolute right-4 top-4 z-[99] desktop:left-[24px] desktop:top-[24px]", "cursor-pointer bg-color-white/20 transition-colors hover:bg-color-white/40", "flex h-12 w-12 items-center justify-center rounded-full desktop:hidden"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/general/more-white.svg"),
                    alt: "close",
                    className: "h-[20px] w-[20px] rotate-90"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                    onClick: function() {
                        setReportPopup(true);
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("absolute hidden w-[123px] rounded-[12px] px-[10px] py-[8px] group-hover:flex", "z-[200] items-center gap-[8px] shadow-xl hover:bg-blue-100", "-right-[10px] top-[40px] bg-color-popup-cell desktop:top-[80px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_6__/* .CustomThemedResource */ .aK, {
                            source: "/general/report",
                            format: "svg"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "text-[16px] font-500 text-blue-800",
                            children: t("txt_report")
                        })
                    ]
                }),
                reportPopup && setReportPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_history_report_popup__WEBPACK_IMPORTED_MODULE_12__/* .ReportPopup */ .j, {
                    payload: payload,
                    setReportPopup: setReportPopup,
                    setPayload: setPayload,
                    payloadLocation: "tutorial",
                    endpoint: "tutorial-report",
                    galleryOrTemplate: "template",
                    closeFn: closeFn,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("fixed z-[201] tablet:right-[20px] tablet:top-[70px]", "bottom-0 left-0 right-0 tablet:bottom-auto tablet:left-auto")
                })
            ]
        })
    });
}
function CloseButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), clicked = ref[0], setClicked = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (window.history.length <= 1 && clicked) {
            router.push("/");
        } else if (clicked) {
            router.back();
        }
    }, [
        clicked,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
        onClick: function() {
            setClicked(true);
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("absolute left-4 top-4 z-[99] desktop:left-[24px] desktop:top-[24px]", "cursor-pointer bg-color-white/20 transition-colors hover:bg-color-white/40", "flex h-12 w-12 items-center justify-center rounded-full", clicked && "pointer-events-none opacity-50"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_16__/* .assetUrl */ .p)("/player/close.svg"),
            alt: "close"
        })
    });
}


/***/ }),

/***/ 9274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ALL_TOOLS": function() { return /* binding */ ALL_TOOLS; },
/* harmony export */   "Arrow": function() { return /* binding */ Arrow; },
/* harmony export */   "SingleProduct": function() { return /* binding */ SingleProduct; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ AllTools; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1455);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1083);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9612);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(624);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);











var __N_SSP = true;
var ALL_TOOLS = [
    "ai_restyle",
    "deform",
    "ai_photo",
    "text_to_image",
    "text_to_video",
    "ai_photoshoot",
    "generative_fill",
    "video_bg_remover",
    "ai_music_generator",
    "look_ai", 
];
var allTools = [
    {
        tool: "deform",
        label: "txt_deforum_ai",
        location: "deforum",
        url: "/tools/ai-video-transformation",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .deforumIcon */ .uv)()
    },
    {
        tool: "ai_restyle",
        label: "txt_restyle_ai",
        location: "restyle",
        url: "/tools/ai-animation-generator",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .restyleIcon */ .Lt)()
    },
    {
        tool: "ai_photo",
        label: "txt_photo_ai",
        location: "photo-ai",
        url: "/tools/ai-photo-editor",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .photoAiIcon */ .x$)()
    },
    {
        tool: "text_to_image",
        label: "txt_text_to_image",
        location: "text-to-image",
        url: "/tools/text-to-image",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .textToImageIcon */ .f7)()
    },
    {
        tool: "ai_photoshoot",
        label: "txt_ai_photoshoot",
        location: "ai-photoshoot",
        url: "/tools/ai-photoshoot-generator",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .AIPhotoshoot */ .wQ)()
    },
    {
        tool: "text_to_video",
        label: "txt_text_to_video",
        location: "text-to-video",
        url: "/tools/text-to-video",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .textToVideoIcon */ .Cz)()
    },
    {
        tool: "look_ai",
        label: "txt_look_ai",
        location: "look-ai",
        url: "/tools/ai-portrait-generator",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .lookAiIcon */ .YH)(),
        mobileOnly: true
    },
    {
        tool: "video_bg_remover",
        label: "txt_video_bg_remover",
        location: "video-bg-remover",
        url: "/tools/video-background-remover",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .videoBGRemoverIcon */ .bv)(),
        mobileOnly: true
    },
    {
        tool: "ai_music_generator",
        label: "txt_ai_music_generator",
        location: "ai-music-generator",
        url: "/tools/royalty-free-music",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .musicGeneratorIcon */ .rL)()
    },
    {
        tool: "generative_fill",
        label: "txt_generative_fill",
        location: "generative-fill",
        url: "/tools/ai-image-replacer",
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .generativeFillIcon */ .hM)(),
        mobileOnly: true
    }, 
];
function AllTools() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex min-h-[100vh] flex-col overflow-hidden bg-color-cell",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: t("lbl_ai_tools"),
                description: t("lbl_ai_tools")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative flex w-full flex-1 justify-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none absolute left-0 top-0 w-full overflow-hidden px-4 tablet:-translate-y-[70px] desktop:left-[calc(50%-588px)] desktop:w-[1175px] desktop:px-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_4__/* .ResponsiveImage */ .t3, {
                            src: "/ai-tools/index/intro",
                            className: "w-full desktop:w-[1175px]"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tools, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
}
function Tools() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common").t;
    var device = (0,_utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .useDeviceSize */ .BV)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative mb-[20px] mt-[170px] flex w-full flex-col items-center justify-start tablet:mt-[215px] desktop:mt-[320px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pointer-events-none absolute left-0 top-0 flex h-full w-full translate-y-[10%] flex-col overflow-x-clip tablet:translate-y-0 desktop:h-auto desktop:translate-y-[8%] desktop:overflow-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/ai-tools/index/gradient-desktop.webp"),
                            className: " w-full flex-1 scale-x-[1.3] scale-y-[2] tablet:scale-[1.5] desktop:flex-none desktop:scale-100",
                            alt: "gradient"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/ai-tools/index/gradient-desktop.webp"),
                            className: "hidden w-full flex-1 scale-x-[1.1] tablet:block tablet:scale-[1.5] desktop:flex-none desktop:scale-100",
                            alt: "gradient"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "z-10 flex w-full flex-col items-center justify-start gap-7 tablet:gap-16 desktop:w-[1175px] desktop:gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-h3",
                            children: t("lbl_ai_tools")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("no-scrollbar flex w-full flex-col gap-3 px-4", "tablet:grid tablet:w-auto tablet:grid-cols-3 tablet:gap-4", "desktop:grid-cols-5 desktop:gap-6 desktop:px-0"),
                            children: allTools.map(function(product) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleProduct, {
                                    product: product,
                                    isMobile: device === _utils_breakpoints__WEBPACK_IMPORTED_MODULE_6__/* .Device.Mobile */ .AS.Mobile
                                }, product.url);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function SingleProduct(props) {
    var product = props.product, isMobile = props.isMobile;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common").t;
    var player = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (player.current) if (player.current.clientHeight >= 208) player.current.autoplay = false;
        else player.current.play().catch(console.error);
    }, [
        player
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            href: product.url,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("relative flex w-full shrink-0 flex-row items-center", "justify-between gap-[10px] rounded-[8px] bg-color-cell py-[8px] pl-[8px] pr-[12px]", "tablet:items-start tablet:justify-start tablet:rounded-[14px] tablet:p-0 tablet:pb-4"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("absolute left-[10px] top-[10px] hidden h-[30px] items-center justify-center px-[10px]", " rounded-[40px] bg-color-black/40 backdrop-blur-[23px]", "text-[14px] font-500 text-color-white", product.mobileOnly !== true ? "hidden" : "hidden tablet:flex"),
                    children: t("txt_in_mobile")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex flex-row items-center gap-[10px]", "tablet:w-full tablet:flex-col tablet:gap-[14px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            muted: true,
                            loop: true,
                            playsInline: true,
                            preload: "metadata",
                            ref: player,
                            onPointerEnter: function(e) {
                                if (isMobile) return;
                                e.currentTarget.play().catch(console.error);
                            },
                            onPointerLeave: function(e) {
                                if (isMobile) return;
                                e.currentTarget.pause();
                                e.currentTarget.currentTime = 0.001;
                            },
                            onTouchMove: function(e) {
                                if (isMobile) return;
                                e.currentTarget.play().catch(console.error);
                            },
                            onTouchEnd: function(e) {
                                if (isMobile) return;
                                e.currentTarget.pause();
                                e.currentTarget.currentTime = 0.001;
                            },
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/ai-tools/".concat(product.location, "/intro.mp4#t=0.001")),
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("aspect-1 h-[88px] rounded-[6px] object-cover object-top tablet:h-auto", "transition-all duration-300 tablet:rounded-[14px] tablet:hover:rounded", "atablet:h-[208px] adesktop:h-[200px] tablet:aspect-none tablet:w-full")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-[3px] tablet:w-full tablet:gap-[10px] tablet:px-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-start gap-[3px] text-[16px] font-600 text-blue-700 [--icon-color:var(--color-blue-700)] tablet:flex-row tablet:items-center tablet:gap-3 tablet:text-[18px] tablet:text-blue-800 desktop:text-[20px]",
                                    children: [
                                        product.icon,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: " w-[80%] truncate leading-[19px] tablet:leading-normal",
                                            children: t(product.label)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "line-clamp-2 w-full text-[12px] font-500 leading-[15px] text-blue-600 tablet:text-[16px] tablet:leading-normal tablet:text-blue-700",
                                    children: t("".concat(product.label, "_description"))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "[--icon-color:var(--color-placeholder)] tablet:hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
                })
            ]
        })
    });
}
function Arrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.66675 12L10.6667 8L6.66675 4",
            stroke: "var(--icon-color)",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/***/ }),

/***/ 4168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "categoriesResultData": function() { return /* binding */ categoriesResultData; },
/* harmony export */   "categorySchema": function() { return /* binding */ categorySchema; },
/* harmony export */   "default": function() { return /* binding */ Templates; },
/* harmony export */   "featuredExtractor": function() { return /* binding */ featuredExtractor; },
/* harmony export */   "featuredResponseSchema": function() { return /* binding */ featuredResponseSchema; },
/* harmony export */   "featuredResultData": function() { return /* binding */ featuredResultData; },
/* harmony export */   "indexFiltersTemplates": function() { return /* binding */ indexFiltersTemplates; },
/* harmony export */   "searchedTemplates": function() { return /* binding */ searchedTemplates; },
/* harmony export */   "templateExtractor": function() { return /* binding */ templateExtractor; },
/* harmony export */   "templateSchema": function() { return /* binding */ templateSchema; },
/* harmony export */   "templatesWithCategoriesResponseSchema": function() { return /* binding */ templatesWithCategoriesResponseSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6106);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1604);





var __N_SSP = true;
var templateSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    id: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    likes: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
    setups: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
    preview_image_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string(),
    preview_gif_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullable(),
    preview_webp_url: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullable(),
    price: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
    is_pro: zod__WEBPACK_IMPORTED_MODULE_2__.z.boolean(),
    created_by_user: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        profile_pic: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
            original: zod__WEBPACK_IMPORTED_MODULE_2__.z.string().nullable().default(null)
        }).nullable(),
        username: zod__WEBPACK_IMPORTED_MODULE_2__.z.string()
    })
});
var featuredResultData = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    section: zod__WEBPACK_IMPORTED_MODULE_2__.z["enum"]([
        "featured",
        "rec",
        "used"
    ]),
    data: zod__WEBPACK_IMPORTED_MODULE_2__.z.array(templateSchema)
});
var categorySchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    section: zod__WEBPACK_IMPORTED_MODULE_2__.z.literal("category"),
    data: zod__WEBPACK_IMPORTED_MODULE_2__.z.array(templateSchema),
    category: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        id: zod__WEBPACK_IMPORTED_MODULE_2__.z.number(),
        name: zod__WEBPACK_IMPORTED_MODULE_2__.z.string()
    })
});
var categoriesResultData = featuredResultData.merge(categorySchema);
var templatesWithCategoriesResponseSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    result: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        data: zod__WEBPACK_IMPORTED_MODULE_2__.z.array(categoriesResultData)
    })
});
var searchedTemplates = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    result: zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
        tutorials: zod__WEBPACK_IMPORTED_MODULE_2__.z.array(templateSchema)
    })
});
var featuredResponseSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.object({
    result: zod__WEBPACK_IMPORTED_MODULE_2__.z.array(featuredResultData)
});
var indexFiltersWithoutApplied = {
    selectedCategory: -2,
    price: "all",
    searchQuery: null,
    sortBy: "rec"
};
var indexFiltersTemplates = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, indexFiltersWithoutApplied), {
    applyFilters: indexFiltersWithoutApplied
});
function templateExtractor(entity) {
    var ref;
    var id = entity.id, likes = entity.likes, setups = entity.setups, preview_gif_url = entity.preview_gif_url, preview_image_url = entity.preview_image_url, preview_webp_url = entity.preview_webp_url, created_by_user = entity.created_by_user, price = entity.price, is_pro = entity.is_pro;
    var ref1;
    return {
        id: id,
        likes: likes,
        setups: setups,
        preview: {
            webp: preview_webp_url,
            gif: preview_gif_url,
            jpg: preview_image_url
        },
        price: price,
        prime: is_pro,
        creator: {
            username: created_by_user.username,
            picture: (ref1 = (ref = created_by_user.profile_pic) === null || ref === void 0 ? void 0 : ref.original) !== null && ref1 !== void 0 ? ref1 : null
        }
    };
}
function featuredExtractor(entity) {
    var section;
    var id;
    if (entity.section === "category") {
        section = entity.category.name;
        id = entity.category.id;
    } else {
        section = entity.section;
        id = null;
    }
    return {
        id: id,
        section: section,
        data: entity.data.map(templateExtractor)
    };
}
function Templates(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        galleryJobs: null,
        templatesJobs: props.jobs,
        adExamplesJobs: null,
        initialFiltersTemplates: props.initial,
        initialFiltersGallery: null,
        availableFiltersTemplates: props.availableFiltersTemplates,
        availableFiltersGallery: props.availableFiltersGallery,
        initialFiltersAdExamples: null,
        pageTitle: props.pageTitle,
        metaLinks: null,
        initialPage: "video-templates"
    });
}


/***/ }),

/***/ 8067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ GeneratedVideo; },
/* harmony export */   "e": function() { return /* binding */ skeletonColors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3153);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9612);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9034);
/* harmony import */ var _comps_progressive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4903);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4165);
/* harmony import */ var _comps_tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4773);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4371);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2706);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6010);
/* harmony import */ var controllers_editors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8767);
























var skeletonColors = [
    "#81E68526",
    "#81E6E326",
    "#81B7E626",
    "#E681A626",
    "#E6D08126",
    "#8185E626",
    "#B081E626",
    "#E381E626",
    "#E6818126", 
];
function GeneratedVideo(props) {
    var dontPushUrl = props.dontPushUrl, canTryOther = props.canTryOther, setDialogContent = props.setDialogContent, setHistoryPopupState = props.setHistoryPopupState, handleDelete = props.handleDelete, selectCreatorTool = props.selectCreatorTool;
    var _entity = props.entity, id = _entity.id, tool = _entity.tool, privacy = _entity.privacy, initial = _entity.initial, width = _entity.width, height = _entity.height, additional_prompt = _entity.additional_prompt, face_object_url = _entity.face_object_url, createdAt = _entity.createdAt, prompt = _entity.prompt, prompt_name = _entity.prompt_name, model_id = _entity.model_id;
    var ref = getThumbnailResultOfGeneration(props.entity), thumbnail = ref.thumbnail, result = ref.result, isVideo = ref.isVideo;
    var thumbImage = typeof thumbnail === "string" ? thumbnail : thumbnail[0];
    var resultImage = typeof result === "string" ? result : result[0];
    var thumbReady = (0,_comps_progressive__WEBPACK_IMPORTED_MODULE_5__/* .useProgressive */ .k)(thumbImage);
    var resultReady = (0,_comps_progressive__WEBPACK_IMPORTED_MODULE_5__/* .useProgressive */ .k)(resultImage);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHovered = ref2[0], setIsHovered = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), videoPaused = ref3[0], setVideoPaused = ref3[1];
    var isPublic = privacy === "public";
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_9__/* .NotificationContext */ .u).notify;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_14__.useQueryClient)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPublicLoading = ref4[0], setIsPublicLoading = ref4[1];
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_8__/* .useAdjustLogger */ .eW)();
    function handleCopyPrompt(text) {
        return _handleCopyPrompt.apply(this, arguments);
    }
    function _handleCopyPrompt() {
        _handleCopyPrompt = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(text) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_4__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_4__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyPrompt.apply(this, arguments);
    }
    var availableButtons = [
        {
            title: t("txt_save"),
            icon: "/ai-tools/history/download-monochrome.svg",
            href: typeof result === "string" ? result : result[offset],
            onClick: function() {
                return logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
            },
            download: true
        },
        {
            title: t("txt_share"),
            icon: "/ai-tools/history/link-monochrome.svg",
            onClick: function() {
                return setDialogContent({
                    open: true,
                    isPublic: isPublic,
                    link: "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_10__/* .APP_HOST */ .b, "/profile/generations/").concat(id),
                    id: id
                });
            }
        },
        null, 
    ];
    function handleRetry() {
        return _handleRetry.apply(this, arguments);
    }
    function _handleRetry() {
        _handleRetry = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var promptType, inputs;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                promptType = props.entity.prompt;
                inputs = promptType === "custom" ? createInputs({
                    type: "custom",
                    content: [
                        ""
                    ]
                }) : createInputs({
                    type: "predefined",
                    id: promptType
                });
                if (!selectCreatorTool) {
                    return [
                        2
                    ];
                }
                switch(tool){
                    case "deform":
                        selectCreatorTool(tool, {
                            tool: "deform",
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_11__/* .DEFORUM_STORAGE_KEY */ .LF,
                            inputs: inputs,
                            promptType: promptType,
                            location: "remote",
                            url: initial
                        });
                        setHistoryPopupState(null);
                        break;
                    case "ai_photo":
                    case "ai_restyle":
                        selectCreatorTool(tool, {
                            tool: tool,
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_11__/* .DEFORUM_STORAGE_KEY */ .LF,
                            input: "",
                            promptType: promptType,
                            location: "remote",
                            url: initial
                        });
                        setHistoryPopupState(null);
                        break;
                    case "text_to_video":
                    case "text_to_image":
                        selectCreatorTool(tool, {
                            tool: tool,
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_11__/* .DEFORUM_STORAGE_KEY */ .LF,
                            promptType: promptType,
                            text: initial,
                            location: "remote",
                            url: face_object_url
                        });
                        setHistoryPopupState(null);
                        break;
                }
                return [
                    2
                ];
            });
        });
        return _handleRetry.apply(this, arguments);
    }
    function handleMakePublic(shouldBePublic) {
        return _handleMakePublic.apply(this, arguments);
    }
    function _handleMakePublic() {
        _handleMakePublic = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(shouldBePublic) {
            var payload, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isPublicLoading) {
                            return [
                                2
                            ];
                        }
                        setIsPublicLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        payload = {
                            privacy: shouldBePublic ? "public" : "private",
                            job: id
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_17__/* ["default"].post */ .Z.post("/api/deforum-privacy", payload)
                        ];
                    case 2:
                        _state.sent();
                        queryClient.invalidateQueries("deforum-history");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_4__/* .ErrorMessage */ .Bc, {
                            children: t(shouldBePublic ? "txt_could_not_make_public" : "txt_could_not_make_private")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsPublicLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleMakePublic.apply(this, arguments);
    }
    var scrollToImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index) {
        var nextImage = document.getElementsByClassName("ai-art-generation-".concat(thumbnail, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, [
        thumbnail
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage,
        thumbnail
    ]);
    var backgroundColor = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return skeletonColors[Math.floor(Math.random() * skeletonColors.length)];
    }, []);
    if (!thumbReady && !resultReady) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                aspectRatio: width / height,
                backgroundColor: backgroundColor
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("min-h-[130px] w-full overflow-hidden rounded-[6px] desktop:min-h-[210px]"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_6__/* .SizedSkeleton */ .xB, {
                className: "h-full w-full !bg-[transparent]"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("relative w-full rounded-[6px] bg-blue-200", "group cursor-pointer text-color-white"),
        children: [
            typeof thumbnail !== "string" && thumbnail.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === 0,
                        onClick: function() {
                            return scrollToImage(offset - 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("absolute left-2 top-[calc(50%-12px)] z-20 flex h-6 w-6 items-center", "justify-center rounded-full border border-[transparent] bg-[#00000052]", "opacity-0 backdrop-blur-[10px] transition-all", "hover:border-color-white/60 disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === thumbnail.length - 1,
                        onClick: function() {
                            return scrollToImage(offset + 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("absolute right-2 top-[calc(50%-12px)] z-20 flex", "h-6 w-6 items-center justify-center rounded-full", "border border-[transparent] bg-[#00000052] opacity-0", "backdrop-blur-[10px] transition-all hover:border-color-white/60", "disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow",
                            className: "rotate-180"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("absolute bottom-0 left-0 z-20 hidden w-full desktop:block", "opacity-0 transition-all group-hover:opacity-100", "rounded-b-[6px]", "bg-gradient-to-t from-color-black/80 to-[transparent]", "flex cursor-auto flex-col items-center"),
                children: [
                    (additional_prompt.trim().length > 0 || tool === "text_to_image") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onMouseEnter: function() {
                            return setIsHovered(true);
                        },
                        onMouseLeave: function() {
                            return setIsHovered(false);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("peer relative flex w-full flex-row items-end justify-between p-3 pt-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_7__/* .TextTooltip */ .JI, {
                                showAlways: initial.length > 144,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("max-w-full pr-6"),
                                title: tool === "text_to_image" ? initial : additional_prompt,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("text-sm font-400 transition-[max-height]", isHovered ? "line-clamp-4 max-h-[80px] whitespace-normal" : "max-h-[20px] truncate"),
                                    children: tool === "text_to_image" ? initial : additional_prompt
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                title: t("common:txt_copy"),
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("!absolute bottom-3 right-3", isHovered && "!absolute bottom-3 right-3"),
                                showAlways: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        return handleCopyPrompt(tool === "text_to_image" ? initial : additional_prompt);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("flex h-6 w-6 shrink-0 cursor-pointer items-center", "justify-center rounded-full bg-[#E9EDF738] transition-colors", "border border-[transparent] hover:border-color-white/60"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                        alt: "copy",
                                        className: "h-3 w-3"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-row items-end justify-between px-3 pb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden gap-2 desktop:flex",
                                children: availableButtons.map(function(singleButton, index) {
                                    if (singleButton === null) {
                                        return;
                                    }
                                    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(RoundButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, singleButton), {
                                        key: index
                                    }));
                                })
                            }),
                            typeof thumbnail !== "string" && thumbnail.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-row gap-[5px] rounded-[40px] bg-[#00000066] px-[10px] py-1 opacity-100 transition-all",
                                children: thumbnail.map(function(_, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: function() {
                                            return scrollToImage(index);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("h-[6px] w-[6px] cursor-pointer rounded-full transition-all", offset === index ? "scale-[1.4] bg-primary-500" : "scale-100 bg-color-white")
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            typeof thumbnail !== "string" && thumbnail.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    left: "calc(50% - ".concat((thumbnail.length * 5 + (thumbnail.length - 1) * 5 + 20) / 2, "px)")
                },
                className: "absolute bottom-2 z-10 flex flex-row gap-[5px] rounded-[40px] bg-[#00000066] px-[10px] py-1 desktop:hidden",
                children: thumbnail.map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return scrollToImage(index);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("h-[5px] w-[5px] cursor-pointer rounded-full transition-all", offset === index ? "scale-[1.4] bg-primary-500" : "scale-100 bg-color-white")
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-2 top-[14px]",
                children: isVideo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/video-icon.svg"),
                    alt: "video-icon",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("h-4 w-4 transition-opacity", videoPaused ? "opacity-100" : "opacity-0")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-[calc(50%-9px)] top-3",
                children: privacy === "public" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/globe-icon.svg"),
                    alt: "private-icon",
                    className: "h-5 w-5"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/profile/generations/".concat(encodeURIComponent(id)),
                onClick: function(e) {
                    e.preventDefault();
                    if (!dontPushUrl) {
                        router.push("/profile/generations/".concat(id), undefined, {
                            shallow: true
                        });
                    }
                    setHistoryPopupState({
                        onClose: function() {
                            return setHistoryPopupState(null);
                        },
                        selectCreatorTool: selectCreatorTool,
                        id: id,
                        imageOrVideo: isVideo ? result + "#t=0.001" : result,
                        previewImage: typeof thumbnail === "string" ? thumbnail : thumbnail[0],
                        tool: tool,
                        createdAt: createdAt,
                        customPrompt: additional_prompt,
                        privacy: privacy,
                        prompt: prompt,
                        setDialogContent: setDialogContent,
                        promptName: prompt_name,
                        initial: initial,
                        handleRetry: handleRetry,
                        notShallow: Boolean(dontPushUrl),
                        handleDelete: handleDelete,
                        aspectRatio: width / height,
                        model_id: model_id
                    });
                },
                children: typeof result === "string" ? !isVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: result,
                    alt: "thumbnail of the result",
                    className: "min-h-[130px] w-full rounded-[6px] object-cover desktop:min-h-[210px]"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                    src: result + "#t=0.001",
                    poster: typeof thumbnail === "string" ? thumbnail : thumbnail[0],
                    playsInline: true,
                    loop: true,
                    preload: "none",
                    muted: true,
                    onPointerEnter: function(e) {
                        setVideoPaused(false);
                        e.currentTarget.play().catch(console.error);
                    },
                    onPointerLeave: function(e) {
                        setVideoPaused(true);
                        e.currentTarget.pause();
                        e.currentTarget.currentTime = 0.001;
                    },
                    style: {
                        aspectRatio: width / height
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("w-full object-cover", "min-h-[130px] rounded-[6px] desktop:min-h-[210px]")
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("w-full overflow-hidden object-cover", "rounded-[6px]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onScroll: function(event) {
                            var container = event.target;
                            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(container, HTMLElement)) {
                                var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                                setOffset(snapIndex);
                            }
                        },
                        className: "no-scrollbar top-0 flex h-full snap-x snap-mandatory flex-row gap-12 overflow-x-scroll transition-all ",
                        children: typeof thumbnail !== "string" && thumbnail.map(function(thumb, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: thumb,
                                alt: "thumb",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(" h-full min-h-[130px] w-full shrink-0 snap-center rounded-[6px] object-cover desktop:min-h-[210px]", "ai-art-generation-".concat(thumbnail, "-").concat(index))
                            }, thumb);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-2 top-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropDownAlternative */ .rV, {
                    hover: true,
                    className: "h-[32px] w-[32px]",
                    trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/more.svg"),
                        alt: "more icon",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("z-30 h-[32px] w-[32px] rotate-90 rounded-full bg-[transparent] object-cover transition-all hover:bg-color-black/30")
                    }),
                    contentClassName: "pt-3 absolute z-[50] right-1 top-full w-[170px] translate-x-4 tablet:w-[231px] desktop:left-1/2 desktop:-translate-x-1/2 desktop:right-[unset]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "rounded-[12px] bg-color-popup-cell px-1 py-3 tablet:px-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                disabled: isPublicLoading,
                                onClick: function(e) {
                                    e.preventDefault();
                                    handleMakePublic(!isPublic);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("mb-1 flex items-center gap-3 px-4 py-3 text-[14px] font-500 text-blue-800", "w-full rounded-[8px] transition-colors hover:bg-[rgba(111,131,187,0.1)]", "disabled:hover:bg-transparent disabled:opacity-50"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: isPublic ? "/ai-tools/history/lock" : "/ai-tools/history/globe"
                                    }),
                                    isPublic ? t("txt_make_private") : t("txt_make_public")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[2px] w-full border-b border-blue-100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                disabled: !canTryOther,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("mt-1 flex items-center gap-3 px-4 py-3 text-[14px] font-500 text-blue-800", "w-full rounded-[8px] transition-colors hover:bg-[rgba(111,131,187,0.1)]", "disabled:hover:bg-transparent disabled:opacity-50"),
                                onClick: handleRetry,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/general/try-again"
                                    }),
                                    tool === "text_to_image" ? t("txt_regenerate") : t("txt_try_other_style")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                onClick: function() {
                                    return logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
                                },
                                href: typeof result === "string" ? result : result[offset],
                                download: true,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 text-[14px] font-500 text-blue-800 desktop:hidden", "w-full rounded-[8px] transition-colors hover:bg-[rgba(111,131,187,0.1)]", "disabled:hover:bg-transparent disabled:opacity-50"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/ai-tools/history/save"
                                    }),
                                    t("txt_save")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: function() {
                                    return setDialogContent({
                                        open: true,
                                        isPublic: isPublic,
                                        link: "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_10__/* .APP_HOST */ .b, "/profile/generations/").concat(id),
                                        id: id
                                    });
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 text-[14px] font-500 text-blue-800 desktop:hidden", "w-full rounded-[8px] transition-colors hover:bg-[rgba(111,131,187,0.1)]", "disabled:hover:bg-transparent disabled:opacity-50"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                        format: "svg",
                                        source: "/ai-tools/history/share",
                                        className: "w-[23px]"
                                    }),
                                    t("txt_share")
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: function() {
                                    return handleDelete(id);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 text-[14px] font-500", "w-full rounded-[8px] transition-colors hover:bg-[rgba(111,131,187,0.1)]", "disabled:hover:bg-transparent text-color-error disabled:opacity-50"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/ai-tools/history/trash.svg"),
                                        alt: "trash"
                                    }),
                                    t("lbl_delete")
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function getThumbnailResultOfGeneration(entity) {
    switch(entity.tool){
        case "ai_restyle":
            return {
                thumbnail: entity.thumbnailAfter,
                isVideo: true,
                result: entity.result,
                prompt_name: entity.prompt_name
            };
        case "deform":
            return {
                thumbnail: entity.thumbnail,
                isVideo: true,
                result: entity.result,
                prompt_name: entity.prompt_name
            };
        case "ai_photo":
            return {
                thumbnail: entity.thumbnailAfter,
                isVideo: false,
                result: entity.result,
                prompt_name: entity.prompt_name
            };
        case "text_to_image":
            return {
                thumbnail: entity.thumbnail,
                isVideo: false,
                result: entity.result,
                prompt_name: entity.prompt_name
            };
        case "text_to_video":
            return {
                thumbnail: entity.thumbnail,
                isVideo: true,
                result: entity.result,
                prompt_name: entity.prompt_name
            };
    }
}
function RoundButton(props) {
    var href = props.href, icon = props.icon, download = props.download, onClick = props.onClick, title = props.title;
    if (href !== undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            title: title,
            showAlways: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                download: download,
                className: "h-[38px] w-[38px] rounded-full border border-[transparent] bg-[transparent] transition-all hover:border-color-white/60",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)(icon),
                    alt: "round icon",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("h-full w-full object-cover")
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        title: title,
        showAlways: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: onClick,
            className: "h-[38px] w-[38px] rounded-full border border-[transparent] bg-[transparent] transition-all hover:border-color-white/60",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)(icon),
                alt: "round icon",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("h-full w-full object-cover")
            })
        })
    });
}
function createInput() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        text: text,
        id: Math.random().toString()
    };
}
function createInputs(initial) {
    if (initial.type === "predefined") {
        return [
            createInput()
        ];
    }
    return initial.content.map(createInput);
}


/***/ }),

/***/ 5091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useEditorFromIndexedDB; },
/* harmony export */   "Y4": function() { return /* binding */ useUploadOption; },
/* harmony export */   "c2": function() { return /* binding */ isImageOrVideo; },
/* harmony export */   "i9": function() { return /* binding */ EditorParamsProviders; },
/* harmony export */   "mK": function() { return /* binding */ useEditorParamsContext; }
/* harmony export */ });
/* unused harmony exports EditorParamsContext, isVideoFile */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9034);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(788);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7592);
/* harmony import */ var _utils_mime_types__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(3867);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4371);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6961);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6010);
/* harmony import */ var controllers_editors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7294);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1604);
/* harmony import */ var _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8641);
/* harmony import */ var _comps_editors_photo_ai__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(187);
/* harmony import */ var _comps_editors_restyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9868);

























var channelsSchema = zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
    available_bitrates: zod__WEBPACK_IMPORTED_MODULE_15__.z.array(zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
        bitrate: zod__WEBPACK_IMPORTED_MODULE_15__.z.number()
    })),
    available_intensities: zod__WEBPACK_IMPORTED_MODULE_15__.z.array(zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
        intensity: zod__WEBPACK_IMPORTED_MODULE_15__.z.union([
            zod__WEBPACK_IMPORTED_MODULE_15__.z.literal("low"),
            zod__WEBPACK_IMPORTED_MODULE_15__.z.literal("medium"),
            zod__WEBPACK_IMPORTED_MODULE_15__.z.literal("high"), 
        ])
    })),
    categories: zod__WEBPACK_IMPORTED_MODULE_15__.z.array(zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
        category_id: zod__WEBPACK_IMPORTED_MODULE_15__.z.number(),
        name: zod__WEBPACK_IMPORTED_MODULE_15__.z.string(),
        groups: zod__WEBPACK_IMPORTED_MODULE_15__.z.array(zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
            name: zod__WEBPACK_IMPORTED_MODULE_15__.z.string(),
            playlist: zod__WEBPACK_IMPORTED_MODULE_15__.z.string()
        }))
    }))
});
var channelsResponseSchema = zod__WEBPACK_IMPORTED_MODULE_15__.z.object({
    data: channelsSchema
});
var EditorParamsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_11__.createContext)(null);
function useEditorParamsContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_11__.useContext)(EditorParamsContext);
    return context;
}
var pageMaps = {
    deform: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8641));
    },
    ai_restyle: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9868));
    },
    ai_photo: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 187));
    },
    text_to_image: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3569));
    },
    text_to_video: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5042));
    },
    ai_music_generator: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2490));
    }
};
function getParams(tool) {
    return _getParams.apply(this, arguments);
}
function _getParams() {
    _getParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(tool) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(tool !== "ai_music_generator")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].post */ .Z.post("/api/deforum-params", {
                            tool: tool
                        }).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, result), {
                            channels: null
                        })
                    ];
                case 2:
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getParams.apply(this, arguments);
}
function getChannels(tool, isPro, pat) {
    return _getChannels.apply(this, arguments);
}
function _getChannels() {
    _getChannels = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(tool, isPro, pat) {
        var submitData, response, result, _data, available_bitrates, available_intensities, categories, e, result1, _data1, available_bitrates1, available_intensities1, categories1, result2, _data2, available_bitrates2, available_intensities2, categories2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(tool === "ai_music_generator" && isPro && pat)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    submitData = {
                        method: "GetPlayMusic",
                        params: {
                            pat: pat
                        }
                    };
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].post */ .Z.post("https://api-b2b.mubert.com/v2/GetPlayMusic", submitData).then(function(res) {
                            return res.data;
                        })
                    ];
                case 2:
                    response = _state.sent();
                    result = channelsResponseSchema.parse(response);
                    _data = result.data, available_bitrates = _data.available_bitrates, available_intensities = _data.available_intensities, categories = _data.categories;
                    return [
                        2,
                        {
                            available_bitrates: available_bitrates,
                            available_intensities: available_intensities,
                            categories: categories
                        }
                    ];
                case 3:
                    e = _state.sent();
                    result1 = channelsResponseSchema.parse(defaultChannelsList);
                    _data1 = result1.data, available_bitrates1 = _data1.available_bitrates, available_intensities1 = _data1.available_intensities, categories1 = _data1.categories;
                    return [
                        2,
                        {
                            available_bitrates: available_bitrates1,
                            available_intensities: available_intensities1,
                            categories: categories1
                        }
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    result2 = channelsResponseSchema.parse(defaultChannelsList);
                    _data2 = result2.data, available_bitrates2 = _data2.available_bitrates, available_intensities2 = _data2.available_intensities, categories2 = _data2.categories;
                    return [
                        2,
                        {
                            available_bitrates: available_bitrates2,
                            available_intensities: available_intensities2,
                            categories: categories2
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getChannels.apply(this, arguments);
}
function loadPageComponent(props, setPage, isPro) {
    return _loadPageComponent.apply(this, arguments);
}
function _loadPageComponent() {
    _loadPageComponent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(props, setPage, isPro) {
        var pat, loader, ref, Comp, params, channels, blob;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pat = props.tool === "ai_music_generator" ? props.pat : null;
                    loader = pageMaps[props.tool];
                    return [
                        4,
                        Promise.all([
                            loader().then(function(imported) {
                                return imported.default;
                            }),
                            getParams(props.tool),
                            getChannels(props.tool, isPro, pat)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), Comp = ref[0], params = ref[1], channels = ref[2];
                    if (!(props.tool !== "ai_music_generator")) return [
                        3,
                        5
                    ];
                    if (!(props.location === "remote" && props.url)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,_utils_video__WEBPACK_IMPORTED_MODULE_7__/* .loadUrlToBlob */ .fj)(props.url)
                    ];
                case 2:
                    blob = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    if (props.location === "local" && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(props.blob, Blob)) {
                        blob = props.blob;
                    } else {
                        blob = null;
                    }
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    blob = null;
                    _state.label = 6;
                case 6:
                    setPage(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
                        params: params,
                        content: props,
                        blob: blob,
                        channels: channels
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadPageComponent.apply(this, arguments);
}
function EditorParamsProviders(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)({
        status: "idle"
    }), state = ref[0], setState = ref[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().userInfo;
    var openPage = (0,react__WEBPACK_IMPORTED_MODULE_11__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(props) {
            var isPro;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                setState({
                    status: "loading"
                });
                isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
                loadPageComponent(props, function(comp) {
                    return setState({
                        status: "done",
                        comp: comp
                    });
                }, isPro);
                return [
                    2
                ];
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }(), [
        userInfo
    ]);
    var closePage = (0,react__WEBPACK_IMPORTED_MODULE_11__.useCallback)(function() {
        setState({
            status: "idle"
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (state.status === "done") {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        state.status
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(EditorParamsContext.Provider, {
        value: {
            openPage: openPage,
            closePage: closePage,
            loading: state.status === "loading",
            isOpen: state.status === "done"
        },
        children: [
            props.children,
            state.status === "done" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("fixed inset-0 z-[100] flex overflow-y-scroll bg-color-background pt-[50px] tablet:pt-[70px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .Header */ .h4, {
                        isSolid: true,
                        isStatic: true
                    }),
                    state.comp
                ]
            })
        ]
    });
}
function useEditorFromIndexedDB(tool, schema) {
    var editorParams = useEditorParamsContext();
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_4__/* .useIndexedDB */ .i)("ai_art", tool, schema);
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_11__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("common").t;
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        function load() {
            return _load.apply(this, arguments);
        }
        function _load() {
            _load = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
                var props;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (editorParams.isOpen) {
                                return [
                                    2
                                ];
                            }
                            if (!(indexed.status === "ready")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                indexed.getData(_comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY)
                            ];
                        case 1:
                            props = _state.sent();
                            if (!props) {
                                return [
                                    2
                                ];
                            }
                            editorParams.openPage(props);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return _load.apply(this, arguments);
        }
        load();
    }, [
        editorParams,
        indexed,
        indexed.status,
        notify,
        t
    ]);
    var clearData = (0,react__WEBPACK_IMPORTED_MODULE_11__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (indexed.status !== "ready") {
                        console.error("Not ready");
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        indexed.clearData(_comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        indexed
    ]);
    return {
        clearData: clearData,
        editorParams: editorParams
    };
}
function useUploadOption(upload, tool) {
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_11__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    var editor = useEditorParamsContext();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("common").t;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().userInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var isPro = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_3__/* .getUserEntitlements */ .xx)(userInfo.entitlements).isPro;
    var data = (0,controllers_editors__WEBPACK_IMPORTED_MODULE_8__/* .getStorage */ .cF)(tool !== null && tool !== void 0 ? tool : "deform");
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_4__/* .useIndexedDB */ .i)("ai_art", data.tool, data.storage);
    if (!upload || !tool) return {};
    switch(tool){
        case "deform":
            {
                var onClick = function() {
                    if (userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                        return;
                    }
                    var fileInput = document.createElement("input");
                    fileInput.type = "file";
                    fileInput.accept = (0,_comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.getAcceptedMimes)();
                    fileInput.onchange = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_) {
                            var _files, file, isOk;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!fileInput.files) return [
                                            3,
                                            2
                                        ];
                                        _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(fileInput.files, 1), file = _files[0];
                                        return [
                                            4,
                                            isImageOrVideo(file)
                                        ];
                                    case 1:
                                        isOk = _state.sent();
                                        if (isOk && indexed.status === "ready") {
                                            indexed.setData({
                                                tool: "deform",
                                                id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                                inputs: (0,_comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.createInputs)({
                                                    type: "custom",
                                                    content: [
                                                        ""
                                                    ]
                                                }),
                                                promptType: "custom",
                                                location: "local",
                                                blob: file
                                            });
                                            router.push("/home?tool=deform");
                                        } else {
                                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                                children: t("txt_wrong_file_uploaded")
                                            }));
                                        }
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    fileInput.click();
                };
                var onDrop = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(files) {
                        var _files, file, isOk;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (userInfo.isAnonymous) {
                                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                        return [
                                            2
                                        ];
                                    }
                                    _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(files, 1), file = _files[0];
                                    if (!file) {
                                        return [
                                            2
                                        ];
                                    }
                                    return [
                                        4,
                                        isImageOrVideo(file)
                                    ];
                                case 1:
                                    isOk = _state.sent();
                                    if (isOk && indexed.status === "ready") {
                                        indexed.setData({
                                            tool: "deform",
                                            id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                            inputs: (0,_comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.createInputs)({
                                                type: "custom",
                                                content: [
                                                    ""
                                                ]
                                            }),
                                            promptType: "custom",
                                            location: "local",
                                            blob: file
                                        });
                                        router.push("/home?tool=deform");
                                    } else {
                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                            children: t("txt_wrong_file_uploaded")
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onDrop(files) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onDrop: onDrop,
                    onClick: onClick,
                    formats: [
                        "image/png",
                        "image/jpeg",
                        "video/mp4",
                        "video/quicktime", 
                    ]
                };
            }
        case "ai_restyle":
            {
                var onClick1 = function() {
                    if (userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                        return;
                    }
                    var fileInput = document.createElement("input");
                    fileInput.type = "file";
                    fileInput.accept = (0,_comps_editors_restyle__WEBPACK_IMPORTED_MODULE_14__.getAcceptedMimes)();
                    fileInput.onchange = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_) {
                            var _files, file, isOk;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!fileInput.files) return [
                                            3,
                                            2
                                        ];
                                        _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(fileInput.files, 1), file = _files[0];
                                        return [
                                            4,
                                            isImageOrVideo(file)
                                        ];
                                    case 1:
                                        isOk = _state.sent();
                                        if (isOk && indexed.status === "ready") {
                                            indexed.setData({
                                                tool: "ai_restyle",
                                                id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                                input: "",
                                                promptType: "custom",
                                                location: "local",
                                                blob: file
                                            });
                                            router.push("/home?tool=ai_restyle");
                                        } else {
                                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                                children: t("txt_wrong_file_uploaded")
                                            }));
                                        }
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    fileInput.click();
                };
                var onDrop1 = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(files) {
                        var _files, file, isOk;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (userInfo.isAnonymous) {
                                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                        return [
                                            2
                                        ];
                                    }
                                    _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(files, 1), file = _files[0];
                                    if (!file) {
                                        return [
                                            2
                                        ];
                                    }
                                    return [
                                        4,
                                        isImageOrVideo(file)
                                    ];
                                case 1:
                                    isOk = _state.sent();
                                    if (isOk && indexed.status === "ready") {
                                        indexed.setData({
                                            tool: "ai_restyle",
                                            id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                            input: "",
                                            promptType: "custom",
                                            location: "local",
                                            blob: file
                                        });
                                        router.push("/home?tool=ai_restyle");
                                    } else {
                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                            children: t("txt_wrong_file_uploaded")
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onDrop1(files) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onDrop: onDrop1,
                    onClick: onClick1,
                    formats: [
                        "video/mp4",
                        "video/quicktime"
                    ]
                };
            }
        case "ai_photo":
            {
                var onClick2 = function() {
                    if (userInfo.isAnonymous) {
                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                        return;
                    }
                    var fileInput = document.createElement("input");
                    fileInput.type = "file";
                    fileInput.accept = (0,_comps_editors_photo_ai__WEBPACK_IMPORTED_MODULE_13__.getAcceptedMimes)();
                    fileInput.onchange = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_) {
                            var _files, file, isOk;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!fileInput.files) return [
                                            3,
                                            2
                                        ];
                                        _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(fileInput.files, 1), file = _files[0];
                                        return [
                                            4,
                                            isImageOrVideo(file)
                                        ];
                                    case 1:
                                        isOk = _state.sent();
                                        if (isOk && indexed.status === "ready") {
                                            indexed.setData({
                                                tool: "ai_photo",
                                                id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                                input: "",
                                                promptType: "custom",
                                                location: "local",
                                                blob: file
                                            });
                                            router.push("/home?tool=ai_photo");
                                        } else {
                                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                                children: t("txt_wrong_file_uploaded")
                                            }));
                                        }
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    fileInput.click();
                };
                var onDrop2 = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(files) {
                        var _files, file, isOk;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (userInfo.isAnonymous) {
                                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                        return [
                                            2
                                        ];
                                    }
                                    _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(files, 1), file = _files[0];
                                    if (!file) {
                                        return [
                                            2
                                        ];
                                    }
                                    return [
                                        4,
                                        isImageOrVideo(file)
                                    ];
                                case 1:
                                    isOk = _state.sent();
                                    if (isOk && indexed.status === "ready") {
                                        indexed.setData({
                                            tool: "ai_photo",
                                            id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                            input: "",
                                            promptType: "custom",
                                            location: "local",
                                            blob: file
                                        });
                                        router.push("/home?tool=ai_photo");
                                    } else {
                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                            children: t("txt_wrong_file_uploaded")
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onDrop2(files) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onDrop: onDrop2,
                    onClick: onClick2,
                    formats: [
                        "image/png",
                        "image/jpeg"
                    ]
                };
            }
        case "text_to_image":
            {
                var onClick3 = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(prompt) {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            if (userInfo.isAnonymous) {
                                (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                return [
                                    2
                                ];
                            }
                            if (indexed.status === "ready") {
                                indexed.setData({
                                    tool: "text_to_image",
                                    id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                    promptType: null,
                                    text: prompt !== null && prompt !== void 0 ? prompt : "",
                                    location: "local",
                                    blob: null
                                });
                                router.push("/home?tool=text_to_image");
                            }
                            return [
                                2
                            ];
                        });
                    });
                    return function onClick3(prompt) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onClick: onClick3
                };
            }
        case "text_to_video":
            {
                var onClick4 = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(prompt) {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            if (userInfo.isAnonymous) {
                                (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                return [
                                    2
                                ];
                            }
                            editor.openPage({
                                tool: "text_to_video",
                                id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                promptType: null,
                                text: prompt !== null && prompt !== void 0 ? prompt : "",
                                location: "local",
                                blob: null
                            });
                            return [
                                2
                            ];
                        });
                    });
                    return function onClick4(prompt) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onClick: onClick4
                };
            }
        case "ai_music_generator":
            {
                var onClick5 = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
                        var pat, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (userInfo.isAnonymous) {
                                        (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                                        return [
                                            2
                                        ];
                                    }
                                    pat = "";
                                    if (!isPro) return [
                                        3,
                                        4
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].get */ .Z.get("/api/user-pat").then(function(res) {
                                            return res.data;
                                        })
                                    ];
                                case 2:
                                    pat = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    e = _state.sent();
                                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                                        children: t("txt_something_wrong")
                                    }));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    editor.openPage({
                                        tool: "ai_music_generator",
                                        id: _comps_editors_deform__WEBPACK_IMPORTED_MODULE_12__.DEFORUM_STORAGE_KEY,
                                        pat: pat
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onClick5() {
                        return _ref.apply(this, arguments);
                    };
                }();
                return {
                    onClick: onClick5
                };
            }
    }
}
function isImageFile(file) {
    return _isImageFile.apply(this, arguments);
}
function _isImageFile() {
    _isImageFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(file) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (!file.type.startsWith("image/")) {
                        resolve(false);
                        return;
                    }
                    var reader = new FileReader();
                    reader.onload = function() {
                        if (!reader.result) {
                            resolve(false);
                            return;
                        }
                        var blob = new Blob([
                            reader.result
                        ]);
                        createImageBitmap(blob).then(function(_ok) {
                            return resolve(true);
                        }, function(_err) {
                            return resolve(false);
                        });
                    };
                    reader.onerror = function() {
                        resolve(false);
                    };
                    reader.readAsArrayBuffer(file);
                })
            ];
        });
    });
    return _isImageFile.apply(this, arguments);
}
function isVideoFile(file) {
    return _isVideoFile.apply(this, arguments);
}
function _isVideoFile() {
    _isVideoFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(file) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (file.type === "video/mp4") {
                        file = (0,_utils_mime_types__WEBPACK_IMPORTED_MODULE_24__/* .changeMimeType */ .p)(file, "video/mp4");
                    }
                    if (!file.type.startsWith("video/")) {
                        resolve(false);
                        return;
                    }
                    var element = document.createElement("video");
                    element.preload = "metadata";
                    element.muted = true;
                    element.onloadedmetadata = function() {
                        return resolve(true);
                    };
                    element.onerror = function() {
                        resolve(false);
                    };
                    var url = URL.createObjectURL(file);
                    element.src = url;
                })
            ];
        });
    });
    return _isVideoFile.apply(this, arguments);
}
function isImageOrVideo(file) {
    return _isImageOrVideo.apply(this, arguments);
}
function _isImageOrVideo() {
    _isImageOrVideo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(file) {
        var isImage, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        isImageFile(file)
                    ];
                case 1:
                    isImage = _state.sent();
                    _tmp = isImage;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        isVideoFile(file)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return _isImageOrVideo.apply(this, arguments);
}
var defaultChannelsList = {
    data: {
        available_bitrates: [
            {
                bitrate: 32
            },
            {
                bitrate: 96
            },
            {
                bitrate: 128
            },
            {
                bitrate: 192
            },
            {
                bitrate: 256
            },
            {
                bitrate: 320
            }, 
        ],
        available_intensities: [
            {
                intensity: "low"
            },
            {
                intensity: "medium"
            },
            {
                intensity: "high"
            }, 
        ],
        categories: [
            {
                category_id: 0,
                name: "Moods",
                groups: [
                    {
                        group_id: 0,
                        name: "Calm",
                        playlist: "0.0"
                    },
                    {
                        group_id: 1,
                        name: "Energizing",
                        playlist: "0.1"
                    },
                    {
                        group_id: 2,
                        name: "Joyful",
                        playlist: "0.2"
                    },
                    {
                        group_id: 3,
                        name: "Sad",
                        playlist: "0.3"
                    },
                    {
                        group_id: 4,
                        name: "Tense",
                        playlist: "0.4"
                    },
                    {
                        group_id: 5,
                        name: "Beautiful",
                        playlist: "0.5"
                    },
                    {
                        group_id: 6,
                        name: "Erotic",
                        playlist: "0.6"
                    },
                    {
                        group_id: 7,
                        name: "Dreamy",
                        playlist: "0.7"
                    },
                    {
                        group_id: 8,
                        name: "Heroic",
                        playlist: "0.8"
                    },
                    {
                        group_id: 10,
                        name: "Scary",
                        playlist: "0.10"
                    }, 
                ]
            },
            {
                category_id: 1,
                name: "Focus",
                groups: [
                    {
                        group_id: 0,
                        name: "Minimal",
                        playlist: "1.0"
                    }, 
                ]
            },
            {
                category_id: 2,
                name: "Sleep",
                groups: [
                    {
                        group_id: 0,
                        name: "Ambient",
                        playlist: "2.0"
                    },
                    {
                        group_id: 1,
                        name: "Classical",
                        playlist: "2.1"
                    },
                    {
                        group_id: 2,
                        name: "Lullaby",
                        playlist: "2.2"
                    },
                    {
                        group_id: 3,
                        name: "Noise",
                        playlist: "2.3"
                    },
                    {
                        group_id: 4,
                        name: "Sounds",
                        playlist: "2.4"
                    }, 
                ]
            },
            {
                category_id: 3,
                name: "Calm",
                groups: [
                    {
                        group_id: 0,
                        name: "Ambient",
                        playlist: "3.0"
                    },
                    {
                        group_id: 1,
                        name: "Chill",
                        playlist: "3.1"
                    }, 
                ]
            },
            {
                category_id: 4,
                name: "Chill",
                groups: [
                    {
                        group_id: 0,
                        name: "Chillout",
                        playlist: "4.0"
                    },
                    {
                        group_id: 1,
                        name: "Ethnic",
                        playlist: "4.1"
                    },
                    {
                        group_id: 2,
                        name: "Summer",
                        playlist: "4.2"
                    },
                    {
                        group_id: 3,
                        name: "Travel",
                        playlist: "4.3"
                    }, 
                ]
            },
            {
                category_id: 5,
                name: "Sport",
                groups: [
                    {
                        group_id: 0,
                        name: "Fitness",
                        playlist: "5.0"
                    },
                    {
                        group_id: 1,
                        name: "Cardio",
                        playlist: "5.1"
                    },
                    {
                        group_id: 2,
                        name: "Running",
                        playlist: "5.2"
                    },
                    {
                        group_id: 3,
                        name: "Yoga",
                        playlist: "5.3"
                    }, 
                ]
            },
            {
                category_id: 6,
                name: "Genres",
                groups: [
                    {
                        group_id: 0,
                        name: "EDM",
                        playlist: "6.0"
                    },
                    {
                        group_id: 1,
                        name: "House",
                        playlist: "6.1"
                    },
                    {
                        group_id: 2,
                        name: "Techno",
                        playlist: "6.2"
                    },
                    {
                        group_id: 3,
                        name: "Chill",
                        playlist: "6.3"
                    },
                    {
                        group_id: 4,
                        name: "Hiphop",
                        playlist: "6.4"
                    },
                    {
                        group_id: 5,
                        name: "Ambient",
                        playlist: "6.5"
                    },
                    {
                        group_id: 6,
                        name: "Electronica",
                        playlist: "6.6"
                    },
                    {
                        group_id: 7,
                        name: "Trance",
                        playlist: "6.7"
                    },
                    {
                        group_id: 8,
                        name: "Drumnbass",
                        playlist: "6.8"
                    },
                    {
                        group_id: 9,
                        name: "Dub",
                        playlist: "6.9"
                    },
                    {
                        group_id: 10,
                        name: "Bass",
                        playlist: "6.10"
                    },
                    {
                        group_id: 11,
                        name: "Breakbeat",
                        playlist: "6.11"
                    },
                    {
                        group_id: 12,
                        name: "Jazz & Funk",
                        playlist: "6.12"
                    },
                    {
                        group_id: 13,
                        name: "Disco",
                        playlist: "6.13"
                    },
                    {
                        group_id: 15,
                        name: "Pop",
                        playlist: "6.15"
                    },
                    {
                        group_id: 16,
                        name: "Rock & Metal",
                        playlist: "6.16"
                    },
                    {
                        group_id: 17,
                        name: "Classical",
                        playlist: "6.17"
                    },
                    {
                        group_id: 18,
                        name: "Folk",
                        playlist: "6.18"
                    }, 
                ]
            },
            {
                category_id: 10,
                name: "Countries",
                groups: [
                    {
                        group_id: 0,
                        name: "India",
                        playlist: "10.0"
                    }, 
                ]
            }, 
        ]
    }
};


/***/ }),

/***/ 6685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ShareSection; },
/* harmony export */   "Df": function() { return /* binding */ ScriptSection; },
/* harmony export */   "Im": function() { return /* binding */ SessionName; },
/* harmony export */   "Oz": function() { return /* binding */ TryNowButton; },
/* harmony export */   "Z0": function() { return /* binding */ SocialButton; },
/* harmony export */   "qC": function() { return /* binding */ UsernameFollowSection; },
/* harmony export */   "wK": function() { return /* binding */ AdExamplesPopup; }
/* harmony export */ });
/* unused harmony export getRelated */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_advanced_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8673);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5896);
/* harmony import */ var _comps_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(599);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9034);
/* harmony import */ var _comps_player__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1993);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4165);
/* harmony import */ var _comps_subscription_popup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9460);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1816);
/* harmony import */ var _utils_millions__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(323);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4371);
/* harmony import */ var _utils_tutorial__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4286);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2706);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8767);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2337);
/* harmony import */ var sections_history_generations__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5170);
/* harmony import */ var sections_history_history_popup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1027);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1501);
/* harmony import */ var _all_gallery__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6106);
/* harmony import */ var _single_gallery__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6622);
































var RELATED_LIMIT = 9;
function getRelated(id, limit) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_24__/* ["default"].post */ .Z.post("/api/ad-examples-related", {
                            id: id,
                            limit: limit
                        }).then(function(response) {
                            return response.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function AdExamplesPopup(init) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(init), props = ref[0], setProps = ref[1];
    var entity = props.entity, onClose = props.onClose;
    var preview_thumbnail_url = entity.preview_thumbnail_url, aspect = entity.aspect, preview_video_url = entity.preview_video_url;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var thumbnail = preview_thumbnail_url.startsWith("https://") ? preview_thumbnail_url : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return function() {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "ad-examples-popup",
        onClick: function(e) {
            var target = e.target;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(target, HTMLElement)) {
                if (target.id === "ad-examples-popup") {
                    onClose();
                }
            }
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("fixed left-0 top-0 z-[100] flex h-screen w-screen bg-color-popup tablet:h-screen", "no-scrollbar overflow-y-scroll tablet:items-start tablet:justify-center tablet:pb-[50px] tablet:pt-[100px] desktop:items-center desktop:p-0"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("w-full tablet:h-auto tablet:w-[564px] desktop:h-[660px] desktop:w-[1070px]", "relative flex flex-col bg-color-popup-cell tablet:rounded-[10px] desktop:flex-row"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function(e) {
                        e.preventDefault();
                        onClose();
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute left-4 top-4 z-20 h-10 w-10 rounded-full bg-color-white/20 tablet:h-8 tablet:w-8 tablet:bg-color-popup-cell", "flex items-center justify-center tablet:left-auto tablet:right-[-40px] tablet:top-0"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative h-4 w-4 rotate-45",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-1/2 top-0 h-4 w-[2px] -translate-x-[1px] rounded-sm bg-color-white tablet:bg-blue-700"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute left-0 top-1/2 h-[2px] w-4 -translate-y-[1px] rounded-sm bg-color-white tablet:bg-blue-700"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative flex w-full shrink-0 overflow-hidden", "tablet:h-[667px] tablet:items-center tablet:justify-center tablet:rounded-t-[10px]", "desktop:h-full desktop:w-auto desktop:flex-1 desktop:rounded-l-[10px] desktop:rounded-tr-none"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("absolute inset-0 h-full w-full overflow-hidden bg-color-black filter", "hidden overflow-hidden tablet:block desktop:rounded-r-none"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: thumbnail,
                                alt: "preview image",
                                className: "h-full w-full scale-110 object-cover opacity-30 blur-lg"
                            })
                        }),
                        preview_video_url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: {
                                aspectRatio: aspect
                            },
                            className: "relative z-10 w-full tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] tablet:rounded-t-[10px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[20px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                    style: {
                                        aspectRatio: aspect
                                    },
                                    src: preview_video_url,
                                    poster: thumbnail,
                                    ref: videoRef,
                                    autoPlay: true,
                                    loop: true,
                                    playsInline: true,
                                    className: "relative z-10 w-full tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] tablet:rounded-t-[10px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[10px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(video_provider__WEBPACK_IMPORTED_MODULE_19__/* .VideoProvider */ .G, {
                                    remember: [],
                                    element: videoRef,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute bottom-0 left-0 z-50 w-full text-color-white",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_6__/* .Timeline */ .TY, {
                                                radius: "0px 0px 10px 10px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_6__/* .PlayWithProvider */ .uX, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoSection, {
                    props: props,
                    setProps: setProps
                })
            ]
        })
    });
}
function InfoSection(init) {
    var ref;
    var _props = init.props, entity = _props.entity, startNewSessionWithMessage = _props.startNewSessionWithMessage, onClose = _props.onClose;
    var owner = entity.owner, title = entity.title, created_at = entity.created_at, share_url = entity.share_url, script = entity.script, description = entity.description, preview_video_url = entity.preview_video_url, preview_thumbnail_url = entity.preview_thumbnail_url, id = entity.id;
    var thumbnail = preview_thumbnail_url.startsWith("https://") ? preview_thumbnail_url : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "no-scrollbar w-full bg-color-popup-cell pb-[90px] pt-4 tablet:overflow-y-scroll tablet:rounded-b-[10px] tablet:py-4 desktop:h-full desktop:w-[408px] desktop:rounded-r-[10px] desktop:rounded-bl-none",
        children: [
            owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsernameFollowSection, {
                uid: owner.uid,
                username: owner.username,
                follow_status: owner.follow_status,
                profile_pic: (ref = owner.profile_pic) === null || ref === void 0 ? void 0 : ref.original,
                followers: owner.followers
            }),
            owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-4 mt-3 h-[1px] flex-1 shrink-0 bg-color-separator"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SessionName, {
                title: title,
                created_at: created_at,
                hasOwner: owner ? true : false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShareSection, {
                share_url: share_url !== null && share_url !== void 0 ? share_url : "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_12__/* .APP_HOST */ .b, "/ad-examples/single/").concat(id),
                videoUrl: preview_video_url,
                previewImage: thumbnail !== null && thumbnail !== void 0 ? thumbnail : "",
                id: id,
                title: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-4 mt-3 h-[1px] flex-1 shrink-0 bg-color-separator"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScriptSection, {
                script: script,
                description: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TryNowButton, {
                description: description,
                startNewSessionWithMessage: startNewSessionWithMessage,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedSection, {
                props: init.props,
                setProps: init.setProps
            })
        ]
    });
}
function UsernameFollowSection(props) {
    var uid = props.uid, username = props.username, followers = props.followers, follow_status = props.follow_status, profile_pic = props.profile_pic;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)().userInfo;
    var isSelf = uid === userInfo.userId;
    var follow = follow_status !== undefined ? _utils_tutorial__WEBPACK_IMPORTED_MODULE_11__/* .followStatusMap */ .Xy[follow_status] : null;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(follow), followStatus = ref[0], setFollowStatus = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full flex-row justify-between px-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                href: "/".concat(username),
                className: "flex flex-row items-center justify-center gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: profile_pic !== null && profile_pic !== void 0 ? profile_pic : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/avatar.svg"),
                        onError: function(e) {
                            return e.currentTarget.src = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/general/avatar.svg");
                        },
                        alt: "".concat(username, " avatar"),
                        className: "h-10 w-10 rounded-full border border-color-separator bg-color-background object-cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "max-w-[150px] truncate text-[16px] font-700 text-blue-800",
                                children: username
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[12px] font-400 text-blue-600",
                                children: (0,_utils_millions__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(followers) + " followers"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row gap-4",
                children: !isSelf && followStatus !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_2__/* .FollowButton */ .eg, {
                    followStatus: followStatus,
                    uid: uid,
                    setFollowStatus: setFollowStatus,
                    userPage: false,
                    className: "!w-[106px] !min-w-0 !items-center !justify-center !rounded-[6px] !p-0 !text-center"
                })
            })
        ]
    });
}
function TryNowButton(props) {
    var description = props.description, startNewSessionWithMessage = props.startNewSessionWithMessage, onClose = props.onClose;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)().userInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), subscriptionPopupOpen = ref1[0], setSubscriptionPopupOpen = ref1[1];
    function handleTryNow() {
        return _handleTryNow.apply(this, arguments);
    }
    function _handleTryNow() {
        _handleTryNow = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                setIsLoading(true);
                if (userInfo.isAnonymous) {
                    router.push("/login?redirect_url=/chat?initial_message=".concat(description));
                    setIsLoading(false);
                    return [
                        2
                    ];
                }
                if (startNewSessionWithMessage && onClose) {
                    startNewSessionWithMessage(description);
                    onClose();
                } else {
                    router.push("/chat?initial_message=" + description);
                }
                setIsLoading(false);
                return [
                    2
                ];
            });
        });
        return _handleTryNow.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden w-full px-4 pt-3 tablet:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    text: "txt_try_now",
                    primary: true,
                    full: true,
                    disabled: isLoading,
                    loading: isLoading,
                    onClick: handleTryNow,
                    className: "!w-full !max-w-none"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed bottom-0 left-0 z-30 w-full border-t border-color-separator bg-color-cell p-4 tablet:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    text: "txt_try_now",
                    primary: true,
                    full: true,
                    disabled: isLoading,
                    loading: isLoading,
                    className: "!w-full !max-w-none"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_subscription_popup__WEBPACK_IMPORTED_MODULE_8__/* .SubscriptionPopup */ .yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: router.asPath
            })
        ]
    });
}
function ScriptSection(props) {
    var script = props.script, description = props.description;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_10__/* .NotificationContext */ .u).notify;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)().t;
    var textRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    function handleCopyText(e, text) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(e, text) {
            var target, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    if (!script && !description) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full flex-row pl-4 pr-6 pt-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: textRef,
                className: "popup-markdown-container no-scrollbar max-h-[200px] flex-1 overflow-y-scroll pr-3 font-mono text-[12px] font-400 text-blue-700",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_markdown__WEBPACK_IMPORTED_MODULE_4__/* .Markdown */ .U, {
                    markdown: (ref = script !== null && script !== void 0 ? script : description) !== null && ref !== void 0 ? ref : ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function(e) {
                    var ref;
                    return handleCopyText(e, (ref2 = (ref1 = (ref = textRef.current) === null || ref === void 0 ? void 0 : ref.innerText) !== null && ref1 !== void 0 ? ref1 : description) !== null && ref2 !== void 0 ? ref2 : "");
                },
                className: "h-[20px] w-[20px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                    alt: "copy",
                    className: "h-full"
                })
            })
        ]
    });
}
function ShareSection(props) {
    var share_url = props.share_url, videoUrl = props.videoUrl, previewImage = props.previewImage, title = props.title, id = props.id;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_10__/* .NotificationContext */ .u).notify;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), downloadApi = ref[0], setDownloadApi = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (downloadApi) return;
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isIOS || isSafari) {
            setDownloadApi(true);
            return;
        }
    }, [
        downloadApi
    ]);
    function handleCopyText(e) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(e) {
            var target, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(share_url)
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("relative flex w-full shrink-0 items-start gap-[8px] px-[16px]", "no-scrollbar overflow-x-auto pt-4 desktop:justify-between"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: !videoUrl ? "/api/download-music?link=".concat(encodeURIComponent(previewImage)) : downloadApi ? "/api/download-video?link=".concat(encodeURIComponent(videoUrl), "&name=").concat(encodeURIComponent(title)) : videoUrl,
                onClick: function() {
                    return axios__WEBPACK_IMPORTED_MODULE_24__/* ["default"].post */ .Z.post("/api/wizard-save-result-event", {
                        result_id: id
                    });
                },
                datatype: "mp4",
                download: title + ".mp4",
                target: "_blank",
                rel: "noreferrer noopener",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex items-center justify-center", "transition-colors hover:bg-blue-300", "h-[44px] w-[44px] shrink-0 rounded-full bg-color-surface"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/ai-tools/history/save-primary.svg"),
                    alt: "copy icon",
                    className: "h-[20px] w-[20px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: handleCopyText,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex items-center justify-center", "transition-colors hover:bg-blue-300", "h-[44px] w-[44px] shrink-0 rounded-full bg-color-surface"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_27__/* .assetUrl */ .p)("/ai-tools/history/copy-primary.svg"),
                    alt: "copy icon",
                    className: "h-[20px] w-[20px]"
                })
            }),
            sections_history_generations__WEBPACK_IMPORTED_MODULE_17__/* .socials.map */ .UY.map(function(props) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(SocialButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)({}, props), {
                    slug: share_url,
                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                }));
            })
        ]
    });
}
function SessionName(props) {
    var title = props.title, created_at = props.created_at, hasOwner = props.hasOwner;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex flex-col px-4", hasOwner && "pt-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[16px] font-500 text-blue-700",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[14px] font-400 text-blue-500",
                children: (0,sections_history_history_popup__WEBPACK_IMPORTED_MODULE_18__/* .formatTimes */ .Nf)(created_at)
            })
        ]
    });
}
function RelatedSection(init) {
    var ref, ref1, ref2;
    var props = init.props, setProps = init.setProps;
    var id = props.entity.id;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)().t;
    var related = (0,react_query__WEBPACK_IMPORTED_MODULE_15__.useQuery)({
        queryKey: [
            "related-ad-examples",
            "ad-example-".concat(id)
        ],
        queryFn: getRelated(id, RELATED_LIMIT),
        staleTime: Infinity
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-4",
                children: [
                    !related.isError && ((ref = related.data) === null || ref === void 0 ? void 0 : ref.searches.length) !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "px-4 text-[14px] font-500 tracking-normal text-blue-600",
                        children: t("txt_related_keywords")
                    }),
                    (related.isFetching || related.isSuccess) && ((ref1 = related.data) === null || ref1 === void 0 ? void 0 : ref1.searches.length) !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "no-scrollbar flex h-[36px] w-full shrink-0 flex-row gap-[10px] overflow-x-scroll px-4 pt-[6px]",
                        children: [
                            related.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_all_gallery__WEBPACK_IMPORTED_MODULE_20__/* .SuggestionsSkeleton */ .HI, {}),
                            related.isSuccess && related.data.searches.map(function(keyword) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/ad-examples/".concat(keyword),
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("flex h-full shrink-0 flex-row items-center", "justify-center rounded-[6px] bg-color-surface p-3", "text-[13px] font-400 tracking-wider text-blue-700"),
                                    children: keyword
                                }, keyword);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-4",
                children: [
                    !related.isError && ((ref2 = related.data) === null || ref2 === void 0 ? void 0 : ref2.related.length) !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mt-3 px-4 text-[14px] font-500 tracking-normal text-blue-600",
                        children: t("txt_relevant_ads")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        columnsCount: 2,
                        gutter: "8px",
                        className: "px-4 pt-[6px]",
                        children: [
                            related.isFetching && _single_gallery__WEBPACK_IMPORTED_MODULE_21__/* .skeletonList.map */ .ju.map(function(height, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        height: height
                                    },
                                    className: "w-full overflow-hidden rounded-[12px] desktop:rounded-[14px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_7__/* .SizedSkeleton */ .xB, {
                                        className: "h-full w-full"
                                    })
                                }, index);
                            }),
                            related.isSuccess && related.data.related.map(function(single) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    style: {
                                        aspectRatio: single.aspect
                                    },
                                    href: "/ad-examples/single/".concat(single.id),
                                    onClick: function(e) {
                                        e.preventDefault();
                                        var newUrl = "/ad-examples/single/".concat(single.id);
                                        window.history.pushState({
                                            path: newUrl
                                        }, "", newUrl);
                                        setProps({
                                            entity: single,
                                            onClose: props.onClose
                                        });
                                    },
                                    className: "cursor-pointer rounded-[10px] bg-color-skeleton",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("w-full overflow-hidden object-cover", "rounded-[10px]"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                            src: single.preview_video_url + "#t=0.001",
                                            poster: single.preview_thumbnail_url.startsWith("https://") ? single.preview_thumbnail_url : undefined,
                                            playsInline: true,
                                            loop: true,
                                            preload: "none",
                                            muted: true,
                                            onPointerEnter: function(e) {
                                                e.currentTarget.play().catch(console.error);
                                            },
                                            onPointerLeave: function(e) {
                                                e.currentTarget.pause();
                                                e.currentTarget.currentTime = 0.001;
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("h-full w-full object-cover", "min-h-[130px] rounded-[10px] desktop:min-h-[180px]")
                                        })
                                    })
                                }, single.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function SocialButton(props) {
    var onClick = props.onClick, url = props.url, slug = props.slug, desktop = props.desktop, className = props.className;
    var imageClasses = "hover:bg-blue-300 bg-color-surface transition-colors p-2 desktop:w-full h-full " + className;
    var anchorClasses = "flex overflow-hidden rounded-full shrink-0 pointer-events-auto w-11 h-11";
    var desktopUrl = onClick ? undefined : desktop ? desktop(slug) : url && url(slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                href: desktopUrl,
                onClick: function() {
                    return onClick && onClick(slug);
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("hidden desktop:block", onClick && "cursor-pointer", anchorClasses),
                children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: props.icon,
                    className: imageClasses,
                    alt: "social icon"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.dark,
                            alt: "social icon",
                            "data-hide-on-theme": "light",
                            className: imageClasses
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.light,
                            alt: "social icon",
                            "data-hide-on-theme": "dark",
                            className: imageClasses
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)("desktop:hidden", anchorClasses, onClick && "cursor-pointer"),
                href: url && url(slug),
                children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: props.icon,
                    className: imageClasses,
                    alt: "social anchor icon"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.dark,
                            "data-hide-on-theme": "light",
                            alt: "dark icon",
                            className: imageClasses
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.light,
                            alt: "light icon",
                            "data-hide-on-theme": "dark",
                            className: imageClasses
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 8106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ SingleAd; },
/* harmony export */   "Bp": function() { return /* binding */ FilterDialogAdExamples; },
/* harmony export */   "HP": function() { return /* binding */ RatioAdExamples; },
/* harmony export */   "iV": function() { return /* binding */ AdExamplesGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8673);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1455);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5896);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3153);
/* harmony import */ var _comps_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9980);
/* harmony import */ var _comps_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4773);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(177);
/* harmony import */ var _utils_discover__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3300);
/* harmony import */ var _utils_infinite__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(275);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7294);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2337);
/* harmony import */ var sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8067);
/* harmony import */ var _all_gallery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6106);

















function AdExamplesGrid(props) {
    var handleSeeMore = function handleSeeMore(id) {
        dispatch({
            type: "set_search_query",
            searchQuery: id
        });
        dispatch({
            type: "apply_filters"
        });
        setName(id);
        var searchUrl = (0,_all_gallery__WEBPACK_IMPORTED_MODULE_13__/* .getUrlFromString */ .K5)(id);
        var newUrl = "/ad-examples/".concat(encodeURIComponent(searchUrl));
        if (isDashboard) {
            newUrl = "/discover?filter=ad-examples&q=".concat(encodeURIComponent(searchUrl));
        }
        window.history.pushState({
            path: newUrl
        }, "", newUrl);
    };
    var setPopupState = props.setPopupState, isDashboard = props.isDashboard, startNewSessionWithMessage = props.startNewSessionWithMessage;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useAdExamplesViewContext */ .s3)(), query = ref.query, state = ref.state, dispatch = ref.dispatch;
    var lastRowRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(state.applyFilters.searchQuery), name = ref1[0], setName = ref1[1];
    (0,_utils_infinite__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(query, lastRowRef, 1000);
    var prevQueryKeyComponentsRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)([
        state.applyFilters, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        var currentQueryKeyComponents = [
            state.applyFilters
        ];
        setName(state.applyFilters.searchQuery);
        if (!(0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .arraysAreEqual */ .sK)(currentQueryKeyComponents, prevQueryKeyComponentsRef.current)) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            prevQueryKeyComponentsRef.current = currentQueryKeyComponents;
        }
    }, [
        state.applyFilters
    ]);
    var flatHome = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(function() {
        var ref;
        var flatHomeArray = [];
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.forEach(function(page) {
            if (page.data.type === "home") {
                page.data.content.forEach(function(section) {
                    var flattenedSection = [];
                    var seenIds = new Set();
                    section.results.forEach(function(template) {
                        if (!seenIds.has(template.id)) {
                            seenIds.add(template.id);
                            flattenedSection.push(template);
                        }
                    });
                    flatHomeArray.push({
                        title: section.title,
                        query: section.query,
                        results: flattenedSection
                    });
                });
            }
        });
        return flatHomeArray;
    }, [
        query.data
    ]);
    var flatSearched = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(function() {
        var ref;
        var flattenedSection = [];
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.forEach(function(page) {
            if (page.data.type === "searched") {
                var seenIds = new Set();
                page.data.content.forEach(function(section) {
                    if (!seenIds.has(section.id)) {
                        seenIds.add(section.id);
                        flattenedSection.push(section);
                    }
                });
            }
        });
        return flattenedSection;
    }, [
        query.data
    ]);
    var noTemplates = query.isSuccess && !query.isFetching && flatHome.length === 0 && flatSearched.length === 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("mx-auto my-5 flex w-full flex-col gap-3 tablet:gap-4 desktop:my-0 desktop:gap-5 desktop:px-0", isDashboard ? "overflow-hidden tablet:w-full" : "tablet:w-[768px] desktop:w-[1175px]"),
                children: [
                    name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex flex-row items-center gap-1 px-4 desktop:mt-5", isDashboard ? "desktop:px-5" : "desktop:px-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isDashboard ? "/discover?filter=ad-examples" : "/ad-examples",
                                className: "cursor-pointer text-[17px] font-500 text-blue-600",
                                children: t("lbl_ad_examples")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex [--icon-color:var(--color-blue-500)]",
                                children: BreadCrumb()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-[17px] font-500 text-blue-800",
                                children: name.charAt(0).toUpperCase() + name.slice(1)
                            })
                        ]
                    }),
                    flatHome.length !== 0 && flatHome.map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-full flex-col gap-3 tablet:px-4 desktop:px-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex w-full flex-row justify-between px-4 tablet:px-0 desktop:mt-5", isDashboard ? "desktop:px-5" : "desktop:px-0"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: " text-[14px] font-700 text-blue-700 tablet:text-[18px]",
                                            children: String(item.title).toUpperCase()
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/ad-examples/" + encodeURIComponent((0,_all_gallery__WEBPACK_IMPORTED_MODULE_13__/* .getUrlFromString */ .K5)(item.title)),
                                            onClick: function(e) {
                                                e.preventDefault();
                                                handleSeeMore(item.title);
                                            },
                                            className: "text-[14px] font-500 text-primary-600 tablet:text-[16px]",
                                            children: t("txt_see_more")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("no-scrollbar w-full gap-[10px] overflow-x-scroll px-4", "-mb-[1000px] pb-[1000px] tablet:gap-3", isDashboard ? "grid grid-flow-col overflow-y-hidden tablet:px-0 desktop:px-5" : "flex flex-row tablet:overflow-hidden tablet:px-0 desktop:grid desktop:grid-cols-5 desktop:gap-5 desktop:px-0"),
                                    children: isDashboard ? item.results.map(function(single) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleAd, {
                                            entity: single,
                                            setPopupState: setPopupState,
                                            isDashboard: true,
                                            startNewSessionWithMessage: startNewSessionWithMessage
                                        }, single.id);
                                    }) : item.results.slice(0, 5).map(function(single) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleAd, {
                                            entity: single,
                                            setPopupState: setPopupState,
                                            isGrid: true,
                                            startNewSessionWithMessage: startNewSessionWithMessage
                                        }, single.id);
                                    })
                                })
                            ]
                        }, item.title + index);
                    }),
                    flatSearched.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__/* .ResponsiveMasonry */ .G, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("mx-auto gap-3 p-4 tablet:gap-4 desktop:gap-[15px] desktop:px-0 desktop:pt-4", isDashboard ? "w-full desktop:px-5" : "w-full tablet:w-[768px] desktop:w-[1175px]"),
                        columnsCountBreakPoints: isDashboard ? {
                            1: 2,
                            760: 3,
                            900: 4,
                            1200: 5,
                            1500: 6
                        } : {
                            1: 2,
                            760: 4,
                            1280: 5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            gutter: "12px",
                            children: flatSearched.map(function(single) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleAd, {
                                    entity: single,
                                    setPopupState: setPopupState,
                                    startNewSessionWithMessage: startNewSessionWithMessage
                                }, single.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: lastRowRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full justify-center p-8",
                children: query.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
            }),
            noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIconContainer */ .U$, {
                className: "pb-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIcon */ .mB, {
                        source: "/general/empty-templates"
                    }),
                    t("txt_no_result_yet")
                ]
            })
        ]
    });
}
function SingleAd(props) {
    var ref;
    var entity = props.entity, isGrid = props.isGrid, setPopupState = props.setPopupState, isDashboard = props.isDashboard, startNewSessionWithMessage = props.startNewSessionWithMessage;
    var id = entity.id, aspect = entity.aspect, description = entity.description, preview_thumbnail_url = entity.preview_thumbnail_url, preview_video_url = entity.preview_video_url, owner = entity.owner;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), isHovered = ref1[0], setIsHovered = ref1[1];
    var thumbnail = preview_thumbnail_url.startsWith("https://") ? preview_thumbnail_url : undefined;
    var randomNumber = Math.floor(aspect * 100);
    var isLandscape = aspect > 1.5;
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__/* .skeletonColors */ .e[randomNumber % sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__/* .skeletonColors.length */ .e.length],
            aspectRatio: aspect
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("group relative shrink-0 rounded-[6px]", isGrid && "w-[164px] tablet:w-[172px] desktop:w-full", isDashboard && "w-[164px] tablet:w-[172px] desktop:w-[215px]", !isDashboard && !isGrid && "w-full"),
        children: [
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("absolute bottom-0 left-0 z-10 hidden w-full pt-3 desktop:block", "pointer-events-none opacity-0 transition-all group-hover:pointer-events-auto group-hover:opacity-100", "rounded-b-[6px]", "bg-gradient-to-t from-color-black/80 to-[transparent]", "flex cursor-auto flex-col items-center"),
                children: [
                    description.trim().length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onMouseEnter: function() {
                            if (isLandscape) return;
                            setIsHovered(true);
                        },
                        onMouseLeave: function() {
                            if (isLandscape) return;
                            setIsHovered(false);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("peer relative flex w-full flex-row items-end justify-between p-3 pt-0"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .TextTooltip */ .JI, {
                            showAlways: description.length > 144,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("max-w-full pr-6"),
                            title: description,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("text-sm font-400 text-color-white transition-[max-height]", isHovered ? "line-clamp-4 max-h-[80px] whitespace-normal" : "max-h-[20px] truncate", isLandscape && "truncate"),
                                children: description
                            })
                        })
                    }),
                    owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "/".concat(owner.username),
                        className: "flex flex-row items-center gap-[6px] p-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (ref2 = (ref = owner.profile_pic) === null || ref === void 0 ? void 0 : ref.original) !== null && ref2 !== void 0 ? ref2 : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .assetUrl */ .p)("/general/avatar.svg"),
                                onError: function(e) {
                                    return e.currentTarget.src = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_15__/* .assetUrl */ .p)("/general/avatar.svg");
                                },
                                alt: "".concat(owner.username, " avatar"),
                                className: "h-[24px] w-[24px] rounded-full border border-color-separator bg-color-background object-cover"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "hidden w-[70px] truncate text-[12px] font-600 text-color-white desktop:block",
                                children: owner.username
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/ad-examples/single/".concat(id),
                onClick: function(e) {
                    var onClose = function onClose() {
                        if (!setPopupState) return;
                        if (isDashboard) {
                            window.history.pushState({
                                path: "/discover?filter=ad-examples"
                            }, "", "/discover?filter=ad-examples");
                        } else {
                            window.history.pushState({
                                path: "/ad-examples"
                            }, "", "/ad-examples");
                        }
                        setPopupState(null);
                    };
                    if (!setPopupState) return;
                    e.preventDefault();
                    var newUrl = "/ad-examples/single/".concat(id);
                    window.history.pushState({
                        path: newUrl
                    }, "", newUrl);
                    setPopupState({
                        entity: entity,
                        onClose: onClose,
                        startNewSessionWithMessage: startNewSessionWithMessage
                    });
                },
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("w-full overflow-hidden object-cover", "rounded-[6px]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex h-full flex-row gap-12",
                        children: preview_video_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: preview_video_url,
                            poster: thumbnail,
                            playsInline: true,
                            loop: true,
                            preload: "none",
                            muted: true,
                            onPointerEnter: function(e) {
                                e.currentTarget.play().catch(console.error);
                            },
                            onPointerLeave: function(e) {
                                e.currentTarget.pause();
                                e.currentTarget.currentTime = 0.001;
                            },
                            style: {
                                aspectRatio: aspect
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("h-full w-full object-cover", "rounded-[6px]")
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: thumbnail,
                            alt: "thumbnail",
                            style: {
                                aspectRatio: aspect
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("h-full w-full object-cover", "rounded-[6px]")
                        })
                    })
                })
            })
        ]
    });
}
var aspectLabels = {
    "99": {
        width: null,
        height: null,
        label: "txt_all"
    },
    "9:16": {
        width: 11.6,
        height: 20,
        label: "txt_portrait"
    },
    "16:9": {
        width: 20,
        height: 11.6,
        label: "txt_landscape"
    },
    "1:1": {
        width: 20,
        height: 20,
        label: "txt_square"
    },
    "4:5": {
        width: 12.9,
        height: 16,
        label: "txt_four_on_five"
    },
    "5:4": {
        width: 16,
        height: 12.9,
        label: "txt_five_on_four"
    }
};
var aspectOptions = [
    "99",
    "9:16",
    "16:9",
    "1:1",
    "4:5",
    "5:4", 
];
function RatioAdExamples(props) {
    var setAspect = function setAspect(aspect) {
        dispatch({
            type: "set_aspect",
            aspect: aspect
        });
        dispatch({
            type: "apply_filters"
        });
    };
    var isDashboard = props.isDashboard;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useAdExamplesViewContext */ .s3)(), state = ref.state, dispatch = ref.dispatch;
    var aspect = state.aspect;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    var currentLabel = aspectLabels[aspect !== null && aspect !== void 0 ? aspect : "99"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        hover: true,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("group tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]", isDashboard ? "bg-blue-50" : "bg-color-cell dark:bg-color-background"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-[10px]", "tablet:h-10 tablet:rounded-[6px]", "tablet:w-[194px] desktop:h-11 desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[14px] font-500 text-blue-500",
                    children: t("txt_ratio")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-row items-center gap-[6px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[14px] font-500 text-blue-700",
                            children: t(currentLabel.label)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex h-[18px] w-[18px] -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-10 pt-2 tablet:w-[194px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full rounded-[8px] bg-color-popup-cell p-[10px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full flex-col gap-1",
                    children: aspectOptions.map(function(option) {
                        var label = aspectLabels[option].label;
                        var width = aspectLabels[option].width;
                        var height = aspectLabels[option].height;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            onClick: function() {
                                return setAspect(option !== "99" ? option : null);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex h-10 w-full cursor-pointer items-center gap-[10px] rounded-[4px] px-[6px] text-[14px] font-500 text-blue-900 transition-all", (aspect !== null ? aspect === option : option === "99") ? " bg-color-surface" : " hover:bg-color-surface"),
                            children: [
                                width && height ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex h-5 w-5 items-center justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            width: width,
                                            height: height
                                        },
                                        className: "rounded-[3px] border-[1.7px] border-blue-900"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex h-5 w-5 items-center justify-center [--icon-color:var(--color-blue-900)]",
                                    children: AllRatio()
                                }),
                                t(label)
                            ]
                        }, option);
                    })
                })
            })
        })
    });
}
function FilterDialogAdExamples(props) {
    var isOpen = props.isOpen, setIsOpen = props.setIsOpen;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_7__/* .useAdExamplesViewContext */ .s3)(), state = ref.state, dispatch = ref.dispatch;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)().t;
    var aspect = state.aspect;
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
        setIsOpen(false);
    };
    var setRatio = function(aspect) {
        dispatch({
            type: "set_aspect",
            aspect: aspect
        });
    };
    var apply = function() {
        dispatch({
            type: "apply_filters"
        });
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:hidden", !isOpen && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
            id: "filter-popup",
            onClick: function(event) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(event.target, Element)) {
                    if (event.target.id === event.currentTarget.id) {
                        setIsOpen(false);
                    }
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("relative h-[30svh] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", isOpen ? "translate-y-0" : "translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "no-scrollbar flex h-full w-full flex-col gap-[18px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-4 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex w-full flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-full flex-row items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-[14px] font-600 text-blue-800",
                                            children: t("txt_ratio")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                setRatio(null);
                                            },
                                            className: "text-[12px] font-600 text-blue-500",
                                            children: t("txt_clear")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex w-full flex-wrap gap-[10px]"),
                                    children: aspectOptions.map(function(option) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                setRatio(option !== "99" ? option : null);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", (aspect !== null ? aspect === option : option === "99") ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", (aspect !== null ? aspect === option : option === "99") ? "border-primary-500" : "border-[#9195AB]"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", (aspect !== null ? aspect === option : option === "99") ? "opacity-100" : "opacity-0")
                                                    })
                                                }),
                                                t(aspectLabels[option].label)
                                            ]
                                        }, option);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed bottom-0 left-0 w-full border-t border-color-separator bg-color-popup-cell px-4 py-[14px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-11 w-full flex-row gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function(e) {
                                        e.preventDefault();
                                        clearAll();
                                    },
                                    className: "h-full px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                    children: t("txt_clear_all")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    onClick: function() {
                                        apply();
                                    },
                                    text: t("lbl_apply"),
                                    className: "h-full flex-1"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var BreadCrumb = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.19518 3.52827C5.93483 3.78862 5.93483 4.21073 6.19518 4.47108L9.72378 7.99967L6.19518 11.5283C5.93483 11.7886 5.93483 12.2107 6.19518 12.4711C6.45553 12.7314 6.87764 12.7314 7.13799 12.4711L11.138 8.47108C11.263 8.34605 11.3333 8.17649 11.3333 7.99967C11.3333 7.82286 11.263 7.65329 11.138 7.52827L7.13799 3.52827C6.87764 3.26792 6.45553 3.26792 6.19518 3.52827Z",
            fill: "var(--icon-color)"
        })
    });
};
var AllRatio = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1.625",
                y: "18.375",
                width: "16.75",
                height: "7.75",
                rx: "1.04167",
                transform: "rotate(-90 1.625 18.375)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.625",
                y: "7.375",
                width: "5.75",
                height: "6.75",
                rx: "1.04167",
                transform: "rotate(-90 11.625 7.375)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.625",
                y: "18.375",
                width: "8.75",
                height: "6.75",
                rx: "1.04167",
                transform: "rotate(-90 11.625 18.375)",
                stroke: "var(--icon-color)",
                strokeWidth: "1.25"
            })
        ]
    });
};


/***/ }),

/***/ 6106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ AvailableFiltersGallery; },
/* harmony export */   "E6": function() { return /* binding */ SortByTemplatesComponent; },
/* harmony export */   "Fo": function() { return /* binding */ sortOptions; },
/* harmony export */   "HI": function() { return /* binding */ SuggestionsSkeleton; },
/* harmony export */   "Iz": function() { return /* binding */ SearchBy; },
/* harmony export */   "K5": function() { return /* binding */ getUrlFromString; },
/* harmony export */   "Lg": function() { return /* binding */ AvailableFiltersTemplatesComponent; },
/* harmony export */   "OI": function() { return /* binding */ sortLabels; },
/* harmony export */   "Vm": function() { return /* binding */ CategoriesDialogMobile; },
/* harmony export */   "W2": function() { return /* binding */ SingleGenerated; },
/* harmony export */   "ZP": function() { return /* binding */ GalleryAll; },
/* harmony export */   "bM": function() { return /* binding */ FilterDialogMobile; },
/* harmony export */   "cd": function() { return /* binding */ SortByGallery; },
/* harmony export */   "pz": function() { return /* binding */ TemplatesGrid; },
/* harmony export */   "vg": function() { return /* binding */ GALLERY_ITEMS_IN_PAGE; },
/* harmony export */   "yo": function() { return /* binding */ GallerySuggestions; }
/* harmony export */ });
/* unused harmony exports sortLabelsTemplates, sortOptionsTemplates, priceOptionsTemplates, priceLablesTemplates, GalleryMasonry */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8673);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1455);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5896);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3153);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1083);
/* harmony import */ var _comps_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9980);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9034);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(624);
/* harmony import */ var _comps_progressive__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4903);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4165);
/* harmony import */ var _comps_tooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4773);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2404);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1816);
/* harmony import */ var _utils_discover__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3300);
/* harmony import */ var _utils_infinite__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(275);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7592);
/* harmony import */ var _utils_millions__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(323);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4371);
/* harmony import */ var _utils_queryfy__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(6010);
/* harmony import */ var comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8641);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6489);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var pages_ad_examples__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(8605);
/* harmony import */ var pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(2142);
/* harmony import */ var pages_template_slug___WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(3174);
/* harmony import */ var pages_video_templates__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(4168);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8767);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(2337);
/* harmony import */ var _ad_examples__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(8106);
/* harmony import */ var _ad_examples_popup__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(6685);
/* harmony import */ var _gallery_popup__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(7276);










































var GALLERY_ITEMS_IN_PAGE = 50;
var sortLabels = {
    best: "lbl_most_relevant",
    newest: "lbl_newest",
    oldest: "lbl_oldest"
};
var sortLabelsTemplates = {
    price_low: "lbl_price_low",
    price_high: "lbl_price_high",
    rec: "lbl_rec",
    most_recent: "lbl_most_recent",
    most_used: "lbl_most_used"
};
var sortOptions = [
    "best",
    "newest",
    "oldest", 
];
var sortOptionsTemplates = [
    "rec",
    "most_recent",
    "most_used",
    "price_low",
    "price_high", 
];
var priceOptionsTemplates = [
    "all",
    "prime",
    "coin", 
];
var priceLablesTemplates = {
    prime: "lbl_prime",
    coin: "lbl_coin",
    all: "lbl_all"
};
function getSuggestions(query, isAdExamples) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function() {
        var endpoint;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endpoint = isAdExamples ? "/api/ad-examples-suggestion" : "/api/gallery-suggestion";
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_36__/* ["default"].post */ .Z.post(endpoint, {
                            query: query
                        }, {
                            headers: {
                                Authorization: "Bearer sdgdfsgsdfgsdfg",
                                "web-version": _utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .HEADER_WEB_VERSION */ .F
                            }
                        }).then(function(response) {
                            return response.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function getUrlFromString(text) {
    return text.trim().replace(/,/g, "-") // Remove all commas
    .replace(/&/g, "and") // Replace all "&" with "and"
    .replace(/\s\s*/g, "-") // Replace all spaces with hyphens
    .replace(/\//g, "-") // Replace all "/" with "-"
    .replace(/-{1,}/g, "-") // Replace sequences of two or more hyphens with a single hyphen
    .toLowerCase();
}
function getJsonLDData(query, galleryJobs) {
    var jsonLdData = [];
    if (query.trim().length !== 0) {
        jsonLdData.push({
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "https://zoomerang.app/ai-gallery/",
            potentialAction: {
                "@type": "SearchAction",
                target: "https://zoomerang.app/ai-gallery/{search_term_string}",
                "query-input": "required name=search_term_string"
            }
        });
    }
    if (galleryJobs) {
        galleryJobs.gallery.forEach(function(job) {
            if (job.media_type === "video") {
                return;
            }
            var _accepted_at, _prompt, ref, _prompt1, ref1;
            var imageObject = {
                "@context": "https://schema.org",
                "@type": "ImageObject",
                contentUrl: job.object_urls[0].object,
                license: "https://zoomerang.app/privacy-policy",
                acquireLicensePage: "https://zoomerang.app/ai-gallery/single/" + job.id,
                copyrightNotice: "Zoomerang",
                uploadDate: new Date((_accepted_at = job.accepted_at) !== null && _accepted_at !== void 0 ? _accepted_at : 0).toISOString(),
                author: {
                    "@type": "Person",
                    name: job.owner.username
                },
                creator: {
                    "@type": "Person",
                    name: job.owner.username
                },
                description: (ref = (_prompt = job.prompt) !== null && _prompt !== void 0 ? _prompt : job.style_name) !== null && ref !== void 0 ? ref : "Custom",
                caption: (ref1 = (_prompt1 = job.prompt) !== null && _prompt1 !== void 0 ? _prompt1 : job.style_name) !== null && ref1 !== void 0 ? ref1 : "Custom",
                url: "https://zoomerang.app/ai-gallery/single/" + job.id
            };
            jsonLdData.push(imageObject);
        });
    }
    return jsonLdData;
}
function getJsonLDDataAdExamples(query, jobs) {
    var jsonLdData = [];
    if (query.trim().length !== 0) {
        jsonLdData.push({
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "https://zoomerang.app/ad-examples/",
            potentialAction: {
                "@type": "SearchAction",
                target: "https://zoomerang.app/ad-examples/{search_term_string}",
                "query-input": "required name=search_term_string"
            }
        });
    }
    if (jobs) {
        if (jobs.type === "home") {
            jobs.content.forEach(function(page) {
                page.results.forEach(function(job) {
                    var ref, ref1;
                    if (!job.preview_video_url) return;
                    var _title, ref2, _description, ref3, ref4, ref5;
                    var imageObject = {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: (ref2 = (_title = job.title) !== null && _title !== void 0 ? _title : job.description) !== null && ref2 !== void 0 ? ref2 : "",
                        description: (ref3 = (_description = job.description) !== null && _description !== void 0 ? _description : job.title) !== null && ref3 !== void 0 ? ref3 : "",
                        thumbnailUrl: job.preview_thumbnail_url,
                        license: "https://zoomerang.app/privacy-policy",
                        acquireLicensePage: "https://zoomerang.app/ad-examples/single/" + job.id,
                        copyrightNotice: "Zoomerang",
                        uploadDate: job.created_at,
                        author: {
                            "@type": "Person",
                            name: (ref4 = (ref = job.owner) === null || ref === void 0 ? void 0 : ref.username) !== null && ref4 !== void 0 ? ref4 : "Zoomerang"
                        },
                        creator: {
                            "@type": "Person",
                            name: (ref5 = (ref1 = job.owner) === null || ref1 === void 0 ? void 0 : ref1.username) !== null && ref5 !== void 0 ? ref5 : "Zoomerang"
                        },
                        contentUrl: job.preview_video_url
                    };
                    jsonLdData.push(imageObject);
                });
            });
        } else {
            jobs.content.forEach(function(job) {
                var ref, ref1;
                if (!job.preview_video_url) return;
                var _title, ref2, _description, ref3;
                var imageObject = {
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    name: (ref2 = (_title = job.title) !== null && _title !== void 0 ? _title : job.description) !== null && ref2 !== void 0 ? ref2 : "",
                    description: (ref3 = (_description = job.description) !== null && _description !== void 0 ? _description : job.title) !== null && ref3 !== void 0 ? ref3 : "",
                    thumbnailUrl: job.preview_thumbnail_url,
                    license: "https://zoomerang.app/privacy-policy",
                    acquireLicensePage: "https://zoomerang.app/ad-examples/single/" + job.id,
                    copyrightNotice: "Zoomerang",
                    uploadDate: job.created_at,
                    author: {
                        "@type": "Person",
                        name: (ref = job.owner) === null || ref === void 0 ? void 0 : ref.username
                    },
                    creator: {
                        "@type": "Person",
                        name: (ref1 = job.owner) === null || ref1 === void 0 ? void 0 : ref1.username
                    },
                    contentUrl: job.preview_video_url
                };
                jsonLdData.push(imageObject);
            });
        }
    }
    return jsonLdData;
}
function GalleryAll(props) {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), filterDialogOpen = ref1[0], setFilterDialogOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), categoryDialogOpen = ref2[0], setCategoryDialogOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), isFilterSelected = ref3[0], setIsFilterSelected = ref3[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)("common").t;
    var initialFiltersGallery = props.initialFiltersGallery, initialFiltersTemplates = props.initialFiltersTemplates, initialFiltersAdExamples = props.initialFiltersAdExamples, galleryJobs = props.galleryJobs, templatesJobs = props.templatesJobs, adExamplesJobs = props.adExamplesJobs, availableFiltersGallery = props.availableFiltersGallery, availableFiltersTemplates = props.availableFiltersTemplates, title = props.pageTitle, initialPage = props.initialPage, metaLinks = props.metaLinks, pageNumber = props.pageNumber;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(null), galleryPopupState = ref4[0], setGalleryPopupState = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(null), adExamplesPopupState = ref5[0], setAdExamplesPopupState = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(title), pageTitle = ref6[0], setPageTitle = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), active = ref7[0], setActive = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(initialPage), page = ref8[0], setPage = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(initialPage), searchByPage = ref9[0], setSearchByPage = ref9[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_23__.useRouter)();
    var ref10;
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)((ref10 = (ref = router.asPath.split("/".concat(page, "/"))[1]) === null || ref === void 0 ? void 0 : ref.split("?")[0]) !== null && ref10 !== void 0 ? ref10 : ""), queryInput = ref11[0], setQueryInput = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(metaLinks !== null && metaLinks !== void 0 ? metaLinks : {
        next: "".concat(router.asPath, "?page=2"),
        prev: null
    }), pageLinks = ref12[0], setPageLinks = ref12[1];
    var prevUrlRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        if (true) {
            prevUrlRef.current = window.location.href;
            var handlePopState = function() {
                if (window.location.href !== prevUrlRef.current) {
                    window.location.reload();
                }
            };
            window.addEventListener("popstate", handlePopState);
            return function() {
                window.removeEventListener("popstate", handlePopState);
            };
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        if (true) {
            prevUrlRef.current = window.location.href;
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        if (filterDialogOpen || galleryPopupState !== null || adExamplesPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        adExamplesPopupState,
        filterDialogOpen,
        galleryPopupState, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .GalleryViewProvider */ .tp, {
        availableFilters: availableFiltersGallery,
        initialFilters: initialFiltersGallery !== null && initialFiltersGallery !== void 0 ? initialFiltersGallery : pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__.indexFiltersGallery,
        initialData: galleryJobs !== null && galleryJobs !== void 0 ? galleryJobs : undefined,
        page: page,
        pageNumber: initialPage === "ai-gallery" && pageNumber ? pageNumber : 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .TemplatesViewProvider */ .ri, {
            availableFilters: availableFiltersTemplates,
            initialFilters: initialFiltersTemplates !== null && initialFiltersTemplates !== void 0 ? initialFiltersTemplates : pages_video_templates__WEBPACK_IMPORTED_MODULE_27__.indexFiltersTemplates,
            initialData: templatesJobs !== null && templatesJobs !== void 0 ? templatesJobs : undefined,
            page: page,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .AdExamplesViewProvider */ .Bv, {
                initialFilters: initialFiltersAdExamples !== null && initialFiltersAdExamples !== void 0 ? initialFiltersAdExamples : pages_ad_examples__WEBPACK_IMPORTED_MODULE_24__.indexFiltersAdExamples,
                initialData: adExamplesJobs !== null && adExamplesJobs !== void 0 ? adExamplesJobs : undefined,
                page: page,
                pageNumber: initialPage === "ad-examples" && pageNumber ? pageNumber : 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        title: pageTitle ? pageTitle + (page === "ai-gallery" ? " - " + t("txt_gallery_title") : page === "video-templates" ? " - " + t("txt_templates_title") : " " + t("txt_ad_examples_zoomerang")) : page === "ai-gallery" ? t("txt_gallery_title") : page === "video-templates" ? t("txt_templates_title") : t("txt_ad_examples_title"),
                        description: page === "ai-gallery" ? t("txt_gallery_description") : page === "video-templates" ? t("txt_templates_description") : t("txt_ad_examples_description"),
                        cover: page === "ai-gallery" ? (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/covers/gallery.jpg") : page === "video-templates" ? (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/covers/templates.jpg") : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/covers/ad-examples.jpg"),
                        prevAndNextLinks: page === "ai-gallery" || page === "ad-examples" ? pageLinks : undefined,
                        currentPage: router.asPath,
                        jsonLdData: page === "ai-gallery" ? getJsonLDData(queryInput, galleryJobs) : page === "ad-examples" ? getJsonLDDataAdExamples(queryInput, adExamplesJobs) : []
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        isStatic: true,
                        isSolid: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterDialogMobile, {
                            filterDialogOpen: filterDialogOpen,
                            setFilterDialogOpen: setFilterDialogOpen,
                            setCategoryDialogOpen: setCategoryDialogOpen,
                            setIsFilterSelected: setIsFilterSelected,
                            page: page,
                            initialFilters: initialFiltersTemplates !== null && initialFiltersTemplates !== void 0 ? initialFiltersTemplates : pages_video_templates__WEBPACK_IMPORTED_MODULE_27__.indexFiltersTemplates
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoriesDialogMobile, {
                            filterDialogOpen: categoryDialogOpen,
                            setFilterDialogOpen: setCategoryDialogOpen
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex min-h-screen flex-col justify-between overflow-x-clip",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "sticky top-[-20px] z-50 bg-color-background tablet:top-[16px] desktop:top-[10px] ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    style: {
                                        background: "linear-gradient(90deg, rgba(176, 191, 232, 0.18) 12.5%, rgba(229, 138, 88, 0.12) 51.98%, rgba(214, 51, 168, 0.11) 86.46%)"
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-[194px] w-full flex-col items-center justify-center gap-[14px] px-4", "tablet:h-[176px] desktop:h-[190px] desktop:px-8"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("z-[1] flex w-full flex-row items-start justify-between pt-[16px] tablet:pt-[18px] desktop:pt-0", "tablet:w-[768px] tablet:px-4 desktop:w-[1175px] desktop:px-0"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex w-full flex-col justify-end gap-5 tablet:w-auto",
                                                    children: [
                                                        pageTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                                                            page: page,
                                                            pageTitle: pageTitle,
                                                            setPageTitle: setPageTitle
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex flex-row items-center gap-[18px] tablet:gap-[22px] desktop:gap-8",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    href: "/ai-gallery",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        window.history.pushState({
                                                                            path: "/ai-gallery"
                                                                        }, "", "/ai-gallery");
                                                                        setPage("ai-gallery");
                                                                        setSearchByPage("ai-gallery");
                                                                    },
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("truncate text-[18px] font-600 desktop:text-[21px]", "leading-[36px] transition-colors", "flex flex-row items-center gap-1", page === "ai-gallery" ? "text-primary-500 [--icon-color:var(--color-primary-500)]" : "text-blue-700 [--icon-color:var(--color-blue-700)]"),
                                                                    children: [
                                                                        (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .galleryIcon */ .Uq)(),
                                                                        t("lbl_ai_gallery")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    href: "/video-templates",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        window.history.pushState({
                                                                            path: "/video-templates"
                                                                        }, "", "/video-templates");
                                                                        setPage("video-templates");
                                                                        setSearchByPage("video-templates");
                                                                    },
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("truncate text-[18px] font-600 desktop:text-[21px]", "leading-[36px] transition-colors", "flex flex-row items-center gap-1", page === "video-templates" ? "text-primary-500 [--icon-color:var(--color-primary-500)]" : "text-blue-700 [--icon-color:var(--color-blue-700)]"),
                                                                    children: [
                                                                        (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .templatesIcon */ .wv)(),
                                                                        t("lbl_templates")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    href: "/ad-examples",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        window.history.pushState({
                                                                            path: "/ad-examples"
                                                                        }, "", "/ad-examples");
                                                                        setPage("ad-examples");
                                                                        setSearchByPage("ad-examples");
                                                                    },
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("truncate text-[18px] font-600 desktop:text-[21px]", "leading-[36px] transition-colors", "flex flex-row items-center gap-1", page === "ad-examples" ? "text-primary-500 [--icon-color:var(--color-primary-500)]" : "text-blue-700 [--icon-color:var(--color-blue-700)]"),
                                                                    children: [
                                                                        (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .aiAdsGenratorIcon */ .SB)(),
                                                                        t("lbl_ad_examples")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex flex-row items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative flex h-11 w-full flex-row items-center", "gap-[6px] rounded-[6px] bg-color-cell px-3 py-[10px]", "dark:bg-color-background tablet:h-10 tablet:w-[394px]", "tablet:rounded-[8px] tablet:py-[7px] tablet:pl-0 tablet:pr-[14px]", "border transition-colors desktop:h-11 desktop:w-[744px]", "desktop:rounded-[10px] desktop:py-[10px]", active ? " border-blue-400" : "border-color-cell dark:border-color-background"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" absolute -left-1 -top-1 -z-[1] h-[calc(100%+8px)] w-[calc(100%+8px)] bg-color-black/20 transition-opacity", "rounded-[9px] tablet:rounded-[11px] desktop:rounded-[13px]", active ? "opacity-100" : "opacity-0")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchBy, {
                                                                            searchByPage: searchByPage,
                                                                            setSearchByPage: setSearchByPage
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("ml-[2px] hidden h-full w-[1px] border-l", "border-color-separator tablet:block")
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-[16px] w-[16px] items-center justify-center", "[--icon-color:var(--color-placeholder)] tablet:ml-[2px]"),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .SearchIcon */ .W1, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchQuery, {
                                                                            setPageTitle: setPageTitle,
                                                                            setActive: setActive,
                                                                            searchByPage: searchByPage,
                                                                            setPage: setPage,
                                                                            setQueryInput: setQueryInput
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "relative flex h-11 tablet:hidden",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: function() {
                                                                                return setFilterDialogOpen(true);
                                                                            },
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center justify-center", "[--icon-color:var(--color-blue-600)]", "h-full w-11 hover:bg-blue-100", "rounded-[6px] bg-color-cell dark:bg-color-background"),
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .FilterIcon */ .k1, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute right-[-3px] top-[-3px] h-[8px] w-[8px]", "rounded-full bg-primary-500 transition-opacity tablet:hidden", !isFilterSelected && "opacity-0")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "hidden h-full flex-row items-end gap-3 tablet:flex",
                                                    children: [
                                                        page === "ai-gallery" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortByGallery, {}),
                                                        page === "video-templates" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortByTemplatesComponent, {}),
                                                        page === "ad-examples" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ad_examples__WEBPACK_IMPORTED_MODULE_31__/* .RatioAdExamples */ .HP, {}),
                                                        page === "ai-gallery" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvailableFiltersGallery, {}),
                                                        page === "video-templates" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvailableFiltersTemplatesComponent, {
                                                            initialFilters: initialFiltersTemplates !== null && initialFiltersTemplates !== void 0 ? initialFiltersTemplates : pages_video_templates__WEBPACK_IMPORTED_MODULE_27__.indexFiltersTemplates
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        page === "ai-gallery" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GallerySuggestions, {
                                            setPageTitle: setPageTitle
                                        }),
                                        page === "ad-examples" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GallerySuggestions, {
                                            setPageTitle: setPageTitle,
                                            isAdExamples: true
                                        }),
                                        page === "video-templates" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[36px] w-full"
                                        })
                                    ]
                                })
                            }),
                            page === "ai-gallery" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryMasonry, {
                                setGalleryPopupState: setGalleryPopupState,
                                setPageLinks: setPageLinks
                            }),
                            page === "video-templates" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TemplatesGrid, {}),
                            page === "ad-examples" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ad_examples__WEBPACK_IMPORTED_MODULE_31__/* .AdExamplesGrid */ .iV, {
                                setPopupState: setAdExamplesPopupState
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                        ]
                    }),
                    galleryPopupState !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gallery_popup__WEBPACK_IMPORTED_MODULE_33__/* .GalleryPopup */ .wY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z)({}, galleryPopupState)),
                    adExamplesPopupState !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ad_examples_popup__WEBPACK_IMPORTED_MODULE_32__/* .AdExamplesPopup */ .wK, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z)({}, adExamplesPopupState))
                ]
            })
        })
    });
}
function PageTitle(props) {
    var ref, ref1;
    var page = props.page, pageTitle = props.pageTitle, setPageTitle = props.setPageTitle;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var query = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useAdExamplesViewContext */ .s3)().query;
    var ref2 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), gallery = ref2.query;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(pageTitle), oldTitle = ref3[0], setOldTitle = ref3[1];
    var totalAdExamples = ((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages[0].data.type) === "searched" ? query.data.pages[0].data.total : null;
    var _total;
    var totalGallery = (_total = (ref1 = gallery.data) === null || ref1 === void 0 ? void 0 : ref1.pages[0].data.total) !== null && _total !== void 0 ? _total : null;
    var number = page === "ad-examples" ? totalAdExamples : page === "ai-gallery" ? totalGallery : null;
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        if (oldTitle !== pageTitle && number !== null) {
            var newTitle = number + " " + pageTitle;
            setPageTitle(newTitle);
            setOldTitle(newTitle);
        }
    }, [
        number,
        oldTitle,
        page,
        pageTitle,
        setPageTitle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("text-h5 w-full truncate text-center text-blue-800", "tablet:w-[482px] tablet:text-start tablet:leading-[24px] desktop:w-[750px] desktop:leading-[36px]"),
        children: pageTitle + " " + (page === "ai-gallery" ? t("txt_ai_generated_art") : page === "video-templates" ? t("lbl_templates") : t("lbl_ad_examples"))
    });
}
var MAX_ALLOWED_DISTANCE = 1;
function getNextVisibleChild(container) {
    var parentBounds = container.getBoundingClientRect();
    var parentX = parentBounds.x;
    var parentWidth = parentBounds.width;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = container.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(child, HTMLElement)) {
                var ref = child.getBoundingClientRect(), x = ref.x, width = ref.width;
                if (x + width - MAX_ALLOWED_DISTANCE > parentX + parentWidth) {
                    return child;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function getPrevVisibleChild(container) {
    var parentBounds = container.getBoundingClientRect();
    var parentX = parentBounds.x;
    var last = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = container.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(child, HTMLButtonElement)) {
                var x = child.getBoundingClientRect().x;
                if (x + MAX_ALLOWED_DISTANCE > parentX) {
                    return last;
                }
                last = child;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function GallerySuggestions(props) {
    var ref;
    var setPageTitle = props.setPageTitle, isAdExamples = props.isAdExamples, isColorBackground = props.isColorBackground, changeDiscoverFilter = props.changeDiscoverFilter;
    var ref1 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), galleryState = ref1.state, galleryDispatch = ref1.dispatch;
    var ref2 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useAdExamplesViewContext */ .s3)(), adExamplesState = ref2.state, adExamplesDispatch = ref2.dispatch;
    var searchQuery = (isAdExamples ? adExamplesState : galleryState).searchQuery;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_23__.useRouter)();
    var scrollContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)(null);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(true), prevDisabled = ref3[0], setPrevDisabled = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), nextDisabled = ref4[0], setNextDisabled = ref4[1];
    var scrollLeft = function() {
        if (!scrollContainerRef.current) {
            return;
        }
        var prev = getPrevVisibleChild(scrollContainerRef.current);
        if (!prev) {
            return;
        }
        prev.scrollIntoView({
            block: "center",
            inline: "start",
            behavior: "smooth"
        });
    };
    var scrollRight = function() {
        if (!scrollContainerRef.current) {
            return;
        }
        var next = getNextVisibleChild(scrollContainerRef.current);
        if (!next) {
            return;
        }
        next.scrollIntoView({
            block: "center",
            inline: "end",
            behavior: "smooth"
        });
    };
    var submitQuery = function(suggestion) {
        if (isAdExamples) {
            adExamplesDispatch({
                type: "set_search_query",
                searchQuery: suggestion
            });
            suggestions.refetch();
            adExamplesDispatch({
                type: "apply_filters"
            });
            changeDiscoverFilter && changeDiscoverFilter("ad-examples", suggestion);
        } else {
            galleryDispatch({
                type: "set_search_query",
                searchQuery: suggestion
            });
            suggestions.refetch();
            galleryDispatch({
                type: "apply_filters",
                filters: galleryState
            });
            changeDiscoverFilter && changeDiscoverFilter("ai-gallery", suggestion);
        }
    };
    var updateButtonStatus = (0,react__WEBPACK_IMPORTED_MODULE_28__.useCallback)(function() {
        var nextDisabled = false;
        if (scrollContainerRef.current && scrollContainerRef.current.scrollWidth <= scrollContainerRef.current.clientWidth) {
            nextDisabled = true;
        }
        if (scrollContainerRef.current && getNextVisibleChild(scrollContainerRef.current)) {
            nextDisabled = false;
        }
        if (scrollContainerRef.current && !getNextVisibleChild(scrollContainerRef.current)) {
            nextDisabled = true;
        }
        setNextDisabled(nextDisabled);
        var prevDisabled = true;
        if (scrollContainerRef.current && getPrevVisibleChild(scrollContainerRef.current)) {
            prevDisabled = false;
        }
        setPrevDisabled(prevDisabled);
    }, [
        scrollContainerRef
    ]);
    var suggestions = (0,react_query__WEBPACK_IMPORTED_MODULE_29__.useQuery)({
        queryKey: [
            "suggestions",
            "query-".concat(searchQuery),
            "is-ad-examples-".concat(isAdExamples), 
        ],
        queryFn: getSuggestions(searchQuery !== null && searchQuery !== void 0 ? searchQuery : "", isAdExamples !== null && isAdExamples !== void 0 ? isAdExamples : false),
        staleTime: Infinity
    });
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        updateButtonStatus();
    }, [
        searchQuery,
        updateButtonStatus,
        suggestions.status
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative w-full", !isColorBackground && " desktop:w-[1175px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    onScroll: updateButtonStatus,
                    ref: scrollContainerRef,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("no-scrollbar mx-auto flex w-full flex-row", "items-center gap-[10px] overflow-x-scroll", isColorBackground ? "w-full" : "tablet:px-[calc(50%-368px)] desktop:w-[1175px] desktop:px-0", isColorBackground && ((ref = suggestions.data) === null || ref === void 0 ? void 0 : ref.length) === 0 ? "h-0" : "h-[36px]"),
                    children: [
                        suggestions.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SuggestionsSkeleton, {}),
                        suggestions.isSuccess && !suggestions.isFetching && suggestions.data.map(function(suggestion) {
                            var searchUrl = getUrlFromString(suggestion);
                            var href = isAdExamples ? "/ad-examples/".concat(encodeURIComponent(searchUrl)) : "/ai-gallery/".concat(encodeURIComponent(searchUrl));
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: href,
                                onClick: function(e) {
                                    e.preventDefault();
                                    submitQuery(suggestion);
                                    if (setPageTitle) {
                                        setPageTitle(suggestion.replace("-", " ").replace(/\b\w/g, function(match) {
                                            return match.toUpperCase();
                                        }));
                                        router.push(href, undefined, {
                                            shallow: true
                                        });
                                    }
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-full shrink-0 flex-row items-center justify-center", "gap-[4px] rounded-[6px] p-3 text-[13px]", "font-400 tracking-wider text-blue-700 [--icon-color:var(--color-blue-600)]", isColorBackground ? "bg-blue-50" : "bg-color-cell dark:bg-color-background"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex h-[14px] w-[14px] items-center justify-center",
                                        children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .SearchIcon */ .W1)()
                                    }),
                                    suggestion
                                ]
                            }, suggestion);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    disabled: prevDisabled,
                    style: {
                        filter: "drop-shadow(0px 2.353px 13.647px rgba(123, 128, 158, 0.12))"
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute top-[-2px] hidden h-10 w-10", "items-center justify-center rounded-full bg-color-cell", "[--icon-color:var(--color-blue-600)] disabled:pointer-events-none", "disabled:opacity-0 desktop:flex", suggestions.isFetching && "pointer-events-none opacity-0", isColorBackground ? "left-[-10px]" : "left-[-20px]"),
                    onClick: scrollLeft,
                    children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd)()
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    disabled: nextDisabled,
                    style: {
                        filter: "drop-shadow(0px 2.353px 13.647px rgba(123, 128, 158, 0.12))"
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute top-[-2px] hidden h-10 w-10", "rotate-180 items-center justify-center rounded-full bg-color-cell", "[--icon-color:var(--color-blue-600)] disabled:pointer-events-none", "disabled:opacity-0 desktop:flex", suggestions.isFetching && "pointer-events-none opacity-0", isColorBackground ? "right-[-10px]" : "right-[-20px]"),
                    onClick: scrollRight,
                    children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd)()
                })
            ]
        })
    });
}
function SuggestionsSkeleton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[110px] shrink-0 rounded-[6px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[80px] shrink-0 rounded-[6px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[90px] shrink-0 rounded-[6px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[70px] shrink-0 rounded-[6px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[110px] shrink-0 rounded-[6px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_11__/* .SizedSkeleton */ .xB, {
                className: "h-full w-[90px] shrink-0 rounded-[6px]"
            })
        ]
    });
}
function TemplatesGrid(props) {
    var handleSeeMore = function handleSeeMore(id) {
        var ref;
        dispatch({
            type: "select_category",
            id: id
        });
        dispatch({
            type: "apply_filters"
        });
        var ref1;
        var find = (ref1 = (ref = categories.find(function(pre) {
            return pre.id === id;
        })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : t("lbl_featured");
        setName(find);
        setCategory(id);
        var params = (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: id
        });
        var newUrl = "/video-templates".concat(params);
        if (isDashboard) {
            newUrl = "/discover?filter=video-templates&categoryId=".concat(id);
        }
        window.history.pushState({
            path: newUrl
        }, "", newUrl);
    };
    var isDashboard = props.isDashboard;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), query = ref.query, state = ref.state, dispatch = ref.dispatch, availableFilters = ref.availableFilters;
    var lastRowRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)(null);
    var categories = availableFilters.categories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(), name = ref1[0], setName = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(null), category = ref2[0], setCategory = ref2[1];
    (0,_utils_infinite__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(query, lastRowRef, 1000);
    var prevQueryKeyComponentsRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)([
        state.applyFilters, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var currentQueryKeyComponents = [
            state.applyFilters
        ];
        if (!(0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .arraysAreEqual */ .sK)(currentQueryKeyComponents, prevQueryKeyComponentsRef.current)) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            prevQueryKeyComponentsRef.current = currentQueryKeyComponents;
        }
    }, [
        state.applyFilters
    ]);
    var flat = (0,react__WEBPACK_IMPORTED_MODULE_28__.useMemo)(function() {
        var ref;
        var flatArray = [];
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.forEach(function(page) {
            page.data.forEach(function(section) {
                var flattenedSection = [];
                var seenIds = new Set();
                section.data.forEach(function(template) {
                    if (!seenIds.has(template.id)) {
                        seenIds.add(template.id);
                        flattenedSection.push(template);
                    }
                });
                flatArray.push({
                    id: section.id,
                    section: section.section,
                    data: flattenedSection
                });
            });
        });
        return flatArray;
    }, [
        query.data
    ]);
    var flatSection = (0,react__WEBPACK_IMPORTED_MODULE_28__.useMemo)(function() {
        var ref;
        var flattenedSection = [];
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.forEach(function(page) {
            page.data.forEach(function(section) {
                if (section.section !== "searched") {
                    return flattenedSection;
                }
                var seenIds = new Set();
                section.data.forEach(function(template) {
                    if (!seenIds.has(template.id)) {
                        seenIds.add(template.id);
                        flattenedSection.push(template);
                    }
                });
            });
        });
        return flattenedSection;
    }, [
        query.data
    ]);
    var noTemplates = query.isSuccess && !query.isFetching && flat[0].data.length === 0;
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var ref;
        if (category === state.applyFilters.selectedCategory) return;
        var selectedCategoryId = state.applyFilters.selectedCategory;
        var ref1;
        var find = (ref1 = (ref = categories.find(function(pre) {
            return pre.id === Number(selectedCategoryId);
        })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : t("lbl_featured");
        setName(find);
        setCategory(selectedCategoryId ? Number(selectedCategoryId) : null);
    }, [
        categories,
        category,
        state.applyFilters,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("mx-auto my-5 flex w-full flex-col gap-3", "tablet:gap-4 desktop:my-0 desktop:gap-5", !isDashboard && "tablet:w-[768px] desktop:w-[1175px] desktop:px-0"),
                children: [
                    category !== null && Number(category) !== -2 && name !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center gap-1 px-4 desktop:mt-5 desktop:px-0", isDashboard ? "desktop:px-5" : "desktop:px-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isDashboard ? "/discover?filter=video-templates" : "/video-templates",
                                className: "cursor-pointer text-[17px] font-500 text-blue-600",
                                children: t("lbl_templates")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex [--icon-color:var(--color-blue-500)]",
                                children: BreadCrumb()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-[17px] font-500 text-blue-800",
                                children: name
                            })
                        ]
                    }),
                    Number(category) === -2 && state.applyFilters.searchQuery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center gap-1 px-4 desktop:mt-5 desktop:px-0", isDashboard ? "desktop:px-5" : "desktop:px-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isDashboard ? "/discover?filter=video-templates" : "/video-templates",
                                className: "cursor-pointer text-[17px] font-500 text-blue-600",
                                children: t("lbl_templates")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex [--icon-color:var(--color-blue-500)]",
                                children: BreadCrumb()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " max-w-[200px] truncate text-[17px] font-500 text-blue-800",
                                children: state.applyFilters.searchQuery
                            })
                        ]
                    }),
                    Number(category) === -2 && !state.applyFilters.searchQuery && state.applyFilters.price !== "all" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center gap-1 px-4 desktop:mt-5 desktop:px-0", isDashboard ? "desktop:px-5" : "desktop:px-0"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isDashboard ? "/discover?filter=video-templates" : "/video-templates",
                                className: "cursor-pointer text-[17px] font-500 text-blue-600",
                                children: t("lbl_templates")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex [--icon-color:var(--color-blue-500)]",
                                children: BreadCrumb()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " max-w-[200px] truncate text-[17px] font-500 text-blue-800",
                                children: state.applyFilters.price.charAt(0).toUpperCase() + state.applyFilters.price.slice(1) + " " + t("txt_video_templates")
                            })
                        ]
                    }),
                    flat.map(function(item, index) {
                        if (item.section !== "searched" && item.data.length < 5 || item.section === "used" || item.section === "rec") {
                            return;
                        } else if (item.section !== "searched") {
                            var _id;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3 tablet:px-4 desktop:px-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-row justify-between px-4 tablet:px-0 desktop:mt-5", isDashboard ? " desktop:px-5" : "desktop:px-0"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: " text-[14px] font-700 text-blue-700 tablet:text-[18px]",
                                                children: String(item.section).toUpperCase()
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function() {
                                                    return handleSeeMore((_id = item.id) !== null && _id !== void 0 ? _id : -1);
                                                },
                                                className: "text-[14px] font-500 text-primary-600 tablet:text-[16px]",
                                                children: t("txt_see_more")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("no-scrollbar flex w-full flex-row gap-3 overflow-x-scroll px-4", "tablet:gap-3", isDashboard ? "px-5" : "tablet:overflow-hidden tablet:px-0 desktop:grid desktop:grid-cols-5 desktop:gap-3 desktop:px-0"),
                                        children: isDashboard ? item.data.map(function(template) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleTemplate, {
                                                template: template,
                                                isDashboard: isDashboard
                                            }, template.id);
                                        }) : item.data.slice(0, 5).map(function(template) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleTemplate, {
                                                template: template
                                            }, template.id);
                                        })
                                    })
                                ]
                            }, item.section + index);
                        }
                    }),
                    flatSection.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-col gap-3 desktop:px-0", !isDashboard && "px-4"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("grid w-full grid-cols-2 gap-3 tablet:grid-cols-4", isDashboard ? "bg-color-cell px-5 desktop:grid-cols-5 desktop+:grid-cols-6" : "desktop:grid-cols-5"),
                            children: flatSection.map(function(template) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleTemplate, {
                                    template: template,
                                    grid: true
                                }, template.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: lastRowRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full justify-center p-8",
                children: query.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
            }),
            noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIconContainer */ .U$, {
                className: "pb-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIcon */ .mB, {
                        source: "/general/empty-templates"
                    }),
                    t("txt_no_result_yet")
                ]
            })
        ]
    });
}
function SingleTemplate(props) {
    var _template = props.template, preview = _template.preview, price = _template.price, prime = _template.prime, likes = _template.likes, setups = _template.setups, creator = _template.creator, id = _template.id;
    var grid = props.grid, isDashboard = props.isDashboard;
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var cookieValue = {
            location: "single"
        };
        document.cookie = (0,cookie__WEBPACK_IMPORTED_MODULE_21__/* .serialize */ .q)(pages_template_slug___WEBPACK_IMPORTED_MODULE_26__.TEMPLATE_FETCHING_CONTEXT_COOKIE_KEY, JSON.stringify(cookieValue), {
            sameSite: "lax"
        });
    }, []);
    var ref, ref1;
    var image = (ref1 = (ref = preview === null || preview === void 0 ? void 0 : preview.webp) !== null && ref !== void 0 ? ref : preview === null || preview === void 0 ? void 0 : preview.gif) !== null && ref1 !== void 0 ? ref1 : preview === null || preview === void 0 ? void 0 : preview.jpg;
    var _picture;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                backgroundColor: skeletonColors[likes % skeletonColors.length]
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative aspect-[9/16] shrink-0 overflow-hidden rounded-[6px]", grid ? " min-h-[268px] w-full" : "h-[268px] w-[164px] tablet:h-[280px] tablet:w-[172px] desktop:h-[349px]", isDashboard ? "desktop:w-[215px]" : "desktop:w-full"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/template/".concat(id),
                    className: "h-full w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: image,
                        alt: "".concat(creator.username, " Video Template"),
                        className: "h-full w-full object-cover"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute bottom-0 left-0 h-[50px] w-full bg-gradient-to-t from-color-black/50 via-color-black/20 to-color-white/0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute left-0 top-3 flex w-full flex-row items-center px-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-[60px] flex-row items-center justify-center gap-[2px] rounded bg-color-black/30 px-[10px] py-[3px] text-[14px] font-600 text-color-white backdrop-blur-sm", !price && "pointer-events-none opacity-0"),
                        children: [
                            price !== null && price !== void 0 ? price : 0,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/general/coin.svg"),
                                alt: "setups",
                                className: "h-[14px] w-[14px]"
                            })
                        ]
                    })
                }),
                prime && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute left-3 top-3 flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/icons/prime-icon.svg"),
                        alt: "coin icon",
                        className: "h-[20px]"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute bottom-[10px] left-0 flex w-full flex-row items-center justify-between px-[10px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "/".concat(creator.username),
                            className: "flex flex-row items-center gap-[6px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (_picture = creator.picture) !== null && _picture !== void 0 ? _picture : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/general/avatar.svg"),
                                    onError: function(e) {
                                        return e.currentTarget.src = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/general/avatar.svg");
                                    },
                                    alt: "".concat(creator.username, " avatar"),
                                    className: "h-[24px] w-[24px] rounded-full border border-color-separator bg-color-background object-cover"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "hidden w-[70px] truncate text-[12px] font-600 text-color-white desktop:block",
                                    children: creator.username
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row items-center gap-[6px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-[2px] text-[12px] font-600 text-color-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/player/likes.webp"),
                                            alt: "likes",
                                            className: "h-[14px] w-[14px]"
                                        }),
                                        (0,_utils_millions__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z)(likes)
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row items-center gap-[2px] text-[12px] font-600 text-color-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/player/setup-preview.webp"),
                                            alt: "setups",
                                            className: "h-[14px] w-[14px]"
                                        }),
                                        (0,_utils_millions__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z)(setups)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function GalleryMasonry(props) {
    var ref;
    var setGalleryPopupState = props.setGalleryPopupState, setPageLinks = props.setPageLinks;
    var ref1 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), query = ref1.query, state = ref1.state;
    var lastRowRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    (0,_utils_infinite__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(query, lastRowRef, 1000);
    var prevQueryKeyComponentsRef = (0,react__WEBPACK_IMPORTED_MODULE_28__.useRef)([
        state.applyFilters, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var currentQueryKeyComponents = [
            state.applyFilters
        ];
        if (!(0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .arraysAreEqual */ .sK)(currentQueryKeyComponents, prevQueryKeyComponentsRef.current)) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            prevQueryKeyComponentsRef.current = currentQueryKeyComponents;
        }
    }, [
        state.applyFilters
    ]);
    var flat = (0,react__WEBPACK_IMPORTED_MODULE_28__.useMemo)(function() {
        var ref;
        return (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .flattenAndFilterGallery */ .KP)(((ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) || []);
    }, [
        query.data
    ]);
    var noTemplates = query.isSuccess && !query.isFetching && flat.length === 0;
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var ref;
        var pathname = window.location.pathname;
        var urlParams = new URLSearchParams(window.location.search);
        var pageParam = urlParams.get("page");
        var page = 1;
        if (pageParam !== null) {
            var parsedPage = Number(pageParam);
            if (!isNaN(parsedPage) && parsedPage > 1) {
                page = parsedPage;
            }
        }
        var nextPageLink = null;
        var prevPageLink = null;
        var _length;
        var length = (_length = (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.length) !== null && _length !== void 0 ? _length : 1;
        var currentNumber = page - 1 + length;
        if (query.hasNextPage) {
            nextPageLink = pathname + "?page=" + (currentNumber + 1);
        }
        if (currentNumber > 1) {
            prevPageLink = pathname + "?page=" + (currentNumber - 1);
        }
        setPageLinks && setPageLinks({
            next: nextPageLink,
            prev: prevPageLink
        });
    }, [
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.length,
        query.hasNextPage,
        setPageLinks, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            query.isSuccess && !noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_30__/* .ResponsiveMasonry */ .G, {
                className: "mx-auto w-full gap-3 p-4 tablet:w-[768px] desktop:w-[1175px] desktop:px-0 desktop:pt-4",
                columnsCountBreakPoints: {
                    1: 2,
                    760: 4,
                    1280: 5
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                    gutter: "12px",
                    children: flat.map(function(single, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleGenerated, {
                                entity: single,
                                setGalleryPopupState: setGalleryPopupState
                            })
                        }, "item-".concat(single.id));
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-[1px] w-full",
                ref: lastRowRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full justify-center p-8",
                children: query.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
            }),
            noTemplates && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIconContainer */ .U$, {
                className: "pb-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .LockIcon */ .mB, {
                        source: "/general/empty-gallery"
                    }),
                    t("txt_no_result_yet")
                ]
            })
        ]
    });
}
function SearchQuery(props) {
    var setPageTitle = props.setPageTitle, setActive = props.setActive, setPage = props.setPage, searchByPage = props.searchByPage, setQueryInput = props.setQueryInput;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), galleryState = ref.state, galleryDispatch = ref.dispatch;
    var ref1 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), templatesState = ref1.state, templatesDispatch = ref1.dispatch;
    var ref2 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useAdExamplesViewContext */ .s3)(), adExamplesState = ref2.state, adExamplesDispatch = ref2.dispatch;
    var state = searchByPage === "ai-gallery" ? galleryState : searchByPage === "video-templates" ? templatesState : adExamplesState;
    var searchQuery = state.searchQuery;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_29__.useQueryClient)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(""), value = ref3[0], setValue = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        if (searchQuery) {
            setValue(searchQuery);
        }
    }, [
        searchQuery
    ]);
    var submitQuery = function(clear) {
        var text = clear ? "" : value;
        galleryDispatch({
            type: "set_search_query",
            searchQuery: text.trim().length === 0 ? null : text
        });
        templatesDispatch({
            type: "set_search_query",
            searchQuery: text.trim().length === 0 ? null : text
        });
        adExamplesDispatch({
            type: "set_search_query",
            searchQuery: text.trim().length === 0 ? null : text
        });
        queryClient.invalidateQueries("suggestions");
        if (searchByPage === "ai-gallery") {
            galleryDispatch({
                type: "apply_filters",
                filters: galleryState
            });
        } else if (searchByPage === "video-templates") {
            templatesDispatch({
                type: "apply_filters"
            });
        } else if (searchByPage === "ad-examples") {
            adExamplesDispatch({
                type: "apply_filters"
            });
        }
        var url = new URL(window.location.href);
        var searchParams = new URLSearchParams(url.search);
        var category = searchParams.get("categoryId");
        var params = category ? (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: category
        }) : "";
        if (text.trim().length === 0) {
            setPageTitle(null);
            var newUrl = "/".concat(searchByPage).concat(params);
            setQueryInput("");
            setPage(searchByPage);
            window.history.pushState({
                path: newUrl
            }, "", newUrl);
        } else {
            setPageTitle(text.replace("-", " ").replace(/\b\w/g, function(match) {
                return match.toUpperCase();
            }));
            var searchUrl = getUrlFromString(text);
            var newUrl1 = "/".concat(searchByPage, "/").concat(encodeURIComponent(searchUrl)).concat(params);
            setQueryInput(searchUrl);
            setPage(searchByPage);
            window.history.pushState({
                path: newUrl1
            }, "", newUrl1);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex-1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "text",
                name: "search art",
                id: "search art",
                onChange: function(e) {
                    return setValue(e.currentTarget.value);
                },
                onFocus: function() {
                    setActive(true);
                },
                onBlur: function() {
                    setActive(false);
                },
                value: value,
                placeholder: searchByPage === "ai-gallery" ? "Search art" : searchByPage === "video-templates" ? "Search templates" : "Search ads",
                onKeyDown: function(e) {
                    if (e.key === "Enter") {
                        submitQuery();
                    }
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("w-[calc(100%-23px)] border-none bg-[transparent] text-[16px] font-500 text-blue-900", "placeholder:text-color-placeholder focus:outline-none")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function() {
                    setValue("");
                    if (searchQuery) {
                        submitQuery(true);
                    }
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute right-0 top-[calc(50%-11px)] flex h-[22px] w-[22px] items-center justify-center", "rounded-full bg-blue-200 transition-opacity [--icon-color:var(--color-blue-600)] hover:bg-blue-300", value.trim().length !== 0 ? "opacity-100" : "pointer-events-none opacity-0"),
                children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ClearIcon */ .Rk)()
            })
        ]
    });
}
function SortByTemplatesComponent(props) {
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
        dispatch({
            type: "apply_filters"
        });
    };
    var isDashboard = props.isDashboard;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), state = ref.state, dispatch = ref.dispatch;
    var sortBy = state.sortBy;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var currentLabel = sortLabelsTemplates[sortBy];
    var isFeatured = state.selectedCategory === -1;
    var isPriceAll = state.price === "all";
    var isCategoryAll = state.selectedCategory === -2;
    var isSearched = state.searchQuery !== null;
    var canChange = isSearched || !isCategoryAll && !isFeatured || isCategoryAll && !isPriceAll;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        hover: true,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("group transition-opacity tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]", !canChange && "pointer-events-none cursor-not-allowed opacity-0", isDashboard ? "bg-blue-50" : "bg-color-cell dark:bg-color-background"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-4", "tablet:h-10 tablet:w-[140px] tablet:rounded-[6px]", "desktop:h-11 desktop:w-[175px] desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[14px] font-500 text-blue-700",
                    children: t(currentLabel)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-10 pt-2 tablet:w-[140px] desktop:w-[175px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full rounded-[10px] bg-color-popup-cell px-[10px] py-[14px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full flex-col gap-1",
                    children: sortOptionsTemplates.map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: function() {
                                return setSortBy(option);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center rounded-[8px] py-3 pl-4 text-[14px] font-500 text-blue-800 transition-all", sortBy === option ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                            children: t(sortLabelsTemplates[option])
                        }, option);
                    })
                })
            })
        })
    });
}
function SortByGallery(props) {
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    var isColorBackground = props.isColorBackground;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), state = ref.state, dispatch = ref.dispatch;
    var sortBy = state.sortBy;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var currentLabel = sortLabels[sortBy];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        hover: true,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("group", " tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]", isColorBackground ? " bg-blue-50" : "bg-color-cell dark:bg-color-background"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center justify-between px-4", "tablet:h-10 tablet:w-[140px] tablet:rounded-[6px]", "desktop:h-11 desktop:w-[175px] desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[14px] font-500 text-blue-700",
                    children: t(currentLabel)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-10 pt-2 tablet:w-[140px] desktop:w-[175px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full rounded-[10px] bg-color-popup-cell px-[10px] py-[14px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full flex-col gap-1",
                    children: sortOptions.map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: function() {
                                return setSortBy(option);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer items-center rounded-[8px] py-3 pl-4 text-[14px] font-500 text-blue-800 transition-all hover:bg-blue-100", sortBy === option && "bg-blue-100"),
                            children: t(sortLabels[option])
                        }, option);
                    })
                })
            })
        })
    });
}
function SearchBy(props) {
    var searchByPage = props.searchByPage, setSearchByPage = props.setSearchByPage;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        hover: true,
        className: "group hidden h-full tablet:block",
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-[120px] flex-row items-center justify-between gap-[6px] pl-[14px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "flex-1 text-center text-[15px] font-500 text-blue-700",
                    children: t("lbl_".concat(searchByPage.replaceAll("-", "_")))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("mr-1 flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-10 w-[134px] pt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-col items-center gap-1 rounded-[12px] bg-color-popup-cell", "px-[10px] py-[14px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return setSearchByPage("ai-gallery");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", searchByPage === "ai-gallery" ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                        children: t("lbl_ai_gallery")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return setSearchByPage("video-templates");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", searchByPage === "video-templates" ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                        children: t("lbl_templates")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return setSearchByPage("ad-examples");
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all", searchByPage === "ad-examples" ? "bg-blue-100 hover:bg-blue-100" : "hover:bg-color-background"),
                        children: t("lbl_ad_examples")
                    })
                ]
            })
        })
    });
}
function AvailableFiltersGallery(props) {
    var setMediaType = function setMediaType(mediaType) {
        dispatch({
            type: "set_media_type",
            mediaType: mediaType
        });
    };
    var isColorBackground = props.isColorBackground;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), dispatch = ref.dispatch, state = ref.state;
    var mediaType = state.mediaType;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var availableFilters = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)().availableFilters;
    var styles = availableFilters.styles;
    var uniqueFilters = styles.filter(function(style) {
        return state.selectedTools.includes(style.tool);
    }).map(function(style) {
        return style.name;
    });
    var filteredStyles = Array.from(new Set(uniqueFilters));
    var uniqueTools = Array.from(new Set(styles.map(function(style) {
        return style.tool;
    })));
    var commonTools = pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__.galleryProducts.filter(function(tool) {
        return uniqueTools.some(function(product) {
            return product === tool.tool;
        });
    });
    var setStyle = function(name) {
        if (state.selectedStyles.find(function(style) {
            return style.name === name;
        })) {
            dispatch({
                type: "remove_style",
                name: name
            });
            return;
        }
        dispatch({
            type: "select_style",
            name: name,
            tools: commonTools.map(function(tool) {
                return tool.tool;
            })
        });
    };
    var setTool = function(tool) {
        if (state.selectedTools.find(function(selected) {
            return selected === tool;
        })) {
            dispatch({
                type: "remove_tool",
                tool: tool
            });
            return;
        }
        dispatch({
            type: "select_tool",
            tool: tool
        });
    };
    var selectCustom = function(custom) {
        dispatch({
            type: "set_include_custom",
            state: custom
        });
    };
    var clearStyle = function() {
        dispatch({
            type: "clear_style"
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
    };
    var apply = function() {
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    var clearTools = function() {
        dispatch({
            type: "clear_tools"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        closeOnClick: true,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("group", "tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]", isColorBackground ? "bg-blue-50" : "bg-color-cell dark:bg-color-background"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex flex-row items-center justify-center [--icon-color:var(--color-blue-600)]", "tablet:h-10 tablet:w-10 tablet:rounded-[6px]", "hover:bg-blue-100 desktop:h-11 desktop:w-11 desktop:rounded-[10px]"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .FilterIcon */ .k1, {})
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-50 -translate-x-[calc(100%-44px)] pt-2 tablet:w-[349px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col gap-[18px] rounded-[13px] bg-color-popup-cell px-4 py-3 [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_media_type")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setMediaType("all");
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-wrap gap-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setMediaType("all");
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-8 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "all" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "all" ? "border-primary-500" : "border-[#9195AB]"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "all" ? "opacity-100" : "opacity-0")
                                                })
                                            }),
                                            t("lbl_all")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setMediaType("image");
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-8 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "image" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "image" ? "border-primary-500" : "border-[#9195AB]"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "image" ? "opacity-100" : "opacity-0")
                                                })
                                            }),
                                            t("lbl_image")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setMediaType("video");
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-8 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "video" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "video" ? "border-primary-500" : "border-[#9195AB]"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "video" ? "opacity-100" : "opacity-0")
                                                })
                                            }),
                                            t("lbl_video")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[1px] w-full border-b border-color-separator"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_ai_tools")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            clearTools();
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex w-full flex-wrap gap-[10px]",
                                children: pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__.galleryProducts.map(function(tool, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setTool(tool.tool);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 [--icon-color:var(--color-blue-600)]", state.selectedTools.some(function(selected) {
                                            return selected === tool.tool;
                                        }) ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            tool.icon,
                                            t(tool.label)
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[1px] w-full border-b border-color-separator"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_style")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return clearStyle();
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "no-scrollbar flex max-h-[142px] w-full flex-wrap gap-[10px] overflow-y-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            selectCustom(!state.includeCustoms);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.includeCustoms ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: t("txt_custom")
                                    }),
                                    filteredStyles.map(function(name, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                setStyle(name);
                                            },
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-[6px] text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.selectedStyles.some(function(style) {
                                                return style.name === name;
                                            }) ? "border-blue-300 bg-blue-300 text-blue-800" : "border-color-separator text-blue-700"),
                                            children: t(name)
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex h-11 w-full flex-row gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    clearAll();
                                },
                                className: "h-full cursor-pointer px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                children: t("txt_clear_all")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                onClick: apply,
                                text: t("lbl_apply"),
                                className: "h-full flex-1"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function AvailableFiltersTemplatesComponent(props) {
    var ref;
    var initialFilters = props.initialFilters, isDashboard = props.isDashboard;
    var ref1 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), dispatch = ref1.dispatch, state = ref1.state, availableFilters = ref1.availableFilters;
    var selectedCategory = state.selectedCategory, price = state.price;
    var categories = availableFilters.categories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var initialName = selectedCategory === -1 ? t("txt_featured") : selectedCategory === -2 ? t("txt_all") : ((ref = categories.find(function(cat) {
        return cat.id === selectedCategory;
    })) === null || ref === void 0 ? void 0 : ref.name) || "All";
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(initialName), selectedName = ref2[0], setSelectedName = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var ref;
        var newName = selectedCategory === -1 ? t("txt_featured") : selectedCategory === -2 ? t("txt_all") : ((ref = categories.find(function(cat) {
            return cat.id === selectedCategory;
        })) === null || ref === void 0 ? void 0 : ref.name) || "All";
        setSelectedName(newName);
    }, [
        selectedCategory,
        categories,
        t
    ]);
    var selectCategory = function(id, name) {
        setSelectedName(name);
        dispatch({
            type: "select_category",
            id: id
        });
    };
    var setPrice = function(price) {
        dispatch({
            type: "select_price",
            price: price
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
        var category = initialFilters.selectedCategory;
        var params = category ? (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: category
        }) : "";
        if (!state.searchQuery) {
            if (!isDashboard) {
                var newUrl = "/video-templates".concat(params);
                window.history.pushState({
                    path: newUrl
                }, "", newUrl);
            } else {
                var query = category ? "&categoryId=".concat(category) : "";
                var newUrl1 = "/discover?filter=video-templates".concat(query);
                window.history.pushState({
                    path: newUrl1
                }, "", newUrl1);
            }
        } else {
            if (!isDashboard) {
                var newUrl2 = "/video-templates/".concat(getUrlFromString(state.searchQuery)).concat(params);
                window.history.pushState({
                    path: newUrl2
                }, "", newUrl2);
            } else {
                var categoryQuery = category ? "&categoryId=".concat(category) : "";
                var query1 = "&q=".concat(getUrlFromString(state.searchQuery));
                var newUrl3 = "/discover?filter=video-templates".concat(query1).concat(categoryQuery);
                window.history.pushState({
                    path: newUrl3
                }, "", newUrl3);
            }
        }
    };
    var apply = function() {
        dispatch({
            type: "apply_filters"
        });
        var category = state.selectedCategory;
        var params = category ? (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: category
        }) : "";
        if (!state.searchQuery) {
            if (!isDashboard) {
                var newUrl = "/video-templates".concat(params);
                window.history.pushState({
                    path: newUrl
                }, "", newUrl);
            } else {
                var query = category ? "&categoryId=".concat(category) : "";
                var newUrl1 = "/discover?filter=video-templates".concat(query);
                window.history.pushState({
                    path: newUrl1
                }, "", newUrl1);
            }
        } else {
            if (!isDashboard) {
                var newUrl2 = "/video-templates/".concat(getUrlFromString(state.searchQuery)).concat(params);
                window.history.pushState({
                    path: newUrl2
                }, "", newUrl2);
            } else {
                var categoryQuery = category ? "&categoryId=".concat(category) : "";
                var query1 = "&q=".concat(getUrlFromString(state.searchQuery));
                var newUrl3 = "/discover?filter=video-templates".concat(query1).concat(categoryQuery);
                window.history.pushState({
                    path: newUrl3
                }, "", newUrl3);
            }
        }
    };
    var clearCategories = function() {
        dispatch({
            type: "select_category",
            id: -2
        });
    };
    var isFilterSelected = initialFilters.selectedCategory !== selectedCategory || initialFilters.price !== price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("tablet:h-10 tablet:rounded-[6px] desktop:h-11 desktop:rounded-[10px]", isDashboard ? "bg-blue-50" : "bg-color-cell dark:bg-color-background"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative flex flex-row items-center justify-center [--icon-color:var(--color-blue-600)]", "tablet:h-10 tablet:w-10 tablet:rounded-[6px]", "hover:bg-blue-100 desktop:h-11 desktop:w-11 desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .FilterIcon */ .k1, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute right-[-2px] top-[-1px] h-[8px] w-[8px] rounded-full bg-primary-500 transition-opacity", !isFilterSelected && "opacity-0")
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-50 -translate-x-[calc(100%-44px)] pt-2 tablet:w-[349px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col gap-[18px] rounded-[13px] bg-color-popup-cell px-4 py-3 [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_categories")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            clearCategories();
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_4__/* .DropDown */ .vb, {
                                closeOnClick: true,
                                className: "group h-10 flex-1",
                                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-10 w-[317px] flex-row items-center justify-between gap-[6px] rounded-[6px] px-3 py-2", isDashboard ? " bg-color-surface" : "bg-color-background"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex-1 text-start text-[14px] font-400 text-blue-600",
                                            children: selectedName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("mr-1 flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)] group-hover:-rotate-[270deg]"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute z-10 w-[317px] pt-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("no-scrollbar flex max-h-[200px] flex-col items-center gap-1 overflow-y-scroll rounded-[12px] bg-blue-100", "px-[10px] py-[14px]"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    selectCategory(-2, t("txt_all"));
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all hover:bg-blue-200", selectedCategory === -2 && "bg-blue-200"),
                                                children: t("txt_all")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    selectCategory(-1, t("txt_featured"));
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all hover:bg-blue-200", selectedCategory === -1 && "bg-blue-200"),
                                                children: t("txt_featured")
                                            }),
                                            categories.map(function(category) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        selectCategory(category.id, category.name);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full cursor-pointer py-2 pl-4", "rounded-[8px] text-[14px] font-500 text-blue-800 transition-all hover:bg-blue-200", selectedCategory === category.id && "bg-blue-200"),
                                                    children: category.name
                                                }, category.id);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[1px] w-full border-b border-color-separator"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-600 text-blue-800",
                                        children: t("lbl_price")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setPrice("all");
                                        },
                                        className: "text-[12px] font-600 text-blue-500",
                                        children: t("txt_clear")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-wrap gap-[10px]", selectedCategory === -1 && "pointer-events-none opacity-50"),
                                children: priceOptionsTemplates.map(function(option) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setPrice(option);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", price === option ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", price === option ? "border-primary-500" : "border-[#9195AB]"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", price === option ? "opacity-100" : "opacity-0")
                                                })
                                            }),
                                            t(priceLablesTemplates[option])
                                        ]
                                    }, option);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex h-11 w-full flex-row gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    clearAll();
                                },
                                className: "h-full cursor-pointer px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                children: t("txt_clear_all")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                onClick: apply,
                                text: t("lbl_apply"),
                                className: "h-full flex-1"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function FilterDialogMobile(props) {
    var filterDialogOpen = props.filterDialogOpen, setFilterDialogOpen = props.setFilterDialogOpen, page = props.page, setCategoryDialogOpen = props.setCategoryDialogOpen, setIsFilterSelected = props.setIsFilterSelected, initialFilters = props.initialFilters;
    if (page === "ai-gallery") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterDialogGallery, {
            filterDialogOpen: filterDialogOpen,
            setFilterDialogOpen: setFilterDialogOpen
        });
    } else if (page === "video-templates") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterDialogTemplates, {
            filterDialogOpen: filterDialogOpen,
            setFilterDialogOpen: setFilterDialogOpen,
            setCategoryDialogOpen: setCategoryDialogOpen,
            setIsFilterSelected: setIsFilterSelected,
            initialFilters: initialFilters
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ad_examples__WEBPACK_IMPORTED_MODULE_31__/* .FilterDialogAdExamples */ .Bp, {
            isOpen: filterDialogOpen,
            setIsOpen: setFilterDialogOpen
        });
    }
}
function FilterDialogGallery(props) {
    var setMediaType = function setMediaType(mediaType) {
        dispatch({
            type: "set_media_type",
            mediaType: mediaType
        });
    };
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
    };
    var filterDialogOpen = props.filterDialogOpen, setFilterDialogOpen = props.setFilterDialogOpen;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)(), dispatch = ref.dispatch, state = ref.state;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var availableFilters = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useGalleryViewContext */ .$e)().availableFilters;
    var mediaType = state.mediaType, sortBy = state.sortBy;
    var styles = availableFilters.styles;
    var uniqueFilters = styles.filter(function(style) {
        return state.selectedTools.includes(style.tool);
    }).map(function(style) {
        return style.name;
    });
    var filteredStyles = Array.from(new Set(uniqueFilters));
    var uniqueTools = Array.from(new Set(styles.map(function(style) {
        return style.tool;
    })));
    var commonTools = pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__.galleryProducts.filter(function(tool) {
        return uniqueTools.some(function(product) {
            return product === tool.tool;
        });
    });
    var setStyle = function(name) {
        if (state.selectedStyles.find(function(style) {
            return style.name === name;
        })) {
            dispatch({
                type: "remove_style",
                name: name
            });
            return;
        }
        dispatch({
            type: "select_style",
            name: name,
            tools: commonTools.map(function(tool) {
                return tool.tool;
            })
        });
    };
    var setTool = function(tool) {
        if (state.selectedTools.find(function(selected) {
            return selected === tool;
        })) {
            dispatch({
                type: "remove_tool",
                tool: tool
            });
            return;
        }
        dispatch({
            type: "select_tool",
            tool: tool
        });
    };
    var selectCustom = function(custom) {
        dispatch({
            type: "set_include_custom",
            state: custom
        });
    };
    var clearStyle = function() {
        dispatch({
            type: "clear_style"
        });
    };
    var clearTools = function() {
        dispatch({
            type: "clear_tools"
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
    };
    var apply = function() {
        dispatch({
            type: "apply_filters",
            filters: state
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:hidden", !filterDialogOpen && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
            id: "filter-popup",
            onClick: function(event) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(event.target, Element)) {
                    if (event.target.id === event.currentTarget.id) {
                        setFilterDialogOpen(false);
                    }
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative h-[564px] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", filterDialogOpen ? "translate-y-0" : "translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "no-scrollbar flex h-[487px] w-full flex-col gap-[18px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-4 py-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_media_type")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setMediaType("all");
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-wrap gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setMediaType("all");
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "all" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "all" ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "all" ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t("lbl_all")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                id: "image-media",
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setMediaType("image");
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "image" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "image" ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "image" ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t("lbl_image")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                id: "video-media",
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setMediaType("video");
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", mediaType === "video" ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", mediaType === "video" ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", mediaType === "video" ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t("lbl_video")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_sort_by")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy("newest");
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full flex-wrap gap-[10px]",
                                        children: sortOptions.map(function(option) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                id: option,
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy(option);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", sortBy === option ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", sortBy === option ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", sortBy === option ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t(sortLabels[option])
                                                ]
                                            }, option);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_ai_tools")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    clearTools();
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex w-full flex-wrap gap-[10px]",
                                        children: pages_ai_gallery__WEBPACK_IMPORTED_MODULE_25__.galleryProducts.map(function(tool, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                id: tool.tool,
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setTool(tool.tool);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all", state.selectedTools.some(function(selected) {
                                                    return selected === tool.tool;
                                                }) ? "border-blue-100 bg-blue-100 text-blue-800 [--icon-color:var(--color-blue-700)]" : "border-color-separator text-blue-700 [--icon-color:var(--color-blue-600)]"),
                                                children: [
                                                    tool.icon,
                                                    t(tool.label)
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_style")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function() {
                                                    return clearStyle();
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "no-scrollbar flex max-h-[184px] w-full flex-wrap gap-[10px] overflow-y-auto pb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    selectCustom(!state.includeCustoms);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.includeCustoms ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: t("txt_custom")
                                            }),
                                            filteredStyles.map(function(name, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    id: name,
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        setStyle(name);
                                                    },
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" flex cursor-pointer select-none flex-row items-center gap-1 rounded-[6px] border px-3 py-3 text-[12px] font-500 transition-all [--icon-color:var(--color-blue-700)]", state.selectedStyles.some(function(style) {
                                                        return style.name === name;
                                                    }) ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                    children: t(name)
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed bottom-0 left-0 w-full border-t border-color-separator bg-color-popup-cell px-4 py-[14px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-11 w-full flex-row gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    id: "clear-all-filters",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        clearAll();
                                    },
                                    className: "h-full px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                    children: t("txt_clear_all")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    onClick: function() {
                                        apply();
                                        setFilterDialogOpen(false);
                                    },
                                    text: t("lbl_apply"),
                                    className: "h-full flex-1"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
function FilterDialogTemplates(props) {
    var setSortBy = function setSortBy(sortBy) {
        dispatch({
            type: "set_sort_by",
            sortBy: sortBy
        });
    };
    var ref;
    var filterDialogOpen = props.filterDialogOpen, setFilterDialogOpen = props.setFilterDialogOpen, setCategoryDialogOpen = props.setCategoryDialogOpen, setIsFilterSelected = props.setIsFilterSelected, initialFilters = props.initialFilters;
    var ref1 = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), dispatch = ref1.dispatch, state = ref1.state, availableFilters = ref1.availableFilters;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var sortBy = state.sortBy, selectedCategory = state.selectedCategory, price = state.price;
    var categories = availableFilters.categories;
    var initialName = selectedCategory === -1 ? t("txt_featured") : selectedCategory === -2 ? t("txt_all") : ((ref = categories.find(function(cat) {
        return cat.id === selectedCategory;
    })) === null || ref === void 0 ? void 0 : ref.name) || "All";
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(initialName), selectedName = ref2[0], setSelectedName = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var ref;
        var newName = selectedCategory === -1 ? t("txt_featured") : selectedCategory === -2 ? t("txt_all") : ((ref = categories.find(function(cat) {
            return cat.id === selectedCategory;
        })) === null || ref === void 0 ? void 0 : ref.name) || "All";
        setSelectedName(newName);
    }, [
        selectedCategory,
        categories,
        t
    ]);
    var setPrice = function(price) {
        dispatch({
            type: "select_price",
            price: price
        });
    };
    var selectCategory = function(id, name) {
        setSelectedName(name);
        dispatch({
            type: "select_category",
            id: id
        });
    };
    var clearAll = function() {
        dispatch({
            type: "clear_all"
        });
        var category = initialFilters.selectedCategory;
        var params = category ? (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: category
        }) : "";
        if (!state.searchQuery) {
            var newUrl = "/video-templates".concat(params);
            window.history.pushState({
                path: newUrl
            }, "", newUrl);
        } else {
            var newUrl1 = "/video-templates/".concat(getUrlFromString(state.searchQuery)).concat(params);
            window.history.pushState({
                path: newUrl1
            }, "", newUrl1);
        }
        setIsFilterSelected(false);
    };
    var apply = function() {
        dispatch({
            type: "apply_filters"
        });
        var category = state.selectedCategory;
        var params = category ? (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)({
            categoryId: category
        }) : "";
        if (!state.searchQuery) {
            var newUrl = "/video-templates".concat(params);
            window.history.pushState({
                path: newUrl
            }, "", newUrl);
        } else {
            var newUrl1 = "/video-templates/".concat(getUrlFromString(state.searchQuery)).concat(params);
            window.history.pushState({
                path: newUrl1
            }, "", newUrl1);
        }
        var isFilterSelected = initialFilters.selectedCategory !== selectedCategory || initialFilters.price !== price || initialFilters.sortBy !== sortBy;
        setIsFilterSelected(isFilterSelected);
    };
    var isFeatured = state.selectedCategory === -1;
    var isPriceAll = state.price === "all";
    var isCategoryAll = state.selectedCategory === -2;
    var isSearched = state.searchQuery !== null;
    var canChange = isSearched || !isCategoryAll && !isFeatured || isCategoryAll && !isPriceAll;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:hidden", !filterDialogOpen && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
            id: "filter-popup",
            onClick: function(event) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(event.target, Element)) {
                    if (event.target.id === event.currentTarget.id) {
                        setFilterDialogOpen(false);
                    }
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative h-[480px] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", filterDialogOpen ? "translate-y-0" : "translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "no-scrollbar flex h-[487px] w-full flex-col gap-[18px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-4 py-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_categories")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    selectCategory(-2, t("txt_all"));
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            setCategoryDialogOpen(true);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-10 w-full flex-row items-center justify-between gap-[6px] rounded-[6px] bg-color-background px-3 py-2"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "flex-1 text-start text-[14px] font-400 text-blue-600",
                                                children: selectedName
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("mr-1 flex -rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-placeholder)]"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonArrowIcon */ .hd, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_price")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setPrice("all");
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-wrap gap-[10px]", selectedCategory === -1 && "pointer-events-none opacity-50"),
                                        children: priceOptionsTemplates.map(function(option) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setPrice(option);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", price === option ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", price === option ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", price === option ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t(priceLablesTemplates[option])
                                                ]
                                            }, option);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex w-full flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[14px] font-600 text-blue-800",
                                                children: t("lbl_sort_by")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy("rec");
                                                },
                                                className: "text-[12px] font-600 text-blue-500",
                                                children: t("txt_clear")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-wrap gap-[10px]", !canChange && "pointer-events-none opacity-50"),
                                        children: sortOptionsTemplates.map(function(option) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setSortBy(option);
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-11 flex-row items-center justify-center gap-3 rounded-[6px] border pl-[7px] pr-[14px] text-[12px] font-500 transition-all", sortBy === option ? "border-blue-100 bg-blue-100 text-blue-800" : "border-color-separator text-blue-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-4 w-4 items-center justify-center rounded-full border-[1.2px] transition-all", sortBy === option ? "border-primary-500" : "border-[#9195AB]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-primary-500 transition-opacity", sortBy === option ? "opacity-100" : "opacity-0")
                                                        })
                                                    }),
                                                    t(sortLabelsTemplates[option])
                                                ]
                                            }, option);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed bottom-0 left-0 w-full border-t border-color-separator bg-color-popup-cell px-4 py-[14px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-11 w-full flex-row gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function(e) {
                                        e.preventDefault();
                                        clearAll();
                                    },
                                    className: "h-full px-[18px] py-3 text-[16px] font-600 text-blue-500",
                                    children: t("txt_clear_all")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    onClick: function() {
                                        apply();
                                        setFilterDialogOpen(false);
                                    },
                                    text: t("lbl_apply"),
                                    className: "h-full flex-1"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
function CategoriesDialogMobile(props) {
    var filterDialogOpen = props.filterDialogOpen, setFilterDialogOpen = props.setFilterDialogOpen;
    var ref = (0,_utils_discover__WEBPACK_IMPORTED_MODULE_15__/* .useTemplatesViewContext */ .Zs)(), dispatch = ref.dispatch, state = ref.state, availableFilters = ref.availableFilters;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var selectedCategory = state.selectedCategory;
    var categories = availableFilters.categories;
    var selectCategory = function(id) {
        dispatch({
            type: "select_category",
            id: id
        });
        setFilterDialogOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:hidden", !filterDialogOpen && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
            id: "filter-popup",
            onClick: function(event) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(event.target, Element)) {
                    if (event.target.id === event.currentTarget.id) {
                        setFilterDialogOpen(false);
                    }
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("relative h-[500px] w-full rounded-t-[12px] bg-color-popup-cell pt-3 transition-all", filterDialogOpen ? "translate-y-0" : "translate-y-full"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "no-scrollbar flex h-full w-full flex-col gap-[8px] overflow-y-auto rounded-[13px] bg-color-popup-cell px-[10px] py-[14px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                selectCategory(-2);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-row items-center rounded-[8px] px-4 py-3", selectedCategory === -2 && "bg-blue-100"),
                            children: t("txt_all")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                selectCategory(-1);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-row items-center rounded-[8px] px-4 py-3", selectedCategory === -1 && "bg-blue-100"),
                            children: t("txt_featured")
                        }),
                        categories.map(function(cat) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    selectCategory(cat.id);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex w-full flex-row items-center rounded-[8px] px-4 py-3", selectedCategory === cat.id && "bg-blue-100"),
                                children: cat.name
                            }, cat.id);
                        })
                    ]
                })
            })
        })
    });
}
var skeletonColors = [
    "#81E68526",
    "#81E6E326",
    "#81B7E626",
    "#E681A626",
    "#E6D08126",
    "#8185E626",
    "#B081E626",
    "#E381E626",
    "#E6818126", 
];
function SingleGenerated(props) {
    var setAsViewed = function setAsViewed() {
        var options = {
            action: "view",
            gallery_id: id
        };
        axios__WEBPACK_IMPORTED_MODULE_36__/* ["default"].post */ .Z.post("/api/gallery-view", options).catch(function(e) {
            return console.error(e);
        });
    };
    var setGalleryPopupState = props.setGalleryPopupState, notShallow = props.notShallow, closeLink = props.closeLink, selectCreatorTool = props.selectCreatorTool;
    var _entity = props.entity, id = _entity.id, object_urls = _entity.object_urls, media_type = _entity.media_type, prompt = _entity.prompt, tool = _entity.tool, accepted_at = _entity.accepted_at, style_name = _entity.style_name, style = _entity.style, model_id = _entity.model_id, model_name = _entity.model_name, likes = _entity.likes, views = _entity.views;
    var _owner = props.entity.owner, username = _owner.username, followers = _owner.followers, uid = _owner.uid, profile_pic = _owner.profile_pic;
    var ownerId = uid;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_22__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_28__.useState)(true), videoPaused = ref2[0], setVideoPaused = ref2[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)().userInfo;
    function handleRetry() {
        return _handleRetry.apply(this, arguments);
    }
    function _handleRetry() {
        _handleRetry = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function() {
            var promptType, inputs, link;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                if (userInfo.isAnonymous || !selectCreatorTool) {
                    (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_17__/* .redirectToLogin */ .r)();
                    return [
                        2
                    ];
                }
                promptType = prompt;
                inputs = promptType === "custom" ? (0,comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.createInputs)({
                    type: "custom",
                    content: [
                        ""
                    ]
                }) : (0,comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.createInputs)({
                    type: "predefined",
                    id: promptType !== null && promptType !== void 0 ? promptType : ""
                });
                switch(tool){
                    case "deform":
                        selectCreatorTool(tool, {
                            tool: "deform",
                            id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.DEFORUM_STORAGE_KEY,
                            inputs: inputs,
                            promptType: style !== null && style !== void 0 ? style : "custom",
                            location: "local",
                            blob: null
                        }, true);
                        break;
                    case "ai_photo":
                        selectCreatorTool(tool, {
                            tool: "ai_photo",
                            id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.DEFORUM_STORAGE_KEY,
                            input: prompt !== null && prompt !== void 0 ? prompt : "",
                            promptType: style,
                            location: "local",
                            blob: null
                        }, true);
                        break;
                    case "ai_restyle":
                        selectCreatorTool(tool, {
                            tool: "ai_restyle",
                            id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.DEFORUM_STORAGE_KEY,
                            input: prompt !== null && prompt !== void 0 ? prompt : "",
                            promptType: style,
                            location: "local",
                            blob: null
                        }, true);
                        break;
                    case "text_to_image":
                        selectCreatorTool(tool, {
                            tool: "text_to_image",
                            id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_20__.DEFORUM_STORAGE_KEY,
                            promptType: style,
                            text: prompt !== null && prompt !== void 0 ? prompt : "",
                            location: "local",
                            blob: null
                        }, true);
                        break;
                    default:
                        link = document.createElement("a");
                        link.href = _utils_branch__WEBPACK_IMPORTED_MODULE_13__/* .appStoreConstant */ .HY;
                        link.target = "_blank";
                        link.click();
                        break;
                }
                setGalleryPopupState(null);
                return [
                    2
                ];
            });
        });
        return _handleRetry.apply(this, arguments);
    }
    var scrollToImage = (0,react__WEBPACK_IMPORTED_MODULE_28__.useCallback)(function(index) {
        var nextImage = document.getElementsByClassName("gallery-".concat(id, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, [
        id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage,
        id
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_23__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_28__.useEffect)(function() {
        var handlePopState = function handlePopState() {
            setGalleryPopupState(null);
        };
        window.addEventListener("popstate", handlePopState);
    }, [
        router,
        setGalleryPopupState
    ]);
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_28__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_18__/* .NotificationContext */ .u).notify;
    var thumbReady = (0,_comps_progressive__WEBPACK_IMPORTED_MODULE_10__/* .useProgressive */ .k)(object_urls[0].thumb);
    function handleCopyPrompt(text) {
        return _handleCopyPrompt.apply(this, arguments);
    }
    function _handleCopyPrompt() {
        _handleCopyPrompt = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(text) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyPrompt.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: skeletonColors[id % skeletonColors.length]
        },
        className: "group relative min-h-[130px] w-full shrink-0 rounded-[6px] desktop:min-h-[180px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-2 top-2",
                children: media_type === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/ai-tools/history/video-icon.svg"),
                    alt: "video-icon",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-4 w-4 transition-opacity", videoPaused ? "opacity-100" : "opacity-0")
                })
            }),
            (prompt || model_name || style_name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute bottom-0 left-0 z-10 hidden w-full pt-3 desktop:block", "pointer-events-none opacity-0 transition-all group-hover:pointer-events-auto group-hover:opacity-100", "rounded-b-[6px]", "bg-gradient-to-t from-color-black/80 to-[transparent]", "flex cursor-auto flex-col items-center"),
                children: [
                    prompt && prompt.trim().length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onMouseEnter: function() {
                            return setIsHovered(true);
                        },
                        onMouseLeave: function() {
                            return setIsHovered(false);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("peer relative flex w-full flex-row items-end justify-between p-3 pt-0"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .TextTooltip */ .JI, {
                            showAlways: prompt.length > 144,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("max-w-full pr-6"),
                            title: prompt,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("text-sm font-400 text-color-white transition-[max-height]", isHovered ? "line-clamp-4 max-h-[80px] whitespace-normal" : "max-h-[20px] truncate"),
                                children: prompt
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-row items-center justify-between px-3 pb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "rounded-[100px] bg-[#212127A3] px-[13px] py-1 text-[13px] font-500 text-color-white",
                                children: style_name !== null && style_name !== void 0 ? style_name : model_name
                            }),
                            prompt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                className: "flex items-center justify-center",
                                title: t("common:txt_copy"),
                                showAlways: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        return handleCopyPrompt(prompt);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                        alt: "copy",
                                        className: "h-full"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            object_urls.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === 0,
                        onClick: function() {
                            return scrollToImage(offset - 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute left-2 top-[calc(50%-12px)] z-20 flex h-6 w-6 items-center justify-center", "rounded-full border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px]", "transition-all hover:border-color-white/60 disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === object_urls.length - 1,
                        onClick: function() {
                            return scrollToImage(offset + 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("absolute right-2 top-[calc(50%-12px)] z-20 flex h-6 w-6 items-center justify-center", "rounded-full border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px]", "transition-all hover:border-color-white/60 disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_37__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow",
                            className: "rotate-180"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/ai-gallery/single/".concat(id),
                onClick: function(e) {
                    var onClose = function onClose() {
                        if (!notShallow) {
                            var newUrl = closeLink !== null && closeLink !== void 0 ? closeLink : "/ai-gallery";
                            window.history.pushState({
                                path: newUrl
                            }, "", newUrl);
                        }
                        setGalleryPopupState(null);
                    };
                    setAsViewed();
                    e.preventDefault();
                    if (!notShallow) {
                        var newUrl = "/ai-gallery/single/".concat(id);
                        window.history.pushState({
                            path: newUrl
                        }, "", newUrl);
                    }
                    if (media_type === "image") {
                        setAsViewed();
                    } else {
                        setTimeout(function() {
                            return setAsViewed();
                        }, 1000);
                    }
                    var isVideo = media_type === "video";
                    setGalleryPopupState({
                        onClose: onClose,
                        closeLink: closeLink !== null && closeLink !== void 0 ? closeLink : "/ai-gallery",
                        previewImage: object_urls[0].thumb,
                        id: id,
                        imageOrVideo: object_urls.length > 1 ? object_urls.map(function(single) {
                            return single.object;
                        }) : isVideo ? object_urls[0].object + "#t=0.001" : object_urls[0].object,
                        tool: tool,
                        createdAt: accepted_at !== null && accepted_at !== void 0 ? accepted_at : new Date().getDate(),
                        customPrompt: prompt !== null && prompt !== void 0 ? prompt : "",
                        privacy: "public",
                        prompt: prompt !== null && prompt !== void 0 ? prompt : "",
                        promptName: style_name !== null && style_name !== void 0 ? style_name : "Custom",
                        username: username,
                        followers: followers,
                        profile_pic: profile_pic === null || profile_pic === void 0 ? void 0 : profile_pic.original,
                        handleRetry: handleRetry,
                        notShallow: true,
                        showRelated: true,
                        model_id: model_id,
                        ownerId: ownerId,
                        showFor: true,
                        views: views,
                        likes: likes
                    });
                },
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("w-full overflow-hidden object-cover", "rounded-[6px]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onScroll: function(event) {
                            var container = event.target;
                            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z)(container, HTMLElement)) {
                                var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                                setOffset(snapIndex);
                            }
                        },
                        className: "no-scrollbar top-0 flex h-full snap-x snap-mandatory flex-row gap-12 overflow-x-scroll transition-all ",
                        children: object_urls.map(function(single, index) {
                            return media_type === "image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: single.thumb,
                                alt: prompt ? prompt : style !== null && style !== void 0 ? style : "Custom",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)(" h-full min-h-[130px] w-full shrink-0 snap-center rounded-[6px] object-cover desktop:min-h-[180px]", "gallery-".concat(id, "-").concat(index), !thumbReady && "opacity-0")
                            }, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: single.object + "#t=0.001",
                                poster: single.thumb,
                                playsInline: true,
                                loop: true,
                                preload: "none",
                                muted: true,
                                onPointerEnter: function(e) {
                                    setVideoPaused(false);
                                    e.currentTarget.play().catch(console.error);
                                },
                                onPointerLeave: function(e) {
                                    setVideoPaused(true);
                                    e.currentTarget.pause();
                                    e.currentTarget.currentTime = 0.001;
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z)("h-full w-full object-cover", "min-h-[130px] rounded-[6px] desktop:min-h-[180px]")
                            }, index);
                        })
                    })
                })
            })
        ]
    });
}
var BreadCrumb = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.19518 3.52827C5.93483 3.78862 5.93483 4.21073 6.19518 4.47108L9.72378 7.99967L6.19518 11.5283C5.93483 11.7886 5.93483 12.2107 6.19518 12.4711C6.45553 12.7314 6.87764 12.7314 7.13799 12.4711L11.138 8.47108C11.263 8.34605 11.3333 8.17649 11.3333 7.99967C11.3333 7.82286 11.263 7.65329 11.138 7.52827L7.13799 3.52827C6.87764 3.26792 6.45553 3.26792 6.19518 3.52827Z",
            fill: "var(--icon-color)"
        })
    });
};


/***/ }),

/***/ 7276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wY": function() { return /* binding */ GalleryPopup; },
  "$g": function() { return /* binding */ getKeywords; },
  "VE": function() { return /* binding */ getRelatedArt; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./comps/advanced-profile.tsx
var advanced_profile = __webpack_require__(8673);
// EXTERNAL MODULE: ./comps/ai-tools/icons.tsx
var icons = __webpack_require__(1455);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/login-redirect.tsx
var login_redirect = __webpack_require__(7592);
// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./utils/variables.ts
var variables = __webpack_require__(2706);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./pages/models/index.tsx + 2 modules
var models = __webpack_require__(1087);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./sections/history/generations.tsx
var generations = __webpack_require__(5170);
;// CONCATENATED MODULE: ./sections/gallery/thanks-popup.tsx















function ThanksPopup(props) {
    var open = props.open, username = props.username, image = props.image, id = props.id, setOpen = props.setOpen, handleSocialShare = props.handleSocialShare, setAsShared = props.setAsShared, shareDialog = props.shareDialog;
    var t = (0,esm/* useTranslation */.$G)().t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    function handleCopyLink(e) {
        return _handleCopyLink.apply(this, arguments);
    }
    function _handleCopyLink() {
        _handleCopyLink = (0,_async_to_generator/* default */.Z)(function(e) {
            var target, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText("AI Art by ".concat(username, " on Zoomerang: ").concat(variables/* APP_HOST */.b, "/ai-gallery/single/").concat(id))
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyLink.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(open ? "flex" : "hidden", "fixed z-[999] flex items-start gap-[6px] tablet:top-[30%] desktop:left-1/2 desktop:top-1/2", "animate-appear tablet:left-[50%] tablet:-translate-x-1/2 tablet:-translate-y-1/2", "bottom-0 left-0 right-0 tablet:bottom-auto tablet:left-auto tablet:right-auto", "desktop:w-[576px] tablet:w-[538px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex items-start gap-[16px] rounded-[16px] bg-color-cell p-[14px] pr-0", "w-full tablet:rounded-[10px] justify-center tablet:justify-normal"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image,
                        alt: "image",
                        className: "hidden h-[224px] w-[171px] rounded-[4px] object-cover tablet:flex"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex flex-col tablet:items-start gap-[7px] tablet:w-[337px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start gap-[10px] w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[20px] font-500 text-blue-900 tablet:text-[24px]",
                                        children: t("txt_give_thanks")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-start gap-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "w-[150px] text-[16px] font-500 text-blue-700",
                                                children: t("txt_give_thanks_desc")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "-ml-[10px] text-[16px] font-600 text-blue-800",
                                                children: username
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("items-center justify-between bg-color-background p-[14px]", "flex  rounded-[6px] border border-color-separator tablet:w-[323px]", "max-w-[347px] w-full"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-[4px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[16px] font-400 text-blue-600",
                                                        children: "AI Art by"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "w-[60px] truncate text-[16px] font-400 text-blue-800",
                                                        children: [
                                                            "@",
                                                            username
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[16px] font-400 text-blue-600",
                                                        children: "on"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-[16px] font-400 text-blue-800",
                                                        children: "Zoomerang"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: handleCopyLink,
                                                className: (0,clsx_m/* default */.Z)("relative flex items-center justify-center p-1", "group transition-colors hover:bg-blue-100", "shrink-0 overflow-visible rounded-md bg-color-background"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,cdn/* assetUrl */.p)("/ai-tools/history/copy.svg"),
                                                        alt: "copy",
                                                        className: "h-[20px] w-[20px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("absolute -bottom-7 opacity-0 hover:opacity-0 group-hover:opacity-100", "rounded-[4px] bg-color-tooltip px-3 py-1 transition-all", "z-10 text-xs font-500 text-blue-900"),
                                                        children: t("txt_copy")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("no-scrollbar flex items-center gap-[8px] tablet:w-[335px] desktop:w-[337px]", "mb-[54px] overflow-hidden overflow-x-scroll pr-[14px] tablet:mb-0"),
                                children: generations/* socials.map */.UY.map(function(props) {
                                    return /*#__PURE__*/ (0,react.createElement)(generations/* SocialButton */.Z0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                        title: "",
                                        handleSocialShare: handleSocialShare,
                                        dialogContent: shareDialog,
                                        setAsShared: setAsShared,
                                        key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                    }));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "hidden rounded-full bg-color-cell p-2 desktop:block",
                onClick: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                    source: "/general/close",
                    format: "svg",
                    className: "h-[16px] w-[16px]"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./sections/history/history-popup.tsx
var history_popup = __webpack_require__(1027);
// EXTERNAL MODULE: ./sections/history/more-button.tsx
var more_button = __webpack_require__(9610);
// EXTERNAL MODULE: ./sections/history/render-content.tsx
var render_content = __webpack_require__(7731);
// EXTERNAL MODULE: ./sections/history/render-text-content.tsx
var render_text_content = __webpack_require__(5492);
// EXTERNAL MODULE: ./sections/history/report-popup.tsx
var report_popup = __webpack_require__(1059);
// EXTERNAL MODULE: ./sections/history/save-media-popup.tsx
var save_media_popup = __webpack_require__(373);
// EXTERNAL MODULE: ./sections/history/share-content.tsx
var share_content = __webpack_require__(8440);
// EXTERNAL MODULE: ./sections/history/single-generated.tsx
var single_generated = __webpack_require__(535);
// EXTERNAL MODULE: ./comps/skeleton.tsx
var skeleton = __webpack_require__(4165);
// EXTERNAL MODULE: ./node_modules/react-responsive-masonry/es/index.js + 2 modules
var react_responsive_masonry_es = __webpack_require__(2337);
// EXTERNAL MODULE: ./sections/gallery/all-gallery.tsx
var all_gallery = __webpack_require__(6106);
;// CONCATENATED MODULE: ./sections/gallery/related-masonry.tsx











var RELATED_ART_LIMIT = 10;
var skeletonList = [
    150,
    200,
    136,
    120,
    130,
    180
];
function RelatedMasonry(relatedProps) {
    var scrollToImage = function scrollToImage(index) {
        var ref;
        var nextImage = (ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByClassName("gallery-".concat(id, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    };
    var handleSetProps = function handleSetProps(e, single) {
        var ref;
        e.preventDefault();
        var newUrl = "/ai-gallery/single/".concat(single.id);
        window.history.pushState({
            path: newUrl
        }, "", newUrl);
        var isVideo = typeof imageOrVideo === "string" && imageOrVideo.split(".").pop() === "mp4";
        var _accepted_at, _prompt, _prompt1, _style_name;
        setProps({
            onClose: onClose,
            closeLink: closeLink !== null && closeLink !== void 0 ? closeLink : "/ai-gallery",
            id: single.id,
            imageOrVideo: typeof imageOrVideo === "string" ? isVideo ? single.object_urls[0].object + "#t=0.001" : single.object_urls[0].object : single.object_urls.map(function(single) {
                return single.object;
            }),
            previewImage: single.object_urls[0].thumb,
            tool: single.tool,
            createdAt: (_accepted_at = single.accepted_at) !== null && _accepted_at !== void 0 ? _accepted_at : new Date().getDate(),
            customPrompt: (_prompt = single.prompt) !== null && _prompt !== void 0 ? _prompt : "",
            privacy: "public",
            prompt: (_prompt1 = single.prompt) !== null && _prompt1 !== void 0 ? _prompt1 : "",
            promptName: (_style_name = single.style_name) !== null && _style_name !== void 0 ? _style_name : "Custom",
            username: single.owner.username,
            followers: single.owner.followers,
            profile_pic: (ref = single.owner.profile_pic) === null || ref === void 0 ? void 0 : ref.original,
            handleRetry: handleRetry,
            notShallow: true,
            showRelated: true,
            model_id: model_id,
            ownerId: single.owner.uid,
            showFor: showFor,
            likes: likes,
            views: views
        });
    };
    var ref, ref1;
    var props = relatedProps.initialProps, setProps = relatedProps.setProps;
    var ref2 = (0,react.useState)(0), offset = ref2[0], setOffset = ref2[1];
    var id = props.id, showRelated = props.showRelated, imageOrVideo = props.imageOrVideo, onClose = props.onClose, closeLink = props.closeLink, handleRetry = props.handleRetry, model_id = props.model_id, showFor = props.showFor, likes = props.likes, views = props.views;
    var t = (0,esm/* useTranslation */.$G)().t;
    var scrollRef = (0,react.useRef)(null);
    var keywords = (0,es.useQuery)({
        queryKey: [
            "keywords",
            "id-".concat(id)
        ],
        queryFn: getKeywords(id),
        staleTime: Infinity,
        enabled: showRelated
    });
    var relatedArt = (0,es.useQuery)({
        queryKey: [
            "related",
            "art-".concat(id)
        ],
        queryFn: getRelatedArt(id, RELATED_ART_LIMIT),
        staleTime: Infinity,
        enabled: showRelated
    });
    var _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto h-[1px] w-[calc(100%-32px)] shrink-0 border-t border-color-separator"
            }),
            !keywords.isError && ((ref = keywords.data) === null || ref === void 0 ? void 0 : ref.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "px-4 text-[14px] font-500 tracking-normal text-blue-600",
                children: t("txt_related_keywords")
            }),
            (keywords.isFetching || keywords.isSuccess) && ((ref1 = keywords.data) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "no-scrollbar flex h-[36px] w-full shrink-0 flex-row gap-[10px] overflow-x-scroll px-4",
                children: [
                    keywords.isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(all_gallery/* SuggestionsSkeleton */.HI, {}),
                    keywords.isSuccess && keywords.data.map(function(keyword) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/ai-gallery/".concat(keyword),
                            className: (0,clsx_m/* default */.Z)("flex h-full shrink-0 flex-row items-center", "justify-center rounded-[6px] bg-color-surface p-3", "text-[13px] font-400 tracking-wider text-blue-700"),
                            children: keyword
                        }, keyword);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "px-4 pt-3 text-[14px] font-500 tracking-normal text-blue-600",
                children: t("txt_relevant_art")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_responsive_masonry_es/* default */.Z, {
                columnsCount: 3,
                gutter: "8px",
                className: "px-4",
                children: [
                    relatedArt.isFetching && skeletonList.map(function(height, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                height: height
                            },
                            className: "w-full overflow-hidden rounded-[12px] desktop:rounded-[14px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                className: "h-full w-full"
                            })
                        }, index);
                    }),
                    relatedArt.isSuccess && relatedArt.data.map(function(single, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "/ai-gallery/single/".concat(single.id),
                            onClick: function(e) {
                                return handleSetProps(e, single);
                            },
                            className: "cursor-pointer",
                            children: [
                                single.object_urls.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            disabled: offset === 0,
                                            onClick: function() {
                                                scrollToImage(offset - 1);
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute left-2 top-[calc(50%-12px)] flex h-6 w-6 items-center justify-center rounded-full", "border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-0 group-hover:opacity-100", "z-[999] desktop:-left-[73px]"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/ai-tools/history/arrow-white.svg"),
                                                alt: "arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            disabled: offset === single.object_urls.length - 1,
                                            onClick: function() {
                                                scrollToImage(offset + 1);
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute right-2 top-[calc(50%-12px)] flex h-6 w-6 items-center justify-center rounded-full", " border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all", " hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-0 group-hover:opacity-100", "z-[999] desktop:-right-[73px]"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/ai-tools/history/arrow-white.svg"),
                                                alt: "arrow",
                                                className: "rotate-180"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("w-full overflow-hidden object-cover", "rounded-[12px] desktop:rounded-[14px]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onScroll: function(event) {
                                            var container = event.target;
                                            if ((0,_instanceof/* default */.Z)(container, HTMLElement)) {
                                                var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                                                setOffset(snapIndex);
                                            }
                                        },
                                        ref: scrollRef,
                                        className: (0,clsx_m/* default */.Z)("no-scrollbar top-0 flex h-full snap-x", "snap-mandatory flex-row gap-12 overflow-x-scroll transition-all"),
                                        children: single.object_urls.map(function(image, index) {
                                            return single.media_type === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: image.thumb,
                                                alt: single.prompt ? single.prompt : (_style = single.style) !== null && _style !== void 0 ? _style : "Custom",
                                                className: (0,clsx_m/* default */.Z)(" h-full min-h-[130px] w-full shrink-0 snap-center", "rounded-[12px] object-cover desktop:min-h-[180px]", "desktop:rounded-[14px]", "gallery-".concat(id, "-").concat(index))
                                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                src: image.object + "#t=0.001",
                                                poster: image.thumb,
                                                playsInline: true,
                                                loop: true,
                                                preload: "none",
                                                muted: true,
                                                onPointerEnter: function(e) {
                                                    e.currentTarget.play().catch(console.error);
                                                },
                                                onPointerLeave: function(e) {
                                                    e.currentTarget.pause();
                                                    e.currentTarget.currentTime = 0.001;
                                                },
                                                className: (0,clsx_m/* default */.Z)("h-full w-full object-cover", "min-h-[130px] rounded-[12px] desktop:min-h-[180px] desktop:rounded-[14px]")
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        }, "item-".concat(single.id));
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./sections/gallery/gallery-popup.tsx




































function getKeywords(id) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.post */.Z.post("/api/gallery-related-searches", {
                            id: id
                        }, {
                            headers: {
                                Authorization: "Bearer sdgdfsgsdfgsdfg",
                                "web-version": cdn/* HEADER_WEB_VERSION */.F
                            }
                        }).then(function(response) {
                            return response.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function getRelatedArt(id, limit) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.post */.Z.post("/api/gallery-related-art", {
                            id: id,
                            limit: limit
                        }, {
                            headers: {
                                Authorization: "Bearer sdgdfsgsdfgsdfg",
                                "web-version": cdn/* HEADER_WEB_VERSION */.F
                            }
                        }).then(function(response) {
                            return response.data.slice(0, limit - 1);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function GalleryPopup(init) {
    var setAsShared = function setAsShared() {
        var options = {
            action: "share",
            gallery_id: id
        };
        axios/* default.post */.Z.post("/api/gallery-view", options).catch(function(e) {
            return console.error(e);
        });
    };
    var backgroundClickHandler = function backgroundClickHandler(e) {
        var target = e.target;
        if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
            if (target.id === "background") {
                if (!notShallow) {
                    router.push(closeLink ? "".concat(closeLink) : "/ai-gallery", undefined, {
                        shallow: true
                    });
                }
                onClose();
            }
            if (target.id !== "media-box") {
                setShowMediaDialog(false);
            }
            if (target.id === "thanks-popup-background") {
                setThanksPopup(false);
            }
        }
    };
    var ref = (0,react.useState)(init), props = ref[0], setProps = ref[1];
    var imageOrVideo = props.imageOrVideo, onClose = props.onClose, createdAt = props.createdAt, privacy = props.privacy, id = props.id, tool = props.tool, initial = props.initial, handleRetry = props.handleRetry, username = props.username, followers = props.followers, profile_pic = props.profile_pic, closeLink = props.closeLink, notShallow = props.notShallow, handleDelete = props.handleDelete, ownerId = props.ownerId, showFor = props.showFor, prompt = props.prompt, customPrompt = props.customPrompt, likes = props.likes, views = props.views, promptName = props.promptName, previewImage = props.previewImage;
    var queryClient = (0,es.useQueryClient)();
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(window.matchMedia("(max-width: 767px)").matches), isMobileView = ref1[0], _ = ref1[1];
    var ref2 = (0,react.useState)(privacy === "public"), isPublic = ref2[0], setPublic = ref2[1];
    var ref3 = (0,react.useState)({
        gallery_id: id,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref3[0], setPayload = ref3[1];
    var ref4 = (0,react.useState)(false), showDropdown = ref4[0], setShowDropdown = ref4[1];
    var ref5 = (0,react.useState)({
        open: false,
        isPublic: false,
        link: "".concat(variables/* APP_HOST */.b, "/ai-gallery/single/").concat(id),
        id: null
    }), shareDialog = ref5[0], setShareDialog = ref5[1];
    var ref6 = (0,react.useState)(false), showMediaDialog = ref6[0], setShowMediaDialog = ref6[1];
    var ref7 = (0,react.useState)(0), offset = ref7[0], setOffset = ref7[1];
    var ref8 = (0,react.useState)(false), reportPopup = ref8[0], setReportPopup = ref8[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var isSelf = ownerId === userInfo.userId;
    var _followStatus;
    var ref9 = (0,react.useState)((_followStatus = props.followStatus) !== null && _followStatus !== void 0 ? _followStatus : "not_following"), followStatus = ref9[0], setFollowStatus = ref9[1];
    var ref10 = (0,react.useState)(false), thanksPopup = ref10[0], setThanksPopup = ref10[1];
    var ref11 = (0,react.useState)(false), liked = ref11[0], setLiked = ref11[1];
    (0,react.useEffect)(function() {
        if (reportPopup) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        reportPopup
    ]);
    function handleMakePublic(privacy, id) {
        return _handleMakePublic.apply(this, arguments);
    }
    function _handleMakePublic() {
        _handleMakePublic = (0,_async_to_generator/* default */.Z)(function(privacy, id) {
            var payload, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        payload = {
                            privacy: privacy === "public" ? "private" : "public",
                            job: id
                        };
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/deforum-privacy", payload)
                        ];
                    case 1:
                        _state.sent();
                        queryClient.invalidateQueries("deforum-history");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t(privacy === "public" ? "txt_could_not_make_public" : "txt_could_not_make_private")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleMakePublic.apply(this, arguments);
    }
    function handleSocialShare(desktop, desktopFunction, url) {
        return _handleSocialShare.apply(this, arguments);
    }
    function _handleSocialShare() {
        _handleSocialShare = (0,_async_to_generator/* default */.Z)(function(desktop, desktopFunction, url) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(!shareDialog.isPublic && !showFor)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleMakePublic("private", id)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        if (desktop && desktopFunction) return [
                            2,
                            desktopFunction(shareDialog.link)
                        ];
                        else if (url) return [
                            2,
                            url(shareDialog.link)
                        ];
                        else throw Error("No function");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        console.error(e);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            2,
                            ""
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSocialShare.apply(this, arguments);
    }
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.key === "Escape") {
                if (!notShallow) {
                    router.push(closeLink ? "".concat(closeLink) : "/ai-gallery", undefined, {
                        shallow: true
                    });
                }
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return function() {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        closeLink,
        notShallow,
        onClose,
        router
    ]);
    function handleCopyText(e) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_async_to_generator/* default */.Z)(function(e) {
            var target, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        setAsShared();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText("".concat(variables/* APP_HOST */.b, "/ai-gallery/single/").concat(id))
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    function handleLike() {
        return _handleLike.apply(this, arguments);
    }
    function _handleLike() {
        _handleLike = (0,_async_to_generator/* default */.Z)(function() {
            var endpoint, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (userInfo && userInfo.isAnonymous) {
                            (0,login_redirect/* redirectToLogin */.r)();
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        endpoint = liked ? "/api/gallery-unlike" : "/api/gallery-like";
                        return [
                            4,
                            axios/* default.post */.Z.post(endpoint, {
                                gallery_id: id
                            })
                        ];
                    case 2:
                        _state.sent();
                        setLiked(!liked);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleLike.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(reportPopup ? "overflow-hidden" : "overflow-y-scroll", "no-scrollbar fixed inset-0 z-[100] h-screen w-screen", "transition-opacity duration-300", "bg-color-cell tablet:overscroll-contain tablet:bg-color-black/40", "cursor-auto desktop:overflow-hidden"),
        id: "background",
        onClick: function(e) {
            return backgroundClickHandler(e);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("no-scrollbar relative w-screen bg-color-cell tablet:rounded-xl", "tablet:left-1/2 tablet:top-[100px] tablet:h-[1090px] tablet:w-[564px] tablet:-translate-x-1/2 ", " responsive-zoom desktop:h-[857px] desktop:w-[1206px]", "desktop:top-1/2 desktop:-translate-y-1/2"),
                children: [
                    thanksPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "thanks-popup-background",
                        className: (0,clsx_m/* default */.Z)("fixed z-[998] h-full w-full rounded-xl bg-color-popup")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThanksPopup, {
                        open: thanksPopup,
                        setOpen: setThanksPopup,
                        username: username,
                        id: id,
                        image: typeof imageOrVideo === "string" ? imageOrVideo : imageOrVideo[offset],
                        setAsShared: setAsShared,
                        shareDialog: shareDialog,
                        handleSocialShare: handleSocialShare
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("relative flex flex-col", "desktop:w-full desktop:flex-row"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render_content/* RenderContent */.x, {
                                id: id,
                                tool: tool,
                                imageOrVideo: imageOrVideo,
                                createdAt: createdAt,
                                closeLink: closeLink,
                                prompt: prompt,
                                privacy: privacy,
                                customPrompt: customPrompt,
                                notShallow: false,
                                promptName: promptName,
                                offset: offset,
                                onClose: onClose,
                                handleRetry: handleRetry,
                                previewImage: previewImage,
                                setOffset: setOffset,
                                viewFor: "gallery"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("mb-[60px] hidden flex-col gap-[12px] py-[14px] tablet:flex desktop:mb-0", "no-scrollbar shrink-0 overflow-y-scroll desktop:w-[431px] desktop:py-[16px]", "relative z-50 bg-color-cell tablet:h-[559px] desktop:h-[857px]", "rounded-xl tablet:rounded-t-none desktop:rounded-l-none desktop:rounded-r-xl"),
                                children: [
                                    username[0] !== "-" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between px-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-center gap-[6px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/".concat(username, "?active=2"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: profile_pic !== null && profile_pic !== void 0 ? profile_pic : (0,cdn/* assetUrl */.p)("/general/avatar.svg"),
                                                            onError: function(e) {
                                                                return e.currentTarget.setAttribute("src", (0,cdn/* assetUrl */.p)("/icons/avatar-default.svg"));
                                                            },
                                                            alt: "profile picture",
                                                            className: "h-10 w-10 shrink-0 rounded-full border border-color-separator object-cover"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col gap-[1px]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/".concat(username, "?active=2"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "max-w-[100px] truncate text-[16px] font-700 text-blue-800",
                                                                    children: username
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-[14px] font-500 text-blue-600",
                                                                children: (0,millions/* default */.Z)(followers !== null && followers !== void 0 ? followers : 0) + " followers"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(isSelf && "hidden", "flex items-center gap-[11px]"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex w-[150px] items-center justify-center overflow-hidden rounded-[6px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(advanced_profile/* FollowButton */.eg, {
                                                            followStatus: followStatus,
                                                            uid: ownerId,
                                                            setFollowStatus: setFollowStatus,
                                                            userPage: false
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,clsx_m/* default */.Z)("h-[44px] w-[44px] [--icon-color:var(--color-blue-900)] hover:bg-blue-100", "flex items-center justify-center rounded-md"),
                                                                children: (0,icons/* moreIcon */.Jf)()
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onClick: function() {
                                                                    setReportPopup === null || setReportPopup === void 0 ? void 0 : setReportPopup(true);
                                                                },
                                                                className: (0,clsx_m/* default */.Z)("fixed hidden w-[123px] rounded-[12px] px-[10px] py-[8px] group-hover:flex", "z-[200] items-center gap-[8px] shadow-xl hover:bg-blue-100", "-right-[30px] top-[740px] bg-color-popup-cell desktop:top-[80px]"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                                        source: "/general/report",
                                                                        format: "svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[16px] font-500 text-blue-800",
                                                                        children: t("txt_report")
                                                                    })
                                                                ]
                                                            }),
                                                            reportPopup && setReportPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(report_popup/* ReportPopup */.j, {
                                                                payloadLocation: "gallery",
                                                                payload: payload,
                                                                setPayload: setPayload,
                                                                setReportPopup: setReportPopup,
                                                                endpoint: "gallery-report",
                                                                galleryOrTemplate: "gallery"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    username[0] !== "-" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto h-[1px] w-[calc(100%-32px)] shrink-0 bg-color-separator"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex shrink-0 flex-col gap-[8px] px-[16px] desktop:w-[431px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("flex items-center justify-between"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-[12px] [--icon-color:var(--color-blue-600)]",
                                                    children: [
                                                        props.model === undefined && (0,history_popup/* transformToolToIcon */.eA)(tool),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (0,clsx_m/* default */.Z)("text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-blue-700"),
                                                            children: props.model !== undefined ? props.model : (0,history_popup/* transformTool */.L2)(tool)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx_m/* default */.Z)("text-[16px] font-[500] leading-[26px] tracking-[0.28px] text-blue-500"),
                                                    children: (0,history_popup/* formatTimes */.Nf)(createdAt)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto h-[1px] w-[calc(100%-32px)] shrink-0 bg-color-separator"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("relative z-50 flex shrink-0 items-start gap-[10px] px-[16px]", "no-scrollbar -mb-[30px] pb-[30px] desktop:overflow-x-auto"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(save_media_popup/* SaveMediaPopup */.N, {
                                                setAsShared: setAsShared,
                                                offset: offset,
                                                showMediaDialog: showMediaDialog,
                                                setShowMediaDialog: setShowMediaDialog,
                                                imageOrVideo: imageOrVideo,
                                                showDropdown: showDropdown,
                                                setThanksPopup: setThanksPopup,
                                                setShowDropdown: setShowDropdown
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[50px] w-[1px] bg-blue-300 desktop:shrink-0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: handleCopyText,
                                                className: (0,clsx_m/* default */.Z)("relative flex items-center justify-center", "group transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 overflow-visible rounded-full bg-color-surface"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,cdn/* assetUrl */.p)("/ai-tools/history/copy-primary.svg"),
                                                        alt: "copy icon",
                                                        className: "h-[20px] w-[20px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)("pointer-events-none absolute -bottom-[30px] w-[80px]", "rounded-[4px] px-3 py-1 opacity-0 hover:opacity-0 group-hover:opacity-100", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                                        children: t("txt_copy_link")
                                                    })
                                                ]
                                            }),
                                            generations/* socials.map */.UY.map(function(props) {
                                                return /*#__PURE__*/ (0,react.createElement)(generations/* SocialButton */.Z0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                                    title: "",
                                                    tooltipTitle: props.title,
                                                    handleSocialShare: handleSocialShare,
                                                    dialogContent: shareDialog,
                                                    setAsShared: setAsShared,
                                                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                                }));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render_text_content/* RenderTextContent */.K, (0,_object_spread/* default */.Z)({}, props)),
                                    props.modelType !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("ml-[16px] flex items-center gap-[4px] rounded-[5px]", "bg-color-background px-[10px] py-[4px]"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,cdn/* assetUrl */.p)("/general/model-icon.svg"),
                                                    className: "h-[14px] w-[14px]",
                                                    alt: "model icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[14px] font-500 text-blue-700",
                                                    children: (0,models.getModelType)(props.modelType)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: handleRetry,
                                        className: (0,clsx_m/* default */.Z)("mx-auto my-[4px] hidden w-[calc(100%-32px)] shrink-0 items-center", "justify-center gap-[12px] rounded-[10px] bg-primary-500 py-[12px]", "hover:opacity-70 desktop:my-[10px] desktop:flex"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/general/regenerate-white.svg"),
                                                alt: "plus icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                                children: t("txt_use_prompt")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full shrink-0 px-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: branch/* appStoreConstant */.HY,
                                            className: (0,clsx_m/* default */.Z)("relative mx-auto flex w-full items-center justify-center", "gap-[12px] rounded-[10px] bg-primary-500 py-[12px]", "hover:opacity-70 desktop:hidden"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,cdn/* assetUrl */.p)("/general/regenerate-white.svg"),
                                                    alt: "plus icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                                    children: t("txt_use_prompt")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedMasonry, {
                                        initialProps: props,
                                        setProps: setProps
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-40 flex w-full flex-col gap-[19px] p-[12px] tablet:hidden", "border-t border-color-separator bg-color-white"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: branch/* appStoreConstant */.HY,
                                    className: (0,clsx_m/* default */.Z)("relative flex w-full items-center justify-center gap-[12px]", "rounded-[10px] bg-primary-500 py-[12px] hover:opacity-80"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 -z-10 h-full w-full rounded-[10px] bg-color-black/80"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                            children: t("txt_use_prompt")
                                        })
                                    ]
                                })
                            }),
                            reportPopup && setReportPopup && !isSelf && /*#__PURE__*/ (0,jsx_runtime.jsx)(report_popup/* ReportPopup */.j, {
                                payloadLocation: "gallery",
                                payload: payload,
                                setPayload: setPayload,
                                endpoint: "gallery-report",
                                setReportPopup: setReportPopup,
                                galleryOrTemplate: "gallery"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(" absolute right-[17px] top-[17px] z-50", "tablet:top-[680px] desktop:top-[18px]", "flex items-center gap-[12px]", username && "tablet:hidden"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(more_button/* MoreButton */.z, {
                                    handleMakePublic: handleMakePublic,
                                    setShowDropdown: setShowDropdown,
                                    setShareDialog: setShareDialog,
                                    handleDelete: handleDelete,
                                    setPublic: setPublic,
                                    showDropdown: showDropdown,
                                    dark: !isMobileView,
                                    isPublic: isPublic,
                                    privacy: privacy,
                                    href: initial !== null && initial !== void 0 ? initial : "",
                                    id: id,
                                    username: username,
                                    closeLink: closeLink,
                                    setReportPopup: setReportPopup,
                                    reportPopup: !isSelf && reportPopup
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-t-[12px] tablet:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(single_generated/* RelatedSection */.$, {
                    id: id,
                    showRelated: true,
                    profilePic: profile_pic === undefined ? null : profile_pic,
                    ownerId: ownerId,
                    setFollowStatus: setFollowStatus,
                    followStatus: followStatus,
                    username: username,
                    tool: tool,
                    createdAt: createdAt,
                    followers: followers,
                    customPrompt: customPrompt,
                    likes: likes,
                    views: views,
                    singlePageUse: false,
                    liked: liked,
                    handleLike: handleLike
                })
            }),
            shareDialog.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(share_content/* ShareContent */.X, {
                shareDialog: shareDialog,
                setShareDialog: setShareDialog,
                isPublic: isPublic,
                id: id,
                handleMakePublic: handleMakePublic
            })
        ]
    });
}


/***/ }),

/***/ 6622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ju": function() { return /* binding */ skeletonList; },
/* harmony export */   "uF": function() { return /* binding */ GallerySingle; }
/* harmony export */ });
/* unused harmony export SocialButtonGallery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2404);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1816);
/* harmony import */ var _utils_indexed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(788);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7592);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2706);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6154);
/* harmony import */ var comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8641);
/* harmony import */ var controllers_editors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3826);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7294);
/* harmony import */ var sections_history_ai_single_page__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5576);
















var skeletonList = [
    150,
    200,
    136,
    120,
    130,
    180
];
function getJsonLdData(id, image, uploadDate, username, prompt, isVideo, preview, name, description) {
    if (isVideo) {
        return [
            {
                "@context": "https://schema.org",
                "@type": "VideoObject",
                name: name,
                description: description,
                thumbnailUrl: [
                    preview
                ],
                license: "https://zoomerang.app/privacy-policy",
                acquireLicensePage: "https://zoomerang.app/ai-gallery/single/" + id,
                copyrightNotice: "Zoomerang",
                uploadDate: uploadDate,
                author: {
                    "@type": "Person",
                    name: username
                },
                creator: {
                    "@type": "Person",
                    name: username
                },
                contentUrl: image
            }, 
        ];
    }
    return [
        {
            "@context": "https://schema.org",
            "@type": "ImageObject",
            contentUrl: image,
            license: "https://zoomerang.app/privacy-policy",
            acquireLicensePage: "https://zoomerang.app/ai-gallery/single/" + id,
            copyrightNotice: "Zoomerang",
            uploadDate: uploadDate,
            author: {
                "@type": "Person",
                name: username
            },
            creator: {
                "@type": "Person",
                name: username
            },
            description: prompt,
            caption: prompt,
            url: "https://zoomerang.app/ai-gallery/single/" + id
        }, 
    ];
}
function GallerySingle(props) {
    var setAsShared = function setAsShared() {
        var options = {
            action: "share",
            gallery_id: id
        };
        axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/gallery-view", options).catch(function(e) {
            return console.error(e);
        });
    };
    var scrollToImage = function scrollToImage(index) {
        var nextImage = document.getElementsByClassName("ai-art-generation-".concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    };
    var job = props.job;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var _job = job.job, result = _job.result, tool = _job.tool, id = _job.id, promptName = _job.promptName, previewImage = _job.previewImage, customPrompt = _job.customPrompt, prompt = _job.prompt, likes = _job.likes, views = _job.views, isVideo = _job.isVideo, accepted_at = _job.accepted_at;
    var _user = job.user, username = _user.username, picture = _user.picture, followers = _user.followers, uid = _user.uid, followStatus = _user.followStatus;
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().userInfo;
    var data = (0,controllers_editors__WEBPACK_IMPORTED_MODULE_7__/* .getStorage */ .cF)(tool !== "ai_look" && tool !== "ai_suggest" ? tool : "deform");
    var indexed = (0,_utils_indexed__WEBPACK_IMPORTED_MODULE_3__/* .useIndexedDB */ .i)("ai_art", data.tool, data.storage);
    var viewRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        if (!viewRef.current) {
            viewRef.current = true;
            var options = {
                action: "view",
                gallery_id: id
            };
            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/gallery-view", options).catch(function(e) {
                return console.error(e);
            });
        }
    }, [
        id,
        viewRef
    ]);
    function handleRetry() {
        return _handleRetry.apply(this, arguments);
    }
    function _handleRetry() {
        _handleRetry = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            var promptType, inputs, link;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (userInfo.isAnonymous) {
                            (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_4__/* .redirectToLogin */ .r)();
                            return [
                                2
                            ];
                        }
                        if (indexed.status !== "ready") return [
                            2
                        ];
                        promptType = prompt;
                        inputs = promptType === "custom" ? (0,comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.createInputs)({
                            type: "custom",
                            content: [
                                ""
                            ]
                        }) : (0,comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.createInputs)({
                            type: "predefined",
                            id: promptType !== null && promptType !== void 0 ? promptType : ""
                        });
                        switch(tool){
                            case "deform":
                                return [
                                    3,
                                    1
                                ];
                            case "ai_photo":
                                return [
                                    3,
                                    3
                                ];
                            case "ai_restyle":
                                return [
                                    3,
                                    5
                                ];
                            case "text_to_image":
                                return [
                                    3,
                                    7
                                ];
                        }
                        return [
                            3,
                            9
                        ];
                    case 1:
                        return [
                            4,
                            indexed.setData({
                                tool: "deform",
                                id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.DEFORUM_STORAGE_KEY,
                                inputs: inputs,
                                promptType: prompt !== null && prompt !== void 0 ? prompt : "custom",
                                location: "local",
                                blob: null
                            })
                        ];
                    case 2:
                        _state.sent();
                        router.push("/home?tool=deform");
                        return [
                            3,
                            10
                        ];
                    case 3:
                        return [
                            4,
                            indexed.setData({
                                tool: "ai_photo",
                                id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.DEFORUM_STORAGE_KEY,
                                input: "",
                                promptType: prompt,
                                location: "local",
                                blob: null
                            })
                        ];
                    case 4:
                        _state.sent();
                        router.push("/home?tool=ai_photo");
                        return [
                            3,
                            10
                        ];
                    case 5:
                        return [
                            4,
                            indexed.setData({
                                tool: "ai_restyle",
                                id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.DEFORUM_STORAGE_KEY,
                                input: "",
                                promptType: prompt,
                                location: "local",
                                blob: null
                            })
                        ];
                    case 6:
                        _state.sent();
                        router.push("/home?tool=ai_restyle");
                        return [
                            3,
                            10
                        ];
                    case 7:
                        return [
                            4,
                            indexed.setData({
                                tool: "text_to_image",
                                id: comps_editors_deform__WEBPACK_IMPORTED_MODULE_6__.DEFORUM_STORAGE_KEY,
                                promptType: prompt,
                                text: customPrompt !== null && customPrompt !== void 0 ? customPrompt : "",
                                location: "local",
                                blob: null
                            })
                        ];
                    case 8:
                        _state.sent();
                        router.push("/home?tool=text_to_image");
                        return [
                            3,
                            10
                        ];
                    case 9:
                        link = document.createElement("a");
                        link.href = _utils_branch__WEBPACK_IMPORTED_MODULE_1__/* .appStoreConstant */ .HY;
                        link.target = "_blank";
                        link.click();
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleRetry.apply(this, arguments);
    }
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)({
        open: false,
        isPublic: true,
        link: "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_5__/* .APP_HOST */ .b, "/ai-gallery/single/").concat(id),
        id: null
    }), shareDialog = ref[0], setShareDialog = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        scrollToImage(0);
    }, [
        result
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_history_ai_single_page__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        onClose: function() {
            router.push("/ai-gallery");
        },
        createdAt: 0,
        imageOrVideo: result.map(function(elem) {
            return elem.object;
        }),
        isVideo: isVideo,
        previewImage: previewImage,
        tool: tool,
        cover: result[0].thumb,
        id: id !== null && id !== void 0 ? id : 0,
        customPrompt: customPrompt !== null && customPrompt !== void 0 ? customPrompt : "",
        style: promptName,
        shareDialog: shareDialog,
        setShareDialog: setShareDialog,
        handleRetry: handleRetry,
        closeLink: "/ai-gallery",
        username: username,
        profile_pic: picture,
        followers: followers,
        notShallow: true,
        showRelated: true,
        ownerId: uid,
        followStatus: followStatus !== null && followStatus !== void 0 ? followStatus : "not_following",
        setAsShared: setAsShared,
        likes: likes,
        views: views,
        jsonLdData: getJsonLdData(id, result[0].object, new Date(accepted_at !== null && accepted_at !== void 0 ? accepted_at : 0).toISOString(), username, prompt !== null && prompt !== void 0 ? prompt : promptName, isVideo, result[0].thumb, "AI Art" + (username ? " by " + username + " - " : " - ") + (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_9__.getFirstFiveWords)(customPrompt && customPrompt.trim().length !== 0 ? customPrompt : promptName), customPrompt ? promptName + " - " + customPrompt : promptName + " AI Art By " + username)
    });
}
function SocialButtonGallery(props) {
    var url = props.url, dialogContent = props.dialogContent, desktop = props.desktop, title = props.title, handleSocialShare = props.handleSocialShare, tooltipTitle = props.tooltipTitle;
    var imageClasses = "bg-color-background transition-colors hover:bg-blue-300 p-3 w-[52px] h-[52px]";
    var anchorClasses = "flex rounded-full overflow-hidden shrink-0 pointer-events-auto w-[52px] h-[52px]";
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "group relative flex flex-col items-center gap-2",
            children: [
                /*#__PURE__*/ _jsx("button", {
                    onClick: /*#__PURE__*/ _async_to_generator(function() {
                        var anchor, desktopUrl;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    anchor = document.createElement("a");
                                    anchor.target = "_blank";
                                    anchor.rel = "noreferrer";
                                    return [
                                        4,
                                        handleSocialShare(true, desktop, url)
                                    ];
                                case 1:
                                    desktopUrl = _state.sent();
                                    anchor.href = desktopUrl;
                                    anchor.click();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: clsx("hidden desktop:block", !dialogContent.open ? "pointer-events-none" : "cursor-pointer", anchorClasses),
                    children: props.icon ? /*#__PURE__*/ _jsx("img", {
                        src: props.icon,
                        alt: "social icon",
                        className: imageClasses
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: props.dark,
                                "data-hide-on-theme": "light",
                                alt: "dark icon",
                                className: imageClasses
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: props.light,
                                alt: "light icon",
                                "data-hide-on-theme": "dark",
                                className: imageClasses
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("button", {
                    onClick: /*#__PURE__*/ _async_to_generator(function() {
                        var anchor, mobileUrl;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    anchor = document.createElement("a");
                                    anchor.target = "_blank";
                                    anchor.rel = "noreferrer";
                                    return [
                                        4,
                                        handleSocialShare(false, undefined, url)
                                    ];
                                case 1:
                                    mobileUrl = _state.sent();
                                    anchor.href = mobileUrl;
                                    anchor.click();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: clsx("desktop:hidden", anchorClasses, !dialogContent.open ? "pointer-events-none" : "cursor-pointer"),
                    children: props.icon ? /*#__PURE__*/ _jsx("img", {
                        src: props.icon,
                        alt: "icon",
                        className: imageClasses
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: props.dark,
                                alt: "dark icon",
                                "data-hide-on-theme": "light",
                                className: imageClasses
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: props.light,
                                alt: "light icon",
                                "data-hide-on-theme": "dark",
                                className: imageClasses
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-[14px] font-600 text-blue-600",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx("opacity-0 hover:opacity-0 group-hover:opacity-100", "absolute -bottom-[22px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                    children: tooltipTitle
                })
            ]
        })
    });
}


/***/ }),

/***/ 5576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ RELATED_ART_LIMIT; },
/* harmony export */   "Z": function() { return /* binding */ AISinglePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_advanced_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8673);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1455);
/* harmony import */ var _comps_ai_tools_other_products_section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(437);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1083);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9612);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9034);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(624);
/* harmony import */ var _comps_player__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1993);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6254);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2404);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1816);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7592);
/* harmony import */ var _utils_millions__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(323);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4371);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2706);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3826);
/* harmony import */ var pages_tools__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9274);
/* harmony import */ var sections_history_generations__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5170);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(1501);
/* harmony import */ var _history_popup__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1027);
/* harmony import */ var _more_button__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(9610);
/* harmony import */ var _report_popup__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(1059);
/* harmony import */ var _share_content__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(8440);
/* harmony import */ var _single_generated__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(535);






































var RELATED_ART_LIMIT = 20;
function AISinglePage(props) {
    var handleRoute = function handleRoute() {
        onClose();
        if (!notShallow) {
            router.push(closeLink ? "".concat(closeLink) : "/home", undefined, {
                shallow: true
            });
        }
    };
    var id = props.id, tool = props.tool, createdAt = props.createdAt, shareDialog = props.shareDialog, setShareDialog = props.setShareDialog, imageOrVideo = props.imageOrVideo, isVideo = props.isVideo, customPrompt = props.customPrompt, onClose = props.onClose, handleRetry = props.handleRetry, closeLink = props.closeLink, username = props.username, profile_pic = props.profile_pic, followers = props.followers, style = props.style, notShallow = props.notShallow, showRelated = props.showRelated, ownerId = props.ownerId, setAsShared = props.setAsShared, cover = props.cover, views = props.views, previewImage = props.previewImage, jsonLdData = props.jsonLdData;
    var auth = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMediaDialog = ref[0], setShowMediaDialog = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_18__.useRouter)();
    var _followStatus;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_followStatus = props.followStatus) !== null && _followStatus !== void 0 ? _followStatus : null), followStatus = ref2[0], setFollowStatus = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showDropdown = ref3[0], setShowDropdown = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), liked = ref4[0], setLiked = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.likes), likes = ref5[0], setLikes = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHovered = ref6[0], setIsHovered = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        gallery_id: id,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref7[0], setPayload = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), reportPopup = ref8[0], setReportPopup = ref8[1];
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_15__/* .NotificationContext */ .u).notify;
    var isSelf = ownerId === auth.userInfo.userId && !auth.userInfo.isAnonymous;
    function handleLike() {
        return _handleLike.apply(this, arguments);
    }
    function _handleLike() {
        _handleLike = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
            var endpoint, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (auth.userInfo && auth.userInfo.isAnonymous) {
                            (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_14__/* .redirectToLogin */ .r)();
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        endpoint = liked ? "/api/gallery-unlike" : "/api/gallery-like";
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_30__/* ["default"].post */ .Z.post(endpoint, {
                                gallery_id: id
                            })
                        ];
                    case 2:
                        _state.sent();
                        setLikes(function(c) {
                            if (c === null) {
                                return c;
                            }
                            if (liked) {
                                return c - 1;
                            } else {
                                return c + 1;
                            }
                        });
                        setLiked(!liked);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleLike.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_meta__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                title: "AI Art" + (username ? " by " + username + " - " : " - ") + (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_19__.getFirstFiveWords)(customPrompt && customPrompt.trim().length !== 0 ? customPrompt : style),
                description: customPrompt ? style + " - " + customPrompt : style + " AI Art By " + username,
                cover: cover,
                jsonLdData: jsonLdData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar h-full overflow-y-scroll", showRelated ? " bg-color-cell tablet:bg-color-background" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden desktop:block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex flex-col", "relative desktop:flex-row desktop:items-start desktop:justify-center", "desktop:gap-[120px] desktop:pt-[88px]"),
                        onClick: function(e) {
                            var target = e.target;
                            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(target, HTMLElement)) {
                                if (target.id !== "media-box") {
                                    setShowMediaDialog(false);
                                }
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("hidden items-center justify-between desktop:flex", "absolute left-1/2 top-[20px] w-[1075px] -translate-x-1/2"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex items-center"),
                                    onClick: handleRoute,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/arrow-left.svg"),
                                            alt: "arrow icon",
                                            className: "h-[36px] w-[36px] shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[18px] font-500 text-blue-800",
                                            children: username ? t("common:lbl_gallery") : t("txt_history")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderImageSection, {
                                imageOrVideo: imageOrVideo,
                                previewImage: previewImage,
                                isVideo: isVideo,
                                offset: offset,
                                style: style,
                                setOffset: setOffset
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute left-[17px] top-[17px] z-[101] desktop:hidden", "rounded-full bg-color-white/25 p-2"),
                                onClick: function() {
                                    onClose();
                                    if (!notShallow) {
                                        router.push(closeLink ? "".concat(closeLink) : "/home", undefined, {
                                            shallow: true
                                        });
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/comps/close-icon.svg"),
                                    alt: "close icon"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute right-[17px] top-[17px] z-50 tablet:hidden", "flex items-center justify-center gap-[12px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_more_button__WEBPACK_IMPORTED_MODULE_24__/* .MoreButton */ .z, {
                                        setShareDialog: setShareDialog,
                                        showDropdown: showDropdown,
                                        setShowDropdown: setShowDropdown,
                                        id: id,
                                        href: typeof imageOrVideo === "string" ? imageOrVideo : imageOrVideo[0],
                                        dark: false,
                                        isSinglePage: true,
                                        username: username !== null && username !== void 0 ? username : undefined,
                                        setReportPopup: setReportPopup,
                                        reportPopup: !isSelf && reportPopup,
                                        closeLink: closeLink !== null && closeLink !== void 0 ? closeLink : undefined
                                    }),
                                    reportPopup && setReportPopup && !isSelf && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_report_popup__WEBPACK_IMPORTED_MODULE_25__/* .ReportPopup */ .j, {
                                        payloadLocation: "gallery",
                                        payload: payload,
                                        setPayload: setPayload,
                                        endpoint: "gallery-report",
                                        setReportPopup: setReportPopup,
                                        galleryOrTemplate: "gallery"
                                    })
                                ]
                            }),
                            shareDialog.open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_content__WEBPACK_IMPORTED_MODULE_26__/* .ShareContent */ .X, {
                                shareDialog: shareDialog,
                                setShareDialog: setShareDialog,
                                isPublic: true,
                                id: id
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden tablet:block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderContentSection, {
                                    closeFn: onClose,
                                    tool: tool,
                                    id: id,
                                    showRelated: showRelated,
                                    shareDialog: shareDialog,
                                    setShareDialog: setShareDialog,
                                    ownerId: ownerId !== null && ownerId !== void 0 ? ownerId : null,
                                    setShowMediaDialog: setShowMediaDialog,
                                    followers: followers,
                                    createdAt: createdAt,
                                    customPrompt: customPrompt,
                                    offset: offset,
                                    setFollowStatus: setFollowStatus,
                                    imageOrVideo: imageOrVideo,
                                    closeLink: closeLink,
                                    showMediaDialog: showMediaDialog,
                                    handleRetry: handleRetry,
                                    username: username,
                                    profilePicture: profile_pic,
                                    followStatus: followStatus,
                                    style: style,
                                    setAsShared: setAsShared,
                                    handleLike: handleLike,
                                    liked: liked,
                                    likes: likes,
                                    views: views
                                })
                            }),
                            showRelated ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("fixed bottom-0 left-0 z-40 flex w-full flex-col gap-[19px] p-[12px] tablet:hidden", "border-t border-color-separator bg-color-white"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: _utils_branch__WEBPACK_IMPORTED_MODULE_12__/* .appStoreConstant */ .HY,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative flex w-full items-center justify-center gap-[12px]", "rounded-[10px] bg-primary-500 py-[12px] hover:opacity-80"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0 -z-10 h-full w-full rounded-[10px] bg-color-black/80"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                            children: t("txt_try_now")
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("fixed bottom-0 left-0 z-[10] flex w-full flex-col gap-[19px] px-[16px] pb-[46px] tablet:hidden", "bg-gradient-to-t from-color-black/75 via-color-black/40 to-color-black/5 backdrop-blur-[1px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-[8px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex items-center justify-between", "tablet:absolute tablet:-top-[360px] tablet:flex-col tablet:items-start"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center gap-[12px] [--icon-color:var(--color-white)]",
                                                        children: [
                                                            (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .transformToolToIcon */ .eA)(tool),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(" text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-color-white ", "tablet:text-blue-700"),
                                                                children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .transformTool */ .L2)(tool)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-blue-400"),
                                                        children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .formatTimes */ .Nf)(createdAt)
                                                    })
                                                ]
                                            }),
                                            tool === "text_to_image" || tool === "text_to_video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("w-full pr-3 tablet:hidden", "transition-all group-hover:opacity-100", "relative mt-[16px] flex cursor-auto items-start gap-[30px]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "no-scrollbar flex justify-between overflow-hidden overflow-y-scroll pr-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("cursor-text font-mono text-sm font-400 text-color-white transition-[max-height]", isHovered ? "max-h-[80px] min-h-[50px] max-w-[280px] whitespace-normal" : "max-h-[20px] w-[260px] truncate"),
                                                                        children: customPrompt
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(isHovered ? " absolute right-0 top-0" : "hidden", "h-8 w-8 shrink-0 cursor-pointer transition-colors hover:bg-blue-100", "flex items-center justify-center rounded-[4px]"),
                                                                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
                                                                            var e;
                                                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        _state.trys.push([
                                                                                            0,
                                                                                            2,
                                                                                            ,
                                                                                            3
                                                                                        ]);
                                                                                        return [
                                                                                            4,
                                                                                            navigator.clipboard.writeText(customPrompt !== null && customPrompt !== void 0 ? customPrompt : "")
                                                                                        ];
                                                                                    case 1:
                                                                                        _state.sent();
                                                                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .SuccessMessage */ .kk, {
                                                                                            children: t("common:txt_successfully_copied")
                                                                                        }));
                                                                                        return [
                                                                                            3,
                                                                                            3
                                                                                        ];
                                                                                    case 2:
                                                                                        e = _state.sent();
                                                                                        console.error(e);
                                                                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                                                            children: t("common:txt_couldnt_copy")
                                                                                        }));
                                                                                        return [
                                                                                            3,
                                                                                            3
                                                                                        ];
                                                                                    case 3:
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        }),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                                                            alt: "copy",
                                                                            className: "h-[18px] w-[18px]"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(isHovered ? "-bottom-[2px]" : "-top-[2px]", "absolute right-0 w-[70px]", "flex items-center justify-center rounded-[12px]"),
                                                                onClick: function() {
                                                                    return setIsHovered(!isHovered);
                                                                },
                                                                children: isHovered ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-color-white",
                                                                    children: t("txt_less")
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-color-white",
                                                                    children: t("txt_more")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("mx-[16px] hidden justify-between gap-[8px] tablet:flex", "relative pl-[12px] pr-[5px]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("text-[13px] font-400 leading-[22px] tracking-[0.32px] text-blue-800", "cursor-text -tracking-[0.5px] tablet:max-h-[130px]", "no-scrollbar overflow-y-scroll desktop:max-h-[175px]"),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("py-[9px] pr-[45px] font-mono"),
                                                                    children: customPrompt
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: " absolute right-4 top-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative h-8 w-8 shrink-0 cursor-pointer transition-colors", "group flex items-center justify-center rounded-[4px] hover:bg-blue-200"),
                                                                    onClick: function() {
                                                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(e) {
                                                                            var target, e1;
                                                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        target = e.currentTarget;
                                                                                        target.disabled = true;
                                                                                        setTimeout(function() {
                                                                                            target.disabled = false;
                                                                                        }, 3000);
                                                                                        _state.label = 1;
                                                                                    case 1:
                                                                                        _state.trys.push([
                                                                                            1,
                                                                                            3,
                                                                                            ,
                                                                                            4
                                                                                        ]);
                                                                                        return [
                                                                                            4,
                                                                                            navigator.clipboard.writeText(customPrompt !== null && customPrompt !== void 0 ? customPrompt : "")
                                                                                        ];
                                                                                    case 2:
                                                                                        _state.sent();
                                                                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .SuccessMessage */ .kk, {
                                                                                            children: t("common:txt_successfully_copied")
                                                                                        }));
                                                                                        return [
                                                                                            3,
                                                                                            4
                                                                                        ];
                                                                                    case 3:
                                                                                        e1 = _state.sent();
                                                                                        console.error(e1);
                                                                                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                                                            children: t("common:txt_couldnt_copy")
                                                                                        }));
                                                                                        return [
                                                                                            3,
                                                                                            4
                                                                                        ];
                                                                                    case 4:
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                        return function(e) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }(),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                                                            alt: "copy",
                                                                            className: "h-[20px] w-[20px]"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute -bottom-7 opacity-0 hover:opacity-0 group-hover:opacity-100", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                                                            children: t("txt_copy")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex tablet:flex-col tablet:gap-[8px] tablet:px-[16px]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "hidden text-[16px] font-600 leading-[26px] tracking-[0.32px] text-blue-500 tablet:block",
                                                        children: t("txt_style")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("rounded-[100px] bg-color-success-15 px-[22px] text-[14px] font-[500] capitalize", " leading-[26px] tracking-[0.28px] text-color-success"),
                                                            children: style
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: _utils_branch__WEBPACK_IMPORTED_MODULE_12__/* .appStoreConstant */ .HY,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative flex w-full items-center justify-center gap-[12px]", "hover:bg-primary-600/80 rounded-[10px] bg-primary-500 py-[12px]"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/regenerate-white.svg"),
                                                alt: "plus icon"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                                children: t("txt_regenerate")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full flex-col items-center justify-center gap-5 tablet:hidden desktop:mt-8 desktop:flex",
                        children: [
                            showRelated && ownerId && followStatus && username && followers !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_single_generated__WEBPACK_IMPORTED_MODULE_27__/* .RelatedSection */ .$, {
                                customPrompt: customPrompt,
                                ownerId: ownerId,
                                setFollowStatus: setFollowStatus,
                                followers: followers,
                                followStatus: followStatus,
                                createdAt: createdAt,
                                tool: tool,
                                showRelated: showRelated,
                                id: id,
                                username: username,
                                profilePic: profile_pic,
                                liked: liked,
                                handleLike: handleLike,
                                singlePageUse: false
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "mb-[12px] mt-[56px] hidden text-center text-[16px] font-700 tracking-normal text-blue-700 desktop:block",
                                children: t("txt_other_ai_tools")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden grid-cols-5 gap-[25px] desktop:grid desktop:w-[1175px]",
                                children: _comps_ai_tools_other_products_section__WEBPACK_IMPORTED_MODULE_4__/* .allProducts.map */ .Od.map(function(product, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_tools__WEBPACK_IMPORTED_MODULE_20__.SingleProduct, {
                                        product: product,
                                        isMobile: false
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden tablet:block desktop:mt-[70px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_footer__WEBPACK_IMPORTED_MODULE_5__/* .WrappedFooter */ .M, {})
                    })
                ]
            })
        ]
    });
}
function RenderContentSection(props) {
    var tool = props.tool, followStatus = props.followStatus, setFollowStatus = props.setFollowStatus, id = props.id, username = props.username, profilePicture = props.profilePicture, followers = props.followers, shareDialog = props.shareDialog, setShareDialog = props.setShareDialog, createdAt = props.createdAt, ownerId = props.ownerId, imageOrVideo = props.imageOrVideo, setShowMediaDialog = props.setShowMediaDialog, showMediaDialog = props.showMediaDialog, customPrompt = props.customPrompt, offset = props.offset, closeLink = props.closeLink, showRelated = props.showRelated, handleRetry = props.handleRetry, style = props.style, setAsShared = props.setAsShared, likes = props.likes, handleLike = props.handleLike, liked = props.liked;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_15__/* .NotificationContext */ .u).notify;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_11__/* .useAdjustLogger */ .eW)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        gallery_id: id,
        info: {
            reason: "",
            message: ""
        }
    }), payload = ref1[0], setPayload = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), reportPopup = ref2[0], setReportPopup = ref2[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)().userInfo;
    var isSelf = ownerId === userInfo.userId && !userInfo.isAnonymous;
    function handleSocialShare(desktop, desktopFunction, url) {
        return _handleSocialShare.apply(this, arguments);
    }
    function _handleSocialShare() {
        _handleSocialShare = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(desktop, desktopFunction, url) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                try {
                    setShareDialog({
                        open: false,
                        isPublic: false,
                        link: shareDialog.link,
                        id: null
                    });
                    if (desktop && desktopFunction) return [
                        2,
                        desktopFunction(shareDialog.link)
                    ];
                    else if (url) return [
                        2,
                        url(shareDialog.link)
                    ];
                    else throw Error("No function");
                } catch (e) {
                    setShareDialog({
                        open: false,
                        isPublic: false,
                        link: shareDialog.link,
                        id: null
                    });
                    console.error(e);
                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                        children: t("common:txt_couldnt_copy")
                    }));
                    return [
                        2,
                        ""
                    ];
                }
                return [
                    2
                ];
            });
        });
        return _handleSocialShare.apply(this, arguments);
    }
    function handleSaveAllMedia() {
        return _handleSaveAllMedia.apply(this, arguments);
    }
    function _handleSaveAllMedia() {
        _handleSaveAllMedia = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url, anchor, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowMediaDialog(!showMediaDialog);
                        if (typeof imageOrVideo === "string") {
                            return [
                                2
                            ];
                        }
                        setAsShared && setAsShared();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = imageOrVideo[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        url = _step.value;
                        anchor = document.createElement("a");
                        anchor.href = url;
                        anchor.rel = "noopener noreferrer";
                        anchor.download = url.substring(url.lastIndexOf("/") + 1);
                        document.body.appendChild(anchor);
                        anchor.click();
                        document.body.removeChild(anchor);
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 500);
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSaveAllMedia.apply(this, arguments);
    }
    function handleCopy(text) {
        return _handleCopy.apply(this, arguments);
    }
    function _handleCopy() {
        _handleCopy = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(text) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopy.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex flex-col items-center justify-center", "relative z-50 h-full bg-color-cell pb-[60px] desktop:rounded-xl desktop:pb-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex w-[520px] flex-col gap-[12px] px-[16px] pt-[14px] ", "shrink-0 desktop:w-[431px] desktop:py-[16px] "),
                children: [
                    username && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row items-center gap-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/".concat(username),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: profilePicture !== null && profilePicture !== void 0 ? profilePicture : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/avatar.svg"),
                                                    onError: function(e) {
                                                        return e.currentTarget.setAttribute("src", (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/icons/avatar-default.svg"));
                                                    },
                                                    alt: "profile picture",
                                                    className: "h-10 w-10 shrink-0 rounded-full border border-color-separator object-cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col gap-[1px]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/".concat(username, "?active=2"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "max-w-[130px] truncate text-[16px] font-700 text-blue-800",
                                                            children: username
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-[14px] font-500 text-blue-600",
                                                        children: (0,_utils_millions__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(followers !== null && followers !== void 0 ? followers : 0) + " followers"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(isSelf && "hidden", "flex items-center gap-[11px]"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex w-[150px] items-center justify-center", "h-[44px] overflow-hidden rounded-[6px]"),
                                                children: followStatus !== null && ownerId !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_2__/* .FollowButton */ .eg, {
                                                    followStatus: followStatus,
                                                    uid: ownerId,
                                                    setFollowStatus: setFollowStatus,
                                                    userPage: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("group relative cursor-pointer", "-mb-[30px] pb-[30px]"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("h-[44px] w-[44px] [--icon-color:var(--color-blue-900)] hover:bg-blue-100", "flex items-center justify-center rounded-[10px]"),
                                                        children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_3__/* .moreIcon */ .Jf)()
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        onClick: function() {
                                                            setReportPopup(true);
                                                        },
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute hidden w-[123px] rounded-[12px] px-[10px]", "bg-color-popup-cell py-[8px] group-hover:flex", "items-center gap-[8px] shadow-xl hover:bg-blue-100", "left-1/2 top-[50px] -translate-x-1/2"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_7__/* .CustomThemedResource */ .aK, {
                                                                source: "/general/report",
                                                                format: "svg"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[16px] font-500 text-blue-800",
                                                                children: t("txt_report")
                                                            })
                                                        ]
                                                    }),
                                                    reportPopup && setReportPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_report_popup__WEBPACK_IMPORTED_MODULE_25__/* .ReportPopup */ .j, {
                                                        payloadLocation: "gallery",
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute left-1/2 top-[50px] z-[100] -translate-x-2/3"),
                                                        payload: payload,
                                                        setPayload: setPayload,
                                                        endpoint: "gallery-report",
                                                        setReportPopup: setReportPopup,
                                                        galleryOrTemplate: "gallery"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto h-[1px] w-full bg-blue-300"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex flex-col gap-[8px] desktop:w-[431px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex flex-col items-start"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center gap-[12px] [--icon-color:var(--color-blue-600)]",
                                        children: [
                                            (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .transformToolToIcon */ .eA)(tool),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-blue-700"),
                                                children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .transformTool */ .L2)(tool)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(" text-[16px] font-[500] leading-[26px] tracking-[0.28px] text-blue-500"),
                                    children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .formatTimes */ .Nf)(createdAt)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[1px] w-full bg-blue-300"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative z-50 flex items-start gap-[10px]", "no-scrollbar -mb-[30px] pb-[30px] desktop:overflow-x-auto"),
                        children: [
                            typeof imageOrVideo !== "string" && imageOrVideo.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: function() {
                                    setShowMediaDialog(!showMediaDialog);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("group relative flex items-center justify-center", "cursor-pointer transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 rounded-full bg-color-background"),
                                id: "media-box",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/save-primary.svg"),
                                        alt: "save icon",
                                        className: "h-[20px] w-[20px]",
                                        id: "media-box"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none absolute -bottom-[30px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                        children: t("txt_save")
                                    }),
                                    showMediaDialog && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("fixed z-[103] w-[200px] translate-x-[970px] translate-y-[100px] shadow-xl", "shadow-color-black/30 tablet:left-0", "flex flex-col gap-[4px] rounded-xl bg-color-cell px-[10px] py-[14px]"),
                                        id: "media-box",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                onClick: function() {
                                                    logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
                                                    setAsShared && setAsShared();
                                                    setShowDropdown(!showDropdown);
                                                },
                                                href: imageOrVideo[offset],
                                                download: true,
                                                className: "rounded-lg px-[16px] py-[12px] text-start text-blue-800 hover:bg-blue-100",
                                                children: t("txt_save_media")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "rounded-lg px-[16px] py-[12px] text-start text-blue-800 hover:bg-blue-100",
                                                onClick: handleSaveAllMedia,
                                                children: t("txt_save_all_media")
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("group relative flex items-center justify-center", "cursor-pointer"),
                                id: "media-box",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: imageOrVideo[offset],
                                        onClick: function() {
                                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
                                            setAsShared && setAsShared();
                                            setShowDropdown(!showDropdown);
                                        },
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("h-[52px] w-[52px] shrink-0 rounded-full bg-color-surface", " disabled:hover:bg-transparent transition-colors hover:bg-blue-300 disabled:opacity-50", "flex items-center justify-center"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/save-primary.svg"),
                                            alt: "save icon",
                                            className: "h-[20px] w-[20px]",
                                            id: "media-box"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none absolute -bottom-[30px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                        children: t("txt_save")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[50px] w-[1px] shrink-0 bg-blue-300"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(e) {
                                        var target;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    target = e.currentTarget;
                                                    target.disabled = true;
                                                    setTimeout(function() {
                                                        target.disabled = false;
                                                    }, 3000);
                                                    return [
                                                        4,
                                                        handleCopy(closeLink ? "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_16__/* .APP_HOST */ .b).concat(closeLink, "/single/").concat(id) : "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_16__/* .APP_HOST */ .b, "/profile/generations/").concat(id))
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("group relative flex items-center justify-center", "transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 rounded-full bg-color-background"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/copy-primary.svg"),
                                        alt: "copy icon",
                                        className: "h-[20px] w-[20px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("pointer-events-none absolute -bottom-[30px] w-[80px]", "rounded-[4px] px-3 py-1 opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                        children: t("txt_copy_link")
                                    })
                                ]
                            }),
                            sections_history_generations__WEBPACK_IMPORTED_MODULE_21__/* .socials.map */ .UY.map(function(props) {
                                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(sections_history_generations__WEBPACK_IMPORTED_MODULE_21__/* .SocialButton */ .Z0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)({}, props), {
                                    title: "",
                                    tooltipTitle: props.title,
                                    handleSocialShare: handleSocialShare,
                                    dialogContent: shareDialog,
                                    key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                }));
                            })
                        ]
                    }),
                    likes !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex items-center justify-start border-b border-t border-color-separator", "gap-[18px] py-[16px] tablet:w-full"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: handleLike,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("rounded-[4px] border border-color-separator", "flex items-center gap-[6px] bg-color-background px-[14px] py-[10px]"),
                            children: [
                                liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/heart-primary.svg"),
                                    alt: "heart image primary",
                                    className: "animate-appear"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/heart.svg"),
                                    alt: "heart image primary"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[14px] font-400 text-blue-700",
                                    children: likes
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderStyleOrPrompt, {
                        tool: tool,
                        customPrompt: customPrompt,
                        style: style,
                        handleCopy: handleCopy
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            handleRetry && handleRetry(customPrompt !== null && customPrompt !== void 0 ? customPrompt : undefined);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("my-[4px] hidden w-full items-center justify-center gap-[12px]", "rounded-[10px] bg-primary-500 py-[12px] hover:opacity-80 disabled:opacity-60", "desktop:my-[10px] desktop:flex"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/regenerate-white.svg"),
                                alt: "plus icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                children: !username ? t("txt_regenerate") : t("txt_try_now")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: _utils_branch__WEBPACK_IMPORTED_MODULE_12__/* .appStoreConstant */ .HY,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative mx-auto flex w-full items-center justify-center gap-[12px]", "rounded-[10px] bg-primary-500 py-[12px]  hover:opacity-80 desktop:hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/general/regenerate-white.svg"),
                                alt: "plus icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                children: !username ? t("txt_regenerate") : t("txt_try_now")
                            })
                        ]
                    })
                ]
            }),
            showRelated && ownerId && followStatus && username && followers !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full desktop:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_single_generated__WEBPACK_IMPORTED_MODULE_27__/* .RelatedSection */ .$, {
                    customPrompt: customPrompt,
                    ownerId: ownerId,
                    setFollowStatus: setFollowStatus,
                    followers: followers,
                    followStatus: followStatus,
                    createdAt: createdAt,
                    tool: tool,
                    showRelated: showRelated,
                    id: id,
                    username: username,
                    profilePic: profilePicture,
                    liked: liked,
                    handleLike: handleLike,
                    singlePageUse: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-[12px] mt-[56px] hidden text-center text-[16px] font-700 tracking-normal text-blue-700 tablet:block desktop:hidden",
                children: t("txt_other_ai_tools")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar hidden w-full gap-2 overflow-x-scroll px-4 tablet:flex", "desktop:hidden"),
                children: _comps_ai_tools_other_products_section__WEBPACK_IMPORTED_MODULE_4__/* .allProducts.map */ .Od.map(function(product, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_history_popup__WEBPACK_IMPORTED_MODULE_23__/* .SingleProductHistory */ .h$, {
                        product: product
                    }, index);
                })
            })
        ]
    });
}
function RenderStyleOrPrompt(props) {
    var tool = props.tool, customPrompt = props.customPrompt, style = props.style, handleCopy = props.handleCopy;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_17__/* .useTranslation */ .$G)().t;
    switch(tool){
        case "deform":
        case "ai_photo":
        case "ai_restyle":
        case "model_drafts":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[16px] font-600 leading-[26px] tracking-[0.32px] text-blue-500 desktop:hidden",
                        children: t("txt_style")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("rounded-[100px] bg-color-success-15 px-[22px] text-[14px] font-[500] capitalize", " leading-[26px] tracking-[0.28px] text-color-success"),
                            children: style
                        })
                    })
                ]
            });
        case "text_to_image":
        case "text_to_video":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("hidden justify-between gap-[8px] tablet:flex", "relative rounded-[5px] bg-color-background pl-[12px] pr-[5px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("text-[13px] font-400 leading-[22px] tracking-[0.32px] text-blue-800", "cursor-text -tracking-[0.5px] tablet:max-h-[130px]", "scrollbar overflow-y-scroll desktop:max-h-[175px]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("py-[9px] pr-[45px] font-mono"),
                            children: customPrompt
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " absolute right-4 top-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative h-8 w-8 shrink-0 cursor-pointer transition-colors", "group flex items-center justify-center rounded-[4px] hover:bg-blue-200"),
                            onClick: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(function(e) {
                                    var target;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_29__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                target = e.currentTarget;
                                                target.disabled = true;
                                                setTimeout(function() {
                                                    target.disabled = false;
                                                }, 3000);
                                                return [
                                                    4,
                                                    handleCopy(customPrompt !== null && customPrompt !== void 0 ? customPrompt : "")
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                    alt: "copy",
                                    className: "h-[20px] w-[20px]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute -bottom-7 opacity-0 hover:opacity-0 group-hover:opacity-100", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                    children: t("txt_copy")
                                })
                            ]
                        })
                    })
                ]
            });
    }
}
function RenderImageSection(props) {
    var imageOrVideo = props.imageOrVideo, isVideo = props.isVideo, customPrompt = props.customPrompt, previewImage = props.previewImage, offset = props.offset, style = props.style, setOffset = props.setOffset;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var scrollToImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index) {
        var isImage = typeof imageOrVideo === "string";
        if (isImage) {
            return;
        }
        var nextImage = document.getElementsByClassName("ai-art-generation-".concat(imageOrVideo, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, [
        imageOrVideo
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage,
        imageOrVideo
    ]);
    var typeContent = typeof imageOrVideo === "string";
    var display = "image";
    if (typeContent || imageOrVideo.length === 1) {
        if (isVideo) {
            display = "video";
        } else {
            display = "image";
        }
    } else {
        display = "images";
    }
    if (typeContent || imageOrVideo.length === 1) {
        if (display === "image") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar flex justify-start overflow-y-scroll tablet:justify-center", "relative z-10 tablet:pb-[100px] tablet:pt-[140px]", "desktop:p-0"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 hidden h-full w-full bg-cover bg-center bg-no-repeat tablet:block", "opacity-100 blur-3xl filter desktop:hidden"),
                        style: {
                            backgroundImage: "url(".concat(imageOrVideo, ")")
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative z-40", "overflow-hidden tablet:rounded-[19px]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: typeof imageOrVideo === "string" ? imageOrVideo : imageOrVideo[0],
                            alt: (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_19__.getFirstFiveWords)(customPrompt && customPrompt.trim().length !== 0 ? customPrompt : style),
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("tablet:max-h-[533px] tablet:max-w-[322px]", "tablet:rounded-[19px] desktop:max-h-[637px] desktop:max-w-[436px]")
                        })
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar flex max-h-[100svh] justify-center overflow-y-scroll tablet:h-auto", "relative z-10 pb-[100px] pt-[140px]", "desktop:p-0"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 h-full w-full overflow-hidden bg-color-black filter", "overflow-hidden desktop:hidden desktop:h-[857px] desktop:w-[775px] desktop:rounded-r-none"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: previewImage,
                            alt: "preview image",
                            className: "absolute h-full w-full scale-110 object-cover opacity-30 blur-lg"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("relative z-40", "overflow-hidden tablet:rounded-[19px]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                loop: true,
                                autoPlay: true,
                                playsInline: true,
                                preload: "metadata",
                                src: typeof imageOrVideo === "string" ? imageOrVideo + "#t=0.001" : imageOrVideo[0] + "#t=0.001",
                                ref: videoRef,
                                poster: previewImage,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("w-full tablet:max-h-[533px] tablet:max-w-[322px]", "tablet:rounded-[19px] desktop:max-h-[637px] desktop:max-w-[436px]")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(video_provider__WEBPACK_IMPORTED_MODULE_22__/* .VideoProvider */ .G, {
                                remember: [],
                                element: videoRef,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute bottom-0 left-0 z-50 w-full text-color-white",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_10__/* .Timeline */ .TY, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_10__/* .PlayWithProvider */ .uX, {})
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar flex justify-center overflow-y-scroll bg-color-cell tablet:bg-[transparent]", "relative z-10", "tablet:px-[30px]", "desktop:p-0"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("fixed left-0 top-0 z-10 hidden h-full w-full bg-cover bg-center bg-no-repeat tablet:block", "opacity-100 blur-3xl filter desktop:hidden"),
                    style: {
                        backgroundImage: "url(".concat(imageOrVideo[0], ")")
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("ah-[533px] relative w-[400px] object-cover tablet:rounded-xl", "tablet:h-[550px] tablet:w-full", "group desktop:h-full desktop:w-[550px]", "absolute inset-0 z-40 flex items-center justify-center"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onScroll: function(event) {
                                var container = event.target;
                                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(container, HTMLElement)) {
                                    var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                                    setOffset(snapIndex);
                                }
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("no-scrollbar flex max-w-[400px] snap-x snap-mandatory gap-5 overflow-x-scroll transition-all", "tablet:rounded-xl"),
                            children: imageOrVideo.map(function(thumb, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: thumb,
                                    alt: (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_19__.getFirstFiveWords)(customPrompt && customPrompt.trim().length !== 0 ? customPrompt : style),
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("w-full max-w-[400px] shrink-0 snap-center object-cover tablet:rounded-xl", "ai-art-generation-".concat(imageOrVideo, "-").concat(index))
                                }, thumb);
                            })
                        }),
                        imageOrVideo.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("flex flex-row gap-[5px] rounded-[40px] bg-[#00000066]", "px-[10px] py-1 opacity-100 transition-all", "absolute bottom-2 left-1/2 -translate-x-1/2"),
                            children: imageOrVideo.map(function(_, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        return scrollToImage(index);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("h-[6px] w-[6px] cursor-pointer rounded-full transition-all", offset === index ? "scale-[1.4] bg-primary-500" : "scale-100 bg-color-white")
                                }, index);
                            })
                        }),
                        imageOrVideo.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset === 0,
                                    onClick: function() {
                                        return scrollToImage(offset - 1);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute left-2 top-[calc(50%-12px)] z-50 flex h-6 w-6 items-center justify-center rounded-full", " border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all", " hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-100 group-hover:opacity-100"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                                        alt: "arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset === imageOrVideo.length - 1,
                                    onClick: function() {
                                        return scrollToImage(offset + 1);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)("absolute right-2 top-[calc(50%-12px)] z-50 flex h-6 w-6 items-center", "justify-center rounded-full", " border border-[transparent] bg-[#00000052] opacity-0", "backdrop-blur-[10px] transition-all", " hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-100 group-hover:opacity-100"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_33__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                                        alt: "arrow",
                                        className: "rotate-180"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}


/***/ }),

/***/ 5170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Re": function() { return /* binding */ getConcurrentJobCount; },
/* harmony export */   "UY": function() { return /* binding */ socials; },
/* harmony export */   "WI": function() { return /* binding */ fetchVideos; },
/* harmony export */   "Yx": function() { return /* binding */ fetchLast; },
/* harmony export */   "Z0": function() { return /* binding */ SocialButton; },
/* harmony export */   "f2": function() { return /* binding */ STATUS_UPDATE_MILLIS; }
/* harmony export */ });
/* unused harmony exports HISTORY_ITEMS_IN_PAGE, filterOptions, HISTORY_UPDATE_MILLIS, default */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1455);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3153);
/* harmony import */ var _comps_footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8109);
/* harmony import */ var _comps_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1083);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9612);
/* harmony import */ var _comps_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9980);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9034);
/* harmony import */ var _comps_meta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(624);
/* harmony import */ var _comps_primary_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3363);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4165);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2404);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1816);
/* harmony import */ var _utils_errors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3882);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4371);
/* harmony import */ var _utils_regenerate__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1964);
/* harmony import */ var _utils_trigger__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9483);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2213);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8767);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2337);
/* harmony import */ var sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8067);
/* harmony import */ var sections_history_history_popup__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(1027);
































var HISTORY_ITEMS_IN_PAGE = 10;
function fetchVideos(filters, offset) {
    return _fetchVideos.apply(this, arguments);
}
function _fetchVideos() {
    _fetchVideos = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function(filters, offset) {
        var limit, payload;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    limit = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : HISTORY_ITEMS_IN_PAGE;
                    payload = {
                        offset: offset,
                        limit: limit,
                        filters: filters
                    };
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].post */ .Z.post("/api/deforum-history", payload).then(function(response) {
                            return response.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _fetchVideos.apply(this, arguments);
}
function fetchLast() {
    return _fetchLast.apply(this, arguments);
}
function _fetchLast() {
    _fetchLast = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_25__/* ["default"].get */ .Z.get("/api/deforum-status-new").then(function(response) {
                            return response.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _fetchLast.apply(this, arguments);
}
var createNewTools = [
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .deforumIcon */ .uv)(),
        title: "txt_deforum_ai",
        subtitle: "txt_deforum_ai_description",
        url: "/tools/ai-video-transformation",
        color: "[--icon-color:var(--color-blue-600)]"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .restyleIcon */ .Lt)(),
        title: "txt_restyle_ai",
        subtitle: "txt_restyle_ai_description",
        url: "/tools/ai-animation-generator",
        color: "[--icon-color:var(--color-blue-600)]"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .photoAiIcon */ .x$)(),
        title: "txt_photo_ai",
        subtitle: "txt_photo_ai_description",
        url: "/tools/ai-photo-editor",
        color: "[--icon-color:var(--color-blue-600)]"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToImageIcon */ .f7)(),
        title: "txt_text_to_image",
        subtitle: "txt_text_to_image_description",
        url: "/tools/text-to-image",
        color: "[--icon-color:var(--color-blue-600)]"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToVideoIcon */ .Cz)(),
        title: "txt_text_to_video",
        subtitle: "txt_text_to_video_description",
        url: "/tools/text-to-video",
        color: "[--icon-color:var(--color-blue-600)]"
    }, 
];
var filterOptions = [
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .allIcon */ .X9)(),
        tools: [
            "deform",
            "ai_restyle",
            "ai_photo",
            "text_to_image",
            "text_to_video", 
        ],
        name: "lbl_all"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .deforumIcon */ .uv)(),
        tools: [
            "deform"
        ],
        name: "txt_deforum_ai"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .restyleIcon */ .Lt)(),
        tools: [
            "ai_restyle"
        ],
        name: "txt_restyle_ai"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .photoAiIcon */ .x$)(),
        tools: [
            "ai_photo"
        ],
        name: "txt_photo_ai"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToImageIcon */ .f7)(),
        tools: [
            "text_to_image"
        ],
        name: "txt_text_to_image"
    },
    {
        icon: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToVideoIcon */ .Cz)(),
        tools: [
            "text_to_video"
        ],
        name: "txt_text_to_video"
    }, 
];
var socials = [
    {
        title: "Facebook",
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/facebook-colorful.svg"),
        url: function(link) {
            return "https://www.facebook.com/sharer/sharer.php?u=".concat(link);
        }
    },
    {
        title: "Messenger",
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/messenger-colorful.svg"),
        url: function(link) {
            return "fb-messenger://share?link=".concat(link, "&app_id=").concat("215609162521480", "}");
        },
        desktop: function(link) {
            return "https://www.facebook.com/dialog/send?link=".concat(link, "&app_id=").concat("215609162521480", "&redirect_uri=").concat(encodeURIComponent("https://zoomerang.app"));
        }
    },
    {
        title: "Whatsapp",
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/whatsapp-colorful.svg"),
        url: function(link) {
            return "https://wa.me/?text=".concat(link);
        }
    },
    {
        title: "Viber",
        light: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/viber-colorful-light.svg"),
        dark: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/viber-colorful-dark.svg"),
        url: function(link) {
            return "viber://forward?text=".concat(link);
        }
    },
    {
        title: "Pinterest",
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/pinterest-colorful.svg"),
        url: function(link) {
            return "https://pinterest.com/pin/create/button/?url=".concat(link);
        }
    },
    {
        title: "Email",
        icon: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_26__/* .assetUrl */ .p)("/comps/email-colorful.svg"),
        url: function(link) {
            return "mailto:?body=".concat(link);
        }
    }, 
];
function getHistoryState(_, historyQuery) {
    if (historyQuery === undefined) {
        return "loading";
    }
    if (historyQuery.find(function(page) {
        return page.length;
    })) {
        return "data";
    }
    return "empty";
}
function getConcurrentJobCount(hasConcurrentJobs) {
    if (hasConcurrentJobs) return 3;
    return 1;
}
var STATUS_UPDATE_MILLIS = 5000;
var HISTORY_UPDATE_MILLIS = 30000;
function ProfileGenerationsPage() {
    var ref, ref1, ref2, ref3;
    var lastRowRef = useRef(null);
    var notify = useContext(NotificationContext).notify;
    var userInfo = useAuth().userInfo;
    var regenerate = useRegenerate();
    var ref4 = useState(filterOptions[0]), filter = ref4[0], setFilter = ref4[1];
    var lastQuery = useQuery({
        queryFn: fetchLast,
        queryKey: [
            "deforum-last",
            "user",
            "pro"
        ],
        refetchInterval: STATUS_UPDATE_MILLIS
    });
    var query = useInfiniteQuery({
        queryFn: function() {
            var _ref = _async_to_generator(function(context) {
                var offset;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            offset = context.pageParam;
                            return [
                                4,
                                fetchVideos(filter.tools, offset !== null && offset !== void 0 ? offset : 0)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(context) {
                return _ref.apply(this, arguments);
            };
        }(),
        getNextPageParam: function(lastPage, allPages) {
            if (lastPage.length < HISTORY_ITEMS_IN_PAGE) {
                return undefined;
            }
            return allPages.length * HISTORY_ITEMS_IN_PAGE;
        },
        queryKey: [
            "deforum-history",
            "user",
            "pro",
            filter.tools,
            (ref = lastQuery.data) === null || ref === void 0 ? void 0 : ref.filter(function(job) {
                return job.status === "in-queue" || job.status === "in-progress";
            }).length, 
        ],
        onError: withNotify(function(t) {
            return notify(/*#__PURE__*/ _jsx(ErrorMessage, {
                children: t
            }));
        }),
        refetchInterval: HISTORY_UPDATE_MILLIS
    });
    useEffect(function() {
        if (lastRowRef.current === null) {
            return;
        }
        if (!query.isStale) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            var intersecting = entries.find(function(entry) {
                return entry.isIntersecting;
            });
            if (!intersecting) {
                return;
            }
            if (!query.isStale) {
                return;
            }
            if (!query.hasNextPage) {
                return;
            }
            query.fetchNextPage();
        }, {
            rootMargin: "200px"
        });
        observer.observe(lastRowRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        lastRowRef,
        query
    ]);
    var historyState = getHistoryState(lastQuery.data, (ref1 = query.data) === null || ref1 === void 0 ? void 0 : ref1.pages);
    var isFetchingMore = query.isFetching && historyState !== "loading";
    var _length;
    var currentRunningJobs = (_length = (ref2 = lastQuery.data) === null || ref2 === void 0 ? void 0 : ref2.filter(function(job) {
        return job.status === "in-queue" || job.status === "in-progress";
    }).length) !== null && _length !== void 0 ? _length : -1;
    var hasConcurrentJobs = getUserEntitlements(userInfo.entitlements).hasConcurrentJobs;
    var canTryAgain = currentRunningJobs < getConcurrentJobCount(hasConcurrentJobs);
    var t = useTranslation("common").t;
    var ref5 = useState({
        open: false,
        isPublic: false,
        link: "",
        id: null
    }), dialogOpen = ref5[0], setDialogOpen = ref5[1];
    var ref6 = useState(null), historyPopupState = ref6[0], setHistoryPopupState = ref6[1];
    useEffect(function() {
        if (historyPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        historyPopupState
    ]);
    var ref7 = useState(false), isPublicLoading = ref7[0], setIsPublicLoading = ref7[1];
    useEffect(function() {
        if (dialogOpen.open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        dialogOpen
    ]);
    function handleDelete(id) {
        return _handleDelete.apply(this, arguments);
    }
    function _handleDelete() {
        _handleDelete = _async_to_generator(function(id) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            mutateWithNotify(notify, function() {
                                return axios.post("/api/deforum-delete", {
                                    id: id
                                }).then(function(res) {
                                    return res.data;
                                });
                            }, t("txt_successfully_deleted"), t("txt_error_deleting"))
                        ];
                    case 1:
                        _state.sent();
                        query.refetch();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleDelete.apply(this, arguments);
    }
    var handleMakePublic = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _id, payload, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isPublicLoading) {
                        return [
                            2
                        ];
                    }
                    setIsPublicLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    payload = {
                        privacy: "public",
                        job: (_id = dialogOpen.id) !== null && _id !== void 0 ? _id : 0
                    };
                    return [
                        4,
                        axios.post("/api/deforum-privacy", payload)
                    ];
                case 2:
                    _state.sent();
                    query.refetch();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    notify(/*#__PURE__*/ _jsx(ErrorMessage, {
                        children: t("txt_could_not_make_public")
                    }));
                    return [
                        3,
                        4
                    ];
                case 4:
                    setIsPublicLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        dialogOpen.id,
        isPublicLoading,
        notify,
        query,
        t
    ]);
    function handleShare() {
        return _handleShare.apply(this, arguments);
    }
    function _handleShare() {
        _handleShare = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!!dialogOpen.isPublic) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleMakePublic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            navigator.clipboard.writeText(dialogOpen.link)
                        ];
                    case 3:
                        _state.sent();
                        setDialogOpen({
                            open: false,
                            isPublic: false,
                            link: dialogOpen.link,
                            id: null
                        });
                        notify(/*#__PURE__*/ _jsx(SuccessMessage, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        setDialogOpen({
                            open: false,
                            isPublic: false,
                            link: dialogOpen.link,
                            id: null
                        });
                        console.error(e);
                        notify(/*#__PURE__*/ _jsx(ErrorMessage, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleShare.apply(this, arguments);
    }
    function handleSocialShare(desktop, desktopFunction, url) {
        return _handleSocialShare.apply(this, arguments);
    }
    function _handleSocialShare() {
        _handleSocialShare = _async_to_generator(function(desktop, desktopFunction, url) {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!!dialogOpen.isPublic) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleMakePublic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setDialogOpen({
                            open: false,
                            isPublic: false,
                            link: dialogOpen.link,
                            id: null
                        });
                        if (desktop && desktopFunction) return [
                            2,
                            desktopFunction(dialogOpen.link)
                        ];
                        else if (url) return [
                            2,
                            url(dialogOpen.link)
                        ];
                        else throw Error("No function");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setDialogOpen({
                            open: false,
                            isPublic: false,
                            link: dialogOpen.link,
                            id: null
                        });
                        console.error(e);
                        notify(/*#__PURE__*/ _jsx(ErrorMessage, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            2,
                            ""
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSocialShare.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Meta, {
                title: t("txt_generations_title"),
                description: t("txt_generations_description")
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx("h4", {
                className: clsx("text-h4 mt-[22px] tablet:mt-[24px]", "text-center desktop:mt-[56px]", "mb-[28px] tablet:mb-[16px] desktop:mb-[28px]"),
                children: t("txt_history")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mx-auto flex w-full select-none flex-col gap-4 py-4 tablet:w-[768px] desktop:w-[1175px] desktop:gap-6",
                children: [
                    lastQuery.data && lastQuery.data.filter(function(job) {
                        return job.status === "in-queue" || job.status === "in-progress";
                    }).length > 0 && /*#__PURE__*/ _jsx("div", {
                        className: "relative h-[70px] w-full",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "no-scrollbar absolute top-0 flex h-[140px] w-full flex-row gap-3 overflow-x-scroll px-4",
                            children: lastQuery.data.map(function(job) {
                                return /*#__PURE__*/ _jsx(LastLoading, {
                                    video: job
                                }, job.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex h-12 w-full flex-row items-center justify-between px-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex h-full items-center justify-center",
                                children: /*#__PURE__*/ _jsx(DropDown, {
                                    closeOnClick: true,
                                    hover: true,
                                    className: "group h-full w-[215px]",
                                    contentClassName: "py-2",
                                    trigger: /*#__PURE__*/ _jsxs("div", {
                                        className: clsx("flex h-[48px] w-[215px] gap-3 bg-color-cell px-4 py-2 text-blue-800", "[--icon-color:var(--color-blue-600)] hover:[--icon-color:var(--color-blue-800)]", "items-center rounded-[8px] text-[14px] font-500"),
                                        children: [
                                            filter.icon,
                                            t(filter.name),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-1"
                                            }),
                                            /*#__PURE__*/ _jsx(CustomThemedResource, {
                                                format: "svg",
                                                source: "/general/arrow",
                                                className: "h-5 w-5 rotate-90 transition-all group-hover:-rotate-90"
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "absolute left-0 top-full z-50 w-full pt-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "flex w-full flex-col gap-1 rounded-[12px] bg-color-popup-cell p-2 [box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]",
                                            children: filterOptions.map(function(option) {
                                                return /*#__PURE__*/ _jsxs("button", {
                                                    onClick: function() {
                                                        return setFilter(option);
                                                    },
                                                    className: clsx("flex items-center gap-3 rounded-[8px] px-4 py-3", "transition-colors [--icon-color:var(--color-blue-600)]", "hover:bg-[rgba(111,131,187,0.1)] hover:[--icon-color:var(--color-blue-900)]"),
                                                    children: [
                                                        option.icon,
                                                        t(option.name)
                                                    ]
                                                }, option.tools.join(","));
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs(PrimaryButton, {
                                className: "hidden h-[48px] justify-center gap-2 tablet:flex desktop:hidden",
                                href: appStoreConstant,
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: assetUrl("/general/plus-white.svg"),
                                        className: "self-center",
                                        alt: "plus white"
                                    }),
                                    t("txt_create_new")
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "hidden desktop:flex",
                                children: /*#__PURE__*/ _jsx(DropDown, {
                                    hover: true,
                                    className: clsx(!canTryAgain && "pointer-events-none cursor-not-allowed opacity-50"),
                                    contentClassName: "py-[10px] absolute w-[450px] right-0",
                                    trigger: /*#__PURE__*/ _jsxs("div", {
                                        className: clsx("flex gap-1 bg-primary-500 py-3 font-600 text-color-white", "w-[215px] justify-center rounded-[10px] hover:bg-primary-600"),
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: assetUrl("/general/plus-white.svg"),
                                                alt: "plus white"
                                            }),
                                            t("txt_create_new")
                                        ]
                                    }),
                                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "absolute right-[100px] top-2 z-[-1] h-6 w-6 -translate-x-1/2 rotate-45 rounded-[8px] bg-color-cell"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex flex-col gap-2 rounded-[22px] bg-color-popup-cell p-[10px] [box-shadow:0px_0px_30px_rgba(0,0,0,0.13)]",
                                                children: createNewTools.map(function(tools) {
                                                    return /*#__PURE__*/ _jsxs("a", {
                                                        href: tools.url,
                                                        className: clsx("group flex gap-2 rounded-[16px] bg-color-background p-4", "items-center transition-colors hover:bg-[#eff1fb] dark:hover:bg-[#212127]", !canTryAgain && "pointer-events-none cursor-not-allowed opacity-50"),
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: clsx("flex h-[44px] w-[44px] scale-125 items-center justify-center rounded-[6px]", tools.color),
                                                                children: tools.icon
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mr-[10px] h-[45px] w-[1px] bg-color-separator"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex flex-1 flex-col overflow-hidden",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "text-[18px] font-600 text-blue-800",
                                                                        children: t(tools.title)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "truncate text-blue-700",
                                                                        children: t(tools.subtitle)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(CustomThemedResource, {
                                                                format: "svg",
                                                                source: "/general/arrow",
                                                                className: "h-5 w-5 translate-x-0 transition-transform group-hover:translate-x-1"
                                                            })
                                                        ]
                                                    }, tools.url);
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: clsx("fixed inset-0 flex items-end justify-start bg-color-popup tablet:items-center tablet:justify-center", !dialogOpen.open && "pointer-events-none opacity-0", "z-[99] transition-opacity duration-300"),
                    id: "popup-content",
                    onClick: function(event) {
                        if (_instanceof(event.target, Element)) {
                            if (event.target.id === event.currentTarget.id) {
                                setDialogOpen({
                                    open: false,
                                    isPublic: false,
                                    link: dialogOpen.link,
                                    id: null
                                });
                            }
                        }
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: clsx("relative w-full rounded-t-2xl bg-color-cell pb-8 pt-4 transition-all tablet:w-auto tablet:rounded-2xl tablet:py-4", dialogOpen.open ? "translate-y-0" : "translate-y-full tablet:translate-y-0"),
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                onClick: function() {
                                    return setDialogOpen({
                                        open: false,
                                        isPublic: false,
                                        link: dialogOpen.link,
                                        id: null
                                    });
                                },
                                className: clsx("absolute -right-10 top-0 hidden h-8 w-8 items-center justify-center rounded-full desktop:flex", "bg-color-cell transition-colors hover:bg-blue-100"),
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: assetUrl("/general/close.svg"),
                                    alt: "close icon"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col gap-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex flex-col gap-1 px-4",
                                        children: /*#__PURE__*/ _jsx("p", {
                                            className: "text-[18px] font-500 text-blue-900 tablet:text-[24px]",
                                            children: t("txt_share")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-col gap-[22px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: clsx("no-scrollbar flex flex-row gap-5 overflow-x-scroll px-4", !dialogOpen.open && "hidden"),
                                                children: socials.map(function(props) {
                                                    return /*#__PURE__*/ _createElement(SocialButton, _object_spread_props(_object_spread({}, props), {
                                                        handleSocialShare: handleSocialShare,
                                                        dialogContent: dialogOpen,
                                                        key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                                    }));
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex w-full flex-col items-center gap-3 px-4 tablet:flex-row tablet:justify-end",
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "text-[16px] font-400 text-color-placeholder",
                                                        children: t("txt_will_be_available_public")
                                                    }),
                                                    /*#__PURE__*/ _jsxs("button", {
                                                        disabled: isPublicLoading,
                                                        onClick: handleShare,
                                                        className: " bg-primary-500/10 hover:bg-primary-600/30 disabled:hover:bg-primary-600/10 flex h-11 w-full shrink-0 flex-row items-center justify-center gap-1 rounded-[10px] text-[16px] font-600 text-primary-500 transition-colors disabled:cursor-default tablet:w-[251px]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("img", {
                                                                src: assetUrl("/ai-tools/history/copy-primary.svg"),
                                                                alt: "copy icon"
                                                            }),
                                                            t("txt_copy")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            historyPopupState !== null && /*#__PURE__*/ _jsx(HistoryPopup, _object_spread({}, historyPopupState)),
            historyState === "data" && /*#__PURE__*/ _jsx(ResponsiveMasonry, {
                className: "mx-auto w-full gap-3 p-4 tablet:w-[768px] tablet:gap-4 tablet:p-4 desktop:w-[1175px] desktop:gap-[25px]",
                columnsCountBreakPoints: {
                    1: 2,
                    760: 4,
                    1280: 4
                },
                children: /*#__PURE__*/ _jsx(Masonry, {
                    gutter: "20px",
                    children: (ref3 = query.data) === null || ref3 === void 0 ? void 0 : ref3.pages.map(function(page) {
                        return page.filter(function(video) {
                            return video.status !== "canceled";
                        }).map(function(video) {
                            return /*#__PURE__*/ _jsx(GeneratedVideo, _object_spread({
                                historyPopupState: historyPopupState,
                                setHistoryPopupState: setHistoryPopupState,
                                canTryOther: canTryAgain,
                                entity: video,
                                setDialogContent: setDialogOpen,
                                handleDelete: handleDelete
                            }, regenerate), video.id);
                        });
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: lastRowRef
            }),
            /*#__PURE__*/ _jsx(NoGenerations, {
                noGenerations: historyState === "empty"
            }),
            historyState === "loading" && /*#__PURE__*/ _jsx(HistorySkeleton, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "flex w-full justify-center p-8",
                children: isFetchingMore && /*#__PURE__*/ _jsx(Loader, {})
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
}
function HistorySkeleton() {
    var skeletonList = [
        369,
        200,
        136,
        285,
        369,
        369,
        369,
        369, 
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(ResponsiveMasonry, {
            className: "mx-auto w-full gap-3 p-4 tablet:w-[768px] tablet:gap-4 tablet:p-4 desktop:w-[1175px] desktop:gap-[25px]",
            columnsCountBreakPoints: {
                1: 2,
                760: 4,
                1280: 4
            },
            children: /*#__PURE__*/ _jsx(Masonry, {
                gutter: "20px",
                children: skeletonList.map(function(height, index) {
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            height: height,
                            opacity: 20
                        },
                        children: /*#__PURE__*/ _jsx(MasonrySkeleton, {
                            className: "h-full rounded-xl"
                        })
                    }, index);
                })
            })
        })
    });
}
function NoGenerations(props) {
    var noGenerations = props.noGenerations;
    var t = useTranslation().t;
    if (!noGenerations) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full items-center justify-center gap-[25px]",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "hidden aspect-[9/16] w-[269px] rounded-[12px] bg-color-cell opacity-40 desktop:block"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "-ml-10 aspect-[9/16] w-[180px] rounded-[12px] bg-color-cell opacity-60 tablet:mx-0 tablet:w-[287px]"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("aspect-[9/16] w-[197px] rounded-[14px] bg-color-cell tablet:w-[332px]", "flex flex-col items-center gap-[42px] font-500 text-blue-700", "relative justify-center"),
                children: [
                    /*#__PURE__*/ _jsx(CustomThemedResource, {
                        source: "/deforum/no-generations",
                        className: "aspect-square w-[98px]"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col items-center gap-1 text-[10px] tablet:text-[20px]",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: t("txt_no_videos")
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: t("txt_create_ai_video")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "-mr-10 aspect-[9/16] w-[180px] rounded-[12px] bg-color-cell opacity-60 tablet:mx-0 tablet:w-[287px]"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "hidden aspect-[9/16] w-[269px] rounded-[12px] bg-color-cell opacity-40 desktop:block"
            })
        ]
    });
}
function LastLoading(props) {
    var _video = props.video, status = _video.status, thumbnail = _video.thumbnail, estimatedSeconds = _video.estimatedSeconds, id = _video.id, isVideo = _video.isVideo, tool = _video.tool;
    var ref = useState(false), loading = ref[0], setLoading = ref[1];
    var ceil = Math.ceil(estimatedSeconds / 60);
    var minutes = ceil < 1 ? 1 : ceil;
    var t = useTranslation("common").t;
    var notify = useContext(NotificationContext).notify;
    var queryClient = useQueryClient();
    if (status === "ready" || status === "canceled") {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    function handleCancel() {
        return _handleCancel.apply(this, arguments);
    }
    function _handleCancel() {
        _handleCancel = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            mutateWithNotify(notify, function() {
                                return axios.post("/api/deforum-cancel", {
                                    id: id
                                }).then(function(res) {
                                    return res.data;
                                });
                            }, t("txt_successfully_canceled"), t("txt_error_canceling"))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            queryClient.invalidateQueries("deforum-status")
                        ];
                    case 2:
                        _state.sent();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCancel.apply(this, arguments);
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx("relative flex flex-row gap-2", "h-[70px]", "bg-color-cell", "shrink-0 rounded-[8px] p-[6px]", " text-blue-800", status === "in-progress" && "border-2 border-[#007BFF]", status === "in-queue" && "border-2 border-[#FF8C22]", status === "in-queue" ? " w-[228px]" : " w-[208px]"),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: clsx("absolute right-2 top-3", status !== "in-queue" && "hidden"),
                children: /*#__PURE__*/ _jsx(DropDown, {
                    className: "!z-[67]",
                    trigger: /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/deforum/dots-with-background.webp"),
                        className: "h-6 w-6",
                        alt: "dots icon"
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "absolute right-0 top-full flex w-[214px] flex-col items-stretch gap-1 rounded-[12px] bg-color-popup-cell px-3 py-4 [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]",
                        children: /*#__PURE__*/ _jsxs("button", {
                            onClick: handleCancel,
                            disabled: loading,
                            className: clsx("text-color-error", "hover:bg-[rgba(111,131,187,0.1)]", "flex gap-3 rounded-[8px] bg-color-cell", "items-center px-3 py-2 font-500", "disabled:pointer-events-none"),
                            children: [
                                /*#__PURE__*/ _jsx(CustomThemedResource, {
                                    source: "/deforum/delete-red",
                                    format: "svg"
                                }),
                                t("lbl_cancel")
                            ]
                        })
                    })
                })
            }),
            isVideo && thumbnail ? /*#__PURE__*/ _jsx("video", {
                src: thumbnail,
                loop: true,
                playsInline: true,
                muted: true,
                autoPlay: true,
                className: clsx("aspect-1 h-full object-cover", "rounded-[5px]")
            }) : thumbnail ? /*#__PURE__*/ _jsx("img", {
                src: thumbnail,
                alt: "thumbnail",
                className: clsx("aspect-1 h-full object-cover", "rounded-[5px]")
            }) : /*#__PURE__*/ _jsxs("div", {
                className: "flex aspect-1 h-full items-center justify-center [--icon-color:var(--color-blue-500)]",
                children: [
                    tool === "text_to_image" && textToImageIcon(),
                    tool === "text_to_video" && textToVideoIcon(),
                    tool === "ai_suggest" && /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/general/model-icon.svg"),
                        alt: "model icon"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("flex h-full flex-col justify-center gap-1"),
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        className: " text-[14px] text-blue-800",
                        children: [
                            t("txt_status"),
                            /*#__PURE__*/ _jsx("strong", {
                                children: status === "in-progress" ? t("txt_in_progress") : t("txt_in_queue")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: " text-[14px] text-blue-800",
                        children: [
                            t("txt_remaining"),
                            /*#__PURE__*/ _jsx("strong", {
                                children: t("fs_minutes_short", {
                                    count: minutes
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function SocialButton(props) {
    var url = props.url, dialogContent = props.dialogContent, desktop = props.desktop, title = props.title, handleSocialShare = props.handleSocialShare, tooltipTitle = props.tooltipTitle, setAsShared = props.setAsShared;
    var imageClasses = "bg-color-surface transition-colors hover:bg-blue-200 p-3 w-[52px] h-[52px]";
    var anchorClasses = "flex rounded-full overflow-hidden shrink-0 w-[52px] h-[52px]";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "group relative flex w-[70px] shrink-0 flex-col items-center gap-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
                        var anchor, desktopUrl;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    anchor = document.createElement("a");
                                    anchor.target = "_blank";
                                    anchor.rel = "noreferrer";
                                    setAsShared && setAsShared();
                                    return [
                                        4,
                                        handleSocialShare(true, desktop, url)
                                    ];
                                case 1:
                                    desktopUrl = _state.sent();
                                    anchor.href = desktopUrl;
                                    anchor.click();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("hidden desktop:block", !dialogContent.open ? "pointer-events-none" : "pointer-events-auto cursor-pointer", anchorClasses),
                    children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: props.icon,
                        className: imageClasses,
                        alt: "social icon"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: props.dark,
                                "data-hide-on-theme": "light",
                                className: imageClasses,
                                alt: "social icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: props.light,
                                "data-hide-on-theme": "dark",
                                className: imageClasses,
                                alt: "social icon"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
                        var anchor, mobileUrl;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    anchor = document.createElement("a");
                                    anchor.target = "_blank";
                                    anchor.rel = "noreferrer";
                                    setAsShared && setAsShared();
                                    return [
                                        4,
                                        handleSocialShare(false, undefined, url)
                                    ];
                                case 1:
                                    mobileUrl = _state.sent();
                                    anchor.href = mobileUrl;
                                    anchor.click();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("desktop:hidden", anchorClasses, !dialogContent.open ? "pointer-events-none" : "pointer-events-auto cursor-pointer"),
                    children: props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: props.icon,
                        className: imageClasses,
                        alt: "social icon"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: props.dark,
                                "data-hide-on-theme": "light",
                                className: imageClasses,
                                alt: "social icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: props.light,
                                "data-hide-on-theme": "dark",
                                className: imageClasses,
                                alt: "social icon"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[14px] font-600 text-blue-600",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)("opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none absolute -bottom-[22px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-100"),
                    children: tooltipTitle
                })
            ]
        })
    });
}


/***/ }),

/***/ 1027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ transformTool; },
/* harmony export */   "Nf": function() { return /* binding */ formatTimes; },
/* harmony export */   "eA": function() { return /* binding */ transformToolToIcon; },
/* harmony export */   "h$": function() { return /* binding */ SingleProductHistory; },
/* harmony export */   "p": function() { return /* binding */ HistoryPopup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1455);
/* harmony import */ var _comps_ai_tools_other_products_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(437);
/* harmony import */ var _comps_editors_deform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8641);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9034);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2404);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4371);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2706);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6010);
/* harmony import */ var controllers_editors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var pages_models__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1087);
/* harmony import */ var pages_tools__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9274);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8767);
/* harmony import */ var sections_history_generations__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5170);
/* harmony import */ var _more_button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9610);
/* harmony import */ var _render_content__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7731);
/* harmony import */ var _render_text_content__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5492);
/* harmony import */ var _save_media_popup__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(373);
/* harmony import */ var _share_content__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8440);






























function HistoryPopup(props) {
    var backgroundClickHandler = function backgroundClickHandler(e) {
        var target = e.target;
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(target, HTMLElement)) {
            if (target.id === "background") {
                if (!notShallow) {
                    router.push("/profile/generations/all", undefined, {
                        shallow: true
                    });
                }
                onClose();
            }
            if (target.id !== "media-box") {
                setShowMediaDialog(false);
            }
        }
    };
    var imageOrVideo = props.imageOrVideo, onClose = props.onClose, createdAt = props.createdAt, privacy = props.privacy, id = props.id, tool = props.tool, initial = props.initial, handleRetry = props.handleRetry, notShallow = props.notShallow, handleDelete = props.handleDelete, selectCreatorTool = props.selectCreatorTool;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_14__.useQueryClient)();
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_7__/* .NotificationContext */ .u).notify;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(window.matchMedia("(max-width: 767px)").matches), isMobileView = ref[0], _ = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(privacy === "public"), isPublic = ref1[0], setPublic = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showDropdown = ref2[0], setShowDropdown = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        open: false,
        isPublic: false,
        link: "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_8__/* .APP_HOST */ .b, "/profile/generations/").concat(id),
        id: null
    }), shareDialog = ref3[0], setShareDialog = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMediaDialog = ref4[0], setShowMediaDialog = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), offset = ref5[0], setOffset = ref5[1];
    function handleMakePublic(privacy, id) {
        return _handleMakePublic.apply(this, arguments);
    }
    function _handleMakePublic() {
        _handleMakePublic = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(privacy, id) {
            var payload, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        payload = {
                            privacy: privacy === "public" ? "private" : "public",
                            job: id
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_24__/* ["default"].post */ .Z.post("/api/deforum-privacy", payload)
                        ];
                    case 1:
                        _state.sent();
                        queryClient.invalidateQueries("deforum-history");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                            children: t(privacy === "public" ? "txt_could_not_make_public" : "txt_could_not_make_private")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleMakePublic.apply(this, arguments);
    }
    function handleSocialShare(desktop, desktopFunction, url) {
        return _handleSocialShare.apply(this, arguments);
    }
    function _handleSocialShare() {
        _handleSocialShare = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(desktop, desktopFunction, url) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!!shareDialog.isPublic) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleMakePublic("private", id)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        if (desktop && desktopFunction) return [
                            2,
                            desktopFunction(shareDialog.link)
                        ];
                        else if (url) return [
                            2,
                            url(shareDialog.link)
                        ];
                        else throw Error("No function");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            2,
                            ""
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSocialShare.apply(this, arguments);
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.key === "Escape") {
                if (!notShallow) {
                    router.push("/profile/generations/all", undefined, {
                        shallow: true
                    });
                }
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return function() {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        notShallow,
        onClose,
        router
    ]);
    function handleCopyText(e) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(e) {
            var target, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText("".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_8__/* .APP_HOST */ .b, "/profile/generations/").concat(id))
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_5__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("no-scrollbar fixed inset-0 z-[100] h-screen w-screen overflow-y-scroll", "transition-opacity duration-300", "bg-color-background tablet:overscroll-contain tablet:bg-color-black/40", "cursor-auto desktop:overflow-hidden"),
        id: "background",
        onClick: backgroundClickHandler,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("no-scrollbar relative w-screen bg-color-cell tablet:rounded-xl", "tablet:left-1/2 tablet:top-[100px] tablet:h-[1090px] tablet:w-[564px] tablet:-translate-x-1/2 ", " responsive-zoom desktop:h-[857px] desktop:w-[1206px]", "desktop:top-1/2 desktop:-translate-y-1/2"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative flex flex-col", "desktop:w-full desktop:flex-row"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_render_content__WEBPACK_IMPORTED_MODULE_17__/* .RenderContent */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, props), {
                            offset: offset,
                            setOffset: setOffset,
                            viewFor: "history"
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("mb-[60px] hidden flex-col gap-[12px] py-[14px] tablet:flex desktop:mb-0", "no-scrollbar shrink-0 overflow-y-scroll desktop:w-[431px] desktop:py-[16px]", "relative z-50 bg-color-cell tablet:h-[559px] desktop:h-[857px]", "rounded-xl tablet:rounded-t-none desktop:rounded-l-none desktop:rounded-r-xl"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex shrink-0 flex-col gap-[8px] px-[16px] desktop:w-[431px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center gap-[12px] [--icon-color:var(--color-blue-600)]",
                                                children: [
                                                    props.model === undefined && transformToolToIcon(tool),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-blue-700"),
                                                        children: props.model !== undefined ? props.model : transformTool(tool)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("text-[16px] font-[500] leading-[26px] tracking-[0.28px] text-blue-500"),
                                                children: formatTimes(createdAt)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-auto h-[1px] w-[calc(100%-32px)] shrink-0 bg-color-separator"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative z-50 flex shrink-0 items-start gap-[10px] px-[16px]", "no-scrollbar -mb-[30px] pb-[30px] desktop:overflow-x-auto"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_save_media_popup__WEBPACK_IMPORTED_MODULE_19__/* .SaveMediaPopup */ .N, {
                                            offset: offset,
                                            showMediaDialog: showMediaDialog,
                                            setShowMediaDialog: setShowMediaDialog,
                                            imageOrVideo: imageOrVideo,
                                            showDropdown: showDropdown,
                                            setShowDropdown: setShowDropdown
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[50px] w-[1px] bg-blue-300 desktop:shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            onClick: handleCopyText,
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative flex items-center justify-center", "group transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 overflow-visible rounded-full bg-color-background"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/ai-tools/history/copy-primary.svg"),
                                                    alt: "copy icon",
                                                    className: "h-[20px] w-[20px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("pointer-events-none absolute -bottom-[30px] w-[80px]", "rounded-[4px] px-3 py-1 opacity-0 hover:opacity-0 group-hover:opacity-100", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-100"),
                                                    children: t("txt_copy_link")
                                                })
                                            ]
                                        }),
                                        sections_history_generations__WEBPACK_IMPORTED_MODULE_15__/* .socials.map */ .UY.map(function(props) {
                                            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(sections_history_generations__WEBPACK_IMPORTED_MODULE_15__/* .SocialButton */ .Z0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, props), {
                                                title: "",
                                                tooltipTitle: props.title,
                                                handleSocialShare: handleSocialShare,
                                                dialogContent: shareDialog,
                                                key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                            }));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_render_text_content__WEBPACK_IMPORTED_MODULE_18__/* .RenderTextContent */ .K, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, props)),
                                props.modelType !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("ml-[16px] flex items-center gap-[4px] rounded-[5px]", "bg-color-background px-[10px] py-[4px]"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/general/model-icon.svg"),
                                                className: "h-[14px] w-[14px]",
                                                alt: "model icon"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[14px] font-500 text-blue-700",
                                                children: (0,pages_models__WEBPACK_IMPORTED_MODULE_12__.getModelType)(props.modelType)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    onClick: handleRetry,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("mx-auto my-[4px] hidden w-[calc(100%-32px)] shrink-0 items-center", "justify-center gap-[12px] rounded-[10px] bg-primary-500 py-[12px]", "hover:bg-primary-600 desktop:my-[10px] desktop:flex"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/general/regenerate-white.svg"),
                                            alt: "plus icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                            children: props.model ? t("lbl_remake") : t("txt_regenerate")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full shrink-0 px-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: _utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .appStoreConstant */ .HY,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative mx-auto flex w-full items-center justify-center", "gap-[12px] rounded-[10px] bg-primary-500 py-[12px]", "hover:opacity-70 desktop:hidden"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/general/regenerate-white.svg"),
                                                alt: "plus icon"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-color-white",
                                                children: t("txt_regenerate")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "px-4 text-[16px] font-700 tracking-normal text-blue-700 desktop:mt-auto",
                                    children: t("txt_other_ai_tools")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("no-scrollbar flex w-full gap-2 overflow-x-scroll desktop:gap-0", "tablet:px-[16px] desktop:flex-col"),
                                    children: _comps_ai_tools_other_products_section__WEBPACK_IMPORTED_MODULE_3__/* .allProducts.filter */ .Od.filter(function(t) {
                                        return t.tool !== tool;
                                    }).map(function(product, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleProductHistory, {
                                            product: product,
                                            selectCreatorTool: selectCreatorTool,
                                            onClose: onClose
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("absolute bottom-0 left-0 z-[101] flex w-full flex-col gap-[19px] px-[16px] pb-[46px] tablet:hidden", "bg-gradient-to-t from-color-black/75 via-color-black/40 to-color-black/5 backdrop-blur-[1px]"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col gap-[8px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex items-center justify-between", "tablet:absolute tablet:-top-[360px] tablet:flex-col tablet:items-start"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex items-center gap-[12px] [--icon-color:var(--color-white)]",
                                                    children: [
                                                        transformToolToIcon(tool),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(" text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-color-white ", "tablet:text-blue-700"),
                                                            children: transformTool(tool)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-blue-400"),
                                                    children: formatTimes(createdAt)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                tool === "text_to_image" || tool === "text_to_video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "h-[1px] w-full bg-color-separator opacity-40 dark:opacity-100"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_render_text_content__WEBPACK_IMPORTED_MODULE_18__/* .RenderTextContent */ .K, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, props))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: _utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .appStoreConstant */ .HY,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("relative flex w-full items-center justify-center gap-[12px]", "rounded-[10px] bg-primary-100 py-[12px] hover:bg-primary-200"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/general/regenerate.svg"),
                                            alt: "plus icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0 -z-10 h-full w-full rounded-[10px] bg-color-black/80"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[16px] font-[600] leading-[20px] tracking-[0.32px] text-primary-500",
                                            children: t("txt_regenerate")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(" absolute right-[17px] top-[17px] z-50", "tablet:top-[680px] desktop:top-[18px]", "flex items-center gap-[12px]"),
                            children: [
                                !isPublic && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("hidden cursor-pointer items-center gap-[6px] rounded-[10px]", "bg-blue-100 px-[18px] py-[12px] tablet:flex", "[--icon-color:var(--color-blue-800)] hover:bg-blue-300"),
                                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    setPublic(!isPublic);
                                                    setShowDropdown(!showDropdown);
                                                    return [
                                                        4,
                                                        handleMakePublic(privacy, id)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    children: [
                                        (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .globusIcon */ .s8)(),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[14px] font-500 text-blue-800",
                                            children: isPublic ? t("txt_make_private") : t("txt_make_public")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_more_button__WEBPACK_IMPORTED_MODULE_16__/* .MoreButton */ .z, {
                                    handleMakePublic: handleMakePublic,
                                    setShowDropdown: setShowDropdown,
                                    setShareDialog: setShareDialog,
                                    handleDelete: handleDelete,
                                    setPublic: setPublic,
                                    showDropdown: showDropdown,
                                    dark: !isMobileView,
                                    isPublic: isPublic,
                                    privacy: privacy,
                                    href: initial !== null && initial !== void 0 ? initial : "",
                                    id: id
                                })
                            ]
                        })
                    ]
                })
            }),
            shareDialog.open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_content__WEBPACK_IMPORTED_MODULE_20__/* .ShareContent */ .X, {
                shareDialog: shareDialog,
                setShareDialog: setShareDialog,
                isPublic: isPublic,
                id: id,
                handleMakePublic: handleMakePublic
            })
        ]
    });
}
function formatTimes(timestamp) {
    var date = new Date(timestamp);
    var options = {
        month: "short",
        day: "numeric"
    };
    return date.toLocaleDateString("en-US", options);
}
function SingleProductHistory(props) {
    var product = props.product, selectCreatorTool = props.selectCreatorTool, onClose = props.onClose;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)("common").t;
    var tool = product.tool;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    function handleClickAction() {
        return _handleClickAction.apply(this, arguments);
    }
    function _handleClickAction() {
        _handleClickAction = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function() {
            var inputs, promptType;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                inputs = (0,_comps_editors_deform__WEBPACK_IMPORTED_MODULE_4__.createInputs)({
                    type: "custom",
                    content: [
                        ""
                    ]
                });
                promptType = "custom";
                if (!selectCreatorTool) {
                    return [
                        2
                    ];
                }
                switch(tool){
                    case "deform":
                        selectCreatorTool(tool, {
                            tool: "deform",
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_9__/* .DEFORUM_STORAGE_KEY */ .LF,
                            inputs: inputs,
                            promptType: promptType,
                            location: "local",
                            blob: null
                        });
                        onClose && onClose();
                        break;
                    case "ai_photo":
                    case "ai_restyle":
                        selectCreatorTool(tool, {
                            tool: tool,
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_9__/* .DEFORUM_STORAGE_KEY */ .LF,
                            input: "",
                            promptType: promptType,
                            location: "local",
                            blob: null
                        });
                        onClose && onClose();
                        break;
                    case "text_to_image":
                        selectCreatorTool(tool, {
                            tool: tool,
                            id: controllers_editors__WEBPACK_IMPORTED_MODULE_9__/* .DEFORUM_STORAGE_KEY */ .LF,
                            promptType: promptType,
                            text: "",
                            location: "local",
                            blob: null
                        });
                        onClose && onClose();
                        break;
                    default:
                        router.push(product.url);
                }
                return [
                    2
                ];
            });
        });
        return _handleClickAction.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            href: product.url,
            onClick: function(e) {
                if (selectCreatorTool) {
                    e.preventDefault();
                    handleClickAction();
                }
            },
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex w-[269px] shrink-0 flex-row items-center justify-between gap-[10px] rounded-[8px] bg-blue-100 py-[12px] pl-[12px] pr-[12px] hover:bg-blue-200", "cursor-pointer desktop:w-full desktop:rounded-none desktop:border-b desktop:border-blue-300 first:desktop:rounded-t-[8px] last:desktop:rounded-b-[8px] last:desktop:border-none"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("flex flex-row items-center gap-[10px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            muted: true,
                            loop: true,
                            playsInline: true,
                            autoPlay: true,
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_28__/* .assetUrl */ .p)("/ai-tools/".concat(product.location, "/intro.mp4#t=0.001")),
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)("aspect-1 h-[88px] rounded-[6px] object-cover object-top", "transition-all duration-300", "desktop:hidden")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-2 [--icon-color:var(--color-blue-700)] desktop:flex-row desktop:items-center desktop:gap-3 ",
                            children: [
                                product.icon,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-1 flex-col items-start gap-1 text-[16px] font-500 text-blue-700 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "leading-[19px] tablet:leading-normal",
                                            children: t(product.label)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "truncate text-[14px] font-400 leading-[15px] text-blue-600 tablet:w-[120px] desktop:w-[310px]",
                                            children: t("".concat(product.label, "_description"))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "[--icon-color:var(--color-placeholder)]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_tools__WEBPACK_IMPORTED_MODULE_13__.Arrow, {})
                })
            ]
        })
    });
}
function transformTool(word) {
    var transformations = {
        deform: "Deform",
        ai_photo: "AI Photo",
        ai_restyle: "AI Restyle",
        text_to_image: "Text to Image",
        text_to_video: "Text to Video",
        ai_look: "Look AI",
        ai_suggest: "AI Photoshoot"
    };
    return transformations[word] || word;
}
function transformToolToIcon(word) {
    var transformations = {
        deform: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .deforumIcon */ .uv)(),
        ai_photo: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .photoAiIcon */ .x$)(),
        ai_restyle: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .restyleIcon */ .Lt)(),
        text_to_image: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToImageIcon */ .f7)(),
        text_to_video: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .textToVideoIcon */ .Cz)(),
        ai_look: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .lookAiIcon */ .YH)(),
        ai_suggest: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_2__/* .AIPhotoshoot */ .wQ)()
    };
    return transformations[word] || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 9610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ MoreButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1455);
/* harmony import */ var _comps_dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3153);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9612);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(177);
/* harmony import */ var _utils_variables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2706);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2213);











function MoreButton(props) {
    var handleMakePublic = props.handleMakePublic, id = props.id, href = props.href, handleDelete = props.handleDelete, privacy = props.privacy, setShareDialog = props.setShareDialog, isPublic = props.isPublic, setPublic = props.setPublic, isSinglePage = props.isSinglePage, username = props.username, closeLink = props.closeLink, setReportPopup = props.setReportPopup, reportPopup = props.reportPopup;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_4__/* .useAdjustLogger */ .eW)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_dropdown__WEBPACK_IMPORTED_MODULE_2__/* .DropDown */ .vb, {
        hover: true,
        closeOnClick: true,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-[40px] w-[40px] tablet:h-[45px] tablet:w-[45px]"),
        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex items-center justify-center rounded-full bg-color-white/25 p-2", "hover:bg-color-black/50 tablet:rounded-xl tablet:bg-[inherit] tablet:hover:bg-blue-100", "cursor-pointer [--icon-color:var(--color-white)] dark:[--icon-color:var(--color-white)]", "tablet:z-[102] tablet:h-[45px] tablet:w-[45px] tablet:p-[7px] tablet:[--icon-color:var(--color-blue-900)]"),
            children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_1__/* .moreIcon */ .Jf)()
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(reportPopup && "hidden", "absolute right-0 z-[101] w-[231px] pt-2", "desktop:left-1/2 desktop:right-[unset] desktop:-translate-x-1/2"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex flex-col gap-1 rounded-[12px] bg-color-popup-cell p-2 shadow-xl [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                children: [
                    handleMakePublic && privacy && setPublic && !username && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!isPublic && "tablet:hidden", isSinglePage && "hidden", "flex w-full cursor-pointer items-center gap-2 px-4 py-3 tablet:gap-3", "rounded-lg [--icon-color:var(--color-blue-600)] hover:bg-blue-300"),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setPublic(!isPublic);
                                        return [
                                            4,
                                            handleMakePublic(privacy, id)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                format: "svg",
                                source: isPublic ? "/ai-tools/history/lock" : "/ai-tools/history/globus"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-500 text-blue-800",
                                children: isPublic ? t("txt_make_private") : t("txt_make_public")
                            })
                        ]
                    }),
                    !username && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!isPublic && "tablet:hidden", isSinglePage && "hidden", "h-[1px] w-full bg-blue-100")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        onClick: function() {
                            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
                        },
                        href: href,
                        download: true,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 desktop:hidden", "w-full rounded-[8px] transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "tablet:hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                format: "svg",
                                source: "/ai-tools/history/save"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-500 text-blue-800",
                                children: t("txt_save")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setShareDialog({
                                open: true,
                                isPublic: isPublic !== null && isPublic !== void 0 ? isPublic : true,
                                link: closeLink ? "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_5__/* .APP_HOST */ .b, "/ai-gallery/single/").concat(id) : "".concat(_utils_variables__WEBPACK_IMPORTED_MODULE_5__/* .APP_HOST */ .b, "/profile/generations/").concat(id),
                                id: id
                            });
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 desktop:hidden", "w-full rounded-[8px] transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "tablet:hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                format: "svg",
                                source: "/ai-tools/history/share",
                                className: "w-[23px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-500 text-blue-800",
                                children: t("txt_share")
                            })
                        ]
                    }),
                    setReportPopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setReportPopup(true);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex items-center gap-3 px-4 py-3 tablet:hidden", "w-full rounded-[8px] transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_3__/* .CustomThemedResource */ .aK, {
                                source: "/general/report-gray",
                                format: "svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-500 text-blue-800",
                                children: t("txt_report")
                            })
                        ]
                    }),
                    handleDelete !== undefined && !username && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            handleDelete(id);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(isSinglePage && "hidden", "flex items-center gap-3 px-4 py-3", "w-full rounded-[8px] transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_10__/* .assetUrl */ .p)("/ai-tools/history/trash.svg"),
                                alt: "trash"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[14px] font-500 text-color-error",
                                children: t("txt_remove")
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 7731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ RenderContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_player__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1993);
/* harmony import */ var _comps_progressive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4903);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3826);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var video_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1501);










function RenderContent(props) {
    var imageOrVideo = props.imageOrVideo, notShallow = props.notShallow, onClose = props.onClose, previewImage = props.previewImage, closeLink = props.closeLink, promptName = props.promptName, offset = props.offset, setOffset = props.setOffset, thumb = props.thumb, customPrompt = props.customPrompt, aspectRatio = props.aspectRatio, viewFor = props.viewFor;
    var isVideo = imageOrVideo.includes(".mp4");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(viewFor === "history" ? "h-[100svh]" : "", "w-screen", "overflow-hidden bg-color-popup tablet:h-[667px] tablet:w-full tablet:shrink-0 tablet:rounded-xl", "desktop:h-[857px] desktop:w-[775px] desktop:rounded-r-none desktop:px-[113px] desktop:py-[110px]", "group relative flex items-center justify-center"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute left-0 top-0 z-10 h-full w-full overflow-hidden bg-color-black filter", "overflow-hidden tablet:rounded-xl desktop:h-[857px] desktop:w-[775px] desktop:rounded-r-none"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: previewImage !== null && previewImage !== void 0 ? previewImage : undefined,
                            alt: "preview image",
                            className: "absolute h-full w-full scale-110 object-cover opacity-30 blur-lg"
                        })
                    }),
                    typeof imageOrVideo === "string" ? isVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleVideo, {
                        previewImage: previewImage !== null && previewImage !== void 0 ? previewImage : "",
                        video: imageOrVideo,
                        thumb: thumb,
                        aspectRatio: aspectRatio,
                        prompt: customPrompt,
                        style: promptName
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleImage, {
                        image: imageOrVideo,
                        thumb: thumb,
                        aspectRatio: aspectRatio,
                        previewImage: previewImage,
                        prompt: customPrompt,
                        style: promptName
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MultipleImages, {
                        images: imageOrVideo,
                        aspectRatio: aspectRatio,
                        offset: offset,
                        setOffset: setOffset,
                        previewImage: previewImage,
                        customPrompt: customPrompt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("rounded-full bg-color-white/25 p-2", "fixed left-[17px] top-[17px] z-[101] desktop:hidden"),
                        onClick: function() {
                            if (!notShallow) {
                                router.push(closeLink ? "".concat(closeLink) : "/profile/generations/all", undefined, {
                                    shallow: true
                                });
                            }
                            onClose();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/comps/close-icon.svg"),
                            alt: "close icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute hidden desktop:flex", "right-[-480px] top-0 rounded-full bg-color-cell hover:bg-blue-100", "h-[32px] w-[32px] items-center justify-center"),
                onClick: function() {
                    if (!notShallow) {
                        router.push(closeLink ? "".concat(closeLink) : "/profile/generations/all", undefined, {
                            shallow: true
                        });
                    }
                    onClose();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/comps/close-dark.svg"),
                    alt: "close icon"
                })
            })
        ]
    });
}
function SingleImage(props) {
    var image = props.image, aspectRatio = props.aspectRatio;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            aspectRatio: aspectRatio
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative z-40", "overflow-hidden tablet:rounded-[19px]", "tablet:max-h-[533px] tablet:max-w-[500px]", "desktop:max-h-[700px] desktop:max-w-[525px]"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: image,
            alt: props.style,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("tablet:max-h-[533px] tablet:rounded-[19px] desktop:max-h-[700px]")
        })
    });
}
function SingleVideo(props) {
    var video = props.video, aspectRatio = props.aspectRatio;
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        width: 0,
        height: 0
    }), videoDimensions = ref[0], setVideoDimensions = ref[1];
    var handleVideoLoadedMetadata = function() {
        if (videoRef.current) {
            var _current = videoRef.current, videoWidth = _current.videoWidth, videoHeight = _current.videoHeight;
            setVideoDimensions({
                width: videoWidth,
                height: videoHeight
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            aspectRatio: aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : "".concat(videoDimensions.width, "/").concat(videoDimensions.height)
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative z-40", "max-h-full overflow-hidden tablet:max-h-[533px] tablet:max-w-[322px] tablet:rounded-[19px] desktop:max-h-[700px] desktop:max-w-[525px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                loop: true,
                autoPlay: true,
                playsInline: true,
                preload: "metadata",
                src: video,
                ref: videoRef,
                onLoadedMetadata: handleVideoLoadedMetadata,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-full tablet:rounded-[19px]")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(video_provider__WEBPACK_IMPORTED_MODULE_6__/* .VideoProvider */ .G, {
                remember: [],
                element: videoRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute bottom-0 left-0 z-50 w-full text-color-white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_1__/* .Timeline */ .TY, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_player__WEBPACK_IMPORTED_MODULE_1__/* .PlayWithProvider */ .uX, {})
                ]
            })
        ]
    });
}
function MultipleImages(props) {
    var scrollToImage = function scrollToImage(index) {
        var ref;
        var nextImage = (ref = desktopRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByClassName("ai-art-generation-".concat(images, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    };
    var images = props.images, offset = props.offset, setOffset = props.setOffset, aspectRatio = props.aspectRatio, previewImage = props.previewImage, customPrompt = props.customPrompt;
    var desktopRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    var isImageReady = (0,_comps_progressive__WEBPACK_IMPORTED_MODULE_2__/* .useProgressive */ .k)(images[0]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            aspectRatio: aspectRatio
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative z-50 flex items-center justify-center tablet:max-h-[500px] desktop:max-h-[700px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onScroll: function(event) {
                    var container = event.target;
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(container, HTMLElement)) {
                        var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                        setOffset(snapIndex);
                    }
                },
                ref: desktopRef,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("no-scrollbar flex h-full snap-x snap-mandatory gap-12 overflow-x-scroll transition-all", "tablet:rounded-xl"),
                children: images.map(function(thumb, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: isImageReady ? thumb : previewImage,
                        alt: (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_4__.getFirstFiveWords)(customPrompt),
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("w-full shrink-0 snap-center tablet:rounded-xl desktop:w-[525px]", "ai-art-generation-".concat(images, "-").concat(index))
                    }, thumb);
                })
            }),
            images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("flex flex-row gap-[5px] rounded-[40px] bg-[#00000066] px-[10px] py-1 opacity-100 transition-all", "absolute bottom-2 left-1/2 -translate-x-1/2"),
                children: images.map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return scrollToImage(index);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-[6px] w-[6px] cursor-pointer rounded-full transition-all", offset === index ? "scale-[1.4] bg-primary-500" : "scale-100 bg-color-white")
                    }, index);
                })
            }),
            images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === 0,
                        onClick: function() {
                            scrollToImage(offset - 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute left-2 top-[calc(50%-12px)] flex h-6 w-6 items-center justify-center rounded-full", "border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-0 group-hover:opacity-100", "z-[999] desktop:-left-[73px]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === images.length - 1,
                        onClick: function() {
                            scrollToImage(offset + 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("absolute right-2 top-[calc(50%-12px)] flex h-6 w-6 items-center justify-center rounded-full", " border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all", " hover:border-color-white/60 disabled:border-[transparent]", "hover:opacity-0 group-hover:opacity-100", "z-[999] desktop:-right-[73px]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_8__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow",
                            className: "rotate-180"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 5492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ RenderTextContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9034);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4371);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);










function RenderTextContent(props) {
    var tool = props.tool;
    switch(tool){
        case "text_to_image":
        case "text_to_video":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithText, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case "deform":
        case "ai_restyle":
        case "ai_photo":
        case "model_drafts":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithoutText, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    }
}
function WithText(props) {
    var customPrompt = props.customPrompt;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .NotificationContext */ .u).notify;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    function handleCopyText(e, text) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(e, text) {
            var target, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("w-full pr-3 tablet:hidden", "transition-all group-hover:opacity-100", "relative mt-[16px] flex cursor-auto items-start gap-[30px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "no-scrollbar flex justify-between overflow-hidden overflow-y-scroll pr-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("cursor-text font-mono text-sm font-400 text-color-white transition-[max-height]", isHovered ? "max-h-[80px] min-h-[50px] max-w-[280px] whitespace-normal" : "max-h-[20px] w-[260px] truncate"),
                                children: customPrompt
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(isHovered ? " absolute right-0 top-0" : "hidden", "h-8 w-8 shrink-0 cursor-pointer transition-colors hover:bg-blue-100", "flex items-center justify-center rounded-[4px]"),
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                                    var e;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    navigator.clipboard.writeText(customPrompt)
                                                ];
                                            case 1:
                                                _state.sent();
                                                notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .SuccessMessage */ .kk, {
                                                    children: t("common:txt_successfully_copied")
                                                }));
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                e = _state.sent();
                                                console.error(e);
                                                notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                                                    children: t("common:txt_couldnt_copy")
                                                }));
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                    alt: "copy",
                                    className: "h-[18px] w-[18px]"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(isHovered ? "-bottom-[2px]" : "-top-[2px]", "absolute right-0 w-[70px]", "flex items-center justify-center rounded-[12px]"),
                        onClick: function() {
                            return setIsHovered(!isHovered);
                        },
                        children: isHovered ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-color-white",
                            children: t("txt_less")
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-color-white",
                            children: t("txt_more")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-row pl-4 pr-6 pt-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "popup-markdown-container no-scrollbar max-h-[200px] flex-1 overflow-y-scroll pr-3 font-mono text-[12px] font-400 text-blue-700",
                        children: customPrompt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function(e) {
                            return handleCopyText(e, customPrompt);
                        },
                        className: "h-[20px] w-[20px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_9__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                            alt: "copy",
                            className: "h-full"
                        })
                    })
                ]
            })
        ]
    });
}
function WithoutText(props) {
    var promptName = props.promptName;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex tablet:flex-col tablet:gap-[8px] tablet:px-[16px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "hidden text-[16px] font-600 leading-[26px] tracking-[0.32px] text-blue-500 tablet:block",
                children: t("txt_style")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("rounded-[100px] bg-color-success-15 px-[22px] text-[14px] font-[500] capitalize", " leading-[26px] tracking-[0.28px] text-color-success"),
                    children: promptName
                })
            })
        ]
    });
}


/***/ }),

/***/ 1059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ReportPopup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5896);
/* harmony import */ var _comps_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5792);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9034);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1816);
/* harmony import */ var _utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7592);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4371);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
















function ReportPopup(props) {
    var payload = props.payload, setReportPopup = props.setReportPopup, className = props.className, endpoint = props.endpoint, galleryOrTemplate = props.galleryOrTemplate, setPayload = props.setPayload, closeFn = props.closeFn;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""), selectedReason = ref[0], setSelectedReason = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""), message = ref1[0], setMessage = ref1[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_8__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    var auth = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)();
    function handleReport() {
        return _handleReport.apply(this, arguments);
    }
    function _handleReport() {
        _handleReport = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (auth.userInfo && auth.userInfo.isAnonymous) {
                            (0,_utils_login_redirect__WEBPACK_IMPORTED_MODULE_5__/* .redirectToLogin */ .r)();
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_11__/* ["default"].post */ .Z.post("/api/".concat(endpoint), payload)
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_3__/* .SuccessMessage */ .kk, {
                            children: t("txt_report_success")
                        }));
                        setReportPopup(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleReport.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(className !== null && className !== void 0 ? className : (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("fixed bottom-0 left-0 right-0 tablet:-right-[40px] tablet:bottom-auto tablet:left-auto", "z-[100] tablet:top-[740px] tablet:z-[200] desktop:-right-[150px] desktop:top-[80px]"), "flex flex-col items-center p-[24px] tablet:w-[364px] tablet:rounded-[12px]", "w-full gap-[18px] rounded-t-[12px] bg-color-popup-cell shadow-xl"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[24px] font-600 text-blue-800",
                        children: t("txt_report")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[14px] font-500 text-blue-600",
                        children: t("txt_report_desc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full",
                children: new Array(galleryOrTemplate === "gallery" ? 5 : 6).fill(null).map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: function() {
                                    return setSelectedReason(t("txt_".concat(galleryOrTemplate, "_report_reason_").concat(index)));
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(selectedReason === t("txt_".concat(galleryOrTemplate, "_report_reason_").concat(index)) ? "bg-blue-300" : "hover:bg-blue-cell", "flex items-center justify-between", "w-full rounded-[8px] px-[10px] py-[12px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[14px] font-500 text-blue-600",
                                        children: t("txt_".concat(galleryOrTemplate, "_report_reason_").concat(index))
                                    }),
                                    selectedReason === t("txt_".concat(galleryOrTemplate, "_report_reason_").concat(index)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_13__/* .assetUrl */ .p)("/general/check-primary.svg"),
                                        alt: "check icon primary",
                                        className: "h-[20px] w-[20px]"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[20px] w-[20px] rounded-full border border-blue-300"
                                    })
                                ]
                            }),
                            selectedReason === t("txt_".concat(galleryOrTemplate, "_report_reason_").concat(index)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                value: message,
                                setValue: setMessage,
                                label: t("txt_report_placeholder")
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full items-center gap-[10px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            return setReportPopup && setReportPopup(false);
                        },
                        className: "w-[100px] rounded-[10px] px-[18px] py-[12px] text-[16px] font-600 text-blue-600",
                        children: t("lbl_cancel")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_1__/* .NewButton */ .R9, {
                        text: t("txt_report"),
                        variant: "secondary",
                        disabled: selectedReason === "" || selectedReason === "Other" && message === "",
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setPayload((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, payload), {
                                            info: {
                                                reason: selectedReason,
                                                message: message
                                            }
                                        }));
                                        return [
                                            4,
                                            handleReport()
                                        ];
                                    case 1:
                                        _state.sent();
                                        closeFn === null || closeFn === void 0 ? void 0 : closeFn();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SaveMediaPopup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2222);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_adjust__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6254);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2213);








function SaveMediaPopup(props) {
    var handleSaveMedia = function handleSaveMedia() {
        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("deform_ai_video_save");
        setShowDropdown(!showDropdown);
        setThanksPopup === null || setThanksPopup === void 0 ? void 0 : setThanksPopup(true);
        if (showFor === "gallery") {
            setAsShared === null || setAsShared === void 0 ? void 0 : setAsShared();
        }
    };
    var imageOrVideo = props.imageOrVideo, setShowMediaDialog = props.setShowMediaDialog, showMediaDialog = props.showMediaDialog, offset = props.offset, showFor = props.showFor, setAsShared = props.setAsShared, setShowDropdown = props.setShowDropdown, setThanksPopup = props.setThanksPopup, showDropdown = props.showDropdown;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var logAdjust = (0,_utils_adjust__WEBPACK_IMPORTED_MODULE_1__/* .useAdjustLogger */ .eW)();
    function handleSaveAllMedia() {
        return _handleSaveAllMedia.apply(this, arguments);
    }
    function _handleSaveAllMedia() {
        _handleSaveAllMedia = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url, anchor, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowMediaDialog(!showMediaDialog);
                        if (showFor === "gallery") {
                            setAsShared === null || setAsShared === void 0 ? void 0 : setAsShared();
                        }
                        if (typeof imageOrVideo === "string") {
                            return [
                                2
                            ];
                        }
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = imageOrVideo[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        url = _step.value;
                        anchor = document.createElement("a");
                        anchor.href = url;
                        anchor.rel = "noopener noreferrer";
                        anchor.download = url.substring(url.lastIndexOf("/") + 1);
                        document.body.appendChild(anchor);
                        anchor.click();
                        document.body.removeChild(anchor);
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 500);
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        setThanksPopup === null || setThanksPopup === void 0 ? void 0 : setThanksPopup(true);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSaveAllMedia.apply(this, arguments);
    }
    switch(typeof imageOrVideo === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(imageOrVideo)){
        case "object":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    setShowMediaDialog(!showMediaDialog);
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("group relative flex items-center justify-center", "cursor-pointer transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 rounded-full bg-color-surface"),
                id: "media-box",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/ai-tools/history/save-primary.svg"),
                        alt: "save icon",
                        className: "h-[20px] w-[20px]",
                        id: "media-box"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none absolute -bottom-[30px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-100"),
                        children: t("txt_save")
                    }),
                    showMediaDialog && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("fixed top-[150px] z-[103] w-[200px] translate-x-[780px] shadow-xl", "shadow-color-black/30 tablet:left-0", "flex flex-col gap-[4px] rounded-xl bg-color-cell px-[10px] py-[14px]"),
                        id: "media-box",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                onClick: handleSaveMedia,
                                href: imageOrVideo[offset],
                                download: true,
                                className: "rounded-lg px-[16px] py-[12px] text-start text-blue-800 hover:bg-blue-100",
                                children: t("txt_save_media")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "rounded-lg px-[16px] py-[12px] text-start text-blue-800 hover:bg-blue-100",
                                onClick: handleSaveAllMedia,
                                children: t("txt_save_all_media")
                            })
                        ]
                    })
                ]
            });
        case "string":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                onClick: handleSaveMedia,
                href: imageOrVideo,
                download: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex items-center justify-center", "group transition-colors hover:bg-blue-300", "disabled:hover:bg-transparent disabled:opacity-50", "h-[52px] w-[52px] shrink-0 rounded-full bg-color-background"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/ai-tools/history/save-primary.svg"),
                        alt: "save icon",
                        className: "h-[20px] w-[20px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("opacity-0 hover:opacity-0 group-hover:opacity-100", "pointer-events-none absolute -bottom-[30px]", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-100"),
                        children: t("txt_save")
                    })
                ]
            });
    }
}


/***/ }),

/***/ 8440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ShareContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9034);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2213);
/* harmony import */ var sections_history_generations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5170);














function ShareContent(props) {
    var shareDialog = props.shareDialog, setShareDialog = props.setShareDialog, id = props.id, handleMakePublic = props.handleMakePublic, setAsShared = props.setAsShared;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_3__/* .NotificationContext */ .u).notify;
    function handleSocialShare(desktop, desktopFunction, url) {
        return _handleSocialShare.apply(this, arguments);
    }
    function _handleSocialShare() {
        _handleSocialShare = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(desktop, desktopFunction, url) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(!shareDialog.isPublic && handleMakePublic)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleMakePublic("private", id)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        if (desktop && desktopFunction) return [
                            2,
                            desktopFunction(shareDialog.link)
                        ];
                        else if (url) return [
                            2,
                            url(shareDialog.link)
                        ];
                        else throw Error("No function");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            2,
                            ""
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSocialShare.apply(this, arguments);
    }
    function handleCopyPrompt(text) {
        return _handleCopyPrompt.apply(this, arguments);
    }
    function _handleCopyPrompt() {
        _handleCopyPrompt = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(text) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyPrompt.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("fixed inset-0 flex items-end justify-start bg-color-popup tablet:items-center tablet:justify-center", shareDialog.open ? "z-[102] transition-opacity duration-300" : "hidden"),
        id: "popup-content",
        onClick: function(event) {
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(event.target, Element)) {
                if (event.target.id === event.currentTarget.id) {
                    setShareDialog({
                        open: false,
                        isPublic: false,
                        link: shareDialog.link,
                        id: null
                    });
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("relative w-full rounded-t-2xl bg-color-cell pb-8 pt-4 transition-all", "tablet:w-auto tablet:rounded-2xl tablet:py-4", shareDialog.open ? "translate-y-0" : "translate-y-full tablet:translate-y-0"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        return setShareDialog({
                            open: false,
                            isPublic: false,
                            link: shareDialog.link,
                            id: null
                        });
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("absolute -right-10 top-0 hidden h-8 w-8 items-center justify-center rounded-full desktop:flex", "bg-color-cell transition-colors hover:bg-blue-100"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_10__/* .assetUrl */ .p)("/general/close.svg"),
                        alt: "close icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center gap-1 px-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[18px] font-500 text-blue-700 tablet:text-[24px]",
                                    children: t("txt_share")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[1px] w-full bg-color-separator"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col gap-[22px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("no-scrollbar flex flex-row gap-5 overflow-y-hidden overflow-x-scroll bg-color-cell px-4"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: function() {
                                                    handleCopyPrompt(shareDialog.link);
                                                    setAsShared && setAsShared();
                                                    setShareDialog((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, shareDialog), {
                                                        open: false
                                                    }));
                                                },
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("flex h-[52px] w-[52px] items-center justify-center rounded-full", "bg-color-background p-3 transition-colors hover:bg-blue-100 disabled:cursor-default", "disabled:hover:bg-primary-600/10"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_10__/* .assetUrl */ .p)("/ai-tools/history/copy-primary.svg"),
                                                    alt: "copy icon",
                                                    className: "h-[24px] w-[24px]"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: " shrink-0 text-[14px] font-600 text-blue-600",
                                                children: t("lbl_link")
                                            })
                                        ]
                                    }),
                                    sections_history_generations__WEBPACK_IMPORTED_MODULE_5__/* .socials.map */ .UY.map(function(props) {
                                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(sections_history_generations__WEBPACK_IMPORTED_MODULE_5__/* .SocialButton */ .Z0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                                            handleSocialShare: handleSocialShare,
                                            setAsShared: setAsShared,
                                            dialogContent: shareDialog,
                                            key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                                        }));
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ RelatedSection; }
/* harmony export */ });
/* unused harmony export SingleGenerated */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8673);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9034);
/* harmony import */ var _comps_progressive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4903);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4165);
/* harmony import */ var _comps_tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4773);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4371);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2213);
/* harmony import */ var pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3826);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8767);
/* harmony import */ var react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2337);
/* harmony import */ var sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8067);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6106);
/* harmony import */ var sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7276);
/* harmony import */ var sections_gallery_single_gallery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6622);
/* harmony import */ var _ai_single_page__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5576);
/* harmony import */ var _history_popup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1027);























function SingleGenerated(props) {
    var _entity = props.entity, id = _entity.id, object_urls = _entity.object_urls, media_type = _entity.media_type, prompt = _entity.prompt, style_name = _entity.style_name, style = _entity.style;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(true), videoPaused = ref2[0], setVideoPaused = ref2[1];
    var scrollToImage = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)(function(index) {
        var nextImage = document.getElementsByClassName("single-gallery-".concat(id, "-").concat(index)).item(0);
        if (!nextImage) {
            return;
        }
        var parent = nextImage.parentElement;
        if (!parent) {
            return;
        }
        var childX = nextImage.getBoundingClientRect().x;
        var parentX = parent.getBoundingClientRect().x;
        var childOffset = childX - parentX;
        parent.scrollBy({
            behavior: "smooth",
            left: childOffset
        });
    }, [
        id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        scrollToImage(0);
    }, [
        scrollToImage,
        id
    ]);
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    var thumbReady = (0,_comps_progressive__WEBPACK_IMPORTED_MODULE_3__/* .useProgressive */ .k)(object_urls[0].thumb);
    function handleCopyPrompt(text) {
        return _handleCopyPrompt.apply(this, arguments);
    }
    function _handleCopyPrompt() {
        _handleCopyPrompt = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(text) {
            var e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyPrompt.apply(this, arguments);
    }
    if (!thumbReady) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundColor: sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__/* .skeletonColors */ .e[id % sections_dashboard_generated_video__WEBPACK_IMPORTED_MODULE_12__/* .skeletonColors.length */ .e.length]
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("min-h-[130px] w-full rounded-[12px] desktop:min-h-[180px] desktop:rounded-[14px]"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_4__/* .SizedSkeleton */ .xB, {
            className: "h-full w-full !bg-[transparent]"
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "group relative min-h-[130px] w-full shrink-0 rounded-[12px] desktop:min-h-[180px] desktop:rounded-[14px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-2 top-2",
                children: media_type === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/ai-tools/history/video-icon.svg"),
                    alt: "video-icon",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-4 w-4 transition-opacity", videoPaused ? "opacity-100" : "opacity-0")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute bottom-0 left-0 z-10 hidden w-full pt-3 desktop:block", "pointer-events-none opacity-0 transition-all group-hover:pointer-events-auto group-hover:opacity-100", "rounded-b-[12px] desktop:rounded-b-[14px]", "bg-gradient-to-t from-color-black/80 to-[transparent]", "flex cursor-auto flex-col items-center"),
                children: [
                    prompt && prompt.trim().length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onMouseEnter: function() {
                            return setIsHovered(true);
                        },
                        onMouseLeave: function() {
                            return setIsHovered(false);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("peer relative flex w-full flex-row items-end justify-between p-3 pt-0"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .TextTooltip */ .JI, {
                            showAlways: prompt.length > 144,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("max-w-full pr-6"),
                            title: prompt,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("text-sm font-400 text-color-white transition-[max-height]", isHovered ? "line-clamp-4 max-h-[80px] whitespace-normal" : "max-h-[20px] truncate"),
                                children: prompt
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-full flex-row items-center justify-between px-3 pb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "rounded-[100px] bg-[#212127A3] px-[13px] py-1 text-[13px] font-500 text-color-white",
                                children: style_name
                            }),
                            prompt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                className: "flex items-center justify-center",
                                title: t("common:txt_copy"),
                                showAlways: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        return handleCopyPrompt(prompt);
                                    },
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                        alt: "copy",
                                        className: "h-full"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            object_urls.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === 0,
                        onClick: function() {
                            return scrollToImage(offset - 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute left-2 top-[calc(50%-12px)] z-20 flex h-6 w-6 items-center justify-center rounded-full border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all hover:border-color-white/60 disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: offset === object_urls.length - 1,
                        onClick: function() {
                            return scrollToImage(offset + 1);
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute right-2 top-[calc(50%-12px)] z-20 flex h-6 w-6 items-center justify-center rounded-full border border-[transparent] bg-[#00000052] opacity-0 backdrop-blur-[10px] transition-all hover:border-color-white/60 disabled:border-[transparent]", isHovered ? "opacity-0" : "group-hover:opacity-100"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/ai-tools/history/arrow-white.svg"),
                            alt: "arrow",
                            className: "rotate-180"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/ai-gallery/single/".concat(id),
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("w-full overflow-hidden object-cover", "rounded-[12px] desktop:rounded-[14px]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onScroll: function(event) {
                            var container = event.target;
                            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(container, HTMLElement)) {
                                var snapIndex = Math.floor(container.scrollLeft / container.offsetWidth);
                                setOffset(snapIndex);
                            }
                        },
                        className: "no-scrollbar top-0 flex h-full snap-x snap-mandatory flex-row gap-12 overflow-x-scroll transition-all ",
                        children: object_urls.map(function(single, index) {
                            return media_type === "image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: single.thumb,
                                alt: prompt ? (0,pages_ai_gallery_single_id___WEBPACK_IMPORTED_MODULE_8__.getFirstFiveWords)(prompt) : style !== null && style !== void 0 ? style : "Custom",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(" h-full min-h-[130px] w-full shrink-0 snap-center rounded-[12px] object-cover desktop:min-h-[180px] desktop:rounded-[14px]", "single-gallery-".concat(id, "-").concat(index))
                            }, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: single.object + "#t=0.001",
                                poster: single.thumb,
                                playsInline: true,
                                loop: true,
                                preload: "none",
                                muted: true,
                                onPointerEnter: function(e) {
                                    setVideoPaused(false);
                                    e.currentTarget.play().catch(console.error);
                                },
                                onPointerLeave: function(e) {
                                    setVideoPaused(true);
                                    e.currentTarget.pause();
                                    e.currentTarget.currentTime = 0.001;
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-full w-full object-cover", "min-h-[130px] rounded-[12px] desktop:min-h-[180px] desktop:rounded-[14px]")
                            }, index);
                        })
                    })
                })
            })
        ]
    });
}
function RelatedSection(props) {
    var ref;
    var showRelated = props.showRelated, createdAt = props.createdAt, tool = props.tool, id = props.id, followStatus = props.followStatus, setFollowStatus = props.setFollowStatus, ownerId = props.ownerId, username = props.username, profilePic = props.profilePic, followers = props.followers, customPrompt = props.customPrompt, likes = props.likes, views = props.views, singlePageUse = props.singlePageUse, liked = props.liked, handleLike = props.handleLike;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    function handleCopyText(e) {
        return _handleCopyText.apply(this, arguments);
    }
    function _handleCopyText() {
        _handleCopyText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(e) {
            var target, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = e.currentTarget;
                        target.disabled = true;
                        setTimeout(function() {
                            target.disabled = false;
                        }, 3000);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(customPrompt !== null && customPrompt !== void 0 ? customPrompt : "")
                        ];
                    case 2:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .SuccessMessage */ .kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopyText.apply(this, arguments);
    }
    var keywords = (0,react_query__WEBPACK_IMPORTED_MODULE_10__.useQuery)({
        queryKey: [
            "keywords",
            "id-".concat(id)
        ],
        queryFn: (0,sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_14__/* .getKeywords */ .$g)(id),
        staleTime: Infinity,
        enabled: showRelated
    });
    var relatedArt = (0,react_query__WEBPACK_IMPORTED_MODULE_10__.useQuery)({
        queryKey: [
            "related-single",
            "related-art-".concat(id)
        ],
        queryFn: (0,sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_14__/* .getRelatedArt */ .VE)(id, _ai_single_page__WEBPACK_IMPORTED_MODULE_16__/* .RELATED_ART_LIMIT */ .C),
        staleTime: Infinity,
        enabled: showRelated
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("ap-[16px] flex w-full flex-col items-center gap-[16px] px-4 pb-[60px] pt-4 tablet:pb-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(singlePageUse ? "hidden" : "flex", "w-full items-center justify-between border-b border-color-separator pb-[12px]", "desktop:hidden"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: "flex items-center gap-[6px]",
                        href: "/".concat(username),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: profilePic !== null && profilePic !== void 0 ? profilePic : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/general/avatar.svg"),
                                onError: function(e) {
                                    return e.currentTarget.setAttribute("src", (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/icons/avatar-default.svg"));
                                },
                                alt: "profile picture",
                                className: "h-11 w-11 rounded-full border border-color-separator object-cover"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "max-w-[113px] truncate text-[16px] font-700 text-blue-800",
                                        children: username
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "text-[14px] font-500 text-blue-600",
                                        children: [
                                            followers,
                                            " followers"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[169px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_advanced_profile__WEBPACK_IMPORTED_MODULE_1__/* .FollowButton */ .eg, {
                            userPage: false,
                            setFollowStatus: setFollowStatus,
                            followStatus: followStatus,
                            uid: ownerId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(singlePageUse ? "hidden" : "flex w-full flex-col gap-[8px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex w-full items-center justify-between", "tablet:absolute tablet:-top-[360px] tablet:flex-col tablet:items-start"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-[12px] [--icon-color:var(--color-blue-700)]",
                                children: [
                                    (0,_history_popup__WEBPACK_IMPORTED_MODULE_17__/* .transformToolToIcon */ .eA)(tool),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(" text-[18px] font-[500] leading-[19px] tracking-[0.36px] text-blue-700", "tablet:text-blue-700"),
                                        children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_17__/* .transformTool */ .L2)(tool)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("text-[14px] font-[500] leading-[26px] tracking-[0.28px] text-blue-400"),
                                children: (0,_history_popup__WEBPACK_IMPORTED_MODULE_17__/* .formatTimes */ .Nf)(createdAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col",
                        children: customPrompt !== null && customPrompt.trim().length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex justify-between gap-[8px] desktop:hidden", "relative rounded-[5px] bg-color-background pl-[12px] pr-[5px]", "max-h-[177px] overflow-hidden"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("text-[13px] font-400 leading-[22px] tracking-[0.32px] text-blue-800", "cursor-text -tracking-[0.5px] tablet:max-h-[130px]", "no-scrollbar overflow-y-scroll desktop:max-h-[175px]"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("py-[9px] pr-[45px] font-mono"),
                                        children: customPrompt
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " absolute right-4 top-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("relative h-8 w-8 shrink-0 cursor-pointer transition-colors", "group flex items-center justify-center rounded-[4px] hover:bg-blue-200"),
                                        onClick: handleCopyText,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_21__/* .assetUrl */ .p)("/ai-tools/history/copy.svg"),
                                                alt: "copy",
                                                className: "h-[20px] w-[20px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute -bottom-7 opacity-0 hover:opacity-0 group-hover:opacity-100", "rounded-[4px] px-3 py-1", "bg-color-tooltip transition-all", "text-xs font-500 text-blue-900"),
                                                children: t("txt_copy")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            (keywords.isFetching || keywords.isSuccess && ((ref = keywords.data) === null || ref === void 0 ? void 0 : ref.length) !== 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col gap-3 desktop:w-[1175px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[22px] font-500 tracking-normal text-blue-700",
                        children: t("txt_related_keywords")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "no-scrollbar flex h-[36px] w-full shrink-0 flex-row gap-[10px] overflow-x-scroll",
                        children: [
                            keywords.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_13__/* .SuggestionsSkeleton */ .HI, {}),
                            keywords.isSuccess && keywords.data.map(function(keyword) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/ai-gallery/".concat(keyword),
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex h-full shrink-0 flex-row items-center justify-center gap-[6px] rounded-[6px]", "bg-color-background p-3 tablet:bg-color-background desktop:bg-color-cell", "text-[13px] font-400 tracking-wider text-blue-700 [--icon-color:var(--color-blue-600)]"),
                                    children: keyword
                                }, keyword);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full flex-col gap-[14px] pb-[40px] desktop:w-[1175px]",
                children: [
                    relatedArt.isSuccess && relatedArt.data.length !== 0 && !relatedArt.isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[20px] font-500 tracking-normal text-blue-700",
                        children: t("txt_relevant_art")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__/* .ResponsiveMasonry */ .G, {
                        columnsCountBreakPoints: {
                            1: 3,
                            760: 4,
                            1280: 5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_responsive_masonry__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            gutter: "10px",
                            children: [
                                relatedArt.isFetching && sections_gallery_single_gallery__WEBPACK_IMPORTED_MODULE_15__/* .skeletonList.map */ .ju.map(function(height, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            height: height
                                        },
                                        className: "w-[full] overflow-hidden rounded-[12px] desktop:rounded-[14px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_4__/* .SizedSkeleton */ .xB, {
                                            className: "h-full w-full"
                                        })
                                    }, index);
                                }),
                                relatedArt.isSuccess && relatedArt.data.map(function(single, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleGenerated, {
                                            entity: single
                                        })
                                    }, "item-".concat(single.id));
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModelMobileCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2404);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2213);
/* harmony import */ var pages_models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);







function ModelMobileCard() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("object"), mobileState = ref[0], setMobileState = ref[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var timer = setTimeout(function() {
            if (mobileState === "object") {
                setMobileState("perfume");
            } else if (mobileState === "perfume") {
                setMobileState("person");
            } else {
                setMobileState("object");
            }
        }, 5000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        mobileState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex h-full flex-col items-center justify-center desktop:hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pages_models__WEBPACK_IMPORTED_MODULE_3__.backgroundGradient, "flex h-[70px] w-full justify-center pt-[19px] tablet:h-[80px] tablet:pt-[22px]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-[24px] font-700 text-blue-800",
                    children: t("txt_models")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("flex w-full flex-col items-center gap-[13px] pb-[60px] pt-[67px] tablet:gap-[23px] tablet:pt-[113px]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative flex w-full items-center justify-center gap-[8px] py-[8px] tablet:gap-[13px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-icon-overt.svg"),
                                alt: "model icon",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("absolute -top-[17px] left-1/2 -translate-x-1/2 tablet:-top-[30px] tablet:h-[34px] tablet:w-[34px]", "h-[20px] w-[20px]")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/cut-border.svg"),
                                alt: "border",
                                className: " absolute left-1/2 top-0 h-[56px] w-[204px] -translate-x-1/2 tablet:h-[97px] tablet:w-[353px]"
                            }),
                            new Array(4).fill(null).map(function(_, index) {
                                switch(mobileState){
                                    case "object":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/shoose-model-".concat(index, ".svg")),
                                            alt: "shoose model",
                                            className: "h-[40px] w-[40px] tablet:h-[70px] tablet:w-[70px]"
                                        }, index);
                                    case "person":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-person-".concat(index, ".svg")),
                                            alt: "shoose model",
                                            className: "h-[40px] w-[40px] tablet:h-[70px] tablet:w-[70px]"
                                        }, index);
                                    case "perfume":
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-object-".concat(index, ".svg")),
                                            alt: "shoose model",
                                            className: "h-[40px] w-[40px] tablet:h-[70px] tablet:w-[70px]"
                                        }, index);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: mobileState === "object" ? (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-object.svg?aaa") : mobileState === "person" ? (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-person.svg?aaa") : (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-perfume.svg?aaa"),
                        alt: "model object",
                        className: "h-[174px] w-[184px] rounded-[6.64px] transition-all tablet:h-[301px] tablet:w-[318px] tablet:rounded-[11.5px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start gap-[24px] pt-[33px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center gap-[8px] transition-all",
                                children: mobileState === "person" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/person-icon-solid.svg"),
                                            alt: "person icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-1 w-1 rounded-full bg-blue-600"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/person-icon.svg"),
                                    alt: "person icon",
                                    className: "h-[20px] w-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center gap-[8px]",
                                children: mobileState === "object" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/object-icon-solid.svg"),
                                            alt: "object icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-1 w-1 rounded-full bg-blue-600"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/object-icon.svg"),
                                    alt: "object icon",
                                    className: "h-[20px] w-[20px]"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center gap-[8px]",
                                children: mobileState === "perfume" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/perfume-icon-solid.svg"),
                                            alt: "person icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-1 w-1 rounded-full bg-blue-600"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/perfume-icon.svg"),
                                    alt: "person icon",
                                    className: "h-[20px] w-[20px]"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center gap-[16px] px-[32px] pt-[60px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "max-w-[470px] text-center text-[13px] font-400 text-color-placeholder tablet:max-w-[525px] tablet:text-[18px]",
                                children: t("txt_model_mobile_dec")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: _utils_branch__WEBPACK_IMPORTED_MODULE_1__/* .appStoreConstant */ .HY,
                                className: "flex w-full max-w-[413px] items-center justify-center rounded-[24px] bg-primary-500 py-[14px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-[4px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_6__/* .assetUrl */ .p)("/general/model-plus-white.svg"),
                                            alt: "model pluse icon"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[16px] font-600 text-color-white",
                                            children: t("lbl_train_model")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xF": function() { return /* binding */ AdjustProvider; },
  "kV": function() { return /* binding */ PAYMENT_DATA_KEY; },
  "rs": function() { return /* binding */ UsePageViewEvent; },
  "eW": function() { return /* binding */ useAdjustLogger; }
});

// UNUSED EXPORTS: paymentSessionDataSchema

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/esm/index.esm.js
var esm_index_esm = __webpack_require__(3977);
;// CONCATENATED MODULE: ./utils/firebase.ts

if (false) {}
if (false) {}
if (false) {}
if (false) {}
if (false) {}
if (false) {}
if (false) {}
if (false) {}
var apiKey = "AIzaSyB_FQRFDbEDmM8-SiB2Tx7cvo05ScZv-74";
var authDomain = "zoomerang.club";
var databaseURL = "https://zoomerang-dcf49.firebaseio.com";
var projectId = "zoomerang-dcf49";
var storageBucket = "zoomerang-dcf49.appspot.com";
var messagingSenderId = "478172087871";
var appId = "1:478172087871:web:d058c3ede814459bd81a8a";
var measurementId = "G-ZYG6W3P823";
var firebaseConfig = {
    apiKey: apiKey,
    authDomain: authDomain,
    databaseURL: databaseURL,
    projectId: projectId,
    storageBucket: storageBucket,
    messagingSenderId: messagingSenderId,
    appId: appId,
    measurementId: measurementId
};
var app = (0,esm_index_esm/* initializeApp */.ZF)(firebaseConfig);

;// CONCATENATED MODULE: ./utils/adjust.tsx
/* provided dependency */ var process = __webpack_require__(3454);














var FACEBOOK_PIXEL_TOKEN = "303692382241884";
var paymentSessionDataSchema = lib.z.object({
    session: lib.z.string(),
    currency: lib.z.string(),
    value: lib.z.number()
});
var PAYMENT_DATA_KEY = "payment_data";
function UsePageViewEvent() {
    var logAdjust = useAdjustLogger();
    var id = (0,react.useMemo)(function() {
        return (0,v4/* default */.Z)();
    }, []);
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    var ref = (0,client_auth/* default */.ZP)(), userInfo = ref.userInfo, setUserInfo = ref.setUserInfo;
    // useEffect(() => {
    //   if (logAdjust === null) return
    //   logAdjust.logEventWithPayload(
    //     "page_view",
    //     { from: router.asPath },
    //     id,
    //   )
    // }, [logAdjust, id, router.asPath])
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (!logAdjust) return;
        if (!userInfo) return;
        var handleRouteChange = function() {
            logAdjust.logEvent("view_content");
        };
        if (router.query.monthly === "success" || router.query.yearly === "success") {
            var isMonthly = router.query.monthly === "success";
            try {
                var purchaseData = localStorage.getItem(PAYMENT_DATA_KEY);
                if (!purchaseData) {
                    return;
                }
                var ref = paymentSessionDataSchema.parse(JSON.parse(purchaseData)), session = ref.session, currency = ref.currency, value = ref.value;
                if (session !== router.query.session) {
                    return;
                }
                (0,client_auth/* forceRefreshToken */.EF)().then(function(userInfo) {
                    return setUserInfo(userInfo);
                }).catch(function(error) {
                    return console.error("Could not get new token", error);
                });
                logAdjust.logEventWithPayload("w_upgrade_success", {
                    from: router.asPath
                });
                logAdjust.registerSubscription(value, currency, isMonthly ? "monthly" : "yearly");
                localStorage.removeItem(PAYMENT_DATA_KEY);
            } catch (e) {
                console.error(e);
            }
        } else if (router.query.monthly === "cancel" || router.query.yearly === "cancel") {
            logAdjust.logEventWithPayload("w_upgrade_canceled", {
                from: router.asPath
            });
        }
        if (router.query.coins === "success") {
            queryClient.invalidateQueries("coins");
            try {
                var purchaseData1 = localStorage.getItem(PAYMENT_DATA_KEY);
                if (!purchaseData1) {
                    return;
                }
                var ref1 = paymentSessionDataSchema.parse(JSON.parse(purchaseData1)), session1 = ref1.session, currency1 = ref1.currency, value1 = ref1.value;
                if (session1 !== router.query.session) {
                    return;
                }
                logAdjust.logEvent("non_subscription_purchase");
                logAdjust.registerPurchase(value1, currency1);
                logAdjust.logEvent("non_subscription_purchase");
                localStorage.removeItem(PAYMENT_DATA_KEY);
            } catch (e1) {
                console.error(e1);
            }
        }
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            return router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        id,
        logAdjust,
        queryClient,
        router,
        setUserInfo,
        userInfo, 
    ]);
    (0,react.useEffect)(function() {
        if (!logAdjust) return;
        var elements = (0,_to_consumable_array/* default */.Z)(document.querySelectorAll('a[href^="'.concat(branch/* appStoreConstant */.HY, '"]')));
        var handleAppStoreClick = function() {
            logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("appstore_icons");
        };
        elements.forEach(function(element) {
            return element.addEventListener("click", handleAppStoreClick);
        });
        return function() {
            return elements.forEach(function(element) {
                return element.removeEventListener("click", handleAppStoreClick);
            });
        };
    }, [
        id,
        logAdjust
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
var subscriptionMap = {
    monthly: {
        ltv: 1.8,
        event: "StartTrial"
    },
    yearly: {
        ltv: 1.3,
        event: "Subscribe"
    }
};
var AdjustContext = /*#__PURE__*/ (0,react.createContext)(null);
function AdjustProvider(param) {
    var children = param.children;
    var ref = (0,react.useState)(null), adjust = ref[0], setAdjust = ref[1];
    (0,react.useEffect)(function() {
        var firebaseAnalytics = (0,index_esm/* getAnalytics */.IH)();
        Promise.all([
            __webpack_require__.e(/* import() */ 1767).then(__webpack_require__.t.bind(__webpack_require__, 1767, 23)),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            __webpack_require__.e(/* import() */ 1200).then(__webpack_require__.bind(__webpack_require__, 1200)),
            __webpack_require__.e(/* import() */ 5535).then(__webpack_require__.bind(__webpack_require__, 5535)), 
        ]).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 3), importedPixel = _param[0], googleTagManager = _param[1], Analytics = _param[2];
            var googleTagManagerWrapper = Analytics.default({
                app: "Zoomerang",
                plugins: [
                    googleTagManager.default({
                        containerId: "GTM-T34Q5RX3"
                    }), 
                ]
            });
            var isDebug = process.env.NEXT_PUBLIC_DEBUG === "true";
            importedPixel.default.init(FACEBOOK_PIXEL_TOKEN, undefined, {
                debug: isDebug,
                autoConfig: true
            });
            function logEventWithPayload(event, payload) {
                return _logEventWithPayload.apply(this, arguments);
            }
            function _logEventWithPayload() {
                _logEventWithPayload = (0,_async_to_generator/* default */.Z)(function(event, payload) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        try {
                            importedPixel.default.trackCustom(event, payload);
                            googleTagManagerWrapper.track(event, payload);
                            (0,index_esm/* logEvent */.Kz)(firebaseAnalytics, String(event), payload);
                        } catch (error) {
                            console.error("Analytics Error", error);
                        }
                        return [
                            2
                        ];
                    });
                });
                return _logEventWithPayload.apply(this, arguments);
            }
            setAdjust({
                registerSubscription: function registerSubscription(value, currency, subscription) {
                    var _subscription = subscriptionMap[subscription], ltv = _subscription.ltv, event = _subscription.event;
                    try {
                        importedPixel.default.track(event, {
                            value: value,
                            currency: currency,
                            predicted_ltv: ltv
                        });
                        googleTagManagerWrapper.track(subscription + "_subscribe", {
                            value: value,
                            currency: currency,
                            predicted_ltv: ltv
                        });
                    } catch (e) {
                        console.error(e);
                    }
                },
                registerPurchase: function registerPurchase(value, currency) {
                    try {
                        importedPixel.default.track("Purchase", {
                            value: value,
                            currency: currency
                        });
                        googleTagManagerWrapper.track("non_subscription_purchase", {
                            value: value,
                            currency: currency
                        });
                    } catch (e) {
                        console.error(e);
                    }
                },
                logEvent: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            logEventWithPayload(event, undefined);
                            return [
                                2
                            ];
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                logEventWithPayload: logEventWithPayload
            });
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdjustContext.Provider, {
        value: adjust,
        children: children
    });
}
function useAdjustLogger() {
    return (0,react.useContext)(AdjustContext);
}


/***/ }),

/***/ 2404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AF": function() { return /* binding */ createAppLink; },
/* harmony export */   "Co": function() { return /* binding */ snapchatLink; },
/* harmony export */   "H2": function() { return /* binding */ playStoreConstant; },
/* harmony export */   "HY": function() { return /* binding */ appStoreConstant; },
/* harmony export */   "Ke": function() { return /* binding */ youtubeLink; },
/* harmony export */   "Pn": function() { return /* binding */ tiktokLink; },
/* harmony export */   "RJ": function() { return /* binding */ pinterestLink; },
/* harmony export */   "T4": function() { return /* binding */ discordLink; },
/* harmony export */   "WW": function() { return /* binding */ instagramLink; },
/* harmony export */   "xI": function() { return /* binding */ appStoreFallback; },
/* harmony export */   "yK": function() { return /* binding */ facebookLink; }
/* harmony export */ });
/* unused harmony export inAppFallback */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7582);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);




var appStoreFallback = "https://link.zoomerang.app/QnOr3F3HXvb";
var appStoreConstant = "https://link.zoomerang.app/00obnVZRXvb";
var playStoreConstant = "https://link.zoomerang.app/PMvbFm5RXvb";
var inAppFallback = "https://link.zoomerang.app/NRGfjXcIXvb";
var snapchatLink = "https://www.snapchat.com/add/zoomerang.app";
var facebookLink = "https://www.facebook.com/zoomerangapp/";
var pinterestLink = "https://www.pinterest.com/Zoomerang_App/";
var youtubeLink = "https://www.youtube.com/@Zoomerang";
var tiktokLink = "https://www.tiktok.com/@zoomerang_app";
var instagramLink = "https://www.instagram.com/zoomerang.app";
var discordLink = "https://discord.gg/hueHW8zK2r";
var useBranchRedirect = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref = props || {}, fallback = ref.fallback, users = ref.users, templates = ref.templates;
    var handleLink = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(error, session) {
        if (error || !session) {
            if (fallback) router.replace(fallback);
            return;
        }
        var data = session.data_parsed;
        if (templates) {
            if (data["~feature"] === "tutorial") return router.replace("/template/" + data.tutorial);
        }
        if (data["~feature"] === "ai_art") return router.replace("/ai-gallery/single/" + data.ai_art_id);
        if (data["~feature"] === "video_gpt") return router.replace("/ad-examples/single/" + data.video_gpt.id);
        if (users) {
            if (data["~feature"] === "share") return router.replace(appStoreConstant);
        }
        if (data["~feature"] === undefined) {
            if (fallback) router.replace(fallback);
            return;
        }
    }, [
        templates,
        users,
        fallback,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        __webpack_require__.e(/* import() */ 7860).then(__webpack_require__.t.bind(__webpack_require__, 7860, 23)).then(function(branch) {
            branch.default.init("key_live_ggK8hAqEyb3ZM2MZ0eR8sogkvAhgOWXD" || 0, {}, handleLink);
        });
    }, [
        handleLink
    ]);
};
var createAppLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(uid) {
        var branch, branchKey, linkData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (false) {}
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 7860).then(__webpack_require__.t.bind(__webpack_require__, 7860, 23))
                    ];
                case 1:
                    branch = _state.sent();
                    branchKey = "key_live_ggK8hAqEyb3ZM2MZ0eR8sogkvAhgOWXD";
                    if (!branchKey) {
                        throw new Error("Branch SDK key is missing. Ensure it is set in environment variables.");
                    }
                    branch.default.init(branchKey, {}, function(err) {
                        if (err) {
                            console.error("Branch SDK initialization error:", err);
                            throw err;
                        }
                    });
                    linkData = {
                        data: {
                            uid: uid
                        },
                        feature: "user_profile"
                    };
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            branch.default.link(linkData, function(error, link) {
                                if (error) {
                                    console.error("Error creating link:", error);
                                    reject(error);
                                } else {
                                    resolve(link);
                                }
                            });
                        })
                    ];
            }
        });
    });
    return function createAppLink(uid) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = (useBranchRedirect);


/***/ }),

/***/ 1156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ Device; },
/* harmony export */   "BV": function() { return /* binding */ useDeviceSize; },
/* harmony export */   "Hb": function() { return /* binding */ devices; },
/* harmony export */   "Hi": function() { return /* binding */ Desktop; },
/* harmony export */   "Vi": function() { return /* binding */ TabletOrMobile; },
/* harmony export */   "X$": function() { return /* binding */ onDesktop; },
/* harmony export */   "YD": function() { return /* binding */ Tablet; },
/* harmony export */   "ij": function() { return /* binding */ Mobile; },
/* harmony export */   "lS": function() { return /* binding */ DesktopOrTablet; },
/* harmony export */   "pX": function() { return /* binding */ onTablet; },
/* harmony export */   "tz": function() { return /* binding */ wrapped; }
/* harmony export */ });
/* unused harmony export breakpoints */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (max-width: ",
        "px) {\n		display: none !important;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (max-width: ",
        "px),\n		(min-width: ",
        "px) {\n		display: none !important;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (min-width: ",
        "px) {\n		display: none !important;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (min-width: ",
        "px) {\n		display: none !important;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (max-width: ",
        "px) {\n		display: none !important;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (min-width: ",
        "px) {\n		",
        "\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (min-width: ",
        "px) {\n		",
        "\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media ",
        " {\n		width: 728px;\n	}\n\n	@media ",
        " {\n		width: 1175px;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var breakpoints = {
    desktop: 1224,
    tablet: 768
};
var Device;
(function(Device) {
    Device["Desktop"] = "desktop";
    Device["Tablet"] = "tablet";
    Device["Mobile"] = "mobile";
})(Device || (Device = {}));
var useDeviceSize = function() {
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        query: "(min-width: ".concat(breakpoints.desktop, "px)")
    });
    var isTablet = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        query: "(min-width: ".concat(breakpoints.tablet, "px)")
    });
    if (isDesktop) return Device.Desktop;
    if (isTablet) return Device.Tablet;
    return Device.Mobile;
};
var Desktop = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f0d90958-0"
})(_templateObject(), breakpoints.desktop - 1);
var Tablet = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f0d90958-1"
})(_templateObject1(), breakpoints.tablet - 1, breakpoints.desktop);
var Mobile = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f0d90958-2"
})(_templateObject2(), breakpoints.tablet);
var TabletOrMobile = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f0d90958-3"
})(_templateObject3(), breakpoints.desktop);
var DesktopOrTablet = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f0d90958-4"
})(_templateObject4(), breakpoints.tablet - 1);
var onDesktop = function(style) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), breakpoints.desktop, style);
};
var onTablet = function(style) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), breakpoints.tablet, style);
};
var devices = {
    tablet: "(min-width: ".concat(breakpoints.tablet, "px)"),
    desktop: "(min-width: ".concat(breakpoints.desktop, "px)")
};
var wrapped = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7(), devices.tablet, devices.desktop);


/***/ }),

/***/ 177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HEADER_WEB_VERSION; },
/* harmony export */   "p": function() { return /* binding */ assetUrl; }
/* harmony export */ });
var assetUrl = function(source) {
    var cdnUrl = "https://filesw.zoomerang.info/Web" || 0;
    return cdnUrl + source;
};
var HEADER_WEB_VERSION = 4;


/***/ }),

/***/ 1816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EF": function() { return /* binding */ forceRefreshToken; },
/* harmony export */   "K6": function() { return /* binding */ useClientAuth; },
/* harmony export */   "Sf": function() { return /* binding */ useAuthUpdater; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; },
/* harmony export */   "oO": function() { return /* binding */ SSRAuthProvider; },
/* harmony export */   "s5": function() { return /* binding */ ClientSideAuthProvider; },
/* harmony export */   "xx": function() { return /* binding */ getUserEntitlements; },
/* harmony export */   "zn": function() { return /* binding */ logInWithUserCredential; }
/* harmony export */ });
/* unused harmony exports AUTH_COOKIE_KEY, cookieUserInfoSchema, refreshTokenResponseSchema, customTokenResponseSchema, tokenResponseSchema, claimsSchema, deserializeUserInfo, SSRAuthContext, applyUserCredentials, serializeUserInfo, getRegionClient, userInfoFromUserCredential, AuthPopupStateContext, AuthPopupStateProvider */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6154);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6489);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4367);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1604);
/* harmony import */ var _maxcookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8322);
/* harmony import */ var _utm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3852);













var AUTH_COOKIE_KEY = "_zoom_auth";
function getUserEntitlements(entitlements) {
    var isPro = entitlements.includes("pro");
    var hasConcurrentJobs = entitlements.includes("ai_concurrent_jobs");
    var isCoinFree = entitlements.includes("ai_coin_free");
    var isAdvanced = entitlements.includes("plan_advanced_10");
    return {
        isPro: isPro,
        hasConcurrentJobs: hasConcurrentJobs,
        isCoinFree: isCoinFree,
        isAdvanced: isAdvanced
    };
}
var cookieUserInfoSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    accessToken: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    refreshToken: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    expiresAt: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    issuedAt: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    userId: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    entitlements: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    isAnonymous: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    details: zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
        username: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().optional(),
        promptOnboarding: zod__WEBPACK_IMPORTED_MODULE_7__.z.boolean().optional(),
        profilePic: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().nullable().optional(),
        fullName: zod__WEBPACK_IMPORTED_MODULE_7__.z.string().optional()
    }).default({})
});
var refreshTokenResponseSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    access_token: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    expires_in: zod__WEBPACK_IMPORTED_MODULE_7__.z.coerce.number(),
    token_type: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal("Bearer"),
    refresh_token: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    user_id: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
});
var customTokenResponseSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    idToken: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    refreshToken: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    expiresIn: zod__WEBPACK_IMPORTED_MODULE_7__.z.coerce.number()
});
var tokenResponseSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    status: zod__WEBPACK_IMPORTED_MODULE_7__.z.literal(true),
    result: zod__WEBPACK_IMPORTED_MODULE_7__.z.string(),
    uid: zod__WEBPACK_IMPORTED_MODULE_7__.z.string()
});
var claimsSchema = zod__WEBPACK_IMPORTED_MODULE_7__.z.object({
    revenueCatEntitlements: zod__WEBPACK_IMPORTED_MODULE_7__.z.array(zod__WEBPACK_IMPORTED_MODULE_7__.z.string()).optional(),
    is_anonymous: zod__WEBPACK_IMPORTED_MODULE_7__.z.boolean().optional()
});
function forceRefreshToken() {
    return _forceRefreshToken.apply(this, arguments);
}
function _forceRefreshToken() {
    _forceRefreshToken = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].post */ .Z.post("/api/auth-refresh").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _forceRefreshToken.apply(this, arguments);
}
function deserializeUserInfo(info, details) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, info), {
        issuedAt: new Date(info.issuedAt).toISOString(),
        expiresAt: new Date(info.expiresAt).toISOString(),
        entitlements: info.entitlements.split(",").filter(Boolean),
        isAnonymous: info.isAnonymous === "true",
        details: details
    });
}
var SSRAuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)({
    userInfo: null,
    setUserInfo: function setUserInfo() {
        throw new Error("Provider not used");
    }
});
function SSRAuthProvider(props) {
    var originalUserInfo = props.userInfo, children = props.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(originalUserInfo), userInfo = ref[0], setUserInfo = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SSRAuthContext.Provider, {
        value: {
            userInfo: userInfo,
            setUserInfo: setUserInfo
        },
        children: children
    });
}
var ClientSideAuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)({
    userInfo: null,
    setUserInfo: function() {
        throw new Error("Not used");
    }
});
function getUserDetailsClient(userId, accessToken) {
    return _getUserDetailsClient.apply(this, arguments);
}
function _getUserDetailsClient() {
    _getUserDetailsClient = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(userId, accessToken) {
        var info;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get("/api/user-short-uid?uid=".concat(userId), {
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        }).then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    info = _state.sent();
                    if (info.promptOnboarding === undefined) {
                        throw new Error();
                    }
                    return [
                        2,
                        {
                            profilePic: info.picture,
                            promptOnboarding: info.promptOnboarding,
                            username: info.username,
                            fullName: info.name
                        }
                    ];
            }
        });
    });
    return _getUserDetailsClient.apply(this, arguments);
}
function ClientSideAuthProvider(props) {
    var children = props.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), userInfo = ref[0], setUserInfo = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        function findAuth() {
            return _findAuth.apply(this, arguments);
        }
        function _findAuth() {
            _findAuth = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                var cookies, userCookies, userObject, cookieUserInfo, details, newUserInfo, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            cookies = (0,cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q)(document.cookie);
                            userCookies = cookies[AUTH_COOKIE_KEY];
                            userObject = JSON.parse(userCookies);
                            cookieUserInfo = cookieUserInfoSchema.parse(userObject);
                            return [
                                4,
                                getUserDetailsClient(cookieUserInfo.userId, cookieUserInfo.accessToken)
                            ];
                        case 1:
                            details = _state.sent();
                            newUserInfo = deserializeUserInfo(cookieUserInfo, details);
                            setUserInfo(newUserInfo);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _findAuth.apply(this, arguments);
        }
        findAuth();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClientSideAuthContext.Provider, {
        value: {
            userInfo: userInfo,
            setUserInfo: setUserInfo
        },
        children: children
    });
}
function useAuth() {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(SSRAuthContext);
}
function useClientAuth() {
    var ssrState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(SSRAuthContext);
    var clientState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(ClientSideAuthContext);
    if (ssrState.userInfo === null) {
        return clientState;
    }
    return ssrState;
}
function applyUserCredentials(cred) {
    return _applyUserCredentials.apply(this, arguments);
}
function _applyUserCredentials() {
    _applyUserCredentials = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(cred) {
        var userInfo, serialized;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        userInfoFromUserCredential(cred)
                    ];
                case 1:
                    userInfo = _state.sent();
                    serialized = serializeUserInfo(userInfo);
                    (0,_maxcookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(AUTH_COOKIE_KEY, JSON.stringify(serialized));
                    return [
                        2,
                        userInfo
                    ];
            }
        });
    });
    return _applyUserCredentials.apply(this, arguments);
}
function serializeUserInfo(info) {
    return {
        accessToken: info.accessToken,
        refreshToken: info.refreshToken,
        expiresAt: info.expiresAt.toString(),
        issuedAt: info.issuedAt.toString(),
        userId: info.userId,
        entitlements: info.entitlements.join(","),
        isAnonymous: String(info.isAnonymous),
        details: info.details
    };
}
var getRegionClient = function() {
    var ref;
    return (ref = navigator.language.split("-")[1]) !== null && ref !== void 0 ? ref : "US";
};
function userInfoFromUserCredential(cred) {
    return _userInfoFromUserCredential.apply(this, arguments);
}
function _userInfoFromUserCredential() {
    _userInfoFromUserCredential = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(cred) {
        var refreshToken, userId, decodedToken, accessToken, expiresAt, issuedAt, parsedEntitlements, _revenueCatEntitlements, entitlements, _is_anonymous, isAnonymous, utm, userData, details;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    refreshToken = cred.user.refreshToken;
                    userId = cred.user.uid;
                    return [
                        4,
                        cred.user.getIdTokenResult()
                    ];
                case 1:
                    decodedToken = _state.sent();
                    accessToken = decodedToken.token;
                    expiresAt = new Date(decodedToken.expirationTime).toISOString();
                    issuedAt = new Date(decodedToken.issuedAtTime).toISOString();
                    parsedEntitlements = claimsSchema.parse(decodedToken.claims);
                    entitlements = (_revenueCatEntitlements = parsedEntitlements.revenueCatEntitlements) !== null && _revenueCatEntitlements !== void 0 ? _revenueCatEntitlements : [];
                    isAnonymous = (_is_anonymous = parsedEntitlements.is_anonymous) !== null && _is_anonymous !== void 0 ? _is_anonymous : false;
                    utm = (0,_utm__WEBPACK_IMPORTED_MODULE_6__/* .getUtmIds */ .b)();
                    userData = {
                        uid: userId,
                        agent: navigator.userAgent,
                        region: getRegionClient(),
                        device: userId,
                        token: "Bearer ".concat(accessToken),
                        is_anonymous: isAnonymous,
                        utm: utm
                    };
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].put */ .Z.put("/api/user-auth", userData).catch(console.error)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        getUserDetailsClient(userId, accessToken)
                    ];
                case 3:
                    details = _state.sent();
                    return [
                        2,
                        {
                            refreshToken: refreshToken,
                            accessToken: accessToken,
                            userId: userId,
                            expiresAt: expiresAt,
                            issuedAt: issuedAt,
                            isAnonymous: isAnonymous,
                            entitlements: entitlements,
                            details: details
                        }
                    ];
            }
        });
    });
    return _userInfoFromUserCredential.apply(this, arguments);
}
function logInWithUserCredential(cred) {
    return _logInWithUserCredential.apply(this, arguments);
}
function _logInWithUserCredential() {
    _logInWithUserCredential = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(cred) {
        var userInfo;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)().signOut()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        applyUserCredentials(cred)
                    ];
                case 2:
                    userInfo = _state.sent();
                    return [
                        2,
                        userInfo
                    ];
            }
        });
    });
    return _logInWithUserCredential.apply(this, arguments);
}
var sensitivePaths = [
    {
        path: "/profile/generations",
        action: "redirect",
        target: "/"
    },
    {
        path: "/models",
        action: "redirect",
        target: "/tools/ai-photoshoot-generator"
    },
    {
        path: "/tools",
        action: "refresh"
    }, 
];
function useAuthUpdater() {
    var setUserInfo = useClientAuth().setUserInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onUserChange = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(_) {
        var sensitivePath = sensitivePaths.find(function(page) {
            return router.asPath.startsWith(page.path);
        });
        if (!sensitivePath) {
            return;
        }
        switch(sensitivePath.action){
            case "redirect":
                router.push(sensitivePath.target);
                break;
            case "refresh":
                router.reload();
                break;
        }
    }, [
        router
    ]);
    var logOut = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var info;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].post */ .Z.post("/api/auth-logout").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    info = _state.sent();
                    setUserInfo(info);
                    onUserChange(info);
                    return [
                        2
                    ];
            }
        });
    }), [
        onUserChange,
        setUserInfo
    ]);
    var logInWithEmailAndPassword = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(email, password) {
            var auth, cred, info;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .signInWithEmailAndPassword */ .e5)(auth, email, password)
                        ];
                    case 1:
                        cred = _state.sent();
                        return [
                            4,
                            logInWithUserCredential(cred)
                        ];
                    case 2:
                        info = _state.sent();
                        setUserInfo(info);
                        onUserChange(info);
                        return [
                            2,
                            info
                        ];
                }
            });
        });
        return function(email, password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onUserChange,
        setUserInfo
    ]);
    var logInWithProvider = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(credential) {
            var auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .signInWithRedirect */ .F6)(auth, credential);
                return [
                    2
                ];
            });
        // const cred = await signInWithPopup(auth, credential)
        // const info = await logInWithUserCredential(cred)
        // setUserInfo(info)
        // onUserChange(info)
        // return { userInfo: info, email: cred.user.email }
        });
        return function(credential) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var logInWithCredential = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(credentialString) {
            var credential, cred, info;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        credential = firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .GoogleAuthProvider.credential */ .hJ.credential(credentialString);
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .signInWithCredential */ .sB)((0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)(), credential)
                        ];
                    case 1:
                        cred = _state.sent();
                        return [
                            4,
                            logInWithUserCredential(cred)
                        ];
                    case 2:
                        info = _state.sent();
                        setUserInfo(info);
                        onUserChange(info);
                        return [
                            2,
                            info
                        ];
                }
            });
        });
        return function(credentialString) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onUserChange,
        setUserInfo
    ]);
    var sendPasswordResetEmail = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(email) {
            var auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .sendPasswordResetEmail */ .LS)(auth, email)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var createUserWithEmailAndPassword = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(email, password) {
            var auth, cred, info;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .createUserWithEmailAndPassword */ .Xb)(auth, email, password)
                        ];
                    case 1:
                        cred = _state.sent();
                        return [
                            4,
                            applyUserCredentials(cred)
                        ];
                    case 2:
                        info = _state.sent();
                        setUserInfo(info);
                        onUserChange(info);
                        return [
                            2,
                            info
                        ];
                }
            });
        });
        return function(email, password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onUserChange,
        setUserInfo
    ]);
    var verifyPasswordResetCode = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(oobCode) {
            var auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .verifyPasswordResetCode */ .TX)(auth, oobCode).then(function(res) {
                                return res;
                            }).catch(function(_) {
                                return null;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(oobCode) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var confirmPasswordReset = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(oobCode, newPassword) {
            var auth;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .getAuth */ .v0)();
                        return [
                            4,
                            (0,firebase_auth__WEBPACK_IMPORTED_MODULE_2__/* .confirmPasswordReset */ .LG)(auth, oobCode, newPassword).then(function(_) {
                                return true;
                            }).catch(function(_) {
                                return false;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(oobCode, newPassword) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        logOut: logOut,
        logInWithEmailAndPassword: logInWithEmailAndPassword,
        logInWithProvider: logInWithProvider,
        sendPasswordResetEmail: sendPasswordResetEmail,
        createUserWithEmailAndPassword: createUserWithEmailAndPassword,
        logInWithCredential: logInWithCredential,
        verifyPasswordResetCode: verifyPasswordResetCode,
        confirmPasswordReset: confirmPasswordReset
    };
}
var AuthPopupStateContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(null)));
function AuthPopupStateProvider(props) {
    var children = props.children;
    var ref = useState(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ _jsx(AuthPopupStateContext.Provider, {
        value: {
            open: open,
            setOpen: setOpen
        },
        children: children
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (useAuth);


/***/ }),

/***/ 279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ useCoinsPopup; },
/* harmony export */   "YO": function() { return /* binding */ useCoins; },
/* harmony export */   "_k": function() { return /* binding */ CoinsProvider; }
/* harmony export */ });
/* unused harmony export CoinsContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9034);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4165);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8767);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7632);
/* harmony import */ var _adjust__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6254);
/* harmony import */ var _cdn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(177);
/* harmony import */ var _client_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1816);
/* harmony import */ var _login_redirect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7592);
/* harmony import */ var _notification__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4371);




















var CoinsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)({
    wallet: null,
    openPopup: function(minimumCoins) {
        return {};
    }
});
function fetchCoins() {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("/api/wallet-balance").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function CoinsProvider(props) {
    var ref;
    var children = props.children;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(undefined), minimum = ref2[0], setMinimum = ref2[1];
    var userInfo = (0,_client_auth__WEBPACK_IMPORTED_MODULE_8__/* .useClientAuth */ .K6)().userInfo;
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)({
        queryKey: [
            "coins",
            "user",
            userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId
        ],
        queryFn: fetchCoins(),
        enabled: userInfo !== null && !userInfo.isAnonymous
    });
    var _data, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CoinsContext.Provider, {
        value: {
            wallet: (_data = query.data) !== null && _data !== void 0 ? _data : null,
            openPopup: function(minimumCoins) {
                setMinimum(minimumCoins);
                setIsOpen(true);
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CoinsPopup, {
                minimumCoins: minimum,
                coins: (ref3 = (ref = query.data) === null || ref === void 0 ? void 0 : ref.coins) !== null && ref3 !== void 0 ? ref3 : 0,
                open: isOpen,
                setOpen: setIsOpen
            }),
            children
        ]
    });
}
function useCoins() {
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(CoinsContext).wallet;
}
function useCoinsPopup() {
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(CoinsContext).openPopup;
}
function fetchPrices() {
    return _fetchPrices.apply(this, arguments);
}
function _fetchPrices() {
    _fetchPrices = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("/api/payment-coin-packs").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _fetchPrices.apply(this, arguments);
}
function CoinsPopup(props) {
    var ref;
    var open = props.open, setOpen = props.setOpen, coins = props.coins, minimumCoins = props.minimumCoins;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), selected = ref1[0], setSelected = ref1[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common").t;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isProcessing = ref2[0], setIsProcessing = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_notification__WEBPACK_IMPORTED_MODULE_10__/* .NotificationContext */ .u).notify;
    function handlePurchase() {
        return _handlePurchase.apply(this, arguments);
    }
    function _handlePurchase() {
        _handlePurchase = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            var sessionId, payload, ref, url, value, currency, paymentData, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selected) {
                            return [
                                2
                            ];
                        }
                        setIsProcessing(true);
                        sessionId = (0,uuid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        payload = {
                            id: selected,
                            location: router.asPath,
                            sessionId: sessionId
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].post */ .Z.post("/api/payment-pack-url", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), url = ref.url, value = ref.value, currency = ref.currency;
                        paymentData = {
                            value: value,
                            currency: currency,
                            session: sessionId
                        };
                        localStorage.setItem(_adjust__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_DATA_KEY */ .kV, JSON.stringify(paymentData));
                        return [
                            4,
                            router.push(url)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                            children: t("txt_cannot_buy_now")
                        }));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setIsProcessing(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handlePurchase.apply(this, arguments);
    }
    var userInfo = (0,_client_auth__WEBPACK_IMPORTED_MODULE_8__/* .useClientAuth */ .K6)().userInfo;
    var CACHE_MINUTES = 10;
    var prices = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)({
        queryKey: [
            "coins",
            "prices"
        ],
        queryFn: fetchPrices,
        enabled: Boolean(userInfo) && open,
        staleTime: Infinity,
        cacheTime: CACHE_MINUTES * 60 * 1000
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!prices.data) {
            return;
        }
        if (selected) {
            return;
        }
        if (minimumCoins === undefined) {
            var popular = prices.data.find(function(price) {
                return price.popular;
            });
            if (popular) {
                setSelected(popular.id);
            }
            return;
        }
        var minimumPack = prices.data.find(function(price) {
            return price.coins >= minimumCoins;
        });
        if (!minimumPack) {
            return;
        }
        setSelected(minimumPack.id);
    }, [
        minimumCoins,
        prices.data,
        prices,
        selected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!prices.data) {
            return;
        }
        if (selected) {
            return;
        }
        var popular = prices.data.find(function(price) {
            return price.popular;
        });
        if (popular) {
            setSelected(popular.id);
        }
    }, [
        prices,
        selected
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "popup-background",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("fixed inset-0 flex items-center justify-center", "z-[199] bg-color-popup transition-all", "p-4 tablet:p-0", open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        onClick: function(e) {
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(e.target, Element)) {
                if (e.target.id === "popup-background") {
                    setOpen(false);
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative flex w-full flex-col rounded-[12px] bg-color-cell tablet:w-[665px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[34px] w-[34px] rounded-full bg-color-cell hover:bg-blue-100", "absolute -right-12 top-0 items-center justify-center", "hidden transition-all desktop:flex"),
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_cdn__WEBPACK_IMPORTED_MODULE_17__/* .assetUrl */ .p)("/general/close.svg"),
                        alt: "close popup"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "flex justify-between border-b border-b-color-separator px-4 py-2 tablet:px-6 tablet:py-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[16px] font-700 text-blue-800 tablet:text-[24px] tablet:font-500",
                            children: t("txt_purchase_coins")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center gap-1 text-[14px] tablet:text-[22px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-500 text-blue-500",
                                    children: t("txt_balance_is")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-700 text-blue-800",
                                    children: coins.toLocaleString()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_cdn__WEBPACK_IMPORTED_MODULE_17__/* .assetUrl */ .p)("/general/coin.svg"),
                                    alt: "coin icon",
                                    className: "aspect-square w-3 tablet:w-5"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "flex w-full flex-row flex-wrap items-center gap-1 self-center p-4 tablet:gap-3 tablet:p-5",
                    children: [
                        (ref = prices.data) === null || ref === void 0 ? void 0 : ref.map(function(price) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceOption, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, price), {
                                selected: price.id === selected,
                                onSelected: function() {
                                    if (!userInfo || userInfo.isAnonymous) {
                                        setSelected(price.id);
                                        (0,_login_redirect__WEBPACK_IMPORTED_MODULE_9__/* .redirectToLogin */ .r)();
                                        return;
                                    }
                                    if (selected === price.id) {
                                        handlePurchase();
                                    } else {
                                        setSelected(price.id);
                                    }
                                }
                            }), price.id);
                        }),
                        prices.isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SizedSkeleton */ .xB, {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex w-full justify-center p-4 pt-0 font-700 text-color-white tablet:px-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: !prices.isSuccess || isProcessing,
                        onClick: handlePurchase,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("w-full bg-primary-500 px-2 py-2 text-[14px] tablet:text-[16px]", "rounded-full hover:bg-primary-600 tablet:max-w-[300px] tablet:rounded-[10px]", "select-none transition-all duration-300", "disabled:opacity-30"),
                        children: t("txt_purchase_coins")
                    })
                })
            ]
        })
    });
}
function PriceOption(props) {
    var coins = props.coins, price = props.price, popular = props.popular, best = props.best, selected = props.selected, onSelected = props.onSelected;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var priceTag = (price / 100).toFixed(2);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: onSelected,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("relative flex flex-col items-center justify-center", "h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px] tablet:flex-none tablet:rounded-[12px]", selected ? "bg-primary-50 inner-border-primary-500" : "bg-color-cell inner-border-blue-200", "basis-1/4 transition-all"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "text-[13px] font-700 text-blue-800 tablet:text-[24px]",
                                children: [
                                    "+",
                                    coins.toLocaleString()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (0,_cdn__WEBPACK_IMPORTED_MODULE_17__/* .assetUrl */ .p)("/general/coin.svg"),
                                alt: "coin icon",
                                className: "aspect-square pointer-events-none w-5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-[12px] text-[#888CA0] tablet:text-[22px]",
                        children: [
                            "$",
                            priceTag
                        ]
                    })
                ]
            }),
            popular && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("absolute right-0 top-0", "rounded-bl-[4px] tablet:rounded-bl-[12px]", "rounded-tr-[4px] tablet:rounded-tr-[12px]", "px-1 tablet:px-4", "text-[8px] tablet:text-[16px]", "font-700 uppercase text-color-white", "bg-[radial-gradient(431.07%_238.21%_at_10.87%_100.00%,#6E00FF_0%,#A700FF_37.28%,#FF4E00_100%)]"),
                children: t("lbl_popular")
            }),
            best && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("absolute right-0 top-0 bg-color-success", "rounded-bl-[4px] tablet:rounded-bl-[12px]", "rounded-tr-[4px] tablet:rounded-tr-[12px]", "px-1 tablet:px-4", "text-[8px] tablet:text-[16px]", "font-700 uppercase text-color-white"),
                children: t("lbl_best")
            })
        ]
    });
}


/***/ }),

/***/ 4455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "nU": function() { return /* binding */ dateToSortableString; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
var getFormattedDate = function(time) {
    var deadline = new Date(time);
    var year = deadline.toLocaleString(undefined, {
        year: "numeric"
    });
    var month = deadline.toLocaleString(undefined, {
        month: "long"
    });
    var day = deadline.toLocaleString(undefined, {
        day: "numeric"
    });
    return "".concat(day, " ").concat(month, ", ").concat(year);
};
function dateToSortableString(date) {
    return JSON.stringify(date).slice(1, -1);
}
function formatDate(dateStr, difference) {
    var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December", 
    ];
    var date = new Date(dateStr);
    var day = date.getDate();
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    var currentDate = new Date();
    var timeDiff = Math.abs(date.getTime() - currentDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    var dateString = "".concat(day, " ").concat(month, " ").concat(year);
    if (date.getTime() > currentDate.getTime() && difference) {
        dateString += " (".concat(diffDays, " days)");
    }
    return dateString;
}


/***/ }),

/***/ 3300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ useGalleryViewContext; },
/* harmony export */   "Bv": function() { return /* binding */ AdExamplesViewProvider; },
/* harmony export */   "KP": function() { return /* binding */ flattenAndFilterGallery; },
/* harmony export */   "Zs": function() { return /* binding */ useTemplatesViewContext; },
/* harmony export */   "ri": function() { return /* binding */ TemplatesViewProvider; },
/* harmony export */   "s3": function() { return /* binding */ useAdExamplesViewContext; },
/* harmony export */   "sK": function() { return /* binding */ arraysAreEqual; },
/* harmony export */   "tp": function() { return /* binding */ GalleryViewProvider; }
/* harmony export */ });
/* unused harmony exports deepCompare, TEMPLATES_ITEMS_IN_PAGE, mediaTypeMap, getGallery, getTemplatesWithCategories, getAdExamples, filterStateToPayload */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2715);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6154);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8767);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6106);













var GalleryViewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
function useGalleryViewContext() {
    var result = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(GalleryViewContext);
    if (!result) {
        throw new Error("You forgot the context");
    }
    return result;
}
var TemplatesViewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
function useTemplatesViewContext() {
    var result = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(TemplatesViewContext);
    if (!result) {
        throw new Error("You forgot the context");
    }
    return result;
}
var AdExamplesViewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
function useAdExamplesViewContext() {
    var result = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(AdExamplesViewContext);
    if (!result) {
        throw new Error("You forgot the context");
    }
    return result;
}
function deepCompare(a, b) {
    for(var key in a){
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
var TEMPLATES_ITEMS_IN_PAGE = 20;
function GalleryViewProvider(props) {
    var initialFilters = props.initialFilters, initialData = props.initialData, availableFilters = props.availableFilters, children = props.children, page = props.page, pageNumber = props.pageNumber;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useReducer)(createReducerWithInitialFiltersGallery(initialFilters, availableFilters), initialFilters), state = ref[0], dispatch = ref[1];
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useInfiniteQuery)({
        queryKey: [
            "gallery",
            state.applyFilters
        ],
        queryFn: getGallery(state),
        getNextPageParam: function(last) {
            return last.next;
        },
        staleTime: Infinity,
        cacheTime: 0,
        initialData: function() {
            if (!initialData) {
                return undefined;
            }
            if (!deepCompare(initialFilters, state)) {
                return undefined;
            }
            return {
                pages: [
                    {
                        data: initialData,
                        next: pageNumber * sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_5__/* .GALLERY_ITEMS_IN_PAGE */ .vg
                    }, 
                ],
                pageParams: [
                    0
                ]
            };
        },
        enabled: page === "ai-gallery"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryViewContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            query: query,
            availableFilters: availableFilters
        },
        children: children
    });
}
function TemplatesViewProvider(props) {
    var initialFilters = props.initialFilters, initialData = props.initialData, availableFilters = props.availableFilters, children = props.children, page = props.page;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useReducer)(createReducerWithInitialFiltersTemplates(initialFilters, availableFilters), initialFilters), state = ref[0], dispatch = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useInfiniteQuery)({
        queryKey: [
            "templates",
            state.applyFilters,
            router.asPath, 
        ],
        queryFn: getTemplatesWithCategories(state),
        getNextPageParam: function(last) {
            return last.next;
        },
        initialData: function() {
            if (!initialData) {
                return undefined;
            }
            if (!deepCompare(initialFilters, state)) {
                return undefined;
            }
            var next = TEMPLATES_ITEMS_IN_PAGE;
            if (initialData[0].section !== "searched") {
                next = 3;
            }
            return {
                pages: [
                    {
                        data: initialData,
                        next: next
                    }, 
                ],
                pageParams: [
                    0
                ]
            };
        },
        staleTime: Infinity,
        cacheTime: 0,
        enabled: page === "video-templates"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TemplatesViewContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            query: query,
            availableFilters: availableFilters
        },
        children: children
    });
}
function AdExamplesViewProvider(props) {
    var initialFilters = props.initialFilters, initialData = props.initialData, children = props.children, page = props.page, pageNumber = props.pageNumber;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useReducer)(createReducerWithInitialFiltersAdExamples(initialFilters), initialFilters), state = ref[0], dispatch = ref[1];
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useInfiniteQuery)({
        queryKey: [
            "ad-examples",
            state.applyFilters
        ],
        queryFn: getAdExamples(state),
        getNextPageParam: function(last) {
            return last.next;
        },
        initialData: function() {
            if (!initialData) {
                return undefined;
            }
            if (!deepCompare(initialFilters, state)) {
                return undefined;
            }
            var next = pageNumber * TEMPLATES_ITEMS_IN_PAGE;
            if (initialData.type !== "searched") {
                next = 3 * pageNumber;
            }
            return {
                pages: [
                    {
                        data: initialData,
                        next: next
                    }, 
                ],
                pageParams: [
                    0
                ]
            };
        },
        staleTime: Infinity,
        cacheTime: 0,
        enabled: page === "ad-examples"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdExamplesViewContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            query: query
        },
        children: children
    });
}
function createReducerWithInitialFiltersGallery(initialFilters, availableFilters) {
    return function galleryViewReducer(state, action) {
        switch(action.type){
            case "set_media_type":
                {
                    var mediaType = action.mediaType;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        mediaType: mediaType
                    });
                }
            case "set_search_query":
                {
                    var searchQuery = action.searchQuery;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        searchQuery: searchQuery
                    });
                }
            case "set_sort_by":
                {
                    var sortBy = action.sortBy;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        sortBy: sortBy
                    });
                }
            case "set_include_custom":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        includeCustoms: action.state
                    });
                }
            case "select_style":
                {
                    var styles = availableFilters.styles.filter(function(style) {
                        return style.name === action.name && action.tools.includes(style.tool);
                    });
                    var ids = styles.map(function(style) {
                        return style.id;
                    });
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedStyles: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.selectedStyles).concat([
                            {
                                name: action.name,
                                ids: ids
                            }, 
                        ])
                    });
                }
            case "select_tool":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedTools: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.selectedTools).concat([
                            action.tool, 
                        ])
                    });
                }
            case "remove_tool":
                {
                    var selectedTools = state.selectedTools.filter(function(selected) {
                        return selected !== action.tool;
                    });
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedTools: selectedTools
                    });
                }
            case "clear_tools":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedTools: []
                    });
                }
            case "clear_style":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedStyles: []
                    });
                }
            case "remove_style":
                {
                    var selectedStyles = state.selectedStyles.filter(function(style) {
                        return style.name !== action.name;
                    });
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedStyles: selectedStyles
                    });
                }
            case "apply_filters":
                {
                    var _ = state.applyFilters, currentState = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(state, [
                        "applyFilters"
                    ]);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        applyFilters: currentState
                    });
                }
            case "clear_all":
                {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialFilters);
                }
        }
    };
}
function createReducerWithInitialFiltersTemplates(initialFilters, availableFilters) {
    return function galleryViewReducer(state, action) {
        switch(action.type){
            case "select_category":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        selectedCategory: action.id
                    });
                }
            case "select_price":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        price: action.price
                    });
                }
            case "set_search_query":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        searchQuery: action.searchQuery
                    });
                }
            case "set_sort_by":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        sortBy: action.sortBy
                    });
                }
            case "apply_filters":
                {
                    var _ = state.applyFilters, currentState = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(state, [
                        "applyFilters"
                    ]);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        applyFilters: currentState
                    });
                }
            case "clear_all":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialFilters), {
                        searchQuery: state.searchQuery
                    });
                }
        }
    };
}
function createReducerWithInitialFiltersAdExamples(initialFilters) {
    return function adExamplesViewReducer(state, action) {
        switch(action.type){
            case "set_search_query":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        searchQuery: action.searchQuery
                    });
                }
            case "set_aspect":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        aspect: action.aspect
                    });
                }
            case "apply_filters":
                {
                    var _ = state.applyFilters, currentState = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(state, [
                        "applyFilters"
                    ]);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                        applyFilters: currentState
                    });
                }
            case "clear_all":
                {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialFilters), {
                        searchQuery: state.searchQuery
                    });
                }
        }
    };
}
var mediaTypeMap = {
    image: "image",
    video: "video",
    all: null
};
var getGallery = function(filters) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
            var pageParam, payload, response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        payload = filterStateToPayload(filters, pageParam !== null && pageParam !== void 0 ? pageParam : 0);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/gallery-all", payload).then(function(response) {
                                return response.data;
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: response,
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response.gallery.length, pageParam)
                            }
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getTemplatesWithCategories = function(state) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
            var pageParam, offset, result, response, response1, price_from, price_to, payload, response2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        offset = pageParam !== null && pageParam !== void 0 ? pageParam : 0;
                        result = [];
                        if (!(state.searchQuery === null && state.selectedCategory === -2 && state.price === "all")) return [
                            3,
                            4
                        ];
                        if (!(offset === 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].get */ .Z.get("/api/tutorial-discover").then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/tutorial-discover-categories", {
                                offset: offset
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: result.concat(response),
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response.length, pageParam)
                            }
                        ];
                    case 4:
                        if (!(state.selectedCategory === -1)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/tutorial-featured", {
                                offset: offset,
                                limit: TEMPLATES_ITEMS_IN_PAGE,
                                segment: "featured"
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 5:
                        response1 = _state.sent();
                        return [
                            2,
                            {
                                data: result.concat(response1),
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response1.data.length, pageParam)
                            }
                        ];
                    case 6:
                        price_from = -2;
                        price_to = -2;
                        if (state.price === "prime") {
                            price_from = -1;
                            price_to = -1;
                        } else if (state.price === "coin") {
                            price_from = 1;
                            price_to = 2000;
                        }
                        payload = {
                            offset: offset,
                            limit: TEMPLATES_ITEMS_IN_PAGE,
                            categoryId: state.selectedCategory,
                            price_from: price_from,
                            price_to: price_to,
                            sort: state.sortBy,
                            text: state.searchQuery
                        };
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/tutorial-search", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 7:
                        response2 = _state.sent();
                        return [
                            2,
                            {
                                data: result.concat(response2),
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response2.data.length, pageParam)
                            }
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getAdExamples = function(state) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param) {
            var pageParam, offset, response, _searchQuery, response1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        offset = pageParam !== null && pageParam !== void 0 ? pageParam : 0;
                        if (!(state.searchQuery === null && state.aspect === null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/ad-examples-home", {
                                offset: offset,
                                limit: 3
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                data: {
                                    type: "home",
                                    content: response
                                },
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response.length, pageParam)
                            }
                        ];
                    case 2:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/api/ad-examples-searched", {
                                offset: offset,
                                limit: TEMPLATES_ITEMS_IN_PAGE,
                                search_query: (_searchQuery = state.searchQuery) !== null && _searchQuery !== void 0 ? _searchQuery : "",
                                aspect: state.aspect
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 3:
                        response1 = _state.sent();
                        return [
                            2,
                            {
                                data: {
                                    type: "searched",
                                    content: response1.results,
                                    total: response1.total
                                },
                                next: (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .getGeneralNextPage */ .L9)(response1.results.length, pageParam)
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
function filterStateToPayload(filters, offset) {
    var payload = {
        offset: offset,
        limit: sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_5__/* .GALLERY_ITEMS_IN_PAGE */ .vg,
        owned_by: filters.ownedBy,
        search_query: filters.searchQuery,
        categories: filters.selectedCategories.map(function(category) {
            return category.id;
        }),
        media_type: mediaTypeMap[filters.mediaType],
        styles: filters.selectedStyles.map(function(style) {
            return style.ids;
        }).flat(),
        include_custom: filters.includeCustoms,
        sort: filters.sortBy,
        tools: filters.selectedTools.length !== 0 ? filters.selectedTools : [
            "ai_photo",
            "ai_restyle",
            "deform",
            "text_to_image",
            "text_to_video",
            "ai_look",
            "ai_suggest", 
        ]
    };
    return payload;
}
var flattenAndFilterGallery = function(pages) {
    return (0,_utils_scroll_context__WEBPACK_IMPORTED_MODULE_1__/* .flattenAndFilterArrays */ .nf)(pages, function(page) {
        return page.data.gallery;
    }, function(data) {
        return data.id;
    });
};
function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for(var i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 3882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": function() { return /* binding */ mutateWithNotify; }
/* harmony export */ });
/* unused harmony exports withSkeleton, getErrorLog */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9034);





function mutateWithNotify(notify, result, successMessage, errorMessage) {
    return _mutateWithNotify.apply(this, arguments);
}
function _mutateWithNotify() {
    _mutateWithNotify = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(notify, result, successMessage, errorMessage) {
        var error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        result()
                    ];
                case 1:
                    _state.sent();
                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .SuccessMessage */ .kk, {
                        children: successMessage
                    }));
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                        children: errorMessage
                    }));
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _mutateWithNotify.apply(this, arguments);
}
function withSkeleton(action, setter) {
    return _withSkeleton.apply(this, arguments);
}
function _withSkeleton() {
    _withSkeleton = _async_to_generator(function(action, setter) {
        var result, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setter(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        action
                    ];
                case 2:
                    result = _state.sent();
                    setter(false);
                    return [
                        2,
                        [
                            true,
                            result
                        ]
                    ];
                case 3:
                    e = _state.sent();
                    console.error("Failed to perform action");
                    setter(false);
                    return [
                        2,
                        [
                            false,
                            e
                        ]
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _withSkeleton.apply(this, arguments);
}
function getErrorLog(e, page) {
    if (axios.isAxiosError(e)) {
        var ref, ref1, ref2;
        var statusCode = (ref = e.response) === null || ref === void 0 ? void 0 : ref.status;
        var message = ((ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.data.message) || "";
        var endpoint = (ref2 = e.config) === null || ref2 === void 0 ? void 0 : ref2.url;
        if (statusCode === 404) {
            console.warn("Resource Not Found. \n", "From Page: " + page + "\n", "Endpoint: " + endpoint + "\n", "Message: " + message + "\n");
        } else if (statusCode === 401) {
            console.error("Unauthorized access." + "\n", "From Page: " + page + "\n", "Endpoint: " + endpoint + "\n", "Message: " + message + "\n");
        } else if (statusCode === 500) {
            console.error("Internal server error." + "\n", "From Page: " + page + "\n", "Endpoint: " + endpoint + "\n", "Message: " + message + "\n");
        } else {
            console.error("An unknown error occurred." + "\n", "From Page: " + page + "\n", "Endpoint: " + endpoint + "\n", "Message: " + message + "\n");
        }
    } else {
        console.error("Unexpected error. From Page: " + page, e);
    }
}


/***/ }),

/***/ 9872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ GoogleOneTap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _client_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1816);





function GoogleOneTap() {
    var userInfo = (0,_client_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().userInfo;
    var logInWithCredential = (0,_client_auth__WEBPACK_IMPORTED_MODULE_2__/* .useAuthUpdater */ .Sf)().logInWithCredential;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (userInfo && !userInfo.isAnonymous) {
            return;
        }
        try {
            if (!window.google || !window.google.accounts) {
                console.error("Google accounts library not loaded");
                return;
            }
            window.google.accounts.id.initialize({
                client_id: "478172087871-vv0ov4m902flthd5c1pnl13i8o5l7t7e.apps.googleusercontent.com",
                callback: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(response) {
                        var error;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        logInWithCredential(response.credential)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    error = _state.sent();
                                    console.error("Error logging in with credential", error);
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }()
            });
            window.google.accounts.id.prompt();
        } catch (e) {
            console.error("Google One Tap Error", e);
        }
    }, [
        logInWithCredential,
        userInfo
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        src: "https://accounts.google.com/gsi/client",
        async: true
    });
}


/***/ }),

/***/ 788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useIndexedDB; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1604);




var KEY_NAME = "id";
var indexedDBStores = [
    "deform",
    "ai_restyle",
    "ai_photo",
    "text_to_image",
    "text_to_video",
    "model_drafts",
    "ai_music_generator", 
];
var otherStores = (/* unused pure expression or super */ null && ([
    "deform",
    "ai_restyle",
    "ai_photo",
    "text_to_image",
    "text_to_video",
    "model_drafts", 
]));
function useIndexedDB(databaseName, storeName, schema) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        status: "loading"
    }), content = ref[0], setContent = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!window.indexedDB) {
            setContent({
                status: "not_available"
            });
            return;
        }
        function connectToDB() {
            return _connectToDB.apply(this, arguments);
        }
        function _connectToDB() {
            _connectToDB = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                var db;
                function setData(data) {
                    return _setData.apply(this, arguments);
                }
                function _setData() {
                    _setData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var transaction = db.transaction(storeName, "readwrite");
                                    var store = transaction.objectStore(storeName);
                                    store.put(data);
                                    transaction.oncomplete = function() {
                                        return resolve();
                                    };
                                    transaction.onerror = reject;
                                })
                            ];
                        });
                    });
                    return _setData.apply(this, arguments);
                }
                function clearData(id) {
                    return _clearData.apply(this, arguments);
                }
                function _clearData() {
                    _clearData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var transaction = db.transaction(storeName, "readwrite");
                                    var store = transaction.objectStore(storeName);
                                    store.delete(id);
                                    transaction.oncomplete = function() {
                                        return resolve();
                                    };
                                    transaction.onerror = reject;
                                })
                            ];
                        });
                    });
                    return _clearData.apply(this, arguments);
                }
                function getData(id) {
                    return _getData.apply(this, arguments);
                }
                function _getData() {
                    _getData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var transaction = db.transaction(storeName, "readwrite");
                                    var store = transaction.objectStore(storeName);
                                    var request = store.get(id);
                                    transaction.oncomplete = function() {
                                        var parseResult = schema.safeParse(request.result);
                                        if (!parseResult.success) {
                                            resolve(null);
                                            return;
                                        }
                                        resolve(parseResult.data);
                                    };
                                    transaction.onerror = reject;
                                })
                            ];
                        });
                    });
                    return _getData.apply(this, arguments);
                }
                function getAll() {
                    return _getAll.apply(this, arguments);
                }
                function _getAll() {
                    _getAll = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var transaction = db.transaction(storeName, "readwrite");
                                    var store = transaction.objectStore(storeName);
                                    var request = store.getAll();
                                    transaction.oncomplete = function() {
                                        var parseResult = zod__WEBPACK_IMPORTED_MODULE_3__.z.array(schema).safeParse(request.result);
                                        if (!parseResult.success) {
                                            resolve(null);
                                            return;
                                        }
                                        resolve(parseResult.data);
                                    };
                                    transaction.onerror = reject;
                                })
                            ];
                        });
                    });
                    return _getAll.apply(this, arguments);
                }
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDBWithStore(databaseName, indexedDBStores)
                            ];
                        case 1:
                            db = _state.sent();
                            setContent({
                                status: "ready",
                                setData: setData,
                                getData: getData,
                                clearData: clearData,
                                getAll: getAll
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return _connectToDB.apply(this, arguments);
        }
        connectToDB().catch(function(error) {
            return setContent({
                status: "error",
                error: error
            });
        });
    }, [
        databaseName,
        schema,
        storeName
    ]);
    return content;
}
function getDBWithStore(databaseName, stores) {
    return _getDBWithStore.apply(this, arguments);
}
function _getDBWithStore() {
    _getDBWithStore = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(databaseName, stores) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var openRequest = indexedDB.open(databaseName, stores.length);
                    openRequest.onupgradeneeded = function(e) {
                        if (!e.target) {
                            reject(e);
                            return;
                        }
                        var db = openRequest.result;
                        stores.forEach(function(store) {
                            if (!db.objectStoreNames.contains(store)) {
                                db.createObjectStore(store, {
                                    keyPath: KEY_NAME
                                });
                            }
                        });
                    };
                    openRequest.onsuccess = function(e) {
                        if (!e.target) {
                            reject(e);
                            return;
                        }
                        var db = openRequest.result;
                        resolve(db);
                    };
                    openRequest.onerror = reject;
                })
            ];
        });
    });
    return _getDBWithStore.apply(this, arguments);
}


/***/ }),

/***/ 275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_listener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3943);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var useInfiniteScroll = function(query, container) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, enabled = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, parent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var scrollHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!enabled) return;
        var elem = container.current;
        if (!elem) {
            return;
        }
        var ref = elem.getBoundingClientRect(), y = ref.y, height = ref.height;
        var bottom = y + height;
        if (bottom > window.innerHeight + offset) {
            return;
        }
        if (!query.hasNextPage) {
            return;
        }
        if (query.isFetchingNextPage) {
            return;
        }
        query.fetchNextPage().catch(console.error);
    }, [
        offset,
        container,
        query,
        enabled
    ]);
    (0,_utils_listener__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(scrollHandler, parent);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteScroll);


/***/ }),

/***/ 8178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ LastViewedContext; },
/* harmony export */   "h": function() { return /* binding */ LastViewedProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var LastViewedContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var LastViewedProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), last = ref[0], setLast = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var local = sessionStorage.getItem("last");
        if (typeof local === "string") {
            setLast(local);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LastViewedContext.Provider, {
        value: last,
        children: props.children
    });
};


/***/ }),

/***/ 3943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useScrollListener = function(handler) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var element = parent !== null && parent !== void 0 ? parent : document;
        element.addEventListener("scroll", handler);
        handler();
        return function() {
            return element.removeEventListener("scroll", handler);
        };
    }, [
        handler,
        parent
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollListener);


/***/ }),

/***/ 7592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ redirectToLogin; }
/* harmony export */ });
/* unused harmony export loginPageSchema */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var loginPageSchema = zod__WEBPACK_IMPORTED_MODULE_0__.z["enum"]([
    "signin",
    "signup",
    "verify",
    "username",
    "forgot",
    "success",
    "quiz",
    "plan", 
]);
function redirectToLogin(page) {
    var path = window.location.pathname;
    var search = window.location.search;
    var loginRedirectUrl = "/login?redirect_url=".concat(encodeURIComponent(path + search)).concat(page !== undefined ? "&type=" + page : "");
    window.location.href = loginRedirectUrl;
}


/***/ }),

/***/ 8322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6489);

var setMaxCookie = function(key, value) {
    var maxInt = Math.pow(2, 31) - 1;
    document.cookie = (0,cookie__WEBPACK_IMPORTED_MODULE_0__/* .serialize */ .q)(key, "", {
        maxAge: -1,
        sameSite: "lax",
        secure: false,
        path: "/"
    });
    document.cookie = (0,cookie__WEBPACK_IMPORTED_MODULE_0__/* .serialize */ .q)(key, value, {
        maxAge: maxInt,
        sameSite: "lax",
        secure: false,
        path: "/"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (setMaxCookie);


/***/ }),

/***/ 7961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZN": function() { return /* binding */ blogCdn; },
  "wx": function() { return /* binding */ components; },
  "we": function() { return /* binding */ withComponents; }
});

// UNUSED EXPORTS: compileMarkdown, withChatComponents

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/os-browserify/browser.js
var browser = __webpack_require__(3461);
;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/serialize.js
/* provided dependency */ var process = __webpack_require__(3454);





var lib$2 = {};

var lib$1 = {};

var jsTokens = {};

// Copyright 2014, 2015, 2016, 2017, 2018 Simon Lydell
// License: MIT. (See LICENSE.)

Object.defineProperty(jsTokens, "__esModule", {
  value: true
});

// This regex comes from regex.coffee, and is inserted here by generate-index.js
// (run `npm run build`).
jsTokens.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;

jsTokens.matchToToken = function(match) {
  var token = {type: "invalid", value: match[0], closed: undefined};
       if (match[ 1]) token.type = "string" , token.closed = !!(match[3] || match[4]);
  else if (match[ 5]) token.type = "comment";
  else if (match[ 6]) token.type = "comment", token.closed = !!match[7];
  else if (match[ 8]) token.type = "regex";
  else if (match[ 9]) token.type = "number";
  else if (match[10]) token.type = "name";
  else if (match[11]) token.type = "punctuator";
  else if (match[12]) token.type = "whitespace";
  return token
};

var lib = {};

var identifier = {};

Object.defineProperty(identifier, "__esModule", {
  value: true
});
identifier.isIdentifierStart = isIdentifierStart;
identifier.isIdentifierChar = isIdentifierChar;
identifier.isIdentifierName = isIdentifierName;
let nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u0870-\u0887\u0889-\u088e\u08a0-\u08c9\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u09fc\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0af9\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c5d\u0c60\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cdd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d04-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u1711\u171f-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4c\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31bf\u31f0-\u31ff\u3400-\u4dbf\u4e00-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7ca\ua7d0\ua7d1\ua7d3\ua7d5-\ua7d9\ua7f2-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab69\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
let nonASCIIidentifierChars = "\u200c\u200d\xb7\u0300-\u036f\u0387\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u07fd\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0898-\u089f\u08ca-\u08e1\u08e3-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u09fe\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0afa-\u0aff\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b55-\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c00-\u0c04\u0c3c\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c81-\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d00-\u0d03\u0d3b\u0d3c\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d81-\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u180f-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19d0-\u19da\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1ab0-\u1abd\u1abf-\u1ace\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf4\u1cf7-\u1cf9\u1dc0-\u1dff\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69e\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua82c\ua880\ua881\ua8b4-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f1\ua8ff-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\ua9e5\ua9f0-\ua9f9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b-\uaa7d\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
const nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
const nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
const astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1070, 4050, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 46, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 482, 44, 11, 6, 17, 0, 322, 29, 19, 43, 1269, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4152, 8, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938];
const astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 357, 0, 62, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];

function isInAstralSet(code, set) {
  let pos = 0x10000;

  for (let i = 0, length = set.length; i < length; i += 2) {
    pos += set[i];
    if (pos > code) return false;
    pos += set[i + 1];
    if (pos >= code) return true;
  }

  return false;
}

function isIdentifierStart(code) {
  if (code < 65) return code === 36;
  if (code <= 90) return true;
  if (code < 97) return code === 95;
  if (code <= 122) return true;

  if (code <= 0xffff) {
    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
  }

  return isInAstralSet(code, astralIdentifierStartCodes);
}

function isIdentifierChar(code) {
  if (code < 48) return code === 36;
  if (code < 58) return true;
  if (code < 65) return false;
  if (code <= 90) return true;
  if (code < 97) return code === 95;
  if (code <= 122) return true;

  if (code <= 0xffff) {
    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
  }

  return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
}

function isIdentifierName(name) {
  let isFirst = true;

  for (let i = 0; i < name.length; i++) {
    let cp = name.charCodeAt(i);

    if ((cp & 0xfc00) === 0xd800 && i + 1 < name.length) {
      const trail = name.charCodeAt(++i);

      if ((trail & 0xfc00) === 0xdc00) {
        cp = 0x10000 + ((cp & 0x3ff) << 10) + (trail & 0x3ff);
      }
    }

    if (isFirst) {
      isFirst = false;

      if (!isIdentifierStart(cp)) {
        return false;
      }
    } else if (!isIdentifierChar(cp)) {
      return false;
    }
  }

  return !isFirst;
}

var keyword = {};

Object.defineProperty(keyword, "__esModule", {
  value: true
});
keyword.isReservedWord = isReservedWord;
keyword.isStrictReservedWord = isStrictReservedWord;
keyword.isStrictBindOnlyReservedWord = isStrictBindOnlyReservedWord;
keyword.isStrictBindReservedWord = isStrictBindReservedWord;
keyword.isKeyword = isKeyword;
const reservedWords = {
  keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
  strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
  strictBind: ["eval", "arguments"]
};
const keywords = new Set(reservedWords.keyword);
const reservedWordsStrictSet = new Set(reservedWords.strict);
const reservedWordsStrictBindSet = new Set(reservedWords.strictBind);

function isReservedWord(word, inModule) {
  return inModule && word === "await" || word === "enum";
}

function isStrictReservedWord(word, inModule) {
  return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
}

function isStrictBindOnlyReservedWord(word) {
  return reservedWordsStrictBindSet.has(word);
}

function isStrictBindReservedWord(word, inModule) {
  return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
}

function isKeyword(word) {
  return keywords.has(word);
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isIdentifierName", {
  enumerable: true,
  get: function () {
    return _identifier.isIdentifierName;
  }
});
Object.defineProperty(exports, "isIdentifierChar", {
  enumerable: true,
  get: function () {
    return _identifier.isIdentifierChar;
  }
});
Object.defineProperty(exports, "isIdentifierStart", {
  enumerable: true,
  get: function () {
    return _identifier.isIdentifierStart;
  }
});
Object.defineProperty(exports, "isReservedWord", {
  enumerable: true,
  get: function () {
    return _keyword.isReservedWord;
  }
});
Object.defineProperty(exports, "isStrictBindOnlyReservedWord", {
  enumerable: true,
  get: function () {
    return _keyword.isStrictBindOnlyReservedWord;
  }
});
Object.defineProperty(exports, "isStrictBindReservedWord", {
  enumerable: true,
  get: function () {
    return _keyword.isStrictBindReservedWord;
  }
});
Object.defineProperty(exports, "isStrictReservedWord", {
  enumerable: true,
  get: function () {
    return _keyword.isStrictReservedWord;
  }
});
Object.defineProperty(exports, "isKeyword", {
  enumerable: true,
  get: function () {
    return _keyword.isKeyword;
  }
});

var _identifier = identifier;

var _keyword = keyword;
}(lib));

var chalk = {exports: {}};

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

var escapeStringRegexp = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};

var ansiStyles = {exports: {}};

var conversions$2 = {exports: {}};

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */

var cssKeywords = colorName;

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert$2 = conversions$2.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert$2) {
	if (convert$2.hasOwnProperty(model)) {
		if (!('channels' in convert$2[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert$2[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert$2[model].labels.length !== convert$2[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert$2[model].channels;
		var labels = convert$2[model].labels;
		delete convert$2[model].channels;
		delete convert$2[model].labels;
		Object.defineProperty(convert$2[model], 'channels', {value: channels});
		Object.defineProperty(convert$2[model], 'labels', {value: labels});
	}
}

convert$2.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert$2.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert$2.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert$2.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert$2.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert$2.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert$2.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert$2.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert$2.rgb.lab = function (rgb) {
	var xyz = convert$2.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert$2.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert$2.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert$2.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$2.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert$2.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert$2.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert$2.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert$2.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert$2.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert$2.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};

convert$2.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert$2.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert$2.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert$2.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert$2.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert$2.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert$2.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert$2.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert$2.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert$2.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert$2.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert$2.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert$2.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert$2.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert$2.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert$2.gray.hsl = convert$2.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert$2.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert$2.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert$2.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert$2.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};

var conversions$1 = conversions$2.exports;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions$1);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions$1[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function serialize_link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions$1[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = serialize_link(conversions$1[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route$1 = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var conversions = conversions$2.exports;
var route = route$1;

var convert$1 = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert$1[fromModel] = {};

	Object.defineProperty(convert$1[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert$1[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert$1[fromModel][toModel] = wrapRounded(fn);
		convert$1[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert$1;

(function (module) {
const colorConvert$1 = colorConvert;

const wrapAnsi16 = (fn, offset) => function () {
	const code = fn.apply(colorConvert$1, arguments);
	return `\u001B[${code + offset}m`;
};

const wrapAnsi256 = (fn, offset) => function () {
	const code = fn.apply(colorConvert$1, arguments);
	return `\u001B[${38 + offset};5;${code}m`;
};

const wrapAnsi16m = (fn, offset) => function () {
	const rgb = fn.apply(colorConvert$1, arguments);
	return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
};

function assembleStyles() {
	const codes = new Map();
	const styles = {
		modifier: {
			reset: [0, 0],
			// 21 isn't widely supported and 22 does the same thing
			bold: [1, 22],
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		color: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],
			gray: [90, 39],

			// Bright color
			redBright: [91, 39],
			greenBright: [92, 39],
			yellowBright: [93, 39],
			blueBright: [94, 39],
			magentaBright: [95, 39],
			cyanBright: [96, 39],
			whiteBright: [97, 39]
		},
		bgColor: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49],

			// Bright color
			bgBlackBright: [100, 49],
			bgRedBright: [101, 49],
			bgGreenBright: [102, 49],
			bgYellowBright: [103, 49],
			bgBlueBright: [104, 49],
			bgMagentaBright: [105, 49],
			bgCyanBright: [106, 49],
			bgWhiteBright: [107, 49]
		}
	};

	// Fix humans
	styles.color.grey = styles.color.gray;

	for (const groupName of Object.keys(styles)) {
		const group = styles[groupName];

		for (const styleName of Object.keys(group)) {
			const style = group[styleName];

			styles[styleName] = {
				open: `\u001B[${style[0]}m`,
				close: `\u001B[${style[1]}m`
			};

			group[styleName] = styles[styleName];

			codes.set(style[0], style[1]);
		}

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});

		Object.defineProperty(styles, 'codes', {
			value: codes,
			enumerable: false
		});
	}

	const ansi2ansi = n => n;
	const rgb2rgb = (r, g, b) => [r, g, b];

	styles.color.close = '\u001B[39m';
	styles.bgColor.close = '\u001B[49m';

	styles.color.ansi = {
		ansi: wrapAnsi16(ansi2ansi, 0)
	};
	styles.color.ansi256 = {
		ansi256: wrapAnsi256(ansi2ansi, 0)
	};
	styles.color.ansi16m = {
		rgb: wrapAnsi16m(rgb2rgb, 0)
	};

	styles.bgColor.ansi = {
		ansi: wrapAnsi16(ansi2ansi, 10)
	};
	styles.bgColor.ansi256 = {
		ansi256: wrapAnsi256(ansi2ansi, 10)
	};
	styles.bgColor.ansi16m = {
		rgb: wrapAnsi16m(rgb2rgb, 10)
	};

	for (let key of Object.keys(colorConvert$1)) {
		if (typeof colorConvert$1[key] !== 'object') {
			continue;
		}

		const suite = colorConvert$1[key];

		if (key === 'ansi16') {
			key = 'ansi';
		}

		if ('ansi16' in suite) {
			styles.color.ansi[key] = wrapAnsi16(suite.ansi16, 0);
			styles.bgColor.ansi[key] = wrapAnsi16(suite.ansi16, 10);
		}

		if ('ansi256' in suite) {
			styles.color.ansi256[key] = wrapAnsi256(suite.ansi256, 0);
			styles.bgColor.ansi256[key] = wrapAnsi256(suite.ansi256, 10);
		}

		if ('rgb' in suite) {
			styles.color.ansi16m[key] = wrapAnsi16m(suite.rgb, 0);
			styles.bgColor.ansi16m[key] = wrapAnsi16m(suite.rgb, 10);
		}
	}

	return styles;
}

// Make the export immutable
Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});
}(ansiStyles));

var hasFlag$1 = (flag, argv) => {
	argv = argv || process.argv;
	const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
	const pos = argv.indexOf(prefix + flag);
	const terminatorPos = argv.indexOf('--');
	return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

const os = browser;
const hasFlag = hasFlag$1;

const env = process.env;

let forceColor;
if (hasFlag('no-color') ||
	hasFlag('no-colors') ||
	hasFlag('color=false')) {
	forceColor = false;
} else if (hasFlag('color') ||
	hasFlag('colors') ||
	hasFlag('color=true') ||
	hasFlag('color=always')) {
	forceColor = true;
}
if ('FORCE_COLOR' in env) {
	forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
	if (level === 0) {
		return false;
	}

	return {
		level,
		hasBasic: true,
		has256: level >= 2,
		has16m: level >= 3
	};
}

function supportsColor(stream) {
	if (forceColor === false) {
		return 0;
	}

	if (hasFlag('color=16m') ||
		hasFlag('color=full') ||
		hasFlag('color=truecolor')) {
		return 3;
	}

	if (hasFlag('color=256')) {
		return 2;
	}

	if (stream && !stream.isTTY && forceColor !== true) {
		return 0;
	}

	const min = forceColor ? 1 : 0;

	if (process.platform === 'win32') {
		// Node.js 7.5.0 is the first version of Node.js to include a patch to
		// libuv that enables 256 color output on Windows. Anything earlier and it
		// won't work. However, here we target Node.js 8 at minimum as it is an LTS
		// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
		// release that supports 256 colors. Windows 10 build 14931 is the first release
		// that supports 16m/TrueColor.
		const osRelease = os.release().split('.');
		if (
			Number(process.versions.node.split('.')[0]) >= 8 &&
			Number(osRelease[0]) >= 10 &&
			Number(osRelease[2]) >= 10586
		) {
			return Number(osRelease[2]) >= 14931 ? 3 : 2;
		}

		return 1;
	}

	if ('CI' in env) {
		if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
			return 1;
		}

		return min;
	}

	if ('TEAMCITY_VERSION' in env) {
		return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
	}

	if (env.COLORTERM === 'truecolor') {
		return 3;
	}

	if ('TERM_PROGRAM' in env) {
		const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

		switch (env.TERM_PROGRAM) {
			case 'iTerm.app':
				return version >= 3 ? 3 : 2;
			case 'Apple_Terminal':
				return 2;
			// No default
		}
	}

	if (/-256(color)?$/i.test(env.TERM)) {
		return 2;
	}

	if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
		return 1;
	}

	if ('COLORTERM' in env) {
		return 1;
	}

	if (env.TERM === 'dumb') {
		return min;
	}

	return min;
}

function getSupportLevel(stream) {
	const level = supportsColor(stream);
	return translateLevel(level);
}

var supportsColor_1 = {
	supportsColor: getSupportLevel,
	stdout: getSupportLevel(process.stdout),
	stderr: getSupportLevel(process.stderr)
};

const TEMPLATE_REGEX = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const ESCAPE_REGEX = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi;

const ESCAPES = new Map([
	['n', '\n'],
	['r', '\r'],
	['t', '\t'],
	['b', '\b'],
	['f', '\f'],
	['v', '\v'],
	['0', '\0'],
	['\\', '\\'],
	['e', '\u001B'],
	['a', '\u0007']
]);

function serialize_unescape(c) {
	if ((c[0] === 'u' && c.length === 5) || (c[0] === 'x' && c.length === 3)) {
		return String.fromCharCode(parseInt(c.slice(1), 16));
	}

	return ESCAPES.get(c) || c;
}

function parseArguments(name, args) {
	const results = [];
	const chunks = args.trim().split(/\s*,\s*/g);
	let matches;

	for (const chunk of chunks) {
		if (!isNaN(chunk)) {
			results.push(Number(chunk));
		} else if ((matches = chunk.match(STRING_REGEX))) {
			results.push(matches[2].replace(ESCAPE_REGEX, (m, escape, chr) => escape ? serialize_unescape(escape) : chr));
		} else {
			throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
		}
	}

	return results;
}

function parseStyle(style) {
	STYLE_REGEX.lastIndex = 0;

	const results = [];
	let matches;

	while ((matches = STYLE_REGEX.exec(style)) !== null) {
		const name = matches[1];

		if (matches[2]) {
			const args = parseArguments(name, matches[2]);
			results.push([name].concat(args));
		} else {
			results.push([name]);
		}
	}

	return results;
}

function buildStyle(chalk, styles) {
	const enabled = {};

	for (const layer of styles) {
		for (const style of layer.styles) {
			enabled[style[0]] = layer.inverse ? null : style.slice(1);
		}
	}

	let current = chalk;
	for (const styleName of Object.keys(enabled)) {
		if (Array.isArray(enabled[styleName])) {
			if (!(styleName in current)) {
				throw new Error(`Unknown Chalk style: ${styleName}`);
			}

			if (enabled[styleName].length > 0) {
				current = current[styleName].apply(current, enabled[styleName]);
			} else {
				current = current[styleName];
			}
		}
	}

	return current;
}

var templates = (chalk, tmp) => {
	const styles = [];
	const chunks = [];
	let chunk = [];

	// eslint-disable-next-line max-params
	tmp.replace(TEMPLATE_REGEX, (m, escapeChar, inverse, style, close, chr) => {
		if (escapeChar) {
			chunk.push(serialize_unescape(escapeChar));
		} else if (style) {
			const str = chunk.join('');
			chunk = [];
			chunks.push(styles.length === 0 ? str : buildStyle(chalk, styles)(str));
			styles.push({inverse, styles: parseStyle(style)});
		} else if (close) {
			if (styles.length === 0) {
				throw new Error('Found extraneous } in Chalk template literal');
			}

			chunks.push(buildStyle(chalk, styles)(chunk.join('')));
			chunk = [];
			styles.pop();
		} else {
			chunk.push(chr);
		}
	});

	chunks.push(chunk.join(''));

	if (styles.length > 0) {
		const errMsg = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? '' : 's'} (\`}\`)`;
		throw new Error(errMsg);
	}

	return chunks.join('');
};

(function (module) {
const escapeStringRegexp$1 = escapeStringRegexp;
const ansiStyles$1 = ansiStyles.exports;
const stdoutColor = supportsColor_1.stdout;

const template = templates;

const isSimpleWindowsTerm = process.platform === 'win32' && !(process.env.TERM || '').toLowerCase().startsWith('xterm');

// `supportsColor.level` → `ansiStyles.color[name]` mapping
const levelMapping = ['ansi', 'ansi', 'ansi256', 'ansi16m'];

// `color-convert` models to exclude from the Chalk API due to conflicts and such
const skipModels = new Set(['gray']);

const styles = Object.create(null);

function applyOptions(obj, options) {
	options = options || {};

	// Detect level if not set manually
	const scLevel = stdoutColor ? stdoutColor.level : 0;
	obj.level = options.level === undefined ? scLevel : options.level;
	obj.enabled = 'enabled' in options ? options.enabled : obj.level > 0;
}

function Chalk(options) {
	// We check for this.template here since calling `chalk.constructor()`
	// by itself will have a `this` of a previously constructed chalk object
	if (!this || !(this instanceof Chalk) || this.template) {
		const chalk = {};
		applyOptions(chalk, options);

		chalk.template = function () {
			const args = [].slice.call(arguments);
			return chalkTag.apply(null, [chalk.template].concat(args));
		};

		Object.setPrototypeOf(chalk, Chalk.prototype);
		Object.setPrototypeOf(chalk.template, chalk);

		chalk.template.constructor = Chalk;

		return chalk.template;
	}

	applyOptions(this, options);
}

// Use bright blue on Windows as the normal blue color is illegible
if (isSimpleWindowsTerm) {
	ansiStyles$1.blue.open = '\u001B[94m';
}

for (const key of Object.keys(ansiStyles$1)) {
	ansiStyles$1[key].closeRe = new RegExp(escapeStringRegexp$1(ansiStyles$1[key].close), 'g');

	styles[key] = {
		get() {
			const codes = ansiStyles$1[key];
			return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, key);
		}
	};
}

styles.visible = {
	get() {
		return build.call(this, this._styles || [], true, 'visible');
	}
};

ansiStyles$1.color.closeRe = new RegExp(escapeStringRegexp$1(ansiStyles$1.color.close), 'g');
for (const model of Object.keys(ansiStyles$1.color.ansi)) {
	if (skipModels.has(model)) {
		continue;
	}

	styles[model] = {
		get() {
			const level = this.level;
			return function () {
				const open = ansiStyles$1.color[levelMapping[level]][model].apply(null, arguments);
				const codes = {
					open,
					close: ansiStyles$1.color.close,
					closeRe: ansiStyles$1.color.closeRe
				};
				return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
			};
		}
	};
}

ansiStyles$1.bgColor.closeRe = new RegExp(escapeStringRegexp$1(ansiStyles$1.bgColor.close), 'g');
for (const model of Object.keys(ansiStyles$1.bgColor.ansi)) {
	if (skipModels.has(model)) {
		continue;
	}

	const bgModel = 'bg' + model[0].toUpperCase() + model.slice(1);
	styles[bgModel] = {
		get() {
			const level = this.level;
			return function () {
				const open = ansiStyles$1.bgColor[levelMapping[level]][model].apply(null, arguments);
				const codes = {
					open,
					close: ansiStyles$1.bgColor.close,
					closeRe: ansiStyles$1.bgColor.closeRe
				};
				return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
			};
		}
	};
}

const proto = Object.defineProperties(() => {}, styles);

function build(_styles, _empty, key) {
	const builder = function () {
		return applyStyle.apply(builder, arguments);
	};

	builder._styles = _styles;
	builder._empty = _empty;

	const self = this;

	Object.defineProperty(builder, 'level', {
		enumerable: true,
		get() {
			return self.level;
		},
		set(level) {
			self.level = level;
		}
	});

	Object.defineProperty(builder, 'enabled', {
		enumerable: true,
		get() {
			return self.enabled;
		},
		set(enabled) {
			self.enabled = enabled;
		}
	});

	// See below for fix regarding invisible grey/dim combination on Windows
	builder.hasGrey = this.hasGrey || key === 'gray' || key === 'grey';

	// `__proto__` is used because we must return a function, but there is
	// no way to create a function with a different prototype
	builder.__proto__ = proto; // eslint-disable-line no-proto

	return builder;
}

function applyStyle() {
	// Support varags, but simply cast to string in case there's only one arg
	const args = arguments;
	const argsLen = args.length;
	let str = String(arguments[0]);

	if (argsLen === 0) {
		return '';
	}

	if (argsLen > 1) {
		// Don't slice `arguments`, it prevents V8 optimizations
		for (let a = 1; a < argsLen; a++) {
			str += ' ' + args[a];
		}
	}

	if (!this.enabled || this.level <= 0 || !str) {
		return this._empty ? '' : str;
	}

	// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
	// see https://github.com/chalk/chalk/issues/58
	// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
	const originalDim = ansiStyles$1.dim.open;
	if (isSimpleWindowsTerm && this.hasGrey) {
		ansiStyles$1.dim.open = '';
	}

	for (const code of this._styles.slice().reverse()) {
		// Replace any instances already present with a re-opening code
		// otherwise only the part of the string until said closing code
		// will be colored, and the rest will simply be 'plain'.
		str = code.open + str.replace(code.closeRe, code.open) + code.close;

		// Close the styling before a linebreak and reopen
		// after next line to fix a bleed issue on macOS
		// https://github.com/chalk/chalk/pull/92
		str = str.replace(/\r?\n/g, `${code.close}$&${code.open}`);
	}

	// Reset the original `dim` if we changed it to work around the Windows dimmed gray issue
	ansiStyles$1.dim.open = originalDim;

	return str;
}

function chalkTag(chalk, strings) {
	if (!Array.isArray(strings)) {
		// If chalk() was called by itself or with a string,
		// return the string itself as a string.
		return [].slice.call(arguments, 1).join(' ');
	}

	const args = [].slice.call(arguments, 2);
	const parts = [strings.raw[0]];

	for (let i = 1; i < strings.length; i++) {
		parts.push(String(args[i - 1]).replace(/[{}\\]/g, '\\$&'));
		parts.push(String(strings.raw[i]));
	}

	return template(chalk, parts.join(''));
}

Object.defineProperties(Chalk.prototype, styles);

module.exports = Chalk(); // eslint-disable-line new-cap
module.exports.supportsColor = stdoutColor;
module.exports.default = module.exports; // For TypeScript
}(chalk));

Object.defineProperty(lib$1, "__esModule", {
  value: true
});
lib$1.default = highlight;
lib$1.getChalk = getChalk;
lib$1.shouldHighlight = shouldHighlight;

var _jsTokens = jsTokens;

var _helperValidatorIdentifier = lib;

var _chalk = chalk.exports;

const sometimesKeywords = new Set(["as", "async", "from", "get", "of", "set"]);

function getDefs$1(chalk) {
  return {
    keyword: chalk.cyan,
    capitalized: chalk.yellow,
    jsxIdentifier: chalk.yellow,
    punctuator: chalk.yellow,
    number: chalk.magenta,
    string: chalk.green,
    regex: chalk.magenta,
    comment: chalk.grey,
    invalid: chalk.white.bgRed.bold
  };
}

const NEWLINE$1 = /\r\n|[\n\r\u2028\u2029]/;
const BRACKET = /^[()[\]{}]$/;
let tokenize;
{
  const JSX_TAG = /^[a-z][\w-]*$/i;

  const getTokenType = function (token, offset, text) {
    if (token.type === "name") {
      if ((0, _helperValidatorIdentifier.isKeyword)(token.value) || (0, _helperValidatorIdentifier.isStrictReservedWord)(token.value, true) || sometimesKeywords.has(token.value)) {
        return "keyword";
      }

      if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.substr(offset - 2, 2) == "</")) {
        return "jsxIdentifier";
      }

      if (token.value[0] !== token.value[0].toLowerCase()) {
        return "capitalized";
      }
    }

    if (token.type === "punctuator" && BRACKET.test(token.value)) {
      return "bracket";
    }

    if (token.type === "invalid" && (token.value === "@" || token.value === "#")) {
      return "punctuator";
    }

    return token.type;
  };

  tokenize = function* (text) {
    let match;

    while (match = _jsTokens.default.exec(text)) {
      const token = _jsTokens.matchToToken(match);

      yield {
        type: getTokenType(token, match.index, text),
        value: token.value
      };
    }
  };
}

function highlightTokens(defs, text) {
  let highlighted = "";

  for (const {
    type,
    value
  } of tokenize(text)) {
    const colorize = defs[type];

    if (colorize) {
      highlighted += value.split(NEWLINE$1).map(str => colorize(str)).join("\n");
    } else {
      highlighted += value;
    }
  }

  return highlighted;
}

function shouldHighlight(options) {
  return !!_chalk.supportsColor || options.forceColor;
}

function getChalk(options) {
  return options.forceColor ? new _chalk.constructor({
    enabled: true,
    level: 1
  }) : _chalk;
}

function highlight(code, options = {}) {
  if (shouldHighlight(options)) {
    const chalk = getChalk(options);
    const defs = getDefs$1(chalk);
    return highlightTokens(defs, code);
  } else {
    return code;
  }
}

Object.defineProperty(lib$2, "__esModule", {
  value: true
});
var codeFrameColumns_1 = lib$2.codeFrameColumns = codeFrameColumns;
lib$2.default = _default;

var _highlight = lib$1;

let deprecationWarningShown = false;

function getDefs(chalk) {
  return {
    gutter: chalk.grey,
    marker: chalk.red.bold,
    message: chalk.red.bold
  };
}

const NEWLINE = /\r\n|[\n\r\u2028\u2029]/;

function getMarkerLines(loc, source, opts) {
  const startLoc = Object.assign({
    column: 0,
    line: -1
  }, loc.start);
  const endLoc = Object.assign({}, startLoc, loc.end);
  const {
    linesAbove = 2,
    linesBelow = 3
  } = opts || {};
  const startLine = startLoc.line;
  const startColumn = startLoc.column;
  const endLine = endLoc.line;
  const endColumn = endLoc.column;
  let start = Math.max(startLine - (linesAbove + 1), 0);
  let end = Math.min(source.length, endLine + linesBelow);

  if (startLine === -1) {
    start = 0;
  }

  if (endLine === -1) {
    end = source.length;
  }

  const lineDiff = endLine - startLine;
  const markerLines = {};

  if (lineDiff) {
    for (let i = 0; i <= lineDiff; i++) {
      const lineNumber = i + startLine;

      if (!startColumn) {
        markerLines[lineNumber] = true;
      } else if (i === 0) {
        const sourceLength = source[lineNumber - 1].length;
        markerLines[lineNumber] = [startColumn, sourceLength - startColumn + 1];
      } else if (i === lineDiff) {
        markerLines[lineNumber] = [0, endColumn];
      } else {
        const sourceLength = source[lineNumber - i].length;
        markerLines[lineNumber] = [0, sourceLength];
      }
    }
  } else {
    if (startColumn === endColumn) {
      if (startColumn) {
        markerLines[startLine] = [startColumn, 0];
      } else {
        markerLines[startLine] = true;
      }
    } else {
      markerLines[startLine] = [startColumn, endColumn - startColumn];
    }
  }

  return {
    start,
    end,
    markerLines
  };
}

function codeFrameColumns(rawLines, loc, opts = {}) {
  const highlighted = (opts.highlightCode || opts.forceColor) && (0, _highlight.shouldHighlight)(opts);
  const chalk = (0, _highlight.getChalk)(opts);
  const defs = getDefs(chalk);

  const maybeHighlight = (chalkFn, string) => {
    return highlighted ? chalkFn(string) : string;
  };

  const lines = rawLines.split(NEWLINE);
  const {
    start,
    end,
    markerLines
  } = getMarkerLines(loc, lines, opts);
  const hasColumns = loc.start && typeof loc.start.column === "number";
  const numberMaxWidth = String(end).length;
  const highlightedLines = highlighted ? (0, _highlight.default)(rawLines, opts) : rawLines;
  let frame = highlightedLines.split(NEWLINE, end).slice(start, end).map((line, index) => {
    const number = start + 1 + index;
    const paddedNumber = ` ${number}`.slice(-numberMaxWidth);
    const gutter = ` ${paddedNumber} |`;
    const hasMarker = markerLines[number];
    const lastMarkerLine = !markerLines[number + 1];

    if (hasMarker) {
      let markerLine = "";

      if (Array.isArray(hasMarker)) {
        const markerSpacing = line.slice(0, Math.max(hasMarker[0] - 1, 0)).replace(/[^\t]/g, " ");
        const numberOfMarkers = hasMarker[1] || 1;
        markerLine = ["\n ", maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")), " ", markerSpacing, maybeHighlight(defs.marker, "^").repeat(numberOfMarkers)].join("");

        if (lastMarkerLine && opts.message) {
          markerLine += " " + maybeHighlight(defs.message, opts.message);
        }
      }

      return [maybeHighlight(defs.marker, ">"), maybeHighlight(defs.gutter, gutter), line.length > 0 ? ` ${line}` : "", markerLine].join("");
    } else {
      return ` ${maybeHighlight(defs.gutter, gutter)}${line.length > 0 ? ` ${line}` : ""}`;
    }
  }).join("\n");

  if (opts.message && !hasColumns) {
    frame = `${" ".repeat(numberMaxWidth + 1)}${opts.message}\n${frame}`;
  }

  if (highlighted) {
    return chalk.reset(frame);
  } else {
    return frame;
  }
}

function _default(rawLines, lineNumber, colNumber, opts = {}) {
  if (!deprecationWarningShown) {
    deprecationWarningShown = true;
    const message = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";

    if (process.emitWarning) {
      process.emitWarning(message, "DeprecationWarning");
    } else {
      const deprecationError = new Error(message);
      deprecationError.name = "DeprecationWarning";
      console.warn(new Error(message));
    }
  }

  colNumber = Math.max(colNumber, 0);
  const location = {
    start: {
      column: colNumber,
      line: lineNumber
    }
  };
  return codeFrameColumns(rawLines, location, opts);
}

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
/**
 * Attempt to parse position information from an error message originating from the MDX compiler.
 * Only used if the error object doesn't contain
 */
function parsePositionInformationFromErrorMessage(message) {
    const positionInfoPattern = /\d+:\d+(-\d+:\d+)/g;
    const match = message.match(positionInfoPattern);
    if (match) {
        // take the last match, that seems to be the most reliable source of the error.
        const lastMatch = match.slice(-1)[0];
        const [line, column] = lastMatch.split('-')[0].split(':');
        return {
            start: {
                line: Number.parseInt(line, 10),
                column: Number.parseInt(column, 10),
            },
        };
    }
}
/**
 * Prints a nicely formatted error message from an error caught during MDX compilation.
 *
 * @param error - Error caught from the mdx compiler
 * @param source - Raw MDX string
 * @returns Error
 */
function createFormattedMDXError(error, source) {
    const position = error?.position ?? parsePositionInformationFromErrorMessage(error?.message);
    const codeFrames = position
        ? codeFrameColumns_1(source, {
            start: {
                line: position.start.line,
                column: position.start.column ?? 0,
            },
        }, { linesAbove: 2, linesBelow: 2 })
        : '';
    const formattedError = new Error(`[next-mdx-remote] error compiling MDX:
${error?.message}
${codeFrames ? '\n' + codeFrames + '\n' : ''}
More information: https://mdxjs.com/docs/troubleshooting-mdx`);
    formattedError.stack = '';
    return formattedError;
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 */

var convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        // @ts-ignore looks like a list of tests / partial test object.
        return 'length' in test ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  );
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  var checks = [];
  var index = -1;

  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    var index = -1;

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    var key;

    for (key in check) {
      if (node[key] !== check[key]) return
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {import('unist-util-is').Type} Type
 * @typedef {import('unist-util-is').Props} Props
 */

/** @type {Array.<Node>} */
const empty = (/* unused pure expression or super */ null && ([]));

const remove =
  /**
   * @type {(
   *  (<Tree extends Node>(node: Tree, options: RemoveOptions, test: Type|Props|TestFunction<import('unist-util-visit-parents/complex-types').InclusiveDescendant<Tree>>|Array<Type|Props|TestFunction<import('unist-util-visit-parents/complex-types').InclusiveDescendant<Tree>>>) => Tree|null) &
   *  (<Tree extends Node>(node: Tree, test: Type|Props|TestFunction<import('unist-util-visit-parents/complex-types').InclusiveDescendant<Tree>>|Array<Type|Props|TestFunction<import('unist-util-visit-parents/complex-types').InclusiveDescendant<Tree>>>) => Tree|null)
   * )}
   */
  (
    /**
     * Mutate the given tree by removing all nodes that pass `test`.
     * The tree is walked in preorder (NLR), visiting the node itself, then its head, etc.
     *
     * @param {Node} tree Tree to filter
     * @param {RemoveOptions} options Whether to drop parent nodes if they had children, but all their children were filtered out. Default is `{cascade: true}`
     * @param {Type|Props|TestFunction<Node>|Array<Type|Props|TestFunction<Node>>} test is-compatible test (such as a type)
     * @returns {Node|null}
     */
    function (tree, options, test) {
      const is = convert(test || options);
      const cascade =
        options.cascade === undefined || options.cascade === null
          ? true
          : options.cascade;

      return preorder(tree)

      /**
       * Check and remove nodes recursively in preorder.
       * For each composite node, modify its children array in-place.
       *
       * @param {Node} node
       * @param {number|undefined} [index]
       * @param {Parent|undefined} [parent]
       * @returns {Node|null}
       */
      function preorder(node, index, parent) {
        /** @type {Array.<Node>} */
        // @ts-expect-error looks like a parent.
        const children = node.children || empty;
        let childIndex = -1;
        let position = 0;

        if (is(node, index, parent)) {
          return null
        }

        if (children.length > 0) {
          // Move all living children to the beginning of the children array.
          while (++childIndex < children.length) {
            // @ts-expect-error looks like a parent.
            if (preorder(children[childIndex], childIndex, node)) {
              children[position++] = children[childIndex];
            }
          }

          // Cascade delete.
          if (cascade && !position) {
            return null
          }

          // Drop other nodes.
          children.length = position;
        }

        return node
      }
    }
  );

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
/**
 * remark plugin which removes all import and export statements
 */
function removeImportsExportsPlugin() {
    return (tree) => remove(tree, 'mdxjsEsm');
}

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
function getCompileOptions(mdxOptions = {}, rsc = false) {
    const areImportsEnabled = mdxOptions?.useDynamicImport;
    // don't modify the original object when adding our own plugin
    // this allows code to reuse the same options object
    const remarkPlugins = [
        ...(mdxOptions.remarkPlugins || []),
        ...(areImportsEnabled ? [] : [removeImportsExportsPlugin]),
    ];
    return {
        ...mdxOptions,
        remarkPlugins,
        outputFormat: 'function-body',
        // Disable the importSource option for RSC to ensure there's no `useMDXComponents` implemented.
        providerImportSource: rsc ? undefined : '@mdx-js/react',
    };
}
/**
 * Parses and compiles the provided MDX string. Returns a result which can be passed into <MDXRemote /> to be rendered.
 */
async function serialize_serialize(source, { scope = {}, mdxOptions = {}, parseFrontmatter = false, } = {}, rsc = false) {
    const vfile = new VFile(source);
    // makes frontmatter available via vfile.data.matter
    if (parseFrontmatter) {
        matter(vfile, { strip: true });
    }
    let compiledMdx;
    try {
        compiledMdx = await compile(vfile, getCompileOptions(mdxOptions, rsc));
    }
    catch (error) {
        throw createFormattedMDXError(error, String(vfile));
    }
    let compiledSource = String(compiledMdx);
    return {
        compiledSource,
        frontmatter: (vfile.data.matter ?? {}),
        scope: scope,
    };
}



;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/serialize.js
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */





;// CONCATENATED MODULE: ./utils/mdx.tsx









var p = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: children
    }));
};
var h1 = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h1", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "text-h1 py-[50px] text-center",
        children: children
    }));
};
var h2 = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("text-h2 py-8 text-center tablet:py-10 desktop:py-[50px]"),
        children: children
    }));
};
var h3 = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("text-h3 py-6 text-center tablet:py-8 desktop:py-[40px]"),
        children: children
    }));
};
var blogCdn = "https://filesw.zoomerang.info/blog";
var Image = function(props) {
    var source = props.source, description = props.description, vertical = props.vertical, center = props.center, link = props.link;
    var isSvg = source === null || source === void 0 ? void 0 : source.endsWith(".svg");
    // The ? symbol is a workaround for a bug in the blog CDN
    // September 2023
    var src = isSvg ? "" : "".concat(blogCdn, "/").concat(source, "?");
    var ref = (0,react.useState)(null), url = ref[0], setUrl = ref[1];
    (0,react.useEffect)(function() {
        if (!isSvg) {
            return;
        }
        fetch("".concat(blogCdn, "/").concat(source)).then(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(response) {
                var blob, svgBlob, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                response.blob()
                            ];
                        case 1:
                            blob = _state.sent();
                            svgBlob = new Blob([
                                blob
                            ], {
                                type: "image/svg+xml"
                            });
                            url = URL.createObjectURL(svgBlob);
                            setUrl(url);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        isSvg,
        source
    ]);
    if (link === undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)("w-full", bottomMargin),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src || url || "",
                className: (0,clsx_m/* default */.Z)("max-h-[600px] rounded-[12px] object-cover tablet:rounded-[24px] desktop:rounded-[16px]", vertical ? "h-[600px]" : "w-full", description === undefined && "mb-2", center && "mx-auto"),
                alt: "".concat(description, " image")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: link,
        className: (0,clsx_m/* default */.Z)("w-full", bottomMargin),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: src || url || "",
            className: (0,clsx_m/* default */.Z)("max-h-[600px] rounded-[12px] object-cover tablet:rounded-[24px] desktop:rounded-[16px]", vertical ? "h-[600px]" : "w-full", description === undefined && "mb-2", center && "mx-auto"),
            alt: "".concat(description, " image")
        })
    });
};
var SideBySide = function(props) {
    var children = props.children, center = props.center;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("tablet:[&>*] flex w-full flex-col items-center gap-4 tablet:flex-row tablet:gap-5 tablet:[&>*]:!w-auto", center && "justify-center"),
        children: children
    });
};
var components = {
    h1: h1,
    h2: h2,
    h3: h3,
    p: p
};
var bottomMargin = "mb-3 tablet:mb-4";
var ol = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("ol", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("last:mb-0", bottomMargin),
        children: children
    }));
};
var ul = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("last:mb-0", bottomMargin),
        children: children
    }));
};
var li = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("mb-2 [&>p]:inline"),
        children: children
    }));
};
var a = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0,clsx_m/* default */.Z)("underline decoration-[transparent] duration-200", "text-[#2789FB] hover:decoration-[#2789FB]"),
        children: children
    }));
};
var thirdSubheader = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "text-h6 mb-3 mt-8 text-center desktop:text-left",
        children: children
    }));
};
var secondSubheader = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        id: String(children),
        className: "text-h5 mb-3 mt-8 text-center desktop:text-left",
        children: children
    }));
};
var subheader = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        id: String(children),
        className: "text-h4 subheader mb-3 mt-[50px] text-center desktop:text-left",
        children: children
    }));
};
var paragraph = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: (0,clsx_m/* default */.Z)("text-base", bottomMargin),
        children: children
    }));
};
var withChatComponents = {
    h1: subheader,
    h2: secondSubheader,
    h3: thirdSubheader,
    p: paragraph,
    a: a,
    ol: ol,
    ul: ul,
    li: li
};
var withComponents = {
    h1: subheader,
    h2: secondSubheader,
    h3: thirdSubheader,
    p: paragraph,
    a: a,
    ol: ol,
    ul: ul,
    li: li,
    Image: Image,
    SideBySide: SideBySide
};
function compileMarkdown(source) {
    return _compileMarkdown.apply(this, arguments);
}
function _compileMarkdown() {
    _compileMarkdown = _async_to_generator(function(source) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        serialize(source)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _compileMarkdown.apply(this, arguments);
}


/***/ }),

/***/ 323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ contextAwareTime; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(253);

function prettyMillions(n) {
    var separator = ".";
    var thousands = "K";
    var millions = "M";
    if (n < 1000) {
        return n.toString();
    }
    if (n < 100000) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getNumberAfterDot(n, 3), 2), first = ref[0], last = ref[1];
        if (last === 0) {
            return first + thousands;
        }
        return first + separator + last + thousands;
    }
    if (n < 1000000) {
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getNumberAfterDot(n, 3), 1), first1 = ref1[0];
        return first1 + thousands;
    }
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getNumberAfterDot(n, 6), 2), first2 = ref2[0], last1 = ref2[1];
    if (last1 === 0) {
        return first2 + millions;
    }
    return first2 + separator + last1 + millions;
}
function getNumberAfterDot(n, power) {
    var fraction = n / Math.pow(10, power);
    var remainder = fraction % 1;
    var first = Math.floor(fraction);
    var last = Math.floor(remainder * 10);
    return [
        first,
        last
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (prettyMillions);
var contextAwareTime = function(time) {
    var now = new Date().getTime();
    var passed = now - time;
    var millisecondsInMinutes = 1000 * 60;
    var minutes = passed / millisecondsInMinutes;
    var hours = minutes / 60;
    var days = hours / 24;
    var months = days / 30;
    var years = days / 365;
    var timestamps = [
        {
            count: years,
            locale: "fs_years_ago"
        },
        {
            count: months,
            locale: "fs_months_ago"
        },
        {
            count: days,
            locale: "fs_days_ago"
        },
        {
            count: hours,
            locale: "fs_hours_ago"
        },
        {
            count: minutes,
            locale: "fs_minutes_ago"
        }, 
    ];
    var closest = timestamps.find(function(param) {
        var count = param.count;
        return count >= 1;
    });
    if (closest) {
        return {
            locale: closest.locale,
            text: Math.floor(closest.count)
        };
    }
    return {
        locale: null,
        text: "txt_just_now"
    };
};


/***/ }),

/***/ 3867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ changeMimeType; }
/* harmony export */ });
function changeMimeType(blob, newMime) {
    var newBlob = new Blob([
        blob
    ], {
        type: newMime
    });
    return newBlob;
}


/***/ }),

/***/ 4371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ NotificationProvider; },
/* harmony export */   "u": function() { return /* binding */ NotificationContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1156);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  pointer-events: none;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: var(--w-screen);\n\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n  @media ",
        " {\n    right: -436px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: 0;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  align-self: stretch;\n\n  margin-top: 64px;\n\n  ",
        ";\n\n  @media ",
        " {\n    margin-top: 106px;\n    align-self: center;\n    width: 523px;\n  }\n\n  @media ",
        " {\n    align-self: flex-end;\n    width: 872px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var NotificationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)({
    notify: function(_) {
        throw new Error("Provider not used");
    },
    timeout: 3000
});
var NotificationAligner = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-33a35e1e-0"
})(_templateObject(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop);
var NotificationContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-33a35e1e-1"
})(_templateObject2(), function(props) {
    return props.maxTop && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1());
}, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .devices.desktop */ .Hb.desktop);
var NotificationProvider = function(props) {
    var timeout = props.timeout;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), messages = ref[0], setMessages = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), maxTop = ref1[0], setMaxTop = ref1[1];
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(message) {
        var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setMaxTop(top);
        var currentMessage = {
            message: message,
            counter: Math.random()
        };
        setMessages([
            currentMessage
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(messages)));
    }, [
        messages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NotificationContext.Provider, {
        value: {
            notify: notify,
            timeout: timeout
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NotificationAligner, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NotificationContainer, {
                    maxTop: maxTop,
                    children: messages.map(function(query) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: query.message
                        }, query.counter);
                    })
                })
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 2763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ PopupProvider; },
/* harmony export */   "tH": function() { return /* binding */ PopupContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9521);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7632);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			pointer-events: unset;\n			background-color: var(--color-popup-background);\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: transparent;\n\n	position: fixed;\n	z-index: 101;\n	top: 0;\n	left: 0;\n	width: 100%;\n	height: 100%;\n\n	pointer-events: none;\n\n	transition: background-color ",
        "ms\n		ease-in-out;\n\n	",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n			top: 0;\n			transition: top ",
        "ms ease-out;\n		"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: fixed;\n	z-index: 102;\n	top: 100svh;\n	left: 0;\n\n	width: 100%;\n	height: 100%;\n\n	display: flex;\n	flex-direction: column;\n\n	justify-content: flex-end;\n\n	transition: top ",
        "ms ease-in;\n\n	",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var closeAnimationDuration = 500;
var initialState = {
    add: function add() {
        throw new Error("Provider not used");
    },
    pop: function pop() {
        throw new Error("Provider not used");
    }
};
var PopupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(initialState);
var showPopup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context, builder) {
        var id, close;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            id = (0,uuid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
            close = function() {
                context.pop(id);
            };
            context.add(id, builder(close));
            return [
                2
            ];
        });
    });
    return function showPopup(context, builder) {
        return _ref.apply(this, arguments);
    };
}();
var PopupBackground = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21f8ea6f-0"
})(_templateObject1(), closeAnimationDuration, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject());
});
var PopupElement = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21f8ea6f-1"
})(_templateObject3(), closeAnimationDuration, function(props) {
    return props.show && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), closeAnimationDuration);
});
var PopupProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Map()), layers = ref[0], setLayers = ref[1];
    var add = function(id, component) {
        setLayers(function(layers) {
            layers.set(id, {
                component: component,
                visibility: false
            });
            return new Map(layers);
        });
        setTimeout(function() {
            setLayers(function(layers) {
                var layer = layers.get(id);
                if (layer) {
                    layer.visibility = true;
                    layers.set(id, layer);
                }
                return new Map(layers);
            });
        }, 0);
    };
    var pop = function(id) {
        setLayers(function(layers) {
            var layer = layers.get(id);
            if (layer) {
                layer.visibility = false;
                layers.set(id, layer);
            }
            return new Map(layers);
        });
        setTimeout(function() {
            setLayers(function(layers) {
                layers.delete(id);
                return new Map(layers);
            });
        }, closeAnimationDuration);
    };
    var flatLayers = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Array.from(layers);
    }, [
        layers
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PopupContext.Provider, {
        value: {
            add: add,
            pop: pop
        },
        children: [
            flatLayers.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PopupBackground, {
                show: flatLayers.find(function(param) {
                    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), _ = _param[0], visibility = _param[1].visibility;
                    return visibility;
                }) !== undefined
            }),
            flatLayers.map(function(param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), id = _param[0], ref = _param[1], component = ref.component, visibility = ref.visibility;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PopupElement, {
                    id: id,
                    show: visibility,
                    onClick: function(e) {
                        var element = e.target;
                        if (element.id !== id) return;
                        flatLayers.forEach(function(param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), id = _param[0];
                            return pop(id);
                        });
                    },
                    children: component
                }, id);
            }),
            props.children
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (showPopup);


/***/ }),

/***/ 669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports base, code */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9815);
/* provided dependency */ var process = __webpack_require__(3454);


var base = process.env.BACKEND_ENDPOINT_BASE;
var code = process.env.BACKEND_ENDPOINT_CODE;
var empty = [];
var queryfy = function(params) {
    return "?" + Object.entries(params).reduce(function(array, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(array).concat([
            encodeURIComponent(key) + "=" + encodeURIComponent(value), 
        ]);
    }, empty).join("&");
};
/* harmony default export */ __webpack_exports__["ZP"] = (queryfy);


/***/ }),

/***/ 1964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useRegenerate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var _comps_editors_deform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8641);
/* harmony import */ var _comps_editors_photo_ai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var _comps_editors_restyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9868);
/* harmony import */ var _comps_editors_text_to_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3569);
/* harmony import */ var _comps_editors_text_to_video__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5042);
/* harmony import */ var _indexed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788);








function useRegenerate() {
    var photoAiIndexed = (0,_indexed__WEBPACK_IMPORTED_MODULE_5__/* .useIndexedDB */ .i)("ai_art", "ai_photo", _comps_editors_photo_ai__WEBPACK_IMPORTED_MODULE_1__.photoAiStorageSchema);
    var restyleIndexed = (0,_indexed__WEBPACK_IMPORTED_MODULE_5__/* .useIndexedDB */ .i)("ai_art", "ai_restyle", _comps_editors_restyle__WEBPACK_IMPORTED_MODULE_2__.restyleStorageSchema);
    var deforumIndexed = (0,_indexed__WEBPACK_IMPORTED_MODULE_5__/* .useIndexedDB */ .i)("ai_art", "deform", _comps_editors_deform__WEBPACK_IMPORTED_MODULE_0__.deforumStorageSchema);
    var textToImageIndexed = (0,_indexed__WEBPACK_IMPORTED_MODULE_5__/* .useIndexedDB */ .i)("ai_art", "text_to_image", _comps_editors_text_to_image__WEBPACK_IMPORTED_MODULE_3__.textToImageStorageSchema);
    var textToVideoIndexed = (0,_indexed__WEBPACK_IMPORTED_MODULE_5__/* .useIndexedDB */ .i)("ai_art", "text_to_video", _comps_editors_text_to_video__WEBPACK_IMPORTED_MODULE_4__.textToVideoStorageSchema);
    function setContentDeforum(content) {
        return _setContentDeforum.apply(this, arguments);
    }
    function _setContentDeforum() {
        _setContentDeforum = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(content) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (deforumIndexed.status !== "ready") {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            deforumIndexed.setData(content)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return _setContentDeforum.apply(this, arguments);
    }
    function setContentRestyle(content) {
        return _setContentRestyle.apply(this, arguments);
    }
    function _setContentRestyle() {
        _setContentRestyle = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(content) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (restyleIndexed.status !== "ready") {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            restyleIndexed.setData(content)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return _setContentRestyle.apply(this, arguments);
    }
    function setContentPhotoAi(content) {
        return _setContentPhotoAi.apply(this, arguments);
    }
    function _setContentPhotoAi() {
        _setContentPhotoAi = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(content) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (photoAiIndexed.status !== "ready") {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            photoAiIndexed.setData(content)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return _setContentPhotoAi.apply(this, arguments);
    }
    function setContentTextToImage(content) {
        return _setContentTextToImage.apply(this, arguments);
    }
    function _setContentTextToImage() {
        _setContentTextToImage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(content) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (textToImageIndexed.status !== "ready") {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            textToImageIndexed.setData(content)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return _setContentTextToImage.apply(this, arguments);
    }
    function setContentTextToVideo(content) {
        return _setContentTextToVideo.apply(this, arguments);
    }
    function _setContentTextToVideo() {
        _setContentTextToVideo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(content) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (textToVideoIndexed.status !== "ready") {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            textToVideoIndexed.setData(content)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return _setContentTextToVideo.apply(this, arguments);
    }
    return {
        setContentTextToImage: setContentTextToImage,
        setContentTextToVideo: setContentTextToVideo,
        setContentPhotoAi: setContentPhotoAi,
        setContentRestyle: setContentRestyle,
        setContentDeforum: setContentDeforum
    };
}


/***/ }),

/***/ 2715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z3": function() { return /* binding */ CreatedScrollContext; },
  "zA": function() { return /* binding */ LikedScrollContext; },
  "Ah": function() { return /* binding */ flattenAndFilter; },
  "nf": function() { return /* binding */ flattenAndFilterArrays; },
  "fC": function() { return /* binding */ flattenAndFilterComments; },
  "EJ": function() { return /* binding */ flattenAndFilterGeneralComments; },
  "L9": function() { return /* binding */ getGeneralNextPage; },
  "X5": function() { return /* binding */ setScrollContext; },
  "K3": function() { return /* binding */ useScrollContext; }
});

// UNUSED EXPORTS: FeaturedScrollContext, getFeatured, getScrollContext, getTemplates, scrollReducer, useScrollData

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./utils/queryfy.ts
var queryfy = __webpack_require__(669);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(4367);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
;// CONCATENATED MODULE: ./utils/scroll-context.tsx












var getGeneralNextPage = function(length, page) {
    var next = (page !== null && page !== void 0 ? page : 0) + length;
    if (page === undefined) return length;
    if (length) return next;
    return undefined;
};
var getNextPage = function(templates, page) {
    var next = (page !== null && page !== void 0 ? page : 0) + templates.length;
    if (templates.length === templatesInPage) return next;
    return undefined;
};
var getTemplates = function(uid, field, creator) {
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var pageParam, ref, _, _tmp, _tmp1, _tmp2, _1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pageParam = param.pageParam;
                        _ = axios/* default.get */.Z.get;
                        _tmp = [
                            "/api/user-".concat(field, "-tutorials") + (0,queryfy/* default */.ZP)({
                                uid: uid,
                                offset: pageParam || 0,
                                limit: templatesInPage
                            })
                        ];
                        _tmp1 = {};
                        _tmp2 = {};
                        _1 = "Bearer ";
                        return [
                            4,
                            (ref = (0,index_esm/* getAuth */.v0)().currentUser) === null || ref === void 0 ? void 0 : ref.getIdToken()
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(axios/* default */.Z, _tmp.concat((_tmp1.headers = (_tmp2.Authorization = _1 + _state.sent(), _tmp2["web-version"] = cdn/* HEADER_WEB_VERSION */.F, _tmp2), _tmp1))).then(function(res) {
                                var withCreator = res.data.templates.map(function(template) {
                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, template), {
                                        creator: creator
                                    });
                                });
                                var context = getScrollContext();
                                if (context) {
                                    var _templates;
                                    (_templates = context.templates).push.apply(_templates, (0,_to_consumable_array/* default */.Z)(withCreator));
                                    setScrollContext(context);
                                }
                                return {
                                    data: withCreator,
                                    next: getNextPage(withCreator, pageParam)
                                };
                            })
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var getFeatured = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var pageParam, ref, _, _tmp, _tmp1, _tmp2, _1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pageParam = param.pageParam;
                    _ = axios/* default.get */.Z.get;
                    _tmp = [
                        "/api/tutorial" + (0,queryfy/* default */.ZP)({
                            region: "US",
                            limit: templatesInPage,
                            offset: pageParam !== null && pageParam !== void 0 ? pageParam : 0
                        })
                    ];
                    _tmp1 = {};
                    _tmp2 = {};
                    _1 = "Bearer ";
                    return [
                        4,
                        (ref = (0,index_esm/* getAuth */.v0)().currentUser) === null || ref === void 0 ? void 0 : ref.getIdToken()
                    ];
                case 1:
                    return [
                        4,
                        _.apply(axios/* default */.Z, _tmp.concat((_tmp1.headers = (_tmp2.Authorization = _1 + _state.sent(), _tmp2), _tmp1))).then(function(res) {
                            var context = getScrollContext();
                            if (context) {
                                var _templates;
                                (_templates = context.templates).push.apply(_templates, (0,_to_consumable_array/* default */.Z)(res.data.templates));
                                setScrollContext(context);
                            }
                            return {
                                data: res.data.templates,
                                next: getNextPage(res.data.templates, pageParam)
                            };
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getFeatured(_) {
        return _ref.apply(this, arguments);
    };
}();
var CreatedScrollContext = /*#__PURE__*/ function() {
    "use strict";
    function CreatedScrollContext(uid, templates, creator) {
        _classCallCheck(this, CreatedScrollContext);
        this.id = "created/" + uid;
        this.uid = uid;
        this.templates = templates.map(function(template) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, template), {
                creator: creator
            });
        });
        this.creator = creator;
    }
    var _proto = CreatedScrollContext.prototype;
    _proto.fetcher = function fetcher() {
        return getTemplates(this.uid, "created", this.creator);
    };
    _proto.serialize = function serialize() {
        return {
            page: "created",
            templates: this.templates,
            uid: this.uid,
            creator: this.creator
        };
    };
    return CreatedScrollContext;
}();
var LikedScrollContext = /*#__PURE__*/ function() {
    "use strict";
    function LikedScrollContext(uid, templates, creator) {
        _classCallCheck(this, LikedScrollContext);
        this.id = "liked/" + uid;
        this.uid = uid;
        this.templates = templates.map(function(templates) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, templates), {
                creator: creator
            });
        });
        this.creator = creator;
    }
    var _proto = LikedScrollContext.prototype;
    _proto.fetcher = function fetcher() {
        return getTemplates(this.uid, "liked", this.creator);
    };
    _proto.serialize = function serialize() {
        return {
            page: "liked",
            templates: this.templates,
            uid: this.uid,
            creator: this.creator
        };
    };
    return LikedScrollContext;
}();
var FeaturedScrollContext = /*#__PURE__*/ function() {
    "use strict";
    function FeaturedScrollContext(templates) {
        _classCallCheck(this, FeaturedScrollContext);
        this.id = "featured";
        this.templates = templates;
    }
    var _proto = FeaturedScrollContext.prototype;
    _proto.fetcher = function fetcher() {
        return getFeatured;
    };
    _proto.serialize = function serialize() {
        return {
            page: "featured",
            templates: this.templates
        };
    };
    return FeaturedScrollContext;
}();
var setScrollContext = function(context) {
    var serialized = JSON.stringify(context.serialize());
    sessionStorage.setItem("scroll", serialized);
};
var getScrollContext = function() {
    var context = sessionStorage.getItem("scroll");
    if (!context) return null;
    var scrollContext = null;
    try {
        scrollContext = JSON.parse(context);
    } catch (_) {
        return null;
    }
    switch(scrollContext.page){
        case "created":
            return new CreatedScrollContext(scrollContext.uid, scrollContext.templates, scrollContext.creator);
        case "liked":
            return new LikedScrollContext(scrollContext.uid, scrollContext.templates, scrollContext.creator);
        case "featured":
            return new FeaturedScrollContext(scrollContext.templates);
        default:
            return null;
    }
};
var flattenAndFilter = function(pages) {
    return flattenAndFilterArrays(pages, function(page) {
        return page.data;
    }, function(data) {
        return data.id;
    });
};
var flattenAndFilterComments = function(pages) {
    return flattenAndFilterArrays(pages, function(page) {
        return page.data;
    }, function(data) {
        return data.id;
    });
};
var flattenAndFilterGeneralComments = function(pages) {
    return flattenAndFilterArrays(pages, function(page) {
        return page.data;
    }, function(data) {
        return data.id;
    });
};
var flattenAndFilterArrays = function(pages, extractor, identity) {
    var dataSet = new Set();
    var filteredArray = new Array();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var page = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = extractor(page)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var data = _step1.value;
                    if (!dataSet.has(identity(data))) {
                        dataSet.add(identity(data));
                        filteredArray.push(data);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filteredArray;
};
var templatesInPage = 12;
var useScrollData = function() {
    var ref = useState({
        ready: false,
        data: undefined
    }), result = ref[0], setResult = ref[1];
    useEffect(function() {
        if (result.ready) return;
        var context = getScrollContext();
        var contextState = {
            ready: true,
            data: context
        };
        setResult(contextState);
    }, [
        result.ready
    ]);
    return result;
};
var useScrollContext = function(props) {
    var ref;
    var ref1 = props || {}, ready = ref1.ready, data = ref1.data;
    var enabled = ready && Boolean(data);
    var ref2;
    var initialTemplates = (ref2 = data === null || data === void 0 ? void 0 : data.templates) !== null && ref2 !== void 0 ? ref2 : [];
    var query = (0,es.useInfiniteQuery)({
        queryFn: data === null || data === void 0 ? void 0 : data.fetcher(),
        queryKey: data === null || data === void 0 ? void 0 : data.id,
        enabled: enabled,
        initialData: ready ? {
            pages: [
                {
                    data: initialTemplates,
                    next: initialTemplates.length
                }, 
            ],
            pageParams: [
                initialTemplates.length
            ]
        } : undefined,
        staleTime: Infinity,
        getNextPageParam: function(page) {
            return page.next;
        }
    });
    var templates = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var pages = (ref1 = (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages) !== null && ref1 !== void 0 ? ref1 : [];
        return flattenAndFilter(pages);
    }, [
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages
    ]);
    return {
        query: query,
        templates: templates
    };
};
var scrollReducer = function(state, action) {
    switch(action.name){
        case "single":
            return {
                status: "single",
                template: action.template
            };
        case "context":
            return {
                status: "multiple",
                page: action.context.templates,
                scrolled: false,
                active: action.template
            };
        case "view":
            if (state.status !== "multiple") {
                console.error("Cant view");
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                active: action.active
            });
        case "scrolled":
            if (state.status !== "multiple") {
                console.error("How did you scroll single template?");
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                scrolled: true
            });
        case "load":
            if (state.status !== "multiple") {
                console.error("Loaded with status = single");
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                page: action.page
            });
    }
};


/***/ }),

/***/ 1634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scrollToSection; }
/* harmony export */ });
var scrollToSection = function(section, padding) {
    return function() {
        var sectionElement = document.getElementById(section);
        if (sectionElement) {
            var y = sectionElement.getBoundingClientRect().y;
            var scrollTop = window.scrollY + y;
            window.scroll({
                top: scrollTop - (padding !== null && padding !== void 0 ? padding : 110),
                behavior: "smooth"
            });
        }
    };
};


/***/ }),

/***/ 7232:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getLetterSpacing = function(size) {
    switch(size){
        case "50":
        case "48":
        case "44":
        case "40":
        case "36":
        case "32":
            return "0.035em";
        default:
            return "0.02em";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getLetterSpacing);


/***/ }),

/***/ 9483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nX": function() { return /* binding */ withNotify; }
/* harmony export */ });
/* unused harmony exports useOnce, useErrorNotification */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9034);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2213);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _notification__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4371);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9204);








function withNotify(notify) {
    return function(error) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, axios__WEBPACK_IMPORTED_MODULE_7__/* .AxiosError */ .d7)) {
            var ref, ref1;
            var ref2;
            notify((ref2 = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref2 !== void 0 ? ref2 : error.message);
            return;
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            notify(error.message);
            return;
        }
        notify("Unknown error");
    };
}
var useOnce = function(callback) {
    var ref = useTrigger(), ready = ref.ready, trigger = ref.trigger;
    useEffect(function() {
        if (ready) return;
        callback();
        trigger();
    }, [
        callback,
        ready,
        trigger
    ]);
};
var useTrigger = function() {
    var ref = useState(false), ready = ref[0], setReady = ref[1];
    return {
        ready: ready,
        trigger: function() {
            return setReady(true);
        }
    };
};
function useErrorNotification() {
    var router = useRouter();
    var notify = useContext(NotificationContext).notify;
    var t = useTranslation("common").t;
    var ref = useState(false), notified = ref[0], setNotified = ref[1];
    useEffect(function() {
        var error = router.query.error;
        if (error) {
            if (notified) return;
            setNotified(true);
            notify(/*#__PURE__*/ _jsx(WarningMessage, {
                children: t("txt_no_pdfs")
            }));
        }
    }, [
        notified,
        notify,
        router.query,
        t
    ]);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useTrigger)));


/***/ }),

/***/ 4286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xy": function() { return /* binding */ followStatusMap; },
/* harmony export */   "nM": function() { return /* binding */ extractResponse; }
/* harmony export */ });
/* unused harmony exports getTaggedSlices, templatesExtractor, singleExtractor, singleTemplateExtractor */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);




var followStatusMap = {
    0: "not_following",
    1: "following",
    2: "follow_back",
    3: "requested"
};
var getTaggedSlices = function(tags, text) {
    var withUsernames = extractUsernames(text || "", tags !== null && tags !== void 0 ? tags : []);
    var formatted = extractHashtags(withUsernames);
    return formatted;
};
var extractUsernames = function(description, tags) {
    var initial = [];
    var beginning = 0;
    var formatted = tags.reduce(function(acc, tag) {
        var text = {
            format: "text",
            content: (description === null || description === void 0 ? void 0 : description.slice(beginning, tag.s)) || ""
        };
        beginning = tag.e;
        var ref;
        var user = {
            format: "username",
            label: (ref = description === null || description === void 0 ? void 0 : description.slice(tag.s + 1, tag.e)) !== null && ref !== void 0 ? ref : "",
            uid: tag.uid
        };
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat([
            text,
            user
        ]);
    }, initial);
    formatted.push({
        format: "text",
        content: (description === null || description === void 0 ? void 0 : description.slice(beginning, description === null || description === void 0 ? void 0 : description.length)) || ""
    });
    return formatted;
};
var stringToHashtag = function(text) {
    var words = text.split(" ");
    var tagged = words.map(function(word) {
        if (word[0] === "#") return {
            format: "hashtag",
            content: word.slice(1)
        };
        return {
            format: "text",
            content: word + " "
        };
    });
    var initial = {
        tags: [],
        last: ""
    };
    var reduced = tagged.reduce(function(acc, curr) {
        if (curr.format === "text") {
            acc.last += curr.content;
            return acc;
        }
        var newTag = {
            format: "text",
            content: acc.last
        };
        return {
            tags: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc.tags).concat([
                newTag,
                curr
            ]),
            last: ""
        };
    }, initial);
    if (reduced.last) reduced.tags.push({
        format: "text",
        content: reduced.last
    });
    return reduced.tags;
};
var getCategoryName = function(categories) {
    if (!categories) return null;
    if (!categories.length) return null;
    var _categories = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(categories, 1), category = _categories[0];
    var _name;
    return (_name = category.name) !== null && _name !== void 0 ? _name : null;
};
var getCategoryId = function(categories) {
    if (!categories) return null;
    if (!categories.length) return null;
    var _categories = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(categories, 1), category = _categories[0];
    var _id;
    return (_id = category.id) !== null && _id !== void 0 ? _id : null;
};
var templatePrivacy = [
    "public",
    "private",
    "friends", 
];
var extractHashtags = function(description) {
    return description.reduce(function(acc, tag) {
        if (tag.format === "text") return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stringToHashtag(tag.content)));
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat([
            tag
        ]);
    }, new Array());
};
var templatesExtractor = function(templates) {
    return templates.map(function(template) {
        var _created_by_user = template.created_by_user, username = _created_by_user.username, profile_pic = _created_by_user.profile_pic, followers = _created_by_user.followers, uid = _created_by_user.uid, follow_status = _created_by_user.follow_status;
        var original = profile_pic ? profile_pic.original : null;
        var ref;
        return _object_spread_props(_object_spread({}, singleTemplateExtractor(template)), {
            creator: {
                uid: uid,
                follow_status: (ref = followStatusMap[follow_status !== null && follow_status !== void 0 ? follow_status : 99]) !== null && ref !== void 0 ? ref : null,
                username: username,
                picture: original !== null && original !== void 0 ? original : null,
                followers: followers
            }
        });
    });
};
var singleExtractor = function(template) {
    var _created_by_user = template.created_by_user, username = _created_by_user.username, profile_pic = _created_by_user.profile_pic, followers = _created_by_user.followers, uid = _created_by_user.uid, follow_status = _created_by_user.follow_status;
    var original = profile_pic ? profile_pic.original : null;
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, singleTemplateExtractor(template)), {
        creator: {
            uid: uid,
            follow_status: (ref = followStatusMap[follow_status !== null && follow_status !== void 0 ? follow_status : 99]) !== null && ref !== void 0 ? ref : null,
            username: username,
            picture: original !== null && original !== void 0 ? original : null,
            followers: followers
        }
    });
};
var extractResponse = function(response) {
    if (!response.status) {
        console.error("/tutorials", response);
        throw "Status is false";
    }
    var tutorials = response.result.tutorials;
    return {
        templates: tutorials.map(singleExtractor)
    };
};
var singleTemplateExtractor = function(template) {
    var id = template.id, name = template.name, description = template.description, views = template.views, likes = template.likes, comments = template.comments, created_at = template.created_at, preview_webp_url = template.preview_webp_url, preview_image_url = template.preview_image_url, preview_gif_url = template.preview_gif_url, video_stream_small_url = template.video_stream_small_url, preview_video_stream_url = template.preview_video_stream_url, preview_thumbnail_url = template.preview_thumbnail_url, share_url = template.share_url, setups = template.setups, is_pro = template.is_pro, allow_comments = template.allow_comments, review_status = template.review_status, type = template.type, desc_tags = template.desc_tags, price = template.price, categories = template.categories, privacy = template.privacy;
    var formatted = getTaggedSlices(desc_tags, description);
    var pricing = {
        pricing: "free"
    };
    if (is_pro) pricing = {
        pricing: "pro"
    };
    else if (price > 0) pricing = {
        pricing: "coins",
        price: price
    };
    var created = Number(created_at);
    if (Number.isNaN(created)) throw new Error("Date is NaN");
    var categoryName = getCategoryName(categories);
    var categoryId = getCategoryId(categories);
    var video = video_stream_small_url || preview_video_stream_url;
    if (!video) {
        throw new Error("No video url");
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        privacy: templatePrivacy[privacy],
        id: id,
        name: name,
        description: formatted,
        likes: likes,
        comments: comments,
        created: created,
        share: share_url,
        preview: {
            webp: preview_webp_url,
            gif: preview_gif_url,
            jpg: preview_image_url
        },
        first: preview_thumbnail_url,
        views: views,
        setups: setups,
        video: video
    }, pricing), {
        category: categoryName,
        categoryId: categoryId,
        allowComments: allow_comments,
        reviewStatus: review_status !== null && review_status !== void 0 ? review_status : 0,
        isFeatured: type === 1
    });
};


/***/ }),

/***/ 3852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getUtmIds; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var UTM_KEY = "utm";
function getUtmIds() {
    var value = sessionStorage.getItem(UTM_KEY);
    if (value) {
        try {
            return JSON.parse(value);
        } catch (error) {
            console.error("Failed to parse UTM IDs from session storage", error);
            return null;
        }
    }
    return null;
}
var useUtmIdentifiers = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (router.isReady) {
            var _query = router.query, gclid = _query.gclid, utm_source = _query.utm_source, utm_campaign = _query.utm_campaign, utm_content = _query.utm_content, utm_term = _query.utm_term;
            var hasOneProperty = gclid || utm_source || utm_campaign || utm_content || utm_term;
            if (typeof gclid !== "object" && typeof utm_source !== "object" && typeof utm_campaign !== "object" && typeof utm_content !== "object" && typeof utm_term !== "object" && hasOneProperty) {
                var utmJson = {
                    gclid: gclid,
                    utm_campaign: utm_campaign,
                    utm_content: utm_content,
                    utm_source: utm_source,
                    utm_term: utm_term
                };
                sessionStorage.setItem(UTM_KEY, JSON.stringify(utmJson));
            }
        }
    }, [
        router.isReady,
        router.query
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useUtmIdentifiers);


/***/ }),

/***/ 2706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ APP_HOST; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(3454);
var APP_HOST = process.env.NEXT_PUBLIC_APP_HOST || "https://zoomerang.app";


/***/ }),

/***/ 6961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ getLoadedVideo; },
/* harmony export */   "Ge": function() { return /* binding */ extractUniformFrames; },
/* harmony export */   "bY": function() { return /* binding */ resizeDimensions; },
/* harmony export */   "fj": function() { return /* binding */ loadUrlToBlob; },
/* harmony export */   "jC": function() { return /* binding */ getVideoDimensions; },
/* harmony export */   "nr": function() { return /* binding */ getVideoDurationMillis; },
/* harmony export */   "oE": function() { return /* binding */ extractFramesFromVideo; },
/* harmony export */   "pz": function() { return /* binding */ getImageDimensions; },
/* harmony export */   "um": function() { return /* binding */ getLoadedImage; }
/* harmony export */ });
/* unused harmony exports ImageWithSkeleton, VideoWithSkeleton */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4165);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);








function extractUniformFrames(frames1, targetLength) {
    targetLength = Math.min(targetLength, frames1.length);
    var skip = Math.floor(frames1.length / targetLength);
    var result = [];
    for(var i = 0; i < frames1.length; i += skip){
        result.push(frames1[i]);
    }
    while(result.length > targetLength){
        result.pop();
    }
    return result;
}
function getVideoDurationMillis(videoFile) {
    return new Promise(function(resolve, reject) {
        var video = document.createElement("video");
        var videoUrl = URL.createObjectURL(videoFile);
        video.src = videoUrl;
        video.preload = "metadata";
        video.muted = true;
        video.load();
        video.onloadedmetadata = function() {
            resolve(video.duration * 1000);
        };
        video.onerror = function() {
            reject(frames);
        };
    });
}
function getVideoDimensions(videoFile) {
    return _getVideoDimensions.apply(this, arguments);
}
function _getVideoDimensions() {
    _getVideoDimensions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(videoFile) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var video = document.createElement("video");
                    var videoUrl = URL.createObjectURL(videoFile);
                    video.src = videoUrl;
                    video.preload = "metadata";
                    video.muted = true;
                    video.play();
                    video.onloadedmetadata = function() {
                        resolve({
                            width: video.videoWidth,
                            height: video.videoHeight
                        });
                    };
                    video.onerror = reject;
                })
            ];
        });
    });
    return _getVideoDimensions.apply(this, arguments);
}
function getImageDimensions(image) {
    return _getImageDimensions.apply(this, arguments);
}
function _getImageDimensions() {
    _getImageDimensions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(image) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var img = new Image();
                    img.src = URL.createObjectURL(image);
                    img.onload = function() {
                        resolve({
                            width: img.naturalWidth,
                            height: img.naturalHeight
                        });
                    };
                    img.onerror = reject;
                })
            ];
        });
    });
    return _getImageDimensions.apply(this, arguments);
}
function extractFramesFromVideo(videoFile, frameCount) {
    return new Promise(function(resolve, reject) {
        var video = document.createElement("video");
        var videoUrl = URL.createObjectURL(videoFile);
        video.src = videoUrl;
        video.preload = "metadata";
        video.muted = true;
        video.play().then(function() {
            return video.pause();
        });
        video.onloadedmetadata = function() {
            var duration = video.duration;
            var canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            var context = canvas.getContext("2d");
            if (!context) {
                reject(new Error("Could not get context"));
                return;
            }
            var frames1 = [];
            video.currentTime = 0;
            var delta = duration / frameCount;
            video.onseeked = function() {
                context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                canvas.toBlob(function(blob) {
                    if (blob === null) {
                        resolve({
                            keyframes: frames1,
                            duration: duration
                        });
                        return;
                    }
                    var source = URL.createObjectURL(blob);
                    var time = video.currentTime;
                    frames1.push({
                        source: source,
                        time: time
                    });
                    if (frames1.length >= frameCount) {
                        resolve({
                            keyframes: frames1,
                            duration: duration
                        });
                        return;
                    }
                    video.currentTime += delta;
                });
            };
            video.onerror = function() {
                reject(frames1);
            };
        };
    });
}
function loadUrlToBlob(url) {
    return _loadUrlToBlob.apply(this, arguments);
}
function _loadUrlToBlob() {
    _loadUrlToBlob = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
        var response, blob;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(url + "?")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    return [
                        2,
                        blob
                    ];
            }
        });
    });
    return _loadUrlToBlob.apply(this, arguments);
}
var ImageWithSkeleton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function ImageWithSkeleton(props, ref) {
    var src = props.src, className = props.className, onSuccess = props.onSuccess, onError = props.onError, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "onSuccess",
        "onError"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), url = _$ref[0], setUrl = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (url !== null) {
            return;
        }
        loadUrlToBlob(src).then(function(blob) {
            setUrl(URL.createObjectURL(blob));
            onSuccess && onSuccess();
        }).catch(function(e) {
            console.error(e);
            onError === null || onError === void 0 ? void 0 : onError(e);
        });
    }, [
        onError,
        onSuccess,
        src,
        url
    ]);
    if (url === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_1__/* .SizedSkeleton */ .xB, {
            className: className
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: ref,
        className: className,
        src: url,
        alt: "image skeleton"
    }, otherProps));
});
ImageWithSkeleton.displayName = "ImageWithSkeleton";
var VideoWithSkeleton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function VideoWithSkeleton(props, ref) {
    var src = props.src, className = props.className, onSuccess = props.onSuccess, onError = props.onError, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "onSuccess",
        "onError"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), url = _$ref[0], setUrl = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (url !== null) {
            return;
        }
        loadUrlToBlob(src).then(function(blob) {
            var videoBlob = new Blob([
                blob
            ], {
                type: "video/mp4"
            });
            setUrl(URL.createObjectURL(videoBlob));
            onSuccess && onSuccess();
        }).catch(function(e) {
            console.error(e);
            onError === null || onError === void 0 ? void 0 : onError(e);
        });
    }, [
        onError,
        onSuccess,
        src,
        url
    ]);
    if (url === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_skeleton__WEBPACK_IMPORTED_MODULE_1__/* .SizedSkeleton */ .xB, {
            className: className
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: ref,
        className: className,
        src: url
    }, otherProps));
});
function resizeDimensions(dimensions, max) {
    if (Math.max(dimensions.width, dimensions.height) < max) {
        return dimensions;
    }
    if (dimensions.width > dimensions.height) {
        return {
            width: Math.floor(max / dimensions.height * dimensions.width),
            height: max
        };
    }
    return {
        width: max,
        height: Math.floor(max / dimensions.width * dimensions.height)
    };
}
VideoWithSkeleton.displayName = "VideoWithSkeleton";
function getLoadedVideo(source) {
    return _getLoadedVideo.apply(this, arguments);
}
function _getLoadedVideo() {
    _getLoadedVideo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(source) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var video = document.createElement("video");
                    video.preload = "metadata";
                    var url = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob) ? URL.createObjectURL(source) : source;
                    video.src = url;
                    video.onloadedmetadata = function() {
                        resolve(video);
                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob)) {
                            URL.revokeObjectURL(url);
                        }
                    };
                    video.onerror = function(e) {
                        reject(e);
                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob)) {
                            URL.revokeObjectURL(url);
                        }
                    };
                })
            ];
        });
    });
    return _getLoadedVideo.apply(this, arguments);
}
function getLoadedImage(source) {
    return _getLoadedImage.apply(this, arguments);
}
function _getLoadedImage() {
    _getLoadedImage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(source) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var image = document.createElement("img");
                    var url = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob) ? URL.createObjectURL(source) : source;
                    image.src = url;
                    image.onload = function() {
                        resolve(image);
                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob)) {
                            URL.revokeObjectURL(url);
                        }
                    };
                    image.onerror = function(e) {
                        reject(e);
                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(source, Blob)) {
                            URL.revokeObjectURL(url);
                        }
                    };
                })
            ];
        });
    });
    return _getLoadedImage.apply(this, arguments);
}


/***/ }),

/***/ 1876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 9870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"appear-bottom":"styles_appear-bottom__QaJeP","disappear-top":"styles_disappear-top__FGufh","appear-bottom-opaque":"styles_appear-bottom-opaque__I_TO3","appear-bottom-short":"styles_appear-bottom-short__bpbrg","appear-bottom-short-opaque":"styles_appear-bottom-short-opaque__ES2BZ","appear-bottom-long":"styles_appear-bottom-long__I_uC_","disappear-top-short":"styles_disappear-top-short__2vCss","disappear-top-short-opaque":"styles_disappear-top-short-opaque__Gfl4m","appear-in-place":"styles_appear-in-place__ylFKz"};

/***/ }),

/***/ 906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3461:
/***/ (function(module) {

var __dirname = "/";
(function(){if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.endianness=function(){return"LE"};e.hostname=function(){if(typeof location!=="undefined"){return location.hostname}else return""};e.loadavg=function(){return[]};e.uptime=function(){return 0};e.freemem=function(){return Number.MAX_VALUE};e.totalmem=function(){return Number.MAX_VALUE};e.cpus=function(){return[]};e.type=function(){return"Browser"};e.release=function(){if(typeof navigator!=="undefined"){return navigator.appVersion}return""};e.networkInterfaces=e.getNetworkInterfaces=function(){return{}};e.arch=function(){return"javascript"};e.platform=function(){return"browser"};e.tmpdir=e.tmpDir=function(){return"/tmp"};e.EOL="\n";e.homedir=function(){return"/"}}();module.exports=n})();

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 4059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ QRCodeCanvas; },
/* harmony export */   "ZP": function() { return /* binding */ QRCode; }
/* harmony export */ });
/* unused harmony export QRCodeSVG */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.tsx


// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var qrcodegen;
((qrcodegen2) => {
  const _QrCode = class {
    constructor(version, errorCorrectionLevel, dataCodewords, msk) {
      this.version = version;
      this.errorCorrectionLevel = errorCorrectionLevel;
      this.modules = [];
      this.isFunction = [];
      if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (msk < -1 || msk > 7)
        throw new RangeError("Mask value out of range");
      this.size = version * 4 + 17;
      let row = [];
      for (let i = 0; i < this.size; i++)
        row.push(false);
      for (let i = 0; i < this.size; i++) {
        this.modules.push(row.slice());
        this.isFunction.push(row.slice());
      }
      this.drawFunctionPatterns();
      const allCodewords = this.addEccAndInterleave(dataCodewords);
      this.drawCodewords(allCodewords);
      if (msk == -1) {
        let minPenalty = 1e9;
        for (let i = 0; i < 8; i++) {
          this.applyMask(i);
          this.drawFormatBits(i);
          const penalty = this.getPenaltyScore();
          if (penalty < minPenalty) {
            msk = i;
            minPenalty = penalty;
          }
          this.applyMask(i);
        }
      }
      assert(0 <= msk && msk <= 7);
      this.mask = msk;
      this.applyMask(msk);
      this.drawFormatBits(msk);
      this.isFunction = [];
    }
    static encodeText(text, ecl) {
      const segs = qrcodegen2.QrSegment.makeSegments(text);
      return _QrCode.encodeSegments(segs, ecl);
    }
    static encodeBinary(data, ecl) {
      const seg = qrcodegen2.QrSegment.makeBytes(data);
      return _QrCode.encodeSegments([seg], ecl);
    }
    static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
      if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7)
        throw new RangeError("Invalid value");
      let version;
      let dataUsedBits;
      for (version = minVersion; ; version++) {
        const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
        const usedBits = QrSegment.getTotalBits(segs, version);
        if (usedBits <= dataCapacityBits2) {
          dataUsedBits = usedBits;
          break;
        }
        if (version >= maxVersion)
          throw new RangeError("Data too long");
      }
      for (const newEcl of [_QrCode.Ecc.MEDIUM, _QrCode.Ecc.QUARTILE, _QrCode.Ecc.HIGH]) {
        if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8)
          ecl = newEcl;
      }
      let bb = [];
      for (const seg of segs) {
        appendBits(seg.mode.modeBits, 4, bb);
        appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
        for (const b of seg.getData())
          bb.push(b);
      }
      assert(bb.length == dataUsedBits);
      const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
      assert(bb.length <= dataCapacityBits);
      appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
      appendBits(0, (8 - bb.length % 8) % 8, bb);
      assert(bb.length % 8 == 0);
      for (let padByte = 236; bb.length < dataCapacityBits; padByte ^= 236 ^ 17)
        appendBits(padByte, 8, bb);
      let dataCodewords = [];
      while (dataCodewords.length * 8 < bb.length)
        dataCodewords.push(0);
      bb.forEach((b, i) => dataCodewords[i >>> 3] |= b << 7 - (i & 7));
      return new _QrCode(version, ecl, dataCodewords, mask);
    }
    getModule(x, y) {
      return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
    }
    getModules() {
      return this.modules;
    }
    drawFunctionPatterns() {
      for (let i = 0; i < this.size; i++) {
        this.setFunctionModule(6, i, i % 2 == 0);
        this.setFunctionModule(i, 6, i % 2 == 0);
      }
      this.drawFinderPattern(3, 3);
      this.drawFinderPattern(this.size - 4, 3);
      this.drawFinderPattern(3, this.size - 4);
      const alignPatPos = this.getAlignmentPatternPositions();
      const numAlign = alignPatPos.length;
      for (let i = 0; i < numAlign; i++) {
        for (let j = 0; j < numAlign; j++) {
          if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0))
            this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
        }
      }
      this.drawFormatBits(0);
      this.drawVersion();
    }
    drawFormatBits(mask) {
      const data = this.errorCorrectionLevel.formatBits << 3 | mask;
      let rem = data;
      for (let i = 0; i < 10; i++)
        rem = rem << 1 ^ (rem >>> 9) * 1335;
      const bits = (data << 10 | rem) ^ 21522;
      assert(bits >>> 15 == 0);
      for (let i = 0; i <= 5; i++)
        this.setFunctionModule(8, i, getBit(bits, i));
      this.setFunctionModule(8, 7, getBit(bits, 6));
      this.setFunctionModule(8, 8, getBit(bits, 7));
      this.setFunctionModule(7, 8, getBit(bits, 8));
      for (let i = 9; i < 15; i++)
        this.setFunctionModule(14 - i, 8, getBit(bits, i));
      for (let i = 0; i < 8; i++)
        this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
      for (let i = 8; i < 15; i++)
        this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
      this.setFunctionModule(8, this.size - 8, true);
    }
    drawVersion() {
      if (this.version < 7)
        return;
      let rem = this.version;
      for (let i = 0; i < 12; i++)
        rem = rem << 1 ^ (rem >>> 11) * 7973;
      const bits = this.version << 12 | rem;
      assert(bits >>> 18 == 0);
      for (let i = 0; i < 18; i++) {
        const color = getBit(bits, i);
        const a = this.size - 11 + i % 3;
        const b = Math.floor(i / 3);
        this.setFunctionModule(a, b, color);
        this.setFunctionModule(b, a, color);
      }
    }
    drawFinderPattern(x, y) {
      for (let dy = -4; dy <= 4; dy++) {
        for (let dx = -4; dx <= 4; dx++) {
          const dist = Math.max(Math.abs(dx), Math.abs(dy));
          const xx = x + dx;
          const yy = y + dy;
          if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size)
            this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
        }
      }
    }
    drawAlignmentPattern(x, y) {
      for (let dy = -2; dy <= 2; dy++) {
        for (let dx = -2; dx <= 2; dx++)
          this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
      }
    }
    setFunctionModule(x, y, isDark) {
      this.modules[y][x] = isDark;
      this.isFunction[y][x] = true;
    }
    addEccAndInterleave(data) {
      const ver = this.version;
      const ecl = this.errorCorrectionLevel;
      if (data.length != _QrCode.getNumDataCodewords(ver, ecl))
        throw new RangeError("Invalid argument");
      const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
      const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
      const numShortBlocks = numBlocks - rawCodewords % numBlocks;
      const shortBlockLen = Math.floor(rawCodewords / numBlocks);
      let blocks = [];
      const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
      for (let i = 0, k = 0; i < numBlocks; i++) {
        let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
        k += dat.length;
        const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
        if (i < numShortBlocks)
          dat.push(0);
        blocks.push(dat.concat(ecc));
      }
      let result = [];
      for (let i = 0; i < blocks[0].length; i++) {
        blocks.forEach((block, j) => {
          if (i != shortBlockLen - blockEccLen || j >= numShortBlocks)
            result.push(block[i]);
        });
      }
      assert(result.length == rawCodewords);
      return result;
    }
    drawCodewords(data) {
      if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let i = 0;
      for (let right = this.size - 1; right >= 1; right -= 2) {
        if (right == 6)
          right = 5;
        for (let vert = 0; vert < this.size; vert++) {
          for (let j = 0; j < 2; j++) {
            const x = right - j;
            const upward = (right + 1 & 2) == 0;
            const y = upward ? this.size - 1 - vert : vert;
            if (!this.isFunction[y][x] && i < data.length * 8) {
              this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
              i++;
            }
          }
        }
      }
      assert(i == data.length * 8);
    }
    applyMask(mask) {
      if (mask < 0 || mask > 7)
        throw new RangeError("Mask value out of range");
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          let invert;
          switch (mask) {
            case 0:
              invert = (x + y) % 2 == 0;
              break;
            case 1:
              invert = y % 2 == 0;
              break;
            case 2:
              invert = x % 3 == 0;
              break;
            case 3:
              invert = (x + y) % 3 == 0;
              break;
            case 4:
              invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
              break;
            case 5:
              invert = x * y % 2 + x * y % 3 == 0;
              break;
            case 6:
              invert = (x * y % 2 + x * y % 3) % 2 == 0;
              break;
            case 7:
              invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          if (!this.isFunction[y][x] && invert)
            this.modules[y][x] = !this.modules[y][x];
        }
      }
    }
    getPenaltyScore() {
      let result = 0;
      for (let y = 0; y < this.size; y++) {
        let runColor = false;
        let runX = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++) {
          if (this.modules[y][x] == runColor) {
            runX++;
            if (runX == 5)
              result += _QrCode.PENALTY_N1;
            else if (runX > 5)
              result++;
          } else {
            this.finderPenaltyAddHistory(runX, runHistory);
            if (!runColor)
              result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runX = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let x = 0; x < this.size; x++) {
        let runColor = false;
        let runY = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let y = 0; y < this.size; y++) {
          if (this.modules[y][x] == runColor) {
            runY++;
            if (runY == 5)
              result += _QrCode.PENALTY_N1;
            else if (runY > 5)
              result++;
          } else {
            this.finderPenaltyAddHistory(runY, runHistory);
            if (!runColor)
              result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runY = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let y = 0; y < this.size - 1; y++) {
        for (let x = 0; x < this.size - 1; x++) {
          const color = this.modules[y][x];
          if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1])
            result += _QrCode.PENALTY_N2;
        }
      }
      let dark = 0;
      for (const row of this.modules)
        dark = row.reduce((sum, color) => sum + (color ? 1 : 0), dark);
      const total = this.size * this.size;
      const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      assert(0 <= k && k <= 9);
      result += k * _QrCode.PENALTY_N4;
      assert(0 <= result && result <= 2568888);
      return result;
    }
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      else {
        const numAlign = Math.floor(this.version / 7) + 2;
        const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
        let result = [6];
        for (let pos = this.size - 7; result.length < numAlign; pos -= step)
          result.splice(1, 0, pos);
        return result;
      }
    }
    static getNumRawDataModules(ver) {
      if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let result = (16 * ver + 128) * ver + 64;
      if (ver >= 2) {
        const numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7)
          result -= 36;
      }
      assert(208 <= result && result <= 29648);
      return result;
    }
    static getNumDataCodewords(ver, ecl) {
      return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
    }
    static reedSolomonComputeDivisor(degree) {
      if (degree < 1 || degree > 255)
        throw new RangeError("Degree out of range");
      let result = [];
      for (let i = 0; i < degree - 1; i++)
        result.push(0);
      result.push(1);
      let root = 1;
      for (let i = 0; i < degree; i++) {
        for (let j = 0; j < result.length; j++) {
          result[j] = _QrCode.reedSolomonMultiply(result[j], root);
          if (j + 1 < result.length)
            result[j] ^= result[j + 1];
        }
        root = _QrCode.reedSolomonMultiply(root, 2);
      }
      return result;
    }
    static reedSolomonComputeRemainder(data, divisor) {
      let result = divisor.map((_) => 0);
      for (const b of data) {
        const factor = b ^ result.shift();
        result.push(0);
        divisor.forEach((coef, i) => result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
      }
      return result;
    }
    static reedSolomonMultiply(x, y) {
      if (x >>> 8 != 0 || y >>> 8 != 0)
        throw new RangeError("Byte out of range");
      let z = 0;
      for (let i = 7; i >= 0; i--) {
        z = z << 1 ^ (z >>> 7) * 285;
        z ^= (y >>> i & 1) * x;
      }
      assert(z >>> 8 == 0);
      return z;
    }
    finderPenaltyCountPatterns(runHistory) {
      const n = runHistory[1];
      assert(n <= this.size * 3);
      const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
      return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }
    finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
      if (currentRunColor) {
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        currentRunLength = 0;
      }
      currentRunLength += this.size;
      this.finderPenaltyAddHistory(currentRunLength, runHistory);
      return this.finderPenaltyCountPatterns(runHistory);
    }
    finderPenaltyAddHistory(currentRunLength, runHistory) {
      if (runHistory[0] == 0)
        currentRunLength += this.size;
      runHistory.pop();
      runHistory.unshift(currentRunLength);
    }
  };
  let QrCode = _QrCode;
  QrCode.MIN_VERSION = 1;
  QrCode.MAX_VERSION = 40;
  QrCode.PENALTY_N1 = 3;
  QrCode.PENALTY_N2 = 3;
  QrCode.PENALTY_N3 = 40;
  QrCode.PENALTY_N4 = 10;
  QrCode.ECC_CODEWORDS_PER_BLOCK = [
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
  ];
  QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
  ];
  qrcodegen2.QrCode = QrCode;
  function appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0)
      throw new RangeError("Value out of range");
    for (let i = len - 1; i >= 0; i--)
      bb.push(val >>> i & 1);
  }
  function getBit(x, i) {
    return (x >>> i & 1) != 0;
  }
  function assert(cond) {
    if (!cond)
      throw new Error("Assertion error");
  }
  const _QrSegment = class {
    constructor(mode, numChars, bitData) {
      this.mode = mode;
      this.numChars = numChars;
      this.bitData = bitData;
      if (numChars < 0)
        throw new RangeError("Invalid argument");
      this.bitData = bitData.slice();
    }
    static makeBytes(data) {
      let bb = [];
      for (const b of data)
        appendBits(b, 8, bb);
      return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
    }
    static makeNumeric(digits) {
      if (!_QrSegment.isNumeric(digits))
        throw new RangeError("String contains non-numeric characters");
      let bb = [];
      for (let i = 0; i < digits.length; ) {
        const n = Math.min(digits.length - i, 3);
        appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
        i += n;
      }
      return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
    }
    static makeAlphanumeric(text) {
      if (!_QrSegment.isAlphanumeric(text))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let bb = [];
      let i;
      for (i = 0; i + 2 <= text.length; i += 2) {
        let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        appendBits(temp, 11, bb);
      }
      if (i < text.length)
        appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
      return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
    }
    static makeSegments(text) {
      if (text == "")
        return [];
      else if (_QrSegment.isNumeric(text))
        return [_QrSegment.makeNumeric(text)];
      else if (_QrSegment.isAlphanumeric(text))
        return [_QrSegment.makeAlphanumeric(text)];
      else
        return [_QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))];
    }
    static makeEci(assignVal) {
      let bb = [];
      if (assignVal < 0)
        throw new RangeError("ECI assignment value out of range");
      else if (assignVal < 1 << 7)
        appendBits(assignVal, 8, bb);
      else if (assignVal < 1 << 14) {
        appendBits(2, 2, bb);
        appendBits(assignVal, 14, bb);
      } else if (assignVal < 1e6) {
        appendBits(6, 3, bb);
        appendBits(assignVal, 21, bb);
      } else
        throw new RangeError("ECI assignment value out of range");
      return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
    }
    static isNumeric(text) {
      return _QrSegment.NUMERIC_REGEX.test(text);
    }
    static isAlphanumeric(text) {
      return _QrSegment.ALPHANUMERIC_REGEX.test(text);
    }
    getData() {
      return this.bitData.slice();
    }
    static getTotalBits(segs, version) {
      let result = 0;
      for (const seg of segs) {
        const ccbits = seg.mode.numCharCountBits(version);
        if (seg.numChars >= 1 << ccbits)
          return Infinity;
        result += 4 + ccbits + seg.bitData.length;
      }
      return result;
    }
    static toUtf8ByteArray(str) {
      str = encodeURI(str);
      let result = [];
      for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) != "%")
          result.push(str.charCodeAt(i));
        else {
          result.push(parseInt(str.substr(i + 1, 2), 16));
          i += 2;
        }
      }
      return result;
    }
  };
  let QrSegment = _QrSegment;
  QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
  QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
  QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2) => {
  let QrCode;
  ((QrCode2) => {
    const _Ecc = class {
      constructor(ordinal, formatBits) {
        this.ordinal = ordinal;
        this.formatBits = formatBits;
      }
    };
    let Ecc = _Ecc;
    Ecc.LOW = new _Ecc(0, 1);
    Ecc.MEDIUM = new _Ecc(1, 0);
    Ecc.QUARTILE = new _Ecc(2, 3);
    Ecc.HIGH = new _Ecc(3, 2);
    QrCode2.Ecc = Ecc;
  })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2) => {
  let QrSegment;
  ((QrSegment2) => {
    const _Mode = class {
      constructor(modeBits, numBitsCharCount) {
        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
      }
      numCharCountBits(ver) {
        return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
      }
    };
    let Mode = _Mode;
    Mode.NUMERIC = new _Mode(1, [10, 12, 14]);
    Mode.ALPHANUMERIC = new _Mode(2, [9, 11, 13]);
    Mode.BYTE = new _Mode(4, [8, 16, 16]);
    Mode.KANJI = new _Mode(8, [8, 10, 12]);
    Mode.ECI = new _Mode(7, [0, 0, 0]);
    QrSegment2.Mode = Mode;
  })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;

// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var ERROR_LEVEL_MAP = {
  L: qrcodegen_default.QrCode.Ecc.LOW,
  M: qrcodegen_default.QrCode.Ecc.MEDIUM,
  Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
  H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
  const ops = [];
  modules.forEach(function(row, y) {
    let start = null;
    row.forEach(function(cell, x) {
      if (!cell && start !== null) {
        ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
        start = null;
        return;
      }
      if (x === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
        } else {
          ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
        }
        return;
      }
      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join("");
}
function excavateModules(modules, excavation) {
  return modules.slice().map((row, y) => {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }
    return row.map((cell, x) => {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }
      return false;
    });
  });
}
function getImageSettings(cells, size, includeMargin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  const scale = numCells / size;
  const w = (imageSettings.width || defaultSize) * scale;
  const h = (imageSettings.height || defaultSize) * scale;
  const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  let excavation = null;
  if (imageSettings.excavate) {
    let floorX = Math.floor(x);
    let floorY = Math.floor(y);
    let ceilW = Math.ceil(w + x - floorX);
    let ceilH = Math.ceil(h + y - floorY);
    excavation = { x: floorX, y: floorY, w: ceilW, h: ceilH };
  }
  return { x, y, h, w, excavation };
}
var SUPPORTS_PATH2D = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }
  return true;
}();
function QRCodeCanvas(props) {
  const _a = props, {
    value,
    size = DEFAULT_SIZE,
    level = DEFAULT_LEVEL,
    bgColor = DEFAULT_BGCOLOR,
    fgColor = DEFAULT_FGCOLOR,
    includeMargin = DEFAULT_INCLUDEMARGIN,
    style,
    imageSettings
  } = _a, otherProps = __objRest(_a, [
    "value",
    "size",
    "level",
    "bgColor",
    "fgColor",
    "includeMargin",
    "style",
    "imageSettings"
  ]);
  const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
  const _canvas = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const _image = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [isImgLoaded, setIsImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (_canvas.current != null) {
      const canvas = _canvas.current;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }
      let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
      const margin = includeMargin ? MARGIN_SIZE : 0;
      const numCells = cells.length + margin * 2;
      const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
      const image = _image.current;
      const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }
      const pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      const scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;
      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function(row, rdx) {
          row.forEach(function(cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setIsImageLoaded(false);
  }, [imgSrc]);
  const canvasStyle = __spreadValues({ height: size, width: size }, style);
  let img = null;
  if (imgSrc != null) {
    img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: { display: "none" },
      onLoad: () => {
        setIsImageLoaded(true);
      },
      ref: _image
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("canvas", __spreadValues({
    style: canvasStyle,
    height: size,
    width: size,
    ref: _canvas
  }, otherProps)), img);
}
function QRCodeSVG(props) {
  const _a = props, {
    value,
    size = DEFAULT_SIZE,
    level = DEFAULT_LEVEL,
    bgColor = DEFAULT_BGCOLOR,
    fgColor = DEFAULT_FGCOLOR,
    includeMargin = DEFAULT_INCLUDEMARGIN,
    imageSettings
  } = _a, otherProps = __objRest(_a, [
    "value",
    "size",
    "level",
    "bgColor",
    "fgColor",
    "includeMargin",
    "imageSettings"
  ]);
  let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
  let image = null;
  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cells = excavateModules(cells, calculatedImageSettings.excavation);
    }
    image = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("image", {
      xlinkHref: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none"
    });
  }
  const fgPath = generatePath(cells, margin);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", __spreadValues({
    height: size,
    width: size,
    viewBox: `0 0 ${numCells} ${numCells}`
  }, otherProps), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: bgColor,
    d: `M0,0 h${numCells}v${numCells}H0z`,
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
}
var QRCode = (props) => {
  const _a = props, { renderAs } = _a, otherProps = __objRest(_a, ["renderAs"]);
  if (renderAs === "svg") {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QRCodeSVG, __spreadValues({}, otherProps));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};



/***/ }),

/***/ 2512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ useDropzone; }
});

// UNUSED EXPORTS: ErrorCode, default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file-selector.js


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        return (0,tslib_es6.__generator)(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var files;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var items, files;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(acc), false), (0,tslib_es6.__read)((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        return (0,tslib_es6.__generator)(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                var files, err_1, items;
                return (0,tslib_es6.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        return (0,tslib_es6.__generator)(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(8363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || (0,es/* default */.Z)(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function isKindFile(item) {
  return _typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function es_toConsumableArray(arr) { return es_arrayWithoutHoles(arr) || es_iterableToArray(arr) || es_unsupportedIterableToArray(arr) || es_nonIterableSpread(); }

function es_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function es_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return es_arrayLikeToArray(arr); }

function es_slicedToArray(arr, i) { return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest(); }

function es_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return es_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen); }

function es_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function es_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function es_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es_ownKeys(Object(source), !0).forEach(function (key) { es_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  (0,react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/react.createElement(react.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: (prop_types_default()).func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: prop_types_default().objectOf(prop_types_default().arrayOf((prop_types_default()).string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: (prop_types_default()).bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (prop_types_default()).bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: (prop_types_default()).bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: (prop_types_default()).bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: (prop_types_default()).bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: (prop_types_default()).bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: (prop_types_default()).number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: (prop_types_default()).number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: (prop_types_default()).number,

  /**
   * Enable/disable the dropzone
   */
  disabled: (prop_types_default()).bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: (prop_types_default()).func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: (prop_types_default()).func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: (prop_types_default()).func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: (prop_types_default()).bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: (prop_types_default()).func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: (prop_types_default()).func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: (prop_types_default()).func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: (prop_types_default()).func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: (prop_types_default()).func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = es_objectSpread(es_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = (0,react.useMemo)(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = (0,react.useMemo)(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = (0,react.useMemo)(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0,react.useMemo)(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = es_slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = (0,react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = (0,react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  (0,react.useEffect)(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = (0,react.useCallback)(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(es_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0,react.useCallback)(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = es_slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = (0,react.useCallback)(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = (0,react.useCallback)(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = (0,react.useCallback)(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,react.useMemo)(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return es_objectSpread(es_objectSpread(es_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = es_defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return es_objectSpread(es_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return es_objectSpread(es_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return es_objectSpread(es_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return es_objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),

/***/ 259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pm": function() { return /* binding */ h; },
/* harmony export */   "xX": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports GoogleReCaptcha, GoogleReCaptchaConsumer, GoogleReCaptchaContext, withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* provided dependency */ var process = __webpack_require__(3454);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e,t,r,o){return new(r||(r=Promise))((function(n,a){function c(e){try{s(o.next(e))}catch(e){a(e)}}function i(e){try{s(o.throw(e))}catch(e){a(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(c,i)}s((o=o.apply(e,t||[])).next())}))}function l(e,t){var r,o,n,a,c={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function i(a){return function(i){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return c.label++,{value:a[1],done:!1};case 5:c.label++,o=a[1],a=[0];continue;case 7:a=c.ops.pop(),c.trys.pop();continue;default:if(!(n=c.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){c=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){c.label=a[1];break}if(6===a[0]&&c.label<n[1]){c.label=n[1],n=a;break}if(n&&c.label<n[2]){c.label=n[2],c.ops.push(a);break}n[2]&&c.ops.pop(),c.trys.pop();continue}a=t.call(e,c)}catch(e){a=[6,e],o=0}finally{r=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,i])}}}var f,p=function(e){var t;e?function(e){if(e)for(;e.lastChild;)e.lastChild.remove()}("string"==typeof e?document.getElementById(e):e):(t=document.querySelector(".grecaptcha-badge"))&&t.parentNode&&document.body.removeChild(t.parentNode)},d=function(e,t){p(t),window.___grecaptcha_cfg=void 0;var r=document.querySelector("#"+e);r&&r.remove(),function(){var e=document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');e&&e.remove()}()},y=function(e){var t=e.render,r=e.onLoadCallbackName,o=e.language,n=e.onLoad,a=e.useRecaptchaNet,c=e.useEnterprise,i=e.scriptProps,s=void 0===i?{}:i,u=s.nonce,l=void 0===u?"":u,f=s.defer,p=void 0!==f&&f,d=s.async,y=void 0!==d&&d,m=s.id,v=void 0===m?"":m,b=s.appendTo,h=v||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(h))n();else{var g=function(e){return"https://www."+(e.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/"+(e.useEnterprise?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:a}),S=document.createElement("script");S.id=h,S.src=g+"?render="+t+("explicit"===t?"&onload="+r:"")+(o?"&hl="+o:""),l&&(S.nonce=l),S.defer=!!p,S.async=!!y,S.onload=n,("body"===b?document.body:document.getElementsByTagName("head")[0]).appendChild(S)}},m=function(e){"undefined"!=typeof process&&!!process.env&&"production"!=="production"||console.warn(e)};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var v=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),b=v.Consumer;function h(t){var i=t.reCaptchaKey,u=t.useEnterprise,l=void 0!==u&&u,p=t.useRecaptchaNet,b=void 0!==p&&p,h=t.scriptProps,g=t.language,S=t.container,w=t.children,$=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),C=$[0],P=$[1],x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(i),E=JSON.stringify(h),R=JSON.stringify(null==S?void 0:S.parameters);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3",t=(null==h?void 0:h.onLoadCallbackName)||"onRecaptchaLoadCallback";window[t]=function(){var e=l?window.grecaptcha.enterprise:window.grecaptcha,t=s({badge:"inline",size:"invisible",sitekey:i},(null==S?void 0:S.parameters)||{});x.current=e.render(null==S?void 0:S.element,t)};return y({render:(null==S?void 0:S.element)?"explicit":i,onLoadCallbackName:t,useEnterprise:l,useRecaptchaNet:b,scriptProps:h,language:g,onLoad:function(){if(window&&window.grecaptcha){var e=l?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){P(e)}))}else m("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)},onError:function(){m("Error loading google recaptcha script")}}),function(){d(e,null==S?void 0:S.element)}}m("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[l,b,E,R,g,i,null==S?void 0:S.element]);var M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((function(e){if(!C||!C.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return C.execute(x.current,{action:e})}),[C,x]),N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{executeRecaptcha:C?M:void 0,container:null==S?void 0:S.element}}),[M,C,null==S?void 0:S.element]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(v.Provider,{value:N},w)}var g=function(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(v)};function S(t){var r=this,o=t.action,a=t.onVerify,c=t.refreshReCaptcha,i=g();n((function(){var e=i.executeRecaptcha;if(e){u(r,void 0,void 0,(function(){var t;return l(this,(function(r){switch(r.label){case 0:return[4,e(o)];case 1:return t=r.sent(),a?(a(t),[2]):(m("Please define an onVerify function"),[2])}}))}))}}),[o,a,c,i]);var s=i.container;return"string"==typeof s?e.createElement("div",{id:s}):null}function w(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var $="function"==typeof Symbol&&Symbol.for,C=$?Symbol.for("react.element"):60103,P=$?Symbol.for("react.portal"):60106,x=$?Symbol.for("react.fragment"):60107,E=$?Symbol.for("react.strict_mode"):60108,R=$?Symbol.for("react.profiler"):60114,M=$?Symbol.for("react.provider"):60109,N=$?Symbol.for("react.context"):60110,O=$?Symbol.for("react.async_mode"):60111,_=$?Symbol.for("react.concurrent_mode"):60111,T=$?Symbol.for("react.forward_ref"):60112,j=$?Symbol.for("react.suspense"):60113,L=$?Symbol.for("react.suspense_list"):60120,k=$?Symbol.for("react.memo"):60115,F=$?Symbol.for("react.lazy"):60116,A=$?Symbol.for("react.block"):60121,V=$?Symbol.for("react.fundamental"):60117,z=$?Symbol.for("react.responder"):60118,G=$?Symbol.for("react.scope"):60119;function I(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case C:switch(e=e.type){case O:case _:case x:case R:case E:case j:return e;default:switch(e=e&&e.$$typeof){case N:case T:case F:case k:case M:return e;default:return t}}case P:return t}}}function D(e){return I(e)===_}var q={AsyncMode:O,ConcurrentMode:_,ContextConsumer:N,ContextProvider:M,Element:C,ForwardRef:T,Fragment:x,Lazy:F,Memo:k,Portal:P,Profiler:R,StrictMode:E,Suspense:j,isAsyncMode:function(e){return D(e)||I(e)===O},isConcurrentMode:D,isContextConsumer:function(e){return I(e)===N},isContextProvider:function(e){return I(e)===M},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===C},isForwardRef:function(e){return I(e)===T},isFragment:function(e){return I(e)===x},isLazy:function(e){return I(e)===F},isMemo:function(e){return I(e)===k},isPortal:function(e){return I(e)===P},isProfiler:function(e){return I(e)===R},isStrictMode:function(e){return I(e)===E},isSuspense:function(e){return I(e)===j},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===x||e===_||e===R||e===E||e===j||e===L||"object"==typeof e&&null!==e&&(e.$$typeof===F||e.$$typeof===k||e.$$typeof===M||e.$$typeof===N||e.$$typeof===T||e.$$typeof===V||e.$$typeof===z||e.$$typeof===G||e.$$typeof===A)},typeOf:I},B=w((function(e,t){ false&&0})),J=(B.AsyncMode,B.ConcurrentMode,B.ContextConsumer,B.ContextProvider,B.Element,B.ForwardRef,B.Fragment,B.Lazy,B.Memo,B.Portal,B.Profiler,B.StrictMode,B.Suspense,B.isAsyncMode,B.isConcurrentMode,B.isContextConsumer,B.isContextProvider,B.isElement,B.isForwardRef,B.isFragment,B.isLazy,B.isMemo,B.isPortal,B.isProfiler,B.isStrictMode,B.isSuspense,B.isValidElementType,B.typeOf,w((function(e){ true?e.exports=q:0}))),K={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},U={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},Q={};function W(e){return J.isMemo(e)?H:Q[e.$$typeof]||K}Q[J.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},Q[J.Memo]=H;var X=Object.defineProperty,Y=Object.getOwnPropertyNames,Z=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,re=Object.prototype;var oe=function e(t,r,o){if("string"!=typeof r){if(re){var n=te(r);n&&n!==re&&e(t,n,o)}var a=Y(r);Z&&(a=a.concat(Z(r)));for(var c=W(t),i=W(r),s=0;s<a.length;++s){var u=a[s];if(!(U[u]||o&&o[u]||i&&i[u]||c&&c[u])){var l=ee(r,u);try{X(t,u,l)}catch(e){}}}}return t},ne=function(t){var r=function(r){return e.createElement(b,null,(function(o){return e.createElement(t,s({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",oe(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 5399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var clarityInit = __webpack_require__(9563);

function clarity() {
  var params = Array.prototype.slice.call(arguments);
  if (!window.clarity) {
    throw new Error("Clarity is not initialized");
  }

  window.clarity.apply(undefined, params);
}

function init(id) {
  clarityInit(id);
}

function hasStarted() {
  return typeof window.clarity === "function";
}

function identify(userId, properties) {
  clarity("identify", userId, properties);
}

function consent() {
  clarity("consent");
}

function setTag(key, value) {
  clarity("set", key, value);
}

function upgrade(reason) {
  clarity("upgrade", reason);
}

module.exports = {
  clarity: {
    init,
    hasStarted,
    identify,
    consent,
    setTag,
    upgrade,
  },
};


/***/ }),

/***/ 9563:
/***/ (function(module) {

module.exports = function (id) {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
};


/***/ }),

/***/ 9852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2288);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 6747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(746);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6755);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 6997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2288);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 1909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 68:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2288);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(2288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(1909);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(1216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(2943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutation.js




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,esm_extends/* default */.Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,logger/* getLogger */.j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new retryer/* Retryer */.m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,esm_extends/* default */.Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,esm_extends/* default */.Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,esm_extends/* default */.Z)({}, state, action.state);

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(9852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(68);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(6997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9852);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2288);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 2943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 6755:
/***/ (function() {



/***/ }),

/***/ 2288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationArgs, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return _extends({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return _extends({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return _extends({}, arg2, {
      mutationFn: arg1
    });
  }

  return _extends({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 8767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2409);



/***/ }),

/***/ 2409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useIsFetching, useIsMutating, useMutation, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(1909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(2288);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(9852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(2943);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(1216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(6997);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 2337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ ResponsiveMasonry; },
  "Z": function() { return /* binding */ es; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/Masonry/index.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var Masonry = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Masonry, _React$Component);

  function Masonry() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Masonry.prototype;

  _proto.getColumns = function getColumns() {
    var _this$props = this.props,
        children = _this$props.children,
        columnsCount = _this$props.columnsCount;
    var columns = Array.from({
      length: columnsCount
    }, function () {
      return [];
    });
    react.Children.forEach(children, function (child, index) {
      if (child && react.isValidElement(child)) {
        columns[index % columnsCount].push(child);
      }
    });
    return columns;
  };

  _proto.renderColumns = function renderColumns() {
    var gutter = this.props.gutter;
    return this.getColumns().map(function (column, i) {
      return /*#__PURE__*/react.createElement("div", {
        key: i,
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignContent: "stretch",
          flex: 1,
          width: 0,
          gap: gutter
        }
      }, column.map(function (item) {
        return item;
      }));
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        gutter = _this$props2.gutter,
        className = _this$props2.className,
        style = _this$props2.style;
    return /*#__PURE__*/react.createElement("div", {
      style: _extends({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "stretch",
        boxSizing: "border-box",
        width: "100%",
        gap: gutter
      }, style),
      className: className
    }, this.renderColumns());
  };

  return Masonry;
}(react.Component);

Masonry.propTypes =  false ? 0 : {};
Masonry.defaultProps = {
  columnsCount: 3,
  gutter: "0",
  className: null,
  style: {}
};
/* harmony default export */ var es_Masonry = (Masonry);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/ResponsiveMasonry/index.js


var DEFAULT_COLUMNS_COUNT = 1;
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;

var useHasMounted = function useHasMounted() {
  var _useState = (0,react.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  useIsomorphicLayoutEffect(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

var useWindowWidth = function useWindowWidth() {
  var hasMounted = useHasMounted();

  var _useState2 = (0,react.useState)(0),
      width = _useState2[0],
      setWidth = _useState2[1];

  var handleResize = (0,react.useCallback)(function () {
    if (!hasMounted) return;
    setWidth(window.innerWidth);
  }, [hasMounted]);
  useIsomorphicLayoutEffect(function () {
    if (hasMounted) {
      window.addEventListener("resize", handleResize);
      handleResize();
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
  }, [hasMounted, handleResize]);
  return width;
};

var MasonryResponsive = function MasonryResponsive(_ref) {
  var _ref$columnsCountBrea = _ref.columnsCountBreakPoints,
      columnsCountBreakPoints = _ref$columnsCountBrea === void 0 ? {
    350: 1,
    750: 2,
    900: 3
  } : _ref$columnsCountBrea,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style;
  var windowWidth = useWindowWidth();
  var columnsCount = (0,react.useMemo)(function () {
    var breakPoints = Object.keys(columnsCountBreakPoints).sort(function (a, b) {
      return a - b;
    });
    var count = breakPoints.length > 0 ? columnsCountBreakPoints[breakPoints[0]] : DEFAULT_COLUMNS_COUNT;
    breakPoints.forEach(function (breakPoint) {
      if (breakPoint < windowWidth) {
        count = columnsCountBreakPoints[breakPoint];
      }
    });
    return count;
  }, [windowWidth, columnsCountBreakPoints]);
  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: style
  }, react.Children.map(children, function (child, index) {
    return react.cloneElement(child, {
      key: index,
      columnsCount: columnsCount
    });
  }));
};

MasonryResponsive.propTypes =  false ? 0 : {};
/* harmony default export */ var ResponsiveMasonry = (MasonryResponsive);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/index.js


/* harmony default export */ var es = (es_Masonry);


/***/ }),

/***/ 1852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(7294));
	else {}
})(this, (__WEBPACK_EXTERNAL_MODULE_react__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/css-mediaquery/index.js":
/*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/



exports.match = matchQuery;
exports.parse = parseQuery;

// -----------------------------------------------------------------------------

var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;

function matchQuery(mediaQuery, values) {
    return parseQuery(mediaQuery).some(function (query) {
        var inverse = query.inverse;

        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;

        // Quit early when `type` doesn't match, but take "not" into account.
        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
            return false;
        }

        var expressionsMatch = query.expressions.every(function (expression) {
            var feature  = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value    = values[feature];

            // Missing or falsy values don't match.
            if (!value) { return false; }

            switch (feature) {
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();

                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = toPx(expValue);
                    value    = toPx(value);
                    break;

                case 'resolution':
                    expValue = toDpi(expValue);
                    value    = toDpi(value);
                    break;

                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = toDecimal(expValue);
                    value    = toDecimal(value);
                    break;

                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value    = parseInt(value, 10) || 0;
                    break;
            }

            switch (modifier) {
                case 'min': return value >= expValue;
                case 'max': return value <= expValue;
                default   : return value === expValue;
            }
        });

        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
    });
}

function parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function (query) {
        query = query.trim();

        var captures    = query.match(RE_MEDIA_QUERY),
            modifier    = captures[1],
            type        = captures[2],
            expressions = captures[3] || '',
            parsed      = {};

        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type    = type ? type.toLowerCase() : 'all';

        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];

        parsed.expressions = expressions.map(function (expression) {
            var captures = expression.match(RE_MQ_EXPRESSION),
                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);

            return {
                modifier: feature[1],
                feature : feature[2],
                value   : captures[2]
            };
        });

        return parsed;
    });
}

// -- Utilities ----------------------------------------------------------------

function toDecimal(ratio) {
    var decimal = Number(ratio),
        numbers;

    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }

    return decimal;
}

function toDpi(resolution) {
    var value = parseFloat(resolution),
        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];

    switch (units) {
        case 'dpcm': return value / 2.54;
        case 'dppx': return value * 96;
        default    : return value;
    }
}

function toPx(length) {
    var value = parseFloat(length),
        units = String(length).match(RE_LENGTH_UNIT)[1];

    switch (units) {
        case 'em' : return value * 16;
        case 'rem': return value * 16;
        case 'cm' : return value * 96 / 2.54;
        case 'mm' : return value * 96 / 2.54 / 10;
        case 'in' : return value * 96;
        case 'pt' : return value * 72;
        case 'pc' : return value * 72 / 12;
        default   : return value;
    }
}


/***/ }),

/***/ "./node_modules/hyphenate-style-name/index.js":
/*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __nested_webpack_require_6053__) => {

"use strict";
__nested_webpack_require_6053__.r(__webpack_exports__);
/* harmony export */ __nested_webpack_require_6053__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (hyphenateStyleName);


/***/ }),

/***/ "./node_modules/matchmediaquery/index.js":
/*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_7064__) => {

"use strict";


var staticMatch = (__nested_webpack_require_7064__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match);
var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;

// our fake MediaQueryList
function Mql(query, values, forceStatic){
  var self = this;
  if(dynamicMatch && !forceStatic){
    var mql = dynamicMatch.call(window, query);
    this.matches = mql.matches;
    this.media = mql.media;
    // TODO: is there a time it makes sense to remove this listener?
    mql.addListener(update);
  } else {
    this.matches = staticMatch(query, values);
    this.media = query;
  }

  this.addListener = addListener;
  this.removeListener = removeListener;
  this.dispose = dispose;

  function addListener(listener){
    if(mql){
      mql.addListener(listener);
    }
  }

  function removeListener(listener){
    if(mql){
      mql.removeListener(listener);
    }
  }

  // update ourselves!
  function update(evt){
    self.matches = evt.matches;
    self.media = evt.media;
  }

  function dispose(){
    if(mql){
      mql.removeListener(update);
    }
  }
}

function matchMedia(query, values, forceStatic){
  return new Mql(query, values, forceStatic);
}

module.exports = matchMedia;


/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_10944__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __nested_webpack_require_10944__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
  var loggedTypeFailures = {};
  var has = __nested_webpack_require_10944__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_15184__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __nested_webpack_require_15184__(/*! react-is */ "./node_modules/react-is/index.js");
var assign = __nested_webpack_require_15184__(/*! object-assign */ "./node_modules/object-assign/index.js");

var ReactPropTypesSecret = __nested_webpack_require_15184__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
var has = __nested_webpack_require_15184__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
var checkPropTypes = __nested_webpack_require_15184__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");

var printWarning = function() {};

if (true) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (  true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
        true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_38303__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var ReactIs = __nested_webpack_require_38303__(/*! react-is */ "./node_modules/react-is/index.js");

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __nested_webpack_require_38303__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
} else {}


/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/prop-types/lib/has.js":
/*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/
/***/ ((module) => {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.development.js":
/*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),

/***/ "./node_modules/react-is/index.js":
/*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_47361__) => {

"use strict";


if (false) {} else {
  module.exports = __nested_webpack_require_47361__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
}


/***/ }),

/***/ "./node_modules/shallow-equal/dist/index.esm.js":
/*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __nested_webpack_require_47861__) => {

"use strict";
__nested_webpack_require_47861__.r(__webpack_exports__);
/* harmony export */ __nested_webpack_require_47861__.d(__webpack_exports__, {
/* harmony export */   "shallowEqualArrays": () => (/* binding */ shallowEqualArrays),
/* harmony export */   "shallowEqualObjects": () => (/* binding */ shallowEqualObjects)
/* harmony export */ });
function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}




/***/ }),

/***/ "./src/Component.ts":
/*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_49201__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var useMediaQuery_1 = __importDefault(__nested_webpack_require_49201__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
var MediaQuery = function (_a) {
    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, ["children", "device", "onChange"]);
    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
    if (typeof children === 'function') {
        return children(matches);
    }
    return matches ? children : null;
};
exports["default"] = MediaQuery;


/***/ }),

/***/ "./src/Context.ts":
/*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/
/***/ ((__unused_webpack_module, exports, __nested_webpack_require_50747__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __nested_webpack_require_50747__(/*! react */ "react");
var Context = (0, react_1.createContext)(undefined);
exports["default"] = Context;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_51164__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
var useMediaQuery_1 = __importDefault(__nested_webpack_require_51164__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
exports.useMediaQuery = useMediaQuery_1.default;
var Component_1 = __importDefault(__nested_webpack_require_51164__(/*! ./Component */ "./src/Component.ts"));
exports["default"] = Component_1.default;
var toQuery_1 = __importDefault(__nested_webpack_require_51164__(/*! ./toQuery */ "./src/toQuery.ts"));
exports.toQuery = toQuery_1.default;
var Context_1 = __importDefault(__nested_webpack_require_51164__(/*! ./Context */ "./src/Context.ts"));
exports.Context = Context_1.default;


/***/ }),

/***/ "./src/mediaQuery.ts":
/*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_52239__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var prop_types_1 = __importDefault(__nested_webpack_require_52239__(/*! prop-types */ "./node_modules/prop-types/index.js"));
var stringOrNumber = prop_types_1.default.oneOfType([
    prop_types_1.default.string,
    prop_types_1.default.number
]);
// media types
var types = {
    all: prop_types_1.default.bool,
    grid: prop_types_1.default.bool,
    aural: prop_types_1.default.bool,
    braille: prop_types_1.default.bool,
    handheld: prop_types_1.default.bool,
    print: prop_types_1.default.bool,
    projection: prop_types_1.default.bool,
    screen: prop_types_1.default.bool,
    tty: prop_types_1.default.bool,
    tv: prop_types_1.default.bool,
    embossed: prop_types_1.default.bool
};
// properties that match media queries
var matchers = {
    orientation: prop_types_1.default.oneOf([
        'portrait',
        'landscape'
    ]),
    scan: prop_types_1.default.oneOf([
        'progressive',
        'interlace'
    ]),
    aspectRatio: prop_types_1.default.string,
    deviceAspectRatio: prop_types_1.default.string,
    height: stringOrNumber,
    deviceHeight: stringOrNumber,
    width: stringOrNumber,
    deviceWidth: stringOrNumber,
    color: prop_types_1.default.bool,
    colorIndex: prop_types_1.default.bool,
    monochrome: prop_types_1.default.bool,
    resolution: stringOrNumber,
    type: Object.keys(types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var type = matchers.type, featureMatchers = __rest(matchers
// media features
, ["type"]);
// media features
var features = __assign({ minAspectRatio: prop_types_1.default.string, maxAspectRatio: prop_types_1.default.string, minDeviceAspectRatio: prop_types_1.default.string, maxDeviceAspectRatio: prop_types_1.default.string, minHeight: stringOrNumber, maxHeight: stringOrNumber, minDeviceHeight: stringOrNumber, maxDeviceHeight: stringOrNumber, minWidth: stringOrNumber, maxWidth: stringOrNumber, minDeviceWidth: stringOrNumber, maxDeviceWidth: stringOrNumber, minColor: prop_types_1.default.number, maxColor: prop_types_1.default.number, minColorIndex: prop_types_1.default.number, maxColorIndex: prop_types_1.default.number, minMonochrome: prop_types_1.default.number, maxMonochrome: prop_types_1.default.number, minResolution: stringOrNumber, maxResolution: stringOrNumber }, featureMatchers);
var all = __assign(__assign({}, types), features);
exports["default"] = {
    all: all,
    types: types,
    matchers: matchers,
    features: features
};


/***/ }),

/***/ "./src/toQuery.ts":
/*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_55990__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var hyphenate_style_name_1 = __importDefault(__nested_webpack_require_55990__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
var mediaQuery_1 = __importDefault(__nested_webpack_require_55990__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
var negate = function (cond) { return "not ".concat(cond); };
var keyVal = function (k, v) {
    var realKey = (0, hyphenate_style_name_1.default)(k);
    // px shorthand
    if (typeof v === 'number') {
        v = "".concat(v, "px");
    }
    if (v === true) {
        return realKey;
    }
    if (v === false) {
        return negate(realKey);
    }
    return "(".concat(realKey, ": ").concat(v, ")");
};
var join = function (conds) { return conds.join(' and '); };
var toQuery = function (obj) {
    var rules = [];
    Object.keys(mediaQuery_1.default.all).forEach(function (k) {
        var v = obj[k];
        if (v != null) {
            rules.push(keyVal(k, v));
        }
    });
    return join(rules);
};
exports["default"] = toQuery;


/***/ }),

/***/ "./src/useMediaQuery.ts":
/*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __nested_webpack_require_57428__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __nested_webpack_require_57428__(/*! react */ "react");
var matchmediaquery_1 = __importDefault(__nested_webpack_require_57428__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
var hyphenate_style_name_1 = __importDefault(__nested_webpack_require_57428__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
var shallow_equal_1 = __nested_webpack_require_57428__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
var toQuery_1 = __importDefault(__nested_webpack_require_57428__(/*! ./toQuery */ "./src/toQuery.ts"));
var Context_1 = __importDefault(__nested_webpack_require_57428__(/*! ./Context */ "./src/Context.ts"));
var makeQuery = function (settings) { return settings.query || (0, toQuery_1.default)(settings); };
var hyphenateKeys = function (obj) {
    if (!obj)
        return undefined;
    var keys = Object.keys(obj);
    return keys.reduce(function (result, key) {
        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
        return result;
    }, {});
};
var useIsUpdate = function () {
    var ref = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        ref.current = true;
    }, []);
    return ref.current;
};
var useDevice = function (deviceFromProps) {
    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
    var getDevice = function () {
        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
    };
    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
    (0, react_1.useEffect)(function () {
        var newDevice = getDevice();
        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) {
            setDevice(newDevice);
        }
    }, [deviceFromProps, deviceFromContext]);
    return device;
};
var useQuery = function (settings) {
    var getQuery = function () { return makeQuery(settings); };
    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
    (0, react_1.useEffect)(function () {
        var newQuery = getQuery();
        if (query !== newQuery) {
            setQuery(newQuery);
        }
    }, [settings]);
    return query;
};
var useMatchMedia = function (query, device) {
    var getMatchMedia = function () { return (0, matchmediaquery_1.default)(query, device || {}, !!device); };
    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
    var isUpdate = useIsUpdate();
    (0, react_1.useEffect)(function () {
        if (isUpdate) {
            // skip on mounting, it has already been set
            var newMq_1 = getMatchMedia();
            setMq(newMq_1);
            return function () {
                if (newMq_1) {
                    newMq_1.dispose();
                }
            };
        }
    }, [query, device]);
    return mq;
};
var useMatches = function (mediaQuery) {
    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
    (0, react_1.useEffect)(function () {
        var updateMatches = function (ev) {
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return function () {
            mediaQuery.removeListener(updateMatches);
        };
    }, [mediaQuery]);
    return matches;
};
var useMediaQuery = function (settings, device, onChange) {
    var deviceSettings = useDevice(device);
    var query = useQuery(settings);
    if (!query)
        throw new Error('Invalid or missing MediaQuery!');
    var mq = useMatchMedia(query, deviceSettings);
    var matches = useMatches(mq);
    var isUpdate = useIsUpdate();
    (0, react_1.useEffect)(function () {
        if (isUpdate && onChange) {
            onChange(matches);
        }
    }, [matches]);
    (0, react_1.useEffect)(function () { return function () {
        if (mq) {
            mq.dispose();
        }
    }; }, []);
    return matches;
};
exports["default"] = useMediaQuery;


/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_62230__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_62230__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_62230__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_62230__.o(definition, key) && !__nested_webpack_require_62230__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_62230__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_62230__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __nested_webpack_require_62230__("./src/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 4382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ FlexItem; },
/* harmony export */   "hs": function() { return /* binding */ FlexBox; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* unused harmony exports FlexGapNotSupportedClassName, FlexGapSupportedClassName */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9521);


var FlexGapSupportedClassName = 'flex-gap-supported';
var FlexGapNotSupportedClassName = 'flex-gap-not-supported';
var boxPropsArr = ['sizing', 'position', 'zIndex', 'outline', 'overflow', 'overflowX', 'overflowY', 'height', 'maxHeight', 'minHeight', 'width', 'maxWidth', 'minWidth', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'm', 'mt', 'mr', 'mb', 'ml', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'p', 'pt', 'pr', 'pb', 'pl', 'border', 'borderTop', 'borderRight', 'borderBottom', 'borderLeft', 'b', 'bt', 'br', 'bb', 'bl'];
var flexBoxPropsArr = ['inline', 'wrap', 'reverse', 'wrapReverse', 'column', 'center', 'justifyContent', 'justifyItems', 'alignItems', 'alignContent', 'gap', 'columnGap', 'rowGap'];
var flexItemPropsArr = ['box', 'order', 'grow', 'shrink', 'basis', 'flex', 'alignSelf', 'justifySelf'];
var boxProps = boxPropsArr.slice();
var flexBoxProps = flexBoxPropsArr.slice();
var flexItemProps = flexItemPropsArr.slice().concat(flexBoxProps);

if (typeof document !== 'undefined') {
  var executeOnDomReady = function executeOnDomReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        return callback();
      });
    } else {
      callback();
    }
  };

  executeOnDomReady(function () {
    var htmlDocument = document;
    var htmlBody = htmlDocument.body;
    var bodyClassList = htmlBody.classList;

    var flexGapSupported = function flexGapSupported() {
      var PARENT_WIDTH = 10;
      var GAP = 4;
      /* create test node */

      var parent = htmlDocument.createElement('div');
      parent.style.visibility = 'hidden';
      parent.style.height = '1px';
      parent.style.width = PARENT_WIDTH + "px";
      parent.style.display = 'flex';
      parent.style.gap = GAP + "px";
      parent.innerHTML = '<div id="react-styled-flex-gap-detector-element" style="flex:1"></div><div style="flex:1"></div>';
      /* carry out tests */

      htmlBody.appendChild(parent);

      var _window$getComputedSt = window.getComputedStyle(parent.firstElementChild),
          width = _window$getComputedSt.width;

      htmlBody.removeChild(parent);
      /* Remove node and return result */

      return Math.round(parseFloat(width)) === (PARENT_WIDTH - GAP) / 2;
    };

    if (flexGapSupported()) {
      bodyClassList.add(FlexGapSupportedClassName);
      bodyClassList.remove(FlexGapNotSupportedClassName);
    } else {
      bodyClassList.add(FlexGapNotSupportedClassName);
      bodyClassList.remove(FlexGapSupportedClassName);
    }
  });
}

var FlexGapSupportedIdentifier = "." + FlexGapSupportedClassName + " &&";
var FlexGapNotSupportedIdentifier = "." + FlexGapNotSupportedClassName + " &&";

var boxModelStyles = function boxModelStyles(props) {
  return {
    boxSizing: props.sizing,
    position: props.position,
    height: props.height,
    zIndex: props.zIndex,
    outline: props.outline,
    overflow: props.overflow,
    overflowX: props.overflowX,
    overflowY: props.overflowY,
    maxHeight: props.maxHeight,
    minHeight: props.minHeight,
    width: props.width,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    margin: props.margin || props.m,
    marginTop: props.marginTop || props.mt,
    marginRight: props.marginRight || props.mr,
    marginBottom: props.marginBottom || props.mb,
    marginLeft: props.marginLeft || props.ml,
    padding: props.padding || props.p,
    paddingTop: props.paddingTop || props.pt,
    paddingRight: props.paddingRight || props.pr,
    paddingBottom: props.paddingBottom || props.pb,
    paddingLeft: props.paddingLeft || props.pl,
    border: props.border || props.b,
    borderTop: props.borderTop || props.bt,
    borderRight: props.borderRight || props.br,
    borderBottom: props.borderBottom || props.bb,
    borderLeft: props.borderLeft || props.bl
  };
};

var flexStyles = function flexStyles(props) {
  var inline = props.inline,
      wrapReverse = props.wrapReverse,
      alignContent = props.alignContent,
      justifyItems = props.justifyItems,
      column = props.column,
      reverse = props.reverse,
      wrap = props.wrap,
      gap = props.gap,
      columnGap = props.columnGap,
      rowGap = props.rowGap,
      center = props.center;
  var display = inline ? 'inline-flex' : 'flex';
  var justifyContent = props.justifyContent,
      alignItems = props.alignItems;
  var flexDirection;
  var flexWrap;

  if (center) {
    justifyContent = justifyContent || 'center';
    alignItems = alignItems || 'center';
  }

  if (column || reverse) {
    flexDirection = column ? 'column' : 'row';
    flexDirection += reverse ? '-reverse' : '';
  }

  if (wrap) flexWrap = 'wrap';
  if (wrapReverse) flexWrap = 'wrap-reverse';
  var result = {
    display: display,
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    alignItems: alignItems,
    flexDirection: flexDirection,
    alignContent: alignContent,
    justifyItems: justifyItems
  };

  if (gap || columnGap || rowGap) {
    result[FlexGapSupportedIdentifier] = {
      gap: gap,
      rowGap: rowGap,
      columnGap: columnGap
    };

    if (wrap) ; else {
      var _ref, _result$FlexGapNotSup;

      var marginProp = column ? 'bottom' : 'right';
      var child = reverse ? 'first' : 'last';
      var gapProp = (column ? rowGap : columnGap) || gap;
      result[FlexGapNotSupportedIdentifier] = (_result$FlexGapNotSup = {}, _result$FlexGapNotSup["& > :not(:" + child + "-child)"] = (_ref = {}, _ref["margin-" + marginProp] = gapProp, _ref), _result$FlexGapNotSup);
    }
  }

  return result;
};

var flexItemStyles = function flexItemStyles(props) {
  return {
    order: props.order,
    flex: props.flex,
    alignSelf: props.alignSelf,
    justifySelf: props.justifySelf,
    flexBasis: props.basis,
    flexShrink: props.shrink,
    flexGrow: props.grow
  };
};

var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)('div').withConfig({
  displayName: 'Box',
  shouldForwardProp: function shouldForwardProp(prop) {
    return boxProps.indexOf(prop) === -1;
  }
})(boxModelStyles);
var FlexBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(Box).withConfig({
  displayName: 'FlexBox',
  shouldForwardProp: function shouldForwardProp(prop) {
    return flexBoxProps.indexOf(prop) === -1;
  }
})(flexStyles);
var FlexItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(Box).withConfig({
  displayName: 'FlexItem',
  shouldForwardProp: function shouldForwardProp(prop) {
    return flexItemProps.indexOf(prop) === -1;
  }
})(flexItemStyles, function (props) {
  return props.box ? flexStyles : '';
});


//# sourceMappingURL=react-styled-flex.esm.js.map


/***/ }),

/***/ 6774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 5174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var inline_style_parser_1 = __importDefault(__webpack_require__(8139));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */
function StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') {
        return styleObject;
    }
    var declarations = (0, inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function (declaration) {
        if (declaration.type !== 'declaration') {
            return;
        }
        var property = declaration.property, value = declaration.value;
        if (hasIterator) {
            iterator(property, value, declaration);
        }
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
exports["default"] = StyleToObject;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(9864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(6774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(3454);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=s(Me),n=i((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 7632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 1501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ VideoProvider; },
/* harmony export */   "l": function() { return /* binding */ VideoContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var VideoContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useSaved = function (name, init, remember) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(init), value = _a[0], setStateValue = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (remember.indexOf(name) === -1)
            return;
        var localValue = localStorage.getItem(name);
        if (localValue)
            setStateValue(localValue);
    }, [name, init, setStateValue, remember]);
    var setValue = function (value) {
        setStateValue(value);
        localStorage.setItem(name, value);
    };
    return {
        value: value,
        setValue: setValue
    };
};
var VideoProvider = function (props) {
    var element = props.element, children = props.children, remember = props.remember;
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), paused = _a[0], setPaused = _a[1];
    var savedMute = useSaved("mute", "false", remember);
    var savedVolume = useSaved("volume", "1", remember);
    var mute = function (value) { return savedMute.setValue(value.toString()); };
    var muted = savedMute.value === "true";
    var setVolume = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) { return savedVolume.setValue(value.toString()); }, [savedVolume]);
    var volume = Number(savedVolume.value);
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), now = _b[0], setNow = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), duration = _c[0], setDuration = _c[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (element.current === null)
            return;
        setDuration(element.current.duration);
    }, [element]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (element.current === null)
            return;
        element.current.muted = muted;
        element.current.volume = volume;
    }, [element, muted, volume]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var current = element.current;
        if (current === null)
            return;
        current.onplay = function () { return setPaused(false); };
        current.onpause = function () { return setPaused(true); };
        current.onvolumechange = function () { return setVolume(current.volume); };
        current.ontimeupdate = function () { return setNow(current.currentTime); };
        current.ondurationchange = function () { return setDuration(current.duration); };
    }, [element, paused, setVolume]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (element.current === null)
            return;
        element.current.muted = muted;
    }, [element, muted]);
    var play = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { var _a; return (_a = element.current) === null || _a === void 0 ? void 0 : _a.play(); }, [element]);
    var pause = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { var _a; return (_a = element.current) === null || _a === void 0 ? void 0 : _a.pause(); }, [element]);
    var seek = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (progress) {
        if (element.current)
            element.current.currentTime = progress;
    }, [element]);
    var value = duration !== null
        ? {
            now: now,
            duration: duration,
            muted: muted,
            paused: paused,
            volume: volume,
            play: play,
            pause: pause,
            mute: mute,
            seek: seek,
            setVolume: setVolume
        }
        : null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(VideoContext.Provider, { value: value }, children));
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPluralRules = __webpack_require__(5129);
var PseudoNumberFormat = __webpack_require__(9321);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getPluralRules__default = /*#__PURE__*/_interopDefaultLegacy(getPluralRules);
var PseudoNumberFormat__default = /*#__PURE__*/_interopDefaultLegacy(PseudoNumberFormat);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var plurals$1 = {exports: {}};

(function (module, exports) {
  var a = function a(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : 'other';
  };

  var b = function b(n, ord) {
    if (ord) return 'other';
    return n == 0 || n == 1 ? 'one' : 'other';
  };

  var c = function c(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  };

  var d = function d(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : 'other';
  };

  var e = function e(n, ord) {
    return 'other';
  };

  var f = function f(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  };

  (function (root, plurals) {
    Object.defineProperty(plurals, '__esModule', {
      value: true
    });
    module.exports = plurals;
  })(commonjsGlobal, {
    _in: e,
    af: a,
    ak: b,
    am: c,
    an: a,
    ar: function ar(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
    },
    ars: function ars(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
    },
    as: function as(n, ord) {
      if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    asa: a,
    ast: d,
    az: function az(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          i1000 = i.slice(-3);
      if (ord) return i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8 || i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80 ? 'one' : i10 == 3 || i10 == 4 || i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900 ? 'few' : i == 0 || i10 == 6 || i100 == 40 || i100 == 60 || i100 == 90 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    be: function be(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? 'few' : 'other';
      return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
    },
    bem: a,
    bez: a,
    bg: a,
    bho: b,
    bm: e,
    bn: function bn(n, ord) {
      if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    bo: e,
    br: function br(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          n1000000 = t0 && s[0].slice(-6);
      if (ord) return 'other';
      return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
    },
    brx: a,
    bs: function bs(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    ca: function ca(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 1 || n == 3 ? 'one' : n == 2 ? 'two' : n == 4 ? 'few' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    ce: a,
    ceb: function ceb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    cgg: a,
    chr: a,
    ckb: a,
    cs: function cs(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1];
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
    },
    cy: function cy(n, ord) {
      if (ord) return n == 0 || n == 7 || n == 8 || n == 9 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 || n == 4 ? 'few' : n == 5 || n == 6 ? 'many' : 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
    },
    da: function da(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
    },
    de: d,
    doi: c,
    dsb: function dsb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i100 = i.slice(-2),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
    },
    dv: a,
    dz: e,
    ee: a,
    el: a,
    en: function en(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return n10 == 1 && n100 != 11 ? 'one' : n10 == 2 && n100 != 12 ? 'two' : n10 == 3 && n100 != 13 ? 'few' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    eo: a,
    es: a,
    et: d,
    eu: a,
    fa: c,
    ff: function ff(n, ord) {
      if (ord) return 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    fi: d,
    fil: function fil(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return n == 1 ? 'one' : 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    fo: a,
    fr: function fr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i1000000 = i.slice(-6);
      if (ord) return n == 1 ? 'one' : 'other';
      return n >= 0 && n < 2 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    fur: a,
    fy: d,
    ga: function ga(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
    },
    gd: function gd(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : n == 3 || n == 13 ? 'few' : 'other';
      return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
    },
    gl: d,
    gsw: a,
    gu: function gu(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    guw: b,
    gv: function gv(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 ? 'one' : v0 && i10 == 2 ? 'two' : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? 'few' : !v0 ? 'many' : 'other';
    },
    ha: a,
    haw: a,
    he: function he(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
    },
    hi: function hi(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    hr: function hr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    hsb: function hsb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i100 = i.slice(-2),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
    },
    hu: function hu(n, ord) {
      if (ord) return n == 1 || n == 5 ? 'one' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    hy: function hy(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    ia: d,
    id: e,
    ig: e,
    ii: e,
    io: d,
    is: function is(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          t0 = Number(s[0]) == n,
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
    },
    it: function it(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    iu: f,
    iw: function iw(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
    },
    ja: e,
    jbo: e,
    jgo: a,
    ji: d,
    jmc: a,
    jv: e,
    jw: e,
    ka: function ka(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          i100 = i.slice(-2);
      if (ord) return i == 1 ? 'one' : i == 0 || i100 >= 2 && i100 <= 20 || i100 == 40 || i100 == 60 || i100 == 80 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    kab: function kab(n, ord) {
      if (ord) return 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    kaj: a,
    kcg: a,
    kde: e,
    kea: e,
    kk: function kk(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    kkj: a,
    kl: a,
    km: e,
    kn: c,
    ko: e,
    ks: a,
    ksb: a,
    ksh: function ksh(n, ord) {
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
    },
    ku: a,
    kw: function kw(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2),
          n1000 = t0 && s[0].slice(-3),
          n100000 = t0 && s[0].slice(-5),
          n1000000 = t0 && s[0].slice(-6);
      if (ord) return t0 && n >= 1 && n <= 4 || n100 >= 1 && n100 <= 4 || n100 >= 21 && n100 <= 24 || n100 >= 41 && n100 <= 44 || n100 >= 61 && n100 <= 64 || n100 >= 81 && n100 <= 84 ? 'one' : n == 5 || n100 == 5 ? 'many' : 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1000 && n100000 <= 20000 || n100000 == 40000 || n100000 == 60000 || n100000 == 80000) || n != 0 && n1000000 == 100000 ? 'two' : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? 'few' : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? 'many' : 'other';
    },
    ky: a,
    lag: function lag(n, ord) {
      var s = String(n).split('.'),
          i = s[0];
      if (ord) return 'other';
      return n == 0 ? 'zero' : (i == 0 || i == 1) && n != 0 ? 'one' : 'other';
    },
    lb: a,
    lg: a,
    lij: function lij(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n;
      if (ord) return n == 11 || n == 8 || t0 && n >= 80 && n <= 89 || t0 && n >= 800 && n <= 899 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    lkt: e,
    ln: b,
    lo: function lo(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    lt: function lt(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
    },
    lv: function lv(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          v = f.length,
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          f100 = f.slice(-2),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
    },
    mas: a,
    mg: b,
    mgo: a,
    mk: function mk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return i10 == 1 && i100 != 11 ? 'one' : i10 == 2 && i100 != 12 ? 'two' : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? 'many' : 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
    },
    ml: a,
    mn: a,
    mo: function mo(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
    },
    mr: function mr(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    ms: function ms(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    mt: function mt(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
    },
    my: e,
    nah: a,
    naq: f,
    nb: a,
    nd: a,
    ne: function ne(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return t0 && n >= 1 && n <= 4 ? 'one' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    nl: d,
    nn: a,
    nnh: a,
    no: a,
    nqo: e,
    nr: a,
    nso: b,
    ny: a,
    nyn: a,
    om: a,
    or: function or(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 || n == 5 || t0 && n >= 7 && n <= 9 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    os: a,
    osa: e,
    pa: b,
    pap: a,
    pcm: c,
    pl: function pl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
    },
    prg: function prg(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          v = f.length,
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          f100 = f.slice(-2),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
    },
    ps: a,
    pt: function pt(n, ord) {
      var s = String(n).split('.'),
          i = s[0];
      if (ord) return 'other';
      return i == 0 || i == 1 ? 'one' : 'other';
    },
    pt_PT: d,
    rm: a,
    ro: function ro(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
    },
    rof: a,
    root: e,
    ru: function ru(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
    },
    rwk: a,
    sah: e,
    saq: a,
    sat: f,
    sc: function sc(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    scn: function scn(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    sd: a,
    sdh: a,
    se: f,
    seh: a,
    ses: e,
    sg: e,
    sh: function sh(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    shi: function shi(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n >= 0 && n <= 1 ? 'one' : t0 && n >= 2 && n <= 10 ? 'few' : 'other';
    },
    si: function si(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '';
      if (ord) return 'other';
      return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
    },
    sk: function sk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1];
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
    },
    sl: function sl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
    },
    sma: f,
    smi: f,
    smj: f,
    smn: f,
    sms: f,
    sn: a,
    so: a,
    sq: function sq(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : n10 == 4 && n100 != 14 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    sr: function sr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    ss: a,
    ssy: a,
    st: a,
    su: e,
    sv: function sv(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    sw: d,
    syr: a,
    ta: a,
    te: a,
    teo: a,
    th: e,
    ti: b,
    tig: a,
    tk: function tk(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return n10 == 6 || n10 == 9 || n == 10 ? 'few' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    tl: function tl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return n == 1 ? 'one' : 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    tn: a,
    to: e,
    tr: a,
    ts: a,
    tzm: function tzm(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? 'one' : 'other';
    },
    ug: a,
    uk: function uk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return n10 == 3 && n100 != 13 ? 'few' : 'other';
      return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
    },
    ur: d,
    uz: a,
    ve: a,
    vi: function vi(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    vo: a,
    vun: a,
    wa: b,
    wae: a,
    wo: e,
    xh: a,
    xog: a,
    yi: d,
    yo: e,
    yue: e,
    zh: e,
    zu: c
  });
})(plurals$1);

var plurals = /*@__PURE__*/getDefaultExportFromCjs(plurals$1.exports);

var P = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), plurals$1.exports, {
  'default': plurals
}));

var pluralCategories$1 = {exports: {}};

(function (module, exports) {
  var z = "zero",
      o = "one",
      t = "two",
      f = "few",
      m = "many",
      x = "other";
  var a = {
    cardinal: [o, x],
    ordinal: [x]
  };
  var b = {
    cardinal: [x],
    ordinal: [x]
  };
  var c = {
    cardinal: [o, f, m, x],
    ordinal: [x]
  };
  var d = {
    cardinal: [o, x],
    ordinal: [o, x]
  };
  var e = {
    cardinal: [o, t, x],
    ordinal: [x]
  };

  (function (root, pluralCategories) {
    Object.defineProperty(pluralCategories, '__esModule', {
      value: true
    });
    module.exports = pluralCategories;
  })(commonjsGlobal, {
    _in: b,
    af: a,
    ak: a,
    am: a,
    an: a,
    ar: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [x]
    },
    ars: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [x]
    },
    as: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    asa: a,
    ast: a,
    az: {
      cardinal: [o, x],
      ordinal: [o, f, m, x]
    },
    be: {
      cardinal: [o, f, m, x],
      ordinal: [f, x]
    },
    bem: a,
    bez: a,
    bg: a,
    bho: a,
    bm: b,
    bn: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    bo: b,
    br: {
      cardinal: [o, t, f, m, x],
      ordinal: [x]
    },
    brx: a,
    bs: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    ca: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    ce: a,
    ceb: a,
    cgg: a,
    chr: a,
    ckb: a,
    cs: c,
    cy: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [z, o, t, f, m, x]
    },
    da: a,
    de: a,
    doi: a,
    dsb: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    dv: a,
    dz: b,
    ee: a,
    el: a,
    en: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    eo: a,
    es: a,
    et: a,
    eu: a,
    fa: a,
    ff: a,
    fi: a,
    fil: d,
    fo: a,
    fr: {
      cardinal: [o, m, x],
      ordinal: [o, x]
    },
    fur: a,
    fy: a,
    ga: {
      cardinal: [o, t, f, m, x],
      ordinal: [o, x]
    },
    gd: {
      cardinal: [o, t, f, x],
      ordinal: [o, t, f, x]
    },
    gl: a,
    gsw: a,
    gu: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    guw: a,
    gv: {
      cardinal: [o, t, f, m, x],
      ordinal: [x]
    },
    ha: a,
    haw: a,
    he: {
      cardinal: [o, t, m, x],
      ordinal: [x]
    },
    hi: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    hr: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    hsb: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    hu: d,
    hy: d,
    ia: a,
    id: b,
    ig: b,
    ii: b,
    io: a,
    is: a,
    it: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    iu: e,
    iw: {
      cardinal: [o, t, m, x],
      ordinal: [x]
    },
    ja: b,
    jbo: b,
    jgo: a,
    ji: a,
    jmc: a,
    jv: b,
    jw: b,
    ka: {
      cardinal: [o, x],
      ordinal: [o, m, x]
    },
    kab: a,
    kaj: a,
    kcg: a,
    kde: b,
    kea: b,
    kk: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    kkj: a,
    kl: a,
    km: b,
    kn: a,
    ko: b,
    ks: a,
    ksb: a,
    ksh: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    ku: a,
    kw: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [o, m, x]
    },
    ky: a,
    lag: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    lb: a,
    lg: a,
    lij: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    lkt: b,
    ln: a,
    lo: {
      cardinal: [x],
      ordinal: [o, x]
    },
    lt: c,
    lv: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    mas: a,
    mg: a,
    mgo: a,
    mk: {
      cardinal: [o, x],
      ordinal: [o, t, m, x]
    },
    ml: a,
    mn: a,
    mo: {
      cardinal: [o, f, x],
      ordinal: [o, x]
    },
    mr: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    ms: {
      cardinal: [x],
      ordinal: [o, x]
    },
    mt: c,
    my: b,
    nah: a,
    naq: e,
    nb: a,
    nd: a,
    ne: d,
    nl: a,
    nn: a,
    nnh: a,
    no: a,
    nqo: b,
    nr: a,
    nso: a,
    ny: a,
    nyn: a,
    om: a,
    or: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    os: a,
    osa: b,
    pa: a,
    pap: a,
    pcm: a,
    pl: c,
    prg: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    ps: a,
    pt: a,
    pt_PT: a,
    rm: a,
    ro: {
      cardinal: [o, f, x],
      ordinal: [o, x]
    },
    rof: a,
    root: b,
    ru: c,
    rwk: a,
    sah: b,
    saq: a,
    sat: e,
    sc: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    scn: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    sd: a,
    sdh: a,
    se: e,
    seh: a,
    ses: b,
    sg: b,
    sh: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    shi: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    si: a,
    sk: c,
    sl: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    sma: e,
    smi: e,
    smj: e,
    smn: e,
    sms: e,
    sn: a,
    so: a,
    sq: {
      cardinal: [o, x],
      ordinal: [o, m, x]
    },
    sr: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    ss: a,
    ssy: a,
    st: a,
    su: b,
    sv: d,
    sw: a,
    syr: a,
    ta: a,
    te: a,
    teo: a,
    th: b,
    ti: a,
    tig: a,
    tk: {
      cardinal: [o, x],
      ordinal: [f, x]
    },
    tl: d,
    tn: a,
    to: b,
    tr: a,
    ts: a,
    tzm: a,
    ug: a,
    uk: {
      cardinal: [o, f, m, x],
      ordinal: [f, x]
    },
    ur: a,
    uz: a,
    ve: a,
    vi: {
      cardinal: [x],
      ordinal: [o, x]
    },
    vo: a,
    vun: a,
    wa: a,
    wae: a,
    wo: b,
    xh: a,
    xog: a,
    yi: a,
    yo: b,
    yue: b,
    zh: b,
    zu: a
  });
})(pluralCategories$1);

var pluralCategories = /*@__PURE__*/getDefaultExportFromCjs(pluralCategories$1.exports);

var C = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), pluralCategories$1.exports, {
  'default': pluralCategories
}));

// using them here because with this many small functions, bundlers produce less
// cruft than for ES module exports.

var Plurals = plurals || P;
var Categories = pluralCategories || C;
/* istanbul ignore next */

var NumberFormat = (typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && Intl.NumberFormat || PseudoNumberFormat__default['default']; // make-plural exports are cast with safe-identifier to be valid JS identifiers

var id = function id(lc) {
  return lc === 'in' ? '_in' : lc === 'pt-PT' ? 'pt_PT' : lc;
};

var getSelector = function getSelector(lc) {
  return Plurals[id(lc)];
};

var getCategories = function getCategories(lc, ord) {
  return Categories[id(lc)][ord ? 'ordinal' : 'cardinal'];
};

var PluralRules = getPluralRules__default['default'](NumberFormat, getSelector, getCategories);

module.exports = PluralRules;


/***/ }),

/***/ 3033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var PluralRules = __webpack_require__(6020);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PluralRules__default = /*#__PURE__*/_interopDefaultLegacy(PluralRules);

if (typeof Intl === 'undefined') {
  if (typeof __webpack_require__.g !== 'undefined') {
    __webpack_require__.g.Intl = {
      PluralRules: PluralRules__default['default']
    };
  } else if (typeof window !== 'undefined') {
    window.Intl = {
      PluralRules: PluralRules__default['default']
    };
  } else {
    __webpack_unused_export__ = {
      PluralRules: PluralRules__default['default']
    };
  }

  PluralRules__default['default'].polyfill = true;
} else if (!Intl.PluralRules) {
  Intl.PluralRules = PluralRules__default['default'];
  PluralRules__default['default'].polyfill = true;
} else {
  var test = ['en', 'es', 'ru', 'zh'];
  var supported = Intl.PluralRules.supportedLocalesOf(test);

  if (supported.length < test.length) {
    Intl.PluralRules = PluralRules__default['default'];
    PluralRules__default['default'].polyfill = true;
  }
}


/***/ }),

/***/ 9321:
/***/ (function(module) {

"use strict";


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var PseudoNumberFormat = /*#__PURE__*/function () {
  function PseudoNumberFormat(lc, // locale is ignored; always use 'en'
  _ref) {
    var minID = _ref.minimumIntegerDigits,
        minFD = _ref.minimumFractionDigits,
        maxFD = _ref.maximumFractionDigits,
        minSD = _ref.minimumSignificantDigits,
        maxSD = _ref.maximumSignificantDigits;

    _classCallCheck(this, PseudoNumberFormat);

    this._minID = typeof minID === 'number' ? minID : 1;
    this._minFD = typeof minFD === 'number' ? minFD : 0;
    this._maxFD = typeof maxFD === 'number' ? maxFD : Math.max(this._minFD, 3);

    if (typeof minSD === 'number' || typeof maxSD === 'number') {
      this._minSD = typeof minSD === 'number' ? minSD : 1;
      this._maxSD = typeof maxSD === 'number' ? maxSD : 21;
    }
  }

  _createClass(PseudoNumberFormat, [{
    key: "resolvedOptions",
    value: function resolvedOptions() {
      var opt = {
        minimumIntegerDigits: this._minID,
        minimumFractionDigits: this._minFD,
        maximumFractionDigits: this._maxFD
      };

      if (typeof this._minSD === 'number') {
        opt.minimumSignificantDigits = this._minSD;
        opt.maximumSignificantDigits = this._maxSD;
      }

      return opt;
    }
  }, {
    key: "format",
    value: function format(n) {
      if (this._minSD) {
        var raw = String(n);
        var prec = 0;

        for (var i = 0; i < raw.length; ++i) {
          var c = raw[i];
          if (c >= '0' && c <= '9') ++prec;
        }

        if (prec < this._minSD) return n.toPrecision(this._minSD);
        if (prec > this._maxSD) return n.toPrecision(this._maxSD);
        return raw;
      }

      if (this._minFD > 0) return n.toFixed(this._minFD);
      if (this._maxFD === 0) return n.toFixed(0);
      return String(n);
    }
  }]);

  return PseudoNumberFormat;
}();

module.exports = PseudoNumberFormat;


/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 4578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 9611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 7456:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZR": function() { return /* reexport */ dist_index_esm2017/* FirebaseError */.ZR; },
  "Jn": function() { return /* binding */ SDK_VERSION; },
  "qX": function() { return /* binding */ _getProvider; },
  "Xd": function() { return /* binding */ _registerComponent; },
  "Mq": function() { return /* binding */ getApp; },
  "ZF": function() { return /* binding */ initializeApp; },
  "KN": function() { return /* binding */ registerVersion; }
});

// UNUSED EXPORTS: _DEFAULT_ENTRY_NAME, _addComponent, _addOrOverwriteComponent, _apps, _clearComponents, _components, _removeServiceInstance, deleteApp, getApps, onLog, setLogLevel

// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(8463);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(3333);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(4444);
;// CONCATENATED MODULE: ./node_modules/@firebase/app/node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ./node_modules/@firebase/app/node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// CONCATENATED MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$o = "@firebase/app";
const version$1 = "0.9.13";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new esm_index_esm2017/* Logger */.Yd('@firebase/app');

const name$n = "@firebase/app-compat";

const name$m = "@firebase/analytics-compat";

const name$l = "@firebase/analytics";

const name$k = "@firebase/app-check-compat";

const name$j = "@firebase/app-check";

const name$i = "@firebase/auth";

const name$h = "@firebase/auth-compat";

const name$g = "@firebase/database";

const name$f = "@firebase/database-compat";

const name$e = "@firebase/functions";

const name$d = "@firebase/functions-compat";

const name$c = "@firebase/installations";

const name$b = "@firebase/installations-compat";

const name$a = "@firebase/messaging";

const name$9 = "@firebase/messaging-compat";

const name$8 = "@firebase/performance";

const name$7 = "@firebase/performance-compat";

const name$6 = "@firebase/remote-config";

const name$5 = "@firebase/remote-config-compat";

const name$4 = "@firebase/storage";

const name$3 = "@firebase/storage-compat";

const name$2 = "@firebase/firestore";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const version = "9.23.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$o]: 'fire-core',
    [name$n]: 'fire-core-compat',
    [name$l]: 'fire-analytics',
    [name$m]: 'fire-analytics-compat',
    [name$j]: 'fire-app-check',
    [name$k]: 'fire-app-check-compat',
    [name$i]: 'fire-auth',
    [name$h]: 'fire-auth-compat',
    [name$g]: 'fire-rtdb',
    [name$f]: 'fire-rtdb-compat',
    [name$e]: 'fire-fn',
    [name$d]: 'fire-fn-compat',
    [name$c]: 'fire-iid',
    [name$b]: 'fire-iid-compat',
    [name$a]: 'fire-fcm',
    [name$9]: 'fire-fcm-compat',
    [name$8]: 'fire-perf',
    [name$7]: 'fire-perf-compat',
    [name$6]: 'fire-rc',
    [name$5]: 'fire-rc-compat',
    [name$4]: 'fire-gcs',
    [name$3]: 'fire-gcs-compat',
    [name$2]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new index_esm2017/* Component */.wA('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = (0,dist_index_esm2017/* getDefaultAppConfig */.aH)());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0,dist_index_esm2017/* deepEqual */.vZ)(options, existingApp.options) &&
            (0,dist_index_esm2017/* deepEqual */.vZ)(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new index_esm2017/* ComponentContainer */.H0(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0,dist_index_esm2017/* getDefaultAppConfig */.aH)()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    const name = app.name;
    if (_apps.has(name)) {
        _apps.delete(name);
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new index_esm2017/* Component */.wA(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(STORE_NAME);
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const result = await db
            .transaction(STORE_NAME)
            .objectStore(STORE_NAME)
            .get(computeKey(app));
        return result;
    }
    catch (e) {
        if (e instanceof dist_index_esm2017/* FirebaseError */.ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof dist_index_esm2017/* FirebaseError */.ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (this._heartbeatsCache === null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0,dist_index_esm2017/* base64urlEncodeWithoutPadding */.L)(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0,dist_index_esm2017/* isIndexedDBAvailable */.hl)()) {
            return false;
        }
        else {
            return (0,dist_index_esm2017/* validateIndexedDBOpenable */.eu)()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || { heartbeats: [] };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0,dist_index_esm2017/* base64urlEncodeWithoutPadding */.L)(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new index_esm2017/* Component */.wA('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new index_esm2017/* Component */.wA('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$o, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$o, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 8463:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H0": function() { return /* binding */ ComponentContainer; },
/* harmony export */   "wA": function() { return /* binding */ Component; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var _firebase_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4444);


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new _firebase_util__WEBPACK_IMPORTED_MODULE_0__/* .Deferred */ .BH();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 3333:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yd": function() { return /* binding */ Logger; },
/* harmony export */   "in": function() { return /* binding */ LogLevel; }
/* harmony export */ });
/* unused harmony exports setLogLevel, setUserLogHandler */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types.js').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components | MergeComponents | null | undefined} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode | null | undefined} [children]
 *   Children.
 *
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components | null | undefined}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)

  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  /** @type {Components} */
  let allComponents

  if (disableParentContext) {
    allComponents =
      typeof components === 'function'
        ? components({})
        : components || emptyObject
  } else {
    allComponents = useMDXComponents(components)
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 9474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 3128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 9204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d7": function() { return /* binding */ AxiosError; }
/* harmony export */ });
/* unused harmony exports Axios, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig */
/* harmony import */ var _lib_axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6154);


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = _lib_axios_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;




/***/ }),

/***/ 6154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(1876)["Buffer"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new browser.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (browser.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: browser.isNode ? 'http' : 'xhr',

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: browser.classes.FormData,
    Blob: browser.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js





/* harmony default export */ var cookies = (browser.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (browser.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (browser.isStandardBrowserEnv || browser.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (browser.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && browser.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new core_AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.5.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 6665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IH": function() { return /* reexport */ getAnalytics; },
  "Kz": function() { return /* reexport */ logEvent; }
});

// UNUSED EXPORTS: getGoogleAnalyticsClientId, initializeAnalytics, isSupported, setAnalyticsCollectionEnabled, setConsent, setCurrentScreen, setDefaultEventParameters, setUserId, setUserProperties, settings

// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 2 modules
var index_esm2017 = __webpack_require__(7456);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(3333);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(4444);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(8463);
;// CONCATENATED MODULE: ./node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ./node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction));
        });
    }
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking)
            db.addEventListener('versionchange', () => blocking());
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// CONCATENATED MODULE: ./node_modules/@firebase/installations/dist/esm/index.esm2017.js





const index_esm2017_name = "@firebase/installations";
const version = "0.6.4";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof dist_index_esm2017/* FirebaseError */.ZR &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID can not be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (!response.ok) {
        throw await getErrorFromResponse('Delete Installation', response);
    }
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, oldEntry => {
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
            // Delete the unregistered entry without sending a deleteInstallation request.
            return undefined;
        }
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // Can't delete while trying to register.
            throw ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
        }
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return () => {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
    const installationsImpl = _getProvider(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = (0,index_esm2017/* _getProvider */.qX)(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0,index_esm2017/* _getProvider */.qX)(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    (0,index_esm2017/* _registerComponent */.Xd)(new dist_esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    (0,index_esm2017/* _registerComponent */.Xd)(new dist_esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * Firebase Installations
 *
 * @packageDocumentation
 */
registerInstallations();
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version, 'esm2017');


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/analytics/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Analytics.
 */
const ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const GA_FID_KEY = 'firebase_id';
const ORIGIN_KEY = 'origin';
const FETCH_TIMEOUT_MILLIS = 60 * 1000;
const DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new esm_index_esm2017/* Logger */.Yd('@firebase/analytics');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */]: 'A Firebase Analytics instance with the appId {$id} ' +
        ' already exists. ' +
        'Only one Firebase Analytics instance can be created for each appId.',
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */]: 'initializeAnalytics() cannot be called again with different options than those ' +
        'it was initially called with. It can be called again with the same options to ' +
        'return the existing instance, or getAnalytics() can be used ' +
        'to get a reference to the already-intialized instance.',
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */]: 'Firebase Analytics has already been initialized.' +
        'settings() must be called before initializing any Analytics instance' +
        'or it will have no effect.',
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */]: 'Firebase Analytics is not supported in this environment. ' +
        'Wrap initialization of analytics in analytics.isSupported() ' +
        'to prevent initialization in unsupported environments. Details: {$errorInfo}',
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */]: 'IndexedDB unavailable or restricted in this environment. ' +
        'Wrap initialization of analytics in analytics.isSupported() ' +
        'to prevent initialization in unsupported environments. Details: {$errorInfo}',
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */]: 'The config fetch request timed out while in an exponential backoff state.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field to' +
        'contain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field to' +
        'contain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const index_esm2017_ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('analytics', 'Analytics', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Verifies and creates a TrustedScriptURL.
 */
function createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith(GTAG_URL)) {
        const err = index_esm2017_ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */, {
            gtagURL: url
        });
        logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */
function promiseAllSettled(promises) {
    return Promise.all(promises.map(promise => promise.catch(e => e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */
function createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) {
        trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    }
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy
        ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL)
        : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) {
        dataLayer = window[dataLayerName];
    }
    else {
        window[dataLayerName] = dataLayer;
    }
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */
async function gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) {
            await initializationPromisesMap[correspondingAppId];
        }
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find(config => config.measurementId === measurementId);
            if (foundConfig) {
                await initializationPromisesMap[foundConfig.appId];
            }
        }
    }
    catch (e) {
        logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */, measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */
async function gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) {
                gaSendToList = [gaSendToList];
            }
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList) {
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find(config => config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) {
                    initializationPromisesToWaitFor.push(initializationPromise);
                }
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) {
            initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        }
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */, measurementId, gtagParams || {});
    }
    catch (e) {
        logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */
function wrapGtag(gtagCore, 
/**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */
initializationPromisesMap, 
/**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */
dynamicConfigPromisesList, 
/**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */
measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */
    async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            }
            else if (command === "config" /* GtagCommand.CONFIG */) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            }
            else if (command === "consent" /* GtagCommand.CONSENT */) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */, 'update', gtagParams);
            }
            else if (command === "get" /* GtagCommand.GET */) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */, measurementId, fieldName, callback);
            }
            else if (command === "set" /* GtagCommand.SET */) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */, customParams);
            }
            else {
                gtagCore(command, ...args);
            }
        }
        catch (e) {
            logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */
function wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function (..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] &&
        typeof window[gtagFunctionName] === 'function') {
        // @ts-ignore
        gtagCore = window[gtagFunctionName];
    }
    window[gtagFunctionName] = wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */
function findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)) {
        if (tag.src &&
            tag.src.includes(GTAG_URL) &&
            tag.src.includes(dataLayerName)) {
            return tag;
        }
    }
    return null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */
const LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */
const BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */
class RetryData {
    constructor(throttleMetadata = {}, intervalMillis = BASE_INTERVAL_MILLIS) {
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const defaultRetryData = new RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */
function index_esm2017_getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */
async function fetchDynamicConfig(appFields) {
    var _a;
    const { appId, apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: index_esm2017_getHeaders(apiKey)
    };
    const appUrl = DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = (await response.json());
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) {
                errorMessage = jsonResponse.error.message;
            }
        }
        catch (_ignored) { }
        throw index_esm2017_ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */, {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */
async function fetchDynamicConfigWithRetry(app, 
// retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = defaultRetryData, timeoutMillis) {
    const { appId, apiKey, measurementId } = app.options;
    if (!appId) {
        throw index_esm2017_ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */);
    }
    if (!apiKey) {
        if (measurementId) {
            return {
                measurementId,
                appId
            };
        }
        throw index_esm2017_ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */);
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new AnalyticsAbortSignal();
    setTimeout(async () => {
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : FETCH_TIMEOUT_MILLIS);
    return attemptFetchDynamicConfigWithRetry({ appId, apiKey, measurementId }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */
async function attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis, backoffCount }, signal, retryData = defaultRetryData // for testing
) {
    var _a;
    const { appId, measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await setAbortableTimeout(signal, throttleEndTimeMillis);
    }
    catch (e) {
        if (measurementId) {
            logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` +
                ` Falling back to the measurement ID ${measurementId}` +
                ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return { appId, measurementId };
        }
        throw e;
    }
    try {
        const response = await fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    }
    catch (e) {
        const error = e;
        if (!isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` +
                    ` Falling back to the measurement ID ${measurementId}` +
                    ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return { appId, measurementId };
            }
            else {
                throw e;
            }
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503
            ? (0,dist_index_esm2017/* calculateBackoffMillis */.$s)(backoffCount, retryData.intervalMillis, LONG_RETRY_FACTOR)
            : (0,dist_index_esm2017/* calculateBackoffMillis */.$s)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject) => {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(() => {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(index_esm2017_ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */, {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof dist_index_esm2017/* FirebaseError */.ZR) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
class AnalyticsAbortSignal {
    constructor() {
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach(listener => listener());
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Event parameters to set on 'gtag' during initialization.
 */
let defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */
async function logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */, eventName, eventParams);
        return;
    }
    else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), { 'send_to': measurementId });
        gtagFunction("event" /* GtagCommand.EVENT */, eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */
async function setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */, { 'screen_name': screenName });
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */
async function setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */, { 'user_id': id });
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */
async function setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties)) {
            // use dot notation for merge behavior in gtag.js
            flatProperties[`user_properties.${key}`] = properties[key];
        }
        gtagFunction("set" /* GtagCommand.SET */, flatProperties);
        return Promise.resolve();
    }
    else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */, measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */
async function internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject) => {
        gtagFunction("get" /* GtagCommand.GET */, measurementId, 'client_id', (clientId) => {
            if (!clientId) {
                reject(index_esm2017_ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */));
            }
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */
async function setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */
let defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */
function _setConsentDefaultForInit(consentSettings) {
    defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */
function _setDefaultEventParametersForInit(customParams) {
    defaultEventParametersForInit = customParams;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function validateIndexedDB() {
    if (!(0,dist_index_esm2017/* isIndexedDBAvailable */.hl)()) {
        logger.warn(index_esm2017_ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */, {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    }
    else {
        try {
            await (0,dist_index_esm2017/* validateIndexedDBOpenable */.eu)();
        }
        catch (e) {
            logger.warn(index_esm2017_ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */, {
                errorInfo: e === null || e === void 0 ? void 0 : e.toString()
            }).message);
            return false;
        }
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */
async function _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise
        .then(config => {
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId &&
            config.measurementId !== app.options.measurementId) {
            logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` +
                ` does not match the measurement ID fetched from the server (${config.measurementId}).` +
                ` To ensure analytics events are always sent to the correct Analytics property,` +
                ` update the` +
                ` measurement ID field in the local config or remove it from the local config.`);
        }
    })
        .catch(e => logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = validateIndexedDB().then(envIsValid => {
        if (envIsValid) {
            return installations.getId();
        }
        else {
            return undefined;
        }
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!findGtagScriptOnPage(dataLayerName)) {
        insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    }
    // Detects if there are consent settings that need to be configured.
    if (defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */, 'default', defaultConsentSettingsForInit);
        _setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) {
        configProperties[GA_FID_KEY] = fid;
    }
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */, dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if (defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */, defaultEventParametersForInit);
        _setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Analytics Service class.
 */
class AnalyticsService {
    constructor(app) {
        this.app = app;
    }
    _delete() {
        delete initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */
let initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */
let dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */
const measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */
let dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */
let gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */
let gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */
let wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */
let globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */
function settings(options) {
    if (globalInitDone) {
        throw index_esm2017_ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */);
    }
    if (options.dataLayerName) {
        dataLayerName = options.dataLayerName;
    }
    if (options.gtagName) {
        gtagName = options.gtagName;
    }
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */
function warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0,dist_index_esm2017/* isBrowserExtension */.ru)()) {
        mismatchedEnvMessages.push('This is a browser extension environment.');
    }
    if (!(0,dist_index_esm2017/* areCookiesEnabled */.zI)()) {
        mismatchedEnvMessages.push('Cookies are not available.');
    }
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages
            .map((message, index) => `(${index + 1}) ${message}`)
            .join(' ');
        const err = index_esm2017_ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */, {
            errorInfo: details
        });
        logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */
function factory(app, installations, options) {
    warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) {
        throw index_esm2017_ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */);
    }
    if (!app.options.apiKey) {
        if (app.options.measurementId) {
            logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` +
                ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` +
                ` provided in the "measurementId" field in the local Firebase config.`);
        }
        else {
            throw index_esm2017_ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */);
        }
    }
    if (initializationPromisesMap[appId] != null) {
        throw index_esm2017_ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */, {
            id: appId
        });
    }
    if (!globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        getOrCreateDataLayer(dataLayerName);
        const { wrappedGtag, gtagCore } = wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagName);
        wrappedGtagFunction = wrappedGtag;
        gtagCoreFunction = gtagCore;
        globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    initializationPromisesMap[appId] = _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCoreFunction, dataLayerName, options);
    const analyticsInstance = new AnalyticsService(app);
    return analyticsInstance;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
function getAnalytics(app = (0,index_esm2017/* getApp */.Mq)()) {
    app = (0,dist_index_esm2017/* getModularInstance */.m9)(app);
    // Dependencies
    const analyticsProvider = (0,index_esm2017/* _getProvider */.qX)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        return analyticsProvider.getImmediate();
    }
    return initializeAnalytics(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
function initializeAnalytics(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0,index_esm2017/* _getProvider */.qX)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0,dist_index_esm2017/* deepEqual */.vZ)(options, analyticsProvider.getOptions())) {
            return existingInstance;
        }
        else {
            throw index_esm2017_ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */);
        }
    }
    const analyticsInstance = analyticsProvider.initialize({ options });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */
async function isSupported() {
    if (isBrowserExtension()) {
        return false;
    }
    if (!areCookiesEnabled()) {
        return false;
    }
    if (!isIndexedDBAvailable()) {
        return false;
    }
    try {
        const isDBOpenable = await validateIndexedDBOpenable();
        return isDBOpenable;
    }
    catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */
function setCurrentScreen(analyticsInstance, screenName, options) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setCurrentScreen$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch(e => logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
async function getGoogleAnalyticsClientId(analyticsInstance) {
    analyticsInstance = getModularInstance(analyticsInstance);
    return internalGetGoogleAnalyticsClientId(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */
function setUserId(analyticsInstance, id, options) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setUserId$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch(e => logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */
function setUserProperties(analyticsInstance, properties, options) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setUserProperties$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch(e => logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */
function setAnalyticsCollectionEnabled(analyticsInstance, enabled) {
    analyticsInstance = getModularInstance(analyticsInstance);
    setAnalyticsCollectionEnabled$1(initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch(e => logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */
function setDefaultEventParameters(customParams) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) {
        wrappedGtagFunction("set" /* GtagCommand.SET */, customParams);
    }
    else {
        _setDefaultEventParametersForInit(customParams);
    }
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */
function logEvent(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0,dist_index_esm2017/* getModularInstance */.m9)(analyticsInstance);
    logEvent$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch(e => logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */
function setConsent(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if (wrappedGtagFunction) {
        wrappedGtagFunction("consent" /* GtagCommand.CONSENT */, 'update', consentSettings);
    }
    else {
        _setConsentDefaultForInit(consentSettings);
    }
}

const esm_index_esm2017_name = "@firebase/analytics";
const index_esm2017_version = "0.10.0";

/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */
function registerAnalytics() {
    (0,index_esm2017/* _registerComponent */.Xd)(new dist_esm_index_esm2017/* Component */.wA(ANALYTICS_TYPE, (container, { options: analyticsOptions }) => {
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container
            .getProvider('installations-internal')
            .getImmediate();
        return factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */));
    (0,index_esm2017/* _registerComponent */.Xd)(new dist_esm_index_esm2017/* Component */.wA('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
    (0,index_esm2017/* registerVersion */.KN)(esm_index_esm2017_name, index_esm2017_version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0,index_esm2017/* registerVersion */.KN)(esm_index_esm2017_name, index_esm2017_version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options) => logEvent(analytics, eventName, eventParams, options)
            };
        }
        catch (e) {
            throw index_esm2017_ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */, {
                reason: e
            });
        }
    }
}
registerAnalytics();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZF": function() { return /* reexport safe */ _firebase_app__WEBPACK_IMPORTED_MODULE_0__.ZF; },
/* harmony export */   "ZR": function() { return /* reexport safe */ _firebase_app__WEBPACK_IMPORTED_MODULE_0__.ZR; }
/* harmony export */ });
/* harmony import */ var _firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7456);



var name = "firebase";
var version = "9.23.0";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(0,_firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .registerVersion */ .KN)(name, version, 'app');
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 4367:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_O": function() { return /* reexport */ FacebookAuthProvider; },
  "hJ": function() { return /* reexport */ GoogleAuthProvider; },
  "O4": function() { return /* reexport */ OAuthProvider; },
  "LG": function() { return /* reexport */ confirmPasswordReset; },
  "Xb": function() { return /* reexport */ createUserWithEmailAndPassword; },
  "v0": function() { return /* reexport */ getAuth; },
  "cx": function() { return /* reexport */ getRedirectResult; },
  "LS": function() { return /* reexport */ sendPasswordResetEmail; },
  "sB": function() { return /* reexport */ signInWithCredential; },
  "e5": function() { return /* reexport */ signInWithEmailAndPassword; },
  "F6": function() { return /* reexport */ signInWithRedirect; },
  "TX": function() { return /* reexport */ verifyPasswordResetCode; }
});

// UNUSED EXPORTS: ActionCodeOperation, ActionCodeURL, AuthCredential, AuthErrorCodes, EmailAuthCredential, EmailAuthProvider, FactorId, GithubAuthProvider, OAuthCredential, OperationType, PhoneAuthCredential, PhoneAuthProvider, PhoneMultiFactorGenerator, ProviderId, RecaptchaVerifier, SAMLAuthProvider, SignInMethod, TotpMultiFactorGenerator, TotpSecret, TwitterAuthProvider, applyActionCode, beforeAuthStateChanged, browserLocalPersistence, browserPopupRedirectResolver, browserSessionPersistence, checkActionCode, connectAuthEmulator, debugErrorMap, deleteUser, fetchSignInMethodsForEmail, getAdditionalUserInfo, getIdToken, getIdTokenResult, getMultiFactorResolver, inMemoryPersistence, indexedDBLocalPersistence, initializeAuth, initializeRecaptchaConfig, isSignInWithEmailLink, linkWithCredential, linkWithPhoneNumber, linkWithPopup, linkWithRedirect, multiFactor, onAuthStateChanged, onIdTokenChanged, parseActionCodeURL, prodErrorMap, reauthenticateWithCredential, reauthenticateWithPhoneNumber, reauthenticateWithPopup, reauthenticateWithRedirect, reload, sendEmailVerification, sendSignInLinkToEmail, setPersistence, signInAnonymously, signInWithCustomToken, signInWithEmailLink, signInWithPhoneNumber, signInWithPopup, signOut, unlink, updateCurrentUser, updateEmail, updatePassword, updatePhoneNumber, updateProfile, useDeviceLanguage, verifyBeforeUpdateEmail

// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var index_esm2017 = __webpack_require__(4444);
// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 2 modules
var esm_index_esm2017 = __webpack_require__(7456);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(3333);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var component_dist_esm_index_esm2017 = __webpack_require__(8463);
;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/esm2017/index-e3d5d3f4.js






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */
const FactorId = {
    /** Phone as second factor */
    PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */
const ProviderId = {
    /** Facebook provider ID */
    FACEBOOK: 'facebook.com',
    /** GitHub provider ID */
    GITHUB: 'github.com',
    /** Google provider ID */
    GOOGLE: 'google.com',
    /** Password provider */
    PASSWORD: 'password',
    /** Phone provider */
    PHONE: 'phone',
    /** Twitter provider ID */
    TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */
const SignInMethod = {
    /** Email link sign in method */
    EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */
    EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */
    FACEBOOK: 'facebook.com',
    /** GitHub sign in method */
    GITHUB: 'github.com',
    /** Google sign in method */
    GOOGLE: 'google.com',
    /** Phone sign in method */
    PHONE: 'phone',
    /** Twitter sign in method */
    TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */
const OperationType = {
    /** Operation involving linking an additional provider to an already signed-in user. */
    LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */
    REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */
    SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */
const ActionCodeOperation = {
    /** The email link sign-in action. */
    EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */
    PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */
    RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */
    REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */
    VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */
    VERIFY_EMAIL: 'VERIFY_EMAIL'
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */]: "This app, identified by the domain where it's hosted, is not " +
            'authorized to use Firebase Authentication with the provided API key. ' +
            'Review your key configuration in the Google API console.',
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */]: 'The requested mobile application corresponding to the identifier (' +
            'Android package name or iOS bundle ID) provided is not installed on ' +
            'this device.',
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */]: 'The reCAPTCHA response token provided is either invalid, expired, ' +
            'already used or the domain associated with it does not match the list ' +
            'of whitelisted domains.',
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */]: 'The SMS code has expired. Please re-send the verification code to try ' +
            'again.',
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */]: 'This operation is sensitive and requires recent authentication. Log in ' +
            'again before retrying this request.',
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */]: 'Another Firebase SDK was initialized and is trying to use Auth before Auth is ' +
            'initialized. Please be sure to call `initializeAuth` or `getAuth` before ' +
            'starting any other Firebase SDK.',
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */]: 'Please activate Dynamic Links in the Firebase Console and agree to the terms and ' +
            'conditions.',
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */]: 'Auth instance has already been used to make a network call. Auth can ' +
            'no longer be configured to use the emulator. Try calling ' +
            '"connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */]: 'The phone verification request contains an invalid application verifier.' +
            ' The reCAPTCHA token response is either invalid or expired.',
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */]: 'The mobile app identifier is not registed for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */]: "This user's credential isn't valid for this project. This can happen " +
            "if the user's token has been tampered with, or if the user isn't for " +
            'the project associated with this API key.',
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */]: 'The SMS verification code used to create the phone auth credential is ' +
            'invalid. Please resend the verification code sms and be sure to use the ' +
            'verification code provided by the user.',
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */]: 'The following Cordova plugins must be installed to enable OAuth sign-in: ' +
            'cordova-plugin-buildinfo, cordova-universal-links-plugin, ' +
            'cordova-plugin-browsertab, cordova-plugin-inappbrowser and ' +
            'cordova-plugin-customurlscheme.',
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */]: 'The supplied auth credential is malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */]: 'The email template corresponding to this action contains invalid characters in its message. ' +
            'Please fix by going to the Auth email templates section in the Firebase Console.',
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */]: 'EmailAuthProvider is not supported for this operation. This operation ' +
            'only supports OAuth providers.',
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */]: 'The OAuth client ID provided is either invalid or does not match the ' +
            'specified API key.',
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */]: 'This domain is not authorized for OAuth operations for your Firebase ' +
            'project. Edit the list of authorized domains from the Firebase console.',
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */]: 'The action code is invalid. This can happen if the code is malformed, ' +
            'expired, or has already been used.',
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */]: 'The format of the phone number provided is incorrect. Please enter the ' +
            'phone number in a format that can be parsed into E.164 format. E.164 ' +
            'phone numbers are written in the format [+][country code][subscriber ' +
            'number including area code].',
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */]: 'The email corresponding to this action failed to send as the provided ' +
            'recipient email address is invalid.',
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */]: 'The email template corresponding to this action contains an invalid sender email or name. ' +
            'Please fix by going to the Auth email templates section in the Firebase Console.',
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */]: 'Be sure to include authDomain when calling firebase.initializeApp(), ' +
            'by following the instructions in the Firebase console.',
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */]: 'The phone verification request is missing an application verifier ' +
            'assertion. A reCAPTCHA response token needs to be provided.',
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */]: 'The request does not contain a valid nonce. This can occur if the ' +
            'SHA-256 hash of the provided raw nonce does not match the hashed nonce ' +
            'in the ID token payload.',
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */]: 'An account already exists with the same email address but different ' +
            'sign-in credentials. Sign in using a provider associated with this ' +
            'email address.',
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */]: 'A null user object was provided as the argument for an operation which ' +
            'requires a non-null user object.',
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */]: 'The given sign-in provider is disabled for this Firebase project. ' +
            'Enable it in the Firebase console, under the sign-in method tab of the ' +
            'Auth section.',
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */]: 'This operation is not supported in the environment this application is ' +
            'running on. "location.protocol" must be http, https or chrome-extension' +
            ' and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */]: 'We have blocked all requests from this device due to unusual activity. ' +
            'Try again later.',
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */]: 'The domain of the continue URL is not whitelisted.  Please whitelist ' +
            'the domain in the Firebase console.',
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */]: 'There is no user record corresponding to this identifier. The user may ' +
            'have been deleted.',
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */]: 'initializeAuth() has already been called with ' +
            'different options. To avoid this error, call initializeAuth() with the ' +
            'same options as when it was originally called, or call getAuth() to return the' +
            ' already initialized instance.',
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */]: 'The reCAPTCHA version is invalid when sending request to the backend.'
    };
}
function _prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */]: 'Another Firebase SDK was initialized and is trying to use Auth before Auth is ' +
            'initialized. Please be sure to call `initializeAuth` or `getAuth` before ' +
            'starting any other Firebase SDK.'
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */
const debugErrorMap = (/* unused pure expression or super */ null && (_debugErrorMap));
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */
const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new index_esm2017/* ErrorFactory */.LL('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */
const AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logClient = new dist_esm_index_esm2017/* Logger */.Yd('@firebase/auth');
function _logWarn(msg, ...args) {
    if (logClient.logLevel <= dist_esm_index_esm2017/* LogLevel.WARN */["in"].WARN) {
        logClient.warn(`Auth (${esm_index_esm2017/* SDK_VERSION */.Jn}): ${msg}`, ...args);
    }
}
function _logError(msg, ...args) {
    if (logClient.logLevel <= dist_esm_index_esm2017/* LogLevel.ERROR */["in"].ERROR) {
        logClient.error(`Auth (${esm_index_esm2017/* SDK_VERSION */.Jn}): ${msg}`, ...args);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _fail(authOrCode, ...rest) {
    throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
    return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, prodErrorMap()), { [code]: message });
    const factory = new index_esm2017/* ErrorFactory */.LL('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function _assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) {
            _fail(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        }
        throw _errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */, `Type of ${object.constructor.name} does not match expected instance.` +
            `Did you pass a reference from a different Auth SDK?`);
    }
}
function createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [...rest.slice(1)];
        if (fullParams[0]) {
            fullParams[0].appName = authOrCode.name;
        }
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
    if (!assertion) {
        throw createErrorInternal(authOrCode, ...rest);
    }
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */
function debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    _logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */
function debugAssert(assertion, message) {
    if (!assertion) {
        debugFail(message);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getCurrentUrl() {
    var _a;
    return (typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href)) || '';
}
function _isHttpOrHttps() {
    return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}
function _getCurrentScheme() {
    var _a;
    return (typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol)) || null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Determine whether the browser is working online
 */
function _isOnline() {
    if (typeof navigator !== 'undefined' &&
        navigator &&
        'onLine' in navigator &&
        typeof navigator.onLine === 'boolean' &&
        // Apply only for traditional web apps and Chrome extensions.
        // This is especially true for Cordova apps which have unreliable
        // navigator.onLine behavior unless cordova-plugin-network-information is
        // installed which overwrites the native navigator.onLine value and
        // defines navigator.connection.
        (_isHttpOrHttps() || (0,index_esm2017/* isBrowserExtension */.ru)() || 'connection' in navigator)) {
        return navigator.onLine;
    }
    // If we can't determine the state, assume it is online.
    return true;
}
function _getUserLanguage() {
    if (typeof navigator === 'undefined') {
        return null;
    }
    const navigatorLanguage = navigator;
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language ||
        // Couldn't determine language.
        null);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */
class Delay {
    constructor(shortDelay, longDelay) {
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0,index_esm2017/* isMobileCordova */.uI)() || (0,index_esm2017/* isReactNative */.b$)();
    }
    get() {
        if (!_isOnline()) {
            // Pick the shorter timeout.
            return Math.min(5000 /* DelayMin.OFFLINE */, this.shortDelay);
        }
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _emulatorUrl(config, path) {
    debugAssert(config.emulator, 'Emulator should always be set here');
    const { url } = config.emulator;
    if (!path) {
        return url;
    }
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FetchProvider {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) {
            this.headersImpl = headersImpl;
        }
        if (responseImpl) {
            this.responseImpl = responseImpl;
        }
    }
    static fetch() {
        if (this.fetchImpl) {
            return this.fetchImpl;
        }
        if (typeof self !== 'undefined' && 'fetch' in self) {
            return self.fetch;
        }
        debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) {
            return this.headersImpl;
        }
        if (typeof self !== 'undefined' && 'Headers' in self) {
            return self.Headers;
        }
        debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) {
            return this.responseImpl;
        }
        if (typeof self !== 'undefined' && 'Response' in self) {
            return self.Response;
        }
        debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Map from errors returned by the server to errors to developer visible errors
 */
const SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */]: "user-not-found" /* AuthErrorCode.USER_DELETED */,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);
function _addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) {
        return Object.assign(Object.assign({}, request), { tenantId: auth.tenantId });
    }
    return request;
}
async function _performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return _performFetchWithErrorHandling(auth, customErrorMap, async () => {
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */) {
                params = request;
            }
            else {
                body = {
                    body: JSON.stringify(request)
                };
            }
        }
        const query = (0,index_esm2017/* querystring */.xO)(Object.assign({ key: auth.config.apiKey }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */] = 'application/json';
        if (auth.languageCode) {
            headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */] = auth.languageCode;
        }
        return FetchProvider.fetch()(_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({ method,
            headers, referrerPolicy: 'no-referrer' }, body));
    });
}
async function _performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) {
            throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */, json);
        }
        if (response.ok && !('errorMessage' in json)) {
            return json;
        }
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */) {
                throw _makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */, json);
            }
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */) {
                throw _makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */, json);
            }
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */) {
                throw _makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */, json);
            }
            const authError = errorMap[serverErrorCode] ||
                serverErrorCode
                    .toLowerCase()
                    .replace(/[_\s]+/g, '-');
            if (serverErrorMessage) {
                throw _errorWithCustomMessage(auth, authError, serverErrorMessage);
            }
            else {
                _fail(auth, authError);
            }
        }
    }
    catch (e) {
        if (e instanceof index_esm2017/* FirebaseError */.ZR) {
            throw e;
        }
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        _fail(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */, { 'message': String(e) });
    }
}
async function _performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = (await _performApiRequest(auth, method, path, request, customErrorMap));
    if ('mfaPendingCredential' in serverResponse) {
        _fail(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */, {
            _serverResponse: serverResponse
        });
    }
    return serverResponse;
}
function _getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) {
        return `${auth.config.apiScheme}://${base}`;
    }
    return _emulatorUrl(auth.config, base);
}
class NetworkTimeout {
    constructor(auth) {
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject) => {
            this.timer = setTimeout(() => {
                return reject(_createError(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */));
            }, DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function _makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) {
        errorParams.email = response.email;
    }
    if (response.phoneNumber) {
        errorParams.phoneNumber = response.phoneNumber;
    }
    const error = _createError(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteAccount(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */, request);
}
async function deleteLinkedAccounts(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */, request);
}
async function getAccountInfo(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) {
        return undefined;
    }
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) {
            // Convert to UTC date string.
            return date.toUTCString();
        }
    }
    catch (e) {
        // Do nothing. undefined will be returned.
    }
    return undefined;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
function getIdToken(user, forceRefresh = false) {
    return getModularInstance(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getIdTokenResult(user, forceRefresh = false) {
    const userInternal = (0,index_esm2017/* getModularInstance */.m9)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = _parseToken(token);
    _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims,
        token,
        authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
        expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function _parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined ||
        payload === undefined ||
        signature === undefined) {
        _logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0,index_esm2017/* base64Decode */.tV)(payload);
        if (!decoded) {
            _logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    }
    catch (e) {
        _logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */
function _tokenExpiresIn(token) {
    const parsedToken = _parseToken(token);
    _assert(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    _assert(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    _assert(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) {
        return promise;
    }
    try {
        return await promise;
    }
    catch (e) {
        if (e instanceof index_esm2017/* FirebaseError */.ZR && isUserInvalidated(e)) {
            if (user.auth.currentUser === user) {
                await user.auth.signOut();
            }
        }
        throw e;
    }
}
function isUserInvalidated({ code }) {
    return (code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */}` ||
        code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */}`);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ProactiveRefresh {
    constructor(user) {
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */;
    }
    _start() {
        if (this.isRunning) {
            return;
        }
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) {
            return;
        }
        this.isRunning = false;
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
        }
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */);
            return interval;
        }
        else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) {
            // Just in case...
            return;
        }
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async () => {
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        }
        catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) ===
                `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */}`) {
                this.schedule(/* wasError */ true);
            }
            return;
        }
        this.schedule();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserMetadata {
    constructor(createdAt, lastLoginAt) {
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await _logoutIfInvalidated(user, getAccountInfo(auth, { idToken }));
    _assert(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length)
        ? extractProviderData(coreAccount.providerUserInfo)
        : [];
    const providerData = mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData,
        metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */
async function reload(user) {
    const userInternal = (0,index_esm2017/* getModularInstance */.m9)(user);
    await _reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
    const deduped = original.filter(o => !newData.some(n => n.providerId === o.providerId));
    return [...deduped, ...newData];
}
function extractProviderData(providers) {
    return providers.map((_a) => {
        var { providerId } = _a, provider = (0,tslib_es6.__rest)(_a, ["providerId"]);
        return {
            providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestStsToken(auth, refreshToken) {
    const response = await _performFetchWithErrorHandling(auth, {}, async () => {
        const body = (0,index_esm2017/* querystring */.xO)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost, apiKey } = auth.config;
        const url = _getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */, `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */] = 'application/x-www-form-urlencoded';
        return FetchProvider.fetch()(url, {
            method: "POST" /* HttpMethod.POST */,
            headers,
            body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */
class StsTokenManager {
    constructor() {
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return (!this.expirationTime ||
            Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */);
    }
    updateFromServerResponse(response) {
        _assert(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        _assert(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        _assert(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined'
            ? Number(response.expiresIn)
            : _tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        _assert(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */);
        if (!forceRefresh && this.accessToken && !this.isExpired) {
            return this.accessToken;
        }
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken, refreshToken, expiresIn } = await requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken, accessToken, expirationTime } = object;
        const manager = new StsTokenManager();
        if (refreshToken) {
            _assert(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */, {
                appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            _assert(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */, {
                appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            _assert(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */, {
                appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return debugFail('not implemented');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function assertStringOrUndefined(assertion, appName) {
    _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */, { appName });
}
class UserImpl {
    constructor(_a) {
        var { uid, auth, stsTokenManager } = _a, opt = (0,tslib_es6.__rest)(_a, ["uid", "auth", "stsTokenManager"]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */;
        this.proactiveRefresh = new ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [...opt.providerData] : [];
        this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        _assert(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return getIdTokenResult(this, forceRefresh);
    }
    reload() {
        return reload(this);
    }
    _assign(user) {
        if (this === user) {
            return;
        }
        _assert(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map(userInfo => (Object.assign({}, userInfo)));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new UserImpl(Object.assign(Object.assign({}, this), { auth, stsTokenManager: this.stsTokenManager._clone() }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        _assert(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) {
            this.reloadListener(userInfo);
        }
        else {
            // If no listener is subscribed yet, save the result so it's available when they do subscribe
            this.reloadUserInfo = userInfo;
        }
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken &&
            response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) {
            await _reloadWithoutSaving(this);
        }
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) {
            this.auth._notifyListenersIfCurrent(this);
        }
    }
    async delete() {
        const idToken = await this.getIdToken();
        await _logoutIfInvalidated(this, deleteAccount(this.auth, { idToken }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({ uid: this.uid, email: this.email || undefined, emailVerified: this.emailVerified, displayName: this.displayName || undefined, isAnonymous: this.isAnonymous, photoURL: this.photoURL || undefined, phoneNumber: this.phoneNumber || undefined, tenantId: this.tenantId || undefined, providerData: this.providerData.map(userInfo => (Object.assign({}, userInfo))), stsTokenManager: this.stsTokenManager.toJSON(), 
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId }, this.metadata.toJSON()), { 
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey, appName: this.auth.name });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid, emailVerified, isAnonymous, providerData, stsTokenManager: plainObjectTokenManager } = object;
        _assert(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        _assert(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        assertStringOrUndefined(displayName, auth.name);
        assertStringOrUndefined(email, auth.name);
        _assert(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        _assert(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        assertStringOrUndefined(phoneNumber, auth.name);
        assertStringOrUndefined(photoURL, auth.name);
        assertStringOrUndefined(tenantId, auth.name);
        assertStringOrUndefined(_redirectEventId, auth.name);
        assertStringOrUndefined(createdAt, auth.name);
        assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new UserImpl({
            uid,
            auth,
            email,
            emailVerified,
            displayName,
            isAnonymous,
            photoURL,
            phoneNumber,
            tenantId,
            stsTokenManager,
            createdAt,
            lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) {
            user.providerData = providerData.map(userInfo => (Object.assign({}, userInfo)));
        }
        if (_redirectEventId) {
            user._redirectEventId = _redirectEventId;
        }
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */
    static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: idTokenResponse.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await _reloadWithoutSaving(user);
        return user;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const instanceCache = new Map();
function _getInstance(cls) {
    debugAssert(cls instanceof Function, 'Expected a class definition');
    let instance = instanceCache.get(cls);
    if (instance) {
        debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    instanceCache.set(cls, instance);
    return instance;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InMemoryPersistence {
    constructor() {
        this.type = "NONE" /* PersistenceType.NONE */;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */
const inMemoryPersistence = InMemoryPersistence;

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _persistenceKeyName(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */}:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
    constructor(persistence, auth, userKey) {
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config, name } = this.auth;
        this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = _persistenceKeyName("persistence" /* KeyName.PERSISTENCE_USER */, config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? UserImpl._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) {
            return;
        }
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) {
            return this.setCurrentUser(currentUser);
        }
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */) {
        if (!persistenceHierarchy.length) {
            return new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey);
        }
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence) => {
            if (await persistence._isAvailable()) {
                return persistence;
            }
            return undefined;
        }))).filter(persistence => persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] ||
            _getInstance(inMemoryPersistence);
        const key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy) {
            try {
                const blob = await persistence._get(key);
                if (blob) {
                    const user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                    if (persistence !== selectedPersistence) {
                        userToMigrate = user;
                    }
                    selectedPersistence = persistence;
                    break;
                }
            }
            catch (_a) { }
        }
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter(p => p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration ||
            !migrationHierarchy.length) {
            return new PersistenceUserManager(selectedPersistence, auth, userKey);
        }
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) {
            // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
            // we'll just let it bubble to surface the error.
            await selectedPersistence._set(key, userToMigrate.toJSON());
        }
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence) => {
            if (persistence !== selectedPersistence) {
                try {
                    await persistence._remove(key);
                }
                catch (_a) { }
            }
        }));
        return new PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Determine the browser for the purposes of reporting usage to the API
 */
function _getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) {
        return "Opera" /* BrowserName.OPERA */;
    }
    else if (_isIEMobile(ua)) {
        // Windows phone IEMobile browser.
        return "IEMobile" /* BrowserName.IEMOBILE */;
    }
    else if (ua.includes('msie') || ua.includes('trident/')) {
        return "IE" /* BrowserName.IE */;
    }
    else if (ua.includes('edge/')) {
        return "Edge" /* BrowserName.EDGE */;
    }
    else if (_isFirefox(ua)) {
        return "Firefox" /* BrowserName.FIREFOX */;
    }
    else if (ua.includes('silk/')) {
        return "Silk" /* BrowserName.SILK */;
    }
    else if (_isBlackBerry(ua)) {
        // Blackberry browser.
        return "Blackberry" /* BrowserName.BLACKBERRY */;
    }
    else if (_isWebOS(ua)) {
        // WebOS default browser.
        return "Webos" /* BrowserName.WEBOS */;
    }
    else if (_isSafari(ua)) {
        return "Safari" /* BrowserName.SAFARI */;
    }
    else if ((ua.includes('chrome/') || _isChromeIOS(ua)) &&
        !ua.includes('edge/')) {
        return "Chrome" /* BrowserName.CHROME */;
    }
    else if (_isAndroid(ua)) {
        // Android stock browser.
        return "Android" /* BrowserName.ANDROID */;
    }
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) {
            return matches[1];
        }
    }
    return "Other" /* BrowserName.OTHER */;
}
function _isFirefox(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /firefox\//i.test(ua);
}
function _isSafari(userAgent = (0,index_esm2017/* getUA */.z$)()) {
    const ua = userAgent.toLowerCase();
    return (ua.includes('safari/') &&
        !ua.includes('chrome/') &&
        !ua.includes('crios/') &&
        !ua.includes('android'));
}
function _isChromeIOS(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /crios\//i.test(ua);
}
function _isIEMobile(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /iemobile/i.test(ua);
}
function _isAndroid(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /android/i.test(ua);
}
function _isBlackBerry(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /blackberry/i.test(ua);
}
function _isWebOS(ua = (0,index_esm2017/* getUA */.z$)()) {
    return /webos/i.test(ua);
}
function _isIOS(ua = (0,index_esm2017/* getUA */.z$)()) {
    return (/iphone|ipad|ipod/i.test(ua) ||
        (/macintosh/i.test(ua) && /mobile/i.test(ua)));
}
function _isIOS7Or8(ua = getUA()) {
    return (/(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) ||
        /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua));
}
function _isIOSStandalone(ua = (0,index_esm2017/* getUA */.z$)()) {
    var _a;
    return _isIOS(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function _isIE10() {
    return (0,index_esm2017/* isIE */.w1)() && document.documentMode === 10;
}
function _isMobileBrowser(ua = (0,index_esm2017/* getUA */.z$)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return (_isIOS(ua) ||
        _isAndroid(ua) ||
        _isWebOS(ua) ||
        _isBlackBerry(ua) ||
        /windows phone/i.test(ua) ||
        _isIEMobile(ua));
}
function _isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    }
    catch (e) {
        return false;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * Determine the SDK version string
 */
function _getClientVersion(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch (clientPlatform) {
        case "Browser" /* ClientPlatform.BROWSER */:
            // In a browser environment, report the browser name.
            reportedPlatform = _getBrowserName((0,index_esm2017/* getUA */.z$)());
            break;
        case "Worker" /* ClientPlatform.WORKER */:
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${_getBrowserName((0,index_esm2017/* getUA */.z$)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length
        ? frameworks.join(',')
        : 'FirebaseCore-web'; /* default value if no other framework is used */
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */}/${esm_index_esm2017/* SDK_VERSION */.Jn}/${reportedFrameworks}`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getRecaptchaParams(auth) {
    return ((await _performApiRequest(auth, "GET" /* HttpMethod.GET */, "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */)).recaptchaSiteKey || '');
}
async function getRecaptchaConfig(auth, request) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */, "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isV2(grecaptcha) {
    return (grecaptcha !== undefined &&
        grecaptcha.getResponse !== undefined);
}
function isEnterprise(grecaptcha) {
    return (grecaptcha !== undefined &&
        grecaptcha.enterprise !== undefined);
}
class RecaptchaConfig {
    constructor(response) {
        /**
         * The reCAPTCHA site key.
         */
        this.siteKey = '';
        /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */
        this.emailPasswordEnabled = false;
        if (response.recaptchaKey === undefined) {
            throw new Error('recaptchaKey undefined');
        }
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.emailPasswordEnabled = response.recaptchaEnforcementState.some(enforcementState => enforcementState.provider === 'EMAIL_PASSWORD_PROVIDER' &&
            enforcementState.enforcementState !== 'OFF');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function _loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.setAttribute('src', url);
        el.onload = resolve;
        el.onerror = e => {
            const error = _createError("internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
            error.customData = e;
            reject(error);
        };
        el.type = 'text/javascript';
        el.charset = 'UTF-8';
        getScriptParentElement().appendChild(el);
    });
}
function _generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}

/* eslint-disable @typescript-eslint/no-require-imports */
const RECAPTCHA_ENTERPRISE_URL = 'https://www.google.com/recaptcha/enterprise.js?render=';
const RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const FAKE_TOKEN = 'NO_RECAPTCHA';
class RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */
    constructor(authExtern) {
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */
        this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = _castAuth(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */
    async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) {
                    return auth._agentRecaptchaConfig.siteKey;
                }
                if (auth.tenantId != null &&
                    auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) {
                    return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
                }
            }
            return new Promise(async (resolve, reject) => {
                getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */
                })
                    .then(response => {
                    if (response.recaptchaKey === undefined) {
                        reject(new Error('recaptcha Enterprise site key undefined'));
                    }
                    else {
                        const config = new RecaptchaConfig(response);
                        if (auth.tenantId == null) {
                            auth._agentRecaptchaConfig = config;
                        }
                        else {
                            auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        }
                        return resolve(config.siteKey);
                    }
                })
                    .catch(error => {
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if (isEnterprise(grecaptcha)) {
                grecaptcha.enterprise.ready(() => {
                    grecaptcha.enterprise
                        .execute(siteKey, { action })
                        .then(token => {
                        resolve(token);
                    })
                        .catch(() => {
                        resolve(FAKE_TOKEN);
                    });
                });
            }
            else {
                reject(Error('No reCAPTCHA enterprise script loaded.'));
            }
        }
        return new Promise((resolve, reject) => {
            retrieveSiteKey(this.auth)
                .then(siteKey => {
                if (!forceRefresh && isEnterprise(window.grecaptcha)) {
                    retrieveRecaptchaToken(siteKey, resolve, reject);
                }
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    _loadJS(RECAPTCHA_ENTERPRISE_URL + siteKey)
                        .then(() => {
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    })
                        .catch(error => {
                        reject(error);
                    });
                }
            })
                .catch(error => {
                reject(error);
            });
        });
    }
}
async function injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    }
    catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) {
        Object.assign(newRequest, { captchaResponse });
    }
    else {
        Object.assign(newRequest, { 'captchaResp': captchaResponse });
    }
    Object.assign(newRequest, { 'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */
    });
    return newRequest;
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthMiddlewareQueue {
    constructor(auth) {
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user) => new Promise((resolve, reject) => {
            try {
                const result = callback(user);
                // Either resolve with existing promise or wrap a non-promise
                // return value into a promise.
                resolve(result);
            }
            catch (e) {
                // Sync callback throws.
                reject(e);
            }
        });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return () => {
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = () => Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) {
            return;
        }
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue) {
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) {
                    onAbortStack.push(beforeStateCallback.onAbort);
                }
            }
        }
        catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack) {
                try {
                    onAbort();
                }
                catch (_) {
                    /* swallow error */
                }
            }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */, {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthImpl {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new Subscription(this);
        this.idTokenSubscription = new Subscription(this);
        this.beforeStateQueue = new AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = { appVerificationDisabledForTesting: false };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) {
            this._popupRedirectResolver = _getInstance(popupRedirectResolver);
        }
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async () => {
            var _a, _b;
            if (this._deleted) {
                return;
            }
            this.persistenceManager = await PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) {
                return;
            }
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) {
                // If this fails, don't halt auth loading
                try {
                    await this._popupRedirectResolver._initialize(this);
                }
                catch (e) {
                    /* Ignore the error */
                }
            }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) {
                return;
            }
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */
    async _onStorageEvent() {
        if (this._deleted) {
            return;
        }
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) {
            // No change, do nothing (was signed out and remained signed out).
            return;
        }
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = (await this.assertedPersistence.getCurrentUser());
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) &&
                (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) {
            return this.directlySetCurrentUser(null);
        }
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) {
                try {
                    await this.beforeStateQueue.runMiddleware(futureCurrentUser);
                }
                catch (e) {
                    futureCurrentUser = previouslyStoredUser;
                    // We know this is available since the bit is only set when the
                    // resolver is available
                    this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(e));
                }
            }
            if (futureCurrentUser) {
                return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            }
            else {
                return this.directlySetCurrentUser(null);
            }
        }
        _assert(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser &&
            this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) {
            return this.directlySetCurrentUser(futureCurrentUser);
        }
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        }
        catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await _reloadWithoutSaving(user);
        }
        catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !==
                `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */}`) {
                // Something's wrong with the user's token. Log them out and remove
                // them from storage
                return this.directlySetCurrentUser(null);
            }
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = _getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern
            ? (0,index_esm2017/* getModularInstance */.m9)(userExtern)
            : null;
        if (user) {
            _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */);
        }
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) {
            return;
        }
        if (user) {
            _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */);
        }
        if (!skipBeforeStateCallbacks) {
            await this.beforeStateQueue.runMiddleware(user);
        }
        return this.queue(async () => {
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) {
            await this._setRedirectUser(null);
        }
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async () => {
            await this.assertedPersistence.setPersistence(_getInstance(persistence));
        });
    }
    async initializeRecaptchaConfig() {
        const response = await getRecaptchaConfig(this, {
            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */,
            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */
        });
        const config = new RecaptchaConfig(response);
        if (this.tenantId == null) {
            this._agentRecaptchaConfig = config;
        }
        else {
            this._tenantRecaptchaConfigs[this.tenantId] = config;
        }
        if (config.emailPasswordEnabled) {
            const verifier = new RecaptchaEnterpriseVerifier(this);
            void verifier.verify();
        }
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) {
            return this._agentRecaptchaConfig;
        }
        else {
            return this._tenantRecaptchaConfigs[this.tenantId];
        }
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new index_esm2017/* ErrorFactory */.LL('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null
            ? redirectManager.removeCurrentUser()
            : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = (popupRedirectResolver && _getInstance(popupRedirectResolver)) ||
                this._popupRedirectResolver;
            _assert(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
            this.redirectPersistenceManager = await PersistenceUserManager.create(this, [_getInstance(resolver._redirectPersistence)], "redirectUser" /* KeyName.REDIRECT_USER */);
            this.redirectUser =
                await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) {
            await this.queue(async () => { });
        }
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) {
            return this._currentUser;
        }
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) {
            return this.redirectUser;
        }
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) {
            return this.queue(async () => this.directlySetCurrentUser(user));
        }
    }
    /** Notifies listeners only if the user is current */
    _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) {
            this.notifyAuthListeners();
        }
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) {
            this._currentUser._startProactiveRefresh();
        }
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) {
            this._currentUser._stopProactiveRefresh();
        }
    }
    /** Returns the current user cast as the internal type */
    get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) {
            return;
        }
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) {
            return () => { };
        }
        const cb = typeof nextOrObserver === 'function'
            ? nextOrObserver
            : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized
            ? Promise.resolve()
            : this._initializationPromise;
        _assert(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(() => cb(this.currentUser));
        if (typeof nextOrObserver === 'function') {
            return subscription.addObserver(nextOrObserver, error, completed);
        }
        else {
            return subscription.addObserver(nextOrObserver);
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */
    async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) {
            this._currentUser._stopProactiveRefresh();
        }
        if (user && this.isProactiveRefreshEnabled) {
            user._startProactiveRefresh();
        }
        this.currentUser = user;
        if (user) {
            await this.assertedPersistence.setCurrentUser(user);
        }
        else {
            await this.assertedPersistence.removeCurrentUser();
        }
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        _assert(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) {
            return;
        }
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */]: this.clientVersion
        };
        if (this.app.options.appId) {
            headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */] = this.app.options.appId;
        }
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider
            .getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) {
            headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */] = heartbeatsHeader;
        }
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) {
            headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */] = appCheckToken;
        }
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider
            .getImmediate({ optional: true })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) {
            // Context: appCheck.getToken() will never throw even if an error happened.
            // In the error case, a dummy token will be returned along with an error field describing
            // the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            _logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        }
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */
function _castAuth(auth) {
    return (0,index_esm2017/* getModularInstance */.m9)(auth);
}
/** Helper class to wrap subscriber logic */
class Subscription {
    constructor(auth) {
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0,index_esm2017/* createSubscribe */.ne)(observer => (this.observer = observer));
    }
    get next() {
        _assert(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        return this.observer.next.bind(this.observer);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */
function initializeAuth(app, deps) {
    const provider = (0,esm_index_esm2017/* _getProvider */.qX)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0,index_esm2017/* deepEqual */.vZ)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) {
            return auth;
        }
        else {
            _fail(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */);
        }
    }
    const auth = provider.initialize({ options: deps });
    return auth;
}
function _initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [persistence]).map(_getInstance);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) {
        auth._updateErrorMap(deps.errorMap);
    }
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}

/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */
function connectAuthEmulator(auth, url, options) {
    const authInternal = _castAuth(auth);
    _assert(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */);
    _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */);
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = extractProtocol(url);
    const { host, port } = extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = { url: `${protocol}//${host}${portStr}/` };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host,
        port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({ disableWarnings })
    });
    if (!disableWarnings) {
        emitEmulatorWarning();
    }
}
function extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
    const protocol = extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) {
        return { host: '', port: null };
    }
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return { host, port: parsePort(hostAndPort.substr(host.length + 1)) };
    }
    else {
        const [host, port] = hostAndPort.split(':');
        return { host, port: parsePort(port) };
    }
}
function parsePort(portStr) {
    if (!portStr) {
        return null;
    }
    const port = Number(portStr);
    if (isNaN(port)) {
        return null;
    }
    return port;
}
function emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText =
            'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') {
        console.info('WARNING: You are using the Auth Emulator,' +
            ' which is intended for local testing only.  Do not use with' +
            ' production credentials.');
    }
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            window.addEventListener('DOMContentLoaded', attachBanner);
        }
        else {
            attachBanner();
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */
class AuthCredential {
    /** @internal */
    constructor(
    /**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */
    providerId, 
    /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */
    signInMethod) {
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */
    toJSON() {
        return debugFail('not implemented');
    }
    /** @internal */
    _getIdTokenResponse(_auth) {
        return debugFail('not implemented');
    }
    /** @internal */
    _linkToIdToken(_auth, _idToken) {
        return debugFail('not implemented');
    }
    /** @internal */
    _getReauthenticationResolver(_auth) {
        return debugFail('not implemented');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function resetPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */, _addTidIfNecessary(auth, request));
}
async function updateEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */, request);
}
async function applyActionCode$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithPassword(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */, _addTidIfNecessary(auth, request));
}
async function sendOobCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */, _addTidIfNecessary(auth, request));
}
async function sendEmailVerification$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendPasswordResetEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendSignInLinkToEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function verifyAndChangeEmail(auth, request) {
    return sendOobCode(auth, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithEmailLink$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */, _addTidIfNecessary(auth, request));
}
async function signInWithEmailLinkForLinking(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */
class EmailAuthCredential extends AuthCredential {
    /** @internal */
    constructor(
    /** @internal */
    _email, 
    /** @internal */
    _password, signInMethod, 
    /** @internal */
    _tenantId = null) {
        super("password" /* ProviderId.PASSWORD */, signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */
    static _fromEmailAndPassword(email, password) {
        return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */);
    }
    /** @internal */
    static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */, tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */
    toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */) {
                return this._fromEmailAndPassword(obj.email, obj.password);
            }
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */) {
                return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
            }
        }
        return null;
    }
    /** @internal */
    async _getIdTokenResponse(auth) {
        var _a;
        switch (this.signInMethod) {
            case "password" /* SignInMethod.EMAIL_PASSWORD */:
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */
                };
                if ((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
                    const requestWithRecaptcha = await injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */);
                    return signInWithPassword(auth, requestWithRecaptcha);
                }
                else {
                    return signInWithPassword(auth, request).catch(async (error) => {
                        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */}`) {
                            console.log('Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.');
                            const requestWithRecaptcha = await injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */);
                            return signInWithPassword(auth, requestWithRecaptcha);
                        }
                        else {
                            return Promise.reject(error);
                        }
                    });
                }
            case "emailLink" /* SignInMethod.EMAIL_LINK */:
                return signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        }
    }
    /** @internal */
    async _linkToIdToken(auth, idToken) {
        switch (this.signInMethod) {
            case "password" /* SignInMethod.EMAIL_PASSWORD */:
                return updateEmailPassword(auth, {
                    idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */:
                return signInWithEmailLinkForLinking(auth, {
                    idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        }
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithIdp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */
class OAuthCredential extends AuthCredential {
    constructor() {
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */
    static _fromParams(params) {
        const cred = new OAuthCredential(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) {
                cred.idToken = params.idToken;
            }
            if (params.accessToken) {
                cred.accessToken = params.accessToken;
            }
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) {
                cred.nonce = params.nonce;
            }
            if (params.pendingToken) {
                cred.pendingToken = params.pendingToken;
            }
        }
        else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        }
        else {
            _fail("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        }
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */
    toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod } = obj, rest = (0,tslib_es6.__rest)(obj, ["providerId", "signInMethod"]);
        if (!providerId || !signInMethod) {
            return null;
        }
        const cred = new OAuthCredential(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) {
            request.pendingToken = this.pendingToken;
        }
        else {
            const postBody = {};
            if (this.idToken) {
                postBody['id_token'] = this.idToken;
            }
            if (this.accessToken) {
                postBody['access_token'] = this.accessToken;
            }
            if (this.secret) {
                postBody['oauth_token_secret'] = this.secret;
            }
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) {
                postBody['nonce'] = this.nonce;
            }
            request.postBody = (0,index_esm2017/* querystring */.xO)(postBody);
        }
        return request;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function sendPhoneVerificationCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */, _addTidIfNecessary(auth, request));
}
async function signInWithPhoneNumber$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, request));
}
async function linkWithPhoneNumber$1(auth, request) {
    const response = await _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, request));
    if (response.temporaryProof) {
        throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */, response);
    }
    return response;
}
const VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */]: "user-not-found" /* AuthErrorCode.USER_DELETED */
};
async function verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), { operation: 'REAUTH' });
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */
class PhoneAuthCredential extends AuthCredential {
    constructor(params) {
        super("phone" /* ProviderId.PHONE */, "phone" /* SignInMethod.PHONE */);
        this.params = params;
    }
    /** @internal */
    static _fromVerification(verificationId, verificationCode) {
        return new PhoneAuthCredential({ verificationId, verificationCode });
    }
    /** @internal */
    static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new PhoneAuthCredential({ phoneNumber, temporaryProof });
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        return linkWithPhoneNumber$1(auth, Object.assign({ idToken }, this._makeVerificationRequest()));
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */
    _makeVerificationRequest() {
        const { temporaryProof, phoneNumber, verificationId, verificationCode } = this.params;
        if (temporaryProof && phoneNumber) {
            return { temporaryProof, phoneNumber };
        }
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */
    toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) {
            obj.phoneNumber = this.params.phoneNumber;
        }
        if (this.params.temporaryProof) {
            obj.temporaryProof = this.params.temporaryProof;
        }
        if (this.params.verificationCode) {
            obj.verificationCode = this.params.verificationCode;
        }
        if (this.params.verificationId) {
            obj.verificationId = this.params.verificationId;
        }
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */
    static fromJSON(json) {
        if (typeof json === 'string') {
            json = JSON.parse(json);
        }
        const { verificationId, verificationCode, phoneNumber, temporaryProof } = json;
        if (!verificationCode &&
            !verificationId &&
            !phoneNumber &&
            !temporaryProof) {
            return null;
        }
        return new PhoneAuthCredential({
            verificationId,
            verificationCode,
            phoneNumber,
            temporaryProof
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */
function parseMode(mode) {
    switch (mode) {
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */
function parseDeepLink(url) {
    const link = (0,index_esm2017/* querystringDecode */.zd)((0,index_esm2017/* extractQuerystring */.pd)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link
        ? (0,index_esm2017/* querystringDecode */.zd)((0,index_esm2017/* extractQuerystring */.pd)(link))['deep_link_id']
        : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0,index_esm2017/* querystringDecode */.zd)((0,index_esm2017/* extractQuerystring */.pd)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink
        ? (0,index_esm2017/* querystringDecode */.zd)((0,index_esm2017/* extractQuerystring */.pd)(iOSDeepLink))['link']
        : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */
class ActionCodeURL {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */
    constructor(actionLink) {
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0,index_esm2017/* querystringDecode */.zd)((0,index_esm2017/* extractQuerystring */.pd)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */]) !== null && _b !== void 0 ? _b : null;
        const operation = parseMode((_c = searchParams["mode" /* QueryField.MODE */]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        _assert(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */
    static parseLink(link) {
        const actionLink = parseDeepLink(link);
        try {
            return new ActionCodeURL(actionLink);
        }
        catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */
function parseActionCodeURL(link) {
    return ActionCodeURL.parseLink(link);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */
class EmailAuthProvider {
    constructor() {
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */
        this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */
    static credential(email, password) {
        return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */
    static credentialWithLink(email, emailLink) {
        const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
        _assert(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */
EmailAuthProvider.PROVIDER_ID = "password" /* ProviderId.PASSWORD */;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */
EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */
EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */
class FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */
    constructor(providerId) {
        this.providerId = providerId;
        /** @internal */
        this.defaultLanguageCode = null;
        /** @internal */
        this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */
    setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */
    setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */
    getCustomParameters() {
        return this.customParameters;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */
class BaseOAuthProvider extends FederatedAuthProvider {
    constructor() {
        super(...arguments);
        /** @internal */
        this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */
    addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) {
            this.scopes.push(scope);
        }
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */
    getScopes() {
        return [...this.scopes];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */
class OAuthProvider extends BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */
    static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        _assert('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        return OAuthCredential._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */
    credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), { nonce: params.rawNonce }));
    }
    /** An internal credential method that accepts more permissive options */
    _credential(params) {
        _assert(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        // For OAuthCredential, sign in method is same as providerId.
        return OAuthCredential._fromParams(Object.assign(Object.assign({}, params), { providerId: this.providerId, signInMethod: this.providerId }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return OAuthProvider.oauthCredentialFromTaggedObject((error.customData || {}));
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthIdToken, oauthAccessToken, oauthTokenSecret, pendingToken, nonce, providerId } = tokenResponse;
        if (!oauthAccessToken &&
            !oauthTokenSecret &&
            !oauthIdToken &&
            !pendingToken) {
            return null;
        }
        if (!providerId) {
            return null;
        }
        try {
            return new OAuthProvider(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce,
                pendingToken
            });
        }
        catch (e) {
            return null;
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */
class FacebookAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("facebook.com" /* ProviderId.FACEBOOK */);
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */
    static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: FacebookAuthProvider.PROVIDER_ID,
            signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return FacebookAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) {
            return null;
        }
        if (!tokenResponse.oauthAccessToken) {
            return null;
        }
        try {
            return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */
FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */;
/** Always set to {@link ProviderId}.FACEBOOK. */
FacebookAuthProvider.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */
class GoogleAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("google.com" /* ProviderId.GOOGLE */);
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */
    static credential(idToken, accessToken) {
        return OAuthCredential._fromParams({
            providerId: GoogleAuthProvider.PROVIDER_ID,
            signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
            idToken,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return GoogleAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthIdToken, oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) {
            // This could be an oauth 1 credential or a phone credential
            return null;
        }
        try {
            return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */
GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */;
/** Always set to {@link ProviderId}.GOOGLE. */
GoogleAuthProvider.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */
class GithubAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("github.com" /* ProviderId.GITHUB */);
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */
    static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: GithubAuthProvider.PROVIDER_ID,
            signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return GithubAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) {
            return null;
        }
        if (!tokenResponse.oauthAccessToken) {
            return null;
        }
        try {
            return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */
GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */;
/** Always set to {@link ProviderId}.GITHUB. */
GithubAuthProvider.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */
class SAMLAuthCredential extends (/* unused pure expression or super */ null && (AuthCredential)) {
    /** @internal */
    constructor(providerId, pendingToken) {
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */
    toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, pendingToken } = obj;
        if (!providerId ||
            !signInMethod ||
            !pendingToken ||
            providerId !== signInMethod) {
            return null;
        }
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */
    static _create(providerId, pendingToken) {
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */
class SAMLAuthProvider extends (/* unused pure expression or super */ null && (FederatedAuthProvider)) {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */
    constructor(providerId) {
        _assert(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject((error.customData || {}));
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */
    static credentialFromJSON(json) {
        const credential = SAMLAuthCredential.fromJSON(json);
        _assert(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { pendingToken, providerId } = tokenResponse;
        if (!pendingToken || !providerId) {
            return null;
        }
        try {
            return SAMLAuthCredential._create(providerId, pendingToken);
        }
        catch (e) {
            return null;
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */
class TwitterAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("twitter.com" /* ProviderId.TWITTER */);
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */
    static credential(token, secret) {
        return OAuthCredential._fromParams({
            providerId: TwitterAuthProvider.PROVIDER_ID,
            signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return TwitterAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) {
            return null;
        }
        try {
            return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */
TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */;
/** Always set to {@link ProviderId}.TWITTER. */
TwitterAuthProvider.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signUp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signUp" /* Endpoint.SIGN_UP */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserCredentialImpl {
    constructor(params) {
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = providerIdForResponse(idTokenResponse);
        const userCred = new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: idTokenResponse,
            operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = providerIdForResponse(response);
        return new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: response,
            operationType
        });
    }
}
function providerIdForResponse(response) {
    if (response.providerId) {
        return response.providerId;
    }
    if ('phoneNumber' in response) {
        return "phone" /* ProviderId.PHONE */;
    }
    return null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
async function signInAnonymously(auth) {
    var _a;
    const authInternal = _castAuth(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) {
        // If an anonymous user is already signed in, no need to sign them in again.
        return new UserCredentialImpl({
            user: authInternal.currentUser,
            providerId: null,
            operationType: "signIn" /* OperationType.SIGN_IN */
        });
    }
    const response = await signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */, response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorError extends index_esm2017/* FirebaseError */.ZR {
    constructor(auth, error, operationType, user) {
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new MultiFactorError(auth, error, operationType, user);
    }
}
function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */
        ? credential._getReauthenticationResolver(auth)
        : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch(error => {
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */}`) {
            throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        }
        throw error;
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */
function providerDataAsNames(providerData) {
    return new Set(providerData
        .map(({ providerId }) => providerId)
        .filter(pid => !!pid));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */
async function unlink(user, providerId) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo } = await deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [providerId]
    });
    const providersLeft = providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter(pd => providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */)) {
        userInternal.phoneNumber = null;
    }
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function _link$1(user, credential, bypassAuthState = false) {
    const response = await _logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */, response);
}
async function _assertLinkedStatus(expected, user, provider) {
    await _reloadWithoutSaving(user);
    const providerIds = providerDataAsNames(user.providerData);
    const code = expected === false
        ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */
        : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */;
    _assert(providerIds.has(provider) === expected, user.auth, code);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reauthenticate(user, credential, bypassAuthState = false) {
    const { auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */;
    try {
        const response = await _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        _assert(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const parsed = _parseToken(response.idToken);
        _assert(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const { sub: localId } = parsed;
        _assert(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */);
        return UserCredentialImpl._forOperation(user, operationType, response);
    }
    catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */}`) {
            _fail(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */);
        }
        throw e;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */;
    const response = await _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) {
        await auth._updateCurrentUser(userCredential.user);
    }
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */
async function signInWithCredential(auth, credential) {
    return _signInWithCredential(_castAuth(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */
async function linkWithCredential(user, credential) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(false, userInternal, credential.providerId);
    return _link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */
async function reauthenticateWithCredential(user, credential) {
    return _reauthenticate(getModularInstance(user), credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithCustomToken$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */
async function signInWithCustomToken(auth, customToken) {
    const authInternal = _castAuth(auth);
    const response = await signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */, response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorInfoImpl {
    constructor(factorId, response) {
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) {
            return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        }
        else if ('totpInfo' in enrollment) {
            return TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        }
        return _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    }
}
class PhoneMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response) {
        super("phone" /* FactorId.PHONE */, response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new PhoneMultiFactorInfoImpl(enrollment);
    }
}
class TotpMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response) {
        super("totp" /* FactorId.TOTP */, response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new TotpMultiFactorInfoImpl(enrollment);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    _assert(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */);
    _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' ||
        actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */);
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */);
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */);
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode =
            actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendPasswordResetEmail(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */
    };
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */, true);
        if (actionCodeSettings) {
            _setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
        }
        await sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
    }
    else {
        if (actionCodeSettings) {
            _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
        await sendPasswordResetEmail$1(authInternal, request)
            .catch(async (error) => {
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */}`) {
                console.log('Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.');
                const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */, true);
                if (actionCodeSettings) {
                    _setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                }
                await sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
            }
            else {
                return Promise.reject(error);
            }
        });
    }
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */
async function confirmPasswordReset(auth, oobCode, newPassword) {
    await resetPassword((0,index_esm2017/* getModularInstance */.m9)(auth), {
        oobCode,
        newPassword
    });
    // Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */
async function applyActionCode(auth, oobCode) {
    await applyActionCode$1(getModularInstance(auth), { oobCode });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */
async function checkActionCode(auth, oobCode) {
    const authModular = (0,index_esm2017/* getModularInstance */.m9)(auth);
    const response = await resetPassword(authModular, { oobCode });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    _assert(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    switch (operation) {
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */:
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */:
            _assert(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */:
            _assert(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        // fall through
        default:
            _assert(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) {
        multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
    }
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */
                ? response.newEmail
                : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */
                ? response.email
                : response.newEmail) || null,
            multiFactorInfo
        },
        operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */
async function verifyPasswordResetCode(auth, code) {
    const { data } = await checkActionCode((0,index_esm2017/* getModularInstance */.m9)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */
async function createUserWithEmailAndPassword(auth, email, password) {
    var _a;
    const authInternal = _castAuth(auth);
    const request = {
        returnSecureToken: true,
        email,
        password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */
    };
    let signUpResponse;
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */);
        signUpResponse = signUp(authInternal, requestWithRecaptcha);
    }
    else {
        signUpResponse = signUp(authInternal, request).catch(async (error) => {
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */}`) {
                console.log('Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.');
                const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */);
                return signUp(authInternal, requestWithRecaptcha);
            }
            else {
                return Promise.reject(error);
            }
        });
    }
    const response = await signUpResponse.catch(error => {
        return Promise.reject(error);
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */, response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */
function signInWithEmailAndPassword(auth, email, password) {
    return signInWithCredential((0,index_esm2017/* getModularInstance */.m9)(auth), EmailAuthProvider.credential(email, password));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendSignInLinkToEmail(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        _assert(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        if (actionCodeSettings) {
            _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
    }
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */, true);
        setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
        await sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
    }
    else {
        setActionCodeSettings(request, actionCodeSettings);
        await sendSignInLinkToEmail$1(authInternal, request)
            .catch(async (error) => {
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */}`) {
                console.log('Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.');
                const requestWithRecaptcha = await injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */, true);
                setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                await sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
            }
            else {
                return Promise.reject(error);
            }
        });
    }
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */
function isSignInWithEmailLink(auth, emailLink) {
    const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */
async function signInWithEmailLink(auth, email, emailLink) {
    const authModular = getModularInstance(auth);
    const credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    _assert(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */);
    return signInWithCredential(authModular, credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createAuthUri(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */
async function fetchSignInMethodsForEmail(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = _isHttpOrHttps() ? _getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri
    };
    const { signinMethods } = await createAuthUri(getModularInstance(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendEmailVerification(user, actionCodeSettings) {
    const userInternal = getModularInstance(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */,
        idToken
    };
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    }
    const { email } = await sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) {
        await user.reload();
    }
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings) {
    const userInternal = getModularInstance(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */,
        idToken,
        newEmail
    };
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    }
    const { email } = await verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) {
        // If the local copy of the email on user is outdated, reload the
        // user.
        await user.reload();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateProfile$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */
async function updateProfile(user, { displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) {
        return;
    }
    const userInternal = getModularInstance(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken,
        displayName,
        photoUrl,
        returnSecureToken: true
    };
    const response = await _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId }) => providerId === "password" /* ProviderId.PASSWORD */);
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */
function updateEmail(user, newEmail) {
    return updateEmailOrPassword(getModularInstance(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */
function updatePassword(user, newPassword) {
    return updateEmailOrPassword(getModularInstance(user), null, newPassword);
}
async function updateEmailOrPassword(user, email, password) {
    const { auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken,
        returnSecureToken: true
    };
    if (email) {
        request.email = email;
    }
    if (password) {
        request.password = password;
    }
    const response = await _logoutIfInvalidated(user, updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */
function _fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) {
        return null;
    }
    const { providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo
        ? JSON.parse(idTokenResponse.rawUserInfo)
        : {};
    const isNewUser = idTokenResponse.isNewUser ||
        idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = _parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */ &&
                signInProvider !== "custom" /* ProviderId.CUSTOM */
                ? signInProvider
                : null;
            // Uses generic class in accordance with the legacy SDK.
            return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) {
        return null;
    }
    switch (providerId) {
        case "facebook.com" /* ProviderId.FACEBOOK */:
            return new FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */:
            return new GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */:
            return new GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */:
            return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */:
        case "anonymous" /* ProviderId.ANONYMOUS */:
            return new GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}) {
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class FederatedAdditionalUserInfoWithUsername extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, providerId, profile, username) {
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class FacebookAdditionalUserInfo extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */, profile);
    }
}
class GithubAdditionalUserInfo extends (/* unused pure expression or super */ null && (FederatedAdditionalUserInfoWithUsername)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "github.com" /* ProviderId.GITHUB */, profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class GoogleAdditionalUserInfo extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */, profile);
    }
}
class TwitterAdditionalUserInfo extends (/* unused pure expression or super */ null && (FederatedAdditionalUserInfoWithUsername)) {
    constructor(isNewUser, profile, screenName) {
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */, profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */
function getAdditionalUserInfo(userCredential) {
    const { user, _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) {
        // Handle the special case where signInAnonymously() gets called twice.
        // No network call is made so there's nothing to actually fill this in
        return {
            providerId: null,
            isNewUser: false,
            profile: null
        };
    }
    return _fromIdTokenResponse(_tokenResponse);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */
function setPersistence(auth, persistence) {
    return getModularInstance(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
function initializeRecaptchaConfig(auth) {
    const authInternal = _castAuth(auth);
    return authInternal.initializeRecaptchaConfig();
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */
function onIdTokenChanged(auth, nextOrObserver, error, completed) {
    return (0,index_esm2017/* getModularInstance */.m9)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */
function beforeAuthStateChanged(auth, callback, onAbort) {
    return (0,index_esm2017/* getModularInstance */.m9)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */
function onAuthStateChanged(auth, nextOrObserver, error, completed) {
    return getModularInstance(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
function useDeviceLanguage(auth) {
    getModularInstance(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */
function updateCurrentUser(auth, user) {
    return getModularInstance(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
function signOut(auth) {
    return getModularInstance(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */
async function deleteUser(user) {
    return getModularInstance(user).delete();
}

class MultiFactorSessionImpl {
    constructor(type, credential, auth) {
        this.type = type;
        this.credential = credential;
        this.auth = auth;
    }
    static _fromIdtoken(idToken, auth) {
        return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */, idToken, auth);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */, mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */
            ? 'idToken'
            : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) {
                return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            }
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) {
                return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
            }
        }
        return null;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorResolverImpl {
    constructor(session, hints, signInResolver) {
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */
    static _fromError(authExtern, error) {
        const auth = _castAuth(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map(enrollment => MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        _assert(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new MultiFactorResolverImpl(session, hints, async (assertion) => {
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), { idToken: mfaResponse.idToken, refreshToken: mfaResponse.refreshToken });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch (error.operationType) {
                case "signIn" /* OperationType.SIGN_IN */:
                    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */:
                    _assert(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
                    return UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */
function getMultiFactorResolver(auth, error) {
    var _a;
    const authModular = getModularInstance(auth);
    const errorInternal = error;
    _assert(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
    _assert((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
    return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function startEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function finalizeEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function startEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function finalizeEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function withdrawMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */, _addTidIfNecessary(auth, request));
}

class MultiFactorUserImpl {
    constructor(user) {
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(userInfo => {
            if (userInfo.mfaInfo) {
                this.enrolledFactors = userInfo.mfaInfo.map(enrollment => MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
            }
        });
    }
    static _fromUser(user) {
        return new MultiFactorUserImpl(user);
    }
    async getSession() {
        return MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user.auth);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = (await this.getSession());
        const finalizeMfaResponse = await _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
                idToken,
                mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid }) => uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        }
        catch (e) {
            throw e;
        }
    }
}
const multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */
function multiFactor(user) {
    const userModular = getModularInstance(user);
    if (!multiFactorUserCache.has(userModular)) {
        multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
    }
    return multiFactorUserCache.get(userModular);
}

const STORAGE_AVAILABLE_KEY = '__sak';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class BrowserPersistenceClass {
    constructor(storageRetriever, type) {
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) {
                return Promise.resolve(false);
            }
            this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem(STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        }
        catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _iframeCannotSyncWebStorage() {
    const ua = (0,index_esm2017/* getUA */.z$)();
    return _isSafari(ua) || _isIOS(ua);
}
// The polling period in case events are not supported
const _POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
    constructor() {
        super(() => window.localStorage, "LOCAL" /* PersistenceType.LOCAL */);
        this.boundEventHandler = (event, poll) => this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = _iframeCannotSyncWebStorage() && _isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = _isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)) {
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) {
                cb(key, oldValue, newValue);
            }
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue) => {
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) {
            // Environment detects storage changes via polling.
            // Remove storage event listener to prevent possible event duplication.
            this.detachListener();
        }
        else {
            // Environment detects storage changes via storage event listener.
            // Remove polling listener to prevent possible event duplication.
            this.stopPolling();
        }
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) {
                    // Value changed from current value.
                    this.storage.setItem(key, event.newValue);
                }
                else {
                    // Current value deleted.
                    this.storage.removeItem(key);
                }
            }
            else if (this.localCache[key] === event.newValue && !poll) {
                // Already detected and processed, do not trigger listeners again.
                return;
            }
        }
        const triggerListeners = () => {
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) {
                // Real storage event which has already been detected, do nothing.
                // This seems to trigger in some IE browsers for some reason.
                return;
            }
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if (_isIE10() &&
            storedValue !== event.newValue &&
            event.newValue !== event.oldValue) {
            // IE 10 has this weird bug where a storage event would trigger with the
            // correct key, oldValue and newValue but localStorage.getItem(key) does
            // not yield the updated value until a few milliseconds. This ensures
            // this recovers from that situation.
            setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
        }
        else {
            triggerListeners();
        }
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) {
            for (const listener of Array.from(listeners)) {
                listener(value ? JSON.parse(value) : value);
            }
        }
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(() => {
            this.forAllChangedKeys((key, oldValue, newValue) => {
                this.onStorageEvent(new StorageEvent('storage', {
                    key,
                    oldValue,
                    newValue
                }), 
                /* poll */ true);
            });
        }, _POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) {
                this.startPolling();
            }
            else {
                this.attachListener();
            }
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) {
                delete this.listeners[key];
            }
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */
const browserLocalPersistence = BrowserLocalPersistence;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BrowserSessionPersistence extends BrowserPersistenceClass {
    constructor() {
        super(() => window.sessionStorage, "SESSION" /* PersistenceType.SESSION */);
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */
const browserSessionPersistence = BrowserSessionPersistence;

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */
function _allSettled(promises) {
    return Promise.all(promises.map(async (promise) => {
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value
            };
        }
        catch (reason) {
            return {
                fulfilled: false,
                reason
            };
        }
    }));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface class for receiving messages.
 *
 */
class Receiver {
    constructor(eventTarget) {
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */
    static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find(receiver => receiver.isListeningto(eventTarget));
        if (existingInstance) {
            return existingInstance;
        }
        const newInstance = new Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */
    async handleEvent(event) {
        const messageEvent = event;
        const { eventId, eventType, data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) {
            return;
        }
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */,
            eventId,
            eventType
        });
        const promises = Array.from(handlers).map(async (handler) => handler(messageEvent.origin, data));
        const response = await _allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */,
            eventId,
            eventType,
            response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */
    _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) {
            this.eventTarget.addEventListener('message', this.boundEventHandler);
        }
        if (!this.handlersMap[eventType]) {
            this.handlersMap[eventType] = new Set();
        }
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */
    _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) {
            this.handlersMap[eventType].delete(eventHandler);
        }
        if (!eventHandler || this.handlersMap[eventType].size === 0) {
            delete this.handlersMap[eventType];
        }
        if (Object.keys(this.handlersMap).length === 0) {
            this.eventTarget.removeEventListener('message', this.boundEventHandler);
        }
    }
}
Receiver.receivers = [];

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _generateEventId(prefix = '', digits = 10) {
    let random = '';
    for (let i = 0; i < digits; i++) {
        random += Math.floor(Math.random() * 10);
    }
    return prefix + random;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface for sending messages and waiting for a completion response.
 *
 */
class Sender {
    constructor(target) {
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */
    removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */
    async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) {
            throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */);
        }
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject) => {
            const eventId = _generateEventId('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(() => {
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */));
            }, timeout);
            handler = {
                messageChannel,
                onMessage(event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) {
                        return;
                    }
                    switch (messageEvent.data.status) {
                        case "ack" /* _Status.ACK */:
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(() => {
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */));
                            }, 3000 /* _TimeoutDuration.COMPLETION */);
                            break;
                        case "done" /* _Status.DONE */:
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType,
                eventId,
                data
            }, [messageChannel.port2]);
        }).finally(() => {
            if (handler) {
                this.removeMessageHandler(handler);
            }
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */
function _window() {
    return window;
}
function _setWindowLocation(url) {
    _window().location.href = url;
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _isWorker() {
    return (typeof _window()['WorkerGlobalScope'] !== 'undefined' &&
        typeof _window()['importScripts'] === 'function');
}
async function _getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) {
        return null;
    }
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    }
    catch (_a) {
        return null;
    }
}
function _getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function _getWorkerGlobalScope() {
    return _isWorker() ? self : null;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebaseLocalStorageDb';
const DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */
class DBPromise {
    constructor(request) {
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject) => {
            this.request.addEventListener('success', () => {
                resolve(this.request.result);
            });
            this.request.addEventListener('error', () => {
                reject(this.request.error);
            });
        });
    }
}
function getObjectStore(db, isReadWrite) {
    return db
        .transaction([DB_OBJECTSTORE_NAME], isReadWrite ? 'readwrite' : 'readonly')
        .objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
    const request = indexedDB.deleteDatabase(DB_NAME);
    return new DBPromise(request).toPromise();
}
function _openDatabase() {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    return new Promise((resolve, reject) => {
        request.addEventListener('error', () => {
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', () => {
            const db = request.result;
            try {
                db.createObjectStore(DB_OBJECTSTORE_NAME, { keyPath: DB_DATA_KEYPATH });
            }
            catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async () => {
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await _deleteDatabase();
                resolve(await _openDatabase());
            }
            else {
                resolve(db);
            }
        });
    });
}
async function _putObject(db, key, value) {
    const request = getObjectStore(db, true).put({
        [DB_DATA_KEYPATH]: key,
        value
    });
    return new DBPromise(request).toPromise();
}
async function getObject(db, key) {
    const request = getObjectStore(db, false).get(key);
    const data = await new DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function _deleteObject(db, key) {
    const request = getObjectStore(db, true).delete(key);
    return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
    constructor() {
        this.type = "LOCAL" /* PersistenceType.LOCAL */;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise =
            this.initializeServiceWorkerMessaging().then(() => { }, () => { });
    }
    async _openDb() {
        if (this.db) {
            return this.db;
        }
        this.db = await _openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while (true) {
            try {
                const db = await this._openDb();
                return await op(db);
            }
            catch (e) {
                if (numAttempts++ > _TRANSACTION_RETRY_COUNT) {
                    throw e;
                }
                if (this.db) {
                    this.db.close();
                    this.db = undefined;
                }
                // TODO: consider adding exponential backoff
            }
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */
    async initializeServiceWorkerMessaging() {
        return _isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */
    async initializeReceiver() {
        this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */, async (_origin, data) => {
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */, async (_origin, _data) => {
            return ["keyChanged" /* _EventType.KEY_CHANGED */];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */
    async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await _getActiveServiceWorker();
        if (!this.activeServiceWorker) {
            return;
        }
        this.sender = new Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */, {}, 800 /* _TimeoutDuration.LONG_ACK */);
        if (!results) {
            return;
        }
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) &&
            ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */))) {
            this.serviceWorkerReceiverAvailable = true;
        }
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */
    async notifyServiceWorker(key) {
        if (!this.sender ||
            !this.activeServiceWorker ||
            _getServiceWorkerController() !== this.activeServiceWorker) {
            return;
        }
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */, { key }, 
            // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable
                ? 800 /* _TimeoutDuration.LONG_ACK */
                : 50 /* _TimeoutDuration.ACK */);
        }
        catch (_a) {
            // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) {
                return false;
            }
            const db = await _openDatabase();
            await _putObject(db, STORAGE_AVAILABLE_KEY, '1');
            await _deleteObject(db, STORAGE_AVAILABLE_KEY);
            return true;
        }
        catch (_a) { }
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        }
        finally {
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async () => {
            await this._withRetries((db) => _putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = (await this._withRetries((db) => getObject(db, key)));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async () => {
            await this._withRetries((db) => _deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db) => {
            const getAllRequest = getObjectStore(db, false).getAll();
            return new DBPromise(getAllRequest).toPromise();
        });
        if (!result) {
            return [];
        }
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) {
            return [];
        }
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value } of result) {
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache)) {
            if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                // Deleted
                this.notifyListeners(localKey, null);
                keys.push(localKey);
            }
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) {
            for (const listener of Array.from(listeners)) {
                listener(newValue);
            }
        }
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async () => this._poll(), _POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            this.startPolling();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            void this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) {
                delete this.listeners[key];
            }
        }
        if (Object.keys(this.listeners).length === 0) {
            this.stopPolling();
        }
    }
}
IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */
const indexedDBLocalPersistence = IndexedDBLocalPersistence;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function startSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */, _addTidIfNecessary(auth, request));
}
function finalizeSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */, _addTidIfNecessary(auth, request));
}
function finalizeSignInTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */, "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _SOLVE_TIME_MS = 500;
const _EXPIRATION_TIME_MS = 60000;
const _WIDGET_ID_START = 1000000000000;
class MockReCaptcha {
    constructor(auth) {
        this.auth = auth;
        this.counter = _WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        void ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.delete());
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        void ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.execute());
        return '';
    }
}
class MockWidget {
    constructor(containerOrId, appName, params) {
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = () => {
            this.execute();
        };
        const container = typeof containerOrId === 'string'
            ? document.getElementById(containerOrId)
            : containerOrId;
        _assert(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */, { appName });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) {
            this.execute();
        }
        else {
            this.container.addEventListener('click', this.clickHandler);
        }
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) {
            return;
        }
        this.timerId = window.setTimeout(() => {
            this.responseToken = generateRandomAlphaNumericString(50);
            const { callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) {
                try {
                    callback(this.responseToken);
                }
                catch (e) { }
            }
            this.timerId = window.setTimeout(() => {
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) {
                    try {
                        expiredCallback();
                    }
                    catch (e) { }
                }
                if (this.isVisible) {
                    this.execute();
                }
            }, _EXPIRATION_TIME_MS);
        }, _SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) {
            throw new Error('reCAPTCHA mock was already deleted!');
        }
    }
}
function generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = 0; i < len; i++) {
        chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    }
    return chars.join('');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const _JSLOAD_CALLBACK = _generateCallbackName('rcb');
const NETWORK_TIMEOUT_DELAY = new Delay(30000, 60000);
const RECAPTCHA_BASE = 'https://www.google.com/recaptcha/api.js?';
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */
class ReCaptchaLoaderImpl {
    constructor() {
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */
        this.librarySeparatelyLoaded = !!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        _assert(isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        if (this.shouldResolveImmediately(hl) && isV2(_window().grecaptcha)) {
            return Promise.resolve(_window().grecaptcha);
        }
        return new Promise((resolve, reject) => {
            const networkTimeout = _window().setTimeout(() => {
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */));
            }, NETWORK_TIMEOUT_DELAY.get());
            _window()[_JSLOAD_CALLBACK] = () => {
                _window().clearTimeout(networkTimeout);
                delete _window()[_JSLOAD_CALLBACK];
                const recaptcha = _window().grecaptcha;
                if (!recaptcha || !isV2(recaptcha)) {
                    reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params) => {
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${RECAPTCHA_BASE}?${querystring({
                onload: _JSLOAD_CALLBACK,
                render: 'explicit',
                hl
            })}`;
            _loadJS(url).catch(() => {
                clearTimeout(networkTimeout);
                reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return (!!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) &&
            (hl === this.hostLanguage ||
                this.counter > 0 ||
                this.librarySeparatelyLoaded));
    }
}
function isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class MockReCaptchaLoaderImpl {
    async load(auth) {
        return new MockReCaptcha(auth);
    }
    clearedOneInstance() { }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */
class RecaptchaVerifier {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     */
    constructor(containerOrId, parameters = Object.assign({}, DEFAULT_PARAMS), authExtern) {
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */
        this.type = RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = _castAuth(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */);
        const container = typeof containerOrId === 'string'
            ? document.getElementById(containerOrId)
            : containerOrId;
        _assert(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting
            ? new MockReCaptchaLoaderImpl()
            : new ReCaptchaLoaderImpl();
        this.validateStartingState();
        // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */
    async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) {
            return response;
        }
        return new Promise(resolve => {
            const tokenChange = (token) => {
                if (!token) {
                    return; // Ignore token expirations.
                }
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) {
                recaptcha.execute(id);
            }
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */
    render() {
        try {
            this.assertNotDestroyed();
        }
        catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) {
            return this.renderPromise;
        }
        this.renderPromise = this.makeRenderPromise().catch(e => {
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */
    _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) {
            this.getAssertedRecaptcha().reset(this.widgetId);
        }
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */
    clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) {
            this.container.childNodes.forEach(node => {
                this.container.removeChild(node);
            });
        }
    }
    validateStartingState() {
        _assert(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        _assert(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */);
    }
    makeTokenCallback(existing) {
        return token => {
            this.tokenChangeListeners.forEach(listener => listener(token));
            if (typeof existing === 'function') {
                existing(token);
            }
            else if (typeof existing === 'string') {
                const globalFunc = _window()[existing];
                if (typeof globalFunc === 'function') {
                    globalFunc(token);
                }
            }
        };
    }
    assertNotDestroyed() {
        _assert(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        _assert(_isHttpOrHttps() && !_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        await domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await getRecaptchaParams(this.auth);
        _assert(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        _assert(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        return this.recaptcha;
    }
}
function domReady() {
    let resolver = null;
    return new Promise(resolve => {
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = () => resolve();
        window.addEventListener('load', resolver);
    }).catch(e => {
        if (resolver) {
            window.removeEventListener('load', resolver);
        }
        throw e;
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ConfirmationResultImpl {
    constructor(verificationId, onConfirmation) {
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function signInWithPhoneNumber(auth, phoneNumber, appVerifier) {
    const authInternal = _castAuth(auth);
    const verificationId = await _verifyPhoneNumber(authInternal, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => signInWithCredential(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function linkWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */);
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => linkWithCredential(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function reauthenticateWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = getModularInstance(user);
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => reauthenticateWithCredential(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */
async function _verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        _assert(typeof recaptchaToken === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        _assert(verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        let phoneInfoOptions;
        if (typeof options === 'string') {
            phoneInfoOptions = {
                phoneNumber: options
            };
        }
        else {
            phoneInfoOptions = options;
        }
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                _assert(session.type === "enroll" /* MultiFactorSessionType.ENROLL */, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
                const response = await startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            }
            else {
                _assert(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) ||
                    phoneInfoOptions.multiFactorUid;
                _assert(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */);
                const response = await startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        }
        else {
            const { sessionInfo } = await sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken
            });
            return sessionInfo;
        }
    }
    finally {
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */
async function updatePhoneNumber(user, credential) {
    await _link$1(getModularInstance(user), credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */
class PhoneAuthProvider {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */
    constructor(auth) {
        /** Always set to {@link ProviderId}.PHONE. */
        this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = _castAuth(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */
    verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return _verifyPhoneNumber(this.auth, phoneOptions, (0,index_esm2017/* getModularInstance */.m9)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */
    static credential(verificationId, verificationCode) {
        return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        const credential = userCredential;
        return PhoneAuthProvider.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */
    static credentialFromError(error) {
        return PhoneAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { phoneNumber, temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) {
            return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
        }
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */
PhoneAuthProvider.PROVIDER_ID = "phone" /* ProviderId.PHONE */;
/** Always set to {@link SignInMethod}.PHONE. */
PhoneAuthProvider.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */;

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */
function _withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) {
        return _getInstance(resolverOverride);
    }
    _assert(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
    return auth._popupRedirectResolver;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdpCredential extends AuthCredential {
    constructor(params) {
        super("custom" /* ProviderId.CUSTOM */, "custom" /* ProviderId.CUSTOM */);
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) {
            request.idToken = idToken;
        }
        return request;
    }
}
function _signIn(params) {
    return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}
function _reauth(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}
async function _link(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */
class AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false) {
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [filter];
    }
    execute() {
        return new Promise(async (resolve, reject) => {
            this.pendingPromise = { resolve, reject };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            }
            catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse, sessionId, postBody, tenantId, error, type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        }
        catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch (type) {
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */:
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */:
                return _signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */:
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */:
                return _link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */:
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */:
                return _reauth;
            default:
                _fail(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        }
    }
    resolve(cred) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) {
            this.eventManager.unregisterConsumer(this);
        }
        this.pendingPromise = null;
        this.cleanUp();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */
async function signInWithPopup(auth, provider, resolver) {
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    const action = new PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */, provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function reauthenticateWithPopup(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */, provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function linkWithPopup(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */, provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */
class PopupOperation extends AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user) {
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if (PopupOperation.currentPopupAction) {
            PopupOperation.currentPopupAction.cancel();
        }
        PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        _assert(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        return result;
    }
    async onExecution() {
        debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = _generateEventId();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], // There's always one, see constructor
        eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch(e => {
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, isSupported => {
            if (!isSupported) {
                this.reject(_createError(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */));
            }
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject(_createError(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */));
    }
    cleanUp() {
        if (this.authWindow) {
            this.authWindow.close();
        }
        if (this.pollId) {
            window.clearTimeout(this.pollId);
        }
        this.authWindow = null;
        this.pollId = null;
        PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = () => {
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(() => {
                    this.pollId = null;
                    this.reject(_createError(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */));
                }, 8000 /* _Timeout.AUTH_EVENT */);
                return;
            }
            this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
PopupOperation.currentPopupAction = null;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const redirectOutcomeMap = new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false) {
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */,
            "unknown" /* AuthEventType.UNKNOWN */
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */
    async execute() {
        let readyOutcome = redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await _getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = () => Promise.resolve(result);
            }
            catch (e) {
                readyOutcome = () => Promise.reject(e);
            }
            redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) {
            redirectOutcomeMap.set(this.auth._key(), () => Promise.resolve(null));
        }
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */) {
            return super.onAuthEvent(event);
        }
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            }
            else {
                this.resolve(null);
            }
        }
    }
    async onExecution() { }
    cleanUp() { }
}
async function _getAndClearPendingRedirectStatus(resolver, auth) {
    const key = pendingRedirectKey(auth);
    const persistence = resolverPersistence(resolver);
    if (!(await persistence._isAvailable())) {
        return false;
    }
    const hasPendingRedirect = (await persistence._get(key)) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function _setPendingRedirectStatus(resolver, auth) {
    return resolverPersistence(resolver)._set(pendingRedirectKey(auth), 'true');
}
function _clearRedirectOutcomes() {
    redirectOutcomeMap.clear();
}
function _overrideRedirectResult(auth, result) {
    redirectOutcomeMap.set(auth._key(), result);
}
function resolverPersistence(resolver) {
    return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth) {
    return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
function signInWithRedirect(auth, provider, resolver) {
    return _signInWithRedirect(auth, provider, resolver);
}
async function _signInWithRedirect(auth, provider, resolver) {
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    await _setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
function reauthenticateWithRedirect(user, provider, resolver) {
    return _reauthenticateWithRedirect(user, provider, resolver);
}
async function _reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */, eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */
function linkWithRedirect(user, provider, resolver) {
    return _linkWithRedirect(user, provider, resolver);
}
async function _linkWithRedirect(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _assertLinkedStatus(false, userInternal, provider.providerId);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */, eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function getRedirectResult(auth, resolver) {
    await _castAuth(auth)._initializationPromise;
    return _getRedirectResult(auth, resolver, false);
}
async function _getRedirectResult(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = _castAuth(auth);
    const resolver = _withDefaultResolver(authInternal, resolverExtern);
    const action = new RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function prepareUserForRedirect(user) {
    const eventId = _generateEventId(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const EVENT_DUPLICATION_CACHE_DURATION_MS = 10 * 60 * 1000;
class AuthEventManager {
    constructor(auth) {
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent &&
            this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) {
            return false;
        }
        let handled = false;
        this.consumers.forEach(consumer => {
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) {
            // If we've already seen a redirect before, or this is a popup event,
            // bail now
            return handled;
        }
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) ||
                "internal-error" /* AuthErrorCode.INTERNAL_ERROR */;
            consumer.onError(_createError(this.auth, code));
        }
        else {
            consumer.onAuthEvent(event);
        }
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null ||
            (!!event.eventId && event.eventId === consumer.eventId);
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >=
            EVENT_DUPLICATION_CACHE_DURATION_MS) {
            this.cachedEventUids.clear();
        }
        return this.cachedEventUids.has(eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add(eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function eventUid(e) {
    return [e.type, e.eventId, e.sessionId, e.tenantId].filter(v => v).join('-');
}
function isNullRedirectEvent({ type, error }) {
    return (type === "unknown" /* AuthEventType.UNKNOWN */ &&
        (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */}`);
}
function isRedirectEvent(event) {
    switch (event.type) {
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */:
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */:
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */:
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */:
            return isNullRedirectEvent(event);
        default:
            return false;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _getProjectConfig(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */, "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) {
        return;
    }
    const { authorizedDomains } = await _getProjectConfig(auth);
    for (const domain of authorizedDomains) {
        try {
            if (matchDomain(domain)) {
                return;
            }
        }
        catch (_a) {
            // Do nothing if there's a URL error; just continue searching
        }
    }
    // In the old SDK, this error also provides helpful messages.
    _fail(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */);
}
function matchDomain(expected) {
    const currentUrl = _getCurrentUrl();
    const { protocol, hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') {
            // For some reason we're not parsing chrome URLs properly
            return (protocol === 'chrome-extension:' &&
                expected.replace('chrome-extension://', '') ===
                    currentUrl.replace('chrome-extension://', ''));
        }
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!HTTP_REGEX.test(protocol)) {
        return false;
    }
    if (IP_ADDRESS_REGEX.test(expected)) {
        // The domain has to be exactly equal to the pattern, as an IP domain will
        // only contain the IP, no extra character.
        return hostname === expected;
    }
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */
function resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = _window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) {
        // Get gapi hint.
        for (const hint of Object.keys(beacon.H)) {
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = [...beacon.H[hint].L];
            // Clear pending callbacks.
            if (beacon.CP) {
                for (let i = 0; i < beacon.CP.length; i++) {
                    // Remove all failed pending callbacks.
                    beacon.CP[i] = null;
                }
            }
        }
    }
}
function loadGapi(auth) {
    return new Promise((resolve, reject) => {
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: () => {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: () => {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    resetUnloadedGapiModules();
                    reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */));
                },
                timeout: NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = _window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) {
            // If gapi.iframes.Iframe available, resolve.
            resolve(gapi.iframes.getContext());
        }
        else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) {
            // Gapi loader ready, load gapi.iframes.
            loadGapiIframe();
        }
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = _generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            _window()[cbName] = () => {
                // GApi loader should be ready.
                if (!!gapi.load) {
                    loadGapiIframe();
                }
                else {
                    // Gapi loader failed, throw error.
                    reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */));
                }
            };
            // Load GApi loader.
            return _loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`)
                .catch(e => reject(e));
        }
    }).catch(error => {
        // Reset cached promise to allow for retrial.
        cachedGApiLoader = null;
        throw error;
    });
}
let cachedGApiLoader = null;
function _loadGapi(auth) {
    cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
    return cachedGApiLoader;
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PING_TIMEOUT = new Delay(5000, 15000);
const IFRAME_PATH = '__/auth/iframe';
const EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const EID_FROM_APIHOST = new Map([
    ["identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */, 'p'],
    ['staging-identitytoolkit.sandbox.googleapis.com', 's'],
    ['test-identitytoolkit.sandbox.googleapis.com', 't'] // test
]);
function getIframeUrl(auth) {
    const config = auth.config;
    _assert(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */);
    const url = config.emulator
        ? _emulatorUrl(config, EMULATED_IFRAME_PATH)
        : `https://${auth.config.authDomain}/${IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: esm_index_esm2017/* SDK_VERSION */.Jn
    };
    const eid = EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) {
        params.eid = eid;
    }
    const frameworks = auth._getFrameworks();
    if (frameworks.length) {
        params.fw = frameworks.join(',');
    }
    return `${url}?${(0,index_esm2017/* querystring */.xO)(params).slice(1)}`;
}
async function _openIframe(auth) {
    const context = await _loadGapi(auth);
    const gapi = _window().gapi;
    _assert(gapi, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
    return context.open({
        where: document.body,
        url: getIframeUrl(auth),
        messageHandlersFilter: gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe) => new Promise(async (resolve, reject) => {
        await iframe.restyle({
            // Prevent iframe from closing on mouse out.
            setHideOnLeave: false
        });
        const networkError = _createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */);
        // Confirm iframe is correctly loaded.
        // To fallback on failure, set a timeout.
        const networkErrorTimer = _window().setTimeout(() => {
            reject(networkError);
        }, PING_TIMEOUT.get());
        // Clear timer and resolve pending iframe ready promise.
        function clearTimerAndResolve() {
            _window().clearTimeout(networkErrorTimer);
            resolve(iframe);
        }
        // This returns an IThenable. However the reject part does not call
        // when the iframe is not loaded.
        iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, () => {
            reject(networkError);
        });
    }));
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = '_blank';
const FIREFOX_EMPTY_URL = 'http://localhost';
class AuthPopup {
    constructor(window) {
        this.window = window;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) {
            try {
                this.window.close();
            }
            catch (e) { }
        }
    }
}
function _open(auth, url, name, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), { width: width.toString(), height: height.toString(), top,
        left });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0,index_esm2017/* getUA */.z$)().toLowerCase();
    if (name) {
        target = _isChromeIOS(ua) ? TARGET_BLANK : name;
    }
    if (_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value]) => `${accum}${key}=${value},`, '');
    if (_isIOSStandalone(ua) && target !== '_self') {
        openAsNewWindowIOS(url || '', target);
        return new AuthPopup(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    _assert(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */);
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    }
    catch (e) { }
    return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */
const WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */
const EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */
const FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function _getRedirectUrl(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    _assert(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */);
    _assert(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */);
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType,
        redirectUrl,
        v: esm_index_esm2017/* SDK_VERSION */.Jn,
        eventId
    };
    if (provider instanceof FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0,index_esm2017/* isEmpty */.xb)(provider.getCustomParameters())) {
            params.customParameters = JSON.stringify(provider.getCustomParameters());
        }
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {})) {
            params[key] = value;
        }
    }
    if (provider instanceof BaseOAuthProvider) {
        const scopes = provider.getScopes().filter(scope => scope !== '');
        if (scopes.length > 0) {
            params.scopes = scopes.join(',');
        }
    }
    if (auth.tenantId) {
        params.tid = auth.tenantId;
    }
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict)) {
        if (paramsDict[key] === undefined) {
            delete paramsDict[key];
        }
    }
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken
        ? `#${FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}`
        : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${getHandlerBase(auth)}?${(0,index_esm2017/* querystring */.xO)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function getHandlerBase({ config }) {
    if (!config.emulator) {
        return `https://${config.authDomain}/${WIDGET_PATH}`;
    }
    return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The special web storage event
 *
 */
const WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class BrowserPopupRedirectResolver {
    constructor() {
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = browserSessionPersistence;
        this._completeRedirectFn = _getRedirectResult;
        this._overrideRedirectResult = _overrideRedirectResult;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        debugAssert((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        return _open(auth, url, _generateEventId());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        _setWindowLocation(url);
        return new Promise(() => { });
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager, promise } = this.eventManagers[key];
            if (manager) {
                return Promise.resolve(manager);
            }
            else {
                debugAssert(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = { promise };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(() => {
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await _openIframe(auth);
        const manager = new AuthEventManager(auth);
        iframe.register('authEvent', (iframeEvent) => {
            _assert(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */);
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return { status: handled ? "ACK" /* GapiOutcome.ACK */ : "ERROR" /* GapiOutcome.ERROR */ };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = { manager };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send(WEB_STORAGE_SUPPORT_KEY, { type: WEB_STORAGE_SUPPORT_KEY }, result => {
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) {
                cb(!!isSupported);
            }
            _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) {
            this.originValidationPromises[key] = _validateOrigin(auth);
        }
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return _isMobileBrowser() || _isSafari() || _isIOS();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */
const browserPopupRedirectResolver = BrowserPopupRedirectResolver;

class MultiFactorAssertionImpl {
    constructor(factorId) {
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch (session.type) {
            case "enroll" /* MultiFactorSessionType.ENROLL */:
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */:
                return this._finalizeSignIn(auth, session.credential);
            default:
                return debugFail('unexpected MultiFactorSessionType');
        }
    }
}

/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */
class PhoneMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(credential) {
        super("phone" /* FactorId.PHONE */);
        this.credential = credential;
    }
    /** @internal */
    static _fromCredential(credential) {
        return new PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */
    _finalizeEnroll(auth, idToken, displayName) {
        return finalizeEnrollPhoneMfa(auth, {
            idToken,
            displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */
    _finalizeSignIn(auth, mfaPendingCredential) {
        return finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */
class PhoneMultiFactorGenerator {
    constructor() { }
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */
    static assertion(credential) {
        return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */
PhoneMultiFactorGenerator.FACTOR_ID = 'phone';

/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */
class TotpMultiFactorGenerator {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */
    static assertionForEnrollment(secret, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */
    static assertionForSignIn(enrollmentId, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */
    static async generateSecret(session) {
        const mfaSession = session;
        _assert(typeof mfaSession.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */);
        const response = await startEnrollTotpMfa(mfaSession.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return TotpSecret._fromStartTotpMfaEnrollmentResponse(response, mfaSession.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */
TotpMultiFactorGenerator.FACTOR_ID = "totp" /* FactorId.TOTP */;
class TotpMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret) {
        super("totp" /* FactorId.TOTP */);
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */
    static _fromSecret(secret, otp) {
        return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */
    static _fromEnrollmentId(enrollmentId, otp) {
        return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */
    async _finalizeEnroll(auth, idToken, displayName) {
        _assert(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        return finalizeEnrollTotpMfa(auth, {
            idToken,
            displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */
    async _finalizeSignIn(auth, mfaPendingCredential) {
        _assert(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */);
        const totpVerificationInfo = { verificationCode: this.otp };
        return finalizeSignInTotpMfa(auth, {
            mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */
class TotpSecret {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth) {
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */
    static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */
    _makeTotpVerificationInfo(otp) {
        return { sessionInfo: this.sessionInfo, verificationCode: otp };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */
    generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if (_isEmptyString(accountName) || _isEmptyString(issuer)) {
            useDefaults = true;
        }
        if (useDefaults) {
            if (_isEmptyString(accountName)) {
                accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            }
            if (_isEmptyString(issuer)) {
                issuer = this.auth.name;
            }
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */
function _isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}

var index_e3d5d3f4_name = "@firebase/auth";
var version = "0.23.2";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthInterop {
    constructor(auth) {
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) {
            return null;
        }
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return { accessToken };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) {
            return;
        }
        const unsubscribe = this.auth.onIdTokenChanged(user => {
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) {
            return;
        }
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */);
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) {
            this.auth._startProactiveRefresh();
        }
        else {
            this.auth._stopProactiveRefresh();
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getVersionForPlatform(clientPlatform) {
    switch (clientPlatform) {
        case "Node" /* ClientPlatform.NODE */:
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */:
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */:
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */:
            return 'cordova';
        default:
            return undefined;
    }
}
/** @internal */
function registerAuth(clientPlatform) {
    (0,esm_index_esm2017/* _registerComponent */.Xd)(new component_dist_esm_index_esm2017/* Component */.wA("auth" /* _ComponentName.AUTH */, (container, { options: deps }) => {
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey, authDomain } = app.options;
        _assert(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */, { appName: app.name });
        const config = {
            apiKey,
            authDomain,
            clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */,
            sdkClientVersion: _getClientVersion(clientPlatform)
        };
        const authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        _initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */)
        /**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */
        .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */)
        /**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */
        .setInstanceCreatedCallback((container, _instanceIdentifier, _instance) => {
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */);
        authInternalProvider.initialize();
    }));
    (0,esm_index_esm2017/* _registerComponent */.Xd)(new component_dist_esm_index_esm2017/* Component */.wA("auth-internal" /* _ComponentName.AUTH_INTERNAL */, container => {
        const auth = _castAuth(container.getProvider("auth" /* _ComponentName.AUTH */).getImmediate());
        return (auth => new AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */));
    (0,esm_index_esm2017/* registerVersion */.KN)(index_e3d5d3f4_name, version, getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0,esm_index_esm2017/* registerVersion */.KN)(index_e3d5d3f4_name, version, 'esm2017');
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID_TOKEN_MAX_AGE = 5 * 60;
const authIdTokenMaxAge = (0,index_esm2017/* getExperimentalSetting */.Pz)('authIdTokenMaxAge') || DEFAULT_ID_TOKEN_MAX_AGE;
let lastPostedIdToken = null;
const mintCookieFactory = (url) => async (user) => {
    const idTokenResult = user && (await user.getIdTokenResult());
    const idTokenAge = idTokenResult &&
        (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
    if (idTokenAge && idTokenAge > authIdTokenMaxAge) {
        return;
    }
    // Specifically trip null => undefined when logged out, to delete any existing cookie
    const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
    if (lastPostedIdToken === idToken) {
        return;
    }
    lastPostedIdToken = idToken;
    await fetch(url, {
        method: idToken ? 'POST' : 'DELETE',
        headers: idToken
            ? {
                'Authorization': `Bearer ${idToken}`
            }
            : {}
    });
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */
function getAuth(app = (0,esm_index_esm2017/* getApp */.Mq)()) {
    const provider = (0,esm_index_esm2017/* _getProvider */.qX)(app, 'auth');
    if (provider.isInitialized()) {
        return provider.getImmediate();
    }
    const auth = initializeAuth(app, {
        popupRedirectResolver: browserPopupRedirectResolver,
        persistence: [
            indexedDBLocalPersistence,
            browserLocalPersistence,
            browserSessionPersistence
        ]
    });
    const authTokenSyncUrl = (0,index_esm2017/* getExperimentalSetting */.Pz)('authTokenSyncURL');
    if (authTokenSyncUrl) {
        const mintCookie = mintCookieFactory(authTokenSyncUrl);
        beforeAuthStateChanged(auth, mintCookie, () => mintCookie(auth.currentUser));
        onIdTokenChanged(auth, user => mintCookie(user));
    }
    const authEmulatorHost = (0,index_esm2017/* getDefaultEmulatorHost */.q4)('auth');
    if (authEmulatorHost) {
        connectAuthEmulator(auth, `http://${authEmulatorHost}`);
    }
    return auth;
}
registerAuth("Browser" /* ClientPlatform.BROWSER */);


//# sourceMappingURL=index-e3d5d3f4.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/esm2017/index.js






//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 5129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getPluralRules; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// does not check for duplicate subtags
var isStructurallyValidLanguageTag = function isStructurallyValidLanguageTag(locale) {
  return locale.split('-').every(function (subtag) {
    return /[a-z0-9]+/i.test(subtag);
  });
};

var canonicalizeLocaleList = function canonicalizeLocaleList(locales) {
  if (!locales) return [];
  if (!Array.isArray(locales)) locales = [locales];
  var res = {};

  for (var i = 0; i < locales.length; ++i) {
    var tag = locales[i];
    if (tag && _typeof(tag) === 'object') tag = String(tag);

    if (typeof tag !== 'string') {
      // Requiring tag to be a String or Object means that the Number value
      // NaN will not be interpreted as the language tag "nan", which stands
      // for Min Nan Chinese.
      var msg = "Locales should be strings, ".concat(JSON.stringify(tag), " isn't.");
      throw new TypeError(msg);
    }

    if (tag[0] === '*') continue;

    if (!isStructurallyValidLanguageTag(tag)) {
      var strTag = JSON.stringify(tag);

      var _msg = "The locale ".concat(strTag, " is not a structurally valid BCP 47 language tag.");

      throw new RangeError(_msg);
    }

    res[tag] = true;
  }

  return Object.keys(res);
};

var defaultLocale = function defaultLocale() {
  return (
    /* istanbul ignore next */
    typeof navigator !== 'undefined' && navigator && (navigator.userLanguage || navigator.language) || 'en-US'
  );
};

var getType = function getType(type) {
  if (!type) return 'cardinal';
  if (type === 'cardinal' || type === 'ordinal') return type;
  throw new RangeError('Not a valid plural type: ' + JSON.stringify(type));
};

function getPluralRules(NumberFormat, getSelector, getCategories) {
  var findLocale = function findLocale(locale) {
    do {
      if (getSelector(locale)) return locale;
      locale = locale.replace(/-?[^-]*$/, '');
    } while (locale);

    return null;
  };

  var resolveLocale = function resolveLocale(locales) {
    var canonicalLocales = canonicalizeLocaleList(locales);

    for (var i = 0; i < canonicalLocales.length; ++i) {
      var lc = findLocale(canonicalLocales[i]);
      if (lc) return lc;
    }

    return findLocale(defaultLocale());
  };

  var PluralRules = /*#__PURE__*/function () {
    function PluralRules(locales) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, PluralRules);

      this._locale = resolveLocale(locales);
      this._select = getSelector(this._locale);
      this._type = getType(opt.type);
      this._nf = new NumberFormat('en', opt); // make-plural expects latin digits with . decimal separator
    }

    _createClass(PluralRules, [{
      key: "resolvedOptions",
      value: function resolvedOptions() {
        var _this$_nf$resolvedOpt = this._nf.resolvedOptions(),
            minimumIntegerDigits = _this$_nf$resolvedOpt.minimumIntegerDigits,
            minimumFractionDigits = _this$_nf$resolvedOpt.minimumFractionDigits,
            maximumFractionDigits = _this$_nf$resolvedOpt.maximumFractionDigits,
            minimumSignificantDigits = _this$_nf$resolvedOpt.minimumSignificantDigits,
            maximumSignificantDigits = _this$_nf$resolvedOpt.maximumSignificantDigits;

        var opt = {
          locale: this._locale,
          minimumIntegerDigits: minimumIntegerDigits,
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits,
          pluralCategories: getCategories(this._locale, this._type === 'ordinal'),
          type: this._type
        };

        if (typeof minimumSignificantDigits === 'number') {
          opt.minimumSignificantDigits = minimumSignificantDigits;
          opt.maximumSignificantDigits = maximumSignificantDigits;
        }

        return opt;
      }
    }, {
      key: "select",
      value: function select(number) {
        if (!(this instanceof PluralRules)) throw new TypeError("select() called on incompatible ".concat(this));
        if (typeof number !== 'number') number = Number(number);
        if (!isFinite(number)) return 'other';

        var fmt = this._nf.format(Math.abs(number));

        return this._select(fmt, this._type === 'ordinal');
      }
    }], [{
      key: "supportedLocalesOf",
      value: function supportedLocalesOf(locales) {
        return canonicalizeLocaleList(locales).filter(findLocale);
      }
    }]);

    return PluralRules;
  }();

  Object.defineProperty(PluralRules, 'prototype', {
    writable: false
  });
  return PluralRules;
}




/***/ }),

/***/ 2708:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 9926:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ animated; },
  "vc": function() { return /* reexport */ config; },
  "q_": function() { return /* reexport */ useSpring; }
});

// UNUSED EXPORTS: Any, BailSignal, Controller, FrameValue, Globals, Interpolation, Spring, SpringContext, SpringRef, SpringValue, Trail, Transition, a, createInterpolator, easings, inferTo, interpolate, to, update, useChain, useInView, useIsomorphicLayoutEffect, useReducedMotion, useResize, useScroll, useSpringRef, useSpringValue, useSprings, useTrail, useTransition

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@react-spring/shared/dist/react-spring_shared.modern.mjs
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/globals.ts
var globals_exports = {};
__export(globals_exports, {
  assign: () => react_spring_shared_modern_assign,
  colors: () => colors,
  createStringInterpolator: () => createStringInterpolator,
  skipAnimation: () => skipAnimation,
  to: () => to,
  willAdvance: () => willAdvance
});

// ../rafz/dist/react-spring_rafz.modern.mjs
var updateQueue = makeQueue();
var raf = (fn) => schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
  const time = raf.now() + ms;
  const cancel = () => {
    const i = timeouts.findIndex((t) => t.cancel == cancel);
    if (~i)
      timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };
  const timeout = { time, handler, cancel };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};
var findTimeout = (time) => ~(~timeouts.findIndex((t) => t.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};
raf.sync = (fn) => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = (fn) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
  if (raf.frameLoop !== "demand") {
    console.warn(
      "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
    );
  } else {
    update();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  const prevTs = ts;
  ts = raf.now();
  const count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t) => t.handler());
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next = /* @__PURE__ */ new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */ new Set();
        pendingCount -= current.size;
        eachSafely(current, (fn) => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each2) {
  values.forEach((value) => {
    try {
      each2(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

// src/helpers.ts
function noop() {
}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, { value, writable: true, configurable: true });
var is = {
  arr: Array.isArray,
  obj: (a) => !!a && a.constructor.name === "Object",
  fun: (a) => typeof a === "function",
  str: (a) => typeof a === "string",
  num: (a) => typeof a === "number",
  und: (a) => a === void 0
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length)
      return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i])
        return false;
    }
    return true;
  }
  return a === b;
}
var react_spring_shared_modern_each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }
    return;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
var toArray = (a) => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    react_spring_shared_modern_each(items, iterator);
  }
}
var flushCalls = (queue, ...args) => flush(queue, (fn) => fn(...args));
var isSSR = () => typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

// src/globals.ts
var createStringInterpolator;
var to;
var colors = null;
var skipAnimation = false;
var willAdvance = noop;
var react_spring_shared_modern_assign = (globals) => {
  if (globals.to)
    to = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
  if (globals.frameLoop)
    raf.frameLoop = globals.frameLoop;
};

// src/FrameLoop.ts
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance,
  /** Call this when an animation's priority changes. */
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(
    findIndex(currentFrame, (other) => other.priority > animation.priority),
    0,
    animation
  );
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

// src/clamp.ts
var clamp = (min, max, v) => Math.min(Math.max(v, min), max);

// src/colors.ts
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

// src/colorMatchers.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp(
  "hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)
);
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

// src/normalizeColor.ts
function normalizeColor(color) {
  let match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colors && colors[color] !== void 0) {
    return colors[color];
  }
  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      match[4] + match[4],
      // a
      16
    ) >>> 0;
  }
  if (match = hsl.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match = hsla.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | parse1(match[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}

// src/colorToRgba.ts
function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  const r = (int32Color & 4278190080) >>> 24;
  const g = (int32Color & 16711680) >>> 16;
  const b = (int32Color & 65280) >>> 8;
  const a = (int32Color & 255) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// src/createInterpolator.ts
var createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
  const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
  const easing = config.easing || ((t) => t);
  return (input) => {
    const range2 = findRange(input, inputRange);
    return interpolate(
      input,
      inputRange[range2],
      inputRange[range2 + 1],
      outputRange[range2],
      outputRange[range2 + 1],
      easing,
      extrapolateLeft,
      extrapolateRight,
      config.map
    );
  };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i)
    if (inputRange[i] >= input)
      break;
  return i - 1;
}

// src/easings.ts
var steps = (steps2, direction = "end") => (progress2) => {
  progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
  const expanded = progress2 * steps2;
  const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp(0, 1, rounded / steps2);
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut = (x) => {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};
var easings = {
  linear: (x) => x,
  easeInQuad: (x) => x * x,
  easeOutQuad: (x) => 1 - (1 - x) * (1 - x),
  easeInOutQuad: (x) => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: (x) => x * x * x,
  easeOutCubic: (x) => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: (x) => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: (x) => x * x * x * x,
  easeOutQuart: (x) => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: (x) => x * x * x * x * x,
  easeOutQuint: (x) => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: (x) => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: (x) => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: (x) => Math.sin(x * Math.PI / 2),
  easeInOutSine: (x) => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: (x) => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: (x) => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: (x) => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: (x) => c3 * x * x * x - c1 * x * x,
  easeOutBack: (x) => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: (x) => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: (x) => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: (x) => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: (x) => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
  steps
};

// src/fluids.ts
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer2, event) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event);
  } else {
    observer2(event);
  }
}
function callFluidObservers(target, event) {
  const observers = target[$observers];
  if (observers) {
    observers.forEach((observer2) => {
      callFluidObserver(observer2, event);
    });
  }
}
var FluidValue = class {
  constructor(get) {
    if (!get && !(get = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get);
  }
};
$get, $observers;
var setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  const observers = target[$observers];
  if (observers && observers.has(observer2)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

// src/regexs.ts
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

// src/variableToRgba.ts
var variableToRgba = (input) => {
  const [token, fallback] = parseCSSVariable(input);
  if (!token || isSSR()) {
    return input;
  }
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input;
};
var parseCSSVariable = (current) => {
  const match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

// src/stringInterpolation.ts
var namedColorRegex;
var rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config) => {
  if (!namedColorRegex)
    namedColorRegex = colors ? (
      // match color names, ignore partial matches
      new RegExp(`(${Object.keys(colors).join("|")})(?!\\w)`, "g")
    ) : (
      // never match
      /^\b$/
    );
  const output = config.output.map((value) => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map(
    (_, i) => keyframes.map((values) => {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    })
  );
  const interpolators = outputRanges.map(
    (output2) => createInterpolator({ ...config, output: output2 })
  );
  return (input) => {
    const missingUnit = !unitRegex.test(output[0]) && output.find((value) => unitRegex.test(value))?.replace(numberRegex, "");
    let i = 0;
    return output[0].replace(
      numberRegex,
      () => `${interpolators[i++](input)}${missingUnit || ""}`
    ).replace(rgbaRegex, rgbaRound);
  };
};

// src/deprecations.ts
var prefix = "react-spring: ";
var once = (fn) => {
  const func = fn;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(
    `${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(
    `${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}

// src/isAnimatedString.ts
function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (colors || {}));
}

// src/dom-events/resize/resizeElement.ts
var observer;
var resizeHandlers = /* @__PURE__ */ new WeakMap();
var handleObservation = (entries) => entries.forEach(({ target, contentRect }) => {
  return resizeHandlers.get(target)?.forEach((handler) => handler(contentRect));
});
function resizeElement(handler, target) {
  if (!observer) {
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(handleObservation);
    }
  }
  let elementHandlers = resizeHandlers.get(target);
  if (!elementHandlers) {
    elementHandlers = /* @__PURE__ */ new Set();
    resizeHandlers.set(target, elementHandlers);
  }
  elementHandlers.add(handler);
  if (observer) {
    observer.observe(target);
  }
  return () => {
    const elementHandlers2 = resizeHandlers.get(target);
    if (!elementHandlers2)
      return;
    elementHandlers2.delete(handler);
    if (!elementHandlers2.size && observer) {
      observer.unobserve(target);
    }
  };
}

// src/dom-events/resize/resizeWindow.ts
var listeners = /* @__PURE__ */ new Set();
var cleanupWindowResizeHandler;
var createResizeHandler = () => {
  const handleResize = () => {
    listeners.forEach(
      (callback) => callback({
        width: window.innerWidth,
        height: window.innerHeight
      })
    );
  };
  window.addEventListener("resize", handleResize);
  return () => {
    window.removeEventListener("resize", handleResize);
  };
};
var resizeWindow = (callback) => {
  listeners.add(callback);
  if (!cleanupWindowResizeHandler) {
    cleanupWindowResizeHandler = createResizeHandler();
  }
  return () => {
    listeners.delete(callback);
    if (!listeners.size && cleanupWindowResizeHandler) {
      cleanupWindowResizeHandler();
      cleanupWindowResizeHandler = void 0;
    }
  };
};

// src/dom-events/resize/index.ts
var react_spring_shared_modern_onResize = (callback, { container = document.documentElement } = {}) => {
  if (container === document.documentElement) {
    return resizeWindow(callback);
  } else {
    return resizeElement(callback, container);
  }
};

// src/progress.ts
var progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);

// src/dom-events/scroll/ScrollHandler.ts
var SCROLL_KEYS = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
var ScrollHandler = class {
  constructor(callback, container) {
    this.createAxis = () => ({
      current: 0,
      progress: 0,
      scrollLength: 0
    });
    this.updateAxis = (axisName) => {
      const axis = this.info[axisName];
      const { length, position } = SCROLL_KEYS[axisName];
      axis.current = this.container[`scroll${position}`];
      axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
      axis.progress = progress(0, axis.scrollLength, axis.current);
    };
    this.update = () => {
      this.updateAxis("x");
      this.updateAxis("y");
    };
    this.sendEvent = () => {
      this.callback(this.info);
    };
    this.advance = () => {
      this.update();
      this.sendEvent();
    };
    this.callback = callback;
    this.container = container;
    this.info = {
      time: 0,
      x: this.createAxis(),
      y: this.createAxis()
    };
  }
};

// src/dom-events/scroll/index.ts
var scrollListeners = /* @__PURE__ */ new WeakMap();
var resizeListeners = /* @__PURE__ */ new WeakMap();
var onScrollHandlers = /* @__PURE__ */ new WeakMap();
var getTarget = (container) => container === document.documentElement ? window : container;
var react_spring_shared_modern_onScroll = (callback, { container = document.documentElement } = {}) => {
  let containerHandlers = onScrollHandlers.get(container);
  if (!containerHandlers) {
    containerHandlers = /* @__PURE__ */ new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  const containerHandler = new ScrollHandler(callback, container);
  containerHandlers.add(containerHandler);
  if (!scrollListeners.has(container)) {
    const listener = () => {
      containerHandlers?.forEach((handler) => handler.advance());
      return true;
    };
    scrollListeners.set(container, listener);
    const target = getTarget(container);
    window.addEventListener("resize", listener, { passive: true });
    if (container !== document.documentElement) {
      resizeListeners.set(container, react_spring_shared_modern_onResize(listener, { container }));
    }
    target.addEventListener("scroll", listener, { passive: true });
  }
  const animateScroll = scrollListeners.get(container);
  raf(animateScroll);
  return () => {
    raf.cancel(animateScroll);
    const containerHandlers2 = onScrollHandlers.get(container);
    if (!containerHandlers2)
      return;
    containerHandlers2.delete(containerHandler);
    if (containerHandlers2.size)
      return;
    const listener = scrollListeners.get(container);
    scrollListeners.delete(container);
    if (listener) {
      getTarget(container).removeEventListener("scroll", listener);
      window.removeEventListener("resize", listener);
      resizeListeners.get(container)?.();
    }
  };
};

// src/hooks/useConstant.ts

function react_spring_shared_modern_useConstant(init) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// src/hooks/useForceUpdate.ts


// src/hooks/useIsMounted.ts


// src/hooks/useIsomorphicLayoutEffect.ts

var react_spring_shared_modern_useIsomorphicLayoutEffect = isSSR() ? react.useEffect : react.useLayoutEffect;

// src/hooks/useIsMounted.ts
var useIsMounted = () => {
  const isMounted = (0,react.useRef)(false);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

// src/hooks/useForceUpdate.ts
function useForceUpdate() {
  const update2 = (0,react.useState)()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}

// src/hooks/useMemoOne.ts

function useMemoOne(getResult, inputs) {
  const [initial] = (0,react.useState)(
    () => ({
      inputs,
      result: getResult()
    })
  );
  const committed = (0,react.useRef)();
  const prevCache = committed.current;
  let cache = prevCache;
  if (cache) {
    const useCache = Boolean(
      inputs && cache.inputs && areInputsEqual(inputs, cache.inputs)
    );
    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  (0,react.useEffect)(() => {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }
  return true;
}

// src/hooks/useOnce.ts

var useOnce = (effect) => (0,react.useEffect)(effect, emptyDeps);
var emptyDeps = [];

// src/hooks/usePrev.ts

function usePrev(value) {
  const prevRef = (0,react.useRef)();
  (0,react.useEffect)(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

// src/hooks/useReducedMotion.ts

var useReducedMotion = () => {
  const [reducedMotion, setReducedMotion] = useState3(null);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion)");
    const handleMediaChange = (e) => {
      setReducedMotion(e.matches);
      react_spring_shared_modern_assign({
        skipAnimation: e.matches
      });
    };
    handleMediaChange(mql);
    mql.addEventListener("change", handleMediaChange);
    return () => {
      mql.removeEventListener("change", handleMediaChange);
    };
  }, []);
  return reducedMotion;
};

//# sourceMappingURL=react-spring_shared.modern.mjs.map
;// CONCATENATED MODULE: ./node_modules/@react-spring/animated/dist/react-spring_animated.modern.mjs
// src/Animated.ts

var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
};

// src/AnimatedValue.ts

var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  /** @internal */
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const { done } = this;
    this.done = false;
    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};

// src/AnimatedString.ts

var AnimatedString = class extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  /** @internal */
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    const value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};

// src/AnimatedArray.ts


// src/AnimatedObject.ts


// src/context.ts
var TreeContext = { dependencies: null };

// src/AnimatedObject.ts
var AnimatedObject = class extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }
  /** Replace the raw object data */
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      react_spring_shared_modern_each(this.payload, (node) => node.reset());
    }
  }
  /** Create a payload set. */
  _makePayload(source) {
    if (source) {
      const payload = /* @__PURE__ */ new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      react_spring_shared_modern_each(payload, (node) => this.add(node));
    }
  }
};

// src/AnimatedArray.ts
var AnimatedArray = class extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  /** @internal */
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
};
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

// src/getAnimatedType.ts

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

// src/createHost.ts


// src/withAnimated.tsx



var withAnimated = (Component, host) => {
  const hasInstance = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent
  );
  return (0,react.forwardRef)((givenProps, givenRef) => {
    const instanceRef = (0,react.useRef)(null);
    const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useCallback)(
      (value) => {
        instanceRef.current = updateRef(givenRef, value);
      },
      [givenRef]
    );
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = (0,react.useRef)();
    react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
      observerRef.current = observer;
      react_spring_shared_modern_each(deps, (dep) => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          react_spring_shared_modern_each(
            observerRef.current.deps,
            (dep) => removeFluidObserver(dep, observerRef.current)
          );
          raf.cancel(observerRef.current.update);
        }
      };
    });
    (0,react.useEffect)(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      react_spring_shared_modern_each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */ react.createElement(Component, { ...usedProps, ref });
  });
};
var PropsObserver = class {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }
  eventObserved(event) {
    if (event.type == "change") {
      raf.write(this.update);
    }
  }
};
function getAnimatedState(props, host) {
  const dependencies = /* @__PURE__ */ new Set();
  TreeContext.dependencies = dependencies;
  if (props.style)
    props = {
      ...props,
      style: host.createAnimatedStyle(props.style)
    };
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}

// src/createHost.ts
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };
  const animated = (Component) => {
    const displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = `Animated(${displayName})`;
    return Component;
  };
  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated
  };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

//# sourceMappingURL=react-spring_animated.modern.mjs.map
;// CONCATENATED MODULE: ./node_modules/@react-spring/core/dist/react-spring_core.modern.mjs
// src/hooks/useChain.ts


// src/helpers.ts

function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
var resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var noopTransform = (value) => value;
var getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  const defaults2 = {};
  for (const key of keys) {
    const value = transform(props[key], key);
    if (!is.und(value)) {
      defaults2[key] = value;
    }
  }
  return defaults2;
};
var DEFAULT_PROPS = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  const to2 = getForwardProps(props);
  if (to2) {
    const out = { to: to2 };
    eachProp(props, (val, key) => key in to2 || (out[key] = val));
    return out;
  }
  return { ...props };
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals_exports.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props)
    return true;
  return false;
}
function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}
function detachRefs(ctrl, ref) {
  ctrl.ref?.delete(ctrl);
  ref?.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    ctrl.ref?.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

// src/hooks/useChain.ts
function useChain(refs, timeSteps, timeFrame = 1e3) {
  useIsomorphicLayoutEffect(() => {
    if (timeSteps) {
      let prevDelay = 0;
      each(refs, (ref, i) => {
        const controllers = ref.current;
        if (controllers.length) {
          let delay = timeFrame * timeSteps[i];
          if (isNaN(delay))
            delay = prevDelay;
          else
            prevDelay = delay;
          each(controllers, (ctrl) => {
            each(ctrl.queue, (props) => {
              const memoizedDelayProp = props.delay;
              props.delay = (key) => delay + callProp(memoizedDelayProp || 0, key);
            });
          });
          ref.start();
        }
      });
    } else {
      let p = Promise.resolve();
      each(refs, (ref) => {
        const controllers = ref.current;
        if (controllers.length) {
          const queues = controllers.map((ctrl) => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            each(
              controllers,
              (ctrl, i) => each(queues[i] || [], (update2) => ctrl.queue.push(update2))
            );
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
}

// src/hooks/useSpring.ts


// src/hooks/useSprings.ts



// src/SpringValue.ts



// src/AnimationConfig.ts


// src/constants.ts
var config = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
};

// src/AnimationConfig.ts
var defaults = {
  ...config.default,
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
};
var AnimationConfig = class {
  constructor() {
    /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */
    this.velocity = 0;
    Object.assign(this, defaults);
  }
};
function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = { ...defaultConfig };
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = { ...defaultConfig, ...newConfig };
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (const key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }
  let { frequency, damping } = config2;
  const { mass } = config2;
  if (!is.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props) {
  if (!is.und(props.decay)) {
    config2.duration = void 0;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);
    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}

// src/Animation.ts
var emptyArray = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
  }
};

// src/scheduleProps.ts

function scheduleProps(callId, { key, props, defaultProps, state, actions }) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout;
    let cancel = matchProp(props.cancel ?? defaultProps?.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      let pause = defaultProps?.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !globals_exports.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start({ ...props, callId, cancel }, resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

// src/runAsync.ts


// src/AnimationResult.ts
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(
  target.get(),
  results.every((result) => result.finished)
);
var getNoopResult = (value) => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
var getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
var getCancelledResult = (value) => ({
  value,
  cancelled: true,
  finished: false
});

// src/runAsync.ts
function runAsync(to2, props, state, target) {
  const { callId, parentId, onRest } = props;
  const { asyncTo: prevTo, promise: prevPromise } = state;
  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to2;
    const defaultProps = getDefaultProps(
      props,
      (value, key) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        key === "onRest" ? void 0 : value
      )
    );
    let preventBail;
    let bail;
    const bailPromise = new Promise(
      (resolve, reject) => (preventBail = resolve, bail = reject)
    );
    const bailIfEnded = (bailSignal) => {
      const bailResult = (
        // The `cancel` prop or `stop` method was used.
        callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
        callId !== state.asyncId && getFinishedResult(target, false)
      );
      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };
    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAnimationSignal();
      return (async () => {
        if (globals_exports.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }
        bailIfEnded(bailSignal);
        const props2 = is.obj(arg1) ? { ...arg1 } : { ...arg2, to: arg1 };
        props2.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is.und(props2[key])) {
            props2[key] = value;
          }
        });
        const result2 = await target.start(props2);
        bailIfEnded(bailSignal);
        if (state.paused) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      })();
    };
    let result;
    if (globals_exports.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }
    try {
      let animating;
      if (is.arr(to2)) {
        animating = (async (queue) => {
          for (const props2 of queue) {
            await animate(props2);
          }
        })(to2);
      } else {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }
    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, (t) => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId)
    state.cancelId = cancelId;
}
var BailSignal = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
};
var SkipAnimationSignal = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
};

// src/FrameValue.ts


var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;
      this._onPriorityChange(priority);
    }
  }
  /** Get the current value */
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...args) {
    return globals_exports.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...args) {
    deprecateInterpolate();
    return globals_exports.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority
    });
  }
};

// src/SpringPhase.ts
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
var isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

// src/SpringValue.ts
var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    /** The animation state */
    this.animation = new Animation();
    /** Some props have customizable default values */
    this.defaultProps = {};
    /** The state for `runAsync` calls */
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The promise resolvers of pending `start` calls */
    this._pendingCalls = /* @__PURE__ */ new Set();
    /** The counter for tracking `scheduleProps` calls */
    this._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */
    this._lastToId = 0;
    this._memoizedDuration = 0;
    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? { ...arg1 } : { ...arg2, from: arg1 };
      if (is.und(props.default)) {
        props.default = true;
      }
      this.start(props);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node2) => node2.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return hasAnimated(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return isAnimating(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return isPaused(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let { toValues } = anim;
    const { config: config2 } = anim;
    const payload = getPayload(anim.to);
    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray(getFluidValue(anim.to));
    }
    anim.values.forEach((node2, i) => {
      if (node2.done)
        return;
      const to2 = (
        // Animated strings always go from 0 to 1.
        node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i]
      );
      let finished = anim.immediate;
      let position = to2;
      if (!finished) {
        position = node2.lastPosition;
        if (config2.tension <= 0) {
          node2.done = true;
          return;
        }
        let elapsed = node2.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node2.v0 != null ? node2.v0 : node2.v0 = is.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
        let velocity;
        const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
        if (!is.und(config2.duration)) {
          let p = 1;
          if (config2.duration > 0) {
            if (this._memoizedDuration !== config2.duration) {
              this._memoizedDuration = config2.duration;
              if (node2.durationProgress > 0) {
                node2.elapsedTime = config2.duration * node2.durationProgress;
                elapsed = node2.elapsedTime += dt;
              }
            }
            p = (config2.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node2.durationProgress = p;
          }
          position = from + config2.easing(p) * (to2 - from);
          velocity = (position - node2.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          const decay = config2.decay === true ? 0.998 : config2.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node2.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
          const restVelocity = config2.restVelocity || precision / 10;
          const bounceFactor = config2.clamp ? 0 : config2.bounce;
          const canBounce = !is.und(bounceFactor);
          const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to2 - position) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position == to2 || position > to2 == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to2;
              }
            }
            const springForce = -config2.tension * 1e-6 * (position - to2);
            const dampingForce = -config2.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }
        node2.lastVelocity = velocity;
        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }
      if (payload && !payload[i].done) {
        finished = false;
      }
      if (finished) {
        node2.done = true;
      } else {
        idle = false;
      }
      if (node2.setValue(position, config2.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();
    if (idle) {
      const finalVal = getFluidValue(anim.to);
      if ((currVal !== finalVal || changed) && !config2.decay) {
        node.setValue(finalVal);
        this._onChange(finalVal);
      } else if (changed && config2.decay) {
        this._onChange(currVal);
      }
      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }
  /** Set the current value, while stopping the current animation */
  set(value) {
    raf.batchedUpdates(() => {
      this._stop();
      this._focus(value);
      this._set(value);
    });
    return this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: true });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: false });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (isAnimating(this)) {
      const { to: to2, config: config2 } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();
        if (!config2.decay) {
          this._set(to2, false);
        }
        this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  start(to2, arg2) {
    let queue;
    if (!is.und(to2)) {
      queue = [is.obj(to2) ? to2 : { ...arg2, to: to2 }];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    return Promise.all(
      queue.map((props) => {
        const up = this._update(props);
        return up;
      })
    ).then((results) => getCombinedResult(this, results));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(cancel) {
    const { to: to2 } = this.animation;
    this._focus(this.get());
    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to2, cancel));
    return this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: true });
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._start();
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(props) {
    const key = this.key || "";
    let { to: to2, from } = props;
    to2 = is.obj(to2) ? to2[key] : to2;
    if (to2 == null || isAsyncTo(to2)) {
      to2 = void 0;
    }
    from = is.obj(from) ? from[key] : from;
    if (from == null) {
      from = void 0;
    }
    const range = { to: to2, from };
    if (!hasAnimated(this)) {
      if (props.reverse)
        [to2, from] = [from, to2];
      from = getFluidValue(from);
      if (!is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
        this._set(to2);
      }
    }
    return range;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...props }, isLoop) {
    const { key, defaultProps } = this;
    if (props.default)
      Object.assign(
        defaultProps,
        getDefaultProps(
          props,
          (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value
        )
      );
    mergeActiveFn(this, props, "onProps");
    sendEvent(this, "onProps", props, this);
    const range = this._prepareNode(props);
    if (Object.isFrozen(this)) {
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    }
    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(
              this,
              "onPause",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);
            if (isAnimating(this)) {
              this._resume();
            }
            flushCalls(state.resumeQueue);
            sendEvent(
              this,
              "onResume",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then((result) => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  /** Merge props into the current animation */
  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);
    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const { key, defaultProps, animation: anim } = this;
    const { to: prevTo, from: prevFrom } = anim;
    let { to: to2 = prevTo, from = prevFrom } = range;
    if (hasFromProp && !hasToProp && (!props.default || is.und(to2))) {
      to2 = from;
    }
    if (props.reverse)
      [to2, from] = [from, to2];
    const hasFromChanged = !isEqual(from, prevFrom);
    if (hasFromChanged) {
      anim.from = from;
    }
    from = getFluidValue(from);
    const hasToChanged = !isEqual(to2, prevTo);
    if (hasToChanged) {
      this._focus(to2);
    }
    const hasAsyncTo = isAsyncTo(props.to);
    const { config: config2 } = anim;
    const { decay, velocity } = config2;
    if (hasToProp || hasFromProp) {
      config2.velocity = 0;
    }
    if (props.config && !hasAsyncTo) {
      mergeConfig(
        config2,
        callProp(props.config, key),
        // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0
      );
    }
    let node = getAnimated(this);
    if (!node || is.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key)
    );
    const value = reset ? from : this.get();
    const goal = computeGoal(to2);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
    if (hasToChanged) {
      const nodeType = getAnimatedType(to2);
      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else
          throw Error(
            `Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`
          );
      }
    }
    const goalType = node.constructor;
    let started = hasFluidValue(to2);
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }
    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }
      if (anim.immediate != immediate) {
        anim.immediate = immediate;
        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }
      if (started) {
        const { onRest } = anim;
        react_spring_shared_modern_each(ACTIVE_EVENTS, (type) => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);
        this._pendingCalls.add(resolve);
        if (anim.changed)
          raf.batchedUpdates(() => {
            anim.changed = !reset;
            onRest?.(result, this);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              anim.onStart?.(result, this);
            }
          });
      }
    }
    if (reset) {
      this._set(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }
      anim.to = value;
      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }
  _attach() {
    let priority = 0;
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      addFluidObserver(to2, this);
      if (isFrameValue(to2)) {
        priority = to2.priority + 1;
      }
    }
    this.priority = priority;
  }
  _detach() {
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      removeFluidObserver(to2, this);
    }
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(arg, idle = true) {
    const value = getFluidValue(arg);
    if (!is.und(value)) {
      const oldNode = getAnimated(this);
      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);
        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }
        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }
    return getAnimated(this);
  }
  _onStart() {
    const anim = this.animation;
    if (!anim.changed) {
      anim.changed = true;
      sendEvent(
        this,
        "onStart",
        getFinishedResult(this, checkFinished(this, anim.to)),
        this
      );
    }
  }
  _onChange(value, idle) {
    if (!idle) {
      this._onStart();
      callProp(this.animation.onChange, value, this);
    }
    callProp(this.defaultProps.onChange, value, this);
    super._onChange(value, idle);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node) => node.lastPosition);
    }
    if (!isAnimating(this)) {
      setActiveBit(this, true);
      if (!isPaused(this)) {
        this._resume();
      }
    }
  }
  _resume() {
    if (globals_exports.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      react_spring_shared_modern_each(anim.values, (node) => {
        node.done = true;
      });
      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }
      callFluidObservers(this, {
        type: "idle",
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal ?? anim.to));
      flushCalls(this._pendingCalls, result);
      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }
};
function checkFinished(target, to2) {
  const goal = computeGoal(to2);
  const value = computeGoal(target.get());
  return isEqual(value, goal);
}
function createLoopUpdate(props, loop = props.loop, to2 = props.to) {
  const loopRet = callProp(loop);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate({
      ...props,
      loop,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...overrides
    });
  }
}
function createUpdate(props) {
  const { to: to2, from } = props = inferTo(props);
  const keys = /* @__PURE__ */ new Set();
  if (is.obj(to2))
    findDefined(to2, keys);
  if (is.obj(from))
    findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update2 = createUpdate(props);
  if (is.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}
var ACTIVE_EVENTS = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
  target.animation[type]?.(...args);
  target.defaultProps[type]?.(...args);
}

// src/Controller.ts

var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller = class {
  constructor(props, flush3) {
    this.id = nextId2++;
    /** The animated values */
    this.springs = {};
    /** The queue of props passed to the `update` method. */
    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */
    this._lastAsyncId = 0;
    /** The values currently being animated */
    this._active = /* @__PURE__ */ new Set();
    /** The values that changed recently */
    this._changed = /* @__PURE__ */ new Set();
    /** Equals false when `onStart` listeners can be called */
    this._started = false;
    /** State used by the `runAsync` function */
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    /** The event queues that are flushed once per frame maximum */
    this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props) {
      this.start({ default: true, ...props });
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }
  get item() {
    return this._item;
  }
  set item(item) {
    this._item = item;
  }
  /** Get the current values of our springs */
  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  /** Set the current values without animating. */
  set(values) {
    for (const key in values) {
      const value = values[key];
      if (!is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  /** Push an update onto the queue of each value. */
  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }
    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(props) {
    let { queue } = this;
    if (props) {
      queue = toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** @internal */
  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }
    if (keys) {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each((spring) => spring.stop(!!arg));
    }
    return this;
  }
  /** Freeze the active animation in time */
  pause(keys) {
    if (is.und(keys)) {
      this.start({ pause: true });
    } else {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(keys) {
    if (is.und(keys)) {
      this.start({ pause: false });
    } else {
      const springs = this.springs;
      react_spring_shared_modern_each(toArray(keys), (key) => springs[key].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(iterator) {
    eachProp(this.springs, iterator);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart, onChange, onRest } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;
    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart2, result]) => {
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }
    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;
    if (changed && onChange.size) {
      flush(onChange, ([onChange2, result]) => {
        result.value = values;
        onChange2(result, this, this._item);
      });
    }
    if (idle) {
      this._started = false;
      flush(onRest, ([onRest2, result]) => {
        result.value = values;
        onRest2(result, this, this._item);
      });
    }
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      this._changed.add(event.parent);
      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else
      return;
    raf.onFrame(this._onFrame);
  }
};
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then(
    (results) => getCombinedResult(ctrl, results)
  );
}
async function flushUpdate(ctrl, props, isLoop) {
  const { keys, to: to2, from, loop, onRest, onResolve } = props;
  const defaults2 = is.obj(props.default) && props.default;
  if (loop) {
    props.loop = false;
  }
  if (to2 === false)
    props.to = null;
  if (from === false)
    props.from = null;
  const asyncTo = is.arr(to2) || is.fun(to2) ? to2 : void 0;
  if (asyncTo) {
    props.to = void 0;
    props.onRest = void 0;
    if (defaults2) {
      defaults2.onRest = void 0;
    }
  } else {
    react_spring_shared_modern_each(BATCHED_EVENTS, (key) => {
      const handler = props[key];
      if (is.fun(handler)) {
        const queue = ctrl["_events"][key];
        props[key] = ({ finished, cancelled }) => {
          const result2 = queue.get(handler);
          if (result2) {
            if (!finished)
              result2.finished = false;
            if (cancelled)
              result2.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };
        if (defaults2) {
          defaults2[key] = props[key];
        }
      }
    });
  }
  const state = ctrl["_state"];
  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }
  const promises = (keys || Object.keys(ctrl.springs)).map(
    (key) => ctrl.springs[key].start(props)
  );
  const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
  if (asyncTo || cancel && state.asyncId) {
    promises.push(
      scheduleProps(++ctrl["_lastAsyncId"], {
        props,
        state,
        actions: {
          pause: noop,
          resume: noop,
          start(props2, resolve) {
            if (cancel) {
              stopAsync(state, ctrl["_lastAsyncId"]);
              resolve(getCancelledResult(ctrl));
            } else {
              props2.onRest = onRest;
              resolve(
                runAsync(
                  asyncTo,
                  props2,
                  state,
                  ctrl
                )
              );
            }
          }
        }
      })
    );
  }
  if (state.paused) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const result = getCombinedResult(ctrl, await Promise.all(promises));
  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to2);
    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }
  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }
  return result;
}
function getSprings(ctrl, props) {
  const springs = { ...ctrl.springs };
  if (props) {
    react_spring_shared_modern_each(toArray(props), (props2) => {
      if (is.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is.obj(props2.to)) {
        props2 = { ...props2, to: void 0 };
      }
      prepareSprings(springs, props2, (key) => {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    react_spring_shared_modern_each(props.keys, (key) => {
      const spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  react_spring_shared_modern_each(queue, (props) => {
    prepareSprings(ctrl.springs, props, (key) => {
      return createSpring(key, ctrl);
    });
  });
}

// src/SpringContext.tsx



var SpringContext = ({
  children,
  ...props
}) => {
  const inherited = (0,react.useContext)(ctx);
  const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({ pause, immediate }), [pause, immediate]);
  const { Provider } = ctx;
  return /* @__PURE__ */ react.createElement(Provider, { value: props }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, react.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

// src/SpringRef.ts

var SpringRef = () => {
  const current = [];
  const SpringRef2 = function(props) {
    deprecateDirectCall();
    const results = [];
    react_spring_shared_modern_each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = _getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function(ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2.delete = function(ctrl) {
    const i = current.indexOf(ctrl);
    if (~i)
      current.splice(i, 1);
  };
  SpringRef2.pause = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.pause(...arguments));
    return this;
  };
  SpringRef2.resume = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.resume(...arguments));
    return this;
  };
  SpringRef2.set = function(values) {
    react_spring_shared_modern_each(current, (ctrl, i) => {
      const update2 = is.fun(values) ? values(i, ctrl) : values;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function(props) {
    const results = [];
    react_spring_shared_modern_each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update2 = this._getProps(props, ctrl, i);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function() {
    react_spring_shared_modern_each(current, (ctrl) => ctrl.stop(...arguments));
    return this;
  };
  SpringRef2.update = function(props) {
    react_spring_shared_modern_each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };
  const _getProps = function(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};

// src/hooks/useSprings.ts
function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps)
    deps = [];
  const ref = (0,react.useMemo)(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const layoutId = (0,react.useRef)(0);
  const forceUpdate = useForceUpdate();
  const state = (0,react.useMemo)(
    () => ({
      ctrls: [],
      queue: [],
      flush(ctrl, updates2) {
        const springs2 = getSprings(ctrl, updates2);
        const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
          setSprings(ctrl, springs2);
          state.queue.push(() => {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    }),
    []
  );
  const ctrls = (0,react.useRef)([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length) || 0;
  (0,react.useMemo)(() => {
    react_spring_shared_modern_each(ctrls.current.slice(length, prevLength), (ctrl) => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  (0,react.useMemo)(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update2 = propsFn ? propsFn(i, ctrl) : props[i];
      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }
  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = (0,react.useContext)(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  react_spring_shared_modern_useIsomorphicLayoutEffect(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const { queue } = state;
    if (queue.length) {
      state.queue = [];
      react_spring_shared_modern_each(queue, (cb) => cb());
    }
    react_spring_shared_modern_each(ctrls.current, (ctrl, i) => {
      ref?.add(ctrl);
      if (hasContext) {
        ctrl.start({ default: context });
      }
      const update2 = updates[i];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(() => () => {
    react_spring_shared_modern_each(state.ctrls, (ctrl) => ctrl.stop(true));
  });
  const values = springs.map((x) => ({ ...x }));
  return ref ? [values, ref] : values;
}

// src/hooks/useSpring.ts
function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], ref] = useSprings(
    1,
    isFn ? props : [props],
    isFn ? deps || [] : deps
  );
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

// src/hooks/useSpringRef.ts

var initSpringRef = () => SpringRef();
var useSpringRef = () => useState(initSpringRef)[0];

// src/hooks/useSpringValue.ts

var useSpringValue = (initial, props) => {
  const springValue = useConstant(() => new SpringValue(initial, props));
  useOnce2(() => () => {
    springValue.stop();
  });
  return springValue;
};

// src/hooks/useTrail.ts

function useTrail(length, propsArg, deps) {
  const propsFn = is10.fun(propsArg) && propsArg;
  if (propsFn && !deps)
    deps = [];
  let reverse = true;
  let passedRef = void 0;
  const result = useSprings(
    length,
    (i, ctrl) => {
      const props = propsFn ? propsFn(i, ctrl) : propsArg;
      passedRef = props.ref;
      reverse = reverse && props.reverse;
      return props;
    },
    // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [{}]
  );
  useIsomorphicLayoutEffect3(() => {
    each6(result[1].current, (ctrl, i) => {
      const parent = result[1].current[i + (reverse ? 1 : -1)];
      replaceRef(ctrl, passedRef);
      if (ctrl.ref) {
        if (parent) {
          ctrl.update({ to: parent.springs });
        }
        return;
      }
      if (parent) {
        ctrl.start({ to: parent.springs });
      } else {
        ctrl.start();
      }
    });
  }, deps);
  if (propsFn || arguments.length == 3) {
    const ref = passedRef ?? result[1];
    ref["_getProps"] = (propsArg2, ctrl, i) => {
      const props = is10.fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
      if (props) {
        const parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent)
          props.to = parent.springs;
        return props;
      }
    };
    return result;
  }
  return result[0];
}

// src/hooks/useTransition.tsx



function useTransition(data, props, deps) {
  const propsFn = is11.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = useMemo2(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const items = toArray4(data);
  const transitions = [];
  const usedTransitions = useRef2(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect4(() => {
    usedTransitions.current = transitions;
  });
  useOnce3(() => {
    each7(transitions, (t) => {
      ref?.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return () => {
      each7(usedTransitions.current, (t) => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }
        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect4(
    () => each7(expired, ({ ctrl, item, key }) => {
      detachRefs(ctrl, ref);
      callProp(onDestroyed, item, key);
    })
  );
  const reused = [];
  if (prevTransitions)
    each7(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
        expired.push(t);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i)
          transitions[i] = t;
      }
    });
  each7(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: "mount" /* MOUNT */,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });
  if (reused.length) {
    let i = -1;
    const { leave } = propsFn ? propsFn() : props;
    each7(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = { ...t, item: items[keyIndex] };
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is11.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate2();
  const defaultProps = getDefaultProps(props);
  const changes = /* @__PURE__ */ new Map();
  const exitingTransitions = useRef2(/* @__PURE__ */ new Map());
  const forceChange = useRef2(false);
  each7(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to2;
    let phase;
    const propsDelay = callProp(p.delay || 0, key);
    if (prevPhase == "mount" /* MOUNT */) {
      to2 = p.enter;
      phase = "enter" /* ENTER */;
    } else {
      const isLeave = keys.indexOf(key) < 0;
      if (prevPhase != "leave" /* LEAVE */) {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave" /* LEAVE */;
        } else if (to2 = p.update) {
          phase = "update" /* UPDATE */;
        } else
          return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter" /* ENTER */;
      } else
        return;
    }
    to2 = callProp(to2, t.item, i);
    to2 = is11.obj(to2) ? inferTo(to2) : { to: to2 };
    if (!to2.config) {
      const config2 = propsConfig || defaultProps.config;
      to2.config = callProp(config2, t.item, i, phase);
    }
    delay += trail;
    const payload = {
      ...defaultProps,
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false,
      // Merge any phase-specific props.
      ...to2
    };
    if (phase == "enter" /* ENTER */ && is11.und(payload.from)) {
      const p2 = propsFn ? propsFn() : props;
      const from = is11.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from, t.item, i);
    }
    const { onResolve } = payload;
    payload.onResolve = (result) => {
      callProp(onResolve, result);
      const transitions2 = usedTransitions.current;
      const t2 = transitions2.find((t3) => t3.key === key);
      if (!t2)
        return;
      if (result.cancelled && t2.phase != "update" /* UPDATE */) {
        return;
      }
      if (t2.ctrl.idle) {
        const idle = transitions2.every((t3) => t3.ctrl.idle);
        if (t2.phase == "leave" /* LEAVE */) {
          const expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some((t3) => t3.expired)) {
          exitingTransitions.current.delete(t2);
          if (exitBeforeEnter) {
            forceChange.current = true;
          }
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t.ctrl, payload);
    if (phase === "leave" /* LEAVE */ && exitBeforeEnter) {
      exitingTransitions.current.set(t, { phase, springs, payload });
    } else {
      changes.set(t, { phase, springs, payload });
    }
  });
  const context = useContext3(SpringContext);
  const prevContext = usePrev2(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect4(() => {
    if (hasContext) {
      each7(transitions, (t) => {
        t.ctrl.start({ default: context });
      });
    }
  }, [context]);
  each7(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex((state) => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect4(
    () => {
      each7(
        exitingTransitions.current.size ? exitingTransitions.current : changes,
        ({ phase, payload }, t) => {
          const { ctrl } = t;
          t.phase = phase;
          ref?.add(ctrl);
          if (hasContext && phase == "enter" /* ENTER */) {
            ctrl.start({ default: context });
          }
          if (payload) {
            replaceRef(ctrl, payload.ref);
            if ((ctrl.ref || ref) && !forceChange.current) {
              ctrl.update(payload);
            } else {
              ctrl.start(payload);
              if (forceChange.current) {
                forceChange.current = false;
              }
            }
          }
        }
      );
    },
    reset ? void 0 : deps
  );
  const renderTransitions = (render) => /* @__PURE__ */ React2.createElement(React2.Fragment, null, transitions.map((t, i) => {
    const { springs } = changes.get(t) || t.ctrl;
    const elem = render({ ...springs }, t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */ React2.createElement(
      elem.type,
      {
        ...elem.props,
        key: is11.str(t.key) || is11.num(t.key) ? t.key : t.ctrl.id,
        ref: elem.ref
      }
    ) : elem;
  }));
  return ref ? [renderTransitions, ref] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys = key }, prevTransitions) {
  if (keys === null) {
    const reused = /* @__PURE__ */ new Set();
    return items.map((item) => {
      const t = prevTransitions && prevTransitions.find(
        (t2) => t2.item === item && t2.phase !== "leave" /* LEAVE */ && !reused.has(t2)
      );
      if (t) {
        reused.add(t);
        return t.key;
      }
      return nextKey++;
    });
  }
  return is11.und(keys) ? items : is11.fun(keys) ? items.map(keys) : toArray4(keys);
}

// src/hooks/useScroll.ts

var useScroll = ({
  container,
  ...springOptions
} = {}) => {
  const [scrollValues, api] = useSpring(
    () => ({
      scrollX: 0,
      scrollY: 0,
      scrollXProgress: 0,
      scrollYProgress: 0,
      ...springOptions
    }),
    []
  );
  useIsomorphicLayoutEffect5(() => {
    const cleanupScroll = onScroll(
      ({ x, y }) => {
        api.start({
          scrollX: x.current,
          scrollXProgress: x.progress,
          scrollY: y.current,
          scrollYProgress: y.progress
        });
      },
      { container: container?.current || void 0 }
    );
    return () => {
      each8(Object.values(scrollValues), (value) => value.stop());
      cleanupScroll();
    };
  }, []);
  return scrollValues;
};

// src/hooks/useResize.ts

var useResize = ({
  container,
  ...springOptions
}) => {
  const [sizeValues, api] = useSpring(
    () => ({
      width: 0,
      height: 0,
      ...springOptions
    }),
    []
  );
  useIsomorphicLayoutEffect6(() => {
    const cleanupScroll = onResize(
      ({ width, height }) => {
        api.start({
          width,
          height,
          immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
        });
      },
      { container: container?.current || void 0 }
    );
    return () => {
      each9(Object.values(sizeValues), (value) => value.stop());
      cleanupScroll();
    };
  }, []);
  return sizeValues;
};

// src/hooks/useInView.ts


var defaultThresholdOptions = {
  any: 0,
  all: 1
};
function useInView(props, args) {
  const [isInView, setIsInView] = useState2(false);
  const ref = useRef3();
  const propsFn = is12.fun(props) && props;
  const springsProps = propsFn ? propsFn() : {};
  const { to: to2 = {}, from = {}, ...restSpringProps } = springsProps;
  const intersectionArguments = propsFn ? args : props;
  const [springs, api] = useSpring(() => ({ from, ...restSpringProps }), []);
  useIsomorphicLayoutEffect7(() => {
    const element = ref.current;
    const {
      root,
      once,
      amount = "any",
      ...restArgs
    } = intersectionArguments ?? {};
    if (!element || once && isInView || typeof IntersectionObserver === "undefined")
      return;
    const activeIntersections = /* @__PURE__ */ new WeakMap();
    const onEnter = () => {
      if (to2) {
        api.start(to2);
      }
      setIsInView(true);
      const cleanup = () => {
        if (from) {
          api.start(from);
        }
        setIsInView(false);
      };
      return once ? void 0 : cleanup;
    };
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const onLeave = activeIntersections.get(entry.target);
        if (entry.isIntersecting === Boolean(onLeave)) {
          return;
        }
        if (entry.isIntersecting) {
          const newOnLeave = onEnter();
          if (is12.fun(newOnLeave)) {
            activeIntersections.set(entry.target, newOnLeave);
          } else {
            observer.unobserve(entry.target);
          }
        } else if (onLeave) {
          onLeave();
          activeIntersections.delete(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      root: root && root.current || void 0,
      threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount],
      ...restArgs
    });
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [intersectionArguments]);
  if (propsFn) {
    return [ref, springs];
  }
  return [ref, isInView];
}

// src/components/Spring.tsx
function Spring({ children, ...props }) {
  return children(useSpring(props));
}

// src/components/Trail.tsx

function Trail({
  items,
  children,
  ...props
}) {
  const trails = useTrail(items.length, props);
  return items.map((item, index) => {
    const result = children(item, index);
    return is13.fun(result) ? result(trails[index]) : result;
  });
}

// src/components/Transition.tsx
function Transition({
  items,
  children,
  ...props
}) {
  return useTransition(items, props)(children);
}

// src/interpolate.ts


// src/Interpolation.ts


var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    /** Equals false when in the frameloop */
    this.idle = true;
    /** The inputs which are currently animating */
    this._active = /* @__PURE__ */ new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      react_spring_shared_modern_each(getPayload(this), (node) => {
        node.done = false;
      });
      if (globals_exports.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  // Observe our sources only when we're observed.
  _attach() {
    let priority = 1;
    react_spring_shared_modern_each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;
    this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    react_spring_shared_modern_each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);
        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray(this.source).reduce(
        (highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1),
        0
      );
    }
  }
};
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    react_spring_shared_modern_each(getPayload(self), (node) => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}

// src/interpolate.ts
var react_spring_core_modern_to = (source, ...args) => new Interpolation(source, args);
var react_spring_core_modern_interpolate = (source, ...args) => (deprecateInterpolate2(), new Interpolation(source, args));

// src/globals.ts

globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});
var react_spring_core_modern_update = frameLoop.advance;

// src/index.ts



//# sourceMappingURL=react-spring_core.modern.mjs.map
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
;// CONCATENATED MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs
// src/index.ts





// src/applyAnimatedValues.ts
var isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]))
    return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const { style, children, scrollTop, scrollLeft, viewBox, ...attributes } = props;
  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(
    (name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (n) => "-" + n.toLowerCase()
    ))
  );
  if (children !== void 0) {
    instance.textContent = children;
  }
  for (const name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);
      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }
  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
  if (viewBox !== void 0) {
    instance.setAttribute("viewBox", viewBox);
  }
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach((prefix) => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

// src/AnimatedStyle.ts


var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;
var isValueIdentity = (value, id) => is.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
  constructor({ x, y, z, ...style }) {
    const inputs = [];
    const transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push((xyz) => [
        `translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`,
        // prettier-ignore
        isValueIdentity(xyz, 0)
      ]);
    }
    eachProp(style, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value))
          return;
        const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(
          key === "rotate3d" ? ([x2, y2, z2, deg]) => [
            `rotate3d(${x2},${y2},${z2},${addUnit(deg, unit)})`,
            isValueIdentity(deg, 0)
          ] : (input) => [
            `${key}(${input.map((v) => addUnit(v, unit)).join(",")})`,
            isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    super(style);
  }
};
var FluidTransform = class extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity = true;
    react_spring_shared_modern_each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](
        is.arr(arg1) ? arg1 : input.map(getFluidValue)
      );
      transform += " " + t;
      identity = identity && id;
    });
    return identity ? "none" : transform;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(count) {
    if (count == 1)
      react_spring_shared_modern_each(
        this.inputs,
        (input) => react_spring_shared_modern_each(
          input,
          (value) => hasFluidValue(value) && addFluidObserver(value, this)
        )
      );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(count) {
    if (count == 0)
      react_spring_shared_modern_each(
        this.inputs,
        (input) => react_spring_shared_modern_each(
          input,
          (value) => hasFluidValue(value) && removeFluidObserver(value, this)
        )
      );
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._value = null;
    }
    callFluidObservers(this, event);
  }
};

// src/primitives.ts
var primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];

// src/index.ts

globals_exports.assign({
  batchedUpdates: react_dom.unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator2,
  colors: colors2
});
var host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: (style) => new AnimatedStyle(style),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop, scrollLeft, ...props }) => props
});
var animated = host.animated;

//# sourceMappingURL=react-spring_web.modern.mjs.map
;// CONCATENATED MODULE: ./node_modules/react-spring/dist/react-spring.modern.mjs
// src/index.ts

//# sourceMappingURL=react-spring.modern.mjs.map

/***/ }),

/***/ 7851:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ twMerge; }
});

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/class-utils.mjs
var CLASS_PART_SEPARATOR = '-';
function createClassUtils(config) {
  var classMap = createClassMap(config);
  var conflictingClassGroups = config.conflictingClassGroups,
    _config$conflictingCl = config.conflictingClassGroupModifiers,
    conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
  function getClassGroupId(className) {
    var classParts = className.split(CLASS_PART_SEPARATOR);
    // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
    if (classParts[0] === '' && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    var conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
    }
    return conflicts;
  }
  return {
    getClassGroupId: getClassGroupId,
    getConflictingClassGroupIds: getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  var currentClassPart = classParts[0];
  var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  var classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return undefined;
  }
  var classRest = classParts.join(CLASS_PART_SEPARATOR);
  return classPartObject.validators.find(function (_ref) {
    var validator = _ref.validator;
    return validator(classRest);
  })?.classGroupId;
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    var arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
    if (property) {
      // I use two dots here because one dot is used as prefix for class groups in plugins
      return 'arbitrary..' + property;
    }
  }
}
/**
 * Exported for testing only
 */
function createClassMap(config) {
  var theme = config.theme,
    prefix = config.prefix;
  var classMap = {
    nextPart: new Map(),
    validators: []
  };
  var prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(function (_ref2) {
    var classGroupId = _ref2[0],
      classGroup = _ref2[1];
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach(function (classDefinition) {
    if (typeof classDefinition === 'string') {
      var classPartObjectToEdit = classDefinition === '' ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === 'function') {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId: classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(function (_ref3) {
      var key = _ref3[0],
        classGroup = _ref3[1];
      processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  var currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(function (pathPart) {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(function (_ref4) {
    var classGroupId = _ref4[0],
      classGroup = _ref4[1];
    var prefixedClassGroup = classGroup.map(function (classDefinition) {
      if (typeof classDefinition === 'string') {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === 'object') {
        return Object.fromEntries(Object.entries(classDefinition).map(function (_ref5) {
          var key = _ref5[0],
            value = _ref5[1];
          return [prefix + key, value];
        }));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}


//# sourceMappingURL=class-utils.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/lru-cache.mjs
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: function get() {
        return undefined;
      },
      set: function set() {}
    };
  }
  var cacheSize = 0;
  var cache = new Map();
  var previousCache = new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = new Map();
    }
  }
  return {
    get: function get(key) {
      var value = cache.get(key);
      if (value !== undefined) {
        return value;
      }
      if ((value = previousCache.get(key)) !== undefined) {
        update(key, value);
        return value;
      }
    },
    set: function set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}


//# sourceMappingURL=lru-cache.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/modifier-utils.mjs
var IMPORTANT_MODIFIER = '!';
function createSplitModifiers(config) {
  var separator = config.separator || ':';
  var isSeparatorSingleCharacter = separator.length === 1;
  var firstSeparatorCharacter = separator[0];
  var separatorLength = separator.length;
  // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
  return function splitModifiers(className) {
    var modifiers = [];
    var bracketDepth = 0;
    var modifierStart = 0;
    var postfixModifierPosition;
    for (var index = 0; index < className.length; index++) {
      var currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === '/') {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === '[') {
        bracketDepth++;
      } else if (currentCharacter === ']') {
        bracketDepth--;
      }
    }
    var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    var hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
    return {
      modifiers: modifiers,
      hasImportantModifier: hasImportantModifier,
      baseClassName: baseClassName,
      maybePostfixModifierPosition: maybePostfixModifierPosition
    };
  };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  var sortedModifiers = [];
  var unsortedModifiers = [];
  modifiers.forEach(function (modifier) {
    var isArbitraryVariant = modifier[0] === '[';
    if (isArbitraryVariant) {
      sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([modifier]));
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
  return sortedModifiers;
}


//# sourceMappingURL=modifier-utils.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/config-utils.mjs




function createConfigUtils(config) {
  return {
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config),
    ...createClassUtils(config)
  };
}


//# sourceMappingURL=config-utils.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/merge-classlist.mjs


var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  var splitModifiers = configUtils.splitModifiers,
    getClassGroupId = configUtils.getClassGroupId,
    getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
  /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */
  var classGroupsInConflict = new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map(function (originalClassName) {
    var _splitModifiers = splitModifiers(originalClassName),
      modifiers = _splitModifiers.modifiers,
      hasImportantModifier = _splitModifiers.hasImportantModifier,
      baseClassName = _splitModifiers.baseClassName,
      maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
    var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName: originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName: originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    var variantModifier = sortModifiers(modifiers).join(':');
    var modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId: modifierId,
      classGroupId: classGroupId,
      originalClassName: originalClassName,
      hasPostfixModifier: hasPostfixModifier
    };
  }).reverse()
  // Last class in conflict wins, so we need to filter conflicting classes in reverse order.
  .filter(function (parsed) {
    if (!parsed.isTailwindClass) {
      return true;
    }
    var modifierId = parsed.modifierId,
      classGroupId = parsed.classGroupId,
      hasPostfixModifier = parsed.hasPostfixModifier;
    var classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function (group) {
      return classGroupsInConflict.add(modifierId + group);
    });
    return true;
  }).reverse().map(function (parsed) {
    return parsed.originalClassName;
  }).join(' ');
}


//# sourceMappingURL=merge-classlist.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/tw-join.mjs
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */
function twJoin() {
  var index = 0;
  var argument;
  var resolvedValue;
  var string = '';
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === 'string') {
    return mix;
  }
  var resolvedValue;
  var string = '';
  for (var k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}


//# sourceMappingURL=tw-join.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/create-tailwind-merge.mjs




function createTailwindMerge() {
  for (var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++) {
    createConfig[_key] = arguments[_key];
  }
  var configUtils;
  var cacheGet;
  var cacheSet;
  var functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    var firstCreateConfig = createConfig[0],
      restCreateConfig = createConfig.slice(1);
    var config = restCreateConfig.reduce(function (previousConfig, createConfigCurrent) {
      return createConfigCurrent(previousConfig);
    }, firstCreateConfig());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    var cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    var result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}


//# sourceMappingURL=create-tailwind-merge.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/from-theme.mjs
function fromTheme(key) {
  var themeGetter = function themeGetter(theme) {
    return theme[key] || [];
  };
  themeGetter.isThemeGetter = true;
  return themeGetter;
}


//# sourceMappingURL=from-theme.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/validators.mjs
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /*#__PURE__*/new Set(['px', 'full', 'screen']);
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(value) {
  return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value) || isArbitraryLength(value);
}
function isArbitraryLength(value) {
  return getIsArbitraryValue(value, 'length', isLengthOnly);
}
function isArbitrarySize(value) {
  return getIsArbitraryValue(value, 'size', isNever);
}
function isArbitraryPosition(value) {
  return getIsArbitraryValue(value, 'position', isNever);
}
function isArbitraryUrl(value) {
  return getIsArbitraryValue(value, 'url', isUrl);
}
function isArbitraryNumber(value) {
  return getIsArbitraryValue(value, 'number', isNumber);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */
var isArbitraryWeight = (/* unused pure expression or super */ null && (isArbitraryNumber));
function isNumber(value) {
  return !Number.isNaN(Number(value));
}
function isPercent(value) {
  return value.endsWith('%') && isNumber(value.slice(0, -1));
}
function isInteger(value) {
  return isIntegerOnly(value) || getIsArbitraryValue(value, 'number', isIntegerOnly);
}
function isArbitraryValue(value) {
  return arbitraryValueRegex.test(value);
}
function isAny() {
  return true;
}
function isTshirtSize(value) {
  return tshirtUnitRegex.test(value);
}
function isArbitraryShadow(value) {
  return getIsArbitraryValue(value, '', isShadow);
}
function getIsArbitraryValue(value, label, testValue) {
  var result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return result[1] === label;
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly(value) {
  return lengthUnitRegex.test(value);
}
function isNever() {
  return false;
}
function isUrl(value) {
  return value.startsWith('url(');
}
function isIntegerOnly(value) {
  return Number.isInteger(Number(value));
}
function isShadow(value) {
  return shadowRegex.test(value);
}


//# sourceMappingURL=validators.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/default-config.mjs



function getDefaultConfig() {
  var colors = fromTheme('colors');
  var spacing = fromTheme('spacing');
  var blur = fromTheme('blur');
  var brightness = fromTheme('brightness');
  var borderColor = fromTheme('borderColor');
  var borderRadius = fromTheme('borderRadius');
  var borderSpacing = fromTheme('borderSpacing');
  var borderWidth = fromTheme('borderWidth');
  var contrast = fromTheme('contrast');
  var grayscale = fromTheme('grayscale');
  var hueRotate = fromTheme('hueRotate');
  var invert = fromTheme('invert');
  var gap = fromTheme('gap');
  var gradientColorStops = fromTheme('gradientColorStops');
  var gradientColorStopPositions = fromTheme('gradientColorStopPositions');
  var inset = fromTheme('inset');
  var margin = fromTheme('margin');
  var opacity = fromTheme('opacity');
  var padding = fromTheme('padding');
  var saturate = fromTheme('saturate');
  var scale = fromTheme('scale');
  var sepia = fromTheme('sepia');
  var skew = fromTheme('skew');
  var space = fromTheme('space');
  var translate = fromTheme('translate');
  var getOverscroll = function getOverscroll() {
    return ['auto', 'contain', 'none'];
  };
  var getOverflow = function getOverflow() {
    return ['auto', 'hidden', 'clip', 'visible', 'scroll'];
  };
  var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
    return ['auto', isArbitraryValue, spacing];
  };
  var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
    return [isArbitraryValue, spacing];
  };
  var getLengthWithEmpty = function getLengthWithEmpty() {
    return ['', isLength];
  };
  var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
    return ['auto', isNumber, isArbitraryValue];
  };
  var getPositions = function getPositions() {
    return ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top'];
  };
  var getLineStyles = function getLineStyles() {
    return ['solid', 'dashed', 'dotted', 'double', 'none'];
  };
  var getBlendModes = function getBlendModes() {
    return ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity', 'plus-lighter'];
  };
  var getAlign = function getAlign() {
    return ['start', 'end', 'center', 'between', 'around', 'evenly', 'stretch'];
  };
  var getZeroAndEmpty = function getZeroAndEmpty() {
    return ['', '0', isArbitraryValue];
  };
  var getBreaks = function getBreaks() {
    return ['auto', 'avoid', 'all', 'avoid-page', 'page', 'left', 'right', 'column'];
  };
  var getNumber = function getNumber() {
    return [isNumber, isArbitraryNumber];
  };
  var getNumberAndArbitrary = function getNumberAndArbitrary() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ['none', '', isTshirtSize, isArbitraryValue],
      brightness: getNumber(),
      borderColor: [colors],
      borderRadius: ['none', '', 'full', isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmpty(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ['auto', 'square', 'video', isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ['container'],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      'break-after': [{
        'break-after': getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      'break-before': [{
        'break-before': getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      'break-inside': [{
        'break-inside': ['auto', 'avoid', 'avoid-page', 'avoid-column']
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      'box-decoration': [{
        'box-decoration': ['slice', 'clone']
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ['border', 'content']
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ['block', 'inline-block', 'inline', 'flex', 'inline-flex', 'table', 'inline-table', 'table-caption', 'table-cell', 'table-column', 'table-column-group', 'table-footer-group', 'table-header-group', 'table-row-group', 'table-row', 'flow-root', 'grid', 'inline-grid', 'contents', 'list-item', 'hidden'],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      "float": [{
        "float": ['right', 'left', 'none']
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ['left', 'right', 'both', 'none']
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ['isolate', 'isolation-auto'],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      'object-fit': [{
        object: ['contain', 'cover', 'fill', 'none', 'scale-down']
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      'object-position': [{
        object: [].concat(getPositions(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-x': [{
        'overflow-x': getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-y': [{
        'overflow-y': getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-x': [{
        'overscroll-x': getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-y': [{
        'overscroll-y': getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ['static', 'fixed', 'absolute', 'relative', 'sticky'],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-x': [{
        'inset-x': [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-y': [{
        'inset-y': [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ['visible', 'invisible', 'collapse'],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ['auto', isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      'flex-direction': [{
        flex: ['row', 'row-reverse', 'col', 'col-reverse']
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      'flex-wrap': [{
        flex: ['wrap', 'wrap-reverse', 'nowrap']
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ['1', 'auto', 'initial', 'none', isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ['first', 'last', 'none', isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      'grid-cols': [{
        'grid-cols': [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start-end': [{
        col: ['auto', {
          span: ['full', isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start': [{
        'col-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-end': [{
        'col-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      'grid-rows': [{
        'grid-rows': [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start-end': [{
        row: ['auto', {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start': [{
        'row-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-end': [{
        'row-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      'grid-flow': [{
        'grid-flow': ['row', 'col', 'dense', 'row-dense', 'col-dense']
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      'auto-cols': [{
        'auto-cols': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      'auto-rows': [{
        'auto-rows': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-x': [{
        'gap-x': [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-y': [{
        'gap-y': [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      'justify-content': [{
        justify: ['normal'].concat(getAlign())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      'justify-items': [{
        'justify-items': ['start', 'end', 'center', 'stretch']
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      'justify-self': [{
        'justify-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      'align-content': [{
        content: ['normal'].concat(getAlign(), ['baseline'])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      'align-items': [{
        items: ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      'align-self': [{
        self: ['auto', 'start', 'end', 'center', 'stretch', 'baseline']
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      'place-content': [{
        'place-content': [].concat(getAlign(), ['baseline'])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      'place-items': [{
        'place-items': ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      'place-self': [{
        'place-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      'space-x': [{
        'space-x': [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-x-reverse': ['space-x-reverse'],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      'space-y': [{
        'space-y': [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-y-reverse': ['space-y-reverse'],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ['auto', 'min', 'max', 'fit', isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      'min-w': [{
        'min-w': ['min', 'max', 'fit', isArbitraryValue, isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      'max-w': [{
        'max-w': ['0', 'none', 'full', 'min', 'max', 'fit', 'prose', {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryValue]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit']
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      'min-h': [{
        'min-h': ['min', 'max', 'fit', isArbitraryValue, isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      'max-h': [{
        'max-h': [isArbitraryValue, spacing, 'min', 'max', 'fit']
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      'font-size': [{
        text: ['base', isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      'font-smoothing': ['antialiased', 'subpixel-antialiased'],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      'font-style': ['italic', 'not-italic'],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      'font-weight': [{
        font: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black', isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      'font-family': [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-normal': ['normal-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-ordinal': ['ordinal'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-slashed-zero': ['slashed-zero'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-figure': ['lining-nums', 'oldstyle-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-spacing': ['proportional-nums', 'tabular-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-fraction': ['diagonal-fractions', 'stacked-fractons'],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ['tighter', 'tight', 'normal', 'wide', 'wider', 'widest', isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      'line-clamp': [{
        'line-clamp': ['none', isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ['none', 'tight', 'snug', 'normal', 'relaxed', 'loose', isArbitraryValue, isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      'list-image': [{
        'list-image': ['none', isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      'list-style-type': [{
        list: ['none', 'disc', 'decimal', isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      'list-style-position': [{
        list: ['inside', 'outside']
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      'placeholder-color': [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      'placeholder-opacity': [{
        'placeholder-opacity': [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      'text-alignment': [{
        text: ['left', 'center', 'right', 'justify', 'start', 'end']
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      'text-color': [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      'text-opacity': [{
        'text-opacity': [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      'text-decoration': ['underline', 'overline', 'line-through', 'no-underline'],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      'text-decoration-style': [{
        decoration: [].concat(getLineStyles(), ['wavy'])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      'text-decoration-thickness': [{
        decoration: ['auto', 'from-font', isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      'underline-offset': [{
        'underline-offset': ['auto', isArbitraryValue, isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      'text-decoration-color': [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      'text-transform': ['uppercase', 'lowercase', 'capitalize', 'normal-case'],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      'text-overflow': ['truncate', 'text-ellipsis', 'text-clip'],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      'vertical-align': [{
        align: ['baseline', 'top', 'middle', 'bottom', 'text-top', 'text-bottom', 'sub', 'super', isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ['normal', 'nowrap', 'pre', 'pre-line', 'pre-wrap', 'break-spaces']
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      "break": [{
        "break": ['normal', 'words', 'all', 'keep']
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ['none', 'manual', 'auto']
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ['none', isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      'bg-attachment': [{
        bg: ['fixed', 'local', 'scroll']
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      'bg-clip': [{
        'bg-clip': ['border', 'padding', 'content', 'text']
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      'bg-opacity': [{
        'bg-opacity': [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      'bg-origin': [{
        'bg-origin': ['border', 'padding', 'content']
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      'bg-position': [{
        bg: [].concat(getPositions(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      'bg-repeat': [{
        bg: ['no-repeat', {
          repeat: ['', 'x', 'y', 'round', 'space']
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      'bg-size': [{
        bg: ['auto', 'cover', 'contain', isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      'bg-image': [{
        bg: ['none', {
          'gradient-to': ['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      'bg-color': [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from-pos': [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via-pos': [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to-pos': [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from': [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via': [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to': [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-s': [{
        'rounded-s': [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-e': [{
        'rounded-e': [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-t': [{
        'rounded-t': [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-r': [{
        'rounded-r': [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-b': [{
        'rounded-b': [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-l': [{
        'rounded-l': [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ss': [{
        'rounded-ss': [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-se': [{
        'rounded-se': [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ee': [{
        'rounded-ee': [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-es': [{
        'rounded-es': [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tl': [{
        'rounded-tl': [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tr': [{
        'rounded-tr': [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-br': [{
        'rounded-br': [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-bl': [{
        'rounded-bl': [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w': [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-x': [{
        'border-x': [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-y': [{
        'border-y': [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-s': [{
        'border-s': [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-e': [{
        'border-e': [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-t': [{
        'border-t': [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-r': [{
        'border-r': [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-b': [{
        'border-b': [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-l': [{
        'border-l': [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      'border-opacity': [{
        'border-opacity': [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      'border-style': [{
        border: [].concat(getLineStyles(), ['hidden'])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x': [{
        'divide-x': [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x-reverse': ['divide-x-reverse'],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y': [{
        'divide-y': [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y-reverse': ['divide-y-reverse'],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      'divide-opacity': [{
        'divide-opacity': [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      'divide-style': [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color': [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-x': [{
        'border-x': [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-y': [{
        'border-y': [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-t': [{
        'border-t': [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-r': [{
        'border-r': [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-b': [{
        'border-b': [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-l': [{
        'border-l': [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      'divide-color': [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      'outline-style': [{
        outline: [''].concat(getLineStyles())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      'outline-offset': [{
        'outline-offset': [isArbitraryValue, isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      'outline-w': [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      'outline-color': [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w': [{
        ring: getLengthWithEmpty()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w-inset': ['ring-inset'],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      'ring-color': [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      'ring-opacity': [{
        'ring-opacity': [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      'ring-offset-w': [{
        'ring-offset': [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      'ring-offset-color': [{
        'ring-offset': [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ['', 'inner', 'none', isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      'shadow-color': [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      'mix-blend': [{
        'mix-blend': getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      'bg-blend': [{
        'bg-blend': getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ['', 'none']
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      'drop-shadow': [{
        'drop-shadow': ['', 'none', isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      'hue-rotate': [{
        'hue-rotate': [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      'backdrop-filter': [{
        'backdrop-filter': ['', 'none']
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      'backdrop-blur': [{
        'backdrop-blur': [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      'backdrop-brightness': [{
        'backdrop-brightness': [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      'backdrop-contrast': [{
        'backdrop-contrast': [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      'backdrop-grayscale': [{
        'backdrop-grayscale': [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      'backdrop-hue-rotate': [{
        'backdrop-hue-rotate': [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      'backdrop-invert': [{
        'backdrop-invert': [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      'backdrop-opacity': [{
        'backdrop-opacity': [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      'backdrop-saturate': [{
        'backdrop-saturate': [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      'backdrop-sepia': [{
        'backdrop-sepia': [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      'border-collapse': [{
        border: ['collapse', 'separate']
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing': [{
        'border-spacing': [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-x': [{
        'border-spacing-x': [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-y': [{
        'border-spacing-y': [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      'table-layout': [{
        table: ['auto', 'fixed']
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ['top', 'bottom']
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ['none', 'all', '', 'colors', 'opacity', 'shadow', 'transform', isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ['linear', 'in', 'out', 'in-out', isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ['none', 'spin', 'ping', 'pulse', 'bounce', isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ['', 'gpu', 'none']
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-x': [{
        'scale-x': [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-y': [{
        'scale-y': [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-x': [{
        'translate-x': [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-y': [{
        'translate-y': [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-x': [{
        'skew-x': [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-y': [{
        'skew-y': [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      'transform-origin': [{
        origin: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ['auto', colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ['appearance-none'],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ['auto', 'default', 'pointer', 'wait', 'text', 'move', 'help', 'not-allowed', 'none', 'context-menu', 'progress', 'cell', 'crosshair', 'vertical-text', 'alias', 'copy', 'no-drop', 'grab', 'grabbing', 'all-scroll', 'col-resize', 'row-resize', 'n-resize', 'e-resize', 's-resize', 'w-resize', 'ne-resize', 'nw-resize', 'se-resize', 'sw-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'zoom-in', 'zoom-out', isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      'caret-color': [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      'pointer-events': [{
        'pointer-events': ['none', 'auto']
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ['none', 'y', 'x', '']
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      'scroll-behavior': [{
        scroll: ['auto', 'smooth']
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-m': [{
        'scroll-m': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mx': [{
        'scroll-mx': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-my': [{
        'scroll-my': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ms': [{
        'scroll-ms': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-me': [{
        'scroll-me': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mt': [{
        'scroll-mt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mr': [{
        'scroll-mr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mb': [{
        'scroll-mb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ml': [{
        'scroll-ml': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-p': [{
        'scroll-p': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-px': [{
        'scroll-px': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-py': [{
        'scroll-py': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-ps': [{
        'scroll-ps': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pe': [{
        'scroll-pe': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pt': [{
        'scroll-pt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pr': [{
        'scroll-pr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pb': [{
        'scroll-pb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pl': [{
        'scroll-pl': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      'snap-align': [{
        snap: ['start', 'end', 'center', 'align-none']
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      'snap-stop': [{
        snap: ['normal', 'always']
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-type': [{
        snap: ['none', 'x', 'y', 'both']
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-strictness': [{
        snap: ['mandatory', 'proximity']
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ['auto', 'none', 'pinch-zoom', 'manipulation', {
          pan: ['x', 'left', 'right', 'y', 'up', 'down']
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ['none', 'text', 'all', 'auto']
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      'will-change': [{
        'will-change': ['auto', 'scroll', 'contents', 'transform', isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, 'none']
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      'stroke-w': [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, 'none']
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ['sr-only', 'not-sr-only']
    },
    conflictingClassGroups: {
      overflow: ['overflow-x', 'overflow-y'],
      overscroll: ['overscroll-x', 'overscroll-y'],
      inset: ['inset-x', 'inset-y', 'start', 'end', 'top', 'right', 'bottom', 'left'],
      'inset-x': ['right', 'left'],
      'inset-y': ['top', 'bottom'],
      flex: ['basis', 'grow', 'shrink'],
      gap: ['gap-x', 'gap-y'],
      p: ['px', 'py', 'ps', 'pe', 'pt', 'pr', 'pb', 'pl'],
      px: ['pr', 'pl'],
      py: ['pt', 'pb'],
      m: ['mx', 'my', 'ms', 'me', 'mt', 'mr', 'mb', 'ml'],
      mx: ['mr', 'ml'],
      my: ['mt', 'mb'],
      'font-size': ['leading'],
      'fvn-normal': ['fvn-ordinal', 'fvn-slashed-zero', 'fvn-figure', 'fvn-spacing', 'fvn-fraction'],
      'fvn-ordinal': ['fvn-normal'],
      'fvn-slashed-zero': ['fvn-normal'],
      'fvn-figure': ['fvn-normal'],
      'fvn-spacing': ['fvn-normal'],
      'fvn-fraction': ['fvn-normal'],
      rounded: ['rounded-s', 'rounded-e', 'rounded-t', 'rounded-r', 'rounded-b', 'rounded-l', 'rounded-ss', 'rounded-se', 'rounded-ee', 'rounded-es', 'rounded-tl', 'rounded-tr', 'rounded-br', 'rounded-bl'],
      'rounded-s': ['rounded-ss', 'rounded-es'],
      'rounded-e': ['rounded-se', 'rounded-ee'],
      'rounded-t': ['rounded-tl', 'rounded-tr'],
      'rounded-r': ['rounded-tr', 'rounded-br'],
      'rounded-b': ['rounded-br', 'rounded-bl'],
      'rounded-l': ['rounded-tl', 'rounded-bl'],
      'border-spacing': ['border-spacing-x', 'border-spacing-y'],
      'border-w': ['border-w-s', 'border-w-e', 'border-w-t', 'border-w-r', 'border-w-b', 'border-w-l'],
      'border-w-x': ['border-w-r', 'border-w-l'],
      'border-w-y': ['border-w-t', 'border-w-b'],
      'border-color': ['border-color-t', 'border-color-r', 'border-color-b', 'border-color-l'],
      'border-color-x': ['border-color-r', 'border-color-l'],
      'border-color-y': ['border-color-t', 'border-color-b'],
      'scroll-m': ['scroll-mx', 'scroll-my', 'scroll-ms', 'scroll-me', 'scroll-mt', 'scroll-mr', 'scroll-mb', 'scroll-ml'],
      'scroll-mx': ['scroll-mr', 'scroll-ml'],
      'scroll-my': ['scroll-mt', 'scroll-mb'],
      'scroll-p': ['scroll-px', 'scroll-py', 'scroll-ps', 'scroll-pe', 'scroll-pt', 'scroll-pr', 'scroll-pb', 'scroll-pl'],
      'scroll-px': ['scroll-pr', 'scroll-pl'],
      'scroll-py': ['scroll-pt', 'scroll-pb']
    },
    conflictingClassGroupModifiers: {
      'font-size': ['leading']
    }
  };
}


//# sourceMappingURL=default-config.mjs.map

;// CONCATENATED MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs



var twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);


//# sourceMappingURL=tw-merge.mjs.map


/***/ }),

/***/ 1604:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ z; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodCatch, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPipeline, ZodPromise, ZodReadonly, ZodRecord, ZodSchema, ZodSet, ZodString, ZodSymbol, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, boolean, coerce, custom, date, default, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, literal, makeIssue, map, nan, nativeEnum, never, null, nullable, number, object, objectUtil, oboolean, onumber, optional, ostring, pipeline, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, string, symbol, transformer, tuple, undefined, union, unknown, util, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    constructor() {
        super(...arguments);
        this._regex = (regex, validation, message) => this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */
        this.nonempty = (message) => this.min(1, errorUtil.errToObj(message));
        this.trim = () => new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
        this.toLowerCase = () => new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
        this.toUpperCase = () => new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ }),

/***/ 8753:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reviews":[{"image":"https://filesw.zoomerang.info/Web/pricing/reviews/adam.webp","name":"Adam Williams","stars":5,"text":"Guys, Prime plan? It\'s like adding a secret spice to my videos! The effects and filters? On point! And those AI tools? Straight-up sorcery—I\'ve turned plain text into mesmerizing visuals! If you\'re serious about video, Prime\'s where the party\'s at! 🎉🎥✨"},{"image":"https://filesw.zoomerang.info/Web/pricing/reviews/christopher.webp","name":"Christopher Brown","stars":5,"text":"Just got Prime, and it\'s like discovering a whole new world for my videos! They\'re pure wizardry—I\'ve transformed plain text into stunning videos!"},{"image":"https://filesw.zoomerang.info/Web/pricing/reviews/sarah.webp","name":"Sarah Robinson","stars":5,"text":"These video templates are pure social media magic! They\'ve elevated my brand\'s storytelling to new heights across social media."}],"faq":[{"q":"Can I switch between plans?","a":"Yes, you can upgrade or downgrade your plan at any time, allowing for flexibility based on evolving needs."},{"q":"How do I cancel my subscription?","a":"You can manage your subscription and cancel at any time through your account settings. Once canceled, you\'ll retain access to your plan\'s features until the end of the billing cycle."},{"q":"Is there a penalty for canceling my subscription?","a":"No, there are no penalties or fees associated with canceling your subscription. We believe in flexibility and want you to have the freedom to manage your subscription based on your preferences."},{"q":"Are there any limitations on the number of videos I can create?","a":"No, there are no limitations on the number of videos you can create across any subscription plan."},{"q":"Can I use the platform for commercial purposes?","a":"Absolutely, users across all plans have the freedom to create and utilize videos for commercial purposes without restrictions."},{"q":"Are there any additional charges for using stock videos and photos?","a":"No, all plans offer access to a vast library of stock videos and photos without any additional charges."},{"q":"What level of technical expertise is needed to use Zoomerang?","a":"Zoomerang is user-friendly and intuitive, catering to users of varying technical abilities. No advanced technical skills are required to navigate and create stunning videos using our platform."},{"q":"Can I use Zoomerang on mobile devices?","a":"You can download the Zoomerang app from the App Store or Google Play and use your subscription plans there."}],"save_percent":70,"plans":{"free":{"id":"free_init","points":["3 tokens (~ 2 video ads)","Exports with watermark","Script Generator","Mobile Video Editor"],"pricing":"free"},"basic":{"id":"basic_init","points":["1M+ Templates for Tiktok & Reels","No Ads, no watermark + Pro Badge","See Profile Visits","Rich Editor","AI Studio"],"pricing":"payment","variants":[{"pack_id":"pro_tire_1","monthly_tokens":25,"monthly_price":3900,"monthly_entitlement":"token_subs_monthly_pack_tire_1","yearly_entitlement":"token_subs_yearly_pack_tire_1","yearly_tokens":300,"yearly_price":39900}]},"advanced":{"id":"advanced_init","subtitle":"For most businesses that want to optimize web queries","points":["All Pro Features","Unlimited AI","Pro Support"],"pricing":"payment","variants":[{"pack_id":"pro_tire_1","monthly_tokens":25,"monthly_price":3900,"monthly_entitlement":"token_subs_monthly_pack_tire_1","yearly_entitlement":"token_subs_yearly_pack_tire_1","yearly_tokens":300,"yearly_price":39900}]},"enterprise":{"id":"enterprise_init","contact_url":"https://zoomerang.app/contact","points":["Unlimited Video ads","Premium support","API Access","Priority video processing","Custom AI UGC Actors"],"pricing":"custom"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);